import * as et from "react";
import In, { useContext as _g, useRef as zr, useCallback as qr, useDebugValue as rm, useMemo as Br, useState as ir, useEffect as Kr, useLayoutEffect as X6, createContext as P6, Component as B6, isValidElement as Uf, createElement as Bo, PureComponent as PT, forwardRef as $g, Children as BT, cloneElement as Jd, useReducer as DT, useImperativeHandle as LT, Fragment as ZT, useId as MT, useDeferredValue as jT } from "react";
import { unstable_batchedUpdates as D6 } from "react-dom";
import { AppBar as YT, Toolbar as zT, IconButton as Ci, Box as gr, Typography as br, Stack as pt, Avatar as ey, Dialog as L6, DialogTitle as GT, DialogContent as QT, List as hc, Divider as ty, ListItemButton as Zf, Chip as ry, Slide as JT, TextField as ll, Badge as Au, ListItem as Z6, Checkbox as HT, Button as nu, styled as Zn, keyframes as _T, CircularProgress as $T, Link as is, ClickAwayListener as eU, Menu as tU, MenuItem as Iq, MerinioTheme as rU } from "merinio-mui";
import { BackIcon as nU, CloseIcon as wu, GroupIcon as iU, SearchIcon as M6, CommentsIcon as aU, ChevronsDownIcon as sU, FavoriteIcon as nm, FileIcon as oU, TextFileIcon as uU, CsvFileIcon as fU, ExcelFileIcon as lU, PdfFileIcon as dU, VideoFileIcon as cU, ImageFileIcon as pU, NoFileIcon as vU, AddIcon as hU, EllipsisIcon as ku, AttachmentIcon as ny, EmojiPickerIcon as mU, SendIcon as gU, ConversationIcon as yU, EditIcon as VU } from "merinio-icons";
import { initReactI18next as qU, useTranslation as bU } from "react-i18next";
import sp from "i18next";
var Xn = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function iy(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function AU(e) {
  if (e.__esModule)
    return e;
  var t = e.default;
  if (typeof t == "function") {
    var r = function n() {
      return this instanceof n ? Reflect.construct(t, arguments, this.constructor) : t.apply(this, arguments);
    };
    r.prototype = t.prototype;
  } else
    r = {};
  return Object.defineProperty(r, "__esModule", { value: !0 }), Object.keys(e).forEach(function(n) {
    var i = Object.getOwnPropertyDescriptor(e, n);
    Object.defineProperty(r, n, i.get ? i : {
      enumerable: !0,
      get: function() {
        return e[n];
      }
    });
  }), r;
}
var im = { exports: {} }, rf = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Xq;
function wU() {
  if (Xq)
    return rf;
  Xq = 1;
  var e = In, t = Symbol.for("react.element"), r = Symbol.for("react.fragment"), n = Object.prototype.hasOwnProperty, i = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, a = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(o, u, f) {
    var l, d = {}, c = null, p = null;
    f !== void 0 && (c = "" + f), u.key !== void 0 && (c = "" + u.key), u.ref !== void 0 && (p = u.ref);
    for (l in u)
      n.call(u, l) && !a.hasOwnProperty(l) && (d[l] = u[l]);
    if (o && o.defaultProps)
      for (l in u = o.defaultProps, u)
        d[l] === void 0 && (d[l] = u[l]);
    return { $$typeof: t, type: o, key: c, ref: p, props: d, _owner: i.current };
  }
  return rf.Fragment = r, rf.jsx = s, rf.jsxs = s, rf;
}
var nf = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Pq;
function kU() {
  return Pq || (Pq = 1, process.env.NODE_ENV !== "production" && function() {
    var e = In, t = Symbol.for("react.element"), r = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), i = Symbol.for("react.strict_mode"), a = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), o = Symbol.for("react.context"), u = Symbol.for("react.forward_ref"), f = Symbol.for("react.suspense"), l = Symbol.for("react.suspense_list"), d = Symbol.for("react.memo"), c = Symbol.for("react.lazy"), p = Symbol.for("react.offscreen"), v = Symbol.iterator, h = "@@iterator";
    function m(G) {
      if (G === null || typeof G != "object")
        return null;
      var Ce = v && G[v] || G[h];
      return typeof Ce == "function" ? Ce : null;
    }
    var q = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function w(G) {
      {
        for (var Ce = arguments.length, Te = new Array(Ce > 1 ? Ce - 1 : 0), ct = 1; ct < Ce; ct++)
          Te[ct - 1] = arguments[ct];
        O("error", G, Te);
      }
    }
    function O(G, Ce, Te) {
      {
        var ct = q.ReactDebugCurrentFrame, Ft = ct.getStackAddendum();
        Ft !== "" && (Ce += "%s", Te = Te.concat([Ft]));
        var nt = Te.map(function(Ct) {
          return String(Ct);
        });
        nt.unshift("Warning: " + Ce), Function.prototype.apply.call(console[G], console, nt);
      }
    }
    var C = !1, R = !1, I = !1, P = !1, K = !1, B;
    B = Symbol.for("react.module.reference");
    function L(G) {
      return !!(typeof G == "string" || typeof G == "function" || G === n || G === a || K || G === i || G === f || G === l || P || G === p || C || R || I || typeof G == "object" && G !== null && (G.$$typeof === c || G.$$typeof === d || G.$$typeof === s || G.$$typeof === o || G.$$typeof === u || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      G.$$typeof === B || G.getModuleId !== void 0));
    }
    function _(G, Ce, Te) {
      var ct = G.displayName;
      if (ct)
        return ct;
      var Ft = Ce.displayName || Ce.name || "";
      return Ft !== "" ? Te + "(" + Ft + ")" : Te;
    }
    function ne(G) {
      return G.displayName || "Context";
    }
    function Z(G) {
      if (G == null)
        return null;
      if (typeof G.tag == "number" && w("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof G == "function")
        return G.displayName || G.name || null;
      if (typeof G == "string")
        return G;
      switch (G) {
        case n:
          return "Fragment";
        case r:
          return "Portal";
        case a:
          return "Profiler";
        case i:
          return "StrictMode";
        case f:
          return "Suspense";
        case l:
          return "SuspenseList";
      }
      if (typeof G == "object")
        switch (G.$$typeof) {
          case o:
            var Ce = G;
            return ne(Ce) + ".Consumer";
          case s:
            var Te = G;
            return ne(Te._context) + ".Provider";
          case u:
            return _(G, G.render, "ForwardRef");
          case d:
            var ct = G.displayName || null;
            return ct !== null ? ct : Z(G.type) || "Memo";
          case c: {
            var Ft = G, nt = Ft._payload, Ct = Ft._init;
            try {
              return Z(Ct(nt));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var le = Object.assign, he = 0, Ie, xe, ye, ue, M, F, pe;
    function We() {
    }
    We.__reactDisabledLog = !0;
    function ce() {
      {
        if (he === 0) {
          Ie = console.log, xe = console.info, ye = console.warn, ue = console.error, M = console.group, F = console.groupCollapsed, pe = console.groupEnd;
          var G = {
            configurable: !0,
            enumerable: !0,
            value: We,
            writable: !0
          };
          Object.defineProperties(console, {
            info: G,
            log: G,
            warn: G,
            error: G,
            group: G,
            groupCollapsed: G,
            groupEnd: G
          });
        }
        he++;
      }
    }
    function oe() {
      {
        if (he--, he === 0) {
          var G = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: le({}, G, {
              value: Ie
            }),
            info: le({}, G, {
              value: xe
            }),
            warn: le({}, G, {
              value: ye
            }),
            error: le({}, G, {
              value: ue
            }),
            group: le({}, G, {
              value: M
            }),
            groupCollapsed: le({}, G, {
              value: F
            }),
            groupEnd: le({}, G, {
              value: pe
            })
          });
        }
        he < 0 && w("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var z = q.ReactCurrentDispatcher, Ze;
    function Ae(G, Ce, Te) {
      {
        if (Ze === void 0)
          try {
            throw Error();
          } catch (Ft) {
            var ct = Ft.stack.trim().match(/\n( *(at )?)/);
            Ze = ct && ct[1] || "";
          }
        return `
` + Ze + G;
      }
    }
    var re = !1, Qe;
    {
      var Ee = typeof WeakMap == "function" ? WeakMap : Map;
      Qe = new Ee();
    }
    function Ue(G, Ce) {
      if (!G || re)
        return "";
      {
        var Te = Qe.get(G);
        if (Te !== void 0)
          return Te;
      }
      var ct;
      re = !0;
      var Ft = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var nt;
      nt = z.current, z.current = null, ce();
      try {
        if (Ce) {
          var Ct = function() {
            throw Error();
          };
          if (Object.defineProperty(Ct.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(Ct, []);
            } catch (fn) {
              ct = fn;
            }
            Reflect.construct(G, [], Ct);
          } else {
            try {
              Ct.call();
            } catch (fn) {
              ct = fn;
            }
            G.call(Ct.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (fn) {
            ct = fn;
          }
          G();
        }
      } catch (fn) {
        if (fn && ct && typeof fn.stack == "string") {
          for (var Wt = fn.stack.split(`
`), yr = ct.stack.split(`
`), hr = Wt.length - 1, Yt = yr.length - 1; hr >= 1 && Yt >= 0 && Wt[hr] !== yr[Yt]; )
            Yt--;
          for (; hr >= 1 && Yt >= 0; hr--, Yt--)
            if (Wt[hr] !== yr[Yt]) {
              if (hr !== 1 || Yt !== 1)
                do
                  if (hr--, Yt--, Yt < 0 || Wt[hr] !== yr[Yt]) {
                    var Vr = `
` + Wt[hr].replace(" at new ", " at ");
                    return G.displayName && Vr.includes("<anonymous>") && (Vr = Vr.replace("<anonymous>", G.displayName)), typeof G == "function" && Qe.set(G, Vr), Vr;
                  }
                while (hr >= 1 && Yt >= 0);
              break;
            }
        }
      } finally {
        re = !1, z.current = nt, oe(), Error.prepareStackTrace = Ft;
      }
      var xr = G ? G.displayName || G.name : "", Qn = xr ? Ae(xr) : "";
      return typeof G == "function" && Qe.set(G, Qn), Qn;
    }
    function He(G, Ce, Te) {
      return Ue(G, !1);
    }
    function te(G) {
      var Ce = G.prototype;
      return !!(Ce && Ce.isReactComponent);
    }
    function it(G, Ce, Te) {
      if (G == null)
        return "";
      if (typeof G == "function")
        return Ue(G, te(G));
      if (typeof G == "string")
        return Ae(G);
      switch (G) {
        case f:
          return Ae("Suspense");
        case l:
          return Ae("SuspenseList");
      }
      if (typeof G == "object")
        switch (G.$$typeof) {
          case u:
            return He(G.render);
          case d:
            return it(G.type, Ce, Te);
          case c: {
            var ct = G, Ft = ct._payload, nt = ct._init;
            try {
              return it(nt(Ft), Ce, Te);
            } catch {
            }
          }
        }
      return "";
    }
    var Vt = Object.prototype.hasOwnProperty, Oe = {}, Bt = q.ReactDebugCurrentFrame;
    function mt(G) {
      if (G) {
        var Ce = G._owner, Te = it(G.type, G._source, Ce ? Ce.type : null);
        Bt.setExtraStackFrame(Te);
      } else
        Bt.setExtraStackFrame(null);
    }
    function Ot(G, Ce, Te, ct, Ft) {
      {
        var nt = Function.call.bind(Vt);
        for (var Ct in G)
          if (nt(G, Ct)) {
            var Wt = void 0;
            try {
              if (typeof G[Ct] != "function") {
                var yr = Error((ct || "React class") + ": " + Te + " type `" + Ct + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof G[Ct] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw yr.name = "Invariant Violation", yr;
              }
              Wt = G[Ct](Ce, Ct, ct, Te, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (hr) {
              Wt = hr;
            }
            Wt && !(Wt instanceof Error) && (mt(Ft), w("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", ct || "React class", Te, Ct, typeof Wt), mt(null)), Wt instanceof Error && !(Wt.message in Oe) && (Oe[Wt.message] = !0, mt(Ft), w("Failed %s type: %s", Te, Wt.message), mt(null));
          }
      }
    }
    var It = Array.isArray;
    function Me(G) {
      return It(G);
    }
    function Gr(G) {
      {
        var Ce = typeof Symbol == "function" && Symbol.toStringTag, Te = Ce && G[Symbol.toStringTag] || G.constructor.name || "Object";
        return Te;
      }
    }
    function $e(G) {
      try {
        return Je(G), !1;
      } catch {
        return !0;
      }
    }
    function Je(G) {
      return "" + G;
    }
    function qt(G) {
      if ($e(G))
        return w("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", Gr(G)), Je(G);
    }
    var ft = q.ReactCurrentOwner, at = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, rt, Dt, vr;
    vr = {};
    function Qr(G) {
      if (Vt.call(G, "ref")) {
        var Ce = Object.getOwnPropertyDescriptor(G, "ref").get;
        if (Ce && Ce.isReactWarning)
          return !1;
      }
      return G.ref !== void 0;
    }
    function un(G) {
      if (Vt.call(G, "key")) {
        var Ce = Object.getOwnPropertyDescriptor(G, "key").get;
        if (Ce && Ce.isReactWarning)
          return !1;
      }
      return G.key !== void 0;
    }
    function Nr(G, Ce) {
      if (typeof G.ref == "string" && ft.current && Ce && ft.current.stateNode !== Ce) {
        var Te = Z(ft.current.type);
        vr[Te] || (w('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', Z(ft.current.type), G.ref), vr[Te] = !0);
      }
    }
    function kr(G, Ce) {
      {
        var Te = function() {
          rt || (rt = !0, w("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", Ce));
        };
        Te.isReactWarning = !0, Object.defineProperty(G, "key", {
          get: Te,
          configurable: !0
        });
      }
    }
    function Jr(G, Ce) {
      {
        var Te = function() {
          Dt || (Dt = !0, w("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", Ce));
        };
        Te.isReactWarning = !0, Object.defineProperty(G, "ref", {
          get: Te,
          configurable: !0
        });
      }
    }
    var Ke = function(G, Ce, Te, ct, Ft, nt, Ct) {
      var Wt = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: t,
        // Built-in properties that belong on the element
        type: G,
        key: Ce,
        ref: Te,
        props: Ct,
        // Record the component responsible for creating this element.
        _owner: nt
      };
      return Wt._store = {}, Object.defineProperty(Wt._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(Wt, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: ct
      }), Object.defineProperty(Wt, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: Ft
      }), Object.freeze && (Object.freeze(Wt.props), Object.freeze(Wt)), Wt;
    };
    function Re(G, Ce, Te, ct, Ft) {
      {
        var nt, Ct = {}, Wt = null, yr = null;
        Te !== void 0 && (qt(Te), Wt = "" + Te), un(Ce) && (qt(Ce.key), Wt = "" + Ce.key), Qr(Ce) && (yr = Ce.ref, Nr(Ce, Ft));
        for (nt in Ce)
          Vt.call(Ce, nt) && !at.hasOwnProperty(nt) && (Ct[nt] = Ce[nt]);
        if (G && G.defaultProps) {
          var hr = G.defaultProps;
          for (nt in hr)
            Ct[nt] === void 0 && (Ct[nt] = hr[nt]);
        }
        if (Wt || yr) {
          var Yt = typeof G == "function" ? G.displayName || G.name || "Unknown" : G;
          Wt && kr(Ct, Yt), yr && Jr(Ct, Yt);
        }
        return Ke(G, Wt, yr, Ft, ct, ft.current, Ct);
      }
    }
    var ge = q.ReactCurrentOwner, qe = q.ReactDebugCurrentFrame;
    function Ve(G) {
      if (G) {
        var Ce = G._owner, Te = it(G.type, G._source, Ce ? Ce.type : null);
        qe.setExtraStackFrame(Te);
      } else
        qe.setExtraStackFrame(null);
    }
    var Ne;
    Ne = !1;
    function Xe(G) {
      return typeof G == "object" && G !== null && G.$$typeof === t;
    }
    function fe() {
      {
        if (ge.current) {
          var G = Z(ge.current.type);
          if (G)
            return `

Check the render method of \`` + G + "`.";
        }
        return "";
      }
    }
    function ke(G) {
      {
        if (G !== void 0) {
          var Ce = G.fileName.replace(/^.*[\\\/]/, ""), Te = G.lineNumber;
          return `

Check your code at ` + Ce + ":" + Te + ".";
        }
        return "";
      }
    }
    var ae = {};
    function me(G) {
      {
        var Ce = fe();
        if (!Ce) {
          var Te = typeof G == "string" ? G : G.displayName || G.name;
          Te && (Ce = `

Check the top-level render call using <` + Te + ">.");
        }
        return Ce;
      }
    }
    function se(G, Ce) {
      {
        if (!G._store || G._store.validated || G.key != null)
          return;
        G._store.validated = !0;
        var Te = me(Ce);
        if (ae[Te])
          return;
        ae[Te] = !0;
        var ct = "";
        G && G._owner && G._owner !== ge.current && (ct = " It was passed a child from " + Z(G._owner.type) + "."), Ve(G), w('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', Te, ct), Ve(null);
      }
    }
    function ze(G, Ce) {
      {
        if (typeof G != "object")
          return;
        if (Me(G))
          for (var Te = 0; Te < G.length; Te++) {
            var ct = G[Te];
            Xe(ct) && se(ct, Ce);
          }
        else if (Xe(G))
          G._store && (G._store.validated = !0);
        else if (G) {
          var Ft = m(G);
          if (typeof Ft == "function" && Ft !== G.entries)
            for (var nt = Ft.call(G), Ct; !(Ct = nt.next()).done; )
              Xe(Ct.value) && se(Ct.value, Ce);
        }
      }
    }
    function Pe(G) {
      {
        var Ce = G.type;
        if (Ce == null || typeof Ce == "string")
          return;
        var Te;
        if (typeof Ce == "function")
          Te = Ce.propTypes;
        else if (typeof Ce == "object" && (Ce.$$typeof === u || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        Ce.$$typeof === d))
          Te = Ce.propTypes;
        else
          return;
        if (Te) {
          var ct = Z(Ce);
          Ot(Te, G.props, "prop", ct, G);
        } else if (Ce.PropTypes !== void 0 && !Ne) {
          Ne = !0;
          var Ft = Z(Ce);
          w("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", Ft || "Unknown");
        }
        typeof Ce.getDefaultProps == "function" && !Ce.getDefaultProps.isReactClassApproved && w("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function dt(G) {
      {
        for (var Ce = Object.keys(G.props), Te = 0; Te < Ce.length; Te++) {
          var ct = Ce[Te];
          if (ct !== "children" && ct !== "key") {
            Ve(G), w("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", ct), Ve(null);
            break;
          }
        }
        G.ref !== null && (Ve(G), w("Invalid attribute `ref` supplied to `React.Fragment`."), Ve(null));
      }
    }
    function tt(G, Ce, Te, ct, Ft, nt) {
      {
        var Ct = L(G);
        if (!Ct) {
          var Wt = "";
          (G === void 0 || typeof G == "object" && G !== null && Object.keys(G).length === 0) && (Wt += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var yr = ke(Ft);
          yr ? Wt += yr : Wt += fe();
          var hr;
          G === null ? hr = "null" : Me(G) ? hr = "array" : G !== void 0 && G.$$typeof === t ? (hr = "<" + (Z(G.type) || "Unknown") + " />", Wt = " Did you accidentally export a JSX literal instead of a component?") : hr = typeof G, w("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", hr, Wt);
        }
        var Yt = Re(G, Ce, Te, Ft, nt);
        if (Yt == null)
          return Yt;
        if (Ct) {
          var Vr = Ce.children;
          if (Vr !== void 0)
            if (ct)
              if (Me(Vr)) {
                for (var xr = 0; xr < Vr.length; xr++)
                  ze(Vr[xr], G);
                Object.freeze && Object.freeze(Vr);
              } else
                w("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              ze(Vr, G);
        }
        return G === n ? dt(Yt) : Pe(Yt), Yt;
      }
    }
    function st(G, Ce, Te) {
      return tt(G, Ce, Te, !0);
    }
    function vt(G, Ce, Te) {
      return tt(G, Ce, Te, !1);
    }
    var ht = vt, lt = st;
    nf.Fragment = n, nf.jsx = ht, nf.jsxs = lt;
  }()), nf;
}
process.env.NODE_ENV === "production" ? im.exports = wU() : im.exports = kU();
var ay = im.exports;
const tn = ay.Fragment, j = ay.jsx, ut = ay.jsxs;
var am = { exports: {} }, Sv = {};
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Bq;
function WU() {
  if (Bq)
    return Sv;
  Bq = 1;
  var e = In;
  function t(d, c) {
    return d === c && (d !== 0 || 1 / d === 1 / c) || d !== d && c !== c;
  }
  var r = typeof Object.is == "function" ? Object.is : t, n = e.useState, i = e.useEffect, a = e.useLayoutEffect, s = e.useDebugValue;
  function o(d, c) {
    var p = c(), v = n({ inst: { value: p, getSnapshot: c } }), h = v[0].inst, m = v[1];
    return a(function() {
      h.value = p, h.getSnapshot = c, u(h) && m({ inst: h });
    }, [d, p, c]), i(function() {
      return u(h) && m({ inst: h }), d(function() {
        u(h) && m({ inst: h });
      });
    }, [d]), s(p), p;
  }
  function u(d) {
    var c = d.getSnapshot;
    d = d.value;
    try {
      var p = c();
      return !r(d, p);
    } catch {
      return !0;
    }
  }
  function f(d, c) {
    return c();
  }
  var l = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? f : o;
  return Sv.useSyncExternalStore = e.useSyncExternalStore !== void 0 ? e.useSyncExternalStore : l, Sv;
}
var Cv = {};
/**
 * @license React
 * use-sync-external-store-shim.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Dq;
function SU() {
  return Dq || (Dq = 1, process.env.NODE_ENV !== "production" && function() {
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
    var e = In, t = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function r(O) {
      {
        for (var C = arguments.length, R = new Array(C > 1 ? C - 1 : 0), I = 1; I < C; I++)
          R[I - 1] = arguments[I];
        n("error", O, R);
      }
    }
    function n(O, C, R) {
      {
        var I = t.ReactDebugCurrentFrame, P = I.getStackAddendum();
        P !== "" && (C += "%s", R = R.concat([P]));
        var K = R.map(function(B) {
          return String(B);
        });
        K.unshift("Warning: " + C), Function.prototype.apply.call(console[O], console, K);
      }
    }
    function i(O, C) {
      return O === C && (O !== 0 || 1 / O === 1 / C) || O !== O && C !== C;
    }
    var a = typeof Object.is == "function" ? Object.is : i, s = e.useState, o = e.useEffect, u = e.useLayoutEffect, f = e.useDebugValue, l = !1, d = !1;
    function c(O, C, R) {
      l || e.startTransition !== void 0 && (l = !0, r("You are using an outdated, pre-release alpha of React 18 that does not support useSyncExternalStore. The use-sync-external-store shim will not work correctly. Upgrade to a newer pre-release."));
      var I = C();
      if (!d) {
        var P = C();
        a(I, P) || (r("The result of getSnapshot should be cached to avoid an infinite loop"), d = !0);
      }
      var K = s({
        inst: {
          value: I,
          getSnapshot: C
        }
      }), B = K[0].inst, L = K[1];
      return u(function() {
        B.value = I, B.getSnapshot = C, p(B) && L({
          inst: B
        });
      }, [O, I, C]), o(function() {
        p(B) && L({
          inst: B
        });
        var _ = function() {
          p(B) && L({
            inst: B
          });
        };
        return O(_);
      }, [O]), f(I), I;
    }
    function p(O) {
      var C = O.getSnapshot, R = O.value;
      try {
        var I = C();
        return !a(R, I);
      } catch {
        return !0;
      }
    }
    function v(O, C, R) {
      return C();
    }
    var h = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u", m = !h, q = m ? v : c, w = e.useSyncExternalStore !== void 0 ? e.useSyncExternalStore : q;
    Cv.useSyncExternalStore = w, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
  }()), Cv;
}
process.env.NODE_ENV === "production" ? am.exports = WU() : am.exports = SU();
var j6 = am.exports, sm = { exports: {} }, Fv = {};
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Lq;
function CU() {
  if (Lq)
    return Fv;
  Lq = 1;
  var e = In, t = j6;
  function r(f, l) {
    return f === l && (f !== 0 || 1 / f === 1 / l) || f !== f && l !== l;
  }
  var n = typeof Object.is == "function" ? Object.is : r, i = t.useSyncExternalStore, a = e.useRef, s = e.useEffect, o = e.useMemo, u = e.useDebugValue;
  return Fv.useSyncExternalStoreWithSelector = function(f, l, d, c, p) {
    var v = a(null);
    if (v.current === null) {
      var h = { hasValue: !1, value: null };
      v.current = h;
    } else
      h = v.current;
    v = o(function() {
      function q(I) {
        if (!w) {
          if (w = !0, O = I, I = c(I), p !== void 0 && h.hasValue) {
            var P = h.value;
            if (p(P, I))
              return C = P;
          }
          return C = I;
        }
        if (P = C, n(O, I))
          return P;
        var K = c(I);
        return p !== void 0 && p(P, K) ? P : (O = I, C = K);
      }
      var w = !1, O, C, R = d === void 0 ? null : d;
      return [function() {
        return q(l());
      }, R === null ? void 0 : function() {
        return q(R());
      }];
    }, [l, d, c, p]);
    var m = i(f, v[0], v[1]);
    return s(function() {
      h.hasValue = !0, h.value = m;
    }, [m]), u(m), m;
  }, Fv;
}
var Kv = {};
/**
 * @license React
 * use-sync-external-store-shim/with-selector.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Zq;
function FU() {
  return Zq || (Zq = 1, process.env.NODE_ENV !== "production" && function() {
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
    var e = In, t = j6;
    function r(l, d) {
      return l === d && (l !== 0 || 1 / l === 1 / d) || l !== l && d !== d;
    }
    var n = typeof Object.is == "function" ? Object.is : r, i = t.useSyncExternalStore, a = e.useRef, s = e.useEffect, o = e.useMemo, u = e.useDebugValue;
    function f(l, d, c, p, v) {
      var h = a(null), m;
      h.current === null ? (m = {
        hasValue: !1,
        value: null
      }, h.current = m) : m = h.current;
      var q = o(function() {
        var R = !1, I, P, K = function(ne) {
          if (!R) {
            R = !0, I = ne;
            var Z = p(ne);
            if (v !== void 0 && m.hasValue) {
              var le = m.value;
              if (v(le, Z))
                return P = le, le;
            }
            return P = Z, Z;
          }
          var he = I, Ie = P;
          if (n(he, ne))
            return Ie;
          var xe = p(ne);
          return v !== void 0 && v(Ie, xe) ? Ie : (I = ne, P = xe, xe);
        }, B = c === void 0 ? null : c, L = function() {
          return K(d());
        }, _ = B === null ? void 0 : function() {
          return K(B());
        };
        return [L, _];
      }, [d, c, p, v]), w = q[0], O = q[1], C = i(l, w, O);
      return s(function() {
        m.hasValue = !0, m.value = C;
      }, [C]), u(C), C;
    }
    Kv.useSyncExternalStoreWithSelector = f, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
  }()), Kv;
}
process.env.NODE_ENV === "production" ? sm.exports = CU() : sm.exports = FU();
var KU = sm.exports;
function RU(e) {
  e();
}
let Y6 = RU;
const TU = (e) => Y6 = e, UU = () => Y6, Mq = Symbol.for("react-redux-context"), jq = typeof globalThis < "u" ? globalThis : (
  /* fall back to a per-module scope (pre-8.1 behaviour) if `globalThis` is not available */
  {}
);
function xU() {
  var e;
  if (!et.createContext)
    return {};
  const t = (e = jq[Mq]) != null ? e : jq[Mq] = /* @__PURE__ */ new Map();
  let r = t.get(et.createContext);
  return r || (r = et.createContext(null), process.env.NODE_ENV !== "production" && (r.displayName = "ReactRedux"), t.set(et.createContext, r)), r;
}
const as = /* @__PURE__ */ xU();
function sy(e = as) {
  return function() {
    const r = _g(e);
    if (process.env.NODE_ENV !== "production" && !r)
      throw new Error("could not find react-redux context value; please ensure the component is wrapped in a <Provider>");
    return r;
  };
}
const z6 = /* @__PURE__ */ sy(), EU = () => {
  throw new Error("uSES not initialized!");
};
let G6 = EU;
const OU = (e) => {
  G6 = e;
}, NU = (e, t) => e === t;
function IU(e = as) {
  const t = e === as ? z6 : sy(e);
  return function(n, i = {}) {
    const {
      equalityFn: a = NU,
      stabilityCheck: s = void 0,
      noopCheck: o = void 0
    } = typeof i == "function" ? {
      equalityFn: i
    } : i;
    if (process.env.NODE_ENV !== "production") {
      if (!n)
        throw new Error("You must pass a selector to useSelector");
      if (typeof n != "function")
        throw new Error("You must pass a function as a selector to useSelector");
      if (typeof a != "function")
        throw new Error("You must pass a function as an equality function to useSelector");
    }
    const {
      store: u,
      subscription: f,
      getServerState: l,
      stabilityCheck: d,
      noopCheck: c
    } = t(), p = zr(!0), v = qr({
      [n.name](m) {
        const q = n(m);
        if (process.env.NODE_ENV !== "production") {
          const w = typeof s > "u" ? d : s;
          if (w === "always" || w === "once" && p.current) {
            const C = n(m);
            a(q, C) || console.warn("Selector " + (n.name || "unknown") + ` returned a different result when called with the same parameters. This can lead to unnecessary rerenders.
Selectors that return a new reference (such as an object or an array) should be memoized: https://redux.js.org/usage/deriving-data-selectors#optimizing-selectors-with-memoization`, {
              state: m,
              selected: q,
              selected2: C
            });
          }
          const O = typeof o > "u" ? c : o;
          (O === "always" || O === "once" && p.current) && q === m && console.warn("Selector " + (n.name || "unknown") + ` returned the root state when called. This can lead to unnecessary rerenders.
Selectors that return the entire state are almost certainly a mistake, as they will cause a rerender whenever *anything* in state changes.`), p.current && (p.current = !1);
        }
        return q;
      }
    }[n.name], [n, d, s]), h = G6(f.addNestedSub, u.getState, l || u.getState, v, a);
    return rm(h), h;
  };
}
const Lt = /* @__PURE__ */ IU();
function yt() {
  return yt = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, yt.apply(this, arguments);
}
function vn(e, t) {
  if (e == null)
    return {};
  var r = {}, n = Object.keys(e), i, a;
  for (a = 0; a < n.length; a++)
    i = n[a], !(t.indexOf(i) >= 0) && (r[i] = e[i]);
  return r;
}
var om = { exports: {} }, Ht = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Yq;
function XU() {
  if (Yq)
    return Ht;
  Yq = 1;
  var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, r = e ? Symbol.for("react.portal") : 60106, n = e ? Symbol.for("react.fragment") : 60107, i = e ? Symbol.for("react.strict_mode") : 60108, a = e ? Symbol.for("react.profiler") : 60114, s = e ? Symbol.for("react.provider") : 60109, o = e ? Symbol.for("react.context") : 60110, u = e ? Symbol.for("react.async_mode") : 60111, f = e ? Symbol.for("react.concurrent_mode") : 60111, l = e ? Symbol.for("react.forward_ref") : 60112, d = e ? Symbol.for("react.suspense") : 60113, c = e ? Symbol.for("react.suspense_list") : 60120, p = e ? Symbol.for("react.memo") : 60115, v = e ? Symbol.for("react.lazy") : 60116, h = e ? Symbol.for("react.block") : 60121, m = e ? Symbol.for("react.fundamental") : 60117, q = e ? Symbol.for("react.responder") : 60118, w = e ? Symbol.for("react.scope") : 60119;
  function O(R) {
    if (typeof R == "object" && R !== null) {
      var I = R.$$typeof;
      switch (I) {
        case t:
          switch (R = R.type, R) {
            case u:
            case f:
            case n:
            case a:
            case i:
            case d:
              return R;
            default:
              switch (R = R && R.$$typeof, R) {
                case o:
                case l:
                case v:
                case p:
                case s:
                  return R;
                default:
                  return I;
              }
          }
        case r:
          return I;
      }
    }
  }
  function C(R) {
    return O(R) === f;
  }
  return Ht.AsyncMode = u, Ht.ConcurrentMode = f, Ht.ContextConsumer = o, Ht.ContextProvider = s, Ht.Element = t, Ht.ForwardRef = l, Ht.Fragment = n, Ht.Lazy = v, Ht.Memo = p, Ht.Portal = r, Ht.Profiler = a, Ht.StrictMode = i, Ht.Suspense = d, Ht.isAsyncMode = function(R) {
    return C(R) || O(R) === u;
  }, Ht.isConcurrentMode = C, Ht.isContextConsumer = function(R) {
    return O(R) === o;
  }, Ht.isContextProvider = function(R) {
    return O(R) === s;
  }, Ht.isElement = function(R) {
    return typeof R == "object" && R !== null && R.$$typeof === t;
  }, Ht.isForwardRef = function(R) {
    return O(R) === l;
  }, Ht.isFragment = function(R) {
    return O(R) === n;
  }, Ht.isLazy = function(R) {
    return O(R) === v;
  }, Ht.isMemo = function(R) {
    return O(R) === p;
  }, Ht.isPortal = function(R) {
    return O(R) === r;
  }, Ht.isProfiler = function(R) {
    return O(R) === a;
  }, Ht.isStrictMode = function(R) {
    return O(R) === i;
  }, Ht.isSuspense = function(R) {
    return O(R) === d;
  }, Ht.isValidElementType = function(R) {
    return typeof R == "string" || typeof R == "function" || R === n || R === f || R === a || R === i || R === d || R === c || typeof R == "object" && R !== null && (R.$$typeof === v || R.$$typeof === p || R.$$typeof === s || R.$$typeof === o || R.$$typeof === l || R.$$typeof === m || R.$$typeof === q || R.$$typeof === w || R.$$typeof === h);
  }, Ht.typeOf = O, Ht;
}
var _t = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var zq;
function PU() {
  return zq || (zq = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, r = e ? Symbol.for("react.portal") : 60106, n = e ? Symbol.for("react.fragment") : 60107, i = e ? Symbol.for("react.strict_mode") : 60108, a = e ? Symbol.for("react.profiler") : 60114, s = e ? Symbol.for("react.provider") : 60109, o = e ? Symbol.for("react.context") : 60110, u = e ? Symbol.for("react.async_mode") : 60111, f = e ? Symbol.for("react.concurrent_mode") : 60111, l = e ? Symbol.for("react.forward_ref") : 60112, d = e ? Symbol.for("react.suspense") : 60113, c = e ? Symbol.for("react.suspense_list") : 60120, p = e ? Symbol.for("react.memo") : 60115, v = e ? Symbol.for("react.lazy") : 60116, h = e ? Symbol.for("react.block") : 60121, m = e ? Symbol.for("react.fundamental") : 60117, q = e ? Symbol.for("react.responder") : 60118, w = e ? Symbol.for("react.scope") : 60119;
    function O(Ue) {
      return typeof Ue == "string" || typeof Ue == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      Ue === n || Ue === f || Ue === a || Ue === i || Ue === d || Ue === c || typeof Ue == "object" && Ue !== null && (Ue.$$typeof === v || Ue.$$typeof === p || Ue.$$typeof === s || Ue.$$typeof === o || Ue.$$typeof === l || Ue.$$typeof === m || Ue.$$typeof === q || Ue.$$typeof === w || Ue.$$typeof === h);
    }
    function C(Ue) {
      if (typeof Ue == "object" && Ue !== null) {
        var He = Ue.$$typeof;
        switch (He) {
          case t:
            var te = Ue.type;
            switch (te) {
              case u:
              case f:
              case n:
              case a:
              case i:
              case d:
                return te;
              default:
                var it = te && te.$$typeof;
                switch (it) {
                  case o:
                  case l:
                  case v:
                  case p:
                  case s:
                    return it;
                  default:
                    return He;
                }
            }
          case r:
            return He;
        }
      }
    }
    var R = u, I = f, P = o, K = s, B = t, L = l, _ = n, ne = v, Z = p, le = r, he = a, Ie = i, xe = d, ye = !1;
    function ue(Ue) {
      return ye || (ye = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), M(Ue) || C(Ue) === u;
    }
    function M(Ue) {
      return C(Ue) === f;
    }
    function F(Ue) {
      return C(Ue) === o;
    }
    function pe(Ue) {
      return C(Ue) === s;
    }
    function We(Ue) {
      return typeof Ue == "object" && Ue !== null && Ue.$$typeof === t;
    }
    function ce(Ue) {
      return C(Ue) === l;
    }
    function oe(Ue) {
      return C(Ue) === n;
    }
    function z(Ue) {
      return C(Ue) === v;
    }
    function Ze(Ue) {
      return C(Ue) === p;
    }
    function Ae(Ue) {
      return C(Ue) === r;
    }
    function re(Ue) {
      return C(Ue) === a;
    }
    function Qe(Ue) {
      return C(Ue) === i;
    }
    function Ee(Ue) {
      return C(Ue) === d;
    }
    _t.AsyncMode = R, _t.ConcurrentMode = I, _t.ContextConsumer = P, _t.ContextProvider = K, _t.Element = B, _t.ForwardRef = L, _t.Fragment = _, _t.Lazy = ne, _t.Memo = Z, _t.Portal = le, _t.Profiler = he, _t.StrictMode = Ie, _t.Suspense = xe, _t.isAsyncMode = ue, _t.isConcurrentMode = M, _t.isContextConsumer = F, _t.isContextProvider = pe, _t.isElement = We, _t.isForwardRef = ce, _t.isFragment = oe, _t.isLazy = z, _t.isMemo = Ze, _t.isPortal = Ae, _t.isProfiler = re, _t.isStrictMode = Qe, _t.isSuspense = Ee, _t.isValidElementType = O, _t.typeOf = C;
  }()), _t;
}
process.env.NODE_ENV === "production" ? om.exports = XU() : om.exports = PU();
var oy = om.exports, Q6 = oy, BU = {
  $$typeof: !0,
  render: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0
}, DU = {
  $$typeof: !0,
  compare: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0,
  type: !0
}, J6 = {};
J6[Q6.ForwardRef] = BU;
J6[Q6.Memo] = DU;
var $t = {};
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Gq;
function LU() {
  if (Gq)
    return $t;
  Gq = 1;
  var e = Symbol.for("react.element"), t = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), n = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), a = Symbol.for("react.provider"), s = Symbol.for("react.context"), o = Symbol.for("react.server_context"), u = Symbol.for("react.forward_ref"), f = Symbol.for("react.suspense"), l = Symbol.for("react.suspense_list"), d = Symbol.for("react.memo"), c = Symbol.for("react.lazy"), p = Symbol.for("react.offscreen"), v;
  v = Symbol.for("react.module.reference");
  function h(m) {
    if (typeof m == "object" && m !== null) {
      var q = m.$$typeof;
      switch (q) {
        case e:
          switch (m = m.type, m) {
            case r:
            case i:
            case n:
            case f:
            case l:
              return m;
            default:
              switch (m = m && m.$$typeof, m) {
                case o:
                case s:
                case u:
                case c:
                case d:
                case a:
                  return m;
                default:
                  return q;
              }
          }
        case t:
          return q;
      }
    }
  }
  return $t.ContextConsumer = s, $t.ContextProvider = a, $t.Element = e, $t.ForwardRef = u, $t.Fragment = r, $t.Lazy = c, $t.Memo = d, $t.Portal = t, $t.Profiler = i, $t.StrictMode = n, $t.Suspense = f, $t.SuspenseList = l, $t.isAsyncMode = function() {
    return !1;
  }, $t.isConcurrentMode = function() {
    return !1;
  }, $t.isContextConsumer = function(m) {
    return h(m) === s;
  }, $t.isContextProvider = function(m) {
    return h(m) === a;
  }, $t.isElement = function(m) {
    return typeof m == "object" && m !== null && m.$$typeof === e;
  }, $t.isForwardRef = function(m) {
    return h(m) === u;
  }, $t.isFragment = function(m) {
    return h(m) === r;
  }, $t.isLazy = function(m) {
    return h(m) === c;
  }, $t.isMemo = function(m) {
    return h(m) === d;
  }, $t.isPortal = function(m) {
    return h(m) === t;
  }, $t.isProfiler = function(m) {
    return h(m) === i;
  }, $t.isStrictMode = function(m) {
    return h(m) === n;
  }, $t.isSuspense = function(m) {
    return h(m) === f;
  }, $t.isSuspenseList = function(m) {
    return h(m) === l;
  }, $t.isValidElementType = function(m) {
    return typeof m == "string" || typeof m == "function" || m === r || m === i || m === n || m === f || m === l || m === p || typeof m == "object" && m !== null && (m.$$typeof === c || m.$$typeof === d || m.$$typeof === a || m.$$typeof === s || m.$$typeof === u || m.$$typeof === v || m.getModuleId !== void 0);
  }, $t.typeOf = h, $t;
}
var er = {};
/**
 * @license React
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Qq;
function ZU() {
  return Qq || (Qq = 1, process.env.NODE_ENV !== "production" && function() {
    var e = Symbol.for("react.element"), t = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), n = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), a = Symbol.for("react.provider"), s = Symbol.for("react.context"), o = Symbol.for("react.server_context"), u = Symbol.for("react.forward_ref"), f = Symbol.for("react.suspense"), l = Symbol.for("react.suspense_list"), d = Symbol.for("react.memo"), c = Symbol.for("react.lazy"), p = Symbol.for("react.offscreen"), v = !1, h = !1, m = !1, q = !1, w = !1, O;
    O = Symbol.for("react.module.reference");
    function C(te) {
      return !!(typeof te == "string" || typeof te == "function" || te === r || te === i || w || te === n || te === f || te === l || q || te === p || v || h || m || typeof te == "object" && te !== null && (te.$$typeof === c || te.$$typeof === d || te.$$typeof === a || te.$$typeof === s || te.$$typeof === u || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      te.$$typeof === O || te.getModuleId !== void 0));
    }
    function R(te) {
      if (typeof te == "object" && te !== null) {
        var it = te.$$typeof;
        switch (it) {
          case e:
            var Vt = te.type;
            switch (Vt) {
              case r:
              case i:
              case n:
              case f:
              case l:
                return Vt;
              default:
                var Oe = Vt && Vt.$$typeof;
                switch (Oe) {
                  case o:
                  case s:
                  case u:
                  case c:
                  case d:
                  case a:
                    return Oe;
                  default:
                    return it;
                }
            }
          case t:
            return it;
        }
      }
    }
    var I = s, P = a, K = e, B = u, L = r, _ = c, ne = d, Z = t, le = i, he = n, Ie = f, xe = l, ye = !1, ue = !1;
    function M(te) {
      return ye || (ye = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function F(te) {
      return ue || (ue = !0, console.warn("The ReactIs.isConcurrentMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function pe(te) {
      return R(te) === s;
    }
    function We(te) {
      return R(te) === a;
    }
    function ce(te) {
      return typeof te == "object" && te !== null && te.$$typeof === e;
    }
    function oe(te) {
      return R(te) === u;
    }
    function z(te) {
      return R(te) === r;
    }
    function Ze(te) {
      return R(te) === c;
    }
    function Ae(te) {
      return R(te) === d;
    }
    function re(te) {
      return R(te) === t;
    }
    function Qe(te) {
      return R(te) === i;
    }
    function Ee(te) {
      return R(te) === n;
    }
    function Ue(te) {
      return R(te) === f;
    }
    function He(te) {
      return R(te) === l;
    }
    er.ContextConsumer = I, er.ContextProvider = P, er.Element = K, er.ForwardRef = B, er.Fragment = L, er.Lazy = _, er.Memo = ne, er.Portal = Z, er.Profiler = le, er.StrictMode = he, er.Suspense = Ie, er.SuspenseList = xe, er.isAsyncMode = M, er.isConcurrentMode = F, er.isContextConsumer = pe, er.isContextProvider = We, er.isElement = ce, er.isForwardRef = oe, er.isFragment = z, er.isLazy = Ze, er.isMemo = Ae, er.isPortal = re, er.isProfiler = Qe, er.isStrictMode = Ee, er.isSuspense = Ue, er.isSuspenseList = He, er.isValidElementType = C, er.typeOf = R;
  }()), er;
}
process.env.NODE_ENV === "production" ? LU() : ZU();
function MU() {
  const e = UU();
  let t = null, r = null;
  return {
    clear() {
      t = null, r = null;
    },
    notify() {
      e(() => {
        let n = t;
        for (; n; )
          n.callback(), n = n.next;
      });
    },
    get() {
      let n = [], i = t;
      for (; i; )
        n.push(i), i = i.next;
      return n;
    },
    subscribe(n) {
      let i = !0, a = r = {
        callback: n,
        next: null,
        prev: r
      };
      return a.prev ? a.prev.next = a : t = a, function() {
        !i || t === null || (i = !1, a.next ? a.next.prev = a.prev : r = a.prev, a.prev ? a.prev.next = a.next : t = a.next);
      };
    }
  };
}
const Jq = {
  notify() {
  },
  get: () => []
};
function jU(e, t) {
  let r, n = Jq;
  function i(d) {
    return u(), n.subscribe(d);
  }
  function a() {
    n.notify();
  }
  function s() {
    l.onStateChange && l.onStateChange();
  }
  function o() {
    return !!r;
  }
  function u() {
    r || (r = t ? t.addNestedSub(s) : e.subscribe(s), n = MU());
  }
  function f() {
    r && (r(), r = void 0, n.clear(), n = Jq);
  }
  const l = {
    addNestedSub: i,
    notifyNestedSubs: a,
    handleChangeWrapper: s,
    isSubscribed: o,
    trySubscribe: u,
    tryUnsubscribe: f,
    getListeners: () => n
  };
  return l;
}
const YU = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u", zU = YU ? et.useLayoutEffect : et.useEffect;
function Hq(e, t) {
  return e === t ? e !== 0 || t !== 0 || 1 / e === 1 / t : e !== e && t !== t;
}
function mc(e, t) {
  if (Hq(e, t))
    return !0;
  if (typeof e != "object" || e === null || typeof t != "object" || t === null)
    return !1;
  const r = Object.keys(e), n = Object.keys(t);
  if (r.length !== n.length)
    return !1;
  for (let i = 0; i < r.length; i++)
    if (!Object.prototype.hasOwnProperty.call(t, r[i]) || !Hq(e[r[i]], t[r[i]]))
      return !1;
  return !0;
}
function GU({
  store: e,
  context: t,
  children: r,
  serverState: n,
  stabilityCheck: i = "once",
  noopCheck: a = "once"
}) {
  const s = et.useMemo(() => {
    const f = jU(e);
    return {
      store: e,
      subscription: f,
      getServerState: n ? () => n : void 0,
      stabilityCheck: i,
      noopCheck: a
    };
  }, [e, n, i, a]), o = et.useMemo(() => e.getState(), [e]);
  zU(() => {
    const {
      subscription: f
    } = s;
    return f.onStateChange = f.notifyNestedSubs, f.trySubscribe(), o !== e.getState() && f.notifyNestedSubs(), () => {
      f.tryUnsubscribe(), f.onStateChange = void 0;
    };
  }, [s, o]);
  const u = t || as;
  return /* @__PURE__ */ et.createElement(u.Provider, {
    value: s
  }, r);
}
function H6(e = as) {
  const t = (
    // @ts-ignore
    e === as ? z6 : (
      // @ts-ignore
      sy(e)
    )
  );
  return function() {
    const {
      store: n
    } = t();
    return n;
  };
}
const _6 = /* @__PURE__ */ H6();
function QU(e = as) {
  const t = (
    // @ts-ignore
    e === as ? _6 : H6(e)
  );
  return function() {
    return t().dispatch;
  };
}
const Gs = /* @__PURE__ */ QU();
OU(KU.useSyncExternalStoreWithSelector);
TU(D6);
function Fr(e) {
  for (var t = arguments.length, r = Array(t > 1 ? t - 1 : 0), n = 1; n < t; n++)
    r[n - 1] = arguments[n];
  if (process.env.NODE_ENV !== "production") {
    var i = ix[e], a = i ? typeof i == "function" ? i.apply(null, r) : i : "unknown error nr: " + e;
    throw Error("[Immer] " + a);
  }
  throw Error("[Immer] minified error nr: " + e + (r.length ? " " + r.map(function(s) {
    return "'" + s + "'";
  }).join(",") : "") + ". Find the full error at: https://bit.ly/3cXEKWf");
}
function Fi(e) {
  return !!e && !!e[wr];
}
function Ki(e) {
  var t;
  return !!e && (function(r) {
    if (!r || typeof r != "object")
      return !1;
    var n = Object.getPrototypeOf(r);
    if (n === null)
      return !0;
    var i = Object.hasOwnProperty.call(n, "constructor") && n.constructor;
    return i === Object || typeof i == "function" && Function.toString.call(i) === ax;
  }(e) || Array.isArray(e) || !!e[xf] || !!(!((t = e.constructor) === null || t === void 0) && t[xf]) || op(e) || up(e));
}
function JU(e) {
  return Fi(e) || Fr(23, e), e[wr].t;
}
function ss(e, t, r) {
  r === void 0 && (r = !1), os(e) === 0 ? (r ? Object.keys : Do)(e).forEach(function(n) {
    r && typeof n == "symbol" || t(n, e[n], e);
  }) : e.forEach(function(n, i) {
    return t(i, n, e);
  });
}
function os(e) {
  var t = e[wr];
  return t ? t.i > 3 ? t.i - 4 : t.i : Array.isArray(e) ? 1 : op(e) ? 2 : up(e) ? 3 : 0;
}
function Ja(e, t) {
  return os(e) === 2 ? e.has(t) : Object.prototype.hasOwnProperty.call(e, t);
}
function Hd(e, t) {
  return os(e) === 2 ? e.get(t) : e[t];
}
function $6(e, t, r) {
  var n = os(e);
  n === 2 ? e.set(t, r) : n === 3 ? e.add(r) : e[t] = r;
}
function e3(e, t) {
  return e === t ? e !== 0 || 1 / e == 1 / t : e != e && t != t;
}
function op(e) {
  return rx && e instanceof Map;
}
function up(e) {
  return nx && e instanceof Set;
}
function Za(e) {
  return e.o || e.t;
}
function uy(e) {
  if (Array.isArray(e))
    return Array.prototype.slice.call(e);
  var t = r3(e);
  delete t[wr];
  for (var r = Do(t), n = 0; n < r.length; n++) {
    var i = r[n], a = t[i];
    a.writable === !1 && (a.writable = !0, a.configurable = !0), (a.get || a.set) && (t[i] = { configurable: !0, writable: !0, enumerable: a.enumerable, value: e[i] });
  }
  return Object.create(Object.getPrototypeOf(e), t);
}
function fy(e, t) {
  return t === void 0 && (t = !1), ly(e) || Fi(e) || !Ki(e) || (os(e) > 1 && (e.set = e.add = e.clear = e.delete = HU), Object.freeze(e), t && ss(e, function(r, n) {
    return fy(n, !0);
  }, !0)), e;
}
function HU() {
  Fr(2);
}
function ly(e) {
  return e == null || typeof e != "object" || Object.isFrozen(e);
}
function Li(e) {
  var t = dm[e];
  return t || Fr(18, e), t;
}
function t3(e, t) {
  dm[e] || (dm[e] = t);
}
function um() {
  return process.env.NODE_ENV === "production" || iu || Fr(0), iu;
}
function Rv(e, t) {
  t && (Li("Patches"), e.u = [], e.s = [], e.v = t);
}
function gc(e) {
  fm(e), e.p.forEach(_U), e.p = null;
}
function fm(e) {
  e === iu && (iu = e.l);
}
function _q(e) {
  return iu = { p: [], l: iu, h: e, m: !0, _: 0 };
}
function _U(e) {
  var t = e[wr];
  t.i === 0 || t.i === 1 ? t.j() : t.g = !0;
}
function Tv(e, t) {
  t._ = t.p.length;
  var r = t.p[0], n = e !== void 0 && e !== r;
  return t.h.O || Li("ES5").S(t, e, n), n ? (r[wr].P && (gc(t), Fr(4)), Ki(e) && (e = yc(t, e), t.l || Vc(t, e)), t.u && Li("Patches").M(r[wr].t, e, t.u, t.s)) : e = yc(t, r, []), gc(t), t.u && t.v(t.u, t.s), e !== cy ? e : void 0;
}
function yc(e, t, r) {
  if (ly(t))
    return t;
  var n = t[wr];
  if (!n)
    return ss(t, function(o, u) {
      return $q(e, n, t, o, u, r);
    }, !0), t;
  if (n.A !== e)
    return t;
  if (!n.P)
    return Vc(e, n.t, !0), n.t;
  if (!n.I) {
    n.I = !0, n.A._--;
    var i = n.i === 4 || n.i === 5 ? n.o = uy(n.k) : n.o, a = i, s = !1;
    n.i === 3 && (a = new Set(i), i.clear(), s = !0), ss(a, function(o, u) {
      return $q(e, n, i, o, u, r, s);
    }), Vc(e, i, !1), r && e.u && Li("Patches").N(n, r, e.u, e.s);
  }
  return n.o;
}
function $q(e, t, r, n, i, a, s) {
  if (process.env.NODE_ENV !== "production" && i === r && Fr(5), Fi(i)) {
    var o = yc(e, i, a && t && t.i !== 3 && !Ja(t.R, n) ? a.concat(n) : void 0);
    if ($6(r, n, o), !Fi(o))
      return;
    e.m = !1;
  } else
    s && r.add(i);
  if (Ki(i) && !ly(i)) {
    if (!e.h.D && e._ < 1)
      return;
    yc(e, i), t && t.A.l || Vc(e, i);
  }
}
function Vc(e, t, r) {
  r === void 0 && (r = !1), !e.l && e.h.D && e.m && fy(t, r);
}
function Uv(e, t) {
  var r = e[wr];
  return (r ? Za(r) : e)[t];
}
function eb(e, t) {
  if (t in e)
    for (var r = Object.getPrototypeOf(e); r; ) {
      var n = Object.getOwnPropertyDescriptor(r, t);
      if (n)
        return n;
      r = Object.getPrototypeOf(r);
    }
}
function Ma(e) {
  e.P || (e.P = !0, e.l && Ma(e.l));
}
function xv(e) {
  e.o || (e.o = uy(e.t));
}
function lm(e, t, r) {
  var n = op(t) ? Li("MapSet").F(t, r) : up(t) ? Li("MapSet").T(t, r) : e.O ? function(i, a) {
    var s = Array.isArray(i), o = { i: s ? 1 : 0, A: a ? a.A : um(), P: !1, I: !1, R: {}, l: a, t: i, k: null, o: null, j: null, C: !1 }, u = o, f = Mf;
    s && (u = [o], f = Wf);
    var l = Proxy.revocable(u, f), d = l.revoke, c = l.proxy;
    return o.k = c, o.j = d, c;
  }(t, r) : Li("ES5").J(t, r);
  return (r ? r.A : um()).p.push(n), n;
}
function $U(e) {
  return Fi(e) || Fr(22, e), function t(r) {
    if (!Ki(r))
      return r;
    var n, i = r[wr], a = os(r);
    if (i) {
      if (!i.P && (i.i < 4 || !Li("ES5").K(i)))
        return i.t;
      i.I = !0, n = tb(r, a), i.I = !1;
    } else
      n = tb(r, a);
    return ss(n, function(s, o) {
      i && Hd(i.t, s) === o || $6(n, s, t(o));
    }), a === 3 ? new Set(n) : n;
  }(e);
}
function tb(e, t) {
  switch (t) {
    case 2:
      return new Map(e);
    case 3:
      return Array.from(e);
  }
  return uy(e);
}
function ex() {
  function e(s, o) {
    var u = a[s];
    return u ? u.enumerable = o : a[s] = u = { configurable: !0, enumerable: o, get: function() {
      var f = this[wr];
      return process.env.NODE_ENV !== "production" && i(f), Mf.get(f, s);
    }, set: function(f) {
      var l = this[wr];
      process.env.NODE_ENV !== "production" && i(l), Mf.set(l, s, f);
    } }, u;
  }
  function t(s) {
    for (var o = s.length - 1; o >= 0; o--) {
      var u = s[o][wr];
      if (!u.P)
        switch (u.i) {
          case 5:
            n(u) && Ma(u);
            break;
          case 4:
            r(u) && Ma(u);
        }
    }
  }
  function r(s) {
    for (var o = s.t, u = s.k, f = Do(u), l = f.length - 1; l >= 0; l--) {
      var d = f[l];
      if (d !== wr) {
        var c = o[d];
        if (c === void 0 && !Ja(o, d))
          return !0;
        var p = u[d], v = p && p[wr];
        if (v ? v.t !== c : !e3(p, c))
          return !0;
      }
    }
    var h = !!o[wr];
    return f.length !== Do(o).length + (h ? 0 : 1);
  }
  function n(s) {
    var o = s.k;
    if (o.length !== s.t.length)
      return !0;
    var u = Object.getOwnPropertyDescriptor(o, o.length - 1);
    if (u && !u.get)
      return !0;
    for (var f = 0; f < o.length; f++)
      if (!o.hasOwnProperty(f))
        return !0;
    return !1;
  }
  function i(s) {
    s.g && Fr(3, JSON.stringify(Za(s)));
  }
  var a = {};
  t3("ES5", { J: function(s, o) {
    var u = Array.isArray(s), f = function(d, c) {
      if (d) {
        for (var p = Array(c.length), v = 0; v < c.length; v++)
          Object.defineProperty(p, "" + v, e(v, !0));
        return p;
      }
      var h = r3(c);
      delete h[wr];
      for (var m = Do(h), q = 0; q < m.length; q++) {
        var w = m[q];
        h[w] = e(w, d || !!h[w].enumerable);
      }
      return Object.create(Object.getPrototypeOf(c), h);
    }(u, s), l = { i: u ? 5 : 4, A: o ? o.A : um(), P: !1, I: !1, R: {}, l: o, t: s, k: f, o: null, g: !1, C: !1 };
    return Object.defineProperty(f, wr, { value: l, writable: !0 }), f;
  }, S: function(s, o, u) {
    u ? Fi(o) && o[wr].A === s && t(s.p) : (s.u && function f(l) {
      if (l && typeof l == "object") {
        var d = l[wr];
        if (d) {
          var c = d.t, p = d.k, v = d.R, h = d.i;
          if (h === 4)
            ss(p, function(C) {
              C !== wr && (c[C] !== void 0 || Ja(c, C) ? v[C] || f(p[C]) : (v[C] = !0, Ma(d)));
            }), ss(c, function(C) {
              p[C] !== void 0 || Ja(p, C) || (v[C] = !1, Ma(d));
            });
          else if (h === 5) {
            if (n(d) && (Ma(d), v.length = !0), p.length < c.length)
              for (var m = p.length; m < c.length; m++)
                v[m] = !1;
            else
              for (var q = c.length; q < p.length; q++)
                v[q] = !0;
            for (var w = Math.min(p.length, c.length), O = 0; O < w; O++)
              p.hasOwnProperty(O) || (v[O] = !0), v[O] === void 0 && f(p[O]);
          }
        }
      }
    }(s.p[0]), t(s.p));
  }, K: function(s) {
    return s.i === 4 ? r(s) : n(s);
  } });
}
function tx() {
  function e(n) {
    if (!Ki(n))
      return n;
    if (Array.isArray(n))
      return n.map(e);
    if (op(n))
      return new Map(Array.from(n.entries()).map(function(s) {
        return [s[0], e(s[1])];
      }));
    if (up(n))
      return new Set(Array.from(n).map(e));
    var i = Object.create(Object.getPrototypeOf(n));
    for (var a in n)
      i[a] = e(n[a]);
    return Ja(n, xf) && (i[xf] = n[xf]), i;
  }
  function t(n) {
    return Fi(n) ? e(n) : n;
  }
  var r = "add";
  t3("Patches", { $: function(n, i) {
    return i.forEach(function(a) {
      for (var s = a.path, o = a.op, u = n, f = 0; f < s.length - 1; f++) {
        var l = os(u), d = s[f];
        typeof d != "string" && typeof d != "number" && (d = "" + d), l !== 0 && l !== 1 || d !== "__proto__" && d !== "constructor" || Fr(24), typeof u == "function" && d === "prototype" && Fr(24), typeof (u = Hd(u, d)) != "object" && Fr(15, s.join("/"));
      }
      var c = os(u), p = e(a.value), v = s[s.length - 1];
      switch (o) {
        case "replace":
          switch (c) {
            case 2:
              return u.set(v, p);
            case 3:
              Fr(16);
            default:
              return u[v] = p;
          }
        case r:
          switch (c) {
            case 1:
              return v === "-" ? u.push(p) : u.splice(v, 0, p);
            case 2:
              return u.set(v, p);
            case 3:
              return u.add(p);
            default:
              return u[v] = p;
          }
        case "remove":
          switch (c) {
            case 1:
              return u.splice(v, 1);
            case 2:
              return u.delete(v);
            case 3:
              return u.delete(a.value);
            default:
              return delete u[v];
          }
        default:
          Fr(17, o);
      }
    }), n;
  }, N: function(n, i, a, s) {
    switch (n.i) {
      case 0:
      case 4:
      case 2:
        return function(o, u, f, l) {
          var d = o.t, c = o.o;
          ss(o.R, function(p, v) {
            var h = Hd(d, p), m = Hd(c, p), q = v ? Ja(d, p) ? "replace" : r : "remove";
            if (h !== m || q !== "replace") {
              var w = u.concat(p);
              f.push(q === "remove" ? { op: q, path: w } : { op: q, path: w, value: m }), l.push(q === r ? { op: "remove", path: w } : q === "remove" ? { op: r, path: w, value: t(h) } : { op: "replace", path: w, value: t(h) });
            }
          });
        }(n, i, a, s);
      case 5:
      case 1:
        return function(o, u, f, l) {
          var d = o.t, c = o.R, p = o.o;
          if (p.length < d.length) {
            var v = [p, d];
            d = v[0], p = v[1];
            var h = [l, f];
            f = h[0], l = h[1];
          }
          for (var m = 0; m < d.length; m++)
            if (c[m] && p[m] !== d[m]) {
              var q = u.concat([m]);
              f.push({ op: "replace", path: q, value: t(p[m]) }), l.push({ op: "replace", path: q, value: t(d[m]) });
            }
          for (var w = d.length; w < p.length; w++) {
            var O = u.concat([w]);
            f.push({ op: r, path: O, value: t(p[w]) });
          }
          d.length < p.length && l.push({ op: "replace", path: u.concat(["length"]), value: d.length });
        }(n, i, a, s);
      case 3:
        return function(o, u, f, l) {
          var d = o.t, c = o.o, p = 0;
          d.forEach(function(v) {
            if (!c.has(v)) {
              var h = u.concat([p]);
              f.push({ op: "remove", path: h, value: v }), l.unshift({ op: r, path: h, value: v });
            }
            p++;
          }), p = 0, c.forEach(function(v) {
            if (!d.has(v)) {
              var h = u.concat([p]);
              f.push({ op: r, path: h, value: v }), l.unshift({ op: "remove", path: h, value: v });
            }
            p++;
          });
        }(n, i, a, s);
    }
  }, M: function(n, i, a, s) {
    a.push({ op: "replace", path: [], value: i === cy ? void 0 : i }), s.push({ op: "replace", path: [], value: n });
  } });
}
var rb, iu, dy = typeof Symbol < "u" && typeof Symbol("x") == "symbol", rx = typeof Map < "u", nx = typeof Set < "u", nb = typeof Proxy < "u" && Proxy.revocable !== void 0 && typeof Reflect < "u", cy = dy ? Symbol.for("immer-nothing") : ((rb = {})["immer-nothing"] = !0, rb), xf = dy ? Symbol.for("immer-draftable") : "__$immer_draftable", wr = dy ? Symbol.for("immer-state") : "__$immer_state", ix = { 0: "Illegal state", 1: "Immer drafts cannot have computed properties", 2: "This object has been frozen and should not be mutated", 3: function(e) {
  return "Cannot use a proxy that has been revoked. Did you pass an object from inside an immer function to an async process? " + e;
}, 4: "An immer producer returned a new value *and* modified its draft. Either return a new value *or* modify the draft.", 5: "Immer forbids circular references", 6: "The first or second argument to `produce` must be a function", 7: "The third argument to `produce` must be a function or undefined", 8: "First argument to `createDraft` must be a plain object, an array, or an immerable object", 9: "First argument to `finishDraft` must be a draft returned by `createDraft`", 10: "The given draft is already finalized", 11: "Object.defineProperty() cannot be used on an Immer draft", 12: "Object.setPrototypeOf() cannot be used on an Immer draft", 13: "Immer only supports deleting array indices", 14: "Immer only supports setting array indices and the 'length' property", 15: function(e) {
  return "Cannot apply patch, path doesn't resolve: " + e;
}, 16: 'Sets cannot have "replace" patches.', 17: function(e) {
  return "Unsupported patch operation: " + e;
}, 18: function(e) {
  return "The plugin for '" + e + "' has not been loaded into Immer. To enable the plugin, import and call `enable" + e + "()` when initializing your application.";
}, 20: "Cannot use proxies if Proxy, Proxy.revocable or Reflect are not available", 21: function(e) {
  return "produce can only be called on things that are draftable: plain objects, arrays, Map, Set or classes that are marked with '[immerable]: true'. Got '" + e + "'";
}, 22: function(e) {
  return "'current' expects a draft, got: " + e;
}, 23: function(e) {
  return "'original' expects a draft, got: " + e;
}, 24: "Patching reserved attributes like __proto__, prototype and constructor is not allowed" }, ax = "" + Object.prototype.constructor, Do = typeof Reflect < "u" && Reflect.ownKeys ? Reflect.ownKeys : Object.getOwnPropertySymbols !== void 0 ? function(e) {
  return Object.getOwnPropertyNames(e).concat(Object.getOwnPropertySymbols(e));
} : Object.getOwnPropertyNames, r3 = Object.getOwnPropertyDescriptors || function(e) {
  var t = {};
  return Do(e).forEach(function(r) {
    t[r] = Object.getOwnPropertyDescriptor(e, r);
  }), t;
}, dm = {}, Mf = { get: function(e, t) {
  if (t === wr)
    return e;
  var r = Za(e);
  if (!Ja(r, t))
    return function(i, a, s) {
      var o, u = eb(a, s);
      return u ? "value" in u ? u.value : (o = u.get) === null || o === void 0 ? void 0 : o.call(i.k) : void 0;
    }(e, r, t);
  var n = r[t];
  return e.I || !Ki(n) ? n : n === Uv(e.t, t) ? (xv(e), e.o[t] = lm(e.A.h, n, e)) : n;
}, has: function(e, t) {
  return t in Za(e);
}, ownKeys: function(e) {
  return Reflect.ownKeys(Za(e));
}, set: function(e, t, r) {
  var n = eb(Za(e), t);
  if (n != null && n.set)
    return n.set.call(e.k, r), !0;
  if (!e.P) {
    var i = Uv(Za(e), t), a = i == null ? void 0 : i[wr];
    if (a && a.t === r)
      return e.o[t] = r, e.R[t] = !1, !0;
    if (e3(r, i) && (r !== void 0 || Ja(e.t, t)))
      return !0;
    xv(e), Ma(e);
  }
  return e.o[t] === r && (r !== void 0 || t in e.o) || Number.isNaN(r) && Number.isNaN(e.o[t]) || (e.o[t] = r, e.R[t] = !0), !0;
}, deleteProperty: function(e, t) {
  return Uv(e.t, t) !== void 0 || t in e.t ? (e.R[t] = !1, xv(e), Ma(e)) : delete e.R[t], e.o && delete e.o[t], !0;
}, getOwnPropertyDescriptor: function(e, t) {
  var r = Za(e), n = Reflect.getOwnPropertyDescriptor(r, t);
  return n && { writable: !0, configurable: e.i !== 1 || t !== "length", enumerable: n.enumerable, value: r[t] };
}, defineProperty: function() {
  Fr(11);
}, getPrototypeOf: function(e) {
  return Object.getPrototypeOf(e.t);
}, setPrototypeOf: function() {
  Fr(12);
} }, Wf = {};
ss(Mf, function(e, t) {
  Wf[e] = function() {
    return arguments[0] = arguments[0][0], t.apply(this, arguments);
  };
}), Wf.deleteProperty = function(e, t) {
  return process.env.NODE_ENV !== "production" && isNaN(parseInt(t)) && Fr(13), Wf.set.call(this, e, t, void 0);
}, Wf.set = function(e, t, r) {
  return process.env.NODE_ENV !== "production" && t !== "length" && isNaN(parseInt(t)) && Fr(14), Mf.set.call(this, e[0], t, r, e[0]);
};
var sx = function() {
  function e(r) {
    var n = this;
    this.O = nb, this.D = !0, this.produce = function(i, a, s) {
      if (typeof i == "function" && typeof a != "function") {
        var o = a;
        a = i;
        var u = n;
        return function(h) {
          var m = this;
          h === void 0 && (h = o);
          for (var q = arguments.length, w = Array(q > 1 ? q - 1 : 0), O = 1; O < q; O++)
            w[O - 1] = arguments[O];
          return u.produce(h, function(C) {
            var R;
            return (R = a).call.apply(R, [m, C].concat(w));
          });
        };
      }
      var f;
      if (typeof a != "function" && Fr(6), s !== void 0 && typeof s != "function" && Fr(7), Ki(i)) {
        var l = _q(n), d = lm(n, i, void 0), c = !0;
        try {
          f = a(d), c = !1;
        } finally {
          c ? gc(l) : fm(l);
        }
        return typeof Promise < "u" && f instanceof Promise ? f.then(function(h) {
          return Rv(l, s), Tv(h, l);
        }, function(h) {
          throw gc(l), h;
        }) : (Rv(l, s), Tv(f, l));
      }
      if (!i || typeof i != "object") {
        if ((f = a(i)) === void 0 && (f = i), f === cy && (f = void 0), n.D && fy(f, !0), s) {
          var p = [], v = [];
          Li("Patches").M(i, f, p, v), s(p, v);
        }
        return f;
      }
      Fr(21, i);
    }, this.produceWithPatches = function(i, a) {
      if (typeof i == "function")
        return function(f) {
          for (var l = arguments.length, d = Array(l > 1 ? l - 1 : 0), c = 1; c < l; c++)
            d[c - 1] = arguments[c];
          return n.produceWithPatches(f, function(p) {
            return i.apply(void 0, [p].concat(d));
          });
        };
      var s, o, u = n.produce(i, a, function(f, l) {
        s = f, o = l;
      });
      return typeof Promise < "u" && u instanceof Promise ? u.then(function(f) {
        return [f, s, o];
      }) : [u, s, o];
    }, typeof (r == null ? void 0 : r.useProxies) == "boolean" && this.setUseProxies(r.useProxies), typeof (r == null ? void 0 : r.autoFreeze) == "boolean" && this.setAutoFreeze(r.autoFreeze);
  }
  var t = e.prototype;
  return t.createDraft = function(r) {
    Ki(r) || Fr(8), Fi(r) && (r = $U(r));
    var n = _q(this), i = lm(this, r, void 0);
    return i[wr].C = !0, fm(n), i;
  }, t.finishDraft = function(r, n) {
    var i = r && r[wr];
    process.env.NODE_ENV !== "production" && (i && i.C || Fr(9), i.I && Fr(10));
    var a = i.A;
    return Rv(a, n), Tv(void 0, a);
  }, t.setAutoFreeze = function(r) {
    this.D = r;
  }, t.setUseProxies = function(r) {
    r && !nb && Fr(20), this.O = r;
  }, t.applyPatches = function(r, n) {
    var i;
    for (i = n.length - 1; i >= 0; i--) {
      var a = n[i];
      if (a.path.length === 0 && a.op === "replace") {
        r = a.value;
        break;
      }
    }
    i > -1 && (n = n.slice(i + 1));
    var s = Li("Patches").$;
    return Fi(r) ? s(r, n) : this.produce(r, function(o) {
      return s(o, n);
    });
  }, e;
}(), Ln = new sx(), dl = Ln.produce, n3 = Ln.produceWithPatches.bind(Ln);
Ln.setAutoFreeze.bind(Ln);
Ln.setUseProxies.bind(Ln);
var ib = Ln.applyPatches.bind(Ln);
Ln.createDraft.bind(Ln);
Ln.finishDraft.bind(Ln);
function au(e) {
  "@babel/helpers - typeof";
  return au = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, au(e);
}
function ox(e, t) {
  if (au(e) !== "object" || e === null)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (au(n) !== "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function ux(e) {
  var t = ox(e, "string");
  return au(t) === "symbol" ? t : String(t);
}
function fx(e, t, r) {
  return t = ux(t), t in e ? Object.defineProperty(e, t, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = r, e;
}
function ab(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function sb(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? ab(Object(r), !0).forEach(function(n) {
      fx(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : ab(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function pn(e) {
  return "Minified Redux error #" + e + "; visit https://redux.js.org/Errors?code=" + e + " for the full message or use the non-minified dev environment for full errors. ";
}
var ob = function() {
  return typeof Symbol == "function" && Symbol.observable || "@@observable";
}(), Ev = function() {
  return Math.random().toString(36).substring(7).split("").join(".");
}, Bs = {
  INIT: "@@redux/INIT" + Ev(),
  REPLACE: "@@redux/REPLACE" + Ev(),
  PROBE_UNKNOWN_ACTION: function() {
    return "@@redux/PROBE_UNKNOWN_ACTION" + Ev();
  }
};
function i3(e) {
  if (typeof e != "object" || e === null)
    return !1;
  for (var t = e; Object.getPrototypeOf(t) !== null; )
    t = Object.getPrototypeOf(t);
  return Object.getPrototypeOf(e) === t;
}
function lx(e) {
  if (e === void 0)
    return "undefined";
  if (e === null)
    return "null";
  var t = typeof e;
  switch (t) {
    case "boolean":
    case "string":
    case "number":
    case "symbol":
    case "function":
      return t;
  }
  if (Array.isArray(e))
    return "array";
  if (px(e))
    return "date";
  if (cx(e))
    return "error";
  var r = dx(e);
  switch (r) {
    case "Symbol":
    case "Promise":
    case "WeakMap":
    case "WeakSet":
    case "Map":
    case "Set":
      return r;
  }
  return t.slice(8, -1).toLowerCase().replace(/\s/g, "");
}
function dx(e) {
  return typeof e.constructor == "function" ? e.constructor.name : null;
}
function cx(e) {
  return e instanceof Error || typeof e.message == "string" && e.constructor && typeof e.constructor.stackTraceLimit == "number";
}
function px(e) {
  return e instanceof Date ? !0 : typeof e.toDateString == "function" && typeof e.getDate == "function" && typeof e.setDate == "function";
}
function Ts(e) {
  var t = typeof e;
  return process.env.NODE_ENV !== "production" && (t = lx(e)), t;
}
function a3(e, t, r) {
  var n;
  if (typeof t == "function" && typeof r == "function" || typeof r == "function" && typeof arguments[3] == "function")
    throw new Error(process.env.NODE_ENV === "production" ? pn(0) : "It looks like you are passing several store enhancers to createStore(). This is not supported. Instead, compose them together to a single function. See https://redux.js.org/tutorials/fundamentals/part-4-store#creating-a-store-with-enhancers for an example.");
  if (typeof t == "function" && typeof r > "u" && (r = t, t = void 0), typeof r < "u") {
    if (typeof r != "function")
      throw new Error(process.env.NODE_ENV === "production" ? pn(1) : "Expected the enhancer to be a function. Instead, received: '" + Ts(r) + "'");
    return r(a3)(e, t);
  }
  if (typeof e != "function")
    throw new Error(process.env.NODE_ENV === "production" ? pn(2) : "Expected the root reducer to be a function. Instead, received: '" + Ts(e) + "'");
  var i = e, a = t, s = [], o = s, u = !1;
  function f() {
    o === s && (o = s.slice());
  }
  function l() {
    if (u)
      throw new Error(process.env.NODE_ENV === "production" ? pn(3) : "You may not call store.getState() while the reducer is executing. The reducer has already received the state as an argument. Pass it down from the top reducer instead of reading it from the store.");
    return a;
  }
  function d(h) {
    if (typeof h != "function")
      throw new Error(process.env.NODE_ENV === "production" ? pn(4) : "Expected the listener to be a function. Instead, received: '" + Ts(h) + "'");
    if (u)
      throw new Error(process.env.NODE_ENV === "production" ? pn(5) : "You may not call store.subscribe() while the reducer is executing. If you would like to be notified after the store has been updated, subscribe from a component and invoke store.getState() in the callback to access the latest state. See https://redux.js.org/api/store#subscribelistener for more details.");
    var m = !0;
    return f(), o.push(h), function() {
      if (m) {
        if (u)
          throw new Error(process.env.NODE_ENV === "production" ? pn(6) : "You may not unsubscribe from a store listener while the reducer is executing. See https://redux.js.org/api/store#subscribelistener for more details.");
        m = !1, f();
        var w = o.indexOf(h);
        o.splice(w, 1), s = null;
      }
    };
  }
  function c(h) {
    if (!i3(h))
      throw new Error(process.env.NODE_ENV === "production" ? pn(7) : "Actions must be plain objects. Instead, the actual type was: '" + Ts(h) + "'. You may need to add middleware to your store setup to handle dispatching other values, such as 'redux-thunk' to handle dispatching functions. See https://redux.js.org/tutorials/fundamentals/part-4-store#middleware and https://redux.js.org/tutorials/fundamentals/part-6-async-logic#using-the-redux-thunk-middleware for examples.");
    if (typeof h.type > "u")
      throw new Error(process.env.NODE_ENV === "production" ? pn(8) : 'Actions may not have an undefined "type" property. You may have misspelled an action type string constant.');
    if (u)
      throw new Error(process.env.NODE_ENV === "production" ? pn(9) : "Reducers may not dispatch actions.");
    try {
      u = !0, a = i(a, h);
    } finally {
      u = !1;
    }
    for (var m = s = o, q = 0; q < m.length; q++) {
      var w = m[q];
      w();
    }
    return h;
  }
  function p(h) {
    if (typeof h != "function")
      throw new Error(process.env.NODE_ENV === "production" ? pn(10) : "Expected the nextReducer to be a function. Instead, received: '" + Ts(h));
    i = h, c({
      type: Bs.REPLACE
    });
  }
  function v() {
    var h, m = d;
    return h = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function(w) {
        if (typeof w != "object" || w === null)
          throw new Error(process.env.NODE_ENV === "production" ? pn(11) : "Expected the observer to be an object. Instead, received: '" + Ts(w) + "'");
        function O() {
          w.next && w.next(l());
        }
        O();
        var C = m(O);
        return {
          unsubscribe: C
        };
      }
    }, h[ob] = function() {
      return this;
    }, h;
  }
  return c({
    type: Bs.INIT
  }), n = {
    dispatch: c,
    subscribe: d,
    getState: l,
    replaceReducer: p
  }, n[ob] = v, n;
}
function ub(e) {
  typeof console < "u" && typeof console.error == "function" && console.error(e);
  try {
    throw new Error(e);
  } catch {
  }
}
function vx(e, t, r, n) {
  var i = Object.keys(t), a = r && r.type === Bs.INIT ? "preloadedState argument passed to createStore" : "previous state received by the reducer";
  if (i.length === 0)
    return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
  if (!i3(e))
    return "The " + a + ' has unexpected type of "' + Ts(e) + '". Expected argument to be an object with the following ' + ('keys: "' + i.join('", "') + '"');
  var s = Object.keys(e).filter(function(o) {
    return !t.hasOwnProperty(o) && !n[o];
  });
  if (s.forEach(function(o) {
    n[o] = !0;
  }), !(r && r.type === Bs.REPLACE) && s.length > 0)
    return "Unexpected " + (s.length > 1 ? "keys" : "key") + " " + ('"' + s.join('", "') + '" found in ' + a + ". ") + "Expected to find one of the known reducer keys instead: " + ('"' + i.join('", "') + '". Unexpected keys will be ignored.');
}
function hx(e) {
  Object.keys(e).forEach(function(t) {
    var r = e[t], n = r(void 0, {
      type: Bs.INIT
    });
    if (typeof n > "u")
      throw new Error(process.env.NODE_ENV === "production" ? pn(12) : 'The slice reducer for key "' + t + `" returned undefined during initialization. If the state passed to the reducer is undefined, you must explicitly return the initial state. The initial state may not be undefined. If you don't want to set a value for this reducer, you can use null instead of undefined.`);
    if (typeof r(void 0, {
      type: Bs.PROBE_UNKNOWN_ACTION()
    }) > "u")
      throw new Error(process.env.NODE_ENV === "production" ? pn(13) : 'The slice reducer for key "' + t + '" returned undefined when probed with a random type. ' + ("Don't try to handle '" + Bs.INIT + `' or other actions in "redux/*" `) + "namespace. They are considered private. Instead, you must return the current state for any unknown actions, unless it is undefined, in which case you must return the initial state, regardless of the action type. The initial state may not be undefined, but can be null.");
  });
}
function s3(e) {
  for (var t = Object.keys(e), r = {}, n = 0; n < t.length; n++) {
    var i = t[n];
    process.env.NODE_ENV !== "production" && typeof e[i] > "u" && ub('No reducer provided for key "' + i + '"'), typeof e[i] == "function" && (r[i] = e[i]);
  }
  var a = Object.keys(r), s;
  process.env.NODE_ENV !== "production" && (s = {});
  var o;
  try {
    hx(r);
  } catch (u) {
    o = u;
  }
  return function(f, l) {
    if (f === void 0 && (f = {}), o)
      throw o;
    if (process.env.NODE_ENV !== "production") {
      var d = vx(f, r, l, s);
      d && ub(d);
    }
    for (var c = !1, p = {}, v = 0; v < a.length; v++) {
      var h = a[v], m = r[h], q = f[h], w = m(q, l);
      if (typeof w > "u") {
        var O = l && l.type;
        throw new Error(process.env.NODE_ENV === "production" ? pn(14) : "When called with an action of type " + (O ? '"' + String(O) + '"' : "(unknown type)") + ', the slice reducer for key "' + h + '" returned undefined. To ignore an action, you must explicitly return the previous state. If you want this reducer to hold no value, you can return null instead of undefined.');
      }
      p[h] = w, c = c || w !== q;
    }
    return c = c || a.length !== Object.keys(f).length, c ? p : f;
  };
}
function qc() {
  for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++)
    t[r] = arguments[r];
  return t.length === 0 ? function(n) {
    return n;
  } : t.length === 1 ? t[0] : t.reduce(function(n, i) {
    return function() {
      return n(i.apply(void 0, arguments));
    };
  });
}
function mx() {
  for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++)
    t[r] = arguments[r];
  return function(n) {
    return function() {
      var i = n.apply(void 0, arguments), a = function() {
        throw new Error(process.env.NODE_ENV === "production" ? pn(15) : "Dispatching while constructing your middleware is not allowed. Other middleware would not be applied to this dispatch.");
      }, s = {
        getState: i.getState,
        dispatch: function() {
          return a.apply(void 0, arguments);
        }
      }, o = t.map(function(u) {
        return u(s);
      });
      return a = qc.apply(void 0, o)(i.dispatch), sb(sb({}, i), {}, {
        dispatch: a
      });
    };
  };
}
var bc = "NOT_FOUND";
function gx(e) {
  var t;
  return {
    get: function(n) {
      return t && e(t.key, n) ? t.value : bc;
    },
    put: function(n, i) {
      t = {
        key: n,
        value: i
      };
    },
    getEntries: function() {
      return t ? [t] : [];
    },
    clear: function() {
      t = void 0;
    }
  };
}
function yx(e, t) {
  var r = [];
  function n(o) {
    var u = r.findIndex(function(l) {
      return t(o, l.key);
    });
    if (u > -1) {
      var f = r[u];
      return u > 0 && (r.splice(u, 1), r.unshift(f)), f.value;
    }
    return bc;
  }
  function i(o, u) {
    n(o) === bc && (r.unshift({
      key: o,
      value: u
    }), r.length > e && r.pop());
  }
  function a() {
    return r;
  }
  function s() {
    r = [];
  }
  return {
    get: n,
    put: i,
    getEntries: a,
    clear: s
  };
}
var Vx = function(t, r) {
  return t === r;
};
function qx(e) {
  return function(r, n) {
    if (r === null || n === null || r.length !== n.length)
      return !1;
    for (var i = r.length, a = 0; a < i; a++)
      if (!e(r[a], n[a]))
        return !1;
    return !0;
  };
}
function cm(e, t) {
  var r = typeof t == "object" ? t : {
    equalityCheck: t
  }, n = r.equalityCheck, i = n === void 0 ? Vx : n, a = r.maxSize, s = a === void 0 ? 1 : a, o = r.resultEqualityCheck, u = qx(i), f = s === 1 ? gx(u) : yx(s, u);
  function l() {
    var d = f.get(arguments);
    if (d === bc) {
      if (d = e.apply(null, arguments), o) {
        var c = f.getEntries(), p = c.find(function(v) {
          return o(v.value, d);
        });
        p && (d = p.value);
      }
      f.put(arguments, d);
    }
    return d;
  }
  return l.clearCache = function() {
    return f.clear();
  }, l;
}
function bx(e) {
  var t = Array.isArray(e[0]) ? e[0] : e;
  if (!t.every(function(n) {
    return typeof n == "function";
  })) {
    var r = t.map(function(n) {
      return typeof n == "function" ? "function " + (n.name || "unnamed") + "()" : typeof n;
    }).join(", ");
    throw new Error("createSelector expects all input-selectors to be functions, but received the following types: [" + r + "]");
  }
  return t;
}
function Ax(e) {
  for (var t = arguments.length, r = new Array(t > 1 ? t - 1 : 0), n = 1; n < t; n++)
    r[n - 1] = arguments[n];
  var i = function() {
    for (var s = arguments.length, o = new Array(s), u = 0; u < s; u++)
      o[u] = arguments[u];
    var f = 0, l, d = {
      memoizeOptions: void 0
    }, c = o.pop();
    if (typeof c == "object" && (d = c, c = o.pop()), typeof c != "function")
      throw new Error("createSelector expects an output function after the inputs, but received: [" + typeof c + "]");
    var p = d, v = p.memoizeOptions, h = v === void 0 ? r : v, m = Array.isArray(h) ? h : [h], q = bx(o), w = e.apply(void 0, [function() {
      return f++, c.apply(null, arguments);
    }].concat(m)), O = e(function() {
      for (var R = [], I = q.length, P = 0; P < I; P++)
        R.push(q[P].apply(null, arguments));
      return l = w.apply(null, R), l;
    });
    return Object.assign(O, {
      resultFunc: c,
      memoizedResultFunc: w,
      dependencies: q,
      lastResult: function() {
        return l;
      },
      recomputations: function() {
        return f;
      },
      resetRecomputations: function() {
        return f = 0;
      }
    }), O;
  };
  return i;
}
var _r = /* @__PURE__ */ Ax(cm);
function o3(e) {
  var t = function(n) {
    var i = n.dispatch, a = n.getState;
    return function(s) {
      return function(o) {
        return typeof o == "function" ? o(i, a, e) : s(o);
      };
    };
  };
  return t;
}
var u3 = o3();
u3.withExtraArgument = o3;
const fb = u3;
var f3 = globalThis && globalThis.__extends || function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var a in i)
        Object.prototype.hasOwnProperty.call(i, a) && (n[a] = i[a]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), wx = globalThis && globalThis.__generator || function(e, t) {
  var r = { label: 0, sent: function() {
    if (a[0] & 1)
      throw a[1];
    return a[1];
  }, trys: [], ops: [] }, n, i, a, s;
  return s = { next: o(0), throw: o(1), return: o(2) }, typeof Symbol == "function" && (s[Symbol.iterator] = function() {
    return this;
  }), s;
  function o(f) {
    return function(l) {
      return u([f, l]);
    };
  }
  function u(f) {
    if (n)
      throw new TypeError("Generator is already executing.");
    for (; r; )
      try {
        if (n = 1, i && (a = f[0] & 2 ? i.return : f[0] ? i.throw || ((a = i.return) && a.call(i), 0) : i.next) && !(a = a.call(i, f[1])).done)
          return a;
        switch (i = 0, a && (f = [f[0] & 2, a.value]), f[0]) {
          case 0:
          case 1:
            a = f;
            break;
          case 4:
            return r.label++, { value: f[1], done: !1 };
          case 5:
            r.label++, i = f[1], f = [0];
            continue;
          case 7:
            f = r.ops.pop(), r.trys.pop();
            continue;
          default:
            if (a = r.trys, !(a = a.length > 0 && a[a.length - 1]) && (f[0] === 6 || f[0] === 2)) {
              r = 0;
              continue;
            }
            if (f[0] === 3 && (!a || f[1] > a[0] && f[1] < a[3])) {
              r.label = f[1];
              break;
            }
            if (f[0] === 6 && r.label < a[1]) {
              r.label = a[1], a = f;
              break;
            }
            if (a && r.label < a[2]) {
              r.label = a[2], r.ops.push(f);
              break;
            }
            a[2] && r.ops.pop(), r.trys.pop();
            continue;
        }
        f = t.call(e, r);
      } catch (l) {
        f = [6, l], i = 0;
      } finally {
        n = a = 0;
      }
    if (f[0] & 5)
      throw f[1];
    return { value: f[0] ? f[1] : void 0, done: !0 };
  }
}, su = globalThis && globalThis.__spreadArray || function(e, t) {
  for (var r = 0, n = t.length, i = e.length; r < n; r++, i++)
    e[i] = t[r];
  return e;
}, kx = Object.defineProperty, Wx = Object.defineProperties, Sx = Object.getOwnPropertyDescriptors, lb = Object.getOwnPropertySymbols, Cx = Object.prototype.hasOwnProperty, Fx = Object.prototype.propertyIsEnumerable, db = function(e, t, r) {
  return t in e ? kx(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[t] = r;
}, Ha = function(e, t) {
  for (var r in t || (t = {}))
    Cx.call(t, r) && db(e, r, t[r]);
  if (lb)
    for (var n = 0, i = lb(t); n < i.length; n++) {
      var r = i[n];
      Fx.call(t, r) && db(e, r, t[r]);
    }
  return e;
}, Ov = function(e, t) {
  return Wx(e, Sx(t));
}, Kx = function(e, t, r) {
  return new Promise(function(n, i) {
    var a = function(u) {
      try {
        o(r.next(u));
      } catch (f) {
        i(f);
      }
    }, s = function(u) {
      try {
        o(r.throw(u));
      } catch (f) {
        i(f);
      }
    }, o = function(u) {
      return u.done ? n(u.value) : Promise.resolve(u.value).then(a, s);
    };
    o((r = r.apply(e, t)).next());
  });
}, Rx = typeof window < "u" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : function() {
  if (arguments.length !== 0)
    return typeof arguments[0] == "object" ? qc : qc.apply(null, arguments);
};
function ma(e) {
  if (typeof e != "object" || e === null)
    return !1;
  var t = Object.getPrototypeOf(e);
  if (t === null)
    return !0;
  for (var r = t; Object.getPrototypeOf(r) !== null; )
    r = Object.getPrototypeOf(r);
  return t === r;
}
var l3 = function(e) {
  return e && typeof e.match == "function";
};
function bn(e, t) {
  function r() {
    for (var n = [], i = 0; i < arguments.length; i++)
      n[i] = arguments[i];
    if (t) {
      var a = t.apply(void 0, n);
      if (!a)
        throw new Error("prepareAction did not return an object");
      return Ha(Ha({
        type: e,
        payload: a.payload
      }, "meta" in a && { meta: a.meta }), "error" in a && { error: a.error });
    }
    return { type: e, payload: n[0] };
  }
  return r.toString = function() {
    return "" + e;
  }, r.type = e, r.match = function(n) {
    return n.type === e;
  }, r;
}
function Tx(e) {
  return typeof e == "function" && "type" in e && l3(e);
}
function Ux(e) {
  var t = e ? ("" + e).split("/") : [], r = t[t.length - 1] || "actionCreator";
  return 'Detected an action creator with type "' + (e || "unknown") + `" being dispatched. 
Make sure you're calling the action creator before dispatching, i.e. \`dispatch(` + r + "())` instead of `dispatch(" + r + ")`. This is necessary even if the action has no payload.";
}
function xx(e) {
  if (e === void 0 && (e = {}), process.env.NODE_ENV === "production")
    return function() {
      return function(n) {
        return function(i) {
          return n(i);
        };
      };
    };
  var t = e.isActionCreator, r = t === void 0 ? Tx : t;
  return function() {
    return function(n) {
      return function(i) {
        return r(i) && console.warn(Ux(i.type)), n(i);
      };
    };
  };
}
function d3(e, t) {
  var r = 0;
  return {
    measureTime: function(n) {
      var i = Date.now();
      try {
        return n();
      } finally {
        var a = Date.now();
        r += a - i;
      }
    },
    warnIfExceeded: function() {
      r > e && console.warn(t + " took " + r + "ms, which is more than the warning threshold of " + e + `ms. 
If your state or actions are very large, you may want to disable the middleware as it might cause too much of a slowdown in development mode. See https://redux-toolkit.js.org/api/getDefaultMiddleware for instructions.
It is disabled in production builds, so you don't need to worry about that.`);
    }
  };
}
var Ex = (
  /** @class */
  function(e) {
    f3(t, e);
    function t() {
      for (var r = [], n = 0; n < arguments.length; n++)
        r[n] = arguments[n];
      var i = e.apply(this, r) || this;
      return Object.setPrototypeOf(i, t.prototype), i;
    }
    return Object.defineProperty(t, Symbol.species, {
      get: function() {
        return t;
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.concat = function() {
      for (var r = [], n = 0; n < arguments.length; n++)
        r[n] = arguments[n];
      return e.prototype.concat.apply(this, r);
    }, t.prototype.prepend = function() {
      for (var r = [], n = 0; n < arguments.length; n++)
        r[n] = arguments[n];
      return r.length === 1 && Array.isArray(r[0]) ? new (t.bind.apply(t, su([void 0], r[0].concat(this))))() : new (t.bind.apply(t, su([void 0], r.concat(this))))();
    }, t;
  }(Array)
), Ox = (
  /** @class */
  function(e) {
    f3(t, e);
    function t() {
      for (var r = [], n = 0; n < arguments.length; n++)
        r[n] = arguments[n];
      var i = e.apply(this, r) || this;
      return Object.setPrototypeOf(i, t.prototype), i;
    }
    return Object.defineProperty(t, Symbol.species, {
      get: function() {
        return t;
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.concat = function() {
      for (var r = [], n = 0; n < arguments.length; n++)
        r[n] = arguments[n];
      return e.prototype.concat.apply(this, r);
    }, t.prototype.prepend = function() {
      for (var r = [], n = 0; n < arguments.length; n++)
        r[n] = arguments[n];
      return r.length === 1 && Array.isArray(r[0]) ? new (t.bind.apply(t, su([void 0], r[0].concat(this))))() : new (t.bind.apply(t, su([void 0], r.concat(this))))();
    }, t;
  }(Array)
);
function pm(e) {
  return Ki(e) ? dl(e, function() {
  }) : e;
}
var Nx = process.env.NODE_ENV === "production", cb = "Invariant failed";
function pb(e, t) {
  if (!e)
    throw Nx ? new Error(cb) : new Error(cb + ": " + (t || ""));
}
function Ix(e, t, r, n) {
  return JSON.stringify(e, Xx(t, n), r);
}
function Xx(e, t) {
  var r = [], n = [];
  return t || (t = function(i, a) {
    return r[0] === a ? "[Circular ~]" : "[Circular ~." + n.slice(0, r.indexOf(a)).join(".") + "]";
  }), function(i, a) {
    if (r.length > 0) {
      var s = r.indexOf(this);
      ~s ? r.splice(s + 1) : r.push(this), ~s ? n.splice(s, 1 / 0, i) : n.push(i), ~r.indexOf(a) && (a = t.call(this, i, a));
    } else
      r.push(a);
    return e == null ? a : e.call(this, i, a);
  };
}
function Px(e) {
  return typeof e != "object" || e == null || Object.isFrozen(e);
}
function Bx(e, t, r) {
  var n = c3(e, t, r);
  return {
    detectMutations: function() {
      return p3(e, t, n, r);
    }
  };
}
function c3(e, t, r, n, i) {
  t === void 0 && (t = []), n === void 0 && (n = ""), i === void 0 && (i = /* @__PURE__ */ new Set());
  var a = { value: r };
  if (!e(r) && !i.has(r)) {
    i.add(r), a.children = {};
    for (var s in r) {
      var o = n ? n + "." + s : s;
      t.length && t.indexOf(o) !== -1 || (a.children[s] = c3(e, t, r[s], o));
    }
  }
  return a;
}
function p3(e, t, r, n, i, a) {
  t === void 0 && (t = []), i === void 0 && (i = !1), a === void 0 && (a = "");
  var s = r ? r.value : void 0, o = s === n;
  if (i && !o && !Number.isNaN(n))
    return { wasMutated: !0, path: a };
  if (e(s) || e(n))
    return { wasMutated: !1 };
  var u = {};
  for (var f in r.children)
    u[f] = !0;
  for (var f in n)
    u[f] = !0;
  var l = t.length > 0, d = function(p) {
    var v = a ? a + "." + p : p;
    if (l) {
      var h = t.some(function(q) {
        return q instanceof RegExp ? q.test(v) : v === q;
      });
      if (h)
        return "continue";
    }
    var m = p3(e, t, r.children[p], n[p], o, v);
    if (m.wasMutated)
      return { value: m };
  };
  for (var f in u) {
    var c = d(f);
    if (typeof c == "object")
      return c.value;
  }
  return { wasMutated: !1 };
}
function Dx(e) {
  if (e === void 0 && (e = {}), process.env.NODE_ENV === "production")
    return function() {
      return function(u) {
        return function(f) {
          return u(f);
        };
      };
    };
  var t = e.isImmutable, r = t === void 0 ? Px : t, n = e.ignoredPaths, i = e.warnAfter, a = i === void 0 ? 32 : i, s = e.ignore;
  n = n || s;
  var o = Bx.bind(null, r, n);
  return function(u) {
    var f = u.getState, l = f(), d = o(l), c;
    return function(p) {
      return function(v) {
        var h = d3(a, "ImmutableStateInvariantMiddleware");
        h.measureTime(function() {
          l = f(), c = d.detectMutations(), d = o(l), pb(!c.wasMutated, "A state mutation was detected between dispatches, in the path '" + (c.path || "") + "'.  This may cause incorrect behavior. (https://redux.js.org/style-guide/style-guide#do-not-mutate-state)");
        });
        var m = p(v);
        return h.measureTime(function() {
          l = f(), c = d.detectMutations(), d = o(l), c.wasMutated && pb(!c.wasMutated, "A state mutation was detected inside a dispatch, in the path: " + (c.path || "") + ". Take a look at the reducer(s) handling the action " + Ix(v) + ". (https://redux.js.org/style-guide/style-guide#do-not-mutate-state)");
        }), h.warnIfExceeded(), m;
      };
    };
  };
}
function v3(e) {
  var t = typeof e;
  return e == null || t === "string" || t === "boolean" || t === "number" || Array.isArray(e) || ma(e);
}
function vm(e, t, r, n, i, a) {
  t === void 0 && (t = ""), r === void 0 && (r = v3), i === void 0 && (i = []);
  var s;
  if (!r(e))
    return {
      keyPath: t || "<root>",
      value: e
    };
  if (typeof e != "object" || e === null || a != null && a.has(e))
    return !1;
  for (var o = n != null ? n(e) : Object.entries(e), u = i.length > 0, f = function(m, q) {
    var w = t ? t + "." + m : m;
    if (u) {
      var O = i.some(function(C) {
        return C instanceof RegExp ? C.test(w) : w === C;
      });
      if (O)
        return "continue";
    }
    if (!r(q))
      return { value: {
        keyPath: w,
        value: q
      } };
    if (typeof q == "object" && (s = vm(q, w, r, n, i, a), s))
      return { value: s };
  }, l = 0, d = o; l < d.length; l++) {
    var c = d[l], p = c[0], v = c[1], h = f(p, v);
    if (typeof h == "object")
      return h.value;
  }
  return a && h3(e) && a.add(e), !1;
}
function h3(e) {
  if (!Object.isFrozen(e))
    return !1;
  for (var t = 0, r = Object.values(e); t < r.length; t++) {
    var n = r[t];
    if (!(typeof n != "object" || n === null) && !h3(n))
      return !1;
  }
  return !0;
}
function Lx(e) {
  if (e === void 0 && (e = {}), process.env.NODE_ENV === "production")
    return function() {
      return function(O) {
        return function(C) {
          return O(C);
        };
      };
    };
  var t = e.isSerializable, r = t === void 0 ? v3 : t, n = e.getEntries, i = e.ignoredActions, a = i === void 0 ? [] : i, s = e.ignoredActionPaths, o = s === void 0 ? ["meta.arg", "meta.baseQueryMeta"] : s, u = e.ignoredPaths, f = u === void 0 ? [] : u, l = e.warnAfter, d = l === void 0 ? 32 : l, c = e.ignoreState, p = c === void 0 ? !1 : c, v = e.ignoreActions, h = v === void 0 ? !1 : v, m = e.disableCache, q = m === void 0 ? !1 : m, w = !q && WeakSet ? /* @__PURE__ */ new WeakSet() : void 0;
  return function(O) {
    return function(C) {
      return function(R) {
        var I = C(R), P = d3(d, "SerializableStateInvariantMiddleware");
        return !h && !(a.length && a.indexOf(R.type) !== -1) && P.measureTime(function() {
          var K = vm(R, "", r, n, o, w);
          if (K) {
            var B = K.keyPath, L = K.value;
            console.error("A non-serializable value was detected in an action, in the path: `" + B + "`. Value:", L, `
Take a look at the logic that dispatched this action: `, R, `
(See https://redux.js.org/faq/actions#why-should-type-be-a-string-or-at-least-serializable-why-should-my-action-types-be-constants)`, `
(To allow non-serializable values see: https://redux-toolkit.js.org/usage/usage-guide#working-with-non-serializable-data)`);
          }
        }), p || (P.measureTime(function() {
          var K = O.getState(), B = vm(K, "", r, n, f, w);
          if (B) {
            var L = B.keyPath, _ = B.value;
            console.error("A non-serializable value was detected in the state, in the path: `" + L + "`. Value:", _, `
Take a look at the reducer(s) handling this action type: ` + R.type + `.
(See https://redux.js.org/faq/organizing-state#can-i-put-functions-promises-or-other-non-serializable-items-in-my-store-state)`);
          }
        }), P.warnIfExceeded()), I;
      };
    };
  };
}
function $l(e) {
  return typeof e == "boolean";
}
function Zx() {
  return function(t) {
    return Mx(t);
  };
}
function Mx(e) {
  e === void 0 && (e = {});
  var t = e.thunk, r = t === void 0 ? !0 : t, n = e.immutableCheck, i = n === void 0 ? !0 : n, a = e.serializableCheck, s = a === void 0 ? !0 : a, o = e.actionCreatorCheck, u = o === void 0 ? !0 : o, f = new Ex();
  if (r && ($l(r) ? f.push(fb) : f.push(fb.withExtraArgument(r.extraArgument))), process.env.NODE_ENV !== "production") {
    if (i) {
      var l = {};
      $l(i) || (l = i), f.unshift(Dx(l));
    }
    if (s) {
      var d = {};
      $l(s) || (d = s), f.push(Lx(d));
    }
    if (u) {
      var c = {};
      $l(u) || (c = u), f.unshift(xx(c));
    }
  }
  return f;
}
var Nv = process.env.NODE_ENV === "production";
function jx(e) {
  var t = Zx(), r = e || {}, n = r.reducer, i = n === void 0 ? void 0 : n, a = r.middleware, s = a === void 0 ? t() : a, o = r.devTools, u = o === void 0 ? !0 : o, f = r.preloadedState, l = f === void 0 ? void 0 : f, d = r.enhancers, c = d === void 0 ? void 0 : d, p;
  if (typeof i == "function")
    p = i;
  else if (ma(i))
    p = s3(i);
  else
    throw new Error('"reducer" is a required argument, and must be a function or an object of functions that can be passed to combineReducers');
  var v = s;
  if (typeof v == "function" && (v = v(t), !Nv && !Array.isArray(v)))
    throw new Error("when using a middleware builder function, an array of middleware must be returned");
  if (!Nv && v.some(function(C) {
    return typeof C != "function";
  }))
    throw new Error("each middleware provided to configureStore must be a function");
  var h = mx.apply(void 0, v), m = qc;
  u && (m = Rx(Ha({
    trace: !Nv
  }, typeof u == "object" && u)));
  var q = new Ox(h), w = q;
  Array.isArray(c) ? w = su([h], c) : typeof c == "function" && (w = c(q));
  var O = m.apply(void 0, w);
  return a3(p, l, O);
}
function m3(e) {
  var t = {}, r = [], n, i = {
    addCase: function(a, s) {
      if (process.env.NODE_ENV !== "production") {
        if (r.length > 0)
          throw new Error("`builder.addCase` should only be called before calling `builder.addMatcher`");
        if (n)
          throw new Error("`builder.addCase` should only be called before calling `builder.addDefaultCase`");
      }
      var o = typeof a == "string" ? a : a.type;
      if (!o)
        throw new Error("`builder.addCase` cannot be called with an empty action type");
      if (o in t)
        throw new Error("`builder.addCase` cannot be called with two reducers for the same action type");
      return t[o] = s, i;
    },
    addMatcher: function(a, s) {
      if (process.env.NODE_ENV !== "production" && n)
        throw new Error("`builder.addMatcher` should only be called before calling `builder.addDefaultCase`");
      return r.push({ matcher: a, reducer: s }), i;
    },
    addDefaultCase: function(a) {
      if (process.env.NODE_ENV !== "production" && n)
        throw new Error("`builder.addDefaultCase` can only be called once");
      return n = a, i;
    }
  };
  return e(i), [t, r, n];
}
function Yx(e) {
  return typeof e == "function";
}
var vb = !1;
function zx(e, t, r, n) {
  r === void 0 && (r = []), process.env.NODE_ENV !== "production" && typeof t == "object" && (vb || (vb = !0, console.warn("The object notation for `createReducer` is deprecated, and will be removed in RTK 2.0. Please use the 'builder callback' notation instead: https://redux-toolkit.js.org/api/createReducer")));
  var i = typeof t == "function" ? m3(t) : [t, r, n], a = i[0], s = i[1], o = i[2], u;
  if (Yx(e))
    u = function() {
      return pm(e());
    };
  else {
    var f = pm(e);
    u = function() {
      return f;
    };
  }
  function l(d, c) {
    d === void 0 && (d = u());
    var p = su([
      a[c.type]
    ], s.filter(function(v) {
      var h = v.matcher;
      return h(c);
    }).map(function(v) {
      var h = v.reducer;
      return h;
    }));
    return p.filter(function(v) {
      return !!v;
    }).length === 0 && (p = [o]), p.reduce(function(v, h) {
      if (h)
        if (Fi(v)) {
          var m = v, q = h(m, c);
          return q === void 0 ? v : q;
        } else {
          if (Ki(v))
            return dl(v, function(w) {
              return h(w, c);
            });
          var q = h(v, c);
          if (q === void 0) {
            if (v === null)
              return v;
            throw Error("A case reducer on a non-draftable value must not return undefined");
          }
          return q;
        }
      return v;
    }, d);
  }
  return l.getInitialState = u, l;
}
var hb = !1;
function Gx(e, t) {
  return e + "/" + t;
}
function On(e) {
  var t = e.name;
  if (!t)
    throw new Error("`name` is a required option for createSlice");
  typeof process < "u" && process.env.NODE_ENV === "development" && e.initialState === void 0 && console.error("You must provide an `initialState` value that is not `undefined`. You may have misspelled `initialState`");
  var r = typeof e.initialState == "function" ? e.initialState : pm(e.initialState), n = e.reducers || {}, i = Object.keys(n), a = {}, s = {}, o = {};
  i.forEach(function(l) {
    var d = n[l], c = Gx(t, l), p, v;
    "reducer" in d ? (p = d.reducer, v = d.prepare) : p = d, a[l] = p, s[c] = p, o[l] = v ? bn(c, v) : bn(c);
  });
  function u() {
    process.env.NODE_ENV !== "production" && typeof e.extraReducers == "object" && (hb || (hb = !0, console.warn("The object notation for `createSlice.extraReducers` is deprecated, and will be removed in RTK 2.0. Please use the 'builder callback' notation instead: https://redux-toolkit.js.org/api/createSlice")));
    var l = typeof e.extraReducers == "function" ? m3(e.extraReducers) : [e.extraReducers], d = l[0], c = d === void 0 ? {} : d, p = l[1], v = p === void 0 ? [] : p, h = l[2], m = h === void 0 ? void 0 : h, q = Ha(Ha({}, c), s);
    return zx(r, function(w) {
      for (var O in q)
        w.addCase(O, q[O]);
      for (var C = 0, R = v; C < R.length; C++) {
        var I = R[C];
        w.addMatcher(I.matcher, I.reducer);
      }
      m && w.addDefaultCase(m);
    });
  }
  var f;
  return {
    name: t,
    reducer: function(l, d) {
      return f || (f = u()), f(l, d);
    },
    actions: o,
    caseReducers: a,
    getInitialState: function() {
      return f || (f = u()), f.getInitialState();
    }
  };
}
var Qx = "ModuleSymbhasOwnPr-0123456789ABCDEFGHNRVfgctiUvz_KqYTJkLxpZXIjQW", g3 = function(e) {
  e === void 0 && (e = 21);
  for (var t = "", r = e; r--; )
    t += Qx[Math.random() * 64 | 0];
  return t;
}, Jx = [
  "name",
  "message",
  "stack",
  "code"
], Iv = (
  /** @class */
  function() {
    function e(t, r) {
      this.payload = t, this.meta = r;
    }
    return e;
  }()
), mb = (
  /** @class */
  function() {
    function e(t, r) {
      this.payload = t, this.meta = r;
    }
    return e;
  }()
), Hx = function(e) {
  if (typeof e == "object" && e !== null) {
    for (var t = {}, r = 0, n = Jx; r < n.length; r++) {
      var i = n[r];
      typeof e[i] == "string" && (t[i] = e[i]);
    }
    return t;
  }
  return { message: String(e) };
}, gb = function() {
  function e(t, r, n) {
    var i = bn(t + "/fulfilled", function(l, d, c, p) {
      return {
        payload: l,
        meta: Ov(Ha({}, p || {}), {
          arg: c,
          requestId: d,
          requestStatus: "fulfilled"
        })
      };
    }), a = bn(t + "/pending", function(l, d, c) {
      return {
        payload: void 0,
        meta: Ov(Ha({}, c || {}), {
          arg: d,
          requestId: l,
          requestStatus: "pending"
        })
      };
    }), s = bn(t + "/rejected", function(l, d, c, p, v) {
      return {
        payload: p,
        error: (n && n.serializeError || Hx)(l || "Rejected"),
        meta: Ov(Ha({}, v || {}), {
          arg: c,
          requestId: d,
          rejectedWithValue: !!p,
          requestStatus: "rejected",
          aborted: (l == null ? void 0 : l.name) === "AbortError",
          condition: (l == null ? void 0 : l.name) === "ConditionError"
        })
      };
    }), o = !1, u = typeof AbortController < "u" ? AbortController : (
      /** @class */
      function() {
        function l() {
          this.signal = {
            aborted: !1,
            addEventListener: function() {
            },
            dispatchEvent: function() {
              return !1;
            },
            onabort: function() {
            },
            removeEventListener: function() {
            },
            reason: void 0,
            throwIfAborted: function() {
            }
          };
        }
        return l.prototype.abort = function() {
          process.env.NODE_ENV !== "production" && (o || (o = !0, console.info("This platform does not implement AbortController. \nIf you want to use the AbortController to react to `abort` events, please consider importing a polyfill like 'abortcontroller-polyfill/dist/abortcontroller-polyfill-only'.")));
        }, l;
      }()
    );
    function f(l) {
      return function(d, c, p) {
        var v = n != null && n.idGenerator ? n.idGenerator(l) : g3(), h = new u(), m;
        function q(O) {
          m = O, h.abort();
        }
        var w = function() {
          return Kx(this, null, function() {
            var O, C, R, I, P, K, B;
            return wx(this, function(L) {
              switch (L.label) {
                case 0:
                  return L.trys.push([0, 4, , 5]), I = (O = n == null ? void 0 : n.condition) == null ? void 0 : O.call(n, l, { getState: c, extra: p }), $x(I) ? [4, I] : [3, 2];
                case 1:
                  I = L.sent(), L.label = 2;
                case 2:
                  if (I === !1 || h.signal.aborted)
                    throw {
                      name: "ConditionError",
                      message: "Aborted due to condition callback returning false."
                    };
                  return P = new Promise(function(_, ne) {
                    return h.signal.addEventListener("abort", function() {
                      return ne({
                        name: "AbortError",
                        message: m || "Aborted"
                      });
                    });
                  }), d(a(v, l, (C = n == null ? void 0 : n.getPendingMeta) == null ? void 0 : C.call(n, { requestId: v, arg: l }, { getState: c, extra: p }))), [4, Promise.race([
                    P,
                    Promise.resolve(r(l, {
                      dispatch: d,
                      getState: c,
                      extra: p,
                      requestId: v,
                      signal: h.signal,
                      abort: q,
                      rejectWithValue: function(_, ne) {
                        return new Iv(_, ne);
                      },
                      fulfillWithValue: function(_, ne) {
                        return new mb(_, ne);
                      }
                    })).then(function(_) {
                      if (_ instanceof Iv)
                        throw _;
                      return _ instanceof mb ? i(_.payload, v, l, _.meta) : i(_, v, l);
                    })
                  ])];
                case 3:
                  return R = L.sent(), [3, 5];
                case 4:
                  return K = L.sent(), R = K instanceof Iv ? s(null, v, l, K.payload, K.meta) : s(K, v, l), [3, 5];
                case 5:
                  return B = n && !n.dispatchConditionRejection && s.match(R) && R.meta.condition, B || d(R), [2, R];
              }
            });
          });
        }();
        return Object.assign(w, {
          abort: q,
          requestId: v,
          arg: l,
          unwrap: function() {
            return w.then(_x);
          }
        });
      };
    }
    return Object.assign(f, {
      pending: a,
      rejected: s,
      fulfilled: i,
      typePrefix: t
    });
  }
  return e.withTypes = function() {
    return e;
  }, e;
}();
function _x(e) {
  if (e.meta && e.meta.rejectedWithValue)
    throw e.payload;
  if (e.error)
    throw e.error;
  return e.payload;
}
function $x(e) {
  return e !== null && typeof e == "object" && typeof e.then == "function";
}
var y3 = function(e, t) {
  return l3(e) ? e.match(t) : e(t);
};
function Wu() {
  for (var e = [], t = 0; t < arguments.length; t++)
    e[t] = arguments[t];
  return function(r) {
    return e.some(function(n) {
      return y3(n, r);
    });
  };
}
function Ef() {
  for (var e = [], t = 0; t < arguments.length; t++)
    e[t] = arguments[t];
  return function(r) {
    return e.every(function(n) {
      return y3(n, r);
    });
  };
}
function fp(e, t) {
  if (!e || !e.meta)
    return !1;
  var r = typeof e.meta.requestId == "string", n = t.indexOf(e.meta.requestStatus) > -1;
  return r && n;
}
function cl(e) {
  return typeof e[0] == "function" && "pending" in e[0] && "fulfilled" in e[0] && "rejected" in e[0];
}
function py() {
  for (var e = [], t = 0; t < arguments.length; t++)
    e[t] = arguments[t];
  return e.length === 0 ? function(r) {
    return fp(r, ["pending"]);
  } : cl(e) ? function(r) {
    var n = e.map(function(a) {
      return a.pending;
    }), i = Wu.apply(void 0, n);
    return i(r);
  } : py()(e[0]);
}
function jf() {
  for (var e = [], t = 0; t < arguments.length; t++)
    e[t] = arguments[t];
  return e.length === 0 ? function(r) {
    return fp(r, ["rejected"]);
  } : cl(e) ? function(r) {
    var n = e.map(function(a) {
      return a.rejected;
    }), i = Wu.apply(void 0, n);
    return i(r);
  } : jf()(e[0]);
}
function lp() {
  for (var e = [], t = 0; t < arguments.length; t++)
    e[t] = arguments[t];
  var r = function(n) {
    return n && n.meta && n.meta.rejectedWithValue;
  };
  return e.length === 0 ? function(n) {
    var i = Ef(jf.apply(void 0, e), r);
    return i(n);
  } : cl(e) ? function(n) {
    var i = Ef(jf.apply(void 0, e), r);
    return i(n);
  } : lp()(e[0]);
}
function Qs() {
  for (var e = [], t = 0; t < arguments.length; t++)
    e[t] = arguments[t];
  return e.length === 0 ? function(r) {
    return fp(r, ["fulfilled"]);
  } : cl(e) ? function(r) {
    var n = e.map(function(a) {
      return a.fulfilled;
    }), i = Wu.apply(void 0, n);
    return i(r);
  } : Qs()(e[0]);
}
function hm() {
  for (var e = [], t = 0; t < arguments.length; t++)
    e[t] = arguments[t];
  return e.length === 0 ? function(r) {
    return fp(r, ["pending", "fulfilled", "rejected"]);
  } : cl(e) ? function(r) {
    for (var n = [], i = 0, a = e; i < a.length; i++) {
      var s = a[i];
      n.push(s.pending, s.rejected, s.fulfilled);
    }
    var o = Wu.apply(void 0, n);
    return o(r);
  } : hm()(e[0]);
}
var vy = "listenerMiddleware";
bn(vy + "/add");
bn(vy + "/removeAll");
bn(vy + "/remove");
var Sf = "RTK_autoBatch", af = function() {
  return function(e) {
    var t;
    return {
      payload: e,
      meta: (t = {}, t[Sf] = !0, t)
    };
  };
}, yb;
typeof queueMicrotask == "function" && queueMicrotask.bind(typeof window < "u" ? window : typeof global < "u" ? global : globalThis);
ex();
const Gi = bn("RESET_STORE_TO_INITIAL_STATE"), Vb = {
  conversations: {},
  conversationsUnreadMessagesMap: {}
}, hy = On({
  name: "conversations",
  initialState: Vb,
  reducers: {
    addConversation: (e, t) => {
      e.conversations[t.payload.sid] = t.payload;
    },
    updateConversation: (e, t) => {
      const { sid: r, data: n } = t.payload, i = e.conversations[r];
      i && (e.conversations[r] = { ...i, ...n });
    },
    removeConversation: (e, t) => {
      const r = t.payload;
      if (e.conversations[r]) {
        const { [r]: i, ...a } = e.conversations;
        e.conversations = { ...a };
      }
    },
    setConversationUnreadCount: (e, t) => {
      const { conversationId: r, unreadCount: n } = t.payload;
      e.conversationsUnreadMessagesMap[r] = n;
    }
  },
  extraReducers: (e) => e.addCase(Gi, () => Vb)
}), qb = {
  activeConversation: null,
  isChatOpen: !1,
  currentUser: { identity: "", favorites: [] }
}, V3 = On({
  name: "chat",
  initialState: qb,
  reducers: {
    toggleChat: (e) => {
      const t = e.isChatOpen;
      e.isChatOpen = !t;
    },
    setActiveConversation: (e, t) => {
      e.activeConversation = t.payload;
    },
    upsertCurrentUser: (e, t) => {
      e.currentUser.identity === t.payload.identity && (e.currentUser = t.payload);
    },
    setCurrentUser: (e, t) => {
      e.currentUser = t.payload;
    }
  },
  extraReducers: (e) => e.addCase(Gi, () => qb)
}), bb = {
  typingMap: {}
}, q3 = On({
  name: "conversations-typing",
  initialState: bb,
  reducers: {
    addTypingParticipant: (e, t) => {
      const { conversationId: r, participant: n } = t.payload, a = [...e.typingMap[r] ?? [], n], s = [...new Set(a)];
      e.typingMap[r] = s;
    },
    removeTypingParticipant: (e, t) => {
      const { conversationId: r, participant: n } = t.payload, a = (e.typingMap[r] ?? []).filter((s) => s !== n);
      e.typingMap[r] = a;
    }
  },
  extraReducers: (e) => e.addCase(Gi, () => bb)
});
var ou = globalThis && globalThis.__generator || function(e, t) {
  var r = { label: 0, sent: function() {
    if (a[0] & 1)
      throw a[1];
    return a[1];
  }, trys: [], ops: [] }, n, i, a, s;
  return s = { next: o(0), throw: o(1), return: o(2) }, typeof Symbol == "function" && (s[Symbol.iterator] = function() {
    return this;
  }), s;
  function o(f) {
    return function(l) {
      return u([f, l]);
    };
  }
  function u(f) {
    if (n)
      throw new TypeError("Generator is already executing.");
    for (; r; )
      try {
        if (n = 1, i && (a = f[0] & 2 ? i.return : f[0] ? i.throw || ((a = i.return) && a.call(i), 0) : i.next) && !(a = a.call(i, f[1])).done)
          return a;
        switch (i = 0, a && (f = [f[0] & 2, a.value]), f[0]) {
          case 0:
          case 1:
            a = f;
            break;
          case 4:
            return r.label++, { value: f[1], done: !1 };
          case 5:
            r.label++, i = f[1], f = [0];
            continue;
          case 7:
            f = r.ops.pop(), r.trys.pop();
            continue;
          default:
            if (a = r.trys, !(a = a.length > 0 && a[a.length - 1]) && (f[0] === 6 || f[0] === 2)) {
              r = 0;
              continue;
            }
            if (f[0] === 3 && (!a || f[1] > a[0] && f[1] < a[3])) {
              r.label = f[1];
              break;
            }
            if (f[0] === 6 && r.label < a[1]) {
              r.label = a[1], a = f;
              break;
            }
            if (a && r.label < a[2]) {
              r.label = a[2], r.ops.push(f);
              break;
            }
            a[2] && r.ops.pop(), r.trys.pop();
            continue;
        }
        f = t.call(e, r);
      } catch (l) {
        f = [6, l], i = 0;
      } finally {
        n = a = 0;
      }
    if (f[0] & 5)
      throw f[1];
    return { value: f[0] ? f[1] : void 0, done: !0 };
  }
}, Ac = globalThis && globalThis.__spreadArray || function(e, t) {
  for (var r = 0, n = t.length, i = e.length; r < n; r++, i++)
    e[i] = t[r];
  return e;
}, eE = Object.defineProperty, tE = Object.defineProperties, rE = Object.getOwnPropertyDescriptors, wc = Object.getOwnPropertySymbols, b3 = Object.prototype.hasOwnProperty, A3 = Object.prototype.propertyIsEnumerable, Ab = function(e, t, r) {
  return t in e ? eE(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[t] = r;
}, Cr = function(e, t) {
  for (var r in t || (t = {}))
    b3.call(t, r) && Ab(e, r, t[r]);
  if (wc)
    for (var n = 0, i = wc(t); n < i.length; n++) {
      var r = i[n];
      A3.call(t, r) && Ab(e, r, t[r]);
    }
  return e;
}, Bi = function(e, t) {
  return tE(e, rE(t));
}, wb = function(e, t) {
  var r = {};
  for (var n in e)
    b3.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && wc)
    for (var i = 0, a = wc(e); i < a.length; i++) {
      var n = a[i];
      t.indexOf(n) < 0 && A3.call(e, n) && (r[n] = e[n]);
    }
  return r;
}, uu = function(e, t, r) {
  return new Promise(function(n, i) {
    var a = function(u) {
      try {
        o(r.next(u));
      } catch (f) {
        i(f);
      }
    }, s = function(u) {
      try {
        o(r.throw(u));
      } catch (f) {
        i(f);
      }
    }, o = function(u) {
      return u.done ? n(u.value) : Promise.resolve(u.value).then(a, s);
    };
    o((r = r.apply(e, t)).next());
  });
}, Sr;
(function(e) {
  e.uninitialized = "uninitialized", e.pending = "pending", e.fulfilled = "fulfilled", e.rejected = "rejected";
})(Sr || (Sr = {}));
function nE(e) {
  return {
    status: e,
    isUninitialized: e === Sr.uninitialized,
    isLoading: e === Sr.pending,
    isSuccess: e === Sr.fulfilled,
    isError: e === Sr.rejected
  };
}
function iE(e) {
  return new RegExp("(^|:)//").test(e);
}
var aE = function(e) {
  return e.replace(/\/$/, "");
}, sE = function(e) {
  return e.replace(/^\//, "");
};
function oE(e, t) {
  if (!e)
    return t;
  if (!t)
    return e;
  if (iE(t))
    return t;
  var r = e.endsWith("/") || !t.startsWith("?") ? "/" : "";
  return e = aE(e), t = sE(t), "" + e + r + t;
}
var kb = function(e) {
  return [].concat.apply([], e);
};
function uE() {
  return typeof navigator > "u" || navigator.onLine === void 0 ? !0 : navigator.onLine;
}
function fE() {
  return typeof document > "u" ? !0 : document.visibilityState !== "hidden";
}
var Wb = ma;
function w3(e, t) {
  if (e === t || !(Wb(e) && Wb(t) || Array.isArray(e) && Array.isArray(t)))
    return t;
  for (var r = Object.keys(t), n = Object.keys(e), i = r.length === n.length, a = Array.isArray(t) ? [] : {}, s = 0, o = r; s < o.length; s++) {
    var u = o[s];
    a[u] = w3(e[u], t[u]), i && (i = e[u] === a[u]);
  }
  return i ? e : a;
}
var Sb = function() {
  for (var e = [], t = 0; t < arguments.length; t++)
    e[t] = arguments[t];
  return fetch.apply(void 0, e);
}, lE = function(e) {
  return e.status >= 200 && e.status <= 299;
}, dE = function(e) {
  return /ion\/(vnd\.api\+)?json/.test(e.get("content-type") || "");
};
function Cb(e) {
  if (!ma(e))
    return e;
  for (var t = Cr({}, e), r = 0, n = Object.entries(t); r < n.length; r++) {
    var i = n[r], a = i[0], s = i[1];
    s === void 0 && delete t[a];
  }
  return t;
}
function cE(e) {
  var t = this;
  e === void 0 && (e = {});
  var r = e, n = r.baseUrl, i = r.prepareHeaders, a = i === void 0 ? function(O) {
    return O;
  } : i, s = r.fetchFn, o = s === void 0 ? Sb : s, u = r.paramsSerializer, f = r.isJsonContentType, l = f === void 0 ? dE : f, d = r.jsonContentType, c = d === void 0 ? "application/json" : d, p = r.jsonReplacer, v = r.timeout, h = r.responseHandler, m = r.validateStatus, q = wb(r, [
    "baseUrl",
    "prepareHeaders",
    "fetchFn",
    "paramsSerializer",
    "isJsonContentType",
    "jsonContentType",
    "jsonReplacer",
    "timeout",
    "responseHandler",
    "validateStatus"
  ]);
  return typeof fetch > "u" && o === Sb && console.warn("Warning: `fetch` is not available. Please supply a custom `fetchFn` property to use `fetchBaseQuery` on SSR environments."), function(O, C) {
    return uu(t, null, function() {
      var R, I, P, K, B, L, _, ne, Z, le, he, Ie, xe, ye, ue, M, F, pe, We, ce, oe, z, Ze, Ae, re, Qe, Ee, Ue, He, te, it, Vt, Oe, Bt, mt, Ot;
      return ou(this, function(It) {
        switch (It.label) {
          case 0:
            return R = C.signal, I = C.getState, P = C.extra, K = C.endpoint, B = C.forced, L = C.type, ne = typeof O == "string" ? { url: O } : O, Z = ne.url, le = ne.headers, he = le === void 0 ? new Headers(q.headers) : le, Ie = ne.params, xe = Ie === void 0 ? void 0 : Ie, ye = ne.responseHandler, ue = ye === void 0 ? h ?? "json" : ye, M = ne.validateStatus, F = M === void 0 ? m ?? lE : M, pe = ne.timeout, We = pe === void 0 ? v : pe, ce = wb(ne, [
              "url",
              "headers",
              "params",
              "responseHandler",
              "validateStatus",
              "timeout"
            ]), oe = Cr(Bi(Cr({}, q), {
              signal: R
            }), ce), he = new Headers(Cb(he)), z = oe, [4, a(he, {
              getState: I,
              extra: P,
              endpoint: K,
              forced: B,
              type: L
            })];
          case 1:
            z.headers = It.sent() || he, Ze = function(Me) {
              return typeof Me == "object" && (ma(Me) || Array.isArray(Me) || typeof Me.toJSON == "function");
            }, !oe.headers.has("content-type") && Ze(oe.body) && oe.headers.set("content-type", c), Ze(oe.body) && l(oe.headers) && (oe.body = JSON.stringify(oe.body, p)), xe && (Ae = ~Z.indexOf("?") ? "&" : "?", re = u ? u(xe) : new URLSearchParams(Cb(xe)), Z += Ae + re), Z = oE(n, Z), Qe = new Request(Z, oe), Ee = new Request(Z, oe), _ = { request: Ee }, He = !1, te = We && setTimeout(function() {
              He = !0, C.abort();
            }, We), It.label = 2;
          case 2:
            return It.trys.push([2, 4, 5, 6]), [4, o(Qe)];
          case 3:
            return Ue = It.sent(), [3, 6];
          case 4:
            return it = It.sent(), [2, {
              error: {
                status: He ? "TIMEOUT_ERROR" : "FETCH_ERROR",
                error: String(it)
              },
              meta: _
            }];
          case 5:
            return te && clearTimeout(te), [
              7
              /*endfinally*/
            ];
          case 6:
            Vt = Ue.clone(), _.response = Vt, Bt = "", It.label = 7;
          case 7:
            return It.trys.push([7, 9, , 10]), [4, Promise.all([
              w(Ue, ue).then(function(Me) {
                return Oe = Me;
              }, function(Me) {
                return mt = Me;
              }),
              Vt.text().then(function(Me) {
                return Bt = Me;
              }, function() {
              })
            ])];
          case 8:
            if (It.sent(), mt)
              throw mt;
            return [3, 10];
          case 9:
            return Ot = It.sent(), [2, {
              error: {
                status: "PARSING_ERROR",
                originalStatus: Ue.status,
                data: Bt,
                error: String(Ot)
              },
              meta: _
            }];
          case 10:
            return [2, F(Ue, Oe) ? {
              data: Oe,
              meta: _
            } : {
              error: {
                status: Ue.status,
                data: Oe
              },
              meta: _
            }];
        }
      });
    });
  };
  function w(O, C) {
    return uu(this, null, function() {
      var R;
      return ou(this, function(I) {
        switch (I.label) {
          case 0:
            return typeof C == "function" ? [2, C(O)] : (C === "content-type" && (C = l(O.headers) ? "json" : "text"), C !== "json" ? [3, 2] : [4, O.text()]);
          case 1:
            return R = I.sent(), [2, R.length ? JSON.parse(R) : null];
          case 2:
            return [2, O.text()];
        }
      });
    });
  }
}
var Lo = (
  /** @class */
  function() {
    function e(t, r) {
      r === void 0 && (r = void 0), this.value = t, this.meta = r;
    }
    return e;
  }()
);
function pE(e, t) {
  return e === void 0 && (e = 0), t === void 0 && (t = 5), uu(this, null, function() {
    var r, n;
    return ou(this, function(i) {
      switch (i.label) {
        case 0:
          return r = Math.min(e, t), n = ~~((Math.random() + 0.4) * (300 << r)), [4, new Promise(function(a) {
            return setTimeout(function(s) {
              return a(s);
            }, n);
          })];
        case 1:
          return i.sent(), [
            2
            /*return*/
          ];
      }
    });
  });
}
function vE(e) {
  throw Object.assign(new Lo({ error: e }), {
    throwImmediately: !0
  });
}
var Fb = {}, hE = function(e, t) {
  return function(r, n, i) {
    return uu(void 0, null, function() {
      var a, s, o, u, f, l, d;
      return ou(this, function(c) {
        switch (c.label) {
          case 0:
            a = [
              5,
              (t || Fb).maxRetries,
              (i || Fb).maxRetries
            ].filter(function(p) {
              return p !== void 0;
            }), s = a.slice(-1)[0], o = function(p, v, h) {
              var m = h.attempt;
              return m <= s;
            }, u = Cr(Cr({
              maxRetries: s,
              backoff: pE,
              retryCondition: o
            }, t), i), f = 0, c.label = 1;
          case 1:
            c.label = 2;
          case 2:
            return c.trys.push([2, 4, , 6]), [4, e(r, n, i)];
          case 3:
            if (l = c.sent(), l.error)
              throw new Lo(l);
            return [2, l];
          case 4:
            if (d = c.sent(), f++, d.throwImmediately) {
              if (d instanceof Lo)
                return [2, d.value];
              throw d;
            }
            return d instanceof Lo && !u.retryCondition(d.value.error, r, {
              attempt: f,
              baseQueryApi: n,
              extraOptions: i
            }) ? [2, d.value] : [4, u.backoff(f, u.maxRetries)];
          case 5:
            return c.sent(), [3, 6];
          case 6:
            return [3, 1];
          case 7:
            return [
              2
              /*return*/
            ];
        }
      });
    });
  };
}, mE = /* @__PURE__ */ Object.assign(hE, { fail: vE }), my = /* @__PURE__ */ bn("__rtkq/focused"), k3 = /* @__PURE__ */ bn("__rtkq/unfocused"), gy = /* @__PURE__ */ bn("__rtkq/online"), W3 = /* @__PURE__ */ bn("__rtkq/offline"), Yi;
(function(e) {
  e.query = "query", e.mutation = "mutation";
})(Yi || (Yi = {}));
function S3(e) {
  return e.type === Yi.query;
}
function gE(e) {
  return e.type === Yi.mutation;
}
function yy(e, t, r, n, i, a) {
  return yE(e) ? e(t, r, n, i).map(mm).map(a) : Array.isArray(e) ? e.map(mm).map(a) : [];
}
function yE(e) {
  return typeof e == "function";
}
function mm(e) {
  return typeof e == "string" ? { type: e } : e;
}
function Xv(e) {
  return e != null;
}
var Yf = Symbol("forceQueryFn"), gm = function(e) {
  return typeof e[Yf] == "function";
};
function VE(e) {
  var t = e.serializeQueryArgs, r = e.queryThunk, n = e.mutationThunk, i = e.api, a = e.context, s = /* @__PURE__ */ new Map(), o = /* @__PURE__ */ new Map(), u = i.internalActions, f = u.unsubscribeQueryResult, l = u.removeMutationResult, d = u.updateSubscriptionOptions;
  return {
    buildInitiateQuery: O,
    buildInitiateMutation: C,
    getRunningQueryThunk: v,
    getRunningMutationThunk: h,
    getRunningQueriesThunk: m,
    getRunningMutationsThunk: q,
    getRunningOperationPromises: p,
    removalWarning: c
  };
  function c() {
    throw new Error(`This method had to be removed due to a conceptual bug in RTK.
       Please see https://github.com/reduxjs/redux-toolkit/pull/2481 for details.
       See https://redux-toolkit.js.org/rtk-query/usage/server-side-rendering for new guidance on SSR.`);
  }
  function p() {
    if (typeof process < "u" && process.env.NODE_ENV === "development")
      c();
    else {
      var R = function(I) {
        return Array.from(I.values()).flatMap(function(P) {
          return P ? Object.values(P) : [];
        });
      };
      return Ac(Ac([], R(s)), R(o)).filter(Xv);
    }
  }
  function v(R, I) {
    return function(P) {
      var K, B = a.endpointDefinitions[R], L = t({
        queryArgs: I,
        endpointDefinition: B,
        endpointName: R
      });
      return (K = s.get(P)) == null ? void 0 : K[L];
    };
  }
  function h(R, I) {
    return function(P) {
      var K;
      return (K = o.get(P)) == null ? void 0 : K[I];
    };
  }
  function m() {
    return function(R) {
      return Object.values(s.get(R) || {}).filter(Xv);
    };
  }
  function q() {
    return function(R) {
      return Object.values(o.get(R) || {}).filter(Xv);
    };
  }
  function w(R) {
    if (process.env.NODE_ENV !== "production") {
      if (w.triggered)
        return;
      var I = R(i.internalActions.internal_probeSubscription({
        queryCacheKey: "DOES_NOT_EXIST",
        requestId: "DUMMY_REQUEST_ID"
      }));
      if (w.triggered = !0, typeof I != "boolean")
        throw new Error('Warning: Middleware for RTK-Query API at reducerPath "' + i.reducerPath + `" has not been added to the store.
You must add the middleware for RTK-Query to function correctly!`);
    }
  }
  function O(R, I) {
    var P = function(K, B) {
      var L = B === void 0 ? {} : B, _ = L.subscribe, ne = _ === void 0 ? !0 : _, Z = L.forceRefetch, le = L.subscriptionOptions, he = Yf, Ie = L[he];
      return function(xe, ye) {
        var ue, M, F = t({
          queryArgs: K,
          endpointDefinition: I,
          endpointName: R
        }), pe = r((ue = {
          type: "query",
          subscribe: ne,
          forceRefetch: Z,
          subscriptionOptions: le,
          endpointName: R,
          originalArgs: K,
          queryCacheKey: F
        }, ue[Yf] = Ie, ue)), We = i.endpoints[R].select(K), ce = xe(pe), oe = We(ye());
        w(xe);
        var z = ce.requestId, Ze = ce.abort, Ae = oe.requestId !== z, re = (M = s.get(xe)) == null ? void 0 : M[F], Qe = function() {
          return We(ye());
        }, Ee = Object.assign(Ie ? ce.then(Qe) : Ae && !re ? Promise.resolve(oe) : Promise.all([re, ce]).then(Qe), {
          arg: K,
          requestId: z,
          subscriptionOptions: le,
          queryCacheKey: F,
          abort: Ze,
          unwrap: function() {
            return uu(this, null, function() {
              var He;
              return ou(this, function(te) {
                switch (te.label) {
                  case 0:
                    return [4, Ee];
                  case 1:
                    if (He = te.sent(), He.isError)
                      throw He.error;
                    return [2, He.data];
                }
              });
            });
          },
          refetch: function() {
            return xe(P(K, { subscribe: !1, forceRefetch: !0 }));
          },
          unsubscribe: function() {
            ne && xe(f({
              queryCacheKey: F,
              requestId: z
            }));
          },
          updateSubscriptionOptions: function(He) {
            Ee.subscriptionOptions = He, xe(d({
              endpointName: R,
              requestId: z,
              queryCacheKey: F,
              options: He
            }));
          }
        });
        if (!re && !Ae && !Ie) {
          var Ue = s.get(xe) || {};
          Ue[F] = Ee, s.set(xe, Ue), Ee.then(function() {
            delete Ue[F], Object.keys(Ue).length || s.delete(xe);
          });
        }
        return Ee;
      };
    };
    return P;
  }
  function C(R) {
    return function(I, P) {
      var K = P === void 0 ? {} : P, B = K.track, L = B === void 0 ? !0 : B, _ = K.fixedCacheKey;
      return function(ne, Z) {
        var le = n({
          type: "mutation",
          endpointName: R,
          originalArgs: I,
          track: L,
          fixedCacheKey: _
        }), he = ne(le);
        w(ne);
        var Ie = he.requestId, xe = he.abort, ye = he.unwrap, ue = he.unwrap().then(function(We) {
          return { data: We };
        }).catch(function(We) {
          return { error: We };
        }), M = function() {
          ne(l({ requestId: Ie, fixedCacheKey: _ }));
        }, F = Object.assign(ue, {
          arg: he.arg,
          requestId: Ie,
          abort: xe,
          unwrap: ye,
          unsubscribe: M,
          reset: M
        }), pe = o.get(ne) || {};
        return o.set(ne, pe), pe[Ie] = F, F.then(function() {
          delete pe[Ie], Object.keys(pe).length || o.delete(ne);
        }), _ && (pe[_] = F, F.then(function() {
          pe[_] === F && (delete pe[_], Object.keys(pe).length || o.delete(ne));
        })), F;
      };
    };
  }
}
function Kb(e) {
  return e;
}
function qE(e) {
  var t = this, r = e.reducerPath, n = e.baseQuery, i = e.context.endpointDefinitions, a = e.serializeQueryArgs, s = e.api, o = e.assertTagType, u = function(C, R, I, P) {
    return function(K, B) {
      var L = i[C], _ = a({
        queryArgs: R,
        endpointDefinition: L,
        endpointName: C
      });
      if (K(s.internalActions.queryResultPatched({ queryCacheKey: _, patches: I })), !!P) {
        var ne = s.endpoints[C].select(R)(B()), Z = yy(L.providesTags, ne.data, void 0, R, {}, o);
        K(s.internalActions.updateProvidedBy({ queryCacheKey: _, providedTags: Z }));
      }
    };
  }, f = function(C, R, I, P) {
    return P === void 0 && (P = !0), function(K, B) {
      var L, _, ne = s.endpoints[C], Z = ne.select(R)(B()), le = {
        patches: [],
        inversePatches: [],
        undo: function() {
          return K(s.util.patchQueryData(C, R, le.inversePatches, P));
        }
      };
      if (Z.status === Sr.uninitialized)
        return le;
      var he;
      if ("data" in Z)
        if (Ki(Z.data)) {
          var Ie = n3(Z.data, I), xe = Ie[0], ye = Ie[1], ue = Ie[2];
          (L = le.patches).push.apply(L, ye), (_ = le.inversePatches).push.apply(_, ue), he = xe;
        } else
          he = I(Z.data), le.patches.push({ op: "replace", path: [], value: he }), le.inversePatches.push({
            op: "replace",
            path: [],
            value: Z.data
          });
      return K(s.util.patchQueryData(C, R, le.patches, P)), le;
    };
  }, l = function(C, R, I) {
    return function(P) {
      var K;
      return P(s.endpoints[C].initiate(R, (K = {
        subscribe: !1,
        forceRefetch: !0
      }, K[Yf] = function() {
        return {
          data: I
        };
      }, K)));
    };
  }, d = function(C, R) {
    return uu(t, [C, R], function(I, P) {
      var K, B, L, _, ne, Z, le, he, Ie, xe, ye, ue, M, F, pe, We, ce, oe, z = P.signal, Ze = P.abort, Ae = P.rejectWithValue, re = P.fulfillWithValue, Qe = P.dispatch, Ee = P.getState, Ue = P.extra;
      return ou(this, function(He) {
        switch (He.label) {
          case 0:
            K = i[I.endpointName], He.label = 1;
          case 1:
            return He.trys.push([1, 8, , 13]), B = Kb, L = void 0, _ = {
              signal: z,
              abort: Ze,
              dispatch: Qe,
              getState: Ee,
              extra: Ue,
              endpoint: I.endpointName,
              type: I.type,
              forced: I.type === "query" ? c(I, Ee()) : void 0
            }, ne = I.type === "query" ? I[Yf] : void 0, ne ? (L = ne(), [3, 6]) : [3, 2];
          case 2:
            return K.query ? [4, n(K.query(I.originalArgs), _, K.extraOptions)] : [3, 4];
          case 3:
            return L = He.sent(), K.transformResponse && (B = K.transformResponse), [3, 6];
          case 4:
            return [4, K.queryFn(I.originalArgs, _, K.extraOptions, function(te) {
              return n(te, _, K.extraOptions);
            })];
          case 5:
            L = He.sent(), He.label = 6;
          case 6:
            if (typeof process < "u" && process.env.NODE_ENV === "development") {
              if (Z = K.query ? "`baseQuery`" : "`queryFn`", le = void 0, !L)
                le = Z + " did not return anything.";
              else if (typeof L != "object")
                le = Z + " did not return an object.";
              else if (L.error && L.data)
                le = Z + " returned an object containing both `error` and `result`.";
              else if (L.error === void 0 && L.data === void 0)
                le = Z + " returned an object containing neither a valid `error` and `result`. At least one of them should not be `undefined`";
              else
                for (he = 0, Ie = Object.keys(L); he < Ie.length; he++)
                  if (xe = Ie[he], xe !== "error" && xe !== "data" && xe !== "meta") {
                    le = "The object returned by " + Z + " has the unknown property " + xe + ".";
                    break;
                  }
              le && console.error("Error encountered handling the endpoint " + I.endpointName + `.
              ` + le + "\n              It needs to return an object with either the shape `{ data: <value> }` or `{ error: <value> }` that may contain an optional `meta` property.\n              Object returned was:", L);
            }
            if (L.error)
              throw new Lo(L.error, L.meta);
            return ye = re, [4, B(L.data, L.meta, I.originalArgs)];
          case 7:
            return [2, ye.apply(void 0, [He.sent(), (ce = {
              fulfilledTimeStamp: Date.now(),
              baseQueryMeta: L.meta
            }, ce[Sf] = !0, ce)])];
          case 8:
            if (ue = He.sent(), M = ue, !(M instanceof Lo))
              return [3, 12];
            F = Kb, K.query && K.transformErrorResponse && (F = K.transformErrorResponse), He.label = 9;
          case 9:
            return He.trys.push([9, 11, , 12]), pe = Ae, [4, F(M.value, M.meta, I.originalArgs)];
          case 10:
            return [2, pe.apply(void 0, [He.sent(), (oe = { baseQueryMeta: M.meta }, oe[Sf] = !0, oe)])];
          case 11:
            return We = He.sent(), M = We, [3, 12];
          case 12:
            throw typeof process < "u" && process.env.NODE_ENV !== "production" ? console.error('An unhandled error occurred processing a request for the endpoint "' + I.endpointName + `".
In the case of an unhandled error, no tags will be "provided" or "invalidated".`, M) : console.error(M), M;
          case 13:
            return [
              2
              /*return*/
            ];
        }
      });
    });
  };
  function c(C, R) {
    var I, P, K, B, L = (P = (I = R[r]) == null ? void 0 : I.queries) == null ? void 0 : P[C.queryCacheKey], _ = (K = R[r]) == null ? void 0 : K.config.refetchOnMountOrArgChange, ne = L == null ? void 0 : L.fulfilledTimeStamp, Z = (B = C.forceRefetch) != null ? B : C.subscribe && _;
    return Z ? Z === !0 || (Number(/* @__PURE__ */ new Date()) - Number(ne)) / 1e3 >= Z : !1;
  }
  var p = gb(r + "/executeQuery", d, {
    getPendingMeta: function() {
      var C;
      return C = { startedTimeStamp: Date.now() }, C[Sf] = !0, C;
    },
    condition: function(C, R) {
      var I = R.getState, P, K, B, L = I(), _ = (K = (P = L[r]) == null ? void 0 : P.queries) == null ? void 0 : K[C.queryCacheKey], ne = _ == null ? void 0 : _.fulfilledTimeStamp, Z = C.originalArgs, le = _ == null ? void 0 : _.originalArgs, he = i[C.endpointName];
      return gm(C) ? !0 : (_ == null ? void 0 : _.status) === "pending" ? !1 : c(C, L) || S3(he) && ((B = he == null ? void 0 : he.forceRefetch) != null && B.call(he, {
        currentArg: Z,
        previousArg: le,
        endpointState: _,
        state: L
      })) ? !0 : !ne;
    },
    dispatchConditionRejection: !0
  }), v = gb(r + "/executeMutation", d, {
    getPendingMeta: function() {
      var C;
      return C = { startedTimeStamp: Date.now() }, C[Sf] = !0, C;
    }
  }), h = function(C) {
    return "force" in C;
  }, m = function(C) {
    return "ifOlderThan" in C;
  }, q = function(C, R, I) {
    return function(P, K) {
      var B = h(I) && I.force, L = m(I) && I.ifOlderThan, _ = function(he) {
        return he === void 0 && (he = !0), s.endpoints[C].initiate(R, { forceRefetch: he });
      }, ne = s.endpoints[C].select(R)(K());
      if (B)
        P(_());
      else if (L) {
        var Z = ne == null ? void 0 : ne.fulfilledTimeStamp;
        if (!Z) {
          P(_());
          return;
        }
        var le = (Number(/* @__PURE__ */ new Date()) - Number(new Date(Z))) / 1e3 >= L;
        le && P(_());
      } else
        P(_(!1));
    };
  };
  function w(C) {
    return function(R) {
      var I, P;
      return ((P = (I = R == null ? void 0 : R.meta) == null ? void 0 : I.arg) == null ? void 0 : P.endpointName) === C;
    };
  }
  function O(C, R) {
    return {
      matchPending: Ef(py(C), w(R)),
      matchFulfilled: Ef(Qs(C), w(R)),
      matchRejected: Ef(jf(C), w(R))
    };
  }
  return {
    queryThunk: p,
    mutationThunk: v,
    prefetch: q,
    updateQueryData: f,
    upsertQueryData: l,
    patchQueryData: u,
    buildMatchThunkActions: O
  };
}
function C3(e, t, r, n) {
  return yy(r[e.meta.arg.endpointName][t], Qs(e) ? e.payload : void 0, lp(e) ? e.payload : void 0, e.meta.arg.originalArgs, "baseQueryMeta" in e.meta ? e.meta.baseQueryMeta : void 0, n);
}
function ed(e, t, r) {
  var n = e[t];
  n && r(n);
}
function zf(e) {
  var t;
  return (t = "arg" in e ? e.arg.fixedCacheKey : e.fixedCacheKey) != null ? t : e.requestId;
}
function Rb(e, t, r) {
  var n = e[zf(t)];
  n && r(n);
}
var sf = {};
function bE(e) {
  var t = e.reducerPath, r = e.queryThunk, n = e.mutationThunk, i = e.context, a = i.endpointDefinitions, s = i.apiUid, o = i.extractRehydrationInfo, u = i.hasRehydrationInfo, f = e.assertTagType, l = e.config, d = bn(t + "/resetApiState"), c = On({
    name: t + "/queries",
    initialState: sf,
    reducers: {
      removeQueryResult: {
        reducer: function(R, I) {
          var P = I.payload.queryCacheKey;
          delete R[P];
        },
        prepare: af()
      },
      queryResultPatched: {
        reducer: function(R, I) {
          var P = I.payload, K = P.queryCacheKey, B = P.patches;
          ed(R, K, function(L) {
            L.data = ib(L.data, B.concat());
          });
        },
        prepare: af()
      }
    },
    extraReducers: function(R) {
      R.addCase(r.pending, function(I, P) {
        var K = P.meta, B = P.meta.arg, L, _, ne = gm(B);
        (B.subscribe || ne) && ((_ = I[L = B.queryCacheKey]) != null || (I[L] = {
          status: Sr.uninitialized,
          endpointName: B.endpointName
        })), ed(I, B.queryCacheKey, function(Z) {
          Z.status = Sr.pending, Z.requestId = ne && Z.requestId ? Z.requestId : K.requestId, B.originalArgs !== void 0 && (Z.originalArgs = B.originalArgs), Z.startedTimeStamp = K.startedTimeStamp;
        });
      }).addCase(r.fulfilled, function(I, P) {
        var K = P.meta, B = P.payload;
        ed(I, K.arg.queryCacheKey, function(L) {
          var _;
          if (!(L.requestId !== K.requestId && !gm(K.arg))) {
            var ne = a[K.arg.endpointName].merge;
            if (L.status = Sr.fulfilled, ne)
              if (L.data !== void 0) {
                var Z = K.fulfilledTimeStamp, le = K.arg, he = K.baseQueryMeta, Ie = K.requestId, xe = dl(L.data, function(ye) {
                  return ne(ye, B, {
                    arg: le.originalArgs,
                    baseQueryMeta: he,
                    fulfilledTimeStamp: Z,
                    requestId: Ie
                  });
                });
                L.data = xe;
              } else
                L.data = B;
            else
              L.data = (_ = a[K.arg.endpointName].structuralSharing) == null || _ ? w3(Fi(L.data) ? JU(L.data) : L.data, B) : B;
            delete L.error, L.fulfilledTimeStamp = K.fulfilledTimeStamp;
          }
        });
      }).addCase(r.rejected, function(I, P) {
        var K = P.meta, B = K.condition, L = K.arg, _ = K.requestId, ne = P.error, Z = P.payload;
        ed(I, L.queryCacheKey, function(le) {
          if (!B) {
            if (le.requestId !== _)
              return;
            le.status = Sr.rejected, le.error = Z ?? ne;
          }
        });
      }).addMatcher(u, function(I, P) {
        for (var K = o(P).queries, B = 0, L = Object.entries(K); B < L.length; B++) {
          var _ = L[B], ne = _[0], Z = _[1];
          ((Z == null ? void 0 : Z.status) === Sr.fulfilled || (Z == null ? void 0 : Z.status) === Sr.rejected) && (I[ne] = Z);
        }
      });
    }
  }), p = On({
    name: t + "/mutations",
    initialState: sf,
    reducers: {
      removeMutationResult: {
        reducer: function(R, I) {
          var P = I.payload, K = zf(P);
          K in R && delete R[K];
        },
        prepare: af()
      }
    },
    extraReducers: function(R) {
      R.addCase(n.pending, function(I, P) {
        var K = P.meta, B = P.meta, L = B.requestId, _ = B.arg, ne = B.startedTimeStamp;
        _.track && (I[zf(K)] = {
          requestId: L,
          status: Sr.pending,
          endpointName: _.endpointName,
          startedTimeStamp: ne
        });
      }).addCase(n.fulfilled, function(I, P) {
        var K = P.payload, B = P.meta;
        B.arg.track && Rb(I, B, function(L) {
          L.requestId === B.requestId && (L.status = Sr.fulfilled, L.data = K, L.fulfilledTimeStamp = B.fulfilledTimeStamp);
        });
      }).addCase(n.rejected, function(I, P) {
        var K = P.payload, B = P.error, L = P.meta;
        L.arg.track && Rb(I, L, function(_) {
          _.requestId === L.requestId && (_.status = Sr.rejected, _.error = K ?? B);
        });
      }).addMatcher(u, function(I, P) {
        for (var K = o(P).mutations, B = 0, L = Object.entries(K); B < L.length; B++) {
          var _ = L[B], ne = _[0], Z = _[1];
          ((Z == null ? void 0 : Z.status) === Sr.fulfilled || (Z == null ? void 0 : Z.status) === Sr.rejected) && ne !== (Z == null ? void 0 : Z.requestId) && (I[ne] = Z);
        }
      });
    }
  }), v = On({
    name: t + "/invalidation",
    initialState: sf,
    reducers: {
      updateProvidedBy: {
        reducer: function(R, I) {
          for (var P, K, B, L, _ = I.payload, ne = _.queryCacheKey, Z = _.providedTags, le = 0, he = Object.values(R); le < he.length; le++)
            for (var Ie = he[le], xe = 0, ye = Object.values(Ie); xe < ye.length; xe++) {
              var ue = ye[xe], M = ue.indexOf(ne);
              M !== -1 && ue.splice(M, 1);
            }
          for (var F = 0, pe = Z; F < pe.length; F++) {
            var We = pe[F], ce = We.type, oe = We.id, z = (L = (K = (P = R[ce]) != null ? P : R[ce] = {})[B = oe || "__internal_without_id"]) != null ? L : K[B] = [], Ze = z.includes(ne);
            Ze || z.push(ne);
          }
        },
        prepare: af()
      }
    },
    extraReducers: function(R) {
      R.addCase(c.actions.removeQueryResult, function(I, P) {
        for (var K = P.payload.queryCacheKey, B = 0, L = Object.values(I); B < L.length; B++)
          for (var _ = L[B], ne = 0, Z = Object.values(_); ne < Z.length; ne++) {
            var le = Z[ne], he = le.indexOf(K);
            he !== -1 && le.splice(he, 1);
          }
      }).addMatcher(u, function(I, P) {
        for (var K, B, L, _, ne = o(P).provided, Z = 0, le = Object.entries(ne); Z < le.length; Z++)
          for (var he = le[Z], Ie = he[0], xe = he[1], ye = 0, ue = Object.entries(xe); ye < ue.length; ye++)
            for (var M = ue[ye], F = M[0], pe = M[1], We = (_ = (B = (K = I[Ie]) != null ? K : I[Ie] = {})[L = F || "__internal_without_id"]) != null ? _ : B[L] = [], ce = 0, oe = pe; ce < oe.length; ce++) {
              var z = oe[ce], Ze = We.includes(z);
              Ze || We.push(z);
            }
      }).addMatcher(Wu(Qs(r), lp(r)), function(I, P) {
        var K = C3(P, "providesTags", a, f), B = P.meta.arg.queryCacheKey;
        v.caseReducers.updateProvidedBy(I, v.actions.updateProvidedBy({
          queryCacheKey: B,
          providedTags: K
        }));
      });
    }
  }), h = On({
    name: t + "/subscriptions",
    initialState: sf,
    reducers: {
      updateSubscriptionOptions: function(R, I) {
      },
      unsubscribeQueryResult: function(R, I) {
      },
      internal_probeSubscription: function(R, I) {
      }
    }
  }), m = On({
    name: t + "/internalSubscriptions",
    initialState: sf,
    reducers: {
      subscriptionsUpdated: {
        reducer: function(R, I) {
          return ib(R, I.payload);
        },
        prepare: af()
      }
    }
  }), q = On({
    name: t + "/config",
    initialState: Cr({
      online: uE(),
      focused: fE(),
      middlewareRegistered: !1
    }, l),
    reducers: {
      middlewareRegistered: function(R, I) {
        var P = I.payload;
        R.middlewareRegistered = R.middlewareRegistered === "conflict" || s !== P ? "conflict" : !0;
      }
    },
    extraReducers: function(R) {
      R.addCase(gy, function(I) {
        I.online = !0;
      }).addCase(W3, function(I) {
        I.online = !1;
      }).addCase(my, function(I) {
        I.focused = !0;
      }).addCase(k3, function(I) {
        I.focused = !1;
      }).addMatcher(u, function(I) {
        return Cr({}, I);
      });
    }
  }), w = s3({
    queries: c.reducer,
    mutations: p.reducer,
    provided: v.reducer,
    subscriptions: m.reducer,
    config: q.reducer
  }), O = function(R, I) {
    return w(d.match(I) ? void 0 : R, I);
  }, C = Bi(Cr(Cr(Cr(Cr(Cr(Cr({}, q.actions), c.actions), h.actions), m.actions), p.actions), v.actions), {
    unsubscribeMutationResult: p.actions.removeMutationResult,
    resetApiState: d
  });
  return { reducer: O, actions: C };
}
var Is = /* @__PURE__ */ Symbol.for("RTKQ/skipToken"), F3 = {
  status: Sr.uninitialized
}, Tb = /* @__PURE__ */ dl(F3, function() {
}), Ub = /* @__PURE__ */ dl(F3, function() {
});
function AE(e) {
  var t = e.serializeQueryArgs, r = e.reducerPath, n = function(l) {
    return Tb;
  }, i = function(l) {
    return Ub;
  };
  return { buildQuerySelector: o, buildMutationSelector: u, selectInvalidatedBy: f };
  function a(l) {
    return Cr(Cr({}, l), nE(l.status));
  }
  function s(l) {
    var d = l[r];
    if (process.env.NODE_ENV !== "production" && !d) {
      if (s.triggered)
        return d;
      s.triggered = !0, console.error("Error: No data found at `state." + r + "`. Did you forget to add the reducer to the store?");
    }
    return d;
  }
  function o(l, d) {
    return function(c) {
      var p = t({
        queryArgs: c,
        endpointDefinition: d,
        endpointName: l
      }), v = function(m) {
        var q, w, O;
        return (O = (w = (q = s(m)) == null ? void 0 : q.queries) == null ? void 0 : w[p]) != null ? O : Tb;
      }, h = c === Is ? n : v;
      return _r(h, a);
    };
  }
  function u() {
    return function(l) {
      var d, c;
      typeof l == "object" ? c = (d = zf(l)) != null ? d : Is : c = l;
      var p = function(h) {
        var m, q, w;
        return (w = (q = (m = s(h)) == null ? void 0 : m.mutations) == null ? void 0 : q[c]) != null ? w : Ub;
      }, v = c === Is ? i : p;
      return _r(v, a);
    };
  }
  function f(l, d) {
    for (var c, p = l[r], v = /* @__PURE__ */ new Set(), h = 0, m = d.map(mm); h < m.length; h++) {
      var q = m[h], w = p.provided[q.type];
      if (w)
        for (var O = (c = q.id !== void 0 ? w[q.id] : kb(Object.values(w))) != null ? c : [], C = 0, R = O; C < R.length; C++) {
          var I = R[C];
          v.add(I);
        }
    }
    return kb(Array.from(v.values()).map(function(P) {
      var K = p.queries[P];
      return K ? [
        {
          queryCacheKey: P,
          endpointName: K.endpointName,
          originalArgs: K.originalArgs
        }
      ] : [];
    }));
  }
}
var td = WeakMap ? /* @__PURE__ */ new WeakMap() : void 0, xb = function(e) {
  var t = e.endpointName, r = e.queryArgs, n = "", i = td == null ? void 0 : td.get(r);
  if (typeof i == "string")
    n = i;
  else {
    var a = JSON.stringify(r, function(s, o) {
      return ma(o) ? Object.keys(o).sort().reduce(function(u, f) {
        return u[f] = o[f], u;
      }, {}) : o;
    });
    ma(r) && (td == null || td.set(r, a)), n = a;
  }
  return t + "(" + n + ")";
};
function wE() {
  for (var e = [], t = 0; t < arguments.length; t++)
    e[t] = arguments[t];
  return function(n) {
    var i = cm(function(l) {
      var d, c;
      return (c = n.extractRehydrationInfo) == null ? void 0 : c.call(n, l, {
        reducerPath: (d = n.reducerPath) != null ? d : "api"
      });
    }), a = Bi(Cr({
      reducerPath: "api",
      keepUnusedDataFor: 60,
      refetchOnMountOrArgChange: !1,
      refetchOnFocus: !1,
      refetchOnReconnect: !1
    }, n), {
      extractRehydrationInfo: i,
      serializeQueryArgs: function(l) {
        var d = xb;
        if ("serializeQueryArgs" in l.endpointDefinition) {
          var c = l.endpointDefinition.serializeQueryArgs;
          d = function(p) {
            var v = c(p);
            return typeof v == "string" ? v : xb(Bi(Cr({}, p), {
              queryArgs: v
            }));
          };
        } else
          n.serializeQueryArgs && (d = n.serializeQueryArgs);
        return d(l);
      },
      tagTypes: Ac([], n.tagTypes || [])
    }), s = {
      endpointDefinitions: {},
      batch: function(l) {
        l();
      },
      apiUid: g3(),
      extractRehydrationInfo: i,
      hasRehydrationInfo: cm(function(l) {
        return i(l) != null;
      })
    }, o = {
      injectEndpoints: f,
      enhanceEndpoints: function(l) {
        var d = l.addTagTypes, c = l.endpoints;
        if (d)
          for (var p = 0, v = d; p < v.length; p++) {
            var h = v[p];
            a.tagTypes.includes(h) || a.tagTypes.push(h);
          }
        if (c)
          for (var m = 0, q = Object.entries(c); m < q.length; m++) {
            var w = q[m], O = w[0], C = w[1];
            typeof C == "function" ? C(s.endpointDefinitions[O]) : Object.assign(s.endpointDefinitions[O] || {}, C);
          }
        return o;
      }
    }, u = e.map(function(l) {
      return l.init(o, a, s);
    });
    function f(l) {
      for (var d = l.endpoints({
        query: function(C) {
          return Bi(Cr({}, C), { type: Yi.query });
        },
        mutation: function(C) {
          return Bi(Cr({}, C), { type: Yi.mutation });
        }
      }), c = 0, p = Object.entries(d); c < p.length; c++) {
        var v = p[c], h = v[0], m = v[1];
        if (!l.overrideExisting && h in s.endpointDefinitions) {
          typeof process < "u" && process.env.NODE_ENV === "development" && console.error("called `injectEndpoints` to override already-existing endpointName " + h + " without specifying `overrideExisting: true`");
          continue;
        }
        s.endpointDefinitions[h] = m;
        for (var q = 0, w = u; q < w.length; q++) {
          var O = w[q];
          O.injectEndpoint(h, m);
        }
      }
      return o;
    }
    return o.injectEndpoints({ endpoints: n.endpoints });
  };
}
function kE(e) {
  for (var t in e)
    return !1;
  return !0;
}
var WE = 2147483647 / 1e3 - 1, SE = function(e) {
  var t = e.reducerPath, r = e.api, n = e.context, i = e.internalState, a = r.internalActions, s = a.removeQueryResult, o = a.unsubscribeQueryResult;
  function u(c) {
    var p = i.currentSubscriptions[c];
    return !!p && !kE(p);
  }
  var f = {}, l = function(c, p, v) {
    var h;
    if (o.match(c)) {
      var m = p.getState()[t], q = c.payload.queryCacheKey;
      d(q, (h = m.queries[q]) == null ? void 0 : h.endpointName, p, m.config);
    }
    if (r.util.resetApiState.match(c))
      for (var w = 0, O = Object.entries(f); w < O.length; w++) {
        var C = O[w], R = C[0], I = C[1];
        I && clearTimeout(I), delete f[R];
      }
    if (n.hasRehydrationInfo(c))
      for (var m = p.getState()[t], P = n.extractRehydrationInfo(c).queries, K = 0, B = Object.entries(P); K < B.length; K++) {
        var L = B[K], q = L[0], _ = L[1];
        d(q, _ == null ? void 0 : _.endpointName, p, m.config);
      }
  };
  function d(c, p, v, h) {
    var m, q = n.endpointDefinitions[p], w = (m = q == null ? void 0 : q.keepUnusedDataFor) != null ? m : h.keepUnusedDataFor;
    if (w !== 1 / 0) {
      var O = Math.max(0, Math.min(w, WE));
      if (!u(c)) {
        var C = f[c];
        C && clearTimeout(C), f[c] = setTimeout(function() {
          u(c) || v.dispatch(s({ queryCacheKey: c })), delete f[c];
        }, O * 1e3);
      }
    }
  }
  return l;
}, CE = function(e) {
  var t = e.reducerPath, r = e.context, n = e.context.endpointDefinitions, i = e.mutationThunk, a = e.api, s = e.assertTagType, o = e.refetchQuery, u = a.internalActions.removeQueryResult, f = Wu(Qs(i), lp(i)), l = function(c, p) {
    f(c) && d(C3(c, "invalidatesTags", n, s), p), a.util.invalidateTags.match(c) && d(yy(c.payload, void 0, void 0, void 0, void 0, s), p);
  };
  function d(c, p) {
    var v = p.getState(), h = v[t], m = a.util.selectInvalidatedBy(v, c);
    r.batch(function() {
      for (var q, w = Array.from(m.values()), O = 0, C = w; O < C.length; O++) {
        var R = C[O].queryCacheKey, I = h.queries[R], P = (q = h.subscriptions[R]) != null ? q : {};
        I && (Object.keys(P).length === 0 ? p.dispatch(u({
          queryCacheKey: R
        })) : I.status !== Sr.uninitialized && p.dispatch(o(I, R)));
      }
    });
  }
  return l;
}, FE = function(e) {
  var t = e.reducerPath, r = e.queryThunk, n = e.api, i = e.refetchQuery, a = e.internalState, s = {}, o = function(p, v) {
    (n.internalActions.updateSubscriptionOptions.match(p) || n.internalActions.unsubscribeQueryResult.match(p)) && f(p.payload, v), (r.pending.match(p) || r.rejected.match(p) && p.meta.condition) && f(p.meta.arg, v), (r.fulfilled.match(p) || r.rejected.match(p) && !p.meta.condition) && u(p.meta.arg, v), n.util.resetApiState.match(p) && d();
  };
  function u(p, v) {
    var h = p.queryCacheKey, m = v.getState()[t], q = m.queries[h], w = a.currentSubscriptions[h];
    if (!(!q || q.status === Sr.uninitialized)) {
      var O = c(w);
      if (Number.isFinite(O)) {
        var C = s[h];
        C != null && C.timeout && (clearTimeout(C.timeout), C.timeout = void 0);
        var R = Date.now() + O, I = s[h] = {
          nextPollTimestamp: R,
          pollingInterval: O,
          timeout: setTimeout(function() {
            I.timeout = void 0, v.dispatch(i(q, h));
          }, O)
        };
      }
    }
  }
  function f(p, v) {
    var h = p.queryCacheKey, m = v.getState()[t], q = m.queries[h], w = a.currentSubscriptions[h];
    if (!(!q || q.status === Sr.uninitialized)) {
      var O = c(w);
      if (!Number.isFinite(O)) {
        l(h);
        return;
      }
      var C = s[h], R = Date.now() + O;
      (!C || R < C.nextPollTimestamp) && u({ queryCacheKey: h }, v);
    }
  }
  function l(p) {
    var v = s[p];
    v != null && v.timeout && clearTimeout(v.timeout), delete s[p];
  }
  function d() {
    for (var p = 0, v = Object.keys(s); p < v.length; p++) {
      var h = v[p];
      l(h);
    }
  }
  function c(p) {
    p === void 0 && (p = {});
    var v = Number.POSITIVE_INFINITY;
    for (var h in p)
      p[h].pollingInterval && (v = Math.min(p[h].pollingInterval, v));
    return v;
  }
  return o;
}, KE = function(e) {
  var t = e.reducerPath, r = e.context, n = e.api, i = e.refetchQuery, a = e.internalState, s = n.internalActions.removeQueryResult, o = function(f, l) {
    my.match(f) && u(l, "refetchOnFocus"), gy.match(f) && u(l, "refetchOnReconnect");
  };
  function u(f, l) {
    var d = f.getState()[t], c = d.queries, p = a.currentSubscriptions;
    r.batch(function() {
      for (var v = 0, h = Object.keys(p); v < h.length; v++) {
        var m = h[v], q = c[m], w = p[m];
        if (!(!w || !q)) {
          var O = Object.values(w).some(function(C) {
            return C[l] === !0;
          }) || Object.values(w).every(function(C) {
            return C[l] === void 0;
          }) && d.config[l];
          O && (Object.keys(w).length === 0 ? f.dispatch(s({
            queryCacheKey: m
          })) : q.status !== Sr.uninitialized && f.dispatch(i(q, m)));
        }
      }
    });
  }
  return o;
}, Eb = new Error("Promise never resolved before cacheEntryRemoved."), RE = function(e) {
  var t = e.api, r = e.reducerPath, n = e.context, i = e.queryThunk, a = e.mutationThunk;
  e.internalState;
  var s = hm(i), o = hm(a), u = Qs(i, a), f = {}, l = function(p, v, h) {
    var m = d(p);
    if (i.pending.match(p)) {
      var q = h[r].queries[m], w = v.getState()[r].queries[m];
      !q && w && c(p.meta.arg.endpointName, p.meta.arg.originalArgs, m, v, p.meta.requestId);
    } else if (a.pending.match(p)) {
      var w = v.getState()[r].mutations[m];
      w && c(p.meta.arg.endpointName, p.meta.arg.originalArgs, m, v, p.meta.requestId);
    } else if (u(p)) {
      var O = f[m];
      O != null && O.valueResolved && (O.valueResolved({
        data: p.payload,
        meta: p.meta.baseQueryMeta
      }), delete O.valueResolved);
    } else if (t.internalActions.removeQueryResult.match(p) || t.internalActions.removeMutationResult.match(p)) {
      var O = f[m];
      O && (delete f[m], O.cacheEntryRemoved());
    } else if (t.util.resetApiState.match(p))
      for (var C = 0, R = Object.entries(f); C < R.length; C++) {
        var I = R[C], P = I[0], O = I[1];
        delete f[P], O.cacheEntryRemoved();
      }
  };
  function d(p) {
    return s(p) ? p.meta.arg.queryCacheKey : o(p) ? p.meta.requestId : t.internalActions.removeQueryResult.match(p) ? p.payload.queryCacheKey : t.internalActions.removeMutationResult.match(p) ? zf(p.payload) : "";
  }
  function c(p, v, h, m, q) {
    var w = n.endpointDefinitions[p], O = w == null ? void 0 : w.onCacheEntryAdded;
    if (O) {
      var C = {}, R = new Promise(function(_) {
        C.cacheEntryRemoved = _;
      }), I = Promise.race([
        new Promise(function(_) {
          C.valueResolved = _;
        }),
        R.then(function() {
          throw Eb;
        })
      ]);
      I.catch(function() {
      }), f[h] = C;
      var P = t.endpoints[p].select(w.type === Yi.query ? v : h), K = m.dispatch(function(_, ne, Z) {
        return Z;
      }), B = Bi(Cr({}, m), {
        getCacheEntry: function() {
          return P(m.getState());
        },
        requestId: q,
        extra: K,
        updateCachedData: w.type === Yi.query ? function(_) {
          return m.dispatch(t.util.updateQueryData(p, v, _));
        } : void 0,
        cacheDataLoaded: I,
        cacheEntryRemoved: R
      }), L = O(v, B);
      Promise.resolve(L).catch(function(_) {
        if (_ !== Eb)
          throw _;
      });
    }
  }
  return l;
}, TE = function(e) {
  var t = e.api, r = e.context, n = e.queryThunk, i = e.mutationThunk, a = py(n, i), s = jf(n, i), o = Qs(n, i), u = {}, f = function(l, d) {
    var c, p, v;
    if (a(l)) {
      var h = l.meta, m = h.requestId, q = h.arg, w = q.endpointName, O = q.originalArgs, C = r.endpointDefinitions[w], R = C == null ? void 0 : C.onQueryStarted;
      if (R) {
        var I = {}, P = new Promise(function(he, Ie) {
          I.resolve = he, I.reject = Ie;
        });
        P.catch(function() {
        }), u[m] = I;
        var K = t.endpoints[w].select(C.type === Yi.query ? O : m), B = d.dispatch(function(he, Ie, xe) {
          return xe;
        }), L = Bi(Cr({}, d), {
          getCacheEntry: function() {
            return K(d.getState());
          },
          requestId: m,
          extra: B,
          updateCachedData: C.type === Yi.query ? function(he) {
            return d.dispatch(t.util.updateQueryData(w, O, he));
          } : void 0,
          queryFulfilled: P
        });
        R(O, L);
      }
    } else if (o(l)) {
      var _ = l.meta, m = _.requestId, ne = _.baseQueryMeta;
      (c = u[m]) == null || c.resolve({
        data: l.payload,
        meta: ne
      }), delete u[m];
    } else if (s(l)) {
      var Z = l.meta, m = Z.requestId, le = Z.rejectedWithValue, ne = Z.baseQueryMeta;
      (v = u[m]) == null || v.reject({
        error: (p = l.payload) != null ? p : l.error,
        isUnhandledError: !le,
        meta: ne
      }), delete u[m];
    }
  };
  return f;
}, UE = function(e) {
  var t = e.api, r = e.context.apiUid, n = e.reducerPath;
  return function(i, a) {
    var s, o;
    t.util.resetApiState.match(i) && a.dispatch(t.internalActions.middlewareRegistered(r)), typeof process < "u" && process.env.NODE_ENV === "development" && t.internalActions.middlewareRegistered.match(i) && i.payload === r && ((o = (s = a.getState()[n]) == null ? void 0 : s.config) == null ? void 0 : o.middlewareRegistered) === "conflict" && console.warn('There is a mismatch between slice and middleware for the reducerPath "' + n + `".
You can only have one api per reducer path, this will lead to crashes in various situations!` + (n === "api" ? `
If you have multiple apis, you *have* to specify the reducerPath option when using createApi!` : ""));
  };
}, Ob, xE = typeof queueMicrotask == "function" ? queueMicrotask.bind(typeof window < "u" ? window : typeof global < "u" ? global : globalThis) : function(e) {
  return (Ob || (Ob = Promise.resolve())).then(e).catch(function(t) {
    return setTimeout(function() {
      throw t;
    }, 0);
  });
}, EE = function(e) {
  var t = e.api, r = e.queryThunk, n = e.internalState, i = t.reducerPath + "/subscriptions", a = null, s = !1, o = t.internalActions, u = o.updateSubscriptionOptions, f = o.unsubscribeQueryResult, l = function(d, c) {
    var p, v, h, m, q, w, O, C, R;
    if (u.match(c)) {
      var I = c.payload, P = I.queryCacheKey, K = I.requestId, B = I.options;
      return (p = d == null ? void 0 : d[P]) != null && p[K] && (d[P][K] = B), !0;
    }
    if (f.match(c)) {
      var L = c.payload, P = L.queryCacheKey, K = L.requestId;
      return d[P] && delete d[P][K], !0;
    }
    if (t.internalActions.removeQueryResult.match(c))
      return delete d[c.payload.queryCacheKey], !0;
    if (r.pending.match(c)) {
      var _ = c.meta, ne = _.arg, K = _.requestId;
      if (ne.subscribe) {
        var Z = (h = d[v = ne.queryCacheKey]) != null ? h : d[v] = {};
        return Z[K] = (q = (m = ne.subscriptionOptions) != null ? m : Z[K]) != null ? q : {}, !0;
      }
    }
    if (r.rejected.match(c)) {
      var le = c.meta, he = le.condition, ne = le.arg, K = le.requestId;
      if (he && ne.subscribe) {
        var Z = (O = d[w = ne.queryCacheKey]) != null ? O : d[w] = {};
        return Z[K] = (R = (C = ne.subscriptionOptions) != null ? C : Z[K]) != null ? R : {}, !0;
      }
    }
    return !1;
  };
  return function(d, c) {
    var p, v;
    if (a || (a = JSON.parse(JSON.stringify(n.currentSubscriptions))), t.util.resetApiState.match(d))
      return a = n.currentSubscriptions = {}, [!0, !1];
    if (t.internalActions.internal_probeSubscription.match(d)) {
      var h = d.payload, m = h.queryCacheKey, q = h.requestId, w = !!((p = n.currentSubscriptions[m]) != null && p[q]);
      return [!1, w];
    }
    var O = l(n.currentSubscriptions, d);
    if (O) {
      s || (xE(function() {
        var P = JSON.parse(JSON.stringify(n.currentSubscriptions)), K = n3(a, function() {
          return P;
        }), B = K[1];
        c.next(t.internalActions.subscriptionsUpdated(B)), a = P, s = !1;
      }), s = !0);
      var C = !!((v = d.type) != null && v.startsWith(i)), R = r.rejected.match(d) && d.meta.condition && !!d.meta.arg.subscribe, I = !C && !R;
      return [I, !1];
    }
    return [!0, !1];
  };
};
function OE(e) {
  var t = e.reducerPath, r = e.queryThunk, n = e.api, i = e.context, a = i.apiUid, s = {
    invalidateTags: bn(t + "/invalidateTags")
  }, o = function(d) {
    return !!d && typeof d.type == "string" && d.type.startsWith(t + "/");
  }, u = [
    UE,
    SE,
    CE,
    FE,
    RE,
    TE
  ], f = function(d) {
    var c = !1, p = {
      currentSubscriptions: {}
    }, v = Bi(Cr({}, e), {
      internalState: p,
      refetchQuery: l
    }), h = u.map(function(w) {
      return w(v);
    }), m = EE(v), q = KE(v);
    return function(w) {
      return function(O) {
        c || (c = !0, d.dispatch(n.internalActions.middlewareRegistered(a)));
        var C = Bi(Cr({}, d), { next: w }), R = d.getState(), I = m(O, C, R), P = I[0], K = I[1], B;
        if (P ? B = w(O) : B = K, d.getState()[t] && (q(O, C, R), o(O) || i.hasRehydrationInfo(O)))
          for (var L = 0, _ = h; L < _.length; L++) {
            var ne = _[L];
            ne(O, C, R);
          }
        return B;
      };
    };
  };
  return { middleware: f, actions: s };
  function l(d, c, p) {
    return p === void 0 && (p = {}), r(Cr({
      type: "query",
      endpointName: d.endpointName,
      originalArgs: d.originalArgs,
      subscribe: !1,
      forceRefetch: !0,
      queryCacheKey: c
    }, p));
  }
}
function Xa(e) {
  for (var t = [], r = 1; r < arguments.length; r++)
    t[r - 1] = arguments[r];
  Object.assign.apply(Object, Ac([e], t));
}
var Nb = /* @__PURE__ */ Symbol(), NE = function() {
  return {
    name: Nb,
    init: function(e, t, r) {
      var n = t.baseQuery, i = t.tagTypes, a = t.reducerPath, s = t.serializeQueryArgs, o = t.keepUnusedDataFor, u = t.refetchOnMountOrArgChange, f = t.refetchOnFocus, l = t.refetchOnReconnect;
      tx();
      var d = function(We) {
        return typeof process < "u" && process.env.NODE_ENV === "development" && (i.includes(We.type) || console.error("Tag type '" + We.type + "' was used, but not specified in `tagTypes`!")), We;
      };
      Object.assign(e, {
        reducerPath: a,
        endpoints: {},
        internalActions: {
          onOnline: gy,
          onOffline: W3,
          onFocus: my,
          onFocusLost: k3
        },
        util: {}
      });
      var c = qE({
        baseQuery: n,
        reducerPath: a,
        context: r,
        api: e,
        serializeQueryArgs: s,
        assertTagType: d
      }), p = c.queryThunk, v = c.mutationThunk, h = c.patchQueryData, m = c.updateQueryData, q = c.upsertQueryData, w = c.prefetch, O = c.buildMatchThunkActions, C = bE({
        context: r,
        queryThunk: p,
        mutationThunk: v,
        reducerPath: a,
        assertTagType: d,
        config: {
          refetchOnFocus: f,
          refetchOnReconnect: l,
          refetchOnMountOrArgChange: u,
          keepUnusedDataFor: o,
          reducerPath: a
        }
      }), R = C.reducer, I = C.actions;
      Xa(e.util, {
        patchQueryData: h,
        updateQueryData: m,
        upsertQueryData: q,
        prefetch: w,
        resetApiState: I.resetApiState
      }), Xa(e.internalActions, I);
      var P = OE({
        reducerPath: a,
        context: r,
        queryThunk: p,
        mutationThunk: v,
        api: e,
        assertTagType: d
      }), K = P.middleware, B = P.actions;
      Xa(e.util, B), Xa(e, { reducer: R, middleware: K });
      var L = AE({
        serializeQueryArgs: s,
        reducerPath: a
      }), _ = L.buildQuerySelector, ne = L.buildMutationSelector, Z = L.selectInvalidatedBy;
      Xa(e.util, { selectInvalidatedBy: Z });
      var le = VE({
        queryThunk: p,
        mutationThunk: v,
        api: e,
        serializeQueryArgs: s,
        context: r
      }), he = le.buildInitiateQuery, Ie = le.buildInitiateMutation, xe = le.getRunningMutationThunk, ye = le.getRunningMutationsThunk, ue = le.getRunningQueriesThunk, M = le.getRunningQueryThunk, F = le.getRunningOperationPromises, pe = le.removalWarning;
      return Xa(e.util, {
        getRunningOperationPromises: F,
        getRunningOperationPromise: pe,
        getRunningMutationThunk: xe,
        getRunningMutationsThunk: ye,
        getRunningQueryThunk: M,
        getRunningQueriesThunk: ue
      }), {
        name: Nb,
        injectEndpoint: function(We, ce) {
          var oe, z, Ze = e;
          (z = (oe = Ze.endpoints)[We]) != null || (oe[We] = {}), S3(ce) ? Xa(Ze.endpoints[We], {
            name: We,
            select: _(We, ce),
            initiate: he(We, ce)
          }, O(p, We)) : gE(ce) && Xa(Ze.endpoints[We], {
            name: We,
            select: ne(),
            initiate: Ie(We)
          }, O(v, We));
        }
      };
    }
  };
}, IE = globalThis && globalThis.__spreadArray || function(e, t) {
  for (var r = 0, n = t.length, i = e.length; r < n; r++, i++)
    e[i] = t[r];
  return e;
}, XE = Object.defineProperty, PE = Object.defineProperties, BE = Object.getOwnPropertyDescriptors, Ib = Object.getOwnPropertySymbols, DE = Object.prototype.hasOwnProperty, LE = Object.prototype.propertyIsEnumerable, Xb = function(e, t, r) {
  return t in e ? XE(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[t] = r;
}, sa = function(e, t) {
  for (var r in t || (t = {}))
    DE.call(t, r) && Xb(e, r, t[r]);
  if (Ib)
    for (var n = 0, i = Ib(t); n < i.length; n++) {
      var r = i[n];
      LE.call(t, r) && Xb(e, r, t[r]);
    }
  return e;
}, _d = function(e, t) {
  return PE(e, BE(t));
};
function Pb(e, t, r, n) {
  var i = Br(function() {
    return {
      queryArgs: e,
      serialized: typeof e == "object" ? t({ queryArgs: e, endpointDefinition: r, endpointName: n }) : e
    };
  }, [e, t, r, n]), a = zr(i);
  return Kr(function() {
    a.current.serialized !== i.serialized && (a.current = i);
  }, [i]), a.current.serialized === i.serialized ? a.current.queryArgs : e;
}
var Pv = Symbol();
function Bv(e) {
  var t = zr(e);
  return Kr(function() {
    mc(t.current, e) || (t.current = e);
  }, [e]), mc(t.current, e) ? t.current : e;
}
var rd = WeakMap ? /* @__PURE__ */ new WeakMap() : void 0, ZE = function(e) {
  var t = e.endpointName, r = e.queryArgs, n = "", i = rd == null ? void 0 : rd.get(r);
  if (typeof i == "string")
    n = i;
  else {
    var a = JSON.stringify(r, function(s, o) {
      return ma(o) ? Object.keys(o).sort().reduce(function(u, f) {
        return u[f] = o[f], u;
      }, {}) : o;
    });
    ma(r) && (rd == null || rd.set(r, a)), n = a;
  }
  return t + "(" + n + ")";
}, ME = typeof window < "u" && window.document && window.document.createElement ? X6 : Kr, jE = function(e) {
  return e;
}, YE = function(e) {
  return e.isUninitialized ? _d(sa({}, e), {
    isUninitialized: !1,
    isFetching: !0,
    isLoading: e.data === void 0,
    status: Sr.pending
  }) : e;
};
function zE(e) {
  var t = e.api, r = e.moduleOptions, n = r.batch, i = r.useDispatch, a = r.useSelector, s = r.useStore, o = r.unstable__sideEffectsInRender, u = e.serializeQueryArgs, f = e.context, l = o ? function(h) {
    return h();
  } : Kr;
  return { buildQueryHooks: p, buildMutationHook: v, usePrefetch: c };
  function d(h, m, q) {
    if (m != null && m.endpointName && h.isUninitialized) {
      var w = m.endpointName, O = f.endpointDefinitions[w];
      u({
        queryArgs: m.originalArgs,
        endpointDefinition: O,
        endpointName: w
      }) === u({
        queryArgs: q,
        endpointDefinition: O,
        endpointName: w
      }) && (m = void 0);
    }
    var C = h.isSuccess ? h.data : m == null ? void 0 : m.data;
    C === void 0 && (C = h.data);
    var R = C !== void 0, I = h.isLoading, P = !R && I, K = h.isSuccess || I && R;
    return _d(sa({}, h), {
      data: C,
      currentData: h.data,
      isFetching: I,
      isLoading: P,
      isSuccess: K
    });
  }
  function c(h, m) {
    var q = i(), w = Bv(m);
    return qr(function(O, C) {
      return q(t.util.prefetch(h, O, sa(sa({}, w), C)));
    }, [h, q, w]);
  }
  function p(h) {
    var m = function(O, C) {
      var R = C === void 0 ? {} : C, I = R.refetchOnReconnect, P = R.refetchOnFocus, K = R.refetchOnMountOrArgChange, B = R.skip, L = B === void 0 ? !1 : B, _ = R.pollingInterval, ne = _ === void 0 ? 0 : _, Z = t.endpoints[h].initiate, le = i(), he = Pb(L ? Is : O, ZE, f.endpointDefinitions[h], h), Ie = Bv({
        refetchOnReconnect: I,
        refetchOnFocus: P,
        pollingInterval: ne
      }), xe = zr(!1), ye = zr(), ue = ye.current || {}, M = ue.queryCacheKey, F = ue.requestId, pe = !1;
      if (M && F) {
        var We = le(t.internalActions.internal_probeSubscription({
          queryCacheKey: M,
          requestId: F
        }));
        if (process.env.NODE_ENV !== "production" && typeof We != "boolean")
          throw new Error('Warning: Middleware for RTK-Query API at reducerPath "' + t.reducerPath + `" has not been added to the store.
    You must add the middleware for RTK-Query to function correctly!`);
        pe = !!We;
      }
      var ce = !pe && xe.current;
      return l(function() {
        xe.current = pe;
      }), l(function() {
        ce && (ye.current = void 0);
      }, [ce]), l(function() {
        var oe, z = ye.current;
        if (typeof process < "u" && process.env.NODE_ENV === "removeMeOnCompilation" && console.log(ce), he === Is) {
          z == null || z.unsubscribe(), ye.current = void 0;
          return;
        }
        var Ze = (oe = ye.current) == null ? void 0 : oe.subscriptionOptions;
        if (!z || z.arg !== he) {
          z == null || z.unsubscribe();
          var Ae = le(Z(he, {
            subscriptionOptions: Ie,
            forceRefetch: K
          }));
          ye.current = Ae;
        } else
          Ie !== Ze && z.updateSubscriptionOptions(Ie);
      }, [
        le,
        Z,
        K,
        he,
        Ie,
        ce
      ]), Kr(function() {
        return function() {
          var oe;
          (oe = ye.current) == null || oe.unsubscribe(), ye.current = void 0;
        };
      }, []), Br(function() {
        return {
          refetch: function() {
            var oe;
            if (!ye.current)
              throw new Error("Cannot refetch a query that has not been started yet.");
            return (oe = ye.current) == null ? void 0 : oe.refetch();
          }
        };
      }, []);
    }, q = function(O) {
      var C = O === void 0 ? {} : O, R = C.refetchOnReconnect, I = C.refetchOnFocus, P = C.pollingInterval, K = P === void 0 ? 0 : P, B = t.endpoints[h].initiate, L = i(), _ = ir(Pv), ne = _[0], Z = _[1], le = zr(), he = Bv({
        refetchOnReconnect: R,
        refetchOnFocus: I,
        pollingInterval: K
      });
      l(function() {
        var ye, ue, M = (ye = le.current) == null ? void 0 : ye.subscriptionOptions;
        he !== M && ((ue = le.current) == null || ue.updateSubscriptionOptions(he));
      }, [he]);
      var Ie = zr(he);
      l(function() {
        Ie.current = he;
      }, [he]);
      var xe = qr(function(ye, ue) {
        ue === void 0 && (ue = !1);
        var M;
        return n(function() {
          var F;
          (F = le.current) == null || F.unsubscribe(), le.current = M = L(B(ye, {
            subscriptionOptions: Ie.current,
            forceRefetch: !ue
          })), Z(ye);
        }), M;
      }, [L, B]);
      return Kr(function() {
        return function() {
          var ye;
          (ye = le == null ? void 0 : le.current) == null || ye.unsubscribe();
        };
      }, []), Kr(function() {
        ne !== Pv && !le.current && xe(ne, !0);
      }, [ne, xe]), Br(function() {
        return [xe, ne];
      }, [xe, ne]);
    }, w = function(O, C) {
      var R = C === void 0 ? {} : C, I = R.skip, P = I === void 0 ? !1 : I, K = R.selectFromResult, B = t.endpoints[h].select, L = Pb(P ? Is : O, u, f.endpointDefinitions[h], h), _ = zr(), ne = Br(function() {
        return _r([
          B(L),
          function(xe, ye) {
            return ye;
          },
          function(xe) {
            return L;
          }
        ], d);
      }, [B, L]), Z = Br(function() {
        return K ? _r([ne], K) : ne;
      }, [ne, K]), le = a(function(xe) {
        return Z(xe, _.current);
      }, mc), he = s(), Ie = ne(he.getState(), _.current);
      return ME(function() {
        _.current = Ie;
      }, [Ie]), le;
    };
    return {
      useQueryState: w,
      useQuerySubscription: m,
      useLazyQuerySubscription: q,
      useLazyQuery: function(O) {
        var C = q(O), R = C[0], I = C[1], P = w(I, _d(sa({}, O), {
          skip: I === Pv
        })), K = Br(function() {
          return { lastArg: I };
        }, [I]);
        return Br(function() {
          return [R, P, K];
        }, [R, P, K]);
      },
      useQuery: function(O, C) {
        var R = m(O, C), I = w(O, sa({
          selectFromResult: O === Is || C != null && C.skip ? void 0 : YE
        }, C)), P = I.data, K = I.status, B = I.isLoading, L = I.isSuccess, _ = I.isError, ne = I.error;
        return rm({ data: P, status: K, isLoading: B, isSuccess: L, isError: _, error: ne }), Br(function() {
          return sa(sa({}, I), R);
        }, [I, R]);
      }
    };
  }
  function v(h) {
    return function(m) {
      var q = m === void 0 ? {} : m, w = q.selectFromResult, O = w === void 0 ? jE : w, C = q.fixedCacheKey, R = t.endpoints[h], I = R.select, P = R.initiate, K = i(), B = ir(), L = B[0], _ = B[1];
      Kr(function() {
        return function() {
          L != null && L.arg.fixedCacheKey || L == null || L.reset();
        };
      }, [L]);
      var ne = qr(function(z) {
        var Ze = K(P(z, { fixedCacheKey: C }));
        return _(Ze), Ze;
      }, [K, P, C]), Z = (L || {}).requestId, le = Br(function() {
        return _r([I({ fixedCacheKey: C, requestId: L == null ? void 0 : L.requestId })], O);
      }, [I, L, O, C]), he = a(le, mc), Ie = C == null ? L == null ? void 0 : L.arg.originalArgs : void 0, xe = qr(function() {
        n(function() {
          L && _(void 0), C && K(t.internalActions.removeMutationResult({
            requestId: Z,
            fixedCacheKey: C
          }));
        });
      }, [K, C, L, Z]), ye = he.endpointName, ue = he.data, M = he.status, F = he.isLoading, pe = he.isSuccess, We = he.isError, ce = he.error;
      rm({
        endpointName: ye,
        data: ue,
        status: M,
        isLoading: F,
        isSuccess: pe,
        isError: We,
        error: ce
      });
      var oe = Br(function() {
        return _d(sa({}, he), { originalArgs: Ie, reset: xe });
      }, [he, Ie, xe]);
      return Br(function() {
        return [ne, oe];
      }, [ne, oe]);
    };
  }
}
var kc;
(function(e) {
  e.query = "query", e.mutation = "mutation";
})(kc || (kc = {}));
function GE(e) {
  return e.type === kc.query;
}
function QE(e) {
  return e.type === kc.mutation;
}
function Dv(e) {
  return e.replace(e[0], e[0].toUpperCase());
}
function nd(e) {
  for (var t = [], r = 1; r < arguments.length; r++)
    t[r - 1] = arguments[r];
  Object.assign.apply(Object, IE([e], t));
}
var JE = /* @__PURE__ */ Symbol(), HE = function(e) {
  var t = e === void 0 ? {} : e, r = t.batch, n = r === void 0 ? D6 : r, i = t.useDispatch, a = i === void 0 ? Gs : i, s = t.useSelector, o = s === void 0 ? Lt : s, u = t.useStore, f = u === void 0 ? _6 : u, l = t.unstable__sideEffectsInRender, d = l === void 0 ? !1 : l;
  return {
    name: JE,
    init: function(c, p, v) {
      var h = p.serializeQueryArgs, m = c, q = zE({
        api: c,
        moduleOptions: {
          batch: n,
          useDispatch: a,
          useSelector: o,
          useStore: f,
          unstable__sideEffectsInRender: d
        },
        serializeQueryArgs: h,
        context: v
      }), w = q.buildQueryHooks, O = q.buildMutationHook, C = q.usePrefetch;
      return nd(m, { usePrefetch: C }), nd(v, { batch: n }), {
        injectEndpoint: function(R, I) {
          if (GE(I)) {
            var P = w(R), K = P.useQuery, B = P.useLazyQuery, L = P.useLazyQuerySubscription, _ = P.useQueryState, ne = P.useQuerySubscription;
            nd(m.endpoints[R], {
              useQuery: K,
              useLazyQuery: B,
              useLazyQuerySubscription: L,
              useQueryState: _,
              useQuerySubscription: ne
            }), c["use" + Dv(R) + "Query"] = K, c["useLazy" + Dv(R) + "Query"] = B;
          } else if (QE(I)) {
            var Z = O(R);
            nd(m.endpoints[R], {
              useMutation: Z
            }), c["use" + Dv(R) + "Mutation"] = Z;
          }
        }
      };
    }
  };
}, _E = /* @__PURE__ */ wE(NE(), HE()), Vy = { exports: {} }, $E = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
function qy(e) {
  this.message = e;
}
qy.prototype = new Error();
qy.prototype.name = "InvalidCharacterError";
function eO(e) {
  var t = String(e).replace(/=+$/, "");
  if (t.length % 4 == 1)
    throw new qy("'atob' failed: The string to be decoded is not correctly encoded.");
  for (
    var r = 0, n, i, a = 0, s = "";
    // get next character
    i = t.charAt(a++);
    // character found in table? initialize bit storage and add its ascii value;
    ~i && (n = r % 4 ? n * 64 + i : i, // and if not first of each 4 characters,
    // convert the first 8 bits to one ascii character
    r++ % 4) ? s += String.fromCharCode(255 & n >> (-2 * r & 6)) : 0
  )
    i = $E.indexOf(i);
  return s;
}
var tO = typeof window < "u" && window.atob && window.atob.bind(window) || eO, K3 = tO;
function rO(e) {
  return decodeURIComponent(K3(e).replace(/(.)/g, function(t, r) {
    var n = r.charCodeAt(0).toString(16).toUpperCase();
    return n.length < 2 && (n = "0" + n), "%" + n;
  }));
}
var nO = function(e) {
  var t = e.replace(/-/g, "+").replace(/_/g, "/");
  switch (t.length % 4) {
    case 0:
      break;
    case 2:
      t += "==";
      break;
    case 3:
      t += "=";
      break;
    default:
      throw "Illegal base64url string!";
  }
  try {
    return rO(t);
  } catch {
    return K3(t);
  }
}, iO = nO;
function Gf(e) {
  this.message = e;
}
Gf.prototype = new Error();
Gf.prototype.name = "InvalidTokenError";
Vy.exports = function(e, t) {
  if (typeof e != "string")
    throw new Gf("Invalid token specified");
  t = t || {};
  var r = t.header === !0 ? 0 : 1;
  try {
    return JSON.parse(iO(e.split(".")[r]));
  } catch (n) {
    throw new Gf("Invalid token specified: " + n.message);
  }
};
Vy.exports.InvalidTokenError = Gf;
var aO = Vy.exports;
const sO = /* @__PURE__ */ iy(aO), R3 = () => localStorage.getItem("token"), oO = (e) => e ? sO(e) : null, uO = (e, t) => `${e[0].toUpperCase()}${t[0].toUpperCase()}`, fO = (e, t) => {
  const r = e.map(({ fullName: n }) => n).join(", ");
  return t || r;
}, lO = ({ selectedUserId: e, directConversationsParticipant: t }) => {
  const r = t.find(({ participantId: n }) => n === e);
  return (r == null ? void 0 : r.convoSid) ?? null;
}, dO = () => window.location.origin, cO = () => cE({
  prepareHeaders: (e) => {
    const t = R3();
    return t && e.set("token", t), e;
  },
  baseUrl: `${dO()}/api`
}), Zo = _E({
  reducerPath: "api",
  baseQuery: mE(cO()),
  endpoints: (e) => ({
    getMerinioUsers: e.query({
      query: () => ({ url: "/users/users", params: { fields: JSON.stringify({ _id: 1, firstName: 1, lastName: 1, picture: 1, employeeNumber: 1 }) } })
    })
  })
});
Zo.endpoints.getMerinioUsers.select();
const { useGetMerinioUsersQuery: pO } = Zo, Bb = {
  participants: {}
}, T3 = On({
  name: "participants",
  initialState: Bb,
  reducers: {
    addParticipant: (e, t) => {
      const { conversationId: r, participant: n } = t.payload, i = e.participants[r] ?? [], a = i == null ? void 0 : i.find((s) => s.sid === n.sid);
      a != null && a.sid || (e.participants[r] = [...i, n]);
    },
    removeParticipant: (e, t) => {
      const { conversationId: r, participantId: n } = t.payload, a = e.participants[r].filter((s) => s.sid !== n);
      e.participants[r] = a;
    }
  },
  extraReducers: (e) => {
    e.addCase(Gi, () => Bb), e.addCase(hy.actions.removeConversation, (t, r) => {
      const n = r.payload, { [n]: i, ...a } = t.participants;
      t.participants = a;
    });
  }
}), Lv = {
  routes: ["conversations"]
}, U3 = On({
  name: "router",
  initialState: Lv,
  reducers: {
    goBack: (e) => {
      e.routes.length > 1 && (e.routes = e.routes.slice(0, -1));
    },
    goTo: (e, t) => {
      e.routes.includes(t.payload) || e.routes.push(t.payload);
    },
    replace: (e, t) => {
      if (e.routes.length > 1) {
        const r = e.routes.length - 1;
        e.routes[r] = t.payload;
      }
    },
    goHome: (e) => {
      e.routes = Lv.routes;
    }
  },
  extraReducers: (e) => e.addCase(Gi, () => Lv)
}), Db = {
  messages: []
}, x3 = On({
  name: "messages",
  initialState: Db,
  reducers: {
    loadMessages: (e, t) => {
      e.messages = t.payload;
    },
    loadPreviousMessages: (e, t) => {
      e.messages = [...t.payload, ...e.messages];
    },
    addNewMessage: (e, t) => {
      const r = e.messages.filter((n) => n.sid != t.payload.sid);
      e.messages = [...r, t.payload];
    },
    deleteMessage: (e, t) => {
      e.messages = e.messages.filter((r) => r.sid !== t.payload);
    },
    clearMessages: (e) => {
      e.messages = [];
    }
  },
  extraReducers: (e) => e.addCase(Gi, () => Db)
}), Lb = {
  twilioUsers: {}
}, E3 = On({
  name: "twilioUsers",
  initialState: Lb,
  reducers: {
    upsertUser: (e, t) => {
      const r = t.payload;
      e.twilioUsers[r.identity] = r;
    },
    removeUser: (e, t) => {
      const r = t.payload, { [r]: n, ...i } = e.twilioUsers;
      e.twilioUsers = { ...i };
    }
  },
  extraReducers: (e) => e.addCase(Gi, () => Lb)
}), { addConversation: O3, setConversationUnreadCount: pl, removeConversation: N3, updateConversation: I3 } = hy.actions, { toggleChat: vO, setActiveConversation: hO, upsertCurrentUser: X3, setCurrentUser: P3 } = V3.actions, { addTypingParticipant: B3, removeTypingParticipant: D3 } = q3.actions, { addParticipant: L3, removeParticipant: Z3 } = T3.actions, { goBack: M3, goTo: j3, replace: Y3, goHome: z3 } = U3.actions, { loadMessages: G3, loadPreviousMessages: Q3, addNewMessage: J3, deleteMessage: H3, clearMessages: mO } = x3.actions, { upsertUser: by, removeUser: gO } = E3.actions, yO = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  addConversation: O3,
  addNewMessage: J3,
  addParticipant: L3,
  addTypingParticipant: B3,
  clearMessages: mO,
  deleteMessage: H3,
  goBack: M3,
  goHome: z3,
  goTo: j3,
  loadMessages: G3,
  loadPreviousMessages: Q3,
  removeConversation: N3,
  removeParticipant: Z3,
  removeTypingParticipant: D3,
  removeUser: gO,
  replace: Y3,
  resetStoreToInitialState: Gi,
  setActiveConversation: hO,
  setConversationUnreadCount: pl,
  setCurrentUser: P3,
  toggleChat: vO,
  updateConversation: I3,
  upsertCurrentUser: X3,
  upsertUser: by
}, Symbol.toStringTag, { value: "Module" })), VO = jx({
  reducer: {
    conversations: hy.reducer,
    chat: V3.reducer,
    typing: q3.reducer,
    participants: T3.reducer,
    router: U3.reducer,
    messages: x3.reducer,
    twilioUsers: E3.reducer,
    [Zo.reducerPath]: Zo.reducer
  },
  middleware: (e) => e().concat(Zo.middleware),
  devTools: { actionCreators: yO }
});
var _3 = {}, id = function(e) {
  return e && e.Math === Math && e;
}, Xt = (
  // eslint-disable-next-line es/no-global-this -- safe
  id(typeof globalThis == "object" && globalThis) || id(typeof window == "object" && window) || // eslint-disable-next-line no-restricted-globals -- safe
  id(typeof self == "object" && self) || id(typeof Xn == "object" && Xn) || // eslint-disable-next-line no-new-func -- fallback
  function() {
    return this;
  }() || Xn || Function("return this")()
), Qi = {}, St = function(e) {
  try {
    return !!e();
  } catch {
    return !0;
  }
}, qO = St, Ar = !qO(function() {
  return Object.defineProperty({}, 1, { get: function() {
    return 7;
  } })[1] !== 7;
}), bO = St, vl = !bO(function() {
  var e = (function() {
  }).bind();
  return typeof e != "function" || e.hasOwnProperty("prototype");
}), AO = vl, ad = Function.prototype.call, fr = AO ? ad.bind(ad) : function() {
  return ad.apply(ad, arguments);
}, hl = {}, $3 = {}.propertyIsEnumerable, eS = Object.getOwnPropertyDescriptor, wO = eS && !$3.call({ 1: 2 }, 1);
hl.f = wO ? function(t) {
  var r = eS(this, t);
  return !!r && r.enumerable;
} : $3;
var Js = function(e, t) {
  return {
    enumerable: !(e & 1),
    configurable: !(e & 2),
    writable: !(e & 4),
    value: t
  };
}, tS = vl, rS = Function.prototype, ym = rS.call, kO = tS && rS.bind.bind(ym, ym), Kt = tS ? kO : function(e) {
  return function() {
    return ym.apply(e, arguments);
  };
}, nS = Kt, WO = nS({}.toString), SO = nS("".slice), Ji = function(e) {
  return SO(WO(e), 8, -1);
}, CO = Kt, FO = St, KO = Ji, Zv = Object, RO = CO("".split), ml = FO(function() {
  return !Zv("z").propertyIsEnumerable(0);
}) ? function(e) {
  return KO(e) === "String" ? RO(e, "") : Zv(e);
} : Zv, Ri = function(e) {
  return e == null;
}, TO = Ri, UO = TypeError, Hi = function(e) {
  if (TO(e))
    throw UO("Can't call method on " + e);
  return e;
}, xO = ml, EO = Hi, Mn = function(e) {
  return xO(EO(e));
}, Vm = typeof document == "object" && document.all, OO = typeof Vm > "u" && Vm !== void 0, iS = {
  all: Vm,
  IS_HTMLDDA: OO
}, aS = iS, NO = aS.all, or = aS.IS_HTMLDDA ? function(e) {
  return typeof e == "function" || e === NO;
} : function(e) {
  return typeof e == "function";
}, Zb = or, sS = iS, IO = sS.all, Rr = sS.IS_HTMLDDA ? function(e) {
  return typeof e == "object" ? e !== null : Zb(e) || e === IO;
} : function(e) {
  return typeof e == "object" ? e !== null : Zb(e);
}, Mv = Xt, XO = or, PO = function(e) {
  return XO(e) ? e : void 0;
}, Ti = function(e, t) {
  return arguments.length < 2 ? PO(Mv[e]) : Mv[e] && Mv[e][t];
}, BO = Kt, ka = BO({}.isPrototypeOf), Hs = typeof navigator < "u" && String(navigator.userAgent) || "", oS = Xt, jv = Hs, Mb = oS.process, jb = oS.Deno, Yb = Mb && Mb.versions || jb && jb.version, zb = Yb && Yb.v8, bi, Wc;
zb && (bi = zb.split("."), Wc = bi[0] > 0 && bi[0] < 4 ? 1 : +(bi[0] + bi[1]));
!Wc && jv && (bi = jv.match(/Edge\/(\d+)/), (!bi || bi[1] >= 74) && (bi = jv.match(/Chrome\/(\d+)/), bi && (Wc = +bi[1])));
var Su = Wc, Gb = Su, DO = St, LO = Xt, ZO = LO.String, Cu = !!Object.getOwnPropertySymbols && !DO(function() {
  var e = Symbol("symbol detection");
  return !ZO(e) || !(Object(e) instanceof Symbol) || // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
  !Symbol.sham && Gb && Gb < 41;
}), MO = Cu, uS = MO && !Symbol.sham && typeof Symbol.iterator == "symbol", jO = Ti, YO = or, zO = ka, GO = uS, QO = Object, Fu = GO ? function(e) {
  return typeof e == "symbol";
} : function(e) {
  var t = jO("Symbol");
  return YO(t) && zO(t.prototype, QO(e));
}, JO = String, _s = function(e) {
  try {
    return JO(e);
  } catch {
    return "Object";
  }
}, HO = or, _O = _s, $O = TypeError, li = function(e) {
  if (HO(e))
    return e;
  throw $O(_O(e) + " is not a function");
}, eN = li, tN = Ri, $s = function(e, t) {
  var r = e[t];
  return tN(r) ? void 0 : eN(r);
}, Yv = fr, zv = or, Gv = Rr, rN = TypeError, nN = function(e, t) {
  var r, n;
  if (t === "string" && zv(r = e.toString) && !Gv(n = Yv(r, e)) || zv(r = e.valueOf) && !Gv(n = Yv(r, e)) || t !== "string" && zv(r = e.toString) && !Gv(n = Yv(r, e)))
    return n;
  throw rN("Can't convert object to primitive value");
}, fS = { exports: {} }, lS = !1, Qb = Xt, iN = Object.defineProperty, Ay = function(e, t) {
  try {
    iN(Qb, e, { value: t, configurable: !0, writable: !0 });
  } catch {
    Qb[e] = t;
  }
  return t;
}, aN = Xt, sN = Ay, Jb = "__core-js_shared__", oN = aN[Jb] || sN(Jb, {}), wy = oN, Hb = wy;
(fS.exports = function(e, t) {
  return Hb[e] || (Hb[e] = t !== void 0 ? t : {});
})("versions", []).push({
  version: "3.32.2",
  mode: "global",
  copyright: "© 2014-2023 Denis Pushkarev (zloirock.ru)",
  license: "https://github.com/zloirock/core-js/blob/v3.32.2/LICENSE",
  source: "https://github.com/zloirock/core-js"
});
var Ku = fS.exports, uN = Hi, fN = Object, hn = function(e) {
  return fN(uN(e));
}, lN = Kt, dN = hn, cN = lN({}.hasOwnProperty), Tr = Object.hasOwn || function(t, r) {
  return cN(dN(t), r);
}, pN = Kt, vN = 0, hN = Math.random(), mN = pN(1 .toString), gl = function(e) {
  return "Symbol(" + (e === void 0 ? "" : e) + ")_" + mN(++vN + hN, 36);
}, gN = Xt, yN = Ku, _b = Tr, VN = gl, qN = Cu, bN = uS, No = gN.Symbol, Qv = yN("wks"), AN = bN ? No.for || No : No && No.withoutSetter || VN, lr = function(e) {
  return _b(Qv, e) || (Qv[e] = qN && _b(No, e) ? No[e] : AN("Symbol." + e)), Qv[e];
}, wN = fr, $b = Rr, e0 = Fu, kN = $s, WN = nN, SN = lr, CN = TypeError, FN = SN("toPrimitive"), ky = function(e, t) {
  if (!$b(e) || e0(e))
    return e;
  var r = kN(e, FN), n;
  if (r) {
    if (t === void 0 && (t = "default"), n = wN(r, e, t), !$b(n) || e0(n))
      return n;
    throw CN("Can't convert object to primitive value");
  }
  return t === void 0 && (t = "number"), WN(e, t);
}, KN = ky, RN = Fu, yl = function(e) {
  var t = KN(e, "string");
  return RN(t) ? t : t + "";
}, TN = Xt, t0 = Rr, qm = TN.document, UN = t0(qm) && t0(qm.createElement), dp = function(e) {
  return UN ? qm.createElement(e) : {};
}, xN = Ar, EN = St, ON = dp, dS = !xN && !EN(function() {
  return Object.defineProperty(ON("div"), "a", {
    get: function() {
      return 7;
    }
  }).a !== 7;
}), NN = Ar, IN = fr, XN = hl, PN = Js, BN = Mn, DN = yl, LN = Tr, ZN = dS, r0 = Object.getOwnPropertyDescriptor;
Qi.f = NN ? r0 : function(t, r) {
  if (t = BN(t), r = DN(r), ZN)
    try {
      return r0(t, r);
    } catch {
    }
  if (LN(t, r))
    return PN(!IN(XN.f, t, r), t[r]);
};
var wn = {}, MN = Ar, jN = St, cS = MN && jN(function() {
  return Object.defineProperty(function() {
  }, "prototype", {
    value: 42,
    writable: !1
  }).prototype !== 42;
}), YN = Rr, zN = String, GN = TypeError, Or = function(e) {
  if (YN(e))
    return e;
  throw GN(zN(e) + " is not an object");
}, QN = Ar, JN = dS, HN = cS, sd = Or, n0 = yl, _N = TypeError, Jv = Object.defineProperty, $N = Object.getOwnPropertyDescriptor, Hv = "enumerable", _v = "configurable", $v = "writable";
wn.f = QN ? HN ? function(t, r, n) {
  if (sd(t), r = n0(r), sd(n), typeof t == "function" && r === "prototype" && "value" in n && $v in n && !n[$v]) {
    var i = $N(t, r);
    i && i[$v] && (t[r] = n.value, n = {
      configurable: _v in n ? n[_v] : i[_v],
      enumerable: Hv in n ? n[Hv] : i[Hv],
      writable: !1
    });
  }
  return Jv(t, r, n);
} : Jv : function(t, r, n) {
  if (sd(t), r = n0(r), sd(n), JN)
    try {
      return Jv(t, r, n);
    } catch {
    }
  if ("get" in n || "set" in n)
    throw _N("Accessors not supported");
  return "value" in n && (t[r] = n.value), t;
};
var eI = Ar, tI = wn, rI = Js, Wa = eI ? function(e, t, r) {
  return tI.f(e, t, rI(1, r));
} : function(e, t, r) {
  return e[t] = r, e;
}, pS = { exports: {} }, bm = Ar, nI = Tr, vS = Function.prototype, iI = bm && Object.getOwnPropertyDescriptor, Wy = nI(vS, "name"), aI = Wy && (function() {
}).name === "something", sI = Wy && (!bm || bm && iI(vS, "name").configurable), Vl = {
  EXISTS: Wy,
  PROPER: aI,
  CONFIGURABLE: sI
}, oI = Kt, uI = or, Am = wy, fI = oI(Function.toString);
uI(Am.inspectSource) || (Am.inspectSource = function(e) {
  return fI(e);
});
var Sy = Am.inspectSource, lI = Xt, dI = or, i0 = lI.WeakMap, cI = dI(i0) && /native code/.test(String(i0)), pI = Ku, vI = gl, a0 = pI("keys"), cp = function(e) {
  return a0[e] || (a0[e] = vI(e));
}, ql = {}, hI = cI, hS = Xt, mI = Rr, gI = Wa, eh = Tr, th = wy, yI = cp, VI = ql, s0 = "Object already initialized", wm = hS.TypeError, qI = hS.WeakMap, Sc, Qf, Cc, bI = function(e) {
  return Cc(e) ? Qf(e) : Sc(e, {});
}, AI = function(e) {
  return function(t) {
    var r;
    if (!mI(t) || (r = Qf(t)).type !== e)
      throw wm("Incompatible receiver, " + e + " required");
    return r;
  };
};
if (hI || th.state) {
  var xi = th.state || (th.state = new qI());
  xi.get = xi.get, xi.has = xi.has, xi.set = xi.set, Sc = function(e, t) {
    if (xi.has(e))
      throw wm(s0);
    return t.facade = e, xi.set(e, t), t;
  }, Qf = function(e) {
    return xi.get(e) || {};
  }, Cc = function(e) {
    return xi.has(e);
  };
} else {
  var go = yI("state");
  VI[go] = !0, Sc = function(e, t) {
    if (eh(e, go))
      throw wm(s0);
    return t.facade = e, gI(e, go, t), t;
  }, Qf = function(e) {
    return eh(e, go) ? e[go] : {};
  }, Cc = function(e) {
    return eh(e, go);
  };
}
var jn = {
  set: Sc,
  get: Qf,
  has: Cc,
  enforce: bI,
  getterFor: AI
}, Cy = Kt, wI = St, kI = or, od = Tr, km = Ar, WI = Vl.CONFIGURABLE, SI = Sy, mS = jn, CI = mS.enforce, FI = mS.get, o0 = String, $d = Object.defineProperty, KI = Cy("".slice), RI = Cy("".replace), TI = Cy([].join), UI = km && !wI(function() {
  return $d(function() {
  }, "length", { value: 8 }).length !== 8;
}), xI = String(String).split("String"), EI = pS.exports = function(e, t, r) {
  KI(o0(t), 0, 7) === "Symbol(" && (t = "[" + RI(o0(t), /^Symbol\(([^)]*)\)/, "$1") + "]"), r && r.getter && (t = "get " + t), r && r.setter && (t = "set " + t), (!od(e, "name") || WI && e.name !== t) && (km ? $d(e, "name", { value: t, configurable: !0 }) : e.name = t), UI && r && od(r, "arity") && e.length !== r.arity && $d(e, "length", { value: r.arity });
  try {
    r && od(r, "constructor") && r.constructor ? km && $d(e, "prototype", { writable: !1 }) : e.prototype && (e.prototype = void 0);
  } catch {
  }
  var n = CI(e);
  return od(n, "source") || (n.source = TI(xI, typeof t == "string" ? t : "")), e;
};
Function.prototype.toString = EI(function() {
  return kI(this) && FI(this).source || SI(this);
}, "toString");
var gS = pS.exports, OI = or, NI = wn, II = gS, XI = Ay, kn = function(e, t, r, n) {
  n || (n = {});
  var i = n.enumerable, a = n.name !== void 0 ? n.name : t;
  if (OI(r) && II(r, a, n), n.global)
    i ? e[t] = r : XI(t, r);
  else {
    try {
      n.unsafe ? e[t] && (i = !0) : delete e[t];
    } catch {
    }
    i ? e[t] = r : NI.f(e, t, {
      value: r,
      enumerable: !1,
      configurable: !n.nonConfigurable,
      writable: !n.nonWritable
    });
  }
  return e;
}, ls = {}, PI = Math.ceil, BI = Math.floor, yS = Math.trunc || function(t) {
  var r = +t;
  return (r > 0 ? BI : PI)(r);
}, DI = yS, _i = function(e) {
  var t = +e;
  return t !== t || t === 0 ? 0 : DI(t);
}, LI = _i, ZI = Math.max, MI = Math.min, eo = function(e, t) {
  var r = LI(e);
  return r < 0 ? ZI(r + t, 0) : MI(r, t);
}, jI = _i, YI = Math.min, Sa = function(e) {
  return e > 0 ? YI(jI(e), 9007199254740991) : 0;
}, zI = Sa, on = function(e) {
  return zI(e.length);
}, GI = Mn, QI = eo, JI = on, u0 = function(e) {
  return function(t, r, n) {
    var i = GI(t), a = JI(i), s = QI(n, a), o;
    if (e && r !== r) {
      for (; a > s; )
        if (o = i[s++], o !== o)
          return !0;
    } else
      for (; a > s; s++)
        if ((e || s in i) && i[s] === r)
          return e || s || 0;
    return !e && -1;
  };
}, pp = {
  // `Array.prototype.includes` method
  // https://tc39.es/ecma262/#sec-array.prototype.includes
  includes: u0(!0),
  // `Array.prototype.indexOf` method
  // https://tc39.es/ecma262/#sec-array.prototype.indexof
  indexOf: u0(!1)
}, HI = Kt, rh = Tr, _I = Mn, $I = pp.indexOf, eX = ql, f0 = HI([].push), VS = function(e, t) {
  var r = _I(e), n = 0, i = [], a;
  for (a in r)
    !rh(eX, a) && rh(r, a) && f0(i, a);
  for (; t.length > n; )
    rh(r, a = t[n++]) && (~$I(i, a) || f0(i, a));
  return i;
}, Fy = [
  "constructor",
  "hasOwnProperty",
  "isPrototypeOf",
  "propertyIsEnumerable",
  "toLocaleString",
  "toString",
  "valueOf"
], tX = VS, rX = Fy, nX = rX.concat("length", "prototype");
ls.f = Object.getOwnPropertyNames || function(t) {
  return tX(t, nX);
};
var bl = {};
bl.f = Object.getOwnPropertySymbols;
var iX = Ti, aX = Kt, sX = ls, oX = bl, uX = Or, fX = aX([].concat), qS = iX("Reflect", "ownKeys") || function(t) {
  var r = sX.f(uX(t)), n = oX.f;
  return n ? fX(r, n(t)) : r;
}, l0 = Tr, lX = qS, dX = Qi, cX = wn, bS = function(e, t, r) {
  for (var n = lX(t), i = cX.f, a = dX.f, s = 0; s < n.length; s++) {
    var o = n[s];
    !l0(e, o) && !(r && l0(r, o)) && i(e, o, a(t, o));
  }
}, pX = St, vX = or, hX = /#|\.prototype\./, Al = function(e, t) {
  var r = gX[mX(e)];
  return r === VX ? !0 : r === yX ? !1 : vX(t) ? pX(t) : !!t;
}, mX = Al.normalize = function(e) {
  return String(e).replace(hX, ".").toLowerCase();
}, gX = Al.data = {}, yX = Al.NATIVE = "N", VX = Al.POLYFILL = "P", vp = Al, nh = Xt, qX = Qi.f, bX = Wa, AX = kn, wX = Ay, kX = bS, WX = vp, xt = function(e, t) {
  var r = e.target, n = e.global, i = e.stat, a, s, o, u, f, l;
  if (n ? s = nh : i ? s = nh[r] || wX(r, {}) : s = (nh[r] || {}).prototype, s)
    for (o in t) {
      if (f = t[o], e.dontCallGetSet ? (l = qX(s, o), u = l && l.value) : u = s[o], a = WX(n ? o : r + (i ? "." : "#") + o, e.forced), !a && u !== void 0) {
        if (typeof f == typeof u)
          continue;
        kX(f, u);
      }
      (e.sham || u && u.sham) && bX(f, "sham", !0), AX(s, o, f, e);
    }
}, SX = wn.f, CX = Tr, FX = lr, d0 = FX("toStringTag"), Ca = function(e, t, r) {
  e && !r && (e = e.prototype), e && !CX(e, d0) && SX(e, d0, { configurable: !0, value: t });
}, KX = xt, RX = Xt, TX = Ca;
KX({ global: !0 }, { Reflect: {} });
TX(RX.Reflect, "Reflect", !0);
var UX = vl, AS = Function.prototype, c0 = AS.apply, p0 = AS.call, ds = typeof Reflect == "object" && Reflect.apply || (UX ? p0.bind(c0) : function() {
  return p0.apply(c0, arguments);
}), xX = Kt, Ru = xX([].slice), wS = Kt, EX = li, OX = Rr, NX = Tr, v0 = Ru, IX = vl, kS = Function, XX = wS([].concat), PX = wS([].join), ih = {}, BX = function(e, t, r) {
  if (!NX(ih, t)) {
    for (var n = [], i = 0; i < t; i++)
      n[i] = "a[" + i + "]";
    ih[t] = kS("C,a", "return new C(" + PX(n, ",") + ")");
  }
  return ih[t](e, r);
}, DX = IX ? kS.bind : function(t) {
  var r = EX(this), n = r.prototype, i = v0(arguments, 1), a = function() {
    var o = XX(i, v0(arguments));
    return this instanceof a ? BX(r, o.length, o) : r.apply(t, o);
  };
  return OX(n) && (a.prototype = n), a;
}, LX = lr, ZX = LX("toStringTag"), WS = {};
WS[ZX] = "z";
var Ky = String(WS) === "[object z]", MX = Ky, jX = or, ec = Ji, YX = lr, zX = YX("toStringTag"), GX = Object, QX = ec(function() {
  return arguments;
}()) === "Arguments", JX = function(e, t) {
  try {
    return e[t];
  } catch {
  }
}, Fa = MX ? ec : function(e) {
  var t, r, n;
  return e === void 0 ? "Undefined" : e === null ? "Null" : typeof (r = JX(t = GX(e), zX)) == "string" ? r : QX ? ec(t) : (n = ec(t)) === "Object" && jX(t.callee) ? "Arguments" : n;
}, HX = Kt, _X = St, SS = or, $X = Fa, e5 = Ti, t5 = Sy, CS = function() {
}, r5 = [], FS = e5("Reflect", "construct"), Ry = /^\s*(?:class|function)\b/, n5 = HX(Ry.exec), i5 = !Ry.exec(CS), of = function(t) {
  if (!SS(t))
    return !1;
  try {
    return FS(CS, r5, t), !0;
  } catch {
    return !1;
  }
}, KS = function(t) {
  if (!SS(t))
    return !1;
  switch ($X(t)) {
    case "AsyncFunction":
    case "GeneratorFunction":
    case "AsyncGeneratorFunction":
      return !1;
  }
  try {
    return i5 || !!n5(Ry, t5(t));
  } catch {
    return !0;
  }
};
KS.sham = !0;
var hp = !FS || _X(function() {
  var e;
  return of(of.call) || !of(Object) || !of(function() {
    e = !0;
  }) || e;
}) ? KS : of, a5 = hp, s5 = _s, o5 = TypeError, Ty = function(e) {
  if (a5(e))
    return e;
  throw o5(s5(e) + " is not a constructor");
}, Uy = {}, u5 = VS, f5 = Fy, wl = Object.keys || function(t) {
  return u5(t, f5);
}, l5 = Ar, d5 = cS, c5 = wn, p5 = Or, v5 = Mn, h5 = wl;
Uy.f = l5 && !d5 ? Object.defineProperties : function(t, r) {
  p5(t);
  for (var n = v5(r), i = h5(r), a = i.length, s = 0, o; a > s; )
    c5.f(t, o = i[s++], n[o]);
  return t;
};
var m5 = Ti, RS = m5("document", "documentElement"), g5 = Or, y5 = Uy, h0 = Fy, V5 = ql, q5 = RS, b5 = dp, A5 = cp, m0 = ">", g0 = "<", Wm = "prototype", Sm = "script", TS = A5("IE_PROTO"), ah = function() {
}, US = function(e) {
  return g0 + Sm + m0 + e + g0 + "/" + Sm + m0;
}, y0 = function(e) {
  e.write(US("")), e.close();
  var t = e.parentWindow.Object;
  return e = null, t;
}, w5 = function() {
  var e = b5("iframe"), t = "java" + Sm + ":", r;
  return e.style.display = "none", q5.appendChild(e), e.src = String(t), r = e.contentWindow.document, r.open(), r.write(US("document.F=Object")), r.close(), r.F;
}, ud, tc = function() {
  try {
    ud = new ActiveXObject("htmlfile");
  } catch {
  }
  tc = typeof document < "u" ? document.domain && ud ? y0(ud) : w5() : y0(ud);
  for (var e = h0.length; e--; )
    delete tc[Wm][h0[e]];
  return tc();
};
V5[TS] = !0;
var cs = Object.create || function(t, r) {
  var n;
  return t !== null ? (ah[Wm] = g5(t), n = new ah(), ah[Wm] = null, n[TS] = t) : n = tc(), r === void 0 ? n : y5.f(n, r);
}, k5 = xt, W5 = Ti, sh = ds, S5 = DX, V0 = Ty, C5 = Or, q0 = Rr, F5 = cs, xS = St, xy = W5("Reflect", "construct"), K5 = Object.prototype, R5 = [].push, ES = xS(function() {
  function e() {
  }
  return !(xy(function() {
  }, [], e) instanceof e);
}), OS = !xS(function() {
  xy(function() {
  });
}), b0 = ES || OS;
k5({ target: "Reflect", stat: !0, forced: b0, sham: b0 }, {
  construct: function(t, r) {
    V0(t), C5(r);
    var n = arguments.length < 3 ? t : V0(arguments[2]);
    if (OS && !ES)
      return xy(t, r, n);
    if (t === n) {
      switch (r.length) {
        case 0:
          return new t();
        case 1:
          return new t(r[0]);
        case 2:
          return new t(r[0], r[1]);
        case 3:
          return new t(r[0], r[1], r[2]);
        case 4:
          return new t(r[0], r[1], r[2], r[3]);
      }
      var i = [null];
      return sh(R5, i, r), new (sh(S5, t, i))();
    }
    var a = n.prototype, s = F5(q0(a) ? a : K5), o = sh(t, s, r);
    return q0(o) ? o : s;
  }
});
var T5 = xt, U5 = hn, NS = wl, x5 = St, E5 = x5(function() {
  NS(1);
});
T5({ target: "Object", stat: !0, forced: E5 }, {
  keys: function(t) {
    return NS(U5(t));
  }
});
var O5 = Fa, N5 = String, $r = function(e) {
  if (O5(e) === "Symbol")
    throw TypeError("Cannot convert a Symbol value to a string");
  return N5(e);
}, Ey = {}, I5 = yl, X5 = wn, P5 = Js, Tu = function(e, t, r) {
  var n = I5(t);
  n in e ? X5.f(e, n, P5(0, r)) : e[n] = r;
}, A0 = eo, B5 = on, D5 = Tu, L5 = Array, Z5 = Math.max, kl = function(e, t, r) {
  for (var n = B5(e), i = A0(t, n), a = A0(r === void 0 ? n : r, n), s = L5(Z5(a - i, 0)), o = 0; i < a; i++, o++)
    D5(s, o, e[i]);
  return s.length = o, s;
}, M5 = Ji, j5 = Mn, IS = ls.f, Y5 = kl, XS = typeof window == "object" && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [], z5 = function(e) {
  try {
    return IS(e);
  } catch {
    return Y5(XS);
  }
};
Ey.f = function(t) {
  return XS && M5(t) === "Window" ? z5(t) : IS(j5(t));
};
var w0 = gS, G5 = wn, $i = function(e, t, r) {
  return r.get && w0(r.get, t, { getter: !0 }), r.set && w0(r.set, t, { setter: !0 }), G5.f(e, t, r);
}, Oy = {}, Q5 = lr;
Oy.f = Q5;
var J5 = Xt, PS = J5, k0 = PS, H5 = Tr, _5 = Oy, $5 = wn.f, BS = function(e) {
  var t = k0.Symbol || (k0.Symbol = {});
  H5(t, e) || $5(t, e, {
    value: _5.f(e)
  });
}, eP = fr, tP = Ti, rP = lr, nP = kn, iP = function() {
  var e = tP("Symbol"), t = e && e.prototype, r = t && t.valueOf, n = rP("toPrimitive");
  t && !t[n] && nP(t, n, function(i) {
    return eP(r, this);
  }, { arity: 1 });
}, aP = Ji, sP = Kt, mp = function(e) {
  if (aP(e) === "Function")
    return sP(e);
}, W0 = mp, oP = li, uP = vl, fP = W0(W0.bind), Ka = function(e, t) {
  return oP(e), t === void 0 ? e : uP ? fP(e, t) : function() {
    return e.apply(t, arguments);
  };
}, lP = Ji, Wl = Array.isArray || function(t) {
  return lP(t) === "Array";
}, S0 = Wl, dP = hp, cP = Rr, pP = lr, vP = pP("species"), C0 = Array, hP = function(e) {
  var t;
  return S0(e) && (t = e.constructor, dP(t) && (t === C0 || S0(t.prototype)) ? t = void 0 : cP(t) && (t = t[vP], t === null && (t = void 0))), t === void 0 ? C0 : t;
}, mP = hP, Ny = function(e, t) {
  return new (mP(e))(t === 0 ? 0 : t);
}, gP = Ka, yP = Kt, VP = ml, qP = hn, bP = on, AP = Ny, F0 = yP([].push), Pa = function(e) {
  var t = e === 1, r = e === 2, n = e === 3, i = e === 4, a = e === 6, s = e === 7, o = e === 5 || a;
  return function(u, f, l, d) {
    for (var c = qP(u), p = VP(c), v = gP(f, l), h = bP(p), m = 0, q = d || AP, w = t ? q(u, h) : r || s ? q(u, 0) : void 0, O, C; h > m; m++)
      if ((o || m in p) && (O = p[m], C = v(O, m, c), e))
        if (t)
          w[m] = C;
        else if (C)
          switch (e) {
            case 3:
              return !0;
            case 5:
              return O;
            case 6:
              return m;
            case 2:
              F0(w, O);
          }
        else
          switch (e) {
            case 4:
              return !1;
            case 7:
              F0(w, O);
          }
    return a ? -1 : n || i ? i : w;
  };
}, Un = {
  // `Array.prototype.forEach` method
  // https://tc39.es/ecma262/#sec-array.prototype.foreach
  forEach: Pa(0),
  // `Array.prototype.map` method
  // https://tc39.es/ecma262/#sec-array.prototype.map
  map: Pa(1),
  // `Array.prototype.filter` method
  // https://tc39.es/ecma262/#sec-array.prototype.filter
  filter: Pa(2),
  // `Array.prototype.some` method
  // https://tc39.es/ecma262/#sec-array.prototype.some
  some: Pa(3),
  // `Array.prototype.every` method
  // https://tc39.es/ecma262/#sec-array.prototype.every
  every: Pa(4),
  // `Array.prototype.find` method
  // https://tc39.es/ecma262/#sec-array.prototype.find
  find: Pa(5),
  // `Array.prototype.findIndex` method
  // https://tc39.es/ecma262/#sec-array.prototype.findIndex
  findIndex: Pa(6),
  // `Array.prototype.filterReject` method
  // https://github.com/tc39/proposal-array-filtering
  filterReject: Pa(7)
}, gp = xt, Iy = Xt, Xy = fr, wP = Kt, fu = Ar, lu = Cu, kP = St, en = Tr, WP = ka, Cm = Or, yp = Mn, Py = yl, SP = $r, Fm = Js, Jf = cs, DS = wl, CP = ls, LS = Ey, FP = bl, ZS = Qi, MS = wn, KP = Uy, jS = hl, oh = kn, RP = $i, By = Ku, TP = cp, YS = ql, K0 = gl, UP = lr, xP = Oy, EP = BS, OP = iP, NP = Ca, zS = jn, Vp = Un.forEach, Fn = TP("hidden"), qp = "Symbol", Hf = "prototype", IP = zS.set, R0 = zS.getterFor(qp), ui = Object[Hf], Ds = Iy.Symbol, Cf = Ds && Ds[Hf], XP = Iy.TypeError, uh = Iy.QObject, GS = ZS.f, xs = MS.f, QS = LS.f, PP = jS.f, JS = wP([].push), ga = By("symbols"), Sl = By("op-symbols"), BP = By("wks"), Km = !uh || !uh[Hf] || !uh[Hf].findChild, Rm = fu && kP(function() {
  return Jf(xs({}, "a", {
    get: function() {
      return xs(this, "a", { value: 7 }).a;
    }
  })).a !== 7;
}) ? function(e, t, r) {
  var n = GS(ui, t);
  n && delete ui[t], xs(e, t, r), n && e !== ui && xs(ui, t, n);
} : xs, fh = function(e, t) {
  var r = ga[e] = Jf(Cf);
  return IP(r, {
    type: qp,
    tag: e,
    description: t
  }), fu || (r.description = t), r;
}, bp = function(t, r, n) {
  t === ui && bp(Sl, r, n), Cm(t);
  var i = Py(r);
  return Cm(n), en(ga, i) ? (n.enumerable ? (en(t, Fn) && t[Fn][i] && (t[Fn][i] = !1), n = Jf(n, { enumerable: Fm(0, !1) })) : (en(t, Fn) || xs(t, Fn, Fm(1, {})), t[Fn][i] = !0), Rm(t, i, n)) : xs(t, i, n);
}, Dy = function(t, r) {
  Cm(t);
  var n = yp(r), i = DS(n).concat($S(n));
  return Vp(i, function(a) {
    (!fu || Xy(Tm, n, a)) && bp(t, a, n[a]);
  }), t;
}, DP = function(t, r) {
  return r === void 0 ? Jf(t) : Dy(Jf(t), r);
}, Tm = function(t) {
  var r = Py(t), n = Xy(PP, this, r);
  return this === ui && en(ga, r) && !en(Sl, r) ? !1 : n || !en(this, r) || !en(ga, r) || en(this, Fn) && this[Fn][r] ? n : !0;
}, HS = function(t, r) {
  var n = yp(t), i = Py(r);
  if (!(n === ui && en(ga, i) && !en(Sl, i))) {
    var a = GS(n, i);
    return a && en(ga, i) && !(en(n, Fn) && n[Fn][i]) && (a.enumerable = !0), a;
  }
}, _S = function(t) {
  var r = QS(yp(t)), n = [];
  return Vp(r, function(i) {
    !en(ga, i) && !en(YS, i) && JS(n, i);
  }), n;
}, $S = function(e) {
  var t = e === ui, r = QS(t ? Sl : yp(e)), n = [];
  return Vp(r, function(i) {
    en(ga, i) && (!t || en(ui, i)) && JS(n, ga[i]);
  }), n;
};
lu || (Ds = function() {
  if (WP(Cf, this))
    throw XP("Symbol is not a constructor");
  var t = !arguments.length || arguments[0] === void 0 ? void 0 : SP(arguments[0]), r = K0(t), n = function(i) {
    this === ui && Xy(n, Sl, i), en(this, Fn) && en(this[Fn], r) && (this[Fn][r] = !1), Rm(this, r, Fm(1, i));
  };
  return fu && Km && Rm(ui, r, { configurable: !0, set: n }), fh(r, t);
}, Cf = Ds[Hf], oh(Cf, "toString", function() {
  return R0(this).tag;
}), oh(Ds, "withoutSetter", function(e) {
  return fh(K0(e), e);
}), jS.f = Tm, MS.f = bp, KP.f = Dy, ZS.f = HS, CP.f = LS.f = _S, FP.f = $S, xP.f = function(e) {
  return fh(UP(e), e);
}, fu && (RP(Cf, "description", {
  configurable: !0,
  get: function() {
    return R0(this).description;
  }
}), oh(ui, "propertyIsEnumerable", Tm, { unsafe: !0 })));
gp({ global: !0, constructor: !0, wrap: !0, forced: !lu, sham: !lu }, {
  Symbol: Ds
});
Vp(DS(BP), function(e) {
  EP(e);
});
gp({ target: qp, stat: !0, forced: !lu }, {
  useSetter: function() {
    Km = !0;
  },
  useSimple: function() {
    Km = !1;
  }
});
gp({ target: "Object", stat: !0, forced: !lu, sham: !fu }, {
  // `Object.create` method
  // https://tc39.es/ecma262/#sec-object.create
  create: DP,
  // `Object.defineProperty` method
  // https://tc39.es/ecma262/#sec-object.defineproperty
  defineProperty: bp,
  // `Object.defineProperties` method
  // https://tc39.es/ecma262/#sec-object.defineproperties
  defineProperties: Dy,
  // `Object.getOwnPropertyDescriptor` method
  // https://tc39.es/ecma262/#sec-object.getownpropertydescriptors
  getOwnPropertyDescriptor: HS
});
gp({ target: "Object", stat: !0, forced: !lu }, {
  // `Object.getOwnPropertyNames` method
  // https://tc39.es/ecma262/#sec-object.getownpropertynames
  getOwnPropertyNames: _S
});
OP();
NP(Ds, qp);
YS[Fn] = !0;
var LP = Cu, eC = LP && !!Symbol.for && !!Symbol.keyFor, ZP = xt, MP = Ti, jP = Tr, YP = $r, tC = Ku, zP = eC, lh = tC("string-to-symbol-registry"), GP = tC("symbol-to-string-registry");
ZP({ target: "Symbol", stat: !0, forced: !zP }, {
  for: function(e) {
    var t = YP(e);
    if (jP(lh, t))
      return lh[t];
    var r = MP("Symbol")(t);
    return lh[t] = r, GP[r] = t, r;
  }
});
var QP = xt, JP = Tr, HP = Fu, _P = _s, $P = Ku, eB = eC, T0 = $P("symbol-to-string-registry");
QP({ target: "Symbol", stat: !0, forced: !eB }, {
  keyFor: function(t) {
    if (!HP(t))
      throw TypeError(_P(t) + " is not a symbol");
    if (JP(T0, t))
      return T0[t];
  }
});
var tB = Kt, U0 = Wl, rB = or, x0 = Ji, nB = $r, E0 = tB([].push), iB = function(e) {
  if (rB(e))
    return e;
  if (U0(e)) {
    for (var t = e.length, r = [], n = 0; n < t; n++) {
      var i = e[n];
      typeof i == "string" ? E0(r, i) : (typeof i == "number" || x0(i) === "Number" || x0(i) === "String") && E0(r, nB(i));
    }
    var a = r.length, s = !0;
    return function(o, u) {
      if (s)
        return s = !1, u;
      if (U0(this))
        return u;
      for (var f = 0; f < a; f++)
        if (r[f] === o)
          return u;
    };
  }
}, aB = xt, rC = Ti, nC = ds, sB = fr, Cl = Kt, iC = St, O0 = or, N0 = Fu, aC = Ru, oB = iB, uB = Cu, fB = String, _a = rC("JSON", "stringify"), fd = Cl(/./.exec), I0 = Cl("".charAt), lB = Cl("".charCodeAt), dB = Cl("".replace), cB = Cl(1 .toString), pB = /[\uD800-\uDFFF]/g, X0 = /^[\uD800-\uDBFF]$/, P0 = /^[\uDC00-\uDFFF]$/, B0 = !uB || iC(function() {
  var e = rC("Symbol")("stringify detection");
  return _a([e]) !== "[null]" || _a({ a: e }) !== "{}" || _a(Object(e)) !== "{}";
}), D0 = iC(function() {
  return _a("\uDF06\uD834") !== '"\\udf06\\ud834"' || _a("\uDEAD") !== '"\\udead"';
}), vB = function(e, t) {
  var r = aC(arguments), n = oB(t);
  if (!(!O0(n) && (e === void 0 || N0(e))))
    return r[1] = function(i, a) {
      if (O0(n) && (a = sB(n, this, fB(i), a)), !N0(a))
        return a;
    }, nC(_a, null, r);
}, hB = function(e, t, r) {
  var n = I0(r, t - 1), i = I0(r, t + 1);
  return fd(X0, e) && !fd(P0, i) || fd(P0, e) && !fd(X0, n) ? "\\u" + cB(lB(e, 0), 16) : e;
};
_a && aB({ target: "JSON", stat: !0, arity: 3, forced: B0 || D0 }, {
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  stringify: function(t, r, n) {
    var i = aC(arguments), a = nC(B0 ? vB : _a, null, i);
    return D0 && typeof a == "string" ? dB(a, pB, hB) : a;
  }
});
var mB = xt, gB = Cu, yB = St, sC = bl, VB = hn, qB = !gB || yB(function() {
  sC.f(1);
});
mB({ target: "Object", stat: !0, forced: qB }, {
  getOwnPropertySymbols: function(t) {
    var r = sC.f;
    return r ? r(VB(t)) : [];
  }
});
var bB = St, AB = lr, wB = Su, kB = AB("species"), Fl = function(e) {
  return wB >= 51 || !bB(function() {
    var t = [], r = t.constructor = {};
    return r[kB] = function() {
      return { foo: 1 };
    }, t[e](Boolean).foo !== 1;
  });
}, WB = xt, SB = Un.filter, CB = Fl, FB = CB("filter");
WB({ target: "Array", proto: !0, forced: !FB }, {
  filter: function(t) {
    return SB(this, t, arguments.length > 1 ? arguments[1] : void 0);
  }
});
var KB = xt, RB = St, TB = Mn, oC = Qi.f, uC = Ar, UB = !uC || RB(function() {
  oC(1);
});
KB({ target: "Object", stat: !0, forced: UB, sham: !uC }, {
  getOwnPropertyDescriptor: function(t, r) {
    return oC(TB(t), r);
  }
});
var xB = xt, EB = Ar, OB = qS, NB = Mn, IB = Qi, XB = Tu;
xB({ target: "Object", stat: !0, sham: !EB }, {
  getOwnPropertyDescriptors: function(t) {
    for (var r = NB(t), n = IB.f, i = OB(r), a = {}, s = 0, o, u; i.length > s; )
      u = n(r, o = i[s++]), u !== void 0 && XB(a, o, u);
    return a;
  }
});
var fC = { exports: {} };
(function(e) {
  function t(n, i, a, s, o, u, f) {
    try {
      var l = n[u](f), d = l.value;
    } catch (c) {
      a(c);
      return;
    }
    l.done ? i(d) : Promise.resolve(d).then(s, o);
  }
  function r(n) {
    return function() {
      var i = this, a = arguments;
      return new Promise(function(s, o) {
        var u = n.apply(i, a);
        function f(d) {
          t(u, s, o, f, l, "next", d);
        }
        function l(d) {
          t(u, s, o, f, l, "throw", d);
        }
        f(void 0);
      });
    };
  }
  e.exports = r, e.exports.__esModule = !0, e.exports.default = e.exports;
})(fC);
var Kl = fC.exports, lC = { exports: {} };
(function(e) {
  function t(r) {
    if (r === void 0)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return r;
  }
  e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
})(lC);
var to = lC.exports, dC = { exports: {} }, cC = { exports: {} };
(function(e) {
  function t(r, n) {
    return e.exports = t = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(a, s) {
      return a.__proto__ = s, a;
    }, e.exports.__esModule = !0, e.exports.default = e.exports, t(r, n);
  }
  e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
})(cC);
var Ly = cC.exports;
(function(e) {
  var t = Ly;
  function r(n, i) {
    if (typeof i != "function" && i !== null)
      throw new TypeError("Super expression must either be null or a function");
    n.prototype = Object.create(i && i.prototype, {
      constructor: {
        value: n,
        writable: !0,
        configurable: !0
      }
    }), Object.defineProperty(n, "prototype", {
      writable: !1
    }), i && t(n, i);
  }
  e.exports = r, e.exports.__esModule = !0, e.exports.default = e.exports;
})(dC);
var ea = dC.exports, pC = { exports: {} }, vC = { exports: {} };
(function(e) {
  function t(r) {
    "@babel/helpers - typeof";
    return e.exports = t = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(n) {
      return typeof n;
    } : function(n) {
      return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
    }, e.exports.__esModule = !0, e.exports.default = e.exports, t(r);
  }
  e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
})(vC);
var di = vC.exports;
(function(e) {
  var t = di.default, r = to;
  function n(i, a) {
    if (a && (t(a) === "object" || typeof a == "function"))
      return a;
    if (a !== void 0)
      throw new TypeError("Derived constructors may only return object or undefined");
    return r(i);
  }
  e.exports = n, e.exports.__esModule = !0, e.exports.default = e.exports;
})(pC);
var ta = pC.exports, hC = { exports: {} };
(function(e) {
  function t(r) {
    return e.exports = t = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(i) {
      return i.__proto__ || Object.getPrototypeOf(i);
    }, e.exports.__esModule = !0, e.exports.default = e.exports, t(r);
  }
  e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
})(hC);
var ci = hC.exports, mC = { exports: {} }, gC = { exports: {} }, yC = { exports: {} };
(function(e) {
  var t = di.default;
  function r(n, i) {
    if (t(n) !== "object" || n === null)
      return n;
    var a = n[Symbol.toPrimitive];
    if (a !== void 0) {
      var s = a.call(n, i || "default");
      if (t(s) !== "object")
        return s;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (i === "string" ? String : Number)(n);
  }
  e.exports = r, e.exports.__esModule = !0, e.exports.default = e.exports;
})(yC);
var PB = yC.exports;
(function(e) {
  var t = di.default, r = PB;
  function n(i) {
    var a = r(i, "string");
    return t(a) === "symbol" ? a : String(a);
  }
  e.exports = n, e.exports.__esModule = !0, e.exports.default = e.exports;
})(gC);
var VC = gC.exports;
(function(e) {
  var t = VC;
  function r(n, i, a) {
    return i = t(i), i in n ? Object.defineProperty(n, i, {
      value: a,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : n[i] = a, n;
  }
  e.exports = r, e.exports.__esModule = !0, e.exports.default = e.exports;
})(mC);
var ro = mC.exports, qC = { exports: {} };
(function(e) {
  var t = VC;
  function r(i, a) {
    for (var s = 0; s < a.length; s++) {
      var o = a[s];
      o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(i, t(o.key), o);
    }
  }
  function n(i, a, s) {
    return a && r(i.prototype, a), s && r(i, s), Object.defineProperty(i, "prototype", {
      writable: !1
    }), i;
  }
  e.exports = n, e.exports.__esModule = !0, e.exports.default = e.exports;
})(qC);
var ps = qC.exports, bC = { exports: {} };
(function(e) {
  function t(r, n) {
    if (!(r instanceof n))
      throw new TypeError("Cannot call a class as a function");
  }
  e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
})(bC);
var ra = bC.exports, BB = Ky, DB = Fa, LB = BB ? {}.toString : function() {
  return "[object " + DB(this) + "]";
}, ZB = Ky, MB = kn, jB = LB;
ZB || MB(Object.prototype, "toString", jB, { unsafe: !0 });
var YB = Xt, zB = Ji, Ap = zB(YB.process) === "process", GB = Kt, QB = li, JB = function(e, t, r) {
  try {
    return GB(QB(Object.getOwnPropertyDescriptor(e, t)[r]));
  } catch {
  }
}, HB = or, _B = String, $B = TypeError, eD = function(e) {
  if (typeof e == "object" || HB(e))
    return e;
  throw $B("Can't set " + _B(e) + " as a prototype");
}, tD = JB, rD = Or, nD = eD, Uu = Object.setPrototypeOf || ("__proto__" in {} ? function() {
  var e = !1, t = {}, r;
  try {
    r = tD(Object.prototype, "__proto__", "set"), r(t, []), e = t instanceof Array;
  } catch {
  }
  return function(i, a) {
    return rD(i), nD(a), e ? r(i, a) : i.__proto__ = a, i;
  };
}() : void 0), iD = Ti, aD = $i, sD = lr, oD = Ar, L0 = sD("species"), wp = function(e) {
  var t = iD(e);
  oD && t && !t[L0] && aD(t, L0, {
    configurable: !0,
    get: function() {
      return this;
    }
  });
}, uD = ka, fD = TypeError, vs = function(e, t) {
  if (uD(t, e))
    return e;
  throw fD("Incorrect invocation");
}, Z0 = Or, lD = Ty, dD = Ri, cD = lr, pD = cD("species"), Zy = function(e, t) {
  var r = Z0(e).constructor, n;
  return r === void 0 || dD(n = Z0(r)[pD]) ? t : lD(n);
}, vD = TypeError, My = function(e, t) {
  if (e < t)
    throw vD("Not enough arguments");
  return e;
}, hD = Hs, AC = /(?:ipad|iphone|ipod).*applewebkit/i.test(hD), Pn = Xt, mD = ds, gD = Ka, M0 = or, yD = Tr, wC = St, j0 = RS, VD = Ru, Y0 = dp, qD = My, bD = AC, AD = Ap, Um = Pn.setImmediate, xm = Pn.clearImmediate, wD = Pn.process, dh = Pn.Dispatch, kD = Pn.Function, z0 = Pn.MessageChannel, WD = Pn.String, ch = 0, Of = {}, G0 = "onreadystatechange", _f, ks, ph, vh;
wC(function() {
  _f = Pn.location;
});
var jy = function(e) {
  if (yD(Of, e)) {
    var t = Of[e];
    delete Of[e], t();
  }
}, hh = function(e) {
  return function() {
    jy(e);
  };
}, Q0 = function(e) {
  jy(e.data);
}, J0 = function(e) {
  Pn.postMessage(WD(e), _f.protocol + "//" + _f.host);
};
(!Um || !xm) && (Um = function(t) {
  qD(arguments.length, 1);
  var r = M0(t) ? t : kD(t), n = VD(arguments, 1);
  return Of[++ch] = function() {
    mD(r, void 0, n);
  }, ks(ch), ch;
}, xm = function(t) {
  delete Of[t];
}, AD ? ks = function(e) {
  wD.nextTick(hh(e));
} : dh && dh.now ? ks = function(e) {
  dh.now(hh(e));
} : z0 && !bD ? (ph = new z0(), vh = ph.port2, ph.port1.onmessage = Q0, ks = gD(vh.postMessage, vh)) : Pn.addEventListener && M0(Pn.postMessage) && !Pn.importScripts && _f && _f.protocol !== "file:" && !wC(J0) ? (ks = J0, Pn.addEventListener("message", Q0, !1)) : G0 in Y0("script") ? ks = function(e) {
  j0.appendChild(Y0("script"))[G0] = function() {
    j0.removeChild(this), jy(e);
  };
} : ks = function(e) {
  setTimeout(hh(e), 0);
});
var kC = {
  set: Um,
  clear: xm
}, WC = function() {
  this.head = null, this.tail = null;
};
WC.prototype = {
  add: function(e) {
    var t = { item: e, next: null }, r = this.tail;
    r ? r.next = t : this.head = t, this.tail = t;
  },
  get: function() {
    var e = this.head;
    if (e) {
      var t = this.head = e.next;
      return t === null && (this.tail = null), e.item;
    }
  }
};
var SC = WC, SD = Hs, CD = /ipad|iphone|ipod/i.test(SD) && typeof Pebble < "u", FD = Hs, KD = /web0s(?!.*chrome)/i.test(FD), Zs = Xt, H0 = Ka, RD = Qi.f, mh = kC.set, TD = SC, UD = AC, xD = CD, ED = KD, gh = Ap, _0 = Zs.MutationObserver || Zs.WebKitMutationObserver, $0 = Zs.document, eA = Zs.process, ld = Zs.Promise, tA = RD(Zs, "queueMicrotask"), Em = tA && tA.value, yo, yh, Vh, dd, rA;
if (!Em) {
  var cd = new TD(), pd = function() {
    var e, t;
    for (gh && (e = eA.domain) && e.exit(); t = cd.get(); )
      try {
        t();
      } catch (r) {
        throw cd.head && yo(), r;
      }
    e && e.enter();
  };
  !UD && !gh && !ED && _0 && $0 ? (yh = !0, Vh = $0.createTextNode(""), new _0(pd).observe(Vh, { characterData: !0 }), yo = function() {
    Vh.data = yh = !yh;
  }) : !xD && ld && ld.resolve ? (dd = ld.resolve(void 0), dd.constructor = ld, rA = H0(dd.then, dd), yo = function() {
    rA(pd);
  }) : gh ? yo = function() {
    eA.nextTick(pd);
  } : (mh = H0(mh, Zs), yo = function() {
    mh(pd);
  }), Em = function(e) {
    cd.head || yo(), cd.add(e);
  };
}
var OD = Em, ND = function(e, t) {
  try {
    arguments.length === 1 ? console.error(e) : console.error(e, t);
  } catch {
  }
}, Yy = function(e) {
  try {
    return { error: !1, value: e() };
  } catch (t) {
    return { error: !0, value: t };
  }
}, ID = Xt, kp = ID.Promise, CC = typeof Deno == "object" && Deno && typeof Deno.version == "object", XD = CC, PD = Ap, BD = !XD && !PD && typeof window == "object" && typeof document == "object", DD = Xt, Nf = kp, LD = or, ZD = vp, MD = Sy, jD = lr, YD = BD, zD = CC, qh = Su;
Nf && Nf.prototype;
var GD = jD("species"), Om = !1, FC = LD(DD.PromiseRejectionEvent), QD = ZD("Promise", function() {
  var e = MD(Nf), t = e !== String(Nf);
  if (!t && qh === 66)
    return !0;
  if (!qh || qh < 51 || !/native code/.test(e)) {
    var r = new Nf(function(a) {
      a(1);
    }), n = function(a) {
      a(function() {
      }, function() {
      });
    }, i = r.constructor = {};
    if (i[GD] = n, Om = r.then(function() {
    }) instanceof n, !Om)
      return !0;
  }
  return !t && (YD || zD) && !FC;
}), Rl = {
  CONSTRUCTOR: QD,
  REJECTION_EVENT: FC,
  SUBCLASSING: Om
}, xu = {}, nA = li, JD = TypeError, HD = function(e) {
  var t, r;
  this.promise = new e(function(n, i) {
    if (t !== void 0 || r !== void 0)
      throw JD("Bad Promise constructor");
    t = n, r = i;
  }), this.resolve = nA(t), this.reject = nA(r);
};
xu.f = function(e) {
  return new HD(e);
};
var _D = xt, Fc = Ap, us = Xt, du = fr, iA = kn, aA = Uu, $D = Ca, e8 = wp, t8 = li, rc = or, r8 = Rr, n8 = vs, i8 = Zy, KC = kC.set, zy = OD, a8 = ND, s8 = Yy, o8 = SC, RC = jn, Kc = kp, Gy = Rl, TC = xu, Wp = "Promise", UC = Gy.CONSTRUCTOR, u8 = Gy.REJECTION_EVENT, f8 = Gy.SUBCLASSING, bh = RC.getterFor(Wp), l8 = RC.set, xo = Kc && Kc.prototype, Es = Kc, vd = xo, xC = us.TypeError, Nm = us.document, Qy = us.process, Im = TC.f, d8 = Im, c8 = !!(Nm && Nm.createEvent && us.dispatchEvent), EC = "unhandledrejection", p8 = "rejectionhandled", sA = 0, OC = 1, v8 = 2, Jy = 1, NC = 2, hd, oA, h8, uA, IC = function(e) {
  var t;
  return r8(e) && rc(t = e.then) ? t : !1;
}, XC = function(e, t) {
  var r = t.value, n = t.state === OC, i = n ? e.ok : e.fail, a = e.resolve, s = e.reject, o = e.domain, u, f, l;
  try {
    i ? (n || (t.rejection === NC && g8(t), t.rejection = Jy), i === !0 ? u = r : (o && o.enter(), u = i(r), o && (o.exit(), l = !0)), u === e.promise ? s(xC("Promise-chain cycle")) : (f = IC(u)) ? du(f, u, a, s) : a(u)) : s(r);
  } catch (d) {
    o && !l && o.exit(), s(d);
  }
}, PC = function(e, t) {
  e.notified || (e.notified = !0, zy(function() {
    for (var r = e.reactions, n; n = r.get(); )
      XC(n, e);
    e.notified = !1, t && !e.rejection && m8(e);
  }));
}, BC = function(e, t, r) {
  var n, i;
  c8 ? (n = Nm.createEvent("Event"), n.promise = t, n.reason = r, n.initEvent(e, !1, !0), us.dispatchEvent(n)) : n = { promise: t, reason: r }, !u8 && (i = us["on" + e]) ? i(n) : e === EC && a8("Unhandled promise rejection", r);
}, m8 = function(e) {
  du(KC, us, function() {
    var t = e.facade, r = e.value, n = fA(e), i;
    if (n && (i = s8(function() {
      Fc ? Qy.emit("unhandledRejection", r, t) : BC(EC, t, r);
    }), e.rejection = Fc || fA(e) ? NC : Jy, i.error))
      throw i.value;
  });
}, fA = function(e) {
  return e.rejection !== Jy && !e.parent;
}, g8 = function(e) {
  du(KC, us, function() {
    var t = e.facade;
    Fc ? Qy.emit("rejectionHandled", t) : BC(p8, t, e.value);
  });
}, Io = function(e, t, r) {
  return function(n) {
    e(t, n, r);
  };
}, Mo = function(e, t, r) {
  e.done || (e.done = !0, r && (e = r), e.value = t, e.state = v8, PC(e, !0));
}, Xm = function(e, t, r) {
  if (!e.done) {
    e.done = !0, r && (e = r);
    try {
      if (e.facade === t)
        throw xC("Promise can't be resolved itself");
      var n = IC(t);
      n ? zy(function() {
        var i = { done: !1 };
        try {
          du(
            n,
            t,
            Io(Xm, i, e),
            Io(Mo, i, e)
          );
        } catch (a) {
          Mo(i, a, e);
        }
      }) : (e.value = t, e.state = OC, PC(e, !1));
    } catch (i) {
      Mo({ done: !1 }, i, e);
    }
  }
};
if (UC && (Es = function(t) {
  n8(this, vd), t8(t), du(hd, this);
  var r = bh(this);
  try {
    t(Io(Xm, r), Io(Mo, r));
  } catch (n) {
    Mo(r, n);
  }
}, vd = Es.prototype, hd = function(t) {
  l8(this, {
    type: Wp,
    done: !1,
    notified: !1,
    parent: !1,
    reactions: new o8(),
    rejection: !1,
    state: sA,
    value: void 0
  });
}, hd.prototype = iA(vd, "then", function(t, r) {
  var n = bh(this), i = Im(i8(this, Es));
  return n.parent = !0, i.ok = rc(t) ? t : !0, i.fail = rc(r) && r, i.domain = Fc ? Qy.domain : void 0, n.state === sA ? n.reactions.add(i) : zy(function() {
    XC(i, n);
  }), i.promise;
}), oA = function() {
  var e = new hd(), t = bh(e);
  this.promise = e, this.resolve = Io(Xm, t), this.reject = Io(Mo, t);
}, TC.f = Im = function(e) {
  return e === Es || e === h8 ? new oA(e) : d8(e);
}, rc(Kc) && xo !== Object.prototype)) {
  uA = xo.then, f8 || iA(xo, "then", function(t, r) {
    var n = this;
    return new Es(function(i, a) {
      du(uA, n, i, a);
    }).then(t, r);
  }, { unsafe: !0 });
  try {
    delete xo.constructor;
  } catch {
  }
  aA && aA(xo, vd);
}
_D({ global: !0, constructor: !0, wrap: !0, forced: UC }, {
  Promise: Es
});
$D(Es, Wp, !1);
e8(Wp);
var Tl = {}, y8 = lr, V8 = Tl, q8 = y8("iterator"), b8 = Array.prototype, Hy = function(e) {
  return e !== void 0 && (V8.Array === e || b8[q8] === e);
}, A8 = Fa, lA = $s, w8 = Ri, k8 = Tl, W8 = lr, S8 = W8("iterator"), Ul = function(e) {
  if (!w8(e))
    return lA(e, S8) || lA(e, "@@iterator") || k8[A8(e)];
}, C8 = fr, F8 = li, K8 = Or, R8 = _s, T8 = Ul, U8 = TypeError, Sp = function(e, t) {
  var r = arguments.length < 2 ? T8(e) : t;
  if (F8(r))
    return K8(C8(r, e));
  throw U8(R8(e) + " is not iterable");
}, x8 = fr, dA = Or, E8 = $s, DC = function(e, t, r) {
  var n, i;
  dA(e);
  try {
    if (n = E8(e, "return"), !n) {
      if (t === "throw")
        throw r;
      return r;
    }
    n = x8(n, e);
  } catch (a) {
    i = !0, n = a;
  }
  if (t === "throw")
    throw r;
  if (i)
    throw n;
  return dA(n), r;
}, O8 = Ka, N8 = fr, I8 = Or, X8 = _s, P8 = Hy, B8 = on, cA = ka, D8 = Sp, L8 = Ul, pA = DC, Z8 = TypeError, nc = function(e, t) {
  this.stopped = e, this.result = t;
}, vA = nc.prototype, xl = function(e, t, r) {
  var n = r && r.that, i = !!(r && r.AS_ENTRIES), a = !!(r && r.IS_RECORD), s = !!(r && r.IS_ITERATOR), o = !!(r && r.INTERRUPTED), u = O8(t, n), f, l, d, c, p, v, h, m = function(w) {
    return f && pA(f, "normal", w), new nc(!0, w);
  }, q = function(w) {
    return i ? (I8(w), o ? u(w[0], w[1], m) : u(w[0], w[1])) : o ? u(w, m) : u(w);
  };
  if (a)
    f = e.iterator;
  else if (s)
    f = e;
  else {
    if (l = L8(e), !l)
      throw Z8(X8(e) + " is not iterable");
    if (P8(l)) {
      for (d = 0, c = B8(e); c > d; d++)
        if (p = q(e[d]), p && cA(vA, p))
          return p;
      return new nc(!1);
    }
    f = D8(e, l);
  }
  for (v = a ? e.next : f.next; !(h = N8(v, f)).done; ) {
    try {
      p = q(h.value);
    } catch (w) {
      pA(f, "throw", w);
    }
    if (typeof p == "object" && p && cA(vA, p))
      return p;
  }
  return new nc(!1);
}, M8 = lr, LC = M8("iterator"), ZC = !1;
try {
  var j8 = 0, hA = {
    next: function() {
      return { done: !!j8++ };
    },
    return: function() {
      ZC = !0;
    }
  };
  hA[LC] = function() {
    return this;
  }, Array.from(hA, function() {
    throw 2;
  });
} catch {
}
var Cp = function(e, t) {
  try {
    if (!t && !ZC)
      return !1;
  } catch {
    return !1;
  }
  var r = !1;
  try {
    var n = {};
    n[LC] = function() {
      return {
        next: function() {
          return { done: r = !0 };
        }
      };
    }, e(n);
  } catch {
  }
  return r;
}, Y8 = kp, z8 = Cp, G8 = Rl.CONSTRUCTOR, MC = G8 || !z8(function(e) {
  Y8.all(e).then(void 0, function() {
  });
}), Q8 = xt, J8 = fr, H8 = li, _8 = xu, $8 = Yy, e7 = xl, t7 = MC;
Q8({ target: "Promise", stat: !0, forced: t7 }, {
  all: function(t) {
    var r = this, n = _8.f(r), i = n.resolve, a = n.reject, s = $8(function() {
      var o = H8(r.resolve), u = [], f = 0, l = 1;
      e7(t, function(d) {
        var c = f++, p = !1;
        l++, J8(o, r, d).then(function(v) {
          p || (p = !0, u[c] = v, --l || i(u));
        }, a);
      }), --l || i(u);
    });
    return s.error && a(s.value), n.promise;
  }
});
var r7 = xt, n7 = Rl.CONSTRUCTOR, Pm = kp, i7 = Ti, a7 = or, s7 = kn, mA = Pm && Pm.prototype;
r7({ target: "Promise", proto: !0, forced: n7, real: !0 }, {
  catch: function(e) {
    return this.then(void 0, e);
  }
});
if (a7(Pm)) {
  var gA = i7("Promise").prototype.catch;
  mA.catch !== gA && s7(mA, "catch", gA, { unsafe: !0 });
}
var o7 = xt, u7 = fr, f7 = li, l7 = xu, d7 = Yy, c7 = xl, p7 = MC;
o7({ target: "Promise", stat: !0, forced: p7 }, {
  race: function(t) {
    var r = this, n = l7.f(r), i = n.reject, a = d7(function() {
      var s = f7(r.resolve);
      c7(t, function(o) {
        u7(s, r, o).then(n.resolve, i);
      });
    });
    return a.error && i(a.value), n.promise;
  }
});
var v7 = xt, h7 = fr, m7 = xu, g7 = Rl.CONSTRUCTOR;
v7({ target: "Promise", stat: !0, forced: g7 }, {
  reject: function(t) {
    var r = m7.f(this);
    return h7(r.reject, void 0, t), r.promise;
  }
});
var y7 = Or, V7 = Rr, q7 = xu, b7 = function(e, t) {
  if (y7(e), V7(t) && t.constructor === e)
    return t;
  var r = q7.f(e), n = r.resolve;
  return n(t), r.promise;
}, A7 = xt, w7 = Ti, k7 = Rl.CONSTRUCTOR, W7 = b7;
w7("Promise");
A7({ target: "Promise", stat: !0, forced: k7 }, {
  resolve: function(t) {
    return W7(this, t);
  }
});
var S7 = xt, C7 = Un.map, F7 = Fl, K7 = F7("map");
S7({ target: "Array", proto: !0, forced: !K7 }, {
  map: function(t) {
    return C7(this, t, arguments.length > 1 ? arguments[1] : void 0);
  }
});
var jC = {
  CSSRuleList: 0,
  CSSStyleDeclaration: 0,
  CSSValueList: 0,
  ClientRectList: 0,
  DOMRectList: 0,
  DOMStringList: 0,
  DOMTokenList: 1,
  DataTransferItemList: 0,
  FileList: 0,
  HTMLAllCollection: 0,
  HTMLCollection: 0,
  HTMLFormElement: 0,
  HTMLSelectElement: 0,
  MediaList: 0,
  MimeTypeArray: 0,
  NamedNodeMap: 0,
  NodeList: 1,
  PaintRequestList: 0,
  Plugin: 0,
  PluginArray: 0,
  SVGLengthList: 0,
  SVGNumberList: 0,
  SVGPathSegList: 0,
  SVGPointList: 0,
  SVGStringList: 0,
  SVGTransformList: 0,
  SourceBufferList: 0,
  StyleSheetList: 0,
  TextTrackCueList: 0,
  TextTrackList: 0,
  TouchList: 0
}, R7 = dp, Ah = R7("span").classList, yA = Ah && Ah.constructor && Ah.constructor.prototype, YC = yA === Object.prototype ? void 0 : yA, T7 = St, Fp = function(e, t) {
  var r = [][e];
  return !!r && T7(function() {
    r.call(null, t || function() {
      return 1;
    }, 1);
  });
}, U7 = Un.forEach, x7 = Fp, E7 = x7("forEach"), O7 = E7 ? [].forEach : function(t) {
  return U7(this, t, arguments.length > 1 ? arguments[1] : void 0);
}, VA = Xt, qA = jC, N7 = YC, wh = O7, I7 = Wa, zC = function(e) {
  if (e && e.forEach !== wh)
    try {
      I7(e, "forEach", wh);
    } catch {
      e.forEach = wh;
    }
};
for (var kh in qA)
  qA[kh] && zC(VA[kh] && VA[kh].prototype);
zC(N7);
var GC = { exports: {} };
(function(e) {
  var t = di.default;
  function r() {
    e.exports = r = function() {
      return i;
    }, e.exports.__esModule = !0, e.exports.default = e.exports;
    var n, i = {}, a = Object.prototype, s = a.hasOwnProperty, o = Object.defineProperty || function(ue, M, F) {
      ue[M] = F.value;
    }, u = typeof Symbol == "function" ? Symbol : {}, f = u.iterator || "@@iterator", l = u.asyncIterator || "@@asyncIterator", d = u.toStringTag || "@@toStringTag";
    function c(ue, M, F) {
      return Object.defineProperty(ue, M, {
        value: F,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }), ue[M];
    }
    try {
      c({}, "");
    } catch {
      c = function(F, pe, We) {
        return F[pe] = We;
      };
    }
    function p(ue, M, F, pe) {
      var We = M && M.prototype instanceof C ? M : C, ce = Object.create(We.prototype), oe = new xe(pe || []);
      return o(ce, "_invoke", {
        value: Z(ue, F, oe)
      }), ce;
    }
    function v(ue, M, F) {
      try {
        return {
          type: "normal",
          arg: ue.call(M, F)
        };
      } catch (pe) {
        return {
          type: "throw",
          arg: pe
        };
      }
    }
    i.wrap = p;
    var h = "suspendedStart", m = "suspendedYield", q = "executing", w = "completed", O = {};
    function C() {
    }
    function R() {
    }
    function I() {
    }
    var P = {};
    c(P, f, function() {
      return this;
    });
    var K = Object.getPrototypeOf, B = K && K(K(ye([])));
    B && B !== a && s.call(B, f) && (P = B);
    var L = I.prototype = C.prototype = Object.create(P);
    function _(ue) {
      ["next", "throw", "return"].forEach(function(M) {
        c(ue, M, function(F) {
          return this._invoke(M, F);
        });
      });
    }
    function ne(ue, M) {
      function F(We, ce, oe, z) {
        var Ze = v(ue[We], ue, ce);
        if (Ze.type !== "throw") {
          var Ae = Ze.arg, re = Ae.value;
          return re && t(re) == "object" && s.call(re, "__await") ? M.resolve(re.__await).then(function(Qe) {
            F("next", Qe, oe, z);
          }, function(Qe) {
            F("throw", Qe, oe, z);
          }) : M.resolve(re).then(function(Qe) {
            Ae.value = Qe, oe(Ae);
          }, function(Qe) {
            return F("throw", Qe, oe, z);
          });
        }
        z(Ze.arg);
      }
      var pe;
      o(this, "_invoke", {
        value: function(ce, oe) {
          function z() {
            return new M(function(Ze, Ae) {
              F(ce, oe, Ze, Ae);
            });
          }
          return pe = pe ? pe.then(z, z) : z();
        }
      });
    }
    function Z(ue, M, F) {
      var pe = h;
      return function(We, ce) {
        if (pe === q)
          throw new Error("Generator is already running");
        if (pe === w) {
          if (We === "throw")
            throw ce;
          return {
            value: n,
            done: !0
          };
        }
        for (F.method = We, F.arg = ce; ; ) {
          var oe = F.delegate;
          if (oe) {
            var z = le(oe, F);
            if (z) {
              if (z === O)
                continue;
              return z;
            }
          }
          if (F.method === "next")
            F.sent = F._sent = F.arg;
          else if (F.method === "throw") {
            if (pe === h)
              throw pe = w, F.arg;
            F.dispatchException(F.arg);
          } else
            F.method === "return" && F.abrupt("return", F.arg);
          pe = q;
          var Ze = v(ue, M, F);
          if (Ze.type === "normal") {
            if (pe = F.done ? w : m, Ze.arg === O)
              continue;
            return {
              value: Ze.arg,
              done: F.done
            };
          }
          Ze.type === "throw" && (pe = w, F.method = "throw", F.arg = Ze.arg);
        }
      };
    }
    function le(ue, M) {
      var F = M.method, pe = ue.iterator[F];
      if (pe === n)
        return M.delegate = null, F === "throw" && ue.iterator.return && (M.method = "return", M.arg = n, le(ue, M), M.method === "throw") || F !== "return" && (M.method = "throw", M.arg = new TypeError("The iterator does not provide a '" + F + "' method")), O;
      var We = v(pe, ue.iterator, M.arg);
      if (We.type === "throw")
        return M.method = "throw", M.arg = We.arg, M.delegate = null, O;
      var ce = We.arg;
      return ce ? ce.done ? (M[ue.resultName] = ce.value, M.next = ue.nextLoc, M.method !== "return" && (M.method = "next", M.arg = n), M.delegate = null, O) : ce : (M.method = "throw", M.arg = new TypeError("iterator result is not an object"), M.delegate = null, O);
    }
    function he(ue) {
      var M = {
        tryLoc: ue[0]
      };
      1 in ue && (M.catchLoc = ue[1]), 2 in ue && (M.finallyLoc = ue[2], M.afterLoc = ue[3]), this.tryEntries.push(M);
    }
    function Ie(ue) {
      var M = ue.completion || {};
      M.type = "normal", delete M.arg, ue.completion = M;
    }
    function xe(ue) {
      this.tryEntries = [{
        tryLoc: "root"
      }], ue.forEach(he, this), this.reset(!0);
    }
    function ye(ue) {
      if (ue || ue === "") {
        var M = ue[f];
        if (M)
          return M.call(ue);
        if (typeof ue.next == "function")
          return ue;
        if (!isNaN(ue.length)) {
          var F = -1, pe = function We() {
            for (; ++F < ue.length; )
              if (s.call(ue, F))
                return We.value = ue[F], We.done = !1, We;
            return We.value = n, We.done = !0, We;
          };
          return pe.next = pe;
        }
      }
      throw new TypeError(t(ue) + " is not iterable");
    }
    return R.prototype = I, o(L, "constructor", {
      value: I,
      configurable: !0
    }), o(I, "constructor", {
      value: R,
      configurable: !0
    }), R.displayName = c(I, d, "GeneratorFunction"), i.isGeneratorFunction = function(ue) {
      var M = typeof ue == "function" && ue.constructor;
      return !!M && (M === R || (M.displayName || M.name) === "GeneratorFunction");
    }, i.mark = function(ue) {
      return Object.setPrototypeOf ? Object.setPrototypeOf(ue, I) : (ue.__proto__ = I, c(ue, d, "GeneratorFunction")), ue.prototype = Object.create(L), ue;
    }, i.awrap = function(ue) {
      return {
        __await: ue
      };
    }, _(ne.prototype), c(ne.prototype, l, function() {
      return this;
    }), i.AsyncIterator = ne, i.async = function(ue, M, F, pe, We) {
      We === void 0 && (We = Promise);
      var ce = new ne(p(ue, M, F, pe), We);
      return i.isGeneratorFunction(M) ? ce : ce.next().then(function(oe) {
        return oe.done ? oe.value : ce.next();
      });
    }, _(L), c(L, d, "Generator"), c(L, f, function() {
      return this;
    }), c(L, "toString", function() {
      return "[object Generator]";
    }), i.keys = function(ue) {
      var M = Object(ue), F = [];
      for (var pe in M)
        F.push(pe);
      return F.reverse(), function We() {
        for (; F.length; ) {
          var ce = F.pop();
          if (ce in M)
            return We.value = ce, We.done = !1, We;
        }
        return We.done = !0, We;
      };
    }, i.values = ye, xe.prototype = {
      constructor: xe,
      reset: function(M) {
        if (this.prev = 0, this.next = 0, this.sent = this._sent = n, this.done = !1, this.delegate = null, this.method = "next", this.arg = n, this.tryEntries.forEach(Ie), !M)
          for (var F in this)
            F.charAt(0) === "t" && s.call(this, F) && !isNaN(+F.slice(1)) && (this[F] = n);
      },
      stop: function() {
        this.done = !0;
        var M = this.tryEntries[0].completion;
        if (M.type === "throw")
          throw M.arg;
        return this.rval;
      },
      dispatchException: function(M) {
        if (this.done)
          throw M;
        var F = this;
        function pe(Ae, re) {
          return oe.type = "throw", oe.arg = M, F.next = Ae, re && (F.method = "next", F.arg = n), !!re;
        }
        for (var We = this.tryEntries.length - 1; We >= 0; --We) {
          var ce = this.tryEntries[We], oe = ce.completion;
          if (ce.tryLoc === "root")
            return pe("end");
          if (ce.tryLoc <= this.prev) {
            var z = s.call(ce, "catchLoc"), Ze = s.call(ce, "finallyLoc");
            if (z && Ze) {
              if (this.prev < ce.catchLoc)
                return pe(ce.catchLoc, !0);
              if (this.prev < ce.finallyLoc)
                return pe(ce.finallyLoc);
            } else if (z) {
              if (this.prev < ce.catchLoc)
                return pe(ce.catchLoc, !0);
            } else {
              if (!Ze)
                throw new Error("try statement without catch or finally");
              if (this.prev < ce.finallyLoc)
                return pe(ce.finallyLoc);
            }
          }
        }
      },
      abrupt: function(M, F) {
        for (var pe = this.tryEntries.length - 1; pe >= 0; --pe) {
          var We = this.tryEntries[pe];
          if (We.tryLoc <= this.prev && s.call(We, "finallyLoc") && this.prev < We.finallyLoc) {
            var ce = We;
            break;
          }
        }
        ce && (M === "break" || M === "continue") && ce.tryLoc <= F && F <= ce.finallyLoc && (ce = null);
        var oe = ce ? ce.completion : {};
        return oe.type = M, oe.arg = F, ce ? (this.method = "next", this.next = ce.finallyLoc, O) : this.complete(oe);
      },
      complete: function(M, F) {
        if (M.type === "throw")
          throw M.arg;
        return M.type === "break" || M.type === "continue" ? this.next = M.arg : M.type === "return" ? (this.rval = this.arg = M.arg, this.method = "return", this.next = "end") : M.type === "normal" && F && (this.next = F), O;
      },
      finish: function(M) {
        for (var F = this.tryEntries.length - 1; F >= 0; --F) {
          var pe = this.tryEntries[F];
          if (pe.finallyLoc === M)
            return this.complete(pe.completion, pe.afterLoc), Ie(pe), O;
        }
      },
      catch: function(M) {
        for (var F = this.tryEntries.length - 1; F >= 0; --F) {
          var pe = this.tryEntries[F];
          if (pe.tryLoc === M) {
            var We = pe.completion;
            if (We.type === "throw") {
              var ce = We.arg;
              Ie(pe);
            }
            return ce;
          }
        }
        throw new Error("illegal catch attempt");
      },
      delegateYield: function(M, F, pe) {
        return this.delegate = {
          iterator: ye(M),
          resultName: F,
          nextLoc: pe
        }, this.method === "next" && (this.arg = n), O;
      }
    }, i;
  }
  e.exports = r, e.exports.__esModule = !0, e.exports.default = e.exports;
})(GC);
var X7 = GC.exports, ic = X7(), El = ic;
try {
  regeneratorRuntime = ic;
} catch {
  typeof globalThis == "object" ? globalThis.regeneratorRuntime = ic : Function("r", "regeneratorRuntime = r")(ic);
}
var P7 = TypeError, B7 = 9007199254740991, QC = function(e) {
  if (e > B7)
    throw P7("Maximum allowed index exceeded");
  return e;
}, D7 = xt, L7 = St, Z7 = Wl, M7 = Rr, j7 = hn, Y7 = on, bA = QC, AA = Tu, z7 = Ny, G7 = Fl, Q7 = lr, J7 = Su, JC = Q7("isConcatSpreadable"), H7 = J7 >= 51 || !L7(function() {
  var e = [];
  return e[JC] = !1, e.concat()[0] !== e;
}), _7 = function(e) {
  if (!M7(e))
    return !1;
  var t = e[JC];
  return t !== void 0 ? !!t : Z7(e);
}, $7 = !H7 || !G7("concat");
D7({ target: "Array", proto: !0, arity: 1, forced: $7 }, {
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  concat: function(t) {
    var r = j7(this), n = z7(r, 0), i = 0, a, s, o, u, f;
    for (a = -1, o = arguments.length; a < o; a++)
      if (f = a === -1 ? r : arguments[a], _7(f))
        for (u = Y7(f), bA(i + u), s = 0; s < u; s++, i++)
          s in f && AA(n, i, f[s]);
      else
        bA(i + 1), AA(n, i++, f);
    return n.length = i, n;
  }
});
var eL = Or, tL = DC, rL = function(e, t, r, n) {
  try {
    return n ? t(eL(r)[0], r[1]) : t(r);
  } catch (i) {
    tL(e, "throw", i);
  }
}, nL = Ka, iL = fr, aL = hn, sL = rL, oL = Hy, uL = hp, fL = on, wA = Tu, lL = Sp, dL = Ul, kA = Array, HC = function(t) {
  var r = aL(t), n = uL(this), i = arguments.length, a = i > 1 ? arguments[1] : void 0, s = a !== void 0;
  s && (a = nL(a, i > 2 ? arguments[2] : void 0));
  var o = dL(r), u = 0, f, l, d, c, p, v;
  if (o && !(this === kA && oL(o)))
    for (c = lL(r, o), p = c.next, l = n ? new this() : []; !(d = iL(p, c)).done; u++)
      v = s ? sL(c, a, [d.value, u], !0) : d.value, wA(l, u, v);
  else
    for (f = fL(r), l = n ? new this(f) : kA(f); f > u; u++)
      v = s ? a(r[u], u) : r[u], wA(l, u, v);
  return l.length = u, l;
}, cL = xt, pL = HC, vL = Cp, hL = !vL(function(e) {
  Array.from(e);
});
cL({ target: "Array", stat: !0, forced: hL }, {
  from: pL
});
var _y = Kt, mL = _i, gL = $r, yL = Hi, VL = _y("".charAt), WA = _y("".charCodeAt), qL = _y("".slice), SA = function(e) {
  return function(t, r) {
    var n = gL(yL(t)), i = mL(r), a = n.length, s, o;
    return i < 0 || i >= a ? e ? "" : void 0 : (s = WA(n, i), s < 55296 || s > 56319 || i + 1 === a || (o = WA(n, i + 1)) < 56320 || o > 57343 ? e ? VL(n, i) : s : e ? qL(n, i, i + 2) : (s - 55296 << 10) + (o - 56320) + 65536);
  };
}, $y = {
  // `String.prototype.codePointAt` method
  // https://tc39.es/ecma262/#sec-string.prototype.codepointat
  codeAt: SA(!1),
  // `String.prototype.at` method
  // https://github.com/mathiasbynens/String.prototype.at
  charAt: SA(!0)
}, bL = St, AL = !bL(function() {
  function e() {
  }
  return e.prototype.constructor = null, Object.getPrototypeOf(new e()) !== e.prototype;
}), wL = Tr, kL = or, WL = hn, SL = cp, CL = AL, CA = SL("IE_PROTO"), Bm = Object, FL = Bm.prototype, Ol = CL ? Bm.getPrototypeOf : function(e) {
  var t = WL(e);
  if (wL(t, CA))
    return t[CA];
  var r = t.constructor;
  return kL(r) && t instanceof r ? r.prototype : t instanceof Bm ? FL : null;
}, KL = St, RL = or, TL = Rr, FA = Ol, UL = kn, xL = lr, Dm = xL("iterator"), _C = !1, Ms, Wh, Sh;
[].keys && (Sh = [].keys(), "next" in Sh ? (Wh = FA(FA(Sh)), Wh !== Object.prototype && (Ms = Wh)) : _C = !0);
var EL = !TL(Ms) || KL(function() {
  var e = {};
  return Ms[Dm].call(e) !== e;
});
EL && (Ms = {});
RL(Ms[Dm]) || UL(Ms, Dm, function() {
  return this;
});
var $C = {
  IteratorPrototype: Ms,
  BUGGY_SAFARI_ITERATORS: _C
}, OL = $C.IteratorPrototype, NL = cs, IL = Js, XL = Ca, PL = Tl, BL = function() {
  return this;
}, eF = function(e, t, r, n) {
  var i = t + " Iterator";
  return e.prototype = NL(OL, { next: IL(+!n, r) }), XL(e, i, !1), PL[i] = BL, e;
}, DL = xt, LL = fr, tF = Vl, ZL = or, ML = eF, KA = Ol, RA = Uu, jL = Ca, YL = Wa, Ch = kn, zL = lr, GL = Tl, rF = $C, QL = tF.PROPER, JL = tF.CONFIGURABLE, TA = rF.IteratorPrototype, md = rF.BUGGY_SAFARI_ITERATORS, uf = zL("iterator"), UA = "keys", ff = "values", xA = "entries", HL = function() {
  return this;
}, eV = function(e, t, r, n, i, a, s) {
  ML(r, t, n);
  var o = function(q) {
    if (q === i && c)
      return c;
    if (!md && q && q in l)
      return l[q];
    switch (q) {
      case UA:
        return function() {
          return new r(this, q);
        };
      case ff:
        return function() {
          return new r(this, q);
        };
      case xA:
        return function() {
          return new r(this, q);
        };
    }
    return function() {
      return new r(this);
    };
  }, u = t + " Iterator", f = !1, l = e.prototype, d = l[uf] || l["@@iterator"] || i && l[i], c = !md && d || o(i), p = t === "Array" && l.entries || d, v, h, m;
  if (p && (v = KA(p.call(new e())), v !== Object.prototype && v.next && (KA(v) !== TA && (RA ? RA(v, TA) : ZL(v[uf]) || Ch(v, uf, HL)), jL(v, u, !0))), QL && i === ff && d && d.name !== ff && (JL ? YL(l, "name", ff) : (f = !0, c = function() {
    return LL(d, this);
  })), i)
    if (h = {
      values: o(ff),
      keys: a ? c : o(UA),
      entries: o(xA)
    }, s)
      for (m in h)
        (md || f || !(m in l)) && Ch(l, m, h[m]);
    else
      DL({ target: t, proto: !0, forced: md || f }, h);
  return l[uf] !== c && Ch(l, uf, c, { name: i }), GL[t] = c, h;
}, tV = function(e, t) {
  return { value: e, done: t };
}, _L = $y.charAt, $L = $r, nF = jn, eZ = eV, EA = tV, iF = "String Iterator", tZ = nF.set, rZ = nF.getterFor(iF);
eZ(String, "String", function(e) {
  tZ(this, {
    type: iF,
    string: $L(e),
    index: 0
  });
}, function() {
  var t = rZ(this), r = t.string, n = t.index, i;
  return n >= r.length ? EA(void 0, !0) : (i = _L(r, n), t.index += i.length, EA(i, !1));
});
var aF = { exports: {} };
(function(e) {
  (function(t, r) {
    e.exports ? e.exports = r() : t.log = r();
  })(Xn, function() {
    var t = function() {
    }, r = "undefined", n = typeof window !== r && typeof window.navigator !== r && /Trident\/|MSIE /.test(window.navigator.userAgent), i = [
      "trace",
      "debug",
      "info",
      "warn",
      "error"
    ];
    function a(h, m) {
      var q = h[m];
      if (typeof q.bind == "function")
        return q.bind(h);
      try {
        return Function.prototype.bind.call(q, h);
      } catch {
        return function() {
          return Function.prototype.apply.apply(q, [h, arguments]);
        };
      }
    }
    function s() {
      console.log && (console.log.apply ? console.log.apply(console, arguments) : Function.prototype.apply.apply(console.log, [console, arguments])), console.trace && console.trace();
    }
    function o(h) {
      return h === "debug" && (h = "log"), typeof console === r ? !1 : h === "trace" && n ? s : console[h] !== void 0 ? a(console, h) : console.log !== void 0 ? a(console, "log") : t;
    }
    function u(h, m) {
      for (var q = 0; q < i.length; q++) {
        var w = i[q];
        this[w] = q < h ? t : this.methodFactory(w, h, m);
      }
      this.log = this.debug;
    }
    function f(h, m, q) {
      return function() {
        typeof console !== r && (u.call(this, m, q), this[h].apply(this, arguments));
      };
    }
    function l(h, m, q) {
      return o(h) || f.apply(this, arguments);
    }
    function d(h, m, q) {
      var w = this, O;
      m = m ?? "WARN";
      var C = "loglevel";
      typeof h == "string" ? C += ":" + h : typeof h == "symbol" && (C = void 0);
      function R(B) {
        var L = (i[B] || "silent").toUpperCase();
        if (!(typeof window === r || !C)) {
          try {
            window.localStorage[C] = L;
            return;
          } catch {
          }
          try {
            window.document.cookie = encodeURIComponent(C) + "=" + L + ";";
          } catch {
          }
        }
      }
      function I() {
        var B;
        if (!(typeof window === r || !C)) {
          try {
            B = window.localStorage[C];
          } catch {
          }
          if (typeof B === r)
            try {
              var L = window.document.cookie, _ = L.indexOf(
                encodeURIComponent(C) + "="
              );
              _ !== -1 && (B = /^([^;]+)/.exec(L.slice(_))[1]);
            } catch {
            }
          return w.levels[B] === void 0 && (B = void 0), B;
        }
      }
      function P() {
        if (!(typeof window === r || !C)) {
          try {
            window.localStorage.removeItem(C);
            return;
          } catch {
          }
          try {
            window.document.cookie = encodeURIComponent(C) + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC";
          } catch {
          }
        }
      }
      w.name = h, w.levels = {
        TRACE: 0,
        DEBUG: 1,
        INFO: 2,
        WARN: 3,
        ERROR: 4,
        SILENT: 5
      }, w.methodFactory = q || l, w.getLevel = function() {
        return O;
      }, w.setLevel = function(B, L) {
        if (typeof B == "string" && w.levels[B.toUpperCase()] !== void 0 && (B = w.levels[B.toUpperCase()]), typeof B == "number" && B >= 0 && B <= w.levels.SILENT) {
          if (O = B, L !== !1 && R(B), u.call(w, B, h), typeof console === r && B < w.levels.SILENT)
            return "No console available for logging";
        } else
          throw "log.setLevel() called with invalid level: " + B;
      }, w.setDefaultLevel = function(B) {
        m = B, I() || w.setLevel(B, !1);
      }, w.resetLevel = function() {
        w.setLevel(m, !1), P();
      }, w.enableAll = function(B) {
        w.setLevel(w.levels.TRACE, B);
      }, w.disableAll = function(B) {
        w.setLevel(w.levels.SILENT, B);
      };
      var K = I();
      K == null && (K = m), w.setLevel(K, !1);
    }
    var c = new d(), p = {};
    c.getLogger = function(m) {
      if (typeof m != "symbol" && typeof m != "string" || m === "")
        throw new TypeError("You must supply a name when creating a logger.");
      var q = p[m];
      return q || (q = p[m] = new d(
        m,
        c.getLevel(),
        c.methodFactory
      )), q;
    };
    var v = typeof window !== r ? window.log : void 0;
    return c.noConflict = function() {
      return typeof window !== r && window.log === c && (window.log = v), c;
    }, c.getLoggers = function() {
      return p;
    }, c.default = c, c;
  });
})(aF);
var Nl = aF.exports;
const Ls = "\\d+(?:[\\.,]\\d+)?", nZ = `(${Ls}W)`, iZ = `(${Ls}Y)?(${Ls}M)?(${Ls}D)?`, aZ = `T(${Ls}H)?(${Ls}M)?(${Ls}S)?`, sZ = `P(?:${nZ}|${iZ}(?:${aZ})?)`, oZ = ["weeks", "years", "months", "days", "hours", "minutes", "seconds"], rV = new RegExp(sZ), sF = (e) => e.match(rV).slice(1).reduce((t, r, n) => (t[oZ[n]] = parseFloat(r) || 0, t), {}), nV = (e, t) => {
  const r = t ? t.getTime() : Date.now(), n = new Date(r);
  return n.setFullYear(n.getFullYear() + e.years), n.setMonth(n.getMonth() + e.months), n.setDate(n.getDate() + e.days), n.setHours(n.getHours() + e.hours), n.setMinutes(n.getMinutes() + e.minutes), n.setMilliseconds(n.getMilliseconds() + e.seconds * 1e3), n.setDate(n.getDate() + e.weeks * 7), n;
}, oF = (e, t) => {
  const r = t ? t.getTime() : Date.now(), n = new Date(r);
  return (nV(e, n).getTime() - n.getTime()) / 1e3;
}, uZ = {
  end: nV,
  toSeconds: oF,
  pattern: rV,
  parse: sF
}, fZ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: uZ,
  end: nV,
  parse: sF,
  pattern: rV,
  toSeconds: oF
}, Symbol.toStringTag, { value: "Module" })), lZ = /* @__PURE__ */ AU(fZ);
var dZ = lr, cZ = cs, pZ = wn.f, Lm = dZ("unscopables"), Zm = Array.prototype;
Zm[Lm] === void 0 && pZ(Zm, Lm, {
  configurable: !0,
  value: cZ(null)
});
var iV = function(e) {
  Zm[Lm][e] = !0;
}, vZ = Mn, aV = iV, OA = Tl, uF = jn, hZ = wn.f, mZ = eV, gd = tV, gZ = Ar, fF = "Array Iterator", yZ = uF.set, VZ = uF.getterFor(fF), lF = mZ(Array, "Array", function(e, t) {
  yZ(this, {
    type: fF,
    target: vZ(e),
    // target
    index: 0,
    // next index
    kind: t
    // kind
  });
}, function() {
  var e = VZ(this), t = e.target, r = e.kind, n = e.index++;
  if (!t || n >= t.length)
    return e.target = void 0, gd(void 0, !0);
  switch (r) {
    case "keys":
      return gd(n, !1);
    case "values":
      return gd(t[n], !1);
  }
  return gd([n, t[n]], !1);
}, "values"), NA = OA.Arguments = OA.Array;
aV("keys");
aV("values");
aV("entries");
if (gZ && NA.name !== "values")
  try {
    hZ(NA, "name", { value: "values" });
  } catch {
  }
var IA = Xt, dF = jC, qZ = YC, Ff = lF, Fh = Wa, cF = lr, Kh = cF("iterator"), XA = cF("toStringTag"), Rh = Ff.values, pF = function(e, t) {
  if (e) {
    if (e[Kh] !== Rh)
      try {
        Fh(e, Kh, Rh);
      } catch {
        e[Kh] = Rh;
      }
    if (e[XA] || Fh(e, XA, t), dF[t]) {
      for (var r in Ff)
        if (e[r] !== Ff[r])
          try {
            Fh(e, r, Ff[r]);
          } catch {
            e[r] = Ff[r];
          }
    }
  }
};
for (var Th in dF)
  pF(IA[Th] && IA[Th].prototype, Th);
pF(qZ, "DOMTokenList");
var bZ = or, AZ = Rr, PA = Uu, sV = function(e, t, r) {
  var n, i;
  return (
    // it can work only with native `setPrototypeOf`
    PA && // we haven't completely correct pre-ES6 way for getting `new.target`, so use this
    bZ(n = t.constructor) && n !== r && AZ(i = n.prototype) && i !== r.prototype && PA(e, i), e
  );
}, wZ = Kt, kZ = wZ(1 .valueOf), WZ = `	
\v\f\r                　\u2028\u2029\uFEFF`, SZ = Kt, CZ = Hi, FZ = $r, Mm = WZ, BA = SZ("".replace), KZ = RegExp("^[" + Mm + "]+"), RZ = RegExp("(^|[^" + Mm + "])[" + Mm + "]+$"), Uh = function(e) {
  return function(t) {
    var r = FZ(CZ(t));
    return e & 1 && (r = BA(r, KZ, "")), e & 2 && (r = BA(r, RZ, "$1")), r;
  };
}, TZ = {
  // `String.prototype.{ trimLeft, trimStart }` methods
  // https://tc39.es/ecma262/#sec-string.prototype.trimstart
  start: Uh(1),
  // `String.prototype.{ trimRight, trimEnd }` methods
  // https://tc39.es/ecma262/#sec-string.prototype.trimend
  end: Uh(2),
  // `String.prototype.trim` method
  // https://tc39.es/ecma262/#sec-string.prototype.trim
  trim: Uh(3)
}, UZ = xt, vF = lS, xZ = Ar, hF = Xt, mF = PS, gF = Kt, EZ = vp, DA = Tr, OZ = sV, NZ = ka, IZ = Fu, yF = ky, XZ = St, PZ = ls.f, BZ = Qi.f, DZ = wn.f, LZ = kZ, ZZ = TZ.trim, Kp = "Number", jo = hF[Kp];
mF[Kp];
var oV = jo.prototype, MZ = hF.TypeError, jZ = gF("".slice), yd = gF("".charCodeAt), YZ = function(e) {
  var t = yF(e, "number");
  return typeof t == "bigint" ? t : zZ(t);
}, zZ = function(e) {
  var t = yF(e, "number"), r, n, i, a, s, o, u, f;
  if (IZ(t))
    throw MZ("Cannot convert a Symbol value to a number");
  if (typeof t == "string" && t.length > 2) {
    if (t = ZZ(t), r = yd(t, 0), r === 43 || r === 45) {
      if (n = yd(t, 2), n === 88 || n === 120)
        return NaN;
    } else if (r === 48) {
      switch (yd(t, 1)) {
        case 66:
        case 98:
          i = 2, a = 49;
          break;
        case 79:
        case 111:
          i = 8, a = 55;
          break;
        default:
          return +t;
      }
      for (s = jZ(t, 2), o = s.length, u = 0; u < o; u++)
        if (f = yd(s, u), f < 48 || f > a)
          return NaN;
      return parseInt(s, i);
    }
  }
  return +t;
}, uV = EZ(Kp, !jo(" 0o1") || !jo("0b1") || jo("+0x1")), GZ = function(e) {
  return NZ(oV, e) && XZ(function() {
    LZ(e);
  });
}, Rp = function(t) {
  var r = arguments.length < 1 ? 0 : jo(YZ(t));
  return GZ(this) ? OZ(Object(r), this, Rp) : r;
};
Rp.prototype = oV;
uV && !vF && (oV.constructor = Rp);
UZ({ global: !0, constructor: !0, wrap: !0, forced: uV }, {
  Number: Rp
});
var QZ = function(e, t) {
  for (var r = xZ ? PZ(t) : (
    // ES3:
    "MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,EPSILON,MAX_SAFE_INTEGER,MIN_SAFE_INTEGER,isFinite,isInteger,isNaN,isSafeInteger,parseFloat,parseInt,fromString,range".split(",")
  ), n = 0, i; r.length > n; n++)
    DA(t, i = r[n]) && !DA(e, i) && DZ(e, i, BZ(t, i));
};
(uV || vF) && QZ(mF[Kp], jo);
var JZ = Or, VF = function() {
  var e = JZ(this), t = "";
  return e.hasIndices && (t += "d"), e.global && (t += "g"), e.ignoreCase && (t += "i"), e.multiline && (t += "m"), e.dotAll && (t += "s"), e.unicode && (t += "u"), e.unicodeSets && (t += "v"), e.sticky && (t += "y"), t;
}, fV = St, HZ = Xt, lV = HZ.RegExp, dV = fV(function() {
  var e = lV("a", "y");
  return e.lastIndex = 2, e.exec("abcd") !== null;
}), _Z = dV || fV(function() {
  return !lV("a", "y").sticky;
}), $Z = dV || fV(function() {
  var e = lV("^r", "gy");
  return e.lastIndex = 2, e.exec("str") !== null;
}), qF = {
  BROKEN_CARET: $Z,
  MISSED_STICKY: _Z,
  UNSUPPORTED_Y: dV
}, eM = St, tM = Xt, rM = tM.RegExp, nM = eM(function() {
  var e = rM(".", "s");
  return !(e.dotAll && e.exec(`
`) && e.flags === "s");
}), iM = St, aM = Xt, sM = aM.RegExp, oM = iM(function() {
  var e = sM("(?<a>b)", "g");
  return e.exec("b").groups.a !== "b" || "b".replace(e, "$<a>c") !== "bc";
}), Xo = fr, Tp = Kt, uM = $r, fM = VF, lM = qF, dM = Ku, cM = cs, pM = jn.get, vM = nM, hM = oM, mM = dM("native-string-replace", String.prototype.replace), Rc = RegExp.prototype.exec, jm = Rc, gM = Tp("".charAt), yM = Tp("".indexOf), VM = Tp("".replace), xh = Tp("".slice), Ym = function() {
  var e = /a/, t = /b*/g;
  return Xo(Rc, e, "a"), Xo(Rc, t, "a"), e.lastIndex !== 0 || t.lastIndex !== 0;
}(), bF = lM.BROKEN_CARET, zm = /()??/.exec("")[1] !== void 0, qM = Ym || zm || bF || vM || hM;
qM && (jm = function(t) {
  var r = this, n = pM(r), i = uM(t), a = n.raw, s, o, u, f, l, d, c;
  if (a)
    return a.lastIndex = r.lastIndex, s = Xo(jm, a, i), r.lastIndex = a.lastIndex, s;
  var p = n.groups, v = bF && r.sticky, h = Xo(fM, r), m = r.source, q = 0, w = i;
  if (v && (h = VM(h, "y", ""), yM(h, "g") === -1 && (h += "g"), w = xh(i, r.lastIndex), r.lastIndex > 0 && (!r.multiline || r.multiline && gM(i, r.lastIndex - 1) !== `
`) && (m = "(?: " + m + ")", w = " " + w, q++), o = new RegExp("^(?:" + m + ")", h)), zm && (o = new RegExp("^" + m + "$(?!\\s)", h)), Ym && (u = r.lastIndex), f = Xo(Rc, v ? o : r, w), v ? f ? (f.input = xh(f.input, q), f[0] = xh(f[0], q), f.index = r.lastIndex, r.lastIndex += f[0].length) : r.lastIndex = 0 : Ym && f && (r.lastIndex = r.global ? f.index + f[0].length : u), zm && f && f.length > 1 && Xo(mM, f[0], o, function() {
    for (l = 1; l < arguments.length - 2; l++)
      arguments[l] === void 0 && (f[l] = void 0);
  }), f && p)
    for (f.groups = d = cM(null), l = 0; l < p.length; l++)
      c = p[l], d[c[0]] = f[c[1]];
  return f;
});
var Up = jm, bM = xt, LA = Up;
bM({ target: "RegExp", proto: !0, forced: /./.exec !== LA }, {
  exec: LA
});
var ZA = mp, MA = kn, AM = Up, jA = St, AF = lr, wM = Wa, kM = AF("species"), Eh = RegExp.prototype, xp = function(e, t, r, n) {
  var i = AF(e), a = !jA(function() {
    var f = {};
    return f[i] = function() {
      return 7;
    }, ""[e](f) !== 7;
  }), s = a && !jA(function() {
    var f = !1, l = /a/;
    return e === "split" && (l = {}, l.constructor = {}, l.constructor[kM] = function() {
      return l;
    }, l.flags = "", l[i] = /./[i]), l.exec = function() {
      return f = !0, null;
    }, l[i](""), !f;
  });
  if (!a || !s || r) {
    var o = ZA(/./[i]), u = t(i, ""[e], function(f, l, d, c, p) {
      var v = ZA(f), h = l.exec;
      return h === AM || h === Eh.exec ? a && !p ? { done: !0, value: o(l, d, c) } : { done: !0, value: v(d, l, c) } : { done: !1 };
    });
    MA(String.prototype, e, u[0]), MA(Eh, i, u[1]);
  }
  n && wM(Eh[i], "sham", !0);
}, WM = $y.charAt, cV = function(e, t, r) {
  return t + (r ? WM(e, t).length : 1);
}, pV = Kt, SM = hn, CM = Math.floor, Oh = pV("".charAt), FM = pV("".replace), Nh = pV("".slice), KM = /\$([$&'`]|\d{1,2}|<[^>]*>)/g, RM = /\$([$&'`]|\d{1,2})/g, TM = function(e, t, r, n, i, a) {
  var s = r + e.length, o = n.length, u = RM;
  return i !== void 0 && (i = SM(i), u = KM), FM(a, u, function(f, l) {
    var d;
    switch (Oh(l, 0)) {
      case "$":
        return "$";
      case "&":
        return e;
      case "`":
        return Nh(t, 0, r);
      case "'":
        return Nh(t, s);
      case "<":
        d = i[Nh(l, 1, -1)];
        break;
      default:
        var c = +l;
        if (c === 0)
          return f;
        if (c > o) {
          var p = CM(c / 10);
          return p === 0 ? f : p <= o ? n[p - 1] === void 0 ? Oh(l, 1) : n[p - 1] + Oh(l, 1) : f;
        }
        d = n[c - 1];
    }
    return d === void 0 ? "" : d;
  });
}, YA = fr, UM = Or, xM = or, EM = Ji, OM = Up, NM = TypeError, Ep = function(e, t) {
  var r = e.exec;
  if (xM(r)) {
    var n = YA(r, e, t);
    return n !== null && UM(n), n;
  }
  if (EM(e) === "RegExp")
    return YA(OM, e, t);
  throw NM("RegExp#exec called on incompatible receiver");
}, IM = ds, zA = fr, Op = Kt, XM = xp, PM = St, BM = Or, DM = or, LM = Ri, ZM = _i, MM = Sa, Vo = $r, jM = Hi, YM = cV, zM = $s, GM = TM, QM = Ep, JM = lr, Gm = JM("replace"), HM = Math.max, _M = Math.min, $M = Op([].concat), Ih = Op([].push), GA = Op("".indexOf), QA = Op("".slice), ej = function(e) {
  return e === void 0 ? e : String(e);
}, tj = function() {
  return "a".replace(/./, "$0") === "$0";
}(), JA = function() {
  return /./[Gm] ? /./[Gm]("a", "$0") === "" : !1;
}(), rj = !PM(function() {
  var e = /./;
  return e.exec = function() {
    var t = [];
    return t.groups = { a: "7" }, t;
  }, "".replace(e, "$<a>") !== "7";
});
XM("replace", function(e, t, r) {
  var n = JA ? "$" : "$0";
  return [
    // `String.prototype.replace` method
    // https://tc39.es/ecma262/#sec-string.prototype.replace
    function(a, s) {
      var o = jM(this), u = LM(a) ? void 0 : zM(a, Gm);
      return u ? zA(u, a, o, s) : zA(t, Vo(o), a, s);
    },
    // `RegExp.prototype[@@replace]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@replace
    function(i, a) {
      var s = BM(this), o = Vo(i);
      if (typeof a == "string" && GA(a, n) === -1 && GA(a, "$<") === -1) {
        var u = r(t, s, o, a);
        if (u.done)
          return u.value;
      }
      var f = DM(a);
      f || (a = Vo(a));
      var l = s.global, d;
      l && (d = s.unicode, s.lastIndex = 0);
      for (var c = [], p; p = QM(s, o), !(p === null || (Ih(c, p), !l)); ) {
        var v = Vo(p[0]);
        v === "" && (s.lastIndex = YM(o, MM(s.lastIndex), d));
      }
      for (var h = "", m = 0, q = 0; q < c.length; q++) {
        p = c[q];
        for (var w = Vo(p[0]), O = HM(_M(ZM(p.index), o.length), 0), C = [], R, I = 1; I < p.length; I++)
          Ih(C, ej(p[I]));
        var P = p.groups;
        if (f) {
          var K = $M([w], C, O, o);
          P !== void 0 && Ih(K, P), R = Vo(IM(a, void 0, K));
        } else
          R = GM(w, o, O, C, P, a);
        O >= m && (h += QA(o, m, O) + R, m = O + w.length);
      }
      return h + QA(o, m);
    }
  ];
}, !rj || !tj || JA);
var nj = xt, ij = Kt, aj = ml, sj = Mn, oj = Fp, uj = ij([].join), fj = aj !== Object, lj = fj || !oj("join", ",");
nj({ target: "Array", proto: !0, forced: lj }, {
  join: function(t) {
    return uj(sj(this), t === void 0 ? "," : t);
  }
});
var rn = {}, dj = xt, HA = Wl, cj = hp, pj = Rr, _A = eo, vj = on, hj = Mn, mj = Tu, gj = lr, yj = Fl, Vj = Ru, qj = yj("slice"), bj = gj("species"), Xh = Array, Aj = Math.max;
dj({ target: "Array", proto: !0, forced: !qj }, {
  slice: function(t, r) {
    var n = hj(this), i = vj(n), a = _A(t, i), s = _A(r === void 0 ? i : r, i), o, u, f;
    if (HA(n) && (o = n.constructor, cj(o) && (o === Xh || HA(o.prototype)) ? o = void 0 : pj(o) && (o = o[bj], o === null && (o = void 0)), o === Xh || o === void 0))
      return Vj(n, a, s);
    for (u = new (o === void 0 ? Xh : o)(Aj(s - a, 0)), f = 0; a < s; a++, f++)
      a in n && mj(u, f, n[a]);
    return u.length = f, u;
  }
});
var wj = xt, $A = fr, kj = or, ew = Or, Wj = $r, Sj = function() {
  var e = !1, t = /[ac]/;
  return t.exec = function() {
    return e = !0, /./.exec.apply(this, arguments);
  }, t.test("abc") === !0 && e;
}(), Cj = /./.test;
wj({ target: "RegExp", proto: !0, forced: !Sj }, {
  test: function(e) {
    var t = ew(this), r = Wj(e), n = t.exec;
    if (!kj(n))
      return $A(Cj, t, r);
    var i = $A(n, t, r);
    return i === null ? !1 : (ew(i), !0);
  }
});
var Fj = xt, Kj = Ar, Rj = Xt, Vd = Kt, Tj = Tr, Uj = or, xj = ka, Ej = $r, Oj = $i, Nj = bS, ua = Rj.Symbol, Ws = ua && ua.prototype;
if (Kj && Uj(ua) && (!("description" in Ws) || // Safari 12 bug
ua().description !== void 0)) {
  var tw = {}, qd = function() {
    var t = arguments.length < 1 || arguments[0] === void 0 ? void 0 : Ej(arguments[0]), r = xj(Ws, this) ? new ua(t) : t === void 0 ? ua() : ua(t);
    return t === "" && (tw[r] = !0), r;
  };
  Nj(qd, ua), qd.prototype = Ws, Ws.constructor = qd;
  var Ij = String(ua("description detection")) === "Symbol(description detection)", Xj = Vd(Ws.valueOf), Pj = Vd(Ws.toString), Bj = /^Symbol\((.*)\)[^)]+$/, Dj = Vd("".replace), Lj = Vd("".slice);
  Oj(Ws, "description", {
    configurable: !0,
    get: function() {
      var t = Xj(this);
      if (Tj(tw, t))
        return "";
      var r = Pj(t), n = Ij ? Lj(r, 7, -1) : Dj(r, Bj, "$1");
      return n === "" ? void 0 : n;
    }
  }), Fj({ global: !0, constructor: !0, forced: !0 }, {
    Symbol: qd
  });
}
var Zj = BS;
Zj("iterator");
var Mj = Ar, jj = Vl.EXISTS, wF = Kt, Yj = $i, kF = Function.prototype, zj = wF(kF.toString), WF = /function\b(?:\s|\/\*[\S\s]*?\*\/|\/\/[^\n\r]*[\n\r]+)*([^\s(/]*)/, Gj = wF(WF.exec), Qj = "name";
Mj && !jj && Yj(kF, Qj, {
  configurable: !0,
  get: function() {
    try {
      return Gj(WF, zj(this))[1];
    } catch {
      return "";
    }
  }
});
var SF = { exports: {} }, CF = { exports: {} };
(function(e) {
  function t(r) {
    if (Array.isArray(r))
      return r;
  }
  e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
})(CF);
var Jj = CF.exports, FF = { exports: {} };
(function(e) {
  function t(r, n) {
    var i = r == null ? null : typeof Symbol < "u" && r[Symbol.iterator] || r["@@iterator"];
    if (i != null) {
      var a, s, o, u, f = [], l = !0, d = !1;
      try {
        if (o = (i = i.call(r)).next, n === 0) {
          if (Object(i) !== i)
            return;
          l = !1;
        } else
          for (; !(l = (a = o.call(i)).done) && (f.push(a.value), f.length !== n); l = !0)
            ;
      } catch (c) {
        d = !0, s = c;
      } finally {
        try {
          if (!l && i.return != null && (u = i.return(), Object(u) !== u))
            return;
        } finally {
          if (d)
            throw s;
        }
      }
      return f;
    }
  }
  e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
})(FF);
var Hj = FF.exports, KF = { exports: {} }, RF = { exports: {} };
(function(e) {
  function t(r, n) {
    (n == null || n > r.length) && (n = r.length);
    for (var i = 0, a = new Array(n); i < n; i++)
      a[i] = r[i];
    return a;
  }
  e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
})(RF);
var TF = RF.exports;
(function(e) {
  var t = TF;
  function r(n, i) {
    if (n) {
      if (typeof n == "string")
        return t(n, i);
      var a = Object.prototype.toString.call(n).slice(8, -1);
      if (a === "Object" && n.constructor && (a = n.constructor.name), a === "Map" || a === "Set")
        return Array.from(n);
      if (a === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(a))
        return t(n, i);
    }
  }
  e.exports = r, e.exports.__esModule = !0, e.exports.default = e.exports;
})(KF);
var UF = KF.exports, xF = { exports: {} };
(function(e) {
  function t() {
    throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
})(xF);
var _j = xF.exports;
(function(e) {
  var t = Jj, r = Hj, n = UF, i = _j;
  function a(s, o) {
    return t(s) || r(s, o) || n(s, o) || i();
  }
  e.exports = a, e.exports.__esModule = !0, e.exports.default = e.exports;
})(SF);
var Eu = SF.exports, EF = { exports: {} }, OF = { exports: {} };
(function(e) {
  var t = TF;
  function r(n) {
    if (Array.isArray(n))
      return t(n);
  }
  e.exports = r, e.exports.__esModule = !0, e.exports.default = e.exports;
})(OF);
var $j = OF.exports, NF = { exports: {} };
(function(e) {
  function t(r) {
    if (typeof Symbol < "u" && r[Symbol.iterator] != null || r["@@iterator"] != null)
      return Array.from(r);
  }
  e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
})(NF);
var eY = NF.exports, IF = { exports: {} };
(function(e) {
  function t() {
    throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
})(IF);
var tY = IF.exports;
(function(e) {
  var t = $j, r = eY, n = UF, i = tY;
  function a(s) {
    return t(s) || r(s) || n(s) || i();
  }
  e.exports = a, e.exports.__esModule = !0, e.exports.default = e.exports;
})(EF);
var Ou = EF.exports, rY = xt, nY = pp.includes, iY = St, aY = iV, sY = iY(function() {
  return !Array(1).includes();
});
rY({ target: "Array", proto: !0, forced: sY }, {
  includes: function(t) {
    return nY(this, t, arguments.length > 1 ? arguments[1] : void 0);
  }
});
aY("includes");
var oY = Rr, uY = Math.floor, XF = Number.isInteger || function(t) {
  return !oY(t) && isFinite(t) && uY(t) === t;
}, fY = xt, lY = XF;
fY({ target: "Number", stat: !0 }, {
  isInteger: lY
});
var PF = Ar, dY = St, BF = Kt, cY = Ol, pY = wl, vY = Mn, hY = hl.f, DF = BF(hY), mY = BF([].push), gY = PF && dY(function() {
  var e = /* @__PURE__ */ Object.create(null);
  return e[2] = 2, !DF(e, 2);
}), rw = function(e) {
  return function(t) {
    for (var r = vY(t), n = pY(r), i = gY && cY(r) === null, a = n.length, s = 0, o = [], u; a > s; )
      u = n[s++], (!PF || (i ? u in r : DF(r, u))) && mY(o, e ? [u, r[u]] : r[u]);
    return o;
  };
}, yY = {
  // `Object.entries` method
  // https://tc39.es/ecma262/#sec-object.entries
  entries: rw(!0),
  // `Object.values` method
  // https://tc39.es/ecma262/#sec-object.values
  values: rw(!1)
}, VY = xt, qY = yY.entries;
VY({ target: "Object", stat: !0 }, {
  entries: function(t) {
    return qY(t);
  }
});
/*
@license
Copyright (c) 2021 Twilio Inc.

Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.


*/
Object.defineProperty(rn, "__esModule", { value: !0 });
var bY = di, AY = Eu, wY = Ou, kY = ps, WY = ra, SY = ea, CY = ta, FY = ci;
function hs(e) {
  return e && typeof e == "object" && "default" in e ? e : { default: e };
}
var Yo = /* @__PURE__ */ hs(bY), ya = /* @__PURE__ */ hs(AY), Ph = /* @__PURE__ */ hs(wY), KY = /* @__PURE__ */ hs(kY), RY = /* @__PURE__ */ hs(WY), TY = /* @__PURE__ */ hs(SY), UY = /* @__PURE__ */ hs(CY), nw = /* @__PURE__ */ hs(FY), Ra = function() {
  for (var t = arguments.length, r = new Array(t), n = 0; n < t; n++)
    r[n] = arguments[n];
  return {
    checks: r
  };
};
function xY(e, t) {
  var r = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (!r) {
    if (Array.isArray(e) || (r = EY(e)) || t && e && typeof e.length == "number") {
      r && (e = r);
      var n = 0, i = function() {
      };
      return { s: i, n: function() {
        return n >= e.length ? { done: !0 } : { done: !1, value: e[n++] };
      }, e: function(f) {
        throw f;
      }, f: i };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  var a = !0, s = !1, o;
  return { s: function() {
    r = r.call(e);
  }, n: function() {
    var f = r.next();
    return a = f.done, f;
  }, e: function(f) {
    s = !0, o = f;
  }, f: function() {
    try {
      !a && r.return != null && r.return();
    } finally {
      if (s)
        throw o;
    }
  } };
}
function EY(e, t) {
  if (e) {
    if (typeof e == "string")
      return iw(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set")
      return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return iw(e, t);
  }
}
function iw(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
var LF = function() {
  for (var t = arguments.length, r = new Array(t), n = 0; n < t; n++)
    r[n] = arguments[n];
  return Ra(function(i) {
    var a = !1, s = [], o = xY(r), u;
    try {
      for (o.s(); !(u = o.n()).done; ) {
        var f = u.value;
        if (typeof f == "string") {
          a = a || Yo.default(i) === f, s.push("of type ".concat(f));
          continue;
        }
        a = a || i instanceof f, s.push("an instance of ".concat(f.name));
      }
    } catch (l) {
      o.e(l);
    } finally {
      o.f();
    }
    return [a, s];
  });
};
function OY(e, t) {
  var r = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (!r) {
    if (Array.isArray(e) || (r = NY(e)) || t && e && typeof e.length == "number") {
      r && (e = r);
      var n = 0, i = function() {
      };
      return { s: i, n: function() {
        return n >= e.length ? { done: !0 } : { done: !1, value: e[n++] };
      }, e: function(f) {
        throw f;
      }, f: i };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  var a = !0, s = !1, o;
  return { s: function() {
    r = r.call(e);
  }, n: function() {
    var f = r.next();
    return a = f.done, f;
  }, e: function(f) {
    s = !0, o = f;
  }, f: function() {
    try {
      !a && r.return != null && r.return();
    } finally {
      if (s)
        throw o;
    }
  } };
}
function NY(e, t) {
  if (e) {
    if (typeof e == "string")
      return aw(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set")
      return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return aw(e, t);
  }
}
function aw(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
var IY = function() {
  for (var t = arguments.length, r = new Array(t), n = 0; n < t; n++)
    r[n] = arguments[n];
  return Ra(function(i) {
    var a = !1, s = [], o = OY(r), u;
    try {
      for (o.s(); !(u = o.n()).done; ) {
        var f = u.value;
        a = a || i === f, s.push(typeof f == "string" ? '"'.concat(f, '"') : "".concat(f));
      }
    } catch (l) {
      o.e(l);
    } finally {
      o.f();
    }
    return [a, s];
  });
};
function XY(e) {
  var t = PY();
  return function() {
    var n = nw.default(e), i;
    if (t) {
      var a = nw.default(this).constructor;
      i = Reflect.construct(n, arguments, a);
    } else
      i = n.apply(this, arguments);
    return UY.default(this, i);
  };
}
function PY() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function $f(e, t) {
  var r = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (!r) {
    if (Array.isArray(e) || (r = BY(e)) || t && e && typeof e.length == "number") {
      r && (e = r);
      var n = 0, i = function() {
      };
      return { s: i, n: function() {
        return n >= e.length ? { done: !0 } : { done: !1, value: e[n++] };
      }, e: function(f) {
        throw f;
      }, f: i };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  var a = !0, s = !1, o;
  return { s: function() {
    r = r.call(e);
  }, n: function() {
    var f = r.next();
    return a = f.done, f;
  }, e: function(f) {
    s = !0, o = f;
  }, f: function() {
    try {
      !a && r.return != null && r.return();
    } finally {
      if (s)
        throw o;
    }
  } };
}
function BY(e, t) {
  if (e) {
    if (typeof e == "string")
      return sw(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set")
      return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return sw(e, t);
  }
}
function sw(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
var Np = function(t, r) {
  if (r.length > t.length)
    throw new Error("Expected at most ".concat(t.length, " argument(s), but got ").concat(r.length));
  for (; r.length < t.length; )
    r.push(void 0);
  var n = $f(r.entries()), i;
  try {
    for (n.s(); !(i = n.n()).done; ) {
      var a = ya.default(i.value, 2), s = a[0], o = a[1], u = Xp(t[s], o), f = ya.default(u, 4), l = f[0], d = f[1], c = f[2], p = f[3];
      if (!l) {
        var v = s + 1;
        throw new Error("Argument ".concat(v, " is expected to be ").concat(c).concat(p, " but got ").concat(d));
      }
    }
  } catch (h) {
    n.e(h);
  } finally {
    n.f();
  }
}, ZF = function(t) {
  var r, n, i = ["undefined", "boolean", "number", "bigint", "string"];
  if (i.includes(Yo.default(t)) && (n = typeof t == "string" ? '"'.concat(t, '"') : "".concat(t)), Yo.default(t) === "object" && (t == null || (r = t.constructor) === null || r === void 0 ? void 0 : r.name) !== "Object") {
    var a;
    n = t === null ? "null" : "instance of ".concat(t == null || (a = t.constructor) === null || a === void 0 ? void 0 : a.name);
  }
  return n || (n = Yo.default(t)), n;
}, DY = function() {
  for (var t = arguments.length, r = new Array(t), n = 0; n < t; n++)
    r[n] = arguments[n];
  var i = vV(r);
  return function(a) {
    return /* @__PURE__ */ function(s) {
      TY.default(u, s);
      var o = XY(u);
      function u() {
        RY.default(this, u);
        for (var f = arguments.length, l = new Array(f), d = 0; d < f; d++)
          l[d] = arguments[d];
        return Np(i, l), o.call.apply(o, [this].concat(l));
      }
      return KY.default(u);
    }(a);
  };
}, LY = function() {
  for (var t = arguments.length, r = new Array(t), n = 0; n < t; n++)
    r[n] = arguments[n];
  var i = vV(r);
  return function(a, s, o) {
    if (typeof o.value != "function")
      throw new Error("The validateTypes decorator can only be applied to methods");
    var u = o.value;
    o.value = function() {
      for (var f = arguments.length, l = new Array(f), d = 0; d < f; d++)
        l[d] = arguments[d];
      return Np(i, l), u.apply(this, l);
    };
  };
}, ZY = function() {
  for (var t = arguments.length, r = new Array(t), n = 0; n < t; n++)
    r[n] = arguments[n];
  var i = vV(r);
  return function(a, s, o) {
    if (typeof o.value != "function")
      throw new Error("The validateTypesAsync decorator can only be applied to methods");
    var u = o.value;
    o.value = function() {
      for (var f = arguments.length, l = new Array(f), d = 0; d < f; d++)
        l[d] = arguments[d];
      try {
        Np(i, l);
      } catch (c) {
        return Promise.reject(c);
      }
      return u.apply(this, l);
    };
  };
}, vV = function(t) {
  var r = [], n = $f(t), i;
  try {
    for (n.s(); !(i = n.n()).done; ) {
      var a = i.value;
      r.push(Ip(a));
    }
  } catch (s) {
    n.e(s);
  } finally {
    n.f();
  }
  return r;
}, Ip = function(t) {
  var r = [], n = Array.isArray(t) ? t : [t], i = $f(n), a;
  try {
    for (i.s(); !(a = i.n()).done; ) {
      var s = a.value;
      if (typeof s == "string" || typeof s == "function") {
        r.push(LF(s));
        continue;
      }
      r.push(s);
    }
  } catch (o) {
    i.e(o);
  } finally {
    i.f();
  }
  return r;
}, Xp = function(t, r) {
  var n = [], i, a = !1, s = $f(t), o;
  try {
    for (s.s(); !(o = s.n()).done; ) {
      var u = o.value, f = $f(u.checks), l;
      try {
        for (f.s(); !(l = f.n()).done; ) {
          var d = l.value, c = d(r), p = ya.default(c, 3), v = p[0], h = p[1], m = p[2];
          a = a || v, !i && m && (i = m), h && (n = typeof h == "string" ? [].concat(Ph.default(n), [h]) : [].concat(Ph.default(n), Ph.default(h)));
        }
      } catch (C) {
        f.e(C);
      } finally {
        f.f();
      }
    }
  } catch (C) {
    s.e(C);
  } finally {
    s.f();
  }
  if (a)
    return [!0];
  var q = i || ZF(r), w = n.length - 1, O = w > 0 ? "".concat(n.slice(0, w).join(", "), " or ").concat(n[w]) : n.join(", ");
  return [!1, q, O, w > 1 ? ";" : ","];
};
function MY(e, t) {
  var r = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (!r) {
    if (Array.isArray(e) || (r = jY(e)) || t && e && typeof e.length == "number") {
      r && (e = r);
      var n = 0, i = function() {
      };
      return { s: i, n: function() {
        return n >= e.length ? { done: !0 } : { done: !1, value: e[n++] };
      }, e: function(f) {
        throw f;
      }, f: i };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  var a = !0, s = !1, o;
  return { s: function() {
    r = r.call(e);
  }, n: function() {
    var f = r.next();
    return a = f.done, f;
  }, e: function(f) {
    s = !0, o = f;
  }, f: function() {
    try {
      !a && r.return != null && r.return();
    } finally {
      if (s)
        throw o;
    }
  } };
}
function jY(e, t) {
  if (e) {
    if (typeof e == "string")
      return ow(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set")
      return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return ow(e, t);
  }
}
function ow(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
var YY = function(t, r) {
  return Ra(function(n) {
    if (!Array.isArray(n) || n.length < 1)
      return [!1, "a non-empty array of ".concat(t)];
    var i = MY(n.entries()), a;
    try {
      for (i.s(); !(a = i.n()).done; ) {
        var s = ya.default(a.value, 2), o = s[0], u = s[1], f = Xp(Ip(r), u), l = ya.default(f, 3), d = l[0], c = l[1], p = l[2];
        if (!d)
          return [!1, "a valid non-empty array of ".concat(t, " (index ").concat(o, " should be ").concat(p, ")"), "malformed array of ".concat(t, " (index ").concat(o, " is ").concat(c, ")")];
      }
    } catch (v) {
      i.e(v);
    } finally {
      i.f();
    }
    return [!0];
  });
}, zY = Ra(function(e) {
  return [typeof e == "string" && e.length > 0, "a non-empty string"];
}), GY = Ra(function(e) {
  return [typeof e == "number" && Number.isInteger(e) && e >= 0, "a non-negative integer"];
}), QY = Ra(function(e) {
  return [Yo.default(e) === "object" && e !== null && !Array.isArray(e), "a pure object (non-null and non-array)"];
}), JY = function(t, r) {
  return Ra(function(n) {
    if (Yo.default(n) !== "object" || n === null || Array.isArray(n))
      return [!1, "valid ".concat(t, " (should be a pure object)")];
    for (var i = 0, a = Object.entries(r); i < a.length; i++) {
      var s = ya.default(a[i], 2), o = s[0], u = s[1], f = Xp(Ip(u), n[o]), l = ya.default(f, 3), d = l[0], c = l[1], p = l[2];
      if (!d)
        return [!1, "valid ".concat(t, ' (key "').concat(o, '" should be ').concat(p, ")"), "malformed ".concat(t, ' (key "').concat(o, '" is ').concat(c, ")")];
    }
    return [!0];
  });
};
function HY(e, t) {
  var r = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (!r) {
    if (Array.isArray(e) || (r = _Y(e)) || t && e && typeof e.length == "number") {
      r && (e = r);
      var n = 0, i = function() {
      };
      return { s: i, n: function() {
        return n >= e.length ? { done: !0 } : { done: !1, value: e[n++] };
      }, e: function(f) {
        throw f;
      }, f: i };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  var a = !0, s = !1, o;
  return { s: function() {
    r = r.call(e);
  }, n: function() {
    var f = r.next();
    return a = f.done, f;
  }, e: function(f) {
    s = !0, o = f;
  }, f: function() {
    try {
      !a && r.return != null && r.return();
    } finally {
      if (s)
        throw o;
    }
  } };
}
function _Y(e, t) {
  if (e) {
    if (typeof e == "string")
      return uw(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set")
      return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return uw(e, t);
  }
}
function uw(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
var $Y = function(t, r) {
  return Ra(function(n) {
    if (!Array.isArray(n))
      return [!1, "an array of ".concat(t)];
    var i = HY(n.entries()), a;
    try {
      for (i.s(); !(a = i.n()).done; ) {
        var s = ya.default(a.value, 2), o = s[0], u = s[1], f = Xp(Ip(r), u), l = ya.default(f, 3), d = l[0], c = l[1], p = l[2];
        if (!d)
          return [!1, "a valid array of ".concat(t, " (index ").concat(o, " should be ").concat(p, ")"), "malformed array of ".concat(t, " (index ").concat(o, " is ").concat(c, ")")];
      }
    } catch (v) {
      i.e(v);
    } finally {
      i.f();
    }
    return [!0];
  });
};
rn.array = $Y;
rn.custom = Ra;
rn.literal = IY;
rn.nonEmptyArray = YY;
rn.nonEmptyString = zY;
rn.nonNegativeInteger = GY;
rn.objectSchema = JY;
rn.pureObject = QY;
rn.runtimeTypeValidation = Np;
rn.stringifyReceivedType = ZF;
rn.type = LF;
rn.validateConstructorTypes = DY;
rn.validateTypes = LY;
rn.validateTypesAsync = ZY;
var hV = {}, MF = { exports: {} }, jF = { exports: {} };
(function(e) {
  var t = ci;
  function r(n, i) {
    for (; !Object.prototype.hasOwnProperty.call(n, i) && (n = t(n), n !== null); )
      ;
    return n;
  }
  e.exports = r, e.exports.__esModule = !0, e.exports.default = e.exports;
})(jF);
var ez = jF.exports;
(function(e) {
  var t = ez;
  function r() {
    return typeof Reflect < "u" && Reflect.get ? (e.exports = r = Reflect.get.bind(), e.exports.__esModule = !0, e.exports.default = e.exports) : (e.exports = r = function(i, a, s) {
      var o = t(i, a);
      if (o) {
        var u = Object.getOwnPropertyDescriptor(o, a);
        return u.get ? u.get.call(arguments.length < 3 ? i : s) : u.value;
      }
    }, e.exports.__esModule = !0, e.exports.default = e.exports), r.apply(this, arguments);
  }
  e.exports = r, e.exports.__esModule = !0, e.exports.default = e.exports;
})(MF);
var mV = MF.exports;
/*
@license
Copyright (c) 2021 Twilio Inc.

Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

*/
Object.defineProperty(hV, "__esModule", { value: !0 });
var tz = Ou, rz = ra, nz = ps, iz = to, az = mV, sz = ea, oz = ta, uz = ci, fz = ro;
function Ta(e) {
  return e && typeof e == "object" && "default" in e ? e : { default: e };
}
var fw = /* @__PURE__ */ Ta(tz), lz = /* @__PURE__ */ Ta(rz), dz = /* @__PURE__ */ Ta(nz), cz = /* @__PURE__ */ Ta(iz), Ss = /* @__PURE__ */ Ta(az), pz = /* @__PURE__ */ Ta(sz), vz = /* @__PURE__ */ Ta(oz), fa = /* @__PURE__ */ Ta(uz), hz = /* @__PURE__ */ Ta(fz), mz;
function $a() {
}
$a.prototype = /* @__PURE__ */ Object.create(null);
function cr() {
  cr.init.call(this);
}
cr.EventEmitter = cr;
cr.usingDomains = !1;
cr.prototype.domain = void 0;
cr.prototype._events = void 0;
cr.prototype._maxListeners = void 0;
cr.defaultMaxListeners = 10;
cr.init = function() {
  this.domain = null, cr.usingDomains && mz.active, (!this._events || this._events === Object.getPrototypeOf(this)._events) && (this._events = new $a(), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
};
cr.prototype.setMaxListeners = function(t) {
  if (typeof t != "number" || t < 0 || isNaN(t))
    throw new TypeError('"n" argument must be a positive number');
  return this._maxListeners = t, this;
};
function YF(e) {
  return e._maxListeners === void 0 ? cr.defaultMaxListeners : e._maxListeners;
}
cr.prototype.getMaxListeners = function() {
  return YF(this);
};
function gz(e, t, r) {
  if (t)
    e.call(r);
  else
    for (var n = e.length, i = Il(e, n), a = 0; a < n; ++a)
      i[a].call(r);
}
function yz(e, t, r, n) {
  if (t)
    e.call(r, n);
  else
    for (var i = e.length, a = Il(e, i), s = 0; s < i; ++s)
      a[s].call(r, n);
}
function Vz(e, t, r, n, i) {
  if (t)
    e.call(r, n, i);
  else
    for (var a = e.length, s = Il(e, a), o = 0; o < a; ++o)
      s[o].call(r, n, i);
}
function qz(e, t, r, n, i, a) {
  if (t)
    e.call(r, n, i, a);
  else
    for (var s = e.length, o = Il(e, s), u = 0; u < s; ++u)
      o[u].call(r, n, i, a);
}
function bz(e, t, r, n) {
  if (t)
    e.apply(r, n);
  else
    for (var i = e.length, a = Il(e, i), s = 0; s < i; ++s)
      a[s].apply(r, n);
}
cr.prototype.emit = function(t) {
  var r, n, i, a, s, o, u, f = t === "error";
  if (o = this._events, o)
    f = f && o.error == null;
  else if (!f)
    return !1;
  if (u = this.domain, f) {
    if (r = arguments[1], u)
      r || (r = new Error('Uncaught, unspecified "error" event')), r.domainEmitter = this, r.domain = u, r.domainThrown = !1, u.emit("error", r);
    else {
      if (r instanceof Error)
        throw r;
      var l = new Error('Uncaught, unspecified "error" event. (' + r + ")");
      throw l.context = r, l;
    }
    return !1;
  }
  if (n = o[t], !n)
    return !1;
  var d = typeof n == "function";
  switch (i = arguments.length, i) {
    case 1:
      gz(n, d, this);
      break;
    case 2:
      yz(n, d, this, arguments[1]);
      break;
    case 3:
      Vz(n, d, this, arguments[1], arguments[2]);
      break;
    case 4:
      qz(n, d, this, arguments[1], arguments[2], arguments[3]);
      break;
    default:
      for (a = new Array(i - 1), s = 1; s < i; s++)
        a[s - 1] = arguments[s];
      bz(n, d, this, a);
  }
  return !0;
};
function zF(e, t, r, n) {
  var i, a, s;
  if (typeof r != "function")
    throw new TypeError('"listener" argument must be a function');
  if (a = e._events, a ? (a.newListener && (e.emit(
    "newListener",
    t,
    r.listener ? r.listener : r
  ), a = e._events), s = a[t]) : (a = e._events = new $a(), e._eventsCount = 0), !s)
    s = a[t] = r, ++e._eventsCount;
  else if (typeof s == "function" ? s = a[t] = n ? [r, s] : [s, r] : n ? s.unshift(r) : s.push(r), !s.warned && (i = YF(e), i && i > 0 && s.length > i)) {
    s.warned = !0;
    var o = new Error("Possible EventEmitter memory leak detected. " + s.length + " " + t + " listeners added. Use emitter.setMaxListeners() to increase limit");
    o.name = "MaxListenersExceededWarning", o.emitter = e, o.type = t, o.count = s.length, Az(o);
  }
  return e;
}
function Az(e) {
  typeof console.warn == "function" ? console.warn(e) : console.log(e);
}
cr.prototype.addListener = function(t, r) {
  return zF(this, t, r, !1);
};
cr.prototype.on = cr.prototype.addListener;
cr.prototype.prependListener = function(t, r) {
  return zF(this, t, r, !0);
};
function GF(e, t, r) {
  var n = !1;
  function i() {
    e.removeListener(t, i), n || (n = !0, r.apply(e, arguments));
  }
  return i.listener = r, i;
}
cr.prototype.once = function(t, r) {
  if (typeof r != "function")
    throw new TypeError('"listener" argument must be a function');
  return this.on(t, GF(this, t, r)), this;
};
cr.prototype.prependOnceListener = function(t, r) {
  if (typeof r != "function")
    throw new TypeError('"listener" argument must be a function');
  return this.prependListener(t, GF(this, t, r)), this;
};
cr.prototype.removeListener = function(t, r) {
  var n, i, a, s, o;
  if (typeof r != "function")
    throw new TypeError('"listener" argument must be a function');
  if (i = this._events, !i)
    return this;
  if (n = i[t], !n)
    return this;
  if (n === r || n.listener && n.listener === r)
    --this._eventsCount === 0 ? this._events = new $a() : (delete i[t], i.removeListener && this.emit("removeListener", t, n.listener || r));
  else if (typeof n != "function") {
    for (a = -1, s = n.length; s-- > 0; )
      if (n[s] === r || n[s].listener && n[s].listener === r) {
        o = n[s].listener, a = s;
        break;
      }
    if (a < 0)
      return this;
    if (n.length === 1) {
      if (n[0] = void 0, --this._eventsCount === 0)
        return this._events = new $a(), this;
      delete i[t];
    } else
      wz(n, a);
    i.removeListener && this.emit("removeListener", t, o || r);
  }
  return this;
};
cr.prototype.off = function(e, t) {
  return this.removeListener(e, t);
};
cr.prototype.removeAllListeners = function(t) {
  var r, n;
  if (n = this._events, !n)
    return this;
  if (!n.removeListener)
    return arguments.length === 0 ? (this._events = new $a(), this._eventsCount = 0) : n[t] && (--this._eventsCount === 0 ? this._events = new $a() : delete n[t]), this;
  if (arguments.length === 0) {
    for (var i = Object.keys(n), a = 0, s; a < i.length; ++a)
      s = i[a], s !== "removeListener" && this.removeAllListeners(s);
    return this.removeAllListeners("removeListener"), this._events = new $a(), this._eventsCount = 0, this;
  }
  if (r = n[t], typeof r == "function")
    this.removeListener(t, r);
  else if (r)
    do
      this.removeListener(t, r[r.length - 1]);
    while (r[0]);
  return this;
};
cr.prototype.listeners = function(t) {
  var r, n, i = this._events;
  return i ? (r = i[t], r ? typeof r == "function" ? n = [r.listener || r] : n = kz(r) : n = []) : n = [], n;
};
cr.listenerCount = function(e, t) {
  return typeof e.listenerCount == "function" ? e.listenerCount(t) : QF.call(e, t);
};
cr.prototype.listenerCount = QF;
function QF(e) {
  var t = this._events;
  if (t) {
    var r = t[e];
    if (typeof r == "function")
      return 1;
    if (r)
      return r.length;
  }
  return 0;
}
cr.prototype.eventNames = function() {
  return this._eventsCount > 0 ? Reflect.ownKeys(this._events) : [];
};
function wz(e, t) {
  for (var r = t, n = r + 1, i = e.length; n < i; r += 1, n += 1)
    e[r] = e[n];
  e.pop();
}
function Il(e, t) {
  for (var r = new Array(t); t--; )
    r[t] = e[t];
  return r;
}
function kz(e) {
  for (var t = new Array(e.length), r = 0; r < t.length; ++r)
    t[r] = e[r].listener || e[r];
  return t;
}
function Wz(e) {
  var t = Sz();
  return function() {
    var n = fa.default(e), i;
    if (t) {
      var a = fa.default(this).constructor;
      i = Reflect.construct(n, arguments, a);
    } else
      i = n.apply(this, arguments);
    return vz.default(this, i);
  };
}
function Sz() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
var Cz = /* @__PURE__ */ function(e) {
  pz.default(r, e);
  var t = Wz(r);
  function r() {
    var n;
    return lz.default(this, r), n = t.call(this), hz.default(cz.default(n), "eventHistory", /* @__PURE__ */ new Map()), n;
  }
  return dz.default(r, [{
    key: "on",
    value: function(i, a) {
      return Ss.default(fa.default(r.prototype), "on", this).call(this, i, a);
    }
  }, {
    key: "once",
    value: function(i, a) {
      return Ss.default(fa.default(r.prototype), "once", this).call(this, i, a);
    }
  }, {
    key: "off",
    value: function(i, a) {
      return Ss.default(fa.default(r.prototype), "off", this).call(this, i, a);
    }
  }, {
    key: "emit",
    value: function(i) {
      for (var a, s = arguments.length, o = new Array(s > 1 ? s - 1 : 0), u = 1; u < s; u++)
        o[u - 1] = arguments[u];
      return this.eventHistory.set(i, o), (a = Ss.default(fa.default(r.prototype), "emit", this)).call.apply(a, [this, i].concat(o));
    }
  }, {
    key: "addListener",
    value: function(i, a) {
      return Ss.default(fa.default(r.prototype), "addListener", this).call(this, i, a);
    }
  }, {
    key: "removeListener",
    value: function(i, a) {
      return Ss.default(fa.default(r.prototype), "removeListener", this).call(this, i, a);
    }
  }, {
    key: "addListenerWithReplay",
    value: function(i, a) {
      var s = this.eventHistory.get(i);
      return s !== void 0 && a.apply(void 0, fw.default(s)), this.addListener(i, a);
    }
  }, {
    key: "onWithReplay",
    value: function(i, a) {
      return this.addListenerWithReplay(i, a);
    }
  }, {
    key: "onceWithReplay",
    value: function(i, a) {
      var s = this.eventHistory.get(i);
      return s !== void 0 ? (a.apply(void 0, fw.default(s)), this) : Ss.default(fa.default(r.prototype), "once", this).call(this, i, a);
    }
  }]), r;
}(cr);
hV.ReplayEventEmitter = Cz;
var Tc = { exports: {} };
Tc.exports;
(function(e, t) {
  var r = 200, n = "__lodash_hash_undefined__", i = 1, a = 2, s = 9007199254740991, o = "[object Arguments]", u = "[object Array]", f = "[object AsyncFunction]", l = "[object Boolean]", d = "[object Date]", c = "[object Error]", p = "[object Function]", v = "[object GeneratorFunction]", h = "[object Map]", m = "[object Number]", q = "[object Null]", w = "[object Object]", O = "[object Promise]", C = "[object Proxy]", R = "[object RegExp]", I = "[object Set]", P = "[object String]", K = "[object Symbol]", B = "[object Undefined]", L = "[object WeakMap]", _ = "[object ArrayBuffer]", ne = "[object DataView]", Z = "[object Float32Array]", le = "[object Float64Array]", he = "[object Int8Array]", Ie = "[object Int16Array]", xe = "[object Int32Array]", ye = "[object Uint8Array]", ue = "[object Uint8ClampedArray]", M = "[object Uint16Array]", F = "[object Uint32Array]", pe = /[\\^$.*+?()[\]{}|]/g, We = /^\[object .+?Constructor\]$/, ce = /^(?:0|[1-9]\d*)$/, oe = {};
  oe[Z] = oe[le] = oe[he] = oe[Ie] = oe[xe] = oe[ye] = oe[ue] = oe[M] = oe[F] = !0, oe[o] = oe[u] = oe[_] = oe[l] = oe[ne] = oe[d] = oe[c] = oe[p] = oe[h] = oe[m] = oe[w] = oe[R] = oe[I] = oe[P] = oe[L] = !1;
  var z = typeof Xn == "object" && Xn && Xn.Object === Object && Xn, Ze = typeof self == "object" && self && self.Object === Object && self, Ae = z || Ze || Function("return this")(), re = t && !t.nodeType && t, Qe = re && !0 && e && !e.nodeType && e, Ee = Qe && Qe.exports === re, Ue = Ee && z.process, He = function() {
    try {
      return Ue && Ue.binding && Ue.binding("util");
    } catch {
    }
  }(), te = He && He.isTypedArray;
  function it(J, ie) {
    for (var Be = -1, ot = J == null ? 0 : J.length, mr = 0, Tt = []; ++Be < ot; ) {
      var Rt = J[Be];
      ie(Rt, Be, J) && (Tt[mr++] = Rt);
    }
    return Tt;
  }
  function Vt(J, ie) {
    for (var Be = -1, ot = ie.length, mr = J.length; ++Be < ot; )
      J[mr + Be] = ie[Be];
    return J;
  }
  function Oe(J, ie) {
    for (var Be = -1, ot = J == null ? 0 : J.length; ++Be < ot; )
      if (ie(J[Be], Be, J))
        return !0;
    return !1;
  }
  function Bt(J, ie) {
    for (var Be = -1, ot = Array(J); ++Be < J; )
      ot[Be] = ie(Be);
    return ot;
  }
  function mt(J) {
    return function(ie) {
      return J(ie);
    };
  }
  function Ot(J, ie) {
    return J.has(ie);
  }
  function It(J, ie) {
    return J == null ? void 0 : J[ie];
  }
  function Me(J) {
    var ie = -1, Be = Array(J.size);
    return J.forEach(function(ot, mr) {
      Be[++ie] = [mr, ot];
    }), Be;
  }
  function Gr(J, ie) {
    return function(Be) {
      return J(ie(Be));
    };
  }
  function $e(J) {
    var ie = -1, Be = Array(J.size);
    return J.forEach(function(ot) {
      Be[++ie] = ot;
    }), Be;
  }
  var Je = Array.prototype, qt = Function.prototype, ft = Object.prototype, at = Ae["__core-js_shared__"], rt = qt.toString, Dt = ft.hasOwnProperty, vr = function() {
    var J = /[^.]+$/.exec(at && at.keys && at.keys.IE_PROTO || "");
    return J ? "Symbol(src)_1." + J : "";
  }(), Qr = ft.toString, un = RegExp(
    "^" + rt.call(Dt).replace(pe, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  ), Nr = Ee ? Ae.Buffer : void 0, kr = Ae.Symbol, Jr = Ae.Uint8Array, Ke = ft.propertyIsEnumerable, Re = Je.splice, ge = kr ? kr.toStringTag : void 0, qe = Object.getOwnPropertySymbols, Ve = Nr ? Nr.isBuffer : void 0, Ne = Gr(Object.keys, Object), Xe = dr(Ae, "DataView"), fe = dr(Ae, "Map"), ke = dr(Ae, "Promise"), ae = dr(Ae, "Set"), me = dr(Ae, "WeakMap"), se = dr(Object, "create"), ze = x(Xe), Pe = x(fe), dt = x(ke), tt = x(ae), st = x(me), vt = kr ? kr.prototype : void 0, ht = vt ? vt.valueOf : void 0;
  function lt(J) {
    var ie = -1, Be = J == null ? 0 : J.length;
    for (this.clear(); ++ie < Be; ) {
      var ot = J[ie];
      this.set(ot[0], ot[1]);
    }
  }
  function G() {
    this.__data__ = se ? se(null) : {}, this.size = 0;
  }
  function Ce(J) {
    var ie = this.has(J) && delete this.__data__[J];
    return this.size -= ie ? 1 : 0, ie;
  }
  function Te(J) {
    var ie = this.__data__;
    if (se) {
      var Be = ie[J];
      return Be === n ? void 0 : Be;
    }
    return Dt.call(ie, J) ? ie[J] : void 0;
  }
  function ct(J) {
    var ie = this.__data__;
    return se ? ie[J] !== void 0 : Dt.call(ie, J);
  }
  function Ft(J, ie) {
    var Be = this.__data__;
    return this.size += this.has(J) ? 0 : 1, Be[J] = se && ie === void 0 ? n : ie, this;
  }
  lt.prototype.clear = G, lt.prototype.delete = Ce, lt.prototype.get = Te, lt.prototype.has = ct, lt.prototype.set = Ft;
  function nt(J) {
    var ie = -1, Be = J == null ? 0 : J.length;
    for (this.clear(); ++ie < Be; ) {
      var ot = J[ie];
      this.set(ot[0], ot[1]);
    }
  }
  function Ct() {
    this.__data__ = [], this.size = 0;
  }
  function Wt(J) {
    var ie = this.__data__, Be = Oa(ie, J);
    if (Be < 0)
      return !1;
    var ot = ie.length - 1;
    return Be == ot ? ie.pop() : Re.call(ie, Be, 1), --this.size, !0;
  }
  function yr(J) {
    var ie = this.__data__, Be = Oa(ie, J);
    return Be < 0 ? void 0 : ie[Be][1];
  }
  function hr(J) {
    return Oa(this.__data__, J) > -1;
  }
  function Yt(J, ie) {
    var Be = this.__data__, ot = Oa(Be, J);
    return ot < 0 ? (++this.size, Be.push([J, ie])) : Be[ot][1] = ie, this;
  }
  nt.prototype.clear = Ct, nt.prototype.delete = Wt, nt.prototype.get = yr, nt.prototype.has = hr, nt.prototype.set = Yt;
  function Vr(J) {
    var ie = -1, Be = J == null ? 0 : J.length;
    for (this.clear(); ++ie < Be; ) {
      var ot = J[ie];
      this.set(ot[0], ot[1]);
    }
  }
  function xr() {
    this.size = 0, this.__data__ = {
      hash: new lt(),
      map: new (fe || nt)(),
      string: new lt()
    };
  }
  function Qn(J) {
    var ie = na(this, J).delete(J);
    return this.size -= ie ? 1 : 0, ie;
  }
  function fn(J) {
    return na(this, J).get(J);
  }
  function uo(J) {
    return na(this, J).has(J);
  }
  function fo(J, ie) {
    var Be = na(this, J), ot = Be.size;
    return Be.set(J, ie), this.size += Be.size == ot ? 0 : 1, this;
  }
  Vr.prototype.clear = xr, Vr.prototype.delete = Qn, Vr.prototype.get = fn, Vr.prototype.has = uo, Vr.prototype.set = fo;
  function Ea(J) {
    var ie = -1, Be = J == null ? 0 : J.length;
    for (this.__data__ = new Vr(); ++ie < Be; )
      this.add(J[ie]);
  }
  function zu(J) {
    return this.__data__.set(J, n), this;
  }
  function lo(J) {
    return this.__data__.has(J);
  }
  Ea.prototype.add = Ea.prototype.push = zu, Ea.prototype.has = lo;
  function Jn(J) {
    var ie = this.__data__ = new nt(J);
    this.size = ie.size;
  }
  function Gu() {
    this.__data__ = new nt(), this.size = 0;
  }
  function mn(J) {
    var ie = this.__data__, Be = ie.delete(J);
    return this.size = ie.size, Be;
  }
  function Qu(J) {
    return this.__data__.get(J);
  }
  function co(J) {
    return this.__data__.has(J);
  }
  function Lr(J, ie) {
    var Be = this.__data__;
    if (Be instanceof nt) {
      var ot = Be.__data__;
      if (!fe || ot.length < r - 1)
        return ot.push([J, ie]), this.size = ++Be.size, this;
      Be = this.__data__ = new Vr(ot);
    }
    return Be.set(J, ie), this.size = Be.size, this;
  }
  Jn.prototype.clear = Gu, Jn.prototype.delete = mn, Jn.prototype.get = Qu, Jn.prototype.has = co, Jn.prototype.set = Lr;
  function Ju(J, ie) {
    var Be = D(J), ot = !Be && Q(J), mr = !Be && !ot && Se(J), Tt = !Be && !ot && !mr && ln(J), Rt = Be || ot || mr || Tt, Zr = Rt ? Bt(J.length, String) : [], N = Zr.length;
    for (var X in J)
      (ie || Dt.call(J, X)) && !(Rt && // Safari 9 has enumerable `arguments.length` in strict mode.
      (X == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
      mr && (X == "offset" || X == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
      Tt && (X == "buffer" || X == "byteLength" || X == "byteOffset") || // Skip index properties.
      mi(X, N))) && Zr.push(X);
    return Zr;
  }
  function Oa(J, ie) {
    for (var Be = J.length; Be--; )
      if (U(J[Be][0], ie))
        return Be;
    return -1;
  }
  function po(J, ie, Be) {
    var ot = ie(J);
    return D(J) ? ot : Vt(ot, Be(J));
  }
  function hi(J) {
    return J == null ? J === void 0 ? B : q : ge && ge in Object(J) ? mo(J) : E(J);
  }
  function vo(J) {
    return gi(J) && hi(J) == o;
  }
  function Hn(J, ie, Be, ot, mr) {
    return J === ie ? !0 : J == null || ie == null || !gi(J) && !gi(ie) ? J !== J && ie !== ie : zt(J, ie, Be, ot, Hn, mr);
  }
  function zt(J, ie, Be, ot, mr, Tt) {
    var Rt = D(J), Zr = D(ie), N = Rt ? u : _n(J), X = Zr ? u : _n(ie);
    N = N == o ? w : N, X = X == o ? w : X;
    var S = N == w, y = X == w, g = N == X;
    if (g && Se(J)) {
      if (!Se(ie))
        return !1;
      Rt = !0, S = !1;
    }
    if (g && !S)
      return Tt || (Tt = new Jn()), Rt || ln(J) ? As(J, ie, Be, ot, mr, Tt) : ho(J, ie, N, Be, ot, mr, Tt);
    if (!(Be & i)) {
      var W = S && Dt.call(J, "__wrapped__"), V = y && Dt.call(ie, "__wrapped__");
      if (W || V) {
        var b = W ? J.value() : J, A = V ? ie.value() : ie;
        return Tt || (Tt = new Jn()), mr(b, A, Be, ot, Tt);
      }
    }
    return g ? (Tt || (Tt = new Jn()), ef(J, ie, Be, ot, mr, Tt)) : !1;
  }
  function Hu(J) {
    if (!Ir(J) || Y(J))
      return !1;
    var ie = _e(J) ? un : We;
    return ie.test(x(J));
  }
  function _u(J) {
    return gi(J) && bt(J.length) && !!oe[hi(J)];
  }
  function $u(J) {
    if (!H(J))
      return Ne(J);
    var ie = [];
    for (var Be in Object(J))
      Dt.call(J, Be) && Be != "constructor" && ie.push(Be);
    return ie;
  }
  function As(J, ie, Be, ot, mr, Tt) {
    var Rt = Be & i, Zr = J.length, N = ie.length;
    if (Zr != N && !(Rt && N > Zr))
      return !1;
    var X = Tt.get(J);
    if (X && Tt.get(ie))
      return X == ie;
    var S = -1, y = !0, g = Be & a ? new Ea() : void 0;
    for (Tt.set(J, ie), Tt.set(ie, J); ++S < Zr; ) {
      var W = J[S], V = ie[S];
      if (ot)
        var b = Rt ? ot(V, W, S, ie, J, Tt) : ot(W, V, S, J, ie, Tt);
      if (b !== void 0) {
        if (b)
          continue;
        y = !1;
        break;
      }
      if (g) {
        if (!Oe(ie, function(A, k) {
          if (!Ot(g, k) && (W === A || mr(W, A, Be, ot, Tt)))
            return g.push(k);
        })) {
          y = !1;
          break;
        }
      } else if (!(W === V || mr(W, V, Be, ot, Tt))) {
        y = !1;
        break;
      }
    }
    return Tt.delete(J), Tt.delete(ie), y;
  }
  function ho(J, ie, Be, ot, mr, Tt, Rt) {
    switch (Be) {
      case ne:
        if (J.byteLength != ie.byteLength || J.byteOffset != ie.byteOffset)
          return !1;
        J = J.buffer, ie = ie.buffer;
      case _:
        return !(J.byteLength != ie.byteLength || !Tt(new Jr(J), new Jr(ie)));
      case l:
      case d:
      case m:
        return U(+J, +ie);
      case c:
        return J.name == ie.name && J.message == ie.message;
      case R:
      case P:
        return J == ie + "";
      case h:
        var Zr = Me;
      case I:
        var N = ot & i;
        if (Zr || (Zr = $e), J.size != ie.size && !N)
          return !1;
        var X = Rt.get(J);
        if (X)
          return X == ie;
        ot |= a, Rt.set(J, ie);
        var S = As(Zr(J), Zr(ie), ot, mr, Tt, Rt);
        return Rt.delete(J), S;
      case K:
        if (ht)
          return ht.call(J) == ht.call(ie);
    }
    return !1;
  }
  function ef(J, ie, Be, ot, mr, Tt) {
    var Rt = Be & i, Zr = ws(J), N = Zr.length, X = ws(ie), S = X.length;
    if (N != S && !Rt)
      return !1;
    for (var y = N; y--; ) {
      var g = Zr[y];
      if (!(Rt ? g in ie : Dt.call(ie, g)))
        return !1;
    }
    var W = Tt.get(J);
    if (W && Tt.get(ie))
      return W == ie;
    var V = !0;
    Tt.set(J, ie), Tt.set(ie, J);
    for (var b = Rt; ++y < N; ) {
      g = Zr[y];
      var A = J[g], k = ie[g];
      if (ot)
        var T = Rt ? ot(k, A, g, ie, J, Tt) : ot(A, k, g, J, ie, Tt);
      if (!(T === void 0 ? A === k || mr(A, k, Be, ot, Tt) : T)) {
        V = !1;
        break;
      }
      b || (b = g == "constructor");
    }
    if (V && !b) {
      var $ = J.constructor, ee = ie.constructor;
      $ != ee && "constructor" in J && "constructor" in ie && !(typeof $ == "function" && $ instanceof $ && typeof ee == "function" && ee instanceof ee) && (V = !1);
    }
    return Tt.delete(J), Tt.delete(ie), V;
  }
  function ws(J) {
    return po(J, yi, tf);
  }
  function na(J, ie) {
    var Be = J.__data__;
    return Na(ie) ? Be[typeof ie == "string" ? "string" : "hash"] : Be.map;
  }
  function dr(J, ie) {
    var Be = It(J, ie);
    return Hu(Be) ? Be : void 0;
  }
  function mo(J) {
    var ie = Dt.call(J, ge), Be = J[ge];
    try {
      J[ge] = void 0;
      var ot = !0;
    } catch {
    }
    var mr = Qr.call(J);
    return ot && (ie ? J[ge] = Be : delete J[ge]), mr;
  }
  var tf = qe ? function(J) {
    return J == null ? [] : (J = Object(J), it(qe(J), function(ie) {
      return Ke.call(J, ie);
    }));
  } : Wv, _n = hi;
  (Xe && _n(new Xe(new ArrayBuffer(1))) != ne || fe && _n(new fe()) != h || ke && _n(ke.resolve()) != O || ae && _n(new ae()) != I || me && _n(new me()) != L) && (_n = function(J) {
    var ie = hi(J), Be = ie == w ? J.constructor : void 0, ot = Be ? x(Be) : "";
    if (ot)
      switch (ot) {
        case ze:
          return ne;
        case Pe:
          return h;
        case dt:
          return O;
        case tt:
          return I;
        case st:
          return L;
      }
    return ie;
  });
  function mi(J, ie) {
    return ie = ie ?? s, !!ie && (typeof J == "number" || ce.test(J)) && J > -1 && J % 1 == 0 && J < ie;
  }
  function Na(J) {
    var ie = typeof J;
    return ie == "string" || ie == "number" || ie == "symbol" || ie == "boolean" ? J !== "__proto__" : J === null;
  }
  function Y(J) {
    return !!vr && vr in J;
  }
  function H(J) {
    var ie = J && J.constructor, Be = typeof ie == "function" && ie.prototype || ft;
    return J === Be;
  }
  function E(J) {
    return Qr.call(J);
  }
  function x(J) {
    if (J != null) {
      try {
        return rt.call(J);
      } catch {
      }
      try {
        return J + "";
      } catch {
      }
    }
    return "";
  }
  function U(J, ie) {
    return J === ie || J !== J && ie !== ie;
  }
  var Q = vo(function() {
    return arguments;
  }()) ? vo : function(J) {
    return gi(J) && Dt.call(J, "callee") && !Ke.call(J, "callee");
  }, D = Array.isArray;
  function Fe(J) {
    return J != null && bt(J.length) && !_e(J);
  }
  var Se = Ve || Hl;
  function je(J, ie) {
    return Hn(J, ie);
  }
  function _e(J) {
    if (!Ir(J))
      return !1;
    var ie = hi(J);
    return ie == p || ie == v || ie == f || ie == C;
  }
  function bt(J) {
    return typeof J == "number" && J > -1 && J % 1 == 0 && J <= s;
  }
  function Ir(J) {
    var ie = typeof J;
    return J != null && (ie == "object" || ie == "function");
  }
  function gi(J) {
    return J != null && typeof J == "object";
  }
  var ln = te ? mt(te) : _u;
  function yi(J) {
    return Fe(J) ? Ju(J) : $u(J);
  }
  function Wv() {
    return [];
  }
  function Hl() {
    return !1;
  }
  e.exports = je;
})(Tc, Tc.exports);
var Fz = Tc.exports, JF = { exports: {} }, Kz = St, Rz = Kz(function() {
  if (typeof ArrayBuffer == "function") {
    var e = new ArrayBuffer(8);
    Object.isExtensible(e) && Object.defineProperty(e, "a", { value: 8 });
  }
}), Tz = St, Uz = Rr, xz = Ji, lw = Rz, ac = Object.isExtensible, Ez = Tz(function() {
  ac(1);
}), Oz = Ez || lw ? function(t) {
  return !Uz(t) || lw && xz(t) === "ArrayBuffer" ? !1 : ac ? ac(t) : !0;
} : ac, Nz = St, HF = !Nz(function() {
  return Object.isExtensible(Object.preventExtensions({}));
}), Iz = xt, Xz = Kt, Pz = ql, Bz = Rr, gV = Tr, Dz = wn.f, dw = ls, Lz = Ey, yV = Oz, Zz = gl, Mz = HF, _F = !1, Va = Zz("meta"), jz = 0, VV = function(e) {
  Dz(e, Va, { value: {
    objectID: "O" + jz++,
    // object ID
    weakData: {}
    // weak collections IDs
  } });
}, Yz = function(e, t) {
  if (!Bz(e))
    return typeof e == "symbol" ? e : (typeof e == "string" ? "S" : "P") + e;
  if (!gV(e, Va)) {
    if (!yV(e))
      return "F";
    if (!t)
      return "E";
    VV(e);
  }
  return e[Va].objectID;
}, zz = function(e, t) {
  if (!gV(e, Va)) {
    if (!yV(e))
      return !0;
    if (!t)
      return !1;
    VV(e);
  }
  return e[Va].weakData;
}, Gz = function(e) {
  return Mz && _F && yV(e) && !gV(e, Va) && VV(e), e;
}, Qz = function() {
  Jz.enable = function() {
  }, _F = !0;
  var e = dw.f, t = Xz([].splice), r = {};
  r[Va] = 1, e(r).length && (dw.f = function(n) {
    for (var i = e(n), a = 0, s = i.length; a < s; a++)
      if (i[a] === Va) {
        t(i, a, 1);
        break;
      }
    return i;
  }, Iz({ target: "Object", stat: !0, forced: !0 }, {
    getOwnPropertyNames: Lz.f
  }));
}, Jz = JF.exports = {
  enable: Qz,
  fastKey: Yz,
  getWeakData: zz,
  onFreeze: Gz
};
Pz[Va] = !0;
var Pp = JF.exports, Hz = xt, _z = Xt, $z = Kt, cw = vp, eG = kn, tG = Pp, rG = xl, nG = vs, iG = or, aG = Ri, Bh = Rr, Dh = St, sG = Cp, oG = Ca, uG = sV, qV = function(e, t, r) {
  var n = e.indexOf("Map") !== -1, i = e.indexOf("Weak") !== -1, a = n ? "set" : "add", s = _z[e], o = s && s.prototype, u = s, f = {}, l = function(q) {
    var w = $z(o[q]);
    eG(
      o,
      q,
      q === "add" ? function(C) {
        return w(this, C === 0 ? 0 : C), this;
      } : q === "delete" ? function(O) {
        return i && !Bh(O) ? !1 : w(this, O === 0 ? 0 : O);
      } : q === "get" ? function(C) {
        return i && !Bh(C) ? void 0 : w(this, C === 0 ? 0 : C);
      } : q === "has" ? function(C) {
        return i && !Bh(C) ? !1 : w(this, C === 0 ? 0 : C);
      } : function(C, R) {
        return w(this, C === 0 ? 0 : C, R), this;
      }
    );
  }, d = cw(
    e,
    !iG(s) || !(i || o.forEach && !Dh(function() {
      new s().entries().next();
    }))
  );
  if (d)
    u = r.getConstructor(t, e, n, a), tG.enable();
  else if (cw(e, !0)) {
    var c = new u(), p = c[a](i ? {} : -0, 1) !== c, v = Dh(function() {
      c.has(1);
    }), h = sG(function(q) {
      new s(q);
    }), m = !i && Dh(function() {
      for (var q = new s(), w = 5; w--; )
        q[a](w, w);
      return !q.has(-0);
    });
    h || (u = t(function(q, w) {
      nG(q, o);
      var O = uG(new s(), q, u);
      return aG(w) || rG(w, O[a], { that: O, AS_ENTRIES: n }), O;
    }), u.prototype = o, o.constructor = u), (v || m) && (l("delete"), l("has"), n && l("get")), (m || p) && l(a), i && o.clear && delete o.clear;
  }
  return f[e] = u, Hz({ global: !0, constructor: !0, forced: u !== s }, f), oG(u, e), i || r.setStrong(u, e, n), u;
}, fG = kn, Bp = function(e, t, r) {
  for (var n in t)
    fG(e, n, t[n], r);
  return e;
}, lG = cs, dG = $i, pw = Bp, cG = Ka, pG = vs, vG = Ri, hG = xl, mG = eV, bd = tV, gG = wp, lf = Ar, vw = Pp.fastKey, $F = jn, hw = $F.set, Lh = $F.getterFor, eK = {
  getConstructor: function(e, t, r, n) {
    var i = e(function(f, l) {
      pG(f, a), hw(f, {
        type: t,
        index: lG(null),
        first: void 0,
        last: void 0,
        size: 0
      }), lf || (f.size = 0), vG(l) || hG(l, f[n], { that: f, AS_ENTRIES: r });
    }), a = i.prototype, s = Lh(t), o = function(f, l, d) {
      var c = s(f), p = u(f, l), v, h;
      return p ? p.value = d : (c.last = p = {
        index: h = vw(l, !0),
        key: l,
        value: d,
        previous: v = c.last,
        next: void 0,
        removed: !1
      }, c.first || (c.first = p), v && (v.next = p), lf ? c.size++ : f.size++, h !== "F" && (c.index[h] = p)), f;
    }, u = function(f, l) {
      var d = s(f), c = vw(l), p;
      if (c !== "F")
        return d.index[c];
      for (p = d.first; p; p = p.next)
        if (p.key === l)
          return p;
    };
    return pw(a, {
      // `{ Map, Set }.prototype.clear()` methods
      // https://tc39.es/ecma262/#sec-map.prototype.clear
      // https://tc39.es/ecma262/#sec-set.prototype.clear
      clear: function() {
        for (var l = this, d = s(l), c = d.index, p = d.first; p; )
          p.removed = !0, p.previous && (p.previous = p.previous.next = void 0), delete c[p.index], p = p.next;
        d.first = d.last = void 0, lf ? d.size = 0 : l.size = 0;
      },
      // `{ Map, Set }.prototype.delete(key)` methods
      // https://tc39.es/ecma262/#sec-map.prototype.delete
      // https://tc39.es/ecma262/#sec-set.prototype.delete
      delete: function(f) {
        var l = this, d = s(l), c = u(l, f);
        if (c) {
          var p = c.next, v = c.previous;
          delete d.index[c.index], c.removed = !0, v && (v.next = p), p && (p.previous = v), d.first === c && (d.first = p), d.last === c && (d.last = v), lf ? d.size-- : l.size--;
        }
        return !!c;
      },
      // `{ Map, Set }.prototype.forEach(callbackfn, thisArg = undefined)` methods
      // https://tc39.es/ecma262/#sec-map.prototype.foreach
      // https://tc39.es/ecma262/#sec-set.prototype.foreach
      forEach: function(l) {
        for (var d = s(this), c = cG(l, arguments.length > 1 ? arguments[1] : void 0), p; p = p ? p.next : d.first; )
          for (c(p.value, p.key, this); p && p.removed; )
            p = p.previous;
      },
      // `{ Map, Set}.prototype.has(key)` methods
      // https://tc39.es/ecma262/#sec-map.prototype.has
      // https://tc39.es/ecma262/#sec-set.prototype.has
      has: function(l) {
        return !!u(this, l);
      }
    }), pw(a, r ? {
      // `Map.prototype.get(key)` method
      // https://tc39.es/ecma262/#sec-map.prototype.get
      get: function(l) {
        var d = u(this, l);
        return d && d.value;
      },
      // `Map.prototype.set(key, value)` method
      // https://tc39.es/ecma262/#sec-map.prototype.set
      set: function(l, d) {
        return o(this, l === 0 ? 0 : l, d);
      }
    } : {
      // `Set.prototype.add(value)` method
      // https://tc39.es/ecma262/#sec-set.prototype.add
      add: function(l) {
        return o(this, l = l === 0 ? 0 : l, l);
      }
    }), lf && dG(a, "size", {
      configurable: !0,
      get: function() {
        return s(this).size;
      }
    }), i;
  },
  setStrong: function(e, t, r) {
    var n = t + " Iterator", i = Lh(t), a = Lh(n);
    mG(e, t, function(s, o) {
      hw(this, {
        type: n,
        target: s,
        state: i(s),
        kind: o,
        last: void 0
      });
    }, function() {
      for (var s = a(this), o = s.kind, u = s.last; u && u.removed; )
        u = u.previous;
      return !s.target || !(s.last = u = u ? u.next : s.state.first) ? (s.target = void 0, bd(void 0, !0)) : bd(o === "keys" ? u.key : o === "values" ? u.value : [u.key, u.value], !1);
    }, r ? "entries" : "values", !r, !0), gG(t);
  }
}, yG = qV, VG = eK;
yG("Map", function(e) {
  return function() {
    return e(this, arguments.length ? arguments[0] : void 0);
  };
}, VG);
var Ua = {};
/*
@license
Copyright (c) 2016, Twilio, Inc.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted, provided that the above
copyright notice and this permission notice appear in all copies.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES
WITH REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF
MERCHANTABILITY AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY
SPECIAL, DIRECT, INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES
WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION
OF CONTRACT, NEGLIGENCE OR OTHER TORTIOUS ACTION, ARISING OUT OF OR IN
CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.

*/
Object.defineProperty(Ua, "__esModule", { value: !0 });
var qG = ra, bG = ps, AG = to, wG = ea, kG = ta, WG = ci, SG = ro;
function no(e) {
  return e && typeof e == "object" && "default" in e ? e : { default: e };
}
var bV = /* @__PURE__ */ no(qG), AV = /* @__PURE__ */ no(bG), da = /* @__PURE__ */ no(AG), wV = /* @__PURE__ */ no(wG), tK = /* @__PURE__ */ no(kG), Uc = /* @__PURE__ */ no(WG), ca = /* @__PURE__ */ no(SG), CG;
function es() {
}
es.prototype = /* @__PURE__ */ Object.create(null);
function ar() {
  ar.init.call(this);
}
ar.EventEmitter = ar;
ar.usingDomains = !1;
ar.prototype.domain = void 0;
ar.prototype._events = void 0;
ar.prototype._maxListeners = void 0;
ar.defaultMaxListeners = 10;
ar.init = function() {
  this.domain = null, ar.usingDomains && CG.active, (!this._events || this._events === Object.getPrototypeOf(this)._events) && (this._events = new es(), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
};
ar.prototype.setMaxListeners = function(t) {
  if (typeof t != "number" || t < 0 || isNaN(t))
    throw new TypeError('"n" argument must be a positive number');
  return this._maxListeners = t, this;
};
function rK(e) {
  return e._maxListeners === void 0 ? ar.defaultMaxListeners : e._maxListeners;
}
ar.prototype.getMaxListeners = function() {
  return rK(this);
};
function FG(e, t, r) {
  if (t)
    e.call(r);
  else
    for (var n = e.length, i = Xl(e, n), a = 0; a < n; ++a)
      i[a].call(r);
}
function KG(e, t, r, n) {
  if (t)
    e.call(r, n);
  else
    for (var i = e.length, a = Xl(e, i), s = 0; s < i; ++s)
      a[s].call(r, n);
}
function RG(e, t, r, n, i) {
  if (t)
    e.call(r, n, i);
  else
    for (var a = e.length, s = Xl(e, a), o = 0; o < a; ++o)
      s[o].call(r, n, i);
}
function TG(e, t, r, n, i, a) {
  if (t)
    e.call(r, n, i, a);
  else
    for (var s = e.length, o = Xl(e, s), u = 0; u < s; ++u)
      o[u].call(r, n, i, a);
}
function UG(e, t, r, n) {
  if (t)
    e.apply(r, n);
  else
    for (var i = e.length, a = Xl(e, i), s = 0; s < i; ++s)
      a[s].apply(r, n);
}
ar.prototype.emit = function(t) {
  var r, n, i, a, s, o, u, f = t === "error";
  if (o = this._events, o)
    f = f && o.error == null;
  else if (!f)
    return !1;
  if (u = this.domain, f) {
    if (r = arguments[1], u)
      r || (r = new Error('Uncaught, unspecified "error" event')), r.domainEmitter = this, r.domain = u, r.domainThrown = !1, u.emit("error", r);
    else {
      if (r instanceof Error)
        throw r;
      var l = new Error('Uncaught, unspecified "error" event. (' + r + ")");
      throw l.context = r, l;
    }
    return !1;
  }
  if (n = o[t], !n)
    return !1;
  var d = typeof n == "function";
  switch (i = arguments.length, i) {
    case 1:
      FG(n, d, this);
      break;
    case 2:
      KG(n, d, this, arguments[1]);
      break;
    case 3:
      RG(n, d, this, arguments[1], arguments[2]);
      break;
    case 4:
      TG(n, d, this, arguments[1], arguments[2], arguments[3]);
      break;
    default:
      for (a = new Array(i - 1), s = 1; s < i; s++)
        a[s - 1] = arguments[s];
      UG(n, d, this, a);
  }
  return !0;
};
function nK(e, t, r, n) {
  var i, a, s;
  if (typeof r != "function")
    throw new TypeError('"listener" argument must be a function');
  if (a = e._events, a ? (a.newListener && (e.emit(
    "newListener",
    t,
    r.listener ? r.listener : r
  ), a = e._events), s = a[t]) : (a = e._events = new es(), e._eventsCount = 0), !s)
    s = a[t] = r, ++e._eventsCount;
  else if (typeof s == "function" ? s = a[t] = n ? [r, s] : [s, r] : n ? s.unshift(r) : s.push(r), !s.warned && (i = rK(e), i && i > 0 && s.length > i)) {
    s.warned = !0;
    var o = new Error("Possible EventEmitter memory leak detected. " + s.length + " " + t + " listeners added. Use emitter.setMaxListeners() to increase limit");
    o.name = "MaxListenersExceededWarning", o.emitter = e, o.type = t, o.count = s.length, xG(o);
  }
  return e;
}
function xG(e) {
  typeof console.warn == "function" ? console.warn(e) : console.log(e);
}
ar.prototype.addListener = function(t, r) {
  return nK(this, t, r, !1);
};
ar.prototype.on = ar.prototype.addListener;
ar.prototype.prependListener = function(t, r) {
  return nK(this, t, r, !0);
};
function iK(e, t, r) {
  var n = !1;
  function i() {
    e.removeListener(t, i), n || (n = !0, r.apply(e, arguments));
  }
  return i.listener = r, i;
}
ar.prototype.once = function(t, r) {
  if (typeof r != "function")
    throw new TypeError('"listener" argument must be a function');
  return this.on(t, iK(this, t, r)), this;
};
ar.prototype.prependOnceListener = function(t, r) {
  if (typeof r != "function")
    throw new TypeError('"listener" argument must be a function');
  return this.prependListener(t, iK(this, t, r)), this;
};
ar.prototype.removeListener = function(t, r) {
  var n, i, a, s, o;
  if (typeof r != "function")
    throw new TypeError('"listener" argument must be a function');
  if (i = this._events, !i)
    return this;
  if (n = i[t], !n)
    return this;
  if (n === r || n.listener && n.listener === r)
    --this._eventsCount === 0 ? this._events = new es() : (delete i[t], i.removeListener && this.emit("removeListener", t, n.listener || r));
  else if (typeof n != "function") {
    for (a = -1, s = n.length; s-- > 0; )
      if (n[s] === r || n[s].listener && n[s].listener === r) {
        o = n[s].listener, a = s;
        break;
      }
    if (a < 0)
      return this;
    if (n.length === 1) {
      if (n[0] = void 0, --this._eventsCount === 0)
        return this._events = new es(), this;
      delete i[t];
    } else
      EG(n, a);
    i.removeListener && this.emit("removeListener", t, o || r);
  }
  return this;
};
ar.prototype.off = function(e, t) {
  return this.removeListener(e, t);
};
ar.prototype.removeAllListeners = function(t) {
  var r, n;
  if (n = this._events, !n)
    return this;
  if (!n.removeListener)
    return arguments.length === 0 ? (this._events = new es(), this._eventsCount = 0) : n[t] && (--this._eventsCount === 0 ? this._events = new es() : delete n[t]), this;
  if (arguments.length === 0) {
    for (var i = Object.keys(n), a = 0, s; a < i.length; ++a)
      s = i[a], s !== "removeListener" && this.removeAllListeners(s);
    return this.removeAllListeners("removeListener"), this._events = new es(), this._eventsCount = 0, this;
  }
  if (r = n[t], typeof r == "function")
    this.removeListener(t, r);
  else if (r)
    do
      this.removeListener(t, r[r.length - 1]);
    while (r[0]);
  return this;
};
ar.prototype.listeners = function(t) {
  var r, n, i = this._events;
  return i ? (r = i[t], r ? typeof r == "function" ? n = [r.listener || r] : n = OG(r) : n = []) : n = [], n;
};
ar.listenerCount = function(e, t) {
  return typeof e.listenerCount == "function" ? e.listenerCount(t) : aK.call(e, t);
};
ar.prototype.listenerCount = aK;
function aK(e) {
  var t = this._events;
  if (t) {
    var r = t[e];
    if (typeof r == "function")
      return 1;
    if (r)
      return r.length;
  }
  return 0;
}
ar.prototype.eventNames = function() {
  return this._eventsCount > 0 ? Reflect.ownKeys(this._events) : [];
};
function EG(e, t) {
  for (var r = t, n = r + 1, i = e.length; n < i; r += 1, n += 1)
    e[r] = e[n];
  e.pop();
}
function Xl(e, t) {
  for (var r = new Array(t); t--; )
    r[t] = e[t];
  return r;
}
function OG(e) {
  for (var t = new Array(e.length), r = 0; r < t.length; ++r)
    t[r] = e[r].listener || e[r];
  return t;
}
function sK(e) {
  var t = NG();
  return function() {
    var n = Uc.default(e), i;
    if (t) {
      var a = Uc.default(this).constructor;
      i = Reflect.construct(n, arguments, a);
    } else
      i = n.apply(this, arguments);
    return tK.default(this, i);
  };
}
function NG() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
var oK = /* @__PURE__ */ function(e) {
  wV.default(r, e);
  var t = sK(r);
  function r(n) {
    var i;
    return bV.default(this, r), i = t.call(this), ca.default(da.default(i), "timeout", null), ca.default(da.default(i), "startTimestamp", -1), i.minDelay = n.min, i.maxDelay = n.max, i.initialDelay = n.initial || 0, i.maxAttemptsCount = n.maxAttemptsCount || 0, i.maxAttemptsTime = n.maxAttemptsTime || 0, i.randomness = n.randomness || 0, i.inProgress = !1, i.attemptNum = 0, i.prevDelay = 0, i.currDelay = 0, i;
  }
  return AV.default(r, [{
    key: "attempt",
    value: function() {
      this.timeout && (clearTimeout(this.timeout), this.timeout = null), this.attemptNum++, this.emit("attempt", this);
    }
  }, {
    key: "nextDelay",
    value: function(i) {
      if (typeof i == "number")
        return this.prevDelay = 0, this.currDelay = i, i;
      if (this.attemptNum == 0)
        return this.initialDelay;
      if (this.attemptNum == 1)
        return this.currDelay = this.minDelay, this.currDelay;
      this.prevDelay = this.currDelay;
      var a = this.currDelay + this.prevDelay;
      return this.maxDelay && a > this.maxDelay && (this.currDelay = this.maxDelay, a = this.maxDelay), this.currDelay = a, a;
    }
  }, {
    key: "randomize",
    value: function(i) {
      var a = i * this.randomness, s = Math.round(Math.random() * a * 2 - a);
      return Math.max(0, i + s);
    }
  }, {
    key: "scheduleAttempt",
    value: function(i) {
      var a = this;
      if (this.maxAttemptsCount && this.attemptNum >= this.maxAttemptsCount) {
        this.cleanup(), this.emit("failed", new Error("Maximum attempt count limit reached"));
        return;
      }
      var s = this.nextDelay(i);
      if (s = this.randomize(s), this.maxAttemptsTime && this.startTimestamp + this.maxAttemptsTime < Date.now() + s) {
        this.cleanup(), this.emit("failed", new Error("Maximum attempt time limit reached"));
        return;
      }
      this.timeout = setTimeout(function() {
        return a.attempt();
      }, s);
    }
  }, {
    key: "cleanup",
    value: function() {
      this.timeout && (clearTimeout(this.timeout), this.timeout = null), this.inProgress = !1, this.attemptNum = 0, this.prevDelay = 0, this.currDelay = 0;
    }
  }, {
    key: "start",
    value: function() {
      if (this.inProgress)
        throw new Error("Retrier is already in progress");
      this.inProgress = !0, this.startTimestamp = Date.now(), this.scheduleAttempt(this.initialDelay);
    }
  }, {
    key: "cancel",
    value: function() {
      this.timeout && (clearTimeout(this.timeout), this.timeout = null, this.inProgress = !1, this.emit("cancelled"));
    }
    // @todo Must be a T here, so the entire Retrier must be typed on this value type.
    // eslint-disable-next-line
  }, {
    key: "succeeded",
    value: function(i) {
      this.emit("succeeded", i);
    }
  }, {
    key: "failed",
    value: function(i, a) {
      if (this.timeout)
        throw new Error("Retrier attempt is already in progress");
      this.scheduleAttempt(a);
    }
  }]), r;
}(ar), IG = /* @__PURE__ */ function(e) {
  wV.default(r, e);
  var t = sK(r);
  function r(n) {
    var i;
    return bV.default(this, r), i = t.call(this), ca.default(da.default(i), "resolve", function() {
    }), ca.default(da.default(i), "reject", function() {
    }), i.retrier = new oK(n), i;
  }
  return AV.default(r, [{
    key: "run",
    value: function(i) {
      var a = this;
      return this.retrier.on("attempt", function() {
        i().then(function(s) {
          return a.retrier.succeeded(s);
        }).catch(function(s) {
          return a.retrier.failed(s);
        });
      }), this.retrier.on("succeeded", function(s) {
        return a.resolve(s);
      }), this.retrier.on("cancelled", function() {
        return a.reject(new Error("Cancelled"));
      }), this.retrier.on("failed", function(s) {
        return a.reject(s);
      }), new Promise(function(s, o) {
        a.resolve = s, a.reject = o, a.retrier.start();
      });
    }
  }, {
    key: "cancel",
    value: function() {
      this.retrier.cancel();
    }
  }]), r;
}(ar);
function XG(e) {
  var t = PG();
  return function() {
    var n = Uc.default(e), i;
    if (t) {
      var a = Uc.default(this).constructor;
      i = Reflect.construct(n, arguments, a);
    } else
      i = n.apply(this, arguments);
    return tK.default(this, i);
  };
}
function PG() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function Ad(e) {
  return e != null;
}
var BG = /* @__PURE__ */ function(e) {
  wV.default(r, e);
  var t = XG(r);
  function r(n) {
    var i;
    bV.default(this, r), i = t.call(this), ca.default(da.default(i), "backoffDelay", 0), ca.default(da.default(i), "nextBackoffDelay", 0), ca.default(da.default(i), "backoffNumber", 0), ca.default(da.default(i), "timeoutID", null), ca.default(da.default(i), "maxNumberOfRetry", -1), n = n || {};
    var a = n, s = a.initialDelay, o = a.maxDelay, u = a.randomisationFactor, f = a.factor;
    if (Ad(s) && s < 1)
      throw new Error("The initial timeout must be equal to or greater than 1.");
    if (Ad(o) && o <= 1)
      throw new Error("The maximal timeout must be greater than 1.");
    if (Ad(u) && (u < 0 || u > 1))
      throw new Error("The randomisation factor must be between 0 and 1.");
    if (Ad(f) && f <= 1)
      throw new Error("Exponential factor should be greater than 1.");
    if (i.initialDelay = s || 100, i.maxDelay = o || 1e4, i.maxDelay <= i.initialDelay)
      throw new Error("The maximal backoff delay must be greater than the initial backoff delay.");
    return i.randomisationFactor = u || 0, i.factor = f || 2, i.reset(), i;
  }
  return AV.default(r, [{
    key: "backoff",
    value: function(i) {
      this.timeoutID == null && (this.backoffNumber === this.maxNumberOfRetry ? (this.emit("fail", i), this.reset()) : (this.backoffDelay = this.next(), this.timeoutID = setTimeout(this.onBackoff.bind(this), this.backoffDelay), this.emit("backoff", this.backoffNumber, this.backoffDelay, i)));
    }
  }, {
    key: "reset",
    value: function() {
      this.backoffDelay = 0, this.nextBackoffDelay = this.initialDelay, this.backoffNumber = 0, this.timeoutID && clearTimeout(this.timeoutID), this.timeoutID = null;
    }
  }, {
    key: "failAfter",
    value: function(i) {
      if (i <= 0)
        throw new Error("Expected a maximum number of retry greater than 0 but got ".concat(i));
      this.maxNumberOfRetry = i;
    }
  }, {
    key: "next",
    value: function() {
      this.backoffDelay = Math.min(this.nextBackoffDelay, this.maxDelay), this.nextBackoffDelay = this.backoffDelay * this.factor;
      var i = 1 + Math.random() * this.randomisationFactor;
      return Math.min(this.maxDelay, Math.round(this.backoffDelay * i));
    }
  }, {
    key: "onBackoff",
    value: function() {
      this.timeoutID = null, this.emit("ready", this.backoffNumber, this.backoffDelay), this.backoffNumber++;
    }
  }], [{
    key: "exponential",
    value: function(i) {
      return new r(i);
    }
  }]), r;
}(ar);
Ua.AsyncRetrier = IG;
Ua.Backoff = BG;
Ua.Retrier = oK;
var Dp = {}, DG = fr, LG = Tr, ZG = ka, MG = VF, mw = RegExp.prototype, jG = function(e) {
  var t = e.flags;
  return t === void 0 && !("flags" in mw) && !LG(e, "flags") && ZG(mw, e) ? DG(MG, e) : t;
}, YG = Vl.PROPER, zG = kn, GG = Or, gw = $r, QG = St, JG = jG, kV = "toString", HG = RegExp.prototype, uK = HG[kV], _G = QG(function() {
  return uK.call({ source: "a", flags: "b" }) !== "/a/b";
}), $G = YG && uK.name !== kV;
(_G || $G) && zG(RegExp.prototype, kV, function() {
  var t = GG(this), r = gw(t.source), n = gw(JG(t));
  return "/" + r + "/" + n;
}, { unsafe: !0 });
var Wn = {};
/*
@license
Copyright (c) 2021 Twilio Inc.

Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.


*/
Object.defineProperty(Wn, "__esModule", { value: !0 });
var eQ = di, tQ = Eu, rQ = Ou, nQ = ra, iQ = ea, aQ = ta, sQ = ci;
function io(e) {
  return e && typeof e == "object" && "default" in e ? e : { default: e };
}
var zo = /* @__PURE__ */ io(eQ), js = /* @__PURE__ */ io(tQ), Zh = /* @__PURE__ */ io(rQ), oQ = /* @__PURE__ */ io(nQ), uQ = /* @__PURE__ */ io(iQ), fQ = /* @__PURE__ */ io(aQ), yw = /* @__PURE__ */ io(sQ), ms = function() {
  for (var t = arguments.length, r = new Array(t), n = 0; n < t; n++)
    r[n] = arguments[n];
  return {
    checks: r
  };
};
function lQ(e, t) {
  var r = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (!r) {
    if (Array.isArray(e) || (r = dQ(e)) || t && e && typeof e.length == "number") {
      r && (e = r);
      var n = 0, i = function() {
      };
      return { s: i, n: function() {
        return n >= e.length ? { done: !0 } : { done: !1, value: e[n++] };
      }, e: function(f) {
        throw f;
      }, f: i };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  var a = !0, s = !1, o;
  return { s: function() {
    r = r.call(e);
  }, n: function() {
    var f = r.next();
    return a = f.done, f;
  }, e: function(f) {
    s = !0, o = f;
  }, f: function() {
    try {
      !a && r.return != null && r.return();
    } finally {
      if (s)
        throw o;
    }
  } };
}
function dQ(e, t) {
  if (e) {
    if (typeof e == "string")
      return Vw(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set")
      return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return Vw(e, t);
  }
}
function Vw(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
var fK = function() {
  for (var t = arguments.length, r = new Array(t), n = 0; n < t; n++)
    r[n] = arguments[n];
  return ms(function(i) {
    var a = !1, s = [], o = lQ(r), u;
    try {
      for (o.s(); !(u = o.n()).done; ) {
        var f = u.value;
        if (typeof f == "string") {
          a = a || zo.default(i) === f, s.push("of type ".concat(f));
          continue;
        }
        a = a || i instanceof f, s.push("an instance of ".concat(f.name));
      }
    } catch (l) {
      o.e(l);
    } finally {
      o.f();
    }
    return [a, s];
  });
};
function cQ(e, t) {
  var r = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (!r) {
    if (Array.isArray(e) || (r = pQ(e)) || t && e && typeof e.length == "number") {
      r && (e = r);
      var n = 0, i = function() {
      };
      return { s: i, n: function() {
        return n >= e.length ? { done: !0 } : { done: !1, value: e[n++] };
      }, e: function(f) {
        throw f;
      }, f: i };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  var a = !0, s = !1, o;
  return { s: function() {
    r = r.call(e);
  }, n: function() {
    var f = r.next();
    return a = f.done, f;
  }, e: function(f) {
    s = !0, o = f;
  }, f: function() {
    try {
      !a && r.return != null && r.return();
    } finally {
      if (s)
        throw o;
    }
  } };
}
function pQ(e, t) {
  if (e) {
    if (typeof e == "string")
      return qw(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set")
      return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return qw(e, t);
  }
}
function qw(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
var vQ = function() {
  for (var t = arguments.length, r = new Array(t), n = 0; n < t; n++)
    r[n] = arguments[n];
  return ms(function(i) {
    var a = !1, s = [], o = cQ(r), u;
    try {
      for (o.s(); !(u = o.n()).done; ) {
        var f = u.value;
        a = a || i === f, s.push(typeof f == "string" ? '"'.concat(f, '"') : "".concat(f));
      }
    } catch (l) {
      o.e(l);
    } finally {
      o.f();
    }
    return [a, s];
  });
}, hQ = ms(function(e) {
  return [typeof e == "string" && e.length > 0, "a non-empty string"];
}), mQ = ms(function(e) {
  return [typeof e == "number" && Number.isInteger(e) && e >= 0, "a non-negative integer"];
}), gQ = ms(function(e) {
  return [zo.default(e) === "object" && e !== null && !Array.isArray(e), "a pure object (non-null and non-array)"];
});
function yQ(e) {
  var t = VQ();
  return function() {
    var n = yw.default(e), i;
    if (t) {
      var a = yw.default(this).constructor;
      i = Reflect.construct(n, arguments, a);
    } else
      i = n.apply(this, arguments);
    return fQ.default(this, i);
  };
}
function VQ() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function el(e, t) {
  var r = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (!r) {
    if (Array.isArray(e) || (r = qQ(e)) || t && e && typeof e.length == "number") {
      r && (e = r);
      var n = 0, i = function() {
      };
      return { s: i, n: function() {
        return n >= e.length ? { done: !0 } : { done: !1, value: e[n++] };
      }, e: function(f) {
        throw f;
      }, f: i };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  var a = !0, s = !1, o;
  return { s: function() {
    r = r.call(e);
  }, n: function() {
    var f = r.next();
    return a = f.done, f;
  }, e: function(f) {
    s = !0, o = f;
  }, f: function() {
    try {
      !a && r.return != null && r.return();
    } finally {
      if (s)
        throw o;
    }
  } };
}
function qQ(e, t) {
  if (e) {
    if (typeof e == "string")
      return bw(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set")
      return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return bw(e, t);
  }
}
function bw(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
var Lp = function(t, r) {
  if (r.length > t.length)
    throw new Error("Expected at most ".concat(t.length, " argument(s), but got ").concat(r.length));
  for (; r.length < t.length; )
    r.push(void 0);
  var n = el(r.entries()), i;
  try {
    for (n.s(); !(i = n.n()).done; ) {
      var a = js.default(i.value, 2), s = a[0], o = a[1], u = CV(t[s], o), f = js.default(u, 4), l = f[0], d = f[1], c = f[2], p = f[3];
      if (!l) {
        var v = s + 1;
        throw new Error("Argument ".concat(v, " is expected to be ").concat(c).concat(p, " but got ").concat(d));
      }
    }
  } catch (h) {
    n.e(h);
  } finally {
    n.f();
  }
}, lK = function(t) {
  var r, n, i = ["undefined", "boolean", "number", "bigint", "string"];
  if (i.includes(zo.default(t)) && (n = typeof t == "string" ? '"'.concat(t, '"') : "".concat(t)), zo.default(t) === "object" && (t == null || (r = t.constructor) === null || r === void 0 ? void 0 : r.name) !== "Object") {
    var a;
    n = t === null ? "null" : "instance of ".concat(t == null || (a = t.constructor) === null || a === void 0 ? void 0 : a.name);
  }
  return n || (n = zo.default(t)), n;
}, bQ = function() {
  for (var t = arguments.length, r = new Array(t), n = 0; n < t; n++)
    r[n] = arguments[n];
  var i = WV(r);
  return function(a) {
    return /* @__PURE__ */ function(s) {
      uQ.default(u, s);
      var o = yQ(u);
      function u() {
        oQ.default(this, u);
        for (var f = arguments.length, l = new Array(f), d = 0; d < f; d++)
          l[d] = arguments[d];
        return Lp(i, l), o.call.apply(o, [this].concat(l));
      }
      return u;
    }(a);
  };
}, AQ = function() {
  for (var t = arguments.length, r = new Array(t), n = 0; n < t; n++)
    r[n] = arguments[n];
  var i = WV(r);
  return function(a, s, o) {
    if (typeof o.value != "function")
      throw new Error("The validateTypes decorator can only be applied to methods");
    var u = o.value;
    o.value = function() {
      for (var f = arguments.length, l = new Array(f), d = 0; d < f; d++)
        l[d] = arguments[d];
      return Lp(i, l), u.apply(this, l);
    };
  };
}, wQ = function() {
  for (var t = arguments.length, r = new Array(t), n = 0; n < t; n++)
    r[n] = arguments[n];
  var i = WV(r);
  return function(a, s, o) {
    if (typeof o.value != "function")
      throw new Error("The validateTypesAsync decorator can only be applied to methods");
    var u = o.value;
    o.value = function() {
      for (var f = arguments.length, l = new Array(f), d = 0; d < f; d++)
        l[d] = arguments[d];
      try {
        Lp(i, l);
      } catch (c) {
        return Promise.reject(c);
      }
      return u.apply(this, l);
    };
  };
}, WV = function(t) {
  var r = [], n = el(t), i;
  try {
    for (n.s(); !(i = n.n()).done; ) {
      var a = i.value;
      r.push(SV(a));
    }
  } catch (s) {
    n.e(s);
  } finally {
    n.f();
  }
  return r;
}, SV = function(t) {
  var r = [], n = Array.isArray(t) ? t : [t], i = el(n), a;
  try {
    for (i.s(); !(a = i.n()).done; ) {
      var s = a.value;
      if (typeof s == "string" || typeof s == "function") {
        r.push(fK(s));
        continue;
      }
      r.push(s);
    }
  } catch (o) {
    i.e(o);
  } finally {
    i.f();
  }
  return r;
}, CV = function(t, r) {
  var n = [], i, a = !1, s = el(t), o;
  try {
    for (s.s(); !(o = s.n()).done; ) {
      var u = o.value, f = el(u.checks), l;
      try {
        for (f.s(); !(l = f.n()).done; ) {
          var d = l.value, c = d(r), p = js.default(c, 3), v = p[0], h = p[1], m = p[2];
          a = a || v, !i && m && (i = m), h && (n = typeof h == "string" ? [].concat(Zh.default(n), [h]) : [].concat(Zh.default(n), Zh.default(h)));
        }
      } catch (C) {
        f.e(C);
      } finally {
        f.f();
      }
    }
  } catch (C) {
    s.e(C);
  } finally {
    s.f();
  }
  if (a)
    return [!0];
  var q = i || lK(r), w = n.length - 1, O = w > 0 ? "".concat(n.slice(0, w).join(", "), " or ").concat(n[w]) : n.join(", ");
  return [!1, q, O, w > 1 ? ";" : ","];
}, kQ = function(t, r) {
  return ms(function(n) {
    if (zo.default(n) !== "object" || n === null || Array.isArray(n))
      return [!1, "valid ".concat(t, " (should be a pure object)")];
    for (var i = 0, a = Object.entries(r); i < a.length; i++) {
      var s = js.default(a[i], 2), o = s[0], u = s[1], f = CV(SV(u), n[o]), l = js.default(f, 3), d = l[0], c = l[1], p = l[2];
      if (!d)
        return [!1, "valid ".concat(t, ' (key "').concat(o, '" should be ').concat(p, ")"), "malformed ".concat(t, ' (key "').concat(o, '" is ').concat(c, ")")];
    }
    return [!0];
  });
};
function WQ(e, t) {
  var r = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (!r) {
    if (Array.isArray(e) || (r = SQ(e)) || t && e && typeof e.length == "number") {
      r && (e = r);
      var n = 0, i = function() {
      };
      return { s: i, n: function() {
        return n >= e.length ? { done: !0 } : { done: !1, value: e[n++] };
      }, e: function(f) {
        throw f;
      }, f: i };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  var a = !0, s = !1, o;
  return { s: function() {
    r = r.call(e);
  }, n: function() {
    var f = r.next();
    return a = f.done, f;
  }, e: function(f) {
    s = !0, o = f;
  }, f: function() {
    try {
      !a && r.return != null && r.return();
    } finally {
      if (s)
        throw o;
    }
  } };
}
function SQ(e, t) {
  if (e) {
    if (typeof e == "string")
      return Aw(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set")
      return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return Aw(e, t);
  }
}
function Aw(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
var CQ = function(t, r) {
  return ms(function(n) {
    if (!Array.isArray(n))
      return [!1, "an array of ".concat(t)];
    var i = WQ(n.entries()), a;
    try {
      for (i.s(); !(a = i.n()).done; ) {
        var s = js.default(a.value, 2), o = s[0], u = s[1], f = CV(SV(r), u), l = js.default(f, 3), d = l[0], c = l[1], p = l[2];
        if (!d)
          return [!1, "a valid array of ".concat(t, " (index ").concat(o, " should be ").concat(p, ")"), "malformed array of ".concat(t, " (index ").concat(o, " is ").concat(c, ")")];
      }
    } catch (v) {
      i.e(v);
    } finally {
      i.f();
    }
    return [!0];
  });
};
Wn.array = CQ;
Wn.custom = ms;
Wn.literal = vQ;
Wn.nonEmptyString = hQ;
Wn.nonNegativeInteger = mQ;
Wn.objectSchema = kQ;
Wn.pureObject = gQ;
Wn.runtimeTypeValidation = Lp;
Wn.stringifyReceivedType = lK;
Wn.type = fK;
Wn.validateConstructorTypes = bQ;
Wn.validateTypes = AQ;
Wn.validateTypesAsync = wQ;
var FQ = qV, KQ = eK;
FQ("Set", function(e) {
  return function() {
    return e(this, arguments.length ? arguments[0] : void 0);
  };
}, KQ);
var dK = { exports: {} };
(function(e, t) {
  (function(n, i) {
    e.exports = i();
  })(Xn, function() {
    return (
      /******/
      function(r) {
        var n = {};
        function i(a) {
          if (n[a])
            return n[a].exports;
          var s = n[a] = {
            /******/
            i: a,
            /******/
            l: !1,
            /******/
            exports: {}
            /******/
          };
          return r[a].call(s.exports, s, s.exports, i), s.l = !0, s.exports;
        }
        return i.m = r, i.c = n, i.i = function(a) {
          return a;
        }, i.d = function(a, s, o) {
          i.o(a, s) || Object.defineProperty(a, s, {
            /******/
            configurable: !1,
            /******/
            enumerable: !0,
            /******/
            get: o
            /******/
          });
        }, i.n = function(a) {
          var s = a && a.__esModule ? (
            /******/
            function() {
              return a.default;
            }
          ) : (
            /******/
            function() {
              return a;
            }
          );
          return i.d(s, "a", s), s;
        }, i.o = function(a, s) {
          return Object.prototype.hasOwnProperty.call(a, s);
        }, i.p = "", i(i.s = 5);
      }([
        /* 0 */
        /***/
        function(r, n, i) {
          r.exports = function(a, s) {
            var o, u, f;
            for (o = 1; o < arguments.length; o++) {
              u = arguments[o];
              for (f in u)
                u.hasOwnProperty(f) && (a[f] = u[f]);
            }
            return a;
          };
        },
        /* 1 */
        /***/
        function(r, n, i) {
          var a = i(0);
          r.exports = {
            build: function(s, o) {
              var u, f, l, d = o.plugins;
              for (u = 0, f = d.length; u < f; u++)
                l = d[u], l.methods && a(s, l.methods), l.properties && Object.defineProperties(s, l.properties);
            },
            hook: function(s, o, u) {
              var f, l, d, c, p = s.config.plugins, v = [s.context];
              for (u && (v = v.concat(u)), f = 0, l = p.length; f < l; f++)
                c = p[f], d = p[f][o], d && d.apply(c, v);
            }
          };
        },
        /* 2 */
        /***/
        function(r, n, i) {
          function a(s) {
            if (s.length === 0)
              return s;
            var o, u, f = s.split(/[_-]/);
            if (f.length === 1 && f[0][0].toLowerCase() === f[0][0])
              return s;
            for (u = f[0].toLowerCase(), o = 1; o < f.length; o++)
              u = u + f[o].charAt(0).toUpperCase() + f[o].substring(1).toLowerCase();
            return u;
          }
          a.prepended = function(s, o) {
            return o = a(o), s + o[0].toUpperCase() + o.substring(1);
          }, r.exports = a;
        },
        /* 3 */
        /***/
        function(r, n, i) {
          var a = i(0), s = i(2);
          function o(u, f) {
            u = u || {}, this.options = u, this.defaults = f.defaults, this.states = [], this.transitions = [], this.map = {}, this.lifecycle = this.configureLifecycle(), this.init = this.configureInitTransition(u.init), this.data = this.configureData(u.data), this.methods = this.configureMethods(u.methods), this.map[this.defaults.wildcard] = {}, this.configureTransitions(u.transitions || []), this.plugins = this.configurePlugins(u.plugins, f.plugin);
          }
          a(o.prototype, {
            addState: function(u) {
              this.map[u] || (this.states.push(u), this.addStateLifecycleNames(u), this.map[u] = {});
            },
            addStateLifecycleNames: function(u) {
              this.lifecycle.onEnter[u] = s.prepended("onEnter", u), this.lifecycle.onLeave[u] = s.prepended("onLeave", u), this.lifecycle.on[u] = s.prepended("on", u);
            },
            addTransition: function(u) {
              this.transitions.indexOf(u) < 0 && (this.transitions.push(u), this.addTransitionLifecycleNames(u));
            },
            addTransitionLifecycleNames: function(u) {
              this.lifecycle.onBefore[u] = s.prepended("onBefore", u), this.lifecycle.onAfter[u] = s.prepended("onAfter", u), this.lifecycle.on[u] = s.prepended("on", u);
            },
            mapTransition: function(u) {
              var f = u.name, l = u.from, d = u.to;
              return this.addState(l), typeof d != "function" && this.addState(d), this.addTransition(f), this.map[l][f] = u, u;
            },
            configureLifecycle: function() {
              return {
                onBefore: { transition: "onBeforeTransition" },
                onAfter: { transition: "onAfterTransition" },
                onEnter: { state: "onEnterState" },
                onLeave: { state: "onLeaveState" },
                on: { transition: "onTransition" }
              };
            },
            configureInitTransition: function(u) {
              return typeof u == "string" ? this.mapTransition(a({}, this.defaults.init, { to: u, active: !0 })) : typeof u == "object" ? this.mapTransition(a({}, this.defaults.init, u, { active: !0 })) : (this.addState(this.defaults.init.from), this.defaults.init);
            },
            configureData: function(u) {
              return typeof u == "function" ? u : typeof u == "object" ? function() {
                return u;
              } : function() {
                return {};
              };
            },
            configureMethods: function(u) {
              return u || {};
            },
            configurePlugins: function(u, f) {
              u = u || [];
              var l, d, c;
              for (l = 0, d = u.length; l < d; l++)
                c = u[l], typeof c == "function" && (u[l] = c = c()), c.configure && c.configure(this);
              return u;
            },
            configureTransitions: function(u) {
              var f, l, d, c, p, v = this.defaults.wildcard;
              for (l = 0; l < u.length; l++)
                for (d = u[l], c = Array.isArray(d.from) ? d.from : [d.from || v], p = d.to || v, f = 0; f < c.length; f++)
                  this.mapTransition({ name: d.name, from: c[f], to: p });
            },
            transitionFor: function(u, f) {
              var l = this.defaults.wildcard;
              return this.map[u][f] || this.map[l][f];
            },
            transitionsFor: function(u) {
              var f = this.defaults.wildcard;
              return Object.keys(this.map[u]).concat(Object.keys(this.map[f]));
            },
            allStates: function() {
              return this.states;
            },
            allTransitions: function() {
              return this.transitions;
            }
          }), r.exports = o;
        },
        /* 4 */
        /***/
        function(r, n, i) {
          var a = i(0), s = i(6), o = i(1), u = [null, []];
          function f(l, d) {
            this.context = l, this.config = d, this.state = d.init.from, this.observers = [l];
          }
          a(f.prototype, {
            init: function(l) {
              if (a(this.context, this.config.data.apply(this.context, l)), o.hook(this, "init"), this.config.init.active)
                return this.fire(this.config.init.name, []);
            },
            is: function(l) {
              return Array.isArray(l) ? l.indexOf(this.state) >= 0 : this.state === l;
            },
            isPending: function() {
              return this.pending;
            },
            can: function(l) {
              return !this.isPending() && !!this.seek(l);
            },
            cannot: function(l) {
              return !this.can(l);
            },
            allStates: function() {
              return this.config.allStates();
            },
            allTransitions: function() {
              return this.config.allTransitions();
            },
            transitions: function() {
              return this.config.transitionsFor(this.state);
            },
            seek: function(l, d) {
              var c = this.config.defaults.wildcard, p = this.config.transitionFor(this.state, l), v = p && p.to;
              return typeof v == "function" ? v.apply(this.context, d) : v === c ? this.state : v;
            },
            fire: function(l, d) {
              return this.transit(l, this.state, this.seek(l, d), d);
            },
            transit: function(l, d, c, p) {
              var v = this.config.lifecycle, h = this.config.options.observeUnchangedState || d !== c;
              return c ? this.isPending() ? this.context.onPendingTransition(l, d, c) : (this.config.addState(c), this.beginTransit(), p.unshift({
                // this context will be passed to each lifecycle event observer
                transition: l,
                from: d,
                to: c,
                fsm: this.context
              }), this.observeEvents([
                this.observersForEvent(v.onBefore.transition),
                this.observersForEvent(v.onBefore[l]),
                h ? this.observersForEvent(v.onLeave.state) : u,
                h ? this.observersForEvent(v.onLeave[d]) : u,
                this.observersForEvent(v.on.transition),
                h ? ["doTransit", [this]] : u,
                h ? this.observersForEvent(v.onEnter.state) : u,
                h ? this.observersForEvent(v.onEnter[c]) : u,
                h ? this.observersForEvent(v.on[c]) : u,
                this.observersForEvent(v.onAfter.transition),
                this.observersForEvent(v.onAfter[l]),
                this.observersForEvent(v.on[l])
              ], p)) : this.context.onInvalidTransition(l, d, c);
            },
            beginTransit: function() {
              this.pending = !0;
            },
            endTransit: function(l) {
              return this.pending = !1, l;
            },
            failTransit: function(l) {
              throw this.pending = !1, l;
            },
            doTransit: function(l) {
              this.state = l.to;
            },
            observe: function(l) {
              if (l.length === 2) {
                var d = {};
                d[l[0]] = l[1], this.observers.push(d);
              } else
                this.observers.push(l[0]);
            },
            observersForEvent: function(l) {
              for (var d = 0, c = this.observers.length, p, v = []; d < c; d++)
                p = this.observers[d], p[l] && v.push(p);
              return [l, v, !0];
            },
            observeEvents: function(l, d, c, p) {
              if (l.length === 0)
                return this.endTransit(p === void 0 ? !0 : p);
              var v = l[0][0], h = l[0][1], m = l[0][2];
              if (d[0].event = v, v && m && v !== c && o.hook(this, "lifecycle", d), h.length === 0)
                return l.shift(), this.observeEvents(l, d, v, p);
              var q = h.shift(), w = q[v].apply(q, d);
              return w && typeof w.then == "function" ? w.then(this.observeEvents.bind(this, l, d, v)).catch(this.failTransit.bind(this)) : w === !1 ? this.endTransit(!1) : this.observeEvents(l, d, v, w);
            },
            onInvalidTransition: function(l, d, c) {
              throw new s("transition is invalid in current state", l, d, c, this.state);
            },
            onPendingTransition: function(l, d, c) {
              throw new s("transition is invalid while previous transition is still in progress", l, d, c, this.state);
            }
          }), r.exports = f;
        },
        /* 5 */
        /***/
        function(r, n, i) {
          var a = i(0), s = i(2), o = i(1), u = i(3), f = i(4), l = {
            is: function(m) {
              return this._fsm.is(m);
            },
            can: function(m) {
              return this._fsm.can(m);
            },
            cannot: function(m) {
              return this._fsm.cannot(m);
            },
            observe: function() {
              return this._fsm.observe(arguments);
            },
            transitions: function() {
              return this._fsm.transitions();
            },
            allTransitions: function() {
              return this._fsm.allTransitions();
            },
            allStates: function() {
              return this._fsm.allStates();
            },
            onInvalidTransition: function(m, q, w) {
              return this._fsm.onInvalidTransition(m, q, w);
            },
            onPendingTransition: function(m, q, w) {
              return this._fsm.onPendingTransition(m, q, w);
            }
          }, d = {
            state: {
              configurable: !1,
              enumerable: !0,
              get: function() {
                return this._fsm.state;
              },
              set: function(m) {
                throw Error("use transitions to change state");
              }
            }
          };
          function c(m) {
            return v(this || {}, m);
          }
          function p() {
            var m, q;
            typeof arguments[0] == "function" ? (m = arguments[0], q = arguments[1] || {}) : (m = function() {
              this._fsm.apply(this, arguments);
            }, q = arguments[0] || {});
            var w = new u(q, c);
            return h(m.prototype, w), m.prototype._fsm.config = w, m;
          }
          function v(m, q) {
            var w = new u(q, c);
            return h(m, w), m._fsm(), m;
          }
          function h(m, q) {
            if (typeof m != "object" || Array.isArray(m))
              throw Error("StateMachine can only be applied to objects");
            o.build(m, q), Object.defineProperties(m, d), a(m, l), a(m, q.methods), q.allTransitions().forEach(function(w) {
              m[s(w)] = function() {
                return this._fsm.fire(w, [].slice.call(arguments));
              };
            }), m._fsm = function() {
              this._fsm = new f(this, q), this._fsm.init(arguments);
            };
          }
          c.version = "3.0.1", c.factory = p, c.apply = v, c.defaults = {
            wildcard: "*",
            init: {
              name: "init",
              from: "none"
            }
          }, r.exports = c;
        },
        /* 6 */
        /***/
        function(r, n, i) {
          r.exports = function(a, s, o, u, f) {
            this.message = a, this.transition = s, this.from = o, this.to = u, this.current = f;
          };
        }
        /******/
      ])
    );
  });
})(dK);
var RQ = dK.exports, Qm = { exports: {} }, ww = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto < "u" && typeof window.msCrypto.getRandomValues == "function" && msCrypto.getRandomValues.bind(msCrypto);
if (ww) {
  var kw = new Uint8Array(16);
  Qm.exports = function() {
    return ww(kw), kw;
  };
} else {
  var Ww = new Array(16);
  Qm.exports = function() {
    for (var t = 0, r; t < 16; t++)
      t & 3 || (r = Math.random() * 4294967296), Ww[t] = r >>> ((t & 3) << 3) & 255;
    return Ww;
  };
}
var cK = Qm.exports, pK = [];
for (var wd = 0; wd < 256; ++wd)
  pK[wd] = (wd + 256).toString(16).substr(1);
function TQ(e, t) {
  var r = t || 0, n = pK;
  return [
    n[e[r++]],
    n[e[r++]],
    n[e[r++]],
    n[e[r++]],
    "-",
    n[e[r++]],
    n[e[r++]],
    "-",
    n[e[r++]],
    n[e[r++]],
    "-",
    n[e[r++]],
    n[e[r++]],
    "-",
    n[e[r++]],
    n[e[r++]],
    n[e[r++]],
    n[e[r++]],
    n[e[r++]],
    n[e[r++]]
  ].join("");
}
var vK = TQ, UQ = cK, xQ = vK, Sw, Mh, jh = 0, Yh = 0;
function EQ(e, t, r) {
  var n = t && r || 0, i = t || [];
  e = e || {};
  var a = e.node || Sw, s = e.clockseq !== void 0 ? e.clockseq : Mh;
  if (a == null || s == null) {
    var o = UQ();
    a == null && (a = Sw = [
      o[0] | 1,
      o[1],
      o[2],
      o[3],
      o[4],
      o[5]
    ]), s == null && (s = Mh = (o[6] << 8 | o[7]) & 16383);
  }
  var u = e.msecs !== void 0 ? e.msecs : (/* @__PURE__ */ new Date()).getTime(), f = e.nsecs !== void 0 ? e.nsecs : Yh + 1, l = u - jh + (f - Yh) / 1e4;
  if (l < 0 && e.clockseq === void 0 && (s = s + 1 & 16383), (l < 0 || u > jh) && e.nsecs === void 0 && (f = 0), f >= 1e4)
    throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
  jh = u, Yh = f, Mh = s, u += 122192928e5;
  var d = ((u & 268435455) * 1e4 + f) % 4294967296;
  i[n++] = d >>> 24 & 255, i[n++] = d >>> 16 & 255, i[n++] = d >>> 8 & 255, i[n++] = d & 255;
  var c = u / 4294967296 * 1e4 & 268435455;
  i[n++] = c >>> 8 & 255, i[n++] = c & 255, i[n++] = c >>> 24 & 15 | 16, i[n++] = c >>> 16 & 255, i[n++] = s >>> 8 | 128, i[n++] = s & 255;
  for (var p = 0; p < 6; ++p)
    i[n + p] = a[p];
  return t || xQ(i);
}
var OQ = EQ, NQ = cK, IQ = vK;
function XQ(e, t, r) {
  var n = t && r || 0;
  typeof e == "string" && (t = e === "binary" ? new Array(16) : null, e = null), e = e || {};
  var i = e.random || (e.rng || NQ)();
  if (i[6] = i[6] & 15 | 64, i[8] = i[8] & 63 | 128, t)
    for (var a = 0; a < 16; ++a)
      t[n + a] = i[a];
  return t || IQ(i);
}
var PQ = XQ, BQ = OQ, hK = PQ, FV = hK;
FV.v1 = BQ;
FV.v4 = hK;
var DQ = FV, Jm = { exports: {} }, mK = typeof ArrayBuffer < "u" && typeof DataView < "u", LQ = mK, KV = Ar, An = Xt, gK = or, Zp = Rr, fs = Tr, RV = Fa, ZQ = _s, MQ = Wa, Hm = kn, jQ = $i, YQ = ka, Mp = Ol, Nu = Uu, zQ = lr, GQ = gl, yK = jn, VK = yK.enforce, QQ = yK.get, xc = An.Int8Array, _m = xc && xc.prototype, Cw = An.Uint8ClampedArray, Fw = Cw && Cw.prototype, Di = xc && Mp(xc), ki = _m && Mp(_m), JQ = Object.prototype, TV = An.TypeError, Kw = zQ("toStringTag"), $m = GQ("TYPED_ARRAY_TAG"), Ec = "TypedArrayConstructor", qa = LQ && !!Nu && RV(An.opera) !== "Opera", qK = !1, Kn, ja, Go, ba = {
  Int8Array: 1,
  Uint8Array: 1,
  Uint8ClampedArray: 1,
  Int16Array: 2,
  Uint16Array: 2,
  Int32Array: 4,
  Uint32Array: 4,
  Float32Array: 4,
  Float64Array: 8
}, UV = {
  BigInt64Array: 8,
  BigUint64Array: 8
}, HQ = function(t) {
  if (!Zp(t))
    return !1;
  var r = RV(t);
  return r === "DataView" || fs(ba, r) || fs(UV, r);
}, bK = function(e) {
  var t = Mp(e);
  if (Zp(t)) {
    var r = QQ(t);
    return r && fs(r, Ec) ? r[Ec] : bK(t);
  }
}, AK = function(e) {
  if (!Zp(e))
    return !1;
  var t = RV(e);
  return fs(ba, t) || fs(UV, t);
}, _Q = function(e) {
  if (AK(e))
    return e;
  throw TV("Target is not a typed array");
}, $Q = function(e) {
  if (gK(e) && (!Nu || YQ(Di, e)))
    return e;
  throw TV(ZQ(e) + " is not a typed array constructor");
}, eJ = function(e, t, r, n) {
  if (KV) {
    if (r)
      for (var i in ba) {
        var a = An[i];
        if (a && fs(a.prototype, e))
          try {
            delete a.prototype[e];
          } catch {
            try {
              a.prototype[e] = t;
            } catch {
            }
          }
      }
    (!ki[e] || r) && Hm(ki, e, r ? t : qa && _m[e] || t, n);
  }
}, tJ = function(e, t, r) {
  var n, i;
  if (KV) {
    if (Nu) {
      if (r) {
        for (n in ba)
          if (i = An[n], i && fs(i, e))
            try {
              delete i[e];
            } catch {
            }
      }
      if (!Di[e] || r)
        try {
          return Hm(Di, e, r ? t : qa && Di[e] || t);
        } catch {
        }
      else
        return;
    }
    for (n in ba)
      i = An[n], i && (!i[e] || r) && Hm(i, e, t);
  }
};
for (Kn in ba)
  ja = An[Kn], Go = ja && ja.prototype, Go ? VK(Go)[Ec] = ja : qa = !1;
for (Kn in UV)
  ja = An[Kn], Go = ja && ja.prototype, Go && (VK(Go)[Ec] = ja);
if ((!qa || !gK(Di) || Di === Function.prototype) && (Di = function() {
  throw TV("Incorrect invocation");
}, qa))
  for (Kn in ba)
    An[Kn] && Nu(An[Kn], Di);
if ((!qa || !ki || ki === JQ) && (ki = Di.prototype, qa))
  for (Kn in ba)
    An[Kn] && Nu(An[Kn].prototype, ki);
qa && Mp(Fw) !== ki && Nu(Fw, ki);
if (KV && !fs(ki, Kw)) {
  qK = !0, jQ(ki, Kw, {
    configurable: !0,
    get: function() {
      return Zp(this) ? this[$m] : void 0;
    }
  });
  for (Kn in ba)
    An[Kn] && MQ(An[Kn], $m, Kn);
}
var pr = {
  NATIVE_ARRAY_BUFFER_VIEWS: qa,
  TYPED_ARRAY_TAG: qK && $m,
  aTypedArray: _Q,
  aTypedArrayConstructor: $Q,
  exportTypedArrayMethod: eJ,
  exportTypedArrayStaticMethod: tJ,
  getTypedArrayConstructor: bK,
  isView: HQ,
  isTypedArray: AK,
  TypedArray: Di,
  TypedArrayPrototype: ki
}, wK = Xt, zh = St, rJ = Cp, nJ = pr.NATIVE_ARRAY_BUFFER_VIEWS, iJ = wK.ArrayBuffer, Cs = wK.Int8Array, aJ = !nJ || !zh(function() {
  Cs(1);
}) || !zh(function() {
  new Cs(-1);
}) || !rJ(function(e) {
  new Cs(), new Cs(null), new Cs(1.5), new Cs(e);
}, !0) || zh(function() {
  return new Cs(new iJ(2), 1, void 0).length !== 1;
}), sJ = _i, oJ = Sa, uJ = RangeError, kK = function(e) {
  if (e === void 0)
    return 0;
  var t = sJ(e), r = oJ(t);
  if (t !== r)
    throw uJ("Wrong length or index");
  return r;
}, fJ = Math.sign || function(t) {
  var r = +t;
  return r === 0 || r !== r ? r : r < 0 ? -1 : 1;
}, lJ = fJ, dJ = yS, cJ = Array, WK = Math.abs, la = Math.pow, pJ = Math.floor, vJ = Math.log, hJ = Math.LN2, Rw = function(e) {
  var t = dJ(e), r = WK(e - t);
  return r > 0.5 || r === 0.5 && t % 2 !== 0 ? t + lJ(e) : t;
}, mJ = function(e, t, r) {
  var n = cJ(r), i = r * 8 - t - 1, a = (1 << i) - 1, s = a >> 1, o = t === 23 ? la(2, -24) - la(2, -77) : 0, u = e < 0 || e === 0 && 1 / e < 0 ? 1 : 0, f = 0, l, d, c;
  for (e = WK(e), e !== e || e === 1 / 0 ? (d = e !== e ? 1 : 0, l = a) : (l = pJ(vJ(e) / hJ), c = la(2, -l), e * c < 1 && (l--, c *= 2), l + s >= 1 ? e += o / c : e += o * la(2, 1 - s), e * c >= 2 && (l++, c /= 2), l + s >= a ? (d = 0, l = a) : l + s >= 1 ? (d = Rw((e * c - 1) * la(2, t)), l += s) : (d = Rw(e * la(2, s - 1) * la(2, t)), l = 0)); t >= 8; )
    n[f++] = d & 255, d /= 256, t -= 8;
  for (l = l << t | d, i += t; i > 0; )
    n[f++] = l & 255, l /= 256, i -= 8;
  return n[--f] |= u * 128, n;
}, gJ = function(e, t) {
  var r = e.length, n = r * 8 - t - 1, i = (1 << n) - 1, a = i >> 1, s = n - 7, o = r - 1, u = e[o--], f = u & 127, l;
  for (u >>= 7; s > 0; )
    f = f * 256 + e[o--], s -= 8;
  for (l = f & (1 << -s) - 1, f >>= -s, s += t; s > 0; )
    l = l * 256 + e[o--], s -= 8;
  if (f === 0)
    f = 1 - a;
  else {
    if (f === i)
      return l ? NaN : u ? -1 / 0 : 1 / 0;
    l += la(2, t), f -= a;
  }
  return (u ? -1 : 1) * l * la(2, f - t);
}, yJ = {
  pack: mJ,
  unpack: gJ
}, VJ = hn, Tw = eo, qJ = on, SK = function(t) {
  for (var r = VJ(this), n = qJ(r), i = arguments.length, a = Tw(i > 1 ? arguments[1] : void 0, n), s = i > 2 ? arguments[2] : void 0, o = s === void 0 ? n : Tw(s, n); o > a; )
    r[a++] = t;
  return r;
}, jp = Xt, xV = Kt, Gh = Ar, bJ = mK, CK = Vl, Uw = Wa, AJ = $i, xw = Bp, Qh = St, kd = vs, wJ = _i, kJ = Sa, Oc = kK, FK = yJ, WJ = Ol, Ew = Uu, SJ = ls.f, CJ = SK, FJ = kl, KK = Ca, EV = jn, KJ = CK.PROPER, Ow = CK.CONFIGURABLE, Qo = "ArrayBuffer", Yp = "DataView", Jo = "prototype", RJ = "Wrong length", RK = "Wrong index", Nw = EV.getterFor(Qo), If = EV.getterFor(Yp), Iw = EV.set, ni = jp[Qo], En = ni, qo = En && En[Jo], Ni = jp[Yp], Fs = Ni && Ni[Jo], Xw = Object.prototype, TJ = jp.Array, Nc = jp.RangeError, UJ = xV(CJ), xJ = xV([].reverse), TK = FK.pack, Pw = FK.unpack, Bw = function(e) {
  return [e & 255];
}, Dw = function(e) {
  return [e & 255, e >> 8 & 255];
}, Lw = function(e) {
  return [e & 255, e >> 8 & 255, e >> 16 & 255, e >> 24 & 255];
}, Zw = function(e) {
  return e[3] << 24 | e[2] << 16 | e[1] << 8 | e[0];
}, EJ = function(e) {
  return TK(e, 23, 4);
}, OJ = function(e) {
  return TK(e, 52, 8);
}, Wd = function(e, t, r) {
  AJ(e[Jo], t, {
    configurable: !0,
    get: function() {
      return r(this)[t];
    }
  });
}, Ba = function(e, t, r, n) {
  var i = If(e), a = Oc(r), s = !!n;
  if (a + t > i.byteLength)
    throw Nc(RK);
  var o = i.bytes, u = a + i.byteOffset, f = FJ(o, u, u + t);
  return s ? f : xJ(f);
}, Da = function(e, t, r, n, i, a) {
  var s = If(e), o = Oc(r), u = n(+i), f = !!a;
  if (o + t > s.byteLength)
    throw Nc(RK);
  for (var l = s.bytes, d = o + s.byteOffset, c = 0; c < t; c++)
    l[d + c] = u[f ? c : t - c - 1];
};
if (!bJ)
  En = function(t) {
    kd(this, qo);
    var r = Oc(t);
    Iw(this, {
      type: Qo,
      bytes: UJ(TJ(r), 0),
      byteLength: r
    }), Gh || (this.byteLength = r, this.detached = !1);
  }, qo = En[Jo], Ni = function(t, r, n) {
    kd(this, Fs), kd(t, qo);
    var i = Nw(t), a = i.byteLength, s = wJ(r);
    if (s < 0 || s > a)
      throw Nc("Wrong offset");
    if (n = n === void 0 ? a - s : kJ(n), s + n > a)
      throw Nc(RJ);
    Iw(this, {
      type: Yp,
      buffer: t,
      byteLength: n,
      byteOffset: s,
      bytes: i.bytes
    }), Gh || (this.buffer = t, this.byteLength = n, this.byteOffset = s);
  }, Fs = Ni[Jo], Gh && (Wd(En, "byteLength", Nw), Wd(Ni, "buffer", If), Wd(Ni, "byteLength", If), Wd(Ni, "byteOffset", If)), xw(Fs, {
    getInt8: function(t) {
      return Ba(this, 1, t)[0] << 24 >> 24;
    },
    getUint8: function(t) {
      return Ba(this, 1, t)[0];
    },
    getInt16: function(t) {
      var r = Ba(this, 2, t, arguments.length > 1 ? arguments[1] : !1);
      return (r[1] << 8 | r[0]) << 16 >> 16;
    },
    getUint16: function(t) {
      var r = Ba(this, 2, t, arguments.length > 1 ? arguments[1] : !1);
      return r[1] << 8 | r[0];
    },
    getInt32: function(t) {
      return Zw(Ba(this, 4, t, arguments.length > 1 ? arguments[1] : !1));
    },
    getUint32: function(t) {
      return Zw(Ba(this, 4, t, arguments.length > 1 ? arguments[1] : !1)) >>> 0;
    },
    getFloat32: function(t) {
      return Pw(Ba(this, 4, t, arguments.length > 1 ? arguments[1] : !1), 23);
    },
    getFloat64: function(t) {
      return Pw(Ba(this, 8, t, arguments.length > 1 ? arguments[1] : !1), 52);
    },
    setInt8: function(t, r) {
      Da(this, 1, t, Bw, r);
    },
    setUint8: function(t, r) {
      Da(this, 1, t, Bw, r);
    },
    setInt16: function(t, r) {
      Da(this, 2, t, Dw, r, arguments.length > 2 ? arguments[2] : !1);
    },
    setUint16: function(t, r) {
      Da(this, 2, t, Dw, r, arguments.length > 2 ? arguments[2] : !1);
    },
    setInt32: function(t, r) {
      Da(this, 4, t, Lw, r, arguments.length > 2 ? arguments[2] : !1);
    },
    setUint32: function(t, r) {
      Da(this, 4, t, Lw, r, arguments.length > 2 ? arguments[2] : !1);
    },
    setFloat32: function(t, r) {
      Da(this, 4, t, EJ, r, arguments.length > 2 ? arguments[2] : !1);
    },
    setFloat64: function(t, r) {
      Da(this, 8, t, OJ, r, arguments.length > 2 ? arguments[2] : !1);
    }
  });
else {
  var Mw = KJ && ni.name !== Qo;
  if (!Qh(function() {
    ni(1);
  }) || !Qh(function() {
    new ni(-1);
  }) || Qh(function() {
    return new ni(), new ni(1.5), new ni(NaN), ni.length !== 1 || Mw && !Ow;
  })) {
    En = function(t) {
      return kd(this, qo), new ni(Oc(t));
    }, En[Jo] = qo;
    for (var jw = SJ(ni), Yw = 0, Jh; jw.length > Yw; )
      (Jh = jw[Yw++]) in En || Uw(En, Jh, ni[Jh]);
    qo.constructor = En;
  } else
    Mw && Ow && Uw(ni, "name", Qo);
  Ew && WJ(Fs) !== Xw && Ew(Fs, Xw);
  var Sd = new Ni(new En(2)), zw = xV(Fs.setInt8);
  Sd.setInt8(0, 2147483648), Sd.setInt8(1, 2147483649), (Sd.getInt8(0) || !Sd.getInt8(1)) && xw(Fs, {
    setInt8: function(t, r) {
      zw(this, t, r << 24 >> 24);
    },
    setUint8: function(t, r) {
      zw(this, t, r << 24 >> 24);
    }
  }, { unsafe: !0 });
}
KK(En, Qo);
KK(Ni, Yp);
var UK = {
  ArrayBuffer: En,
  DataView: Ni
}, NJ = _i, IJ = RangeError, XJ = function(e) {
  var t = NJ(e);
  if (t < 0)
    throw IJ("The argument can't be less than 0");
  return t;
}, PJ = XJ, BJ = RangeError, xK = function(e, t) {
  var r = PJ(e);
  if (r % t)
    throw BJ("Wrong offset");
  return r;
}, DJ = Math.round, LJ = function(e) {
  var t = DJ(e);
  return t < 0 ? 0 : t > 255 ? 255 : t & 255;
}, ZJ = Fa, MJ = function(e) {
  var t = ZJ(e);
  return t === "BigInt64Array" || t === "BigUint64Array";
}, jJ = ky, YJ = TypeError, EK = function(e) {
  var t = jJ(e, "number");
  if (typeof t == "number")
    throw YJ("Can't convert number to bigint");
  return BigInt(t);
}, zJ = Ka, GJ = fr, QJ = Ty, JJ = hn, HJ = on, _J = Sp, $J = Ul, eH = Hy, tH = MJ, rH = pr.aTypedArrayConstructor, nH = EK, iH = function(t) {
  var r = QJ(this), n = JJ(t), i = arguments.length, a = i > 1 ? arguments[1] : void 0, s = a !== void 0, o = $J(n), u, f, l, d, c, p, v, h;
  if (o && !eH(o))
    for (v = _J(n, o), h = v.next, n = []; !(p = GJ(h, v)).done; )
      n.push(p.value);
  for (s && i > 2 && (a = zJ(a, arguments[2])), f = HJ(n), l = new (rH(r))(f), d = tH(l), u = 0; f > u; u++)
    c = s ? a(n[u], u) : n[u], l[u] = d ? nH(c) : +c;
  return l;
}, Gw = xt, OK = Xt, Qw = fr, aH = Ar, sH = aJ, Iu = pr, NK = UK, Jw = vs, oH = Js, df = Wa, uH = XF, fH = Sa, Hw = kK, Hh = xK, lH = LJ, IK = yl, cf = Tr, dH = Fa, eg = Rr, cH = Fu, pH = cs, vH = ka, Cd = Uu, hH = ls.f, _w = iH, mH = Un.forEach, gH = wp, yH = $i, XK = wn, PK = Qi, OV = jn, VH = sV, tg = OV.get, qH = OV.set, bH = OV.enforce, BK = XK.f, AH = PK.f, _h = OK.RangeError, DK = NK.ArrayBuffer, wH = DK.prototype, kH = NK.DataView, Fd = Iu.NATIVE_ARRAY_BUFFER_VIEWS, $w = Iu.TYPED_ARRAY_TAG, ek = Iu.TypedArray, pf = Iu.TypedArrayPrototype, WH = Iu.aTypedArrayConstructor, rg = Iu.isTypedArray, Kd = "BYTES_PER_ELEMENT", $h = "Wrong length", tk = function(e, t) {
  WH(e);
  for (var r = 0, n = t.length, i = new e(n); n > r; )
    i[r] = t[r++];
  return i;
}, Rd = function(e, t) {
  yH(e, t, {
    configurable: !0,
    get: function() {
      return tg(this)[t];
    }
  });
}, rk = function(e) {
  var t;
  return vH(wH, e) || (t = dH(e)) === "ArrayBuffer" || t === "SharedArrayBuffer";
}, LK = function(e, t) {
  return rg(e) && !cH(t) && t in e && uH(+t) && t >= 0;
}, nk = function(t, r) {
  return r = IK(r), LK(t, r) ? oH(2, t[r]) : AH(t, r);
}, ik = function(t, r, n) {
  return r = IK(r), LK(t, r) && eg(n) && cf(n, "value") && !cf(n, "get") && !cf(n, "set") && !n.configurable && (!cf(n, "writable") || n.writable) && (!cf(n, "enumerable") || n.enumerable) ? (t[r] = n.value, t) : BK(t, r, n);
};
aH ? (Fd || (PK.f = nk, XK.f = ik, Rd(pf, "buffer"), Rd(pf, "byteOffset"), Rd(pf, "byteLength"), Rd(pf, "length")), Gw({ target: "Object", stat: !0, forced: !Fd }, {
  getOwnPropertyDescriptor: nk,
  defineProperty: ik
}), Jm.exports = function(e, t, r) {
  var n = e.match(/\d+/)[0] / 8, i = e + (r ? "Clamped" : "") + "Array", a = "get" + e, s = "set" + e, o = OK[i], u = o, f = u && u.prototype, l = {}, d = function(h, m) {
    var q = tg(h);
    return q.view[a](m * n + q.byteOffset, !0);
  }, c = function(h, m, q) {
    var w = tg(h);
    w.view[s](m * n + w.byteOffset, r ? lH(q) : q, !0);
  }, p = function(h, m) {
    BK(h, m, {
      get: function() {
        return d(this, m);
      },
      set: function(q) {
        return c(this, m, q);
      },
      enumerable: !0
    });
  };
  Fd ? sH && (u = t(function(h, m, q, w) {
    return Jw(h, f), VH(function() {
      return eg(m) ? rk(m) ? w !== void 0 ? new o(m, Hh(q, n), w) : q !== void 0 ? new o(m, Hh(q, n)) : new o(m) : rg(m) ? tk(u, m) : Qw(_w, u, m) : new o(Hw(m));
    }(), h, u);
  }), Cd && Cd(u, ek), mH(hH(o), function(h) {
    h in u || df(u, h, o[h]);
  }), u.prototype = f) : (u = t(function(h, m, q, w) {
    Jw(h, f);
    var O = 0, C = 0, R, I, P;
    if (!eg(m))
      P = Hw(m), I = P * n, R = new DK(I);
    else if (rk(m)) {
      R = m, C = Hh(q, n);
      var K = m.byteLength;
      if (w === void 0) {
        if (K % n || (I = K - C, I < 0))
          throw _h($h);
      } else if (I = fH(w) * n, I + C > K)
        throw _h($h);
      P = I / n;
    } else
      return rg(m) ? tk(u, m) : Qw(_w, u, m);
    for (qH(h, {
      buffer: R,
      byteOffset: C,
      byteLength: I,
      length: P,
      view: new kH(R)
    }); O < P; )
      p(h, O++);
  }), Cd && Cd(u, ek), f = u.prototype = pH(pf)), f.constructor !== u && df(f, "constructor", u), bH(f).TypedArrayConstructor = u, $w && df(f, $w, i);
  var v = u !== o;
  l[i] = u, Gw({ global: !0, constructor: !0, forced: v, sham: !Fd }, l), Kd in u || df(u, Kd, n), Kd in f || df(f, Kd, n), gH(i);
}) : Jm.exports = function() {
};
var SH = Jm.exports, CH = SH;
CH("Uint8", function(e) {
  return function(r, n, i) {
    return e(this, r, n, i);
  };
});
var ak = _s, FH = TypeError, NV = function(e, t) {
  if (!delete e[t])
    throw FH("Cannot delete property " + ak(t) + " of " + ak(e));
}, KH = hn, e1 = eo, RH = on, TH = NV, UH = Math.min, xH = [].copyWithin || function(t, r) {
  var n = KH(this), i = RH(n), a = e1(t, i), s = e1(r, i), o = arguments.length > 2 ? arguments[2] : void 0, u = UH((o === void 0 ? i : e1(o, i)) - s, i - a), f = 1;
  for (s < a && a < s + u && (f = -1, s += u - 1, a += u - 1); u-- > 0; )
    s in n ? n[a] = n[s] : TH(n, a), a += f, s += f;
  return n;
}, EH = Kt, ZK = pr, OH = xH, NH = EH(OH), IH = ZK.aTypedArray, XH = ZK.exportTypedArrayMethod;
XH("copyWithin", function(t, r) {
  return NH(IH(this), t, r, arguments.length > 2 ? arguments[2] : void 0);
});
var MK = pr, PH = Un.every, BH = MK.aTypedArray, DH = MK.exportTypedArrayMethod;
DH("every", function(t) {
  return PH(BH(this), t, arguments.length > 1 ? arguments[1] : void 0);
});
var jK = pr, LH = SK, ZH = EK, MH = Fa, jH = fr, YH = Kt, zH = St, GH = jK.aTypedArray, QH = jK.exportTypedArrayMethod, JH = YH("".slice), HH = zH(function() {
  var e = 0;
  return new Int8Array(2).fill({ valueOf: function() {
    return e++;
  } }), e !== 1;
});
QH("fill", function(t) {
  var r = arguments.length;
  GH(this);
  var n = JH(MH(this), 0, 3) === "Big" ? ZH(t) : +t;
  return jH(LH, this, n, r > 1 ? arguments[1] : void 0, r > 2 ? arguments[2] : void 0);
}, HH);
var _H = on, $H = function(e, t) {
  for (var r = 0, n = _H(t), i = new e(n); n > r; )
    i[r] = t[r++];
  return i;
}, YK = pr, e_ = Zy, t_ = YK.aTypedArrayConstructor, r_ = YK.getTypedArrayConstructor, zp = function(e) {
  return t_(e_(e, r_(e)));
}, n_ = $H, i_ = zp, a_ = function(e, t) {
  return n_(i_(e), t);
}, zK = pr, s_ = Un.filter, o_ = a_, u_ = zK.aTypedArray, f_ = zK.exportTypedArrayMethod;
f_("filter", function(t) {
  var r = s_(u_(this), t, arguments.length > 1 ? arguments[1] : void 0);
  return o_(this, r);
});
var GK = pr, l_ = Un.find, d_ = GK.aTypedArray, c_ = GK.exportTypedArrayMethod;
c_("find", function(t) {
  return l_(d_(this), t, arguments.length > 1 ? arguments[1] : void 0);
});
var QK = pr, p_ = Un.findIndex, v_ = QK.aTypedArray, h_ = QK.exportTypedArrayMethod;
h_("findIndex", function(t) {
  return p_(v_(this), t, arguments.length > 1 ? arguments[1] : void 0);
});
var JK = pr, m_ = Un.forEach, g_ = JK.aTypedArray, y_ = JK.exportTypedArrayMethod;
y_("forEach", function(t) {
  m_(g_(this), t, arguments.length > 1 ? arguments[1] : void 0);
});
var HK = pr, V_ = pp.includes, q_ = HK.aTypedArray, b_ = HK.exportTypedArrayMethod;
b_("includes", function(t) {
  return V_(q_(this), t, arguments.length > 1 ? arguments[1] : void 0);
});
var _K = pr, A_ = pp.indexOf, w_ = _K.aTypedArray, k_ = _K.exportTypedArrayMethod;
k_("indexOf", function(t) {
  return A_(w_(this), t, arguments.length > 1 ? arguments[1] : void 0);
});
var W_ = Xt, S_ = St, IV = Kt, $K = pr, XV = lF, C_ = lr, PV = C_("iterator"), sk = W_.Uint8Array, F_ = IV(XV.values), K_ = IV(XV.keys), R_ = IV(XV.entries), BV = $K.aTypedArray, Gp = $K.exportTypedArrayMethod, Eo = sk && sk.prototype, Qp = !S_(function() {
  Eo[PV].call([1]);
}), e9 = !!Eo && Eo.values && Eo[PV] === Eo.values && Eo.values.name === "values", t9 = function() {
  return F_(BV(this));
};
Gp("entries", function() {
  return R_(BV(this));
}, Qp);
Gp("keys", function() {
  return K_(BV(this));
}, Qp);
Gp("values", t9, Qp || !e9, { name: "values" });
Gp(PV, t9, Qp || !e9, { name: "values" });
var r9 = pr, T_ = Kt, U_ = r9.aTypedArray, x_ = r9.exportTypedArrayMethod, E_ = T_([].join);
x_("join", function(t) {
  return E_(U_(this), t);
});
var O_ = ds, N_ = Mn, I_ = _i, X_ = on, P_ = Fp, B_ = Math.min, ng = [].lastIndexOf, n9 = !!ng && 1 / [1].lastIndexOf(1, -0) < 0, D_ = P_("lastIndexOf"), L_ = n9 || !D_, Z_ = L_ ? function(t) {
  if (n9)
    return O_(ng, this, arguments) || 0;
  var r = N_(this), n = X_(r), i = n - 1;
  for (arguments.length > 1 && (i = B_(i, I_(arguments[1]))), i < 0 && (i = n + i); i >= 0; i--)
    if (i in r && r[i] === t)
      return i || 0;
  return -1;
} : ng, i9 = pr, M_ = ds, j_ = Z_, Y_ = i9.aTypedArray, z_ = i9.exportTypedArrayMethod;
z_("lastIndexOf", function(t) {
  var r = arguments.length;
  return M_(j_, Y_(this), r > 1 ? [t, arguments[1]] : [t]);
});
var a9 = pr, G_ = Un.map, Q_ = zp, J_ = a9.aTypedArray, H_ = a9.exportTypedArrayMethod;
H_("map", function(t) {
  return G_(J_(this), t, arguments.length > 1 ? arguments[1] : void 0, function(r, n) {
    return new (Q_(r))(n);
  });
});
var __ = li, $_ = hn, e$ = ml, t$ = on, r$ = TypeError, ok = function(e) {
  return function(t, r, n, i) {
    __(r);
    var a = $_(t), s = e$(a), o = t$(a), u = e ? o - 1 : 0, f = e ? -1 : 1;
    if (n < 2)
      for (; ; ) {
        if (u in s) {
          i = s[u], u += f;
          break;
        }
        if (u += f, e ? u < 0 : o <= u)
          throw r$("Reduce of empty array with no initial value");
      }
    for (; e ? u >= 0 : o > u; u += f)
      u in s && (i = r(i, s[u], u, a));
    return i;
  };
}, s9 = {
  // `Array.prototype.reduce` method
  // https://tc39.es/ecma262/#sec-array.prototype.reduce
  left: ok(!1),
  // `Array.prototype.reduceRight` method
  // https://tc39.es/ecma262/#sec-array.prototype.reduceright
  right: ok(!0)
}, o9 = pr, n$ = s9.left, i$ = o9.aTypedArray, a$ = o9.exportTypedArrayMethod;
a$("reduce", function(t) {
  var r = arguments.length;
  return n$(i$(this), t, r, r > 1 ? arguments[1] : void 0);
});
var u9 = pr, s$ = s9.right, o$ = u9.aTypedArray, u$ = u9.exportTypedArrayMethod;
u$("reduceRight", function(t) {
  var r = arguments.length;
  return s$(o$(this), t, r, r > 1 ? arguments[1] : void 0);
});
var f9 = pr, f$ = f9.aTypedArray, l$ = f9.exportTypedArrayMethod, d$ = Math.floor;
l$("reverse", function() {
  for (var t = this, r = f$(t).length, n = d$(r / 2), i = 0, a; i < n; )
    a = t[i], t[i++] = t[--r], t[r] = a;
  return t;
});
var l9 = Xt, d9 = fr, DV = pr, c$ = on, p$ = xK, v$ = hn, c9 = St, h$ = l9.RangeError, ig = l9.Int8Array, uk = ig && ig.prototype, p9 = uk && uk.set, m$ = DV.aTypedArray, g$ = DV.exportTypedArrayMethod, ag = !c9(function() {
  var e = new Uint8ClampedArray(2);
  return d9(p9, e, { length: 1, 0: 3 }, 1), e[1] !== 3;
}), y$ = ag && DV.NATIVE_ARRAY_BUFFER_VIEWS && c9(function() {
  var e = new ig(2);
  return e.set(1), e.set("2", 1), e[0] !== 0 || e[1] !== 2;
});
g$("set", function(t) {
  m$(this);
  var r = p$(arguments.length > 1 ? arguments[1] : void 0, 1), n = v$(t);
  if (ag)
    return d9(p9, this, n, r);
  var i = this.length, a = c$(n), s = 0;
  if (a + r > i)
    throw h$("Wrong length");
  for (; s < a; )
    this[r + s] = n[s++];
}, !ag || y$);
var v9 = pr, V$ = zp, q$ = St, b$ = Ru, A$ = v9.aTypedArray, w$ = v9.exportTypedArrayMethod, k$ = q$(function() {
  new Int8Array(1).slice();
});
w$("slice", function(t, r) {
  for (var n = b$(A$(this), t, r), i = V$(this), a = 0, s = n.length, o = new i(s); s > a; )
    o[a] = n[a++];
  return o;
}, k$);
var h9 = pr, W$ = Un.some, S$ = h9.aTypedArray, C$ = h9.exportTypedArrayMethod;
C$("some", function(t) {
  return W$(S$(this), t, arguments.length > 1 ? arguments[1] : void 0);
});
var fk = kl, F$ = Math.floor, sg = function(e, t) {
  var r = e.length, n = F$(r / 2);
  return r < 8 ? K$(e, t) : R$(
    e,
    sg(fk(e, 0, n), t),
    sg(fk(e, n), t),
    t
  );
}, K$ = function(e, t) {
  for (var r = e.length, n = 1, i, a; n < r; ) {
    for (a = n, i = e[n]; a && t(e[a - 1], i) > 0; )
      e[a] = e[--a];
    a !== n++ && (e[a] = i);
  }
  return e;
}, R$ = function(e, t, r, n) {
  for (var i = t.length, a = r.length, s = 0, o = 0; s < i || o < a; )
    e[s + o] = s < i && o < a ? n(t[s], r[o]) <= 0 ? t[s++] : r[o++] : s < i ? t[s++] : r[o++];
  return e;
}, LV = sg, T$ = Hs, lk = T$.match(/firefox\/(\d+)/i), m9 = !!lk && +lk[1], U$ = Hs, g9 = /MSIE|Trident/.test(U$), x$ = Hs, dk = x$.match(/AppleWebKit\/(\d+)\./), y9 = !!dk && +dk[1], E$ = Xt, O$ = mp, og = St, N$ = li, I$ = LV, V9 = pr, ck = m9, X$ = g9, pk = Su, vk = y9, P$ = V9.aTypedArray, B$ = V9.exportTypedArrayMethod, tl = E$.Uint16Array, Ho = tl && O$(tl.prototype.sort), D$ = !!Ho && !(og(function() {
  Ho(new tl(2), null);
}) && og(function() {
  Ho(new tl(2), {});
})), hk = !!Ho && !og(function() {
  if (pk)
    return pk < 74;
  if (ck)
    return ck < 67;
  if (X$)
    return !0;
  if (vk)
    return vk < 602;
  var e = new tl(516), t = Array(516), r, n;
  for (r = 0; r < 516; r++)
    n = r % 4, e[r] = 515 - r, t[r] = r - 2 * n + 3;
  for (Ho(e, function(i, a) {
    return (i / 4 | 0) - (a / 4 | 0);
  }), r = 0; r < 516; r++)
    if (e[r] !== t[r])
      return !0;
}), L$ = function(e) {
  return function(t, r) {
    return e !== void 0 ? +e(t, r) || 0 : r !== r ? -1 : t !== t ? 1 : t === 0 && r === 0 ? 1 / t > 0 && 1 / r < 0 ? 1 : -1 : t > r;
  };
};
B$("sort", function(t) {
  return t !== void 0 && N$(t), hk ? Ho(this, t) : I$(P$(this), L$(t));
}, !hk || D$);
var q9 = pr, Z$ = Sa, mk = eo, M$ = zp, j$ = q9.aTypedArray, Y$ = q9.exportTypedArrayMethod;
Y$("subarray", function(t, r) {
  var n = j$(this), i = n.length, a = mk(t, i), s = M$(n);
  return new s(
    n.buffer,
    n.byteOffset + a * n.BYTES_PER_ELEMENT,
    Z$((r === void 0 ? i : mk(r, i)) - a)
  );
});
var z$ = Xt, G$ = ds, b9 = pr, ug = St, gk = Ru, Ic = z$.Int8Array, yk = b9.aTypedArray, Q$ = b9.exportTypedArrayMethod, A9 = [].toLocaleString, J$ = !!Ic && ug(function() {
  A9.call(new Ic(1));
}), H$ = ug(function() {
  return [1, 2].toLocaleString() !== new Ic([1, 2]).toLocaleString();
}) || !ug(function() {
  Ic.prototype.toLocaleString.call([1, 2]);
});
Q$("toLocaleString", function() {
  return G$(
    A9,
    J$ ? gk(yk(this)) : yk(this),
    gk(arguments)
  );
}, H$);
var _$ = pr.exportTypedArrayMethod, $$ = St, eee = Xt, tee = Kt, Vk = eee.Uint8Array, ree = Vk && Vk.prototype || {}, Xc = [].toString, nee = tee([].join);
$$(function() {
  Xc.call({});
}) && (Xc = function() {
  return nee(this);
});
var iee = ree.toString !== Xc;
_$("toString", Xc, iee);
var aee = Rr, see = Ji, oee = lr, uee = oee("match"), w9 = function(e) {
  var t;
  return aee(e) && ((t = e[uee]) !== void 0 ? !!t : see(e) === "RegExp");
}, fee = ds, vf = fr, ZV = Kt, lee = xp, dee = Or, cee = Ri, pee = w9, qk = Hi, vee = Zy, hee = cV, mee = Sa, t1 = $r, gee = $s, bk = kl, Ak = Ep, yee = Up, Vee = qF, qee = St, bo = Vee.UNSUPPORTED_Y, wk = 4294967295, bee = Math.min, k9 = [].push, Aee = ZV(/./.exec), Ao = ZV(k9), hf = ZV("".slice), wee = !qee(function() {
  var e = /(?:)/, t = e.exec;
  e.exec = function() {
    return t.apply(this, arguments);
  };
  var r = "ab".split(e);
  return r.length !== 2 || r[0] !== "a" || r[1] !== "b";
});
lee("split", function(e, t, r) {
  var n;
  return "abbc".split(/(b)*/)[1] === "c" || // eslint-disable-next-line regexp/no-empty-group -- required for testing
  "test".split(/(?:)/, -1).length !== 4 || "ab".split(/(?:ab)*/).length !== 2 || ".".split(/(.?)(.?)/).length !== 4 || // eslint-disable-next-line regexp/no-empty-capturing-group, regexp/no-empty-group -- required for testing
  ".".split(/()()/).length > 1 || "".split(/.?/).length ? n = function(i, a) {
    var s = t1(qk(this)), o = a === void 0 ? wk : a >>> 0;
    if (o === 0)
      return [];
    if (i === void 0)
      return [s];
    if (!pee(i))
      return vf(t, s, i, o);
    for (var u = [], f = (i.ignoreCase ? "i" : "") + (i.multiline ? "m" : "") + (i.unicode ? "u" : "") + (i.sticky ? "y" : ""), l = 0, d = new RegExp(i.source, f + "g"), c, p, v; (c = vf(yee, d, s)) && (p = d.lastIndex, !(p > l && (Ao(u, hf(s, l, c.index)), c.length > 1 && c.index < s.length && fee(k9, u, bk(c, 1)), v = c[0].length, l = p, u.length >= o))); )
      d.lastIndex === c.index && d.lastIndex++;
    return l === s.length ? (v || !Aee(d, "")) && Ao(u, "") : Ao(u, hf(s, l)), u.length > o ? bk(u, 0, o) : u;
  } : "0".split(void 0, 0).length ? n = function(i, a) {
    return i === void 0 && a === 0 ? [] : vf(t, this, i, a);
  } : n = t, [
    // `String.prototype.split` method
    // https://tc39.es/ecma262/#sec-string.prototype.split
    function(a, s) {
      var o = qk(this), u = cee(a) ? void 0 : gee(a, e);
      return u ? vf(u, a, o, s) : vf(n, t1(o), a, s);
    },
    // `RegExp.prototype[@@split]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@split
    //
    // NOTE: This cannot be properly polyfilled in engines that don't support
    // the 'y' flag.
    function(i, a) {
      var s = dee(this), o = t1(i), u = r(n, s, o, a, n !== t);
      if (u.done)
        return u.value;
      var f = vee(s, RegExp), l = s.unicode, d = (s.ignoreCase ? "i" : "") + (s.multiline ? "m" : "") + (s.unicode ? "u" : "") + (bo ? "g" : "y"), c = new f(bo ? "^(?:" + s.source + ")" : s, d), p = a === void 0 ? wk : a >>> 0;
      if (p === 0)
        return [];
      if (o.length === 0)
        return Ak(c, o) === null ? [o] : [];
      for (var v = 0, h = 0, m = []; h < o.length; ) {
        c.lastIndex = bo ? 0 : h;
        var q = Ak(c, bo ? hf(o, h) : o), w;
        if (q === null || (w = bee(mee(c.lastIndex + (bo ? h : 0)), o.length)) === v)
          h = hee(o, h, l);
        else {
          if (Ao(m, hf(o, v, h)), m.length === p)
            return m;
          for (var O = 1; O <= q.length - 1; O++)
            if (Ao(m, q[O]), m.length === p)
              return m;
          h = v = w;
        }
      }
      return Ao(m, hf(o, v)), m;
    }
  ];
}, !wee, bo);
var W9 = { exports: {} }, S9 = { exports: {} };
(function(e) {
  function t(r) {
    return Function.toString.call(r).indexOf("[native code]") !== -1;
  }
  e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
})(S9);
var kee = S9.exports, C9 = { exports: {} }, F9 = { exports: {} };
(function(e) {
  function t() {
    if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
      return !1;
    if (typeof Proxy == "function")
      return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      })), !0;
    } catch {
      return !1;
    }
  }
  e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
})(F9);
var Wee = F9.exports;
(function(e) {
  var t = Ly, r = Wee;
  function n(i, a, s) {
    return r() ? (e.exports = n = Reflect.construct.bind(), e.exports.__esModule = !0, e.exports.default = e.exports) : (e.exports = n = function(u, f, l) {
      var d = [null];
      d.push.apply(d, f);
      var c = Function.bind.apply(u, d), p = new c();
      return l && t(p, l.prototype), p;
    }, e.exports.__esModule = !0, e.exports.default = e.exports), n.apply(null, arguments);
  }
  e.exports = n, e.exports.__esModule = !0, e.exports.default = e.exports;
})(C9);
var See = C9.exports;
(function(e) {
  var t = ci, r = Ly, n = kee, i = See;
  function a(s) {
    var o = typeof Map == "function" ? /* @__PURE__ */ new Map() : void 0;
    return e.exports = a = function(f) {
      if (f === null || !n(f))
        return f;
      if (typeof f != "function")
        throw new TypeError("Super expression must either be null or a function");
      if (typeof o < "u") {
        if (o.has(f))
          return o.get(f);
        o.set(f, l);
      }
      function l() {
        return i(f, arguments, t(this).constructor);
      }
      return l.prototype = Object.create(f.prototype, {
        constructor: {
          value: l,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), r(l, f);
    }, e.exports.__esModule = !0, e.exports.default = e.exports, a(s);
  }
  e.exports = a, e.exports.__esModule = !0, e.exports.default = e.exports;
})(W9);
var Jp = W9.exports, Pc = { exports: {} };
/*!
 * Platform.js v1.3.6
 * Copyright 2014-2020 Benjamin Tan
 * Copyright 2011-2013 John-David Dalton
 * Available under MIT license
 */
Pc.exports;
(function(e, t) {
  (function() {
    var r = {
      function: !0,
      object: !0
    }, n = r[typeof window] && window || this, i = t, a = e && !e.nodeType && e, s = i && a && typeof Xn == "object" && Xn;
    s && (s.global === s || s.window === s || s.self === s) && (n = s);
    var o = Math.pow(2, 53) - 1, u = /\bOpera/, f = Object.prototype, l = f.hasOwnProperty, d = f.toString;
    function c(K) {
      return K = String(K), K.charAt(0).toUpperCase() + K.slice(1);
    }
    function p(K, B, L) {
      var _ = {
        "10.0": "10",
        "6.4": "10 Technical Preview",
        "6.3": "8.1",
        "6.2": "8",
        "6.1": "Server 2008 R2 / 7",
        "6.0": "Server 2008 / Vista",
        "5.2": "Server 2003 / XP 64-bit",
        "5.1": "XP",
        "5.01": "2000 SP1",
        "5.0": "2000",
        "4.0": "NT",
        "4.90": "ME"
      };
      return B && L && /^Win/i.test(K) && !/^Windows Phone /i.test(K) && (_ = _[/[\d.]+$/.exec(K)]) && (K = "Windows " + _), K = String(K), B && L && (K = K.replace(RegExp(B, "i"), L)), K = h(
        K.replace(/ ce$/i, " CE").replace(/\bhpw/i, "web").replace(/\bMacintosh\b/, "Mac OS").replace(/_PowerPC\b/i, " OS").replace(/\b(OS X) [^ \d]+/i, "$1").replace(/\bMac (OS X)\b/, "$1").replace(/\/(\d)/, " $1").replace(/_/g, ".").replace(/(?: BePC|[ .]*fc[ \d.]+)$/i, "").replace(/\bx86\.64\b/gi, "x86_64").replace(/\b(Windows Phone) OS\b/, "$1").replace(/\b(Chrome OS \w+) [\d.]+\b/, "$1").split(" on ")[0]
      ), K;
    }
    function v(K, B) {
      var L = -1, _ = K ? K.length : 0;
      if (typeof _ == "number" && _ > -1 && _ <= o)
        for (; ++L < _; )
          B(K[L], L, K);
      else
        m(K, B);
    }
    function h(K) {
      return K = R(K), /^(?:webOS|i(?:OS|P))/.test(K) ? K : c(K);
    }
    function m(K, B) {
      for (var L in K)
        l.call(K, L) && B(K[L], L, K);
    }
    function q(K) {
      return K == null ? c(K) : d.call(K).slice(8, -1);
    }
    function w(K, B) {
      var L = K != null ? typeof K[B] : "number";
      return !/^(?:boolean|number|string|undefined)$/.test(L) && (L == "object" ? !!K[B] : !0);
    }
    function O(K) {
      return String(K).replace(/([ -])(?!$)/g, "$1?");
    }
    function C(K, B) {
      var L = null;
      return v(K, function(_, ne) {
        L = B(L, _, ne, K);
      }), L;
    }
    function R(K) {
      return String(K).replace(/^ +| +$/g, "");
    }
    function I(K) {
      var B = n, L = K && typeof K == "object" && q(K) != "String";
      L && (B = K, K = null);
      var _ = B.navigator || {}, ne = _.userAgent || "";
      K || (K = ne);
      var Z = L ? !!_.likeChrome : /\bChrome\b/.test(K) && !/internal|\n/i.test(d.toString()), le = "Object", he = L ? le : "ScriptBridgingProxyObject", Ie = L ? le : "Environment", xe = L && B.java ? "JavaPackage" : q(B.java), ye = L ? le : "RuntimeObject", ue = /\bJava/.test(xe) && B.java, M = ue && q(B.environment) == Ie, F = ue ? "a" : "α", pe = ue ? "b" : "β", We = B.document || {}, ce = B.operamini || B.opera, oe = u.test(oe = L && ce ? ce["[[Class]]"] : q(ce)) ? oe : ce = null, z, Ze = K, Ae = [], re = null, Qe = K == ne, Ee = Qe && ce && typeof ce.version == "function" && ce.version(), Ue, He = Bt([
        { label: "EdgeHTML", pattern: "Edge" },
        "Trident",
        { label: "WebKit", pattern: "AppleWebKit" },
        "iCab",
        "Presto",
        "NetFront",
        "Tasman",
        "KHTML",
        "Gecko"
      ]), te = Ot([
        "Adobe AIR",
        "Arora",
        "Avant Browser",
        "Breach",
        "Camino",
        "Electron",
        "Epiphany",
        "Fennec",
        "Flock",
        "Galeon",
        "GreenBrowser",
        "iCab",
        "Iceweasel",
        "K-Meleon",
        "Konqueror",
        "Lunascape",
        "Maxthon",
        { label: "Microsoft Edge", pattern: "(?:Edge|Edg|EdgA|EdgiOS)" },
        "Midori",
        "Nook Browser",
        "PaleMoon",
        "PhantomJS",
        "Raven",
        "Rekonq",
        "RockMelt",
        { label: "Samsung Internet", pattern: "SamsungBrowser" },
        "SeaMonkey",
        { label: "Silk", pattern: "(?:Cloud9|Silk-Accelerated)" },
        "Sleipnir",
        "SlimBrowser",
        { label: "SRWare Iron", pattern: "Iron" },
        "Sunrise",
        "Swiftfox",
        "Vivaldi",
        "Waterfox",
        "WebPositive",
        { label: "Yandex Browser", pattern: "YaBrowser" },
        { label: "UC Browser", pattern: "UCBrowser" },
        "Opera Mini",
        { label: "Opera Mini", pattern: "OPiOS" },
        "Opera",
        { label: "Opera", pattern: "OPR" },
        "Chromium",
        "Chrome",
        { label: "Chrome", pattern: "(?:HeadlessChrome)" },
        { label: "Chrome Mobile", pattern: "(?:CriOS|CrMo)" },
        { label: "Firefox", pattern: "(?:Firefox|Minefield)" },
        { label: "Firefox for iOS", pattern: "FxiOS" },
        { label: "IE", pattern: "IEMobile" },
        { label: "IE", pattern: "MSIE" },
        "Safari"
      ]), it = Me([
        { label: "BlackBerry", pattern: "BB10" },
        "BlackBerry",
        { label: "Galaxy S", pattern: "GT-I9000" },
        { label: "Galaxy S2", pattern: "GT-I9100" },
        { label: "Galaxy S3", pattern: "GT-I9300" },
        { label: "Galaxy S4", pattern: "GT-I9500" },
        { label: "Galaxy S5", pattern: "SM-G900" },
        { label: "Galaxy S6", pattern: "SM-G920" },
        { label: "Galaxy S6 Edge", pattern: "SM-G925" },
        { label: "Galaxy S7", pattern: "SM-G930" },
        { label: "Galaxy S7 Edge", pattern: "SM-G935" },
        "Google TV",
        "Lumia",
        "iPad",
        "iPod",
        "iPhone",
        "Kindle",
        { label: "Kindle Fire", pattern: "(?:Cloud9|Silk-Accelerated)" },
        "Nexus",
        "Nook",
        "PlayBook",
        "PlayStation Vita",
        "PlayStation",
        "TouchPad",
        "Transformer",
        { label: "Wii U", pattern: "WiiU" },
        "Wii",
        "Xbox One",
        { label: "Xbox 360", pattern: "Xbox" },
        "Xoom"
      ]), Vt = mt({
        Apple: { iPad: 1, iPhone: 1, iPod: 1 },
        Alcatel: {},
        Archos: {},
        Amazon: { Kindle: 1, "Kindle Fire": 1 },
        Asus: { Transformer: 1 },
        "Barnes & Noble": { Nook: 1 },
        BlackBerry: { PlayBook: 1 },
        Google: { "Google TV": 1, Nexus: 1 },
        HP: { TouchPad: 1 },
        HTC: {},
        Huawei: {},
        Lenovo: {},
        LG: {},
        Microsoft: { Xbox: 1, "Xbox One": 1 },
        Motorola: { Xoom: 1 },
        Nintendo: { "Wii U": 1, Wii: 1 },
        Nokia: { Lumia: 1 },
        Oppo: {},
        Samsung: { "Galaxy S": 1, "Galaxy S2": 1, "Galaxy S3": 1, "Galaxy S4": 1 },
        Sony: { PlayStation: 1, "PlayStation Vita": 1 },
        Xiaomi: { Mi: 1, Redmi: 1 }
      }), Oe = It([
        "Windows Phone",
        "KaiOS",
        "Android",
        "CentOS",
        { label: "Chrome OS", pattern: "CrOS" },
        "Debian",
        { label: "DragonFly BSD", pattern: "DragonFly" },
        "Fedora",
        "FreeBSD",
        "Gentoo",
        "Haiku",
        "Kubuntu",
        "Linux Mint",
        "OpenBSD",
        "Red Hat",
        "SuSE",
        "Ubuntu",
        "Xubuntu",
        "Cygwin",
        "Symbian OS",
        "hpwOS",
        "webOS ",
        "webOS",
        "Tablet OS",
        "Tizen",
        "Linux",
        "Mac OS X",
        "Macintosh",
        "Mac",
        "Windows 98;",
        "Windows "
      ]);
      function Bt(qt) {
        return C(qt, function(ft, at) {
          return ft || RegExp("\\b" + (at.pattern || O(at)) + "\\b", "i").exec(K) && (at.label || at);
        });
      }
      function mt(qt) {
        return C(qt, function(ft, at, rt) {
          return ft || (at[it] || at[/^[a-z]+(?: +[a-z]+\b)*/i.exec(it)] || RegExp("\\b" + O(rt) + "(?:\\b|\\w*\\d)", "i").exec(K)) && rt;
        });
      }
      function Ot(qt) {
        return C(qt, function(ft, at) {
          return ft || RegExp("\\b" + (at.pattern || O(at)) + "\\b", "i").exec(K) && (at.label || at);
        });
      }
      function It(qt) {
        return C(qt, function(ft, at) {
          var rt = at.pattern || O(at);
          return !ft && (ft = RegExp("\\b" + rt + "(?:/[\\d.]+|[ \\w.]*)", "i").exec(K)) && (ft = p(ft, rt, at.label || at)), ft;
        });
      }
      function Me(qt) {
        return C(qt, function(ft, at) {
          var rt = at.pattern || O(at);
          return !ft && (ft = RegExp("\\b" + rt + " *\\d+[.\\w_]*", "i").exec(K) || RegExp("\\b" + rt + " *\\w+-[\\w]*", "i").exec(K) || RegExp("\\b" + rt + "(?:; *(?:[a-z]+[_-])?[a-z]+\\d+|[^ ();-]*)", "i").exec(K)) && ((ft = String(at.label && !RegExp(rt, "i").test(at.label) ? at.label : ft).split("/"))[1] && !/[\d.]+/.test(ft[0]) && (ft[0] += " " + ft[1]), at = at.label || at, ft = h(ft[0].replace(RegExp(rt, "i"), at).replace(RegExp("; *(?:" + at + "[_-])?", "i"), " ").replace(RegExp("(" + at + ")[-_.]?(\\w)", "i"), "$1 $2"))), ft;
        });
      }
      function Gr(qt) {
        return C(qt, function(ft, at) {
          return ft || (RegExp(at + "(?:-[\\d.]+/|(?: for [\\w-]+)?[ /-])([\\d.]+[^ ();/_-]*)", "i").exec(K) || 0)[1] || null;
        });
      }
      function $e() {
        return this.description || "";
      }
      if (He && (He = [He]), /\bAndroid\b/.test(Oe) && !it && (z = /\bAndroid[^;]*;(.*?)(?:Build|\) AppleWebKit)\b/i.exec(K)) && (it = R(z[1]).replace(/^[a-z]{2}-[a-z]{2};\s*/i, "") || null), Vt && !it ? it = Me([Vt]) : Vt && it && (it = it.replace(RegExp("^(" + O(Vt) + ")[-_.\\s]", "i"), Vt + " ").replace(RegExp("^(" + O(Vt) + ")[-_.]?(\\w)", "i"), Vt + " $2")), (z = /\bGoogle TV\b/.exec(it)) && (it = z[0]), /\bSimulator\b/i.test(K) && (it = (it ? it + " " : "") + "Simulator"), te == "Opera Mini" && /\bOPiOS\b/.test(K) && Ae.push("running in Turbo/Uncompressed mode"), te == "IE" && /\blike iPhone OS\b/.test(K) ? (z = I(K.replace(/like iPhone OS/, "")), Vt = z.manufacturer, it = z.product) : /^iP/.test(it) ? (te || (te = "Safari"), Oe = "iOS" + ((z = / OS ([\d_]+)/i.exec(K)) ? " " + z[1].replace(/_/g, ".") : "")) : te == "Konqueror" && /^Linux\b/i.test(Oe) ? Oe = "Kubuntu" : Vt && Vt != "Google" && (/Chrome/.test(te) && !/\bMobile Safari\b/i.test(K) || /\bVita\b/.test(it)) || /\bAndroid\b/.test(Oe) && /^Chrome/.test(te) && /\bVersion\//i.test(K) ? (te = "Android Browser", Oe = /\bAndroid\b/.test(Oe) ? Oe : "Android") : te == "Silk" ? (/\bMobi/i.test(K) || (Oe = "Android", Ae.unshift("desktop mode")), /Accelerated *= *true/i.test(K) && Ae.unshift("accelerated")) : te == "UC Browser" && /\bUCWEB\b/.test(K) ? Ae.push("speed mode") : te == "PaleMoon" && (z = /\bFirefox\/([\d.]+)\b/.exec(K)) ? Ae.push("identifying as Firefox " + z[1]) : te == "Firefox" && (z = /\b(Mobile|Tablet|TV)\b/i.exec(K)) ? (Oe || (Oe = "Firefox OS"), it || (it = z[1])) : !te || (z = !/\bMinefield\b/i.test(K) && /\b(?:Firefox|Safari)\b/.exec(te)) ? (te && !it && /[\/,]|^[^(]+?\)/.test(K.slice(K.indexOf(z + "/") + 8)) && (te = null), (z = it || Vt || Oe) && (it || Vt || /\b(?:Android|Symbian OS|Tablet OS|webOS)\b/.test(Oe)) && (te = /[a-z]+(?: Hat)?/i.exec(/\bAndroid\b/.test(Oe) ? Oe : z) + " Browser")) : te == "Electron" && (z = (/\bChrome\/([\d.]+)\b/.exec(K) || 0)[1]) && Ae.push("Chromium " + z), Ee || (Ee = Gr([
        "(?:Cloud9|CriOS|CrMo|Edge|Edg|EdgA|EdgiOS|FxiOS|HeadlessChrome|IEMobile|Iron|Opera ?Mini|OPiOS|OPR|Raven|SamsungBrowser|Silk(?!/[\\d.]+$)|UCBrowser|YaBrowser)",
        "Version",
        O(te),
        "(?:Firefox|Minefield|NetFront)"
      ])), (z = He == "iCab" && parseFloat(Ee) > 3 && "WebKit" || /\bOpera\b/.test(te) && (/\bOPR\b/.test(K) ? "Blink" : "Presto") || /\b(?:Midori|Nook|Safari)\b/i.test(K) && !/^(?:Trident|EdgeHTML)$/.test(He) && "WebKit" || !He && /\bMSIE\b/i.test(K) && (Oe == "Mac OS" ? "Tasman" : "Trident") || He == "WebKit" && /\bPlayStation\b(?! Vita\b)/i.test(te) && "NetFront") && (He = [z]), te == "IE" && (z = (/; *(?:XBLWP|ZuneWP)(\d+)/i.exec(K) || 0)[1]) ? (te += " Mobile", Oe = "Windows Phone " + (/\+$/.test(z) ? z : z + ".x"), Ae.unshift("desktop mode")) : /\bWPDesktop\b/i.test(K) ? (te = "IE Mobile", Oe = "Windows Phone 8.x", Ae.unshift("desktop mode"), Ee || (Ee = (/\brv:([\d.]+)/.exec(K) || 0)[1])) : te != "IE" && He == "Trident" && (z = /\brv:([\d.]+)/.exec(K)) && (te && Ae.push("identifying as " + te + (Ee ? " " + Ee : "")), te = "IE", Ee = z[1]), Qe) {
        if (w(B, "global"))
          if (ue && (z = ue.lang.System, Ze = z.getProperty("os.arch"), Oe = Oe || z.getProperty("os.name") + " " + z.getProperty("os.version")), M) {
            try {
              Ee = B.require("ringo/engine").version.join("."), te = "RingoJS";
            } catch {
              (z = B.system) && z.global.system == B.system && (te = "Narwhal", Oe || (Oe = z[0].os || null));
            }
            te || (te = "Rhino");
          } else
            typeof B.process == "object" && !B.process.browser && (z = B.process) && (typeof z.versions == "object" && (typeof z.versions.electron == "string" ? (Ae.push("Node " + z.versions.node), te = "Electron", Ee = z.versions.electron) : typeof z.versions.nw == "string" && (Ae.push("Chromium " + Ee, "Node " + z.versions.node), te = "NW.js", Ee = z.versions.nw)), te || (te = "Node.js", Ze = z.arch, Oe = z.platform, Ee = /[\d.]+/.exec(z.version), Ee = Ee ? Ee[0] : null));
        else
          q(z = B.runtime) == he ? (te = "Adobe AIR", Oe = z.flash.system.Capabilities.os) : q(z = B.phantom) == ye ? (te = "PhantomJS", Ee = (z = z.version || null) && z.major + "." + z.minor + "." + z.patch) : typeof We.documentMode == "number" && (z = /\bTrident\/(\d+)/i.exec(K)) ? (Ee = [Ee, We.documentMode], (z = +z[1] + 4) != Ee[1] && (Ae.push("IE " + Ee[1] + " mode"), He && (He[1] = ""), Ee[1] = z), Ee = te == "IE" ? String(Ee[1].toFixed(1)) : Ee[0]) : typeof We.documentMode == "number" && /^(?:Chrome|Firefox)\b/.test(te) && (Ae.push("masking as " + te + " " + Ee), te = "IE", Ee = "11.0", He = ["Trident"], Oe = "Windows");
        Oe = Oe && h(Oe);
      }
      if (Ee && (z = /(?:[ab]|dp|pre|[ab]\d+pre)(?:\d+\+?)?$/i.exec(Ee) || /(?:alpha|beta)(?: ?\d)?/i.exec(K + ";" + (Qe && _.appMinorVersion)) || /\bMinefield\b/i.test(K) && "a") && (re = /b/i.test(z) ? "beta" : "alpha", Ee = Ee.replace(RegExp(z + "\\+?$"), "") + (re == "beta" ? pe : F) + (/\d+\+?/.exec(z) || "")), te == "Fennec" || te == "Firefox" && /\b(?:Android|Firefox OS|KaiOS)\b/.test(Oe))
        te = "Firefox Mobile";
      else if (te == "Maxthon" && Ee)
        Ee = Ee.replace(/\.[\d.]+/, ".x");
      else if (/\bXbox\b/i.test(it))
        it == "Xbox 360" && (Oe = null), it == "Xbox 360" && /\bIEMobile\b/.test(K) && Ae.unshift("mobile mode");
      else if ((/^(?:Chrome|IE|Opera)$/.test(te) || te && !it && !/Browser|Mobi/.test(te)) && (Oe == "Windows CE" || /Mobi/i.test(K)))
        te += " Mobile";
      else if (te == "IE" && Qe)
        try {
          B.external === null && Ae.unshift("platform preview");
        } catch {
          Ae.unshift("embedded");
        }
      else
        (/\bBlackBerry\b/.test(it) || /\bBB10\b/.test(K)) && (z = (RegExp(it.replace(/ +/g, " *") + "/([.\\d]+)", "i").exec(K) || 0)[1] || Ee) ? (z = [z, /BB10/.test(K)], Oe = (z[1] ? (it = null, Vt = "BlackBerry") : "Device Software") + " " + z[0], Ee = null) : this != m && it != "Wii" && (Qe && ce || /Opera/.test(te) && /\b(?:MSIE|Firefox)\b/i.test(K) || te == "Firefox" && /\bOS X (?:\d+\.){2,}/.test(Oe) || te == "IE" && (Oe && !/^Win/.test(Oe) && Ee > 5.5 || /\bWindows XP\b/.test(Oe) && Ee > 8 || Ee == 8 && !/\bTrident\b/.test(K))) && !u.test(z = I.call(m, K.replace(u, "") + ";")) && z.name && (z = "ing as " + z.name + ((z = z.version) ? " " + z : ""), u.test(te) ? (/\bIE\b/.test(z) && Oe == "Mac OS" && (Oe = null), z = "identify" + z) : (z = "mask" + z, oe ? te = h(oe.replace(/([a-z])([A-Z])/g, "$1 $2")) : te = "Opera", /\bIE\b/.test(z) && (Oe = null), Qe || (Ee = null)), He = ["Presto"], Ae.push(z));
      (z = (/\bAppleWebKit\/([\d.]+\+?)/i.exec(K) || 0)[1]) && (z = [parseFloat(z.replace(/\.(\d)$/, ".0$1")), z], te == "Safari" && z[1].slice(-1) == "+" ? (te = "WebKit Nightly", re = "alpha", Ee = z[1].slice(0, -1)) : (Ee == z[1] || Ee == (z[2] = (/\bSafari\/([\d.]+\+?)/i.exec(K) || 0)[1])) && (Ee = null), z[1] = (/\b(?:Headless)?Chrome\/([\d.]+)/i.exec(K) || 0)[1], z[0] == 537.36 && z[2] == 537.36 && parseFloat(z[1]) >= 28 && He == "WebKit" && (He = ["Blink"]), !Qe || !Z && !z[1] ? (He && (He[1] = "like Safari"), z = (z = z[0], z < 400 ? 1 : z < 500 ? 2 : z < 526 ? 3 : z < 533 ? 4 : z < 534 ? "4+" : z < 535 ? 5 : z < 537 ? 6 : z < 538 ? 7 : z < 601 ? 8 : z < 602 ? 9 : z < 604 ? 10 : z < 606 ? 11 : z < 608 ? 12 : "12")) : (He && (He[1] = "like Chrome"), z = z[1] || (z = z[0], z < 530 ? 1 : z < 532 ? 2 : z < 532.05 ? 3 : z < 533 ? 4 : z < 534.03 ? 5 : z < 534.07 ? 6 : z < 534.1 ? 7 : z < 534.13 ? 8 : z < 534.16 ? 9 : z < 534.24 ? 10 : z < 534.3 ? 11 : z < 535.01 ? 12 : z < 535.02 ? "13+" : z < 535.07 ? 15 : z < 535.11 ? 16 : z < 535.19 ? 17 : z < 536.05 ? 18 : z < 536.1 ? 19 : z < 537.01 ? 20 : z < 537.11 ? "21+" : z < 537.13 ? 23 : z < 537.18 ? 24 : z < 537.24 ? 25 : z < 537.36 ? 26 : He != "Blink" ? "27" : "28")), He && (He[1] += " " + (z += typeof z == "number" ? ".x" : /[.+]/.test(z) ? "" : "+")), te == "Safari" && (!Ee || parseInt(Ee) > 45) ? Ee = z : te == "Chrome" && /\bHeadlessChrome/i.test(K) && Ae.unshift("headless")), te == "Opera" && (z = /\bzbov|zvav$/.exec(Oe)) ? (te += " ", Ae.unshift("desktop mode"), z == "zvav" ? (te += "Mini", Ee = null) : te += "Mobile", Oe = Oe.replace(RegExp(" *" + z + "$"), "")) : te == "Safari" && /\bChrome\b/.exec(He && He[1]) ? (Ae.unshift("desktop mode"), te = "Chrome Mobile", Ee = null, /\bOS X\b/.test(Oe) ? (Vt = "Apple", Oe = "iOS 4.3+") : Oe = null) : /\bSRWare Iron\b/.test(te) && !Ee && (Ee = Gr("Chrome")), Ee && Ee.indexOf(z = /[\d.]+$/.exec(Oe)) == 0 && K.indexOf("/" + z + "-") > -1 && (Oe = R(Oe.replace(z, ""))), Oe && Oe.indexOf(te) != -1 && !RegExp(te + " OS").test(Oe) && (Oe = Oe.replace(RegExp(" *" + O(te) + " *"), "")), He && !/\b(?:Avant|Nook)\b/.test(te) && (/Browser|Lunascape|Maxthon/.test(te) || te != "Safari" && /^iOS/.test(Oe) && /\bSafari\b/.test(He[1]) || /^(?:Adobe|Arora|Breach|Midori|Opera|Phantom|Rekonq|Rock|Samsung Internet|Sleipnir|SRWare Iron|Vivaldi|Web)/.test(te) && He[1]) && (z = He[He.length - 1]) && Ae.push(z), Ae.length && (Ae = ["(" + Ae.join("; ") + ")"]), Vt && it && it.indexOf(Vt) < 0 && Ae.push("on " + Vt), it && Ae.push((/^on /.test(Ae[Ae.length - 1]) ? "" : "on ") + it), Oe && (z = / ([\d.+]+)$/.exec(Oe), Ue = z && Oe.charAt(Oe.length - z[0].length - 1) == "/", Oe = {
        architecture: 32,
        family: z && !Ue ? Oe.replace(z[0], "") : Oe,
        version: z ? z[1] : null,
        toString: function() {
          var qt = this.version;
          return this.family + (qt && !Ue ? " " + qt : "") + (this.architecture == 64 ? " 64-bit" : "");
        }
      }), (z = /\b(?:AMD|IA|Win|WOW|x86_|x)64\b/i.exec(Ze)) && !/\bi686\b/i.test(Ze) ? (Oe && (Oe.architecture = 64, Oe.family = Oe.family.replace(RegExp(" *" + z), "")), te && (/\bWOW64\b/i.test(K) || Qe && /\w(?:86|32)$/.test(_.cpuClass || _.platform) && !/\bWin64; x64\b/i.test(K)) && Ae.unshift("32-bit")) : Oe && /^OS X/.test(Oe.family) && te == "Chrome" && parseFloat(Ee) >= 39 && (Oe.architecture = 64), K || (K = null);
      var Je = {};
      return Je.description = K, Je.layout = He && He[0], Je.manufacturer = Vt, Je.name = te, Je.prerelease = re, Je.product = it, Je.ua = K, Je.version = te && Ee, Je.os = Oe || {
        /**
         * The CPU architecture the OS is built for.
         *
         * @memberOf platform.os
         * @type number|null
         */
        architecture: null,
        /**
         * The family of the OS.
         *
         * Common values include:
         * "Windows", "Windows Server 2008 R2 / 7", "Windows Server 2008 / Vista",
         * "Windows XP", "OS X", "Linux", "Ubuntu", "Debian", "Fedora", "Red Hat",
         * "SuSE", "Android", "iOS" and "Windows Phone"
         *
         * @memberOf platform.os
         * @type string|null
         */
        family: null,
        /**
         * The version of the OS.
         *
         * @memberOf platform.os
         * @type string|null
         */
        version: null,
        /**
         * Returns the OS string.
         *
         * @memberOf platform.os
         * @returns {string} The OS string.
         */
        toString: function() {
          return "null";
        }
      }, Je.parse = I, Je.toString = $e, Je.version && Ae.unshift(Ee), Je.name && Ae.unshift(te), Oe && te && !(Oe == String(Oe).split(" ")[0] && (Oe == te.split(" ")[0] || it)) && Ae.push(it ? "(" + Oe + ")" : "on " + Oe), Ae.length && (Je.description = Ae.join(" ")), Je;
    }
    var P = I();
    i && a ? m(P, function(K, B) {
      i[B] = K;
    }) : n.platform = P;
  }).call(Xn);
})(Pc, Pc.exports);
var K9 = Pc.exports, Cee = fr, Fee = xp, Kee = Or, Ree = Ri, Tee = Sa, r1 = $r, Uee = Hi, xee = $s, Eee = cV, kk = Ep;
Fee("match", function(e, t, r) {
  return [
    // `String.prototype.match` method
    // https://tc39.es/ecma262/#sec-string.prototype.match
    function(i) {
      var a = Uee(this), s = Ree(i) ? void 0 : xee(i, e);
      return s ? Cee(s, i, a) : new RegExp(i)[e](r1(a));
    },
    // `RegExp.prototype[@@match]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@match
    function(n) {
      var i = Kee(this), a = r1(n), s = r(t, i, a);
      if (s.done)
        return s.value;
      if (!i.global)
        return kk(i, a);
      var o = i.unicode;
      i.lastIndex = 0;
      for (var u = [], f = 0, l; (l = kk(i, a)) !== null; ) {
        var d = r1(l[0]);
        u[f] = d, d === "" && (i.lastIndex = Eee(a, Tee(i.lastIndex), o)), f++;
      }
      return f === 0 ? null : u;
    }
  ];
});
var Oee = Object.is || function(t, r) {
  return t === r ? t !== 0 || 1 / t === 1 / r : t !== t && r !== r;
}, Nee = fr, Iee = xp, Xee = Or, Pee = Ri, Bee = Hi, Wk = Oee, Sk = $r, Dee = $s, Lee = Ep;
Iee("search", function(e, t, r) {
  return [
    // `String.prototype.search` method
    // https://tc39.es/ecma262/#sec-string.prototype.search
    function(i) {
      var a = Bee(this), s = Pee(i) ? void 0 : Dee(i, e);
      return s ? Nee(s, i, a) : new RegExp(i)[e](Sk(a));
    },
    // `RegExp.prototype[@@search]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@search
    function(n) {
      var i = Xee(this), a = Sk(n), s = r(t, i, a);
      if (s.done)
        return s.value;
      var o = i.lastIndex;
      Wk(o, 0) || (i.lastIndex = 0);
      var u = Lee(i, a);
      return Wk(i.lastIndex, o) || (i.lastIndex = o), u === null ? -1 : u.index;
    }
  ];
});
var Zee = Ar, Mee = Wl, jee = TypeError, Yee = Object.getOwnPropertyDescriptor, zee = Zee && !function() {
  if (this !== void 0)
    return !0;
  try {
    Object.defineProperty([], "length", { writable: !1 }).length = 1;
  } catch (e) {
    return e instanceof TypeError;
  }
}(), Gee = zee ? function(e, t) {
  if (Mee(e) && !Yee(e, "length").writable)
    throw jee("Cannot set read only .length");
  return e.length = t;
} : function(e, t) {
  return e.length = t;
}, Qee = xt, Jee = hn, Hee = eo, _ee = _i, $ee = on, ete = Gee, tte = QC, rte = Ny, nte = Tu, n1 = NV, ite = Fl, ate = ite("splice"), ste = Math.max, ote = Math.min;
Qee({ target: "Array", proto: !0, forced: !ate }, {
  splice: function(t, r) {
    var n = Jee(this), i = $ee(n), a = Hee(t, i), s = arguments.length, o, u, f, l, d, c;
    for (s === 0 ? o = u = 0 : s === 1 ? (o = 0, u = i - a) : (o = s - 2, u = ote(ste(_ee(r), 0), i - a)), tte(i + o - u), f = rte(n, u), l = 0; l < u; l++)
      d = a + l, d in n && nte(f, l, n[d]);
    if (f.length = u, o < u) {
      for (l = a; l < i - u; l++)
        d = l + u, c = l + o, d in n ? n[c] = n[d] : n1(n, c);
      for (l = i; l > i - u + o; l--)
        n1(n, l - 1);
    } else if (o > u)
      for (l = i - u; l > a; l--)
        d = l + u - 1, c = l + o - 1, d in n ? n[c] = n[d] : n1(n, c);
    for (l = 0; l < o; l++)
      n[l + a] = arguments[l + 2];
    return ete(n, i - u + o), f;
  }
});
/*
@license
The following license applies to all parts of this software except as
documented below.

    Copyright (c) 2016, Twilio, inc.
    All rights reserved.

    Redistribution and use in source and binary forms, with or without
    modification, are permitted provided that the following conditions are
    met:

      1. Redistributions of source code must retain the above copyright
         notice, this list of conditions and the following disclaimer.

      2. Redistributions in binary form must reproduce the above copyright
         notice, this list of conditions and the following disclaimer in
         the documentation and/or other materials provided with the
         distribution.

      3. Neither the name of Twilio nor the names of its contributors may
         be used to endorse or promote products derived from this software
         without specific prior written permission.

    THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
    "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
    LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
    A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT
    HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
    SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT
    LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE,
    DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY
    THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
    (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
    OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.

This software includes javascript-state-machine under the following license.

    Copyright (c) 2012, 2013, 2014, 2015, Jake Gordon and contributors

    Permission is hereby granted, free of charge, to any person obtaining a copy
    of this software and associated documentation files (the "Software"), to deal
    in the Software without restriction, including without limitation the rights
    to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
    copies of the Software, and to permit persons to whom the Software is
    furnished to do so, subject to the following conditions:

    The above copyright notice and this permission notice shall be included in all
    copies or substantial portions of the Software.

    THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
    IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
    FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
    AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
    LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
    OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE

This software includes loglevel under the following license.

    Copyright (c) 2013 Tim Perry

    Permission is hereby granted, free of charge, to any person
    obtaining a copy of this software and associated documentation
    files (the "Software"), to deal in the Software without
    restriction, including without limitation the rights to use,
    copy, modify, merge, publish, distribute, sublicense, and/or sell
    copies of the Software, and to permit persons to whom the
    Software is furnished to do so, subject to the following
    conditions:

    The above copyright notice and this permission notice shall be
    included in all copies or substantial portions of the Software.

    THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
    EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES
    OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
    NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT
    HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
    WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
    FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR
    OTHER DEALINGS IN THE SOFTWARE.


*/
(function(e) {
  var t = typeof t < "u" ? t : typeof self < "u" ? self : typeof window < "u" ? window : {};
  Object.defineProperty(e, "__esModule", { value: !0 });
  var r = Kl, n = ps, i = to, a = mV, s = ea, o = ta, u = ci, f = ra, l = ro, d = El, c = di, p = Wn, v = Nl, h = RQ, m = DQ, q = Jp, w = Ua, O = K9;
  function C(Y) {
    return Y && typeof Y == "object" && "default" in Y ? Y : { default: Y };
  }
  function R(Y) {
    if (Y && Y.__esModule)
      return Y;
    var H = /* @__PURE__ */ Object.create(null);
    return Y && Object.keys(Y).forEach(function(E) {
      if (E !== "default") {
        var x = Object.getOwnPropertyDescriptor(Y, E);
        Object.defineProperty(H, E, x.get ? x : {
          enumerable: !0,
          get: function() {
            return Y[E];
          }
        });
      }
    }), H.default = Y, Object.freeze(H);
  }
  var I = /* @__PURE__ */ C(r), P = /* @__PURE__ */ C(n), K = /* @__PURE__ */ C(i), B = /* @__PURE__ */ C(a), L = /* @__PURE__ */ C(s), _ = /* @__PURE__ */ C(o), ne = /* @__PURE__ */ C(u), Z = /* @__PURE__ */ C(f), le = /* @__PURE__ */ C(l), he = /* @__PURE__ */ C(d), Ie = /* @__PURE__ */ C(c), xe = /* @__PURE__ */ R(v), ye = /* @__PURE__ */ R(h), ue = /* @__PURE__ */ C(q), M = /* @__PURE__ */ R(O);
  function F(Y, H, E, x) {
    var U = arguments.length, Q = U < 3 ? H : x === null ? x = Object.getOwnPropertyDescriptor(H, E) : x, D;
    if ((typeof Reflect > "u" ? "undefined" : Ie.default(Reflect)) === "object" && typeof Reflect.decorate == "function")
      Q = Reflect.decorate(Y, H, E, x);
    else
      for (var Fe = Y.length - 1; Fe >= 0; Fe--)
        (D = Y[Fe]) && (Q = (U < 3 ? D(Q) : U > 3 ? D(H, E, Q) : D(H, E)) || Q);
    return U > 3 && Q && Object.defineProperty(H, E, Q), Q;
  }
  function pe(Y, H) {
    if ((typeof Reflect > "u" ? "undefined" : Ie.default(Reflect)) === "object" && typeof Reflect.metadata == "function")
      return Reflect.metadata(Y, H);
  }
  var We;
  function ce() {
  }
  ce.prototype = /* @__PURE__ */ Object.create(null);
  function oe() {
    oe.init.call(this);
  }
  oe.EventEmitter = oe, oe.usingDomains = !1, oe.prototype.domain = void 0, oe.prototype._events = void 0, oe.prototype._maxListeners = void 0, oe.defaultMaxListeners = 10, oe.init = function() {
    this.domain = null, oe.usingDomains && We.active, (!this._events || this._events === Object.getPrototypeOf(this)._events) && (this._events = new ce(), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
  }, oe.prototype.setMaxListeners = function(H) {
    if (typeof H != "number" || H < 0 || isNaN(H))
      throw new TypeError('"n" argument must be a positive number');
    return this._maxListeners = H, this;
  };
  function z(Y) {
    return Y._maxListeners === void 0 ? oe.defaultMaxListeners : Y._maxListeners;
  }
  oe.prototype.getMaxListeners = function() {
    return z(this);
  };
  function Ze(Y, H, E) {
    if (H)
      Y.call(E);
    else
      for (var x = Y.length, U = Oe(Y, x), Q = 0; Q < x; ++Q)
        U[Q].call(E);
  }
  function Ae(Y, H, E, x) {
    if (H)
      Y.call(E, x);
    else
      for (var U = Y.length, Q = Oe(Y, U), D = 0; D < U; ++D)
        Q[D].call(E, x);
  }
  function re(Y, H, E, x, U) {
    if (H)
      Y.call(E, x, U);
    else
      for (var Q = Y.length, D = Oe(Y, Q), Fe = 0; Fe < Q; ++Fe)
        D[Fe].call(E, x, U);
  }
  function Qe(Y, H, E, x, U, Q) {
    if (H)
      Y.call(E, x, U, Q);
    else
      for (var D = Y.length, Fe = Oe(Y, D), Se = 0; Se < D; ++Se)
        Fe[Se].call(E, x, U, Q);
  }
  function Ee(Y, H, E, x) {
    if (H)
      Y.apply(E, x);
    else
      for (var U = Y.length, Q = Oe(Y, U), D = 0; D < U; ++D)
        Q[D].apply(E, x);
  }
  oe.prototype.emit = function(H) {
    var E, x, U, Q, D, Fe, Se, je = H === "error";
    if (Fe = this._events, Fe)
      je = je && Fe.error == null;
    else if (!je)
      return !1;
    if (Se = this.domain, je) {
      if (E = arguments[1], Se)
        E || (E = new Error('Uncaught, unspecified "error" event')), E.domainEmitter = this, E.domain = Se, E.domainThrown = !1, Se.emit("error", E);
      else {
        if (E instanceof Error)
          throw E;
        var _e = new Error('Uncaught, unspecified "error" event. (' + E + ")");
        throw _e.context = E, _e;
      }
      return !1;
    }
    if (x = Fe[H], !x)
      return !1;
    var bt = typeof x == "function";
    switch (U = arguments.length, U) {
      case 1:
        Ze(x, bt, this);
        break;
      case 2:
        Ae(x, bt, this, arguments[1]);
        break;
      case 3:
        re(x, bt, this, arguments[1], arguments[2]);
        break;
      case 4:
        Qe(x, bt, this, arguments[1], arguments[2], arguments[3]);
        break;
      default:
        for (Q = new Array(U - 1), D = 1; D < U; D++)
          Q[D - 1] = arguments[D];
        Ee(x, bt, this, Q);
    }
    return !0;
  };
  function Ue(Y, H, E, x) {
    var U, Q, D;
    if (typeof E != "function")
      throw new TypeError('"listener" argument must be a function');
    if (Q = Y._events, Q ? (Q.newListener && (Y.emit(
      "newListener",
      H,
      E.listener ? E.listener : E
    ), Q = Y._events), D = Q[H]) : (Q = Y._events = new ce(), Y._eventsCount = 0), !D)
      D = Q[H] = E, ++Y._eventsCount;
    else if (typeof D == "function" ? D = Q[H] = x ? [E, D] : [D, E] : x ? D.unshift(E) : D.push(E), !D.warned && (U = z(Y), U && U > 0 && D.length > U)) {
      D.warned = !0;
      var Fe = new Error("Possible EventEmitter memory leak detected. " + D.length + " " + H + " listeners added. Use emitter.setMaxListeners() to increase limit");
      Fe.name = "MaxListenersExceededWarning", Fe.emitter = Y, Fe.type = H, Fe.count = D.length, He(Fe);
    }
    return Y;
  }
  function He(Y) {
    typeof console.warn == "function" ? console.warn(Y) : console.log(Y);
  }
  oe.prototype.addListener = function(H, E) {
    return Ue(this, H, E, !1);
  }, oe.prototype.on = oe.prototype.addListener, oe.prototype.prependListener = function(H, E) {
    return Ue(this, H, E, !0);
  };
  function te(Y, H, E) {
    var x = !1;
    function U() {
      Y.removeListener(H, U), x || (x = !0, E.apply(Y, arguments));
    }
    return U.listener = E, U;
  }
  oe.prototype.once = function(H, E) {
    if (typeof E != "function")
      throw new TypeError('"listener" argument must be a function');
    return this.on(H, te(this, H, E)), this;
  }, oe.prototype.prependOnceListener = function(H, E) {
    if (typeof E != "function")
      throw new TypeError('"listener" argument must be a function');
    return this.prependListener(H, te(this, H, E)), this;
  }, oe.prototype.removeListener = function(H, E) {
    var x, U, Q, D, Fe;
    if (typeof E != "function")
      throw new TypeError('"listener" argument must be a function');
    if (U = this._events, !U)
      return this;
    if (x = U[H], !x)
      return this;
    if (x === E || x.listener && x.listener === E)
      --this._eventsCount === 0 ? this._events = new ce() : (delete U[H], U.removeListener && this.emit("removeListener", H, x.listener || E));
    else if (typeof x != "function") {
      for (Q = -1, D = x.length; D-- > 0; )
        if (x[D] === E || x[D].listener && x[D].listener === E) {
          Fe = x[D].listener, Q = D;
          break;
        }
      if (Q < 0)
        return this;
      if (x.length === 1) {
        if (x[0] = void 0, --this._eventsCount === 0)
          return this._events = new ce(), this;
        delete U[H];
      } else
        Vt(x, Q);
      U.removeListener && this.emit("removeListener", H, Fe || E);
    }
    return this;
  }, oe.prototype.off = function(Y, H) {
    return this.removeListener(Y, H);
  }, oe.prototype.removeAllListeners = function(H) {
    var E, x;
    if (x = this._events, !x)
      return this;
    if (!x.removeListener)
      return arguments.length === 0 ? (this._events = new ce(), this._eventsCount = 0) : x[H] && (--this._eventsCount === 0 ? this._events = new ce() : delete x[H]), this;
    if (arguments.length === 0) {
      for (var U = Object.keys(x), Q = 0, D; Q < U.length; ++Q)
        D = U[Q], D !== "removeListener" && this.removeAllListeners(D);
      return this.removeAllListeners("removeListener"), this._events = new ce(), this._eventsCount = 0, this;
    }
    if (E = x[H], typeof E == "function")
      this.removeListener(H, E);
    else if (E)
      do
        this.removeListener(H, E[E.length - 1]);
      while (E[0]);
    return this;
  }, oe.prototype.listeners = function(H) {
    var E, x, U = this._events;
    return U ? (E = U[H], E ? typeof E == "function" ? x = [E.listener || E] : x = Bt(E) : x = []) : x = [], x;
  }, oe.listenerCount = function(Y, H) {
    return typeof Y.listenerCount == "function" ? Y.listenerCount(H) : it.call(Y, H);
  }, oe.prototype.listenerCount = it;
  function it(Y) {
    var H = this._events;
    if (H) {
      var E = H[Y];
      if (typeof E == "function")
        return 1;
      if (E)
        return E.length;
    }
    return 0;
  }
  oe.prototype.eventNames = function() {
    return this._eventsCount > 0 ? Reflect.ownKeys(this._events) : [];
  };
  function Vt(Y, H) {
    for (var E = H, x = E + 1, U = Y.length; x < U; E += 1, x += 1)
      Y[E] = Y[x];
    Y.pop();
  }
  function Oe(Y, H) {
    for (var E = new Array(H); H--; )
      E[H] = Y[H];
    return E;
  }
  function Bt(Y) {
    for (var H = new Array(Y.length), E = 0; E < H.length; ++E)
      H[E] = Y[E].listener || Y[E];
    return H;
  }
  var mt = xe.getLogger("twilsock");
  function Ot(Y, H) {
    return ["".concat((/* @__PURE__ */ new Date()).toISOString(), " Twilsock ").concat(Y, ":")].concat(Array.from(H));
  }
  var It = /* @__PURE__ */ function() {
    function Y(H) {
      Z.default(this, Y), le.default(this, "prefix", ""), this.prefix = H != null && H.length > 0 ? " " + H + ":" : "";
    }
    return P.default(Y, [{
      key: "setLevel",
      value: function(E) {
        mt.setLevel(E);
      }
    }, {
      key: "trace",
      value: function() {
        for (var E = arguments.length, x = new Array(E), U = 0; U < E; U++)
          x[U] = arguments[U];
        mt.trace.apply(null, Ot("T", x));
      }
    }, {
      key: "debug",
      value: function() {
        for (var E = arguments.length, x = new Array(E), U = 0; U < E; U++)
          x[U] = arguments[U];
        mt.debug.apply(null, Ot("D", x));
      }
    }, {
      key: "info",
      value: function() {
        for (var E = arguments.length, x = new Array(E), U = 0; U < E; U++)
          x[U] = arguments[U];
        mt.info.apply(null, Ot("I", x));
      }
    }, {
      key: "warn",
      value: function() {
        for (var E = arguments.length, x = new Array(E), U = 0; U < E; U++)
          x[U] = arguments[U];
        mt.warn.apply(null, Ot("W", x));
      }
    }, {
      key: "error",
      value: function() {
        for (var E = arguments.length, x = new Array(E), U = 0; U < E; U++)
          x[U] = arguments[U];
        mt.error.apply(null, Ot("E", x));
      }
    }], [{
      key: "setLevel",
      value: function(E) {
        mt.setLevel(E);
      }
    }, {
      key: "trace",
      value: function() {
        for (var E = arguments.length, x = new Array(E), U = 0; U < E; U++)
          x[U] = arguments[U];
        mt.trace.apply(null, Ot("T", x));
      }
    }, {
      key: "debug",
      value: function() {
        for (var E = arguments.length, x = new Array(E), U = 0; U < E; U++)
          x[U] = arguments[U];
        mt.debug.apply(null, Ot("D", x));
      }
    }, {
      key: "info",
      value: function() {
        for (var E = arguments.length, x = new Array(E), U = 0; U < E; U++)
          x[U] = arguments[U];
        mt.info.apply(null, Ot("I", x));
      }
    }, {
      key: "warn",
      value: function() {
        for (var E = arguments.length, x = new Array(E), U = 0; U < E; U++)
          x[U] = arguments[U];
        mt.warn.apply(null, Ot("W", x));
      }
    }, {
      key: "error",
      value: function() {
        for (var E = arguments.length, x = new Array(E), U = 0; U < E; U++)
          x[U] = arguments[U];
        mt.error.apply(null, Ot("E", x));
      }
    }]), Y;
  }(), Me = new It(""), Gr = "0.12.2", $e = /* @__PURE__ */ function() {
    function Y(H, E, x) {
      Z.default(this, Y), le.default(this, "confirmedCapabilities", /* @__PURE__ */ new Set()), this.activeGrant = E, this._token = H;
      var U = x.region || "us1", Q = "wss://tsock.".concat(U, ".twilio.com/v3/wsconnect"), D = x.twilsock || x.Twilsock || {};
      this.url = D.uri || Q, this._continuationToken = x.continuationToken ? x.continuationToken : null, this.logLevel = x.logLevel ? x.logLevel : "error", this.retryPolicy = x.retryPolicy ? x.retryPolicy : {
        min: 1 * 1e3,
        max: 2 * 60 * 1e3,
        randomness: 0.2
      }, this.clientMetadata = x.clientMetadata ? x.clientMetadata : {}, this.clientMetadata.ver = Gr, this.initRegistrations = x.initRegistrations ? x.initRegistrations : null, this.tweaks = x.tweaks ? x.tweaks : null;
    }
    return P.default(Y, [{
      key: "token",
      get: function() {
        return this._token;
      }
    }, {
      key: "continuationToken",
      get: function() {
        return this._continuationToken;
      }
    }, {
      key: "updateToken",
      value: function(E) {
        this._token = E;
      }
    }, {
      key: "updateContinuationToken",
      value: function(E) {
        this._continuationToken = E;
      }
    }]), Y;
  }(), Je = function Y(H) {
    Z.default(this, Y), this.id = H || "TM".concat(m.v4());
  };
  function qt(Y) {
    var H = ft();
    return function() {
      var x = ne.default(Y), U;
      if (H) {
        var Q = ne.default(this).constructor;
        U = Reflect.construct(x, arguments, Q);
      } else
        U = x.apply(this, arguments);
      return _.default(this, U);
    };
  }
  function ft() {
    if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
      return !1;
    if (typeof Proxy == "function")
      return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      })), !0;
    } catch {
      return !1;
    }
  }
  var at = /* @__PURE__ */ function(Y) {
    L.default(E, Y);
    var H = qt(E);
    function E(x, U, Q, D, Fe) {
      var Se;
      return Z.default(this, E), Se = H.call(this), le.default(K.default(Se), "method", "init"), Se.token = x, Se.continuation_token = U, Se.metadata = Q, Se.registrations = D, Se.tweaks = Fe, Se.capabilities = ["client_update", "offline_storage", "telemetry.v1"], Se;
    }
    return E;
  }(Je);
  function rt(Y) {
    var H = Dt();
    return function() {
      var x = ne.default(Y), U;
      if (H) {
        var Q = ne.default(this).constructor;
        U = Reflect.construct(x, arguments, Q);
      } else
        U = x.apply(this, arguments);
      return _.default(this, U);
    };
  }
  function Dt() {
    if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
      return !1;
    if (typeof Proxy == "function")
      return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      })), !0;
    } catch {
      return !1;
    }
  }
  var vr = /* @__PURE__ */ function(Y) {
    L.default(E, Y);
    var H = rt(E);
    function E(x, U, Q, D, Fe, Se, je) {
      var _e;
      return Z.default(this, E), _e = H.call(this, x), _e.continuationToken = U, _e.continuationTokenStatus = D, _e.offlineStorage = Fe, _e.initRegistrations = Se, _e.debugInfo = je, _e.confirmedCapabilities = Q, _e;
    }
    return E;
  }(Je);
  function Qr(Y) {
    var H = un();
    return function() {
      var x = ne.default(Y), U;
      if (H) {
        var Q = ne.default(this).constructor;
        U = Reflect.construct(x, arguments, Q);
      } else
        U = x.apply(this, arguments);
      return _.default(this, U);
    };
  }
  function un() {
    if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
      return !1;
    if (typeof Proxy == "function")
      return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      })), !0;
    } catch {
      return !1;
    }
  }
  var Nr = /* @__PURE__ */ function(Y) {
    L.default(E, Y);
    var H = Qr(E);
    function E(x) {
      var U;
      return Z.default(this, E), U = H.call(this), le.default(K.default(U), "method", "update"), U.token = x, U;
    }
    return E;
  }(Je);
  function kr(Y) {
    var H = Jr();
    return function() {
      var x = ne.default(Y), U;
      if (H) {
        var Q = ne.default(this).constructor;
        U = Reflect.construct(x, arguments, Q);
      } else
        U = x.apply(this, arguments);
      return _.default(this, U);
    };
  }
  function Jr() {
    if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
      return !1;
    if (typeof Proxy == "function")
      return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      })), !0;
    } catch {
      return !1;
    }
  }
  var Ke = /* @__PURE__ */ function(Y) {
    L.default(E, Y);
    var H = kr(E);
    function E(x, U, Q) {
      var D;
      return Z.default(this, E), D = H.call(this), le.default(K.default(D), "method", "message"), D.active_grant = x, D.payload_type = U, D.http_request = Q, D;
    }
    return E;
  }(Je);
  function Re(Y) {
    var H = ge();
    return function() {
      var x = ne.default(Y), U;
      if (H) {
        var Q = ne.default(this).constructor;
        U = Reflect.construct(x, arguments, Q);
      } else
        U = x.apply(this, arguments);
      return _.default(this, U);
    };
  }
  function ge() {
    if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
      return !1;
    if (typeof Proxy == "function")
      return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      })), !0;
    } catch {
      return !1;
    }
  }
  var qe = /* @__PURE__ */ function(Y) {
    L.default(E, Y);
    var H = Re(E);
    function E(x) {
      var U;
      return Z.default(this, E), U = H.call(this, x), le.default(K.default(U), "method", "reply"), le.default(K.default(U), "payload_type", "application/json"), le.default(K.default(U), "status", {
        code: 200,
        status: "OK"
      }), U;
    }
    return E;
  }(Je);
  function Ve(Y) {
    var H = Ne();
    return function() {
      var x = ne.default(Y), U;
      if (H) {
        var Q = ne.default(this).constructor;
        U = Reflect.construct(x, arguments, Q);
      } else
        U = x.apply(this, arguments);
      return _.default(this, U);
    };
  }
  function Ne() {
    if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
      return !1;
    if (typeof Proxy == "function")
      return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      })), !0;
    } catch {
      return !1;
    }
  }
  var Xe = /* @__PURE__ */ function(Y) {
    L.default(E, Y);
    var H = Ve(E);
    function E() {
      var x;
      return Z.default(this, E), x = H.call(this), le.default(K.default(x), "method", "close"), x;
    }
    return E;
  }(Je);
  function fe(Y) {
    var H = ke();
    return function() {
      var x = ne.default(Y), U;
      if (H) {
        var Q = ne.default(this).constructor;
        U = Reflect.construct(x, arguments, Q);
      } else
        U = x.apply(this, arguments);
      return _.default(this, U);
    };
  }
  function ke() {
    if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
      return !1;
    if (typeof Proxy == "function")
      return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      })), !0;
    } catch {
      return !1;
    }
  }
  var ae = function Y(H, E, x, U, Q, D) {
    Z.default(this, Y), this.start = H, this.end = E, this.title = x, this.details = U, this.id = Q, this.type = D;
  }, me = /* @__PURE__ */ function(Y) {
    L.default(E, Y);
    var H = fe(E);
    function E(x) {
      var U;
      return Z.default(this, E), U = H.call(this), le.default(K.default(U), "method", "telemetry.v1"), U.events = x, U;
    }
    return E;
  }(Je);
  function se(Y) {
    var H = encodeURIComponent(Y), E = H.replace(/%([0-9A-F]{2})/g, function(x, U) {
      return String.fromCharCode(+("0x" + U));
    });
    return E.length;
  }
  function ze(Y) {
    var H = encodeURIComponent(Y), E = H.replace(/%([0-9A-F]{2})/g, function(U, Q) {
      return String.fromCharCode(+("0x" + Q));
    }), x = new Uint8Array(E.length);
    return Array.prototype.forEach.call(E, function(U, Q) {
      x[Q] = U.charCodeAt(0);
    }), x;
  }
  function Pe(Y) {
    var H = Array.prototype.map.call(Y, function(x) {
      return String.fromCharCode(x);
    }).join(""), E = H.replace(/(.)/g, function(x, U) {
      var Q = U.charCodeAt(0).toString(16).toUpperCase();
      return Q.length < 2 && (Q = "0" + Q), "%" + Q;
    });
    return decodeURIComponent(E);
  }
  function dt(Y) {
    return JSON.parse(Pe(Y));
  }
  function tt(Y) {
    for (var H = "", E = 0; E < Y.length; ++E) {
      var x = String.fromCharCode(Y[E]);
      if (H += x, x === "\r") {
        E += 2;
        break;
      }
    }
    var U = H.split(" ");
    return {
      size: E,
      protocol: U[0],
      version: U[1],
      headerSize: Number(U[2])
    };
  }
  var st = /* @__PURE__ */ function() {
    function Y() {
      Z.default(this, Y);
    }
    return P.default(Y, null, [{
      key: "parse",
      value: function(E) {
        var x = 2, U = new Uint8Array(E), Q = tt(U);
        if (Q.protocol !== "TWILSOCK" || Q.version !== "V3.0")
          return Me.error("unsupported protocol: ".concat(Q.protocol, " ver ").concat(Q.version)), null;
        var D;
        try {
          D = dt(U.subarray(Q.size, Q.size + Q.headerSize));
        } catch (_e) {
          return Me.error("failed to parse message header", _e, E), null;
        }
        Me.debug("message received: ", D.method), Me.trace("message received: ", D);
        var Fe;
        if (D.payload_size > 0) {
          var Se = x + Q.size + Q.headerSize, je = D.payload_size;
          if (!D.hasOwnProperty("payload_type") || D.payload_type.indexOf("application/json") === 0)
            try {
              Fe = dt(U.subarray(Se, Se + je));
            } catch (_e) {
              return Me.error("failed to parse message body", _e, E), null;
            }
          else
            D.payload_type.indexOf("text/plain") === 0 && (Fe = Pe(U.subarray(Se, Se + je)));
        }
        return {
          method: D.method,
          header: D,
          payload: Fe
        };
      }
    }, {
      key: "createPacket",
      value: function(E) {
        var x = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
        E.payload_size = se(x);
        var U = JSON.stringify(E), Q = "TWILSOCK V3.0 " + se(U);
        Me.debug("send request:", Q + U + x);
        var D = ze(Q + `\r
` + U + `\r
` + x);
        return D.buffer;
      }
    }]), Y;
  }();
  function vt(Y) {
    var H = ht();
    return function() {
      var x = ne.default(Y), U;
      if (H) {
        var Q = ne.default(this).constructor;
        U = Reflect.construct(x, arguments, Q);
      } else
        U = x.apply(this, arguments);
      return _.default(this, U);
    };
  }
  function ht() {
    if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
      return !1;
    if (typeof Proxy == "function")
      return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      })), !0;
    } catch {
      return !1;
    }
  }
  var lt = /* @__PURE__ */ function(Y) {
    L.default(E, Y);
    var H = vt(E);
    function E(x) {
      return Z.default(this, E), H.call(this, x);
    }
    return E;
  }(/* @__PURE__ */ ue.default(Error));
  function G(Y) {
    var H = Ce();
    return function() {
      var x = ne.default(Y), U;
      if (H) {
        var Q = ne.default(this).constructor;
        U = Reflect.construct(x, arguments, Q);
      } else
        U = x.apply(this, arguments);
      return _.default(this, U);
    };
  }
  function Ce() {
    if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
      return !1;
    if (typeof Proxy == "function")
      return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      })), !0;
    } catch {
      return !1;
    }
  }
  var Te = /* @__PURE__ */ function(Y) {
    L.default(E, Y);
    var H = G(E);
    function E(x, U) {
      var Q;
      return Z.default(this, E), Q = H.call(this, x), Q.reply = U, Q;
    }
    return E;
  }(lt);
  function ct(Y, H) {
    var E = Object.keys(Y);
    if (Object.getOwnPropertySymbols) {
      var x = Object.getOwnPropertySymbols(Y);
      H && (x = x.filter(function(U) {
        return Object.getOwnPropertyDescriptor(Y, U).enumerable;
      })), E.push.apply(E, x);
    }
    return E;
  }
  function Ft(Y) {
    for (var H = 1; H < arguments.length; H++) {
      var E = arguments[H] != null ? arguments[H] : {};
      H % 2 ? ct(Object(E), !0).forEach(function(x) {
        le.default(Y, x, E[x]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(Y, Object.getOwnPropertyDescriptors(E)) : ct(Object(E)).forEach(function(x) {
        Object.defineProperty(Y, x, Object.getOwnPropertyDescriptor(E, x));
      });
    }
    return Y;
  }
  function nt(Y) {
    var H = Ct();
    return function() {
      var x = ne.default(Y), U;
      if (H) {
        var Q = ne.default(this).constructor;
        U = Reflect.construct(x, arguments, Q);
      } else
        U = x.apply(this, arguments);
      return _.default(this, U);
    };
  }
  function Ct() {
    if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
      return !1;
    if (typeof Proxy == "function")
      return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      })), !0;
    } catch {
      return !1;
    }
  }
  var Wt = /* @__PURE__ */ function(Y) {
    L.default(E, Y);
    var H = nt(E);
    function E(x) {
      var U;
      return Z.default(this, E), U = H.call(this), le.default(K.default(U), "newBackoff", null), le.default(K.default(U), "usedBackoff", null), le.default(K.default(U), "retrier", null), U.options = x ? Ft({}, x) : {}, U;
    }
    return P.default(E, [{
      key: "inProgress",
      get: function() {
        return !!this.retrier;
      }
    }, {
      key: "start",
      value: function() {
        if (this.inProgress)
          throw new Error("Already waiting for next attempt, call finishAttempt(success : boolean) to finish it");
        this.createRetrier();
      }
      /**
       * Should be called to stop retrier entirely.
       */
    }, {
      key: "stop",
      value: function() {
        this.cleanRetrier(), this.newBackoff = null, this.usedBackoff = null;
      }
      /**
       * Modifies backoff for next attempt.
       * Expected behavior:
       * - If there was no backoff passed previously reschedulling next attempt to given backoff
       * - If previous backoff was longer then ignoring this one.
       * - If previous backoff was shorter then reschedulling with this one.
       * With or without backoff retrier will keep growing normally.
       * @param delay delay of next attempts in ms.
       */
    }, {
      key: "modifyBackoff",
      value: function(U) {
        this.newBackoff = U;
      }
      /**
       * Mark last emmited attempt as failed, initiating either next of fail if limits were hit.
       */
    }, {
      key: "attemptFailed",
      value: function() {
        if (!this.inProgress)
          throw new Error("No attempt is in progress");
        if (this.newBackoff) {
          var U = !this.usedBackoff || this.usedBackoff < this.newBackoff;
          if (U)
            this.createRetrier();
          else {
            var Q;
            (Q = this.retrier) === null || Q === void 0 || Q.failed(new Error());
          }
        } else {
          var D;
          (D = this.retrier) === null || D === void 0 || D.failed(new Error());
        }
      }
    }, {
      key: "cancel",
      value: function() {
        var U;
        (U = this.retrier) === null || U === void 0 || U.cancel();
      }
    }, {
      key: "cleanRetrier",
      value: function() {
        var U, Q;
        (U = this.retrier) === null || U === void 0 || U.removeAllListeners(), (Q = this.retrier) === null || Q === void 0 || Q.cancel(), this.retrier = null;
      }
    }, {
      key: "getRetryPolicy",
      value: function() {
        var U = Ft({}, this.options);
        return this.newBackoff && (U.min = this.newBackoff, U.max = this.options.max && this.options.max > this.newBackoff ? this.options.max : this.newBackoff), U.maxAttemptsCount = this.options.maxAttemptsCount ? this.options.maxAttemptsCount + 1 : void 0, U;
      }
    }, {
      key: "createRetrier",
      value: function() {
        var U = this;
        this.cleanRetrier();
        var Q = this.getRetryPolicy();
        this.retrier = new w.Retrier(Q), this.retrier.once("attempt", function() {
          var D, Fe;
          (D = U.retrier) === null || D === void 0 || D.on("attempt", function() {
            return U.emit("attempt");
          }), (Fe = U.retrier) === null || Fe === void 0 || Fe.failed(new Error("Skipping first attempt"));
        }), this.retrier.on("failed", function(D) {
          return U.emit("failed", D);
        }), this.usedBackoff = this.newBackoff, this.newBackoff = null, this.retrier.start();
      }
    }]), E;
  }(oe);
  function yr(Y) {
    var H = hr();
    return function() {
      var x = ne.default(Y), U;
      if (H) {
        var Q = ne.default(this).constructor;
        U = Reflect.construct(x, arguments, Q);
      } else
        U = x.apply(this, arguments);
      return _.default(this, U);
    };
  }
  function hr() {
    if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
      return !1;
    if (typeof Proxy == "function")
      return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      })), !0;
    } catch {
      return !1;
    }
  }
  var Yt = 3e3;
  function Vr(Y) {
    setTimeout(Y, 0);
  }
  var xr = /* @__PURE__ */ function(Y) {
    L.default(E, Y);
    var H = yr(E);
    function E(x, U, Q) {
      var D;
      Z.default(this, E), D = H.call(this), le.default(K.default(D), "disconnectingTimer", null), le.default(K.default(D), "disconnectedPromiseResolve", null), le.default(K.default(D), "terminalStates", ["disconnected", "rejected"]), le.default(K.default(D), "tokenExpiredSasCode", 20104), le.default(K.default(D), "terminationReason", "Connection is not initialized"), D.websocket = x, D.websocket.on("connected", function() {
        return D.fsm.socketConnected();
      }), D.websocket.on("disconnected", function() {
        return D.fsm.socketClosed();
      }), D.websocket.on("message", function(Se) {
        return D.onIncomingMessage(Se);
      }), D.websocket.on("socketError", function(Se) {
        return D.emit("connectionError", {
          terminal: !1,
          message: "Socket error: ".concat(Se.message),
          httpStatusCode: null,
          errorCode: null
        });
      }), D.transport = U, D.config = Q, D.retrier = new Wt(Q.retryPolicy), D.retrier.on("attempt", function() {
        return D.retry();
      }), D.retrier.on("failed", function(Se) {
        Me.warn("Retrying failed: ".concat(Se.message)), D.disconnect();
      }), typeof window < "u" && typeof window.addEventListener < "u" && (window.addEventListener("online", function() {
        Me.debug("Browser reported connectivity state: online"), D.resetBackoff(), D.fsm.systemOnline();
      }), window.addEventListener("offline", function() {
        Me.debug("Browser reported connectivity state: offline"), D.websocket.close(), D.fsm.socketClosed();
      }));
      var Fe = ye.factory({
        init: "disconnected",
        transitions: [{
          name: "userConnect",
          from: ["disconnected", "rejected"],
          to: "connecting"
        }, {
          name: "userConnect",
          from: ["connecting", "connected"]
        }, {
          name: "userDisconnect",
          from: ["connecting", "initialising", "connected", "updating", "retrying", "rejected", "waitSocketClosed", "waitOffloadSocketClosed"],
          to: "disconnecting"
        }, {
          name: "userRetry",
          from: ["retrying"],
          to: "connecting"
        }, {
          name: "socketConnected",
          from: ["connecting"],
          to: "initialising"
        }, {
          name: "socketClosed",
          from: ["connecting", "initialising", "connected", "updating", "error", "waitOffloadSocketClosed"],
          to: "retrying"
        }, {
          name: "socketClosed",
          from: ["disconnecting"],
          to: "disconnected"
        }, {
          name: "socketClosed",
          from: ["waitSocketClosed"],
          to: "disconnected"
        }, {
          name: "socketClosed",
          from: ["rejected"],
          to: "rejected"
        }, {
          name: "initSuccess",
          from: ["initialising"],
          to: "connected"
        }, {
          name: "initError",
          from: ["initialising"],
          to: "error"
        }, {
          name: "tokenRejected",
          from: ["initialising", "updating"],
          to: "rejected"
        }, {
          name: "protocolError",
          from: ["initialising", "connected", "updating"],
          to: "error"
        }, {
          name: "receiveClose",
          from: ["initialising", "connected", "updating"],
          to: "waitSocketClosed"
        }, {
          name: "receiveOffload",
          from: ["initialising", "connected", "updating"],
          to: "waitOffloadSocketClosed"
        }, {
          name: "unsupportedProtocol",
          from: ["initialising", "connected", "updating"],
          to: "unsupported"
        }, {
          name: "receiveFatalClose",
          from: ["initialising", "connected", "updating"],
          to: "unsupported"
        }, {
          name: "userUpdateToken",
          from: ["disconnected", "rejected", "connecting", "retrying"],
          to: "connecting"
        }, {
          name: "userUpdateToken",
          from: ["connected"],
          to: "updating"
        }, {
          name: "updateSuccess",
          from: ["updating"],
          to: "connected"
        }, {
          name: "updateError",
          from: ["updating"],
          to: "error"
        }, {
          name: "userSend",
          from: ["connected"],
          to: "connected"
        }, {
          name: "systemOnline",
          from: ["retrying"],
          to: "connecting"
        }],
        methods: {
          onConnecting: function() {
            D.setupSocket(), D.emit("connecting");
          },
          onEnterInitialising: function() {
            D.sendInit();
          },
          onLeaveInitialising: function() {
            D.cancelInit();
          },
          onEnterUpdating: function() {
            D.sendUpdate();
          },
          onLeaveUpdating: function() {
            D.cancelUpdate();
          },
          onEnterRetrying: function() {
            D.initRetry(), D.emit("connecting");
          },
          onEnterConnected: function() {
            D.resetBackoff(), D.onConnected();
          },
          onUserUpdateToken: function() {
            D.resetBackoff();
          },
          onTokenRejected: function() {
            D.resetBackoff(), D.closeSocket(!0), D.finalizeSocket();
          },
          onUserDisconnect: function() {
            D.closeSocket(!0);
          },
          onEnterDisconnecting: function() {
            D.startDisconnectTimer();
          },
          onLeaveDisconnecting: function() {
            D.cancelDisconnectTimer();
          },
          onEnterWaitSocketClosed: function() {
            D.startDisconnectTimer();
          },
          onLeaveWaitSocketClosed: function() {
            D.cancelDisconnectTimer();
          },
          onEnterWaitOffloadSocketClosed: function() {
            D.startDisconnectTimer();
          },
          onLeaveWaitOffloadSocketClosed: function() {
            D.cancelDisconnectTimer();
          },
          onDisconnected: function() {
            D.resetBackoff(), D.finalizeSocket();
          },
          onReceiveClose: function() {
            D.onCloseReceived();
          },
          onReceiveOffload: function(je, _e) {
            Me.debug("onreceiveoffload: ", _e), D.modifyBackoff(_e.body), D.onCloseReceived();
          },
          onUnsupported: function() {
            D.closeSocket(!0), D.finalizeSocket();
          },
          onError: function(je, _e) {
            D.closeSocket(_e), D.finalizeSocket();
          },
          onEnterState: function(je) {
            je.from !== "none" && D.changeState(je);
          },
          onInvalidTransition: function(je, _e, bt) {
            Me.warn("FSM: unexpected transition", _e, bt);
          }
        }
      });
      return D.fsm = new Fe(), D;
    }
    return P.default(E, [{
      key: "changeState",
      value: function(U) {
        Me.debug("FSM: ".concat(U.transition, ": ").concat(U.from, " --> ").concat(U.to)), this.lastEmittedState !== this.state && (this.lastEmittedState = this.state, this.emit("stateChanged", this.state));
      }
    }, {
      key: "resetBackoff",
      value: function() {
        Me.trace("resetBackoff"), this.retrier.stop();
      }
    }, {
      key: "modifyBackoff",
      value: function(U) {
        Me.trace("modifyBackoff", U);
        var Q = U ? U.backoff_policy : null;
        Q && typeof Q.reconnect_min_ms == "number" && this.retrier.modifyBackoff(Q.reconnect_min_ms);
      }
    }, {
      key: "startDisconnectTimer",
      value: function() {
        var U = this;
        Me.trace("startDisconnectTimer"), this.disconnectingTimer && (clearTimeout(this.disconnectingTimer), this.disconnectingTimer = null), this.disconnectingTimer = setTimeout(function() {
          Me.debug("disconnecting is timed out"), U.closeSocket(!0);
        }, Yt);
      }
    }, {
      key: "cancelDisconnectTimer",
      value: function() {
        Me.trace("cancelDisconnectTimer"), this.disconnectingTimer && (clearTimeout(this.disconnectingTimer), this.disconnectingTimer = null);
      }
    }, {
      key: "isConnected",
      get: function() {
        return this.state === "connected" && this.websocket.isConnected;
      }
    }, {
      key: "state",
      get: function() {
        switch (this.fsm.state) {
          case "connecting":
          case "initialising":
          case "retrying":
          case "error":
            return "connecting";
          case "updating":
          case "connected":
            return "connected";
          case "rejected":
            return "denied";
          case "disconnecting":
          case "waitSocketClosed":
          case "waitOffloadSocketClosed":
            return "disconnecting";
          case "disconnected":
          default:
            return "disconnected";
        }
      }
    }, {
      key: "initRetry",
      value: function() {
        Me.debug("initRetry"), this.retrier.inProgress ? this.retrier.attemptFailed() : this.retrier.start();
      }
    }, {
      key: "retry",
      value: function() {
        this.fsm.state != "connecting" ? (Me.trace("retry"), this.websocket.close(), this.fsm.userRetry()) : Me.trace("can	 retry as already connecting");
      }
    }, {
      key: "onConnected",
      value: function() {
        this.emit("connected");
      }
    }, {
      key: "finalizeSocket",
      value: function() {
        Me.trace("finalizeSocket"), this.websocket.close(), this.emit("disconnected"), this.disconnectedPromiseResolve && (this.disconnectedPromiseResolve(), this.disconnectedPromiseResolve = null);
      }
    }, {
      key: "setupSocket",
      value: function() {
        Me.trace("setupSocket:", this.config.token), this.emit("beforeConnect"), this.websocket.connect();
      }
    }, {
      key: "onIncomingMessage",
      value: function(U) {
        var Q = st.parse(U);
        if (Q) {
          var D = Q.method, Fe = Q.header, Se = Q.payload;
          if (D !== "reply" && this.confirmReceiving(Fe), D === "notification")
            this.emit("message", Fe.message_type, Se);
          else if (Fe.method === "reply")
            this.transport.processReply({
              id: Fe.id,
              status: Fe.status,
              header: Fe,
              body: Se
            });
          else if (Fe.method === "client_update")
            Fe.client_update_type === "token_about_to_expire" && this.emit("tokenAboutToExpire");
          else if (Fe.method === "close")
            if (Fe.status.code === 308)
              Me.debug("Connection has been offloaded"), this.fsm.receiveOffload({
                status: Fe.status.status,
                body: Se
              });
            else if (Fe.status.code === 406) {
              var je = "Server closed connection because can't parse protocol: ".concat(JSON.stringify(Fe.status));
              this.emitReplyConnectionError(je, Fe, !0), Me.error(je), this.fsm.receiveFatalClose();
            } else
              Fe.status.code === 417 ? (Me.error("Server closed connection because can't parse client reply: ".concat(JSON.stringify(Fe.status))), this.fsm.receiveFatalClose(Fe.status.status)) : Fe.status.code === 410 ? (Me.warn("Server closed connection: ".concat(JSON.stringify(Fe.status))), this.fsm.receiveClose(Fe.status.status), this.emit("tokenExpired")) : Fe.status.code === 401 ? (Me.error("Server closed connection: ".concat(JSON.stringify(Fe.status))), this.fsm.receiveClose(Fe.status.status)) : (Me.warn("unexpected message: ", Fe.status), this.fsm.receiveOffload({
                status: Fe.status.status,
                body: null
              }));
        }
      }
    }, {
      key: "sendInit",
      value: function() {
        var x = I.default(/* @__PURE__ */ he.default.mark(function Q() {
          var D, Fe;
          return he.default.wrap(function(je) {
            for (; ; )
              switch (je.prev = je.next) {
                case 0:
                  return Me.trace("sendInit"), je.prev = 1, this.emit("beforeSendInit"), je.next = 5, this.transport.sendInit();
                case 5:
                  D = je.sent, this.config.updateContinuationToken(D.continuationToken), this.config.confirmedCapabilities = D.confirmedCapabilities, this.fsm.initSuccess(D), this.emit("initialized", D), this.emit("tokenUpdated"), je.next = 17;
                  break;
                case 13:
                  je.prev = 13, je.t0 = je.catch(1), je.t0 instanceof Te ? (Fe = !1, Me.warn("Init rejected by server: ".concat(JSON.stringify(je.t0.reply.status))), this.emit("sendInitFailed"), je.t0.reply.status.code === 401 || je.t0.reply.status.code === 403 ? (Fe = !0, this.fsm.tokenRejected(je.t0.reply.status), je.t0.reply.status.errorCode === this.tokenExpiredSasCode && this.emit("tokenExpired")) : je.t0.reply.status.code === 429 ? (this.modifyBackoff(je.t0.reply.body), this.fsm.initError(!0)) : je.t0.reply.status.code === 500 ? this.fsm.initError(!1) : this.fsm.initError(!0), this.emitReplyConnectionError(je.t0.message, je.t0.reply, Fe)) : (this.terminationReason = je.t0.message, this.emit("connectionError", {
                    terminal: !0,
                    message: "Unknown error during connection initialisation: ".concat(je.t0.message, `
`).concat(JSON.stringify(je.t0, null, 2)),
                    httpStatusCode: null,
                    errorCode: null
                  }), this.fsm.initError(!0)), this.emit("tokenUpdated", je.t0);
                case 17:
                case "end":
                  return je.stop();
              }
          }, Q, this, [[1, 13]]);
        }));
        function U() {
          return x.apply(this, arguments);
        }
        return U;
      }()
    }, {
      key: "sendUpdate",
      value: function() {
        var x = I.default(/* @__PURE__ */ he.default.mark(function Q() {
          var D, Fe, Se;
          return he.default.wrap(function(_e) {
            for (; ; )
              switch (_e.prev = _e.next) {
                case 0:
                  return Me.trace("sendUpdate"), D = new Nr(this.config.token), _e.prev = 2, _e.next = 5, this.transport.sendWithReply(D);
                case 5:
                  Fe = _e.sent, this.fsm.updateSuccess(Fe.body), this.emit("tokenUpdated"), _e.next = 14;
                  break;
                case 10:
                  _e.prev = 10, _e.t0 = _e.catch(2), _e.t0 instanceof Te ? (Se = !1, Me.warn("Token update rejected by server: ".concat(JSON.stringify(_e.t0.reply.status))), _e.t0.reply.status.code === 401 || _e.t0.reply.status.code === 403 ? (Se = !0, this.fsm.tokenRejected(_e.t0.reply.status), _e.t0.reply.status.errorCode === this.tokenExpiredSasCode && this.emit("tokenExpired")) : _e.t0.reply.status.code === 429 ? (this.modifyBackoff(_e.t0.reply.body), this.fsm.updateError(_e.t0.reply.status)) : this.fsm.updateError(_e.t0.reply.status), this.emitReplyConnectionError(_e.t0.message, _e.t0.reply, Se)) : (this.emit("error", !1, _e.t0.message, null, null), this.fsm.updateError(_e.t0)), this.emit("tokenUpdated", _e.t0);
                case 14:
                case "end":
                  return _e.stop();
              }
          }, Q, this, [[2, 10]]);
        }));
        function U() {
          return x.apply(this, arguments);
        }
        return U;
      }()
    }, {
      key: "emitReplyConnectionError",
      value: function(U, Q, D) {
        var Fe = Q.status && Q.status.description ? Q.status.description : U, Se = Q.status.code, je = Q.status && Q.status.errorCode ? Q.status.errorCode : null;
        D && (this.terminationReason = Fe), this.emit("connectionError", {
          terminal: D,
          message: "Connection error: ".concat(Fe),
          httpStatusCode: Se,
          errorCode: je
        });
      }
    }, {
      key: "cancelInit",
      value: function() {
        Me.trace("cancelInit");
      }
    }, {
      key: "cancelUpdate",
      value: function() {
        Me.trace("cancelUpdate");
      }
      /**
       * Should be called for each message to confirm it received
       */
    }, {
      key: "confirmReceiving",
      value: function(U) {
        Me.trace("confirmReceiving");
        try {
          this.transport.send(new qe(U.id));
        } catch (Q) {
          Me.debug("failed to confirm packet receiving", Q);
        }
      }
      /**
       * Shutdown connection
       */
    }, {
      key: "closeSocket",
      value: function(U) {
        var Q = this;
        Me.trace("closeSocket (graceful: ".concat(U, ")")), U && this.transport.isConnected && this.transport.sendClose(), this.websocket.close(), Vr(function() {
          return Q.fsm.socketClosed();
        });
      }
      /**
       * Initiate the twilsock connection
       * If already connected, it does nothing
       */
    }, {
      key: "connect",
      value: function() {
        Me.trace("connect"), this.fsm.userConnect();
      }
      /**
       * Close twilsock connection
       * If already disconnected, it does nothing
       */
    }, {
      key: "disconnect",
      value: function() {
        var U = this;
        return Me.trace("disconnect"), this.fsm.is("disconnected") ? Promise.resolve() : new Promise(function(Q) {
          U.disconnectedPromiseResolve = Q, U.fsm.userDisconnect();
        });
      }
      /**
       * Update fpa token for twilsock connection
       */
    }, {
      key: "updateToken",
      value: function(U) {
        var Q = this;
        return Me.trace("updateToken:", U), new Promise(function(D, Fe) {
          Q.once("tokenUpdated", function(Se) {
            Se ? Fe(Se) : D();
          }), Q.fsm.userUpdateToken();
        });
      }
    }, {
      key: "isTerminalState",
      get: function() {
        return this.terminalStates.indexOf(this.fsm.state) !== -1;
      }
    }, {
      key: "getTerminationReason",
      get: function() {
        return this.terminationReason;
      }
    }, {
      key: "onCloseReceived",
      value: function() {
        this.websocket.close();
      }
    }]), E;
  }(oe), Qn = /* @__PURE__ */ function() {
    function Y() {
      Z.default(this, Y);
    }
    return P.default(Y, null, [{
      key: "getMetadata",
      value: function(E) {
        var x, U, Q, D, Fe, Se, je, _e, bt = E && E.clientMetadata ? E.clientMetadata : {}, Ir = ["ver", "env", "envv", "os", "osv", "osa", "type", "sdk", "sdkv", "dev", "devv", "devt", "app", "appv"], gi = {
          env: (x = M.name) !== null && x !== void 0 ? x : "unknown",
          envv: (U = M.version) !== null && U !== void 0 ? U : "unknown",
          os: (Q = (D = M.os) === null || D === void 0 ? void 0 : D.family) !== null && Q !== void 0 ? Q : "unknown",
          osv: (Fe = (Se = M.os) === null || Se === void 0 ? void 0 : Se.version) !== null && Fe !== void 0 ? Fe : "unknown",
          osa: (je = (_e = M.os) === null || _e === void 0 ? void 0 : _e.architecture) !== null && je !== void 0 ? je : "unknown",
          sdk: "js-default"
        }, ln = {};
        return Ir.filter(function(yi) {
          return yi in bt || yi in gi;
        }).forEach(function(yi) {
          return ln[yi] = yi in bt ? bt[yi] : gi[yi];
        }), ln;
      }
    }]), Y;
  }(), fn = 3e4;
  function uo(Y) {
    return Y >= 200 && Y < 300;
  }
  function fo(Y) {
    switch (Ie.default(Y)) {
      case "undefined":
        return "";
      case "object":
        return JSON.stringify(Y);
      default:
        return Y;
    }
  }
  var Ea = /* @__PURE__ */ function() {
    function Y(H, E) {
      var x = this;
      Z.default(this, Y), this.config = E, this.activeRequests = /* @__PURE__ */ new Map(), this.channel = H, this.channel.on("reply", function(U) {
        return x.processReply(U);
      }), this.channel.on("disconnected", function() {
        x.activeRequests.forEach(function(U) {
          clearTimeout(U.timeout), U.reject(new lt("disconnected"));
        }), x.activeRequests.clear();
      });
    }
    return P.default(Y, [{
      key: "isConnected",
      get: function() {
        return this.channel.isConnected;
      }
    }, {
      key: "processReply",
      value: function(E) {
        var x = this.activeRequests.get(E.id);
        x && (clearTimeout(x.timeout), this.activeRequests.delete(E.id), uo(E.status.code) ? x.resolve(E) : (x.reject(new Te("Transport failure: " + E.status.status, E)), Me.trace("message rejected")));
      }
    }, {
      key: "storeRequest",
      value: function(E, x, U) {
        var Q = {
          resolve: x,
          reject: U,
          timeout: setTimeout(function() {
            Me.trace("request", E, "is timed out"), U(new lt("Twilsock: request timeout: " + E));
          }, fn)
        };
        this.activeRequests.set(E, Q);
      }
    }, {
      key: "shutdown",
      value: function() {
        this.activeRequests.forEach(function(E) {
          clearTimeout(E.timeout), E.reject(new lt("Twilsock: request cancelled by user"));
        }), this.activeRequests.clear();
      }
    }, {
      key: "sendInit",
      value: function() {
        var H = I.default(/* @__PURE__ */ he.default.mark(function x() {
          var U, Q, D;
          return he.default.wrap(function(Se) {
            for (; ; )
              switch (Se.prev = Se.next) {
                case 0:
                  return Me.trace("sendInit"), U = Qn.getMetadata(this.config), Q = new at(this.config.token, this.config.continuationToken, U, this.config.initRegistrations, this.config.tweaks), Se.next = 5, this.sendWithReply(Q);
                case 5:
                  return D = Se.sent, Se.abrupt("return", new vr(D.id, D.header.continuation_token, new Set(D.header.capabilities), D.header.continuation_token_status, D.header.offline_storage, D.header.init_registrations, D.header.debug_info));
                case 7:
                case "end":
                  return Se.stop();
              }
          }, x, this);
        }));
        function E() {
          return H.apply(this, arguments);
        }
        return E;
      }()
    }, {
      key: "sendClose",
      value: function() {
        var E = new Xe();
        this.send(E);
      }
    }, {
      key: "sendWithReply",
      value: function(E, x) {
        var U = this;
        return new Promise(function(Q, D) {
          var Fe = U.send(E, x);
          U.storeRequest(Fe, Q, D);
        });
      }
    }, {
      key: "send",
      value: function(E, x) {
        E.id = E.id || "TM".concat(m.v4());
        var U = st.createPacket(E, fo(x));
        try {
          return this.channel.send(U), E.id;
        } catch (Q) {
          throw Me.debug("failed to send ", E, Q), Me.trace(Q.stack), Q;
        }
      }
    }]), Y;
  }();
  function zu(Y) {
    var H = lo();
    return function() {
      var x = ne.default(Y), U;
      if (H) {
        var Q = ne.default(this).constructor;
        U = Reflect.construct(x, arguments, Q);
      } else
        U = x.apply(this, arguments);
      return _.default(this, U);
    };
  }
  function lo() {
    if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
      return !1;
    if (typeof Proxy == "function")
      return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      })), !0;
    } catch {
      return !1;
    }
  }
  var Jn = /* @__PURE__ */ function(Y) {
    L.default(E, Y);
    var H = zu(E);
    function E(x) {
      var U;
      return Z.default(this, E), U = H.call(this), le.default(K.default(U), "socket", null), U.url = x, U.url = x, U.WebSocket = t.WebSocket || t.MozWebSocket || {}, U;
    }
    return P.default(E, [{
      key: "isConnected",
      get: function() {
        return !!this.socket && this.socket.readyState === 1;
      }
    }, {
      key: "connect",
      value: function() {
        var U = this;
        Me.trace("connecting to socket");
        var Q;
        try {
          Q = new this.WebSocket(this.url);
        } catch (D) {
          Me.debug("Socket error: ".concat(this.url)), this.emit("socketError", D);
          return;
        }
        Q.binaryType = "arraybuffer", Q.onopen = function() {
          Me.debug("socket opened ".concat(U.url)), U.emit("connected");
        }, Q.onclose = function(D) {
          Me.debug("socket closed", D), U.emit("disconnected", D);
        }, Q.onerror = function(D) {
          Me.debug("Socket error:", D), U.emit("socketError", D);
        }, Q.onmessage = function(D) {
          U.emit("message", D.data);
        }, this.socket = Q;
      }
    }, {
      key: "send",
      value: function(U) {
        return this.socket && this.socket.send(U);
      }
    }, {
      key: "close",
      value: function() {
        if (Me.trace("closing socket"), this.socket) {
          this.socket.onopen = null, this.socket.onclose = null, this.socket.onerror = null, this.socket.onmessage = null;
          try {
            this.socket.close();
          } finally {
          }
        }
      }
    }]), E;
  }(oe);
  function Gu(Y) {
    var H = mn();
    return function() {
      var x = ne.default(Y), U;
      if (H) {
        var Q = ne.default(this).constructor;
        U = Reflect.construct(x, arguments, Q);
      } else
        U = x.apply(this, arguments);
      return _.default(this, U);
    };
  }
  function mn() {
    if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
      return !1;
    if (typeof Proxy == "function")
      return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      })), !0;
    } catch {
      return !1;
    }
  }
  var Qu = /* @__PURE__ */ function(Y) {
    L.default(E, Y);
    var H = Gu(E);
    function E(x) {
      var U;
      return Z.default(this, E), U = H.call(this), U.transport = x, U.registrations = /* @__PURE__ */ new Map(), U.registrationsInProgress = /* @__PURE__ */ new Map(), U;
    }
    return P.default(E, [{
      key: "putNotificationContext",
      value: function() {
        var x = I.default(/* @__PURE__ */ he.default.mark(function Q(D, Fe) {
          var Se;
          return he.default.wrap(function(_e) {
            for (; ; )
              switch (_e.prev = _e.next) {
                case 0:
                  return Se = {
                    method: "put_notification_ctx",
                    notification_ctx_id: D
                  }, _e.next = 3, this.transport.sendWithReply(Se, Fe);
                case 3:
                case "end":
                  return _e.stop();
              }
          }, Q, this);
        }));
        function U(Q, D) {
          return x.apply(this, arguments);
        }
        return U;
      }()
    }, {
      key: "deleteNotificationContext",
      value: function() {
        var x = I.default(/* @__PURE__ */ he.default.mark(function Q(D) {
          var Fe;
          return he.default.wrap(function(je) {
            for (; ; )
              switch (je.prev = je.next) {
                case 0:
                  return Fe = {
                    method: "delete_notification_ctx",
                    notification_ctx_id: D
                  }, je.next = 3, this.transport.sendWithReply(Fe);
                case 3:
                case "end":
                  return je.stop();
              }
          }, Q, this);
        }));
        function U(Q) {
          return x.apply(this, arguments);
        }
        return U;
      }()
    }, {
      key: "updateRegistration",
      value: function() {
        var x = I.default(/* @__PURE__ */ he.default.mark(function Q(D, Fe) {
          var Se, je;
          return he.default.wrap(function(bt) {
            for (; ; )
              switch (bt.prev = bt.next) {
                case 0:
                  return Me.debug("update registration for context", D), Se = this.registrationsInProgress.get(D), Se || (Se = /* @__PURE__ */ new Set(), this.registrationsInProgress.set(D, Se)), je = m.v4(), Se.add(je), bt.prev = 5, bt.next = 8, this.putNotificationContext(D, Fe);
                case 8:
                  Me.debug("registration attempt succeeded for context", Fe), Se.delete(je), Se.size === 0 && (this.registrationsInProgress.delete(D), this.emit("registered", D)), bt.next = 19;
                  break;
                case 13:
                  bt.prev = 13, bt.t0 = bt.catch(5), Me.warn("registration attempt failed for context", Fe), Me.debug(bt.t0), Se.delete(je), Se.size === 0 && (this.registrationsInProgress.delete(D), this.emit("registrationFailed", D, bt.t0));
                case 19:
                case "end":
                  return bt.stop();
              }
          }, Q, this, [[5, 13]]);
        }));
        function U(Q, D) {
          return x.apply(this, arguments);
        }
        return U;
      }()
    }, {
      key: "updateRegistrations",
      value: function() {
        var x = I.default(/* @__PURE__ */ he.default.mark(function Q() {
          var D = this, Fe;
          return he.default.wrap(function(je) {
            for (; ; )
              switch (je.prev = je.next) {
                case 0:
                  return Me.trace("refreshing ".concat(this.registrations.size, " registrations")), Fe = [], this.registrations.forEach(function(_e, bt) {
                    Fe.push(D.updateRegistration(bt, _e));
                  }), je.next = 5, Promise.all(Fe);
                case 5:
                case "end":
                  return je.stop();
              }
          }, Q, this);
        }));
        function U() {
          return x.apply(this, arguments);
        }
        return U;
      }()
    }, {
      key: "setNotificationsContext",
      value: function() {
        var x = I.default(/* @__PURE__ */ he.default.mark(function Q(D, Fe) {
          return he.default.wrap(function(je) {
            for (; ; )
              switch (je.prev = je.next) {
                case 0:
                  if (!(!D || !Fe)) {
                    je.next = 2;
                    break;
                  }
                  throw new lt("Invalid arguments provided");
                case 2:
                  return this.registrations.set(D, Fe), je.next = 5, this.updateRegistration(D, Fe);
                case 5:
                  return je.abrupt("return", je.sent);
                case 6:
                case "end":
                  return je.stop();
              }
          }, Q, this);
        }));
        function U(Q, D) {
          return x.apply(this, arguments);
        }
        return U;
      }()
    }, {
      key: "removeNotificationsContext",
      value: function() {
        var x = I.default(/* @__PURE__ */ he.default.mark(function Q(D) {
          return he.default.wrap(function(Se) {
            for (; ; )
              switch (Se.prev = Se.next) {
                case 0:
                  if (this.registrations.has(D)) {
                    Se.next = 2;
                    break;
                  }
                  return Se.abrupt("return");
                case 2:
                  return Se.next = 4, this.deleteNotificationContext(D);
                case 4:
                  this.transport.isConnected && this.registrations.delete(D);
                case 5:
                case "end":
                  return Se.stop();
              }
          }, Q, this);
        }));
        function U(Q) {
          return x.apply(this, arguments);
        }
        return U;
      }()
    }]), E;
  }(oe);
  function co(Y) {
    var H = Lr();
    return function() {
      var x = ne.default(Y), U;
      if (H) {
        var Q = ne.default(this).constructor;
        U = Reflect.construct(x, arguments, Q);
      } else
        U = x.apply(this, arguments);
      return _.default(this, U);
    };
  }
  function Lr() {
    if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
      return !1;
    if (typeof Proxy == "function")
      return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      })), !0;
    } catch {
      return !1;
    }
  }
  var Ju = /* @__PURE__ */ function(Y) {
    L.default(E, Y);
    var H = co(E);
    function E(x, U, Q) {
      var D;
      return Z.default(this, E), D = H.call(this, U), D.status = x, D.description = U, D.body = Q, D;
    }
    return E;
  }(lt);
  function Oa(Y) {
    var H = po();
    return function() {
      var x = ne.default(Y), U;
      if (H) {
        var Q = ne.default(this).constructor;
        U = Reflect.construct(x, arguments, Q);
      } else
        U = x.apply(this, arguments);
      return _.default(this, U);
    };
  }
  function po() {
    if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
      return !1;
    if (typeof Proxy == "function")
      return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      })), !0;
    } catch {
      return !1;
    }
  }
  var hi = /* @__PURE__ */ function(Y) {
    L.default(E, Y);
    var H = Oa(E);
    function E(x) {
      return Z.default(this, E), H.call(this, x);
    }
    return E;
  }(lt), vo = 2e4;
  function Hn(Y) {
    return Y >= 200 && Y < 300;
  }
  function zt(Y) {
    return Y && Y.header && Y.header.http_status;
  }
  function Hu(Y) {
    var H = Y.match(/^(https?\:)\/\/(([^:\/?#]*)(?:\:([0-9]+))?)(\/[^?#]*)(\?[^#]*|)(#.*|)$/);
    if (H) {
      var E = {
        protocol: H[1],
        host: H[2],
        hostname: H[3],
        port: H[4],
        pathname: H[5],
        search: H[6],
        hash: H[7],
        params: {}
      };
      if (E.search.length > 0) {
        var x = E.search.substring(1);
        E.params = x.split("&").map(function(U) {
          return U.split("=");
        }).reduce(function(U, Q) {
          return U.hasOwnProperty(Q[0]) ? Array.isArray(U[Q[0]]) ? U[Q[0]].push(Q[1]) : U[Q[0]] = [U[Q[0]], Q[1]] : U[Q[0]] = Q[1], U;
        }, {});
      }
      return E;
    }
    throw new lt("Incorrect URI: " + Y);
  }
  function _u(Y, H) {
    var E = Hu(H), x = {
      method: Y,
      host: E.host,
      path: E.pathname
    };
    return E.params && (x.params = E.params), x;
  }
  function $u(Y, H, E, x, U) {
    return {
      to: _u(Y, H),
      headers: E,
      body: x,
      grant: U
    };
  }
  var As = /* @__PURE__ */ function() {
    function Y(H, E, x) {
      Z.default(this, Y), this.config = x, this.transport = H, this.pendingMessages = [], this.twilsock = E;
    }
    return P.default(Y, [{
      key: "saveMessage",
      value: function(E) {
        var x = this;
        return new Promise(function(U, Q) {
          var D = {
            message: E,
            resolve: U,
            reject: Q,
            alreadyRejected: !1,
            timeout: setTimeout(function() {
              Me.debug("request is timed out"), Q(new lt("request '".concat(E.to.method, "' to '").concat(E.to.host, "' timed out"))), D.alreadyRejected = !0;
            }, vo)
          };
          x.pendingMessages.push(D);
        });
      }
    }, {
      key: "sendPendingMessages",
      value: function() {
        for (var E = this, x = function() {
          var D = E.pendingMessages[0];
          if (!D.alreadyRejected)
            try {
              var Fe = D.message;
              E.actualSend(Fe).then(function(Se) {
                return D.resolve(Se);
              }).catch(function(Se) {
                return D.reject(Se);
              }), clearTimeout(D.timeout);
            } catch (Se) {
              return Me.debug("Failed to send pending message", Se), "break";
            }
          E.pendingMessages.splice(0, 1);
        }; this.pendingMessages.length > 0; ) {
          var U = x();
          if (U === "break")
            break;
        }
      }
    }, {
      key: "rejectPendingMessages",
      value: function() {
        var E = this;
        this.pendingMessages.forEach(function(x) {
          x.reject(new hi(
            // @todo Error Unhandled promise rejection!
            "Unable to connect: " + E.twilsock.getTerminationReason
          )), x.alreadyRejected = !0, clearTimeout(x.timeout);
        }), this.pendingMessages.splice(0, this.pendingMessages.length);
      }
    }, {
      key: "actualSend",
      value: function() {
        var H = I.default(/* @__PURE__ */ he.default.mark(function x(U) {
          var Q, D, Fe, Se, je, _e, bt, Ir;
          return he.default.wrap(function(ln) {
            for (; ; )
              switch (ln.prev = ln.next) {
                case 0:
                  return D = U.to, Fe = U.headers, Se = U.body, je = (Q = U.grant) !== null && Q !== void 0 ? Q : this.config.activeGrant, _e = {
                    host: D.host,
                    path: D.path,
                    method: D.method,
                    params: D.params,
                    headers: Fe
                  }, bt = new Ke(je, Fe["Content-Type"] || "application/json", _e), Me.trace("Sending upstream message", bt), ln.next = 9, this.transport.sendWithReply(bt, Se);
                case 9:
                  if (Ir = ln.sent, Me.trace("Received upstream message response", Ir), !(zt(Ir) && !Hn(Ir.header.http_status.code))) {
                    ln.next = 13;
                    break;
                  }
                  throw new Ju(Ir.header.http_status.code, Ir.header.http_status.status, Ir.body);
                case 13:
                  return ln.abrupt("return", {
                    status: Ir.header.http_status,
                    headers: Ir.header.http_headers,
                    body: Ir.body
                  });
                case 14:
                case "end":
                  return ln.stop();
              }
          }, x, this);
        }));
        function E(x) {
          return H.apply(this, arguments);
        }
        return E;
      }()
      /**
       * Send an upstream message
       * @param {string} method The upstream method
       * @param {string} url URL to send the message to
       * @param {object} [headers] The message headers
       * @param {any} [body] The message body
       * @param {string} [grant] The product grant
       * @returns {Promise<Result>} Result from remote side
       */
    }, {
      key: "send",
      value: function(E, x) {
        var U = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, Q = arguments.length > 3 ? arguments[3] : void 0, D = arguments.length > 4 ? arguments[4] : void 0;
        if (this.twilsock.isTerminalState)
          return Promise.reject(new hi("Unable to connect: " + this.twilsock.getTerminationReason));
        var Fe = $u(E, x, U, Q, D);
        return this.twilsock.isConnected ? this.actualSend(Fe) : this.saveMessage(Fe);
      }
    }]), Y;
  }(), ho = /* @__PURE__ */ function() {
    function Y() {
      var H = this;
      Z.default(this, Y), this._promise = new Promise(function(E, x) {
        H._resolve = E, H._reject = x;
      });
    }
    return P.default(Y, [{
      key: "promise",
      get: function() {
        return this._promise;
      }
    }, {
      key: "update",
      value: function(E) {
        this._resolve(E);
      }
    }, {
      key: "set",
      value: function(E) {
        this._resolve(E);
      }
    }, {
      key: "fail",
      value: function(E) {
        this._reject(E);
      }
    }]), Y;
  }(), ef = /* @__PURE__ */ function() {
    function Y(H) {
      Z.default(this, Y), this.id = H;
    }
    return P.default(Y, null, [{
      key: "create",
      value: function(E) {
        if (E instanceof Object && "storage_id" in E)
          return new Y(E.storage_id);
        throw new lt('Field "storage_id" is missing');
      }
    }]), Y;
  }(), ws = /* @__PURE__ */ function() {
    function Y() {
      return Z.default(this, Y), le.default(this, "initializedFlag", "twilio_twilsock_token_storage"), le.default(this, "tokenStoragePrefix", "twilio_continuation_token_"), Y._instance || (this.initialize(), Y._instance = this), Y._instance;
    }
    return P.default(Y, [{
      key: "sessionStorage",
      value: function() {
        try {
          return t.sessionStorage;
        } catch {
          return null;
        }
      }
    }, {
      key: "window",
      value: function() {
        try {
          return t.window;
        } catch {
          return null;
        }
      }
    }, {
      key: "storeToken",
      value: function(E, x) {
        this.canStore() && this.sessionStorage.setItem(this.getKeyName(x), E);
      }
    }, {
      key: "getStoredToken",
      value: function(E) {
        return this.canStore() ? this.sessionStorage.getItem(this.getKeyName(E)) : null;
      }
    }, {
      key: "initialize",
      value: function() {
        var E = this;
        if (this.canStore()) {
          var x = this.sessionStorage.getItem(this.initializedFlag);
          x && this.clear(), this.sessionStorage.setItem(this.initializedFlag, "true");
          var U = this.sessionStorage.removeItem;
          this.window.addEventListener("unload", function() {
            U(E.initializedFlag);
          });
        }
      }
    }, {
      key: "clear",
      value: function() {
        if (this.canStore()) {
          for (var E = [], x = 0; x < this.sessionStorage.length; x++) {
            var U = this.sessionStorage.key(x);
            U && U.indexOf(this.tokenStoragePrefix) === 0 && E.push(U);
          }
          var Q = this.sessionStorage.removeItem;
          E.forEach(function(D) {
            return Q(D);
          }), Q(this.initializedFlag);
        }
      }
    }, {
      key: "getKeyName",
      value: function(E) {
        return "".concat(this.tokenStoragePrefix).concat(E);
      }
    }, {
      key: "canStore",
      value: function() {
        return !!(this.sessionStorage && this.sessionStorage.length && this.window);
      }
    }]), Y;
  }();
  le.default(ws, "_instance", null);
  var na = new ws(), dr = /* @__PURE__ */ function() {
    function Y(H, E, x, U, Q, D) {
      Z.default(this, Y), this.title = H, this.details = E, this.start = x, this.type = Q, this.id = D, this.end = U;
    }
    return P.default(Y, [{
      key: "toTelemetryEvent",
      value: function() {
        var E = /* @__PURE__ */ new Date(), x = this.start, U = this.end ? this.end : E;
        if (U < x) {
          var Q = U;
          U = x, x = Q;
        }
        var D = x.getTime() - E.getTime(), Fe = U.getTime() - E.getTime(), Se = new ae(D, Fe, this.title, this.details, this.id, this.type);
        return Se;
      }
    }]), Y;
  }();
  e.TelemetryPoint = void 0, function(Y) {
    Y[Y.Start = 0] = "Start", Y[Y.End = 1] = "End";
  }(e.TelemetryPoint || (e.TelemetryPoint = {})), e.EventSendingLimitation = void 0, function(Y) {
    Y[Y.MinEventsPortion = 0] = "MinEventsPortion", Y[Y.AnyEvents = 1] = "AnyEvents", Y[Y.AnyEventsIncludingUnfinished = 2] = "AnyEventsIncludingUnfinished";
  }(e.EventSendingLimitation || (e.EventSendingLimitation = {}));
  var mo = /* @__PURE__ */ function() {
    function Y(H, E) {
      Z.default(this, Y), le.default(this, "minEventsPortionToSend", 50), le.default(this, "maxEventsPortionToSend", 100), le.default(this, "pendingEvents", /* @__PURE__ */ new Map()), le.default(this, "readyEvents", []), le.default(this, "hasInitializationFinished", !1), le.default(this, "_canSendTelemetry", !1), this.config = H, this.packetInterface = E;
    }
    return P.default(Y, [{
      key: "isTelemetryEnabled",
      get: function() {
        return this.config.confirmedCapabilities.has("telemetry.v1");
      }
    }, {
      key: "canSendTelemetry",
      get: function() {
        return this._canSendTelemetry && this.isTelemetryEnabled;
      },
      set: function(E) {
        Me.debug("TelemetryTracker.canSendTelemetry: ".concat(E, " TelemetryTracker.isTelemetryEnabled: ").concat(this.isTelemetryEnabled)), this._canSendTelemetry && !E && (this.pendingEvents.clear(), this.readyEvents = []), this._canSendTelemetry = E, E && this.sendTelemetry(e.EventSendingLimitation.AnyEvents), E && !this.hasInitializationFinished && (this.hasInitializationFinished = !0);
      }
      // Add complete event
    }, {
      key: "addTelemetryEvent",
      value: function(E) {
        !this.canSendTelemetry && this.hasInitializationFinished || this.readyEvents.push(E);
      }
      // Add incomplete event (with either starting or ending time point)
    }, {
      key: "addPartialEvent",
      value: function(E, x, U) {
        Me.debug("Adding ".concat(U === e.TelemetryPoint.Start ? "starting" : "ending", " timepoint for '").concat(x, "' event"));
        var Q = this.pendingEvents.has(x);
        if (U === e.TelemetryPoint.Start)
          Q && Me.debug("Overwriting starting point for '".concat(x, "' event")), this.pendingEvents.set(x, E);
        else {
          if (!Q) {
            Me.info("Could not find started event for '".concat(x, "' event"));
            return;
          }
          this.addTelemetryEvent(this.merge(this.pendingEvents.get(x), E)), this.pendingEvents.delete(x);
        }
      }
    }, {
      key: "getTelemetryToSend",
      value: function(E) {
        return !this.canSendTelemetry || this.readyEvents.length == 0 ? [] : E == e.EventSendingLimitation.MinEventsPortion && this.readyEvents.length < this.minEventsPortionToSend ? [] : this.getTelemetryPortion(E == e.EventSendingLimitation.AnyEventsIncludingUnfinished);
      }
    }, {
      key: "getTelemetryPortion",
      value: function(E) {
        var x = this, U = Math.min(this.readyEvents.length, this.maxEventsPortionToSend), Q = this.readyEvents.splice(0, U);
        return E && Q.length < this.maxEventsPortionToSend && this.pendingEvents.forEach(function(D, Fe) {
          if (!(Q.length >= x.maxEventsPortionToSend)) {
            var Se = x.pendingEvents.get(Fe);
            x.pendingEvents.delete(Fe), Q.push(new dr(
              "[UNFINISHED] ".concat(Se.title),
              // add prefix title to mark unfinished events for CleanSock
              Se.details,
              Se.start,
              null,
              // Not ended, on sending will be replaced with now
              Se.type,
              Se.id
            ));
          }
        }), Q;
      }
      // Merging 2 partial events:
      //   use start.startTime & end.endTime.
      // For other fields,
      //   if there are values in end, use them,
      //   else use values from start.
    }, {
      key: "merge",
      value: function(E, x) {
        return new dr(x.title ? x.title : E.title, x.details ? x.details : E.details, E.start, x.end, x.type ? x.type : E.type, x.id ? x.id : E.id);
      }
    }, {
      key: "sendTelemetryIfMinimalPortionCollected",
      value: function() {
        this.sendTelemetry(e.EventSendingLimitation.MinEventsPortion);
      }
      // NB: getTelemetryToSend will return non-empty array only if we have already received initReply
      // and telemetry.v1 capability is enabled there.
    }, {
      key: "sendTelemetry",
      value: function(E) {
        var x = this.getTelemetryToSend(E);
        if (x.length !== 0)
          try {
            this.packetInterface.send(new me(x.map(function(U) {
              return U.toTelemetryEvent();
            })));
          } catch (U) {
            Me.debug("Error while sending ".concat(x.length, " telemetry events due to ").concat(U, "; they will be resubmitted")), this.readyEvents = this.readyEvents.concat(x);
          }
      }
    }]), Y;
  }();
  function tf(Y) {
    var H = _n();
    return function() {
      var x = ne.default(Y), U;
      if (H) {
        var Q = ne.default(this).constructor;
        U = Reflect.construct(x, arguments, Q);
      } else
        U = x.apply(this, arguments);
      return _.default(this, U);
    };
  }
  function _n() {
    if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
      return !1;
    if (typeof Proxy == "function")
      return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      })), !0;
    } catch {
      return !1;
    }
  }
  var mi = function Y() {
    Z.default(this, Y);
  };
  le.default(mi, "TWILSOCK_CONNECT", "twilsock.sdk.connect"), le.default(mi, "TWILSOCK_INIT", "twilsock.sdk.init"), e.TwilsockClient = /* @__PURE__ */ function(Y) {
    L.default(E, Y);
    var H = tf(E);
    function E(x, U, Q) {
      var D;
      Z.default(this, E), D = H.call(this), le.default(K.default(D), "version", Gr), le.default(K.default(D), "offlineStorageDeferred", new ho()), Q.continuationToken = Q.continuationToken ? Q.continuationToken : na.getStoredToken(U);
      var Fe = D.config = new $e(x, U, Q);
      Me.setLevel(Fe.logLevel);
      var Se = new Jn(Fe.url), je = new Ea(Se, Fe);
      return D.channel = new xr(Se, je, Fe), D.registrations = new Qu(je), D.upstream = new As(je, D.channel, Fe), D.telemetryTracker = new mo(Fe, je), D.channel.on("initialized", function() {
        return D.telemetryTracker.canSendTelemetry = !0;
      }), Se.on("disconnected", function() {
        return D.telemetryTracker.canSendTelemetry = !1;
      }), D.registrations.on("registered", function(_e) {
        return D.emit("registered", _e);
      }), D.channel.on("message", function(_e, bt) {
        return setTimeout(function() {
          return D.emit("message", _e, bt);
        }, 0);
      }), D.channel.on("stateChanged", function(_e) {
        return setTimeout(function() {
          return D.emit("stateChanged", _e);
        }, 0);
      }), D.channel.on("connectionError", function(_e) {
        return setTimeout(function() {
          return D.emit("connectionError", _e);
        }, 0);
      }), D.channel.on("tokenAboutToExpire", function() {
        return setTimeout(function() {
          return D.emit("tokenAboutToExpire");
        }, 0);
      }), D.channel.on("tokenExpired", function() {
        return setTimeout(function() {
          return D.emit("tokenExpired");
        }, 0);
      }), D.channel.on("connected", function() {
        return D.registrations.updateRegistrations();
      }), D.channel.on("connected", function() {
        return D.upstream.sendPendingMessages();
      }), D.channel.on("connected", function() {
        return setTimeout(function() {
          return D.emit("connected");
        }, 0);
      }), D.channel.on("beforeConnect", function() {
        return D.telemetryTracker.addPartialEvent(new dr("Establish WebSocket connection", "", /* @__PURE__ */ new Date()), mi.TWILSOCK_CONNECT, e.TelemetryPoint.Start);
      }), D.channel.on("connected", function() {
        return D.telemetryTracker.addPartialEvent(new dr("Establish WebSocket connection", "", /* @__PURE__ */ new Date(), /* @__PURE__ */ new Date()), mi.TWILSOCK_CONNECT, e.TelemetryPoint.End);
      }), D.channel.on("beforeSendInit", function() {
        return D.telemetryTracker.addPartialEvent(new dr("Send Twilsock init", "", /* @__PURE__ */ new Date()), mi.TWILSOCK_INIT, e.TelemetryPoint.Start);
      }), D.channel.on("initialized", function() {
        return D.telemetryTracker.addPartialEvent(new dr("Send Twilsock init", "Succeeded", /* @__PURE__ */ new Date(), /* @__PURE__ */ new Date()), mi.TWILSOCK_INIT, e.TelemetryPoint.End);
      }), D.channel.on("sendInitFailed", function() {
        return D.telemetryTracker.addPartialEvent(new dr("Send Twilsock init", "Failed", /* @__PURE__ */ new Date(), /* @__PURE__ */ new Date()), mi.TWILSOCK_INIT, e.TelemetryPoint.End);
      }), D.channel.on("initialized", function(_e) {
        D.handleStorageId(U, _e), na.storeToken(_e.continuationToken, U), setTimeout(function() {
          return D.emit("initialized", _e);
        }, 0);
      }), D.channel.on("disconnected", function() {
        return setTimeout(function() {
          return D.emit("disconnected");
        }, 0);
      }), D.channel.on("disconnected", function() {
        return D.upstream.rejectPendingMessages();
      }), D.channel.on("disconnected", function() {
        return D.offlineStorageDeferred.fail(new lt("Client disconnected"));
      }), D.offlineStorageDeferred.promise.catch(function() {
      }), D;
    }
    return P.default(E, [{
      key: "emit",
      value: function(U) {
        for (var Q, D = arguments.length, Fe = new Array(D > 1 ? D - 1 : 0), Se = 1; Se < D; Se++)
          Fe[Se - 1] = arguments[Se];
        return Me.debug("Emitting ".concat(U.toString(), "(").concat(Fe.map(function(je) {
          return JSON.stringify(je);
        }).join(", "), ")")), (Q = B.default(ne.default(E.prototype), "emit", this)).call.apply(Q, [this, U].concat(Fe));
      }
    }, {
      key: "handleStorageId",
      value: function(U, Q) {
        if (!Q.offlineStorage)
          this.offlineStorageDeferred.fail(new lt("No offline storage id"));
        else if (Q.offlineStorage.hasOwnProperty(U))
          try {
            this.offlineStorageDeferred.set(ef.create(Q.offlineStorage[U])), Me.debug("Offline storage for '".concat(U, "' product: ").concat(JSON.stringify(Q.offlineStorage[U]), "."));
          } catch (D) {
            this.offlineStorageDeferred.fail(new lt("Failed to parse offline storage for ".concat(U, " ").concat(JSON.stringify(Q.offlineStorage[U]), ". ").concat(D, ".")));
          }
        else
          this.offlineStorageDeferred.fail(new lt("No offline storage id for '".concat(U, "' product: ").concat(JSON.stringify(Q.offlineStorage))));
      }
      /**
       * Get offline storage ID
       * @returns {Promise}
       */
    }, {
      key: "storageId",
      value: function() {
        return this.offlineStorageDeferred.promise;
      }
      /**
       * Indicates if twilsock is connected now
       * @returns {Boolean}
       */
    }, {
      key: "isConnected",
      get: function() {
        return this.channel.isConnected;
      }
      /**
       * Current state
       * @returns {ConnectionState}
       */
    }, {
      key: "state",
      get: function() {
        return this.channel.state;
      }
      /**
       * Update token
       * @param {String} token
       * @returns {Promise}
       */
    }, {
      key: "updateToken",
      value: function() {
        var x = I.default(/* @__PURE__ */ he.default.mark(function Q(D) {
          return he.default.wrap(function(Se) {
            for (; ; )
              switch (Se.prev = Se.next) {
                case 0:
                  if (Me.trace("updating token '".concat(D, "'")), this.config.token !== D) {
                    Se.next = 3;
                    break;
                  }
                  return Se.abrupt("return");
                case 3:
                  return this.config.updateToken(D), Se.next = 6, this.channel.updateToken(D);
                case 6:
                  return Se.abrupt("return", Se.sent);
                case 7:
                case "end":
                  return Se.stop();
              }
          }, Q, this);
        }));
        function U(Q) {
          return x.apply(this, arguments);
        }
        return U;
      }()
      /**
       * Updates notification context.
       * This method shouldn't be used anyone except twilio notifications library
       * @param contextId id of notification context
       * @param context value of notification context
       * @private
       */
    }, {
      key: "setNotificationsContext",
      value: function() {
        var x = I.default(/* @__PURE__ */ he.default.mark(function Q(D, Fe) {
          return he.default.wrap(function(je) {
            for (; ; )
              switch (je.prev = je.next) {
                case 0:
                  return je.next = 2, this.registrations.setNotificationsContext(D, Fe);
                case 2:
                case "end":
                  return je.stop();
              }
          }, Q, this);
        }));
        function U(Q, D) {
          return x.apply(this, arguments);
        }
        return U;
      }()
      /**
       * Remove notification context.
       * This method shouldn't be used anyone except twilio notifications library
       * @param contextId id of notification context
       * @private
       */
    }, {
      key: "removeNotificationsContext",
      value: function() {
        var x = I.default(/* @__PURE__ */ he.default.mark(function Q(D) {
          return he.default.wrap(function(Se) {
            for (; ; )
              switch (Se.prev = Se.next) {
                case 0:
                  return Se.next = 2, this.registrations.removeNotificationsContext(D);
                case 2:
                case "end":
                  return Se.stop();
              }
          }, Q, this);
        }));
        function U(Q) {
          return x.apply(this, arguments);
        }
        return U;
      }()
      /**
       * Connect to the server
       * @fires Twilsock#connected
       * @public
       * @returns {void}
       */
    }, {
      key: "connect",
      value: function() {
        return this.channel.connect();
      }
      /**
       * Disconnect from the server
       * @fires Twilsock#disconnected
       * @public
       * @returns {Promise}
       */
    }, {
      key: "disconnect",
      value: function() {
        var x = I.default(/* @__PURE__ */ he.default.mark(function Q() {
          return he.default.wrap(function(Fe) {
            for (; ; )
              switch (Fe.prev = Fe.next) {
                case 0:
                  return this.telemetryTracker.sendTelemetry(e.EventSendingLimitation.AnyEventsIncludingUnfinished), Fe.next = 3, this.channel.disconnect();
                case 3:
                  return Fe.abrupt("return", Fe.sent);
                case 4:
                case "end":
                  return Fe.stop();
              }
          }, Q, this);
        }));
        function U() {
          return x.apply(this, arguments);
        }
        return U;
      }()
      /**
       * Get HTTP request to upstream service
       * @param {string} url Upstream service url
       * @param {headers} headers Set of custom headers
       * @param {string} [grant] The product grant
       * @returns {Promise}
       */
    }, {
      key: "get",
      value: function() {
        var x = I.default(/* @__PURE__ */ he.default.mark(function Q(D, Fe, Se) {
          return he.default.wrap(function(_e) {
            for (; ; )
              switch (_e.prev = _e.next) {
                case 0:
                  return this.telemetryTracker.sendTelemetry(e.EventSendingLimitation.AnyEvents), _e.next = 3, this.upstream.send("GET", D, Fe, void 0, Se);
                case 3:
                  return _e.abrupt("return", _e.sent);
                case 4:
                case "end":
                  return _e.stop();
              }
          }, Q, this);
        }));
        function U(Q, D, Fe) {
          return x.apply(this, arguments);
        }
        return U;
      }()
      /**
       * Post HTTP request to upstream service
       * @param {string} url Upstream service url
       * @param {headers} headers Set of custom headers
       * @param {body} body Body to send
       * @param {string} [grant] The product grant
       * @returns {Promise}
       */
    }, {
      key: "post",
      value: function() {
        var x = I.default(/* @__PURE__ */ he.default.mark(function Q(D, Fe, Se, je) {
          return he.default.wrap(function(bt) {
            for (; ; )
              switch (bt.prev = bt.next) {
                case 0:
                  return this.telemetryTracker.sendTelemetry(e.EventSendingLimitation.AnyEvents), bt.next = 3, this.upstream.send("POST", D, Fe, Se, je);
                case 3:
                  return bt.abrupt("return", bt.sent);
                case 4:
                case "end":
                  return bt.stop();
              }
          }, Q, this);
        }));
        function U(Q, D, Fe, Se) {
          return x.apply(this, arguments);
        }
        return U;
      }()
      /**
       * Put HTTP request to upstream service
       * @param {string} url Upstream service url
       * @param {headers} headers Set of custom headers
       * @param {body} body Body to send
       * @param {string} [grant] The product grant
       * @returns {Promise}
       */
    }, {
      key: "put",
      value: function() {
        var x = I.default(/* @__PURE__ */ he.default.mark(function Q(D, Fe, Se, je) {
          return he.default.wrap(function(bt) {
            for (; ; )
              switch (bt.prev = bt.next) {
                case 0:
                  return this.telemetryTracker.sendTelemetry(e.EventSendingLimitation.AnyEvents), bt.next = 3, this.upstream.send("PUT", D, Fe, Se, je);
                case 3:
                  return bt.abrupt("return", bt.sent);
                case 4:
                case "end":
                  return bt.stop();
              }
          }, Q, this);
        }));
        function U(Q, D, Fe, Se) {
          return x.apply(this, arguments);
        }
        return U;
      }()
      /**
       * Delete HTTP request to upstream service
       * @param {string} url Upstream service url
       * @param {headers} headers Set of custom headers
       * @param {body} body Body to send
       * @param {string} [grant] The product grant
       * @returns {Promise}
       */
    }, {
      key: "delete",
      value: function() {
        var x = I.default(/* @__PURE__ */ he.default.mark(function Q(D, Fe, Se, je) {
          return he.default.wrap(function(bt) {
            for (; ; )
              switch (bt.prev = bt.next) {
                case 0:
                  return this.telemetryTracker.sendTelemetry(e.EventSendingLimitation.AnyEvents), bt.next = 3, this.upstream.send("DELETE", D, Fe, Se, je);
                case 3:
                  return bt.abrupt("return", bt.sent);
                case 4:
                case "end":
                  return bt.stop();
              }
          }, Q, this);
        }));
        function U(Q, D, Fe, Se) {
          return x.apply(this, arguments);
        }
        return U;
      }()
      /**
       * Submits internal telemetry event. Not to be used for any customer and/or sensitive data.
       * @param {TelemetryEventDescription} event Event details.
       * @returns {void}
       */
    }, {
      key: "addTelemetryEvent",
      value: function(U) {
        this.telemetryTracker.addTelemetryEvent(U), this.telemetryTracker.sendTelemetryIfMinimalPortionCollected();
      }
      /**
       * Submits internal telemetry event. Not to be used for any customer and/or sensitive data.
       * @param {TelemetryEventDescription} event Event details.
       * @param {string} eventKey Unique event key.
       * @param {TelemetryPoint} point Is this partial event for start or end of measurement.
       * @returns {void}
       */
    }, {
      key: "addPartialTelemetryEvent",
      value: function(U, Q, D) {
        this.telemetryTracker.addPartialEvent(U, Q, D), D === e.TelemetryPoint.End && this.telemetryTracker.sendTelemetryIfMinimalPortionCollected();
      }
    }]), E;
  }(oe), e.TwilsockClient = F([p.validateConstructorTypes(p.nonEmptyString, p.nonEmptyString, [p.pureObject, "undefined", p.literal(null)]), pe("design:paramtypes", [String, String, Object])], e.TwilsockClient);
  var Na = /* @__PURE__ */ function() {
    function Y(H) {
      Z.default(this, Y), this.product = H, this.type = "ers", this.notification_protocol_version = 0, this.message_types = [];
    }
    return P.default(Y, [{
      key: "populateInitRegistrations",
      value: function(E) {
        var x = new Set(this.message_types);
        for (var U in E)
          x.add(E[U]);
        this.message_types = Array.from(x);
      }
    }]), Y;
  }();
  e.InitRegistration = Na, e.TelemetryEventDescription = dr, e.TelemetryTracker = mo, e.TransportUnavailableError = hi, e.Twilsock = e.TwilsockClient, e.TwilsockError = lt;
})(Dp);
var R9 = {}, Ck = Ar, ute = Kt, fte = fr, lte = St, i1 = wl, dte = bl, cte = hl, pte = hn, vte = ml, wo = Object.assign, Fk = Object.defineProperty, hte = ute([].concat), T9 = !wo || lte(function() {
  if (Ck && wo({ b: 1 }, wo(Fk({}, "a", {
    enumerable: !0,
    get: function() {
      Fk(this, "b", {
        value: 3,
        enumerable: !1
      });
    }
  }), { b: 2 })).b !== 1)
    return !0;
  var e = {}, t = {}, r = Symbol("assign detection"), n = "abcdefghijklmnopqrst";
  return e[r] = 7, n.split("").forEach(function(i) {
    t[i] = i;
  }), wo({}, e)[r] !== 7 || i1(wo({}, t)).join("") !== n;
}) ? function(t, r) {
  for (var n = pte(t), i = arguments.length, a = 1, s = dte.f, o = cte.f; i > a; )
    for (var u = vte(arguments[a++]), f = s ? hte(i1(u), s(u)) : i1(u), l = f.length, d = 0, c; l > d; )
      c = f[d++], (!Ck || fte(o, u, c)) && (n[c] = u[c]);
  return n;
} : wo, mte = xt, Kk = T9;
mte({ target: "Object", stat: !0, arity: 2, forced: Object.assign !== Kk }, {
  assign: Kk
});
var fg = { exports: {} }, Rk = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto < "u" && typeof window.msCrypto.getRandomValues == "function" && msCrypto.getRandomValues.bind(msCrypto);
if (Rk) {
  var Tk = new Uint8Array(16);
  fg.exports = function() {
    return Rk(Tk), Tk;
  };
} else {
  var Uk = new Array(16);
  fg.exports = function() {
    for (var t = 0, r; t < 16; t++)
      t & 3 || (r = Math.random() * 4294967296), Uk[t] = r >>> ((t & 3) << 3) & 255;
    return Uk;
  };
}
var U9 = fg.exports, x9 = [];
for (var Td = 0; Td < 256; ++Td)
  x9[Td] = (Td + 256).toString(16).substr(1);
function gte(e, t) {
  var r = t || 0, n = x9;
  return [
    n[e[r++]],
    n[e[r++]],
    n[e[r++]],
    n[e[r++]],
    "-",
    n[e[r++]],
    n[e[r++]],
    "-",
    n[e[r++]],
    n[e[r++]],
    "-",
    n[e[r++]],
    n[e[r++]],
    "-",
    n[e[r++]],
    n[e[r++]],
    n[e[r++]],
    n[e[r++]],
    n[e[r++]],
    n[e[r++]]
  ].join("");
}
var E9 = gte, yte = U9, Vte = E9, xk, a1, s1 = 0, o1 = 0;
function qte(e, t, r) {
  var n = t && r || 0, i = t || [];
  e = e || {};
  var a = e.node || xk, s = e.clockseq !== void 0 ? e.clockseq : a1;
  if (a == null || s == null) {
    var o = yte();
    a == null && (a = xk = [
      o[0] | 1,
      o[1],
      o[2],
      o[3],
      o[4],
      o[5]
    ]), s == null && (s = a1 = (o[6] << 8 | o[7]) & 16383);
  }
  var u = e.msecs !== void 0 ? e.msecs : (/* @__PURE__ */ new Date()).getTime(), f = e.nsecs !== void 0 ? e.nsecs : o1 + 1, l = u - s1 + (f - o1) / 1e4;
  if (l < 0 && e.clockseq === void 0 && (s = s + 1 & 16383), (l < 0 || u > s1) && e.nsecs === void 0 && (f = 0), f >= 1e4)
    throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
  s1 = u, o1 = f, a1 = s, u += 122192928e5;
  var d = ((u & 268435455) * 1e4 + f) % 4294967296;
  i[n++] = d >>> 24 & 255, i[n++] = d >>> 16 & 255, i[n++] = d >>> 8 & 255, i[n++] = d & 255;
  var c = u / 4294967296 * 1e4 & 268435455;
  i[n++] = c >>> 8 & 255, i[n++] = c & 255, i[n++] = c >>> 24 & 15 | 16, i[n++] = c >>> 16 & 255, i[n++] = s >>> 8 | 128, i[n++] = s & 255;
  for (var p = 0; p < 6; ++p)
    i[n + p] = a[p];
  return t || Vte(i);
}
var bte = qte, Ate = U9, wte = E9;
function kte(e, t, r) {
  var n = t && r || 0;
  typeof e == "string" && (t = e === "binary" ? new Array(16) : null, e = null), e = e || {};
  var i = e.random || (e.rng || Ate)();
  if (i[6] = i[6] & 15 | 64, i[8] = i[8] & 63 | 128, t)
    for (var a = 0; a < 16; ++a)
      t[n + a] = i[a];
  return t || wte(i);
}
var Wte = kte, Ste = bte, O9 = Wte, MV = O9;
MV.v1 = Ste;
MV.v4 = O9;
var Cte = MV;
/*
@license
The MIT License (MIT)

Copyright (c) 2016 Twilio Inc.

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all
copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
SOFTWARE.

*/
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 });
  var t = Kl, r = ra, n = ps, i = ea, a = ta, s = ci, o = El, u = di, f = Dp, l = to, d = ro, c = Ua, p = Eu, v = Ou, h = Nl, m = Cte, q = rn;
  function w(Ke) {
    return Ke && typeof Ke == "object" && "default" in Ke ? Ke : { default: Ke };
  }
  function O(Ke) {
    if (Ke && Ke.__esModule)
      return Ke;
    var Re = /* @__PURE__ */ Object.create(null);
    return Ke && Object.keys(Ke).forEach(function(ge) {
      if (ge !== "default") {
        var qe = Object.getOwnPropertyDescriptor(Ke, ge);
        Object.defineProperty(Re, ge, qe.get ? qe : {
          enumerable: !0,
          get: function() {
            return Ke[ge];
          }
        });
      }
    }), Re.default = Ke, Object.freeze(Re);
  }
  var C = /* @__PURE__ */ w(t), R = /* @__PURE__ */ w(r), I = /* @__PURE__ */ w(n), P = /* @__PURE__ */ w(i), K = /* @__PURE__ */ w(a), B = /* @__PURE__ */ w(s), L = /* @__PURE__ */ w(o), _ = /* @__PURE__ */ w(u), ne = /* @__PURE__ */ w(l), Z = /* @__PURE__ */ w(d), le = /* @__PURE__ */ w(p), he = /* @__PURE__ */ w(v), Ie = /* @__PURE__ */ O(h), xe = /* @__PURE__ */ O(m);
  function ye(Ke, Re, ge, qe) {
    var Ve = arguments.length, Ne = Ve < 3 ? Re : qe === null ? qe = Object.getOwnPropertyDescriptor(Re, ge) : qe, Xe;
    if ((typeof Reflect > "u" ? "undefined" : _.default(Reflect)) === "object" && typeof Reflect.decorate == "function")
      Ne = Reflect.decorate(Ke, Re, ge, qe);
    else
      for (var fe = Ke.length - 1; fe >= 0; fe--)
        (Xe = Ke[fe]) && (Ne = (Ve < 3 ? Xe(Ne) : Ve > 3 ? Xe(Re, ge, Ne) : Xe(Re, ge)) || Ne);
    return Ve > 3 && Ne && Object.defineProperty(Re, ge, Ne), Ne;
  }
  function ue(Ke, Re) {
    if ((typeof Reflect > "u" ? "undefined" : _.default(Reflect)) === "object" && typeof Reflect.metadata == "function")
      return Reflect.metadata(Ke, Re);
  }
  var M;
  function F() {
  }
  F.prototype = /* @__PURE__ */ Object.create(null);
  function pe() {
    pe.init.call(this);
  }
  pe.EventEmitter = pe, pe.usingDomains = !1, pe.prototype.domain = void 0, pe.prototype._events = void 0, pe.prototype._maxListeners = void 0, pe.defaultMaxListeners = 10, pe.init = function() {
    this.domain = null, pe.usingDomains && M.active, (!this._events || this._events === Object.getPrototypeOf(this)._events) && (this._events = new F(), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
  }, pe.prototype.setMaxListeners = function(Re) {
    if (typeof Re != "number" || Re < 0 || isNaN(Re))
      throw new TypeError('"n" argument must be a positive number');
    return this._maxListeners = Re, this;
  };
  function We(Ke) {
    return Ke._maxListeners === void 0 ? pe.defaultMaxListeners : Ke._maxListeners;
  }
  pe.prototype.getMaxListeners = function() {
    return We(this);
  };
  function ce(Ke, Re, ge) {
    if (Re)
      Ke.call(ge);
    else
      for (var qe = Ke.length, Ve = te(Ke, qe), Ne = 0; Ne < qe; ++Ne)
        Ve[Ne].call(ge);
  }
  function oe(Ke, Re, ge, qe) {
    if (Re)
      Ke.call(ge, qe);
    else
      for (var Ve = Ke.length, Ne = te(Ke, Ve), Xe = 0; Xe < Ve; ++Xe)
        Ne[Xe].call(ge, qe);
  }
  function z(Ke, Re, ge, qe, Ve) {
    if (Re)
      Ke.call(ge, qe, Ve);
    else
      for (var Ne = Ke.length, Xe = te(Ke, Ne), fe = 0; fe < Ne; ++fe)
        Xe[fe].call(ge, qe, Ve);
  }
  function Ze(Ke, Re, ge, qe, Ve, Ne) {
    if (Re)
      Ke.call(ge, qe, Ve, Ne);
    else
      for (var Xe = Ke.length, fe = te(Ke, Xe), ke = 0; ke < Xe; ++ke)
        fe[ke].call(ge, qe, Ve, Ne);
  }
  function Ae(Ke, Re, ge, qe) {
    if (Re)
      Ke.apply(ge, qe);
    else
      for (var Ve = Ke.length, Ne = te(Ke, Ve), Xe = 0; Xe < Ve; ++Xe)
        Ne[Xe].apply(ge, qe);
  }
  pe.prototype.emit = function(Re) {
    var ge, qe, Ve, Ne, Xe, fe, ke, ae = Re === "error";
    if (fe = this._events, fe)
      ae = ae && fe.error == null;
    else if (!ae)
      return !1;
    if (ke = this.domain, ae) {
      if (ge = arguments[1], ke)
        ge || (ge = new Error('Uncaught, unspecified "error" event')), ge.domainEmitter = this, ge.domain = ke, ge.domainThrown = !1, ke.emit("error", ge);
      else {
        if (ge instanceof Error)
          throw ge;
        var me = new Error('Uncaught, unspecified "error" event. (' + ge + ")");
        throw me.context = ge, me;
      }
      return !1;
    }
    if (qe = fe[Re], !qe)
      return !1;
    var se = typeof qe == "function";
    switch (Ve = arguments.length, Ve) {
      case 1:
        ce(qe, se, this);
        break;
      case 2:
        oe(qe, se, this, arguments[1]);
        break;
      case 3:
        z(qe, se, this, arguments[1], arguments[2]);
        break;
      case 4:
        Ze(qe, se, this, arguments[1], arguments[2], arguments[3]);
        break;
      default:
        for (Ne = new Array(Ve - 1), Xe = 1; Xe < Ve; Xe++)
          Ne[Xe - 1] = arguments[Xe];
        Ae(qe, se, this, Ne);
    }
    return !0;
  };
  function re(Ke, Re, ge, qe) {
    var Ve, Ne, Xe;
    if (typeof ge != "function")
      throw new TypeError('"listener" argument must be a function');
    if (Ne = Ke._events, Ne ? (Ne.newListener && (Ke.emit(
      "newListener",
      Re,
      ge.listener ? ge.listener : ge
    ), Ne = Ke._events), Xe = Ne[Re]) : (Ne = Ke._events = new F(), Ke._eventsCount = 0), !Xe)
      Xe = Ne[Re] = ge, ++Ke._eventsCount;
    else if (typeof Xe == "function" ? Xe = Ne[Re] = qe ? [ge, Xe] : [Xe, ge] : qe ? Xe.unshift(ge) : Xe.push(ge), !Xe.warned && (Ve = We(Ke), Ve && Ve > 0 && Xe.length > Ve)) {
      Xe.warned = !0;
      var fe = new Error("Possible EventEmitter memory leak detected. " + Xe.length + " " + Re + " listeners added. Use emitter.setMaxListeners() to increase limit");
      fe.name = "MaxListenersExceededWarning", fe.emitter = Ke, fe.type = Re, fe.count = Xe.length, Qe(fe);
    }
    return Ke;
  }
  function Qe(Ke) {
    typeof console.warn == "function" ? console.warn(Ke) : console.log(Ke);
  }
  pe.prototype.addListener = function(Re, ge) {
    return re(this, Re, ge, !1);
  }, pe.prototype.on = pe.prototype.addListener, pe.prototype.prependListener = function(Re, ge) {
    return re(this, Re, ge, !0);
  };
  function Ee(Ke, Re, ge) {
    var qe = !1;
    function Ve() {
      Ke.removeListener(Re, Ve), qe || (qe = !0, ge.apply(Ke, arguments));
    }
    return Ve.listener = ge, Ve;
  }
  pe.prototype.once = function(Re, ge) {
    if (typeof ge != "function")
      throw new TypeError('"listener" argument must be a function');
    return this.on(Re, Ee(this, Re, ge)), this;
  }, pe.prototype.prependOnceListener = function(Re, ge) {
    if (typeof ge != "function")
      throw new TypeError('"listener" argument must be a function');
    return this.prependListener(Re, Ee(this, Re, ge)), this;
  }, pe.prototype.removeListener = function(Re, ge) {
    var qe, Ve, Ne, Xe, fe;
    if (typeof ge != "function")
      throw new TypeError('"listener" argument must be a function');
    if (Ve = this._events, !Ve)
      return this;
    if (qe = Ve[Re], !qe)
      return this;
    if (qe === ge || qe.listener && qe.listener === ge)
      --this._eventsCount === 0 ? this._events = new F() : (delete Ve[Re], Ve.removeListener && this.emit("removeListener", Re, qe.listener || ge));
    else if (typeof qe != "function") {
      for (Ne = -1, Xe = qe.length; Xe-- > 0; )
        if (qe[Xe] === ge || qe[Xe].listener && qe[Xe].listener === ge) {
          fe = qe[Xe].listener, Ne = Xe;
          break;
        }
      if (Ne < 0)
        return this;
      if (qe.length === 1) {
        if (qe[0] = void 0, --this._eventsCount === 0)
          return this._events = new F(), this;
        delete Ve[Re];
      } else
        He(qe, Ne);
      Ve.removeListener && this.emit("removeListener", Re, fe || ge);
    }
    return this;
  }, pe.prototype.off = function(Ke, Re) {
    return this.removeListener(Ke, Re);
  }, pe.prototype.removeAllListeners = function(Re) {
    var ge, qe;
    if (qe = this._events, !qe)
      return this;
    if (!qe.removeListener)
      return arguments.length === 0 ? (this._events = new F(), this._eventsCount = 0) : qe[Re] && (--this._eventsCount === 0 ? this._events = new F() : delete qe[Re]), this;
    if (arguments.length === 0) {
      for (var Ve = Object.keys(qe), Ne = 0, Xe; Ne < Ve.length; ++Ne)
        Xe = Ve[Ne], Xe !== "removeListener" && this.removeAllListeners(Xe);
      return this.removeAllListeners("removeListener"), this._events = new F(), this._eventsCount = 0, this;
    }
    if (ge = qe[Re], typeof ge == "function")
      this.removeListener(Re, ge);
    else if (ge)
      do
        this.removeListener(Re, ge[ge.length - 1]);
      while (ge[0]);
    return this;
  }, pe.prototype.listeners = function(Re) {
    var ge, qe, Ve = this._events;
    return Ve ? (ge = Ve[Re], ge ? typeof ge == "function" ? qe = [ge.listener || ge] : qe = it(ge) : qe = []) : qe = [], qe;
  }, pe.listenerCount = function(Ke, Re) {
    return typeof Ke.listenerCount == "function" ? Ke.listenerCount(Re) : Ue.call(Ke, Re);
  }, pe.prototype.listenerCount = Ue;
  function Ue(Ke) {
    var Re = this._events;
    if (Re) {
      var ge = Re[Ke];
      if (typeof ge == "function")
        return 1;
      if (ge)
        return ge.length;
    }
    return 0;
  }
  pe.prototype.eventNames = function() {
    return this._eventsCount > 0 ? Reflect.ownKeys(this._events) : [];
  };
  function He(Ke, Re) {
    for (var ge = Re, qe = ge + 1, Ve = Ke.length; qe < Ve; ge += 1, qe += 1)
      Ke[ge] = Ke[qe];
    Ke.pop();
  }
  function te(Ke, Re) {
    for (var ge = new Array(Re); Re--; )
      ge[Re] = Ke[Re];
    return ge;
  }
  function it(Ke) {
    for (var Re = new Array(Ke.length), ge = 0; ge < Re.length; ++ge)
      Re[ge] = Ke[ge].listener || Ke[ge];
    return Re;
  }
  var Vt = Ie.getLogger("twilio-notificatiions");
  function Oe(Ke, Re) {
    return ["".concat((/* @__PURE__ */ new Date()).toISOString(), " Twilio.Notifications ").concat(Ke, ":")].concat(Array.from(Re));
  }
  var Bt = /* @__PURE__ */ function() {
    function Ke() {
      R.default(this, Ke);
    }
    return I.default(Ke, [{
      key: "setLevel",
      value: function(ge) {
        Vt.setLevel(ge);
      }
    }, {
      key: "trace",
      value: function() {
        for (var ge = arguments.length, qe = new Array(ge), Ve = 0; Ve < ge; Ve++)
          qe[Ve] = arguments[Ve];
        Vt.trace.apply(null, Oe("T", qe));
      }
    }, {
      key: "debug",
      value: function() {
        for (var ge = arguments.length, qe = new Array(ge), Ve = 0; Ve < ge; Ve++)
          qe[Ve] = arguments[Ve];
        Vt.debug.apply(null, Oe("D", qe));
      }
    }, {
      key: "info",
      value: function() {
        for (var ge = arguments.length, qe = new Array(ge), Ve = 0; Ve < ge; Ve++)
          qe[Ve] = arguments[Ve];
        Vt.info.apply(null, Oe("I", qe));
      }
    }, {
      key: "warn",
      value: function() {
        for (var ge = arguments.length, qe = new Array(ge), Ve = 0; Ve < ge; Ve++)
          qe[Ve] = arguments[Ve];
        Vt.warn.apply(null, Oe("W", qe));
      }
    }, {
      key: "error",
      value: function() {
        for (var ge = arguments.length, qe = new Array(ge), Ve = 0; Ve < ge; Ve++)
          qe[Ve] = arguments[Ve];
        Vt.error.apply(null, Oe("E", qe));
      }
    }]), Ke;
  }(), mt = new Bt();
  function Ot(Ke) {
    var Re = It();
    return function() {
      var qe = B.default(Ke), Ve;
      if (Re) {
        var Ne = B.default(this).constructor;
        Ve = Reflect.construct(qe, arguments, Ne);
      } else
        Ve = qe.apply(this, arguments);
      return K.default(this, Ve);
    };
  }
  function It() {
    if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
      return !1;
    if (typeof Proxy == "function")
      return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      })), !0;
    } catch {
      return !1;
    }
  }
  var Me = /* @__PURE__ */ I.default(function Ke() {
    var Re = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", ge = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", qe = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : /* @__PURE__ */ new Set();
    R.default(this, Ke), this.token = Re, this.notificationId = ge, this.messageTypes = qe;
  });
  function Gr(Ke, Re) {
    return [].concat(he.default(he.default(Ke).filter(function(ge) {
      return !Re.has(ge);
    })), he.default(he.default(Re).filter(function(ge) {
      return !Ke.has(ge);
    })));
  }
  function $e(Ke, Re) {
    var ge = /* @__PURE__ */ new Set();
    return Ke.notificationId !== Re.notificationId && ge.add("notificationId"), Ke.token !== Re.token && ge.add("token"), Gr(Ke.messageTypes, Re.messageTypes).length > 0 && ge.add("messageType"), [ge.size > 0, ge];
  }
  var Je = /* @__PURE__ */ function(Ke) {
    P.default(ge, Ke);
    var Re = Ot(ge);
    function ge(qe) {
      var Ve;
      return R.default(this, ge), Ve = Re.call(this), Z.default(ne.default(Ve), "desiredState", new Me()), Z.default(ne.default(Ve), "currentState", new Me()), Z.default(ne.default(Ve), "_hasActiveAttempt", !1), Ve.channelType = qe, Ve;
    }
    return I.default(ge, [{
      key: "setNotificationId",
      value: function(Ve) {
        this.desiredState.notificationId = Ve;
      }
      /**
       * Return true is this connector is in usable state and should be able to commit changes.
       */
    }, {
      key: "isActive",
      value: function() {
        return this.desiredState.notificationId !== "";
      }
    }, {
      key: "subscribe",
      value: function(Ve) {
        if (this.desiredState.messageTypes.has(Ve)) {
          mt.debug("message type '".concat(Ve, "' for channel ").concat(this.channelType, " is already registered"));
          return;
        }
        this.desiredState.messageTypes.add(Ve);
      }
    }, {
      key: "unsubscribe",
      value: function(Ve) {
        this.desiredState.messageTypes.has(Ve) && this.desiredState.messageTypes.delete(Ve);
      }
    }, {
      key: "updateToken",
      value: function(Ve) {
        this.desiredState.token = Ve;
      }
      /**
       * Perform actual registration after all required changes are settled.
       */
    }, {
      key: "commitChanges",
      value: function() {
        var qe = C.default(/* @__PURE__ */ L.default.mark(function Ne() {
          var Xe, fe, ke, ae, me, se;
          return L.default.wrap(function(Pe) {
            for (; ; )
              switch (Pe.prev = Pe.next) {
                case 0:
                  if (!this._hasActiveAttempt) {
                    Pe.next = 3;
                    break;
                  }
                  throw mt.error("One registration attempt is already in progress"), new Error("One registration attempt is already in progress");
                case 3:
                  if (Xe = $e(this.desiredState, this.currentState), fe = le.default(Xe, 2), ke = fe[0], ae = fe[1], ke) {
                    Pe.next = 6;
                    break;
                  }
                  return Pe.abrupt("return");
                case 6:
                  if (this.currentState.notificationId || ae.delete("notificationId"), mt.trace("Persisting ".concat(this.channelType, " registration"), ae, this.desiredState), Pe.prev = 8, this._hasActiveAttempt = !0, me = new Me(), me.token = this.desiredState.token, me.notificationId = this.desiredState.notificationId, me.messageTypes = new Set(this.desiredState.messageTypes), !(me.messageTypes.size > 0)) {
                    Pe.next = 24;
                    break;
                  }
                  return Pe.next = 17, this.updateRegistration(me, ae);
                case 17:
                  se = Pe.sent, this.currentState.token = se.token, this.currentState.notificationId = se.notificationId, this.currentState.messageTypes = new Set(se.messageTypes), this.emit("stateChanged", this.channelType, "registered", this.currentState), Pe.next = 30;
                  break;
                case 24:
                  return Pe.next = 26, this.removeRegistration();
                case 26:
                  this.currentState.token = me.token, this.currentState.notificationId = me.notificationId, this.currentState.messageTypes.clear(), this.emit("stateChanged", this.channelType, "unregistered", this.currentState);
                case 30:
                  Pe.next = 35;
                  break;
                case 32:
                  throw Pe.prev = 32, Pe.t0 = Pe.catch(8), Pe.t0;
                case 35:
                  return Pe.prev = 35, this._hasActiveAttempt = !1, Pe.finish(35);
                case 38:
                case "end":
                  return Pe.stop();
              }
          }, Ne, this, [[8, 32, 35, 38]]);
        }));
        function Ve() {
          return qe.apply(this, arguments);
        }
        return Ve;
      }()
    }]), ge;
  }(pe);
  function qt(Ke) {
    var Re = ft();
    return function() {
      var qe = B.default(Ke), Ve;
      if (Re) {
        var Ne = B.default(this).constructor;
        Ve = Reflect.construct(qe, arguments, Ne);
      } else
        Ve = qe.apply(this, arguments);
      return K.default(this, Ve);
    };
  }
  function ft() {
    if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
      return !1;
    if (typeof Proxy == "function")
      return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      })), !0;
    } catch {
      return !1;
    }
  }
  var at = {
    min: 2e3,
    max: 12e4,
    randomness: 0.2
  }, rt = /* @__PURE__ */ function(Ke) {
    P.default(ge, Ke);
    var Re = qt(ge);
    function ge(qe, Ve, Ne, Xe) {
      var fe;
      return R.default(this, ge), fe = Re.call(this, qe), Z.default(ne.default(fe), "registrationId", null), fe.context = Ve, fe.twilsock = Ne, fe.registrarUrl = Xe, fe;
    }
    return I.default(ge, [{
      key: "updateRegistration",
      value: function() {
        var qe = C.default(/* @__PURE__ */ L.default.mark(function Ne(Xe, fe) {
          var ke = this, ae, me, se, ze, Pe;
          return L.default.wrap(function(tt) {
            for (; ; )
              switch (tt.prev = tt.next) {
                case 0:
                  if (!fe.has("notificationId")) {
                    tt.next = 3;
                    break;
                  }
                  return tt.next = 3, this.removeRegistration();
                case 3:
                  if (!(!Xe.notificationId || !Xe.notificationId.length)) {
                    tt.next = 6;
                    break;
                  }
                  throw mt.error("No push notification ID for registration"), new Error("No push notification ID for registration");
                case 6:
                  return mt.trace("Registering", this.channelType, Xe), ae = {
                    endpoint_platform: this.context.platform,
                    channel_type: this.channelType,
                    version: this.context.protocolVersion.toString(),
                    message_types: Array.from(Xe.messageTypes),
                    data: {
                      registration_id: Xe.notificationId
                    }
                    //ttl: 'PT24H' - This is totally ignored by notify, all bindings use PT1Y ttl.
                  }, me = this.context.productId, se = "".concat(this.registrarUrl, "?productId=").concat(me), ze = {
                    "Content-Type": "application/json"
                    // 'X-Twilio-Token': registration.token
                  }, mt.trace("Creating registration for channel ".concat(this.channelType)), tt.prev = 12, tt.next = 15, new c.AsyncRetrier(at).run(function() {
                    return ke.twilsock.post(se, ze, ae, me);
                  });
                case 15:
                  Pe = tt.sent, this.registrationId = Pe.body.id, mt.debug("Registration created: ", Pe), tt.next = 24;
                  break;
                case 20:
                  throw tt.prev = 20, tt.t0 = tt.catch(12), mt.error("Registration failed: ", tt.t0), tt.t0;
                case 24:
                  return tt.abrupt("return", Xe);
                case 25:
                case "end":
                  return tt.stop();
              }
          }, Ne, this, [[12, 20]]);
        }));
        function Ve(Ne, Xe) {
          return qe.apply(this, arguments);
        }
        return Ve;
      }()
    }, {
      key: "removeRegistration",
      value: function() {
        var qe = C.default(/* @__PURE__ */ L.default.mark(function Ne() {
          var Xe = this, fe, ke, ae;
          return L.default.wrap(function(se) {
            for (; ; )
              switch (se.prev = se.next) {
                case 0:
                  if (this.registrationId) {
                    se.next = 2;
                    break;
                  }
                  return se.abrupt("return");
                case 2:
                  return fe = this.context.productId, ke = "".concat(this.registrarUrl, "/").concat(this.registrationId, "?productId=").concat(fe), ae = {
                    "Content-Type": "application/json"
                    // 'X-Twilio-Token': this.config.token
                  }, mt.trace("Removing registration for ".concat(this.channelType)), se.prev = 6, se.next = 9, new c.AsyncRetrier(Object.assign(at, {
                    maxAttemptsCount: 3
                  })).run(function() {
                    return Xe.twilsock.delete(ke, ae, {}, fe);
                  });
                case 9:
                  this.registrationId = null, this.currentState.notificationId = "", mt.debug("Registration removed for ".concat(this.channelType)), se.next = 18;
                  break;
                case 14:
                  throw se.prev = 14, se.t0 = se.catch(6), mt.error("Failed to remove registration ", this.channelType, se.t0), se.t0;
                case 18:
                case "end":
                  return se.stop();
              }
          }, Ne, this, [[6, 14]]);
        }));
        function Ve() {
          return qe.apply(this, arguments);
        }
        return Ve;
      }()
    }, {
      key: "sendDeviceRemoveRequest",
      value: function() {
        var qe = C.default(/* @__PURE__ */ L.default.mark(function Ne(Xe) {
          var fe = this, ke, ae, me, se;
          return L.default.wrap(function(Pe) {
            for (; ; )
              switch (Pe.prev = Pe.next) {
                case 0:
                  if (Xe !== "") {
                    Pe.next = 2;
                    break;
                  }
                  throw new Error("Empty registration ID");
                case 2:
                  return ke = this.context.productId, ae = "".concat(this.registrarUrl, "?productId=").concat(ke), me = {
                    "Content-Type": "application/json"
                    // @todo Content-Length??
                  }, se = {
                    binding_type: this.channelType,
                    address: Xe
                  }, Pe.prev = 6, mt.trace("Removing old registrations for ".concat(this.channelType)), Pe.next = 10, new c.AsyncRetrier(Object.assign(at, {
                    maxAttemptsCount: 3
                  })).run(function() {
                    return fe.twilsock.delete(ae, me, se, ke);
                  });
                case 10:
                  this.registrationId = null, this.currentState.notificationId = "", mt.debug("Registration removed for ".concat(this.channelType)), Pe.next = 19;
                  break;
                case 15:
                  throw Pe.prev = 15, Pe.t0 = Pe.catch(6), mt.error("Failed to remove registration ", this.channelType, Pe.t0), Pe.t0;
                case 19:
                case "end":
                  return Pe.stop();
              }
          }, Ne, this, [[6, 15]]);
        }));
        function Ve(Ne) {
          return qe.apply(this, arguments);
        }
        return Ve;
      }()
    }]), ge;
  }(Je);
  function Dt(Ke) {
    var Re = vr();
    return function() {
      var qe = B.default(Ke), Ve;
      if (Re) {
        var Ne = B.default(this).constructor;
        Ve = Reflect.construct(qe, arguments, Ne);
      } else
        Ve = qe.apply(this, arguments);
      return K.default(this, Ve);
    };
  }
  function vr() {
    if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
      return !1;
    if (typeof Proxy == "function")
      return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      })), !0;
    } catch {
      return !1;
    }
  }
  var Qr = /* @__PURE__ */ function(Ke) {
    P.default(ge, Ke);
    var Re = Dt(ge);
    function ge(qe, Ve, Ne) {
      var Xe;
      return R.default(this, ge), Xe = Re.call(this, "twilsock"), Z.default(ne.default(Xe), "contextId", xe.v4()), Xe.productId = qe, Xe.platform = Ve, Xe.twilsock = Ne, Xe;
    }
    return I.default(ge, [{
      key: "updateRegistration",
      value: function() {
        var qe = C.default(/* @__PURE__ */ L.default.mark(function Ne(Xe, fe) {
          var ke, ae;
          return L.default.wrap(function(se) {
            for (; ; )
              switch (se.prev = se.next) {
                case 0:
                  if (fe.has("messageType")) {
                    se.next = 2;
                    break;
                  }
                  return se.abrupt("return", Xe);
                case 2:
                  return ke = Array.from(Xe.messageTypes), ae = {
                    product_id: this.productId,
                    notification_protocol_version: 4,
                    endpoint_platform: this.platform,
                    message_types: ke
                  }, se.prev = 4, se.next = 7, this.twilsock.setNotificationsContext(this.contextId, ae);
                case 7:
                  se.next = 13;
                  break;
                case 9:
                  throw se.prev = 9, se.t0 = se.catch(4), mt.error("Failed to update twilsock notification context: ".concat(se.t0)), se.t0;
                case 13:
                  return se.abrupt("return", Xe);
                case 14:
                case "end":
                  return se.stop();
              }
          }, Ne, this, [[4, 9]]);
        }));
        function Ve(Ne, Xe) {
          return qe.apply(this, arguments);
        }
        return Ve;
      }()
    }, {
      key: "removeRegistration",
      value: function() {
        var qe = C.default(/* @__PURE__ */ L.default.mark(function Ne() {
          return L.default.wrap(function(fe) {
            for (; ; )
              switch (fe.prev = fe.next) {
                case 0:
                  return fe.prev = 0, fe.next = 3, this.twilsock.removeNotificationsContext(this.contextId);
                case 3:
                  fe.next = 9;
                  break;
                case 5:
                  throw fe.prev = 5, fe.t0 = fe.catch(0), mt.error("Failed to remove twilsock notification context: ".concat(fe.t0)), fe.t0;
                case 9:
                case "end":
                  return fe.stop();
              }
          }, Ne, this, [[0, 5]]);
        }));
        function Ve() {
          return qe.apply(this, arguments);
        }
        return Ve;
      }()
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
    }, {
      key: "sendDeviceRemoveRequest",
      value: function() {
        var qe = C.default(/* @__PURE__ */ L.default.mark(function Ne(Xe) {
          return L.default.wrap(function(ke) {
            for (; ; )
              switch (ke.prev = ke.next) {
                case 0:
                case "end":
                  return ke.stop();
              }
          }, Ne);
        }));
        function Ve(Ne) {
          return qe.apply(this, arguments);
        }
        return Ve;
      }()
    }]), ge;
  }(Je);
  function un(Ke) {
    var Re = Nr();
    return function() {
      var qe = B.default(Ke), Ve;
      if (Re) {
        var Ne = B.default(this).constructor;
        Ve = Reflect.construct(qe, arguments, Ne);
      } else
        Ve = qe.apply(this, arguments);
      return K.default(this, Ve);
    };
  }
  function Nr() {
    if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
      return !1;
    if (typeof Proxy == "function")
      return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      })), !0;
    } catch {
      return !1;
    }
  }
  var kr, Jr = q.literal("apn", "fcm", "twilsock");
  e.Notifications = kr = /* @__PURE__ */ function(Ke) {
    P.default(ge, Ke);
    var Re = un(ge);
    function ge(qe) {
      var Ve, Ne, Xe, fe, ke, ae, me, se = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      R.default(this, ge), me = Re.call(this), se.logLevel = (Ve = se.logLevel) !== null && Ve !== void 0 ? Ve : "error", mt.setLevel(se.logLevel);
      var ze = (Ne = se.productId) !== null && Ne !== void 0 ? Ne : "notifications", Pe = !se.twilsockClient, dt = se.twilsockClient = (Xe = se.twilsockClient) !== null && Xe !== void 0 ? Xe : new f.TwilsockClient(qe, ze, se), tt = (fe = se.notifications) !== null && fe !== void 0 ? fe : {}, st = (ke = (ae = tt.region) !== null && ae !== void 0 ? ae : se.region) !== null && ke !== void 0 ? ke : "us1", vt = "https://ers.".concat(st, ".twilio.com/v1/registrations"), ht = tt.ersUrl || vt;
      me.connectors = /* @__PURE__ */ new Map();
      var lt = kr._detectPlatform();
      return me.connectors.set("apn", new rt("apn", {
        protocolVersion: 4,
        productId: ze,
        platform: lt
      }, dt, ht)), me.connectors.set("fcm", new rt("fcm", {
        protocolVersion: 3,
        productId: ze,
        platform: lt
      }, dt, ht)), me.connectors.set("twilsock", new Qr(ze, lt, dt)), dt.on("stateChanged", function(G) {
        return me.emit("transportState", G);
      }), me._connector("twilsock").on("stateChanged", function(G, Ce, Te) {
        return me.emit("stateChanged", G, Ce, Te);
      }), me._connector("apn").on("stateChanged", function(G, Ce, Te) {
        return me.emit("stateChanged", G, Ce, Te);
      }), me._connector("fcm").on("stateChanged", function(G, Ce, Te) {
        return me.emit("stateChanged", G, Ce, Te);
      }), dt.on("message", function(G, Ce) {
        return me._routeMessage(G, Ce);
      }), me.updateToken(qe), Pe && (dt.connect(), me.twilsock = dt), me;
    }
    return I.default(ge, [{
      key: "shutdown",
      value: function() {
        var qe = C.default(/* @__PURE__ */ L.default.mark(function Ne() {
          return L.default.wrap(function(fe) {
            for (; ; )
              switch (fe.prev = fe.next) {
                case 0:
                  if (this.connectors.clear(), !this.twilsock) {
                    fe.next = 4;
                    break;
                  }
                  return fe.next = 4, this.twilsock.disconnect();
                case 4:
                case "end":
                  return fe.stop();
              }
          }, Ne, this);
        }));
        function Ve() {
          return qe.apply(this, arguments);
        }
        return Ve;
      }()
      /**
       * Set OS-provided APNS/FCM registration binding for the given channel type. Not used for 'twilsock'.
       *
       * You must call this function once you've received the ID of your device from the underlying OS.
       *
       * @param {ChannelType} channelType Channel type ('apn'/'fcm').
       * @param {string} pushRegistrationId Token received from FCM/APNS system on device.
       */
    }, {
      key: "setPushRegistrationId",
      value: function(Ve, Ne) {
        mt.debug("Set ".concat(Ve, " push registration id '").concat(Ne, "'")), this._connector(Ve).setNotificationId(Ne);
      }
      /**
       * Subscribe to a given message type for a given channel type.
       *
       * Creates a subscriptions to receive incoming messages according to message type.
       * Subscription establishes a binding and you will receive a signal when a notification
       * of this type has been received by the library.
       *
       * Subscribed binding is preserved for 1 year, after which time it needs to be re-subscribed.
       * This is the responsibility of the client SDK.
       *
       * @param {ChannelType} channelType Supported are 'twilsock', 'apn' and 'fcm'
       * @param {string} messageType The type of message that you want to receive
       */
    }, {
      key: "subscribe",
      value: function(Ve, Ne) {
        mt.debug("Add ".concat(Ve, " subscriptions for message type ").concat(Ne)), this._connector(Ve).subscribe(Ne);
      }
      /**
       * Unsubscribe from a given message type.
       *
       * Unsubscribing breaks a binding and you will not receive more notifications for this message type.
       * Please note that you have to call commitChanges() and receive a successful result before
       * the subscription is actually removed.
       *
       * @param {ChannelType} channelType Supported are 'twilsock', 'apn' and 'fcm'
       * @param {string} messageType The type of message that you don't want to receive anymore
       */
    }, {
      key: "unsubscribe",
      value: function(Ve, Ne) {
        mt.debug("Remove ".concat(Ve, " subscriptions for message type ").concat(Ne)), this._connector(Ve).unsubscribe(Ne);
      }
      /**
       * Update subscription token. You must update the token when the old one expires.
       *
       * When you receive onTokenWillExpire event from twilsock, call this function with the new refreshed
       * token _after_ you have updated twilsock and other associated objects with the new token.
       *
       * @param {string} token Authentication token for registrations
       */
    }, {
      key: "updateToken",
      value: function(Ve) {
        this.connectors.forEach(function(Ne) {
          return Ne.updateToken(Ve);
        });
      }
      /**
       * Commit all collected subscription changes as a batched update. This function tries to reduce
       * number of network calls necessary to update bindings status.
       */
    }, {
      key: "commitChanges",
      value: function() {
        var qe = C.default(/* @__PURE__ */ L.default.mark(function Ne() {
          var Xe;
          return L.default.wrap(function(ke) {
            for (; ; )
              switch (ke.prev = ke.next) {
                case 0:
                  return Xe = [], this.connectors.forEach(function(ae) {
                    ae.isActive() && Xe.push(ae.commitChanges());
                  }), ke.next = 4, Promise.all(Xe);
                case 4:
                case "end":
                  return ke.stop();
              }
          }, Ne, this);
        }));
        function Ve() {
          return qe.apply(this, arguments);
        }
        return Ve;
      }()
      /**
       * Clear existing registrations directly using provided device token.
       * This is useful to ensure stopped subscriptions without resubscribing.
       *
       * This function goes completely beside the state machine and removes all registrations.
       * Use with caution: if it races with current state machine operations, madness will ensue.
       *
       * @param {ChannelType} channelType Channel type ('apn'/'fcm').
       * @param {string} registrationId Token received from FCM/APNS system on device.
       */
    }, {
      key: "removeRegistrations",
      value: function() {
        var qe = C.default(/* @__PURE__ */ L.default.mark(function Ne(Xe, fe) {
          return L.default.wrap(function(ae) {
            for (; ; )
              switch (ae.prev = ae.next) {
                case 0:
                  return ae.next = 2, this._connector(Xe).sendDeviceRemoveRequest(fe);
                case 2:
                case "end":
                  return ae.stop();
              }
          }, Ne, this);
        }));
        function Ve(Ne, Xe) {
          return qe.apply(this, arguments);
        }
        return Ve;
      }()
      /**
       * Handle incoming push notification.
       * Client application should call this method when it receives push notifications and pass the received data.
       * @param {Object} message push message
       * @return {PushNotification} A reformatted payload with extracted message type.
       */
    }, {
      key: "handlePushNotification",
      value: function(Ve) {
        return {
          messageType: Ve.twi_message_type,
          payload: Ve.payload
        };
      }
      /**
       * Routes messages to the external subscribers
       */
    }, {
      key: "_routeMessage",
      value: function(Ve, Ne) {
        mt.debug("Notification message arrived: ", Ve, Ne), this.emit("message", Ve, Ne);
      }
      /**
       * @param {String} type Channel type
       * @throws {Error} Error with description
       */
    }, {
      key: "_connector",
      value: function(Ve) {
        var Ne = this.connectors.get(Ve);
        if (!Ne)
          throw new Error("Unknown channel type: ".concat(Ve));
        return Ne;
      }
      /**
       * Returns platform string limited to max 128 chars
       */
    }], [{
      key: "_detectPlatform",
      value: function() {
        var Ve = "";
        return typeof navigator < "u" ? (Ve = "unknown", typeof navigator.product < "u" && (Ve = navigator.product), typeof navigator.userAgent < "u" && (Ve = navigator.userAgent)) : Ve = "web", Ve.substring(0, 128);
      }
    }]), ge;
  }(pe), ye([q.validateTypes(Jr, q.nonEmptyString), ue("design:type", Function), ue("design:paramtypes", [String, String]), ue("design:returntype", void 0)], e.Notifications.prototype, "setPushRegistrationId", null), ye([q.validateTypes(Jr, q.nonEmptyString), ue("design:type", Function), ue("design:paramtypes", [String, String]), ue("design:returntype", void 0)], e.Notifications.prototype, "subscribe", null), ye([q.validateTypes(Jr, q.nonEmptyString), ue("design:type", Function), ue("design:paramtypes", [String, String]), ue("design:returntype", void 0)], e.Notifications.prototype, "unsubscribe", null), ye([q.validateTypes(q.nonEmptyString), ue("design:type", Function), ue("design:paramtypes", [String]), ue("design:returntype", void 0)], e.Notifications.prototype, "updateToken", null), ye([q.validateTypesAsync(Jr, q.nonEmptyString), ue("design:type", Function), ue("design:paramtypes", [String, String]), ue("design:returntype", Promise)], e.Notifications.prototype, "removeRegistrations", null), e.Notifications = kr = ye([q.validateConstructorTypes(q.nonEmptyString, [q.pureObject, "undefined", q.literal(null)]), ue("design:paramtypes", [String, Object])], e.Notifications);
})(R9);
var xn = {}, Sn = {};
/*
@license
Copyright (c) 2021 Twilio Inc.

Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.


*/
Object.defineProperty(Sn, "__esModule", { value: !0 });
var Fte = di, Kte = Eu, Rte = Ou, Tte = ra, Ute = ea, xte = ta, Ete = ci;
function ao(e) {
  return e && typeof e == "object" && "default" in e ? e : { default: e };
}
var _o = /* @__PURE__ */ ao(Fte), Ys = /* @__PURE__ */ ao(Kte), u1 = /* @__PURE__ */ ao(Rte), Ote = /* @__PURE__ */ ao(Tte), Nte = /* @__PURE__ */ ao(Ute), Ite = /* @__PURE__ */ ao(xte), Ek = /* @__PURE__ */ ao(Ete), gs = function() {
  for (var t = arguments.length, r = new Array(t), n = 0; n < t; n++)
    r[n] = arguments[n];
  return {
    checks: r
  };
};
function Xte(e, t) {
  var r = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (!r) {
    if (Array.isArray(e) || (r = Pte(e)) || t && e && typeof e.length == "number") {
      r && (e = r);
      var n = 0, i = function() {
      };
      return { s: i, n: function() {
        return n >= e.length ? { done: !0 } : { done: !1, value: e[n++] };
      }, e: function(f) {
        throw f;
      }, f: i };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  var a = !0, s = !1, o;
  return { s: function() {
    r = r.call(e);
  }, n: function() {
    var f = r.next();
    return a = f.done, f;
  }, e: function(f) {
    s = !0, o = f;
  }, f: function() {
    try {
      !a && r.return != null && r.return();
    } finally {
      if (s)
        throw o;
    }
  } };
}
function Pte(e, t) {
  if (e) {
    if (typeof e == "string")
      return Ok(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set")
      return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return Ok(e, t);
  }
}
function Ok(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
var N9 = function() {
  for (var t = arguments.length, r = new Array(t), n = 0; n < t; n++)
    r[n] = arguments[n];
  return gs(function(i) {
    var a = !1, s = [], o = Xte(r), u;
    try {
      for (o.s(); !(u = o.n()).done; ) {
        var f = u.value;
        if (typeof f == "string") {
          a = a || _o.default(i) === f, s.push("of type ".concat(f));
          continue;
        }
        a = a || i instanceof f, s.push("an instance of ".concat(f.name));
      }
    } catch (l) {
      o.e(l);
    } finally {
      o.f();
    }
    return [a, s];
  });
};
function Bte(e, t) {
  var r = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (!r) {
    if (Array.isArray(e) || (r = Dte(e)) || t && e && typeof e.length == "number") {
      r && (e = r);
      var n = 0, i = function() {
      };
      return { s: i, n: function() {
        return n >= e.length ? { done: !0 } : { done: !1, value: e[n++] };
      }, e: function(f) {
        throw f;
      }, f: i };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  var a = !0, s = !1, o;
  return { s: function() {
    r = r.call(e);
  }, n: function() {
    var f = r.next();
    return a = f.done, f;
  }, e: function(f) {
    s = !0, o = f;
  }, f: function() {
    try {
      !a && r.return != null && r.return();
    } finally {
      if (s)
        throw o;
    }
  } };
}
function Dte(e, t) {
  if (e) {
    if (typeof e == "string")
      return Nk(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set")
      return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return Nk(e, t);
  }
}
function Nk(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
var Lte = function() {
  for (var t = arguments.length, r = new Array(t), n = 0; n < t; n++)
    r[n] = arguments[n];
  return gs(function(i) {
    var a = !1, s = [], o = Bte(r), u;
    try {
      for (o.s(); !(u = o.n()).done; ) {
        var f = u.value;
        a = a || i === f, s.push(typeof f == "string" ? '"'.concat(f, '"') : "".concat(f));
      }
    } catch (l) {
      o.e(l);
    } finally {
      o.f();
    }
    return [a, s];
  });
}, Zte = gs(function(e) {
  return [typeof e == "string" && e.length > 0, "a non-empty string"];
}), Mte = gs(function(e) {
  return [typeof e == "number" && Number.isInteger(e) && e >= 0, "a non-negative integer"];
}), jte = gs(function(e) {
  return [_o.default(e) === "object" && e !== null && !Array.isArray(e), "a pure object (non-null and non-array)"];
});
function Yte(e) {
  var t = zte();
  return function() {
    var n = Ek.default(e), i;
    if (t) {
      var a = Ek.default(this).constructor;
      i = Reflect.construct(n, arguments, a);
    } else
      i = n.apply(this, arguments);
    return Ite.default(this, i);
  };
}
function zte() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function rl(e, t) {
  var r = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (!r) {
    if (Array.isArray(e) || (r = Gte(e)) || t && e && typeof e.length == "number") {
      r && (e = r);
      var n = 0, i = function() {
      };
      return { s: i, n: function() {
        return n >= e.length ? { done: !0 } : { done: !1, value: e[n++] };
      }, e: function(f) {
        throw f;
      }, f: i };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  var a = !0, s = !1, o;
  return { s: function() {
    r = r.call(e);
  }, n: function() {
    var f = r.next();
    return a = f.done, f;
  }, e: function(f) {
    s = !0, o = f;
  }, f: function() {
    try {
      !a && r.return != null && r.return();
    } finally {
      if (s)
        throw o;
    }
  } };
}
function Gte(e, t) {
  if (e) {
    if (typeof e == "string")
      return Ik(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set")
      return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return Ik(e, t);
  }
}
function Ik(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
var Hp = function(t, r) {
  if (r.length > t.length)
    throw new Error("Expected at most ".concat(t.length, " argument(s), but got ").concat(r.length));
  for (; r.length < t.length; )
    r.push(void 0);
  var n = rl(r.entries()), i;
  try {
    for (n.s(); !(i = n.n()).done; ) {
      var a = Ys.default(i.value, 2), s = a[0], o = a[1], u = zV(t[s], o), f = Ys.default(u, 4), l = f[0], d = f[1], c = f[2], p = f[3];
      if (!l) {
        var v = s + 1;
        throw new Error("Argument ".concat(v, " is expected to be ").concat(c).concat(p, " but got ").concat(d));
      }
    }
  } catch (h) {
    n.e(h);
  } finally {
    n.f();
  }
}, I9 = function(t) {
  var r, n, i = ["undefined", "boolean", "number", "bigint", "string"];
  if (i.includes(_o.default(t)) && (n = typeof t == "string" ? '"'.concat(t, '"') : "".concat(t)), _o.default(t) === "object" && (t == null || (r = t.constructor) === null || r === void 0 ? void 0 : r.name) !== "Object") {
    var a;
    n = t === null ? "null" : "instance of ".concat(t == null || (a = t.constructor) === null || a === void 0 ? void 0 : a.name);
  }
  return n || (n = _o.default(t)), n;
}, Qte = function() {
  for (var t = arguments.length, r = new Array(t), n = 0; n < t; n++)
    r[n] = arguments[n];
  var i = jV(r);
  return function(a) {
    return /* @__PURE__ */ function(s) {
      Nte.default(u, s);
      var o = Yte(u);
      function u() {
        Ote.default(this, u);
        for (var f = arguments.length, l = new Array(f), d = 0; d < f; d++)
          l[d] = arguments[d];
        return Hp(i, l), o.call.apply(o, [this].concat(l));
      }
      return u;
    }(a);
  };
}, Jte = function() {
  for (var t = arguments.length, r = new Array(t), n = 0; n < t; n++)
    r[n] = arguments[n];
  var i = jV(r);
  return function(a, s, o) {
    if (typeof o.value != "function")
      throw new Error("The validateTypes decorator can only be applied to methods");
    var u = o.value;
    o.value = function() {
      for (var f = arguments.length, l = new Array(f), d = 0; d < f; d++)
        l[d] = arguments[d];
      return Hp(i, l), u.apply(this, l);
    };
  };
}, Hte = function() {
  for (var t = arguments.length, r = new Array(t), n = 0; n < t; n++)
    r[n] = arguments[n];
  var i = jV(r);
  return function(a, s, o) {
    if (typeof o.value != "function")
      throw new Error("The validateTypesAsync decorator can only be applied to methods");
    var u = o.value;
    o.value = function() {
      for (var f = arguments.length, l = new Array(f), d = 0; d < f; d++)
        l[d] = arguments[d];
      try {
        Hp(i, l);
      } catch (c) {
        return Promise.reject(c);
      }
      return u.apply(this, l);
    };
  };
}, jV = function(t) {
  var r = [], n = rl(t), i;
  try {
    for (n.s(); !(i = n.n()).done; ) {
      var a = i.value;
      r.push(YV(a));
    }
  } catch (s) {
    n.e(s);
  } finally {
    n.f();
  }
  return r;
}, YV = function(t) {
  var r = [], n = Array.isArray(t) ? t : [t], i = rl(n), a;
  try {
    for (i.s(); !(a = i.n()).done; ) {
      var s = a.value;
      if (typeof s == "string" || typeof s == "function") {
        r.push(N9(s));
        continue;
      }
      r.push(s);
    }
  } catch (o) {
    i.e(o);
  } finally {
    i.f();
  }
  return r;
}, zV = function(t, r) {
  var n = [], i, a = !1, s = rl(t), o;
  try {
    for (s.s(); !(o = s.n()).done; ) {
      var u = o.value, f = rl(u.checks), l;
      try {
        for (f.s(); !(l = f.n()).done; ) {
          var d = l.value, c = d(r), p = Ys.default(c, 3), v = p[0], h = p[1], m = p[2];
          a = a || v, !i && m && (i = m), h && (n = typeof h == "string" ? [].concat(u1.default(n), [h]) : [].concat(u1.default(n), u1.default(h)));
        }
      } catch (C) {
        f.e(C);
      } finally {
        f.f();
      }
    }
  } catch (C) {
    s.e(C);
  } finally {
    s.f();
  }
  if (a)
    return [!0];
  var q = i || I9(r), w = n.length - 1, O = w > 0 ? "".concat(n.slice(0, w).join(", "), " or ").concat(n[w]) : n.join(", ");
  return [!1, q, O, w > 1 ? ";" : ","];
}, _te = function(t, r) {
  return gs(function(n) {
    if (_o.default(n) !== "object" || n === null || Array.isArray(n))
      return [!1, "valid ".concat(t, " (should be a pure object)")];
    for (var i = 0, a = Object.entries(r); i < a.length; i++) {
      var s = Ys.default(a[i], 2), o = s[0], u = s[1], f = zV(YV(u), n[o]), l = Ys.default(f, 3), d = l[0], c = l[1], p = l[2];
      if (!d)
        return [!1, "valid ".concat(t, ' (key "').concat(o, '" should be ').concat(p, ")"), "malformed ".concat(t, ' (key "').concat(o, '" is ').concat(c, ")")];
    }
    return [!0];
  });
};
function $te(e, t) {
  var r = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (!r) {
    if (Array.isArray(e) || (r = ere(e)) || t && e && typeof e.length == "number") {
      r && (e = r);
      var n = 0, i = function() {
      };
      return { s: i, n: function() {
        return n >= e.length ? { done: !0 } : { done: !1, value: e[n++] };
      }, e: function(f) {
        throw f;
      }, f: i };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  var a = !0, s = !1, o;
  return { s: function() {
    r = r.call(e);
  }, n: function() {
    var f = r.next();
    return a = f.done, f;
  }, e: function(f) {
    s = !0, o = f;
  }, f: function() {
    try {
      !a && r.return != null && r.return();
    } finally {
      if (s)
        throw o;
    }
  } };
}
function ere(e, t) {
  if (e) {
    if (typeof e == "string")
      return Xk(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set")
      return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return Xk(e, t);
  }
}
function Xk(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
var tre = function(t, r) {
  return gs(function(n) {
    if (!Array.isArray(n))
      return [!1, "an array of ".concat(t)];
    var i = $te(n.entries()), a;
    try {
      for (i.s(); !(a = i.n()).done; ) {
        var s = Ys.default(a.value, 2), o = s[0], u = s[1], f = zV(YV(r), u), l = Ys.default(f, 3), d = l[0], c = l[1], p = l[2];
        if (!d)
          return [!1, "a valid array of ".concat(t, " (index ").concat(o, " should be ").concat(p, ")"), "malformed array of ".concat(t, " (index ").concat(o, " is ").concat(c, ")")];
      }
    } catch (v) {
      i.e(v);
    } finally {
      i.f();
    }
    return [!0];
  });
};
Sn.array = tre;
Sn.custom = gs;
Sn.literal = Lte;
Sn.nonEmptyString = Zte;
Sn.nonNegativeInteger = Mte;
Sn.objectSchema = _te;
Sn.pureObject = jte;
Sn.runtimeTypeValidation = Hp;
Sn.stringifyReceivedType = I9;
Sn.type = N9;
Sn.validateConstructorTypes = Qte;
Sn.validateTypes = Jte;
Sn.validateTypesAsync = Hte;
var lg = { exports: {} }, Pk = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto < "u" && typeof window.msCrypto.getRandomValues == "function" && msCrypto.getRandomValues.bind(msCrypto);
if (Pk) {
  var Bk = new Uint8Array(16);
  lg.exports = function() {
    return Pk(Bk), Bk;
  };
} else {
  var Dk = new Array(16);
  lg.exports = function() {
    for (var t = 0, r; t < 16; t++)
      t & 3 || (r = Math.random() * 4294967296), Dk[t] = r >>> ((t & 3) << 3) & 255;
    return Dk;
  };
}
var X9 = lg.exports, P9 = [];
for (var Ud = 0; Ud < 256; ++Ud)
  P9[Ud] = (Ud + 256).toString(16).substr(1);
function rre(e, t) {
  var r = t || 0, n = P9;
  return [
    n[e[r++]],
    n[e[r++]],
    n[e[r++]],
    n[e[r++]],
    "-",
    n[e[r++]],
    n[e[r++]],
    "-",
    n[e[r++]],
    n[e[r++]],
    "-",
    n[e[r++]],
    n[e[r++]],
    "-",
    n[e[r++]],
    n[e[r++]],
    n[e[r++]],
    n[e[r++]],
    n[e[r++]],
    n[e[r++]]
  ].join("");
}
var B9 = rre, nre = X9, ire = B9, Lk, f1, l1 = 0, d1 = 0;
function are(e, t, r) {
  var n = t && r || 0, i = t || [];
  e = e || {};
  var a = e.node || Lk, s = e.clockseq !== void 0 ? e.clockseq : f1;
  if (a == null || s == null) {
    var o = nre();
    a == null && (a = Lk = [
      o[0] | 1,
      o[1],
      o[2],
      o[3],
      o[4],
      o[5]
    ]), s == null && (s = f1 = (o[6] << 8 | o[7]) & 16383);
  }
  var u = e.msecs !== void 0 ? e.msecs : (/* @__PURE__ */ new Date()).getTime(), f = e.nsecs !== void 0 ? e.nsecs : d1 + 1, l = u - l1 + (f - d1) / 1e4;
  if (l < 0 && e.clockseq === void 0 && (s = s + 1 & 16383), (l < 0 || u > l1) && e.nsecs === void 0 && (f = 0), f >= 1e4)
    throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
  l1 = u, d1 = f, f1 = s, u += 122192928e5;
  var d = ((u & 268435455) * 1e4 + f) % 4294967296;
  i[n++] = d >>> 24 & 255, i[n++] = d >>> 16 & 255, i[n++] = d >>> 8 & 255, i[n++] = d & 255;
  var c = u / 4294967296 * 1e4 & 268435455;
  i[n++] = c >>> 8 & 255, i[n++] = c & 255, i[n++] = c >>> 24 & 15 | 16, i[n++] = c >>> 16 & 255, i[n++] = s >>> 8 | 128, i[n++] = s & 255;
  for (var p = 0; p < 6; ++p)
    i[n + p] = a[p];
  return t || ire(i);
}
var sre = are, ore = X9, ure = B9;
function fre(e, t, r) {
  var n = t && r || 0;
  typeof e == "string" && (t = e === "binary" ? new Array(16) : null, e = null), e = e || {};
  var i = e.random || (e.rng || ore)();
  if (i[6] = i[6] & 15 | 64, i[8] = i[8] & 63 | 128, t)
    for (var a = 0; a < 16; ++a)
      t[n + a] = i[a];
  return t || ure(i);
}
var lre = fre, dre = sre, D9 = lre, GV = D9;
GV.v1 = dre;
GV.v4 = D9;
var cre = GV;
/*
@license
The following license applies to all parts of this software except as
documented below.

    Copyright (c) 2016, Twilio, inc.
    All rights reserved.

    Redistribution and use in source and binary forms, with or without
    modification, are permitted provided that the following conditions are
    met:

      1. Redistributions of source code must retain the above copyright
         notice, this list of conditions and the following disclaimer.

      2. Redistributions in binary form must reproduce the above copyright
         notice, this list of conditions and the following disclaimer in
         the documentation and/or other materials provided with the
         distribution.

      3. Neither the name of Twilio nor the names of its contributors may
         be used to endorse or promote products derived from this software
         without specific prior written permission.

    THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
    "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
    LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
    A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT
    HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
    SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT
    LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE,
    DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY
    THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
    (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
    OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.

This software includes loglevel under the following license.

    Copyright (c) 2013 Tim Perry

    Permission is hereby granted, free of charge, to any person
    obtaining a copy of this software and associated documentation
    files (the "Software"), to deal in the Software without
    restriction, including without limitation the rights to use,
    copy, modify, merge, publish, distribute, sublicense, and/or sell
    copies of the Software, and to permit persons to whom the
    Software is furnished to do so, subject to the following
    conditions:

    The above copyright notice and this permission notice shall be
    included in all copies or substantial portions of the Software.

    THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
    EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES
    OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
    NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT
    HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
    WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
    FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR
    OTHER DEALINGS IN THE SOFTWARE.

This software includes Backoff library under the following license

    Copyright (C) 2012 Mathieu Turcotte

    Permission is hereby granted, free of charge, to any person obtaining a copy of
    this software and associated documentation files (the "Software"), to deal in
    the Software without restriction, including without limitation the rights to
    use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies
    of the Software, and to permit persons to whom the Software is furnished to do
    so, subject to the following conditions:

    The above copyright notice and this permission notice shall be included in all
    copies or substantial portions of the Software.

    THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
    IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
    FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
    AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
    LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
    OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
    SOFTWARE.

This software includes Event-to-Promise library under the following license

    Copyright (c) 2014, Julien Fontanet <julien.fontanet@isonoe.net>.

    Permission to use, copy, modify, and/or distribute this software for any purpose
    with or without fee is hereby granted, provided that the above copyright notice
    and this permission notice appear in all copies.

    THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
    REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY AND
    FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
    INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM LOSS
    OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR OTHER
    TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR PERFORMANCE OF
    THIS SOFTWARE.

*/
Object.defineProperty(xn, "__esModule", { value: !0 });
var pre = Kl, vre = ra, hre = ps, mre = to, gre = ea, yre = ta, Vre = ci, qre = ro, bre = El, Are = di, Le = Sn, Bc = Dp, wre = Jp, kre = Nl, Wre = Eu, L9 = Ua, Z9 = cre, Sre = mV, Cre = K9;
function Yn(e) {
  return e && typeof e == "object" && "default" in e ? e : { default: e };
}
function QV(e) {
  if (e && e.__esModule)
    return e;
  var t = /* @__PURE__ */ Object.create(null);
  return e && Object.keys(e).forEach(function(r) {
    if (r !== "default") {
      var n = Object.getOwnPropertyDescriptor(e, r);
      Object.defineProperty(t, r, n.get ? n : {
        enumerable: !0,
        get: function() {
          return e[r];
        }
      });
    }
  }), t.default = e, Object.freeze(t);
}
var Ge = /* @__PURE__ */ Yn(pre), Zt = /* @__PURE__ */ Yn(vre), Jt = /* @__PURE__ */ Yn(hre), Zi = /* @__PURE__ */ Yn(mre), Cn = /* @__PURE__ */ Yn(gre), ys = /* @__PURE__ */ Yn(yre), Dr = /* @__PURE__ */ Yn(Vre), nr = /* @__PURE__ */ Yn(qre), de = /* @__PURE__ */ Yn(bre), M9 = /* @__PURE__ */ Yn(Are), Fre = /* @__PURE__ */ Yn(wre), Kre = /* @__PURE__ */ QV(kre), j9 = /* @__PURE__ */ Yn(Wre), Rre = /* @__PURE__ */ QV(Z9), Pl = /* @__PURE__ */ Yn(Sre), xd = /* @__PURE__ */ QV(Cre);
function Mt(e, t, r, n) {
  var i = arguments.length, a = i < 3 ? t : n === null ? n = Object.getOwnPropertyDescriptor(t, r) : n, s;
  if ((typeof Reflect > "u" ? "undefined" : M9.default(Reflect)) === "object" && typeof Reflect.decorate == "function")
    a = Reflect.decorate(e, t, r, n);
  else
    for (var o = e.length - 1; o >= 0; o--)
      (s = e[o]) && (a = (i < 3 ? s(a) : i > 3 ? s(t, r, a) : s(t, r)) || a);
  return i > 3 && a && Object.defineProperty(t, r, a), a;
}
function Ye(e, t) {
  if ((typeof Reflect > "u" ? "undefined" : M9.default(Reflect)) === "object" && typeof Reflect.metadata == "function")
    return Reflect.metadata(e, t);
}
var Tre;
function ts() {
}
ts.prototype = /* @__PURE__ */ Object.create(null);
function sr() {
  sr.init.call(this);
}
sr.EventEmitter = sr;
sr.usingDomains = !1;
sr.prototype.domain = void 0;
sr.prototype._events = void 0;
sr.prototype._maxListeners = void 0;
sr.defaultMaxListeners = 10;
sr.init = function() {
  this.domain = null, sr.usingDomains && Tre.active, (!this._events || this._events === Object.getPrototypeOf(this)._events) && (this._events = new ts(), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
};
sr.prototype.setMaxListeners = function(t) {
  if (typeof t != "number" || t < 0 || isNaN(t))
    throw new TypeError('"n" argument must be a positive number');
  return this._maxListeners = t, this;
};
function Y9(e) {
  return e._maxListeners === void 0 ? sr.defaultMaxListeners : e._maxListeners;
}
sr.prototype.getMaxListeners = function() {
  return Y9(this);
};
function Ure(e, t, r) {
  if (t)
    e.call(r);
  else
    for (var n = e.length, i = Bl(e, n), a = 0; a < n; ++a)
      i[a].call(r);
}
function xre(e, t, r, n) {
  if (t)
    e.call(r, n);
  else
    for (var i = e.length, a = Bl(e, i), s = 0; s < i; ++s)
      a[s].call(r, n);
}
function Ere(e, t, r, n, i) {
  if (t)
    e.call(r, n, i);
  else
    for (var a = e.length, s = Bl(e, a), o = 0; o < a; ++o)
      s[o].call(r, n, i);
}
function Ore(e, t, r, n, i, a) {
  if (t)
    e.call(r, n, i, a);
  else
    for (var s = e.length, o = Bl(e, s), u = 0; u < s; ++u)
      o[u].call(r, n, i, a);
}
function Nre(e, t, r, n) {
  if (t)
    e.apply(r, n);
  else
    for (var i = e.length, a = Bl(e, i), s = 0; s < i; ++s)
      a[s].apply(r, n);
}
sr.prototype.emit = function(t) {
  var r, n, i, a, s, o, u, f = t === "error";
  if (o = this._events, o)
    f = f && o.error == null;
  else if (!f)
    return !1;
  if (u = this.domain, f) {
    if (r = arguments[1], u)
      r || (r = new Error('Uncaught, unspecified "error" event')), r.domainEmitter = this, r.domain = u, r.domainThrown = !1, u.emit("error", r);
    else {
      if (r instanceof Error)
        throw r;
      var l = new Error('Uncaught, unspecified "error" event. (' + r + ")");
      throw l.context = r, l;
    }
    return !1;
  }
  if (n = o[t], !n)
    return !1;
  var d = typeof n == "function";
  switch (i = arguments.length, i) {
    case 1:
      Ure(n, d, this);
      break;
    case 2:
      xre(n, d, this, arguments[1]);
      break;
    case 3:
      Ere(n, d, this, arguments[1], arguments[2]);
      break;
    case 4:
      Ore(n, d, this, arguments[1], arguments[2], arguments[3]);
      break;
    default:
      for (a = new Array(i - 1), s = 1; s < i; s++)
        a[s - 1] = arguments[s];
      Nre(n, d, this, a);
  }
  return !0;
};
function z9(e, t, r, n) {
  var i, a, s;
  if (typeof r != "function")
    throw new TypeError('"listener" argument must be a function');
  if (a = e._events, a ? (a.newListener && (e.emit(
    "newListener",
    t,
    r.listener ? r.listener : r
  ), a = e._events), s = a[t]) : (a = e._events = new ts(), e._eventsCount = 0), !s)
    s = a[t] = r, ++e._eventsCount;
  else if (typeof s == "function" ? s = a[t] = n ? [r, s] : [s, r] : n ? s.unshift(r) : s.push(r), !s.warned && (i = Y9(e), i && i > 0 && s.length > i)) {
    s.warned = !0;
    var o = new Error("Possible EventEmitter memory leak detected. " + s.length + " " + t + " listeners added. Use emitter.setMaxListeners() to increase limit");
    o.name = "MaxListenersExceededWarning", o.emitter = e, o.type = t, o.count = s.length, Ire(o);
  }
  return e;
}
function Ire(e) {
  typeof console.warn == "function" ? console.warn(e) : console.log(e);
}
sr.prototype.addListener = function(t, r) {
  return z9(this, t, r, !1);
};
sr.prototype.on = sr.prototype.addListener;
sr.prototype.prependListener = function(t, r) {
  return z9(this, t, r, !0);
};
function G9(e, t, r) {
  var n = !1;
  function i() {
    e.removeListener(t, i), n || (n = !0, r.apply(e, arguments));
  }
  return i.listener = r, i;
}
sr.prototype.once = function(t, r) {
  if (typeof r != "function")
    throw new TypeError('"listener" argument must be a function');
  return this.on(t, G9(this, t, r)), this;
};
sr.prototype.prependOnceListener = function(t, r) {
  if (typeof r != "function")
    throw new TypeError('"listener" argument must be a function');
  return this.prependListener(t, G9(this, t, r)), this;
};
sr.prototype.removeListener = function(t, r) {
  var n, i, a, s, o;
  if (typeof r != "function")
    throw new TypeError('"listener" argument must be a function');
  if (i = this._events, !i)
    return this;
  if (n = i[t], !n)
    return this;
  if (n === r || n.listener && n.listener === r)
    --this._eventsCount === 0 ? this._events = new ts() : (delete i[t], i.removeListener && this.emit("removeListener", t, n.listener || r));
  else if (typeof n != "function") {
    for (a = -1, s = n.length; s-- > 0; )
      if (n[s] === r || n[s].listener && n[s].listener === r) {
        o = n[s].listener, a = s;
        break;
      }
    if (a < 0)
      return this;
    if (n.length === 1) {
      if (n[0] = void 0, --this._eventsCount === 0)
        return this._events = new ts(), this;
      delete i[t];
    } else
      Xre(n, a);
    i.removeListener && this.emit("removeListener", t, o || r);
  }
  return this;
};
sr.prototype.off = function(e, t) {
  return this.removeListener(e, t);
};
sr.prototype.removeAllListeners = function(t) {
  var r, n;
  if (n = this._events, !n)
    return this;
  if (!n.removeListener)
    return arguments.length === 0 ? (this._events = new ts(), this._eventsCount = 0) : n[t] && (--this._eventsCount === 0 ? this._events = new ts() : delete n[t]), this;
  if (arguments.length === 0) {
    for (var i = Object.keys(n), a = 0, s; a < i.length; ++a)
      s = i[a], s !== "removeListener" && this.removeAllListeners(s);
    return this.removeAllListeners("removeListener"), this._events = new ts(), this._eventsCount = 0, this;
  }
  if (r = n[t], typeof r == "function")
    this.removeListener(t, r);
  else if (r)
    do
      this.removeListener(t, r[r.length - 1]);
    while (r[0]);
  return this;
};
sr.prototype.listeners = function(t) {
  var r, n, i = this._events;
  return i ? (r = i[t], r ? typeof r == "function" ? n = [r.listener || r] : n = Pre(r) : n = []) : n = [], n;
};
sr.listenerCount = function(e, t) {
  return typeof e.listenerCount == "function" ? e.listenerCount(t) : Q9.call(e, t);
};
sr.prototype.listenerCount = Q9;
function Q9(e) {
  var t = this._events;
  if (t) {
    var r = t[e];
    if (typeof r == "function")
      return 1;
    if (r)
      return r.length;
  }
  return 0;
}
sr.prototype.eventNames = function() {
  return this._eventsCount > 0 ? Reflect.ownKeys(this._events) : [];
};
function Xre(e, t) {
  for (var r = t, n = r + 1, i = e.length; n < i; r += 1, n += 1)
    e[r] = e[n];
  e.pop();
}
function Bl(e, t) {
  for (var r = new Array(t); t--; )
    r[t] = e[t];
  return r;
}
function Pre(e) {
  for (var t = new Array(e.length), r = 0; r < t.length; ++r)
    t[r] = e[r].listener || e[r];
  return t;
}
var cu = /* @__PURE__ */ function() {
  function e(t) {
    Zt.default(this, e), this.base = t, this.args = new Array(), this.paths = new Array();
  }
  return Jt.default(e, [{
    key: "pathSegment",
    value: function(r) {
      return this.paths.push(encodeURIComponent(r)), this;
    }
  }, {
    key: "queryParam",
    value: function(r, n) {
      return typeof n < "u" && this.args.push(encodeURIComponent(r) + "=" + encodeURIComponent(n)), this;
    }
  }, {
    key: "build",
    value: function() {
      var r = this.base;
      return this.paths.length && (r += "/" + this.paths.join("/")), this.args.length && (r += "?" + this.args.join("&")), r;
    }
  }]), e;
}();
function J9(e) {
  var t = Bre();
  return function() {
    var n = Dr.default(e), i;
    if (t) {
      var a = Dr.default(this).constructor;
      i = Reflect.construct(n, arguments, a);
    } else
      i = n.apply(this, arguments);
    return ys.default(this, i);
  };
}
function Bre() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
var Rn = /* @__PURE__ */ function(e) {
  Cn.default(r, e);
  var t = J9(r);
  function r(n) {
    var i, a = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
    return Zt.default(this, r), i = t.call(this), i.name = i.constructor.name, i.message = "".concat(n, " (status: ").concat(a, ", code: ").concat(s, ")"), i.status = a, i.code = s, i;
  }
  return r;
}(/* @__PURE__ */ Fre.default(Error)), Dre = /* @__PURE__ */ function(e) {
  Cn.default(r, e);
  var t = J9(r);
  function r(n) {
    var i, a = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0, o = arguments.length > 3 ? arguments[3] : void 0;
    return Zt.default(this, r), i = t.call(this, n, a, s), i.body = o, i;
  }
  return r;
}(Rn);
function Wi(e) {
  return JSON.parse(JSON.stringify(e));
}
function H9(e) {
  var t = e === void 0 || JV(e);
  if (!t)
    throw new Rn("Invalid pageSize parameter. Expected a positive integer, was '".concat(e, "'."), 400, 20007);
}
function Lre(e) {
  return !isNaN(parseInt(e)) && isFinite(e);
}
function JV(e) {
  return Lre(e) && e > 0;
}
var ko = Kre.getLogger("twilio-sync");
function mf(e, t) {
  return ["".concat((/* @__PURE__ */ new Date()).toISOString(), " Sync ").concat(e, ":")].concat(Array.from(t));
}
var jt = {
  setLevel: function(t) {
    ko.setLevel(t);
  },
  trace: function() {
    for (var t = arguments.length, r = new Array(t), n = 0; n < t; n++)
      r[n] = arguments[n];
    ko.trace.apply(null, mf("T", r));
  },
  debug: function() {
    for (var t = arguments.length, r = new Array(t), n = 0; n < t; n++)
      r[n] = arguments[n];
    ko.debug.apply(null, mf("D", r));
  },
  info: function() {
    for (var t = arguments.length, r = new Array(t), n = 0; n < t; n++)
      r[n] = arguments[n];
    ko.info.apply(null, mf("I", r));
  },
  warn: function() {
    for (var t = arguments.length, r = new Array(t), n = 0; n < t; n++)
      r[n] = arguments[n];
    ko.warn.apply(null, mf("W", r));
  },
  error: function() {
    for (var t = arguments.length, r = new Array(t), n = 0; n < t; n++)
      r[n] = arguments[n];
    ko.error.apply(null, mf("E", r));
  }
}, Zre = "/v4/Subscriptions", Mre = "/v3/Maps", jre = "/v3/Lists", Yre = "/v3/Documents", zre = "/v3/Streams", Gre = "/v3/Insights";
function Qre(e, t, r) {
  return e && typeof e[t] < "u" ? e[t] : r;
}
var Jre = /* @__PURE__ */ function() {
  function e() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    Zt.default(this, e);
    var r = t.region || "us1", n = "https://cds.".concat(r, ".twilio.com"), i = t.cdsUri || n;
    this.settings = {
      subscriptionsUri: i + Zre,
      documentsUri: i + Yre,
      listsUri: i + jre,
      mapsUri: i + Mre,
      streamsUri: i + zre,
      insightsUri: i + Gre,
      sessionStorageEnabled: Qre(t.Sync, "enableSessionStorage", !0),
      productId: t.productId
    };
  }
  return Jt.default(e, [{
    key: "subscriptionsUri",
    get: function() {
      return this.settings.subscriptionsUri;
    }
  }, {
    key: "documentsUri",
    get: function() {
      return this.settings.documentsUri;
    }
  }, {
    key: "listsUri",
    get: function() {
      return this.settings.listsUri;
    }
  }, {
    key: "mapsUri",
    get: function() {
      return this.settings.mapsUri;
    }
  }, {
    key: "streamsUri",
    get: function() {
      return this.settings.streamsUri;
    }
  }, {
    key: "insightsUri",
    get: function() {
      return this.settings.insightsUri;
    }
  }, {
    key: "backoffConfig",
    get: function() {
      return this.settings.backoffConfig || {};
    }
  }, {
    key: "sessionStorageEnabled",
    get: function() {
      return this.settings.sessionStorageEnabled;
    }
  }, {
    key: "productId",
    get: function() {
      return this.settings.productId;
    }
  }]), e;
}();
function gf(e, t) {
  var r = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (!r) {
    if (Array.isArray(e) || (r = Hre(e)) || t && e && typeof e.length == "number") {
      r && (e = r);
      var n = 0, i = function() {
      };
      return { s: i, n: function() {
        return n >= e.length ? { done: !0 } : { done: !1, value: e[n++] };
      }, e: function(f) {
        throw f;
      }, f: i };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  var a = !0, s = !1, o;
  return { s: function() {
    r = r.call(e);
  }, n: function() {
    var f = r.next();
    return a = f.done, f;
  }, e: function(f) {
    s = !0, o = f;
  }, f: function() {
    try {
      !a && r.return != null && r.return();
    } finally {
      if (s)
        throw o;
    }
  } };
}
function Hre(e, t) {
  if (e) {
    if (typeof e == "string")
      return Zk(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set")
      return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return Zk(e, t);
  }
}
function Zk(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
var _re = /* @__PURE__ */ function() {
  function e(t) {
    Zt.default(this, e), this.localObject = t, this.pendingCorrelationId = null, this.pendingAction = null, this.established = !1, this.retryCount = 0;
  }
  return Jt.default(e, [{
    key: "sid",
    get: function() {
      return this.localObject.sid;
    }
  }, {
    key: "type",
    get: function() {
      return this.localObject.type;
    }
  }, {
    key: "lastEventId",
    get: function() {
      return this.localObject.lastEventId;
    }
    // below properties are specific to Insights only
  }, {
    key: "indexName",
    get: function() {
      return this.localObject.indexName;
    }
  }, {
    key: "queryString",
    get: function() {
      return this.localObject.queryString;
    }
  }, {
    key: "isEstablished",
    get: function() {
      return this.established;
    }
  }, {
    key: "update",
    value: function(r, n) {
      this.localObject._update(r, n);
    }
  }, {
    key: "updatePending",
    value: function(r, n) {
      this.pendingAction = r, this.pendingCorrelationId = n;
    }
  }, {
    key: "reset",
    value: function() {
      this.updatePending(null, null), this.retryCount = 0, this.established = !1, this.setSubscriptionState("none");
    }
  }, {
    key: "markAsFailed",
    value: function(r) {
      this.rejectedWithError = r.error, this.updatePending(null, null), this.localObject.reportFailure(new Rn("Failed to subscribe on service events: ".concat(r.error.message), r.error.status, r.error.code));
    }
  }, {
    key: "complete",
    value: function(r) {
      this.updatePending(null, null), this.established = !0, this.localObject._advanceLastEventId(r);
    }
  }, {
    key: "setSubscriptionState",
    value: function(r) {
      this.localObject._setSubscriptionState(r);
    }
  }]), e;
}(), $re = /* @__PURE__ */ function() {
  function e(t) {
    var r = this;
    Zt.default(this, e), nr.default(this, "isConnected", !1), nr.default(this, "maxBatchSize", 100), nr.default(this, "subscriptionTtlTimer", null), nr.default(this, "pendingPokeReason", null), this.services = t, this.subscriptions = /* @__PURE__ */ new Map(), this.persisted = /* @__PURE__ */ new Map(), this.latestPokeResponseArrivalTimestampByCorrelationId = /* @__PURE__ */ new Map();
    var n = {
      randomisationFactor: 0.2,
      initialDelay: 100,
      maxDelay: 2 * 60 * 1e3
    };
    this.backoff = L9.Backoff.exponential(Object.assign(n, this.services.config.backoffConfig)), this.backoff.on("ready", function() {
      var i = r.getSubscriptionUpdateBatch(), a = i.action, s = i.subscriptions;
      a ? r.applyNewSubscriptionUpdateBatch(a, s) : (r.backoff.reset(), jt.debug("All subscriptions resolved."));
    });
  }
  return Jt.default(e, [{
    key: "getSubscriptionUpdateBatch",
    value: function() {
      function r(a, s, o, u) {
        var f = [], l = gf(a), d;
        try {
          for (l.s(); !(d = l.n()).done; ) {
            var c = j9.default(d.value, 2), p = c[0], v = c[1], h = s.get(p);
            if (!h && o !== v.pendingAction && !v.rejectedWithError && (f.push(v), u && f.length >= u))
              break;
          }
        } catch (m) {
          l.e(m);
        } finally {
          l.f();
        }
        return f;
      }
      var n = r(this.subscriptions, this.persisted, "establish", this.maxBatchSize);
      if (n.length > 0)
        return {
          action: "establish",
          subscriptions: n
        };
      var i = r(this.persisted, this.subscriptions, "cancel", this.maxBatchSize);
      return i.length > 0 ? {
        action: "cancel",
        subscriptions: i
      } : {
        action: null,
        subscriptions: null
      };
    }
  }, {
    key: "persist",
    value: function() {
      this.backoff.backoff();
    }
  }, {
    key: "applyNewSubscriptionUpdateBatch",
    value: function() {
      var t = Ge.default(/* @__PURE__ */ de.default.mark(function n(i, a) {
        var s = this, o, u, f, l, d, c, p, v, h, m, q, w, O, C, R, I;
        return de.default.wrap(function(K) {
          for (; ; )
            switch (K.prev = K.next) {
              case 0:
                if (this.isConnected) {
                  K.next = 4;
                  break;
                }
                return jt.debug("Twilsock connection (required for subscription) not ready; waiting…"), this.backoff.reset(), K.abrupt("return");
              case 4:
                a = this.processLocalActions(i, a), o = (/* @__PURE__ */ new Date()).getTime(), u = gf(a);
                try {
                  for (u.s(); !(f = u.n()).done; )
                    l = f.value, this.recordActionAttemptOn(l, i, o);
                } catch (B) {
                  u.e(B);
                } finally {
                  u.f();
                }
                return d = this.pendingPokeReason, this.pendingPokeReason = null, K.prev = 10, K.next = 13, this.request(i, o, d, a);
              case 13:
                c = K.sent, p = c.body.max_batch_size, !isNaN(parseInt(p)) && isFinite(p) && p > 0 && (this.maxBatchSize = p), this.subscriptionTtlTimer || (v = c.body.ttl_in_s, h = !isNaN(parseFloat(v)) && isFinite(v), m = h && v > 0, m && (this.subscriptionTtlTimer = setTimeout(function() {
                  return s.onSubscriptionTtlElapsed();
                }, v * 1e3))), i === "establish" && (q = c.body.estimated_delivery_in_ms, w = !isNaN(parseFloat(q)) && isFinite(q), O = w && q > 0, O ? setTimeout(function() {
                  return s.verifyPokeDelivery(o, q, a);
                }, q) : jt.error("Invalid timeout: ".concat(q)), a.filter(function(B) {
                  return B.pendingCorrelationId === o;
                }).forEach(function(B) {
                  return B.setSubscriptionState("response_in_flight");
                })), this.backoff.reset(), K.next = 26;
                break;
              case 21:
                K.prev = 21, K.t0 = K.catch(10), C = gf(a);
                try {
                  for (C.s(); !(R = C.n()).done; )
                    I = R.value, this.recordActionFailureOn(I, i);
                } catch (B) {
                  C.e(B);
                } finally {
                  C.f();
                }
                K.t0 instanceof Bc.TransportUnavailableError ? (jt.debug("Twilsock connection (required for subscription) not ready (c:".concat(o, "); waiting…")), this.backoff.reset()) : (jt.debug("Failed an attempt to ".concat(i, " subscriptions (c:").concat(o, "); retrying"), K.t0), this.persist());
              case 26:
              case "end":
                return K.stop();
            }
        }, n, this, [[10, 21]]);
      }));
      function r(n, i) {
        return t.apply(this, arguments);
      }
      return r;
    }()
  }, {
    key: "verifyPokeDelivery",
    value: function(r, n, i) {
      var a = this, s = this.latestPokeResponseArrivalTimestampByCorrelationId.get(r), o = s ? (/* @__PURE__ */ new Date()).getTime() - s : n;
      if (o >= n)
        i.filter(function(f) {
          return f.pendingCorrelationId === r;
        }).forEach(function(f) {
          f.updatePending(null, null), f.retryCount++, a.persisted.delete(f.sid);
        }), this.persist(), this.latestPokeResponseArrivalTimestampByCorrelationId.delete(r);
      else {
        var u = n - o;
        setTimeout(function() {
          return a.verifyPokeDelivery(r, n, i);
        }, u);
      }
    }
  }, {
    key: "processLocalActions",
    value: function(r, n) {
      return r === "cancel" ? n.filter(function(i) {
        return !i.rejectedWithError;
      }) : n;
    }
  }, {
    key: "recordActionAttemptOn",
    value: function(r, n, i) {
      if (r.setSubscriptionState("request_in_flight"), n === "establish")
        this.persisted.set(r.sid, r), r.updatePending(n, i);
      else {
        var a = this.persisted.get(r.sid);
        a && a.updatePending(n, i);
      }
    }
  }, {
    key: "recordActionFailureOn",
    value: function(r, n) {
      r.setSubscriptionState("none"), r.updatePending(null, null), n === "establish" && this.persisted.delete(r.sid);
    }
  }, {
    key: "request",
    value: function(r, n, i, a) {
      var s = a.map(function(f) {
        return {
          object_sid: f.sid,
          object_type: f.type,
          last_event_id: r === "establish" ? f.lastEventId : void 0,
          index_name: r === "establish" ? f.indexName : void 0,
          query_string: r === "establish" ? f.queryString : void 0
        };
      }), o = a.filter(function(f) {
        return f.retryCount > 0;
      }).length;
      jt.debug("Attempting '".concat(r, "' request (c:").concat(n, "):"), s);
      var u = {
        event_protocol_version: 4,
        action: r,
        correlation_id: n,
        retried_requests: o,
        ttl_in_s: -1,
        requests: s
      };
      return i === "ttl" && (u.reason = i), this.services.network.post(this.services.config.subscriptionsUri, u);
    }
    /**
     * Establishes intent to be subscribed to this entity. That subscription will be effected
     * asynchronously.
     * If subscription to the given sid already exists, it will be overwritten.
     *
     * @param {String} sid should be a well-formed SID, uniquely identifying a single instance of a Sync entity.
     * @param {Object} entity should represent the (singular) local representation of this entity.
     *      Incoming events and modifications to the entity will be directed at the _update() function
     *      of this provided reference.
     *
     * @return undefined
     */
  }, {
    key: "add",
    value: function(r, n) {
      jt.debug("Establishing intent to subscribe to ".concat(r));
      var i = this.subscriptions.get(r);
      i && n && i.lastEventId === n.lastEventId || (this.persisted.delete(r), this.subscriptions.set(r, new _re(n)), this.persist());
    }
    /**
     * Establishes the caller's intent to no longer be subscribed to this entity. Following this
     * call, no further events shall be routed to the local representation of the entity, even
     * though a server-side subscription may take more time to actually terminate.
     *
     * @param {string} sid should be any well-formed SID, uniquely identifying a Sync entity.
     *      This call only has meaningful effect if that entity is subscribed at the
     *      time of call. Otherwise does nothing.
     *
     * @return undefined
     */
  }, {
    key: "remove",
    value: function(r) {
      jt.debug("Establishing intent to unsubscribe from ".concat(r));
      var n = this.subscriptions.delete(r);
      n && this.persist();
    }
    /**
     * The point of ingestion for remote incoming messages (e.g. new data was written to a map
     * to which we are subscribed).
     *
     * @param {object} message is the full, unaltered body of the incoming notification.
     *
     * @return undefined
     */
  }, {
    key: "acceptMessage",
    value: function(r, n) {
      jt.trace("Subscriptions received", r);
      var i = r.event_type, a = typeof r.events < "u" ? r.events : [r.event], s = r.correlation_id;
      s && this.latestPokeResponseArrivalTimestampByCorrelationId.set(s, (/* @__PURE__ */ new Date()).getTime());
      var o = gf(a), u;
      try {
        for (o.s(); !(u = o.n()).done; ) {
          var f = u.value, l = void 0;
          switch (r.event_type) {
            case "subscription_established":
              this.applySubscriptionEstablishedMessage(f, s);
              break;
            case "subscription_canceled":
              this.applySubscriptionCancelledMessage(f, s);
              break;
            case "subscription_failed":
              this.applySubscriptionFailedMessage(f, s);
              break;
            case (l = i.match(/^(?:map|list|document|stream|live_query)_/) || {}).input: {
              var d = void 0;
              switch (l[0]) {
                case "map_":
                  d = f.map_sid;
                  break;
                case "list_":
                  d = f.list_sid;
                  break;
                case "document_":
                  d = f.document_sid;
                  break;
                case "stream_":
                  d = f.stream_sid;
                  break;
                case "live_query_":
                  d = f.query_id, n = !1, r.strictly_ordered === !0 && (n = !0);
                  break;
                default:
                  d = void 0;
              }
              this.applyEventToSubscribedEntity(d, f, i, n);
              break;
            }
            default:
              jt.debug("Dropping unknown message type ".concat(i));
              break;
          }
        }
      } catch (c) {
        o.e(c);
      } finally {
        o.f();
      }
    }
  }, {
    key: "applySubscriptionEstablishedMessage",
    value: function(r, n) {
      var i = r.object_sid, a = this.persisted.get(r.object_sid);
      a && a.pendingCorrelationId === n ? r.replay_status === "interrupted" ? (jt.debug("Event Replay for subscription to ".concat(i, " (c:").concat(n, ") interrupted; continuing eagerly.")), a.updatePending(null, null), this.persisted.delete(a.sid), this.backoff.reset()) : r.replay_status === "completed" && (jt.debug("Event Replay for subscription to ".concat(i, " (c:").concat(n, ") completed. Subscription is ready.")), a.complete(r.last_event_id), this.persisted.set(r.object_sid, a), a.setSubscriptionState("established"), this.backoff.reset()) : jt.debug("Late message for ".concat(r.object_sid, " (c:").concat(n, ") dropped.")), this.persist();
    }
  }, {
    key: "applySubscriptionCancelledMessage",
    value: function(r, n) {
      var i = this.persisted.get(r.object_sid);
      i && i.pendingCorrelationId === n ? (i.updatePending(null, null), i.setSubscriptionState("none"), this.persisted.delete(r.object_sid)) : jt.debug("Late message for ".concat(r.object_sid, " (c:").concat(n, ") dropped.")), this.persist();
    }
  }, {
    key: "applySubscriptionFailedMessage",
    value: function(r, n) {
      var i = r.object_sid, a = this.subscriptions.get(i), s = this.persisted.get(i);
      a && s ? s.pendingCorrelationId === n && (jt.error("Failed to subscribe on ".concat(s.sid), r.error), s.markAsFailed(r), s.setSubscriptionState("none")) : !a && s && (this.persisted.delete(i), s.setSubscriptionState("none")), this.persist();
    }
  }, {
    key: "applyEventToSubscribedEntity",
    value: function(r, n, i, a) {
      var s = this;
      if (r) {
        a = a || function() {
          var u = s.persisted.get(r);
          return u && u.isEstablished;
        }();
        var o = this.subscriptions.get(r);
        o ? (n.type = i, o.update(n, a)) : jt.debug("Message dropped for SID '".concat(r, "', for which there is no subscription."));
      }
    }
  }, {
    key: "onConnectionStateChanged",
    value: function(r) {
      this.isConnected = r, r && this.poke("reconnect");
    }
  }, {
    key: "onSubscriptionTtlElapsed",
    value: function() {
      this.isConnected && this.poke("ttl");
    }
    /**
     * Prompts a playback of any missed changes made to any subscribed object. This method
     * should be invoked whenever the connectivity layer has experienced cross-cutting
     * delivery failures that would affect the entire local sync set. Any tangible result
     * of this operation will result in calls to the _update() function of subscribed
     * Sync entities.
     */
  }, {
    key: "poke",
    value: function(r) {
      jt.debug("Triggering event replay for all subscriptions, reason=".concat(r)), this.pendingPokeReason = r, this.subscriptionTtlTimer && (clearTimeout(this.subscriptionTtlTimer), this.subscriptionTtlTimer = null);
      var n = [], i = gf(this.persisted.values()), a;
      try {
        for (i.s(); !(a = i.n()).done; ) {
          var s = a.value;
          s.reset(), s.rejectedWithError && n.push(s);
        }
      } catch (l) {
        i.e(l);
      } finally {
        i.f();
      }
      this.persisted.clear();
      for (var o = 0, u = n; o < u.length; o++) {
        var f = u[o];
        this.persisted.set(f.sid, f);
      }
      this.persist();
    }
    /**
     * Stops all communication, clears any subscription intent, and returns.
     */
  }, {
    key: "shutdown",
    value: function() {
      this.backoff.reset(), this.subscriptions.clear();
    }
  }]), e;
}(), ene = 4e3, tne = 6e4, rne = 9e4, nne = 0.2;
function Mk(e) {
  if (e.body && e.body.message)
    return e.body.message;
  switch (e.status) {
    case 429:
      return "Throttled by server";
    case 404:
      return "Not found from server";
    default:
      return "Error from server";
  }
}
function jk(e) {
  return e.body ? e.body.code : 0;
}
function yf(e) {
  return e.status === 409 ? new Dre(Mk(e), e.status, jk(e), e.body) : e.status ? new Rn(Mk(e), e.status, jk(e)) : e instanceof Bc.TransportUnavailableError ? e : new Rn(e.message, 0, 0);
}
var ine = /* @__PURE__ */ function() {
  function e(t, r, n) {
    Zt.default(this, e), this.clientInfo = t, this.config = r, this.transport = n;
  }
  return Jt.default(e, [{
    key: "createHeaders",
    value: function() {
      return {
        "Content-Type": "application/json",
        "Twilio-Sync-Client-Info": JSON.stringify(this.clientInfo),
        "Twilio-Request-Id": "RQ" + Rre.v4().replace(/-/g, "")
      };
    }
  }, {
    key: "backoffConfig",
    value: function() {
      return Object.assign({
        min: ene,
        max: tne,
        maxAttemptsTime: rne,
        randomness: nne
      }, this.config.backoffConfig);
    }
  }, {
    key: "executeWithRetry",
    value: function(r) {
      var n = this, i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
      return new Promise(function(a, s) {
        var o = [502, 503, 504];
        i && o.push(429);
        var u = new L9.Retrier(n.backoffConfig());
        u.on("attempt", function() {
          r().then(function(f) {
            return u.succeeded(f);
          }).catch(function(f) {
            if (o.includes(f.status)) {
              var l = parseInt(f.headers ? f.headers["Retry-After"] : null);
              u.failed(yf(f), isNaN(l) ? null : l * 1e3);
            } else
              f.message === "Twilsock disconnected" ? u.failed(yf(f)) : (u.removeAllListeners(), u.cancel(), s(yf(f)));
          });
        }), u.on("succeeded", function(f) {
          a(f);
        }), u.on("cancelled", function(f) {
          return s(yf(f));
        }), u.on("failed", function(f) {
          return s(yf(f));
        }), u.start();
      });
    }
    /**
     * Make a GET request by given URI
     * @Returns Promise<Response> Result of successful get request
     */
  }, {
    key: "get",
    value: function(r) {
      var n = this, i = this.createHeaders();
      return jt.debug("GET", r, "ID:", i["Twilio-Request-Id"]), this.executeWithRetry(function() {
        return n.transport.get(r, i, n.config.productId);
      }, !0);
    }
  }, {
    key: "post",
    value: function(r, n, i) {
      var a = this, s = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !1, o = this.createHeaders();
      return typeof i < "u" && i !== null && (o["If-Match"] = i), jt.debug("POST", r, "ID:", o["Twilio-Request-Id"]), this.executeWithRetry(function() {
        return a.transport.post(r, o, n, a.config.productId);
      }, s);
    }
  }, {
    key: "put",
    value: function(r, n, i) {
      var a = this, s = this.createHeaders();
      return typeof i < "u" && i !== null && (s["If-Match"] = i), jt.debug("PUT", r, "ID:", s["Twilio-Request-Id"]), this.executeWithRetry(function() {
        return a.transport.put(r, s, n, a.config.productId);
      }, !1);
    }
  }, {
    key: "delete",
    value: function(r) {
      var n = this, i = this.createHeaders();
      return jt.debug("DELETE", r, "ID:", i["Twilio-Request-Id"]), this.executeWithRetry(function() {
        return n.transport.delete(r, i, n.config.productId);
      }, !1);
    }
  }]), e;
}(), ane = /* @__PURE__ */ function() {
  function e(t, r) {
    Zt.default(this, e), this.config = t, this.storageId = null;
    try {
      this.storage = r || sessionStorage;
    } catch {
    }
  }
  return Jt.default(e, [{
    key: "storageKey",
    value: function(r, n) {
      return "".concat(this.storageId, "::").concat(r, "::").concat(n);
    }
  }, {
    key: "isReady",
    get: function() {
      return this.config.sessionStorageEnabled && !!this.storageId;
    }
  }, {
    key: "updateStorageId",
    value: function(r) {
      this.storageId = r;
    }
  }, {
    key: "store",
    value: function(r, n, i) {
      return this.isReady ? this._store(this.storageKey(r, n), i) : null;
    }
  }, {
    key: "read",
    value: function(r, n) {
      return this.isReady ? this._read(this.storageKey(r, n)) : null;
    }
  }, {
    key: "remove",
    value: function(r, n, i) {
      if (!this.isReady)
        return null;
      try {
        this.storage.removeItem(this.storageKey(r, n)), i && this.storage.removeItem(this.storageKey(r, i));
      } catch {
      }
    }
  }, {
    key: "update",
    value: function(r, n, i, a) {
      if (!this.isReady)
        return null;
      this._apply(this.storageKey(r, n), a), i && this._apply(this.storageKey(r, i), a);
    }
  }, {
    key: "_store",
    value: function(r, n) {
      try {
        this.storage.setItem(r, JSON.stringify(n));
      } catch {
      }
    }
  }, {
    key: "_read",
    value: function(r) {
      try {
        var n = this.storage.getItem(r);
        if (n)
          return JSON.parse(n);
      } catch {
      }
      return null;
    }
  }, {
    key: "_apply",
    value: function(r, n) {
      var i = this._read(r);
      if (!i)
        return !1;
      this._store(r, Object.assign(i, n));
    }
  }]), e;
}();
function sne(e, t) {
  var r = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (!r) {
    if (Array.isArray(e) || (r = one(e)) || t && e && typeof e.length == "number") {
      r && (e = r);
      var n = 0, i = function() {
      };
      return { s: i, n: function() {
        return n >= e.length ? { done: !0 } : { done: !1, value: e[n++] };
      }, e: function(f) {
        throw f;
      }, f: i };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  var a = !0, s = !1, o;
  return { s: function() {
    r = r.call(e);
  }, n: function() {
    var f = r.next();
    return a = f.done, f;
  }, e: function(f) {
    s = !0, o = f;
  }, f: function() {
    try {
      !a && r.return != null && r.return();
    } finally {
      if (s)
        throw o;
    }
  } };
}
function one(e, t) {
  if (e) {
    if (typeof e == "string")
      return Yk(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set")
      return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return Yk(e, t);
  }
}
function Yk(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
var Dl = /* @__PURE__ */ function() {
  function e(t, r) {
    Zt.default(this, e), this.services = t, this.removalHandler = r, this.subscriptionState = "none", this._attachedListeners = /* @__PURE__ */ new Map();
  }
  return Jt.default(e, [{
    key: "_advanceLastEventId",
    value: function(r, n) {
    }
  }, {
    key: "reportFailure",
    value: function(r) {
      r.status === 404 ? this.onRemoved(!1) : this.broadcastEventToListeners("failure", r);
    }
    /**
     * Subscribe to changes of data entity
     * @private
     */
  }, {
    key: "_subscribe",
    value: function() {
      this.services.router._subscribe(this.sid, this);
    }
    /**
     * Unsubscribe from changes of current data entity
     * @private
     */
  }, {
    key: "_unsubscribe",
    value: function() {
      this.services.router._unsubscribe(this.sid);
    }
  }, {
    key: "_setSubscriptionState",
    value: function(r) {
      this.subscriptionState = r, this.broadcastEventToListeners("_subscriptionStateChanged", r);
    }
    /**
     * @public
     */
  }, {
    key: "close",
    value: function() {
      this._unsubscribe(), this.removalHandler != null && this.removalHandler(this.type, this.sid, this.uniqueName);
    }
  }, {
    key: "attach",
    value: function(r) {
      var n = r.listenerUuid, i = this._attachedListeners.get(n);
      i || (this._attachedListeners.size || this._subscribe(), this._attachedListeners.set(n, r));
    }
  }, {
    key: "detach",
    value: function(r) {
      this._attachedListeners.delete(r), this._attachedListeners.size || this.close();
    }
  }, {
    key: "broadcastEventToListeners",
    value: function(r, n) {
      var i = sne(this._attachedListeners.values()), a;
      try {
        for (i.s(); !(a = i.n()).done; ) {
          var s = a.value;
          s.emit(r, n);
        }
      } catch (o) {
        i.e(o);
      } finally {
        i.f();
      }
    }
  }]), e;
}(), _9 = /* @__PURE__ */ function() {
  function e(t) {
    Zt.default(this, e), nr.default(this, "queuedRequests", []), nr.default(this, "isRequestInFlight", !1), this.inputMergingFunction = t;
  }
  return Jt.default(e, [{
    key: "add",
    value: function(r, n) {
      var i = this, a = new Promise(function(s, o) {
        return i.queuedRequests.push({
          input: r,
          requestFunction: n,
          resolve: s,
          reject: o
        });
      });
      return this.wakeupQueue(), a;
    }
  }, {
    key: "squashAndAdd",
    value: function(r, n) {
      var i = this.queuedRequests;
      this.queuedRequests = [];
      var a;
      i.length > 0 ? (a = i.map(function(o) {
        return o.input;
      }).reduce(this.inputMergingFunction), a = this.inputMergingFunction(a, r)) : a = r;
      var s = this.add(a, n);
      return i.forEach(function(o) {
        return s.then(o.resolve, o.reject);
      }), s;
    }
  }, {
    key: "isEmpty",
    value: function() {
      return this.queuedRequests.length === 0 && !this.isRequestInFlight;
    }
  }, {
    key: "wakeupQueue",
    value: function() {
      var r = this;
      if (!(this.queuedRequests.length === 0 || this.isRequestInFlight)) {
        var n = this.queuedRequests.shift();
        this.isRequestInFlight = !0, n.requestFunction(n.input).then(n.resolve, n.reject).then(function(i) {
          r.isRequestInFlight = !1, r.wakeupQueue();
        });
      }
    }
  }]), e;
}(), $9 = /* @__PURE__ */ function() {
  function e(t) {
    Zt.default(this, e), nr.default(this, "queueByNamespaceKey", /* @__PURE__ */ new Map()), this.inputReducer = t;
  }
  return Jt.default(e, [{
    key: "add",
    value: function() {
      var t = Ge.default(/* @__PURE__ */ de.default.mark(function n(i, a, s) {
        return de.default.wrap(function(u) {
          for (; ; )
            switch (u.prev = u.next) {
              case 0:
                return u.abrupt("return", this.invokeQueueMethod(i, function(f) {
                  return f.add(a, s);
                }));
              case 1:
              case "end":
                return u.stop();
            }
        }, n, this);
      }));
      function r(n, i, a) {
        return t.apply(this, arguments);
      }
      return r;
    }()
  }, {
    key: "squashAndAdd",
    value: function() {
      var t = Ge.default(/* @__PURE__ */ de.default.mark(function n(i, a, s) {
        return de.default.wrap(function(u) {
          for (; ; )
            switch (u.prev = u.next) {
              case 0:
                return u.abrupt("return", this.invokeQueueMethod(i, function(f) {
                  return f.squashAndAdd(a, s);
                }));
              case 1:
              case "end":
                return u.stop();
            }
        }, n, this);
      }));
      function r(n, i, a) {
        return t.apply(this, arguments);
      }
      return r;
    }()
  }, {
    key: "invokeQueueMethod",
    value: function() {
      var t = Ge.default(/* @__PURE__ */ de.default.mark(function n(i, a) {
        var s, o;
        return de.default.wrap(function(f) {
          for (; ; )
            switch (f.prev = f.next) {
              case 0:
                return this.queueByNamespaceKey.has(i) || this.queueByNamespaceKey.set(i, new _9(this.inputReducer)), s = this.queueByNamespaceKey.get(i), o = a(s), this.queueByNamespaceKey.get(i).isEmpty() && this.queueByNamespaceKey.delete(i), f.abrupt("return", o);
              case 5:
              case "end":
                return f.stop();
            }
        }, n, this);
      }));
      function r(n, i) {
        return t.apply(this, arguments);
      }
      return r;
    }()
  }]), e;
}();
function une(e) {
  var t = fne();
  return function() {
    var n = Dr.default(e), i;
    if (t) {
      var a = Dr.default(this).constructor;
      i = Reflect.construct(n, arguments, a);
    } else
      i = n.apply(this, arguments);
    return ys.default(this, i);
  };
}
function fne() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
var Ll = /* @__PURE__ */ function(e) {
  Cn.default(r, e);
  var t = une(r);
  function r() {
    var n;
    return Zt.default(this, r), n = t.call(this), n.closed = !1, n.uuid = Z9.v4(), n;
  }
  return Jt.default(r, [{
    key: "listenerUuid",
    get: function() {
      return this.uuid;
    }
  }, {
    key: "close",
    value: function() {
      this.removeAllListeners(), this.closed = !0;
    }
  }, {
    key: "ensureNotClosed",
    value: function() {
      if (this.closed)
        throw new Error("Invalid operation on closed object");
    }
  }]), r;
}(sr);
function e4(e) {
  var t = lne();
  return function() {
    var n = Dr.default(e), i;
    if (t) {
      var a = Dr.default(this).constructor;
      i = Reflect.construct(n, arguments, a);
    } else
      i = n.apply(this, arguments);
    return ys.default(this, i);
  };
}
function lne() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
var dg = /* @__PURE__ */ function(e) {
  Cn.default(r, e);
  var t = e4(r);
  function r(n, i, a) {
    var s;
    Zt.default(this, r), s = t.call(this, n, a), nr.default(Zi.default(s), "isDeleted", !1);
    var o = function(f, l) {
      return typeof l.ttl == "number" ? {
        ttl: l.ttl
      } : f;
    };
    return s.updateMergingQueue = new _9(o), s.descriptor = i, s.descriptor.data = s.descriptor.data || {}, s.descriptor.date_updated = new Date(s.descriptor.date_updated), s;
  }
  return Jt.default(r, [{
    key: "uri",
    get: function() {
      return this.descriptor.url;
    }
  }, {
    key: "revision",
    get: function() {
      return this.descriptor.revision;
    }
  }, {
    key: "lastEventId",
    get: function() {
      return this.descriptor.last_event_id;
    }
  }, {
    key: "dateExpires",
    get: function() {
      return this.descriptor.date_expires;
    }
  }, {
    key: "type",
    get: function() {
      return "document";
    }
    // below properties are specific to Insights only
  }, {
    key: "indexName",
    get: function() {
    }
  }, {
    key: "queryString",
    get: function() {
    }
    // public props, documented along with class description
  }, {
    key: "sid",
    get: function() {
      return this.descriptor.sid;
    }
  }, {
    key: "data",
    get: function() {
      return this.descriptor.data;
    }
  }, {
    key: "dateUpdated",
    get: function() {
      return this.descriptor.date_updated;
    }
  }, {
    key: "uniqueName",
    get: function() {
      return this.descriptor.unique_name || null;
    }
    /**
     * Update data entity with new data
     * @private
     */
  }, {
    key: "_update",
    value: function(i) {
      switch (i.date_created = new Date(i.date_created), i.type) {
        case "document_updated":
          if (i.id <= this.lastEventId) {
            jt.trace("Document update skipped, current:", this.lastEventId, ", remote:", i.id);
            break;
          }
          var a = this.descriptor.data !== void 0 ? Wi(this.descriptor.data) : null;
          this.descriptor.last_event_id = i.id, this.descriptor.revision = i.document_revision, this.descriptor.date_updated = i.date_created, this.descriptor.data = i.document_data, this.broadcastEventToListeners("updated", {
            data: i.document_data,
            isLocal: !1,
            previousData: a
          }), this.services.storage.update(this.type, this.sid, this.uniqueName, {
            last_event_id: i.id,
            revision: i.document_revision,
            date_updated: i.date_created,
            data: i.document_data
          });
          break;
        case "document_removed":
          this.onRemoved(!1);
          break;
      }
    }
  }, {
    key: "set",
    value: function() {
      var n = Ge.default(/* @__PURE__ */ de.default.mark(function a(s, o) {
        var u = this, f;
        return de.default.wrap(function(d) {
          for (; ; )
            switch (d.prev = d.next) {
              case 0:
                return f = o || {}, d.abrupt("return", this.updateMergingQueue.squashAndAdd(f, function(c) {
                  return u._setUnconditionally(s, c.ttl);
                }));
              case 2:
              case "end":
                return d.stop();
            }
        }, a, this);
      }));
      function i(a, s) {
        return n.apply(this, arguments);
      }
      return i;
    }()
  }, {
    key: "mutate",
    value: function() {
      var n = Ge.default(/* @__PURE__ */ de.default.mark(function a(s, o) {
        var u = this, f;
        return de.default.wrap(function(d) {
          for (; ; )
            switch (d.prev = d.next) {
              case 0:
                return f = o || {}, d.abrupt("return", this.updateMergingQueue.add(f, function(c) {
                  return u._setWithIfMatch(s, c.ttl);
                }));
              case 2:
              case "end":
                return d.stop();
            }
        }, a, this);
      }));
      function i(a, s) {
        return n.apply(this, arguments);
      }
      return i;
    }()
  }, {
    key: "update",
    value: function() {
      var n = Ge.default(/* @__PURE__ */ de.default.mark(function a(s, o) {
        return de.default.wrap(function(f) {
          for (; ; )
            switch (f.prev = f.next) {
              case 0:
                return f.abrupt("return", this.mutate(function(l) {
                  return Object.assign(l, s);
                }, o));
              case 1:
              case "end":
                return f.stop();
            }
        }, a, this);
      }));
      function i(a, s) {
        return n.apply(this, arguments);
      }
      return i;
    }()
  }, {
    key: "setTtl",
    value: function() {
      var n = Ge.default(/* @__PURE__ */ de.default.mark(function a(s) {
        var o;
        return de.default.wrap(function(f) {
          for (; ; )
            switch (f.prev = f.next) {
              case 0:
                return f.next = 2, this._postUpdateToServer({
                  ttl: s
                });
              case 2:
                o = f.sent, this.descriptor.date_expires = o.date_expires;
              case 4:
              case "end":
                return f.stop();
            }
        }, a, this);
      }));
      function i(a) {
        return n.apply(this, arguments);
      }
      return i;
    }()
    /**
     * @private
     */
  }, {
    key: "_setUnconditionally",
    value: function() {
      var n = Ge.default(/* @__PURE__ */ de.default.mark(function a(s, o) {
        var u;
        return de.default.wrap(function(l) {
          for (; ; )
            switch (l.prev = l.next) {
              case 0:
                return l.next = 2, this._postUpdateToServer({
                  data: s,
                  revision: void 0,
                  ttl: o
                });
              case 2:
                return u = l.sent, this._handleSuccessfulUpdateResult(u), l.abrupt("return", this.descriptor.data);
              case 5:
              case "end":
                return l.stop();
            }
        }, a, this);
      }));
      function i(a, s) {
        return n.apply(this, arguments);
      }
      return i;
    }()
    /**
     * @private
     */
  }, {
    key: "_setWithIfMatch",
    value: function() {
      var n = Ge.default(/* @__PURE__ */ de.default.mark(function a(s, o) {
        var u, f, l;
        return de.default.wrap(function(c) {
          for (; ; )
            switch (c.prev = c.next) {
              case 0:
                if (u = s(Wi(this.descriptor.data)), !u) {
                  c.next = 22;
                  break;
                }
                return f = this.revision, c.prev = 3, c.next = 6, this._postUpdateToServer({
                  data: u,
                  revision: f,
                  ttl: o
                });
              case 6:
                return l = c.sent, this._handleSuccessfulUpdateResult(l), c.abrupt("return", this.descriptor.data);
              case 11:
                if (c.prev = 11, c.t0 = c.catch(3), c.t0.status !== 412) {
                  c.next = 19;
                  break;
                }
                return c.next = 16, this._softSync();
              case 16:
                return c.abrupt("return", this._setWithIfMatch(s));
              case 19:
                throw c.t0;
              case 20:
                c.next = 23;
                break;
              case 22:
                return c.abrupt("return", this.descriptor.data);
              case 23:
              case "end":
                return c.stop();
            }
        }, a, this, [[3, 11]]);
      }));
      function i(a, s) {
        return n.apply(this, arguments);
      }
      return i;
    }()
    /**
     * @private
     */
  }, {
    key: "_handleSuccessfulUpdateResult",
    value: function(i) {
      if (!(i.last_event_id <= this.descriptor.last_event_id)) {
        var a = this.descriptor.data !== void 0 ? Wi(this.descriptor.data) : null;
        this.descriptor.revision = i.revision, this.descriptor.data = i.data, this.descriptor.last_event_id = i.last_event_id, this.descriptor.date_expires = i.date_expires, this.descriptor.date_updated = new Date(i.date_updated), this.services.storage.update(this.type, this.sid, this.uniqueName, {
          last_event_id: i.last_event_id,
          revision: i.revision,
          date_updated: i.date_updated,
          data: i.data
        }), this.broadcastEventToListeners("updated", {
          data: this.descriptor.data,
          isLocal: !0,
          previousData: a
        });
      }
    }
    /**
     * @private
     */
  }, {
    key: "_postUpdateToServer",
    value: function() {
      var n = Ge.default(/* @__PURE__ */ de.default.mark(function a(s) {
        var o, u, f;
        return de.default.wrap(function(d) {
          for (; ; )
            switch (d.prev = d.next) {
              case 0:
                if (this.isDeleted) {
                  d.next = 17;
                  break;
                }
                return o = {
                  data: s.data
                }, s.ttl !== void 0 && (o.ttl = s.ttl), u = s.revision, d.prev = 4, d.next = 7, this.services.network.post(this.uri, o, u);
              case 7:
                return f = d.sent, d.abrupt("return", {
                  revision: f.body.revision,
                  data: s.data,
                  last_event_id: f.body.last_event_id,
                  date_updated: f.body.date_updated,
                  date_expires: f.body.date_expires
                });
              case 11:
                throw d.prev = 11, d.t0 = d.catch(4), d.t0.status === 404 && this.onRemoved(!1), d.t0;
              case 15:
                d.next = 18;
                break;
              case 17:
                return d.abrupt("return", Promise.reject(new Rn("The Document has been removed", 404, 54100)));
              case 18:
              case "end":
                return d.stop();
            }
        }, a, this, [[4, 11]]);
      }));
      function i(a) {
        return n.apply(this, arguments);
      }
      return i;
    }()
    /**
     * Get new data from server
     * @private
     */
  }, {
    key: "_softSync",
    value: function() {
      var n = Ge.default(/* @__PURE__ */ de.default.mark(function a() {
        var s = this;
        return de.default.wrap(function(u) {
          for (; ; )
            switch (u.prev = u.next) {
              case 0:
                return u.abrupt("return", this.services.network.get(this.uri).then(function(f) {
                  var l = {
                    type: "document_updated",
                    id: f.body.last_event_id,
                    document_revision: f.body.revision,
                    document_data: f.body.data,
                    date_created: f.body.date_updated
                  };
                  return s._update(l), s;
                }).catch(function(f) {
                  f.status === 404 ? s.onRemoved(!1) : jt.error("Can't get updates for ".concat(s.sid, ":"), f);
                }));
              case 1:
              case "end":
                return u.stop();
            }
        }, a, this);
      }));
      function i() {
        return n.apply(this, arguments);
      }
      return i;
    }()
  }, {
    key: "onRemoved",
    value: function(i) {
      if (!this.isDeleted) {
        var a = this.descriptor.data !== void 0 ? Wi(this.descriptor.data) : null;
        this.isDeleted = !0, this._unsubscribe(), this.removalHandler(this.type, this.sid, this.uniqueName), this.broadcastEventToListeners("removed", {
          isLocal: i,
          previousData: a
        });
      }
    }
  }, {
    key: "removeDocument",
    value: function() {
      var n = Ge.default(/* @__PURE__ */ de.default.mark(function a() {
        return de.default.wrap(function(o) {
          for (; ; )
            switch (o.prev = o.next) {
              case 0:
                if (this.isDeleted) {
                  o.next = 6;
                  break;
                }
                return o.next = 3, this.services.network.delete(this.uri);
              case 3:
                this.onRemoved(!0), o.next = 7;
                break;
              case 6:
                return o.abrupt("return", Promise.reject(new Rn("The Document has been removed", 404, 54100)));
              case 7:
              case "end":
                return o.stop();
            }
        }, a, this);
      }));
      function i() {
        return n.apply(this, arguments);
      }
      return i;
    }()
  }], [{
    key: "type",
    get: function() {
      return "document";
    }
  }]), r;
}(Dl), oi = /* @__PURE__ */ function(e) {
  Cn.default(r, e);
  var t = e4(r);
  function r(n) {
    var i;
    return Zt.default(this, r), i = t.call(this), i.syncDocumentImpl = n, i.syncDocumentImpl.attach(Zi.default(i)), i;
  }
  return Jt.default(r, [{
    key: "uri",
    get: (
      // private props
      function() {
        return this.syncDocumentImpl.uri;
      }
    )
  }, {
    key: "revision",
    get: function() {
      return this.syncDocumentImpl.revision;
    }
  }, {
    key: "lastEventId",
    get: function() {
      return this.syncDocumentImpl.lastEventId;
    }
  }, {
    key: "dateExpires",
    get: function() {
      return this.syncDocumentImpl.dateExpires;
    }
  }, {
    key: "type",
    get: function() {
      return dg.type;
    }
    /**
     * The immutable identifier of this document, assigned by the system.
     */
  }, {
    key: "sid",
    get: function() {
      return this.syncDocumentImpl.sid;
    }
    /**
     * The contents of this document.
     */
  }, {
    key: "data",
    get: function() {
      return this.syncDocumentImpl.data;
    }
    /**
     * Date when the document was last updated.
     */
  }, {
    key: "dateUpdated",
    get: function() {
      return this.syncDocumentImpl.dateUpdated;
    }
    /**
     * An optional immutable identifier that may be assigned by the programmer
     * to this document during creation. Globally unique among other documents.
     */
  }, {
    key: "uniqueName",
    get: function() {
      return this.syncDocumentImpl.uniqueName;
    }
  }, {
    key: "set",
    value: (
      /**
       * Assign new contents to this document. The current data will be overwritten.
       * @param data The new contents to assign.
       * @param metadataUpdates New document metadata.
       * @return A promise resolving to the new data of the document.
       * @example
       * ```typescript
       * // Say, the Document data is `{ name: 'John Smith', age: 34 }`
       * document.set({ name: 'Barbara Oaks' }, { ttl: 86400 })
       *   .then((newValue) => {
       *     // Now the Document data is `{ name: 'Barbara Oaks' }`
       *     console.log('Document set() successful, new data:', newValue);
       *   })
       *   .catch((error) => {
       *     console.error('Document set() failed', error);
       *   });
       * ```
       */
      function() {
        var n = Ge.default(/* @__PURE__ */ de.default.mark(function a(s, o) {
          return de.default.wrap(function(f) {
            for (; ; )
              switch (f.prev = f.next) {
                case 0:
                  return this.ensureNotClosed(), f.abrupt("return", this.syncDocumentImpl.set(s, o));
                case 2:
                case "end":
                  return f.stop();
              }
          }, a, this);
        }));
        function i(a, s) {
          return n.apply(this, arguments);
        }
        return i;
      }()
    )
    /**
     * Schedules a modification to this document that will apply a mutation function.
     * @param mutator A function that outputs new data based on the existing data.
     * May be called multiple times, particularly if this document is modified concurrently by remote code.
     * If the mutation ultimately succeeds, the document will have made the particular transition described
     * by this function.
     * @param metadataUpdates New document metadata.
     * @return Resolves with the most recent Document state, whether the output of a
     * successful mutation or a state that prompted graceful cancellation (mutator returned `null`).
     * @example
     * ```typescript
     * const mutatorFunction = (currentValue) => {
     *     currentValue.viewCount = (currentValue.viewCount ?? 0) + 1;
     *     return currentValue;
     * };
     * document.mutate(mutatorFunction, { ttl: 86400 }))
     *   .then((newValue) => {
     *     console.log('Document mutate() successful, new data:', newValue);
     *   })
     *   .catch((error) => {
     *     console.error('Document mutate() failed', error);
     *   });
     * ```
     */
  }, {
    key: "mutate",
    value: function() {
      var n = Ge.default(/* @__PURE__ */ de.default.mark(function a(s, o) {
        return de.default.wrap(function(f) {
          for (; ; )
            switch (f.prev = f.next) {
              case 0:
                return this.ensureNotClosed(), f.abrupt("return", this.syncDocumentImpl.mutate(s, o));
              case 2:
              case "end":
                return f.stop();
            }
        }, a, this);
      }));
      function i(a, s) {
        return n.apply(this, arguments);
      }
      return i;
    }()
    /**
     * Modify a document by appending new fields (or by overwriting existing ones) with the values from the provided Object.
     * This is equivalent to:
     * ```typescript
     * document.mutate((currentValue) => Object.assign(currentValue, obj));
     * ```
     * @param obj Specifies the particular (top-level) attributes that will receive new values.
     * @param metadataUpdates New document metadata.
     * @return A promise resolving to the new data of the document.
     * @example
     * ```typescript
     * // Say, the Document data is `{ name: 'John Smith' }`
     * document.update({ age: 34 }, { ttl: 86400 })
     *   .then((newValue) => {
     *     // Now the Document data is `{ name: 'John Smith', age: 34 }`
     *     console.log('Document update() successful, new data:', newValue);
     *   })
     *   .catch((error) => {
     *     console.error('Document update() failed', error);
     *   });
     * ```
     */
  }, {
    key: "update",
    value: function() {
      var n = Ge.default(/* @__PURE__ */ de.default.mark(function a(s, o) {
        return de.default.wrap(function(f) {
          for (; ; )
            switch (f.prev = f.next) {
              case 0:
                return this.ensureNotClosed(), f.abrupt("return", this.syncDocumentImpl.update(s, o));
              case 2:
              case "end":
                return f.stop();
            }
        }, a, this);
      }));
      function i(a, s) {
        return n.apply(this, arguments);
      }
      return i;
    }()
    /**
     * Update the time-to-live of the document.
     * @param ttl Specifies the time-to-live in seconds after which the document is subject to automatic deletion. The value 0 means infinity.
     * @return A promise that resolves after the TTL update was successful.
     * @example
     * ```typescript
     * document.setTtl(3600)
     *   .then(() => {
     *     console.log('Document setTtl() successful');
     *   })
     *   .catch((error) => {
     *     console.error('Document setTtl() failed', error);
     *   });
     * ```
     */
  }, {
    key: "setTtl",
    value: function() {
      var n = Ge.default(/* @__PURE__ */ de.default.mark(function a(s) {
        return de.default.wrap(function(u) {
          for (; ; )
            switch (u.prev = u.next) {
              case 0:
                return this.ensureNotClosed(), u.abrupt("return", this.syncDocumentImpl.setTtl(s));
              case 2:
              case "end":
                return u.stop();
            }
        }, a, this);
      }));
      function i(a) {
        return n.apply(this, arguments);
      }
      return i;
    }()
    /**
     * Delete a document.
     * @return A promise which resolves if (and only if) the document is ultimately deleted.
     * @example
     * ```typescript
     * document.removeDocument()
     *   .then(() => {
     *     console.log('Document removeDocument() successful');
     *   })
     *   .catch((error) => {
     *     console.error('Document removeDocument() failed', error);
     *   });
     * ```
     */
  }, {
    key: "removeDocument",
    value: function() {
      var n = Ge.default(/* @__PURE__ */ de.default.mark(function a() {
        return de.default.wrap(function(o) {
          for (; ; )
            switch (o.prev = o.next) {
              case 0:
                return this.ensureNotClosed(), o.abrupt("return", this.syncDocumentImpl.removeDocument());
              case 2:
              case "end":
                return o.stop();
            }
        }, a, this);
      }));
      function i() {
        return n.apply(this, arguments);
      }
      return i;
    }()
    /**
     * Conclude work with the document instance and remove all event listeners attached to it.
     * Any subsequent operation on this object will be rejected with error.
     * Other local copies of this document will continue operating and receiving events normally.
     * @example
     * ```typescript
     * document.close();
     * ```
     */
  }, {
    key: "close",
    value: function() {
      Pl.default(Dr.default(r.prototype), "close", this).call(this), this.syncDocumentImpl.detach(this.listenerUuid);
    }
  }], [{
    key: "type",
    get: function() {
      return dg.type;
    }
  }]), r;
}(Ll);
nr.default(oi, "removed", "removed");
nr.default(oi, "updated", "updated");
Mt([Le.validateTypesAsync(Le.pureObject, ["undefined", Le.objectSchema("document metadata", {
  ttl: [Le.nonNegativeInteger, "undefined"]
})]), Ye("design:type", Function), Ye("design:paramtypes", [Object, Object]), Ye("design:returntype", Promise)], oi.prototype, "set", null);
Mt([Le.validateTypesAsync("function", ["undefined", Le.objectSchema("document metadata", {
  ttl: [Le.nonNegativeInteger, "undefined"]
})]), Ye("design:type", Function), Ye("design:paramtypes", [Function, Object]), Ye("design:returntype", Promise)], oi.prototype, "mutate", null);
Mt([Le.validateTypesAsync(Le.pureObject, ["undefined", Le.objectSchema("document metadata", {
  ttl: [Le.nonNegativeInteger, "undefined"]
})]), Ye("design:type", Function), Ye("design:paramtypes", [Object, Object]), Ye("design:returntype", Promise)], oi.prototype, "update", null);
Mt([Le.validateTypesAsync(Le.nonNegativeInteger), Ye("design:type", Function), Ye("design:paramtypes", [Number]), Ye("design:returntype", Promise)], oi.prototype, "setTtl", null);
var cg = /* @__PURE__ */ function() {
  function e(t) {
    Zt.default(this, e), this.descriptor = t;
  }
  return Jt.default(e, [{
    key: "uri",
    get: function() {
      return this.descriptor.uri;
    }
  }, {
    key: "revision",
    get: function() {
      return this.descriptor.revision;
    }
  }, {
    key: "lastEventId",
    get: function() {
      return this.descriptor.lastEventId;
    }
    /**
     * Date when the list item was last updated.
     */
  }, {
    key: "dateUpdated",
    get: function() {
      return this.descriptor.dateUpdated;
    }
  }, {
    key: "dateExpires",
    get: function() {
      return this.descriptor.dateExpires;
    }
    /**
     * The index, within the containing list, of this item. This index is stable;
     * even if lower-indexed items are removed, this index will remain as is.
     */
  }, {
    key: "index",
    get: function() {
      return this.descriptor.index;
    }
    /**
     * The contents of the item.
     */
  }, {
    key: "data",
    get: function() {
      return this.descriptor.data;
    }
    /**
     * @internal
     */
  }, {
    key: "update",
    value: function(r, n, i, a) {
      return this.descriptor.lastEventId = r, this.descriptor.revision = n, this.descriptor.data = i, this.descriptor.dateUpdated = a, this;
    }
    /**
     * @internal
     */
  }, {
    key: "updateDateExpires",
    value: function(r) {
      this.descriptor.dateExpires = r;
    }
  }]), e;
}(), HV = /* @__PURE__ */ function() {
  function e(t, r, n, i) {
    Zt.default(this, e), this.prevToken = n, this.nextToken = i, this.items = t, this.source = r;
  }
  return Jt.default(e, [{
    key: "hasNextPage",
    get: function() {
      return !!this.nextToken;
    }
    /**
     * Indicates the existence of the previous page.
     */
  }, {
    key: "hasPrevPage",
    get: function() {
      return !!this.prevToken;
    }
    /**
     * Request next page.
     * Does not modify existing object.
     */
  }, {
    key: "nextPage",
    value: function() {
      var t = Ge.default(/* @__PURE__ */ de.default.mark(function n() {
        return de.default.wrap(function(a) {
          for (; ; )
            switch (a.prev = a.next) {
              case 0:
                if (this.hasNextPage) {
                  a.next = 2;
                  break;
                }
                throw new Error("No next page");
              case 2:
                return a.abrupt("return", this.source(this.nextToken));
              case 3:
              case "end":
                return a.stop();
            }
        }, n, this);
      }));
      function r() {
        return t.apply(this, arguments);
      }
      return r;
    }()
    /**
     * Request previous page.
     * Does not modify existing object.
     */
  }, {
    key: "prevPage",
    value: function() {
      var t = Ge.default(/* @__PURE__ */ de.default.mark(function n() {
        return de.default.wrap(function(a) {
          for (; ; )
            switch (a.prev = a.next) {
              case 0:
                if (this.hasPrevPage) {
                  a.next = 2;
                  break;
                }
                throw new Error("No previous page");
              case 2:
                return a.abrupt("return", this.source(this.prevToken));
              case 3:
              case "end":
                return a.stop();
            }
        }, n, this);
      }));
      function r() {
        return t.apply(this, arguments);
      }
      return r;
    }()
  }]), e;
}();
function dne(e, t) {
  var r = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (!r) {
    if (Array.isArray(e) || (r = cne(e)) || t && e && typeof e.length == "number") {
      r && (e = r);
      var n = 0, i = function() {
      };
      return { s: i, n: function() {
        return n >= e.length ? { done: !0 } : { done: !1, value: e[n++] };
      }, e: function(f) {
        throw f;
      }, f: i };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  var a = !0, s = !1, o;
  return { s: function() {
    r = r.call(e);
  }, n: function() {
    var f = r.next();
    return a = f.done, f;
  }, e: function(f) {
    s = !0, o = f;
  }, f: function() {
    try {
      !a && r.return != null && r.return();
    } finally {
      if (s)
        throw o;
    }
  } };
}
function cne(e, t) {
  if (e) {
    if (typeof e == "string")
      return zk(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set")
      return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return zk(e, t);
  }
}
function zk(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
var pne = /* @__PURE__ */ function() {
  function e(t, r) {
    Zt.default(this, e), this.balanceFactor = 0, this.key = t, this.value = r, this.parent = null, this.left = null, this.right = null;
  }
  return Jt.default(e, [{
    key: "isRoot",
    get: function() {
      return this.parent === null;
    }
  }, {
    key: "isLeaf",
    get: function() {
      return this.left === null && this.right === null;
    }
  }, {
    key: "isLeftChild",
    get: function() {
      return this.parent.left === this;
    }
  }, {
    key: "update",
    value: function(r) {
      this.value = r;
    }
  }, {
    key: "replace",
    value: function(r, n) {
      r && (this.left === n ? this.left = n : this.right === n && (this.right = n));
    }
  }]), e;
}(), vne = /* @__PURE__ */ function() {
  function e(t, r) {
    Zt.default(this, e), this.isLessThan = t || function(n, i) {
      return n < i;
    }, this.isEqual = r || function(n, i) {
      return n === i;
    }, this.root = null, this.count = null;
  }
  return Jt.default(e, [{
    key: "size",
    get: function() {
      return this.count;
    }
  }, {
    key: "clear",
    value: function() {
      this.root = null, this.count = 0;
    }
  }, {
    key: "set",
    value: function(r, n) {
      var i = this.getNode(r);
      i ? i.update(n) : this.insert(r, n);
    }
  }, {
    key: "insert",
    value: function(r, n) {
      var i = new pne(r, n);
      if (this.count++, !this.root) {
        this.root = i;
        return;
      }
      for (var a = this.root; ; )
        if (this.isLessThan(r, a.key))
          if (a.left)
            a = a.left;
          else {
            a.left = i;
            break;
          }
        else if (a.right)
          a = a.right;
        else {
          a.right = i;
          break;
        }
      for (i.parent = a, a = i; a.parent; ) {
        var s = a.parent, o = s.balanceFactor;
        if (a.isLeftChild ? s.balanceFactor++ : s.balanceFactor--, Math.abs(s.balanceFactor) < Math.abs(o))
          break;
        if (s.balanceFactor < -1 || s.balanceFactor > 1) {
          this.rebalance(s);
          break;
        }
        a = s;
      }
    }
  }, {
    key: "get",
    value: function(r) {
      for (var n = this.root; n; ) {
        if (this.isEqual(r, n.key))
          return n.value;
        this.isLessThan(r, n.key) ? n = n.left : n = n.right;
      }
      return null;
    }
  }, {
    key: "delete",
    value: function(r) {
      var n = this.getNode(r);
      if (!n || n.key !== r)
        return null;
      var i = n.parent, a = n.left, s = n.right;
      if (!!a != !!s) {
        var o = a || s;
        !i && !o ? this.root = null : i && !o ? this.root = o : (i.replace(n, null), this.rebalance(i));
      } else {
        for (var u = n.left; u.right; )
          u = u.right;
        if (n.left === u)
          n.isRoot ? (this.root = u, u.parent = null) : (n.isLeftChild ? n.parent.left = u : n.parent.right = u, u.parent = n.parent), u.right = n.right, u.right.parent = u, u.balanceFactor = n.balanceFactor, n = {
            parent: u,
            isLeftChild: !0
          };
        else {
          var f = u.parent, l = u.left;
          f.right = l, l && (l.parent = f), n.isRoot ? (this.root = u, u.parent = null) : (n.isLeftChild ? n.parent.left = u : n.parent.right = u, u.parent = n.parent), u.right = n.right, u.right.parent = u, u.left = n.left, u.left.parent = u, u.balanceFactor = n.balanceFactor, n = {
            parent: f,
            isLeftChild: !1
          };
        }
      }
      for (this.count--; n.parent; ) {
        var d = n.parent, c = d.balanceFactor;
        if (n.isLeftChild ? d.balanceFactor -= 1 : d.balanceFactor += 1, Math.abs(d.balanceFactor) > Math.abs(c))
          if (d.balanceFactor < -1 || d.balanceFactor > 1)
            if (this.rebalance(d), d.parent.balanceFactor === 0)
              n = d.parent;
            else
              break;
          else
            break;
        else
          n = d;
      }
      return null;
    }
  }, {
    key: "getNode",
    value: function(r) {
      for (var n = this.root; n; ) {
        if (this.isEqual(r, n.key))
          return n;
        this.isLessThan(r, n.key) ? n = n.left : n = n.right;
      }
      return null;
    }
  }, {
    key: "rebalance",
    value: function(r) {
      r.balanceFactor < 0 ? r.right.balanceFactor > 0 ? (this.rotateRight(r.right), this.rotateLeft(r)) : this.rotateLeft(r) : r.balanceFactor > 0 && (r.left.balanceFactor < 0 ? (this.rotateLeft(r.left), this.rotateRight(r)) : this.rotateRight(r));
    }
  }, {
    key: "rotateLeft",
    value: function(r) {
      var n = r.right;
      r.right = n.left, n.left !== null && (n.left.parent = r), n.parent = r.parent, n.parent === null ? this.root = n : r.isLeftChild ? n.parent.left = n : n.parent.right = n, n.left = r, r.parent = n, r.balanceFactor = r.balanceFactor + 1 - Math.min(n.balanceFactor, 0), n.balanceFactor = n.balanceFactor + 1 - Math.max(r.balanceFactor, 0);
    }
  }, {
    key: "rotateRight",
    value: function(r) {
      var n = r.left;
      r.left = n.right, n.right !== null && (n.right.parent = r), n.parent = r.parent, n.parent === null ? this.root = n : r.isLeftChild ? n.parent.left = n : n.parent.right = n, n.right = r, r.parent = n, r.balanceFactor = r.balanceFactor - 1 - Math.min(n.balanceFactor, 0), n.balanceFactor = n.balanceFactor - 1 - Math.max(r.balanceFactor, 0);
    }
  }, {
    key: Symbol.iterator,
    value: /* @__PURE__ */ de.default.mark(function t() {
      var r, n, i;
      return de.default.wrap(function(s) {
        for (; ; )
          switch (s.prev = s.next) {
            case 0:
              r = dne(this.getIterator()), s.prev = 1, r.s();
            case 3:
              if ((n = r.n()).done) {
                s.next = 9;
                break;
              }
              return i = n.value, s.next = 7, i;
            case 7:
              s.next = 3;
              break;
            case 9:
              s.next = 14;
              break;
            case 11:
              s.prev = 11, s.t0 = s.catch(1), r.e(s.t0);
            case 14:
              return s.prev = 14, r.f(), s.finish(14);
            case 17:
            case "end":
              return s.stop();
          }
      }, t, this, [[1, 11, 14, 17]]);
    })
  }, {
    key: "getIterator",
    value: /* @__PURE__ */ de.default.mark(function t() {
      var r, n, i, a = arguments;
      return de.default.wrap(function(o) {
        for (; ; )
          switch (o.prev = o.next) {
            case 0:
              r = a.length > 0 && a[0] !== void 0 ? a[0] : null, n = this.root;
            case 2:
              if (!n) {
                o.next = 8;
                break;
              }
              if (!(this.isEqual(r, n.key) || r === null && !n.left)) {
                o.next = 5;
                break;
              }
              return o.abrupt("break", 8);
            case 5:
              this.isLessThan(r, n.key) || r === null ? n = n.left : n = n.right, o.next = 2;
              break;
            case 8:
              if (n) {
                o.next = 10;
                break;
              }
              return o.abrupt("return", null);
            case 10:
              i = !0;
            case 11:
              if (!i) {
                o.next = 29;
                break;
              }
              return o.next = 14, [n.key, n.value];
            case 14:
              if (i = !1, !n.right) {
                o.next = 21;
                break;
              }
              for (n = n.right; n.left; )
                n = n.left;
              i = !0, o.next = 27;
              break;
            case 21:
              if (!n.parent) {
                o.next = 26;
                break;
              }
              i = n.parent.left === n, n = n.parent, o.next = 27;
              break;
            case 26:
              return o.abrupt("break", 37);
            case 27:
              o.next = 35;
              break;
            case 29:
              if (!n.parent) {
                o.next = 34;
                break;
              }
              i = n.parent.left === n, n = n.parent, o.next = 35;
              break;
            case 34:
              return o.abrupt("break", 37);
            case 35:
              o.next = 11;
              break;
            case 37:
              return o.abrupt("return", null);
            case 38:
            case "end":
              return o.stop();
          }
      }, t, this);
    })
  }, {
    key: "getReverseIterator",
    value: /* @__PURE__ */ de.default.mark(function t() {
      var r, n, i, a = arguments;
      return de.default.wrap(function(o) {
        for (; ; )
          switch (o.prev = o.next) {
            case 0:
              r = a.length > 0 && a[0] !== void 0 ? a[0] : null, n = this.root;
            case 2:
              if (!n) {
                o.next = 8;
                break;
              }
              if (!(this.isEqual(r, n.key) || r === null && !n.right)) {
                o.next = 5;
                break;
              }
              return o.abrupt("break", 8);
            case 5:
              !this.isLessThan(r, n.key) || r === null ? n = n.right : n = n.left, o.next = 2;
              break;
            case 8:
              if (n) {
                o.next = 10;
                break;
              }
              return o.abrupt("return", null);
            case 10:
              i = !0;
            case 11:
              if (!i) {
                o.next = 29;
                break;
              }
              return o.next = 14, [n.key, n.value];
            case 14:
              if (i = !1, !n.left) {
                o.next = 21;
                break;
              }
              for (n = n.left; n.right; )
                n = n.right;
              i = !0, o.next = 27;
              break;
            case 21:
              if (!n.parent) {
                o.next = 26;
                break;
              }
              i = n.parent.right === n, n = n.parent, o.next = 27;
              break;
            case 26:
              return o.abrupt("break", 37);
            case 27:
              o.next = 35;
              break;
            case 29:
              if (!n.parent) {
                o.next = 34;
                break;
              }
              i = n.parent.right === n, n = n.parent, o.next = 35;
              break;
            case 34:
              return o.abrupt("break", 37);
            case 35:
              o.next = 11;
              break;
            case 37:
              return o.abrupt("return", null);
            case 38:
            case "end":
              return o.stop();
          }
      }, t, this);
    })
  }]), e;
}();
function hne(e, t) {
  var r = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (!r) {
    if (Array.isArray(e) || (r = mne(e)) || t && e && typeof e.length == "number") {
      r && (e = r);
      var n = 0, i = function() {
      };
      return { s: i, n: function() {
        return n >= e.length ? { done: !0 } : { done: !1, value: e[n++] };
      }, e: function(f) {
        throw f;
      }, f: i };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  var a = !0, s = !1, o;
  return { s: function() {
    r = r.call(e);
  }, n: function() {
    var f = r.next();
    return a = f.done, f;
  }, e: function(f) {
    s = !0, o = f;
  }, f: function() {
    try {
      !a && r.return != null && r.return();
    } finally {
      if (s)
        throw o;
    }
  } };
}
function mne(e, t) {
  if (e) {
    if (typeof e == "string")
      return Gk(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set")
      return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return Gk(e, t);
  }
}
function Gk(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
var gne = /* @__PURE__ */ function() {
  function e(t, r) {
    Zt.default(this, e), this.value = t, this.revision = r || 0;
  }
  return Jt.default(e, [{
    key: "isValid",
    get: function() {
      return !0;
    }
  }]), e;
}(), yne = /* @__PURE__ */ function() {
  function e(t) {
    Zt.default(this, e), this.revision = t;
  }
  return Jt.default(e, [{
    key: "isValid",
    get: function() {
      return !1;
    }
  }]), e;
}(), _V = /* @__PURE__ */ function() {
  function e() {
    Zt.default(this, e), this.items = new vne();
  }
  return Jt.default(e, [{
    key: "store",
    value: function(r, n, i) {
      var a = this.items.get(r);
      return a && a.revision > i ? a.isValid ? a.value : null : (this.items.set(r, new gne(n, i)), n);
    }
  }, {
    key: "delete",
    value: function(r, n) {
      var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1, a = this.items.get(r);
      (!a || a.revision < n || a && i === !0) && this.items.set(r, new yne(n));
    }
  }, {
    key: "isKnown",
    value: function(r, n) {
      var i = this.items.get(r);
      return i && i.revision >= n;
    }
  }, {
    key: "get",
    value: function(r) {
      var n = this.items.get(r);
      return n && n.isValid ? n.value : null;
    }
  }, {
    key: "has",
    value: function(r) {
      var n = this.items.get(r);
      return n && n.isValid;
    }
  }, {
    key: "forEach",
    value: function(r) {
      if (this.items) {
        var n = hne(this.items), i;
        try {
          for (n.s(); !(i = n.n()).done; ) {
            var a = j9.default(i.value, 2), s = a[0], o = a[1];
            o.isValid && r(s, o.value);
          }
        } catch (u) {
          n.e(u);
        } finally {
          n.f();
        }
      }
    }
  }]), e;
}();
function t4(e) {
  var t = Vne();
  return function() {
    var n = Dr.default(e), i;
    if (t) {
      var a = Dr.default(this).constructor;
      i = Reflect.construct(n, arguments, a);
    } else
      i = n.apply(this, arguments);
    return ys.default(this, i);
  };
}
function Vne() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
var pg = /* @__PURE__ */ function(e) {
  Cn.default(r, e);
  var t = t4(r);
  function r(n, i, a) {
    var s;
    Zt.default(this, r), s = t.call(this, n, a);
    var o = function(f, l) {
      return typeof l.ttl == "number" ? {
        ttl: l.ttl
      } : f;
    };
    return s.updateMergingQueue = new $9(o), s.cache = new _V(), s.descriptor = i, s.descriptor.date_updated = new Date(s.descriptor.date_updated), s;
  }
  return Jt.default(r, [{
    key: "uri",
    get: function() {
      return this.descriptor.url;
    }
  }, {
    key: "revision",
    get: function() {
      return this.descriptor.revision;
    }
  }, {
    key: "lastEventId",
    get: function() {
      return this.descriptor.last_event_id;
    }
  }, {
    key: "links",
    get: function() {
      return this.descriptor.links;
    }
  }, {
    key: "dateExpires",
    get: function() {
      return this.descriptor.date_expires;
    }
  }, {
    key: "type",
    get: function() {
      return "list";
    }
    // below properties are specific to Insights only
  }, {
    key: "indexName",
    get: function() {
    }
  }, {
    key: "queryString",
    get: function() {
    }
    // public props, documented along with class description
  }, {
    key: "sid",
    get: function() {
      return this.descriptor.sid;
    }
  }, {
    key: "uniqueName",
    get: function() {
      return this.descriptor.unique_name || null;
    }
  }, {
    key: "dateUpdated",
    get: function() {
      return this.descriptor.date_updated;
    }
  }, {
    key: "_addOrUpdateItemOnServer",
    value: function() {
      var n = Ge.default(/* @__PURE__ */ de.default.mark(function a(s, o, u, f) {
        var l, d;
        return de.default.wrap(function(p) {
          for (; ; )
            switch (p.prev = p.next) {
              case 0:
                return l = {
                  data: o
                }, f !== void 0 && (l.ttl = f), p.next = 4, this.services.network.post(s, l, u);
              case 4:
                return d = p.sent, d.body.data = o, d.body.date_updated = new Date(d.body.date_updated), p.abrupt("return", d.body);
              case 8:
              case "end":
                return p.stop();
            }
        }, a, this);
      }));
      function i(a, s, o, u) {
        return n.apply(this, arguments);
      }
      return i;
    }()
  }, {
    key: "push",
    value: function() {
      var n = Ge.default(/* @__PURE__ */ de.default.mark(function a(s, o) {
        var u, f, l;
        return de.default.wrap(function(c) {
          for (; ; )
            switch (c.prev = c.next) {
              case 0:
                return u = (o || {}).ttl, c.next = 3, this._addOrUpdateItemOnServer(this.links.items, s, void 0, u);
              case 3:
                return f = c.sent, l = Number(f.index), this._handleItemMutated(l, f.url, f.last_event_id, f.revision, s, f.date_updated, f.date_expires, !0, !1), c.abrupt("return", this.cache.get(l));
              case 7:
              case "end":
                return c.stop();
            }
        }, a, this);
      }));
      function i(a, s) {
        return n.apply(this, arguments);
      }
      return i;
    }()
  }, {
    key: "set",
    value: function() {
      var n = Ge.default(/* @__PURE__ */ de.default.mark(function a(s, o, u) {
        var f = this, l;
        return de.default.wrap(function(c) {
          for (; ; )
            switch (c.prev = c.next) {
              case 0:
                return l = u || {}, c.abrupt("return", this.updateMergingQueue.squashAndAdd(s, l, function(p) {
                  return f._updateItemUnconditionally(s, o, p.ttl);
                }));
              case 2:
              case "end":
                return c.stop();
            }
        }, a, this);
      }));
      function i(a, s, o) {
        return n.apply(this, arguments);
      }
      return i;
    }()
  }, {
    key: "_updateItemUnconditionally",
    value: function() {
      var n = Ge.default(/* @__PURE__ */ de.default.mark(function a(s, o, u) {
        var f, l;
        return de.default.wrap(function(c) {
          for (; ; )
            switch (c.prev = c.next) {
              case 0:
                return c.next = 2, this.get(s);
              case 2:
                return f = c.sent, c.next = 5, this._addOrUpdateItemOnServer(f.uri, o, void 0, u);
              case 5:
                return l = c.sent, this._handleItemMutated(s, l.url, l.last_event_id, l.revision, l.data, l.date_updated, l.date_expires, !1, !1), c.abrupt("return", this.cache.get(s));
              case 8:
              case "end":
                return c.stop();
            }
        }, a, this);
      }));
      function i(a, s, o) {
        return n.apply(this, arguments);
      }
      return i;
    }()
  }, {
    key: "_updateItemWithIfMatch",
    value: function() {
      var n = Ge.default(/* @__PURE__ */ de.default.mark(function a(s, o, u) {
        var f, l, d, c;
        return de.default.wrap(function(v) {
          for (; ; )
            switch (v.prev = v.next) {
              case 0:
                return v.next = 2, this.get(s);
              case 2:
                if (f = v.sent, l = o(Wi(f.data)), !l) {
                  v.next = 25;
                  break;
                }
                return d = f.revision, v.prev = 6, v.next = 9, this._addOrUpdateItemOnServer(f.uri, l, d, u);
              case 9:
                return c = v.sent, this._handleItemMutated(s, c.url, c.last_event_id, c.revision, c.data, c.date_updated, c.date_expires, !1, !1), v.abrupt("return", this.cache.get(s));
              case 14:
                if (v.prev = 14, v.t0 = v.catch(6), v.t0.status !== 412) {
                  v.next = 22;
                  break;
                }
                return v.next = 19, this._getItemFromServer(s);
              case 19:
                return v.abrupt("return", this._updateItemWithIfMatch(s, o, u));
              case 22:
                throw v.t0;
              case 23:
                v.next = 26;
                break;
              case 25:
                return v.abrupt("return", f);
              case 26:
              case "end":
                return v.stop();
            }
        }, a, this, [[6, 14]]);
      }));
      function i(a, s, o) {
        return n.apply(this, arguments);
      }
      return i;
    }()
  }, {
    key: "mutate",
    value: function() {
      var n = Ge.default(/* @__PURE__ */ de.default.mark(function a(s, o, u) {
        var f = this, l;
        return de.default.wrap(function(c) {
          for (; ; )
            switch (c.prev = c.next) {
              case 0:
                return l = u || {}, c.abrupt("return", this.updateMergingQueue.add(s, l, function(p) {
                  return f._updateItemWithIfMatch(s, o, p.ttl);
                }));
              case 2:
              case "end":
                return c.stop();
            }
        }, a, this);
      }));
      function i(a, s, o) {
        return n.apply(this, arguments);
      }
      return i;
    }()
  }, {
    key: "update",
    value: function() {
      var n = Ge.default(/* @__PURE__ */ de.default.mark(function a(s, o, u) {
        return de.default.wrap(function(l) {
          for (; ; )
            switch (l.prev = l.next) {
              case 0:
                return l.abrupt("return", this.mutate(s, function(d) {
                  return Object.assign(d, o);
                }, u));
              case 1:
              case "end":
                return l.stop();
            }
        }, a, this);
      }));
      function i(a, s, o) {
        return n.apply(this, arguments);
      }
      return i;
    }()
  }, {
    key: "remove",
    value: function() {
      var n = Ge.default(/* @__PURE__ */ de.default.mark(function a(s) {
        var o, u, f;
        return de.default.wrap(function(d) {
          for (; ; )
            switch (d.prev = d.next) {
              case 0:
                return d.next = 2, this.get(s);
              case 2:
                return o = d.sent, u = Wi(o.data), d.next = 6, this.services.network.delete(o.uri);
              case 6:
                f = d.sent, this._handleItemRemoved(s, f.body.last_event_id, u, new Date(f.body.date_updated), !1);
              case 8:
              case "end":
                return d.stop();
            }
        }, a, this);
      }));
      function i(a) {
        return n.apply(this, arguments);
      }
      return i;
    }()
  }, {
    key: "get",
    value: function() {
      var n = Ge.default(/* @__PURE__ */ de.default.mark(function a(s) {
        var o;
        return de.default.wrap(function(f) {
          for (; ; )
            switch (f.prev = f.next) {
              case 0:
                if (o = this.cache.get(s), !o) {
                  f.next = 5;
                  break;
                }
                return f.abrupt("return", o);
              case 5:
                return f.abrupt("return", this._getItemFromServer(s));
              case 6:
              case "end":
                return f.stop();
            }
        }, a, this);
      }));
      function i(a) {
        return n.apply(this, arguments);
      }
      return i;
    }()
  }, {
    key: "_getItemFromServer",
    value: function() {
      var n = Ge.default(/* @__PURE__ */ de.default.mark(function a(s) {
        var o;
        return de.default.wrap(function(f) {
          for (; ; )
            switch (f.prev = f.next) {
              case 0:
                return f.next = 2, this.queryItems({
                  index: s
                });
              case 2:
                if (o = f.sent, !(o.items.length < 1)) {
                  f.next = 7;
                  break;
                }
                throw new Rn("No item with index ".concat(s, " found"), 404, 54151);
              case 7:
                return f.abrupt("return", o.items[0]);
              case 8:
              case "end":
                return f.stop();
            }
        }, a, this);
      }));
      function i(a) {
        return n.apply(this, arguments);
      }
      return i;
    }()
    /**
     * Query items from the List
     * @private
     */
  }, {
    key: "queryItems",
    value: function() {
      var n = Ge.default(/* @__PURE__ */ de.default.mark(function a(s) {
        var o = this, u, f, l, d;
        return de.default.wrap(function(p) {
          for (; ; )
            switch (p.prev = p.next) {
              case 0:
                return s = s || {}, u = new cu(this.links.items).queryParam("From", s.from).queryParam("PageSize", s.limit).queryParam("Index", s.index).queryParam("PageToken", s.pageToken).queryParam("Order", s.order).build(), p.next = 4, this.services.network.get(u);
              case 4:
                return f = p.sent, l = f.body.items.map(function(v) {
                  v.date_updated = new Date(v.date_updated);
                  var h = o.cache.get(v.index);
                  return h ? o._handleItemMutated(v.index, v.url, v.last_event_id, v.revision, v.data, v.date_updated, v.date_expires, !1, !0) : o.cache.store(Number(v.index), new cg({
                    index: Number(v.index),
                    uri: v.url,
                    revision: v.revision,
                    lastEventId: v.last_event_id,
                    dateUpdated: v.date_updated,
                    dateExpires: v.date_expires,
                    data: v.data
                  }), v.last_event_id), o.cache.get(v.index);
                }), d = f.body.meta, p.abrupt("return", new HV(l, function(v) {
                  return o.queryItems({
                    pageToken: v
                  });
                }, d.previous_token, d.next_token));
              case 8:
              case "end":
                return p.stop();
            }
        }, a, this);
      }));
      function i(a) {
        return n.apply(this, arguments);
      }
      return i;
    }()
  }, {
    key: "getItems",
    value: function() {
      var n = Ge.default(/* @__PURE__ */ de.default.mark(function a(s) {
        return de.default.wrap(function(u) {
          for (; ; )
            switch (u.prev = u.next) {
              case 0:
                return s = s || {}, H9(s.pageSize), s.limit = s.pageSize || s.limit || 50, s.order = s.order || "asc", u.abrupt("return", this.queryItems(s));
              case 5:
              case "end":
                return u.stop();
            }
        }, a, this);
      }));
      function i(a) {
        return n.apply(this, arguments);
      }
      return i;
    }()
    /**
     * @return {Promise<Object>} Context of List
     * @private
     */
  }, {
    key: "getContext",
    value: function() {
      var n = Ge.default(/* @__PURE__ */ de.default.mark(function a() {
        var s;
        return de.default.wrap(function(u) {
          for (; ; )
            switch (u.prev = u.next) {
              case 0:
                if (this.context) {
                  u.next = 5;
                  break;
                }
                return u.next = 3, this.services.network.get(this.links.context);
              case 3:
                s = u.sent, this._updateContextIfRequired(s.body.data, s.body.last_event_id);
              case 5:
                return u.abrupt("return", this.context);
              case 6:
              case "end":
                return u.stop();
            }
        }, a, this);
      }));
      function i() {
        return n.apply(this, arguments);
      }
      return i;
    }()
  }, {
    key: "setTtl",
    value: function() {
      var n = Ge.default(/* @__PURE__ */ de.default.mark(function a(s) {
        var o, u;
        return de.default.wrap(function(l) {
          for (; ; )
            switch (l.prev = l.next) {
              case 0:
                return l.prev = 0, o = {
                  ttl: s
                }, l.next = 4, this.services.network.post(this.uri, o);
              case 4:
                u = l.sent, this.descriptor.date_expires = u.body.date_expires, l.next = 12;
                break;
              case 8:
                throw l.prev = 8, l.t0 = l.catch(0), l.t0.status === 404 && this.onRemoved(!1), l.t0;
              case 12:
              case "end":
                return l.stop();
            }
        }, a, this, [[0, 8]]);
      }));
      function i(a) {
        return n.apply(this, arguments);
      }
      return i;
    }()
  }, {
    key: "setItemTtl",
    value: function() {
      var n = Ge.default(/* @__PURE__ */ de.default.mark(function a(s, o) {
        var u, f, l;
        return de.default.wrap(function(c) {
          for (; ; )
            switch (c.prev = c.next) {
              case 0:
                return c.next = 2, this.get(s);
              case 2:
                return u = c.sent, f = {
                  ttl: o
                }, c.next = 6, this.services.network.post(u.uri, f);
              case 6:
                l = c.sent, u.updateDateExpires(l.body.date_expires);
              case 8:
              case "end":
                return c.stop();
            }
        }, a, this);
      }));
      function i(a, s) {
        return n.apply(this, arguments);
      }
      return i;
    }()
  }, {
    key: "removeList",
    value: function() {
      var n = Ge.default(/* @__PURE__ */ de.default.mark(function a() {
        return de.default.wrap(function(o) {
          for (; ; )
            switch (o.prev = o.next) {
              case 0:
                return o.next = 2, this.services.network.delete(this.uri);
              case 2:
                this.onRemoved(!0);
              case 3:
              case "end":
                return o.stop();
            }
        }, a, this);
      }));
      function i() {
        return n.apply(this, arguments);
      }
      return i;
    }()
  }, {
    key: "onRemoved",
    value: function(i) {
      this._unsubscribe(), this.removalHandler(this.type, this.sid, this.uniqueName), this.broadcastEventToListeners("removed", {
        isLocal: i
      });
    }
  }, {
    key: "shouldIgnoreEvent",
    value: function(i, a) {
      return this.cache.isKnown(i, a);
    }
    /**
     * Handle update, which came from the server.
     * @private
     */
  }, {
    key: "_update",
    value: function(i, a) {
      var s = Number(i.item_index);
      switch (i.date_created = new Date(i.date_created), i.type) {
        case "list_item_added":
        case "list_item_updated":
          this._handleItemMutated(
            s,
            i.item_url,
            i.id,
            i.item_revision,
            i.item_data,
            i.date_created,
            void 0,
            // orchestration does not include date_expires  -- @todo  it does now?
            i.type === "list_item_added",
            !0
          );
          break;
        case "list_item_removed":
          this._handleItemRemoved(s, i.id, i.item_data, i.date_created, !0);
          break;
        case "list_context_updated":
          this._handleContextUpdate(i.context_data, i.id, i.date_created);
          break;
        case "list_removed":
          this.onRemoved(!1);
          break;
      }
      a && this._advanceLastEventId(i.id, i.list_revision);
    }
  }, {
    key: "_advanceLastEventId",
    value: function(i, a) {
      this.lastEventId < i && (this.descriptor.last_event_id = i, a && (this.descriptor.revision = a));
    }
  }, {
    key: "_updateRootDateUpdated",
    value: function(i) {
      (!this.descriptor.date_updated || i.getTime() > this.descriptor.date_updated.getTime()) && (this.descriptor.date_updated = i, this.services.storage.update(this.type, this.sid, this.uniqueName, {
        date_updated: i
      }));
    }
  }, {
    key: "_handleItemMutated",
    value: function(i, a, s, o, u, f, l, d, c) {
      if (this.shouldIgnoreEvent(i, s)) {
        jt.trace("Item ".concat(i, " update skipped, current: ").concat(this.lastEventId, ", remote: ").concat(s));
        return;
      }
      this._updateRootDateUpdated(f);
      var p = this.cache.get(i);
      if (!p) {
        var v = new cg({
          index: i,
          uri: a,
          lastEventId: s,
          revision: o,
          data: u,
          dateUpdated: f,
          dateExpires: l
        });
        this.cache.store(i, v, s), this.emitItemMutationEvent(v, c, d);
        return;
      }
      var h = Wi(p.data);
      p.update(s, o, u, f), this.cache.store(i, p, s), l !== void 0 && p.updateDateExpires(l), this.emitItemMutationEvent(p, c, !1, h);
    }
    /**
     * @private
     */
  }, {
    key: "emitItemMutationEvent",
    value: function(i, a, s) {
      var o = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null, u = s ? "itemAdded" : "itemUpdated", f = {
        item: i,
        isLocal: !a
      };
      s || (f.previousItemData = o), this.broadcastEventToListeners(u, f);
    }
    /**
     * @private
     */
  }, {
    key: "_handleItemRemoved",
    value: function(i, a, s, o, u) {
      this._updateRootDateUpdated(o), this.cache.delete(i, a), this.broadcastEventToListeners("itemRemoved", {
        index: i,
        isLocal: !u,
        previousItemData: s
      });
    }
    /**
     * @private
     */
  }, {
    key: "_handleContextUpdate",
    value: function(i, a, s) {
      this._updateRootDateUpdated(s), this._updateContextIfRequired(i, a) && this.broadcastEventToListeners("contextUpdated", {
        context: i,
        isLocal: !1
      });
    }
    /**
     * @private
     */
  }, {
    key: "_updateContextIfRequired",
    value: function(i, a) {
      return !this.contextEventId || a > this.contextEventId ? (this.context = i, this.contextEventId = a, !0) : (jt.trace("Context update skipped, current:", this.lastEventId, ", remote:", a), !1);
    }
  }], [{
    key: "type",
    get: function() {
      return "list";
    }
  }]), r;
}(Dl), jr = /* @__PURE__ */ function(e) {
  Cn.default(r, e);
  var t = t4(r);
  function r(n) {
    var i;
    return Zt.default(this, r), i = t.call(this), i.syncListImpl = n, i.syncListImpl.attach(Zi.default(i)), i;
  }
  return Jt.default(r, [{
    key: "uri",
    get: (
      // private props
      function() {
        return this.syncListImpl.uri;
      }
    )
  }, {
    key: "revision",
    get: function() {
      return this.syncListImpl.revision;
    }
  }, {
    key: "lastEventId",
    get: function() {
      return this.syncListImpl.lastEventId;
    }
  }, {
    key: "links",
    get: function() {
      return this.syncListImpl.links;
    }
  }, {
    key: "dateExpires",
    get: function() {
      return this.syncListImpl.dateExpires;
    }
  }, {
    key: "type",
    get: function() {
      return pg.type;
    }
    /**
     * Unique ID of the list, immutable identifier assigned by the system.
     */
  }, {
    key: "sid",
    get: function() {
      return this.syncListImpl.sid;
    }
    /**
     * Unique name of the list, immutable identifier that can be assigned to the list during creation.
     */
  }, {
    key: "uniqueName",
    get: function() {
      return this.syncListImpl.uniqueName;
    }
    /**
     * Date when the list was last updated, given in UTC ISO 8601 format (e.g., '2018-04-26T15:23:19.732Z').
     */
  }, {
    key: "dateUpdated",
    get: function() {
      return this.syncListImpl.dateUpdated;
    }
  }, {
    key: "push",
    value: (
      /**
       * Add a new item to the list.
       * @param data Data to be added.
       * @param itemMetadata Item metadata.
       * @return The newly added item.
       * @example
       * ```typescript
       * list.push({ name: 'John Smith' }, { ttl: 86400 })
       *   .then((item) => {
       *     console.log(`List Item push() successful, item index: ${item.index}, data:`, item.data)
       *   })
       *   .catch((error) => {
       *     console.error('List Item push() failed', error);
       *   });
       * ```
       */
      function() {
        var n = Ge.default(/* @__PURE__ */ de.default.mark(function a(s, o) {
          return de.default.wrap(function(f) {
            for (; ; )
              switch (f.prev = f.next) {
                case 0:
                  return this.ensureNotClosed(), f.abrupt("return", this.syncListImpl.push(s, o));
                case 2:
                case "end":
                  return f.stop();
              }
          }, a, this);
        }));
        function i(a, s) {
          return n.apply(this, arguments);
        }
        return i;
      }()
    )
    /**
     * Assign new data to an existing item, given its index.
     * @param index Index of the item to be updated.
     * @param value New data to be assigned to an item.
     * @param itemMetadataUpdates New item metadata.
     * @return A promise with the updated item containing latest known data.
     * The promise will be rejected if the item does not exist.
     * @example
     * ```typescript
     * list.set(42, { name: 'John Smith' }, { ttl: 86400 })
     *   .then((item) => {
     *     console.log('List Item set() successful, item data:', item.data)
     *   })
     *   .catch((error) => {
     *     console.error('List Item set() failed', error);
     *   });
     * ```
     */
  }, {
    key: "set",
    value: function() {
      var n = Ge.default(/* @__PURE__ */ de.default.mark(function a(s, o, u) {
        return de.default.wrap(function(l) {
          for (; ; )
            switch (l.prev = l.next) {
              case 0:
                return this.ensureNotClosed(), l.abrupt("return", this.syncListImpl.set(s, o, u));
              case 2:
              case "end":
                return l.stop();
            }
        }, a, this);
      }));
      function i(a, s, o) {
        return n.apply(this, arguments);
      }
      return i;
    }()
    /**
     * Modify an existing item by applying a mutation function to it.
     * @param index Index of the item to be changed.
     * @param mutator A function that outputs a new data based on the existing data.
     * @param itemMetadataUpdates New item metadata.
     * @return Resolves with the most recent item state, the output of a successful
     * mutation or a state that prompted graceful cancellation (mutator returned `null`). This promise
     * will be rejected if the indicated item does not already exist.
     * @example
     * ```typescript
     * const mutatorFunction = (currentValue) => {
     *     currentValue.viewCount = (currentValue.viewCount || 0) + 1;
     *     return currentValue;
     * };
     * list.mutate(42, mutatorFunction, { ttl: 86400 })
     *   .then((item) => {
     *     console.log('List Item mutate() successful, new data:', item.data)
     *   })
     *   .catch((error) => {
     *     console.error('List Item mutate() failed', error);
     *   });
     * ```
     */
  }, {
    key: "mutate",
    value: function() {
      var n = Ge.default(/* @__PURE__ */ de.default.mark(function a(s, o, u) {
        return de.default.wrap(function(l) {
          for (; ; )
            switch (l.prev = l.next) {
              case 0:
                return this.ensureNotClosed(), l.abrupt("return", this.syncListImpl.mutate(s, o, u));
              case 2:
              case "end":
                return l.stop();
            }
        }, a, this);
      }));
      function i(a, s, o) {
        return n.apply(this, arguments);
      }
      return i;
    }()
    /**
     * Modify an existing item by appending new fields (or overwriting existing ones) with the values from the object.
     * This is equivalent to
     * ```typescript
     * list.mutate(42, (currentValue) => Object.assign(currentValue, obj));
     * ```
     * @param index Index of an item to be changed.
     * @param obj Set of fields to update.
     * @param itemMetadataUpdates New item metadata.
     * @return A promise with a modified item containing latest known data.
     * The promise will be rejected if the item was not found.
     * @example
     * ```typescript
     * // Say, the List Item (index: 42) data is `{ name: 'John Smith' }`
     * list.update(42, { age: 34 }, { ttl: 86400 })
     *   .then((item) => {
     *     // Now the List Item data is `{ name: 'John Smith', age: 34 }`
     *     console.log('List Item update() successful, new data:', item.data);
     *   })
     *   .catch((error) => {
     *     console.error('List Item update() failed', error);
     *   });
     * ```
     */
  }, {
    key: "update",
    value: function() {
      var n = Ge.default(/* @__PURE__ */ de.default.mark(function a(s, o, u) {
        return de.default.wrap(function(l) {
          for (; ; )
            switch (l.prev = l.next) {
              case 0:
                return this.ensureNotClosed(), l.abrupt("return", this.syncListImpl.update(s, o, u));
              case 2:
              case "end":
                return l.stop();
            }
        }, a, this);
      }));
      function i(a, s, o) {
        return n.apply(this, arguments);
      }
      return i;
    }()
    /**
     * Delete an item given its index.
     * @param index Index of the item to be removed.
     * @return A promise to remove the item.
     * The promise will be rejected if the item was not found.
     * @example
     * ```typescript
     * list.remove(42)
     *   .then(() => {
     *     console.log('List Item remove() successful');
     *   })
     *   .catch((error) => {
     *     console.error('List Item remove() failed', error);
     *   });
     * ```
     */
  }, {
    key: "remove",
    value: function() {
      var n = Ge.default(/* @__PURE__ */ de.default.mark(function a(s) {
        return de.default.wrap(function(u) {
          for (; ; )
            switch (u.prev = u.next) {
              case 0:
                return this.ensureNotClosed(), u.abrupt("return", this.syncListImpl.remove(s));
              case 2:
              case "end":
                return u.stop();
            }
        }, a, this);
      }));
      function i(a) {
        return n.apply(this, arguments);
      }
      return i;
    }()
    /**
     * Retrieve an item by List index.
     * @param index Item index in the list.
     * @return A promise with the item containing latest known data.
     * The promise will be rejected if the item was not found.
     * @example
     * ```typescript
     * list.get(42)
     *   .then((item) => {
     *     console.log('List Item get() successful, item data:', item.data)
     *   })
     *   .catch((error) => {
     *     console.error('List Item get() failed', error);
     *   });
     * ```
     */
  }, {
    key: "get",
    value: function() {
      var n = Ge.default(/* @__PURE__ */ de.default.mark(function a(s) {
        return de.default.wrap(function(u) {
          for (; ; )
            switch (u.prev = u.next) {
              case 0:
                return this.ensureNotClosed(), u.abrupt("return", this.syncListImpl.get(s));
              case 2:
              case "end":
                return u.stop();
            }
        }, a, this);
      }));
      function i(a) {
        return n.apply(this, arguments);
      }
      return i;
    }()
    /**
     * Retrieve a list context
     * @return A promise with the list's context
     * @internal
     */
  }, {
    key: "getContext",
    value: function() {
      var n = Ge.default(/* @__PURE__ */ de.default.mark(function a() {
        return de.default.wrap(function(o) {
          for (; ; )
            switch (o.prev = o.next) {
              case 0:
                return this.ensureNotClosed(), o.abrupt("return", this.syncListImpl.getContext());
              case 2:
              case "end":
                return o.stop();
            }
        }, a, this);
      }));
      function i() {
        return n.apply(this, arguments);
      }
      return i;
    }()
    /**
     * Query a list of items from collection.
     * Information about the query limits can be found {@link https://www.twilio.com/docs/sync/limits|here}.
     * @param queryOptions Query options.
     * @example
     * ```typescript
     * const pageHandler = (paginator) => {
     *   paginator.items.forEach((item) => {
     *     console.log(`Item ${item.index}:`, item.data);
     *   });
     *   return paginator.hasNextPage
     *     ? paginator.nextPage().then(pageHandler)
     *     : null;
     * };
     * list.getItems({ from: 0, order: 'asc' })
     *   .then(pageHandler)
     *   .catch((error) => {
     *     console.error('List getItems() failed', error);
     *   });
     * ```
     */
  }, {
    key: "getItems",
    value: function() {
      var n = Ge.default(/* @__PURE__ */ de.default.mark(function a(s) {
        return de.default.wrap(function(u) {
          for (; ; )
            switch (u.prev = u.next) {
              case 0:
                return this.ensureNotClosed(), u.abrupt("return", this.syncListImpl.getItems(s));
              case 2:
              case "end":
                return u.stop();
            }
        }, a, this);
      }));
      function i(a) {
        return n.apply(this, arguments);
      }
      return i;
    }()
    /**
     * Update the time-to-live of the list.
     * @param ttl Specifies the TTL in seconds after which the list is subject to automatic deletion. The value 0 means infinity.
     * @return A promise that resolves after the TTL update was successful.
     * @example
     * ```typescript
     * list.setTtl(3600)
     *   .then(() => {
     *     console.log('List setTtl() successful');
     *   })
     *   .catch((error) => {
     *     console.error('List setTtl() failed', error);
     *   });
     * ```
     */
  }, {
    key: "setTtl",
    value: function() {
      var n = Ge.default(/* @__PURE__ */ de.default.mark(function a(s) {
        return de.default.wrap(function(u) {
          for (; ; )
            switch (u.prev = u.next) {
              case 0:
                return this.ensureNotClosed(), u.abrupt("return", this.syncListImpl.setTtl(s));
              case 2:
              case "end":
                return u.stop();
            }
        }, a, this);
      }));
      function i(a) {
        return n.apply(this, arguments);
      }
      return i;
    }()
    /**
     * Update the time-to-live of a list item.
     * @param index Item index.
     * @param ttl Specifies the TTL in seconds after which the list item is subject to automatic deletion. The value 0 means infinity.
     * @return A promise that resolves after the TTL update was successful.
     * @example
     * ```typescript
     * list.setItemTtl(42, 86400)
     *   .then(() => {
     *     console.log('List setItemTtl() successful');
     *   })
     *   .catch((error) => {
     *     console.error('List setItemTtl() failed', error);
     *   });
     * ```
     */
  }, {
    key: "setItemTtl",
    value: function() {
      var n = Ge.default(/* @__PURE__ */ de.default.mark(function a(s, o) {
        return de.default.wrap(function(f) {
          for (; ; )
            switch (f.prev = f.next) {
              case 0:
                return this.ensureNotClosed(), f.abrupt("return", this.syncListImpl.setItemTtl(s, o));
              case 2:
              case "end":
                return f.stop();
            }
        }, a, this);
      }));
      function i(a, s) {
        return n.apply(this, arguments);
      }
      return i;
    }()
    /**
     * Delete this list. It will be impossible to restore it.
     * @return A promise that resolves when the list has been deleted.
     * @example
     * list.removeList()
     *   .then(() => {
     *     console.log('List removeList() successful');
     *   })
     *   .catch((error) => {
     *     console.error('List removeList() failed', error);
     *   });
     */
  }, {
    key: "removeList",
    value: function() {
      var n = Ge.default(/* @__PURE__ */ de.default.mark(function a() {
        return de.default.wrap(function(o) {
          for (; ; )
            switch (o.prev = o.next) {
              case 0:
                return this.ensureNotClosed(), o.abrupt("return", this.syncListImpl.removeList());
              case 2:
              case "end":
                return o.stop();
            }
        }, a, this);
      }));
      function i() {
        return n.apply(this, arguments);
      }
      return i;
    }()
    /**
     * Conclude work with the list instance and remove all event listeners attached to it.
     * Any subsequent operation on this object will be rejected with error.
     * Other local copies of this list will continue operating and receiving events normally.
     * @example
     * ```typescript
     * list.close();
     * ```
     */
  }, {
    key: "close",
    value: function() {
      Pl.default(Dr.default(r.prototype), "close", this).call(this), this.syncListImpl.detach(this.listenerUuid);
    }
  }], [{
    key: "type",
    get: function() {
      return pg.type;
    }
  }]), r;
}(Ll);
nr.default(jr, "itemAdded", "itemAdded");
nr.default(jr, "itemUpdated", "itemUpdated");
nr.default(jr, "itemRemoved", "itemRemoved");
nr.default(jr, "removed", "removed");
Mt([Le.validateTypesAsync(Le.pureObject, ["undefined", Le.objectSchema("item metadata", {
  ttl: [Le.nonNegativeInteger, "undefined"]
})]), Ye("design:type", Function), Ye("design:paramtypes", [Object, Object]), Ye("design:returntype", Promise)], jr.prototype, "push", null);
Mt([Le.validateTypesAsync(Le.nonNegativeInteger, Le.pureObject, ["undefined", Le.objectSchema("item metadata", {
  ttl: [Le.nonNegativeInteger, "undefined"]
})]), Ye("design:type", Function), Ye("design:paramtypes", [Number, Object, Object]), Ye("design:returntype", Promise)], jr.prototype, "set", null);
Mt([Le.validateTypesAsync(Le.nonNegativeInteger, "function", ["undefined", Le.objectSchema("item metadata", {
  ttl: [Le.nonNegativeInteger, "undefined"]
})]), Ye("design:type", Function), Ye("design:paramtypes", [Number, Function, Object]), Ye("design:returntype", Promise)], jr.prototype, "mutate", null);
Mt([Le.validateTypesAsync(Le.nonNegativeInteger, Le.pureObject, ["undefined", Le.objectSchema("item metadata", {
  ttl: [Le.nonNegativeInteger, "undefined"]
})]), Ye("design:type", Function), Ye("design:paramtypes", [Number, Object, Object]), Ye("design:returntype", Promise)], jr.prototype, "update", null);
Mt([Le.validateTypesAsync(Le.nonNegativeInteger), Ye("design:type", Function), Ye("design:paramtypes", [Number]), Ye("design:returntype", Promise)], jr.prototype, "remove", null);
Mt([Le.validateTypesAsync(Le.nonNegativeInteger), Ye("design:type", Function), Ye("design:paramtypes", [Number]), Ye("design:returntype", Promise)], jr.prototype, "get", null);
Mt([Le.validateTypesAsync(["undefined", Le.objectSchema("query options", {
  from: [Le.nonNegativeInteger, "undefined"],
  pageSize: [Le.custom(function(e) {
    return [JV(e), "a positive integer"];
  }), "undefined"]
})]), Ye("design:type", Function), Ye("design:paramtypes", [Object]), Ye("design:returntype", Promise)], jr.prototype, "getItems", null);
Mt([Le.validateTypesAsync(Le.nonNegativeInteger), Ye("design:type", Function), Ye("design:paramtypes", [Number]), Ye("design:returntype", Promise)], jr.prototype, "setTtl", null);
Mt([Le.validateTypesAsync(Le.nonNegativeInteger, Le.nonNegativeInteger), Ye("design:type", Function), Ye("design:paramtypes", [Number, Number]), Ye("design:returntype", Promise)], jr.prototype, "setItemTtl", null);
var Kf = /* @__PURE__ */ function() {
  function e(t) {
    Zt.default(this, e), this.descriptor = t;
  }
  return Jt.default(e, [{
    key: "uri",
    get: function() {
      return this.descriptor.url;
    }
  }, {
    key: "revision",
    get: function() {
      return this.descriptor.revision;
    }
  }, {
    key: "lastEventId",
    get: function() {
      return this.descriptor.last_event_id;
    }
  }, {
    key: "dateExpires",
    get: function() {
      return this.descriptor.date_expires;
    }
    /**
     * The identifier that maps to this item within the containing Map.
     */
  }, {
    key: "key",
    get: function() {
      return this.descriptor.key;
    }
    /**
     * The contents of the item.
     */
  }, {
    key: "data",
    get: function() {
      return this.descriptor.data;
    }
    /**
     * Date when the map item was last updated.
     */
  }, {
    key: "dateUpdated",
    get: function() {
      return this.descriptor.date_updated;
    }
    /**
     * @internal
     */
  }, {
    key: "update",
    value: function(r, n, i, a) {
      return this.descriptor.last_event_id = r, this.descriptor.revision = n, this.descriptor.data = i, this.descriptor.date_updated = a, this;
    }
    /**
     * @internal
     */
  }, {
    key: "updateDateExpires",
    value: function(r) {
      this.descriptor.date_expires = r;
    }
  }]), e;
}();
function r4(e) {
  var t = qne();
  return function() {
    var n = Dr.default(e), i;
    if (t) {
      var a = Dr.default(this).constructor;
      i = Reflect.construct(n, arguments, a);
    } else
      i = n.apply(this, arguments);
    return ys.default(this, i);
  };
}
function qne() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
var vg = /* @__PURE__ */ function(e) {
  Cn.default(r, e);
  var t = r4(r);
  function r(n, i, a) {
    var s;
    Zt.default(this, r), s = t.call(this, n, a);
    var o = function(f, l) {
      return typeof l.ttl == "number" ? {
        ttl: l.ttl
      } : f;
    };
    return s.updateMergingQueue = new $9(o), s.cache = new _V(), s.descriptor = i, s.descriptor.date_updated = new Date(s.descriptor.date_updated), i.items && i.items.forEach(function(u) {
      u.date_updated = new Date(u.date_updated), s.cache.store(u.key, new Kf(u), u.last_event_id);
    }), s;
  }
  return Jt.default(r, [{
    key: "uri",
    get: function() {
      return this.descriptor.url;
    }
  }, {
    key: "links",
    get: function() {
      return this.descriptor.links;
    }
  }, {
    key: "revision",
    get: function() {
      return this.descriptor.revision;
    }
  }, {
    key: "lastEventId",
    get: function() {
      return this.descriptor.last_event_id;
    }
  }, {
    key: "dateExpires",
    get: function() {
      return this.descriptor.date_expires;
    }
  }, {
    key: "type",
    get: function() {
      return "map";
    }
    // below properties are specific to Insights only
  }, {
    key: "indexName",
    get: function() {
    }
  }, {
    key: "queryString",
    get: function() {
    }
    // public props, documented along with class description
  }, {
    key: "sid",
    get: function() {
      return this.descriptor.sid;
    }
  }, {
    key: "uniqueName",
    get: function() {
      return this.descriptor.unique_name || null;
    }
  }, {
    key: "dateUpdated",
    get: function() {
      return this.descriptor.date_updated;
    }
  }, {
    key: "set",
    value: function() {
      var n = Ge.default(/* @__PURE__ */ de.default.mark(function a(s, o, u) {
        var f = this, l;
        return de.default.wrap(function(c) {
          for (; ; )
            switch (c.prev = c.next) {
              case 0:
                return l = u || {}, c.abrupt("return", this.updateMergingQueue.squashAndAdd(s, l, function(p) {
                  return f._putItemUnconditionally(s, o, p.ttl);
                }));
              case 2:
              case "end":
                return c.stop();
            }
        }, a, this);
      }));
      function i(a, s, o) {
        return n.apply(this, arguments);
      }
      return i;
    }()
  }, {
    key: "get",
    value: function() {
      var n = Ge.default(/* @__PURE__ */ de.default.mark(function a(s) {
        return de.default.wrap(function(u) {
          for (; ; )
            switch (u.prev = u.next) {
              case 0:
                if (s != null) {
                  u.next = 2;
                  break;
                }
                throw new Rn("SyncMapItem key may not be empty", 400, 54209);
              case 2:
                if (!this.cache.has(s)) {
                  u.next = 6;
                  break;
                }
                return u.abrupt("return", this.cache.get(s));
              case 6:
                return u.abrupt("return", this._getItemFromServer(s));
              case 7:
              case "end":
                return u.stop();
            }
        }, a, this);
      }));
      function i(a) {
        return n.apply(this, arguments);
      }
      return i;
    }()
  }, {
    key: "_getItemFromServer",
    value: function() {
      var n = Ge.default(/* @__PURE__ */ de.default.mark(function a(s) {
        var o;
        return de.default.wrap(function(f) {
          for (; ; )
            switch (f.prev = f.next) {
              case 0:
                return f.next = 2, this.queryItems({
                  key: s
                });
              case 2:
                if (o = f.sent, !(o.items.length < 1)) {
                  f.next = 7;
                  break;
                }
                throw new Rn("The specified Map Item does not exist", 404, 54201);
              case 7:
                return f.abrupt("return", o.items[0]);
              case 8:
              case "end":
                return f.stop();
            }
        }, a, this);
      }));
      function i(a) {
        return n.apply(this, arguments);
      }
      return i;
    }()
  }, {
    key: "mutate",
    value: function() {
      var n = Ge.default(/* @__PURE__ */ de.default.mark(function a(s, o, u) {
        var f = this, l;
        return de.default.wrap(function(c) {
          for (; ; )
            switch (c.prev = c.next) {
              case 0:
                return l = u || {}, c.abrupt("return", this.updateMergingQueue.add(s, l, function(p) {
                  return f._putItemWithIfMatch(s, o, p.ttl);
                }));
              case 2:
              case "end":
                return c.stop();
            }
        }, a, this);
      }));
      function i(a, s, o) {
        return n.apply(this, arguments);
      }
      return i;
    }()
  }, {
    key: "update",
    value: function() {
      var n = Ge.default(/* @__PURE__ */ de.default.mark(function a(s, o, u) {
        return de.default.wrap(function(l) {
          for (; ; )
            switch (l.prev = l.next) {
              case 0:
                return l.abrupt("return", this.mutate(s, function(d) {
                  return Object.assign(d, o);
                }, u));
              case 1:
              case "end":
                return l.stop();
            }
        }, a, this);
      }));
      function i(a, s, o) {
        return n.apply(this, arguments);
      }
      return i;
    }()
  }, {
    key: "_putItemUnconditionally",
    value: function() {
      var n = Ge.default(/* @__PURE__ */ de.default.mark(function a(s, o, u) {
        var f, l;
        return de.default.wrap(function(c) {
          for (; ; )
            switch (c.prev = c.next) {
              case 0:
                return c.next = 2, this._putItemToServer(s, o, void 0, u);
              case 2:
                return f = c.sent, l = f.item, this._handleItemMutated(l.key, l.url, l.last_event_id, l.revision, l.data, l.date_updated, l.date_expires, f.added, !1), c.abrupt("return", this.cache.get(l.key));
              case 6:
              case "end":
                return c.stop();
            }
        }, a, this);
      }));
      function i(a, s, o) {
        return n.apply(this, arguments);
      }
      return i;
    }()
  }, {
    key: "_putItemWithIfMatch",
    value: function() {
      var n = Ge.default(/* @__PURE__ */ de.default.mark(function a(s, o, u) {
        var f, l, d, c, p;
        return de.default.wrap(function(h) {
          for (; ; )
            switch (h.prev = h.next) {
              case 0:
                return h.next = 2, this.get(s).catch(function(m) {
                  if (m.status === 404)
                    return new Kf({
                      key: s,
                      data: {},
                      last_event_id: -1,
                      revision: "-1",
                      url: null,
                      date_updated: null,
                      date_expires: null
                    });
                  throw m;
                });
              case 2:
                if (f = h.sent, l = o(Wi(f.data)), !l) {
                  h.next = 26;
                  break;
                }
                return d = f.revision, h.prev = 6, h.next = 9, this._putItemToServer(s, l, d, u);
              case 9:
                return c = h.sent, p = c.item, this._handleItemMutated(p.key, p.url, p.last_event_id, p.revision, p.data, p.date_updated, p.date_expires, c.added, !1), h.abrupt("return", this.cache.get(p.key));
              case 15:
                if (h.prev = 15, h.t0 = h.catch(6), h.t0.status !== 412) {
                  h.next = 23;
                  break;
                }
                return h.next = 20, this._getItemFromServer(s);
              case 20:
                return h.abrupt("return", this._putItemWithIfMatch(s, o, u));
              case 23:
                throw h.t0;
              case 24:
                h.next = 27;
                break;
              case 26:
                return h.abrupt("return", f);
              case 27:
              case "end":
                return h.stop();
            }
        }, a, this, [[6, 15]]);
      }));
      function i(a, s, o) {
        return n.apply(this, arguments);
      }
      return i;
    }()
  }, {
    key: "_putItemToServer",
    value: function() {
      var n = Ge.default(/* @__PURE__ */ de.default.mark(function a(s, o, u, f) {
        var l, d, c, p, v;
        return de.default.wrap(function(m) {
          for (; ; )
            switch (m.prev = m.next) {
              case 0:
                return l = new cu(this.links.items).pathSegment(s).build(), d = {
                  data: o
                }, f !== void 0 && (d.ttl = f), m.prev = 3, m.next = 6, this.services.network.put(l, d, u);
              case 6:
                return c = m.sent, p = c.body, p.data = o, p.date_updated = new Date(p.date_updated), v = c.status.code === 201, m.abrupt("return", {
                  added: v,
                  item: p
                });
              case 14:
                throw m.prev = 14, m.t0 = m.catch(3), m.t0.status === 404 && this.onRemoved(!1), m.t0;
              case 18:
              case "end":
                return m.stop();
            }
        }, a, this, [[3, 14]]);
      }));
      function i(a, s, o, u) {
        return n.apply(this, arguments);
      }
      return i;
    }()
  }, {
    key: "remove",
    value: function() {
      var n = Ge.default(/* @__PURE__ */ de.default.mark(function a(s) {
        var o, u, f;
        return de.default.wrap(function(d) {
          for (; ; )
            switch (d.prev = d.next) {
              case 0:
                return d.next = 2, this.get(s);
              case 2:
                return o = d.sent, u = Wi(o.data), d.next = 6, this.services.network.delete(o.uri);
              case 6:
                f = d.sent, this._handleItemRemoved(s, f.body.last_event_id, u, new Date(f.body.date_updated), !1);
              case 8:
              case "end":
                return d.stop();
            }
        }, a, this);
      }));
      function i(a) {
        return n.apply(this, arguments);
      }
      return i;
    }()
    /**
     * @private
     */
  }, {
    key: "queryItems",
    value: function() {
      var n = Ge.default(/* @__PURE__ */ de.default.mark(function a(s) {
        var o = this, u, f, l, d;
        return de.default.wrap(function(p) {
          for (; ; )
            switch (p.prev = p.next) {
              case 0:
                return s = s || {}, u = new cu(this.links.items).queryParam("From", s.from).queryParam("PageSize", s.limit).queryParam("Key", s.key).queryParam("PageToken", s.pageToken).queryParam("Order", s.order).build(), p.next = 4, this.services.network.get(u);
              case 4:
                return f = p.sent, l = f.body.items.map(function(v) {
                  v.date_updated = new Date(v.date_updated);
                  var h = o.cache.get(v.key);
                  return h ? o._handleItemMutated(v.key, v.url, v.last_event_id, v.revision, v.data, v.date_updated, v.date_expires, !1, !0) : o.cache.store(v.key, new Kf(v), v.last_event_id), o.cache.get(v.key);
                }), d = f.body.meta, p.abrupt("return", new HV(l, function(v) {
                  return o.queryItems({
                    pageToken: v
                  });
                }, d.previous_token, d.next_token));
              case 8:
              case "end":
                return p.stop();
            }
        }, a, this);
      }));
      function i(a) {
        return n.apply(this, arguments);
      }
      return i;
    }()
  }, {
    key: "getItems",
    value: function() {
      var n = Ge.default(/* @__PURE__ */ de.default.mark(function a(s) {
        return de.default.wrap(function(u) {
          for (; ; )
            switch (u.prev = u.next) {
              case 0:
                return s = s || {}, H9(s.pageSize), s.limit = s.pageSize || s.limit || 50, s.order = s.order || "asc", u.abrupt("return", this.queryItems(s));
              case 5:
              case "end":
                return u.stop();
            }
        }, a, this);
      }));
      function i(a) {
        return n.apply(this, arguments);
      }
      return i;
    }()
  }, {
    key: "shouldIgnoreEvent",
    value: function(i, a) {
      return this.cache.isKnown(i, a);
    }
    /**
     * Handle update from the server
     * @private
     */
  }, {
    key: "_update",
    value: function(i, a) {
      switch (i.date_created = new Date(i.date_created), i.type) {
        case "map_item_added":
        case "map_item_updated":
          this._handleItemMutated(
            i.item_key,
            i.item_url,
            i.id,
            i.item_revision,
            i.item_data,
            i.date_created,
            void 0,
            // orchestration events do not include date_expires
            i.type === "map_item_added",
            !0
          );
          break;
        case "map_item_removed":
          this._handleItemRemoved(i.item_key, i.id, i.item_data, i.date_created, !0);
          break;
        case "map_removed":
          this.onRemoved(!1);
          break;
      }
      a && this._advanceLastEventId(i.id, i.map_revision);
    }
  }, {
    key: "_advanceLastEventId",
    value: function(i, a) {
      this.lastEventId < i && (this.descriptor.last_event_id = i, a && (this.descriptor.revision = a));
    }
  }, {
    key: "_updateRootDateUpdated",
    value: function(i) {
      (!this.descriptor.date_updated || i.getTime() > this.descriptor.date_updated.getTime()) && (this.descriptor.date_updated = i, this.services.storage.update(this.type, this.sid, this.uniqueName, {
        date_updated: i
      }));
    }
  }, {
    key: "_handleItemMutated",
    value: function(i, a, s, o, u, f, l, d, c) {
      if (this.shouldIgnoreEvent(i, s)) {
        jt.trace("SyncMapItem ", i, " update skipped, current:", this.lastEventId, ", remote:", s);
        return;
      }
      this._updateRootDateUpdated(f);
      var p = this.cache.get(i);
      if (!p) {
        var v = new Kf({
          key: i,
          url: a,
          last_event_id: s,
          revision: o,
          data: u,
          date_updated: f,
          date_expires: l
        });
        this.cache.store(i, v, s), this.emitItemMutationEvent(v, c, d);
        return;
      }
      var h = Wi(p.data);
      p.update(s, o, u, f), this.cache.store(i, p, s), l !== void 0 && p.updateDateExpires(l), this.emitItemMutationEvent(p, c, !1, h);
    }
  }, {
    key: "emitItemMutationEvent",
    value: function(i, a, s) {
      var o = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null, u = s ? "itemAdded" : "itemUpdated", f = {
        item: i,
        isLocal: !a
      };
      s || (f.previousItemData = o), this.broadcastEventToListeners(u, f);
    }
    /**
     * @private
     */
  }, {
    key: "_handleItemRemoved",
    value: function(i, a, s, o, u) {
      this._updateRootDateUpdated(o), this.cache.delete(i, a), this.broadcastEventToListeners("itemRemoved", {
        key: i,
        isLocal: !u,
        previousItemData: s
      });
    }
  }, {
    key: "onRemoved",
    value: function(i) {
      this._unsubscribe(), this.removalHandler(this.type, this.sid, this.uniqueName), this.broadcastEventToListeners("removed", {
        isLocal: i
      });
    }
  }, {
    key: "setTtl",
    value: function() {
      var n = Ge.default(/* @__PURE__ */ de.default.mark(function a(s) {
        var o, u;
        return de.default.wrap(function(l) {
          for (; ; )
            switch (l.prev = l.next) {
              case 0:
                return l.prev = 0, o = {
                  ttl: s
                }, l.next = 4, this.services.network.post(this.uri, o);
              case 4:
                u = l.sent, this.descriptor.date_expires = u.body.date_expires, l.next = 12;
                break;
              case 8:
                throw l.prev = 8, l.t0 = l.catch(0), l.t0.status === 404 && this.onRemoved(!1), l.t0;
              case 12:
              case "end":
                return l.stop();
            }
        }, a, this, [[0, 8]]);
      }));
      function i(a) {
        return n.apply(this, arguments);
      }
      return i;
    }()
  }, {
    key: "setItemTtl",
    value: function() {
      var n = Ge.default(/* @__PURE__ */ de.default.mark(function a(s, o) {
        var u, f, l;
        return de.default.wrap(function(c) {
          for (; ; )
            switch (c.prev = c.next) {
              case 0:
                return c.next = 2, this.get(s);
              case 2:
                return u = c.sent, f = {
                  ttl: o
                }, c.next = 6, this.services.network.post(u.uri, f);
              case 6:
                l = c.sent, u.updateDateExpires(l.body.date_expires);
              case 8:
              case "end":
                return c.stop();
            }
        }, a, this);
      }));
      function i(a, s) {
        return n.apply(this, arguments);
      }
      return i;
    }()
  }, {
    key: "removeMap",
    value: function() {
      var n = Ge.default(/* @__PURE__ */ de.default.mark(function a() {
        return de.default.wrap(function(o) {
          for (; ; )
            switch (o.prev = o.next) {
              case 0:
                return o.next = 2, this.services.network.delete(this.uri);
              case 2:
                this.onRemoved(!0);
              case 3:
              case "end":
                return o.stop();
            }
        }, a, this);
      }));
      function i() {
        return n.apply(this, arguments);
      }
      return i;
    }()
  }], [{
    key: "type",
    get: function() {
      return "map";
    }
  }]), r;
}(Dl), Hr = /* @__PURE__ */ function(e) {
  Cn.default(r, e);
  var t = r4(r);
  function r(n) {
    var i;
    return Zt.default(this, r), i = t.call(this), i.syncMapImpl = n, i.syncMapImpl.attach(Zi.default(i)), i;
  }
  return Jt.default(r, [{
    key: "uri",
    get: (
      // private props
      function() {
        return this.syncMapImpl.uri;
      }
    )
  }, {
    key: "links",
    get: function() {
      return this.syncMapImpl.links;
    }
  }, {
    key: "revision",
    get: function() {
      return this.syncMapImpl.revision;
    }
  }, {
    key: "lastEventId",
    get: function() {
      return this.syncMapImpl.lastEventId;
    }
  }, {
    key: "dateExpires",
    get: function() {
      return this.syncMapImpl.dateExpires;
    }
  }, {
    key: "type",
    get: function() {
      return vg.type;
    }
    /**
     * An immutable identifier (a SID) assigned by the system on creation.
     */
  }, {
    key: "sid",
    get: function() {
      return this.syncMapImpl.sid;
    }
    /**
     * An optional immutable identifier that may be assigned by the
     * programmer to this map on creation. Unique among other Maps.
     */
  }, {
    key: "uniqueName",
    get: function() {
      return this.syncMapImpl.uniqueName;
    }
    /**
     * Date when the map was last updated.
     */
  }, {
    key: "dateUpdated",
    get: function() {
      return this.syncMapImpl.dateUpdated;
    }
  }, {
    key: "set",
    value: (
      /**
       * Add a new item to the map with the given key-value pair. Overwrites any data that might already exist with that key.
       * @param key Unique item identifier.
       * @param data Data to be set.
       * @param itemMetadataUpdates New item metadata.
       * @return Newly added item, or modified one if already exists, with the latest known data.
       * @example
       * ```typescript
       * map.set('myKey', { name: 'John Smith' }, { ttl: 86400 })
       *   .then((item) => {
       *     console.log('Map SyncMapItem set() successful, item data:', item.data);
       *   })
       *   .catch((error) => {
       *     console.error('Map SyncMapItem set() failed', error);
       *   });
       * ```
       */
      function() {
        var n = Ge.default(/* @__PURE__ */ de.default.mark(function a(s, o, u) {
          return de.default.wrap(function(l) {
            for (; ; )
              switch (l.prev = l.next) {
                case 0:
                  return this.ensureNotClosed(), l.abrupt("return", this.syncMapImpl.set(s, o, u));
                case 2:
                case "end":
                  return l.stop();
              }
          }, a, this);
        }));
        function i(a, s, o) {
          return n.apply(this, arguments);
        }
        return i;
      }()
    )
    /**
     * Retrieve an item by key.
     * @param key Identifies the desired item.
     * @return A promise that resolves when the item has been fetched.
     * This promise will be rejected if item was not found.
     * @example
     * ```typescript
     * map.get('myKey')
     *   .then((item) => {
     *     console.log('Map SyncMapItem get() successful, item data:', item.data)
     *   })
     *   .catch((error) => {
     *     console.error('Map SyncMapItem get() failed', error);
     *   });
     * ```
     */
  }, {
    key: "get",
    value: function() {
      var n = Ge.default(/* @__PURE__ */ de.default.mark(function a(s) {
        return de.default.wrap(function(u) {
          for (; ; )
            switch (u.prev = u.next) {
              case 0:
                return this.ensureNotClosed(), u.abrupt("return", this.syncMapImpl.get(s));
              case 2:
              case "end":
                return u.stop();
            }
        }, a, this);
      }));
      function i(a) {
        return n.apply(this, arguments);
      }
      return i;
    }()
    /**
     * Schedules a modification to this Map SyncMapItem that will apply a mutation function.
     * If no SyncMapItem with the given key exists, it will first be created, having the default data (`{}`).
     * @param key Selects the map item to be mutated.
     * @param mutator A function that outputs a new data based on the existing data.
     * May be called multiple times, particularly if this Map SyncMapItem is modified concurrently by remote code.
     * If the mutation ultimately succeeds, the Map SyncMapItem will have made the particular transition described
     * by this function.
     * @param itemMetadataUpdates New item metadata.
     * @return Resolves with the most recent item state, the output of a successful
     * mutation or a state that prompted graceful cancellation (mutator returned `null`).
     * @example
     * ```typescript
     * const mutatorFunction = (currentData) => {
     *     currentData.viewCount = (currentData.viewCount || 0) + 1;
     *     return currentData;
     * };
     * map.mutate('myKey', mutatorFunction, { ttl: 86400 })
     *   .then((item) => {
     *     console.log('Map SyncMapItem mutate() successful, new data:', item.data)
     *   })
     *   .catch((error) => {
     *     console.error('Map SyncMapItem mutate() failed', error);
     *   });
     * ```
     */
  }, {
    key: "mutate",
    value: function() {
      var n = Ge.default(/* @__PURE__ */ de.default.mark(function a(s, o, u) {
        return de.default.wrap(function(l) {
          for (; ; )
            switch (l.prev = l.next) {
              case 0:
                return this.ensureNotClosed(), l.abrupt("return", this.syncMapImpl.mutate(s, o, u));
              case 2:
              case "end":
                return l.stop();
            }
        }, a, this);
      }));
      function i(a, s, o) {
        return n.apply(this, arguments);
      }
      return i;
    }()
    /**
     * Modify a map item by appending new fields (or by overwriting existing ones) with the values from
     * the provided Object. Creates a new item if no item by this key exists, copying all given fields and values
     * into it.
     * This is equivalent to
     * ```typescript
     * map.mutate('myKey', (currentData) => Object.assign(currentData, obj));
     * ```
     * @param key Selects the map item to update.
     * @param obj Specifies the particular (top-level) attributes that will receive new values.
     * @param itemMetadataUpdates New item metadata.
     * @return A promise resolving to the modified item in its new state.
     * @example
     * ```typescript
     * // Say, the Map SyncMapItem (key: `'myKey'`) data is `{ name: 'John Smith' }`
     * map.update('myKey', { age: 34 }, { ttl: 86400 })
     *   .then((item) => {
     *     // Now the Map SyncMapItem data is `{ name: 'John Smith', age: 34 }`
     *     console.log('Map SyncMapItem update() successful, new data:', item.data);
     *   })
     *   .catch((error) => {
     *     console.error('Map SyncMapItem update() failed', error);
     *   });
     * ```
     */
  }, {
    key: "update",
    value: function() {
      var n = Ge.default(/* @__PURE__ */ de.default.mark(function a(s, o, u) {
        return de.default.wrap(function(l) {
          for (; ; )
            switch (l.prev = l.next) {
              case 0:
                return this.ensureNotClosed(), l.abrupt("return", this.syncMapImpl.update(s, o, u));
              case 2:
              case "end":
                return l.stop();
            }
        }, a, this);
      }));
      function i(a, s, o) {
        return n.apply(this, arguments);
      }
      return i;
    }()
    /**
     * Delete an item, given its key.
     * @param key Selects the item to delete.
     * @return A promise to remove an item.
     * The promise will be rejected if 'key' is undefined or an item was not found.
     * @example
     * ```typescript
     * map.remove('myKey')
     *   .then(() => {
     *     console.log('Map SyncMapItem remove() successful');
     *   })
     *   .catch((error) => {
     *     console.error('Map SyncMapItem remove() failed', error);
     *   });
     * ```
     */
  }, {
    key: "remove",
    value: function() {
      var n = Ge.default(/* @__PURE__ */ de.default.mark(function a(s) {
        return de.default.wrap(function(u) {
          for (; ; )
            switch (u.prev = u.next) {
              case 0:
                return this.ensureNotClosed(), u.abrupt("return", this.syncMapImpl.remove(s));
              case 2:
              case "end":
                return u.stop();
            }
        }, a, this);
      }));
      function i(a) {
        return n.apply(this, arguments);
      }
      return i;
    }()
    /**
     * Get a complete list of items from the map.
     * Information about the query limits can be found [here](https://www.twilio.com/docs/sync/limits).
     * @param queryOptions Query options.
     * @example
     * ```typescript
     * const pageHandler = (paginator) => {
     *   paginator.items.forEach((item) => {
     *     console.log(`SyncMapItem ${item.key}: `, item.data);
     *   });
     *   return paginator.hasNextPage
     *     ? paginator.nextPage().then(pageHandler)
     *     : null;
     * };
     * map.getItems({ from: 'myKey', order: 'asc' })
     *   .then(pageHandler)
     *   .catch((error) => {
     *     console.error('Map getItems() failed', error);
     *   });
     * ```
     */
  }, {
    key: "getItems",
    value: function() {
      var n = Ge.default(/* @__PURE__ */ de.default.mark(function a(s) {
        return de.default.wrap(function(u) {
          for (; ; )
            switch (u.prev = u.next) {
              case 0:
                return this.ensureNotClosed(), u.abrupt("return", this.syncMapImpl.getItems(s));
              case 2:
              case "end":
                return u.stop();
            }
        }, a, this);
      }));
      function i(a) {
        return n.apply(this, arguments);
      }
      return i;
    }()
    /**
     * Update the time-to-live of the map.
     * @param ttl Specifies the TTL in seconds after which the map is subject to automatic deletion. The value 0 means infinity.
     * @return A promise that resolves after the TTL update was successful.
     * @example
     * ```typescript
     * map.setTtl(3600)
     *   .then(() => {
     *     console.log('Map setTtl() successful');
     *   })
     *   .catch((error) => {
     *     console.error('Map setTtl() failed', error);
     *   });
     * ```
     */
  }, {
    key: "setTtl",
    value: function() {
      var n = Ge.default(/* @__PURE__ */ de.default.mark(function a(s) {
        return de.default.wrap(function(u) {
          for (; ; )
            switch (u.prev = u.next) {
              case 0:
                return this.ensureNotClosed(), u.abrupt("return", this.syncMapImpl.setTtl(s));
              case 2:
              case "end":
                return u.stop();
            }
        }, a, this);
      }));
      function i(a) {
        return n.apply(this, arguments);
      }
      return i;
    }()
    /**
     * Update the time-to-live of a map item.
     * @param key SyncMapItem key.
     * @param ttl Specifies the TTL in seconds after which the map item is subject to automatic deletion. The value 0 means infinity.
     * @return A promise that resolves after the TTL update was successful.
     * @example
     * ```typescript
     * map.setItemTtl('myKey', 86400)
     *   .then(() => {
     *     console.log('Map setItemTtl() successful');
     *   })
     *   .catch((error) => {
     *     console.error('Map setItemTtl() failed', error);
     *   });
     * ```
     */
  }, {
    key: "setItemTtl",
    value: function() {
      var n = Ge.default(/* @__PURE__ */ de.default.mark(function a(s, o) {
        return de.default.wrap(function(f) {
          for (; ; )
            switch (f.prev = f.next) {
              case 0:
                return this.ensureNotClosed(), f.abrupt("return", this.syncMapImpl.setItemTtl(s, o));
              case 2:
              case "end":
                return f.stop();
            }
        }, a, this);
      }));
      function i(a, s) {
        return n.apply(this, arguments);
      }
      return i;
    }()
    /**
     * Delete this map. It will be impossible to restore it.
     * @return A promise that resolves when the map has been deleted.
     * @example
     * ```typescript
     * map.removeMap()
     *   .then(() => {
     *     console.log('Map removeMap() successful');
     *   })
     *   .catch((error) => {
     *     console.error('Map removeMap() failed', error);
     *   });
     * ```
     */
  }, {
    key: "removeMap",
    value: function() {
      var n = Ge.default(/* @__PURE__ */ de.default.mark(function a() {
        return de.default.wrap(function(o) {
          for (; ; )
            switch (o.prev = o.next) {
              case 0:
                return this.ensureNotClosed(), o.next = 3, this.syncMapImpl.removeMap();
              case 3:
              case "end":
                return o.stop();
            }
        }, a, this);
      }));
      function i() {
        return n.apply(this, arguments);
      }
      return i;
    }()
    /**
     * Conclude work with the map instance and remove all event listeners attached to it.
     * Any subsequent operation on this object will be rejected with error.
     * Other local copies of this map will continue operating and receiving events normally.
     * @example
     * ```typescript
     * map.close();
     * ````
     */
  }, {
    key: "close",
    value: function() {
      Pl.default(Dr.default(r.prototype), "close", this).call(this), this.syncMapImpl.detach(this.listenerUuid);
    }
  }], [{
    key: "type",
    get: function() {
      return vg.type;
    }
  }]), r;
}(Ll);
nr.default(Hr, "itemAdded", "itemAdded");
nr.default(Hr, "itemUpdated", "itemUpdated");
nr.default(Hr, "itemRemoved", "itemRemoved");
nr.default(Hr, "removed", "removed");
Mt([Le.validateTypesAsync("string", Le.pureObject, ["undefined", Le.objectSchema("item metadata", {
  ttl: [Le.nonNegativeInteger, "undefined"]
})]), Ye("design:type", Function), Ye("design:paramtypes", [String, Object, Object]), Ye("design:returntype", Promise)], Hr.prototype, "set", null);
Mt([Le.validateTypesAsync("string"), Ye("design:type", Function), Ye("design:paramtypes", [String]), Ye("design:returntype", Promise)], Hr.prototype, "get", null);
Mt([Le.validateTypesAsync("string", "function", ["undefined", Le.objectSchema("item metadata", {
  ttl: [Le.nonNegativeInteger, "undefined"]
})]), Ye("design:type", Function), Ye("design:paramtypes", [String, Function, Object]), Ye("design:returntype", Promise)], Hr.prototype, "mutate", null);
Mt([Le.validateTypesAsync("string", Le.pureObject, ["undefined", Le.objectSchema("item metadata", {
  ttl: [Le.nonNegativeInteger, "undefined"]
})]), Ye("design:type", Function), Ye("design:paramtypes", [String, Object, Object]), Ye("design:returntype", Promise)], Hr.prototype, "update", null);
Mt([Le.validateTypesAsync("string"), Ye("design:type", Function), Ye("design:paramtypes", [String]), Ye("design:returntype", Promise)], Hr.prototype, "remove", null);
Mt([Le.validateTypesAsync(["undefined", Le.objectSchema("query options", {
  from: ["string", "undefined"],
  pageSize: [Le.custom(function(e) {
    return [JV(e), "a positive integer"];
  }), "undefined"]
})]), Ye("design:type", Function), Ye("design:paramtypes", [Object]), Ye("design:returntype", Promise)], Hr.prototype, "getItems", null);
Mt([Le.validateTypesAsync(Le.nonNegativeInteger), Ye("design:type", Function), Ye("design:paramtypes", [Number]), Ye("design:returntype", Promise)], Hr.prototype, "setTtl", null);
Mt([Le.validateTypesAsync("string", Le.nonNegativeInteger), Ye("design:type", Function), Ye("design:paramtypes", [String, Number]), Ye("design:returntype", Promise)], Hr.prototype, "setItemTtl", null);
function n4(e) {
  var t = bne();
  return function() {
    var n = Dr.default(e), i;
    if (t) {
      var a = Dr.default(this).constructor;
      i = Reflect.construct(n, arguments, a);
    } else
      i = n.apply(this, arguments);
    return ys.default(this, i);
  };
}
function bne() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
var nl = /* @__PURE__ */ function(e) {
  Cn.default(r, e);
  var t = n4(r);
  function r(n, i, a) {
    var s;
    return Zt.default(this, r), s = t.call(this, n, a), s.descriptor = i, s;
  }
  return Jt.default(r, [{
    key: "uri",
    get: function() {
      return this.descriptor.url;
    }
  }, {
    key: "links",
    get: function() {
      return this.descriptor.links;
    }
  }, {
    key: "dateExpires",
    get: function() {
      return this.descriptor.date_expires;
    }
  }, {
    key: "type",
    get: function() {
      return "stream";
    }
  }, {
    key: "lastEventId",
    get: function() {
      return null;
    }
    // below properties are specific to Insights only
  }, {
    key: "indexName",
    get: function() {
    }
  }, {
    key: "queryString",
    get: function() {
    }
    // public props, documented along with class description
  }, {
    key: "sid",
    get: function() {
      return this.descriptor.sid;
    }
  }, {
    key: "uniqueName",
    get: function() {
      return this.descriptor.unique_name || null;
    }
  }, {
    key: "publishMessage",
    value: function() {
      var n = Ge.default(/* @__PURE__ */ de.default.mark(function a(s) {
        var o, u, f, l;
        return de.default.wrap(function(c) {
          for (; ; )
            switch (c.prev = c.next) {
              case 0:
                return o = {
                  data: s
                }, c.next = 3, this.services.network.post(this.links.messages, o);
              case 3:
                return u = c.sent, f = u.body, l = this._handleMessagePublished(f.sid, s, !1), c.abrupt("return", l);
              case 7:
              case "end":
                return c.stop();
            }
        }, a, this);
      }));
      function i(a) {
        return n.apply(this, arguments);
      }
      return i;
    }()
  }, {
    key: "setTtl",
    value: function() {
      var n = Ge.default(/* @__PURE__ */ de.default.mark(function a(s) {
        var o, u;
        return de.default.wrap(function(l) {
          for (; ; )
            switch (l.prev = l.next) {
              case 0:
                return l.prev = 0, o = {
                  ttl: s
                }, l.next = 4, this.services.network.post(this.uri, o);
              case 4:
                u = l.sent, this.descriptor.date_expires = u.body.date_expires, l.next = 12;
                break;
              case 8:
                throw l.prev = 8, l.t0 = l.catch(0), l.t0.status === 404 && this.onRemoved(!1), l.t0;
              case 12:
              case "end":
                return l.stop();
            }
        }, a, this, [[0, 8]]);
      }));
      function i(a) {
        return n.apply(this, arguments);
      }
      return i;
    }()
  }, {
    key: "removeStream",
    value: function() {
      var n = Ge.default(/* @__PURE__ */ de.default.mark(function a() {
        return de.default.wrap(function(o) {
          for (; ; )
            switch (o.prev = o.next) {
              case 0:
                return o.next = 2, this.services.network.delete(this.uri);
              case 2:
                this.onRemoved(!0);
              case 3:
              case "end":
                return o.stop();
            }
        }, a, this);
      }));
      function i() {
        return n.apply(this, arguments);
      }
      return i;
    }()
    /**
     * Handle event from the server
     * @private
     */
  }, {
    key: "_update",
    value: function(i) {
      switch (i.type) {
        case "stream_message_published": {
          this._handleMessagePublished(i.message_sid, i.message_data, !0);
          break;
        }
        case "stream_removed": {
          this.onRemoved(!1);
          break;
        }
      }
    }
  }, {
    key: "_handleMessagePublished",
    value: function(i, a, s) {
      var o = {
        sid: i,
        data: a
      };
      return this.broadcastEventToListeners("messagePublished", {
        message: o,
        isLocal: !s
      }), o;
    }
  }, {
    key: "onRemoved",
    value: function(i) {
      this._unsubscribe(), this.removalHandler(this.type, this.sid, this.uniqueName), this.broadcastEventToListeners("removed", {
        isLocal: i
      });
    }
  }], [{
    key: "type",
    get: function() {
      return "stream";
    }
  }]), r;
}(Dl);
Mt([Le.validateTypesAsync(Le.pureObject), Ye("design:type", Function), Ye("design:paramtypes", [Object]), Ye("design:returntype", Promise)], nl.prototype, "publishMessage", null);
Mt([Le.validateTypesAsync(Le.nonNegativeInteger), Ye("design:type", Function), Ye("design:paramtypes", [Number]), Ye("design:returntype", Promise)], nl.prototype, "setTtl", null);
var Xi = /* @__PURE__ */ function(e) {
  Cn.default(r, e);
  var t = n4(r);
  function r(n) {
    var i;
    return Zt.default(this, r), i = t.call(this), i.syncStreamImpl = n, i.syncStreamImpl.attach(Zi.default(i)), i;
  }
  return Jt.default(r, [{
    key: "uri",
    get: (
      // private props
      function() {
        return this.syncStreamImpl.uri;
      }
    )
  }, {
    key: "links",
    get: function() {
      return this.syncStreamImpl.links;
    }
  }, {
    key: "dateExpires",
    get: function() {
      return this.syncStreamImpl.dateExpires;
    }
  }, {
    key: "type",
    get: function() {
      return nl.type;
    }
  }, {
    key: "lastEventId",
    get: function() {
      return null;
    }
    /**
     * The immutable system-assigned identifier of this stream. Never null.
     */
  }, {
    key: "sid",
    get: function() {
      return this.syncStreamImpl.sid;
    }
    /**
     * A unique identifier optionally assigned to the stream on creation.
     */
  }, {
    key: "uniqueName",
    get: function() {
      return this.syncStreamImpl.uniqueName;
    }
  }, {
    key: "publishMessage",
    value: (
      /**
       * Publish a message to the stream. The system will attempt delivery to all online subscribers.
       * @param data The body of the dispatched message. Maximum size in serialized JSON: 4KB.
       * A rate limit applies to this operation, refer to the [Sync API documentation](https://www.twilio.com/docs/api/sync) for details.
       * @return A promise which resolves after the message is successfully published
       * to the Sync service. Resolves irrespective of ultimate delivery to any subscribers.
       * @example
       * ```typescript
       * stream.publishMessage({ x: 42, y: 123 })
       *   .then((message) => {
       *     console.log('Stream publishMessage() successful, message SID:', message.sid);
       *   })
       *   .catch((error) => {
       *     console.error('Stream publishMessage() failed', error);
       *   });
       * ```
       */
      function() {
        var n = Ge.default(/* @__PURE__ */ de.default.mark(function a(s) {
          return de.default.wrap(function(u) {
            for (; ; )
              switch (u.prev = u.next) {
                case 0:
                  return this.ensureNotClosed(), u.abrupt("return", this.syncStreamImpl.publishMessage(s));
                case 2:
                case "end":
                  return u.stop();
              }
          }, a, this);
        }));
        function i(a) {
          return n.apply(this, arguments);
        }
        return i;
      }()
    )
    /**
     * Update the time-to-live of the stream.
     * @param ttl Specifies the TTL in seconds after which the stream is subject to automatic deletion. The value 0 means infinity.
     * @return A promise that resolves after the TTL update was successful.
     * @example
     * ```typescript
     * stream.setTtl(3600)
     *   .then(() => {
     *     console.log('Stream setTtl() successful');
     *   })
     *   .catch((error) => {
     *     console.error('Stream setTtl() failed', error);
     *   });
     * ```
     */
  }, {
    key: "setTtl",
    value: function() {
      var n = Ge.default(/* @__PURE__ */ de.default.mark(function a(s) {
        return de.default.wrap(function(u) {
          for (; ; )
            switch (u.prev = u.next) {
              case 0:
                return this.ensureNotClosed(), u.abrupt("return", this.syncStreamImpl.setTtl(s));
              case 2:
              case "end":
                return u.stop();
            }
        }, a, this);
      }));
      function i(a) {
        return n.apply(this, arguments);
      }
      return i;
    }()
    /**
     * Permanently delete this Stream.
     * @return A promise which resolves after the Stream is successfully deleted.
     * @example
     * ```typescript
     * stream.removeStream()
     *   .then(() => {
     *     console.log('Stream removeStream() successful');
     *   })
     *   .catch((error) => {
     *     console.error('Stream removeStream() failed', error);
     *   });
     * ```
     */
  }, {
    key: "removeStream",
    value: function() {
      var n = Ge.default(/* @__PURE__ */ de.default.mark(function a() {
        return de.default.wrap(function(o) {
          for (; ; )
            switch (o.prev = o.next) {
              case 0:
                return this.ensureNotClosed(), o.abrupt("return", this.syncStreamImpl.removeStream());
              case 2:
              case "end":
                return o.stop();
            }
        }, a, this);
      }));
      function i() {
        return n.apply(this, arguments);
      }
      return i;
    }()
    /**
     * Conclude work with the stream instance and remove all event listeners attached to it.
     * Any subsequent operation on this object will be rejected with error.
     * Other local copies of this stream will continue operating and receiving events normally.
     * @example
     * ```typescript
     * stream.close();
     * ```
     */
  }, {
    key: "close",
    value: function() {
      Pl.default(Dr.default(r.prototype), "close", this).call(this), this.syncStreamImpl.detach(this.listenerUuid);
    }
  }], [{
    key: "type",
    get: function() {
      return nl.type;
    }
  }]), r;
}(Ll);
nr.default(Xi, "messagePublished", "messagePublished");
nr.default(Xi, "removed", "removed");
Mt([Le.validateTypesAsync(Le.pureObject), Ye("design:type", Function), Ye("design:paramtypes", [Object]), Ye("design:returntype", Promise)], Xi.prototype, "publishMessage", null);
Mt([Le.validateTypesAsync(Le.nonNegativeInteger), Ye("design:type", Function), Ye("design:paramtypes", [Number]), Ye("design:returntype", Promise)], Xi.prototype, "setTtl", null);
var Ane = function e(t) {
  Zt.default(this, e), this.sdk = "js", this.sdkVer = t, this.os = xd.os.family, this.osVer = xd.os.version, this.pl = xd.name, this.plVer = xd.version;
}, wne = /* @__PURE__ */ function() {
  function e() {
    Zt.default(this, e), this.names = /* @__PURE__ */ new Map(), this.entities = /* @__PURE__ */ new Map();
  }
  return Jt.default(e, [{
    key: "store",
    value: function(r) {
      var n = this.entities.get(r.sid);
      return n || (this.entities.set(r.sid, r), r.uniqueName && this.names.set(r.type + "::" + r.uniqueName, r.sid), r);
    }
  }, {
    key: "getResolved",
    value: function(r, n) {
      var i = this.names.get(n + "::" + r);
      return i ? this.entities.get(i) : null;
    }
  }, {
    key: "get",
    value: function(r, n) {
      return this.entities.get(r) || this.getResolved(r, n) || null;
    }
  }, {
    key: "remove",
    value: function(r) {
      var n = this.entities.get(r);
      n && (this.entities.delete(r), n.uniqueName && this.names.delete(n.type + "::" + n.uniqueName));
    }
  }]), e;
}();
function $V(e) {
  var t = kne();
  return function() {
    var n = Dr.default(e), i;
    if (t) {
      var a = Dr.default(this).constructor;
      i = Reflect.construct(n, arguments, a);
    } else
      i = n.apply(this, arguments);
    return ys.default(this, i);
  };
}
function kne() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
var Wne = (
  /**
   * @internal
   */
  function e() {
    Zt.default(this, e);
  }
), hg = /* @__PURE__ */ function(e) {
  Cn.default(r, e);
  var t = $V(r);
  function r(n, i, a, s) {
    var o;
    return Zt.default(this, r), o = t.call(this, i, a), o.descriptor = n, o.cache = new _V(), s && s.forEach(function(u) {
      o.cache.store(u.key, {
        key: u.key,
        value: u.data
      }, u.revision);
    }), o;
  }
  return Jt.default(r, [{
    key: "sid",
    get: function() {
      return this.descriptor.sid;
    }
    // private extension of SyncEntity
  }, {
    key: "uniqueName",
    get: function() {
      return null;
    }
  }, {
    key: "type",
    get: function() {
      return r.type;
    }
  }, {
    key: "lastEventId",
    get: function() {
      return this.descriptor.last_event_id;
    }
  }, {
    key: "indexName",
    get: function() {
      return this.descriptor.indexName;
    }
  }, {
    key: "queryString",
    get: function() {
      return this.descriptor.queryExpression;
    }
    // custom private props
  }, {
    key: "queryUri",
    get: function() {
      return this.descriptor.queryUri;
    }
  }, {
    key: "liveQueryDescriptor",
    get: function() {
      return this.descriptor;
    }
    // dummy stub from iface
  }, {
    key: "onRemoved",
    value: function() {
    }
  }, {
    key: "getItems",
    value: function() {
      var i = {};
      return this.cache.forEach(function(a, s) {
        i[a] = s.value;
      }), i;
    }
    /**
     * @internal
     */
  }, {
    key: "_update",
    value: function(i, a) {
      switch (i.type) {
        case "live_query_item_updated":
          this.handleItemMutated(i.item_key, i.item_data, i.item_revision);
          break;
        case "live_query_item_removed":
          this.handleItemRemoved(i.item_key, i.item_revision);
          break;
        case "live_query_updated":
          this.handleBatchUpdate(i.items);
          break;
      }
      a && this._advanceLastEventId(i.last_event_id);
    }
  }, {
    key: "handleItemMutated",
    value: function(i, a, s) {
      if (this.shouldIgnoreEvent(i, s))
        jt.trace("Item ".concat(i, " update skipped, revision: ").concat(s));
      else {
        var o = {
          key: i,
          value: a
        };
        this.cache.store(i, o, s), this.broadcastEventToListeners("itemUpdated", o);
      }
    }
  }, {
    key: "handleItemRemoved",
    value: function(i, a) {
      var s = a === null;
      this.shouldIgnoreEvent(i, a) ? jt.trace("Item ".concat(i, " delete skipped, revision: ").concat(a)) : (this.cache.delete(i, a, s), this.broadcastEventToListeners("itemRemoved", {
        key: i
      }));
    }
  }, {
    key: "handleBatchUpdate",
    value: function(i) {
      var a = this, s = {};
      i != null && i.forEach(function(u) {
        s[u.key] = {
          data: u.data,
          revision: u.revision
        };
      }), this.cache.forEach(function(u, f) {
        var l = s[u];
        l != null ? a.handleItemMutated(u, l.data, l.revision) : a.handleItemRemoved(u, null), delete s[u];
      });
      for (var o in s)
        this.handleItemMutated(o, s[o].data, s[o].revision);
    }
  }, {
    key: "shouldIgnoreEvent",
    value: function(i, a) {
      return i != null && a != null && this.cache.isKnown(i, a);
    }
    /**
     * @internal
     */
  }, {
    key: "_advanceLastEventId",
    value: function(i, a) {
      this.lastEventId < i && (this.descriptor.last_event_id = i);
    }
  }], [{
    key: "type",
    get: function() {
      return "live_query";
    }
  }]), r;
}(Dl);
function i4(e) {
  return mg.apply(this, arguments);
}
function mg() {
  return mg = Ge.default(/* @__PURE__ */ de.default.mark(function e(t) {
    var r, n, i, a, s, o;
    return de.default.wrap(function(f) {
      for (; ; )
        switch (f.prev = f.next) {
          case 0:
            if (r = t.network, n = t.queryString, i = t.uri, a = t.type, n != null) {
              f.next = 3;
              break;
            }
            throw new Rn("Invalid query", 400, 54507);
          case 3:
            return s = {
              query_string: n
              // raw query string (like `key == "value" AND key2 != "value2"`)
            }, a === pa.type && (s.type = a), f.next = 7, r.post(i, s, void 0, !0);
          case 7:
            return o = f.sent, f.abrupt("return", o.body);
          case 9:
          case "end":
            return f.stop();
        }
    }, e);
  })), mg.apply(this, arguments);
}
var pa = /* @__PURE__ */ function(e) {
  Cn.default(r, e);
  var t = $V(r);
  function r(n) {
    var i;
    return Zt.default(this, r), i = t.call(this), i.liveQueryImpl = n, i.liveQueryImpl.attach(Zi.default(i)), i;
  }
  return Jt.default(r, [{
    key: "type",
    get: function() {
      return hg.type;
    }
  }, {
    key: "lastEventId",
    get: function() {
      return this.liveQueryImpl.lastEventId;
    }
    /**
     * The immutable identifier of this query object, assigned by the system.
     */
  }, {
    key: "sid",
    get: function() {
      return this.liveQueryImpl.sid;
    }
  }, {
    key: "close",
    value: (
      /**
       * Closes this query instance and unsubscribes from further service events.
       * This will eventually stop the physical inflow of updates over the network, when all other instances of this query are closed as well.
       */
      function() {
        Pl.default(Dr.default(r.prototype), "close", this).call(this), this.liveQueryImpl.detach(this.listenerUuid);
      }
    )
    /**
     * @return A snapshot of items matching the current query expression.
     */
  }, {
    key: "getItems",
    value: function() {
      return this.ensureNotClosed(), this.liveQueryImpl.getItems();
    }
  }], [{
    key: "type",
    get: (
      // private props
      function() {
        return hg.type;
      }
    )
  }]), r;
}(Ll);
nr.default(pa, "itemUpdated", "itemUpdated");
nr.default(pa, "itemRemoved", "itemRemoved");
var Zl = /* @__PURE__ */ function(e) {
  Cn.default(r, e);
  var t = $V(r);
  function r(n) {
    var i;
    return Zt.default(this, r), i = t.call(this), nr.default(Zi.default(i), "queryExpression", null), nr.default(Zi.default(i), "items", {}), Object.assign(Zi.default(i), n), i.updateIndexName(n.indexName), i;
  }
  return Jt.default(r, [{
    key: "type",
    get: function() {
      return r.type;
    }
  }, {
    key: "search",
    value: (
      /**
       * Spawns a new search request. The result will be provided asynchronously via the {@link InstantQuery.searchResult}
       * event.
       * @param queryExpression A query expression to be executed against the given data index. For more information
       * on the syntax read {@link SyncClient.liveQuery}.
       * @return A promise that resolves when query result has been received.
       */
      function() {
        var n = Ge.default(/* @__PURE__ */ de.default.mark(function a(s) {
          var o = this;
          return de.default.wrap(function(f) {
            for (; ; )
              switch (f.prev = f.next) {
                case 0:
                  return this.items = {}, f.abrupt("return", i4({
                    network: this.network,
                    uri: this.queryUri,
                    queryString: s
                  }).then(function(l) {
                    o.queryExpression = s, l.items && l.items.forEach(function(d) {
                      o.items[d.key] = d.data;
                    }), o.emit("searchResult", o.getItems());
                  }).catch(function(l) {
                    throw jt.error("Error '".concat(l.message, "' while executing query '").concat(s, "'")), o.queryExpression = null, l;
                  }));
                case 2:
                case "end":
                  return f.stop();
              }
          }, a, this);
        }));
        function i(a) {
          return n.apply(this, arguments);
        }
        return i;
      }()
    )
    /**
     * Instantiates a LiveQuery object based on the last known query expression that was passed to the
     * {@link InstantQuery.search} method. This LiveQuery will start receiving updates with new results,
     * while current object can be still used to execute repetitive searches.
     * @return A promise which resolves when the LiveQuery object is ready.
     */
  }, {
    key: "subscribe",
    value: function() {
      var n = Ge.default(/* @__PURE__ */ de.default.mark(function a() {
        return de.default.wrap(function(o) {
          for (; ; )
            switch (o.prev = o.next) {
              case 0:
                if (this.queryExpression != null) {
                  o.next = 2;
                  break;
                }
                return o.abrupt("return", Promise.reject(new Rn("Invalid query", 400, 54507)));
              case 2:
                return o.abrupt("return", this.liveQueryCreator(this.indexName, this.queryExpression));
              case 3:
              case "end":
                return o.stop();
            }
        }, a, this);
      }));
      function i() {
        return n.apply(this, arguments);
      }
      return i;
    }()
    /**
     * @return A snapshot of items matching current query expression.
     */
  }, {
    key: "getItems",
    value: function() {
      return this.items;
    }
    /**
     * Set new index name
     * @param indexName New index name to set
     */
  }, {
    key: "updateIndexName",
    value: function(i) {
      this.indexName = i, this.queryUri = this.generateQueryUri(this.indexName);
    }
  }, {
    key: "generateQueryUri",
    value: function(i) {
      return new cu(this.insightsUri).pathSegment(i).pathSegment("Items").build();
    }
  }], [{
    key: "type",
    get: (
      // private props
      function() {
        return "instant_query";
      }
    )
  }]), r;
}(sr);
nr.default(Zl, "searchResult", "searchResult");
Mt([Le.validateTypesAsync("string"), Ye("design:type", Function), Ye("design:paramtypes", [String]), Ye("design:returntype", Promise)], Zl.prototype, "search", null);
Mt([Le.validateTypes(Le.nonEmptyString), Ye("design:type", Function), Ye("design:paramtypes", [String]), Ye("design:returntype", void 0)], Zl.prototype, "updateIndexName", null);
var Sne = "3.1.0";
function Cne(e) {
  var t = Fne();
  return function() {
    var n = Dr.default(e), i;
    if (t) {
      var a = Dr.default(this).constructor;
      i = Reflect.construct(n, arguments, a);
    } else
      i = n.apply(this, arguments);
    return ys.default(this, i);
  };
}
function Fne() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function Qk(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Jk(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Qk(Object(r), !0).forEach(function(n) {
      nr.default(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Qk(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
var Kne = "data_sync", c1 = Sne;
function Ed(e) {
  if (e) {
    if (typeof e == "string")
      return {
        id: e,
        mode: "open_or_create"
      };
    var t = e.mode || (e.id ? "open_or_create" : "create_new");
    return Jk(Jk({}, e), {}, {
      mode: t
    });
  } else
    return {
      mode: "create_new"
    };
}
var Hk = "com.twilio.rtd.cds.document", _k = "com.twilio.rtd.cds.list", $k = "com.twilio.rtd.cds.map", e2 = "twilio.sync.event", zn = /* @__PURE__ */ function(e) {
  Cn.default(r, e);
  var t = Cne(r);
  function r(n) {
    var i, a = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (Zt.default(this, r), i = t.call(this), !n)
      throw new Error("Sync library needs a valid Twilio token to be passed");
    a.hasOwnProperty("logLevel") ? jt.setLevel(a.logLevel) : jt.setLevel("silent");
    var s = a.productId = a.productId || Kne;
    a.clientMetadata = a.clientMetadata || {}, a.clientMetadata.hasOwnProperty("type") || (a.clientMetadata.type = "sync"), a.clientMetadata.hasOwnProperty("sdk") || (a.clientMetadata.sdk = "JS", a.clientMetadata.sdkv = c1);
    var o = !a.twilsockClient;
    if (!a.initRegistrations) {
      var u = new Bc.InitRegistration(s);
      r.populateInitRegistrations(u), a.initRegistrations = [u];
    }
    var f = a.twilsockClient = a.twilsockClient || new Bc.Twilsock(n, s, a);
    f.on("tokenAboutToExpire", function(p) {
      return i.emit("tokenAboutToExpire", p);
    }), f.on("tokenExpired", function() {
      return i.emit("tokenExpired");
    }), f.on("connectionError", function(p) {
      return i.emit("connectionError", p);
    }), f.on("stateChanged", function(p) {
      i.emit("connectionStateChanged", p), i.services.subscriptions.onConnectionStateChanged(p === "connected");
    }), f.on("message", function(p, v) {
      return i._routeMessage(p, v);
    });
    var l = new Jre(a), d = new ine(new Ane(c1), l, f), c = new ane(l);
    return i.services = {
      config: l,
      twilsock: f,
      network: d,
      storage: c,
      router: Zi.default(i),
      subscriptions: null
    }, i.services.subscriptions = new $re(i.services), i.entities = new wne(), o && f.connect(), i;
  }
  return Jt.default(r, [{
    key: "_routeMessage",
    value: (
      /**
       * Entry point for all the incoming messages (Router).
       *
       * @param type Type of the incoming message
       * @param message Message to route
       * @internal
       */
      function(i, a) {
        switch (jt.trace("Notification type:", i, "content:", a), i) {
          case Hk:
          case _k:
          case $k:
            this.services.subscriptions.acceptMessage(a, !1);
            break;
          case e2:
            this.services.subscriptions.acceptMessage(a, !0);
            break;
        }
      }
    )
    /**
     * Subscribe for events (Router)
     *
     * @internal
     */
  }, {
    key: "_subscribe",
    value: function(i, a) {
      this.services.subscriptions.add(i, a);
    }
    /**
     * Unsubscribe from events (Router)
     *
     * @internal
     */
  }, {
    key: "_unsubscribe",
    value: function(i) {
      this.services.subscriptions.remove(i);
    }
    /**
     * Current version of the Sync client.
     */
  }, {
    key: "connectionState",
    get: (
      /**
       * Current service connection state.
       */
      function() {
        return this.services.twilsock.state;
      }
    )
    /**
     * Returns a promise which resolves when library is correctly initialized
     * Or throws if initialization is impossible
     *
     * @internal
     */
  }, {
    key: "ensureReady",
    value: function() {
      var n = Ge.default(/* @__PURE__ */ de.default.mark(function a() {
        var s;
        return de.default.wrap(function(u) {
          for (; ; )
            switch (u.prev = u.next) {
              case 0:
                if (this.services.config.sessionStorageEnabled) {
                  u.next = 2;
                  break;
                }
                return u.abrupt("return");
              case 2:
                return u.prev = 2, u.next = 5, this.services.twilsock.storageId();
              case 5:
                s = u.sent, this.services.storage.updateStorageId(s.id), u.next = 12;
                break;
              case 9:
                u.prev = 9, u.t0 = u.catch(2), jt.warn("Failed to initialize storage", u.t0);
              case 12:
              case "end":
                return u.stop();
            }
        }, a, this, [[2, 9]]);
      }));
      function i() {
        return n.apply(this, arguments);
      }
      return i;
    }()
  }, {
    key: "storeRootInSessionCache",
    value: function(i, a, s) {
      if (!(!this.services.config.sessionStorageEnabled || !a)) {
        var o = Wi(s);
        (i === jr.type || i === Hr.type) && (o.last_event_id = null, delete o.items), this.services.storage.store(i, a, o);
      }
    }
  }, {
    key: "readRootFromSessionCache",
    value: function(i, a) {
      return !this.services.config.sessionStorageEnabled || !a ? null : this.services.storage.read(i, a);
    }
  }, {
    key: "_get",
    value: function() {
      var n = Ge.default(/* @__PURE__ */ de.default.mark(function a(s, o) {
        var u, f, l, d = arguments;
        return de.default.wrap(function(p) {
          for (; ; )
            switch (p.prev = p.next) {
              case 0:
                if (u = d.length > 2 && d[2] !== void 0 ? d[2] : !1, o) {
                  p.next = 3;
                  break;
                }
                throw new Rn("Cannot get entity without id", 404);
              case 3:
                return f = new cu(s).pathSegment(o).queryParam("Include", u ? "items" : void 0).build(), p.next = 6, this.services.network.get(f);
              case 6:
                return l = p.sent, p.abrupt("return", l.body);
              case 8:
              case "end":
                return p.stop();
            }
        }, a, this);
      }));
      function i(a, s) {
        return n.apply(this, arguments);
      }
      return i;
    }()
  }, {
    key: "_createDocument",
    value: function(i, a, s) {
      var o = {
        unique_name: i,
        data: a || {}
      };
      return s !== void 0 && (o.ttl = s), this.services.network.post(this.services.config.documentsUri, o).then(function(u) {
        return u.body.data = o.data, u.body;
      });
    }
  }, {
    key: "_getDocument",
    value: function() {
      var n = Ge.default(/* @__PURE__ */ de.default.mark(function a(s) {
        return de.default.wrap(function(u) {
          for (; ; )
            switch (u.prev = u.next) {
              case 0:
                return u.abrupt("return", this.readRootFromSessionCache(oi.type, s) || this._get(this.services.config.documentsUri, s));
              case 1:
              case "end":
                return u.stop();
            }
        }, a, this);
      }));
      function i(a) {
        return n.apply(this, arguments);
      }
      return i;
    }()
  }, {
    key: "_createList",
    value: function(i, a, s, o) {
      var u = {
        unique_name: i,
        purpose: a,
        context: s
      };
      return o !== void 0 && (u.ttl = o), this.services.network.post(this.services.config.listsUri, u).then(function(f) {
        return f.body;
      });
    }
  }, {
    key: "_getList",
    value: function() {
      var n = Ge.default(/* @__PURE__ */ de.default.mark(function a(s) {
        return de.default.wrap(function(u) {
          for (; ; )
            switch (u.prev = u.next) {
              case 0:
                return u.abrupt("return", this.readRootFromSessionCache(jr.type, s) || this._get(this.services.config.listsUri, s));
              case 1:
              case "end":
                return u.stop();
            }
        }, a, this);
      }));
      function i(a) {
        return n.apply(this, arguments);
      }
      return i;
    }()
  }, {
    key: "_createMap",
    value: function(i, a) {
      var s = {
        unique_name: i
      };
      return a !== void 0 && (s.ttl = a), this.services.network.post(this.services.config.mapsUri, s).then(function(o) {
        return o.body;
      });
    }
  }, {
    key: "_getMap",
    value: function() {
      var n = Ge.default(/* @__PURE__ */ de.default.mark(function a(s) {
        var o, u = arguments;
        return de.default.wrap(function(l) {
          for (; ; )
            switch (l.prev = l.next) {
              case 0:
                return o = u.length > 1 && u[1] !== void 0 ? u[1] : !1, l.abrupt("return", this.readRootFromSessionCache(Hr.type, s) || this._get(this.services.config.mapsUri, s, o));
              case 2:
              case "end":
                return l.stop();
            }
        }, a, this);
      }));
      function i(a) {
        return n.apply(this, arguments);
      }
      return i;
    }()
  }, {
    key: "_getStream",
    value: function() {
      var n = Ge.default(/* @__PURE__ */ de.default.mark(function a(s) {
        return de.default.wrap(function(u) {
          for (; ; )
            switch (u.prev = u.next) {
              case 0:
                return u.abrupt("return", this.readRootFromSessionCache(Xi.type, s) || this._get(this.services.config.streamsUri, s, !1));
              case 1:
              case "end":
                return u.stop();
            }
        }, a, this);
      }));
      function i(a) {
        return n.apply(this, arguments);
      }
      return i;
    }()
  }, {
    key: "_createStream",
    value: function() {
      var n = Ge.default(/* @__PURE__ */ de.default.mark(function a(s, o) {
        var u, f;
        return de.default.wrap(function(d) {
          for (; ; )
            switch (d.prev = d.next) {
              case 0:
                return u = {
                  unique_name: s
                }, o !== void 0 && (u.ttl = o), d.next = 4, this.services.network.post(this.services.config.streamsUri, u);
              case 4:
                return f = d.sent, d.abrupt("return", f.body);
              case 6:
              case "end":
                return d.stop();
            }
        }, a, this);
      }));
      function i(a, s) {
        return n.apply(this, arguments);
      }
      return i;
    }()
  }, {
    key: "_getLiveQuery",
    value: function(i) {
      return this.readRootFromSessionCache(pa.type, i);
    }
  }, {
    key: "getCached",
    value: function(i, a) {
      return i && this.entities.get(i, a) || null;
    }
  }, {
    key: "removeFromCacheAndSession",
    value: function(i, a, s) {
      this.entities.remove(a), this.services.config.sessionStorageEnabled && this.services.storage.remove(i, a, s);
    }
    /**
     * Read or create a Sync document.
     * @param arg Could be any of the following:
     * * Unique name or SID identifying the Sync document - opens the document with the given identifier or creates one if it does not exist.
     * * none - creates a new document with a randomly assigned SID and no unique name.
     * * {@link OpenDocumentOptions} object for more granular control.
     * @return A promise which resolves after the document is successfully read (or created).
     * This promise may reject if the document could not be created or if this endpoint lacks the necessary permissions to access it.
     * @example
     * ```typescript
     * syncClient.document('MyDocument')
     *   .then((document) => {
     *     console.log('Successfully opened a document. SID:', document.sid);
     *     document.on('updated', (event) => {
     *       console.log('Received an "updated" event: ', event);
     *     });
     *   })
     *   .catch((error) => {
     *     console.error('Unexpected error', error);
     *   });
     * ```
     */
  }, {
    key: "document",
    value: function() {
      var n = Ge.default(/* @__PURE__ */ de.default.mark(function a(s) {
        var o = this, u, f, l, d;
        return de.default.wrap(function(p) {
          for (; ; )
            switch (p.prev = p.next) {
              case 0:
                return p.next = 2, this.ensureReady();
              case 2:
                if (u = Ed(s), u.mode !== "create_new") {
                  p.next = 9;
                  break;
                }
                return p.next = 6, this._createDocument(u.id, u.data, u.ttl);
              case 6:
                f = p.sent, p.next = 39;
                break;
              case 9:
                if (l = this.getCached(u.id, oi.type), !l) {
                  p.next = 14;
                  break;
                }
                return p.abrupt("return", new oi(l));
              case 14:
                return p.prev = 14, p.next = 17, this._getDocument(u.id);
              case 17:
                f = p.sent, p.next = 39;
                break;
              case 20:
                if (p.prev = 20, p.t0 = p.catch(14), !(p.t0.status !== 404 || u.mode === "open_existing")) {
                  p.next = 26;
                  break;
                }
                throw p.t0;
              case 26:
                return p.prev = 26, p.next = 29, this._createDocument(u.id, u.data, u.ttl);
              case 29:
                f = p.sent, p.next = 39;
                break;
              case 32:
                if (p.prev = 32, p.t1 = p.catch(26), p.t1.status !== 409) {
                  p.next = 38;
                  break;
                }
                return p.abrupt("return", this.document(s));
              case 38:
                throw p.t1;
              case 39:
                return this.storeRootInSessionCache(oi.type, u.id, f), d = new dg(this.services, f, function(v, h, m) {
                  return o.removeFromCacheAndSession(v, h, m);
                }), d = this.entities.store(d), p.abrupt("return", new oi(d));
              case 43:
              case "end":
                return p.stop();
            }
        }, a, this, [[14, 20], [26, 32]]);
      }));
      function i(a) {
        return n.apply(this, arguments);
      }
      return i;
    }()
    /**
     * Read or create a Sync map.
     * @param arg Could be any of the following:
     * * Unique name or SID identifying the Sync map - opens the map with the given identifier or creates one if it does not exist.
     * * none - creates a new map with a randomly assigned SID and no unique name.
     * * {@link OpenMapOptions} object for more granular control.
     * @return A promise which resolves after the map is successfully read (or created).
     * This promise may reject if the map could not be created or if this endpoint lacks the necessary permissions to access it.
     * @example
     * ```typescript
     * syncClient.map('MyMap')
     *   .then((map) => {
     *     console.log('Successfully opened a map. SID:', map.sid);
     *     map.on('itemUpdated', (event) => {
     *       console.log('Received an "itemUpdated" event:', event);
     *     });
     *   })
     *   .catch((error) => {
     *     console.error('Unexpected error', error);
     *   });
     * ```
     */
  }, {
    key: "map",
    value: function() {
      var n = Ge.default(/* @__PURE__ */ de.default.mark(function a(s) {
        var o = this, u, f, l, d;
        return de.default.wrap(function(p) {
          for (; ; )
            switch (p.prev = p.next) {
              case 0:
                return p.next = 2, this.ensureReady();
              case 2:
                if (u = Ed(s), u.mode !== "create_new") {
                  p.next = 9;
                  break;
                }
                return p.next = 6, this._createMap(u.id, u.ttl);
              case 6:
                f = p.sent, p.next = 39;
                break;
              case 9:
                if (l = this.getCached(u.id, Hr.type), !l) {
                  p.next = 14;
                  break;
                }
                return p.abrupt("return", new Hr(l));
              case 14:
                return p.prev = 14, p.next = 17, this._getMap(u.id, u.includeItems);
              case 17:
                f = p.sent, p.next = 39;
                break;
              case 20:
                if (p.prev = 20, p.t0 = p.catch(14), !(p.t0.status !== 404 || u.mode === "open_existing")) {
                  p.next = 26;
                  break;
                }
                throw p.t0;
              case 26:
                return p.prev = 26, p.next = 29, this._createMap(u.id, u.ttl);
              case 29:
                f = p.sent, p.next = 39;
                break;
              case 32:
                if (p.prev = 32, p.t1 = p.catch(26), p.t1.status !== 409) {
                  p.next = 38;
                  break;
                }
                return p.abrupt("return", this.map(s));
              case 38:
                throw p.t1;
              case 39:
                return this.storeRootInSessionCache(Hr.type, u.id, f), d = new vg(this.services, f, function(v, h, m) {
                  return o.removeFromCacheAndSession(v, h, m);
                }), d = this.entities.store(d), p.abrupt("return", new Hr(d));
              case 43:
              case "end":
                return p.stop();
            }
        }, a, this, [[14, 20], [26, 32]]);
      }));
      function i(a) {
        return n.apply(this, arguments);
      }
      return i;
    }()
    /**
     * Read or create a Sync list.
     * @param arg Could be any of the following:
     * * Unique name or SID identifying a Sync list - opens the list with the given identifier or creates one if it does not exist.
     * * none - creates a new list with a randomly assigned SID and no unique name.
     * * {@link OpenListOptions} object for more granular control.
     * @return A promise which resolves after the list is successfully read (or created).
     * This promise may reject if the list could not be created or if this endpoint lacks the necessary permissions to access it.
     * @example
     * ```typescript
     * syncClient.list('MyList')
     *   .then((list) => {
     *     console.log('Successfully opened a List. SID:', list.sid);
     *     list.on('itemAdded', (event) => {
     *       console.log('Received an "itemAdded" event:', event);
     *     });
     *   })
     *   .catch((error) => {
     *     console.error('Unexpected error', error);
     *   });
     * ```
     */
  }, {
    key: "list",
    value: function() {
      var n = Ge.default(/* @__PURE__ */ de.default.mark(function a(s) {
        var o = this, u, f, l, d;
        return de.default.wrap(function(p) {
          for (; ; )
            switch (p.prev = p.next) {
              case 0:
                return p.next = 2, this.ensureReady();
              case 2:
                if (u = Ed(s), u.mode !== "create_new") {
                  p.next = 9;
                  break;
                }
                return p.next = 6, this._createList(u.id, u.purpose, u.context, u.ttl);
              case 6:
                f = p.sent, p.next = 39;
                break;
              case 9:
                if (l = this.getCached(u.id, jr.type), !l) {
                  p.next = 14;
                  break;
                }
                return p.abrupt("return", new jr(l));
              case 14:
                return p.prev = 14, p.next = 17, this._getList(u.id);
              case 17:
                f = p.sent, p.next = 39;
                break;
              case 20:
                if (p.prev = 20, p.t0 = p.catch(14), !(p.t0.status !== 404 || u.mode === "open_existing")) {
                  p.next = 26;
                  break;
                }
                throw p.t0;
              case 26:
                return p.prev = 26, p.next = 29, this._createList(u.id, u.purpose, u.context, u.ttl);
              case 29:
                f = p.sent, p.next = 39;
                break;
              case 32:
                if (p.prev = 32, p.t1 = p.catch(26), p.t1.status !== 409) {
                  p.next = 38;
                  break;
                }
                return p.abrupt("return", this.list(s));
              case 38:
                throw p.t1;
              case 39:
                return this.storeRootInSessionCache(jr.type, u.id, f), d = new pg(this.services, f, function(v, h, m) {
                  return o.removeFromCacheAndSession(v, h, m);
                }), d = this.entities.store(d), p.abrupt("return", new jr(d));
              case 43:
              case "end":
                return p.stop();
            }
        }, a, this, [[14, 20], [26, 32]]);
      }));
      function i(a) {
        return n.apply(this, arguments);
      }
      return i;
    }()
    /**
     * Read or create a Sync message stream.
     * @param arg Could be any of the following:
     * * Unique name or SID identifying a stream - opens the stream with the given identifier or creates one if it does not exist.
     * * none - creates a new stream with a randomly assigned SID and no unique name.
     * * {@link OpenStreamOptions} object for more granular control.
     * @return A promise which resolves after the stream is successfully read (or created).
     * The flow of messages will begin imminently (but not necessarily immediately) upon resolution.
     * This promise may reject if the stream could not be created or if this endpoint lacks the necessary permissions to access it.
     * @example
     * ```typescript
     * syncClient.stream('MyStream')
     *   .then((stream) => {
     *     console.log('Successfully opened a message stream. SID:', stream.sid);
     *     stream.on('messagePublished', (event) => {
     *       console.log('Received a "messagePublished" event:', event);
     *     });
     *   })
     *   .catch((error) => {
     *     console.error('Unexpected error', error);
     *   });
     * ```
     */
  }, {
    key: "stream",
    value: function() {
      var n = Ge.default(/* @__PURE__ */ de.default.mark(function a(s) {
        var o = this, u, f, l, d, c;
        return de.default.wrap(function(v) {
          for (; ; )
            switch (v.prev = v.next) {
              case 0:
                return v.next = 2, this.ensureReady();
              case 2:
                if (u = Ed(s), u.mode !== "create_new") {
                  v.next = 9;
                  break;
                }
                return v.next = 6, this._createStream(u.id, u.ttl);
              case 6:
                f = v.sent, v.next = 39;
                break;
              case 9:
                if (l = this.getCached(u.id, Xi.type), !l) {
                  v.next = 14;
                  break;
                }
                return v.abrupt("return", new Xi(l));
              case 14:
                return v.prev = 14, v.next = 17, this._getStream(u.id);
              case 17:
                f = v.sent, v.next = 39;
                break;
              case 20:
                if (v.prev = 20, v.t0 = v.catch(14), !(v.t0.status !== 404 || u.mode === "open_existing")) {
                  v.next = 26;
                  break;
                }
                throw v.t0;
              case 26:
                return v.prev = 26, v.next = 29, this._createStream(u.id, u.ttl);
              case 29:
                f = v.sent, v.next = 39;
                break;
              case 32:
                if (v.prev = 32, v.t1 = v.catch(26), v.t1.status !== 409) {
                  v.next = 38;
                  break;
                }
                return v.abrupt("return", this.stream(s));
              case 38:
                throw v.t1;
              case 39:
                return this.storeRootInSessionCache(Xi.type, u.id, f), d = function(m, q, w) {
                  return o.removeFromCacheAndSession(m, q, w);
                }, c = new nl(this.services, f, d), c = this.entities.store(c), v.abrupt("return", new Xi(c));
              case 44:
              case "end":
                return v.stop();
            }
        }, a, this, [[14, 20], [26, 32]]);
      }));
      function i(a) {
        return n.apply(this, arguments);
      }
      return i;
    }()
    /**
     * Gracefully shuts the Sync client down.
     */
  }, {
    key: "shutdown",
    value: function() {
      var n = Ge.default(/* @__PURE__ */ de.default.mark(function a() {
        return de.default.wrap(function(o) {
          for (; ; )
            switch (o.prev = o.next) {
              case 0:
                return o.next = 2, this.services.subscriptions.shutdown();
              case 2:
                return o.next = 4, this.services.twilsock.disconnect();
              case 4:
              case "end":
                return o.stop();
            }
        }, a, this);
      }));
      function i() {
        return n.apply(this, arguments);
      }
      return i;
    }()
    /**
     * Set the authentication token.
     * @param token New token to set.
     */
  }, {
    key: "updateToken",
    value: function() {
      var n = Ge.default(/* @__PURE__ */ de.default.mark(function a(s) {
        return de.default.wrap(function(u) {
          for (; ; )
            switch (u.prev = u.next) {
              case 0:
                return u.abrupt("return", this.services.twilsock.updateToken(s).catch(function(f) {
                  var l, d = f == null || (l = f.reply) === null || l === void 0 ? void 0 : l.status;
                  throw (d == null ? void 0 : d.code) === 401 && (d == null ? void 0 : d.status) === "UNAUTHORIZED" ? new Rn("Updated token was rejected by server", 400, 51130) : f;
                }));
              case 1:
              case "end":
                return u.stop();
            }
        }, a, this);
      }));
      function i(a) {
        return n.apply(this, arguments);
      }
      return i;
    }()
    /**
     * For Flex customers only. Establishes a long-running query against Flex data wherein the returned
     * result set is updated whenever new (or updated) records match the given expression. Updated results
     * are presented row-by-row according to the lifetime of the returned LiveQuery object.
     *
     * @param indexName Must specify one of the Flex data classes for which Live Queries are available.
     * @param queryExpression A query expression to be executed against the given data index.
     * Please review the [Live Query Language](https://www.twilio.com/docs/sync/live-query)
     * page for Sync client limits and a full list of operators currently supported in query expressions.
     *
     * @return A promise that resolves when the query has been successfully executed.
     * @example
     * ```typescript
     * syncClient.liveQuery('tr-worker', 'data.attributes.worker_name == "Bob"')
     *   .then((args) => {
     *      console.log('Subscribed to live data updates for worker Bob');
     *      const items = args.getItems();
     *      Object.entries(items).forEach(([key, value]) => {
     *        console.log('Search result item key:', key);
     *        console.log('Search result item value:', value);
     *      });
     *   })
     *   .catch((err) => {
     *      console.error('Error when subscribing to live updates for worker Bob', err);
     *   });
     * ```
     */
  }, {
    key: "liveQuery",
    value: function() {
      var n = Ge.default(/* @__PURE__ */ de.default.mark(function a(s, o) {
        var u = this, f, l, d, c, p;
        return de.default.wrap(function(h) {
          for (; ; )
            switch (h.prev = h.next) {
              case 0:
                return h.next = 2, this.ensureReady();
              case 2:
                return f = new cu(this.services.config.insightsUri).pathSegment(s).pathSegment("Items").build(), h.next = 5, i4({
                  network: this.services.network,
                  uri: f,
                  queryString: o,
                  type: pa.type
                });
              case 5:
                return l = h.sent, d = this.getCached(l.query_id, pa.type), d || (c = this._getLiveQuery(l.query_id), c || (c = {
                  indexName: s,
                  queryExpression: o,
                  sid: l.query_id,
                  queryUri: f,
                  last_event_id: l.last_event_id
                }), p = function(q, w, O) {
                  return u.removeFromCacheAndSession(q, w, O);
                }, d = new hg(c, this.services, p, l.items)), this.storeRootInSessionCache(pa.type, l.query_id, d.liveQueryDescriptor), d = this.entities.store(d), h.abrupt("return", new pa(d));
              case 11:
              case "end":
                return h.stop();
            }
        }, a, this);
      }));
      function i(a, s) {
        return n.apply(this, arguments);
      }
      return i;
    }()
    /**
     * For Flex customers only. Creates a query object that can be used to issue one-time queries repeatedly
     * against the target index.
     *
     * @param indexName Must specify one of the Flex data classes for which live queries are available.
     * @return A promise which resolves after the instance of InstantQuery is successfully created.
     * @example
     * ```typescript
     * syncClient.instantQuery('tr-worker')
     *   .then((q) => {
     *     q.on('searchResult', (items) => {
     *       Object.entries(items).forEach(([key, value]) => {
     *         console.log('Search result item key:', key);
     *         console.log('Search result item value:', value);
     *       });
     *     });
     *   });
     * ```
     */
  }, {
    key: "instantQuery",
    value: function() {
      var n = Ge.default(/* @__PURE__ */ de.default.mark(function a(s) {
        var o = this, u;
        return de.default.wrap(function(l) {
          for (; ; )
            switch (l.prev = l.next) {
              case 0:
                return l.next = 2, this.ensureReady();
              case 2:
                return u = function(c, p) {
                  return o.liveQuery(c, p);
                }, l.abrupt("return", new Zl({
                  indexName: s,
                  network: this.services.network,
                  insightsUri: this.services.config.insightsUri,
                  liveQueryCreator: u
                }));
              case 4:
              case "end":
                return l.stop();
            }
        }, a, this);
      }));
      function i(a) {
        return n.apply(this, arguments);
      }
      return i;
    }()
  }], [{
    key: "populateInitRegistrations",
    value: function(i) {
      i.populateInitRegistrations([e2, Hk, _k, $k]);
    }
  }, {
    key: "version",
    get: function() {
      return c1;
    }
  }]), r;
}(sr);
nr.default(zn, "connectionStateChanged", "connectionStateChanged");
nr.default(zn, "connectionError", "connectionError");
nr.default(zn, "tokenAboutToExpire", "tokenAboutToExpire");
nr.default(zn, "tokenExpired", "tokenExpired");
Mt([Le.validateTypesAsync(["undefined", "string", Le.objectSchema("open document options", {
  id: ["string", "undefined"],
  mode: [Le.literal("open_or_create", "open_existing", "create_new"), "undefined"],
  ttl: [Le.nonNegativeInteger, "undefined"],
  data: [Le.pureObject, "undefined", Le.literal(null)]
})]), Ye("design:type", Function), Ye("design:paramtypes", [Object]), Ye("design:returntype", Promise)], zn.prototype, "document", null);
Mt([Le.validateTypesAsync(["undefined", "string", Le.objectSchema("open map options", {
  id: ["string", "undefined"],
  mode: [Le.literal("open_or_create", "open_existing", "create_new"), "undefined"],
  ttl: [Le.nonNegativeInteger, "undefined"],
  data: [Le.pureObject, "undefined", Le.literal(null)],
  includeItems: ["boolean", "undefined"]
})]), Ye("design:type", Function), Ye("design:paramtypes", [Object]), Ye("design:returntype", Promise)], zn.prototype, "map", null);
Mt([Le.validateTypesAsync(["undefined", "string", Le.objectSchema("open list options", {
  id: ["string", "undefined"],
  mode: [Le.literal("open_or_create", "open_existing", "create_new"), "undefined"],
  ttl: [Le.nonNegativeInteger, "undefined"],
  data: [Le.pureObject, "undefined", Le.literal(null)],
  purpose: ["string", "undefined"],
  context: [Le.pureObject, "undefined"],
  includeItems: ["boolean", "undefined"]
})]), Ye("design:type", Function), Ye("design:paramtypes", [Object]), Ye("design:returntype", Promise)], zn.prototype, "list", null);
Mt([Le.validateTypesAsync(["undefined", "string", Le.objectSchema("open stream options", {
  id: ["string", "undefined"],
  mode: [Le.literal("open_or_create", "open_existing", "create_new"), "undefined"],
  ttl: [Le.nonNegativeInteger, "undefined"],
  data: [Le.pureObject, "undefined", Le.literal(null)]
})]), Ye("design:type", Function), Ye("design:paramtypes", [Object]), Ye("design:returntype", Promise)], zn.prototype, "stream", null);
Mt([Le.validateTypesAsync(Le.nonEmptyString), Ye("design:type", Function), Ye("design:paramtypes", [String]), Ye("design:returntype", Promise)], zn.prototype, "updateToken", null);
Mt([Le.validateTypesAsync(Le.nonEmptyString, "string"), Ye("design:type", Function), Ye("design:paramtypes", [String, String]), Ye("design:returntype", Promise)], zn.prototype, "liveQuery", null);
Mt([Le.validateTypesAsync(Le.nonEmptyString), Ye("design:type", Function), Ye("design:paramtypes", [String]), Ye("design:returntype", Promise)], zn.prototype, "instantQuery", null);
xn.Client = zn;
xn.InsightsItem = Wne;
xn.InstantQuery = Zl;
xn.LiveQuery = pa;
xn.Paginator = HV;
xn.SyncClient = zn;
xn.SyncDocument = oi;
xn.SyncList = jr;
xn.SyncListItem = cg;
xn.SyncMap = Hr;
xn.SyncMapItem = Kf;
xn.SyncStream = Xi;
var a4 = {}, Rne = w9, Tne = TypeError, s4 = function(e) {
  if (Rne(e))
    throw Tne("The method doesn't accept regular expressions");
  return e;
}, Une = lr, xne = Une("match"), o4 = function(e) {
  var t = /./;
  try {
    "/./"[e](t);
  } catch {
    try {
      return t[xne] = !1, "/./"[e](t);
    } catch {
    }
  }
  return !1;
}, Ene = xt, u4 = mp, One = Qi.f, Nne = Sa, t2 = $r, Ine = s4, Xne = Hi, Pne = o4, r2 = u4("".startsWith), Bne = u4("".slice), Dne = Math.min, f4 = Pne("startsWith"), Lne = !f4 && !!function() {
  var e = One(String.prototype, "startsWith");
  return e && !e.writable;
}();
Ene({ target: "String", proto: !0, forced: !Lne && !f4 }, {
  startsWith: function(t) {
    var r = t2(Xne(this));
    Ine(t);
    var n = Nne(Dne(arguments.length > 1 ? arguments[1] : void 0, r.length)), i = t2(t);
    return r2 ? r2(r, i, n) : Bne(r, n, n + i.length) === i;
  }
});
var Zne = St, Mne = lr, jne = Ar, n2 = lS, Yne = Mne("iterator"), l4 = !Zne(function() {
  var e = new URL("b?a=1&b=2&c=3", "http://a"), t = e.searchParams, r = new URLSearchParams("a=1&a=2&b=3"), n = "";
  return e.pathname = "c%20d", t.forEach(function(i, a) {
    t.delete("b"), n += a + i;
  }), r.delete("a", 2), r.delete("b", void 0), n2 && (!e.toJSON || !r.has("a", 1) || r.has("a", 2) || !r.has("a", void 0) || r.has("b")) || !t.size && (n2 || !jne) || !t.sort || e.href !== "http://a/c%20d?a=1&c=3" || t.get("c") !== "3" || String(new URLSearchParams("?a=1")) !== "a=1" || !t[Yne] || new URL("https://a@b").username !== "a" || new URLSearchParams(new URLSearchParams("a=b")).get("a") !== "b" || new URL("http://тест").host !== "xn--e1aybc" || new URL("http://a#б").hash !== "#%D0%B1" || n !== "a1c3" || new URL("http://x", void 0).host !== "x";
}), so = Kt, p1 = 2147483647, Xf = 36, d4 = 1, gg = 26, zne = 38, Gne = 700, Qne = 72, Jne = 128, Hne = "-", _ne = /[^\0-\u007E]/, c4 = /[.\u3002\uFF0E\uFF61]/g, i2 = "Overflow: input needs wider integers to process", v1 = Xf - d4, a2 = RangeError, $ne = so(c4.exec), Po = Math.floor, h1 = String.fromCharCode, s2 = so("".charCodeAt), p4 = so([].join), Ya = so([].push), eie = so("".replace), tie = so("".split), rie = so("".toLowerCase), nie = function(e) {
  for (var t = [], r = 0, n = e.length; r < n; ) {
    var i = s2(e, r++);
    if (i >= 55296 && i <= 56319 && r < n) {
      var a = s2(e, r++);
      (a & 64512) === 56320 ? Ya(t, ((i & 1023) << 10) + (a & 1023) + 65536) : (Ya(t, i), r--);
    } else
      Ya(t, i);
  }
  return t;
}, o2 = function(e) {
  return e + 22 + 75 * (e < 26);
}, iie = function(e, t, r) {
  var n = 0;
  for (e = r ? Po(e / Gne) : e >> 1, e += Po(e / t); e > v1 * gg >> 1; )
    e = Po(e / v1), n += Xf;
  return Po(n + (v1 + 1) * e / (e + zne));
}, aie = function(e) {
  var t = [];
  e = nie(e);
  var r = e.length, n = Jne, i = 0, a = Qne, s, o;
  for (s = 0; s < e.length; s++)
    o = e[s], o < 128 && Ya(t, h1(o));
  var u = t.length, f = u;
  for (u && Ya(t, Hne); f < r; ) {
    var l = p1;
    for (s = 0; s < e.length; s++)
      o = e[s], o >= n && o < l && (l = o);
    var d = f + 1;
    if (l - n > Po((p1 - i) / d))
      throw a2(i2);
    for (i += (l - n) * d, n = l, s = 0; s < e.length; s++) {
      if (o = e[s], o < n && ++i > p1)
        throw a2(i2);
      if (o === n) {
        for (var c = i, p = Xf; ; ) {
          var v = p <= a ? d4 : p >= a + gg ? gg : p - a;
          if (c < v)
            break;
          var h = c - v, m = Xf - v;
          Ya(t, h1(o2(v + h % m))), c = Po(h / m), p += Xf;
        }
        Ya(t, h1(o2(c))), a = iie(i, d, f === u), i = 0, f++;
      }
    }
    i++, n++;
  }
  return p4(t, "");
}, sie = function(e) {
  var t = [], r = tie(eie(rie(e), c4, "."), "."), n, i;
  for (n = 0; n < r.length; n++)
    i = r[n], Ya(t, $ne(_ne, i) ? "xn--" + aie(i) : i);
  return p4(t, ".");
}, yg = xt, pu = Xt, Od = fr, zi = Kt, $o = Ar, v4 = l4, h4 = kn, oie = $i, uie = Bp, fie = Ca, lie = eF, eq = jn, m4 = vs, m1 = or, die = Tr, cie = Ka, pie = Fa, vie = Or, g4 = Rr, yn = $r, hie = cs, u2 = Js, Vg = Sp, mie = Ul, Wo = My, gie = lr, yie = LV, Vie = gie("iterator"), Ml = "URLSearchParams", y4 = Ml + "Iterator", V4 = eq.set, ii = eq.getterFor(Ml), qie = eq.getterFor(y4), bie = Object.getOwnPropertyDescriptor, tq = function(e) {
  if (!$o)
    return pu[e];
  var t = bie(pu, e);
  return t && t.value;
}, f2 = tq("fetch"), Dc = tq("Request"), Pf = tq("Headers"), g1 = Dc && Dc.prototype, l2 = Pf && Pf.prototype, Aie = pu.RegExp, wie = pu.TypeError, q4 = pu.decodeURIComponent, kie = pu.encodeURIComponent, Wie = zi("".charAt), d2 = zi([].join), Xs = zi([].push), qg = zi("".replace), Sie = zi([].shift), c2 = zi([].splice), p2 = zi("".split), Cie = zi("".slice), Fie = /\+/g, v2 = Array(4), Kie = function(e) {
  return v2[e - 1] || (v2[e - 1] = Aie("((?:%[\\da-f]{2}){" + e + "})", "gi"));
}, Rie = function(e) {
  try {
    return q4(e);
  } catch {
    return e;
  }
}, h2 = function(e) {
  var t = qg(e, Fie, " "), r = 4;
  try {
    return q4(t);
  } catch {
    for (; r; )
      t = qg(t, Kie(r--), Rie);
    return t;
  }
}, Tie = /[!'()~]|%20/g, Uie = {
  "!": "%21",
  "'": "%27",
  "(": "%28",
  ")": "%29",
  "~": "%7E",
  "%20": "+"
}, xie = function(e) {
  return Uie[e];
}, m2 = function(e) {
  return qg(kie(e), Tie, xie);
}, y1 = lie(function(t, r) {
  V4(this, {
    type: y4,
    iterator: Vg(ii(t).entries),
    kind: r
  });
}, "Iterator", function() {
  var t = qie(this), r = t.kind, n = t.iterator.next(), i = n.value;
  return n.done || (n.value = r === "keys" ? i.key : r === "values" ? i.value : [i.key, i.value]), n;
}, !0), b4 = function(e) {
  this.entries = [], this.url = null, e !== void 0 && (g4(e) ? this.parseObject(e) : this.parseQuery(typeof e == "string" ? Wie(e, 0) === "?" ? Cie(e, 1) : e : yn(e)));
};
b4.prototype = {
  type: Ml,
  bindURL: function(e) {
    this.url = e, this.update();
  },
  parseObject: function(e) {
    var t = mie(e), r, n, i, a, s, o, u;
    if (t)
      for (r = Vg(e, t), n = r.next; !(i = Od(n, r)).done; ) {
        if (a = Vg(vie(i.value)), s = a.next, (o = Od(s, a)).done || (u = Od(s, a)).done || !Od(s, a).done)
          throw wie("Expected sequence with length 2");
        Xs(this.entries, { key: yn(o.value), value: yn(u.value) });
      }
    else
      for (var f in e)
        die(e, f) && Xs(this.entries, { key: f, value: yn(e[f]) });
  },
  parseQuery: function(e) {
    if (e)
      for (var t = p2(e, "&"), r = 0, n, i; r < t.length; )
        n = t[r++], n.length && (i = p2(n, "="), Xs(this.entries, {
          key: h2(Sie(i)),
          value: h2(d2(i, "="))
        }));
  },
  serialize: function() {
    for (var e = this.entries, t = [], r = 0, n; r < e.length; )
      n = e[r++], Xs(t, m2(n.key) + "=" + m2(n.value));
    return d2(t, "&");
  },
  update: function() {
    this.entries.length = 0, this.parseQuery(this.url.query);
  },
  updateURL: function() {
    this.url && this.url.update();
  }
};
var _p = function() {
  m4(this, vu);
  var t = arguments.length > 0 ? arguments[0] : void 0, r = V4(this, new b4(t));
  $o || (this.size = r.entries.length);
}, vu = _p.prototype;
uie(vu, {
  // `URLSearchParams.prototype.append` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-append
  append: function(t, r) {
    var n = ii(this);
    Wo(arguments.length, 2), Xs(n.entries, { key: yn(t), value: yn(r) }), $o || this.length++, n.updateURL();
  },
  // `URLSearchParams.prototype.delete` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-delete
  delete: function(e) {
    for (var t = ii(this), r = Wo(arguments.length, 1), n = t.entries, i = yn(e), a = r < 2 ? void 0 : arguments[1], s = a === void 0 ? a : yn(a), o = 0; o < n.length; ) {
      var u = n[o];
      if (u.key === i && (s === void 0 || u.value === s)) {
        if (c2(n, o, 1), s !== void 0)
          break;
      } else
        o++;
    }
    $o || (this.size = n.length), t.updateURL();
  },
  // `URLSearchParams.prototype.get` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-get
  get: function(t) {
    var r = ii(this).entries;
    Wo(arguments.length, 1);
    for (var n = yn(t), i = 0; i < r.length; i++)
      if (r[i].key === n)
        return r[i].value;
    return null;
  },
  // `URLSearchParams.prototype.getAll` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-getall
  getAll: function(t) {
    var r = ii(this).entries;
    Wo(arguments.length, 1);
    for (var n = yn(t), i = [], a = 0; a < r.length; a++)
      r[a].key === n && Xs(i, r[a].value);
    return i;
  },
  // `URLSearchParams.prototype.has` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-has
  has: function(t) {
    for (var r = ii(this).entries, n = Wo(arguments.length, 1), i = yn(t), a = n < 2 ? void 0 : arguments[1], s = a === void 0 ? a : yn(a), o = 0; o < r.length; ) {
      var u = r[o++];
      if (u.key === i && (s === void 0 || u.value === s))
        return !0;
    }
    return !1;
  },
  // `URLSearchParams.prototype.set` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-set
  set: function(t, r) {
    var n = ii(this);
    Wo(arguments.length, 1);
    for (var i = n.entries, a = !1, s = yn(t), o = yn(r), u = 0, f; u < i.length; u++)
      f = i[u], f.key === s && (a ? c2(i, u--, 1) : (a = !0, f.value = o));
    a || Xs(i, { key: s, value: o }), $o || (this.size = i.length), n.updateURL();
  },
  // `URLSearchParams.prototype.sort` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-sort
  sort: function() {
    var t = ii(this);
    yie(t.entries, function(r, n) {
      return r.key > n.key ? 1 : -1;
    }), t.updateURL();
  },
  // `URLSearchParams.prototype.forEach` method
  forEach: function(t) {
    for (var r = ii(this).entries, n = cie(t, arguments.length > 1 ? arguments[1] : void 0), i = 0, a; i < r.length; )
      a = r[i++], n(a.value, a.key, this);
  },
  // `URLSearchParams.prototype.keys` method
  keys: function() {
    return new y1(this, "keys");
  },
  // `URLSearchParams.prototype.values` method
  values: function() {
    return new y1(this, "values");
  },
  // `URLSearchParams.prototype.entries` method
  entries: function() {
    return new y1(this, "entries");
  }
}, { enumerable: !0 });
h4(vu, Vie, vu.entries, { name: "entries" });
h4(vu, "toString", function() {
  return ii(this).serialize();
}, { enumerable: !0 });
$o && oie(vu, "size", {
  get: function() {
    return ii(this).entries.length;
  },
  configurable: !0,
  enumerable: !0
});
fie(_p, Ml);
yg({ global: !0, constructor: !0, forced: !v4 }, {
  URLSearchParams: _p
});
if (!v4 && m1(Pf)) {
  var Eie = zi(l2.has), Oie = zi(l2.set), g2 = function(e) {
    if (g4(e)) {
      var t = e.body, r;
      if (pie(t) === Ml)
        return r = e.headers ? new Pf(e.headers) : new Pf(), Eie(r, "content-type") || Oie(r, "content-type", "application/x-www-form-urlencoded;charset=UTF-8"), hie(e, {
          body: u2(0, yn(t)),
          headers: u2(0, r)
        });
    }
    return e;
  };
  if (m1(f2) && yg({ global: !0, enumerable: !0, dontCallGetSet: !0, forced: !0 }, {
    fetch: function(t) {
      return f2(t, arguments.length > 1 ? g2(arguments[1]) : {});
    }
  }), m1(Dc)) {
    var V1 = function(t) {
      return m4(this, g1), new Dc(t, arguments.length > 1 ? g2(arguments[1]) : {});
    };
    g1.constructor = V1, V1.prototype = g1, yg({ global: !0, constructor: !0, dontCallGetSet: !0, forced: !0 }, {
      Request: V1
    });
  }
}
var Nie = {
  URLSearchParams: _p,
  getState: ii
}, Iie = xt, rq = Ar, Xie = l4, nq = Xt, y2 = Ka, pi = Kt, Lc = kn, ei = $i, Pie = vs, bg = Tr, iq = T9, So = HC, Vi = kl, Bie = $y.codeAt, Die = sie, oa = $r, Lie = Ca, Zie = My, A4 = Nie, w4 = jn, Mie = w4.set, Zc = w4.getterFor("URL"), jie = A4.URLSearchParams, Yie = A4.getState, Vf = nq.URL, Ag = nq.TypeError, Mc = nq.parseInt, zie = Math.floor, V2 = Math.pow, si = pi("".charAt), wi = pi(/./.exec), Rf = pi([].join), Gie = pi(1 .toString), Qie = pi([].pop), Oo = pi([].push), q1 = pi("".replace), Jie = pi([].shift), Hie = pi("".split), Bf = pi("".slice), jc = pi("".toLowerCase), _ie = pi([].unshift), $ie = "Invalid authority", b1 = "Invalid scheme", Ks = "Invalid host", q2 = "Invalid port", k4 = /[a-z]/i, eae = /[\d+-.a-z]/i, wg = /\d/, tae = /^0x/i, rae = /^[0-7]+$/, nae = /^\d+$/, W4 = /^[\da-f]+$/i, iae = /[\0\t\n\r #%/:<>?@[\\\]^|]/, aae = /[\0\t\n\r #/:<>?@[\\\]^|]/, sae = /^[\u0000-\u0020]+/, oae = /(^|[^\u0000-\u0020])[\u0000-\u0020]+$/, uae = /[\t\n\r]/g, ti, fae = function(e) {
  var t = Hie(e, "."), r, n, i, a, s, o, u;
  if (t.length && t[t.length - 1] === "" && t.length--, r = t.length, r > 4)
    return e;
  for (n = [], i = 0; i < r; i++) {
    if (a = t[i], a === "")
      return e;
    if (s = 10, a.length > 1 && si(a, 0) === "0" && (s = wi(tae, a) ? 16 : 8, a = Bf(a, s === 8 ? 1 : 2)), a === "")
      o = 0;
    else {
      if (!wi(s === 10 ? nae : s === 8 ? rae : W4, a))
        return e;
      o = Mc(a, s);
    }
    Oo(n, o);
  }
  for (i = 0; i < r; i++)
    if (o = n[i], i === r - 1) {
      if (o >= V2(256, 5 - r))
        return null;
    } else if (o > 255)
      return null;
  for (u = Qie(n), i = 0; i < n.length; i++)
    u += n[i] * V2(256, 3 - i);
  return u;
}, lae = function(e) {
  var t = [0, 0, 0, 0, 0, 0, 0, 0], r = 0, n = null, i = 0, a, s, o, u, f, l, d, c = function() {
    return si(e, i);
  };
  if (c() === ":") {
    if (si(e, 1) !== ":")
      return;
    i += 2, r++, n = r;
  }
  for (; c(); ) {
    if (r === 8)
      return;
    if (c() === ":") {
      if (n !== null)
        return;
      i++, r++, n = r;
      continue;
    }
    for (a = s = 0; s < 4 && wi(W4, c()); )
      a = a * 16 + Mc(c(), 16), i++, s++;
    if (c() === ".") {
      if (s === 0 || (i -= s, r > 6))
        return;
      for (o = 0; c(); ) {
        if (u = null, o > 0)
          if (c() === "." && o < 4)
            i++;
          else
            return;
        if (!wi(wg, c()))
          return;
        for (; wi(wg, c()); ) {
          if (f = Mc(c(), 10), u === null)
            u = f;
          else {
            if (u === 0)
              return;
            u = u * 10 + f;
          }
          if (u > 255)
            return;
          i++;
        }
        t[r] = t[r] * 256 + u, o++, (o === 2 || o === 4) && r++;
      }
      if (o !== 4)
        return;
      break;
    } else if (c() === ":") {
      if (i++, !c())
        return;
    } else if (c())
      return;
    t[r++] = a;
  }
  if (n !== null)
    for (l = r - n, r = 7; r !== 0 && l > 0; )
      d = t[r], t[r--] = t[n + l - 1], t[n + --l] = d;
  else if (r !== 8)
    return;
  return t;
}, dae = function(e) {
  for (var t = null, r = 1, n = null, i = 0, a = 0; a < 8; a++)
    e[a] !== 0 ? (i > r && (t = n, r = i), n = null, i = 0) : (n === null && (n = a), ++i);
  return i > r && (t = n, r = i), t;
}, qf = function(e) {
  var t, r, n, i;
  if (typeof e == "number") {
    for (t = [], r = 0; r < 4; r++)
      _ie(t, e % 256), e = zie(e / 256);
    return Rf(t, ".");
  } else if (typeof e == "object") {
    for (t = "", n = dae(e), r = 0; r < 8; r++)
      i && e[r] === 0 || (i && (i = !1), n === r ? (t += r ? ":" : "::", i = !0) : (t += Gie(e[r], 16), r < 7 && (t += ":")));
    return "[" + t + "]";
  }
  return e;
}, sc = {}, S4 = iq({}, sc, {
  " ": 1,
  '"': 1,
  "<": 1,
  ">": 1,
  "`": 1
}), C4 = iq({}, S4, {
  "#": 1,
  "?": 1,
  "{": 1,
  "}": 1
}), A1 = iq({}, C4, {
  "/": 1,
  ":": 1,
  ";": 1,
  "=": 1,
  "@": 1,
  "[": 1,
  "\\": 1,
  "]": 1,
  "^": 1,
  "|": 1
}), La = function(e, t) {
  var r = Bie(e, 0);
  return r > 32 && r < 127 && !bg(t, e) ? e : encodeURIComponent(e);
}, Nd = {
  ftp: 21,
  file: null,
  http: 80,
  https: 443,
  ws: 80,
  wss: 443
}, Tf = function(e, t) {
  var r;
  return e.length === 2 && wi(k4, si(e, 0)) && ((r = si(e, 1)) === ":" || !t && r === "|");
}, b2 = function(e) {
  var t;
  return e.length > 1 && Tf(Bf(e, 0, 2)) && (e.length === 2 || (t = si(e, 2)) === "/" || t === "\\" || t === "?" || t === "#");
}, cae = function(e) {
  return e === "." || jc(e) === "%2e";
}, pae = function(e) {
  return e = jc(e), e === ".." || e === "%2e." || e === ".%2e" || e === "%2e%2e";
}, w1 = {}, A2 = {}, k1 = {}, w2 = {}, k2 = {}, W1 = {}, W2 = {}, S2 = {}, Id = {}, Xd = {}, S1 = {}, C1 = {}, F1 = {}, K1 = {}, C2 = {}, R1 = {}, Co = {}, Ei = {}, F2 = {}, Rs = {}, ia = {}, aq = function(e, t, r) {
  var n = oa(e), i, a, s;
  if (t) {
    if (a = this.parse(n), a)
      throw Ag(a);
    this.searchParams = null;
  } else {
    if (r !== void 0 && (i = new aq(r, !0)), a = this.parse(n, null, i), a)
      throw Ag(a);
    s = Yie(new jie()), s.bindURL(this), this.searchParams = s;
  }
};
aq.prototype = {
  type: "URL",
  // https://url.spec.whatwg.org/#url-parsing
  // eslint-disable-next-line max-statements -- TODO
  parse: function(e, t, r) {
    var n = this, i = t || w1, a = 0, s = "", o = !1, u = !1, f = !1, l, d, c, p;
    for (e = oa(e), t || (n.scheme = "", n.username = "", n.password = "", n.host = null, n.port = null, n.path = [], n.query = null, n.fragment = null, n.cannotBeABaseURL = !1, e = q1(e, sae, ""), e = q1(e, oae, "$1")), e = q1(e, uae, ""), l = So(e); a <= l.length; ) {
      switch (d = l[a], i) {
        case w1:
          if (d && wi(k4, d))
            s += jc(d), i = A2;
          else {
            if (t)
              return b1;
            i = k1;
            continue;
          }
          break;
        case A2:
          if (d && (wi(eae, d) || d === "+" || d === "-" || d === "."))
            s += jc(d);
          else if (d === ":") {
            if (t && (n.isSpecial() !== bg(Nd, s) || s === "file" && (n.includesCredentials() || n.port !== null) || n.scheme === "file" && !n.host))
              return;
            if (n.scheme = s, t) {
              n.isSpecial() && Nd[n.scheme] === n.port && (n.port = null);
              return;
            }
            s = "", n.scheme === "file" ? i = K1 : n.isSpecial() && r && r.scheme === n.scheme ? i = w2 : n.isSpecial() ? i = S2 : l[a + 1] === "/" ? (i = k2, a++) : (n.cannotBeABaseURL = !0, Oo(n.path, ""), i = F2);
          } else {
            if (t)
              return b1;
            s = "", i = k1, a = 0;
            continue;
          }
          break;
        case k1:
          if (!r || r.cannotBeABaseURL && d !== "#")
            return b1;
          if (r.cannotBeABaseURL && d === "#") {
            n.scheme = r.scheme, n.path = Vi(r.path), n.query = r.query, n.fragment = "", n.cannotBeABaseURL = !0, i = ia;
            break;
          }
          i = r.scheme === "file" ? K1 : W1;
          continue;
        case w2:
          if (d === "/" && l[a + 1] === "/")
            i = Id, a++;
          else {
            i = W1;
            continue;
          }
          break;
        case k2:
          if (d === "/") {
            i = Xd;
            break;
          } else {
            i = Ei;
            continue;
          }
        case W1:
          if (n.scheme = r.scheme, d === ti)
            n.username = r.username, n.password = r.password, n.host = r.host, n.port = r.port, n.path = Vi(r.path), n.query = r.query;
          else if (d === "/" || d === "\\" && n.isSpecial())
            i = W2;
          else if (d === "?")
            n.username = r.username, n.password = r.password, n.host = r.host, n.port = r.port, n.path = Vi(r.path), n.query = "", i = Rs;
          else if (d === "#")
            n.username = r.username, n.password = r.password, n.host = r.host, n.port = r.port, n.path = Vi(r.path), n.query = r.query, n.fragment = "", i = ia;
          else {
            n.username = r.username, n.password = r.password, n.host = r.host, n.port = r.port, n.path = Vi(r.path), n.path.length--, i = Ei;
            continue;
          }
          break;
        case W2:
          if (n.isSpecial() && (d === "/" || d === "\\"))
            i = Id;
          else if (d === "/")
            i = Xd;
          else {
            n.username = r.username, n.password = r.password, n.host = r.host, n.port = r.port, i = Ei;
            continue;
          }
          break;
        case S2:
          if (i = Id, d !== "/" || si(s, a + 1) !== "/")
            continue;
          a++;
          break;
        case Id:
          if (d !== "/" && d !== "\\") {
            i = Xd;
            continue;
          }
          break;
        case Xd:
          if (d === "@") {
            o && (s = "%40" + s), o = !0, c = So(s);
            for (var v = 0; v < c.length; v++) {
              var h = c[v];
              if (h === ":" && !f) {
                f = !0;
                continue;
              }
              var m = La(h, A1);
              f ? n.password += m : n.username += m;
            }
            s = "";
          } else if (d === ti || d === "/" || d === "?" || d === "#" || d === "\\" && n.isSpecial()) {
            if (o && s === "")
              return $ie;
            a -= So(s).length + 1, s = "", i = S1;
          } else
            s += d;
          break;
        case S1:
        case C1:
          if (t && n.scheme === "file") {
            i = R1;
            continue;
          } else if (d === ":" && !u) {
            if (s === "")
              return Ks;
            if (p = n.parseHost(s), p)
              return p;
            if (s = "", i = F1, t === C1)
              return;
          } else if (d === ti || d === "/" || d === "?" || d === "#" || d === "\\" && n.isSpecial()) {
            if (n.isSpecial() && s === "")
              return Ks;
            if (t && s === "" && (n.includesCredentials() || n.port !== null))
              return;
            if (p = n.parseHost(s), p)
              return p;
            if (s = "", i = Co, t)
              return;
            continue;
          } else
            d === "[" ? u = !0 : d === "]" && (u = !1), s += d;
          break;
        case F1:
          if (wi(wg, d))
            s += d;
          else if (d === ti || d === "/" || d === "?" || d === "#" || d === "\\" && n.isSpecial() || t) {
            if (s !== "") {
              var q = Mc(s, 10);
              if (q > 65535)
                return q2;
              n.port = n.isSpecial() && q === Nd[n.scheme] ? null : q, s = "";
            }
            if (t)
              return;
            i = Co;
            continue;
          } else
            return q2;
          break;
        case K1:
          if (n.scheme = "file", d === "/" || d === "\\")
            i = C2;
          else if (r && r.scheme === "file")
            switch (d) {
              case ti:
                n.host = r.host, n.path = Vi(r.path), n.query = r.query;
                break;
              case "?":
                n.host = r.host, n.path = Vi(r.path), n.query = "", i = Rs;
                break;
              case "#":
                n.host = r.host, n.path = Vi(r.path), n.query = r.query, n.fragment = "", i = ia;
                break;
              default:
                b2(Rf(Vi(l, a), "")) || (n.host = r.host, n.path = Vi(r.path), n.shortenPath()), i = Ei;
                continue;
            }
          else {
            i = Ei;
            continue;
          }
          break;
        case C2:
          if (d === "/" || d === "\\") {
            i = R1;
            break;
          }
          r && r.scheme === "file" && !b2(Rf(Vi(l, a), "")) && (Tf(r.path[0], !0) ? Oo(n.path, r.path[0]) : n.host = r.host), i = Ei;
          continue;
        case R1:
          if (d === ti || d === "/" || d === "\\" || d === "?" || d === "#") {
            if (!t && Tf(s))
              i = Ei;
            else if (s === "") {
              if (n.host = "", t)
                return;
              i = Co;
            } else {
              if (p = n.parseHost(s), p)
                return p;
              if (n.host === "localhost" && (n.host = ""), t)
                return;
              s = "", i = Co;
            }
            continue;
          } else
            s += d;
          break;
        case Co:
          if (n.isSpecial()) {
            if (i = Ei, d !== "/" && d !== "\\")
              continue;
          } else if (!t && d === "?")
            n.query = "", i = Rs;
          else if (!t && d === "#")
            n.fragment = "", i = ia;
          else if (d !== ti && (i = Ei, d !== "/"))
            continue;
          break;
        case Ei:
          if (d === ti || d === "/" || d === "\\" && n.isSpecial() || !t && (d === "?" || d === "#")) {
            if (pae(s) ? (n.shortenPath(), d !== "/" && !(d === "\\" && n.isSpecial()) && Oo(n.path, "")) : cae(s) ? d !== "/" && !(d === "\\" && n.isSpecial()) && Oo(n.path, "") : (n.scheme === "file" && !n.path.length && Tf(s) && (n.host && (n.host = ""), s = si(s, 0) + ":"), Oo(n.path, s)), s = "", n.scheme === "file" && (d === ti || d === "?" || d === "#"))
              for (; n.path.length > 1 && n.path[0] === ""; )
                Jie(n.path);
            d === "?" ? (n.query = "", i = Rs) : d === "#" && (n.fragment = "", i = ia);
          } else
            s += La(d, C4);
          break;
        case F2:
          d === "?" ? (n.query = "", i = Rs) : d === "#" ? (n.fragment = "", i = ia) : d !== ti && (n.path[0] += La(d, sc));
          break;
        case Rs:
          !t && d === "#" ? (n.fragment = "", i = ia) : d !== ti && (d === "'" && n.isSpecial() ? n.query += "%27" : d === "#" ? n.query += "%23" : n.query += La(d, sc));
          break;
        case ia:
          d !== ti && (n.fragment += La(d, S4));
          break;
      }
      a++;
    }
  },
  // https://url.spec.whatwg.org/#host-parsing
  parseHost: function(e) {
    var t, r, n;
    if (si(e, 0) === "[") {
      if (si(e, e.length - 1) !== "]" || (t = lae(Bf(e, 1, -1)), !t))
        return Ks;
      this.host = t;
    } else if (this.isSpecial()) {
      if (e = Die(e), wi(iae, e) || (t = fae(e), t === null))
        return Ks;
      this.host = t;
    } else {
      if (wi(aae, e))
        return Ks;
      for (t = "", r = So(e), n = 0; n < r.length; n++)
        t += La(r[n], sc);
      this.host = t;
    }
  },
  // https://url.spec.whatwg.org/#cannot-have-a-username-password-port
  cannotHaveUsernamePasswordPort: function() {
    return !this.host || this.cannotBeABaseURL || this.scheme === "file";
  },
  // https://url.spec.whatwg.org/#include-credentials
  includesCredentials: function() {
    return this.username !== "" || this.password !== "";
  },
  // https://url.spec.whatwg.org/#is-special
  isSpecial: function() {
    return bg(Nd, this.scheme);
  },
  // https://url.spec.whatwg.org/#shorten-a-urls-path
  shortenPath: function() {
    var e = this.path, t = e.length;
    t && (this.scheme !== "file" || t !== 1 || !Tf(e[0], !0)) && e.length--;
  },
  // https://url.spec.whatwg.org/#concept-url-serializer
  serialize: function() {
    var e = this, t = e.scheme, r = e.username, n = e.password, i = e.host, a = e.port, s = e.path, o = e.query, u = e.fragment, f = t + ":";
    return i !== null ? (f += "//", e.includesCredentials() && (f += r + (n ? ":" + n : "") + "@"), f += qf(i), a !== null && (f += ":" + a)) : t === "file" && (f += "//"), f += e.cannotBeABaseURL ? s[0] : s.length ? "/" + Rf(s, "/") : "", o !== null && (f += "?" + o), u !== null && (f += "#" + u), f;
  },
  // https://url.spec.whatwg.org/#dom-url-href
  setHref: function(e) {
    var t = this.parse(e);
    if (t)
      throw Ag(t);
    this.searchParams.update();
  },
  // https://url.spec.whatwg.org/#dom-url-origin
  getOrigin: function() {
    var e = this.scheme, t = this.port;
    if (e === "blob")
      try {
        return new hu(e.path[0]).origin;
      } catch {
        return "null";
      }
    return e === "file" || !this.isSpecial() ? "null" : e + "://" + qf(this.host) + (t !== null ? ":" + t : "");
  },
  // https://url.spec.whatwg.org/#dom-url-protocol
  getProtocol: function() {
    return this.scheme + ":";
  },
  setProtocol: function(e) {
    this.parse(oa(e) + ":", w1);
  },
  // https://url.spec.whatwg.org/#dom-url-username
  getUsername: function() {
    return this.username;
  },
  setUsername: function(e) {
    var t = So(oa(e));
    if (!this.cannotHaveUsernamePasswordPort()) {
      this.username = "";
      for (var r = 0; r < t.length; r++)
        this.username += La(t[r], A1);
    }
  },
  // https://url.spec.whatwg.org/#dom-url-password
  getPassword: function() {
    return this.password;
  },
  setPassword: function(e) {
    var t = So(oa(e));
    if (!this.cannotHaveUsernamePasswordPort()) {
      this.password = "";
      for (var r = 0; r < t.length; r++)
        this.password += La(t[r], A1);
    }
  },
  // https://url.spec.whatwg.org/#dom-url-host
  getHost: function() {
    var e = this.host, t = this.port;
    return e === null ? "" : t === null ? qf(e) : qf(e) + ":" + t;
  },
  setHost: function(e) {
    this.cannotBeABaseURL || this.parse(e, S1);
  },
  // https://url.spec.whatwg.org/#dom-url-hostname
  getHostname: function() {
    var e = this.host;
    return e === null ? "" : qf(e);
  },
  setHostname: function(e) {
    this.cannotBeABaseURL || this.parse(e, C1);
  },
  // https://url.spec.whatwg.org/#dom-url-port
  getPort: function() {
    var e = this.port;
    return e === null ? "" : oa(e);
  },
  setPort: function(e) {
    this.cannotHaveUsernamePasswordPort() || (e = oa(e), e === "" ? this.port = null : this.parse(e, F1));
  },
  // https://url.spec.whatwg.org/#dom-url-pathname
  getPathname: function() {
    var e = this.path;
    return this.cannotBeABaseURL ? e[0] : e.length ? "/" + Rf(e, "/") : "";
  },
  setPathname: function(e) {
    this.cannotBeABaseURL || (this.path = [], this.parse(e, Co));
  },
  // https://url.spec.whatwg.org/#dom-url-search
  getSearch: function() {
    var e = this.query;
    return e ? "?" + e : "";
  },
  setSearch: function(e) {
    e = oa(e), e === "" ? this.query = null : (si(e, 0) === "?" && (e = Bf(e, 1)), this.query = "", this.parse(e, Rs)), this.searchParams.update();
  },
  // https://url.spec.whatwg.org/#dom-url-searchparams
  getSearchParams: function() {
    return this.searchParams.facade;
  },
  // https://url.spec.whatwg.org/#dom-url-hash
  getHash: function() {
    var e = this.fragment;
    return e ? "#" + e : "";
  },
  setHash: function(e) {
    if (e = oa(e), e === "") {
      this.fragment = null;
      return;
    }
    si(e, 0) === "#" && (e = Bf(e, 1)), this.fragment = "", this.parse(e, ia);
  },
  update: function() {
    this.query = this.searchParams.serialize() || null;
  }
};
var hu = function(t) {
  var r = Pie(this, gn), n = Zie(arguments.length, 1) > 1 ? arguments[1] : void 0, i = Mie(r, new aq(t, !1, n));
  rq || (r.href = i.serialize(), r.origin = i.getOrigin(), r.protocol = i.getProtocol(), r.username = i.getUsername(), r.password = i.getPassword(), r.host = i.getHost(), r.hostname = i.getHostname(), r.port = i.getPort(), r.pathname = i.getPathname(), r.search = i.getSearch(), r.searchParams = i.getSearchParams(), r.hash = i.getHash());
}, gn = hu.prototype, ri = function(e, t) {
  return {
    get: function() {
      return Zc(this)[e]();
    },
    set: t && function(r) {
      return Zc(this)[t](r);
    },
    configurable: !0,
    enumerable: !0
  };
};
rq && (ei(gn, "href", ri("serialize", "setHref")), ei(gn, "origin", ri("getOrigin")), ei(gn, "protocol", ri("getProtocol", "setProtocol")), ei(gn, "username", ri("getUsername", "setUsername")), ei(gn, "password", ri("getPassword", "setPassword")), ei(gn, "host", ri("getHost", "setHost")), ei(gn, "hostname", ri("getHostname", "setHostname")), ei(gn, "port", ri("getPort", "setPort")), ei(gn, "pathname", ri("getPathname", "setPathname")), ei(gn, "search", ri("getSearch", "setSearch")), ei(gn, "searchParams", ri("getSearchParams")), ei(gn, "hash", ri("getHash", "setHash")));
Lc(gn, "toJSON", function() {
  return Zc(this).serialize();
}, { enumerable: !0 });
Lc(gn, "toString", function() {
  return Zc(this).serialize();
}, { enumerable: !0 });
if (Vf) {
  var K2 = Vf.createObjectURL, R2 = Vf.revokeObjectURL;
  K2 && Lc(hu, "createObjectURL", y2(K2, Vf)), R2 && Lc(hu, "revokeObjectURL", y2(R2, Vf));
}
Lie(hu, "URL");
Iie({ global: !0, constructor: !0, forced: !Xie, sham: !rq }, {
  URL: hu
});
/*
@license
Copyright (c) 2018, Twilio, Inc.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted, provided that the above
copyright notice and this permission notice appear in all copies.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES
WITH REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF
MERCHANTABILITY AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY
SPECIAL, DIRECT, INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES
WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION
OF CONTRACT, NEGLIGENCE OR OTHER TORTIOUS ACTION, ARISING OUT OF OR IN
CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.

*/
(function(e) {
  var t = typeof t < "u" ? t : typeof self < "u" ? self : typeof window < "u" ? window : {};
  Object.defineProperty(e, "__esModule", { value: !0 });
  var r = ra, n = ps, i = ea, a = ta, s = ci, o = Jp, u = ro, f = Kl, l = El, d = di, c = Nl, p = Ua, v = rn;
  function h(fe) {
    return fe && typeof fe == "object" && "default" in fe ? fe : { default: fe };
  }
  function m(fe) {
    if (fe && fe.__esModule)
      return fe;
    var ke = /* @__PURE__ */ Object.create(null);
    return fe && Object.keys(fe).forEach(function(ae) {
      if (ae !== "default") {
        var me = Object.getOwnPropertyDescriptor(fe, ae);
        Object.defineProperty(ke, ae, me.get ? me : {
          enumerable: !0,
          get: function() {
            return fe[ae];
          }
        });
      }
    }), ke.default = fe, Object.freeze(ke);
  }
  var q = /* @__PURE__ */ h(r), w = /* @__PURE__ */ h(n), O = /* @__PURE__ */ h(i), C = /* @__PURE__ */ h(a), R = /* @__PURE__ */ h(s), I = /* @__PURE__ */ h(o), P = /* @__PURE__ */ h(u), K = /* @__PURE__ */ h(f), B = /* @__PURE__ */ h(l), L = /* @__PURE__ */ h(d), _ = /* @__PURE__ */ m(c), ne = { exports: {} }, Z = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto < "u" && typeof window.msCrypto.getRandomValues == "function" && msCrypto.getRandomValues.bind(msCrypto);
  if (Z) {
    var le = new Uint8Array(16);
    ne.exports = function() {
      return Z(le), le;
    };
  } else {
    var he = new Array(16);
    ne.exports = function() {
      for (var ke = 0, ae; ke < 16; ke++)
        ke & 3 || (ae = Math.random() * 4294967296), he[ke] = ae >>> ((ke & 3) << 3) & 255;
      return he;
    };
  }
  for (var Ie = [], xe = 0; xe < 256; ++xe)
    Ie[xe] = (xe + 256).toString(16).substr(1);
  function ye(fe, ke) {
    var ae = ke || 0, me = Ie;
    return [me[fe[ae++]], me[fe[ae++]], me[fe[ae++]], me[fe[ae++]], "-", me[fe[ae++]], me[fe[ae++]], "-", me[fe[ae++]], me[fe[ae++]], "-", me[fe[ae++]], me[fe[ae++]], "-", me[fe[ae++]], me[fe[ae++]], me[fe[ae++]], me[fe[ae++]], me[fe[ae++]], me[fe[ae++]]].join("");
  }
  var ue = ye, M = ne.exports, F = ue, pe, We, ce = 0, oe = 0;
  function z(fe, ke, ae) {
    var me = ke && ae || 0, se = ke || [];
    fe = fe || {};
    var ze = fe.node || pe, Pe = fe.clockseq !== void 0 ? fe.clockseq : We;
    if (ze == null || Pe == null) {
      var dt = M();
      ze == null && (ze = pe = [dt[0] | 1, dt[1], dt[2], dt[3], dt[4], dt[5]]), Pe == null && (Pe = We = (dt[6] << 8 | dt[7]) & 16383);
    }
    var tt = fe.msecs !== void 0 ? fe.msecs : (/* @__PURE__ */ new Date()).getTime(), st = fe.nsecs !== void 0 ? fe.nsecs : oe + 1, vt = tt - ce + (st - oe) / 1e4;
    if (vt < 0 && fe.clockseq === void 0 && (Pe = Pe + 1 & 16383), (vt < 0 || tt > ce) && fe.nsecs === void 0 && (st = 0), st >= 1e4)
      throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
    ce = tt, oe = st, We = Pe, tt += 122192928e5;
    var ht = ((tt & 268435455) * 1e4 + st) % 4294967296;
    se[me++] = ht >>> 24 & 255, se[me++] = ht >>> 16 & 255, se[me++] = ht >>> 8 & 255, se[me++] = ht & 255;
    var lt = tt / 4294967296 * 1e4 & 268435455;
    se[me++] = lt >>> 8 & 255, se[me++] = lt & 255, se[me++] = lt >>> 24 & 15 | 16, se[me++] = lt >>> 16 & 255, se[me++] = Pe >>> 8 | 128, se[me++] = Pe & 255;
    for (var G = 0; G < 6; ++G)
      se[me + G] = ze[G];
    return ke || F(se);
  }
  var Ze = z, Ae = ne.exports, re = ue;
  function Qe(fe, ke, ae) {
    var me = ke && ae || 0;
    typeof fe == "string" && (ke = fe === "binary" ? new Array(16) : null, fe = null), fe = fe || {};
    var se = fe.random || (fe.rng || Ae)();
    if (se[6] = se[6] & 15 | 64, se[8] = se[8] & 63 | 128, ke)
      for (var ze = 0; ze < 16; ++ze)
        ke[me + ze] = se[ze];
    return ke || re(se);
  }
  var Ee = Qe, Ue = Ze, He = Ee, te = He;
  te.v1 = Ue, te.v4 = He;
  var it = te;
  function Vt(fe) {
    var ke = Oe();
    return function() {
      var me = R.default(fe), se;
      if (ke) {
        var ze = R.default(this).constructor;
        se = Reflect.construct(me, arguments, ze);
      } else
        se = me.apply(this, arguments);
      return C.default(this, se);
    };
  }
  function Oe() {
    if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
      return !1;
    if (typeof Proxy == "function")
      return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      })), !0;
    } catch {
      return !1;
    }
  }
  var Bt = /* @__PURE__ */ function(fe) {
    O.default(ae, fe);
    var ke = Vt(ae);
    function ae(me) {
      var se;
      q.default(this, ae);
      var ze = it.v4(), Pe;
      return se = ke.call(this, function(dt, tt) {
        return Pe = tt, me(function(st) {
          ae.cancellationMap.delete(ze), dt(st);
        }, function(st) {
          ae.cancellationMap.delete(ze), tt(st);
        }, function(st) {
          ae.cancellationMap.set(ze, st);
        });
      }), se.id = ze, se.rejectPromise = Pe, se;
    }
    return w.default(ae, [{
      key: "cancel",
      value: function() {
        var se = ae.cancellationMap.get(this.id);
        return se == null || se(), this.rejectPromise && (this.catch(function() {
        }), this.rejectPromise(new Error("Promise was cancelled"))), this;
      }
    }]), ae;
  }(/* @__PURE__ */ I.default(Promise));
  P.default(Bt, "cancellationMap", /* @__PURE__ */ new Map());
  function mt(fe, ke, ae, me) {
    var se = arguments.length, ze = se < 3 ? ke : me === null ? me = Object.getOwnPropertyDescriptor(ke, ae) : me, Pe;
    if ((typeof Reflect > "u" ? "undefined" : L.default(Reflect)) === "object" && typeof Reflect.decorate == "function")
      ze = Reflect.decorate(fe, ke, ae, me);
    else
      for (var dt = fe.length - 1; dt >= 0; dt--)
        (Pe = fe[dt]) && (ze = (se < 3 ? Pe(ze) : se > 3 ? Pe(ke, ae, ze) : Pe(ke, ae)) || ze);
    return se > 3 && ze && Object.defineProperty(ke, ae, ze), ze;
  }
  function Ot(fe, ke) {
    if ((typeof Reflect > "u" ? "undefined" : L.default(Reflect)) === "object" && typeof Reflect.metadata == "function")
      return Reflect.metadata(fe, ke);
  }
  function It(fe, ke) {
    return ["".concat((/* @__PURE__ */ new Date()).toISOString(), " MCS Client ").concat(fe, ":")].concat(Array.from(ke));
  }
  var Me = /* @__PURE__ */ function() {
    function fe(ke) {
      q.default(this, fe), P.default(this, "prefix", ""), this.prefix = ke != null && ke.length > 0 ? ke + " " : "";
    }
    return w.default(fe, [{
      key: "setLevel",
      value: function(ae) {
        _.setLevel(ae);
      }
    }, {
      key: "trace",
      value: (
        /* eslint-disable @typescript-eslint/explicit-module-boundary-types */
        function() {
          for (var ae = arguments.length, me = new Array(ae), se = 0; se < ae; se++)
            me[se] = arguments[se];
          _.trace.apply(null, It(this.prefix + "T", me));
        }
      )
    }, {
      key: "debug",
      value: function() {
        for (var ae = arguments.length, me = new Array(ae), se = 0; se < ae; se++)
          me[se] = arguments[se];
        _.debug.apply(null, It(this.prefix + "D", me));
      }
    }, {
      key: "info",
      value: function() {
        for (var ae = arguments.length, me = new Array(ae), se = 0; se < ae; se++)
          me[se] = arguments[se];
        _.info.apply(null, It(this.prefix + "I", me));
      }
    }, {
      key: "warn",
      value: function() {
        for (var ae = arguments.length, me = new Array(ae), se = 0; se < ae; se++)
          me[se] = arguments[se];
        _.warn.apply(null, It(this.prefix + "W", me));
      }
    }, {
      key: "error",
      value: function() {
        for (var ae = arguments.length, me = new Array(ae), se = 0; se < ae; se++)
          me[se] = arguments[se];
        _.error.apply(null, It(this.prefix + "E", me));
      }
    }], [{
      key: "scope",
      value: function(ae) {
        return new fe(ae);
      }
    }, {
      key: "setLevel",
      value: function(ae) {
        _.setLevel(ae);
      }
    }, {
      key: "trace",
      value: function() {
        for (var ae = arguments.length, me = new Array(ae), se = 0; se < ae; se++)
          me[se] = arguments[se];
        _.trace.apply(null, It("T", me));
      }
    }, {
      key: "debug",
      value: function() {
        for (var ae = arguments.length, me = new Array(ae), se = 0; se < ae; se++)
          me[se] = arguments[se];
        _.debug.apply(null, It("D", me));
      }
    }, {
      key: "info",
      value: function() {
        for (var ae = arguments.length, me = new Array(ae), se = 0; se < ae; se++)
          me[se] = arguments[se];
        _.info.apply(null, It("I", me));
      }
    }, {
      key: "warn",
      value: function() {
        for (var ae = arguments.length, me = new Array(ae), se = 0; se < ae; se++)
          me[se] = arguments[se];
        _.warn.apply(null, It("W", me));
      }
    }, {
      key: "error",
      value: function() {
        for (var ae = arguments.length, me = new Array(ae), se = 0; se < ae; se++)
          me[se] = arguments[se];
        _.error.apply(null, It("E", me));
      }
    }]), fe;
  }(), Gr = 1e3, $e = 4e3, Je = 3, qt = !0, ft = function(ke) {
    return "https://mcs.".concat(ke ?? "us1", ".twilio.com");
  }, at = function(ke) {
    return ke.startsWith("http");
  }, rt = function(ke, ae) {
    return "".concat(at(ke) ? "" : ft(ae)).concat(ke);
  }, Dt = /* @__PURE__ */ function() {
    function fe(ke, ae, me, se) {
      var ze, Pe, dt, tt, st, vt;
      q.default(this, fe);
      var ht = (ze = (Pe = se.MCS) !== null && Pe !== void 0 ? Pe : se) !== null && ze !== void 0 ? ze : {};
      this.region = (dt = (tt = ht.region) !== null && tt !== void 0 ? tt : se.region) !== null && dt !== void 0 ? dt : "us1", this.mediaUrl = rt(ae, this.region), this.mediaSetUrl = me ? rt(me) : "".concat(this.mediaUrl, "Set"), this.token = ke, this.retryWhenThrottledOverride = (st = ht.retryWhenThrottledOverride) !== null && st !== void 0 ? st : qt, this.backoffConfigOverride = (vt = ht.backoffConfigOverride) !== null && vt !== void 0 ? vt : fe.backoffConfigDefault;
    }
    return w.default(fe, [{
      key: "updateToken",
      value: function(ae) {
        this.token = ae;
      }
    }], [{
      key: "backoffConfigDefault",
      get: function() {
        return {
          min: Gr,
          max: $e,
          maxAttemptsCount: Je
        };
      }
    }, {
      key: "retryWhenThrottledDefault",
      get: function() {
        return qt;
      }
    }]), fe;
  }(), vr = /* @__PURE__ */ function() {
    function fe(ke, ae, me) {
      q.default(this, fe), this.config = ke, this.network = ae, this._update(me);
    }
    return w.default(fe, [{
      key: "sid",
      get: function() {
        return this.state.sid;
      }
    }, {
      key: "serviceSid",
      get: function() {
        return this.state.serviceSid;
      }
    }, {
      key: "dateCreated",
      get: function() {
        return this.state.dateCreated;
      }
    }, {
      key: "dateUpdated",
      get: function() {
        return this.state.dateUpdated;
      }
    }, {
      key: "contentType",
      get: function() {
        return this.state.contentType;
      }
    }, {
      key: "size",
      get: function() {
        return this.state.size;
      }
      /** @deprecated Use filename instead */
    }, {
      key: "fileName",
      get: function() {
        return this.state.filename;
      }
    }, {
      key: "filename",
      get: function() {
        return this.state.filename;
      }
    }, {
      key: "category",
      get: function() {
        return this.state.category;
      }
      /**
       * Returns direct content URL to uploaded binary. This URL will expire after some time.
       * This function gets a new URL every time, preventing it from expiring but putting additional load on backend.
       * See getCachedContentUrl() for a function that reduces the amount of network requests.
       *
       * It is reasonable to build your own refresh logic upon these two functions: as soon as URL returned
       * by getCachedContentUrl() returns 40x status you should call getContentUrl() to refresh it.
       */
    }, {
      key: "getContentUrl",
      value: function() {
        var ae = this;
        return new Bt(/* @__PURE__ */ function() {
          var me = K.default(/* @__PURE__ */ B.default.mark(function se(ze, Pe, dt) {
            var tt, st;
            return B.default.wrap(function(ht) {
              for (; ; )
                switch (ht.prev = ht.next) {
                  case 0:
                    return tt = ae.network.get("".concat(ae.config.mediaUrl, "/").concat(ae.sid)), dt(function() {
                      return tt.cancel();
                    }), ht.prev = 2, ht.next = 5, tt;
                  case 5:
                    st = ht.sent, ae._update(st.body), ze(ae.state.contentDirectUrl), ht.next = 13;
                    break;
                  case 10:
                    ht.prev = 10, ht.t0 = ht.catch(2), Pe(ht.t0);
                  case 13:
                  case "end":
                    return ht.stop();
                }
            }, se, null, [[2, 10]]);
          }));
          return function(se, ze, Pe) {
            return me.apply(this, arguments);
          };
        }());
      }
    }, {
      key: "_update",
      value: function(ae) {
        var me, se, ze, Pe;
        this.state = {
          sid: ae.sid,
          serviceSid: ae.service_sid,
          channelSid: ae.channel_sid,
          messageSid: ae.message_sid,
          dateCreated: ae.date_created ? new Date(ae.date_created) : null,
          dateUploadUpdated: ae.date_upload_updated ? new Date(ae.date_upload_updated) : null,
          dateUpdated: ae.date_updated ? new Date(ae.date_updated) : null,
          size: ae.size,
          contentType: ae.content_type,
          author: ae.author,
          url: ae.url,
          contentUrl: ae.links.content,
          contentDirectUrl: (me = ae.links.content_direct_temporary) !== null && me !== void 0 ? me : null,
          filename: (se = ae.filename) !== null && se !== void 0 ? se : null,
          category: (ze = ae.category) !== null && ze !== void 0 ? ze : "media",
          isMultipartUpstream: (Pe = ae.is_multipart_upstream) !== null && Pe !== void 0 ? Pe : !1
        };
      }
      /**
       * @internal
       * This payload is compatible with Conversations' media object _state().
       */
    }, {
      key: "_state",
      value: function() {
        var ae;
        return {
          sid: this.state.sid,
          category: this.state.category,
          filename: (ae = this.state.filename) !== null && ae !== void 0 ? ae : null,
          contentType: this.state.contentType,
          size: this.state.size
        };
      }
    }]), fe;
  }();
  function Qr(fe) {
    var ke = un();
    return function() {
      var me = R.default(fe), se;
      if (ke) {
        var ze = R.default(this).constructor;
        se = Reflect.construct(me, arguments, ze);
      } else
        se = me.apply(this, arguments);
      return C.default(this, se);
    };
  }
  function un() {
    if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
      return !1;
    if (typeof Proxy == "function")
      return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      })), !0;
    } catch {
      return !1;
    }
  }
  var Nr = /* @__PURE__ */ function(fe) {
    O.default(ae, fe);
    var ke = Qr(ae);
    function ae(me, se, ze, Pe, dt) {
      var tt;
      return q.default(this, ae), tt = ke.call(this, me), tt.code = se, tt.body = ze, tt.status = Pe, tt.headers = dt, tt;
    }
    return w.default(ae);
  }(/* @__PURE__ */ I.default(Error)), kr = t.XMLHttpRequest || {};
  function Jr(fe) {
    return fe ? fe.split(`\r
`).map(function(ke) {
      return ke.split(": ");
    }).filter(function(ke) {
      return ke.length === 2 && ke[1].length > 0;
    }).reduce(function(ke, ae) {
      return ke[ae[0]] = ae[1], ke;
    }, {}) : {};
  }
  function Ke(fe) {
    var ke = fe.getResponseHeader("Content-Type");
    if (!ke || ke.indexOf("application/json") !== 0 || fe.responseText.length === 0)
      return fe.responseText;
    try {
      return JSON.parse(fe.responseText);
    } catch {
      return fe.responseText;
    }
  }
  var Re = /* @__PURE__ */ function() {
    function fe() {
      q.default(this, fe);
    }
    return w.default(fe, [{
      key: "get",
      value: (
        /**
         * Make a GET request by given URL
         */
        function(ae, me) {
          return fe.request("GET", ae, me);
        }
      )
      /**
       * Make a POST request by given URL
       */
    }, {
      key: "post",
      value: function(ae, me, se) {
        return fe.request("POST", ae, me, se);
      }
    }], [{
      key: "request",
      value: function(ae, me, se, ze) {
        return new Bt(function(Pe, dt, tt) {
          var st = new kr(), vt = !1;
          tt(function() {
            st.abort(), vt = !0;
          }), st.open(ae, me, !0), st.onreadystatechange = function() {
            if (!(st.readyState !== 4 || vt)) {
              var G = Jr(st.getAllResponseHeaders()), Ce = Ke(st);
              if (200 <= st.status && st.status < 300)
                Pe({
                  status: st.status,
                  headers: G,
                  body: Ce
                });
              else {
                var Te, ct = (Te = st.statusText) !== null && Te !== void 0 ? Te : "NONE", Ft;
                if (typeof Ce == "string")
                  if (Ce && Ce.split(`
`, 2).length === 1)
                    Ft = Ce;
                  else {
                    var nt, Ct = (nt = Ce.replace(/<.*?>/g, "").split(/\r\n/g).filter(function(yr) {
                      return yr.length;
                    })[0]) === null || nt === void 0 ? void 0 : nt.split(" ");
                    Ft = (Ct == null ? void 0 : Ct.length) > 2 ? Ct == null ? void 0 : Ct.slice(1).join(" ") : "";
                  }
                else
                  Ft = JSON.stringify(Ce);
                var Wt = "".concat(st.status, ": [").concat(ct, "] ").concat(Ft);
                dt(new Nr(Wt, st.status, Ce, ct, G));
              }
            }
          };
          for (var ht in se)
            st.setRequestHeader(ht, se[ht]), ht === "Content-Type" && se[ht] === "application/json" && (ze = JSON.stringify(ze));
          st.send(ze);
        });
      }
    }]), fe;
  }(), ge = Me.scope("Network"), qe = /* @__PURE__ */ function() {
    function fe(ke, ae) {
      q.default(this, fe), this.config = ke, this.transport = ae;
    }
    return w.default(fe, [{
      key: "backoffConfig",
      value: function() {
        return Object.assign(Dt.backoffConfigDefault, this.config.backoffConfigOverride);
      }
    }, {
      key: "retryWhenThrottled",
      value: function() {
        var ae, me;
        return (ae = (me = this.config.retryWhenThrottledOverride) !== null && me !== void 0 ? me : Dt.retryWhenThrottledDefault) !== null && ae !== void 0 ? ae : !1;
      }
    }, {
      key: "executeWithRetry",
      value: function(ae, me) {
        var se = this;
        return new Bt(/* @__PURE__ */ function() {
          var ze = K.default(/* @__PURE__ */ B.default.mark(function Pe(dt, tt, st) {
            var vt, ht;
            return B.default.wrap(function(G) {
              for (; ; )
                switch (G.prev = G.next) {
                  case 0:
                    vt = new p.Retrier(se.backoffConfig()), ht = [502, 503, 504], me && ht.push(429), st(function() {
                      vt.cancel(), vt.removeAllListeners();
                    }), vt.on("attempt", /* @__PURE__ */ K.default(/* @__PURE__ */ B.default.mark(function Ce() {
                      var Te, ct;
                      return B.default.wrap(function(nt) {
                        for (; ; )
                          switch (nt.prev = nt.next) {
                            case 0:
                              return nt.prev = 0, Te = ae(), st(function() {
                                Te.cancel(), vt.cancel(), vt.removeAllListeners();
                              }), nt.next = 5, Te;
                            case 5:
                              ct = nt.sent, vt.succeeded(ct), nt.next = 12;
                              break;
                            case 9:
                              nt.prev = 9, nt.t0 = nt.catch(0), ht.indexOf(nt.t0.status) > -1 || nt.t0.message === "Twilsock disconnected" ? vt.failed(nt.t0) : (vt.removeAllListeners(), vt.cancel(), tt(nt.t0));
                            case 12:
                            case "end":
                              return nt.stop();
                          }
                      }, Ce, null, [[0, 9]]);
                    }))), vt.on("succeeded", function(Ce) {
                      dt(Ce);
                    }), vt.on("cancelled", function(Ce) {
                      return tt(Ce);
                    }), vt.on("failed", function(Ce) {
                      return tt(Ce);
                    }), vt.start();
                  case 9:
                  case "end":
                    return G.stop();
                }
            }, Pe);
          }));
          return function(Pe, dt, tt) {
            return ze.apply(this, arguments);
          };
        }());
      }
    }, {
      key: "get",
      value: function(ae) {
        var me = this;
        return new Bt(/* @__PURE__ */ function() {
          var se = K.default(/* @__PURE__ */ B.default.mark(function ze(Pe, dt, tt) {
            var st, vt, ht;
            return B.default.wrap(function(G) {
              for (; ; )
                switch (G.prev = G.next) {
                  case 0:
                    return st = {
                      "X-Twilio-Token": me.config.token
                    }, vt = me.executeWithRetry(function() {
                      return me.transport.get(ae, st);
                    }, me.retryWhenThrottled()), ge.trace("sending GET request to ", ae, " headers ", st), tt(function() {
                      return vt.cancel();
                    }), G.prev = 4, G.next = 7, vt;
                  case 7:
                    ht = G.sent, ge.trace("response", ht), Pe(ht), G.next = 16;
                    break;
                  case 12:
                    G.prev = 12, G.t0 = G.catch(4), ge.debug("get() error ".concat(G.t0)), dt(G.t0);
                  case 16:
                  case "end":
                    return G.stop();
                }
            }, ze, null, [[4, 12]]);
          }));
          return function(ze, Pe, dt) {
            return se.apply(this, arguments);
          };
        }());
      }
    }, {
      key: "post",
      value: function(ae, me, se, ze, Pe) {
        var dt = this, tt = {
          "X-Twilio-Token": this.config.token
        };
        (typeof FormData > "u" || !(se instanceof FormData)) && ze && Object.assign(tt, {
          "Content-Type": ze
        });
        var st = new URL(ae);
        return me && st.searchParams.append("Category", me), Pe && st.searchParams.append("Filename", Pe), new Bt(/* @__PURE__ */ function() {
          var vt = K.default(/* @__PURE__ */ B.default.mark(function ht(lt, G, Ce) {
            var Te, ct;
            return B.default.wrap(function(nt) {
              for (; ; )
                switch (nt.prev = nt.next) {
                  case 0:
                    return Te = dt.transport.post(st.href, tt, se), Ce(function() {
                      return Te.cancel();
                    }), ge.trace("sending POST request to ".concat(ae, " with headers ").concat(tt)), nt.prev = 3, nt.next = 6, Te;
                  case 6:
                    ct = nt.sent, nt.next = 17;
                    break;
                  case 9:
                    if (nt.prev = 9, nt.t0 = nt.catch(3), !(t.XMLHttpRequest === void 0 && se instanceof FormData)) {
                      nt.next = 14;
                      break;
                    }
                    return G(new TypeError("Posting FormData supported only with browser engine's FormData")), nt.abrupt("return");
                  case 14:
                    return ge.debug("post() error ".concat(nt.t0)), G(nt.t0), nt.abrupt("return");
                  case 17:
                    ge.trace("response", ct), lt(ct);
                  case 19:
                  case "end":
                    return nt.stop();
                }
            }, ht, null, [[3, 9]]);
          }));
          return function(ht, lt, G) {
            return vt.apply(this, arguments);
          };
        }());
      }
    }]), fe;
  }(), Ve = "0.6.6", Ne, Xe = Me.scope("");
  e.default = (Ne = /* @__PURE__ */ function() {
    function fe(ke, ae, me) {
      var se, ze, Pe = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
      q.default(this, fe), this.options = Pe, this.options.logLevel = (se = this.options.logLevel) !== null && se !== void 0 ? se : "silent", this.config = new Dt(ke, ae, me, this.options), Xe.setLevel(this.options.logLevel), this.options.transport = (ze = this.options.transport) !== null && ze !== void 0 ? ze : new Re(), this.transport = this.options.transport, this.network = new qe(this.config, this.transport);
    }
    return w.default(fe, [{
      key: "updateToken",
      value: function(ae) {
        Xe.info("updateToken"), this.config.updateToken(ae);
      }
      /**
       * Gets media from media service
       * @param {String} sid - Media's SID
       */
    }, {
      key: "get",
      value: function(ae) {
        var me = this;
        return new Bt(/* @__PURE__ */ function() {
          var se = K.default(/* @__PURE__ */ B.default.mark(function ze(Pe, dt, tt) {
            var st, vt;
            return B.default.wrap(function(lt) {
              for (; ; )
                switch (lt.prev = lt.next) {
                  case 0:
                    return st = me.network.get("".concat(me.config.mediaUrl, "/").concat(ae)), tt(function() {
                      return st.cancel();
                    }), lt.prev = 2, lt.next = 5, st;
                  case 5:
                    vt = lt.sent, Pe(new vr(me.config, me.network, vt.body)), lt.next = 12;
                    break;
                  case 9:
                    lt.prev = 9, lt.t0 = lt.catch(2), dt(lt.t0);
                  case 12:
                  case "end":
                    return lt.stop();
                }
            }, ze, null, [[2, 9]]);
          }));
          return function(ze, Pe, dt) {
            return se.apply(this, arguments);
          };
        }());
      }
      /**
       * Posts raw content to media service
       * @param {String} contentType - content type of media
       * @param {String|Buffer|Blob} media - content to post
       * @param {MediaCategory|null} category - category for the media
       */
    }, {
      key: "post",
      value: function(ae, me, se, ze) {
        var Pe = this;
        return new Bt(/* @__PURE__ */ function() {
          var dt = K.default(/* @__PURE__ */ B.default.mark(function tt(st, vt, ht) {
            var lt, G;
            return B.default.wrap(function(Te) {
              for (; ; )
                switch (Te.prev = Te.next) {
                  case 0:
                    return lt = Pe.network.post(Pe.config.mediaUrl, se ?? "media", me, ae, ze), ht(function() {
                      return lt.cancel();
                    }), Te.prev = 2, Te.next = 5, lt;
                  case 5:
                    G = Te.sent, st(new vr(Pe.config, Pe.network, G.body)), Te.next = 12;
                    break;
                  case 9:
                    Te.prev = 9, Te.t0 = Te.catch(2), vt(Te.t0);
                  case 12:
                  case "end":
                    return Te.stop();
                }
            }, tt, null, [[2, 9]]);
          }));
          return function(tt, st, vt) {
            return dt.apply(this, arguments);
          };
        }());
      }
      /**
       * Posts FormData to media service. Can be used only with browser engine's FormData.
       * In non-browser FormData case the method will do promise reject with
       * new TypeError("Posting FormData supported only with browser engine's FormData")
       * @param {FormData} formData - form data to post
       * @param {MediaCategory|null} category - category for the media
       */
    }, {
      key: "postFormData",
      value: function(ae, me) {
        var se = this;
        return new Bt(/* @__PURE__ */ function() {
          var ze = K.default(/* @__PURE__ */ B.default.mark(function Pe(dt, tt, st) {
            var vt, ht;
            return B.default.wrap(function(G) {
              for (; ; )
                switch (G.prev = G.next) {
                  case 0:
                    return vt = se.network.post(se.config.mediaUrl, me ?? "media", ae), st(function() {
                      return vt.cancel();
                    }), G.prev = 2, G.next = 5, vt;
                  case 5:
                    ht = G.sent, dt(new vr(se.config, se.network, ht.body)), G.next = 12;
                    break;
                  case 9:
                    G.prev = 9, G.t0 = G.catch(2), tt(G.t0);
                  case 12:
                  case "end":
                    return G.stop();
                }
            }, Pe, null, [[2, 9]]);
          }));
          return function(Pe, dt, tt) {
            return ze.apply(this, arguments);
          };
        }());
      }
      /**
       * Retrieve information about multiple media SIDs at the same time.
       * @param mediaSids Array of Media SIDs to get information from.
       */
    }, {
      key: "mediaSetGet",
      value: function(ae) {
        var me = this;
        return new Bt(/* @__PURE__ */ function() {
          var se = K.default(/* @__PURE__ */ B.default.mark(function ze(Pe, dt, tt) {
            var st, vt, ht, lt;
            return B.default.wrap(function(Ce) {
              for (; ; )
                switch (Ce.prev = Ce.next) {
                  case 0:
                    return st = {
                      command: "get",
                      list: ae.map(function(Te) {
                        return {
                          media_sid: Te
                        };
                      })
                    }, vt = me.network.post("".concat(me.config.mediaSetUrl), null, st, "application/json"), tt(function() {
                      return vt.cancel();
                    }), Ce.prev = 3, Ce.next = 6, vt;
                  case 6:
                    ht = Ce.sent, lt = ht.body.map(function(Te) {
                      if (Te.code !== 200) {
                        dt("Failed to obtain detailed information about Media items (failed SID ".concat(Te.media_record.sid, ")"));
                        return;
                      }
                      return new vr(me.config, me.network, Te.media_record);
                    }), Pe(lt), Ce.next = 14;
                    break;
                  case 11:
                    Ce.prev = 11, Ce.t0 = Ce.catch(3), dt(Ce.t0);
                  case 14:
                  case "end":
                    return Ce.stop();
                }
            }, ze, null, [[3, 11]]);
          }));
          return function(ze, Pe, dt) {
            return se.apply(this, arguments);
          };
        }());
      }
      /**
       * Retrieve temporary URLs for a set of media SIDs.
       * @param mediaSids array of the media SIDs to get URLs from.
       */
    }, {
      key: "mediaSetGetContentUrls",
      value: function(ae) {
        var me = this;
        return new Bt(/* @__PURE__ */ function() {
          var se = K.default(/* @__PURE__ */ B.default.mark(function ze(Pe, dt, tt) {
            var st, vt, ht, lt;
            return B.default.wrap(function(Ce) {
              for (; ; )
                switch (Ce.prev = Ce.next) {
                  case 0:
                    return st = {
                      command: "get",
                      list: ae.map(function(Te) {
                        return {
                          media_sid: Te
                        };
                      })
                    }, vt = me.network.post("".concat(me.config.mediaSetUrl), null, st, "application/json"), tt(function() {
                      return vt.cancel();
                    }), Ce.prev = 3, Ce.next = 6, vt;
                  case 6:
                    ht = Ce.sent, lt = /* @__PURE__ */ new Map(), ht.body.forEach(function(Te) {
                      if (Te.code !== 200) {
                        dt("Failed to obtain detailed information about Media items (failed SID ".concat(Te.media_record.sid, ")"));
                        return;
                      }
                      lt.set(Te.media_record.sid, Te.media_record.links.content_direct_temporary);
                    }), Pe(lt), Ce.next = 15;
                    break;
                  case 12:
                    Ce.prev = 12, Ce.t0 = Ce.catch(3), dt(Ce.t0);
                  case 15:
                  case "end":
                    return Ce.stop();
                }
            }, ze, null, [[3, 12]]);
          }));
          return function(ze, Pe, dt) {
            return se.apply(this, arguments);
          };
        }());
      }
    }]), fe;
  }(), P.default(Ne, "version", Ve), Ne), mt([v.validateTypes(v.nonEmptyString), Ot("design:type", Function), Ot("design:paramtypes", [String]), Ot("design:returntype", void 0)], e.default.prototype, "updateToken", null), mt([v.validateTypesAsync(v.nonEmptyString), Ot("design:type", Function), Ot("design:paramtypes", [String]), Ot("design:returntype", Bt)], e.default.prototype, "get", null), e.default = mt([v.validateConstructorTypes(v.nonEmptyString, v.nonEmptyString, [v.nonEmptyString, v.literal(null)], [v.pureObject, "undefined"]), Ot("design:paramtypes", [String, String, Object, Object])], e.default), e.CancellablePromise = Bt, e.Client = e.default, e.McsClient = e.default, e.McsMedia = vr, e.Media = vr;
})(a4);
var F4 = pr, vae = on, hae = _i, mae = F4.aTypedArray, gae = F4.exportTypedArrayMethod;
gae("at", function(t) {
  var r = mae(this), n = vae(r), i = hae(t), a = i >= 0 ? i : n + i;
  return a < 0 || a >= n ? void 0 : r[a];
});
var yae = xt, Vae = Xt, qae = UK, bae = wp, sq = "ArrayBuffer", T2 = qae[sq], Aae = Vae[sq];
yae({ global: !0, constructor: !0, forced: Aae !== T2 }, {
  ArrayBuffer: T2
});
bae(sq);
var wae = xt, K4 = Kt, kae = li, Wae = hn, U2 = on, Sae = NV, x2 = $r, oq = St, Cae = LV, Fae = Fp, E2 = m9, Kae = g9, O2 = Su, N2 = y9, za = [], I2 = K4(za.sort), Rae = K4(za.push), Tae = oq(function() {
  za.sort(void 0);
}), Uae = oq(function() {
  za.sort(null);
}), xae = Fae("sort"), R4 = !oq(function() {
  if (O2)
    return O2 < 70;
  if (!(E2 && E2 > 3)) {
    if (Kae)
      return !0;
    if (N2)
      return N2 < 603;
    var e = "", t, r, n, i;
    for (t = 65; t < 76; t++) {
      switch (r = String.fromCharCode(t), t) {
        case 66:
        case 69:
        case 70:
        case 72:
          n = 3;
          break;
        case 68:
        case 71:
          n = 4;
          break;
        default:
          n = 2;
      }
      for (i = 0; i < 47; i++)
        za.push({ k: r + i, v: n });
    }
    for (za.sort(function(a, s) {
      return s.v - a.v;
    }), i = 0; i < za.length; i++)
      r = za[i].k.charAt(0), e.charAt(e.length - 1) !== r && (e += r);
    return e !== "DGBEFHACIJK";
  }
}), Eae = Tae || !Uae || !xae || !R4, Oae = function(e) {
  return function(t, r) {
    return r === void 0 ? -1 : t === void 0 ? 1 : e !== void 0 ? +e(t, r) || 0 : x2(t) > x2(r) ? 1 : -1;
  };
};
wae({ target: "Array", proto: !0, forced: Eae }, {
  sort: function(t) {
    t !== void 0 && kae(t);
    var r = Wae(this);
    if (R4)
      return t === void 0 ? I2(r) : I2(r, t);
    var n = [], i = U2(r), a, s;
    for (s = 0; s < i; s++)
      s in r && Rae(n, r[s]);
    for (Cae(n, Oae(t)), a = U2(n), s = 0; s < a; )
      r[s] = n[s++];
    for (; s < i; )
      Sae(r, s++);
    return r;
  }
});
var Nae = xt, Iae = Kt, Xae = s4, Pae = Hi, X2 = $r, Bae = o4, Dae = Iae("".indexOf);
Nae({ target: "String", proto: !0, forced: !Bae("includes") }, {
  includes: function(t) {
    return !!~Dae(
      X2(Pae(this)),
      X2(Xae(t)),
      arguments.length > 1 ? arguments[1] : void 0
    );
  }
});
var Lae = Kt, P2 = Bp, Pd = Pp.getWeakData, Zae = vs, Mae = Or, jae = Ri, T1 = Rr, Yae = xl, T4 = Un, B2 = Tr, U4 = jn, zae = U4.set, Gae = U4.getterFor, Qae = T4.find, Jae = T4.findIndex, Hae = Lae([].splice), _ae = 0, Bd = function(e) {
  return e.frozen || (e.frozen = new x4());
}, x4 = function() {
  this.entries = [];
}, U1 = function(e, t) {
  return Qae(e.entries, function(r) {
    return r[0] === t;
  });
};
x4.prototype = {
  get: function(e) {
    var t = U1(this, e);
    if (t)
      return t[1];
  },
  has: function(e) {
    return !!U1(this, e);
  },
  set: function(e, t) {
    var r = U1(this, e);
    r ? r[1] = t : this.entries.push([e, t]);
  },
  delete: function(e) {
    var t = Jae(this.entries, function(r) {
      return r[0] === e;
    });
    return ~t && Hae(this.entries, t, 1), !!~t;
  }
};
var $ae = {
  getConstructor: function(e, t, r, n) {
    var i = e(function(u, f) {
      Zae(u, a), zae(u, {
        type: t,
        id: _ae++,
        frozen: void 0
      }), jae(f) || Yae(f, u[n], { that: u, AS_ENTRIES: r });
    }), a = i.prototype, s = Gae(t), o = function(u, f, l) {
      var d = s(u), c = Pd(Mae(f), !0);
      return c === !0 ? Bd(d).set(f, l) : c[d.id] = l, u;
    };
    return P2(a, {
      // `{ WeakMap, WeakSet }.prototype.delete(key)` methods
      // https://tc39.es/ecma262/#sec-weakmap.prototype.delete
      // https://tc39.es/ecma262/#sec-weakset.prototype.delete
      delete: function(u) {
        var f = s(this);
        if (!T1(u))
          return !1;
        var l = Pd(u);
        return l === !0 ? Bd(f).delete(u) : l && B2(l, f.id) && delete l[f.id];
      },
      // `{ WeakMap, WeakSet }.prototype.has(key)` methods
      // https://tc39.es/ecma262/#sec-weakmap.prototype.has
      // https://tc39.es/ecma262/#sec-weakset.prototype.has
      has: function(f) {
        var l = s(this);
        if (!T1(f))
          return !1;
        var d = Pd(f);
        return d === !0 ? Bd(l).has(f) : d && B2(d, l.id);
      }
    }), P2(a, r ? {
      // `WeakMap.prototype.get(key)` method
      // https://tc39.es/ecma262/#sec-weakmap.prototype.get
      get: function(f) {
        var l = s(this);
        if (T1(f)) {
          var d = Pd(f);
          return d === !0 ? Bd(l).get(f) : d ? d[l.id] : void 0;
        }
      },
      // `WeakMap.prototype.set(key, value)` method
      // https://tc39.es/ecma262/#sec-weakmap.prototype.set
      set: function(f, l) {
        return o(this, f, l);
      }
    } : {
      // `WeakSet.prototype.add(value)` method
      // https://tc39.es/ecma262/#sec-weakset.prototype.add
      add: function(f) {
        return o(this, f, !0);
      }
    }), i;
  }
}, ese = qV, tse = $ae;
ese("WeakSet", function(e) {
  return function() {
    return e(this, arguments.length ? arguments[0] : void 0);
  };
}, tse);
var $p = {}, E4 = { exports: {} };
(function(e) {
  (function(t, r) {
    e.exports ? e.exports = r() : t.log = r();
  })(Xn, function() {
    var t = function() {
    }, r = "undefined", n = typeof window !== r && typeof window.navigator !== r && /Trident\/|MSIE /.test(window.navigator.userAgent), i = [
      "trace",
      "debug",
      "info",
      "warn",
      "error"
    ];
    function a(h, m) {
      var q = h[m];
      if (typeof q.bind == "function")
        return q.bind(h);
      try {
        return Function.prototype.bind.call(q, h);
      } catch {
        return function() {
          return Function.prototype.apply.apply(q, [h, arguments]);
        };
      }
    }
    function s() {
      console.log && (console.log.apply ? console.log.apply(console, arguments) : Function.prototype.apply.apply(console.log, [console, arguments])), console.trace && console.trace();
    }
    function o(h) {
      return h === "debug" && (h = "log"), typeof console === r ? !1 : h === "trace" && n ? s : console[h] !== void 0 ? a(console, h) : console.log !== void 0 ? a(console, "log") : t;
    }
    function u(h, m) {
      for (var q = 0; q < i.length; q++) {
        var w = i[q];
        this[w] = q < h ? t : this.methodFactory(w, h, m);
      }
      this.log = this.debug;
    }
    function f(h, m, q) {
      return function() {
        typeof console !== r && (u.call(this, m, q), this[h].apply(this, arguments));
      };
    }
    function l(h, m, q) {
      return o(h) || f.apply(this, arguments);
    }
    function d(h, m, q) {
      var w = this, O;
      m = m ?? "WARN";
      var C = "loglevel";
      typeof h == "string" ? C += ":" + h : typeof h == "symbol" && (C = void 0);
      function R(B) {
        var L = (i[B] || "silent").toUpperCase();
        if (!(typeof window === r || !C)) {
          try {
            window.localStorage[C] = L;
            return;
          } catch {
          }
          try {
            window.document.cookie = encodeURIComponent(C) + "=" + L + ";";
          } catch {
          }
        }
      }
      function I() {
        var B;
        if (!(typeof window === r || !C)) {
          try {
            B = window.localStorage[C];
          } catch {
          }
          if (typeof B === r)
            try {
              var L = window.document.cookie, _ = L.indexOf(
                encodeURIComponent(C) + "="
              );
              _ !== -1 && (B = /^([^;]+)/.exec(L.slice(_))[1]);
            } catch {
            }
          return w.levels[B] === void 0 && (B = void 0), B;
        }
      }
      function P() {
        if (!(typeof window === r || !C)) {
          try {
            window.localStorage.removeItem(C);
            return;
          } catch {
          }
          try {
            window.document.cookie = encodeURIComponent(C) + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC";
          } catch {
          }
        }
      }
      w.name = h, w.levels = {
        TRACE: 0,
        DEBUG: 1,
        INFO: 2,
        WARN: 3,
        ERROR: 4,
        SILENT: 5
      }, w.methodFactory = q || l, w.getLevel = function() {
        return O;
      }, w.setLevel = function(B, L) {
        if (typeof B == "string" && w.levels[B.toUpperCase()] !== void 0 && (B = w.levels[B.toUpperCase()]), typeof B == "number" && B >= 0 && B <= w.levels.SILENT) {
          if (O = B, L !== !1 && R(B), u.call(w, B, h), typeof console === r && B < w.levels.SILENT)
            return "No console available for logging";
        } else
          throw "log.setLevel() called with invalid level: " + B;
      }, w.setDefaultLevel = function(B) {
        m = B, I() || w.setLevel(B, !1);
      }, w.resetLevel = function() {
        w.setLevel(m, !1), P();
      }, w.enableAll = function(B) {
        w.setLevel(w.levels.TRACE, B);
      }, w.disableAll = function(B) {
        w.setLevel(w.levels.SILENT, B);
      };
      var K = I();
      K == null && (K = m), w.setLevel(K, !1);
    }
    var c = new d(), p = {};
    c.getLogger = function(m) {
      if (typeof m != "symbol" && typeof m != "string" || m === "")
        throw new TypeError("You must supply a name when creating a logger.");
      var q = p[m];
      return q || (q = p[m] = new d(
        m,
        c.getLevel(),
        c.methodFactory
      )), q;
    };
    var v = typeof window !== r ? window.log : void 0;
    return c.noConflict = function() {
      return typeof window !== r && window.log === c && (window.log = v), c;
    }, c.getLoggers = function() {
      return p;
    }, c.default = c, c;
  });
})(E4);
var rse = E4.exports;
/*
@license
Copyright (c) 2022 Twilio Inc.

Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.


*/
Object.defineProperty($p, "__esModule", { value: !0 });
var nse = rse;
function ise(e) {
  return e && typeof e == "object" && "default" in e ? e : { default: e };
}
var Dd = /* @__PURE__ */ ise(nse), ase = function(t, r, n) {
  return function(i, a, s) {
    if (typeof s.value != "function" && (s == null ? void 0 : s.get) === void 0)
      throw new Error("The deprecated decorator can only be applied to methods or getters");
    if (typeof s.value == "function") {
      var o = s.value;
      s.value = function() {
        kg("The method ".concat(t, " is deprecated").concat(r ? ", use " + r + " instead" : "").concat(n ? ", " + n : "."));
        for (var f = arguments.length, l = new Array(f), d = 0; d < f; d++)
          l[d] = arguments[d];
        return o.apply(this, l);
      };
      return;
    }
    var u = s.get;
    s.get = function() {
      return kg("The getter ".concat(t, " is deprecated").concat(r ? ", use " + r + " instead" : "").concat(n ? ", " + n : ".")), u == null ? void 0 : u.apply(this);
    };
  };
}, kg = function(t) {
  var r = Dd.default.getLevel();
  Dd.default.setLevel("warn"), Dd.default.warn(t), Dd.default.setLevel(r);
};
$p.deprecated = ase;
$p.deprecationWarning = kg;
var sse = xt, ose = Un.find, use = iV, Wg = "find", O4 = !0;
Wg in [] && Array(1)[Wg](function() {
  O4 = !1;
});
sse({ target: "Array", proto: !0, forced: O4 }, {
  find: function(t) {
    return ose(this, t, arguments.length > 1 ? arguments[1] : void 0);
  }
});
use(Wg);
var Sg = { exports: {} }, D2 = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto < "u" && typeof window.msCrypto.getRandomValues == "function" && msCrypto.getRandomValues.bind(msCrypto);
if (D2) {
  var L2 = new Uint8Array(16);
  Sg.exports = function() {
    return D2(L2), L2;
  };
} else {
  var Z2 = new Array(16);
  Sg.exports = function() {
    for (var t = 0, r; t < 16; t++)
      t & 3 || (r = Math.random() * 4294967296), Z2[t] = r >>> ((t & 3) << 3) & 255;
    return Z2;
  };
}
var N4 = Sg.exports, I4 = [];
for (var Ld = 0; Ld < 256; ++Ld)
  I4[Ld] = (Ld + 256).toString(16).substr(1);
function fse(e, t) {
  var r = t || 0, n = I4;
  return [
    n[e[r++]],
    n[e[r++]],
    n[e[r++]],
    n[e[r++]],
    "-",
    n[e[r++]],
    n[e[r++]],
    "-",
    n[e[r++]],
    n[e[r++]],
    "-",
    n[e[r++]],
    n[e[r++]],
    "-",
    n[e[r++]],
    n[e[r++]],
    n[e[r++]],
    n[e[r++]],
    n[e[r++]],
    n[e[r++]]
  ].join("");
}
var X4 = fse, lse = N4, dse = X4, M2, x1, E1 = 0, O1 = 0;
function cse(e, t, r) {
  var n = t && r || 0, i = t || [];
  e = e || {};
  var a = e.node || M2, s = e.clockseq !== void 0 ? e.clockseq : x1;
  if (a == null || s == null) {
    var o = lse();
    a == null && (a = M2 = [
      o[0] | 1,
      o[1],
      o[2],
      o[3],
      o[4],
      o[5]
    ]), s == null && (s = x1 = (o[6] << 8 | o[7]) & 16383);
  }
  var u = e.msecs !== void 0 ? e.msecs : (/* @__PURE__ */ new Date()).getTime(), f = e.nsecs !== void 0 ? e.nsecs : O1 + 1, l = u - E1 + (f - O1) / 1e4;
  if (l < 0 && e.clockseq === void 0 && (s = s + 1 & 16383), (l < 0 || u > E1) && e.nsecs === void 0 && (f = 0), f >= 1e4)
    throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
  E1 = u, O1 = f, x1 = s, u += 122192928e5;
  var d = ((u & 268435455) * 1e4 + f) % 4294967296;
  i[n++] = d >>> 24 & 255, i[n++] = d >>> 16 & 255, i[n++] = d >>> 8 & 255, i[n++] = d & 255;
  var c = u / 4294967296 * 1e4 & 268435455;
  i[n++] = c >>> 8 & 255, i[n++] = c & 255, i[n++] = c >>> 24 & 15 | 16, i[n++] = c >>> 16 & 255, i[n++] = s >>> 8 | 128, i[n++] = s & 255;
  for (var p = 0; p < 6; ++p)
    i[n + p] = a[p];
  return t || dse(i);
}
var pse = cse, vse = N4, hse = X4;
function mse(e, t, r) {
  var n = t && r || 0;
  typeof e == "string" && (t = e === "binary" ? new Array(16) : null, e = null), e = e || {};
  var i = e.random || (e.rng || vse)();
  if (i[6] = i[6] & 15 | 64, i[8] = i[8] & 63 | 128, t)
    for (var a = 0; a < 16; ++a)
      t[n + a] = i[a];
  return t || hse(i);
}
var gse = mse, yse = pse, P4 = gse, uq = P4;
uq.v1 = yse;
uq.v4 = P4;
var Vse = uq, qse = xt, bse = HF, Ase = St, wse = Rr, kse = Pp.onFreeze, Cg = Object.freeze, Wse = Ase(function() {
  Cg(1);
});
qse({ target: "Object", stat: !0, forced: Wse, sham: !bse }, {
  freeze: function(t) {
    return Cg && wse(t) ? Cg(kse(t)) : t;
  }
});
/*
@license
The following license applies to all parts of this software except as
documented below.

    Copyright (c) 2019, Twilio, inc.
    All rights reserved.

    Redistribution and use in source and binary forms, with or without
    modification, are permitted provided that the following conditions are
    met:

      1. Redistributions of source code must retain the above copyright
         notice, this list of conditions and the following disclaimer.

      2. Redistributions in binary form must reproduce the above copyright
         notice, this list of conditions and the following disclaimer in
         the documentation and/or other materials provided with the
         distribution.

      3. Neither the name of Twilio nor the names of its contributors may
         be used to endorse or promote products derived from this software
         without specific prior written permission.

    THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
    "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
    LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
    A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT
    HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
    SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT
    LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE,
    DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY
    THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
    (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
    OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.

This software includes javascript-state-machine under the following license.

    Copyright (c) 2012, 2013, 2014, 2015, Jake Gordon and contributors

    Permission is hereby granted, free of charge, to any person obtaining a copy
    of this software and associated documentation files (the "Software"), to deal
    in the Software without restriction, including without limitation the rights
    to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
    copies of the Software, and to permit persons to whom the Software is
    furnished to do so, subject to the following conditions:

    The above copyright notice and this permission notice shall be included in all
    copies or substantial portions of the Software.

    THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
    IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
    FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
    AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
    LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
    OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE

This software includes loglevel under the following license.

    Copyright (c) 2013 Tim Perry

    Permission is hereby granted, free of charge, to any person
    obtaining a copy of this software and associated documentation
    files (the "Software"), to deal in the Software without
    restriction, including without limitation the rights to use,
    copy, modify, merge, publish, distribute, sublicense, and/or sell
    copies of the Software, and to permit persons to whom the
    Software is furnished to do so, subject to the following
    conditions:

    The above copyright notice and this permission notice shall be
    included in all copies or substantial portions of the Software.

    THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
    EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES
    OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
    NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT
    HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
    WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
    FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR
    OTHER DEALINGS IN THE SOFTWARE.

This software includes q under the following license.

    Copyright 2009–2014 Kristopher Michael Kowal. All rights reserved.
    Permission is hereby granted, free of charge, to any person obtaining a copy
    of this software and associated documentation files (the "Software"), to
    deal in the Software without restriction, including without limitation the
    rights to use, copy, modify, merge, publish, distribute, sublicense, and/or
    sell copies of the Software, and to permit persons to whom the Software is
    furnished to do so, subject to the following conditions:

    The above copyright notice and this permission notice shall be included in
    all copies or substantial portions of the Software.

    THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
    IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
    FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
    AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
    LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
    FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS
    IN THE SOFTWARE.

This software includes platform.js under the following license.

    Copyright 2014 Benjamin Tan <https://d10.github.io/>
    Copyright 2011-2015 John-David Dalton <http://allyoucanleet.com/>

    Permission is hereby granted, free of charge, to any person obtaining
    a copy of this software and associated documentation files (the
    "Software"), to deal in the Software without restriction, including
    without limitation the rights to use, copy, modify, merge, publish,
    distribute, sublicense, and/or sell copies of the Software, and to
    permit persons to whom the Software is furnished to do so, subject to
    the following conditions:

    The above copyright notice and this permission notice shall be
    included in all copies or substantial portions of the Software.

    THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
    EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
    MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
    NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
    LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
    OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
    WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

*/
(function(e) {
  var t = typeof t < "u" ? t : typeof self < "u" ? self : typeof window < "u" ? window : {};
  Object.defineProperty(e, "__esModule", { value: !0 });
  var r = Kl, n = to, i = ea, a = ta, s = ci, o = ro, u = ps, f = ra, l = El, d = di, c = Nl, p = lZ, v = rn, h = Ou, m = hV, q = Fz, w = Eu, O = Ua, C = Dp, R = R9, I = xn, P = a4, K = $p, B = Jp, L = Vse;
  function _(N) {
    return N && typeof N == "object" && "default" in N ? N : { default: N };
  }
  function ne(N) {
    if (N && N.__esModule)
      return N;
    var X = /* @__PURE__ */ Object.create(null);
    return N && Object.keys(N).forEach(function(S) {
      if (S !== "default") {
        var y = Object.getOwnPropertyDescriptor(N, S);
        Object.defineProperty(X, S, y.get ? y : {
          enumerable: !0,
          get: function() {
            return N[S];
          }
        });
      }
    }), X.default = N, Object.freeze(X);
  }
  var Z = /* @__PURE__ */ _(r), le = /* @__PURE__ */ _(n), he = /* @__PURE__ */ _(i), Ie = /* @__PURE__ */ _(a), xe = /* @__PURE__ */ _(s), ye = /* @__PURE__ */ _(o), ue = /* @__PURE__ */ _(u), M = /* @__PURE__ */ _(f), F = /* @__PURE__ */ _(l), pe = /* @__PURE__ */ _(d), We = /* @__PURE__ */ ne(c), ce = /* @__PURE__ */ _(h), oe = /* @__PURE__ */ _(q), z = /* @__PURE__ */ _(w), Ze = /* @__PURE__ */ _(B);
  function Ae(N, X, S, y) {
    var g = arguments.length, W = g < 3 ? X : y === null ? y = Object.getOwnPropertyDescriptor(X, S) : y, V;
    if ((typeof Reflect > "u" ? "undefined" : pe.default(Reflect)) === "object" && typeof Reflect.decorate == "function")
      W = Reflect.decorate(N, X, S, y);
    else
      for (var b = N.length - 1; b >= 0; b--)
        (V = N[b]) && (W = (g < 3 ? V(W) : g > 3 ? V(X, S, W) : V(X, S)) || W);
    return g > 3 && W && Object.defineProperty(X, S, W), W;
  }
  function re(N, X) {
    if ((typeof Reflect > "u" ? "undefined" : pe.default(Reflect)) === "object" && typeof Reflect.metadata == "function")
      return Reflect.metadata(N, X);
  }
  function Qe(N, X) {
    return ["".concat((/* @__PURE__ */ new Date()).toISOString(), " Conversations ").concat(N, ":")].concat(Array.from(X));
  }
  var Ee = We.getLogger("twilio-conversations"), Ue = /* @__PURE__ */ function() {
    function N(X) {
      M.default(this, N), ye.default(this, "prefix", ""), this.prefix = X != null && X.length > 0 ? X + " " : "";
    }
    return ue.default(N, [{
      key: "setLevel",
      value: function(S) {
        Ee.setLevel(S);
      }
    }, {
      key: "trace",
      value: function() {
        for (var S = arguments.length, y = new Array(S), g = 0; g < S; g++)
          y[g] = arguments[g];
        Ee.trace.apply(null, Qe(this.prefix + "T", y));
      }
    }, {
      key: "debug",
      value: function() {
        for (var S = arguments.length, y = new Array(S), g = 0; g < S; g++)
          y[g] = arguments[g];
        Ee.debug.apply(null, Qe(this.prefix + "D", y));
      }
    }, {
      key: "info",
      value: function() {
        for (var S = arguments.length, y = new Array(S), g = 0; g < S; g++)
          y[g] = arguments[g];
        Ee.info.apply(null, Qe(this.prefix + "I", y));
      }
    }, {
      key: "warn",
      value: function() {
        for (var S = arguments.length, y = new Array(S), g = 0; g < S; g++)
          y[g] = arguments[g];
        Ee.warn.apply(null, Qe(this.prefix + "W", y));
      }
    }, {
      key: "error",
      value: function() {
        for (var S = arguments.length, y = new Array(S), g = 0; g < S; g++)
          y[g] = arguments[g];
        Ee.error.apply(null, Qe(this.prefix + "E", y));
      }
    }], [{
      key: "scope",
      value: function(S) {
        return new N(S);
      }
    }, {
      key: "setLevel",
      value: function(S) {
        Ee.setLevel(S);
      }
    }, {
      key: "trace",
      value: function() {
        for (var S = arguments.length, y = new Array(S), g = 0; g < S; g++)
          y[g] = arguments[g];
        Ee.trace.apply(null, Qe("T", y));
      }
    }, {
      key: "debug",
      value: function() {
        for (var S = arguments.length, y = new Array(S), g = 0; g < S; g++)
          y[g] = arguments[g];
        Ee.debug.apply(null, Qe("D", y));
      }
    }, {
      key: "info",
      value: function() {
        for (var S = arguments.length, y = new Array(S), g = 0; g < S; g++)
          y[g] = arguments[g];
        Ee.info.apply(null, Qe("I", y));
      }
    }, {
      key: "warn",
      value: function() {
        for (var S = arguments.length, y = new Array(S), g = 0; g < S; g++)
          y[g] = arguments[g];
        Ee.warn.apply(null, Qe("W", y));
      }
    }, {
      key: "error",
      value: function() {
        for (var S = arguments.length, y = new Array(S), g = 0; g < S; g++)
          y[g] = arguments[g];
        Ee.error.apply(null, Qe("E", y));
      }
    }]), N;
  }();
  function He(N, X) {
    var S = Object.keys(N);
    if (Object.getOwnPropertySymbols) {
      var y = Object.getOwnPropertySymbols(N);
      X && (y = y.filter(function(g) {
        return Object.getOwnPropertyDescriptor(N, g).enumerable;
      })), S.push.apply(S, y);
    }
    return S;
  }
  function te(N) {
    for (var X = 1; X < arguments.length; X++) {
      var S = arguments[X] != null ? arguments[X] : {};
      X % 2 ? He(Object(S), !0).forEach(function(y) {
        ye.default(N, y, S[y]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(N, Object.getOwnPropertyDescriptors(S)) : He(Object(S)).forEach(function(y) {
        Object.defineProperty(N, y, Object.getOwnPropertyDescriptor(S, y));
      });
    }
    return N;
  }
  var it = 5, Vt = "PT5S", Oe = "PT5S", Bt = 100, mt = 1e3, Ot = 4e3, It = 3, Me = !0, Gr = /* @__PURE__ */ ue.default(function N() {
    var X, S, y, g, W, V, b, A = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, k = arguments.length > 1 ? arguments[1] : void 0, T = arguments.length > 2 ? arguments[2] : void 0;
    M.default(this, N), ye.default(this, "typingIndicatorTimeoutDefault", it * 1e3);
    var $ = A.Chat || A.IPMessaging || A || {};
    this.productId = $.productId, this.links = {
      myConversations: k.links.my_conversations,
      conversations: k.links.conversations,
      users: k.links.users,
      currentUser: k.links.current_user,
      typing: k.links.typing,
      mediaService: k.links.media_service,
      mediaSetService: k.links.media_set_service,
      messagesReceipts: k.links.messages_receipts
    }, this.limits = {
      mediaAttachmentsCountLimit: k.options.media_attachments_count_limit,
      mediaAttachmentSizeLimitInMb: k.options.media_attachment_size_limit_in_mb,
      mediaAttachmentsTotalSizeLimitInMb: k.options.media_attachments_total_size_limit_in_mb,
      emailHistoriesAllowedContentTypes: k.options.email_histories_allowed_mime_types,
      emailBodiesAllowedContentTypes: k.options.email_bodies_allowed_mime_types
    }, this.typingIndicatorTimeoutOverride = $.typingIndicatorTimeoutOverride, this.backoffConfiguration = te({
      min: mt,
      max: Ot,
      maxAttemptsCount: It
    }, $.backoffConfigOverride), this.retryWhenThrottled = $.retryWhenThrottledOverride !== void 0 ? $.retryWhenThrottledOverride : Me, this.userInfosToSubscribe = (X = (S = $.userInfosToSubscribeOverride) !== null && S !== void 0 ? S : k.options.user_infos_to_subscribe) !== null && X !== void 0 ? X : Bt, this.reachabilityEnabled = k.options.reachability_enabled, this.userIdentity = k.identity, this.userInfo = k.sync_objects.my_user_info, this.myConversations = k.sync_objects.my_conversations;
    var ee = (y = (g = $.httpCacheIntervalOverride) !== null && g !== void 0 ? g : k.options.http_cache_interval) !== null && y !== void 0 ? y : Vt;
    try {
      this.httpCacheInterval = p.toSeconds(p.parse(ee));
    } catch {
      T.error("Failed to parse http cache interval ".concat(ee, ", using default value ").concat(Vt)), this.httpCacheInterval = p.toSeconds(p.parse(Vt));
    }
    var ve = (W = (V = $.consumptionReportIntervalOverride) !== null && V !== void 0 ? V : k.options.consumption_report_interval) !== null && W !== void 0 ? W : Oe;
    try {
      this.consumptionReportInterval = p.toSeconds(p.parse(ve));
    } catch {
      T.error("Failed to parse consumption report interval ".concat(ve, ", using default value ").concat(Oe)), this.consumptionReportInterval = p.toSeconds(p.parse(Oe));
    }
    this.channelMetadataCacheCapacity = (b = A.channelMetadataCacheCapacity) !== null && b !== void 0 ? b : 100;
  });
  function $e(N) {
    return JSON.parse(JSON.stringify(N));
  }
  function Je(N) {
    return typeof N < "u" && !isNaN(Number(N)) ? Number(N) : null;
  }
  function qt(N) {
    try {
      return new Date(N);
    } catch {
      return null;
    }
  }
  function ft(N, X, S) {
    var y = {};
    if (N)
      try {
        y = JSON.parse(N);
      } catch (g) {
        S.warn(X, g);
      }
    return y;
  }
  var at = /* @__PURE__ */ function() {
    function N(X) {
      M.default(this, N), this.base = X.replace(/\/$/, ""), this.args = [], this.paths = [];
    }
    return ue.default(N, [{
      key: "arg",
      value: function(S, y) {
        return typeof y < "u" && this.args.push(encodeURIComponent(S) + "=" + encodeURIComponent(y)), this;
      }
    }, {
      key: "path",
      value: function(S) {
        return this.paths.push(encodeURIComponent(S)), this;
      }
    }, {
      key: "build",
      value: function() {
        var S = this.base;
        return this.paths.length && (S += "/" + this.paths.join("/")), this.args.length && (S += "?" + this.args.join("&")), S;
      }
    }]), N;
  }(), rt = v.custom(function(N) {
    return [["string", "number", "boolean", "object"].includes(pe.default(N)), "a JSON type"];
  }), Dt = v.custom(function(N) {
    return [["undefined", "string", "number", "boolean", "object"].includes(pe.default(N)), "an optional JSON type"];
  }), vr = v.objectSchema("send media options", {
    contentType: [v.literal(null), "string"],
    filename: ["string", "undefined"],
    media: [v.literal("null"), "string"].concat(ce.default(typeof Buffer == "function" ? [Buffer] : []), ce.default(typeof Blob == "function" ? [Blob] : []))
  });
  function Qr(N) {
    var X = un();
    return function() {
      var y = xe.default(N), g;
      if (X) {
        var W = xe.default(this).constructor;
        g = Reflect.construct(y, arguments, W);
      } else
        g = y.apply(this, arguments);
      return Ie.default(this, g);
    };
  }
  function un() {
    if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
      return !1;
    if (typeof Proxy == "function")
      return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      })), !0;
    } catch {
      return !1;
    }
  }
  var Nr = Ue.scope("User"), kr = /* @__PURE__ */ function(N) {
    he.default(S, N);
    var X = Qr(S);
    function S(y, g, W, V) {
      var b;
      return M.default(this, S), b = X.call(this), ye.default(le.default(b), "promiseToFetch", null), ye.default(le.default(b), "updated", "updated"), ye.default(le.default(b), "userSubscribed", "userSubscribed"), ye.default(le.default(b), "userUnsubscribed", "userUnsubscribed"), b.services = V, b.subscribed = "initializing", b.setMaxListeners(0), b.state = {
        identity: y,
        entityName: g,
        friendlyName: null,
        attributes: {},
        online: null,
        notifiable: null
      }, b._initializationPromise = new Promise(function(A) {
        b._resolveInitializationPromise = A;
      }), W !== null && b._resolveInitialization(W, y, g, !1), b;
    }
    return ue.default(S, [{
      key: "identity",
      get: (
        /**
         * User identity.
         */
        function() {
          return this.state.identity;
        }
      ),
      set: function(g) {
        this.state.identity = g;
      }
    }, {
      key: "entityName",
      set: function(g) {
        this.state.entityName = g;
      }
      /**
       * Custom attributes of the user.
       */
    }, {
      key: "attributes",
      get: function() {
        return this.state.attributes;
      }
      /**
       * Friendly name of the user, null if not set.
       */
    }, {
      key: "friendlyName",
      get: function() {
        return this.state.friendlyName;
      }
      /**
       * Status of the real-time conversation connection of the user.
       */
    }, {
      key: "isOnline",
      get: function() {
        return this.state.online;
      }
      /**
       * User push notification registration status.
       */
    }, {
      key: "isNotifiable",
      get: function() {
        return this.state.notifiable;
      }
      /**
       * True if this user is receiving real-time status updates.
       */
    }, {
      key: "isSubscribed",
      get: function() {
        return this.subscribed == "subscribed";
      }
      // Handles service updates
    }, {
      key: "_update",
      value: function() {
        var y = Z.default(/* @__PURE__ */ F.default.mark(function W(V, b) {
          var A, k;
          return F.default.wrap(function($) {
            for (; ; )
              switch ($.prev = $.next) {
                case 0:
                  return $.next = 2, this._initializationPromise;
                case 2:
                  A = [], Nr.debug("User for", this.state.identity, "updated:", V, b), $.t0 = V, $.next = $.t0 === "friendlyName" ? 7 : $.t0 === "attributes" ? 9 : $.t0 === "reachability" ? 12 : 15;
                  break;
                case 7:
                  return this.state.friendlyName !== b.value && (A.push("friendlyName"), this.state.friendlyName = b.value), $.abrupt("break", 16);
                case 9:
                  return k = ft(b.value, "Retrieved malformed attributes from the server for user: ".concat(this.state.identity), Nr), oe.default(this.state.attributes, k) || (this.state.attributes = k, A.push("attributes")), $.abrupt("break", 16);
                case 12:
                  return this.state.online !== b.online && (this.state.online = b.online, A.push("reachabilityOnline")), this.state.notifiable !== b.notifiable && (this.state.notifiable = b.notifiable, A.push("reachabilityNotifiable")), $.abrupt("break", 16);
                case 15:
                  return $.abrupt("return");
                case 16:
                  A.length > 0 && this.emit("updated", {
                    user: this,
                    updateReasons: A
                  });
                case 17:
                case "end":
                  return $.stop();
              }
          }, W, this);
        }));
        function g(W, V) {
          return y.apply(this, arguments);
        }
        return g;
      }()
      // Fetch reachability info
    }, {
      key: "_updateReachabilityInfo",
      value: function() {
        var y = Z.default(/* @__PURE__ */ F.default.mark(function W(V, b) {
          var A = this;
          return F.default.wrap(function(T) {
            for (; ; )
              switch (T.prev = T.next) {
                case 0:
                  return T.next = 2, this._initializationPromise;
                case 2:
                  if (this.configuration.reachabilityEnabled) {
                    T.next = 4;
                    break;
                  }
                  return T.abrupt("return", Promise.resolve());
                case 4:
                  return T.abrupt("return", V.get("reachability").then(b).catch(function($) {
                    Nr.warn("Failed to get reachability info for ", A.state.identity, $);
                  }));
                case 5:
                case "end":
                  return T.stop();
              }
          }, W, this);
        }));
        function g(W, V) {
          return y.apply(this, arguments);
        }
        return g;
      }()
      // Fetch user
    }, {
      key: "_fetch",
      value: function() {
        var y = Z.default(/* @__PURE__ */ F.default.mark(function W() {
          var V = this;
          return F.default.wrap(function(A) {
            for (; ; )
              switch (A.prev = A.next) {
                case 0:
                  return A.next = 2, this._initializationPromise;
                case 2:
                  if (this.state.entityName) {
                    A.next = 4;
                    break;
                  }
                  return A.abrupt("return", this);
                case 4:
                  return this.promiseToFetch = this.services.syncClient.map({
                    id: this.state.entityName,
                    mode: "open_existing",
                    includeItems: !0
                  }).then(function(k) {
                    return V.entity = k, k.on("itemUpdated", function(T) {
                      return Nr.debug(V.state.entityName + " (" + V.state.identity + ") itemUpdated: " + T.item.key), V._update(T.item.key, T.item.data);
                    }), k.on("itemAdded", function(T) {
                      return Nr.debug(V.state.entityName + " (" + V.state.identity + ") itemAdded: " + T.item.key), V._update(T.item.key, T.item.data);
                    }), Promise.all([k.get("friendlyName").then(function(T) {
                      return V._update(T.key, T.data);
                    }), k.get("attributes").then(function(T) {
                      return V._update(T.key, T.data);
                    }), V._updateReachabilityInfo(k, function(T) {
                      return V._update(T.key, T.data);
                    })]);
                  }).then(function() {
                    return Nr.debug("Fetched for", V.identity), V.subscribed = "subscribed", V.emit("userSubscribed", V), V;
                  }).catch(function(k) {
                    throw V.promiseToFetch = null, k;
                  }), A.abrupt("return", this.promiseToFetch);
                case 6:
                case "end":
                  return A.stop();
              }
          }, W, this);
        }));
        function g() {
          return y.apply(this, arguments);
        }
        return g;
      }()
    }, {
      key: "_ensureFetched",
      value: function() {
        var y = Z.default(/* @__PURE__ */ F.default.mark(function W() {
          return F.default.wrap(function(b) {
            for (; ; )
              switch (b.prev = b.next) {
                case 0:
                  return b.next = 2, this._initializationPromise;
                case 2:
                  return b.abrupt("return", this.promiseToFetch || this._fetch());
                case 3:
                case "end":
                  return b.stop();
              }
          }, W, this);
        }));
        function g() {
          return y.apply(this, arguments);
        }
        return g;
      }()
      /**
       * Edit user attributes.
       * @param attributes New attributes.
       */
    }, {
      key: "updateAttributes",
      value: function() {
        var y = Z.default(/* @__PURE__ */ F.default.mark(function W(V) {
          return F.default.wrap(function(A) {
            for (; ; )
              switch (A.prev = A.next) {
                case 0:
                  return A.next = 2, this._initializationPromise;
                case 2:
                  if (this.subscribed != "unsubscribed") {
                    A.next = 4;
                    break;
                  }
                  throw new Error("Can't modify unsubscribed object");
                case 4:
                  return A.next = 6, this.services.commandExecutor.mutateResource("post", this.links.self, {
                    attributes: JSON.stringify(V)
                  });
                case 6:
                  return A.abrupt("return", this);
                case 7:
                case "end":
                  return A.stop();
              }
          }, W, this);
        }));
        function g(W) {
          return y.apply(this, arguments);
        }
        return g;
      }()
      /**
       * Update the friendly name of the user.
       * @param friendlyName New friendly name.
       */
    }, {
      key: "updateFriendlyName",
      value: function() {
        var y = Z.default(/* @__PURE__ */ F.default.mark(function W(V) {
          return F.default.wrap(function(A) {
            for (; ; )
              switch (A.prev = A.next) {
                case 0:
                  return A.next = 2, this._initializationPromise;
                case 2:
                  if (this.subscribed != "unsubscribed") {
                    A.next = 4;
                    break;
                  }
                  throw new Error("Can't modify unsubscribed object");
                case 4:
                  return A.next = 6, this.services.commandExecutor.mutateResource("post", this.links.self, {
                    friendly_name: V
                  });
                case 6:
                  return A.abrupt("return", this);
                case 7:
                case "end":
                  return A.stop();
              }
          }, W, this);
        }));
        function g(W) {
          return y.apply(this, arguments);
        }
        return g;
      }()
      /**
       * Remove the user from the subscription list.
       * @return A promise of completion.
       */
    }, {
      key: "unsubscribe",
      value: function() {
        var y = Z.default(/* @__PURE__ */ F.default.mark(function W() {
          return F.default.wrap(function(b) {
            for (; ; )
              switch (b.prev = b.next) {
                case 0:
                  return b.next = 2, this._initializationPromise;
                case 2:
                  if (!this.promiseToFetch) {
                    b.next = 9;
                    break;
                  }
                  return b.next = 5, this.promiseToFetch;
                case 5:
                  this.entity.close(), this.promiseToFetch = null, this.subscribed = "unsubscribed", this.emit("userUnsubscribed", this);
                case 9:
                case "end":
                  return b.stop();
              }
          }, W, this);
        }));
        function g() {
          return y.apply(this, arguments);
        }
        return g;
      }()
    }, {
      key: "_resolveInitialization",
      value: function(g, W, V, b) {
        this.configuration = g, this.identity = W, this.entityName = V, this.links = {
          self: "".concat(this.configuration.links.users, "/").concat(encodeURIComponent(this.identity))
        }, this._resolveInitializationPromise(), b && this.emit("updated", {
          user: this,
          updateReasons: ["friendlyName", "attributes", "reachabilityOnline", "reachabilityNotifiable"]
        });
      }
    }]), S;
  }(m.ReplayEventEmitter);
  Ae([v.validateTypesAsync(rt), re("design:type", Function), re("design:paramtypes", [Object]), re("design:returntype", Promise)], kr.prototype, "updateAttributes", null), Ae([v.validateTypesAsync(["string"]), re("design:type", Function), re("design:paramtypes", [String]), re("design:returntype", Promise)], kr.prototype, "updateFriendlyName", null);
  function Jr(N, X) {
    var S = typeof Symbol < "u" && N[Symbol.iterator] || N["@@iterator"];
    if (!S) {
      if (Array.isArray(N) || (S = Ke(N)) || X && N && typeof N.length == "number") {
        S && (N = S);
        var y = 0, g = function() {
        };
        return { s: g, n: function() {
          return y >= N.length ? { done: !0 } : { done: !1, value: N[y++] };
        }, e: function(k) {
          throw k;
        }, f: g };
      }
      throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
    }
    var W = !0, V = !1, b;
    return { s: function() {
      S = S.call(N);
    }, n: function() {
      var k = S.next();
      return W = k.done, k;
    }, e: function(k) {
      V = !0, b = k;
    }, f: function() {
      try {
        !W && S.return != null && S.return();
      } finally {
        if (V)
          throw b;
      }
    } };
  }
  function Ke(N, X) {
    if (N) {
      if (typeof N == "string")
        return Re(N, X);
      var S = Object.prototype.toString.call(N).slice(8, -1);
      if (S === "Object" && N.constructor && (S = N.constructor.name), S === "Map" || S === "Set")
        return Array.from(N);
      if (S === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(S))
        return Re(N, X);
    }
  }
  function Re(N, X) {
    (X == null || X > N.length) && (X = N.length);
    for (var S = 0, y = new Array(X); S < X; S++)
      y[S] = N[S];
    return y;
  }
  var ge = /* @__PURE__ */ function() {
    function N(X, S) {
      M.default(this, N), this.configuration = X, this.services = S, this.cache = /* @__PURE__ */ new Map(), this.cacheLifetime = this.configuration.httpCacheInterval * 100, this.cleanupCache();
    }
    return ue.default(N, [{
      key: "isExpired",
      value: function(S) {
        return !this.cacheLifetime || Date.now() - S > this.cacheLifetime;
      }
    }, {
      key: "cleanupCache",
      value: function() {
        var S = Jr(this.cache), y;
        try {
          for (S.s(); !(y = S.n()).done; ) {
            var g = z.default(y.value, 2), W = g[0], V = g[1];
            this.isExpired(V.timestamp) && this.cache.delete(W);
          }
        } catch (b) {
          S.e(b);
        } finally {
          S.f();
        }
        this.cache.size === 0 && clearInterval(this.timer);
      }
    }, {
      key: "pokeTimer",
      value: function() {
        var S = this;
        this.timer = this.timer || setInterval(function() {
          return S.cleanupCache();
        }, this.cacheLifetime * 2);
      }
    }, {
      key: "executeWithRetry",
      value: function(S) {
        var y = this, g = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
        return new Promise(function(W, V) {
          var b = [502, 503, 504];
          g && b.push(429);
          var A = new O.Retrier(y.configuration.backoffConfiguration);
          A.on("attempt", function() {
            S().then(function(k) {
              return A.succeeded(k);
            }).catch(function(k) {
              b.indexOf(k.status) > -1 || k.message === "Twilsock disconnected" ? A.failed(k) : (A.removeAllListeners(), A.cancel(), V(k));
            });
          }), A.on("succeeded", function(k) {
            W(k);
          }), A.on("cancelled", function(k) {
            return V(k);
          }), A.on("failed", function(k) {
            return V(k);
          }), A.start();
        });
      }
    }, {
      key: "get",
      value: function() {
        var X = Z.default(/* @__PURE__ */ F.default.mark(function y(g) {
          var W = this, V, b, A;
          return F.default.wrap(function(T) {
            for (; ; )
              switch (T.prev = T.next) {
                case 0:
                  if (V = this.cache.get(g), !(V && !this.isExpired(V.timestamp))) {
                    T.next = 3;
                    break;
                  }
                  return T.abrupt("return", V.response);
                case 3:
                  return b = {}, T.next = 6, this.executeWithRetry(function() {
                    return W.services.transport.get(g, b, W.configuration.productId);
                  }, this.configuration.retryWhenThrottled);
                case 6:
                  return A = T.sent, this.cache.set(g, {
                    response: A,
                    timestamp: Date.now()
                  }), this.pokeTimer(), T.abrupt("return", A);
                case 10:
                case "end":
                  return T.stop();
              }
          }, y, this);
        }));
        function S(y) {
          return X.apply(this, arguments);
        }
        return S;
      }()
    }]), N;
  }(), qe = /* @__PURE__ */ ue.default(function N() {
    M.default(this, N);
  });
  ye.default(qe, "TYPING_INDICATOR", "twilio.ipmsg.typing_indicator"), ye.default(qe, "NEW_MESSAGE", "twilio.conversations.new_message"), ye.default(qe, "ADDED_TO_CONVERSATION", "twilio.conversations.added_to_conversation"), ye.default(qe, "REMOVED_FROM_CONVERSATION", "twilio.conversations.removed_from_conversation"), ye.default(qe, "CONSUMPTION_UPDATE", "twilio.channel.consumption_update");
  function Ve(N) {
    var X = Ne();
    return function() {
      var y = xe.default(N), g;
      if (X) {
        var W = xe.default(this).constructor;
        g = Reflect.construct(y, arguments, W);
      } else
        g = y.apply(this, arguments);
      return Ie.default(this, g);
    };
  }
  function Ne() {
    if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
      return !1;
    if (typeof Proxy == "function")
      return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      })), !0;
    } catch {
      return !1;
    }
  }
  var Xe = Ue.scope("Participant"), fe = /* @__PURE__ */ function(N) {
    he.default(S, N);
    var X = Ve(S);
    function S(y, g, W, V, b) {
      var A, k, T;
      if (M.default(this, S), T = X.call(this), T.conversation = W, T.links = V, T.services = b, T.state = {
        attributes: ft(y.attributes, "Retrieved malformed attributes from the server for participant: " + g, Xe),
        dateCreated: y.dateCreated ? qt(y.dateCreated) : null,
        dateUpdated: y.dateCreated ? qt(y.dateUpdated) : null,
        sid: g,
        typingTimeout: null,
        isTyping: !1,
        identity: y.identity,
        roleSid: (A = y.roleSid) !== null && A !== void 0 ? A : "",
        lastReadMessageIndex: Number.isInteger(y.lastConsumedMessageIndex) ? y.lastConsumedMessageIndex : null,
        lastReadTimestamp: y.lastConsumptionTimestamp ? qt(y.lastConsumptionTimestamp) : null,
        type: y.type || "chat",
        userInfo: y.userInfo,
        bindings: (k = y.bindings) !== null && k !== void 0 ? k : {}
      }, !y.identity && !y.type)
        throw new Error("Received invalid Participant object from server: Missing identity or type of Participant.");
      return T;
    }
    return ue.default(S, [{
      key: "sid",
      get: (
        /**
         * Conversation that the remote client is a participant of.
         */
        /**
         * The server-assigned unique identifier for the participant.
         */
        function() {
          return this.state.sid;
        }
      )
      /**
       * Custom attributes of the participant.
       */
    }, {
      key: "attributes",
      get: function() {
        return this.state.attributes;
      }
      /**
       * Date this participant was created on.
       */
    }, {
      key: "dateCreated",
      get: function() {
        return this.state.dateCreated;
      }
      /**
       * Date this participant was last updated on.
       */
    }, {
      key: "dateUpdated",
      get: function() {
        return this.state.dateUpdated;
      }
      /**
       * Identity of the participant.
       */
    }, {
      key: "identity",
      get: function() {
        return this.state.identity;
      }
      /**
       * Indicates whether the participant is currently typing.
       */
    }, {
      key: "isTyping",
      get: function() {
        return this.state.isTyping;
      }
      /**
       * The index of the last read message by the participant.
       * Note that retrieving messages on a client endpoint does not mean that messages are read,
       * please consider reading about the [Read Horizon feature](https://www.twilio.com/docs/api/chat/guides/consumption-horizon)
       * to find out about the proper way to mark messages as read.
       */
    }, {
      key: "lastReadMessageIndex",
      get: function() {
        return this.state.lastReadMessageIndex;
      }
      /**
       * Date of the most recent read horizon update.
       */
    }, {
      key: "lastReadTimestamp",
      get: function() {
        return this.state.lastReadTimestamp;
      }
    }, {
      key: "roleSid",
      get: function() {
        return this.state.roleSid;
      }
      /**
       * Type of the participant.
       */
    }, {
      key: "type",
      get: function() {
        return this.state.type;
      }
      /**
       * Get the bindings mapping for the current participant.
       * Available binding depends on the participant type.
       * You could access it as `participant.bindings.sms?.address` or
       * using the type dynamically `participant.bindings[participant.type]`
       * just be aware that the binding information has different structure for
       * each participant type.
       * See also {ParticipantEmailBinding}, the only available currently binding descriptor.
       */
    }, {
      key: "bindings",
      get: function() {
        var g;
        return (g = this.state.bindings) !== null && g !== void 0 ? g : {};
      }
    }, {
      key: "_startTyping",
      value: (
        /**
         * Internal method used to start or reset the typing indicator timeout (with event emitting).
         * @internal
         */
        function(g) {
          var W = this;
          return this.state.typingTimeout && clearTimeout(this.state.typingTimeout), this.state.isTyping = !0, this.emit("typingStarted", this), this.conversation.emit("typingStarted", this), this.state.typingTimeout = Number(setTimeout(function() {
            return W._endTyping();
          }, g)), this;
        }
      )
      /**
       * Internal method function used to stop the typing indicator timeout (with event emitting).
       * @internal
       */
    }, {
      key: "_endTyping",
      value: function() {
        this.state.typingTimeout && (this.state.isTyping = !1, this.emit("typingEnded", this), this.conversation.emit("typingEnded", this), clearInterval(this.state.typingTimeout), this.state.typingTimeout = null);
      }
      /**
       * Internal method function used update local object's property roleSid with a new value.
       * @internal
       */
    }, {
      key: "_update",
      value: function(g) {
        var W = [], V = ft(g.attributes, "Retrieved malformed attributes from the server for participant: " + this.state.sid, Xe);
        g.attributes && !oe.default(this.state.attributes, V) && (this.state.attributes = V, W.push("attributes"));
        var b = qt(g.dateUpdated);
        g.dateUpdated && (b == null ? void 0 : b.getTime()) !== (this.state.dateUpdated && this.state.dateUpdated.getTime()) && (this.state.dateUpdated = b, W.push("dateUpdated"));
        var A = qt(g.dateCreated);
        if (g.dateCreated && (A == null ? void 0 : A.getTime()) !== (this.state.dateCreated && this.state.dateCreated.getTime()) && (this.state.dateCreated = A, W.push("dateCreated")), g.roleSid && this.state.roleSid !== g.roleSid && (this.state.roleSid = g.roleSid, W.push("roleSid")), (Number.isInteger(g.lastConsumedMessageIndex) || g.lastConsumedMessageIndex === null) && this.state.lastReadMessageIndex !== g.lastConsumedMessageIndex && (this.state.lastReadMessageIndex = g.lastConsumedMessageIndex, W.push("lastReadMessageIndex")), g.lastConsumptionTimestamp) {
          var k = new Date(g.lastConsumptionTimestamp);
          (!this.state.lastReadTimestamp || this.state.lastReadTimestamp.getTime() !== k.getTime()) && (this.state.lastReadTimestamp = k, W.push("lastReadTimestamp"));
        }
        return g.bindings && !oe.default(this.state.bindings, g.bindings) && (this.state.bindings = g.bindings, W.push("bindings")), W.length > 0 && this.emit("updated", {
          participant: this,
          updateReasons: W
        }), this;
      }
      /**
       * Get the user for this participant and subscribes to it. Supported only for participants of type `chat`.
       */
    }, {
      key: "getUser",
      value: function() {
        var y = Z.default(/* @__PURE__ */ F.default.mark(function W() {
          return F.default.wrap(function(b) {
            for (; ; )
              switch (b.prev = b.next) {
                case 0:
                  if (this.type == "chat") {
                    b.next = 2;
                    break;
                  }
                  throw new Error("Getting User is not supported for this Participant type: " + this.type);
                case 2:
                  return b.abrupt("return", this.services.users.getUser(this.state.identity, this.state.userInfo));
                case 3:
                case "end":
                  return b.stop();
              }
          }, W, this);
        }));
        function g() {
          return y.apply(this, arguments);
        }
        return g;
      }()
      /**
       * Remove the participant from the conversation.
       */
    }, {
      key: "remove",
      value: function() {
        var y = Z.default(/* @__PURE__ */ F.default.mark(function W() {
          return F.default.wrap(function(b) {
            for (; ; )
              switch (b.prev = b.next) {
                case 0:
                  return b.abrupt("return", this.conversation.removeParticipant(this));
                case 1:
                case "end":
                  return b.stop();
              }
          }, W, this);
        }));
        function g() {
          return y.apply(this, arguments);
        }
        return g;
      }()
      /**
       * Update the attributes of the participant.
       * @param attributes New attributes.
       */
    }, {
      key: "updateAttributes",
      value: function() {
        var y = Z.default(/* @__PURE__ */ F.default.mark(function W(V) {
          return F.default.wrap(function(A) {
            for (; ; )
              switch (A.prev = A.next) {
                case 0:
                  return A.next = 2, this.services.commandExecutor.mutateResource("post", this.links.self, {
                    attributes: JSON.stringify(V)
                  });
                case 2:
                  return A.abrupt("return", this);
                case 3:
                case "end":
                  return A.stop();
              }
          }, W, this);
        }));
        function g(W) {
          return y.apply(this, arguments);
        }
        return g;
      }()
    }]), S;
  }(m.ReplayEventEmitter);
  ye.default(fe, "typingStarted", "typingStarted"), ye.default(fe, "typingEnded", "typingEnded"), ye.default(fe, "updated", "updated"), Ae([v.validateTypesAsync(rt), re("design:type", Function), re("design:paramtypes", [Object]), re("design:returntype", Promise)], fe.prototype, "updateAttributes", null);
  function ke(N) {
    var X = ae();
    return function() {
      var y = xe.default(N), g;
      if (X) {
        var W = xe.default(this).constructor;
        g = Reflect.construct(y, arguments, W);
      } else
        g = y.apply(this, arguments);
      return Ie.default(this, g);
    };
  }
  function ae() {
    if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
      return !1;
    if (typeof Proxy == "function")
      return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      })), !0;
    } catch {
      return !1;
    }
  }
  var me = Ue.scope("Participants"), se = /* @__PURE__ */ function(N) {
    he.default(S, N);
    var X = ke(S);
    function S(y, g, W, V, b) {
      var A;
      return M.default(this, S), A = X.call(this), ye.default(le.default(A), "rosterEntityPromise", null), A.conversation = y, A.participants = g, A.links = W, A.configuration = V, A.services = b, A;
    }
    return ue.default(S, [{
      key: "unsubscribe",
      value: function() {
        var y = Z.default(/* @__PURE__ */ F.default.mark(function W() {
          var V;
          return F.default.wrap(function(A) {
            for (; ; )
              switch (A.prev = A.next) {
                case 0:
                  if (!this.rosterEntityPromise) {
                    A.next = 6;
                    break;
                  }
                  return A.next = 3, this.rosterEntityPromise;
                case 3:
                  V = A.sent, V.close(), this.rosterEntityPromise = null;
                case 6:
                case "end":
                  return A.stop();
              }
          }, W, this);
        }));
        function g() {
          return y.apply(this, arguments);
        }
        return g;
      }()
    }, {
      key: "subscribe",
      value: function(g) {
        var W = this, V = typeof g == "string" ? this.services.syncClient.map({
          id: g,
          mode: "open_existing"
        }) : Promise.resolve(g);
        return this.rosterEntityPromise = this.rosterEntityPromise || V.then(function(b) {
          b.on("itemAdded", function(T) {
            me.debug(W.conversation.sid + " itemAdded: " + T.item.key), W.upsertParticipant(T.item.key, T.item.data).then(function($) {
              W.emit("participantJoined", $);
            });
          }), b.on("itemRemoved", function(T) {
            me.debug(W.conversation.sid + " itemRemoved: " + T.key);
            var $ = T.key;
            if (W.participants.has($)) {
              var ee = W.participants.get($);
              W.participants.delete($), ee && W.emit("participantLeft", ee);
            }
          }), b.on("itemUpdated", function(T) {
            me.debug(W.conversation.sid + " itemUpdated: " + T.item.key), W.upsertParticipant(T.item.key, T.item.data);
          });
          var A = [], k = function T($) {
            return $.items.forEach(function(ee) {
              A.push(W.upsertParticipant(ee.key, ee.data));
            }), $.hasNextPage ? $.nextPage().then(T) : null;
          };
          return b.getItems().then(k).then(function() {
            return Promise.all(A);
          }).then(function() {
            return b;
          });
        }).catch(function(b) {
          throw W.rosterEntityPromise = null, W.services.syncClient.connectionState != "disconnected" && me.error("Failed to get roster object for conversation", W.conversation.sid, b), me.debug("ERROR: Failed to get roster object for conversation", W.conversation.sid, b), b;
        });
      }
    }, {
      key: "upsertParticipantFromResponse",
      value: function() {
        var y = Z.default(/* @__PURE__ */ F.default.mark(function W(V) {
          var b, A, k, T, $, ee, ve, we;
          return F.default.wrap(function(At) {
            for (; ; )
              switch (At.prev = At.next) {
                case 0:
                  return A = V.sid, k = V.attributes, T = V.date_created, $ = V.date_updated, ee = V.identity, ve = V.role_sid, we = V.messaging_binding, At.next = 3, this.upsertParticipant(A, {
                    attributes: k,
                    dateCreated: new Date(T),
                    dateUpdated: new Date($),
                    identity: ee,
                    roleSid: ve,
                    lastConsumedMessageIndex: null,
                    lastConsumptionTimestamp: null,
                    type: (b = we == null ? void 0 : we.type) !== null && b !== void 0 ? b : "chat"
                  });
                case 3:
                  return At.abrupt("return", At.sent);
                case 4:
                case "end":
                  return At.stop();
              }
          }, W, this);
        }));
        function g(W) {
          return y.apply(this, arguments);
        }
        return g;
      }()
    }, {
      key: "upsertParticipant",
      value: function() {
        var y = Z.default(/* @__PURE__ */ F.default.mark(function W(V, b) {
          var A = this, k, T;
          return F.default.wrap(function(ee) {
            for (; ; )
              switch (ee.prev = ee.next) {
                case 0:
                  if (k = this.participants.get(V), !k) {
                    ee.next = 3;
                    break;
                  }
                  return ee.abrupt("return", k._update(b));
                case 3:
                  return T = {
                    self: "".concat(this.links.participants, "/").concat(V)
                  }, k = new fe(b, V, this.conversation, T, this.services), this.participants.set(V, k), k.on("updated", function(ve) {
                    return A.emit("participantUpdated", ve);
                  }), ee.abrupt("return", k);
                case 8:
                case "end":
                  return ee.stop();
              }
          }, W, this);
        }));
        function g(W, V) {
          return y.apply(this, arguments);
        }
        return g;
      }()
      /**
       * @returns {Promise<Array<Participant>>} returns list of participants {@see Participant}
       */
    }, {
      key: "getParticipants",
      value: function() {
        var y = Z.default(/* @__PURE__ */ F.default.mark(function W() {
          var V = this;
          return F.default.wrap(function(A) {
            for (; ; )
              switch (A.prev = A.next) {
                case 0:
                  return A.abrupt("return", this.rosterEntityPromise ? this.rosterEntityPromise.then(function() {
                    var k = [];
                    return V.participants.forEach(function(T) {
                      return k.push(T);
                    }), k;
                  }) : []);
                case 1:
                case "end":
                  return A.stop();
              }
          }, W, this);
        }));
        function g() {
          return y.apply(this, arguments);
        }
        return g;
      }()
      /**
       * Get participant by SID from conversation
       * @returns {Promise<Participant>}
       */
    }, {
      key: "getParticipantBySid",
      value: function() {
        var y = Z.default(/* @__PURE__ */ F.default.mark(function W(V) {
          var b = this;
          return F.default.wrap(function(k) {
            for (; ; )
              switch (k.prev = k.next) {
                case 0:
                  return k.abrupt("return", this.rosterEntityPromise ? this.rosterEntityPromise.then(function() {
                    var T = b.participants.get(V);
                    if (!T)
                      throw new Error("Participant with SID " + V + " was not found");
                    return T;
                  }) : null);
                case 1:
                case "end":
                  return k.stop();
              }
          }, W, this);
        }));
        function g(W) {
          return y.apply(this, arguments);
        }
        return g;
      }()
      /**
       * Get participant by identity from conversation
       * @returns {Promise<Participant>}
       */
    }, {
      key: "getParticipantByIdentity",
      value: function() {
        var y = Z.default(/* @__PURE__ */ F.default.mark(function W(V) {
          var b = this, A;
          return F.default.wrap(function(T) {
            for (; ; )
              switch (T.prev = T.next) {
                case 0:
                  return A = null, T.abrupt("return", this.rosterEntityPromise ? this.rosterEntityPromise.then(function() {
                    if (b.participants.forEach(function($) {
                      $.identity === V && (A = $);
                    }), !A)
                      throw new Error("Participant with identity " + V + " was not found");
                    return A;
                  }) : null);
                case 2:
                case "end":
                  return T.stop();
              }
          }, W, this);
        }));
        function g(W) {
          return y.apply(this, arguments);
        }
        return g;
      }()
      /**
       * Add a chat participant to the conversation
       */
    }, {
      key: "add",
      value: function() {
        var y = Z.default(/* @__PURE__ */ F.default.mark(function W(V, b) {
          return F.default.wrap(function(k) {
            for (; ; )
              switch (k.prev = k.next) {
                case 0:
                  return k.next = 2, this.services.commandExecutor.mutateResource("post", this.links.participants, {
                    identity: V,
                    attributes: typeof b < "u" ? JSON.stringify(b) : void 0
                  });
                case 2:
                  return k.abrupt("return", k.sent);
                case 3:
                case "end":
                  return k.stop();
              }
          }, W, this);
        }));
        function g(W, V) {
          return y.apply(this, arguments);
        }
        return g;
      }()
      /**
       * Add a non-chat participant to the conversation.
       */
    }, {
      key: "addNonChatParticipant",
      value: function() {
        var y = Z.default(/* @__PURE__ */ F.default.mark(function W(V, b) {
          var A, k, T, $, ee = arguments;
          return F.default.wrap(function(we) {
            for (; ; )
              switch (we.prev = we.next) {
                case 0:
                  return T = ee.length > 2 && ee[2] !== void 0 ? ee[2] : {}, $ = ee.length > 3 && ee[3] !== void 0 ? ee[3] : {}, we.next = 4, this.services.commandExecutor.mutateResource("post", this.links.participants, {
                    attributes: typeof T < "u" ? JSON.stringify(T) : void 0,
                    messaging_binding: {
                      address: b,
                      proxy_address: V,
                      name: $ == null || (A = $.email) === null || A === void 0 ? void 0 : A.name,
                      level: $ == null || (k = $.email) === null || k === void 0 ? void 0 : k.level
                    }
                  });
                case 4:
                  return we.abrupt("return", we.sent);
                case 5:
                case "end":
                  return we.stop();
              }
          }, W, this);
        }));
        function g(W, V) {
          return y.apply(this, arguments);
        }
        return g;
      }()
      /**
       * Remove the participant with a given identity from a conversation.
       */
    }, {
      key: "remove",
      value: function(g) {
        return this.services.commandExecutor.mutateResource("delete", "".concat(this.links.participants, "/").concat(encodeURIComponent(g)));
      }
    }]), S;
  }(m.ReplayEventEmitter), ze = /* @__PURE__ */ function() {
    function N(X, S) {
      var y;
      M.default(this, N), ye.default(this, "mcsMedia", null), this.services = S, X instanceof P.McsMedia && (this.mcsMedia = X), this.state = {
        sid: X.sid,
        category: X.category,
        filename: (y = X.filename) !== null && y !== void 0 ? y : null,
        contentType: X.contentType,
        size: X.size
      };
    }
    return ue.default(N, [{
      key: "sid",
      get: function() {
        return this.state.sid;
      }
      /**
       * File name. Null if absent.
       */
    }, {
      key: "filename",
      get: function() {
        return this.state.filename;
      }
      /**
       * Content type of the media.
       */
    }, {
      key: "contentType",
      get: function() {
        return this.state.contentType;
      }
      /**
       * Size of the media in bytes.
       */
    }, {
      key: "size",
      get: function() {
        return this.state.size;
      }
      /**
       * Media category, can be one of the {@link MediaCategory} values.
       */
    }, {
      key: "category",
      get: function() {
        return this.state.category;
      }
      /**
       * Returns the direct content URL for the media.
       *
       * This URL is impermanent, it will expire in several minutes and cannot be cached.
       * If the URL becomes expired, you need to request a new one.
       * Each call to this function produces a new temporary URL.
       */
    }, {
      key: "getContentTemporaryUrl",
      value: function() {
        var S = this;
        return new P.CancellablePromise(/* @__PURE__ */ function() {
          var y = Z.default(/* @__PURE__ */ F.default.mark(function g(W, V, b) {
            var A, k, T, $;
            return F.default.wrap(function(ve) {
              for (; ; )
                switch (ve.prev = ve.next) {
                  case 0:
                    if (k = S.mcsMedia ? void 0 : S._fetchMcsMedia(), T = (A = S.mcsMedia) === null || A === void 0 ? void 0 : A.getContentUrl(), b(function() {
                      k && k.cancel(), T && T.cancel();
                    }), ve.prev = 3, T) {
                      ve.next = 9;
                      break;
                    }
                    return ve.next = 7, k;
                  case 7:
                    $ = ve.sent, T = $ == null ? void 0 : $.getContentUrl();
                  case 9:
                    if (ve.t0 = W, !T) {
                      ve.next = 16;
                      break;
                    }
                    return ve.next = 13, T;
                  case 13:
                    ve.t1 = ve.sent, ve.next = 17;
                    break;
                  case 16:
                    ve.t1 = null;
                  case 17:
                    ve.t2 = ve.t1, (0, ve.t0)(ve.t2), ve.next = 24;
                    break;
                  case 21:
                    ve.prev = 21, ve.t3 = ve.catch(3), V(ve.t3);
                  case 24:
                  case "end":
                    return ve.stop();
                }
            }, g, null, [[3, 21]]);
          }));
          return function(g, W, V) {
            return y.apply(this, arguments);
          };
        }());
      }
    }, {
      key: "_fetchMcsMedia",
      value: function() {
        var S = this;
        return new P.CancellablePromise(/* @__PURE__ */ function() {
          var y = Z.default(/* @__PURE__ */ F.default.mark(function g(W, V, b) {
            var A;
            return F.default.wrap(function(T) {
              for (; ; )
                switch (T.prev = T.next) {
                  case 0:
                    return S.services.mcsClient === null && V(new Error("Media Content Service is unavailable")), A = S.services.mcsClient.get(S.state.sid), b(function() {
                      return A.cancel();
                    }), T.prev = 3, T.next = 6, A;
                  case 6:
                    S.mcsMedia = T.sent, S.state = S.mcsMedia._state(), W(S.mcsMedia), T.next = 14;
                    break;
                  case 11:
                    T.prev = 11, T.t0 = T.catch(3), V(T.t0);
                  case 14:
                  case "end":
                    return T.stop();
                }
            }, g, null, [[3, 11]]);
          }));
          return function(g, W, V) {
            return y.apply(this, arguments);
          };
        }());
      }
      /**
       * @internal
       */
    }, {
      key: "_state",
      value: function() {
        return this.state;
      }
    }]), N;
  }(), Pe = /* @__PURE__ */ function() {
    function N(X) {
      M.default(this, N), this.state = X;
    }
    return ue.default(N, [{
      key: "total",
      get: function() {
        return this.state.total;
      }
      /**
       * Message is considered as **sent** to a participant if the nearest upstream carrier accepted the message.
       *
       * @return Amount of participants that have the **sent** delivery status for the message.
       */
    }, {
      key: "sent",
      get: function() {
        return this.state.sent;
      }
      /**
       * Message is considered as **delivered** to a participant if Twilio has received confirmation of message
       * delivery from the upstream carrier, and, where available, the destination handset.
       *
       * @return Amount of participants that have the **delivered** delivery status for the message.
       */
    }, {
      key: "delivered",
      get: function() {
        return this.state.delivered;
      }
      /**
       * Message is considered as **read** by a participant, if the message has been delivered and opened by the
       * recipient in a conversation. The recipient must have enabled the read receipts.
       *
       * @return Amount of participants that have the **read** delivery status for the message.
       */
    }, {
      key: "read",
      get: function() {
        return this.state.read;
      }
      /**
       * Message is considered as **undelivered** to a participant if Twilio has received a delivery receipt
       * indicating that the message was not delivered. This can happen for many reasons including carrier content
       * filtering and the availability of the destination handset.
       *
       * @return Ammount of participants that have the **undelivered** delivery status for the message.
       */
    }, {
      key: "undelivered",
      get: function() {
        return this.state.undelivered;
      }
      /**
       * Message is considered as **failed** to be delivered to a participant if the message could not be sent.
       * This can happen for various reasons including queue overflows, account suspensions and media
       * errors (in the case of MMS for instance). Twilio does not charge you for failed messages.
       *
       * @return Amount of participants that have the **failed** delivery status for the message.
       */
    }, {
      key: "failed",
      get: function() {
        return this.state.failed;
      }
    }, {
      key: "_update",
      value: function(S) {
        this.state = S;
      }
    }, {
      key: "_isEquals",
      value: function(S) {
        var y = this.total === S.total, g = this.sent === S.sent, W = this.delivered === S.delivered, V = this.read === S.read, b = this.undelivered === S.undelivered, A = this.failed === S.failed;
        return y && g && W && V && b && A;
      }
    }]), N;
  }(), dt = /* @__PURE__ */ function() {
    function N(X, S, y, g) {
      M.default(this, N), this.state = {
        prevToken: y,
        nextToken: g,
        source: S,
        items: X
      };
    }
    return ue.default(N, [{
      key: "hasNextPage",
      get: (
        /**
         * Indicates the existence of the next page.
         */
        function() {
          return !!this.state.nextToken;
        }
      )
      /**
       * Indicates the existence of the previous page
       */
    }, {
      key: "hasPrevPage",
      get: function() {
        return !!this.state.prevToken;
      }
      /**
       * Array of elements on the current page.
       */
    }, {
      key: "items",
      get: function() {
        return this.state.items;
      }
    }, {
      key: "nextPage",
      value: function() {
        return this.hasNextPage ? this.state.source(this.state.nextToken) : Promise.reject(new Error("No next page"));
      }
      /**
       * Request the previous page. Does not modify the existing object.
       */
    }, {
      key: "prevPage",
      value: function() {
        return this.hasPrevPage ? this.state.source(this.state.prevToken) : Promise.reject(new Error("No previous page"));
      }
    }]), N;
  }(), tt = /* @__PURE__ */ ue.default(
    /**
     * Unique identifier for the delivery receipt.
     */
    /**
     * Unique identifier for the message in the conversation.
     */
    /**
     * Unique identifier for the conversation.
     */
    /**
     * Unique identifier for the `‘channel’` message (e.g., `WAxx` for WhatsApp, `SMxx` for SMS).
     */
    /**
     * Unique identifier for the participant.
     */
    /**
     * Status of the message delivery.
     */
    /**
     * Numeric error code mapped from Status callback code. Information about the error codes can be found
     * [here](https://www.twilio.com/docs/sms/api/message-resource#delivery-related-errors).
     */
    /**
     * Date this delivery receipt was created on.
     */
    /**
     * Date this delivery receipt was last updated on.
     */
    /**
     * @internal
     */
    function N(X) {
      M.default(this, N), this.sid = X.sid, this.messageSid = X.message_sid, this.conversationSid = X.conversation_sid, this.channelMessageSid = X.channel_message_sid, this.participantSid = X.participant_sid, this.status = X.status || "queued", this.errorCode = X.error_code || 0, this.dateCreated = X.date_created, this.dateUpdated = X.date_updated;
    }
  ), st = function(X) {
    return X.map(function(S) {
      var y, g, W, V, b = JSON.stringify(S);
      switch (S.type) {
        case "QUICK_REPLY":
          return {
            type: "reply",
            title: S.title,
            id: (y = S.id) !== null && y !== void 0 ? y : "",
            index: (g = S.index) !== null && g !== void 0 ? g : 0,
            rawData: b
          };
        case "PHONE_NUMBER":
          return {
            type: "phone",
            title: S.title,
            phone: (W = S.phone) !== null && W !== void 0 ? W : "",
            rawData: b
          };
        case "URL":
          return {
            type: "url",
            title: S.title,
            url: (V = S.url) !== null && V !== void 0 ? V : "",
            rawData: b
          };
        default:
          return {
            type: "other",
            rawData: b
          };
      }
    });
  }, vt = function(X, S) {
    var y = JSON.stringify(S);
    switch (X) {
      case "twilio/text": {
        var g = S;
        return {
          type: "text",
          body: g.body,
          rawData: y
        };
      }
      case "twilio/media": {
        var W = S;
        return {
          type: "media",
          body: W.body,
          media: W.media,
          rawData: y
        };
      }
      case "twilio/location": {
        var V = S;
        return {
          type: "location",
          longitude: V.longitude,
          latitude: V.latitude,
          label: V.label,
          rawData: y
        };
      }
      case "twilio/quick-reply": {
        var b = S;
        return {
          type: "quickReply",
          body: b.body,
          replies: b.actions,
          rawData: y
        };
      }
      case "twilio/call-to-action": {
        var A = S;
        return {
          type: "callToAction",
          body: A.body,
          actions: st(A.actions),
          rawData: y
        };
      }
      case "twilio/list-picker": {
        var k = S;
        return {
          type: "listPicker",
          body: k.body,
          button: k.button,
          items: k.items,
          rawData: y
        };
      }
      case "twilio/card": {
        var T, $, ee = S;
        return {
          type: "card",
          title: ee.title,
          subtitle: ee.subtitle,
          media: (T = ee.media) !== null && T !== void 0 ? T : [],
          actions: st(($ = ee.actions) !== null && $ !== void 0 ? $ : []),
          rawData: y
        };
      }
      default:
        return {
          type: "other",
          rawData: y
        };
    }
  }, ht = function(X) {
    for (var S = /* @__PURE__ */ new Map(), y = 0, g = Object.entries(X); y < g.length; y++) {
      var W = z.default(g[y], 2), V = W[0], b = W[1];
      S.set(V, vt(V, b));
    }
    return S;
  }, lt = /* @__PURE__ */ function() {
    function N(X, S) {
      M.default(this, N), this.name = X, this.value = S;
    }
    return ue.default(N, [{
      key: "copyWithValue",
      value: function(S) {
        return new N(this.name, S);
      }
    }]), N;
  }(), G = /* @__PURE__ */ ue.default(
    /**
     * The server-assigned unique identifier for the template.
     */
    /**
     * Friendly name used to describe the content. Not visible to the recipient.
     */
    /**
     * Variables used by this template.
     */
    /**
     * Variants of the content. See {@link ContentData}.
     */
    /**
     * Date of creation.
     */
    /**
     * Date of the last update.
     */
    /**
     * @internal
     */
    function N(X) {
      M.default(this, N), this.sid = X.sid, this.friendlyName = X.friendly_name, this.variables = Object.entries(JSON.parse(X.variables)).map(function(S) {
        var y = z.default(S, 2), g = y[0], W = y[1];
        return new lt(g, W);
      }), this.variants = ht(X.variants), this.dateCreated = new Date(X.date_created), this.dateUpdated = new Date(X.date_updated);
    }
  );
  function Ce(N, X) {
    var S = Object.keys(N);
    if (Object.getOwnPropertySymbols) {
      var y = Object.getOwnPropertySymbols(N);
      X && (y = y.filter(function(g) {
        return Object.getOwnPropertyDescriptor(N, g).enumerable;
      })), S.push.apply(S, y);
    }
    return S;
  }
  function Te(N) {
    for (var X = 1; X < arguments.length; X++) {
      var S = arguments[X] != null ? arguments[X] : {};
      X % 2 ? Ce(Object(S), !0).forEach(function(y) {
        ye.default(N, y, S[y]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(N, Object.getOwnPropertyDescriptors(S)) : Ce(Object(S)).forEach(function(y) {
        Object.defineProperty(N, y, Object.getOwnPropertyDescriptor(S, y));
      });
    }
    return N;
  }
  function ct(N) {
    var X = Ft();
    return function() {
      var y = xe.default(N), g;
      if (X) {
        var W = xe.default(this).constructor;
        g = Reflect.construct(y, arguments, W);
      } else
        g = y.apply(this, arguments);
      return Ie.default(this, g);
    };
  }
  function Ft() {
    if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
      return !1;
    if (typeof Proxy == "function")
      return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      })), !0;
    } catch {
      return !1;
    }
  }
  function nt(N, X) {
    Ct(N, X), X.add(N);
  }
  function Ct(N, X) {
    if (X.has(N))
      throw new TypeError("Cannot initialize the same private elements twice on an object");
  }
  function Wt(N, X, S) {
    if (!X.has(N))
      throw new TypeError("attempted to get private field on non-instance");
    return S;
  }
  var yr = Ue.scope("Message"), hr = (
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    t.XMLHttpRequest || {}
  ), Yt = /* @__PURE__ */ new WeakSet(), Vr = /* @__PURE__ */ new WeakSet(), xr = /* @__PURE__ */ function(N) {
    he.default(S, N);
    var X = ct(S);
    function S(y, g, W, V, b, A) {
      var k, T, $, ee, ve, we, gt, At;
      return M.default(this, S), At = X.call(this), nt(le.default(At), Vr), nt(le.default(At), Yt), At.conversation = W, At.links = V, At.configuration = b, At.services = A, At.state = {
        sid: g.sid,
        index: y,
        author: g.author,
        subject: g.subject,
        contentSid: g.contentSid,
        body: (k = g.text) !== null && k !== void 0 ? k : null,
        timestamp: g.timestamp ? new Date(g.timestamp) : null,
        dateUpdated: g.dateUpdated ? new Date(g.dateUpdated) : null,
        lastUpdatedBy: (T = g.lastUpdatedBy) !== null && T !== void 0 ? T : null,
        attributes: ft(g.attributes, "Got malformed attributes for the message ".concat(g.sid), yr),
        type: ($ = g.type) !== null && $ !== void 0 ? $ : "text",
        media: null,
        medias: null,
        participantSid: (ee = g.memberSid) !== null && ee !== void 0 ? ee : null,
        aggregatedDeliveryReceipt: g.delivery ? new Pe(g.delivery) : null,
        hasChannelMetadata: (ve = g.channelMetadata) !== null && ve !== void 0 ? ve : !1
      }, Wt(le.default(At), Vr, fn).call(le.default(At), (we = g.medias) !== null && we !== void 0 ? we : null, (gt = g.media) !== null && gt !== void 0 ? gt : null), At;
    }
    return ue.default(S, [{
      key: "sid",
      get: (
        /**
         * The server-assigned unique identifier for the message.
         */
        function() {
          return this.state.sid;
        }
      )
      /**
       * Name of the user that sent the message.
       */
    }, {
      key: "author",
      get: function() {
        return this.state.author;
      }
      /**
       * Message subject. Used only in email conversations.
       */
    }, {
      key: "subject",
      get: function() {
        return this.state.subject;
      }
      /**
       * Unique identifier of {@link ContentTemplate} for this message.
       */
    }, {
      key: "contentSid",
      get: function() {
        return this.state.contentSid;
      }
      /**
       * Body of the message.
       */
    }, {
      key: "body",
      get: function() {
        return this.state.body;
      }
      /**
       * Date this message was last updated on.
       */
    }, {
      key: "dateUpdated",
      get: function() {
        return this.state.dateUpdated;
      }
      /**
       * Index of this message in the conversation's list of messages.
       *
       * By design, the message indices may have arbitrary gaps between them,
       * that does not necessarily mean they were deleted or otherwise modified - just that
       * messages may have some non-contiguous indices even if they are being sent immediately one after another.
       *
       * Trying to use indices for some calculations is going to be unreliable.
       *
       * To calculate the number of unread messages, it is better to use the Read Horizon API.
       * See {@link Conversation.getUnreadMessagesCount} for details.
       */
    }, {
      key: "index",
      get: function() {
        return this.state.index;
      }
      /**
       * Identity of the last user that updated the message.
       */
    }, {
      key: "lastUpdatedBy",
      get: function() {
        return this.state.lastUpdatedBy;
      }
      /**
       * Date this message was created on.
       */
    }, {
      key: "dateCreated",
      get: function() {
        return this.state.timestamp;
      }
      /**
       * Custom attributes of the message.
       */
    }, {
      key: "attributes",
      get: function() {
        return this.state.attributes;
      }
      /**
       * Type of the message.
       */
    }, {
      key: "type",
      get: function() {
        return this.state.type;
      }
      /**
       * One of the attached media (if present).
       * @deprecated Use attachedMedia instead. Note that the latter is now an array.
       */
    }, {
      key: "media",
      get: function() {
        return this.state.media;
      }
      /**
       * Return all media attachments, except email body/history attachments, without temporary urls.
       */
    }, {
      key: "attachedMedia",
      get: function() {
        return this.getMediaByCategories(["media"]);
      }
      /**
       * The server-assigned unique identifier of the authoring participant.
       */
    }, {
      key: "participantSid",
      get: function() {
        return this.state.participantSid;
      }
      /**
       * Aggregated information about the message delivery statuses across all participants of a conversation..
       */
    }, {
      key: "aggregatedDeliveryReceipt",
      get: function() {
        return this.state.aggregatedDeliveryReceipt;
      }
      /**
       * @deprecated
       * Return a (possibly empty) array of media matching a specific set of categories.
       * Allowed category is so far only 'media'.
       * @param categories Array of categories to match.
       * @returns Array of media descriptors matching given categories.
       */
    }, {
      key: "getMediaByCategory",
      value: function(g) {
        return this.getMediaByCategories(g);
      }
      /**
       * Return a (possibly empty) array of media matching a specific set of categories.
       * Allowed category is so far only 'media'.
       * @param categories Array of categories to match.
       * @returns Array of media descriptors matching given categories.
       */
    }, {
      key: "getMediaByCategories",
      value: function(g) {
        var W;
        return ((W = this.state.medias) !== null && W !== void 0 ? W : []).filter(function(V) {
          return g.includes(V.category);
        });
      }
      /**
       * Get a media descriptor for an email body attachment of a provided type.
       * Allowed body types are returned in the Conversation.limits().emailBodiesAllowedContentTypes array.
       * @param type Type of email body to request, defaults to `text/plain`.
       */
    }, {
      key: "getEmailBody",
      value: function() {
        var g, W, V = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "text/plain";
        return (g = (W = this.getMediaByCategories(["body"])) === null || W === void 0 ? void 0 : W.filter(function(b) {
          return b.contentType == V;
        }).shift()) !== null && g !== void 0 ? g : null;
      }
      /**
       * Get a media descriptor for an email history attachment of a provided type.
       * Allowed body types are returned in the Conversation.limits().emailHistoriesAllowedContentTypes array.
       * @param type Type of email history to request, defaults to `text/plain`.
       */
    }, {
      key: "getEmailHistory",
      value: function() {
        var g, W, V = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "text/plain";
        return (g = (W = this.getMediaByCategories(["history"])) === null || W === void 0 ? void 0 : W.filter(function(b) {
          return b.contentType == V;
        }).shift()) !== null && g !== void 0 ? g : null;
      }
    }, {
      key: "_update",
      value: function(g) {
        var W, V = this, b, A, k, T = [];
        (g.text || typeof g.text == "string") && g.text !== this.state.body && (this.state.body = g.text, T.push("body")), g.subject && g.subject !== this.state.subject && (this.state.subject = g.subject, T.push("subject")), g.lastUpdatedBy && g.lastUpdatedBy !== this.state.lastUpdatedBy && (this.state.lastUpdatedBy = g.lastUpdatedBy, T.push("lastUpdatedBy")), g.author && g.author !== this.state.author && (this.state.author = g.author, T.push("author")), g.dateUpdated && new Date(g.dateUpdated).getTime() !== (this.state.dateUpdated && this.state.dateUpdated.getTime()) && (this.state.dateUpdated = new Date(g.dateUpdated), T.push("dateUpdated")), g.timestamp && new Date(g.timestamp).getTime() !== (this.state.timestamp && this.state.timestamp.getTime()) && (this.state.timestamp = new Date(g.timestamp), T.push("dateCreated"));
        var $ = ft(g.attributes, "Got malformed attributes for the message ".concat(this.sid), yr);
        oe.default(this.state.attributes, $) || (this.state.attributes = $, T.push("attributes"));
        var ee = g.delivery, ve = this.state.aggregatedDeliveryReceipt, we = !!ee && !!ee.total && !!ee.delivered && !!ee.failed && !!ee.read && !!ee.sent && !!ee.undelivered;
        we && (ve ? ve._isEquals(ee) || (ve._update(ee), T.push("deliveryReceipt")) : (this.state.aggregatedDeliveryReceipt = new Pe(ee), T.push("deliveryReceipt")));
        var gt = ((W = g.medias) !== null && W !== void 0 ? W : []).map(function(nn) {
          var Mr;
          return (Mr = Wt(V, Yt, Qn).call(V, nn)) === null || Mr === void 0 ? void 0 : Mr._state();
        }).filter(function(nn) {
          return nn !== null;
        }), At = ((b = this.state.medias) !== null && b !== void 0 ? b : []).map(function(nn) {
          return nn._state();
        }).filter(function(nn) {
          return nn !== null;
        });
        if (!oe.default(gt, At) || !oe.default((A = Wt(this, Yt, Qn).call(this, g.media)) === null || A === void 0 ? void 0 : A._state(), (k = this.state.media) === null || k === void 0 ? void 0 : k._state())) {
          var Et, Nt;
          Wt(this, Vr, fn).call(this, (Et = g.medias) !== null && Et !== void 0 ? Et : null, (Nt = g.media) !== null && Nt !== void 0 ? Nt : null), T.push("media");
        }
        T.length > 0 && this.emit("updated", {
          message: this,
          updateReasons: T
        });
      }
      /**
       * Get the participant who is the author of the message.
       */
    }, {
      key: "getParticipant",
      value: function() {
        var y = Z.default(/* @__PURE__ */ F.default.mark(function W() {
          var V = this, b, A;
          return F.default.wrap(function(T) {
            for (; ; )
              switch (T.prev = T.next) {
                case 0:
                  if (b = null, !this.state.participantSid) {
                    T.next = 5;
                    break;
                  }
                  return T.next = 4, this.conversation.getParticipantBySid(this.state.participantSid).catch(function() {
                    return yr.debug('Participant with sid "'.concat(V.participantSid, '" not found for message ').concat(V.sid)), null;
                  });
                case 4:
                  b = T.sent;
                case 5:
                  if (!(!b && this.state.author)) {
                    T.next = 9;
                    break;
                  }
                  return T.next = 8, this.conversation.getParticipantByIdentity(this.state.author).catch(function() {
                    return yr.debug('Participant with identity "'.concat(V.author, '" not found for message ').concat(V.sid)), null;
                  });
                case 8:
                  b = T.sent;
                case 9:
                  if (!b) {
                    T.next = 11;
                    break;
                  }
                  return T.abrupt("return", b);
                case 11:
                  throw A = "Participant with ", this.state.participantSid && (A += "SID '" + this.state.participantSid + "' "), this.state.author && (this.state.participantSid && (A += "or "), A += "identity '" + this.state.author + "' "), A === "Participant with " && (A = "Participant "), A += "was not found", new Error(A);
                case 17:
                case "end":
                  return T.stop();
              }
          }, W, this);
        }));
        function g() {
          return y.apply(this, arguments);
        }
        return g;
      }()
      /**
       * Get the delivery receipts of the message.
       */
    }, {
      key: "getDetailedDeliveryReceipts",
      value: function() {
        var y = Z.default(/* @__PURE__ */ F.default.mark(function W() {
          var V, b;
          return F.default.wrap(function(k) {
            for (; ; )
              switch (k.prev = k.next) {
                case 0:
                  return k.next = 2, this._getDetailedDeliveryReceiptsPaginator();
                case 2:
                  V = k.sent, b = V.items;
                case 4:
                  if (!V.hasNextPage) {
                    k.next = 11;
                    break;
                  }
                  return k.next = 7, V.nextPage();
                case 7:
                  V = k.sent, b = [].concat(ce.default(b), ce.default(V.items)), k.next = 4;
                  break;
                case 11:
                  return k.abrupt("return", b);
                case 12:
                case "end":
                  return k.stop();
              }
          }, W, this);
        }));
        function g() {
          return y.apply(this, arguments);
        }
        return g;
      }()
      /**
       * Remove the message.
       */
    }, {
      key: "remove",
      value: function() {
        var y = Z.default(/* @__PURE__ */ F.default.mark(function W() {
          return F.default.wrap(function(b) {
            for (; ; )
              switch (b.prev = b.next) {
                case 0:
                  return b.next = 2, this.services.commandExecutor.mutateResource("delete", this.links.self);
                case 2:
                  return b.abrupt("return", this);
                case 3:
                case "end":
                  return b.stop();
              }
          }, W, this);
        }));
        function g() {
          return y.apply(this, arguments);
        }
        return g;
      }()
      /**
       * Edit the message body.
       * @param body New body of the message.
       */
    }, {
      key: "updateBody",
      value: function() {
        var y = Z.default(/* @__PURE__ */ F.default.mark(function W(V) {
          return F.default.wrap(function(A) {
            for (; ; )
              switch (A.prev = A.next) {
                case 0:
                  return A.next = 2, this.services.commandExecutor.mutateResource("post", this.links.self, {
                    body: V
                  });
                case 2:
                  return A.abrupt("return", this);
                case 3:
                case "end":
                  return A.stop();
              }
          }, W, this);
        }));
        function g(W) {
          return y.apply(this, arguments);
        }
        return g;
      }()
      /**
       * Edit the message attributes.
       * @param attributes New attributes.
       */
    }, {
      key: "updateAttributes",
      value: function() {
        var y = Z.default(/* @__PURE__ */ F.default.mark(function W(V) {
          return F.default.wrap(function(A) {
            for (; ; )
              switch (A.prev = A.next) {
                case 0:
                  return A.next = 2, this.services.commandExecutor.mutateResource("post", this.links.self, {
                    attributes: typeof V < "u" ? JSON.stringify(V) : void 0
                  });
                case 2:
                  return A.abrupt("return", this);
                case 3:
                case "end":
                  return A.stop();
              }
          }, W, this);
        }));
        function g(W) {
          return y.apply(this, arguments);
        }
        return g;
      }()
      /**
       * @deprecated
       * Get content URLs for all media attachments in the given set using a single operation.
       * @param contentSet Set of media attachments to query content URLs.
       */
    }, {
      key: "attachTemporaryUrlsFor",
      value: function() {
        var y = Z.default(/* @__PURE__ */ F.default.mark(function W(V) {
          var b = this, A;
          return F.default.wrap(function(T) {
            for (; ; )
              switch (T.prev = T.next) {
                case 0:
                  if (A = V == null ? void 0 : V.map(function($) {
                    return $.sid;
                  }), !(this.services.mcsClient && A)) {
                    T.next = 7;
                    break;
                  }
                  return T.next = 4, this.services.mcsClient.mediaSetGet(A);
                case 4:
                  return T.abrupt("return", T.sent.map(function($) {
                    return new ze($, b.services);
                  }));
                case 7:
                  throw new Error("Media Content Service is unavailable");
                case 8:
                case "end":
                  return T.stop();
              }
          }, W, this);
        }));
        function g(W) {
          return y.apply(this, arguments);
        }
        return g;
      }()
      /**
       * Get content URLs for all media attachments in the given set using a single operation.
       * @param contentSet Set of media attachments to query content URLs.
       */
    }, {
      key: "getTemporaryContentUrlsForMedia",
      value: function(g) {
        var W = g.map(function(V) {
          return V.sid;
        });
        return this.getTemporaryContentUrlsForMediaSids(W);
      }
      /**
       * Get content URLs for all media attachments in the given set of media sids using a single operation.
       * @param mediaSids Set of media sids to query for the content URL.
       */
    }, {
      key: "getTemporaryContentUrlsForMediaSids",
      value: function(g) {
        var W = this;
        return new P.CancellablePromise(/* @__PURE__ */ function() {
          var V = Z.default(/* @__PURE__ */ F.default.mark(function b(A, k, T) {
            var $, ee;
            return F.default.wrap(function(we) {
              for (; ; )
                switch (we.prev = we.next) {
                  case 0:
                    if ($ = W.services.mcsClient.mediaSetGetContentUrls(g ?? []), !(!W.services.mcsClient || !g)) {
                      we.next = 4;
                      break;
                    }
                    return k(new Error("Media Content Service is unavailable")), we.abrupt("return");
                  case 4:
                    return T(function() {
                      $.cancel();
                    }), we.prev = 5, we.next = 8, $;
                  case 8:
                    ee = we.sent, A(ee), we.next = 15;
                    break;
                  case 12:
                    we.prev = 12, we.t0 = we.catch(5), k(we.t0);
                  case 15:
                  case "end":
                    return we.stop();
                }
            }, b, null, [[5, 12]]);
          }));
          return function(b, A, k) {
            return V.apply(this, arguments);
          };
        }());
      }
      /**
       * Get content URLs for all media attached to the message.
       */
    }, {
      key: "getTemporaryContentUrlsForAttachedMedia",
      value: function() {
        var g, W = this.attachedMedia, V = (g = W == null ? void 0 : W.map(function(b) {
          return b.sid;
        })) !== null && g !== void 0 ? g : [];
        return this.getTemporaryContentUrlsForMediaSids(V);
      }
    }, {
      key: "_getDetailedDeliveryReceiptsPaginator",
      value: function() {
        var y = Z.default(/* @__PURE__ */ F.default.mark(function W(V) {
          var b = this, A, k, T;
          return F.default.wrap(function(ee) {
            for (; ; )
              switch (ee.prev = ee.next) {
                case 0:
                  return A = this.configuration.links.messagesReceipts.replace("%s", this.conversation.sid).replace("%s", this.sid), k = new at(A).arg("PageToken", V == null ? void 0 : V.pageToken).arg("PageSize", V == null ? void 0 : V.pageSize).build(), ee.next = 4, this.services.network.get(k);
                case 4:
                  return T = ee.sent, ee.abrupt("return", new dt(T.body.delivery_receipts.map(function(ve) {
                    return new tt(ve);
                  }), function(ve, we) {
                    return b._getDetailedDeliveryReceiptsPaginator({
                      pageToken: ve,
                      pageSize: we
                    });
                  }, T.body.meta.previous_token, T.body.meta.next_token));
                case 6:
                case "end":
                  return ee.stop();
              }
          }, W, this);
        }));
        function g(W) {
          return y.apply(this, arguments);
        }
        return g;
      }()
      /**
       * Get the {@link ContentData} for this message. Resolves to `null` when
       * {@link Message.contentSid} is null.
       */
    }, {
      key: "getContentData",
      value: function() {
        var g = this;
        return new P.CancellablePromise(/* @__PURE__ */ function() {
          var W = Z.default(/* @__PURE__ */ F.default.mark(function V(b, A, k) {
            var T, $, ee, ve, we, gt, At, Et, Nt, nn;
            return F.default.wrap(function(Ut) {
              for (; ; )
                switch (Ut.prev = Ut.next) {
                  case 0:
                    if (g.state.contentSid !== null) {
                      Ut.next = 3;
                      break;
                    }
                    return b(null), Ut.abrupt("return");
                  case 3:
                    if (T = g.getMediaByCategories(["body"]), T !== null) {
                      Ut.next = 7;
                      break;
                    }
                    return b(null), Ut.abrupt("return");
                  case 7:
                    if ($ = "application/x-vnd.com.twilio.rich.", ee = T.filter(function(Ui) {
                      return Ui.contentType.startsWith($);
                    }), ee.length !== 0) {
                      Ut.next = 12;
                      break;
                    }
                    return b(null), Ut.abrupt("return");
                  case 12:
                    return ve = ee[0], we = ve.getContentTemporaryUrl(), k(function() {
                      we.cancel();
                    }), Ut.prev = 15, Ut.next = 18, we;
                  case 18:
                    gt = Ut.sent, Ut.next = 25;
                    break;
                  case 21:
                    return Ut.prev = 21, Ut.t0 = Ut.catch(15), A(Ut.t0), Ut.abrupt("return");
                  case 25:
                    if (gt !== null) {
                      Ut.next = 28;
                      break;
                    }
                    return b(null), Ut.abrupt("return");
                  case 28:
                    return At = new Promise(function(Ui, _l) {
                      var wt, Ia = !1, $n = new hr();
                      $n.open("GET", (wt = gt) !== null && wt !== void 0 ? wt : "", !0), $n.responseType = "text", $n.onreadystatechange = function() {
                        $n.readyState !== 4 || Ia || Ui($n.responseText);
                      }, $n.onerror = function() {
                        _l($n.statusText);
                      }, k(function() {
                        Ia = !0, $n.abort(), _l(new Error("XHR has been aborted"));
                      }), $n.send();
                    }), Ut.prev = 29, Ut.next = 32, At;
                  case 32:
                    Nt = Ut.sent, Et = JSON.parse(Nt), Ut.next = 40;
                    break;
                  case 36:
                    return Ut.prev = 36, Ut.t1 = Ut.catch(29), A(Ut.t1), Ut.abrupt("return");
                  case 40:
                    nn = ve.contentType.replace($, "").replace(".", "/"), b(vt(nn, Et.data));
                  case 42:
                  case "end":
                    return Ut.stop();
                }
            }, V, null, [[15, 21], [29, 36]]);
          }));
          return function(V, b, A) {
            return W.apply(this, arguments);
          };
        }());
      }
      /**
       * Get the {@link ChannelMetadata} for this message. Resolves to `null` if
       * the message doesn't have any channel metadata.
       */
    }, {
      key: "getChannelMetadata",
      value: function() {
        var y = Z.default(/* @__PURE__ */ F.default.mark(function W() {
          return F.default.wrap(function(b) {
            for (; ; )
              switch (b.prev = b.next) {
                case 0:
                  if (this.state.hasChannelMetadata) {
                    b.next = 2;
                    break;
                  }
                  return b.abrupt("return", null);
                case 2:
                  return b.next = 4, this.services.channelMetadataClient.getChannelMetadata(this.conversation.sid, this.sid);
                case 4:
                  return b.abrupt("return", b.sent);
                case 5:
                case "end":
                  return b.stop();
              }
          }, W, this);
        }));
        function g() {
          return y.apply(this, arguments);
        }
        return g;
      }()
    }]), S;
  }(m.ReplayEventEmitter);
  function Qn(N) {
    var X = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
    return N ? X ? new ze(Te(Te({}, N), {}, {
      category: X
    }), this.services) : new ze(N, this.services) : null;
  }
  function fn(N, X) {
    var S = this;
    this.state.media = Wt(this, Yt, Qn).call(this, X), this.state.medias = N ? N.map(function(y) {
      return Wt(S, Yt, Qn).call(S, y);
    }).filter(function(y) {
      return y !== null;
    }) : X && !N ? [Wt(this, Yt, Qn).call(this, X, "media")].filter(function(y) {
      return y !== null;
    }) : null;
  }
  ye.default(xr, "updated", "updated"), Ae([K.deprecated("getMediaByCategory", "getMediaByCategories"), re("design:type", Function), re("design:paramtypes", [Array]), re("design:returntype", Array)], xr.prototype, "getMediaByCategory", null), Ae([v.validateTypes([v.nonEmptyString, "undefined"]), re("design:type", Function), re("design:paramtypes", [Object]), re("design:returntype", ze)], xr.prototype, "getEmailBody", null), Ae([v.validateTypes([v.nonEmptyString, "undefined"]), re("design:type", Function), re("design:paramtypes", [Object]), re("design:returntype", ze)], xr.prototype, "getEmailHistory", null), Ae([v.validateTypesAsync("string"), re("design:type", Function), re("design:paramtypes", [String]), re("design:returntype", Promise)], xr.prototype, "updateBody", null), Ae([v.validateTypesAsync(rt), re("design:type", Function), re("design:paramtypes", [Object]), re("design:returntype", Promise)], xr.prototype, "updateAttributes", null), Ae([K.deprecated("attachTemporaryUrlsFor", "getTemporaryContentUrlsForMedia"), re("design:type", Function), re("design:paramtypes", [Array]), re("design:returntype", Promise)], xr.prototype, "attachTemporaryUrlsFor", null), Ae([v.validateTypesAsync(v.nonEmptyArray("media", ze)), re("design:type", Function), re("design:paramtypes", [Array]), re("design:returntype", P.CancellablePromise)], xr.prototype, "getTemporaryContentUrlsForMedia", null), Ae([v.validateTypesAsync(v.nonEmptyArray("strings", "string")), re("design:type", Function), re("design:paramtypes", [Array]), re("design:returntype", P.CancellablePromise)], xr.prototype, "getTemporaryContentUrlsForMediaSids", null);
  function uo(N, X) {
    var S = Object.keys(N);
    if (Object.getOwnPropertySymbols) {
      var y = Object.getOwnPropertySymbols(N);
      X && (y = y.filter(function(g) {
        return Object.getOwnPropertyDescriptor(N, g).enumerable;
      })), S.push.apply(S, y);
    }
    return S;
  }
  function fo(N) {
    for (var X = 1; X < arguments.length; X++) {
      var S = arguments[X] != null ? arguments[X] : {};
      X % 2 ? uo(Object(S), !0).forEach(function(y) {
        ye.default(N, y, S[y]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(N, Object.getOwnPropertyDescriptors(S)) : uo(Object(S)).forEach(function(y) {
        Object.defineProperty(N, y, Object.getOwnPropertyDescriptor(S, y));
      });
    }
    return N;
  }
  function Ea(N, X) {
    var S = typeof Symbol < "u" && N[Symbol.iterator] || N["@@iterator"];
    if (!S) {
      if (Array.isArray(N) || (S = zu(N)) || X && N && typeof N.length == "number") {
        S && (N = S);
        var y = 0, g = function() {
        };
        return { s: g, n: function() {
          return y >= N.length ? { done: !0 } : { done: !1, value: N[y++] };
        }, e: function(k) {
          throw k;
        }, f: g };
      }
      throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
    }
    var W = !0, V = !1, b;
    return { s: function() {
      S = S.call(N);
    }, n: function() {
      var k = S.next();
      return W = k.done, k;
    }, e: function(k) {
      V = !0, b = k;
    }, f: function() {
      try {
        !W && S.return != null && S.return();
      } finally {
        if (V)
          throw b;
      }
    } };
  }
  function zu(N, X) {
    if (N) {
      if (typeof N == "string")
        return lo(N, X);
      var S = Object.prototype.toString.call(N).slice(8, -1);
      if (S === "Object" && N.constructor && (S = N.constructor.name), S === "Map" || S === "Set")
        return Array.from(N);
      if (S === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(S))
        return lo(N, X);
    }
  }
  function lo(N, X) {
    (X == null || X > N.length) && (X = N.length);
    for (var S = 0, y = new Array(X); S < X; S++)
      y[S] = N[S];
    return y;
  }
  function Jn(N) {
    var X = Gu();
    return function() {
      var y = xe.default(N), g;
      if (X) {
        var W = xe.default(this).constructor;
        g = Reflect.construct(y, arguments, W);
      } else
        g = y.apply(this, arguments);
      return Ie.default(this, g);
    };
  }
  function Gu() {
    if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
      return !1;
    if (typeof Proxy == "function")
      return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      })), !0;
    } catch {
      return !1;
    }
  }
  var mn = Ue.scope("Messages"), Qu = /* @__PURE__ */ function(N) {
    he.default(S, N);
    var X = Jn(S);
    function S(y, g, W) {
      var V;
      return M.default(this, S), V = X.call(this), V.conversation = y, V.configuration = g, V.services = W, V.messagesByIndex = /* @__PURE__ */ new Map(), V.messagesListPromise = null, V;
    }
    return ue.default(S, [{
      key: "subscribe",
      value: function() {
        var y = Z.default(/* @__PURE__ */ F.default.mark(function W(V) {
          var b = this, A;
          return F.default.wrap(function(T) {
            for (; ; )
              switch (T.prev = T.next) {
                case 0:
                  if (!this.messagesListPromise) {
                    T.next = 2;
                    break;
                  }
                  return T.abrupt("return", this.messagesListPromise);
                case 2:
                  return this.messagesListPromise = typeof V == "string" ? this.services.syncClient.list({
                    id: V,
                    mode: "open_existing"
                  }) : Promise.resolve(V), T.prev = 3, T.next = 6, this.messagesListPromise;
                case 6:
                  return A = T.sent, A.on("itemAdded", function($) {
                    mn.debug("".concat(b.conversation.sid, " itemAdded: ").concat($.item.index));
                    var ee = {
                      self: "".concat(b.conversation._links.messages, "/").concat($.item.data.sid),
                      conversation: b.conversation._links.self,
                      messages_receipts: "".concat(b.conversation._links.messages, "/").concat($.item.data.sid, "/Receipts")
                    }, ve = new xr($.item.index, $.item.data, b.conversation, ee, b.configuration, b.services);
                    if (b.messagesByIndex.has(ve.index)) {
                      mn.debug("Message arrived, but is already known and ignored", b.conversation.sid, ve.index);
                      return;
                    }
                    b.messagesByIndex.set(ve.index, ve), ve.on("updated", function(we) {
                      return b.emit("messageUpdated", we);
                    }), b.emit("messageAdded", ve);
                  }), A.on("itemRemoved", function($) {
                    mn.debug("#{this.conversation.sid} itemRemoved: ".concat($.index));
                    var ee = $.index;
                    if (b.messagesByIndex.has(ee)) {
                      var ve = b.messagesByIndex.get(ee);
                      if (!ve)
                        return;
                      b.messagesByIndex.delete(ve.index), ve.removeAllListeners("updated"), b.emit("messageRemoved", ve);
                    }
                  }), A.on("itemUpdated", function($) {
                    mn.debug("".concat(b.conversation.sid, " itemUpdated: ").concat($.item.index));
                    var ee = b.messagesByIndex.get($.item.index);
                    ee && ee._update($.item.data);
                  }), T.abrupt("return", A);
                case 13:
                  throw T.prev = 13, T.t0 = T.catch(3), this.messagesListPromise = null, this.services.syncClient.connectionState !== "disconnected" && mn.error("Failed to get messages object for conversation", this.conversation.sid, T.t0), mn.debug("ERROR: Failed to get messages object for conversation", this.conversation.sid, T.t0), T.t0;
                case 19:
                case "end":
                  return T.stop();
              }
          }, W, this, [[3, 13]]);
        }));
        function g(W) {
          return y.apply(this, arguments);
        }
        return g;
      }()
    }, {
      key: "unsubscribe",
      value: function() {
        var y = Z.default(/* @__PURE__ */ F.default.mark(function W() {
          var V;
          return F.default.wrap(function(A) {
            for (; ; )
              switch (A.prev = A.next) {
                case 0:
                  if (this.messagesListPromise) {
                    A.next = 2;
                    break;
                  }
                  return A.abrupt("return");
                case 2:
                  return A.next = 4, this.messagesListPromise;
                case 4:
                  V = A.sent, V.close(), this.messagesListPromise = null;
                case 7:
                case "end":
                  return A.stop();
              }
          }, W, this);
        }));
        function g() {
          return y.apply(this, arguments);
        }
        return g;
      }()
      /**
       * Send a message to the conversation. The message could include text and multiple media attachments.
       * @param message Message to post
       */
    }, {
      key: "sendV2",
      value: function(g) {
        var W = this;
        return mn.debug("Sending message V2", g.mediaContent, g.attributes, g.emailOptions), new P.CancellablePromise(/* @__PURE__ */ function() {
          var V = Z.default(/* @__PURE__ */ F.default.mark(function b(A, k, T) {
            var $, ee, ve, we, gt, At, Et, Nt, nn, Mr, Ut, Ui;
            return F.default.wrap(function(wt) {
              for (; ; )
                switch (wt.prev = wt.next) {
                  case 0:
                    ee = [], ve = [], T(function() {
                      ve.forEach(function(Ia) {
                        return Ia.cancel();
                      });
                    }), we = Ea(g.mediaContent), wt.prev = 4, we.s();
                  case 6:
                    if ((gt = we.n()).done) {
                      wt.next = 25;
                      break;
                    }
                    return At = z.default(gt.value, 2), Et = At[0], Nt = At[1], wt.prev = 8, mn.debug("Adding media to a message as ".concat(Nt instanceof FormData ? "FormData" : "SendMediaOptions"), Nt), Ut = Nt instanceof FormData ? W.services.mcsClient.postFormData(Nt, Et) : W.services.mcsClient.post((nn = Nt.contentType) !== null && nn !== void 0 ? nn : "", (Mr = Nt.media) !== null && Mr !== void 0 ? Mr : "", Et, Nt.filename), ve.push(Ut), wt.t0 = ee, wt.next = 15, Ut;
                  case 15:
                    wt.t1 = wt.sent, wt.t0.push.call(wt.t0, wt.t1), wt.next = 23;
                    break;
                  case 19:
                    return wt.prev = 19, wt.t2 = wt.catch(8), k(wt.t2), wt.abrupt("return");
                  case 23:
                    wt.next = 6;
                    break;
                  case 25:
                    wt.next = 30;
                    break;
                  case 27:
                    wt.prev = 27, wt.t3 = wt.catch(4), we.e(wt.t3);
                  case 30:
                    return wt.prev = 30, we.f(), wt.finish(30);
                  case 33:
                    return Ui = W.services.commandExecutor.mutateResource("post", W.conversation._links.messages, {
                      body: g.text,
                      subject: ($ = g.emailOptions) === null || $ === void 0 ? void 0 : $.subject,
                      media_sids: ee.map(function(Ia) {
                        return Ia.sid;
                      }),
                      attributes: typeof g.attributes < "u" ? JSON.stringify(g.attributes) : void 0,
                      content_sid: g.contentSid,
                      content_variables: typeof g.contentVariables < "u" ? JSON.stringify(g.contentVariables.reduce(function(Ia, $n) {
                        return fo(fo({}, Ia), {}, ye.default({}, $n.name, $n.value));
                      }, {})) : void 0
                    }), wt.prev = 34, wt.t4 = A, wt.next = 38, Ui;
                  case 38:
                    wt.t5 = wt.sent, (0, wt.t4)(wt.t5), wt.next = 45;
                    break;
                  case 42:
                    wt.prev = 42, wt.t6 = wt.catch(34), k(wt.t6);
                  case 45:
                  case "end":
                    return wt.stop();
                }
            }, b, null, [[4, 27, 30, 33], [8, 19], [34, 42]]);
          }));
          return function(b, A, k) {
            return V.apply(this, arguments);
          };
        }());
      }
      /**
       * Send Message to the conversation
       * @param message Message to post
       * @param attributes Message attributes
       * @param emailOptions Options that modify E-mail integration behaviors.
       * @returns Returns promise which can fail
       */
    }, {
      key: "send",
      value: function() {
        var y = Z.default(/* @__PURE__ */ F.default.mark(function W(V) {
          var b, A, k = arguments;
          return F.default.wrap(function($) {
            for (; ; )
              switch ($.prev = $.next) {
                case 0:
                  return b = k.length > 1 && k[1] !== void 0 ? k[1] : {}, A = k.length > 2 ? k[2] : void 0, mn.debug("Sending text message", V, b, A), $.abrupt("return", this.services.commandExecutor.mutateResource("post", this.conversation._links.messages, {
                    body: V ?? "",
                    attributes: typeof b < "u" ? JSON.stringify(b) : void 0,
                    subject: A == null ? void 0 : A.subject
                  }));
                case 4:
                case "end":
                  return $.stop();
              }
          }, W, this);
        }));
        function g(W) {
          return y.apply(this, arguments);
        }
        return g;
      }()
      /**
       * Send Media Message to the conversation
       * @param mediaContent Media content to post
       * @param attributes Message attributes
       * @param emailOptions Email options
       * @returns Returns promise which can fail
       */
    }, {
      key: "sendMedia",
      value: function() {
        var y = Z.default(/* @__PURE__ */ F.default.mark(function W(V) {
          var b, A, k, T, $, ee = arguments;
          return F.default.wrap(function(we) {
            for (; ; )
              switch (we.prev = we.next) {
                case 0:
                  if (k = ee.length > 1 && ee[1] !== void 0 ? ee[1] : {}, T = ee.length > 2 ? ee[2] : void 0, mn.debug("Sending media message", V, k, T), mn.debug("Sending media message as ".concat(V instanceof FormData ? "FormData" : "SendMediaOptions"), V, k), !(V instanceof FormData)) {
                    we.next = 10;
                    break;
                  }
                  return we.next = 7, this.services.mcsClient.postFormData(V);
                case 7:
                  we.t0 = we.sent, we.next = 13;
                  break;
                case 10:
                  return we.next = 12, this.services.mcsClient.post((b = V.contentType) !== null && b !== void 0 ? b : "", (A = V.media) !== null && A !== void 0 ? A : "", "media", V.filename);
                case 12:
                  we.t0 = we.sent;
                case 13:
                  return $ = we.t0, we.next = 16, this.services.commandExecutor.mutateResource("post", this.conversation._links.messages, {
                    media_sids: [$.sid],
                    attributes: typeof k < "u" ? JSON.stringify(k) : void 0
                  });
                case 16:
                  return we.abrupt("return", we.sent);
                case 17:
                case "end":
                  return we.stop();
              }
          }, W, this);
        }));
        function g(W) {
          return y.apply(this, arguments);
        }
        return g;
      }()
      /**
       * Returns messages from conversation using paginator interface
       * @param pageSize Number of messages to return in single chunk. By default it's 30.
       * @param anchor Most early message id which is already known, or 'end' by default
       * @param direction Pagination order 'backwards' or 'forward', 'forward' by default
       * @returns Last page of messages by default
       */
    }, {
      key: "getMessages",
      value: function() {
        var y = Z.default(/* @__PURE__ */ F.default.mark(function W(V, b) {
          var A, k = arguments;
          return F.default.wrap(function($) {
            for (; ; )
              switch ($.prev = $.next) {
                case 0:
                  return A = k.length > 2 && k[2] !== void 0 ? k[2] : "backwards", $.abrupt("return", this._getMessages(V, b, A));
                case 2:
                case "end":
                  return $.stop();
              }
          }, W, this);
        }));
        function g(W, V) {
          return y.apply(this, arguments);
        }
        return g;
      }()
    }, {
      key: "_wrapPaginator",
      value: function(g, W, V) {
        var b = this, A = g === "desc", k = function() {
          return W.nextPage().then(function(ee) {
            return b._wrapPaginator(g, ee, V);
          });
        }, T = function() {
          return W.prevPage().then(function(ee) {
            return b._wrapPaginator(g, ee, V);
          });
        };
        return V(W.items).then(function($) {
          return {
            items: $.sort(function(ee, ve) {
              return ee.index - ve.index;
            }),
            hasPrevPage: A ? W.hasNextPage : W.hasPrevPage,
            hasNextPage: A ? W.hasPrevPage : W.hasNextPage,
            prevPage: A ? k : T,
            nextPage: A ? T : k
          };
        });
      }
    }, {
      key: "_upsertMessage",
      value: function(g, W) {
        var V = this, b = this.messagesByIndex.get(g);
        if (b)
          return b;
        var A = {
          self: "".concat(this.conversation._links.messages, "/").concat(W.sid),
          conversation: this.conversation._links.self,
          messages_receipts: "".concat(this.conversation._links.messages, "/").concat(W.sid, "/Receipts")
        }, k = new xr(g, W, this.conversation, A, this.configuration, this.services);
        return this.messagesByIndex.set(k.index, k), k.on("updated", function(T) {
          return V.emit("messageUpdated", T);
        }), k;
      }
      /**
       * Returns last messages from conversation
       * @param {Number} [pageSize] Number of messages to return in single chunk. By default it's 30.
       * @param {String} [anchor] Most early message id which is already known, or 'end' by default
       * @param {String} [direction] Pagination order 'backwards' or 'forward', or 'forward' by default
       * @returns {Promise<SyncPaginator<Message>>} last page of messages by default
       * @private
       */
    }, {
      key: "_getMessages",
      value: function() {
        var y = Z.default(/* @__PURE__ */ F.default.mark(function W() {
          var V = this, b, A, k, T, $, ee, ve = arguments;
          return F.default.wrap(function(gt) {
            for (; ; )
              switch (gt.prev = gt.next) {
                case 0:
                  return b = ve.length > 0 && ve[0] !== void 0 ? ve[0] : 30, A = ve.length > 1 && ve[1] !== void 0 ? ve[1] : "end", k = ve.length > 2 && ve[2] !== void 0 ? ve[2] : "forward", T = k === "backwards" ? "desc" : "asc", gt.next = 6, this.messagesListPromise;
                case 6:
                  return $ = gt.sent, gt.next = 9, $ == null ? void 0 : $.getItems({
                    from: A !== "end" ? A : void 0,
                    pageSize: b,
                    order: T,
                    limit: b
                    // @todo Limit equals pageSize by default in Sync. This is probably not ideal.
                  });
                case 9:
                  return ee = gt.sent, gt.next = 12, this._wrapPaginator(T, ee, function(At) {
                    return Promise.all(At.map(function(Et) {
                      return V._upsertMessage(Et.index, Et.data);
                    }));
                  });
                case 12:
                  return gt.abrupt("return", gt.sent);
                case 13:
                case "end":
                  return gt.stop();
              }
          }, W, this);
        }));
        function g() {
          return y.apply(this, arguments);
        }
        return g;
      }()
    }]), S;
  }(m.ReplayEventEmitter), co = /* @__PURE__ */ function() {
    function N(X) {
      M.default(this, N), ye.default(this, "attributes", {}), ye.default(this, "mediaContent", []), ye.default(this, "emailOptions", {}), this.messagesEntity = X;
    }
    return ue.default(N, [{
      key: "send",
      value: function() {
        var S = this;
        return new P.CancellablePromise(/* @__PURE__ */ function() {
          var y = Z.default(/* @__PURE__ */ F.default.mark(function g(W, V, b) {
            var A, k;
            return F.default.wrap(function($) {
              for (; ; )
                switch ($.prev = $.next) {
                  case 0:
                    return A = S.messagesEntity.sendV2(S), b(function() {
                      return A.cancel();
                    }), $.prev = 2, $.next = 5, A;
                  case 5:
                    k = $.sent, W(Je(k.index)), $.next = 12;
                    break;
                  case 9:
                    $.prev = 9, $.t0 = $.catch(2), V($.t0);
                  case 12:
                  case "end":
                    return $.stop();
                }
            }, g, null, [[2, 9]]);
          }));
          return function(g, W, V) {
            return y.apply(this, arguments);
          };
        }());
      }
    }]), N;
  }(), Lr = /* @__PURE__ */ function() {
    function N(X, S) {
      M.default(this, N), this.limits = X, this.message = new co(S), this.emailBodies = /* @__PURE__ */ new Map(), this.emailHistories = /* @__PURE__ */ new Map();
    }
    return ue.default(N, [{
      key: "setBody",
      value: function(S) {
        return this.message.text = S, this;
      }
      /**
       * Sets the message subject.
       * @param subject Contents of the subject.
       */
    }, {
      key: "setSubject",
      value: function(S) {
        return this.message.emailOptions.subject = S, this;
      }
      /**
       * Sets the message attributes.
       * @param attributes Message attributes.
       */
    }, {
      key: "setAttributes",
      value: function(S) {
        return this.message.attributes = S, this;
      }
      /**
       * Set the email body with a given content type.
       * @param contentType Format of the body to set (text/plain or text/html).
       * @param body Body payload in the selected format.
       */
    }, {
      key: "setEmailBody",
      value: function(S, y) {
        return this.emailBodies.set(S, y), this;
      }
      /**
       * Set the email history with a given content type.
       * @param contentType Format of the history to set (text/plain or text/html).
       * @param history History payload in the selected format.
       */
    }, {
      key: "setEmailHistory",
      value: function(S, y) {
        return this.emailHistories.set(S, y), this;
      }
      /**
       * Adds {@link ContentTemplate} SID for the message alongside optional
       * variables. When no variables provided, the default values will be used.
       *
       * Adding the content SID converts the message to a rich message. In this
       * case, other fields are ignored and the message is sent using the content
       * from the the {@link ContentTemplate}.
       *
       * Use {@link Client.getContentTemplates} to request all available
       * {@link ContentTemplate}s.
       *
       * @param contentSid SID of the {@link ContentTemplate}
       * @param variables Custom variables to resolve the template.
       */
    }, {
      key: "setContentTemplate",
      value: function(S) {
        var y = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
        return this.message.contentSid = S, this.message.contentVariables = y, this;
      }
      /**
       * Adds media to the message.
       * @param payload Media to add.
       */
    }, {
      key: "addMedia",
      value: function(S) {
        if (typeof FormData > "u" && S instanceof FormData)
          throw new Error("Could not add FormData content whilst not in a browser");
        if (!(S instanceof FormData)) {
          var y = S;
          if (!y.contentType || !y.media)
            throw new Error("Media content in SendMediaOptions must contain non-empty contentType and media");
        }
        return this.message.mediaContent.push(["media", S]), this;
      }
      /**
       * Builds the message, making it ready to be sent.
       */
    }, {
      key: "build",
      value: function() {
        var S = this;
        if (this.emailBodies.forEach(function(y, g) {
          if (!S.limits.emailBodiesAllowedContentTypes.includes(g))
            throw new Error("Unsupported email body content type ".concat(g));
        }), this.emailHistories.forEach(function(y, g) {
          if (!S.limits.emailHistoriesAllowedContentTypes.includes(g))
            throw new Error("Unsupported email history content type ".concat(g));
        }), this.emailBodies.size > this.limits.emailBodiesAllowedContentTypes.length)
          throw new Error("Too many email bodies attached to the message (".concat(this.emailBodies.size, " > ").concat(this.limits.emailBodiesAllowedContentTypes.length, ")"));
        if (this.emailHistories.size > this.limits.emailHistoriesAllowedContentTypes.length)
          throw new Error("Too many email histories attached to the message (".concat(this.emailHistories.size, " > ").concat(this.limits.emailHistoriesAllowedContentTypes.length, ")"));
        if (this.message.mediaContent.length > this.limits.mediaAttachmentsCountLimit)
          throw new Error("Too many media attachments in the message (".concat(this.message.mediaContent.length, " > ").concat(this.limits.mediaAttachmentsCountLimit, ")"));
        return this.emailBodies.forEach(function(y) {
          S.message.mediaContent.push(["body", y]);
        }), this.emailHistories.forEach(function(y) {
          S.message.mediaContent.push(["history", y]);
        }), this.message;
      }
      /**
       * Prepares a message and sends it to the conversation.
       */
    }, {
      key: "buildAndSend",
      value: function() {
        return this.build().send();
      }
    }]), N;
  }();
  Ae([v.validateTypes("string"), re("design:type", Function), re("design:paramtypes", [String]), re("design:returntype", Lr)], Lr.prototype, "setBody", null), Ae([v.validateTypes("string"), re("design:type", Function), re("design:paramtypes", [String]), re("design:returntype", Lr)], Lr.prototype, "setSubject", null), Ae([v.validateTypes(rt), re("design:type", Function), re("design:paramtypes", [Object]), re("design:returntype", Lr)], Lr.prototype, "setAttributes", null), Ae([v.validateTypes("string", [FormData, vr]), re("design:type", Function), re("design:paramtypes", [String, Object]), re("design:returntype", Lr)], Lr.prototype, "setEmailBody", null), Ae([v.validateTypes("string", [FormData, vr]), re("design:type", Function), re("design:paramtypes", [String, Object]), re("design:returntype", Lr)], Lr.prototype, "setEmailHistory", null), Ae([v.validateTypes("string", [v.array("content variables", lt), "undefined"]), re("design:type", Function), re("design:paramtypes", [String, Array]), re("design:returntype", Lr)], Lr.prototype, "setContentTemplate", null), Ae([v.validateTypes([FormData, vr]), re("design:type", Function), re("design:paramtypes", [Object]), re("design:returntype", Lr)], Lr.prototype, "addMedia", null);
  function Ju(N, X) {
    var S = typeof Symbol < "u" && N[Symbol.iterator] || N["@@iterator"];
    if (!S) {
      if (Array.isArray(N) || (S = Oa(N)) || X && N && typeof N.length == "number") {
        S && (N = S);
        var y = 0, g = function() {
        };
        return { s: g, n: function() {
          return y >= N.length ? { done: !0 } : { done: !1, value: N[y++] };
        }, e: function(k) {
          throw k;
        }, f: g };
      }
      throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
    }
    var W = !0, V = !1, b;
    return { s: function() {
      S = S.call(N);
    }, n: function() {
      var k = S.next();
      return W = k.done, k;
    }, e: function(k) {
      V = !0, b = k;
    }, f: function() {
      try {
        !W && S.return != null && S.return();
      } finally {
        if (V)
          throw b;
      }
    } };
  }
  function Oa(N, X) {
    if (N) {
      if (typeof N == "string")
        return po(N, X);
      var S = Object.prototype.toString.call(N).slice(8, -1);
      if (S === "Object" && N.constructor && (S = N.constructor.name), S === "Map" || S === "Set")
        return Array.from(N);
      if (S === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(S))
        return po(N, X);
    }
  }
  function po(N, X) {
    (X == null || X > N.length) && (X = N.length);
    for (var S = 0, y = new Array(X); S < X; S++)
      y[S] = N[S];
    return y;
  }
  function hi(N) {
    var X = vo();
    return function() {
      var y = xe.default(N), g;
      if (X) {
        var W = xe.default(this).constructor;
        g = Reflect.construct(y, arguments, W);
      } else
        g = y.apply(this, arguments);
      return Ie.default(this, g);
    };
  }
  function vo() {
    if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
      return !1;
    if (typeof Proxy == "function")
      return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      })), !0;
    } catch {
      return !1;
    }
  }
  var Hn = {
    lastMessage: "lastMessage",
    attributes: "attributes",
    createdBy: "createdBy",
    dateCreated: "dateCreated",
    dateUpdated: "dateUpdated",
    friendlyName: "friendlyName",
    lastConsumedMessageIndex: "lastConsumedMessageIndex",
    notificationLevel: "notificationLevel",
    sid: "sid",
    status: "status",
    uniqueName: "uniqueName",
    state: "state",
    bindings: "bindings"
  }, zt = /* @__PURE__ */ function(N) {
    he.default(S, N);
    var X = hi(S);
    function S(y, g, W, V, b) {
      var A, k, T;
      M.default(this, S), T = X.call(this), T.sid = g, T._links = W, T._configuration = V, T._services = b, T._entityName = y.channel, T._internalState = {
        uniqueName: y.uniqueName || null,
        status: "notParticipating",
        attributes: (A = y.attributes) !== null && A !== void 0 ? A : {},
        createdBy: y.createdBy,
        dateCreated: qt(y.dateCreated),
        dateUpdated: qt(y.dateUpdated),
        friendlyName: y.friendlyName || null,
        lastReadMessageIndex: Number.isInteger(y.lastConsumedMessageIndex) ? y.lastConsumedMessageIndex : null,
        bindings: (k = y.bindings) !== null && k !== void 0 ? k : {}
      }, y.notificationLevel && (T._internalState.notificationLevel = y.notificationLevel);
      var $ = {
        participants: T._links.participants
      };
      return T._participants = /* @__PURE__ */ new Map(), T._participantsEntity = new se(le.default(T), T._participants, $, T._configuration, T._services), T._participantsEntity.on("participantJoined", function(ee) {
        return T.emit("participantJoined", ee);
      }), T._participantsEntity.on("participantLeft", function(ee) {
        return T.emit("participantLeft", ee);
      }), T._participantsEntity.on("participantUpdated", function(ee) {
        return T.emit("participantUpdated", ee);
      }), T._messagesEntity = new Qu(le.default(T), V, b), T._messagesEntity.on("messageAdded", function(ee) {
        return T._onMessageAdded(ee);
      }), T._messagesEntity.on("messageUpdated", function(ee) {
        return T.emit("messageUpdated", ee);
      }), T._messagesEntity.on("messageRemoved", function(ee) {
        return T.emit("messageRemoved", ee);
      }), T;
    }
    return ue.default(S, [{
      key: "uniqueName",
      get: function() {
        return this._internalState.uniqueName;
      }
      /**
       * Status of the conversation.
       */
    }, {
      key: "status",
      get: function() {
        return this._internalState.status;
      }
      /**
       * Name of the conversation.
       */
    }, {
      key: "friendlyName",
      get: function() {
        return this._internalState.friendlyName;
      }
      /**
       * Date this conversation was last updated on.
       */
    }, {
      key: "dateUpdated",
      get: function() {
        return this._internalState.dateUpdated;
      }
      /**
       * Date this conversation was created on.
       */
    }, {
      key: "dateCreated",
      get: function() {
        return this._internalState.dateCreated;
      }
      /**
       * Identity of the user that created this conversation.
       */
    }, {
      key: "createdBy",
      get: function() {
        var g;
        return (g = this._internalState.createdBy) !== null && g !== void 0 ? g : "";
      }
      /**
       * Custom attributes of the conversation.
       */
    }, {
      key: "attributes",
      get: function() {
        return this._internalState.attributes;
      }
      /**
       * Index of the last message the user has read in this conversation.
       */
    }, {
      key: "lastReadMessageIndex",
      get: function() {
        return this._internalState.lastReadMessageIndex;
      }
      /**
       * Last message sent to this conversation.
       */
    }, {
      key: "lastMessage",
      get: function() {
        var g;
        return (g = this._internalState.lastMessage) !== null && g !== void 0 ? g : void 0;
      }
      /**
       * User notification level for this conversation.
       */
    }, {
      key: "notificationLevel",
      get: function() {
        var g;
        return (g = this._internalState.notificationLevel) !== null && g !== void 0 ? g : "default";
      }
      /**
       * Conversation bindings. Undocumented feature (for now).
       * @internal
       */
    }, {
      key: "bindings",
      get: function() {
        return this._internalState.bindings;
      }
      /**
       * Current conversation limits.
       */
    }, {
      key: "limits",
      get: function() {
        return this._configuration.limits;
      }
      /**
       * State of the conversation.
       */
    }, {
      key: "state",
      get: function() {
        return this._internalState.state;
      }
      /**
       * Source of the conversation update.
       * @internal
       */
    }, {
      key: "_statusSource",
      get: function() {
        return this._dataSource;
      }
      /**
       * Preprocess the update object.
       * @param update The update object received from Sync.
       * @param conversationSid The SID of the conversation in question.
       */
    }, {
      key: "add",
      value: (
        /**
         * Add a participant to the conversation by its identity.
         * @param identity Identity of the Client to add.
         * @param attributes Attributes to be attached to the participant.
         * @returns The added participant.
         */
        function() {
          var y = Z.default(/* @__PURE__ */ F.default.mark(function W(V, b) {
            return F.default.wrap(function(k) {
              for (; ; )
                switch (k.prev = k.next) {
                  case 0:
                    return k.abrupt("return", this._participantsEntity.add(V, b ?? {}));
                  case 1:
                  case "end":
                    return k.stop();
                }
            }, W, this);
          }));
          function g(W, V) {
            return y.apply(this, arguments);
          }
          return g;
        }()
      )
      /**
       * Add a non-chat participant to the conversation.
       * @param proxyAddress Proxy (Twilio) address of the participant.
       * @param address User address of the participant.
       * @param attributes Attributes to be attached to the participant.
       * @param bindingOptions Options for adding email participants - name and
       * CC/To level.
       * @returns The added participant.
       */
    }, {
      key: "addNonChatParticipant",
      value: function() {
        var y = Z.default(/* @__PURE__ */ F.default.mark(function W(V, b) {
          var A, k, T = arguments;
          return F.default.wrap(function(ee) {
            for (; ; )
              switch (ee.prev = ee.next) {
                case 0:
                  return A = T.length > 2 && T[2] !== void 0 ? T[2] : {}, k = T.length > 3 && T[3] !== void 0 ? T[3] : {}, ee.abrupt("return", this._participantsEntity.addNonChatParticipant(V, b, A ?? {}, k ?? {}));
                case 3:
                case "end":
                  return ee.stop();
              }
          }, W, this);
        }));
        function g(W, V) {
          return y.apply(this, arguments);
        }
        return g;
      }()
      /**
       * Advance the conversation's last read message index to the current read
       * horizon. Rejects if the user is not a participant of the conversation. Last
       * read message index is updated only if the new index value is higher than
       * the previous.
       * @param index Message index to advance to.
       * @return Resulting unread messages count in the conversation.
       */
    }, {
      key: "advanceLastReadMessageIndex",
      value: function() {
        var y = Z.default(/* @__PURE__ */ F.default.mark(function W(V) {
          var b;
          return F.default.wrap(function(k) {
            for (; ; )
              switch (k.prev = k.next) {
                case 0:
                  return k.next = 2, this._subscribeStreams();
                case 2:
                  if (!(V < ((b = this.lastReadMessageIndex) !== null && b !== void 0 ? b : 0))) {
                    k.next = 6;
                    break;
                  }
                  return k.next = 5, this._setLastReadMessageIndex(this.lastReadMessageIndex);
                case 5:
                  return k.abrupt("return", k.sent);
                case 6:
                  return k.next = 8, this._setLastReadMessageIndex(V);
                case 8:
                  return k.abrupt("return", k.sent);
                case 9:
                case "end":
                  return k.stop();
              }
          }, W, this);
        }));
        function g(W) {
          return y.apply(this, arguments);
        }
        return g;
      }()
      /**
       * Delete the conversation and unsubscribe from its events.
       */
    }, {
      key: "delete",
      value: function() {
        var y = Z.default(/* @__PURE__ */ F.default.mark(function W() {
          return F.default.wrap(function(b) {
            for (; ; )
              switch (b.prev = b.next) {
                case 0:
                  return b.next = 2, this._services.commandExecutor.mutateResource("delete", this._links.self);
                case 2:
                  return b.abrupt("return", this);
                case 3:
                case "end":
                  return b.stop();
              }
          }, W, this);
        }));
        function g() {
          return y.apply(this, arguments);
        }
        return g;
      }()
      /**
       * Get the custom attributes of this Conversation.
       */
    }, {
      key: "getAttributes",
      value: function() {
        var y = Z.default(/* @__PURE__ */ F.default.mark(function W() {
          return F.default.wrap(function(b) {
            for (; ; )
              switch (b.prev = b.next) {
                case 0:
                  return b.next = 2, this._subscribe();
                case 2:
                  return b.abrupt("return", this.attributes);
                case 3:
                case "end":
                  return b.stop();
              }
          }, W, this);
        }));
        function g() {
          return y.apply(this, arguments);
        }
        return g;
      }()
      /**
       * Returns messages from the conversation using the paginator interface.
       * @param pageSize Number of messages to return in a single chunk. Default is
       * 30.
       * @param anchor Index of the newest message to fetch. Default is from the
       * end.
       * @param direction Query direction. By default, it queries backwards
       * from newer to older. The `"forward"` value will query in the opposite
       * direction.
       * @return A page of messages.
       */
    }, {
      key: "getMessages",
      value: function() {
        var y = Z.default(/* @__PURE__ */ F.default.mark(function W(V, b, A) {
          return F.default.wrap(function(T) {
            for (; ; )
              switch (T.prev = T.next) {
                case 0:
                  return T.next = 2, this._subscribeStreams();
                case 2:
                  return T.abrupt("return", this._messagesEntity.getMessages(V, b, A));
                case 3:
                case "end":
                  return T.stop();
              }
          }, W, this);
        }));
        function g(W, V, b) {
          return y.apply(this, arguments);
        }
        return g;
      }()
      /**
       * Get a list of all the participants who are joined to this conversation.
       */
    }, {
      key: "getParticipants",
      value: function() {
        var y = Z.default(/* @__PURE__ */ F.default.mark(function W() {
          return F.default.wrap(function(b) {
            for (; ; )
              switch (b.prev = b.next) {
                case 0:
                  return b.next = 2, this._subscribeStreams();
                case 2:
                  return b.abrupt("return", this._participantsEntity.getParticipants());
                case 3:
                case "end":
                  return b.stop();
              }
          }, W, this);
        }));
        function g() {
          return y.apply(this, arguments);
        }
        return g;
      }()
      /**
       * Get conversation participants count.
       *
       * This method is semi-realtime. This means that this data will be eventually
       * correct, but will also be possibly incorrect for a few seconds. The
       * Conversations system does not provide real time events for counter values
       * changes.
       *
       * This is useful for any UI badges, but it is not recommended to build any
       * core application logic based on these counters being accurate in real time.
       */
    }, {
      key: "getParticipantsCount",
      value: function() {
        var y = Z.default(/* @__PURE__ */ F.default.mark(function W() {
          var V, b, A;
          return F.default.wrap(function(T) {
            for (; ; )
              switch (T.prev = T.next) {
                case 0:
                  return b = new at(this._configuration.links.conversations).path(this.sid).build(), T.next = 3, this._services.network.get(b);
                case 3:
                  return A = T.sent, T.abrupt("return", (V = A.body.participants_count) !== null && V !== void 0 ? V : 0);
                case 5:
                case "end":
                  return T.stop();
              }
          }, W, this);
        }));
        function g() {
          return y.apply(this, arguments);
        }
        return g;
      }()
      /**
       * Get a participant by its SID.
       * @param participantSid Participant SID.
       */
    }, {
      key: "getParticipantBySid",
      value: function() {
        var y = Z.default(/* @__PURE__ */ F.default.mark(function W(V) {
          return F.default.wrap(function(A) {
            for (; ; )
              switch (A.prev = A.next) {
                case 0:
                  return A.abrupt("return", this._participantsEntity.getParticipantBySid(V));
                case 1:
                case "end":
                  return A.stop();
              }
          }, W, this);
        }));
        function g(W) {
          return y.apply(this, arguments);
        }
        return g;
      }()
      /**
       * Get a participant by its identity.
       * @param identity Participant identity.
       */
    }, {
      key: "getParticipantByIdentity",
      value: function() {
        var y = Z.default(/* @__PURE__ */ F.default.mark(function W() {
          var V, b = arguments;
          return F.default.wrap(function(k) {
            for (; ; )
              switch (k.prev = k.next) {
                case 0:
                  return V = b.length > 0 && b[0] !== void 0 ? b[0] : "", k.abrupt("return", this._participantsEntity.getParticipantByIdentity(V ?? ""));
                case 2:
                case "end":
                  return k.stop();
              }
          }, W, this);
        }));
        function g() {
          return y.apply(this, arguments);
        }
        return g;
      }()
      /**
       * Get the total message count in the conversation.
       *
       * This method is semi-realtime. This means that this data will be eventually
       * correct, but will also be possibly incorrect for a few seconds. The
       * Conversations system does not provide real time events for counter values
       * changes.
       *
       * This is useful for any UI badges, but it is not recommended to build any
       * core application logic based on these counters being accurate in real time.
       */
    }, {
      key: "getMessagesCount",
      value: function() {
        var y = Z.default(/* @__PURE__ */ F.default.mark(function W() {
          var V, b, A;
          return F.default.wrap(function(T) {
            for (; ; )
              switch (T.prev = T.next) {
                case 0:
                  return b = new at(this._configuration.links.conversations).path(this.sid).build(), T.next = 3, this._services.network.get(b);
                case 3:
                  return A = T.sent, T.abrupt("return", (V = A.body.messages_count) !== null && V !== void 0 ? V : 0);
                case 5:
                case "end":
                  return T.stop();
              }
          }, W, this);
        }));
        function g() {
          return y.apply(this, arguments);
        }
        return g;
      }()
      /**
       * Get count of unread messages for the user if they are a participant of this
       * conversation. Rejects if the user is not a participant of the conversation.
       *
       * Use this method to obtain the number of unread messages together with
       * {@link Conversation.updateLastReadMessageIndex} instead of relying on the
       * message indices which may have gaps. See {@link Message.index} for details.
       *
       * This method is semi-realtime. This means that this data will be eventually
       * correct, but it will also be possibly incorrect for a few seconds. The
       * Conversations system does not provide real time events for counter values
       * changes.
       *
       * This is useful for any UI badges, but it is not recommended to build any
       * core application logic based on these counters being accurate in real time.
       *
       * If the read horizon is not set, this function will return null. This could mean
       * that all messages in the conversation are unread, or that the read horizon system
       * is not being used. How to interpret this `null` value is up to the customer application.
       *
       * @return Number of unread messages based on the current read horizon set for
       * the user or `null` if the read horizon is not set.
       */
    }, {
      key: "getUnreadMessagesCount",
      value: function() {
        var y = Z.default(/* @__PURE__ */ F.default.mark(function W() {
          var V, b, A;
          return F.default.wrap(function(T) {
            for (; ; )
              switch (T.prev = T.next) {
                case 0:
                  return V = new at(this._configuration.links.myConversations).path(this.sid).build(), T.next = 3, this._services.network.get(V);
                case 3:
                  if (b = T.sent, b.body.conversation_sid === this.sid) {
                    T.next = 6;
                    break;
                  }
                  throw new Error("Conversation was not found in the user conversations list");
                case 6:
                  if (A = b.body.unread_messages_count, typeof A != "number") {
                    T.next = 9;
                    break;
                  }
                  return T.abrupt("return", A);
                case 9:
                  return T.abrupt("return", null);
                case 10:
                case "end":
                  return T.stop();
              }
          }, W, this);
        }));
        function g() {
          return y.apply(this, arguments);
        }
        return g;
      }()
      /**
       * Join the conversation and subscribe to its events.
       */
    }, {
      key: "join",
      value: function() {
        var y = Z.default(/* @__PURE__ */ F.default.mark(function W() {
          return F.default.wrap(function(b) {
            for (; ; )
              switch (b.prev = b.next) {
                case 0:
                  return b.next = 2, this._services.commandExecutor.mutateResource("post", this._links.participants, {
                    identity: this._configuration.userIdentity
                  });
                case 2:
                  return b.abrupt("return", this);
                case 3:
                case "end":
                  return b.stop();
              }
          }, W, this);
        }));
        function g() {
          return y.apply(this, arguments);
        }
        return g;
      }()
      /**
       * Leave the conversation.
       */
    }, {
      key: "leave",
      value: function() {
        var y = Z.default(/* @__PURE__ */ F.default.mark(function W() {
          return F.default.wrap(function(b) {
            for (; ; )
              switch (b.prev = b.next) {
                case 0:
                  if (this._internalState.status !== "joined") {
                    b.next = 3;
                    break;
                  }
                  return b.next = 3, this._services.commandExecutor.mutateResource("delete", "".concat(this._links.participants, "/").concat(encodeURIComponent(this._configuration.userIdentity)));
                case 3:
                  return b.abrupt("return", this);
                case 4:
                case "end":
                  return b.stop();
              }
          }, W, this);
        }));
        function g() {
          return y.apply(this, arguments);
        }
        return g;
      }()
      /**
       * Remove a participant from the conversation. When a string is passed as the
       * argument, it will assume that the string is an identity or SID.
       * @param participant Identity, SID or the participant object to remove.
       */
    }, {
      key: "removeParticipant",
      value: function() {
        var y = Z.default(/* @__PURE__ */ F.default.mark(function W(V) {
          return F.default.wrap(function(A) {
            for (; ; )
              switch (A.prev = A.next) {
                case 0:
                  return A.next = 2, this._participantsEntity.remove(typeof V == "string" ? V : V.sid);
                case 2:
                case "end":
                  return A.stop();
              }
          }, W, this);
        }));
        function g(W) {
          return y.apply(this, arguments);
        }
        return g;
      }()
      /**
       * Send a message to the conversation.
       * @param message Message body for the text message,
       * `FormData` or {@link SendMediaOptions} for media content. Sending FormData
       * is supported only with the browser engine.
       * @param messageAttributes Attributes for the message.
       * @param emailOptions Email options for the message.
       * @return Index of the new message.
       */
    }, {
      key: "sendMessage",
      value: function() {
        var y = Z.default(/* @__PURE__ */ F.default.mark(function W(V, b, A) {
          var k, T, $, ee;
          return F.default.wrap(function(we) {
            for (; ; )
              switch (we.prev = we.next) {
                case 0:
                  if (!(typeof V == "string" || V === null)) {
                    we.next = 5;
                    break;
                  }
                  return we.next = 3, this._messagesEntity.send(V, b, A);
                case 3:
                  return $ = we.sent, we.abrupt("return", (T = Je($.index)) !== null && T !== void 0 ? T : 0);
                case 5:
                  return we.next = 7, this._messagesEntity.sendMedia(V, b, A);
                case 7:
                  return ee = we.sent, we.abrupt("return", (k = Je(ee.index)) !== null && k !== void 0 ? k : 0);
                case 9:
                case "end":
                  return we.stop();
              }
          }, W, this);
        }));
        function g(W, V, b) {
          return y.apply(this, arguments);
        }
        return g;
      }()
      /**
       * New interface to prepare for sending a message.
       * Use this instead of {@link Conversation.sendMessage}.
       * @return A MessageBuilder to help set all message sending options.
       */
    }, {
      key: "prepareMessage",
      value: function() {
        return new Lr(this.limits, this._messagesEntity);
      }
      /**
       * Set last read message index of the conversation to the index of the last
       * known message.
       * @return Resulting unread messages count in the conversation.
       */
    }, {
      key: "setAllMessagesRead",
      value: function() {
        var y = Z.default(/* @__PURE__ */ F.default.mark(function W() {
          var V;
          return F.default.wrap(function(A) {
            for (; ; )
              switch (A.prev = A.next) {
                case 0:
                  return A.next = 2, this._subscribeStreams();
                case 2:
                  return A.next = 4, this.getMessages(1);
                case 4:
                  if (V = A.sent, !(V.items.length > 0)) {
                    A.next = 7;
                    break;
                  }
                  return A.abrupt("return", this.advanceLastReadMessageIndex(V.items[0].index));
                case 7:
                  return A.abrupt("return", 0);
                case 8:
                case "end":
                  return A.stop();
              }
          }, W, this);
        }));
        function g() {
          return y.apply(this, arguments);
        }
        return g;
      }()
      /**
       * Set all messages in the conversation unread.
       * @returns New count of unread messages after this update.
       */
    }, {
      key: "setAllMessagesUnread",
      value: function() {
        var y = Z.default(/* @__PURE__ */ F.default.mark(function W() {
          return F.default.wrap(function(b) {
            for (; ; )
              switch (b.prev = b.next) {
                case 0:
                  return b.next = 2, this._subscribeStreams();
                case 2:
                  return b.next = 4, this._setLastReadMessageIndex(null);
                case 4:
                  return b.abrupt("return", b.sent);
                case 5:
                case "end":
                  return b.stop();
              }
          }, W, this);
        }));
        function g() {
          return y.apply(this, arguments);
        }
        return g;
      }()
      /**
       * Set user notification level for this conversation.
       * @param notificationLevel New user notification level.
       */
    }, {
      key: "setUserNotificationLevel",
      value: function() {
        var y = Z.default(/* @__PURE__ */ F.default.mark(function W(V) {
          return F.default.wrap(function(A) {
            for (; ; )
              switch (A.prev = A.next) {
                case 0:
                  return A.next = 2, this._services.commandExecutor.mutateResource("post", "".concat(this._configuration.links.myConversations, "/").concat(this.sid), {
                    notification_level: V
                  });
                case 2:
                case "end":
                  return A.stop();
              }
          }, W, this);
        }));
        function g(W) {
          return y.apply(this, arguments);
        }
        return g;
      }()
      /**
       * Send a notification to the server indicating that this client is currently
       * typing in this conversation. Typing ended notification is sent after a
       * while automatically, but by calling this method again you ensure that
       * typing ended is not received.
       */
    }, {
      key: "typing",
      value: function() {
        return this._services.typingIndicator.send(this.sid);
      }
      /**
       * Update the attributes of the conversation.
       * @param attributes New attributes.
       */
    }, {
      key: "updateAttributes",
      value: function() {
        var y = Z.default(/* @__PURE__ */ F.default.mark(function W(V) {
          return F.default.wrap(function(A) {
            for (; ; )
              switch (A.prev = A.next) {
                case 0:
                  return A.next = 2, this._services.commandExecutor.mutateResource("post", this._links.self, {
                    attributes: V !== void 0 ? JSON.stringify(V) : void 0
                  });
                case 2:
                  return A.abrupt("return", this);
                case 3:
                case "end":
                  return A.stop();
              }
          }, W, this);
        }));
        function g(W) {
          return y.apply(this, arguments);
        }
        return g;
      }()
      /**
       * Update the friendly name of the conversation.
       * @param friendlyName New friendly name.
       */
    }, {
      key: "updateFriendlyName",
      value: function() {
        var y = Z.default(/* @__PURE__ */ F.default.mark(function W(V) {
          return F.default.wrap(function(A) {
            for (; ; )
              switch (A.prev = A.next) {
                case 0:
                  if (this._internalState.friendlyName === V) {
                    A.next = 3;
                    break;
                  }
                  return A.next = 3, this._services.commandExecutor.mutateResource("post", this._links.self, {
                    friendly_name: V
                  });
                case 3:
                  return A.abrupt("return", this);
                case 4:
                case "end":
                  return A.stop();
              }
          }, W, this);
        }));
        function g(W) {
          return y.apply(this, arguments);
        }
        return g;
      }()
      /**
       * Set the last read message index to the current read horizon.
       * @param index Message index to set as last read. If null is provided, then
       * the behavior is identical to {@link Conversation.setAllMessagesUnread}.
       * @returns New count of unread messages after this update.
       */
    }, {
      key: "updateLastReadMessageIndex",
      value: function() {
        var y = Z.default(/* @__PURE__ */ F.default.mark(function W(V) {
          return F.default.wrap(function(A) {
            for (; ; )
              switch (A.prev = A.next) {
                case 0:
                  return A.next = 2, this._subscribeStreams();
                case 2:
                  return A.abrupt("return", this._setLastReadMessageIndex(V));
                case 3:
                case "end":
                  return A.stop();
              }
          }, W, this);
        }));
        function g(W) {
          return y.apply(this, arguments);
        }
        return g;
      }()
      /**
       * Update the unique name of the conversation.
       * @param uniqueName New unique name for the conversation. Setting unique name
       * to null removes it.
       */
    }, {
      key: "updateUniqueName",
      value: function() {
        var y = Z.default(/* @__PURE__ */ F.default.mark(function W(V) {
          return F.default.wrap(function(A) {
            for (; ; )
              switch (A.prev = A.next) {
                case 0:
                  if (this._internalState.uniqueName === V) {
                    A.next = 4;
                    break;
                  }
                  return V || (V = ""), A.next = 4, this._services.commandExecutor.mutateResource("post", this._links.self, {
                    unique_name: V
                  });
                case 4:
                  return A.abrupt("return", this);
                case 5:
                case "end":
                  return A.stop();
              }
          }, W, this);
        }));
        function g(W) {
          return y.apply(this, arguments);
        }
        return g;
      }()
      /**
       * Load and subscribe to this conversation and do not subscribe to its
       * participants and messages. This or _subscribeStreams will need to be called
       * before any events on conversation will fire.
       * @internal
       */
    }, {
      key: "_subscribe",
      value: function() {
        var y = Z.default(/* @__PURE__ */ F.default.mark(function W() {
          var V = this;
          return F.default.wrap(function(A) {
            for (; ; )
              switch (A.prev = A.next) {
                case 0:
                  if (!this._entityPromise) {
                    A.next = 2;
                    break;
                  }
                  return A.abrupt("return", this._entityPromise);
                case 2:
                  return this._entityPromise = this._services.syncClient.document({
                    id: this._entityName,
                    mode: "open_existing"
                  }), A.prev = 3, A.next = 6, this._entityPromise;
                case 6:
                  return this._entity = A.sent, this._entity.on("updated", function(k) {
                    return V._update(k.data);
                  }), this._entity.on("removed", function() {
                    return V.emit("removed", V);
                  }), this._update(this._entity.data), A.abrupt("return", this._entity);
                case 13:
                  throw A.prev = 13, A.t0 = A.catch(3), this._entity = null, this._entityPromise = null, this._services.syncClient.connectionState != "disconnected" && S._logger.error("Failed to get conversation object", A.t0), S._logger.debug("ERROR: Failed to get conversation object", A.t0), A.t0;
                case 20:
                case "end":
                  return A.stop();
              }
          }, W, this, [[3, 13]]);
        }));
        function g() {
          return y.apply(this, arguments);
        }
        return g;
      }()
      /**
       * Fetch participants and messages of the conversation. This method needs to
       * be called during conversation initialization to catch broken conversations
       * (broken conversations are conversations that have essential Sync entities
       * missing, i.e. the conversation document, the messages list or the
       * participant map). In case of this conversation being broken, the method
       * will throw an exception that will be caught and handled gracefully.
       * @internal
       */
    }, {
      key: "_fetchStreams",
      value: function() {
        var y = Z.default(/* @__PURE__ */ F.default.mark(function W() {
          var V, b, A;
          return F.default.wrap(function(T) {
            for (; ; )
              switch (T.prev = T.next) {
                case 0:
                  return T.next = 2, this._subscribe();
                case 2:
                  return S._logger.trace("_streamsAvailable, this.entity.data=", (V = this._entity) === null || V === void 0 ? void 0 : V.data), A = (b = this._entity) === null || b === void 0 ? void 0 : b.data, T.next = 6, this._services.syncClient.list({
                    id: A.messages,
                    mode: "open_existing"
                  });
                case 6:
                  return this._messagesList = T.sent, T.next = 9, this._services.syncClient.map({
                    id: A.roster,
                    mode: "open_existing"
                  });
                case 9:
                  this._participantsMap = T.sent;
                case 10:
                case "end":
                  return T.stop();
              }
          }, W, this);
        }));
        function g() {
          return y.apply(this, arguments);
        }
        return g;
      }()
      /**
       * Load the attributes of this conversation and instantiate its participants
       * and messages. This or _subscribe will need to be called before any events
       * on the conversation will fire. This will need to be called before any
       * events on participants or messages will fire
       * @internal
       */
    }, {
      key: "_subscribeStreams",
      value: function() {
        var y = Z.default(/* @__PURE__ */ F.default.mark(function W() {
          var V, b, A, k, T, $, ee;
          return F.default.wrap(function(we) {
            for (; ; )
              switch (we.prev = we.next) {
                case 0:
                  return we.prev = 0, we.next = 3, this._subscribe();
                case 3:
                  return S._logger.trace("_subscribeStreams, this.entity.data=", (V = this._entity) === null || V === void 0 ? void 0 : V.data), T = (b = this._entity) === null || b === void 0 ? void 0 : b.data, $ = T.messages, ee = T.roster, we.next = 9, Promise.all([this._messagesEntity.subscribe((A = this._messagesList) !== null && A !== void 0 ? A : $), this._participantsEntity.subscribe((k = this._participantsMap) !== null && k !== void 0 ? k : ee)]);
                case 9:
                  we.next = 16;
                  break;
                case 11:
                  throw we.prev = 11, we.t0 = we.catch(0), this._services.syncClient.connectionState !== "disconnected" && S._logger.error("Failed to subscribe on conversation objects", this.sid, we.t0), S._logger.debug("ERROR: Failed to subscribe on conversation objects", this.sid, we.t0), we.t0;
                case 16:
                case "end":
                  return we.stop();
              }
          }, W, this, [[0, 11]]);
        }));
        function g() {
          return y.apply(this, arguments);
        }
        return g;
      }()
      /**
       * Stop listening for and firing events on this conversation.
       * @internal
       */
    }, {
      key: "_unsubscribe",
      value: function() {
        var y = Z.default(/* @__PURE__ */ F.default.mark(function W() {
          return F.default.wrap(function(b) {
            for (; ; )
              switch (b.prev = b.next) {
                case 0:
                  if (!this._entity) {
                    b.next = 5;
                    break;
                  }
                  return b.next = 3, this._entity.close();
                case 3:
                  this._entity = null, this._entityPromise = null;
                case 5:
                  return b.abrupt("return", Promise.all([this._participantsEntity.unsubscribe(), this._messagesEntity.unsubscribe()]));
                case 6:
                case "end":
                  return b.stop();
              }
          }, W, this);
        }));
        function g() {
          return y.apply(this, arguments);
        }
        return g;
      }()
      /**
       * Set conversation status.
       * @internal
       */
    }, {
      key: "_setStatus",
      value: function(g, W) {
        var V = this;
        if (this._dataSource = W, this._internalState.status !== g) {
          if (this._internalState.status = g, g === "joined") {
            this._subscribeStreams().catch(function(b) {
              if (S._logger.debug("ERROR while setting conversation status " + g, b), V._services.syncClient.connectionState !== "disconnected")
                throw b;
            });
            return;
          }
          this._entityPromise && this._unsubscribe().catch(function(b) {
            if (S._logger.debug("ERROR while setting conversation status " + g, b), V._services.syncClient.connectionState !== "disconnected")
              throw b;
          });
        }
      }
      /**
       * Update the local conversation object with new values.
       * @internal
       */
    }, {
      key: "_update",
      value: function(g) {
        var W, V, b, A, k;
        S._logger.trace("_update", g), S.preprocessUpdate(g, this.sid);
        for (var T = /* @__PURE__ */ new Set(), $ = 0, ee = Object.keys(g); $ < ee.length; $++) {
          var ve = ee[$], we = Hn[ve];
          if (we)
            switch (we) {
              case Hn.status:
                if (!g.status || g.status === "unknown" || this._internalState.status === g.status)
                  break;
                this._internalState.status = g.status, T.add(we);
                break;
              case Hn.attributes:
                if (oe.default(this._internalState.attributes, g.attributes))
                  break;
                this._internalState.attributes = g.attributes, T.add(we);
                break;
              case Hn.lastConsumedMessageIndex:
                if (g.lastConsumedMessageIndex === void 0 || g.lastConsumedMessageIndex === this._internalState.lastReadMessageIndex)
                  break;
                this._internalState.lastReadMessageIndex = g.lastConsumedMessageIndex, T.add("lastReadMessageIndex");
                break;
              case Hn.lastMessage:
                if (this._internalState.lastMessage && !g.lastMessage) {
                  delete this._internalState.lastMessage, T.add(we);
                  break;
                }
                this._internalState.lastMessage = this._internalState.lastMessage || {}, ((W = g.lastMessage) === null || W === void 0 ? void 0 : W.index) !== void 0 && g.lastMessage.index !== this._internalState.lastMessage.index && (this._internalState.lastMessage.index = g.lastMessage.index, T.add(we)), ((V = g.lastMessage) === null || V === void 0 ? void 0 : V.timestamp) !== void 0 && ((b = this._internalState.lastMessage) === null || b === void 0 || (A = b.dateCreated) === null || A === void 0 ? void 0 : A.getTime()) !== g.lastMessage.timestamp.getTime() && (this._internalState.lastMessage.dateCreated = g.lastMessage.timestamp, T.add(we)), oe.default(this._internalState.lastMessage, {}) && delete this._internalState.lastMessage;
                break;
              case Hn.state:
                var gt = g.state || void 0;
                if (gt !== void 0 && (gt.dateUpdated = new Date(gt.dateUpdated)), oe.default(this._internalState.state, gt))
                  break;
                this._internalState.state = gt, T.add(we);
                break;
              case Hn.bindings:
                if (oe.default(this._internalState.bindings, g.bindings))
                  break;
                this._internalState.bindings = g.bindings, T.add(we);
                break;
              default:
                var At = g[ve] instanceof Date, Et = At && ((k = this._internalState[we]) === null || k === void 0 ? void 0 : k.getTime()) === g[ve].getTime(), Nt = !At && this[we] === g[ve];
                if (Et || Nt)
                  break;
                this._internalState[we] = g[ve], T.add(we);
            }
        }
        T.size > 0 && this.emit("updated", {
          conversation: this,
          updateReasons: ce.default(T)
        });
      }
      /**
       * Handle onMessageAdded event.
       */
    }, {
      key: "_onMessageAdded",
      value: function(g) {
        var W = Ju(this._participants.values()), V;
        try {
          for (W.s(); !(V = W.n()).done; ) {
            var b = V.value;
            if (b.identity === g.author) {
              b._endTyping();
              break;
            }
          }
        } catch (A) {
          W.e(A);
        } finally {
          W.f();
        }
        this.emit("messageAdded", g);
      }
      /**
       * Set last read message index.
       * @param index New index to set.
       */
    }, {
      key: "_setLastReadMessageIndex",
      value: function() {
        var y = Z.default(/* @__PURE__ */ F.default.mark(function W(V) {
          var b;
          return F.default.wrap(function(k) {
            for (; ; )
              switch (k.prev = k.next) {
                case 0:
                  return k.next = 2, this._services.commandExecutor.mutateResource("post", "".concat(this._configuration.links.myConversations, "/").concat(this.sid), {
                    last_read_message_index: V
                  });
                case 2:
                  return b = k.sent, k.abrupt("return", b.unread_messages_count);
                case 4:
                case "end":
                  return k.stop();
              }
          }, W, this);
        }));
        function g(W) {
          return y.apply(this, arguments);
        }
        return g;
      }()
    }], [{
      key: "preprocessUpdate",
      value: function(g, W) {
        try {
          typeof g.attributes == "string" ? g.attributes = JSON.parse(g.attributes) : g.attributes && JSON.stringify(g.attributes);
        } catch {
          S._logger.warn("Retrieved malformed attributes from the server for conversation: " + W), g.attributes = {};
        }
        try {
          g.dateCreated && (g.dateCreated = new Date(g.dateCreated));
        } catch {
          S._logger.warn("Retrieved malformed dateCreated from the server for conversation: " + W), delete g.dateCreated;
        }
        try {
          g.dateUpdated && (g.dateUpdated = new Date(g.dateUpdated));
        } catch {
          S._logger.warn("Retrieved malformed dateUpdated from the server for conversation: " + W), delete g.dateUpdated;
        }
        try {
          g.lastMessage && g.lastMessage.timestamp && (g.lastMessage.timestamp = new Date(g.lastMessage.timestamp));
        } catch {
          S._logger.warn("Retrieved malformed lastMessage.timestamp from the server for conversation: " + W), delete g.lastMessage.timestamp;
        }
      }
    }]), S;
  }(m.ReplayEventEmitter);
  ye.default(zt, "participantJoined", "participantJoined"), ye.default(zt, "participantLeft", "participantLeft"), ye.default(zt, "participantUpdated", "participantUpdated"), ye.default(zt, "messageAdded", "messageAdded"), ye.default(zt, "messageRemoved", "messageRemoved"), ye.default(zt, "messageUpdated", "messageUpdated"), ye.default(zt, "typingEnded", "typingEnded"), ye.default(zt, "typingStarted", "typingStarted"), ye.default(zt, "updated", "updated"), ye.default(zt, "removed", "removed"), ye.default(zt, "_logger", Ue.scope("Conversation")), Ae([v.validateTypesAsync(v.nonEmptyString, Dt), re("design:type", Function), re("design:paramtypes", [String, Object]), re("design:returntype", Promise)], zt.prototype, "add", null), Ae([v.validateTypesAsync(v.nonEmptyString, v.nonEmptyString, Dt), re("design:type", Function), re("design:paramtypes", [String, String, Object, Object]), re("design:returntype", Promise)], zt.prototype, "addNonChatParticipant", null), Ae([v.validateTypesAsync(v.nonNegativeInteger), re("design:type", Function), re("design:paramtypes", [Number]), re("design:returntype", Promise)], zt.prototype, "advanceLastReadMessageIndex", null), Ae([v.validateTypesAsync(["undefined", v.nonNegativeInteger], ["undefined", v.nonNegativeInteger], ["undefined", v.literal("backwards", "forward")]), re("design:type", Function), re("design:paramtypes", [Number, Number, String]), re("design:returntype", Promise)], zt.prototype, "getMessages", null), Ae([v.validateTypesAsync(v.nonEmptyString), re("design:type", Function), re("design:paramtypes", [String]), re("design:returntype", Promise)], zt.prototype, "getParticipantBySid", null), Ae([v.validateTypesAsync(v.nonEmptyString), re("design:type", Function), re("design:paramtypes", [String]), re("design:returntype", Promise)], zt.prototype, "getParticipantByIdentity", null), Ae([v.validateTypesAsync([v.nonEmptyString, fe]), re("design:type", Function), re("design:paramtypes", [Object]), re("design:returntype", Promise)], zt.prototype, "removeParticipant", null), Ae([v.validateTypesAsync(["string", FormData, v.literal(null), v.objectSchema("media options", {
    contentType: v.nonEmptyString,
    media: v.custom(function(N) {
      var X = typeof N == "string" && N.length > 0 || N instanceof Uint8Array || N instanceof ArrayBuffer;
      return typeof Blob == "function" && (X = X || N instanceof Blob), [X, "a non-empty string, an instance of Buffer or an instance of Blob"];
    })
  })], Dt, ["undefined", v.literal(null), v.objectSchema("email attributes", {
    subject: [v.nonEmptyString, "undefined"]
  })]), re("design:type", Function), re("design:paramtypes", [Object, Object, Object]), re("design:returntype", Promise)], zt.prototype, "sendMessage", null), Ae([v.validateTypesAsync(v.literal("default", "muted")), re("design:type", Function), re("design:paramtypes", [String]), re("design:returntype", Promise)], zt.prototype, "setUserNotificationLevel", null), Ae([v.validateTypesAsync(rt), re("design:type", Function), re("design:paramtypes", [Object]), re("design:returntype", Promise)], zt.prototype, "updateAttributes", null), Ae([v.validateTypesAsync("string"), re("design:type", Function), re("design:paramtypes", [String]), re("design:returntype", Promise)], zt.prototype, "updateFriendlyName", null), Ae([v.validateTypesAsync([v.literal(null), v.nonNegativeInteger]), re("design:type", Function), re("design:paramtypes", [Number]), re("design:returntype", Promise)], zt.prototype, "updateLastReadMessageIndex", null), Ae([v.validateTypesAsync(["string", v.literal(null)]), re("design:type", Function), re("design:paramtypes", [String]), re("design:returntype", Promise)], zt.prototype, "updateUniqueName", null);
  var Hu = /* @__PURE__ */ function() {
    function N() {
      var X = this;
      M.default(this, N), this._promise = new Promise(function(S, y) {
        X._resolve = S, X._reject = y;
      });
    }
    return ue.default(N, [{
      key: "promise",
      get: function() {
        return this._promise;
      }
    }, {
      key: "update",
      value: function(S) {
        this._resolve(S);
      }
    }, {
      key: "set",
      value: function(S) {
        this.current = S, this._resolve(S);
      }
    }, {
      key: "fail",
      value: function(S) {
        this._reject(S);
      }
    }]), N;
  }();
  function _u(N, X) {
    var S = typeof Symbol < "u" && N[Symbol.iterator] || N["@@iterator"];
    if (!S) {
      if (Array.isArray(N) || (S = $u(N)) || X && N && typeof N.length == "number") {
        S && (N = S);
        var y = 0, g = function() {
        };
        return { s: g, n: function() {
          return y >= N.length ? { done: !0 } : { done: !1, value: N[y++] };
        }, e: function(k) {
          throw k;
        }, f: g };
      }
      throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
    }
    var W = !0, V = !1, b;
    return { s: function() {
      S = S.call(N);
    }, n: function() {
      var k = S.next();
      return W = k.done, k;
    }, e: function(k) {
      V = !0, b = k;
    }, f: function() {
      try {
        !W && S.return != null && S.return();
      } finally {
        if (V)
          throw b;
      }
    } };
  }
  function $u(N, X) {
    if (N) {
      if (typeof N == "string")
        return As(N, X);
      var S = Object.prototype.toString.call(N).slice(8, -1);
      if (S === "Object" && N.constructor && (S = N.constructor.name), S === "Map" || S === "Set")
        return Array.from(N);
      if (S === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(S))
        return As(N, X);
    }
  }
  function As(N, X) {
    (X == null || X > N.length) && (X = N.length);
    for (var S = 0, y = new Array(X); S < X; S++)
      y[S] = N[S];
    return y;
  }
  function ho(N, X) {
    var S = Object.keys(N);
    if (Object.getOwnPropertySymbols) {
      var y = Object.getOwnPropertySymbols(N);
      X && (y = y.filter(function(g) {
        return Object.getOwnPropertyDescriptor(N, g).enumerable;
      })), S.push.apply(S, y);
    }
    return S;
  }
  function ef(N) {
    for (var X = 1; X < arguments.length; X++) {
      var S = arguments[X] != null ? arguments[X] : {};
      X % 2 ? ho(Object(S), !0).forEach(function(y) {
        ye.default(N, y, S[y]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(N, Object.getOwnPropertyDescriptors(S)) : ho(Object(S)).forEach(function(y) {
        Object.defineProperty(N, y, Object.getOwnPropertyDescriptor(S, y));
      });
    }
    return N;
  }
  function ws(N) {
    var X = na();
    return function() {
      var y = xe.default(N), g;
      if (X) {
        var W = xe.default(this).constructor;
        g = Reflect.construct(y, arguments, W);
      } else
        g = y.apply(this, arguments);
      return Ie.default(this, g);
    };
  }
  function na() {
    if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
      return !1;
    if (typeof Proxy == "function")
      return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      })), !0;
    } catch {
      return !1;
    }
  }
  var dr = Ue.scope("Conversations"), mo = /* @__PURE__ */ function(N) {
    he.default(S, N);
    var X = ws(S);
    function S(y, g) {
      var W;
      return M.default(this, S), W = X.call(this), ye.default(le.default(W), "conversations", /* @__PURE__ */ new Map()), ye.default(le.default(W), "myConversationsRead", new Hu()), ye.default(le.default(W), "tombstones", /* @__PURE__ */ new Set()), ye.default(le.default(W), "myConversationsFetched", !1), W.configuration = y, W.services = g, W;
    }
    return ue.default(S, [{
      key: "addConversation",
      value: function() {
        var y = Z.default(/* @__PURE__ */ F.default.mark(function W(V) {
          var b, A, k, T, $, ee, ve, we, gt, At;
          return F.default.wrap(function(Nt) {
            for (; ; )
              switch (Nt.prev = Nt.next) {
                case 0:
                  return T = typeof (V == null ? void 0 : V.attributes) < "u" ? V.attributes : {}, Nt.next = 3, this.services.commandExecutor.mutateResource("post", this.configuration.links.conversations, {
                    friendly_name: V.friendlyName,
                    unique_name: V.uniqueName,
                    attributes: typeof T < "u" ? JSON.stringify(T) : void 0
                  });
                case 3:
                  if ($ = Nt.sent, ee = (b = $.sid) !== null && b !== void 0 ? b : null, ve = (A = (k = $.sync_objects) === null || k === void 0 ? void 0 : k.conversation) !== null && A !== void 0 ? A : null, we = ef({
                    self: $.url
                  }, $.links), gt = this.conversations.get(ee), !gt) {
                    Nt.next = 12;
                    break;
                  }
                  return Nt.next = 11, gt._subscribe();
                case 11:
                  return Nt.abrupt("return", gt);
                case 12:
                  return At = new zt({
                    channel: ve,
                    entityName: "",
                    uniqueName: "",
                    attributes: null,
                    createdBy: "",
                    friendlyName: "",
                    lastConsumedMessageIndex: 0,
                    dateCreated: null,
                    dateUpdated: null
                  }, ee, we, this.configuration, this.services), this.conversations.set(At.sid, At), this._registerForEvents(At), Nt.next = 17, At._subscribe();
                case 17:
                  return this.emit("conversationAdded", At), Nt.abrupt("return", At);
                case 19:
                case "end":
                  return Nt.stop();
              }
          }, W, this);
        }));
        function g(W) {
          return y.apply(this, arguments);
        }
        return g;
      }()
      /**
       * Fetch conversations list and instantiate all necessary objects
       */
    }, {
      key: "fetchConversations",
      value: function() {
        var y = Z.default(/* @__PURE__ */ F.default.mark(function W() {
          var V = this, b, A, k, T, $, ee, ve;
          return F.default.wrap(function(gt) {
            for (; ; )
              switch (gt.prev = gt.next) {
                case 0:
                  return gt.prev = 0, gt.next = 3, this._getMap();
                case 3:
                  return b = gt.sent, b.on("itemAdded", function(At) {
                    dr.debug("itemAdded: ".concat(At.item.key)), V._upsertConversation("sync", At.item.key, At.item.data);
                  }), b.on("itemRemoved", function(At) {
                    dr.debug("itemRemoved: ".concat(At.key));
                    var Et = At.key;
                    V.myConversationsFetched || V.tombstones.add(Et);
                    var Nt = V.conversations.get(Et);
                    Nt && (Nt.status === "joined" && (Nt._setStatus("notParticipating", "sync"), V.emit("conversationLeft", Nt)), V.conversations.delete(Et), V.emit("conversationRemoved", Nt), Nt.emit("removed", Nt));
                  }), b.on("itemUpdated", function(At) {
                    dr.debug("itemUpdated: ".concat(At.item.key)), V._upsertConversation("sync", At.item.key, At.item.data);
                  }), gt.next = 9, this._fetchMyConversations();
                case 9:
                  A = gt.sent, k = [], T = _u(A);
                  try {
                    for (T.s(); !($ = T.n()).done; )
                      ee = $.value, k.push(this._upsertConversation("rest", ee.channel_sid, ee));
                  } catch (At) {
                    T.e(At);
                  } finally {
                    T.f();
                  }
                  return this.myConversationsRead.set(!0), gt.next = 16, Promise.all(k);
                case 16:
                  return this.myConversationsFetched = !0, this.tombstones.clear(), dr.debug("The conversations list has been successfully fetched"), gt.abrupt("return", this);
                case 22:
                  throw gt.prev = 22, gt.t0 = gt.catch(0), ve = "Failed to fetch the conversations list", this.services.syncClient.connectionState !== "disconnected" && dr.error(ve, gt.t0), dr.debug("ERROR: ".concat(ve), gt.t0), gt.t0;
                case 28:
                case "end":
                  return gt.stop();
              }
          }, W, this, [[0, 22]]);
        }));
        function g() {
          return y.apply(this, arguments);
        }
        return g;
      }()
    }, {
      key: "getConversations",
      value: function() {
        var y = Z.default(/* @__PURE__ */ F.default.mark(function W() {
          var V = this, b, A;
          return F.default.wrap(function(T) {
            for (; ; )
              switch (T.prev = T.next) {
                case 0:
                  return T.next = 2, this._getMap();
                case 2:
                  return b = T.sent, T.next = 5, b.getItems();
                case 5:
                  return A = T.sent, T.abrupt("return", this._wrapPaginator(A, function($) {
                    return Promise.all($.map(function(ee) {
                      return V._upsertConversation("sync", ee.key, ee.data);
                    }));
                  }));
                case 7:
                case "end":
                  return T.stop();
              }
          }, W, this);
        }));
        function g() {
          return y.apply(this, arguments);
        }
        return g;
      }()
    }, {
      key: "getConversation",
      value: function() {
        var y = Z.default(/* @__PURE__ */ F.default.mark(function W(V) {
          var b = this, A, k, T;
          return F.default.wrap(function(ee) {
            for (; ; )
              switch (ee.prev = ee.next) {
                case 0:
                  return ee.next = 2, this._getMap();
                case 2:
                  return A = ee.sent, ee.next = 5, A.getItems({
                    key: V
                  });
                case 5:
                  return k = ee.sent, T = k.items.map(function(ve) {
                    return b._upsertConversation("sync", ve.key, ve.data);
                  }), ee.abrupt("return", T.length > 0 ? T[0] : null);
                case 8:
                case "end":
                  return ee.stop();
              }
          }, W, this);
        }));
        function g(W) {
          return y.apply(this, arguments);
        }
        return g;
      }()
    }, {
      key: "getConversationByUniqueName",
      value: function() {
        var y = Z.default(/* @__PURE__ */ F.default.mark(function W(V) {
          var b, A, k, T, $;
          return F.default.wrap(function(ve) {
            for (; ; )
              switch (ve.prev = ve.next) {
                case 0:
                  return b = new at(this.configuration.links.myConversations).path(V).build(), ve.next = 3, this.services.network.get(b);
                case 3:
                  return A = ve.sent, k = A.body, T = k.conversation_sid, $ = {
                    entityName: null,
                    lastConsumedMessageIndex: k.last_read_message_index,
                    status: (k == null ? void 0 : k.status) || "unknown",
                    friendlyName: k.friendly_name,
                    dateUpdated: k.date_updated,
                    dateCreated: k.date_created,
                    uniqueName: k.unique_name,
                    createdBy: k.created_by,
                    attributes: k.attributes,
                    channel: k.sync_objects.conversation,
                    notificationLevel: k == null ? void 0 : k.notification_level,
                    sid: T
                  }, ve.abrupt("return", T ? this._upsertConversation("sync", T, $) : null);
                case 8:
                case "end":
                  return ve.stop();
              }
          }, W, this);
        }));
        function g(W) {
          return y.apply(this, arguments);
        }
        return g;
      }()
    }, {
      key: "peekConversation",
      value: function() {
        var y = Z.default(/* @__PURE__ */ F.default.mark(function W(V) {
          var b, A, k, T;
          return F.default.wrap(function(ee) {
            for (; ; )
              switch (ee.prev = ee.next) {
                case 0:
                  return b = new at(this.configuration.links.conversations).path(V).build(), ee.next = 3, this.services.network.get(b);
                case 3:
                  return A = ee.sent, k = A.body, T = {
                    entityName: null,
                    // lastConsumedMessageIndex: body.last_read_message_index,
                    status: (k == null ? void 0 : k.status) || "unknown",
                    friendlyName: k.friendly_name,
                    dateUpdated: k.date_updated,
                    dateCreated: k.date_created,
                    uniqueName: k.unique_name,
                    createdBy: k.created_by,
                    attributes: k.attributes,
                    channel: "".concat(V, ".channel"),
                    // notificationLevel: body?.notification_level,
                    sid: V
                  }, ee.abrupt("return", this._upsertConversation("sync", V, T));
                case 7:
                case "end":
                  return ee.stop();
              }
          }, W, this);
        }));
        function g(W) {
          return y.apply(this, arguments);
        }
        return g;
      }()
    }, {
      key: "_getMap",
      value: function() {
        var y = Z.default(/* @__PURE__ */ F.default.mark(function W() {
          return F.default.wrap(function(b) {
            for (; ; )
              switch (b.prev = b.next) {
                case 0:
                  return b.next = 2, this.services.syncClient.map({
                    id: this.configuration.myConversations,
                    mode: "open_existing"
                  });
                case 2:
                  return b.abrupt("return", b.sent);
                case 3:
                case "end":
                  return b.stop();
              }
          }, W, this);
        }));
        function g() {
          return y.apply(this, arguments);
        }
        return g;
      }()
    }, {
      key: "_wrapPaginator",
      value: function() {
        var y = Z.default(/* @__PURE__ */ F.default.mark(function W(V, b) {
          var A = this, k;
          return F.default.wrap(function($) {
            for (; ; )
              switch ($.prev = $.next) {
                case 0:
                  return $.next = 2, b(V.items);
                case 2:
                  return k = $.sent, $.abrupt("return", {
                    items: k.filter(function(ee) {
                      return ee !== null;
                    }),
                    hasNextPage: V.hasNextPage,
                    hasPrevPage: V.hasPrevPage,
                    nextPage: function() {
                      return V.nextPage().then(function(ve) {
                        return A._wrapPaginator(ve, b);
                      });
                    },
                    prevPage: function() {
                      return V.prevPage().then(function(ve) {
                        return A._wrapPaginator(ve, b);
                      });
                    }
                  });
                case 4:
                case "end":
                  return $.stop();
              }
          }, W);
        }));
        function g(W, V) {
          return y.apply(this, arguments);
        }
        return g;
      }()
    }, {
      key: "_updateConversation",
      value: function() {
        var y = Z.default(/* @__PURE__ */ F.default.mark(function W(V, b, A) {
          var k, T, $;
          return F.default.wrap(function(ve) {
            for (; ; )
              switch (ve.prev = ve.next) {
                case 0:
                  if (k = b._statusSource !== void 0 && V !== b._statusSource, T = V !== "rest" || b._statusSource === "sync", !(k && T && V !== "sync")) {
                    ve.next = 5;
                    break;
                  }
                  return dr.trace("upsertConversation: conversation is known from sync and came from REST, ignoring", {
                    sid: b.sid,
                    data: A.status,
                    conversation: b.status
                  }), ve.abrupt("return");
                case 5:
                  if (!(A.status === "joined" && b.status !== "joined")) {
                    ve.next = 15;
                    break;
                  }
                  return b._setStatus("joined", V), $ = {}, typeof A.notificationLevel < "u" && ($.notificationLevel = A.notificationLevel), typeof A.lastConsumedMessageIndex < "u" && ($.lastConsumedMessageIndex = A.lastConsumedMessageIndex), oe.default($, {}) || b._update($), ve.next = 13, b._subscribe();
                case 13:
                  return this.emit("conversationJoined", b), ve.abrupt("return");
                case 15:
                  if (!(A.status === "notParticipating" && b.status === "joined")) {
                    ve.next = 22;
                    break;
                  }
                  return b._setStatus("notParticipating", V), b._update(A), ve.next = 20, b._subscribe();
                case 20:
                  return this.emit("conversationLeft", b), ve.abrupt("return");
                case 22:
                  if (A.status !== "notParticipating") {
                    ve.next = 26;
                    break;
                  }
                  return ve.next = 25, b._subscribe();
                case 25:
                  return ve.abrupt("return");
                case 26:
                  b._update(A);
                case 27:
                case "end":
                  return ve.stop();
              }
          }, W, this);
        }));
        function g(W, V, b) {
          return y.apply(this, arguments);
        }
        return g;
      }()
    }, {
      key: "_upsertConversation",
      value: function() {
        var y = Z.default(/* @__PURE__ */ F.default.mark(function W(V, b, A) {
          var k, T, $, ee;
          return F.default.wrap(function(we) {
            for (; ; )
              switch (we.prev = we.next) {
                case 0:
                  if (dr.trace("upsertConversation called for ".concat(b), A), k = this.conversations.get(b), !k) {
                    we.next = 9;
                    break;
                  }
                  return dr.trace("upsertConversation: the conversation ".concat(k.sid, " is known;") + "its status is known from the source ".concat(k._statusSource, " ") + "and the update came from the source ".concat(V), k), we.next = 6, this._updateConversation(V, k, A);
                case 6:
                  return we.next = 8, k._subscribe();
                case 8:
                  return we.abrupt("return", k);
                case 9:
                  if (!(V === "rest" && this.tombstones.has(b))) {
                    we.next = 12;
                    break;
                  }
                  return dr.trace("upsertChannel: the conversation is deleted but reappeared again from REST, ignoring", b), we.abrupt("return", null);
                case 12:
                  return dr.trace("upsertConversation: creating a local conversation object with sid " + b, A), T = "".concat(this.configuration.links.conversations, "/").concat(b), $ = {
                    self: T,
                    messages: "".concat(T, "/Messages"),
                    participants: "".concat(T, "/Participants")
                  }, ee = new zt(A, b, $, this.configuration, this.services), this.conversations.set(b, ee), we.prev = 17, we.next = 20, ee._subscribe();
                case 20:
                  if (A.status !== "joined") {
                    we.next = 23;
                    break;
                  }
                  return we.next = 23, ee._fetchStreams();
                case 23:
                  we.next = 32;
                  break;
                case 25:
                  if (we.prev = 25, we.t0 = we.catch(17), we.t0.name === "SyncError") {
                    we.next = 29;
                    break;
                  }
                  throw we.t0;
                case 29:
                  return dr.trace("upsertChannel: the conversation is missing some Sync entity(ies), ignoring", b, we.t0), this.conversations.delete(b), we.abrupt("return", null);
                case 32:
                  return this._registerForEvents(ee), this.emit("conversationAdded", ee), A.status === "joined" && (ee._setStatus("joined", V), this.emit("conversationJoined", ee)), we.abrupt("return", ee);
                case 36:
                case "end":
                  return we.stop();
              }
          }, W, this, [[17, 25]]);
        }));
        function g(W, V, b) {
          return y.apply(this, arguments);
        }
        return g;
      }()
    }, {
      key: "_fetchMyConversations",
      value: function() {
        var y = Z.default(/* @__PURE__ */ F.default.mark(function W() {
          var V, b, A, k, T, $;
          return F.default.wrap(function(ve) {
            for (; ; )
              switch (ve.prev = ve.next) {
                case 0:
                  V = [], b = null;
                case 2:
                  return k = new at(this.configuration.links.myConversations), b && k.arg("PageToken", b), ve.next = 6, this.services.network.get(k.build());
                case 6:
                  T = ve.sent, $ = (A = T.body) === null || A === void 0 ? void 0 : A.conversations.map(function(we) {
                    return {
                      descriptor: we,
                      channel_sid: we.conversation_sid,
                      status: we.status,
                      channel: we.sync_objects.conversation,
                      messages: we.sync_objects.messages,
                      roster: "".concat(we.conversation_sid, ".roster"),
                      lastConsumedMessageIndex: we.last_read_message_index,
                      notificationLevel: we.notification_level
                    };
                  }), b = T.body.meta.next_token, V = [].concat(ce.default(V), ce.default($));
                case 10:
                  if (b) {
                    ve.next = 2;
                    break;
                  }
                case 11:
                  return ve.abrupt("return", V);
                case 12:
                case "end":
                  return ve.stop();
              }
          }, W, this);
        }));
        function g() {
          return y.apply(this, arguments);
        }
        return g;
      }()
    }, {
      key: "_onConversationRemoved",
      value: function(g) {
        var W = this.conversations.get(g);
        W && (this.conversations.delete(g), this.emit("conversationRemoved", W));
      }
    }, {
      key: "_registerForEvents",
      value: function(g) {
        var W = this;
        g.on("removed", function() {
          return W._onConversationRemoved(g.sid);
        }), g.on("updated", function(V) {
          return W.emit("conversationUpdated", V);
        }), g.on("participantJoined", function(V) {
          return W.emit("participantJoined", V);
        }), g.on("participantLeft", function(V) {
          return W.emit("participantLeft", V);
        }), g.on("participantUpdated", function(V) {
          return W.emit("participantUpdated", V);
        }), g.on("messageAdded", function(V) {
          return W.emit("messageAdded", V);
        }), g.on("messageUpdated", function(V) {
          return W.emit("messageUpdated", V);
        }), g.on("messageRemoved", function(V) {
          return W.emit("messageRemoved", V);
        }), g.on("typingStarted", function(V) {
          return W.emit("typingStarted", V);
        }), g.on("typingEnded", function(V) {
          return W.emit("typingEnded", V);
        });
      }
    }]), S;
  }(m.ReplayEventEmitter);
  function tf(N) {
    var X = _n();
    return function() {
      var y = xe.default(N), g;
      if (X) {
        var W = xe.default(this).constructor;
        g = Reflect.construct(y, arguments, W);
      } else
        g = y.apply(this, arguments);
      return Ie.default(this, g);
    };
  }
  function _n() {
    if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
      return !1;
    if (typeof Proxy == "function")
      return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      })), !0;
    } catch {
      return !1;
    }
  }
  var mi = /* @__PURE__ */ function(N) {
    he.default(S, N);
    var X = tf(S);
    function S(y, g, W) {
      var V;
      return M.default(this, S), V = X.call(this), V.configuration = g, V.services = W, V.fifoStack = [], V.myself = y, V.myself.on("updated", function(b) {
        return V.emit("userUpdated", b);
      }), V.myself.on("userSubscribed", function() {
        return V.emit("userSubscribed", V.myself);
      }), V.myself.on("userUnsubscribed", function() {
        V.emit("userUnsubscribed", V.myself), V.myself._ensureFetched();
      }), V.subscribedUsers = /* @__PURE__ */ new Map(), V;
    }
    return ue.default(S, [{
      key: "handleUnsubscribeUser",
      value: function(g) {
        this.subscribedUsers.has(g.identity) && this.subscribedUsers.delete(g.identity);
        var W = 0, V = this.fifoStack.find(function(b, A) {
          return b == g.identity ? (W = A, !0) : !1;
        });
        V && this.fifoStack.splice(W, 1), this.emit("userUnsubscribed", g);
      }
    }, {
      key: "handleSubscribeUser",
      value: function(g) {
        if (!this.subscribedUsers.has(g.identity)) {
          if (this.fifoStack.length >= this.configuration.userInfosToSubscribe) {
            var W, V, b = this.fifoStack.shift();
            (W = this.subscribedUsers) === null || W === void 0 || (V = W.get(b)) === null || V === void 0 || V.unsubscribe();
          }
          this.fifoStack.push(g.identity), this.subscribedUsers.set(g.identity, g), this.emit("userSubscribed", g);
        }
      }
      /**
       * Gets user, if it's in subscribed list - then return the user object from it,
       * if not - then subscribes and adds user to the FIFO stack
       * @returns {Promise<User>} Fully initialized user
       */
    }, {
      key: "getUser",
      value: function() {
        var y = Z.default(/* @__PURE__ */ F.default.mark(function W(V, b) {
          var A, k = this, T, $;
          return F.default.wrap(function(ve) {
            for (; ; )
              switch (ve.prev = ve.next) {
                case 0:
                  return ve.next = 2, this.myself._ensureFetched();
                case 2:
                  if (V != this.myself.identity) {
                    ve.next = 4;
                    break;
                  }
                  return ve.abrupt("return", this.myself);
                case 4:
                  if (T = this.subscribedUsers.get(V), !T) {
                    ve.next = 7;
                    break;
                  }
                  return ve.abrupt("return", T);
                case 7:
                  if (!((A = b) !== null && A !== void 0)) {
                    ve.next = 11;
                    break;
                  }
                  ve.next = 14;
                  break;
                case 11:
                  return ve.next = 13, this.getSyncUniqueName(V);
                case 13:
                  b = ve.sent;
                case 14:
                  return $ = new kr(V, b, this.configuration, this.services), $.on("updated", function(we) {
                    return k.emit("userUpdated", we);
                  }), $.on("userSubscribed", function() {
                    return k.handleSubscribeUser($);
                  }), $.on("userUnsubscribed", function() {
                    return k.handleUnsubscribeUser($);
                  }), ve.next = 20, $._ensureFetched();
                case 20:
                  return ve.abrupt("return", $);
                case 21:
                case "end":
                  return ve.stop();
              }
          }, W, this);
        }));
        function g(W, V) {
          return y.apply(this, arguments);
        }
        return g;
      }()
      /**
       * @returns {Promise<Array<User>>} returns list of subscribed User objects {@see User}
       */
    }, {
      key: "getSubscribedUsers",
      value: function() {
        var y = Z.default(/* @__PURE__ */ F.default.mark(function W() {
          var V;
          return F.default.wrap(function(A) {
            for (; ; )
              switch (A.prev = A.next) {
                case 0:
                  return A.next = 2, this.myself._ensureFetched();
                case 2:
                  return V = [this.myself], this.subscribedUsers.forEach(function(k) {
                    return V.push(k);
                  }), A.abrupt("return", V);
                case 5:
                case "end":
                  return A.stop();
              }
          }, W, this);
        }));
        function g() {
          return y.apply(this, arguments);
        }
        return g;
      }()
      /**
       * @returns {Promise<string>} User's sync unique name
       */
    }, {
      key: "getSyncUniqueName",
      value: function() {
        var y = Z.default(/* @__PURE__ */ F.default.mark(function W(V) {
          var b, A, k, T;
          return F.default.wrap(function(ee) {
            for (; ; )
              switch (ee.prev = ee.next) {
                case 0:
                  return k = new at(this.configuration.links.users).path(V).build(), ee.next = 3, this.services.network.get(k);
                case 3:
                  return T = ee.sent, ee.abrupt("return", (b = (A = T.body) === null || A === void 0 ? void 0 : A.sync_objects.user_info_map) !== null && b !== void 0 ? b : "");
                case 5:
                case "end":
                  return ee.stop();
              }
          }, W, this);
        }));
        function g(W) {
          return y.apply(this, arguments);
        }
        return g;
      }()
    }]), S;
  }(m.ReplayEventEmitter), Na = Ue.scope("TypingIndicator"), Y = /* @__PURE__ */ function() {
    function N(X, S, y) {
      M.default(this, N), this.configuration = S, this.services = y, this.getConversation = X, this.serviceTypingTimeout = null, this.sentUpdates = /* @__PURE__ */ new Map();
    }
    return ue.default(N, [{
      key: "typingTimeout",
      get: function() {
        return this.configuration.typingIndicatorTimeoutOverride || this.serviceTypingTimeout || this.configuration.typingIndicatorTimeoutDefault;
      }
      /**
       * Initialize TypingIndicator controller
       * Registers for needed message types and sets listeners
       * @private
       */
    }, {
      key: "initialize",
      value: function() {
        var S = this;
        this.services.notificationClient.on("message", /* @__PURE__ */ function() {
          var y = Z.default(/* @__PURE__ */ F.default.mark(function g(W, V) {
            return F.default.wrap(function(A) {
              for (; ; )
                switch (A.prev = A.next) {
                  case 0:
                    if (W !== qe.TYPING_INDICATOR) {
                      A.next = 3;
                      break;
                    }
                    return A.next = 3, S._handleRemoteTyping(V);
                  case 3:
                  case "end":
                    return A.stop();
                }
            }, g);
          }));
          return function(g, W) {
            return y.apply(this, arguments);
          };
        }());
      }
      /**
       * Remote participants typing events handler
       */
    }, {
      key: "_handleRemoteTyping",
      value: function() {
        var X = Z.default(/* @__PURE__ */ F.default.mark(function y(g) {
          var W = this;
          return F.default.wrap(function(b) {
            for (; ; )
              switch (b.prev = b.next) {
                case 0:
                  Na.trace("Got new typing indicator ", g), this.getConversation(g.channel_sid).then(function(A) {
                    A && A._participants.forEach(function(k) {
                      if (k.identity === g.identity) {
                        var T = W.configuration.typingIndicatorTimeoutOverride ? W.configuration.typingIndicatorTimeoutOverride + 1e3 : g.typing_timeout * 1e3;
                        k._startTyping(T);
                      }
                    });
                  }).catch(function(A) {
                    throw Na.error(A), A;
                  });
                case 2:
                case "end":
                  return b.stop();
              }
          }, y, this);
        }));
        function S(y) {
          return X.apply(this, arguments);
        }
        return S;
      }()
      /**
       * Send typing event for the given conversation sid
       * @param {String} conversationSid
       */
    }, {
      key: "send",
      value: function(S) {
        var y = this.sentUpdates.get(S);
        return y && y > Date.now() - this.typingTimeout ? Promise.resolve() : (this.sentUpdates.set(S, Date.now()), this._send(S));
      }
    }, {
      key: "_send",
      value: function(S) {
        var y = this;
        Na.trace("Sending typing indicator");
        var g = this.configuration.links.typing, W = {
          "Content-Type": "application/x-www-form-urlencoded"
        }, V = "ChannelSid=".concat(S);
        return this.services.twilsockClient.post(g, W, V, this.configuration.productId).then(function(b) {
          b.body.hasOwnProperty("typing_timeout") && (y.serviceTypingTimeout = b.body.typing_timeout * 1e3);
        }).catch(function(b) {
          throw Na.error("Failed to send typing indicator:", b), b;
        });
      }
    }]), N;
  }(), H = /* @__PURE__ */ ue.default(
    /**
     * Title of the notification.
     */
    /**
     * Text of the notification.
     */
    /**
     * Sound of the notification.
     */
    /**
     * Number of the badge.
     */
    /**
     * Notification action (`click_action` in FCM terms and `category` in APN terms).
     */
    /**
     * Type of the notification.
     */
    /**
     * Additional data of the conversation.
     */
    /**
     * @internal
     */
    function N(X) {
      M.default(this, N), this.title = X.title || null, this.body = X.body || null, this.sound = X.sound || null, this.badge = X.badge || null, this.action = X.action || null, this.type = X.type || null, this.data = X.data || {};
    }
  ), E = "2.4.1";
  function x(N, X) {
    var S = Object.keys(N);
    if (Object.getOwnPropertySymbols) {
      var y = Object.getOwnPropertySymbols(N);
      X && (y = y.filter(function(g) {
        return Object.getOwnPropertyDescriptor(N, g).enumerable;
      })), S.push.apply(S, y);
    }
    return S;
  }
  function U(N) {
    for (var X = 1; X < arguments.length; X++) {
      var S = arguments[X] != null ? arguments[X] : {};
      X % 2 ? x(Object(S), !0).forEach(function(y) {
        ye.default(N, y, S[y]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(N, Object.getOwnPropertyDescriptors(S)) : x(Object(S)).forEach(function(y) {
        Object.defineProperty(N, y, Object.getOwnPropertyDescriptor(S, y));
      });
    }
    return N;
  }
  function Q(N) {
    var X = D();
    return function() {
      var y = xe.default(N), g;
      if (X) {
        var W = xe.default(this).constructor;
        g = Reflect.construct(y, arguments, W);
      } else
        g = y.apply(this, arguments);
      return Ie.default(this, g);
    };
  }
  function D() {
    if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
      return !1;
    if (typeof Proxy == "function")
      return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      })), !0;
    } catch {
      return !1;
    }
  }
  var Fe = function(X) {
    return X.replace(/(^\/+|\/+$)/g, "");
  }, Se = function(X) {
    return X.status.code === 202;
  }, je = /* @__PURE__ */ function(N) {
    he.default(S, N);
    var X = Q(S);
    function S(y) {
      return M.default(this, S), X.call(this, y);
    }
    return ue.default(S);
  }(/* @__PURE__ */ Ze.default(Error)), _e = /* @__PURE__ */ function() {
    function N(X, S, y) {
      M.default(this, N), this._serviceUrl = X, this._services = S, this._productId = y;
    }
    return ue.default(N, [{
      key: "_preProcessUrl",
      value: function(S) {
        var y = Fe(S);
        return /^https?:\/\//.test(S) ? y : "".concat(Fe(this._serviceUrl), "/").concat(y);
      }
    }, {
      key: "_makeRequest",
      value: function() {
        var X = Z.default(/* @__PURE__ */ F.default.mark(function y(g, W, V, b) {
          var A, k, T, $;
          return F.default.wrap(function(ve) {
            for (; ; )
              switch (ve.prev = ve.next) {
                case 0:
                  A = this._preProcessUrl(W), k = U({
                    "Content-Type": "application/json; charset=utf-8"
                  }, b || {}), ve.t0 = g, ve.next = ve.t0 === "get" ? 5 : ve.t0 === "post" ? 11 : ve.t0 === "delete" ? 15 : 19;
                  break;
                case 5:
                  return $ = A, V && ($ += "?" + Object.entries(V).map(function(we) {
                    return we.map(encodeURIComponent).join("=");
                  }).join("&")), ve.next = 9, this._services.transport.get($, k, this._productId);
                case 9:
                  return T = ve.sent, ve.abrupt("break", 19);
                case 11:
                  return ve.next = 13, this._services.transport.post(A, k, JSON.stringify(V), this._productId);
                case 13:
                  return T = ve.sent, ve.abrupt("break", 19);
                case 15:
                  return ve.next = 17, this._services.transport.delete(A, k, {}, this._productId);
                case 17:
                  return T = ve.sent, ve.abrupt("break", 19);
                case 19:
                  if (!(T.status.code < 200 || T.status.code >= 300)) {
                    ve.next = 21;
                    break;
                  }
                  throw new Error("Request responded with a non-success code ".concat(T.status.code));
                case 21:
                  return ve.abrupt("return", T);
                case 22:
                case "end":
                  return ve.stop();
              }
          }, y, this);
        }));
        function S(y, g, W, V) {
          return X.apply(this, arguments);
        }
        return S;
      }()
    }, {
      key: "fetchResource",
      value: function() {
        var X = Z.default(/* @__PURE__ */ F.default.mark(function y(g, W) {
          var V = this, b, A, k;
          return F.default.wrap(function($) {
            for (; ; )
              switch ($.prev = $.next) {
                case 0:
                  return b = 6, A = new O.AsyncRetrier({
                    min: 50,
                    max: 1600,
                    maxAttemptsCount: b
                  }), $.prev = 2, $.next = 5, A.run(/* @__PURE__ */ Z.default(/* @__PURE__ */ F.default.mark(function ee() {
                    var ve, we, gt;
                    return F.default.wrap(function(Et) {
                      for (; ; )
                        switch (Et.prev = Et.next) {
                          case 0:
                            return Et.prev = 0, Et.next = 3, V._makeRequest("get", g, W);
                          case 3:
                            return ve = Et.sent, Et.abrupt("return", {
                              type: "success",
                              data: ve.body
                            });
                          case 7:
                            if (Et.prev = 7, Et.t0 = Et.catch(0), !((Et.t0 === null || Et.t0 === void 0 || (we = Et.t0.body) === null || we === void 0 ? void 0 : we.status) === 404 && (Et.t0 === null || Et.t0 === void 0 || (gt = Et.t0.body) === null || gt === void 0 ? void 0 : gt.code) === 50530)) {
                              Et.next = 11;
                              break;
                            }
                            return Et.abrupt("return", {
                              type: "noMetadata"
                            });
                          case 11:
                            throw Et.t0;
                          case 12:
                          case "end":
                            return Et.stop();
                        }
                    }, ee, null, [[0, 7]]);
                  })));
                case 5:
                  k = $.sent, $.next = 11;
                  break;
                case 8:
                  throw $.prev = 8, $.t0 = $.catch(2), new Error('Fetch resource from "'.concat(g, '" failed.'));
                case 11:
                  if (k.type !== "noMetadata") {
                    $.next = 13;
                    break;
                  }
                  throw new je("No metadata found.");
                case 13:
                  return $.abrupt("return", k.data);
                case 14:
                case "end":
                  return $.stop();
              }
          }, y, null, [[2, 8]]);
        }));
        function S(y, g) {
          return X.apply(this, arguments);
        }
        return S;
      }()
    }, {
      key: "mutateResource",
      value: function() {
        var X = Z.default(/* @__PURE__ */ F.default.mark(function y(g, W, V) {
          var b;
          return F.default.wrap(function(k) {
            for (; ; )
              switch (k.prev = k.next) {
                case 0:
                  return k.next = 2, this._makeRequest(g, W, V, {
                    "X-Twilio-Mutation-Id": L.v4()
                  });
                case 2:
                  if (b = k.sent, !Se(b)) {
                    k.next = 7;
                    break;
                  }
                  return k.next = 6, this.fetchResource(b.body.resource_url);
                case 6:
                  return k.abrupt("return", k.sent);
                case 7:
                  return k.abrupt("return", b.body);
                case 8:
                case "end":
                  return k.stop();
              }
          }, y, this);
        }));
        function S(y, g, W) {
          return X.apply(this, arguments);
        }
        return S;
      }()
    }]), N;
  }(), bt = /* @__PURE__ */ function() {
    function N(X) {
      var S = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 100, y = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 5e3;
      M.default(this, N), ye.default(this, "_cachedTemplates", null), this._services = X, this._pageSize = S, this._cacheTtlMs = y;
    }
    return ue.default(N, [{
      key: "getContentTemplates",
      value: function() {
        var X = Z.default(/* @__PURE__ */ F.default.mark(function y() {
          var g = this, W, V, b, A, k, T, $;
          return F.default.wrap(function(ve) {
            for (; ; )
              switch (ve.prev = ve.next) {
                case 0:
                  if (this._cachedTemplates === null) {
                    ve.next = 2;
                    break;
                  }
                  return ve.abrupt("return", this._cachedTemplates);
                case 2:
                  return ve.next = 4, this._fetchContentTemplates();
                case 4:
                  W = ve.sent, V = z.default(W, 2), b = V[0], A = V[1], k = b;
                case 9:
                  if (A === null) {
                    ve.next = 19;
                    break;
                  }
                  return ve.next = 12, this._fetchContentTemplates(A);
                case 12:
                  T = ve.sent, $ = z.default(T, 2), b = $[0], A = $[1], k = [].concat(ce.default(k), ce.default(b)), ve.next = 9;
                  break;
                case 19:
                  return this._cachedTemplates = Object.freeze(k), setTimeout(function() {
                    g._cachedTemplates = null;
                  }, this._cacheTtlMs), ve.abrupt("return", k);
                case 22:
                case "end":
                  return ve.stop();
              }
          }, y, this);
        }));
        function S() {
          return X.apply(this, arguments);
        }
        return S;
      }()
    }, {
      key: "_fetchContentTemplates",
      value: function() {
        var X = Z.default(/* @__PURE__ */ F.default.mark(function y(g) {
          var W, V, b;
          return F.default.wrap(function(k) {
            for (; ; )
              switch (k.prev = k.next) {
                case 0:
                  return W = "Client/v2/ContentTemplates", V = new at(W), V.arg("PageSize", this._pageSize), g !== void 0 && V.arg("PageToken", g), k.next = 6, this._services.commandExecutor.fetchResource(V.build());
                case 6:
                  return b = k.sent, k.abrupt("return", [b.templates.map(function(T) {
                    return new G(T);
                  }), b.meta.next_token]);
                case 8:
                case "end":
                  return k.stop();
              }
          }, y, this);
        }));
        function S(y) {
          return X.apply(this, arguments);
        }
        return S;
      }()
    }]), N;
  }();
  function Ir(N, X) {
    var S = typeof Symbol < "u" && N[Symbol.iterator] || N["@@iterator"];
    if (!S) {
      if (Array.isArray(N) || (S = gi(N)) || X && N && typeof N.length == "number") {
        S && (N = S);
        var y = 0, g = function() {
        };
        return { s: g, n: function() {
          return y >= N.length ? { done: !0 } : { done: !1, value: N[y++] };
        }, e: function(k) {
          throw k;
        }, f: g };
      }
      throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
    }
    var W = !0, V = !1, b;
    return { s: function() {
      S = S.call(N);
    }, n: function() {
      var k = S.next();
      return W = k.done, k;
    }, e: function(k) {
      V = !0, b = k;
    }, f: function() {
      try {
        !W && S.return != null && S.return();
      } finally {
        if (V)
          throw b;
      }
    } };
  }
  function gi(N, X) {
    if (N) {
      if (typeof N == "string")
        return ln(N, X);
      var S = Object.prototype.toString.call(N).slice(8, -1);
      if (S === "Object" && N.constructor && (S = N.constructor.name), S === "Map" || S === "Set")
        return Array.from(N);
      if (S === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(S))
        return ln(N, X);
    }
  }
  function ln(N, X) {
    (X == null || X > N.length) && (X = N.length);
    for (var S = 0, y = new Array(X); S < X; S++)
      y[S] = N[S];
    return y;
  }
  var yi = /* @__PURE__ */ function(N) {
    function X() {
      var S = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
      if (M.default(this, X), !(S.maxSize && S.maxSize > 0))
        throw new TypeError("`maxSize` must be a number greater than 0");
      this.maxSize = S.maxSize, this.onEviction = S.onEviction, this.cache = /* @__PURE__ */ new Map(), this.oldCache = /* @__PURE__ */ new Map(), this._size = 0;
    }
    return ue.default(X, [{
      key: "_set",
      value: function(y, g) {
        if (this.cache.set(y, g), this._size++, this._size >= this.maxSize) {
          if (this._size = 0, typeof this.onEviction == "function") {
            var W = Ir(this.oldCache.entries()), V;
            try {
              for (W.s(); !(V = W.n()).done; ) {
                var b = z.default(V.value, 2), A = b[0], k = b[1];
                this.onEviction(A, k);
              }
            } catch (T) {
              W.e(T);
            } finally {
              W.f();
            }
          }
          this.oldCache = this.cache, this.cache = /* @__PURE__ */ new Map();
        }
      }
    }, {
      key: "get",
      value: function(y) {
        if (this.cache.has(y))
          return this.cache.get(y);
        if (this.oldCache.has(y)) {
          var g = this.oldCache.get(y);
          return this.oldCache.delete(y), this._set(y, g), g;
        }
      }
    }, {
      key: "set",
      value: function(y, g) {
        return this.cache.has(y) ? this.cache.set(y, g) : this._set(y, g), this;
      }
    }, {
      key: "has",
      value: function(y) {
        return this.cache.has(y) || this.oldCache.has(y);
      }
    }, {
      key: "peek",
      value: function(y) {
        if (this.cache.has(y))
          return this.cache.get(y);
        if (this.oldCache.has(y))
          return this.oldCache.get(y);
      }
    }, {
      key: "delete",
      value: function(y) {
        var g = this.cache.delete(y);
        return g && this._size--, this.oldCache.delete(y) || g;
      }
    }, {
      key: "clear",
      value: function() {
        this.cache.clear(), this.oldCache.clear(), this._size = 0;
      }
    }, {
      key: "keys",
      value: /* @__PURE__ */ F.default.mark(function S() {
        var y, g, W, V;
        return F.default.wrap(function(A) {
          for (; ; )
            switch (A.prev = A.next) {
              case 0:
                y = Ir(this), A.prev = 1, y.s();
              case 3:
                if ((g = y.n()).done) {
                  A.next = 9;
                  break;
                }
                return W = z.default(g.value, 1), V = W[0], A.next = 7, V;
              case 7:
                A.next = 3;
                break;
              case 9:
                A.next = 14;
                break;
              case 11:
                A.prev = 11, A.t0 = A.catch(1), y.e(A.t0);
              case 14:
                return A.prev = 14, y.f(), A.finish(14);
              case 17:
              case "end":
                return A.stop();
            }
        }, S, this, [[1, 11, 14, 17]]);
      })
    }, {
      key: "values",
      value: /* @__PURE__ */ F.default.mark(function S() {
        var y, g, W, V;
        return F.default.wrap(function(A) {
          for (; ; )
            switch (A.prev = A.next) {
              case 0:
                y = Ir(this), A.prev = 1, y.s();
              case 3:
                if ((g = y.n()).done) {
                  A.next = 9;
                  break;
                }
                return W = z.default(g.value, 2), V = W[1], A.next = 7, V;
              case 7:
                A.next = 3;
                break;
              case 9:
                A.next = 14;
                break;
              case 11:
                A.prev = 11, A.t0 = A.catch(1), y.e(A.t0);
              case 14:
                return A.prev = 14, y.f(), A.finish(14);
              case 17:
              case "end":
                return A.stop();
            }
        }, S, this, [[1, 11, 14, 17]]);
      })
    }, {
      key: N,
      value: /* @__PURE__ */ F.default.mark(function S() {
        var y, g, W, V, b, A, k, T;
        return F.default.wrap(function(ee) {
          for (; ; )
            switch (ee.prev = ee.next) {
              case 0:
                y = Ir(this.cache), ee.prev = 1, y.s();
              case 3:
                if ((g = y.n()).done) {
                  ee.next = 9;
                  break;
                }
                return W = g.value, ee.next = 7, W;
              case 7:
                ee.next = 3;
                break;
              case 9:
                ee.next = 14;
                break;
              case 11:
                ee.prev = 11, ee.t0 = ee.catch(1), y.e(ee.t0);
              case 14:
                return ee.prev = 14, y.f(), ee.finish(14);
              case 17:
                V = Ir(this.oldCache), ee.prev = 18, V.s();
              case 20:
                if ((b = V.n()).done) {
                  ee.next = 28;
                  break;
                }
                if (A = b.value, k = z.default(A, 1), T = k[0], this.cache.has(T)) {
                  ee.next = 26;
                  break;
                }
                return ee.next = 26, A;
              case 26:
                ee.next = 20;
                break;
              case 28:
                ee.next = 33;
                break;
              case 30:
                ee.prev = 30, ee.t1 = ee.catch(18), V.e(ee.t1);
              case 33:
                return ee.prev = 33, V.f(), ee.finish(33);
              case 36:
              case "end":
                return ee.stop();
            }
        }, S, this, [[1, 11, 14, 17], [18, 30, 33, 36]]);
      })
    }, {
      key: "size",
      get: function() {
        var y = 0, g = Ir(this.oldCache.keys()), W;
        try {
          for (g.s(); !(W = g.n()).done; ) {
            var V = W.value;
            this.cache.has(V) || y++;
          }
        } catch (b) {
          g.e(b);
        } finally {
          g.f();
        }
        return Math.min(this._size + y, this.maxSize);
      }
    }]), X;
  }(Symbol.iterator), Wv = yi, Hl = /* @__PURE__ */ ue.default(
    /**
     * Communication channel type.
     */
    /**
     * The actual metadata.
     */
    /**
     * @internal
     */
    function N(X, S) {
      M.default(this, N), this.type = X, this.data = S, Object.freeze(S);
    }
  ), J = /* @__PURE__ */ function() {
    function N(X, S) {
      M.default(this, N), this._services = X, this._configuration = S, this._cache = new Wv({
        maxSize: S.channelMetadataCacheCapacity
      });
    }
    return ue.default(N, [{
      key: "getChannelMetadata",
      value: function() {
        var X = Z.default(/* @__PURE__ */ F.default.mark(function y(g, W) {
          var V, b, A, k, T;
          return F.default.wrap(function(ee) {
            for (; ; )
              switch (ee.prev = ee.next) {
                case 0:
                  if (V = "".concat(g, ",").concat(W), b = this._cache.get(V), !b) {
                    ee.next = 4;
                    break;
                  }
                  return ee.abrupt("return", b.item);
                case 4:
                  return A = "".concat(this._configuration.links.conversations, "/").concat(g, "/Messages/").concat(W, "/ChannelMetadata"), ee.prev = 5, ee.next = 8, this._services.commandExecutor.fetchResource(A);
                case 8:
                  k = ee.sent, ee.next = 17;
                  break;
                case 11:
                  if (ee.prev = 11, ee.t0 = ee.catch(5), !(ee.t0 instanceof je)) {
                    ee.next = 16;
                    break;
                  }
                  return this._cache.set(V, {
                    item: null
                  }), ee.abrupt("return", null);
                case 16:
                  throw new Error(ee.t0);
                case 17:
                  return T = new Hl(k.type, k.data), this._cache.set(V, {
                    item: T
                  }), ee.abrupt("return", T);
                case 20:
                case "end":
                  return ee.stop();
              }
          }, y, this, [[5, 11]]);
        }));
        function S(y, g) {
          return X.apply(this, arguments);
        }
        return S;
      }()
    }]), N;
  }(), ie;
  function Be(N, X) {
    var S = Object.keys(N);
    if (Object.getOwnPropertySymbols) {
      var y = Object.getOwnPropertySymbols(N);
      X && (y = y.filter(function(g) {
        return Object.getOwnPropertyDescriptor(N, g).enumerable;
      })), S.push.apply(S, y);
    }
    return S;
  }
  function ot(N) {
    for (var X = 1; X < arguments.length; X++) {
      var S = arguments[X] != null ? arguments[X] : {};
      X % 2 ? Be(Object(S), !0).forEach(function(y) {
        ye.default(N, y, S[y]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(N, Object.getOwnPropertyDescriptors(S)) : Be(Object(S)).forEach(function(y) {
        Object.defineProperty(N, y, Object.getOwnPropertyDescriptor(S, y));
      });
    }
    return N;
  }
  function mr(N) {
    var X = Tt();
    return function() {
      var y = xe.default(N), g;
      if (X) {
        var W = xe.default(this).constructor;
        g = Reflect.construct(y, arguments, W);
      } else
        g = y.apply(this, arguments);
      return Ie.default(this, g);
    };
  }
  function Tt() {
    if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
      return !1;
    if (typeof Proxy == "function")
      return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      })), !0;
    } catch {
      return !1;
    }
  }
  var Rt, Zr = /* @__PURE__ */ ue.default(function N() {
    M.default(this, N);
  });
  e.Client = Rt = (ie = /* @__PURE__ */ function(N) {
    he.default(S, N);
    var X = mr(S);
    function S(y) {
      var g, W, V, b, A, k, T = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      if (M.default(this, S), k = X.call(this), ye.default(le.default(k), "version", E), ye.default(le.default(k), "connectionState", "unknown"), ye.default(le.default(k), "parsePushNotification", Rt.parsePushNotification), k._fpaToken = y ?? "", k._options = T ?? {}, !k._options.disableDeepClone) {
        var $ = ot(ot({}, k._options), {}, {
          transport: void 0,
          twilsockClient: void 0
        });
        $ = $e($), $.transport = k._options.transport, $.twilsockClient = k._options.twilsockClient, k._options = $;
      }
      k._options.logLevel = (g = k._options.logLevel) !== null && g !== void 0 ? g : "silent", Rt._logger.setLevel(k._options.logLevel);
      var ee = k._options.productId = "ip_messaging";
      if (k._options.clientMetadata = k._options.clientMetadata || {}, k._options.clientMetadata.hasOwnProperty("type") || (k._options.clientMetadata.type = "conversations"), k._options.clientMetadata.hasOwnProperty("sdk") || (k._options.clientMetadata.sdk = "JS", k._options.clientMetadata.sdkv = E), k._options.Sync = k._options.Sync || {}, typeof k._options.Sync.enableSessionStorage > "u" && (k._options.Sync.enableSessionStorage = !0), k._options.region && (k._options.Sync.region = k._options.region), !y)
        throw new Error("A valid Twilio token should be provided");
      k._services = new Zr(), k._myself = new kr("", "", null, k._services);
      var ve = !k._options.twilsockClient;
      if (!k._options.initRegistrations) {
        var we = new C.InitRegistration(ee);
        Rt.populateInitRegistrations(we), k._options.initRegistrations = [we];
      }
      k._services.twilsockClient = k._options.twilsockClient = (W = k._options.twilsockClient) !== null && W !== void 0 ? W : new C.TwilsockClient(y, ee, k._options), k._services.twilsockClient.on("tokenAboutToExpire", function() {
        return k.emit("tokenAboutToExpire");
      }), k._services.twilsockClient.on("tokenExpired", function() {
        return k.emit("tokenExpired");
      }), k._services.twilsockClient.on("connectionError", function(Mr) {
        return k.emit("connectionError", Mr);
      }), k._services.twilsockClient.on("stateChanged", function(Mr) {
        Rt._logger.debug("Handling stateChanged for ConversationsClient: new state ".concat(Mr)), Mr !== k.connectionState && (k.connectionState = Mr, k.emit("connectionStateChanged", k.connectionState));
      }), k._services.transport = k._options.transport = (V = k._options.transport) !== null && V !== void 0 ? V : k._options.twilsockClient, k._services.notificationClient = k._options.notificationsClient = (b = k._options.notificationsClient) !== null && b !== void 0 ? b : new R.Notifications(y, k._options), k._services.syncClient = k._options.syncClient = (A = k._options.syncClient) !== null && A !== void 0 ? A : new I.SyncClient(y, k._options);
      var gt = (T == null ? void 0 : T.Chat) || (T == null ? void 0 : T.IPMessaging) || T || {}, At = gt.region || (T == null ? void 0 : T.region), Et = gt.apiUri || gt.typingUri || "https://aim.".concat(At || "us1", ".twilio.com");
      k._services.commandExecutor = new _e(Et, {
        transport: k._options.transport
      }, ee), k._services.contentClient = new bt(k._services);
      var Nt = function(Ut) {
        k._rejectEnsureReady(Ut), k.emit("stateChanged", "failed"), k.emit("initFailed", {
          error: Ut
        });
      }, nn = function() {
        Nt({
          terminal: !0,
          message: "Twilsock has disconnected."
        });
      };
      return k._services.twilsockClient.once("connectionError", Nt), k._services.twilsockClient.once("disconnected", nn), k._services.twilsockClient.once("connected", /* @__PURE__ */ Z.default(/* @__PURE__ */ F.default.mark(function Mr() {
        var Ut, Ui;
        return F.default.wrap(function(wt) {
          for (; ; )
            switch (wt.prev = wt.next) {
              case 0:
                return Rt._logger.debug("ConversationsClient started INITIALIZING"), k._services.twilsockClient.off("connectionError", Nt), k._services.twilsockClient.off("disconnected", nn), wt.prev = 3, Ut = "conversations.client.startup", k._services.twilsockClient.addPartialTelemetryEvent(new C.TelemetryEventDescription(Ut, "Conversations client startup", /* @__PURE__ */ new Date()), Ut, C.TelemetryPoint.Start), wt.next = 8, k._initialize();
              case 8:
                k._services.twilsockClient.addPartialTelemetryEvent(new C.TelemetryEventDescription("", "", /* @__PURE__ */ new Date()), Ut, C.TelemetryPoint.End), wt.next = 17;
                break;
              case 11:
                wt.prev = 11, wt.t0 = wt.catch(3), Ui = {
                  terminal: !0,
                  message: wt.t0.message
                }, k._rejectEnsureReady(Ui), k.emit("stateChanged", "failed"), k.emit("initFailed", {
                  error: Ui
                });
              case 17:
              case "end":
                return wt.stop();
            }
        }, Mr, null, [[3, 11]]);
      }))), k._ensureReady = new Promise(function(Mr, Ut) {
        k._resolveEnsureReady = Mr, k._rejectEnsureReady = Ut;
      }).catch(function() {
      }), ve && k._services.twilsockClient.connect(), k;
    }
    return ue.default(S, [{
      key: "user",
      get: function() {
        return this._myself;
      }
      /**
       * Client reachability state. Throws an error if accessed before the client
       * initialization was completed.
       */
    }, {
      key: "reachabilityEnabled",
      get: function() {
        if (!this._configuration)
          throw new Error("Reachability information could not yet be accessed as the client has not yet been initialized. Subscribe to the 'stateChanged' event to properly react to the client initialization.");
        return this._configuration.reachabilityEnabled;
      }
      /**
       * @deprecated
       * Current token.
       * @internal
       */
    }, {
      key: "token",
      get: function() {
        return this._fpaToken;
      }
      /**
       * @deprecated Call constructor directly.
       *
       * Factory method to create a Conversations client instance.
       *
       * The factory method will automatically trigger connection.
       * Do not use it if you need finer-grained control.
       *
       * Since this method returns an already-initialized client, some of the events
       * will be lost because they happen *before* the initialization. It is
       * recommended that `client.onWithReplay` is used as opposed to `client.on`
       * for subscribing to client events. The `client.onWithReplay` will re-emit
       * the most recent value for a given event if it emitted before the
       * subscription.
       *
       * @param token Access token.
       * @param options Options to customize the client.
       * @returns Returns a fully initialized client.
       */
    }, {
      key: "shutdown",
      value: (
        /**
         * Gracefully shut down the client.
         */
        function() {
          var y = Z.default(/* @__PURE__ */ F.default.mark(function W() {
            return F.default.wrap(function(b) {
              for (; ; )
                switch (b.prev = b.next) {
                  case 0:
                    return b.next = 2, this._ensureReady;
                  case 2:
                    return b.next = 4, this._services.twilsockClient.disconnect();
                  case 4:
                  case "end":
                    return b.stop();
                }
            }, W, this);
          }));
          function g() {
            return y.apply(this, arguments);
          }
          return g;
        }()
      )
      /**
       * Update the token used by the client and re-register with the Conversations services.
       * @param token New access token.
       */
    }, {
      key: "updateToken",
      value: function() {
        var y = Z.default(/* @__PURE__ */ F.default.mark(function W(V) {
          return F.default.wrap(function(A) {
            for (; ; )
              switch (A.prev = A.next) {
                case 0:
                  return A.next = 2, this._ensureReady;
                case 2:
                  if (Rt._logger.info("updateToken"), this._fpaToken !== V) {
                    A.next = 5;
                    break;
                  }
                  return A.abrupt("return", this);
                case 5:
                  return A.next = 7, this._services.twilsockClient.updateToken(V);
                case 7:
                  return A.next = 9, this._services.notificationClient.updateToken(V);
                case 9:
                  return A.next = 11, this._services.mcsClient.updateToken(V);
                case 11:
                  return this._fpaToken = V, A.abrupt("return", this);
                case 13:
                case "end":
                  return A.stop();
              }
          }, W, this);
        }));
        function g(W) {
          return y.apply(this, arguments);
        }
        return g;
      }()
      /**
       * Get a known conversation by its SID.
       * @param conversationSid Conversation sid
       */
    }, {
      key: "getConversationBySid",
      value: function() {
        var y = Z.default(/* @__PURE__ */ F.default.mark(function W(V) {
          var b;
          return F.default.wrap(function(k) {
            for (; ; )
              switch (k.prev = k.next) {
                case 0:
                  return k.next = 2, this._ensureReady;
                case 2:
                  return k.next = 4, this._conversationsEntity.myConversationsRead.promise;
                case 4:
                  return k.next = 6, this._conversationsEntity.getConversation(V);
                case 6:
                  if (b = k.sent, b) {
                    k.next = 12;
                    break;
                  }
                  return k.next = 10, this.peekConversationBySid(V);
                case 10:
                  b = k.sent, b && K.deprecationWarning("The method getConversationBySid is deprecated to retrieve conversations you're not part of. Use peekConversationBySid instead.");
                case 12:
                  if (b) {
                    k.next = 14;
                    break;
                  }
                  throw new Error("Conversation with SID ".concat(V, " was not found."));
                case 14:
                  return k.abrupt("return", b);
                case 15:
                case "end":
                  return k.stop();
              }
          }, W, this);
        }));
        function g(W) {
          return y.apply(this, arguments);
        }
        return g;
      }()
      /**
       * Peek a conversation by its SID.
       * @param conversationSid Conversation sid
       * @internal
       */
    }, {
      key: "peekConversationBySid",
      value: function() {
        var y = Z.default(/* @__PURE__ */ F.default.mark(function W(V) {
          var b;
          return F.default.wrap(function(k) {
            for (; ; )
              switch (k.prev = k.next) {
                case 0:
                  return k.next = 2, this._ensureReady;
                case 2:
                  return k.next = 4, this._conversationsEntity.peekConversation(V);
                case 4:
                  if (b = k.sent, b) {
                    k.next = 7;
                    break;
                  }
                  throw new Error("Conversation with SID ".concat(V, " was not found."));
                case 7:
                  return k.abrupt("return", b);
                case 8:
                case "end":
                  return k.stop();
              }
          }, W, this);
        }));
        function g(W) {
          return y.apply(this, arguments);
        }
        return g;
      }()
      /**
       * Get a known conversation by its unique identifier name.
       * @param uniqueName The unique identifier name of the conversation.
       */
    }, {
      key: "getConversationByUniqueName",
      value: function() {
        var y = Z.default(/* @__PURE__ */ F.default.mark(function W(V) {
          var b;
          return F.default.wrap(function(k) {
            for (; ; )
              switch (k.prev = k.next) {
                case 0:
                  return k.next = 2, this._ensureReady;
                case 2:
                  return k.next = 4, this._conversationsEntity.myConversationsRead.promise;
                case 4:
                  return k.next = 6, this._conversationsEntity.getConversationByUniqueName(V);
                case 6:
                  if (b = k.sent, b) {
                    k.next = 9;
                    break;
                  }
                  throw new Error("Conversation with unique name ".concat(V, " was not found."));
                case 9:
                  return k.abrupt("return", b);
                case 10:
                case "end":
                  return k.stop();
              }
          }, W, this);
        }));
        function g(W) {
          return y.apply(this, arguments);
        }
        return g;
      }()
      /**
       * Get the current list of all the subscribed conversations.
       */
    }, {
      key: "getSubscribedConversations",
      value: function() {
        var y = Z.default(/* @__PURE__ */ F.default.mark(function W() {
          return F.default.wrap(function(b) {
            for (; ; )
              switch (b.prev = b.next) {
                case 0:
                  return b.next = 2, this._ensureReady;
                case 2:
                  return b.abrupt("return", this._conversationsPromise.then(function(A) {
                    return A.getConversations();
                  }));
                case 3:
                case "end":
                  return b.stop();
              }
          }, W, this);
        }));
        function g() {
          return y.apply(this, arguments);
        }
        return g;
      }()
      /**
       * Create a conversation on the server and subscribe to its events.
       * The default is a conversation with an empty friendly name.
       * @param options Options for the conversation.
       */
    }, {
      key: "createConversation",
      value: function() {
        var y = Z.default(/* @__PURE__ */ F.default.mark(function W(V) {
          return F.default.wrap(function(A) {
            for (; ; )
              switch (A.prev = A.next) {
                case 0:
                  return A.next = 2, this._ensureReady;
                case 2:
                  return V = V || {}, A.abrupt("return", this._conversationsPromise.then(function(k) {
                    return k.addConversation(V);
                  }));
                case 4:
                case "end":
                  return A.stop();
              }
          }, W, this);
        }));
        function g(W) {
          return y.apply(this, arguments);
        }
        return g;
      }()
      /**
       * Register for push notifications.
       * @param channelType Channel type.
       * @param registrationId Push notification ID provided by the FCM/APNS service
       * on the platform.
       */
    }, {
      key: "setPushRegistrationId",
      value: function() {
        var y = Z.default(/* @__PURE__ */ F.default.mark(function W(V, b) {
          return F.default.wrap(function(k) {
            for (; ; )
              switch (k.prev = k.next) {
                case 0:
                  return k.next = 2, this._ensureReady;
                case 2:
                  return this._subscribeToPushNotifications(V), this._services.notificationClient.setPushRegistrationId(V, b), k.next = 6, this._services.notificationClient.commitChanges();
                case 6:
                case "end":
                  return k.stop();
              }
          }, W, this);
        }));
        function g(W, V) {
          return y.apply(this, arguments);
        }
        return g;
      }()
      /**
       * Unregister from push notifications.
       * @param channelType Channel type.
       * @deprecated Use removePushRegistrations() instead.
       */
    }, {
      key: "unsetPushRegistrationId",
      value: function() {
        var y = Z.default(/* @__PURE__ */ F.default.mark(function W(V) {
          return F.default.wrap(function(A) {
            for (; ; )
              switch (A.prev = A.next) {
                case 0:
                  return A.next = 2, this._ensureReady;
                case 2:
                  return this._unsubscribeFromPushNotifications(V), A.next = 5, this._services.notificationClient.commitChanges();
                case 5:
                case "end":
                  return A.stop();
              }
          }, W, this);
        }));
        function g(W) {
          return y.apply(this, arguments);
        }
        return g;
      }()
      /**
       * Clear existing registrations directly using provided device token.
       * This is useful to ensure stopped subscriptions without resubscribing.
       *
       * This function goes completely beside the state machine and removes all
       * registrations.
       * Use with caution: if it races with current state machine operations,
       * madness will ensue.
       *
       * @param channelType Channel type.
       * @param registrationId Push notification ID provided by the FCM/APNS service
       * on the platform.
       */
    }, {
      key: "removePushRegistrations",
      value: function() {
        var y = Z.default(/* @__PURE__ */ F.default.mark(function W(V, b) {
          return F.default.wrap(function(k) {
            for (; ; )
              switch (k.prev = k.next) {
                case 0:
                  return k.next = 2, this._services.notificationClient.removeRegistrations(V, b);
                case 2:
                case "end":
                  return k.stop();
              }
          }, W, this);
        }));
        function g(W, V) {
          return y.apply(this, arguments);
        }
        return g;
      }()
      /**
       * Current version of the Conversations client.
       */
    }, {
      key: "handlePushNotification",
      value: (
        /**
         * Handle push notification payload parsing and emit the
         * {@link Client.pushNotification} event on this {@link Client} instance.
         * @param notificationPayload Push notification payload
         */
        function() {
          var y = Z.default(/* @__PURE__ */ F.default.mark(function W(V) {
            return F.default.wrap(function(A) {
              for (; ; )
                switch (A.prev = A.next) {
                  case 0:
                    return A.next = 2, this._ensureReady;
                  case 2:
                    Rt._logger.debug("handlePushNotification, notificationPayload=", V), this.emit("pushNotification", Rt.parsePushNotification(V));
                  case 4:
                  case "end":
                    return A.stop();
                }
            }, W, this);
          }));
          function g(W) {
            return y.apply(this, arguments);
          }
          return g;
        }()
      )
      /**
       * Gets a user with the given identity. If it's in the subscribed list, then
       * return the user object from it;
       * if not, then subscribe and add user to the subscribed list.
       * @param identity Identity of the user.
       * @returns A fully initialized user.
       */
    }, {
      key: "getUser",
      value: function() {
        var y = Z.default(/* @__PURE__ */ F.default.mark(function W(V) {
          return F.default.wrap(function(A) {
            for (; ; )
              switch (A.prev = A.next) {
                case 0:
                  return A.next = 2, this._ensureReady;
                case 2:
                  return A.abrupt("return", this._services.users.getUser(V));
                case 3:
                case "end":
                  return A.stop();
              }
          }, W, this);
        }));
        function g(W) {
          return y.apply(this, arguments);
        }
        return g;
      }()
      /**
       * Get a list of subscribed user objects.
       */
    }, {
      key: "getSubscribedUsers",
      value: function() {
        var y = Z.default(/* @__PURE__ */ F.default.mark(function W() {
          return F.default.wrap(function(b) {
            for (; ; )
              switch (b.prev = b.next) {
                case 0:
                  return b.next = 2, this._ensureReady;
                case 2:
                  return b.abrupt("return", this._services.users.getSubscribedUsers());
                case 3:
                case "end":
                  return b.stop();
              }
          }, W, this);
        }));
        function g() {
          return y.apply(this, arguments);
        }
        return g;
      }()
      /**
       * Get content URLs for all media attachments in the given set of media sids
       * using a single operation.
       * @param mediaSids Set of media sids to query for the content URL.
       */
    }, {
      key: "getTemporaryContentUrlsForMediaSids",
      value: function(g) {
        var W = this;
        return new P.CancellablePromise(/* @__PURE__ */ function() {
          var V = Z.default(/* @__PURE__ */ F.default.mark(function b(A, k, T) {
            var $, ee;
            return F.default.wrap(function(we) {
              for (; ; )
                switch (we.prev = we.next) {
                  case 0:
                    if (!(!W._services.mcsClient || !g)) {
                      we.next = 3;
                      break;
                    }
                    return k(new Error("Media Content Service is unavailable")), we.abrupt("return");
                  case 3:
                    return $ = W._services.mcsClient.mediaSetGetContentUrls(g), T(function() {
                      $.cancel();
                    }), we.prev = 5, we.next = 8, $;
                  case 8:
                    ee = we.sent, A(ee), we.next = 15;
                    break;
                  case 12:
                    we.prev = 12, we.t0 = we.catch(5), k(we.t0);
                  case 15:
                  case "end":
                    return we.stop();
                }
            }, b, null, [[5, 12]]);
          }));
          return function(b, A, k) {
            return V.apply(this, arguments);
          };
        }());
      }
      /**
       * Get content URLs for all media attachments in the given set using a single
       * operation.
       * @param contentSet Set of media attachments to query content URLs.
       */
    }, {
      key: "getTemporaryContentUrlsForMedia",
      value: function(g) {
        var W = g.map(function(V) {
          return V.sid;
        });
        return this.getTemporaryContentUrlsForMediaSids(W);
      }
      /**
       * Returns rich content templates belonging to the account. Rich content
       * templates can be created via the Twilio console or the REST API.
       */
    }, {
      key: "getContentTemplates",
      value: function() {
        var y = Z.default(/* @__PURE__ */ F.default.mark(function W() {
          return F.default.wrap(function(b) {
            for (; ; )
              switch (b.prev = b.next) {
                case 0:
                  return b.next = 2, this._ensureReady;
                case 2:
                  return b.next = 4, this._services.contentClient.getContentTemplates();
                case 4:
                  return b.abrupt("return", b.sent);
                case 5:
                case "end":
                  return b.stop();
              }
          }, W, this);
        }));
        function g() {
          return y.apply(this, arguments);
        }
        return g;
      }()
      /**
       * Initialize the client.
       */
    }, {
      key: "_initialize",
      value: function() {
        var y = Z.default(/* @__PURE__ */ F.default.mark(function W() {
          var V = this, b;
          return F.default.wrap(function(k) {
            for (; ; )
              switch (k.prev = k.next) {
                case 0:
                  return k.next = 2, this._services.commandExecutor.fetchResource("Client/v2/Configuration");
                case 2:
                  return b = k.sent, this._configuration = new Gr(this._options, b, Rt._logger), this._services.channelMetadataClient = new J(this._services, this._configuration), this._myself._resolveInitialization(this._configuration, this._configuration.userIdentity, this._configuration.userInfo, !0), this._services.typingIndicator = new Y(this.getConversationBySid.bind(this), this._configuration, this._services), this._services.network = new ge(this._configuration, this._services), this._services.users = new mi(this._myself, this._configuration, this._services), this._services.users.on("userSubscribed", function(T) {
                    V.emit("userSubscribed", T);
                  }), this._services.users.on("userUpdated", function(T) {
                    return V.emit("userUpdated", T);
                  }), this._services.users.on("userUnsubscribed", function(T) {
                    V.emit("userUnsubscribed", T);
                  }), this._conversationsEntity = new mo(this._configuration, this._services), this._conversationsEntity.on("conversationAdded", function(T) {
                    V.emit("conversationAdded", T);
                  }), this._conversationsEntity.on("conversationRemoved", function(T) {
                    V.emit("conversationRemoved", T);
                  }), this._conversationsEntity.on("conversationJoined", function(T) {
                    V.emit("conversationJoined", T);
                  }), this._conversationsEntity.on("conversationLeft", function(T) {
                    V.emit("conversationLeft", T);
                  }), this._conversationsEntity.on("conversationUpdated", function(T) {
                    return V.emit("conversationUpdated", T);
                  }), this._conversationsEntity.on("participantJoined", function(T) {
                    V.emit("participantJoined", T);
                  }), this._conversationsEntity.on("participantLeft", function(T) {
                    V.emit("participantLeft", T);
                  }), this._conversationsEntity.on("participantUpdated", function(T) {
                    return V.emit("participantUpdated", T);
                  }), this._conversationsEntity.on("messageAdded", function(T) {
                    return V.emit("messageAdded", T);
                  }), this._conversationsEntity.on("messageUpdated", function(T) {
                    return V.emit("messageUpdated", T);
                  }), this._conversationsEntity.on("messageRemoved", function(T) {
                    return V.emit("messageRemoved", T);
                  }), this._conversationsEntity.on("typingStarted", function(T) {
                    return V.emit("typingStarted", T);
                  }), this._conversationsEntity.on("typingEnded", function(T) {
                    return V.emit("typingEnded", T);
                  }), this._conversationsPromise = this._conversationsEntity.fetchConversations().then(function() {
                    return V._conversationsEntity;
                  }).catch(function(T) {
                    throw T;
                  }), k.next = 29, this._services.users.myself._ensureFetched();
                case 29:
                  Rt._supportedPushChannels.forEach(function(T) {
                    return V._subscribeToPushNotifications(T);
                  }), this._services.typingIndicator.initialize(), this._services.mcsClient = new P.McsClient(this._fpaToken, this._configuration.links.mediaService, this._configuration.links.mediaSetService, ot(ot({}, this._options), {}, {
                    transport: void 0
                  })), this._resolveEnsureReady(), this.emit("stateChanged", "initialized"), this.emit("initialized");
                case 35:
                case "end":
                  return k.stop();
              }
          }, W, this);
        }));
        function g() {
          return y.apply(this, arguments);
        }
        return g;
      }()
      /**
       * Subscribe to push notifications.
       * @param channelType The channel type to subscribe to.
       */
    }, {
      key: "_subscribeToPushNotifications",
      value: function(g) {
        var W = this;
        [qe.NEW_MESSAGE, qe.ADDED_TO_CONVERSATION, qe.REMOVED_FROM_CONVERSATION, qe.TYPING_INDICATOR, qe.CONSUMPTION_UPDATE].forEach(function(V) {
          W._services.notificationClient.subscribe(g, V);
        });
      }
      /**
       * Unsubscribe from push notifications.
       * @param channelType The channel type to unsubscribe from.
       */
    }, {
      key: "_unsubscribeFromPushNotifications",
      value: function(g) {
        var W = this;
        [qe.NEW_MESSAGE, qe.ADDED_TO_CONVERSATION, qe.REMOVED_FROM_CONVERSATION, qe.TYPING_INDICATOR, qe.CONSUMPTION_UPDATE].forEach(function(V) {
          W._services.notificationClient.unsubscribe(g, V);
        });
      }
    }], [{
      key: "create",
      value: function() {
        var y = Z.default(/* @__PURE__ */ F.default.mark(function W(V, b) {
          var A;
          return F.default.wrap(function(T) {
            for (; ; )
              switch (T.prev = T.next) {
                case 0:
                  if (!(b != null && b.twilsockClient)) {
                    T.next = 2;
                    break;
                  }
                  throw new Error("Obsolete usage of ConversationsClient.create() factory method: if you pass twilsock from the outside then you must use ConversationsClient constructor and be prepared to work with uninitialized client.");
                case 2:
                  return A = new Rt(V, b), T.next = 5, A._ensureReady;
                case 5:
                  return T.abrupt("return", A);
                case 6:
                case "end":
                  return T.stop();
              }
          }, W);
        }));
        function g(W, V) {
          return y.apply(this, arguments);
        }
        return g;
      }()
      /**
       * Static method for push notification payload parsing. Returns parsed push as
       * a {@link PushNotification} object.
       * @param notificationPayload Push notification payload.
       */
    }, {
      key: "parsePushNotification",
      value: function(g) {
        if (Rt._logger.debug("parsePushNotification, notificationPayload=", g), typeof g.aps < "u") {
          if (!g.twi_message_type)
            throw new Error("Provided push notification payload does not contain Programmable Chat push notification type");
          var W = Rt._parsePushNotificationChatData(g), V = g.aps, b, A = null;
          if (typeof V.alert == "string")
            b = V.alert || null;
          else {
            var k, T;
            b = ((k = V.alert) === null || k === void 0 ? void 0 : k.body) || null, A = ((T = V.alert) === null || T === void 0 ? void 0 : T.title) || null;
          }
          return new H({
            title: A,
            body: b,
            sound: V.sound || null,
            badge: V.badge || null,
            action: V.category || null,
            type: g.twi_message_type,
            data: W
          });
        }
        if (typeof g.data < "u") {
          var $ = g.data;
          if (!$.twi_message_type)
            throw new Error("Provided push notification payload does not contain Programmable Chat push notification type");
          var ee = Rt._parsePushNotificationChatData(g.data);
          return new H({
            title: $.twi_title || null,
            body: $.twi_body || null,
            sound: $.twi_sound || null,
            badge: null,
            action: $.twi_action || null,
            type: $.twi_message_type,
            data: ee
          });
        }
        throw new Error("Provided push notification payload is not Programmable Chat notification");
      }
      /**
       * Static method for parsing push notification chat data.
       * @param data Data to parse
       */
    }, {
      key: "_parsePushNotificationChatData",
      value: function(g) {
        var W = {};
        for (var V in Rt._supportedPushDataFields) {
          var b = g[V];
          if (!(typeof b > "u" || b === null)) {
            if (V === "message_index" || V === "media_count") {
              var A = Je(b);
              A !== null && (W[Rt._supportedPushDataFields[V]] = A);
              continue;
            }
            if (V === "media") {
              if (typeof b == "string")
                try {
                  W[Rt._supportedPushDataFields[V]] = JSON.parse(b);
                } catch {
                  Rt._logger.debug("Media message notification parsing error");
                }
              continue;
            }
            W[Rt._supportedPushDataFields[V]] = b;
          }
        }
        return W;
      }
      /**
       * Populate the client with init registrations.
       * @param reg The init registration to populate.
       */
    }, {
      key: "populateInitRegistrations",
      value: function(g) {
        g.populateInitRegistrations([qe.TYPING_INDICATOR]), I.SyncClient.populateInitRegistrations(g);
      }
    }]), S;
  }(m.ReplayEventEmitter), ye.default(ie, "conversationAdded", "conversationAdded"), ye.default(ie, "conversationJoined", "conversationJoined"), ye.default(ie, "conversationLeft", "conversationLeft"), ye.default(ie, "conversationRemoved", "conversationRemoved"), ye.default(ie, "conversationUpdated", "conversationUpdated"), ye.default(ie, "participantJoined", "participantJoined"), ye.default(ie, "participantLeft", "participantLeft"), ye.default(ie, "participantUpdated", "participantUpdated"), ye.default(ie, "messageAdded", "messageAdded"), ye.default(ie, "messageRemoved", "messageRemoved"), ye.default(ie, "messageUpdated", "messageUpdated"), ye.default(ie, "tokenAboutToExpire", "tokenAboutToExpire"), ye.default(ie, "tokenExpired", "tokenExpired"), ye.default(ie, "typingEnded", "typingEnded"), ye.default(ie, "typingStarted", "typingStarted"), ye.default(ie, "pushNotification", "pushNotification"), ye.default(ie, "userSubscribed", "userSubscribed"), ye.default(ie, "userUnsubscribed", "userUnsubscribed"), ye.default(ie, "userUpdated", "userUpdated"), ye.default(ie, "stateChanged", "stateChanged"), ye.default(ie, "initialized", "initialized"), ye.default(ie, "initFailed", "initFailed"), ye.default(ie, "connectionStateChanged", "connectionStateChanged"), ye.default(ie, "connectionError", "connectionError"), ye.default(ie, "version", E), ye.default(ie, "_logger", Ue.scope("Client")), ye.default(ie, "_supportedPushChannels", ["fcm", "apn"]), ye.default(ie, "_supportedPushDataFields", {
    conversation_sid: "conversationSid",
    conversation_title: "conversationTitle",
    message_sid: "messageSid",
    message_index: "messageIndex",
    media_count: "mediaCount",
    media: "media"
    // object
  }), ie), Ae([K.deprecated("token"), re("design:type", String), re("design:paramtypes", [])], e.Client.prototype, "token", null), Ae([v.validateTypesAsync(v.nonEmptyString), re("design:type", Function), re("design:paramtypes", [String]), re("design:returntype", Promise)], e.Client.prototype, "updateToken", null), Ae([v.validateTypesAsync(v.nonEmptyString), re("design:type", Function), re("design:paramtypes", [String]), re("design:returntype", Promise)], e.Client.prototype, "getConversationBySid", null), Ae([v.validateTypesAsync(v.nonEmptyString), re("design:type", Function), re("design:paramtypes", [String]), re("design:returntype", Promise)], e.Client.prototype, "peekConversationBySid", null), Ae([v.validateTypesAsync(v.nonEmptyString), re("design:type", Function), re("design:paramtypes", [String]), re("design:returntype", Promise)], e.Client.prototype, "getConversationByUniqueName", null), Ae([v.validateTypesAsync(["undefined", v.objectSchema("conversation options", {
    friendlyName: ["string", "undefined"],
    isPrivate: ["boolean", "undefined"],
    uniqueName: ["string", "undefined"]
  })]), re("design:type", Function), re("design:paramtypes", [Object]), re("design:returntype", Promise)], e.Client.prototype, "createConversation", null), Ae([v.validateTypesAsync(v.literal("fcm", "apn"), "string"), re("design:type", Function), re("design:paramtypes", [String, String]), re("design:returntype", Promise)], e.Client.prototype, "setPushRegistrationId", null), Ae([v.validateTypesAsync(v.literal("fcm", "apn")), re("design:type", Function), re("design:paramtypes", [String]), re("design:returntype", Promise)], e.Client.prototype, "unsetPushRegistrationId", null), Ae([v.validateTypesAsync(v.literal("fcm", "apn"), v.nonEmptyString), re("design:type", Function), re("design:paramtypes", [String, String]), re("design:returntype", Promise)], e.Client.prototype, "removePushRegistrations", null), Ae([v.validateTypesAsync(v.pureObject), re("design:type", Function), re("design:paramtypes", [Object]), re("design:returntype", Promise)], e.Client.prototype, "handlePushNotification", null), Ae([v.validateTypesAsync(v.nonEmptyString), re("design:type", Function), re("design:paramtypes", [String]), re("design:returntype", Promise)], e.Client.prototype, "getUser", null), Ae([v.validateTypesAsync(v.nonEmptyArray("strings", "string")), re("design:type", Function), re("design:paramtypes", [Array]), re("design:returntype", P.CancellablePromise)], e.Client.prototype, "getTemporaryContentUrlsForMediaSids", null), Ae([v.validateTypesAsync(v.nonEmptyArray("media", ze)), re("design:type", Function), re("design:paramtypes", [Array]), re("design:returntype", P.CancellablePromise)], e.Client.prototype, "getTemporaryContentUrlsForMedia", null), Ae([K.deprecated("Client.create()", "new Client()"), v.validateTypesAsync("string", ["undefined", v.pureObject]), re("design:type", Function), re("design:paramtypes", [String, Object]), re("design:returntype", Promise)], e.Client, "create", null), Ae([v.validateTypes(v.pureObject), re("design:type", Function), re("design:paramtypes", [Object]), re("design:returntype", H)], e.Client, "parsePushNotification", null), e.Client = Rt = Ae([v.validateConstructorTypes(v.nonEmptyString, [v.pureObject, "undefined"]), re("design:paramtypes", [String, Object])], e.Client), Object.defineProperty(e, "CancellablePromise", {
    enumerable: !0,
    get: function() {
      return P.CancellablePromise;
    }
  }), e.AggregatedDeliveryReceipt = Pe, e.ChannelMetadata = Hl, e.ContentTemplate = G, e.ContentTemplateVariable = lt, e.Conversation = zt, e.DetailedDeliveryReceipt = tt, e.Media = ze, e.Message = xr, e.MessageBuilder = Lr, e.NotificationTypes = qe, e.Participant = fe, e.PushNotification = H, e.RestPaginator = dt, e.UnsentMessage = co, e.User = kr;
})(_3);
const Sse = () => {
  var o;
  const e = zr(null), t = (o = oO(R3())) == null ? void 0 : o.chatSdkToken, [r, n] = ir(null), [i, a] = ir(!1);
  Kr(() => {
    if (!t)
      return;
    const u = new _3.Client(t), f = () => {
      e.current = u, a(!0), n(null);
    }, l = (d) => {
      var p;
      e.current = null;
      const c = ((p = d.error) == null ? void 0 : p.message) ?? null;
      n(c), a(!1), console.error(d);
    };
    return u.on("initialized", f), u.on("initFailed", l), () => {
      u.off("initialized", f), u.off("initFailed", l);
    };
  }, [t]);
  const s = e.current;
  return s ? i ? { client: s, ready: i } : { errorMessage: r ?? "", ready: i } : { ready: !1, errorMessage: r ?? "could not initialize twilio" };
}, B4 = P6(null), Cse = ({ children: e, client: t }) => /* @__PURE__ */ j(B4.Provider, { value: t, children: e }), Vs = () => {
  const e = _g(B4);
  if (!e)
    throw new Error("useTwilioClientContext must be used within TwilioClientProvider");
  return e;
}, D4 = (e) => {
  var n, i, a, s, o;
  const t = e.attributes && typeof e.attributes == "object" && "type" in e.attributes ? e.attributes.type : "direct", r = {
    createdBy: e.createdBy,
    dateCreated: (n = e.dateCreated) == null ? void 0 : n.toString(),
    friendlyName: null,
    dateUpdated: (i = e.dateUpdated) == null ? void 0 : i.toString(),
    lastReadMessageIndex: e.lastReadMessageIndex,
    sid: e.sid,
    lastMessageDate: (s = (a = e.lastMessage) == null ? void 0 : a.dateCreated) == null ? void 0 : s.toString(),
    lastMessageIndex: (o = e.lastMessage) == null ? void 0 : o.index
  };
  return t === "direct" ? {
    ...r,
    friendlyName: null,
    type: t
  } : {
    ...r,
    type: t,
    friendlyName: e.friendlyName ?? ""
  };
}, Fse = (e) => ({
  sid: e.sid,
  identity: e.identity
}), Kse = (e) => ({
  filename: e.filename,
  contentType: e.contentType,
  sid: e.sid
}), j2 = (e) => {
  var t, r;
  return {
    author: e.author,
    dateCreated: ((t = e.dateCreated) == null ? void 0 : t.toString()) ?? "",
    body: e.body,
    sid: e.sid,
    index: e.index,
    attachments: ((r = e.attachedMedia) == null ? void 0 : r.map(Kse)) ?? []
  };
}, L4 = (e) => ({
  isOnline: e.isOnline,
  identity: e.identity
}), Z4 = (e) => (t) => async (r, n) => {
  var u;
  const i = t(r), a = await i.getParticipants(), s = await i.getUnreadConversationCount(), o = D4(r);
  e(O3(o)), e(pl({ conversationId: r.sid, unreadCount: s })), (u = a == null ? void 0 : a.filter((f) => f.identity !== n)) == null || u.forEach(z4(e));
}, Rse = (e) => async (t) => {
  e(N3(t == null ? void 0 : t.sid));
}, Tse = (e) => async (t) => {
  const r = D4(t);
  e(I3({ sid: t.sid, data: r }));
}, Use = (e) => (t, r) => {
  r && e(B3({ conversationId: t, participant: r }));
}, xse = (e) => (t, r) => {
  r && e(D3({ conversationId: t, participant: r }));
}, Ese = (e) => async ({ user: t, updateReasons: r }) => {
  const n = L4(t);
  r.includes("reachabilityOnline") && e(by(n));
}, M4 = (e) => ({
  favorites: e.attributes && typeof e.attributes == "object" && "favorites" in e.attributes ? e.attributes.favorites : [],
  identity: e.identity
}), Ose = (e) => async ({ user: t, updateReasons: r }) => {
  if (r.includes("attributes")) {
    const i = M4(t);
    e(X3(i));
  }
}, j4 = (e) => (t) => async (r, n) => {
  if (r.author === n)
    return;
  const a = await t(r.conversation).getUnreadConversationCount();
  e(pl({ conversationId: r.conversation.sid, unreadCount: a }));
}, Y4 = (e) => (t) => async (r) => {
  const i = await t(r.conversation).getUnreadConversationCount();
  e(pl({ conversationId: r.conversation.sid, unreadCount: i }));
}, z4 = (e) => async (t) => {
  const r = Fse(t);
  e(L3({ conversationId: t.conversation.sid, participant: r }));
  const n = await t.getUser(), i = L4(n);
  e(by(i));
}, Nse = (e) => (t) => {
  e(Z3({ conversationId: t.conversation.sid, participantId: t.sid }));
}, Si = async (e, t) => {
  try {
    return await e.getConversationBySid(t);
  } catch (r) {
    console.error(r);
  }
}, Bn = (e) => ({
  getUnreadConversationCount: async () => {
    const l = await e.getUnreadMessagesCount(), d = await e.getMessagesCount();
    return l ?? d;
  },
  deleteConversation: async () => {
    try {
      return await e.delete();
    } catch (l) {
      console.error(l);
    }
  },
  participantTyping: async () => {
    try {
      await e.typing();
    } catch (l) {
      console.error(l);
    }
  },
  getParticipants: async () => {
    try {
      return await e.getParticipants();
    } catch (l) {
      console.error(l);
    }
  },
  updateFriendlyName: async (l) => {
    try {
      return await e.updateFriendlyName(l);
    } catch (d) {
      console.error(d);
    }
  },
  addParticipant: async (l) => {
    try {
      return (await e.add(l)).identity;
    } catch (d) {
      console.error(d);
    }
  },
  removeParticipant: async (l) => {
    await e.removeParticipant(l);
  },
  getMessagesCursor: async () => {
    try {
      return await e.getMessages();
    } catch (l) {
      console.log(l);
    }
  },
  markMessagesAsRead: async () => {
    await e.setAllMessagesRead();
  }
}), G4 = async (e, t) => Promise.all(
  t.map(async (r) => Bn(e).addParticipant(r))
), Ise = (e) => Bn(e).participantTyping(), Xse = async (e) => {
  const t = { attributes: { type: "direct" } };
  return await e.createConversation(t);
}, Pse = async (e, t) => {
  const r = { attributes: { type: "group" }, friendlyName: t };
  return await e.createConversation(r);
}, fq = async (e) => await Bn(e).deleteConversation(), Bse = async (e) => {
  await Bn(e).markMessagesAsRead();
}, Yc = async (e, t) => {
  await Bn(e).removeParticipant(t);
}, Dse = async (e, t) => await Bn(e).updateFriendlyName(t), Ga = async (e, t) => {
  await e.user.updateAttributes({ favorites: t });
}, ev = (e) => e.participants.participants, Lse = _r(ev, (e) => Object.entries(e).filter(([t, r]) => r.length === 1).map(([t, r]) => ({
  convoSid: t,
  participantId: r[0].identity
}))), Zse = _r(
  [ev, (e, t) => t],
  (e, t) => t ? e[t].map((n) => n.identity) : []
), tv = (e) => e.chat.currentUser.favorites, qs = (e) => e.chat.currentUser.identity, Q4 = Zo.endpoints.getMerinioUsers.select(), Mse = (e) => {
  const t = {};
  return e == null ? void 0 : e.reduce((r, n) => ({ ...r, [n._id]: n }), t);
}, jse = _r(Q4, (e) => {
  var t;
  return (t = e.data) == null ? void 0 : t.users;
}), lq = _r(
  [jse, qs],
  (e, t) => e == null ? void 0 : e.filter((r) => r._id !== t)
), Xu = _r(Q4, (e) => {
  var t;
  return Mse((t = e.data) == null ? void 0 : t.users);
}), J4 = _r([Xu, ev], (e, t) => {
  const r = {};
  return Object.entries(t).reduce((n, [i, a]) => {
    const s = a.map((o) => e == null ? void 0 : e[o.identity ?? ""]).filter(Boolean);
    return { ...n, [i]: s };
  }, r);
}), H4 = _r([J4, (e, t) => t], (e, t) => e[t]), _4 = (e) => e.conversations.conversationsUnreadMessagesMap, $4 = (e) => e.conversations.conversations;
_r($4, (e) => Object.values(e));
const jl = _r(
  [$4, J4, tv],
  (e, t, r) => Object.entries(e).map(([n, i]) => {
    const a = t[n] ?? [];
    if (i.type === "direct") {
      const [f] = a;
      return { ...i, displayName: (f == null ? void 0 : f.fullName) ?? null, isFavorite: r.includes(n) };
    }
    const o = fO(a, i.friendlyName), u = a.map(({ fullName: f }) => f).join(", ");
    return { ...i, displayName: o, isFavorite: r.includes(n), participantsNames: u };
  })
), Yse = _r(_4, (e) => Object.values(e).reduce((t, r) => t + r, 0)), zse = (e) => e.messages.messages, eR = (e) => e.twilioUsers.twilioUsers, Gse = _r([eR, ev], (e, t) => {
  const r = {};
  return Object.entries(t).reduce((n, [i, a]) => {
    const s = a.map((o) => e == null ? void 0 : e[o.identity ?? ""]).filter(Boolean);
    return { ...n, [i]: s };
  }, r);
}), Qse = _r(
  [Gse, (e, t) => t],
  (e, t) => e[t]
), Jse = (e) => e.typing.typingMap, Hse = _r(
  [Jse, (e, t) => t],
  (e, t) => e[t]
), tR = _r(
  [(e, t) => t, Hse, Xu],
  (e, t, r) => (t == null ? void 0 : t.map((n) => {
    var i;
    return (i = r == null ? void 0 : r[n]) == null ? void 0 : i.fullName;
  }).filter(Boolean)) ?? []
), _se = (e) => {
  const t = Gs(), r = Lt(qs), n = qr(
    (o) => {
      Z4(t)(Bn)(o, r), o.on("typingStarted", (u) => {
        Use(t)(o.sid, u.identity);
      }), o.on("typingEnded", (u) => {
        xse(t)(o.sid, u.identity);
      }), o.on("participantJoined", (u) => {
        z4(t)(u);
      }), o.on("participantLeft", (u) => {
        Nse(t)(u);
      }), o.on("updated", (u) => {
        Tse(t)(u.conversation);
      }), o.on("messageAdded", (u) => {
        j4(t)(Bn)(u, r);
      }), o.on("messageRemoved", (u) => {
        Y4(t)(Bn)(u);
      });
    },
    [t, r]
  ), i = qr(
    (o) => {
      Rse(t)(o);
    },
    [t]
  ), a = qr(
    ({ user: o, updateReasons: u }) => {
      Ese(t)({ user: o, updateReasons: u });
    },
    [t]
  ), s = qr(
    ({ user: o, updateReasons: u }) => {
      Ose(t)({ user: o, updateReasons: u });
    },
    [t]
  );
  Kr(() => (e.on("conversationJoined", n), e.on("conversationRemoved", i), e.on("userUpdated", a), e.on("userUpdated", s), () => {
    e.off("conversationJoined", n), e.off("conversationRemoved", i), e.off("userUpdated", a), e.off("userUpdated", s);
  }), [e, t, n, i, s, a]);
}, $se = (e) => {
  const t = Gs(), r = Lt(qs), n = qr(
    async (i) => {
      if (i.items.forEach(async (s) => {
        Z4(t)(Bn)(s, r);
      }), !i.hasNextPage)
        return;
      const a = await i.nextPage();
      n(a);
    },
    [t, r]
  );
  Kr(() => {
    r && (async () => {
      const i = await e.getSubscribedConversations();
      n(i);
    })();
  }, [e, n, r]);
}, eoe = (e) => {
  const t = Gs();
  Kr(() => {
    const r = M4(e.user);
    return t(P3(r)), () => {
      t(Gi());
    };
  }, [e.user, t]);
}, toe = () => {
  const e = Gs();
  Kr(() => () => {
    e(Gi());
  }, [e]);
}, roe = (e) => {
  eoe(e), $se(e), _se(e), toe();
}, noe = P6(null), N1 = {
  didCatch: !1,
  error: null
};
class ioe extends B6 {
  constructor(t) {
    super(t), this.resetErrorBoundary = this.resetErrorBoundary.bind(this), this.state = N1;
  }
  static getDerivedStateFromError(t) {
    return {
      didCatch: !0,
      error: t
    };
  }
  resetErrorBoundary() {
    const {
      error: t
    } = this.state;
    if (t !== null) {
      for (var r, n, i = arguments.length, a = new Array(i), s = 0; s < i; s++)
        a[s] = arguments[s];
      (r = (n = this.props).onReset) === null || r === void 0 || r.call(n, {
        args: a,
        reason: "imperative-api"
      }), this.setState(N1);
    }
  }
  componentDidCatch(t, r) {
    var n, i;
    (n = (i = this.props).onError) === null || n === void 0 || n.call(i, t, r);
  }
  componentDidUpdate(t, r) {
    const {
      didCatch: n
    } = this.state, {
      resetKeys: i
    } = this.props;
    if (n && r.error !== null && aoe(t.resetKeys, i)) {
      var a, s;
      (a = (s = this.props).onReset) === null || a === void 0 || a.call(s, {
        next: i,
        prev: t.resetKeys,
        reason: "keys"
      }), this.setState(N1);
    }
  }
  render() {
    const {
      children: t,
      fallbackRender: r,
      FallbackComponent: n,
      fallback: i
    } = this.props, {
      didCatch: a,
      error: s
    } = this.state;
    let o = t;
    if (a) {
      const u = {
        error: s,
        resetErrorBoundary: this.resetErrorBoundary
      };
      if (Uf(i))
        o = i;
      else if (typeof r == "function")
        o = r(u);
      else if (n)
        o = Bo(n, u);
      else
        throw s;
    }
    return Bo(noe.Provider, {
      value: {
        didCatch: a,
        error: s,
        resetErrorBoundary: this.resetErrorBoundary
      }
    }, o);
  }
}
function aoe() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
  return e.length !== t.length || e.some((r, n) => !Object.is(r, t[n]));
}
var rv = { exports: {} }, rR = {
  À: "A",
  Á: "A",
  Â: "A",
  Ã: "A",
  Ä: "A",
  Å: "A",
  Ấ: "A",
  Ắ: "A",
  Ẳ: "A",
  Ẵ: "A",
  Ặ: "A",
  Æ: "AE",
  Ầ: "A",
  Ằ: "A",
  Ȃ: "A",
  Ç: "C",
  Ḉ: "C",
  È: "E",
  É: "E",
  Ê: "E",
  Ë: "E",
  Ế: "E",
  Ḗ: "E",
  Ề: "E",
  Ḕ: "E",
  Ḝ: "E",
  Ȇ: "E",
  Ì: "I",
  Í: "I",
  Î: "I",
  Ï: "I",
  Ḯ: "I",
  Ȋ: "I",
  Ð: "D",
  Ñ: "N",
  Ò: "O",
  Ó: "O",
  Ô: "O",
  Õ: "O",
  Ö: "O",
  Ø: "O",
  Ố: "O",
  Ṍ: "O",
  Ṓ: "O",
  Ȏ: "O",
  Ù: "U",
  Ú: "U",
  Û: "U",
  Ü: "U",
  Ý: "Y",
  à: "a",
  á: "a",
  â: "a",
  ã: "a",
  ä: "a",
  å: "a",
  ấ: "a",
  ắ: "a",
  ẳ: "a",
  ẵ: "a",
  ặ: "a",
  æ: "ae",
  ầ: "a",
  ằ: "a",
  ȃ: "a",
  ç: "c",
  ḉ: "c",
  è: "e",
  é: "e",
  ê: "e",
  ë: "e",
  ế: "e",
  ḗ: "e",
  ề: "e",
  ḕ: "e",
  ḝ: "e",
  ȇ: "e",
  ì: "i",
  í: "i",
  î: "i",
  ï: "i",
  ḯ: "i",
  ȋ: "i",
  ð: "d",
  ñ: "n",
  ò: "o",
  ó: "o",
  ô: "o",
  õ: "o",
  ö: "o",
  ø: "o",
  ố: "o",
  ṍ: "o",
  ṓ: "o",
  ȏ: "o",
  ù: "u",
  ú: "u",
  û: "u",
  ü: "u",
  ý: "y",
  ÿ: "y",
  Ā: "A",
  ā: "a",
  Ă: "A",
  ă: "a",
  Ą: "A",
  ą: "a",
  Ć: "C",
  ć: "c",
  Ĉ: "C",
  ĉ: "c",
  Ċ: "C",
  ċ: "c",
  Č: "C",
  č: "c",
  C̆: "C",
  c̆: "c",
  Ď: "D",
  ď: "d",
  Đ: "D",
  đ: "d",
  Ē: "E",
  ē: "e",
  Ĕ: "E",
  ĕ: "e",
  Ė: "E",
  ė: "e",
  Ę: "E",
  ę: "e",
  Ě: "E",
  ě: "e",
  Ĝ: "G",
  Ǵ: "G",
  ĝ: "g",
  ǵ: "g",
  Ğ: "G",
  ğ: "g",
  Ġ: "G",
  ġ: "g",
  Ģ: "G",
  ģ: "g",
  Ĥ: "H",
  ĥ: "h",
  Ħ: "H",
  ħ: "h",
  Ḫ: "H",
  ḫ: "h",
  Ĩ: "I",
  ĩ: "i",
  Ī: "I",
  ī: "i",
  Ĭ: "I",
  ĭ: "i",
  Į: "I",
  į: "i",
  İ: "I",
  ı: "i",
  Ĳ: "IJ",
  ĳ: "ij",
  Ĵ: "J",
  ĵ: "j",
  Ķ: "K",
  ķ: "k",
  Ḱ: "K",
  ḱ: "k",
  K̆: "K",
  k̆: "k",
  Ĺ: "L",
  ĺ: "l",
  Ļ: "L",
  ļ: "l",
  Ľ: "L",
  ľ: "l",
  Ŀ: "L",
  ŀ: "l",
  Ł: "l",
  ł: "l",
  Ḿ: "M",
  ḿ: "m",
  M̆: "M",
  m̆: "m",
  Ń: "N",
  ń: "n",
  Ņ: "N",
  ņ: "n",
  Ň: "N",
  ň: "n",
  ŉ: "n",
  N̆: "N",
  n̆: "n",
  Ō: "O",
  ō: "o",
  Ŏ: "O",
  ŏ: "o",
  Ő: "O",
  ő: "o",
  Œ: "OE",
  œ: "oe",
  P̆: "P",
  p̆: "p",
  Ŕ: "R",
  ŕ: "r",
  Ŗ: "R",
  ŗ: "r",
  Ř: "R",
  ř: "r",
  R̆: "R",
  r̆: "r",
  Ȓ: "R",
  ȓ: "r",
  Ś: "S",
  ś: "s",
  Ŝ: "S",
  ŝ: "s",
  Ş: "S",
  Ș: "S",
  ș: "s",
  ş: "s",
  Š: "S",
  š: "s",
  Ţ: "T",
  ţ: "t",
  ț: "t",
  Ț: "T",
  Ť: "T",
  ť: "t",
  Ŧ: "T",
  ŧ: "t",
  T̆: "T",
  t̆: "t",
  Ũ: "U",
  ũ: "u",
  Ū: "U",
  ū: "u",
  Ŭ: "U",
  ŭ: "u",
  Ů: "U",
  ů: "u",
  Ű: "U",
  ű: "u",
  Ų: "U",
  ų: "u",
  Ȗ: "U",
  ȗ: "u",
  V̆: "V",
  v̆: "v",
  Ŵ: "W",
  ŵ: "w",
  Ẃ: "W",
  ẃ: "w",
  X̆: "X",
  x̆: "x",
  Ŷ: "Y",
  ŷ: "y",
  Ÿ: "Y",
  Y̆: "Y",
  y̆: "y",
  Ź: "Z",
  ź: "z",
  Ż: "Z",
  ż: "z",
  Ž: "Z",
  ž: "z",
  ſ: "s",
  ƒ: "f",
  Ơ: "O",
  ơ: "o",
  Ư: "U",
  ư: "u",
  Ǎ: "A",
  ǎ: "a",
  Ǐ: "I",
  ǐ: "i",
  Ǒ: "O",
  ǒ: "o",
  Ǔ: "U",
  ǔ: "u",
  Ǖ: "U",
  ǖ: "u",
  Ǘ: "U",
  ǘ: "u",
  Ǚ: "U",
  ǚ: "u",
  Ǜ: "U",
  ǜ: "u",
  Ứ: "U",
  ứ: "u",
  Ṹ: "U",
  ṹ: "u",
  Ǻ: "A",
  ǻ: "a",
  Ǽ: "AE",
  ǽ: "ae",
  Ǿ: "O",
  ǿ: "o",
  Þ: "TH",
  þ: "th",
  Ṕ: "P",
  ṕ: "p",
  Ṥ: "S",
  ṥ: "s",
  X́: "X",
  x́: "x",
  Ѓ: "Г",
  ѓ: "г",
  Ќ: "К",
  ќ: "к",
  A̋: "A",
  a̋: "a",
  E̋: "E",
  e̋: "e",
  I̋: "I",
  i̋: "i",
  Ǹ: "N",
  ǹ: "n",
  Ồ: "O",
  ồ: "o",
  Ṑ: "O",
  ṑ: "o",
  Ừ: "U",
  ừ: "u",
  Ẁ: "W",
  ẁ: "w",
  Ỳ: "Y",
  ỳ: "y",
  Ȁ: "A",
  ȁ: "a",
  Ȅ: "E",
  ȅ: "e",
  Ȉ: "I",
  ȉ: "i",
  Ȍ: "O",
  ȍ: "o",
  Ȑ: "R",
  ȑ: "r",
  Ȕ: "U",
  ȕ: "u",
  B̌: "B",
  b̌: "b",
  Č̣: "C",
  č̣: "c",
  Ê̌: "E",
  ê̌: "e",
  F̌: "F",
  f̌: "f",
  Ǧ: "G",
  ǧ: "g",
  Ȟ: "H",
  ȟ: "h",
  J̌: "J",
  ǰ: "j",
  Ǩ: "K",
  ǩ: "k",
  M̌: "M",
  m̌: "m",
  P̌: "P",
  p̌: "p",
  Q̌: "Q",
  q̌: "q",
  Ř̩: "R",
  ř̩: "r",
  Ṧ: "S",
  ṧ: "s",
  V̌: "V",
  v̌: "v",
  W̌: "W",
  w̌: "w",
  X̌: "X",
  x̌: "x",
  Y̌: "Y",
  y̌: "y",
  A̧: "A",
  a̧: "a",
  B̧: "B",
  b̧: "b",
  Ḑ: "D",
  ḑ: "d",
  Ȩ: "E",
  ȩ: "e",
  Ɛ̧: "E",
  ɛ̧: "e",
  Ḩ: "H",
  ḩ: "h",
  I̧: "I",
  i̧: "i",
  Ɨ̧: "I",
  ɨ̧: "i",
  M̧: "M",
  m̧: "m",
  O̧: "O",
  o̧: "o",
  Q̧: "Q",
  q̧: "q",
  U̧: "U",
  u̧: "u",
  X̧: "X",
  x̧: "x",
  Z̧: "Z",
  z̧: "z"
}, nR = Object.keys(rR).join("|"), soe = new RegExp(nR, "g"), ooe = new RegExp(nR, ""), iR = function(e) {
  return e.replace(soe, function(t) {
    return rR[t];
  });
}, uoe = function(e) {
  return !!e.match(ooe);
};
rv.exports = iR;
rv.exports.has = uoe;
rv.exports.remove = iR;
var foe = rv.exports;
const loe = /* @__PURE__ */ iy(foe);
var Vn = {
  CASE_SENSITIVE_EQUAL: 7,
  EQUAL: 6,
  STARTS_WITH: 5,
  WORD_STARTS_WITH: 4,
  CONTAINS: 3,
  ACRONYM: 2,
  MATCHES: 1,
  NO_MATCH: 0
};
il.rankings = Vn;
var doe = function(t, r) {
  return String(t.rankedValue).localeCompare(String(r.rankedValue));
};
function il(e, t, r) {
  r === void 0 && (r = {});
  var n = r, i = n.keys, a = n.threshold, s = a === void 0 ? Vn.MATCHES : a, o = n.baseSort, u = o === void 0 ? doe : o, f = n.sorter, l = f === void 0 ? function(p) {
    return p.sort(function(v, h) {
      return hoe(v, h, u);
    });
  } : f, d = e.reduce(c, []);
  return l(d).map(function(p) {
    var v = p.item;
    return v;
  });
  function c(p, v, h) {
    var m = coe(v, i, t, r), q = m.rank, w = m.keyThreshold, O = w === void 0 ? s : w;
    return q >= O && p.push(yt({}, m, {
      item: v,
      index: h
    })), p;
  }
}
function coe(e, t, r, n) {
  if (!t) {
    var i = e;
    return {
      // ends up being duplicate of 'item' in matches but consistent
      rankedValue: i,
      rank: Y2(i, r, n),
      keyIndex: -1,
      keyThreshold: n.threshold
    };
  }
  var a = yoe(e, t);
  return a.reduce(function(s, o, u) {
    var f = s.rank, l = s.rankedValue, d = s.keyIndex, c = s.keyThreshold, p = o.itemValue, v = o.attributes, h = Y2(p, r, n), m = l, q = v.minRanking, w = v.maxRanking, O = v.threshold;
    return h < q && h >= Vn.MATCHES ? h = q : h > w && (h = w), h > f && (f = h, d = u, c = O, m = p), {
      rankedValue: m,
      rank: f,
      keyIndex: d,
      keyThreshold: c
    };
  }, {
    rankedValue: e,
    rank: Vn.NO_MATCH,
    keyIndex: -1,
    keyThreshold: n.threshold
  });
}
function Y2(e, t, r) {
  return e = z2(e, r), t = z2(t, r), t.length > e.length ? Vn.NO_MATCH : e === t ? Vn.CASE_SENSITIVE_EQUAL : (e = e.toLowerCase(), t = t.toLowerCase(), e === t ? Vn.EQUAL : e.startsWith(t) ? Vn.STARTS_WITH : e.includes(" " + t) ? Vn.WORD_STARTS_WITH : e.includes(t) ? Vn.CONTAINS : t.length === 1 ? Vn.NO_MATCH : poe(e).includes(t) ? Vn.ACRONYM : voe(e, t));
}
function poe(e) {
  var t = "", r = e.split(" ");
  return r.forEach(function(n) {
    var i = n.split("-");
    i.forEach(function(a) {
      t += a.substr(0, 1);
    });
  }), t;
}
function voe(e, t) {
  var r = 0, n = 0;
  function i(c, p, v) {
    for (var h = v, m = p.length; h < m; h++) {
      var q = p[h];
      if (q === c)
        return r += 1, h + 1;
    }
    return -1;
  }
  function a(c) {
    var p = 1 / c, v = r / t.length, h = Vn.MATCHES + v * p;
    return h;
  }
  var s = i(t[0], e, 0);
  if (s < 0)
    return Vn.NO_MATCH;
  n = s;
  for (var o = 1, u = t.length; o < u; o++) {
    var f = t[o];
    n = i(f, e, n);
    var l = n > -1;
    if (!l)
      return Vn.NO_MATCH;
  }
  var d = n - s;
  return a(d);
}
function hoe(e, t, r) {
  var n = -1, i = 1, a = e.rank, s = e.keyIndex, o = t.rank, u = t.keyIndex, f = a === o;
  return f ? s === u ? r(e, t) : s < u ? n : i : a > o ? n : i;
}
function z2(e, t) {
  var r = t.keepDiacritics;
  return e = "" + e, r || (e = loe(e)), e;
}
function moe(e, t) {
  typeof t == "object" && (t = t.key);
  var r;
  if (typeof t == "function")
    r = t(e);
  else if (e == null)
    r = null;
  else if (Object.hasOwnProperty.call(e, t))
    r = e[t];
  else {
    if (t.includes("."))
      return goe(t, e);
    r = null;
  }
  return r == null ? [] : Array.isArray(r) ? r : [String(r)];
}
function goe(e, t) {
  for (var r = e.split("."), n = [t], i = 0, a = r.length; i < a; i++) {
    for (var s = r[i], o = [], u = 0, f = n.length; u < f; u++) {
      var l = n[u];
      if (l != null)
        if (Object.hasOwnProperty.call(l, s)) {
          var d = l[s];
          d != null && o.push(d);
        } else
          s === "*" && (o = o.concat(l));
    }
    n = o;
  }
  if (Array.isArray(n[0])) {
    var c = [];
    return c.concat.apply(c, n);
  }
  return n;
}
function yoe(e, t) {
  for (var r = [], n = 0, i = t.length; n < i; n++)
    for (var a = t[n], s = Voe(a), o = moe(e, a), u = 0, f = o.length; u < f; u++)
      r.push({
        itemValue: o[u],
        attributes: s
      });
  return r;
}
var G2 = {
  maxRanking: 1 / 0,
  minRanking: -1 / 0
};
function Voe(e) {
  return typeof e == "string" ? G2 : yt({}, G2, e);
}
const qoe = (e) => {
  const { previousRoute: t, goBack: r } = Gn();
  return /* @__PURE__ */ j(YT, { elevation: 0, color: e.color ?? "transparent", position: "static", sx: { display: "flex", height: "50px", marginBottom: 0.5 }, children: /* @__PURE__ */ ut(zT, { variant: "dense", sx: { height: "50px" }, children: [
    t ? /* @__PURE__ */ j(Ci, { sx: { color: (n) => e.color === "primary" ? n.palette.primary.contrastText : "inherit" }, onClick: () => r(), children: /* @__PURE__ */ j(nU, { size: "xs" }) }) : null,
    /* @__PURE__ */ j(gr, { sx: { flexGrow: 1 } }),
    e.title ? /* @__PURE__ */ j(br, { variant: "subtitle2", noWrap: !0, sx: { maxWidth: "70%" }, children: e.title }) : null,
    /* @__PURE__ */ j(gr, { sx: { flexGrow: 1 } }),
    e.action ?? null
  ] }) });
}, Pu = (e) => /* @__PURE__ */ ut(pt, { id: "screen-container", sx: { height: "100%", position: "relative" }, ...e.stackProps, children: [
  /* @__PURE__ */ j(qoe, { ...e.topBarProps }),
  e.children
] });
function Fg(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function Kg(e, t) {
  return Kg = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, i) {
    return n.__proto__ = i, n;
  }, Kg(e, t);
}
function aR(e, t) {
  e.prototype = Object.create(t.prototype), e.prototype.constructor = e, Kg(e, t);
}
var Q2 = Number.isNaN || function(t) {
  return typeof t == "number" && t !== t;
};
function boe(e, t) {
  return !!(e === t || Q2(e) && Q2(t));
}
function Aoe(e, t) {
  if (e.length !== t.length)
    return !1;
  for (var r = 0; r < e.length; r++)
    if (!boe(e[r], t[r]))
      return !1;
  return !0;
}
function I1(e, t) {
  t === void 0 && (t = Aoe);
  var r, n = [], i, a = !1;
  function s() {
    for (var o = [], u = 0; u < arguments.length; u++)
      o[u] = arguments[u];
    return a && r === this && t(o, n) || (i = e.apply(this, o), a = !0, r = this, n = o), i;
  }
  return s;
}
var woe = typeof performance == "object" && typeof performance.now == "function", J2 = woe ? function() {
  return performance.now();
} : function() {
  return Date.now();
};
function H2(e) {
  cancelAnimationFrame(e.id);
}
function koe(e, t) {
  var r = J2();
  function n() {
    J2() - r >= t ? e.call(null) : i.id = requestAnimationFrame(n);
  }
  var i = {
    id: requestAnimationFrame(n)
  };
  return i;
}
var X1 = -1;
function _2(e) {
  if (e === void 0 && (e = !1), X1 === -1 || e) {
    var t = document.createElement("div"), r = t.style;
    r.width = "50px", r.height = "50px", r.overflow = "scroll", document.body.appendChild(t), X1 = t.offsetWidth - t.clientWidth, document.body.removeChild(t);
  }
  return X1;
}
var Fo = null;
function $2(e) {
  if (e === void 0 && (e = !1), Fo === null || e) {
    var t = document.createElement("div"), r = t.style;
    r.width = "50px", r.height = "50px", r.overflow = "scroll", r.direction = "rtl";
    var n = document.createElement("div"), i = n.style;
    return i.width = "100px", i.height = "100px", t.appendChild(n), document.body.appendChild(t), t.scrollLeft > 0 ? Fo = "positive-descending" : (t.scrollLeft = 1, t.scrollLeft === 0 ? Fo = "negative" : Fo = "positive-ascending"), document.body.removeChild(t), Fo;
  }
  return Fo;
}
process.env.NODE_ENV;
var Woe = 150, Soe = function(t, r) {
  return t;
}, oc = null, uc = null;
process.env.NODE_ENV !== "production" && typeof window < "u" && typeof window.WeakSet < "u" && (oc = /* @__PURE__ */ new WeakSet(), uc = /* @__PURE__ */ new WeakSet());
function Coe(e) {
  var t, r = e.getItemOffset, n = e.getEstimatedTotalSize, i = e.getItemSize, a = e.getOffsetForIndexAndAlignment, s = e.getStartIndexForOffset, o = e.getStopIndexForStartIndex, u = e.initInstanceProps, f = e.shouldResetStyleCacheOnItemSizeChange, l = e.validateProps;
  return t = /* @__PURE__ */ function(d) {
    aR(c, d);
    function c(v) {
      var h;
      return h = d.call(this, v) || this, h._instanceProps = u(h.props, Fg(h)), h._outerRef = void 0, h._resetIsScrollingTimeoutId = null, h.state = {
        instance: Fg(h),
        isScrolling: !1,
        scrollDirection: "forward",
        scrollOffset: typeof h.props.initialScrollOffset == "number" ? h.props.initialScrollOffset : 0,
        scrollUpdateWasRequested: !1
      }, h._callOnItemsRendered = void 0, h._callOnItemsRendered = I1(function(m, q, w, O) {
        return h.props.onItemsRendered({
          overscanStartIndex: m,
          overscanStopIndex: q,
          visibleStartIndex: w,
          visibleStopIndex: O
        });
      }), h._callOnScroll = void 0, h._callOnScroll = I1(function(m, q, w) {
        return h.props.onScroll({
          scrollDirection: m,
          scrollOffset: q,
          scrollUpdateWasRequested: w
        });
      }), h._getItemStyle = void 0, h._getItemStyle = function(m) {
        var q = h.props, w = q.direction, O = q.itemSize, C = q.layout, R = h._getItemStyleCache(f && O, f && C, f && w), I;
        if (R.hasOwnProperty(m))
          I = R[m];
        else {
          var P = r(h.props, m, h._instanceProps), K = i(h.props, m, h._instanceProps), B = w === "horizontal" || C === "horizontal", L = w === "rtl", _ = B ? P : 0;
          R[m] = I = {
            position: "absolute",
            left: L ? void 0 : _,
            right: L ? _ : void 0,
            top: B ? 0 : P,
            height: B ? "100%" : K,
            width: B ? K : "100%"
          };
        }
        return I;
      }, h._getItemStyleCache = void 0, h._getItemStyleCache = I1(function(m, q, w) {
        return {};
      }), h._onScrollHorizontal = function(m) {
        var q = m.currentTarget, w = q.clientWidth, O = q.scrollLeft, C = q.scrollWidth;
        h.setState(function(R) {
          if (R.scrollOffset === O)
            return null;
          var I = h.props.direction, P = O;
          if (I === "rtl")
            switch ($2()) {
              case "negative":
                P = -O;
                break;
              case "positive-descending":
                P = C - w - O;
                break;
            }
          return P = Math.max(0, Math.min(P, C - w)), {
            isScrolling: !0,
            scrollDirection: R.scrollOffset < O ? "forward" : "backward",
            scrollOffset: P,
            scrollUpdateWasRequested: !1
          };
        }, h._resetIsScrollingDebounced);
      }, h._onScrollVertical = function(m) {
        var q = m.currentTarget, w = q.clientHeight, O = q.scrollHeight, C = q.scrollTop;
        h.setState(function(R) {
          if (R.scrollOffset === C)
            return null;
          var I = Math.max(0, Math.min(C, O - w));
          return {
            isScrolling: !0,
            scrollDirection: R.scrollOffset < I ? "forward" : "backward",
            scrollOffset: I,
            scrollUpdateWasRequested: !1
          };
        }, h._resetIsScrollingDebounced);
      }, h._outerRefSetter = function(m) {
        var q = h.props.outerRef;
        h._outerRef = m, typeof q == "function" ? q(m) : q != null && typeof q == "object" && q.hasOwnProperty("current") && (q.current = m);
      }, h._resetIsScrollingDebounced = function() {
        h._resetIsScrollingTimeoutId !== null && H2(h._resetIsScrollingTimeoutId), h._resetIsScrollingTimeoutId = koe(h._resetIsScrolling, Woe);
      }, h._resetIsScrolling = function() {
        h._resetIsScrollingTimeoutId = null, h.setState({
          isScrolling: !1
        }, function() {
          h._getItemStyleCache(-1, null);
        });
      }, h;
    }
    c.getDerivedStateFromProps = function(h, m) {
      return Foe(h, m), l(h), null;
    };
    var p = c.prototype;
    return p.scrollTo = function(h) {
      h = Math.max(0, h), this.setState(function(m) {
        return m.scrollOffset === h ? null : {
          scrollDirection: m.scrollOffset < h ? "forward" : "backward",
          scrollOffset: h,
          scrollUpdateWasRequested: !0
        };
      }, this._resetIsScrollingDebounced);
    }, p.scrollToItem = function(h, m) {
      m === void 0 && (m = "auto");
      var q = this.props, w = q.itemCount, O = q.layout, C = this.state.scrollOffset;
      h = Math.max(0, Math.min(h, w - 1));
      var R = 0;
      if (this._outerRef) {
        var I = this._outerRef;
        O === "vertical" ? R = I.scrollWidth > I.clientWidth ? _2() : 0 : R = I.scrollHeight > I.clientHeight ? _2() : 0;
      }
      this.scrollTo(a(this.props, h, m, C, this._instanceProps, R));
    }, p.componentDidMount = function() {
      var h = this.props, m = h.direction, q = h.initialScrollOffset, w = h.layout;
      if (typeof q == "number" && this._outerRef != null) {
        var O = this._outerRef;
        m === "horizontal" || w === "horizontal" ? O.scrollLeft = q : O.scrollTop = q;
      }
      this._callPropsCallbacks();
    }, p.componentDidUpdate = function() {
      var h = this.props, m = h.direction, q = h.layout, w = this.state, O = w.scrollOffset, C = w.scrollUpdateWasRequested;
      if (C && this._outerRef != null) {
        var R = this._outerRef;
        if (m === "horizontal" || q === "horizontal")
          if (m === "rtl")
            switch ($2()) {
              case "negative":
                R.scrollLeft = -O;
                break;
              case "positive-ascending":
                R.scrollLeft = O;
                break;
              default:
                var I = R.clientWidth, P = R.scrollWidth;
                R.scrollLeft = P - I - O;
                break;
            }
          else
            R.scrollLeft = O;
        else
          R.scrollTop = O;
      }
      this._callPropsCallbacks();
    }, p.componentWillUnmount = function() {
      this._resetIsScrollingTimeoutId !== null && H2(this._resetIsScrollingTimeoutId);
    }, p.render = function() {
      var h = this.props, m = h.children, q = h.className, w = h.direction, O = h.height, C = h.innerRef, R = h.innerElementType, I = h.innerTagName, P = h.itemCount, K = h.itemData, B = h.itemKey, L = B === void 0 ? Soe : B, _ = h.layout, ne = h.outerElementType, Z = h.outerTagName, le = h.style, he = h.useIsScrolling, Ie = h.width, xe = this.state.isScrolling, ye = w === "horizontal" || _ === "horizontal", ue = ye ? this._onScrollHorizontal : this._onScrollVertical, M = this._getRangeToRender(), F = M[0], pe = M[1], We = [];
      if (P > 0)
        for (var ce = F; ce <= pe; ce++)
          We.push(Bo(m, {
            data: K,
            key: L(ce, K),
            index: ce,
            isScrolling: he ? xe : void 0,
            style: this._getItemStyle(ce)
          }));
      var oe = n(this.props, this._instanceProps);
      return Bo(ne || Z || "div", {
        className: q,
        onScroll: ue,
        ref: this._outerRefSetter,
        style: yt({
          position: "relative",
          height: O,
          width: Ie,
          overflow: "auto",
          WebkitOverflowScrolling: "touch",
          willChange: "transform",
          direction: w
        }, le)
      }, Bo(R || I || "div", {
        children: We,
        ref: C,
        style: {
          height: ye ? "100%" : oe,
          pointerEvents: xe ? "none" : void 0,
          width: ye ? oe : "100%"
        }
      }));
    }, p._callPropsCallbacks = function() {
      if (typeof this.props.onItemsRendered == "function") {
        var h = this.props.itemCount;
        if (h > 0) {
          var m = this._getRangeToRender(), q = m[0], w = m[1], O = m[2], C = m[3];
          this._callOnItemsRendered(q, w, O, C);
        }
      }
      if (typeof this.props.onScroll == "function") {
        var R = this.state, I = R.scrollDirection, P = R.scrollOffset, K = R.scrollUpdateWasRequested;
        this._callOnScroll(I, P, K);
      }
    }, p._getRangeToRender = function() {
      var h = this.props, m = h.itemCount, q = h.overscanCount, w = this.state, O = w.isScrolling, C = w.scrollDirection, R = w.scrollOffset;
      if (m === 0)
        return [0, 0, 0, 0];
      var I = s(this.props, R, this._instanceProps), P = o(this.props, I, R, this._instanceProps), K = !O || C === "backward" ? Math.max(1, q) : 1, B = !O || C === "forward" ? Math.max(1, q) : 1;
      return [Math.max(0, I - K), Math.max(0, Math.min(m - 1, P + B)), I, P];
    }, c;
  }(PT), t.defaultProps = {
    direction: "ltr",
    itemData: void 0,
    layout: "vertical",
    overscanCount: 2,
    useIsScrolling: !1
  }, t;
}
var Foe = function(t, r) {
  var n = t.children, i = t.direction, a = t.height, s = t.layout, o = t.innerTagName, u = t.outerTagName, f = t.width, l = r.instance;
  if (process.env.NODE_ENV !== "production") {
    (o != null || u != null) && uc && !uc.has(l) && (uc.add(l), console.warn("The innerTagName and outerTagName props have been deprecated. Please use the innerElementType and outerElementType props instead."));
    var d = i === "horizontal" || s === "horizontal";
    switch (i) {
      case "horizontal":
      case "vertical":
        oc && !oc.has(l) && (oc.add(l), console.warn('The direction prop should be either "ltr" (default) or "rtl". Please use the layout prop to specify "vertical" (default) or "horizontal" orientation.'));
        break;
      case "ltr":
      case "rtl":
        break;
      default:
        throw Error('An invalid "direction" prop has been specified. Value should be either "ltr" or "rtl". ' + ('"' + i + '" was specified.'));
    }
    switch (s) {
      case "horizontal":
      case "vertical":
        break;
      default:
        throw Error('An invalid "layout" prop has been specified. Value should be either "horizontal" or "vertical". ' + ('"' + s + '" was specified.'));
    }
    if (n == null)
      throw Error('An invalid "children" prop has been specified. Value should be a React component. ' + ('"' + (n === null ? "null" : typeof n) + '" was specified.'));
    if (d && typeof f != "number")
      throw Error('An invalid "width" prop has been specified. Horizontal lists must specify a number for width. ' + ('"' + (f === null ? "null" : typeof f) + '" was specified.'));
    if (!d && typeof a != "number")
      throw Error('An invalid "height" prop has been specified. Vertical lists must specify a number for height. ' + ('"' + (a === null ? "null" : typeof a) + '" was specified.'));
  }
}, sR = /* @__PURE__ */ Coe({
  getItemOffset: function(t, r) {
    var n = t.itemSize;
    return r * n;
  },
  getItemSize: function(t, r) {
    var n = t.itemSize;
    return n;
  },
  getEstimatedTotalSize: function(t) {
    var r = t.itemCount, n = t.itemSize;
    return n * r;
  },
  getOffsetForIndexAndAlignment: function(t, r, n, i, a, s) {
    var o = t.direction, u = t.height, f = t.itemCount, l = t.itemSize, d = t.layout, c = t.width, p = o === "horizontal" || d === "horizontal", v = p ? c : u, h = Math.max(0, f * l - v), m = Math.min(h, r * l), q = Math.max(0, r * l - v + l + s);
    switch (n === "smart" && (i >= q - v && i <= m + v ? n = "auto" : n = "center"), n) {
      case "start":
        return m;
      case "end":
        return q;
      case "center": {
        var w = Math.round(q + (m - q) / 2);
        return w < Math.ceil(v / 2) ? 0 : w > h + Math.floor(v / 2) ? h : w;
      }
      case "auto":
      default:
        return i >= q && i <= m ? i : i < q ? q : m;
    }
  },
  getStartIndexForOffset: function(t, r) {
    var n = t.itemCount, i = t.itemSize;
    return Math.max(0, Math.min(n - 1, Math.floor(r / i)));
  },
  getStopIndexForStartIndex: function(t, r, n) {
    var i = t.direction, a = t.height, s = t.itemCount, o = t.itemSize, u = t.layout, f = t.width, l = i === "horizontal" || u === "horizontal", d = r * o, c = l ? f : a, p = Math.ceil((c + n - d) / o);
    return Math.max(0, Math.min(
      s - 1,
      r + p - 1
      // -1 is because stop index is inclusive
    ));
  },
  initInstanceProps: function(t) {
  },
  shouldResetStyleCacheOnItemSizeChange: !0,
  validateProps: function(t) {
    var r = t.itemSize;
    if (process.env.NODE_ENV !== "production" && typeof r != "number")
      throw Error('An invalid "itemSize" prop has been specified. Value should be a number. ' + ('"' + (r === null ? "null" : typeof r) + '" was specified.'));
  }
});
let fi;
typeof window < "u" ? fi = window : typeof self < "u" ? fi = self : fi = global;
let Rg = null, Tg = null;
const eW = 20, P1 = fi.clearTimeout, tW = fi.setTimeout, B1 = fi.cancelAnimationFrame || fi.mozCancelAnimationFrame || fi.webkitCancelAnimationFrame, rW = fi.requestAnimationFrame || fi.mozRequestAnimationFrame || fi.webkitRequestAnimationFrame;
B1 == null || rW == null ? (Rg = P1, Tg = function(t) {
  return tW(t, eW);
}) : (Rg = function([t, r]) {
  B1(t), P1(r);
}, Tg = function(t) {
  const r = rW(function() {
    P1(n), t();
  }), n = tW(function() {
    B1(r), t();
  }, eW);
  return [r, n];
});
function Koe(e) {
  let t, r, n, i, a, s, o;
  const u = typeof document < "u" && document.attachEvent;
  if (!u) {
    s = function(q) {
      const w = q.__resizeTriggers__, O = w.firstElementChild, C = w.lastElementChild, R = O.firstElementChild;
      C.scrollLeft = C.scrollWidth, C.scrollTop = C.scrollHeight, R.style.width = O.offsetWidth + 1 + "px", R.style.height = O.offsetHeight + 1 + "px", O.scrollLeft = O.scrollWidth, O.scrollTop = O.scrollHeight;
    }, a = function(q) {
      return q.offsetWidth !== q.__resizeLast__.width || q.offsetHeight !== q.__resizeLast__.height;
    }, o = function(q) {
      if (q.target.className && typeof q.target.className.indexOf == "function" && q.target.className.indexOf("contract-trigger") < 0 && q.target.className.indexOf("expand-trigger") < 0)
        return;
      const w = this;
      s(this), this.__resizeRAF__ && Rg(this.__resizeRAF__), this.__resizeRAF__ = Tg(function() {
        a(w) && (w.__resizeLast__.width = w.offsetWidth, w.__resizeLast__.height = w.offsetHeight, w.__resizeListeners__.forEach(function(R) {
          R.call(w, q);
        }));
      });
    };
    let c = !1, p = "";
    n = "animationstart";
    const v = "Webkit Moz O ms".split(" ");
    let h = "webkitAnimationStart animationstart oAnimationStart MSAnimationStart".split(" "), m = "";
    {
      const q = document.createElement("fakeelement");
      if (q.style.animationName !== void 0 && (c = !0), c === !1) {
        for (let w = 0; w < v.length; w++)
          if (q.style[v[w] + "AnimationName"] !== void 0) {
            m = v[w], p = "-" + m.toLowerCase() + "-", n = h[w], c = !0;
            break;
          }
      }
    }
    r = "resizeanim", t = "@" + p + "keyframes " + r + " { from { opacity: 0; } to { opacity: 0; } } ", i = p + "animation: 1ms " + r + "; ";
  }
  const f = function(c) {
    if (!c.getElementById("detectElementResize")) {
      const p = (t || "") + ".resize-triggers { " + (i || "") + 'visibility: hidden; opacity: 0; } .resize-triggers, .resize-triggers > div, .contract-trigger:before { content: " "; display: block; position: absolute; top: 0; left: 0; height: 100%; width: 100%; overflow: hidden; z-index: -1; } .resize-triggers > div { background: #eee; overflow: auto; } .contract-trigger:before { width: 200%; height: 200%; }', v = c.head || c.getElementsByTagName("head")[0], h = c.createElement("style");
      h.id = "detectElementResize", h.type = "text/css", e != null && h.setAttribute("nonce", e), h.styleSheet ? h.styleSheet.cssText = p : h.appendChild(c.createTextNode(p)), v.appendChild(h);
    }
  };
  return {
    addResizeListener: function(c, p) {
      if (u)
        c.attachEvent("onresize", p);
      else {
        if (!c.__resizeTriggers__) {
          const v = c.ownerDocument, h = fi.getComputedStyle(c);
          h && h.position === "static" && (c.style.position = "relative"), f(v), c.__resizeLast__ = {}, c.__resizeListeners__ = [], (c.__resizeTriggers__ = v.createElement("div")).className = "resize-triggers";
          const m = v.createElement("div");
          m.className = "expand-trigger", m.appendChild(v.createElement("div"));
          const q = v.createElement("div");
          q.className = "contract-trigger", c.__resizeTriggers__.appendChild(m), c.__resizeTriggers__.appendChild(q), c.appendChild(c.__resizeTriggers__), s(c), c.addEventListener("scroll", o, !0), n && (c.__resizeTriggers__.__animationListener__ = function(O) {
            O.animationName === r && s(c);
          }, c.__resizeTriggers__.addEventListener(n, c.__resizeTriggers__.__animationListener__));
        }
        c.__resizeListeners__.push(p);
      }
    },
    removeResizeListener: function(c, p) {
      if (u)
        c.detachEvent("onresize", p);
      else if (c.__resizeListeners__.splice(c.__resizeListeners__.indexOf(p), 1), !c.__resizeListeners__.length) {
        c.removeEventListener("scroll", o, !0), c.__resizeTriggers__.__animationListener__ && (c.__resizeTriggers__.removeEventListener(n, c.__resizeTriggers__.__animationListener__), c.__resizeTriggers__.__animationListener__ = null);
        try {
          c.__resizeTriggers__ = !c.removeChild(c.__resizeTriggers__);
        } catch {
        }
      }
    }
  };
}
class oR extends B6 {
  constructor(...t) {
    super(...t), this.state = {
      height: this.props.defaultHeight || 0,
      scaledHeight: this.props.defaultHeight || 0,
      scaledWidth: this.props.defaultWidth || 0,
      width: this.props.defaultWidth || 0
    }, this._autoSizer = null, this._detectElementResize = null, this._parentNode = null, this._resizeObserver = null, this._timeoutId = null, this._onResize = () => {
      this._timeoutId = null;
      const {
        disableHeight: r,
        disableWidth: n,
        onResize: i
      } = this.props;
      if (this._parentNode) {
        var a, s, o, u;
        const f = window.getComputedStyle(this._parentNode) || {}, l = parseFloat((a = f.paddingLeft) !== null && a !== void 0 ? a : "0"), d = parseFloat((s = f.paddingRight) !== null && s !== void 0 ? s : "0"), c = parseFloat((o = f.paddingTop) !== null && o !== void 0 ? o : "0"), p = parseFloat((u = f.paddingBottom) !== null && u !== void 0 ? u : "0"), v = this._parentNode.getBoundingClientRect(), h = v.height - c - p, m = v.width - l - d, q = this._parentNode.offsetHeight - c - p, w = this._parentNode.offsetWidth - l - d;
        (!r && (this.state.height !== q || this.state.scaledHeight !== h) || !n && (this.state.width !== w || this.state.scaledWidth !== m)) && (this.setState({
          height: q,
          width: w,
          scaledHeight: h,
          scaledWidth: m
        }), typeof i == "function" && i({
          height: q,
          scaledHeight: h,
          scaledWidth: m,
          width: w
        }));
      }
    }, this._setRef = (r) => {
      this._autoSizer = r;
    };
  }
  componentDidMount() {
    const {
      nonce: t
    } = this.props;
    this._autoSizer && this._autoSizer.parentNode && this._autoSizer.parentNode.ownerDocument && this._autoSizer.parentNode.ownerDocument.defaultView && this._autoSizer.parentNode instanceof this._autoSizer.parentNode.ownerDocument.defaultView.HTMLElement && (this._parentNode = this._autoSizer.parentNode, this._parentNode != null && (typeof ResizeObserver < "u" ? (this._resizeObserver = new ResizeObserver(() => {
      this._timeoutId = setTimeout(this._onResize, 0);
    }), this._resizeObserver.observe(this._parentNode)) : (this._detectElementResize = Koe(t), this._detectElementResize.addResizeListener(this._parentNode, this._onResize)), this._onResize()));
  }
  componentWillUnmount() {
    this._parentNode && (this._detectElementResize && this._detectElementResize.removeResizeListener(this._parentNode, this._onResize), this._timeoutId !== null && clearTimeout(this._timeoutId), this._resizeObserver && (this._resizeObserver.observe(this._parentNode), this._resizeObserver.disconnect()));
  }
  render() {
    const {
      children: t,
      defaultHeight: r,
      defaultWidth: n,
      disableHeight: i = !1,
      disableWidth: a = !1,
      nonce: s,
      onResize: o,
      style: u = {},
      tagName: f = "div",
      ...l
    } = this.props, {
      height: d,
      scaledHeight: c,
      scaledWidth: p,
      width: v
    } = this.state, h = {
      overflow: "visible"
    }, m = {};
    let q = !1;
    return i || (d === 0 && (q = !0), h.height = 0, m.height = d, m.scaledHeight = c), a || (v === 0 && (q = !0), h.width = 0, m.width = v, m.scaledWidth = p), Bo(f, {
      ref: this._setRef,
      style: {
        ...h,
        ...u
      },
      ...l
    }, !q && t(m));
  }
}
const dq = ({ firstName: e, lastName: t, fullName: r, pictureUrl: n, large: i }) => {
  const a = uO(e, t);
  return /* @__PURE__ */ j(ey, { alt: r, src: n, sx: { bgcolor: (o) => o.palette.primary.main, fontSize: 20, ...i ? { width: 62, height: 62 } : {} }, children: a });
}, Roe = {
  ADD_PARTICIPANTS: "Add participants",
  ADD_USER: "Add participant",
  CANCEL: "Cancel",
  CREATE_CONVERSATION: "Create conversation",
  DELETE_CONVERSATION_MODAL_CONTENT: "Are you sure you want to delete this conversation?",
  DELETE_CONVERSATION: "Delete conversation",
  DELETE: "Delete",
  DONE: "Done",
  DUPLICATED_DIRECT_CONVERSATION: "A conversion with this participant already exists",
  EDIT: "Edit",
  FAVORITE: "Add to favorites",
  FILES: "Recent files",
  LEAVE_CONVERSATION_MODAL_CONTENT: "Are you sure you want to leave this conversation?",
  LEAVE_CONVERSATION: "Leave conversation",
  LEAVE: "Leave",
  NAME_YOUR_CONVERSATION: "Name your conversation here",
  NEW_CONVERSATION: "New conversation",
  NEW_MESSAGES: "New messages",
  NO_ATTACHMENTS: "No attachments have been shared yet in this conversation",
  NO_CONVERSATIONS: "You haven't started any conversations yet, create a conversation to send messages",
  ON: "on",
  PARTICIPANTS: "Participants",
  SEARCH: "Search here",
  SEE_CONVERSATION: "See conversation",
  SEND: "Send",
  SHARED_BY: "Shared by",
  UNFAVORITE: "Remove from favorites",
  WRITE_MESSAGE: "Write a message",
  typing_one: "is typing",
  typing_other: "are typing",
  RELOAD: "Reload"
}, Toe = {
  ADD_PARTICIPANTS: "Ajouter participants",
  ADD_USER: "Ajouter un participant",
  CANCEL: "Annuler",
  CREATE_CONVERSATION: "Créer une conversation",
  DELETE_CONVERSATION_MODAL_CONTENT: "Êtes-vous sûr de vouloir supprimer cette conversation?",
  DELETE_CONVERSATION: "Supprimer la conversation",
  DELETE: "Supprimer",
  DONE: "Sauvegarder",
  DUPLICATED_DIRECT_CONVERSATION: "Une conversation avec ce participant existe déjà",
  EDIT: "Modifier",
  FAVORITE: "Ajouter aux favoris",
  FILES: "Fichiers récents",
  LEAVE_CONVERSATION_MODAL_CONTENT: "Êtes-vous sûr de vouloir quitter cette conversation?",
  LEAVE_CONVERSATION: "Quitter la conversation",
  LEAVE: "Quitter",
  NAME_YOUR_CONVERSATION: "Nommez votre conversation ici",
  NEW_CONVERSATION: "Nouvelle conversation",
  NEW_MESSAGES: "Nouveaux messages",
  NO_ATTACHMENTS: "Aucun fichier n'a été partagé dans cette conversation",
  NO_CONVERSATIONS: "Vous n'avez pas encore débuté de conversation, créez une conversation pour envoyer des messages",
  ON: "le",
  PARTICIPANTS: "Participants",
  SEARCH: "Recherchez ici",
  SEE_CONVERSATION: "Voir la conversation",
  SEND: "Envoyer",
  SHARED_BY: "Partagé par",
  UNFAVORITE: "Retirer des favoris",
  WRITE_MESSAGE: "Écrire un message",
  typing_one: "est en train d'écrire",
  typing_other: "sont en train d'écrire",
  RELOAD: "Recharger"
}, nv = "chat";
sp.use(qU).init({
  fallbackLng: "en",
  interpolation: { escapeValue: !1 }
});
sp.loadNamespaces(nv);
sp.addResourceBundle("en", nv, { ...Roe });
sp.addResourceBundle("fr", nv, { ...Toe });
const Ur = () => {
  const { t: e, i18n: t } = bU(nv), [r] = t.language.split("-"), n = r.toLowerCase() === "fr" ? "fr" : "en";
  return { t: e, currentLanguage: n };
}, iv = ({ actions: e, handleClose: t, open: r, title: n, content: i }) => {
  const { t: a } = Ur();
  return /* @__PURE__ */ ut(
    L6,
    {
      open: r,
      onClose: t,
      container: () => document.querySelector("#screen-container"),
      sx: {
        position: "absolute",
        "& .MuiPaper-root": { boxShadow: "0px 0px 28px -7px rgba(0,0,0,0.1)", paddingBottom: 0 },
        "& .MuiBackdrop-root": { bgcolor: "rgba(0, 0, 0, 0.05)", position: "absolute" }
      },
      children: [
        n ? /* @__PURE__ */ j(GT, { variant: "inherit", fontWeight: "600", align: "center", children: n }) : null,
        i ? /* @__PURE__ */ j(QT, { children: /* @__PURE__ */ j(br, { variant: "body2", align: "center", sx: { wordBreak: "break-word" }, children: i }) }) : null,
        /* @__PURE__ */ ut(hc, { disablePadding: !0, children: [
          /* @__PURE__ */ j(ty, {}),
          e.map((s) => /* @__PURE__ */ j(
            Zf,
            {
              disableRipple: !0,
              onClick: () => {
                s.onClick && s.onClick(), t();
              },
              sx: { justifyContent: "center", paddingY: 1 },
              divider: !0,
              children: /* @__PURE__ */ j(br, { noWrap: !0, variant: "subtitle2", fontWeight: "600", color: s.danger ? "error" : "inherit", children: s.text })
            },
            s.text
          )),
          /* @__PURE__ */ j(Zf, { disableRipple: !0, sx: { justifyContent: "center", paddingTop: 1 }, onClick: t, children: /* @__PURE__ */ j(br, { noWrap: !0, variant: "subtitle2", sx: { color: (s) => s.palette.grey[500] }, children: a("CANCEL") }) })
        ] })
      ]
    }
  );
}, Uoe = (e) => /* @__PURE__ */ j(
  ry,
  {
    ...e,
    deleteIcon: /* @__PURE__ */ j(wu, {}),
    sx: {
      margin: ".2rem",
      borderRadius: "4px",
      "& .MuiChip-deleteIcon": {
        color: (t) => t.palette.grey[500],
        fontSize: "1.1rem",
        marginLeft: 0.1
      }
    }
  }
), cq = ({ type: e, participants: t, iconSize: r, large: n, ...i }) => {
  const a = t.length === 1 || e === "direct", s = n ? { width: 60, height: 60 } : {};
  if (a) {
    const { firstName: o, lastName: u, fullName: f, picture: l } = t[0];
    return /* @__PURE__ */ j(dq, { firstName: o, lastName: u, fullName: f, pictureUrl: l == null ? void 0 : l.url, large: n, ...i });
  }
  return /* @__PURE__ */ j(ey, { ...i, sx: { bgcolor: (o) => o.palette.grey[200], color: (o) => o.palette.grey[500], ...s }, children: /* @__PURE__ */ j(iU, { size: n ? "lg" : "sm" }) });
}, xoe = ({ actions: e, handleClose: t, open: r }) => {
  const { t: n } = Ur();
  return /* @__PURE__ */ ut(
    L6,
    {
      open: r,
      onClose: t,
      TransitionComponent: Eoe,
      fullWidth: !0,
      sx: {
        "& .MuiPaper-root": { position: "absolute", bottom: "0px", bgcolor: "transparent", boxShadow: "0px 0px 28px -7px rgba(0,0,0,0.1)" },
        "& .MuiBackdrop-root": { bgcolor: "rgba(0, 0, 0, 0.05)" }
      },
      children: [
        /* @__PURE__ */ j(
          hc,
          {
            disablePadding: !0,
            sx: {
              bgcolor: "white",
              borderRadius: "4px",
              boxShadow: "0px 0px 28px -7px rgba(0,0,0,0.1)"
            },
            children: e.map((i, a) => /* @__PURE__ */ ut(gr, { children: [
              /* @__PURE__ */ j(
                Zf,
                {
                  disableRipple: !0,
                  onClick: () => {
                    i.onClick(), t();
                  },
                  sx: { justifyContent: "center", paddingY: 1 },
                  children: /* @__PURE__ */ j(br, { noWrap: !0, variant: "subtitle2", color: i.danger ? "error" : "inherit", children: i.text })
                }
              ),
              a !== e.length - 1 ? /* @__PURE__ */ j(ty, {}) : null
            ] }, i.text))
          }
        ),
        /* @__PURE__ */ j(
          hc,
          {
            disablePadding: !0,
            sx: {
              marginTop: 1,
              bgcolor: "white",
              borderRadius: "4px",
              boxShadow: "0px 10px 33px -13px rgba(0,0,0,0.1)"
            },
            children: /* @__PURE__ */ j(Zf, { disableRipple: !0, sx: { justifyContent: "center", paddingY: 1 }, onClick: t, children: /* @__PURE__ */ j(br, { noWrap: !0, variant: "subtitle2", sx: { color: (i) => i.palette.grey[500] }, children: n("CANCEL") }) })
          }
        )
      ]
    }
  );
}, Eoe = $g(function(t, r) {
  return /* @__PURE__ */ j(JT, { direction: "up", ref: r, ...t, timeout: 500 });
}), Ooe = ({ name: e, setName: t }) => {
  const { t: r } = Ur(), n = e || r("NAME_YOUR_CONVERSATION"), [i, a] = ir(!1), s = (u) => {
    const f = u.target.value.trim();
    t(f);
  }, o = n.length * 10;
  return /* @__PURE__ */ j("div", { onClick: () => a((u) => !u), children: i ? /* @__PURE__ */ j(
    ll,
    {
      sx: {
        fieldset: { border: "none" },
        input: {
          fontSize: (u) => u.typography.subtitle2.fontSize,
          fontWeight: (u) => u.typography.subtitle2.fontWeight,
          padding: 0
        },
        width: o,
        maxWidth: "100%"
      },
      type: "text",
      name: "conversation-name",
      placeholder: n,
      onChange: s,
      autoFocus: !0,
      onBlur: () => a(!1),
      onKeyDown: (u) => {
        u.key === "Enter" && a(!1);
      }
    }
  ) : /* @__PURE__ */ j(br, { variant: "subtitle2", noWrap: !0, sx: { maxWidth: "100%" }, children: n }) });
}, Noe = {
  black: "#000",
  white: "#fff"
}, al = Noe, Ioe = {
  50: "#ffebee",
  100: "#ffcdd2",
  200: "#ef9a9a",
  300: "#e57373",
  400: "#ef5350",
  500: "#f44336",
  600: "#e53935",
  700: "#d32f2f",
  800: "#c62828",
  900: "#b71c1c",
  A100: "#ff8a80",
  A200: "#ff5252",
  A400: "#ff1744",
  A700: "#d50000"
}, Ko = Ioe, Xoe = {
  50: "#f3e5f5",
  100: "#e1bee7",
  200: "#ce93d8",
  300: "#ba68c8",
  400: "#ab47bc",
  500: "#9c27b0",
  600: "#8e24aa",
  700: "#7b1fa2",
  800: "#6a1b9a",
  900: "#4a148c",
  A100: "#ea80fc",
  A200: "#e040fb",
  A400: "#d500f9",
  A700: "#aa00ff"
}, Ro = Xoe, Poe = {
  50: "#e3f2fd",
  100: "#bbdefb",
  200: "#90caf9",
  300: "#64b5f6",
  400: "#42a5f5",
  500: "#2196f3",
  600: "#1e88e5",
  700: "#1976d2",
  800: "#1565c0",
  900: "#0d47a1",
  A100: "#82b1ff",
  A200: "#448aff",
  A400: "#2979ff",
  A700: "#2962ff"
}, To = Poe, Boe = {
  50: "#e1f5fe",
  100: "#b3e5fc",
  200: "#81d4fa",
  300: "#4fc3f7",
  400: "#29b6f6",
  500: "#03a9f4",
  600: "#039be5",
  700: "#0288d1",
  800: "#0277bd",
  900: "#01579b",
  A100: "#80d8ff",
  A200: "#40c4ff",
  A400: "#00b0ff",
  A700: "#0091ea"
}, Uo = Boe, Doe = {
  50: "#e8f5e9",
  100: "#c8e6c9",
  200: "#a5d6a7",
  300: "#81c784",
  400: "#66bb6a",
  500: "#4caf50",
  600: "#43a047",
  700: "#388e3c",
  800: "#2e7d32",
  900: "#1b5e20",
  A100: "#b9f6ca",
  A200: "#69f0ae",
  A400: "#00e676",
  A700: "#00c853"
}, Us = Doe, Loe = {
  50: "#fffde7",
  100: "#fff9c4",
  200: "#fff59d",
  300: "#fff176",
  400: "#ffee58",
  500: "#ffeb3b",
  600: "#fdd835",
  700: "#fbc02d",
  800: "#f9a825",
  900: "#f57f17",
  A100: "#ffff8d",
  A200: "#ffff00",
  A400: "#ffea00",
  A700: "#ffd600"
}, uR = Loe, Zoe = {
  50: "#fff3e0",
  100: "#ffe0b2",
  200: "#ffcc80",
  300: "#ffb74d",
  400: "#ffa726",
  500: "#ff9800",
  600: "#fb8c00",
  700: "#f57c00",
  800: "#ef6c00",
  900: "#e65100",
  A100: "#ffd180",
  A200: "#ffab40",
  A400: "#ff9100",
  A700: "#ff6d00"
}, bf = Zoe, Moe = {
  50: "#fafafa",
  100: "#f5f5f5",
  200: "#eeeeee",
  300: "#e0e0e0",
  400: "#bdbdbd",
  500: "#9e9e9e",
  600: "#757575",
  700: "#616161",
  800: "#424242",
  900: "#212121",
  A100: "#f5f5f5",
  A200: "#eeeeee",
  A400: "#bdbdbd",
  A700: "#616161"
}, joe = Moe;
function Yoe(e, t) {
  return process.env.NODE_ENV === "production" ? () => null : function(...n) {
    return e(...n) || t(...n);
  };
}
function Os(e) {
  return e !== null && typeof e == "object" && e.constructor === Object;
}
function fR(e) {
  if (!Os(e))
    return e;
  const t = {};
  return Object.keys(e).forEach((r) => {
    t[r] = fR(e[r]);
  }), t;
}
function ha(e, t, r = {
  clone: !0
}) {
  const n = r.clone ? yt({}, e) : e;
  return Os(e) && Os(t) && Object.keys(t).forEach((i) => {
    i !== "__proto__" && (Os(t[i]) && i in e && Os(e[i]) ? n[i] = ha(e[i], t[i], r) : r.clone ? n[i] = Os(t[i]) ? fR(t[i]) : t[i] : n[i] = t[i]);
  }), n;
}
var Ug = { exports: {} };
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var D1, nW;
function zoe() {
  if (nW)
    return D1;
  nW = 1;
  var e = Object.getOwnPropertySymbols, t = Object.prototype.hasOwnProperty, r = Object.prototype.propertyIsEnumerable;
  function n(a) {
    if (a == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(a);
  }
  function i() {
    try {
      if (!Object.assign)
        return !1;
      var a = new String("abc");
      if (a[5] = "de", Object.getOwnPropertyNames(a)[0] === "5")
        return !1;
      for (var s = {}, o = 0; o < 10; o++)
        s["_" + String.fromCharCode(o)] = o;
      var u = Object.getOwnPropertyNames(s).map(function(l) {
        return s[l];
      });
      if (u.join("") !== "0123456789")
        return !1;
      var f = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(l) {
        f[l] = l;
      }), Object.keys(Object.assign({}, f)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return D1 = i() ? Object.assign : function(a, s) {
    for (var o, u = n(a), f, l = 1; l < arguments.length; l++) {
      o = Object(arguments[l]);
      for (var d in o)
        t.call(o, d) && (u[d] = o[d]);
      if (e) {
        f = e(o);
        for (var c = 0; c < f.length; c++)
          r.call(o, f[c]) && (u[f[c]] = o[f[c]]);
      }
    }
    return u;
  }, D1;
}
var L1, iW;
function pq() {
  if (iW)
    return L1;
  iW = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return L1 = e, L1;
}
var Z1, aW;
function lR() {
  return aW || (aW = 1, Z1 = Function.call.bind(Object.prototype.hasOwnProperty)), Z1;
}
var M1, sW;
function Goe() {
  if (sW)
    return M1;
  sW = 1;
  var e = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var t = pq(), r = {}, n = lR();
    e = function(a) {
      var s = "Warning: " + a;
      typeof console < "u" && console.error(s);
      try {
        throw new Error(s);
      } catch {
      }
    };
  }
  function i(a, s, o, u, f) {
    if (process.env.NODE_ENV !== "production") {
      for (var l in a)
        if (n(a, l)) {
          var d;
          try {
            if (typeof a[l] != "function") {
              var c = Error(
                (u || "React class") + ": " + o + " type `" + l + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof a[l] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw c.name = "Invariant Violation", c;
            }
            d = a[l](s, l, u, o, null, t);
          } catch (v) {
            d = v;
          }
          if (d && !(d instanceof Error) && e(
            (u || "React class") + ": type specification of " + o + " `" + l + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof d + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), d instanceof Error && !(d.message in r)) {
            r[d.message] = !0;
            var p = f ? f() : "";
            e(
              "Failed " + o + " type: " + d.message + (p ?? "")
            );
          }
        }
    }
  }
  return i.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (r = {});
  }, M1 = i, M1;
}
var j1, oW;
function Qoe() {
  if (oW)
    return j1;
  oW = 1;
  var e = oy, t = zoe(), r = pq(), n = lR(), i = Goe(), a = function() {
  };
  process.env.NODE_ENV !== "production" && (a = function(o) {
    var u = "Warning: " + o;
    typeof console < "u" && console.error(u);
    try {
      throw new Error(u);
    } catch {
    }
  });
  function s() {
    return null;
  }
  return j1 = function(o, u) {
    var f = typeof Symbol == "function" && Symbol.iterator, l = "@@iterator";
    function d(M) {
      var F = M && (f && M[f] || M[l]);
      if (typeof F == "function")
        return F;
    }
    var c = "<<anonymous>>", p = {
      array: q("array"),
      bigint: q("bigint"),
      bool: q("boolean"),
      func: q("function"),
      number: q("number"),
      object: q("object"),
      string: q("string"),
      symbol: q("symbol"),
      any: w(),
      arrayOf: O,
      element: C(),
      elementType: R(),
      instanceOf: I,
      node: L(),
      objectOf: K,
      oneOf: P,
      oneOfType: B,
      shape: ne,
      exact: Z
    };
    function v(M, F) {
      return M === F ? M !== 0 || 1 / M === 1 / F : M !== M && F !== F;
    }
    function h(M, F) {
      this.message = M, this.data = F && typeof F == "object" ? F : {}, this.stack = "";
    }
    h.prototype = Error.prototype;
    function m(M) {
      if (process.env.NODE_ENV !== "production")
        var F = {}, pe = 0;
      function We(oe, z, Ze, Ae, re, Qe, Ee) {
        if (Ae = Ae || c, Qe = Qe || Ze, Ee !== r) {
          if (u) {
            var Ue = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw Ue.name = "Invariant Violation", Ue;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var He = Ae + ":" + Ze;
            !F[He] && // Avoid spamming the console because they are often not actionable except for lib authors
            pe < 3 && (a(
              "You are manually calling a React.PropTypes validation function for the `" + Qe + "` prop on `" + Ae + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), F[He] = !0, pe++);
          }
        }
        return z[Ze] == null ? oe ? z[Ze] === null ? new h("The " + re + " `" + Qe + "` is marked as required " + ("in `" + Ae + "`, but its value is `null`.")) : new h("The " + re + " `" + Qe + "` is marked as required in " + ("`" + Ae + "`, but its value is `undefined`.")) : null : M(z, Ze, Ae, re, Qe);
      }
      var ce = We.bind(null, !1);
      return ce.isRequired = We.bind(null, !0), ce;
    }
    function q(M) {
      function F(pe, We, ce, oe, z, Ze) {
        var Ae = pe[We], re = Ie(Ae);
        if (re !== M) {
          var Qe = xe(Ae);
          return new h(
            "Invalid " + oe + " `" + z + "` of type " + ("`" + Qe + "` supplied to `" + ce + "`, expected ") + ("`" + M + "`."),
            { expectedType: M }
          );
        }
        return null;
      }
      return m(F);
    }
    function w() {
      return m(s);
    }
    function O(M) {
      function F(pe, We, ce, oe, z) {
        if (typeof M != "function")
          return new h("Property `" + z + "` of component `" + ce + "` has invalid PropType notation inside arrayOf.");
        var Ze = pe[We];
        if (!Array.isArray(Ze)) {
          var Ae = Ie(Ze);
          return new h("Invalid " + oe + " `" + z + "` of type " + ("`" + Ae + "` supplied to `" + ce + "`, expected an array."));
        }
        for (var re = 0; re < Ze.length; re++) {
          var Qe = M(Ze, re, ce, oe, z + "[" + re + "]", r);
          if (Qe instanceof Error)
            return Qe;
        }
        return null;
      }
      return m(F);
    }
    function C() {
      function M(F, pe, We, ce, oe) {
        var z = F[pe];
        if (!o(z)) {
          var Ze = Ie(z);
          return new h("Invalid " + ce + " `" + oe + "` of type " + ("`" + Ze + "` supplied to `" + We + "`, expected a single ReactElement."));
        }
        return null;
      }
      return m(M);
    }
    function R() {
      function M(F, pe, We, ce, oe) {
        var z = F[pe];
        if (!e.isValidElementType(z)) {
          var Ze = Ie(z);
          return new h("Invalid " + ce + " `" + oe + "` of type " + ("`" + Ze + "` supplied to `" + We + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return m(M);
    }
    function I(M) {
      function F(pe, We, ce, oe, z) {
        if (!(pe[We] instanceof M)) {
          var Ze = M.name || c, Ae = ue(pe[We]);
          return new h("Invalid " + oe + " `" + z + "` of type " + ("`" + Ae + "` supplied to `" + ce + "`, expected ") + ("instance of `" + Ze + "`."));
        }
        return null;
      }
      return m(F);
    }
    function P(M) {
      if (!Array.isArray(M))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? a(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : a("Invalid argument supplied to oneOf, expected an array.")), s;
      function F(pe, We, ce, oe, z) {
        for (var Ze = pe[We], Ae = 0; Ae < M.length; Ae++)
          if (v(Ze, M[Ae]))
            return null;
        var re = JSON.stringify(M, function(Ee, Ue) {
          var He = xe(Ue);
          return He === "symbol" ? String(Ue) : Ue;
        });
        return new h("Invalid " + oe + " `" + z + "` of value `" + String(Ze) + "` " + ("supplied to `" + ce + "`, expected one of " + re + "."));
      }
      return m(F);
    }
    function K(M) {
      function F(pe, We, ce, oe, z) {
        if (typeof M != "function")
          return new h("Property `" + z + "` of component `" + ce + "` has invalid PropType notation inside objectOf.");
        var Ze = pe[We], Ae = Ie(Ze);
        if (Ae !== "object")
          return new h("Invalid " + oe + " `" + z + "` of type " + ("`" + Ae + "` supplied to `" + ce + "`, expected an object."));
        for (var re in Ze)
          if (n(Ze, re)) {
            var Qe = M(Ze, re, ce, oe, z + "." + re, r);
            if (Qe instanceof Error)
              return Qe;
          }
        return null;
      }
      return m(F);
    }
    function B(M) {
      if (!Array.isArray(M))
        return process.env.NODE_ENV !== "production" && a("Invalid argument supplied to oneOfType, expected an instance of array."), s;
      for (var F = 0; F < M.length; F++) {
        var pe = M[F];
        if (typeof pe != "function")
          return a(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + ye(pe) + " at index " + F + "."
          ), s;
      }
      function We(ce, oe, z, Ze, Ae) {
        for (var re = [], Qe = 0; Qe < M.length; Qe++) {
          var Ee = M[Qe], Ue = Ee(ce, oe, z, Ze, Ae, r);
          if (Ue == null)
            return null;
          Ue.data && n(Ue.data, "expectedType") && re.push(Ue.data.expectedType);
        }
        var He = re.length > 0 ? ", expected one of type [" + re.join(", ") + "]" : "";
        return new h("Invalid " + Ze + " `" + Ae + "` supplied to " + ("`" + z + "`" + He + "."));
      }
      return m(We);
    }
    function L() {
      function M(F, pe, We, ce, oe) {
        return le(F[pe]) ? null : new h("Invalid " + ce + " `" + oe + "` supplied to " + ("`" + We + "`, expected a ReactNode."));
      }
      return m(M);
    }
    function _(M, F, pe, We, ce) {
      return new h(
        (M || "React class") + ": " + F + " type `" + pe + "." + We + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + ce + "`."
      );
    }
    function ne(M) {
      function F(pe, We, ce, oe, z) {
        var Ze = pe[We], Ae = Ie(Ze);
        if (Ae !== "object")
          return new h("Invalid " + oe + " `" + z + "` of type `" + Ae + "` " + ("supplied to `" + ce + "`, expected `object`."));
        for (var re in M) {
          var Qe = M[re];
          if (typeof Qe != "function")
            return _(ce, oe, z, re, xe(Qe));
          var Ee = Qe(Ze, re, ce, oe, z + "." + re, r);
          if (Ee)
            return Ee;
        }
        return null;
      }
      return m(F);
    }
    function Z(M) {
      function F(pe, We, ce, oe, z) {
        var Ze = pe[We], Ae = Ie(Ze);
        if (Ae !== "object")
          return new h("Invalid " + oe + " `" + z + "` of type `" + Ae + "` " + ("supplied to `" + ce + "`, expected `object`."));
        var re = t({}, pe[We], M);
        for (var Qe in re) {
          var Ee = M[Qe];
          if (n(M, Qe) && typeof Ee != "function")
            return _(ce, oe, z, Qe, xe(Ee));
          if (!Ee)
            return new h(
              "Invalid " + oe + " `" + z + "` key `" + Qe + "` supplied to `" + ce + "`.\nBad object: " + JSON.stringify(pe[We], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(M), null, "  ")
            );
          var Ue = Ee(Ze, Qe, ce, oe, z + "." + Qe, r);
          if (Ue)
            return Ue;
        }
        return null;
      }
      return m(F);
    }
    function le(M) {
      switch (typeof M) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !M;
        case "object":
          if (Array.isArray(M))
            return M.every(le);
          if (M === null || o(M))
            return !0;
          var F = d(M);
          if (F) {
            var pe = F.call(M), We;
            if (F !== M.entries) {
              for (; !(We = pe.next()).done; )
                if (!le(We.value))
                  return !1;
            } else
              for (; !(We = pe.next()).done; ) {
                var ce = We.value;
                if (ce && !le(ce[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function he(M, F) {
      return M === "symbol" ? !0 : F ? F["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && F instanceof Symbol : !1;
    }
    function Ie(M) {
      var F = typeof M;
      return Array.isArray(M) ? "array" : M instanceof RegExp ? "object" : he(F, M) ? "symbol" : F;
    }
    function xe(M) {
      if (typeof M > "u" || M === null)
        return "" + M;
      var F = Ie(M);
      if (F === "object") {
        if (M instanceof Date)
          return "date";
        if (M instanceof RegExp)
          return "regexp";
      }
      return F;
    }
    function ye(M) {
      var F = xe(M);
      switch (F) {
        case "array":
        case "object":
          return "an " + F;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + F;
        default:
          return F;
      }
    }
    function ue(M) {
      return !M.constructor || !M.constructor.name ? c : M.constructor.name;
    }
    return p.checkPropTypes = i, p.resetWarningCache = i.resetWarningCache, p.PropTypes = p, p;
  }, j1;
}
var Y1, uW;
function Joe() {
  if (uW)
    return Y1;
  uW = 1;
  var e = pq();
  function t() {
  }
  function r() {
  }
  return r.resetWarningCache = t, Y1 = function() {
    function n(s, o, u, f, l, d) {
      if (d !== e) {
        var c = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw c.name = "Invariant Violation", c;
      }
    }
    n.isRequired = n;
    function i() {
      return n;
    }
    var a = {
      array: n,
      bigint: n,
      bool: n,
      func: n,
      number: n,
      object: n,
      string: n,
      symbol: n,
      any: n,
      arrayOf: i,
      element: n,
      elementType: n,
      instanceOf: i,
      node: n,
      objectOf: i,
      oneOf: i,
      oneOfType: i,
      shape: i,
      exact: i,
      checkPropTypes: r,
      resetWarningCache: t
    };
    return a.PropTypes = a, a;
  }, Y1;
}
if (process.env.NODE_ENV !== "production") {
  var Hoe = oy, _oe = !0;
  Ug.exports = Qoe()(Hoe.isElement, _oe);
} else
  Ug.exports = Joe()();
var $oe = Ug.exports;
const be = /* @__PURE__ */ iy($oe);
function eue(e) {
  const {
    prototype: t = {}
  } = e;
  return !!t.isReactComponent;
}
function tue(e, t, r, n, i) {
  const a = e[t], s = i || t;
  if (a == null || // When server-side rendering React doesn't warn either.
  // This is not an accurate check for SSR.
  // This is only in place for emotion compat.
  // TODO: Revisit once https://github.com/facebook/react/issues/20047 is resolved.
  typeof window > "u")
    return null;
  let o;
  return typeof a == "function" && !eue(a) && (o = "Did you accidentally provide a plain function component instead?"), o !== void 0 ? new Error(`Invalid ${n} \`${s}\` supplied to \`${r}\`. Expected an element type that can hold a ref. ${o} For more information see https://mui.com/r/caveat-with-refs-guide`) : null;
}
const rue = Yoe(be.elementType, tue);
function mu(e) {
  let t = "https://mui.com/production-error/?code=" + e;
  for (let r = 1; r < arguments.length; r += 1)
    t += "&args[]=" + encodeURIComponent(arguments[r]);
  return "Minified MUI error #" + e + "; visit " + t + " for the full message.";
}
var xg = { exports: {} }, tr = {};
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var fW;
function nue() {
  if (fW)
    return tr;
  fW = 1;
  var e = Symbol.for("react.element"), t = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), n = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), a = Symbol.for("react.provider"), s = Symbol.for("react.context"), o = Symbol.for("react.server_context"), u = Symbol.for("react.forward_ref"), f = Symbol.for("react.suspense"), l = Symbol.for("react.suspense_list"), d = Symbol.for("react.memo"), c = Symbol.for("react.lazy"), p = Symbol.for("react.offscreen"), v;
  v = Symbol.for("react.module.reference");
  function h(m) {
    if (typeof m == "object" && m !== null) {
      var q = m.$$typeof;
      switch (q) {
        case e:
          switch (m = m.type, m) {
            case r:
            case i:
            case n:
            case f:
            case l:
              return m;
            default:
              switch (m = m && m.$$typeof, m) {
                case o:
                case s:
                case u:
                case c:
                case d:
                case a:
                  return m;
                default:
                  return q;
              }
          }
        case t:
          return q;
      }
    }
  }
  return tr.ContextConsumer = s, tr.ContextProvider = a, tr.Element = e, tr.ForwardRef = u, tr.Fragment = r, tr.Lazy = c, tr.Memo = d, tr.Portal = t, tr.Profiler = i, tr.StrictMode = n, tr.Suspense = f, tr.SuspenseList = l, tr.isAsyncMode = function() {
    return !1;
  }, tr.isConcurrentMode = function() {
    return !1;
  }, tr.isContextConsumer = function(m) {
    return h(m) === s;
  }, tr.isContextProvider = function(m) {
    return h(m) === a;
  }, tr.isElement = function(m) {
    return typeof m == "object" && m !== null && m.$$typeof === e;
  }, tr.isForwardRef = function(m) {
    return h(m) === u;
  }, tr.isFragment = function(m) {
    return h(m) === r;
  }, tr.isLazy = function(m) {
    return h(m) === c;
  }, tr.isMemo = function(m) {
    return h(m) === d;
  }, tr.isPortal = function(m) {
    return h(m) === t;
  }, tr.isProfiler = function(m) {
    return h(m) === i;
  }, tr.isStrictMode = function(m) {
    return h(m) === n;
  }, tr.isSuspense = function(m) {
    return h(m) === f;
  }, tr.isSuspenseList = function(m) {
    return h(m) === l;
  }, tr.isValidElementType = function(m) {
    return typeof m == "string" || typeof m == "function" || m === r || m === i || m === n || m === f || m === l || m === p || typeof m == "object" && m !== null && (m.$$typeof === c || m.$$typeof === d || m.$$typeof === a || m.$$typeof === s || m.$$typeof === u || m.$$typeof === v || m.getModuleId !== void 0);
  }, tr.typeOf = h, tr;
}
var rr = {};
/**
 * @license React
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var lW;
function iue() {
  return lW || (lW = 1, process.env.NODE_ENV !== "production" && function() {
    var e = Symbol.for("react.element"), t = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), n = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), a = Symbol.for("react.provider"), s = Symbol.for("react.context"), o = Symbol.for("react.server_context"), u = Symbol.for("react.forward_ref"), f = Symbol.for("react.suspense"), l = Symbol.for("react.suspense_list"), d = Symbol.for("react.memo"), c = Symbol.for("react.lazy"), p = Symbol.for("react.offscreen"), v = !1, h = !1, m = !1, q = !1, w = !1, O;
    O = Symbol.for("react.module.reference");
    function C(te) {
      return !!(typeof te == "string" || typeof te == "function" || te === r || te === i || w || te === n || te === f || te === l || q || te === p || v || h || m || typeof te == "object" && te !== null && (te.$$typeof === c || te.$$typeof === d || te.$$typeof === a || te.$$typeof === s || te.$$typeof === u || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      te.$$typeof === O || te.getModuleId !== void 0));
    }
    function R(te) {
      if (typeof te == "object" && te !== null) {
        var it = te.$$typeof;
        switch (it) {
          case e:
            var Vt = te.type;
            switch (Vt) {
              case r:
              case i:
              case n:
              case f:
              case l:
                return Vt;
              default:
                var Oe = Vt && Vt.$$typeof;
                switch (Oe) {
                  case o:
                  case s:
                  case u:
                  case c:
                  case d:
                  case a:
                    return Oe;
                  default:
                    return it;
                }
            }
          case t:
            return it;
        }
      }
    }
    var I = s, P = a, K = e, B = u, L = r, _ = c, ne = d, Z = t, le = i, he = n, Ie = f, xe = l, ye = !1, ue = !1;
    function M(te) {
      return ye || (ye = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function F(te) {
      return ue || (ue = !0, console.warn("The ReactIs.isConcurrentMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function pe(te) {
      return R(te) === s;
    }
    function We(te) {
      return R(te) === a;
    }
    function ce(te) {
      return typeof te == "object" && te !== null && te.$$typeof === e;
    }
    function oe(te) {
      return R(te) === u;
    }
    function z(te) {
      return R(te) === r;
    }
    function Ze(te) {
      return R(te) === c;
    }
    function Ae(te) {
      return R(te) === d;
    }
    function re(te) {
      return R(te) === t;
    }
    function Qe(te) {
      return R(te) === i;
    }
    function Ee(te) {
      return R(te) === n;
    }
    function Ue(te) {
      return R(te) === f;
    }
    function He(te) {
      return R(te) === l;
    }
    rr.ContextConsumer = I, rr.ContextProvider = P, rr.Element = K, rr.ForwardRef = B, rr.Fragment = L, rr.Lazy = _, rr.Memo = ne, rr.Portal = Z, rr.Profiler = le, rr.StrictMode = he, rr.Suspense = Ie, rr.SuspenseList = xe, rr.isAsyncMode = M, rr.isConcurrentMode = F, rr.isContextConsumer = pe, rr.isContextProvider = We, rr.isElement = ce, rr.isForwardRef = oe, rr.isFragment = z, rr.isLazy = Ze, rr.isMemo = Ae, rr.isPortal = re, rr.isProfiler = Qe, rr.isStrictMode = Ee, rr.isSuspense = Ue, rr.isSuspenseList = He, rr.isValidElementType = C, rr.typeOf = R;
  }()), rr;
}
process.env.NODE_ENV === "production" ? xg.exports = nue() : xg.exports = iue();
var dW = xg.exports;
const aue = /^\s*function(?:\s|\s*\/\*.*\*\/\s*)+([^(\s/]*)\s*/;
function sue(e) {
  const t = `${e}`.match(aue);
  return t && t[1] || "";
}
function dR(e, t = "") {
  return e.displayName || e.name || sue(e) || t;
}
function cW(e, t, r) {
  const n = dR(t);
  return e.displayName || (n !== "" ? `${r}(${n})` : r);
}
function oue(e) {
  if (e != null) {
    if (typeof e == "string")
      return e;
    if (typeof e == "function")
      return dR(e, "Component");
    if (typeof e == "object")
      switch (e.$$typeof) {
        case dW.ForwardRef:
          return cW(e, e.render, "ForwardRef");
        case dW.Memo:
          return cW(e, e.type, "memo");
        default:
          return;
      }
  }
}
const uue = be.oneOfType([be.func, be.object]), fue = uue;
function rs(e) {
  if (typeof e != "string")
    throw new Error(process.env.NODE_ENV !== "production" ? "MUI: `capitalize(string)` expects a string argument." : mu(7));
  return e.charAt(0).toUpperCase() + e.slice(1);
}
function lue(e, t) {
  typeof e == "function" ? e(t) : e && (e.current = t);
}
const due = typeof window < "u" ? et.useLayoutEffect : et.useEffect, vq = due;
function Zd(e) {
  const t = et.useRef(e);
  return vq(() => {
    t.current = e;
  }), et.useCallback((...r) => (
    // @ts-expect-error hide `this`
    // tslint:disable-next-line:ban-comma-operator
    (0, t.current)(...r)
  ), []);
}
function Eg(...e) {
  return et.useMemo(() => e.every((t) => t == null) ? null : (t) => {
    e.forEach((r) => {
      lue(r, t);
    });
  }, e);
}
let av = !0, Og = !1, pW;
const cue = {
  text: !0,
  search: !0,
  url: !0,
  tel: !0,
  email: !0,
  password: !0,
  number: !0,
  date: !0,
  month: !0,
  week: !0,
  time: !0,
  datetime: !0,
  "datetime-local": !0
};
function pue(e) {
  const {
    type: t,
    tagName: r
  } = e;
  return !!(r === "INPUT" && cue[t] && !e.readOnly || r === "TEXTAREA" && !e.readOnly || e.isContentEditable);
}
function vue(e) {
  e.metaKey || e.altKey || e.ctrlKey || (av = !0);
}
function z1() {
  av = !1;
}
function hue() {
  this.visibilityState === "hidden" && Og && (av = !0);
}
function mue(e) {
  e.addEventListener("keydown", vue, !0), e.addEventListener("mousedown", z1, !0), e.addEventListener("pointerdown", z1, !0), e.addEventListener("touchstart", z1, !0), e.addEventListener("visibilitychange", hue, !0);
}
function gue(e) {
  const {
    target: t
  } = e;
  try {
    return t.matches(":focus-visible");
  } catch {
  }
  return av || pue(t);
}
function yue() {
  const e = et.useCallback((i) => {
    i != null && mue(i.ownerDocument);
  }, []), t = et.useRef(!1);
  function r() {
    return t.current ? (Og = !0, window.clearTimeout(pW), pW = window.setTimeout(() => {
      Og = !1;
    }, 100), t.current = !1, !0) : !1;
  }
  function n(i) {
    return gue(i) ? (t.current = !0, !0) : !1;
  }
  return {
    isFocusVisibleRef: t,
    onFocus: n,
    onBlur: r,
    ref: e
  };
}
function cR(e, t) {
  const r = yt({}, t);
  return Object.keys(e).forEach((n) => {
    if (n.toString().match(/^(components|slots)$/))
      r[n] = yt({}, e[n], r[n]);
    else if (n.toString().match(/^(componentsProps|slotProps)$/)) {
      const i = e[n] || {}, a = t[n];
      r[n] = {}, !a || !Object.keys(a) ? r[n] = i : !i || !Object.keys(i) ? r[n] = a : (r[n] = yt({}, a), Object.keys(i).forEach((s) => {
        r[n][s] = cR(i[s], a[s]);
      }));
    } else
      r[n] === void 0 && (r[n] = e[n]);
  }), r;
}
function Yl(e, t, r = void 0) {
  const n = {};
  return Object.keys(e).forEach(
    // `Object.keys(slots)` can't be wider than `T` because we infer `T` from `slots`.
    // @ts-expect-error https://github.com/microsoft/TypeScript/pull/12253#issuecomment-263132208
    (i) => {
      n[i] = e[i].reduce((a, s) => {
        if (s) {
          const o = t(s);
          o !== "" && a.push(o), r && r[s] && a.push(r[s]);
        }
        return a;
      }, []).join(" ");
    }
  ), n;
}
const vW = (e) => e, Vue = () => {
  let e = vW;
  return {
    configure(t) {
      e = t;
    },
    generate(t) {
      return e(t);
    },
    reset() {
      e = vW;
    }
  };
}, que = Vue(), bue = que, Aue = {
  active: "active",
  checked: "checked",
  completed: "completed",
  disabled: "disabled",
  error: "error",
  expanded: "expanded",
  focused: "focused",
  focusVisible: "focusVisible",
  open: "open",
  readOnly: "readOnly",
  required: "required",
  selected: "selected"
};
function oo(e, t, r = "Mui") {
  const n = Aue[t];
  return n ? `${r}-${n}` : `${bue.generate(e)}-${t}`;
}
function Bu(e, t, r = "Mui") {
  const n = {};
  return t.forEach((i) => {
    n[i] = oo(e, i, r);
  }), n;
}
const hq = "$$material";
function pR(e) {
  var t = /* @__PURE__ */ Object.create(null);
  return function(r) {
    return t[r] === void 0 && (t[r] = e(r)), t[r];
  };
}
var wue = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/, kue = /* @__PURE__ */ pR(
  function(e) {
    return wue.test(e) || e.charCodeAt(0) === 111 && e.charCodeAt(1) === 110 && e.charCodeAt(2) < 91;
  }
  /* Z+1 */
);
function Wue(e) {
  if (e.sheet)
    return e.sheet;
  for (var t = 0; t < document.styleSheets.length; t++)
    if (document.styleSheets[t].ownerNode === e)
      return document.styleSheets[t];
}
function Sue(e) {
  var t = document.createElement("style");
  return t.setAttribute("data-emotion", e.key), e.nonce !== void 0 && t.setAttribute("nonce", e.nonce), t.appendChild(document.createTextNode("")), t.setAttribute("data-s", ""), t;
}
var Cue = /* @__PURE__ */ function() {
  function e(r) {
    var n = this;
    this._insertTag = function(i) {
      var a;
      n.tags.length === 0 ? n.insertionPoint ? a = n.insertionPoint.nextSibling : n.prepend ? a = n.container.firstChild : a = n.before : a = n.tags[n.tags.length - 1].nextSibling, n.container.insertBefore(i, a), n.tags.push(i);
    }, this.isSpeedy = r.speedy === void 0 ? process.env.NODE_ENV === "production" : r.speedy, this.tags = [], this.ctr = 0, this.nonce = r.nonce, this.key = r.key, this.container = r.container, this.prepend = r.prepend, this.insertionPoint = r.insertionPoint, this.before = null;
  }
  var t = e.prototype;
  return t.hydrate = function(n) {
    n.forEach(this._insertTag);
  }, t.insert = function(n) {
    this.ctr % (this.isSpeedy ? 65e3 : 1) === 0 && this._insertTag(Sue(this));
    var i = this.tags[this.tags.length - 1];
    if (process.env.NODE_ENV !== "production") {
      var a = n.charCodeAt(0) === 64 && n.charCodeAt(1) === 105;
      a && this._alreadyInsertedOrderInsensitiveRule && console.error(`You're attempting to insert the following rule:
` + n + "\n\n`@import` rules must be before all other types of rules in a stylesheet but other rules have already been inserted. Please ensure that `@import` rules are before all other rules."), this._alreadyInsertedOrderInsensitiveRule = this._alreadyInsertedOrderInsensitiveRule || !a;
    }
    if (this.isSpeedy) {
      var s = Wue(i);
      try {
        s.insertRule(n, s.cssRules.length);
      } catch (o) {
        process.env.NODE_ENV !== "production" && !/:(-moz-placeholder|-moz-focus-inner|-moz-focusring|-ms-input-placeholder|-moz-read-write|-moz-read-only|-ms-clear|-ms-expand|-ms-reveal){/.test(n) && console.error('There was a problem inserting the following rule: "' + n + '"', o);
      }
    } else
      i.appendChild(document.createTextNode(n));
    this.ctr++;
  }, t.flush = function() {
    this.tags.forEach(function(n) {
      return n.parentNode && n.parentNode.removeChild(n);
    }), this.tags = [], this.ctr = 0, process.env.NODE_ENV !== "production" && (this._alreadyInsertedOrderInsensitiveRule = !1);
  }, e;
}(), dn = "-ms-", zc = "-moz-", Gt = "-webkit-", mq = "comm", gq = "rule", yq = "decl", Fue = "@import", vR = "@keyframes", Kue = "@layer", Rue = Math.abs, sv = String.fromCharCode, Tue = Object.assign;
function Uue(e, t) {
  return sn(e, 0) ^ 45 ? (((t << 2 ^ sn(e, 0)) << 2 ^ sn(e, 1)) << 2 ^ sn(e, 2)) << 2 ^ sn(e, 3) : 0;
}
function hR(e) {
  return e.trim();
}
function xue(e, t) {
  return (e = t.exec(e)) ? e[0] : e;
}
function Qt(e, t, r) {
  return e.replace(t, r);
}
function Ng(e, t) {
  return e.indexOf(t);
}
function sn(e, t) {
  return e.charCodeAt(t) | 0;
}
function sl(e, t, r) {
  return e.slice(t, r);
}
function Ii(e) {
  return e.length;
}
function Vq(e) {
  return e.length;
}
function Md(e, t) {
  return t.push(e), e;
}
function Eue(e, t) {
  return e.map(t).join("");
}
var ov = 1, gu = 1, mR = 0, Tn = 0, Yr = 0, Du = "";
function uv(e, t, r, n, i, a, s) {
  return { value: e, root: t, parent: r, type: n, props: i, children: a, line: ov, column: gu, length: s, return: "" };
}
function Af(e, t) {
  return Tue(uv("", null, null, "", null, null, 0), e, { length: -e.length }, t);
}
function Oue() {
  return Yr;
}
function Nue() {
  return Yr = Tn > 0 ? sn(Du, --Tn) : 0, gu--, Yr === 10 && (gu = 1, ov--), Yr;
}
function Dn() {
  return Yr = Tn < mR ? sn(Du, Tn++) : 0, gu++, Yr === 10 && (gu = 1, ov++), Yr;
}
function Mi() {
  return sn(Du, Tn);
}
function fc() {
  return Tn;
}
function zl(e, t) {
  return sl(Du, e, t);
}
function ol(e) {
  switch (e) {
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    case 59:
    case 123:
    case 125:
      return 4;
    case 58:
      return 3;
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function gR(e) {
  return ov = gu = 1, mR = Ii(Du = e), Tn = 0, [];
}
function yR(e) {
  return Du = "", e;
}
function lc(e) {
  return hR(zl(Tn - 1, Ig(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function Iue(e) {
  for (; (Yr = Mi()) && Yr < 33; )
    Dn();
  return ol(e) > 2 || ol(Yr) > 3 ? "" : " ";
}
function Xue(e, t) {
  for (; --t && Dn() && !(Yr < 48 || Yr > 102 || Yr > 57 && Yr < 65 || Yr > 70 && Yr < 97); )
    ;
  return zl(e, fc() + (t < 6 && Mi() == 32 && Dn() == 32));
}
function Ig(e) {
  for (; Dn(); )
    switch (Yr) {
      case e:
        return Tn;
      case 34:
      case 39:
        e !== 34 && e !== 39 && Ig(Yr);
        break;
      case 40:
        e === 41 && Ig(e);
        break;
      case 92:
        Dn();
        break;
    }
  return Tn;
}
function Pue(e, t) {
  for (; Dn() && e + Yr !== 47 + 10; )
    if (e + Yr === 42 + 42 && Mi() === 47)
      break;
  return "/*" + zl(t, Tn - 1) + "*" + sv(e === 47 ? e : Dn());
}
function Bue(e) {
  for (; !ol(Mi()); )
    Dn();
  return zl(e, Tn);
}
function Due(e) {
  return yR(dc("", null, null, null, [""], e = gR(e), 0, [0], e));
}
function dc(e, t, r, n, i, a, s, o, u) {
  for (var f = 0, l = 0, d = s, c = 0, p = 0, v = 0, h = 1, m = 1, q = 1, w = 0, O = "", C = i, R = a, I = n, P = O; m; )
    switch (v = w, w = Dn()) {
      case 40:
        if (v != 108 && sn(P, d - 1) == 58) {
          Ng(P += Qt(lc(w), "&", "&\f"), "&\f") != -1 && (q = -1);
          break;
        }
      case 34:
      case 39:
      case 91:
        P += lc(w);
        break;
      case 9:
      case 10:
      case 13:
      case 32:
        P += Iue(v);
        break;
      case 92:
        P += Xue(fc() - 1, 7);
        continue;
      case 47:
        switch (Mi()) {
          case 42:
          case 47:
            Md(Lue(Pue(Dn(), fc()), t, r), u);
            break;
          default:
            P += "/";
        }
        break;
      case 123 * h:
        o[f++] = Ii(P) * q;
      case 125 * h:
      case 59:
      case 0:
        switch (w) {
          case 0:
          case 125:
            m = 0;
          case 59 + l:
            q == -1 && (P = Qt(P, /\f/g, "")), p > 0 && Ii(P) - d && Md(p > 32 ? mW(P + ";", n, r, d - 1) : mW(Qt(P, " ", "") + ";", n, r, d - 2), u);
            break;
          case 59:
            P += ";";
          default:
            if (Md(I = hW(P, t, r, f, l, i, o, O, C = [], R = [], d), a), w === 123)
              if (l === 0)
                dc(P, t, I, I, C, a, d, o, R);
              else
                switch (c === 99 && sn(P, 3) === 110 ? 100 : c) {
                  case 100:
                  case 108:
                  case 109:
                  case 115:
                    dc(e, I, I, n && Md(hW(e, I, I, 0, 0, i, o, O, i, C = [], d), R), i, R, d, o, n ? C : R);
                    break;
                  default:
                    dc(P, I, I, I, [""], R, 0, o, R);
                }
        }
        f = l = p = 0, h = q = 1, O = P = "", d = s;
        break;
      case 58:
        d = 1 + Ii(P), p = v;
      default:
        if (h < 1) {
          if (w == 123)
            --h;
          else if (w == 125 && h++ == 0 && Nue() == 125)
            continue;
        }
        switch (P += sv(w), w * h) {
          case 38:
            q = l > 0 ? 1 : (P += "\f", -1);
            break;
          case 44:
            o[f++] = (Ii(P) - 1) * q, q = 1;
            break;
          case 64:
            Mi() === 45 && (P += lc(Dn())), c = Mi(), l = d = Ii(O = P += Bue(fc())), w++;
            break;
          case 45:
            v === 45 && Ii(P) == 2 && (h = 0);
        }
    }
  return a;
}
function hW(e, t, r, n, i, a, s, o, u, f, l) {
  for (var d = i - 1, c = i === 0 ? a : [""], p = Vq(c), v = 0, h = 0, m = 0; v < n; ++v)
    for (var q = 0, w = sl(e, d + 1, d = Rue(h = s[v])), O = e; q < p; ++q)
      (O = hR(h > 0 ? c[q] + " " + w : Qt(w, /&\f/g, c[q]))) && (u[m++] = O);
  return uv(e, t, r, i === 0 ? gq : o, u, f, l);
}
function Lue(e, t, r) {
  return uv(e, t, r, mq, sv(Oue()), sl(e, 2, -2), 0);
}
function mW(e, t, r, n) {
  return uv(e, t, r, yq, sl(e, 0, n), sl(e, n + 1, -1), n);
}
function eu(e, t) {
  for (var r = "", n = Vq(e), i = 0; i < n; i++)
    r += t(e[i], i, e, t) || "";
  return r;
}
function Zue(e, t, r, n) {
  switch (e.type) {
    case Kue:
      if (e.children.length)
        break;
    case Fue:
    case yq:
      return e.return = e.return || e.value;
    case mq:
      return "";
    case vR:
      return e.return = e.value + "{" + eu(e.children, n) + "}";
    case gq:
      e.value = e.props.join(",");
  }
  return Ii(r = eu(e.children, n)) ? e.return = e.value + "{" + r + "}" : "";
}
function Mue(e) {
  var t = Vq(e);
  return function(r, n, i, a) {
    for (var s = "", o = 0; o < t; o++)
      s += e[o](r, n, i, a) || "";
    return s;
  };
}
function jue(e) {
  return function(t) {
    t.root || (t = t.return) && e(t);
  };
}
var Yue = function(t, r, n) {
  for (var i = 0, a = 0; i = a, a = Mi(), i === 38 && a === 12 && (r[n] = 1), !ol(a); )
    Dn();
  return zl(t, Tn);
}, zue = function(t, r) {
  var n = -1, i = 44;
  do
    switch (ol(i)) {
      case 0:
        i === 38 && Mi() === 12 && (r[n] = 1), t[n] += Yue(Tn - 1, r, n);
        break;
      case 2:
        t[n] += lc(i);
        break;
      case 4:
        if (i === 44) {
          t[++n] = Mi() === 58 ? "&\f" : "", r[n] = t[n].length;
          break;
        }
      default:
        t[n] += sv(i);
    }
  while (i = Dn());
  return t;
}, Gue = function(t, r) {
  return yR(zue(gR(t), r));
}, gW = /* @__PURE__ */ new WeakMap(), Que = function(t) {
  if (!(t.type !== "rule" || !t.parent || // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  t.length < 1)) {
    for (var r = t.value, n = t.parent, i = t.column === n.column && t.line === n.line; n.type !== "rule"; )
      if (n = n.parent, !n)
        return;
    if (!(t.props.length === 1 && r.charCodeAt(0) !== 58 && !gW.get(n)) && !i) {
      gW.set(t, !0);
      for (var a = [], s = Gue(r, a), o = n.props, u = 0, f = 0; u < s.length; u++)
        for (var l = 0; l < o.length; l++, f++)
          t.props[f] = a[u] ? s[u].replace(/&\f/g, o[l]) : o[l] + " " + s[u];
    }
  }
}, Jue = function(t) {
  if (t.type === "decl") {
    var r = t.value;
    // charcode for l
    r.charCodeAt(0) === 108 && // charcode for b
    r.charCodeAt(2) === 98 && (t.return = "", t.value = "");
  }
}, Hue = "emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason", _ue = function(t) {
  return t.type === "comm" && t.children.indexOf(Hue) > -1;
}, $ue = function(t) {
  return function(r, n, i) {
    if (!(r.type !== "rule" || t.compat)) {
      var a = r.value.match(/(:first|:nth|:nth-last)-child/g);
      if (a) {
        for (var s = !!r.parent, o = s ? r.parent.children : (
          // global rule at the root level
          i
        ), u = o.length - 1; u >= 0; u--) {
          var f = o[u];
          if (f.line < r.line)
            break;
          if (f.column < r.column) {
            if (_ue(f))
              return;
            break;
          }
        }
        a.forEach(function(l) {
          console.error('The pseudo class "' + l + '" is potentially unsafe when doing server-side rendering. Try changing it to "' + l.split("-child")[0] + '-of-type".');
        });
      }
    }
  };
}, VR = function(t) {
  return t.type.charCodeAt(1) === 105 && t.type.charCodeAt(0) === 64;
}, efe = function(t, r) {
  for (var n = t - 1; n >= 0; n--)
    if (!VR(r[n]))
      return !0;
  return !1;
}, yW = function(t) {
  t.type = "", t.value = "", t.return = "", t.children = "", t.props = "";
}, tfe = function(t, r, n) {
  VR(t) && (t.parent ? (console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles."), yW(t)) : efe(r, n) && (console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules."), yW(t)));
};
function qR(e, t) {
  switch (Uue(e, t)) {
    case 5103:
      return Gt + "print-" + e + e;
    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855:
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return Gt + e + e;
    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return Gt + e + zc + e + dn + e + e;
    case 6828:
    case 4268:
      return Gt + e + dn + e + e;
    case 6165:
      return Gt + e + dn + "flex-" + e + e;
    case 5187:
      return Gt + e + Qt(e, /(\w+).+(:[^]+)/, Gt + "box-$1$2" + dn + "flex-$1$2") + e;
    case 5443:
      return Gt + e + dn + "flex-item-" + Qt(e, /flex-|-self/, "") + e;
    case 4675:
      return Gt + e + dn + "flex-line-pack" + Qt(e, /align-content|flex-|-self/, "") + e;
    case 5548:
      return Gt + e + dn + Qt(e, "shrink", "negative") + e;
    case 5292:
      return Gt + e + dn + Qt(e, "basis", "preferred-size") + e;
    case 6060:
      return Gt + "box-" + Qt(e, "-grow", "") + Gt + e + dn + Qt(e, "grow", "positive") + e;
    case 4554:
      return Gt + Qt(e, /([^-])(transform)/g, "$1" + Gt + "$2") + e;
    case 6187:
      return Qt(Qt(Qt(e, /(zoom-|grab)/, Gt + "$1"), /(image-set)/, Gt + "$1"), e, "") + e;
    case 5495:
    case 3959:
      return Qt(e, /(image-set\([^]*)/, Gt + "$1$`$1");
    case 4968:
      return Qt(Qt(e, /(.+:)(flex-)?(.*)/, Gt + "box-pack:$3" + dn + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + Gt + e + e;
    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return Qt(e, /(.+)-inline(.+)/, Gt + "$1$2") + e;
    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (Ii(e) - 1 - t > 6)
        switch (sn(e, t + 1)) {
          case 109:
            if (sn(e, t + 4) !== 45)
              break;
          case 102:
            return Qt(e, /(.+:)(.+)-([^]+)/, "$1" + Gt + "$2-$3$1" + zc + (sn(e, t + 3) == 108 ? "$3" : "$2-$3")) + e;
          case 115:
            return ~Ng(e, "stretch") ? qR(Qt(e, "stretch", "fill-available"), t) + e : e;
        }
      break;
    case 4949:
      if (sn(e, t + 1) !== 115)
        break;
    case 6444:
      switch (sn(e, Ii(e) - 3 - (~Ng(e, "!important") && 10))) {
        case 107:
          return Qt(e, ":", ":" + Gt) + e;
        case 101:
          return Qt(e, /(.+:)([^;!]+)(;|!.+)?/, "$1" + Gt + (sn(e, 14) === 45 ? "inline-" : "") + "box$3$1" + Gt + "$2$3$1" + dn + "$2box$3") + e;
      }
      break;
    case 5936:
      switch (sn(e, t + 11)) {
        case 114:
          return Gt + e + dn + Qt(e, /[svh]\w+-[tblr]{2}/, "tb") + e;
        case 108:
          return Gt + e + dn + Qt(e, /[svh]\w+-[tblr]{2}/, "tb-rl") + e;
        case 45:
          return Gt + e + dn + Qt(e, /[svh]\w+-[tblr]{2}/, "lr") + e;
      }
      return Gt + e + dn + e + e;
  }
  return e;
}
var rfe = function(t, r, n, i) {
  if (t.length > -1 && !t.return)
    switch (t.type) {
      case yq:
        t.return = qR(t.value, t.length);
        break;
      case vR:
        return eu([Af(t, {
          value: Qt(t.value, "@", "@" + Gt)
        })], i);
      case gq:
        if (t.length)
          return Eue(t.props, function(a) {
            switch (xue(a, /(::plac\w+|:read-\w+)/)) {
              case ":read-only":
              case ":read-write":
                return eu([Af(t, {
                  props: [Qt(a, /:(read-\w+)/, ":" + zc + "$1")]
                })], i);
              case "::placeholder":
                return eu([Af(t, {
                  props: [Qt(a, /:(plac\w+)/, ":" + Gt + "input-$1")]
                }), Af(t, {
                  props: [Qt(a, /:(plac\w+)/, ":" + zc + "$1")]
                }), Af(t, {
                  props: [Qt(a, /:(plac\w+)/, dn + "input-$1")]
                })], i);
            }
            return "";
          });
    }
}, nfe = [rfe], ife = function(t) {
  var r = t.key;
  if (process.env.NODE_ENV !== "production" && !r)
    throw new Error(`You have to configure \`key\` for your cache. Please make sure it's unique (and not equal to 'css') as it's used for linking styles to your cache.
If multiple caches share the same key they might "fight" for each other's style elements.`);
  if (r === "css") {
    var n = document.querySelectorAll("style[data-emotion]:not([data-s])");
    Array.prototype.forEach.call(n, function(h) {
      var m = h.getAttribute("data-emotion");
      m.indexOf(" ") !== -1 && (document.head.appendChild(h), h.setAttribute("data-s", ""));
    });
  }
  var i = t.stylisPlugins || nfe;
  if (process.env.NODE_ENV !== "production" && /[^a-z-]/.test(r))
    throw new Error('Emotion key must only contain lower case alphabetical characters and - but "' + r + '" was passed');
  var a = {}, s, o = [];
  s = t.container || document.head, Array.prototype.forEach.call(
    // this means we will ignore elements which don't have a space in them which
    // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll('style[data-emotion^="' + r + ' "]'),
    function(h) {
      for (var m = h.getAttribute("data-emotion").split(" "), q = 1; q < m.length; q++)
        a[m[q]] = !0;
      o.push(h);
    }
  );
  var u, f = [Que, Jue];
  process.env.NODE_ENV !== "production" && f.push($ue({
    get compat() {
      return v.compat;
    }
  }), tfe);
  {
    var l, d = [Zue, process.env.NODE_ENV !== "production" ? function(h) {
      h.root || (h.return ? l.insert(h.return) : h.value && h.type !== mq && l.insert(h.value + "{}"));
    } : jue(function(h) {
      l.insert(h);
    })], c = Mue(f.concat(i, d)), p = function(m) {
      return eu(Due(m), c);
    };
    u = function(m, q, w, O) {
      l = w, process.env.NODE_ENV !== "production" && q.map !== void 0 && (l = {
        insert: function(R) {
          w.insert(R + q.map);
        }
      }), p(m ? m + "{" + q.styles + "}" : q.styles), O && (v.inserted[q.name] = !0);
    };
  }
  var v = {
    key: r,
    sheet: new Cue({
      key: r,
      container: s,
      nonce: t.nonce,
      speedy: t.speedy,
      prepend: t.prepend,
      insertionPoint: t.insertionPoint
    }),
    nonce: t.nonce,
    inserted: a,
    registered: {},
    insert: u
  };
  return v.sheet.hydrate(o), v;
}, afe = !0;
function qq(e, t, r) {
  var n = "";
  return r.split(" ").forEach(function(i) {
    e[i] !== void 0 ? t.push(e[i] + ";") : n += i + " ";
  }), n;
}
var fv = function(t, r, n) {
  var i = t.key + "-" + r.name;
  // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (n === !1 || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  afe === !1) && t.registered[i] === void 0 && (t.registered[i] = r.styles);
}, lv = function(t, r, n) {
  fv(t, r, n);
  var i = t.key + "-" + r.name;
  if (t.inserted[r.name] === void 0) {
    var a = r;
    do
      t.insert(r === a ? "." + i : "", a, t.sheet, !0), a = a.next;
    while (a !== void 0);
  }
};
function sfe(e) {
  for (var t = 0, r, n = 0, i = e.length; i >= 4; ++n, i -= 4)
    r = e.charCodeAt(n) & 255 | (e.charCodeAt(++n) & 255) << 8 | (e.charCodeAt(++n) & 255) << 16 | (e.charCodeAt(++n) & 255) << 24, r = /* Math.imul(k, m): */
    (r & 65535) * 1540483477 + ((r >>> 16) * 59797 << 16), r ^= /* k >>> r: */
    r >>> 24, t = /* Math.imul(k, m): */
    (r & 65535) * 1540483477 + ((r >>> 16) * 59797 << 16) ^ /* Math.imul(h, m): */
    (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16);
  switch (i) {
    case 3:
      t ^= (e.charCodeAt(n + 2) & 255) << 16;
    case 2:
      t ^= (e.charCodeAt(n + 1) & 255) << 8;
    case 1:
      t ^= e.charCodeAt(n) & 255, t = /* Math.imul(h, m): */
      (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16);
  }
  return t ^= t >>> 13, t = /* Math.imul(h, m): */
  (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16), ((t ^ t >>> 15) >>> 0).toString(36);
}
var ofe = {
  animationIterationCount: 1,
  aspectRatio: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
}, VW = `You have illegal escape sequence in your template literal, most likely inside content's property value.
Because you write your CSS inside a JavaScript string you actually have to do double escaping, so for example "content: '\\00d7';" should become "content: '\\\\00d7';".
You can read more about this here:
https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences`, ufe = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).", ffe = /[A-Z]|^ms/g, bR = /_EMO_([^_]+?)_([^]*?)_EMO_/g, bq = function(t) {
  return t.charCodeAt(1) === 45;
}, qW = function(t) {
  return t != null && typeof t != "boolean";
}, G1 = /* @__PURE__ */ pR(function(e) {
  return bq(e) ? e : e.replace(ffe, "-$&").toLowerCase();
}), Gc = function(t, r) {
  switch (t) {
    case "animation":
    case "animationName":
      if (typeof r == "string")
        return r.replace(bR, function(n, i, a) {
          return Ai = {
            name: i,
            styles: a,
            next: Ai
          }, i;
        });
  }
  return ofe[t] !== 1 && !bq(t) && typeof r == "number" && r !== 0 ? r + "px" : r;
};
if (process.env.NODE_ENV !== "production") {
  var lfe = /(var|attr|counters?|url|element|(((repeating-)?(linear|radial))|conic)-gradient)\(|(no-)?(open|close)-quote/, dfe = ["normal", "none", "initial", "inherit", "unset"], cfe = Gc, pfe = /^-ms-/, vfe = /-(.)/g, bW = {};
  Gc = function(t, r) {
    if (t === "content" && (typeof r != "string" || dfe.indexOf(r) === -1 && !lfe.test(r) && (r.charAt(0) !== r.charAt(r.length - 1) || r.charAt(0) !== '"' && r.charAt(0) !== "'")))
      throw new Error("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"" + r + "\"'`");
    var n = cfe(t, r);
    return n !== "" && !bq(t) && t.indexOf("-") !== -1 && bW[t] === void 0 && (bW[t] = !0, console.error("Using kebab-case for css properties in objects is not supported. Did you mean " + t.replace(pfe, "ms-").replace(vfe, function(i, a) {
      return a.toUpperCase();
    }) + "?")), n;
  };
}
var AR = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function ul(e, t, r) {
  if (r == null)
    return "";
  if (r.__emotion_styles !== void 0) {
    if (process.env.NODE_ENV !== "production" && r.toString() === "NO_COMPONENT_SELECTOR")
      throw new Error(AR);
    return r;
  }
  switch (typeof r) {
    case "boolean":
      return "";
    case "object": {
      if (r.anim === 1)
        return Ai = {
          name: r.name,
          styles: r.styles,
          next: Ai
        }, r.name;
      if (r.styles !== void 0) {
        var n = r.next;
        if (n !== void 0)
          for (; n !== void 0; )
            Ai = {
              name: n.name,
              styles: n.styles,
              next: Ai
            }, n = n.next;
        var i = r.styles + ";";
        return process.env.NODE_ENV !== "production" && r.map !== void 0 && (i += r.map), i;
      }
      return hfe(e, t, r);
    }
    case "function": {
      if (e !== void 0) {
        var a = Ai, s = r(e);
        return Ai = a, ul(e, t, s);
      } else
        process.env.NODE_ENV !== "production" && console.error("Functions that are interpolated in css calls will be stringified.\nIf you want to have a css call based on props, create a function that returns a css call like this\nlet dynamicStyle = (props) => css`color: ${props.color}`\nIt can be called directly with props or interpolated in a styled call like this\nlet SomeComponent = styled('div')`${dynamicStyle}`");
      break;
    }
    case "string":
      if (process.env.NODE_ENV !== "production") {
        var o = [], u = r.replace(bR, function(l, d, c) {
          var p = "animation" + o.length;
          return o.push("const " + p + " = keyframes`" + c.replace(/^@keyframes animation-\w+/, "") + "`"), "${" + p + "}";
        });
        o.length && console.error("`keyframes` output got interpolated into plain string, please wrap it with `css`.\n\nInstead of doing this:\n\n" + [].concat(o, ["`" + u + "`"]).join(`
`) + `

You should wrap it with \`css\` like this:

` + ("css`" + u + "`"));
      }
      break;
  }
  if (t == null)
    return r;
  var f = t[r];
  return f !== void 0 ? f : r;
}
function hfe(e, t, r) {
  var n = "";
  if (Array.isArray(r))
    for (var i = 0; i < r.length; i++)
      n += ul(e, t, r[i]) + ";";
  else
    for (var a in r) {
      var s = r[a];
      if (typeof s != "object")
        t != null && t[s] !== void 0 ? n += a + "{" + t[s] + "}" : qW(s) && (n += G1(a) + ":" + Gc(a, s) + ";");
      else {
        if (a === "NO_COMPONENT_SELECTOR" && process.env.NODE_ENV !== "production")
          throw new Error(AR);
        if (Array.isArray(s) && typeof s[0] == "string" && (t == null || t[s[0]] === void 0))
          for (var o = 0; o < s.length; o++)
            qW(s[o]) && (n += G1(a) + ":" + Gc(a, s[o]) + ";");
        else {
          var u = ul(e, t, s);
          switch (a) {
            case "animation":
            case "animationName": {
              n += G1(a) + ":" + u + ";";
              break;
            }
            default:
              process.env.NODE_ENV !== "production" && a === "undefined" && console.error(ufe), n += a + "{" + u + "}";
          }
        }
      }
    }
  return n;
}
var AW = /label:\s*([^\s;\n{]+)\s*(;|$)/g, wR;
process.env.NODE_ENV !== "production" && (wR = /\/\*#\ssourceMappingURL=data:application\/json;\S+\s+\*\//g);
var Ai, yu = function(t, r, n) {
  if (t.length === 1 && typeof t[0] == "object" && t[0] !== null && t[0].styles !== void 0)
    return t[0];
  var i = !0, a = "";
  Ai = void 0;
  var s = t[0];
  s == null || s.raw === void 0 ? (i = !1, a += ul(n, r, s)) : (process.env.NODE_ENV !== "production" && s[0] === void 0 && console.error(VW), a += s[0]);
  for (var o = 1; o < t.length; o++)
    a += ul(n, r, t[o]), i && (process.env.NODE_ENV !== "production" && s[o] === void 0 && console.error(VW), a += s[o]);
  var u;
  process.env.NODE_ENV !== "production" && (a = a.replace(wR, function(c) {
    return u = c, "";
  })), AW.lastIndex = 0;
  for (var f = "", l; (l = AW.exec(a)) !== null; )
    f += "-" + // $FlowFixMe we know it's not null
    l[1];
  var d = sfe(a) + f;
  return process.env.NODE_ENV !== "production" ? {
    name: d,
    styles: a,
    map: u,
    next: Ai,
    toString: function() {
      return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
  } : {
    name: d,
    styles: a,
    next: Ai
  };
}, mfe = function(t) {
  return t();
}, kR = et["useInsertionEffect"] ? et["useInsertionEffect"] : !1, Aq = kR || mfe, wW = kR || et.useLayoutEffect, gfe = {}.hasOwnProperty, wq = /* @__PURE__ */ et.createContext(
  // we're doing this to avoid preconstruct's dead code elimination in this one case
  // because this module is primarily intended for the browser and node
  // but it's also required in react native and similar environments sometimes
  // and we could have a special build just for that
  // but this is much easier and the native packages
  // might use a different theme context in the future anyway
  typeof HTMLElement < "u" ? /* @__PURE__ */ ife({
    key: "css"
  }) : null
);
process.env.NODE_ENV !== "production" && (wq.displayName = "EmotionCacheContext");
wq.Provider;
var dv = function(t) {
  return /* @__PURE__ */ $g(function(r, n) {
    var i = _g(wq);
    return t(r, i, n);
  });
}, Lu = /* @__PURE__ */ et.createContext({});
process.env.NODE_ENV !== "production" && (Lu.displayName = "EmotionThemeContext");
var kW = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__", WW = "__EMOTION_LABEL_PLEASE_DO_NOT_USE__", yfe = function(t) {
  var r = t.cache, n = t.serialized, i = t.isStringTag;
  return fv(r, n, i), Aq(function() {
    return lv(r, n, i);
  }), null;
}, Vfe = /* @__PURE__ */ dv(function(e, t, r) {
  var n = e.css;
  typeof n == "string" && t.registered[n] !== void 0 && (n = t.registered[n]);
  var i = e[kW], a = [n], s = "";
  typeof e.className == "string" ? s = qq(t.registered, a, e.className) : e.className != null && (s = e.className + " ");
  var o = yu(a, void 0, et.useContext(Lu));
  if (process.env.NODE_ENV !== "production" && o.name.indexOf("-") === -1) {
    var u = e[WW];
    u && (o = yu([o, "label:" + u + ";"]));
  }
  s += t.key + "-" + o.name;
  var f = {};
  for (var l in e)
    gfe.call(e, l) && l !== "css" && l !== kW && (process.env.NODE_ENV === "production" || l !== WW) && (f[l] = e[l]);
  return f.ref = r, f.className = s, /* @__PURE__ */ et.createElement(et.Fragment, null, /* @__PURE__ */ et.createElement(yfe, {
    cache: t,
    serialized: o,
    isStringTag: typeof i == "string"
  }), /* @__PURE__ */ et.createElement(i, f));
});
process.env.NODE_ENV !== "production" && (Vfe.displayName = "EmotionCssPropInternal");
var qfe = {
  name: "@emotion/react",
  version: "11.11.1",
  main: "dist/emotion-react.cjs.js",
  module: "dist/emotion-react.esm.js",
  browser: {
    "./dist/emotion-react.esm.js": "./dist/emotion-react.browser.esm.js"
  },
  exports: {
    ".": {
      module: {
        worker: "./dist/emotion-react.worker.esm.js",
        browser: "./dist/emotion-react.browser.esm.js",
        default: "./dist/emotion-react.esm.js"
      },
      import: "./dist/emotion-react.cjs.mjs",
      default: "./dist/emotion-react.cjs.js"
    },
    "./jsx-runtime": {
      module: {
        worker: "./jsx-runtime/dist/emotion-react-jsx-runtime.worker.esm.js",
        browser: "./jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js",
        default: "./jsx-runtime/dist/emotion-react-jsx-runtime.esm.js"
      },
      import: "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.mjs",
      default: "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.js"
    },
    "./_isolated-hnrs": {
      module: {
        worker: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.worker.esm.js",
        browser: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.browser.esm.js",
        default: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.esm.js"
      },
      import: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.mjs",
      default: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.js"
    },
    "./jsx-dev-runtime": {
      module: {
        worker: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.worker.esm.js",
        browser: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.browser.esm.js",
        default: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.esm.js"
      },
      import: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.mjs",
      default: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.js"
    },
    "./package.json": "./package.json",
    "./types/css-prop": "./types/css-prop.d.ts",
    "./macro": {
      types: {
        import: "./macro.d.mts",
        default: "./macro.d.ts"
      },
      default: "./macro.js"
    }
  },
  types: "types/index.d.ts",
  files: [
    "src",
    "dist",
    "jsx-runtime",
    "jsx-dev-runtime",
    "_isolated-hnrs",
    "types/*.d.ts",
    "macro.*"
  ],
  sideEffects: !1,
  author: "Emotion Contributors",
  license: "MIT",
  scripts: {
    "test:typescript": "dtslint types"
  },
  dependencies: {
    "@babel/runtime": "^7.18.3",
    "@emotion/babel-plugin": "^11.11.0",
    "@emotion/cache": "^11.11.0",
    "@emotion/serialize": "^1.1.2",
    "@emotion/use-insertion-effect-with-fallbacks": "^1.0.1",
    "@emotion/utils": "^1.2.1",
    "@emotion/weak-memoize": "^0.3.1",
    "hoist-non-react-statics": "^3.3.1"
  },
  peerDependencies: {
    react: ">=16.8.0"
  },
  peerDependenciesMeta: {
    "@types/react": {
      optional: !0
    }
  },
  devDependencies: {
    "@definitelytyped/dtslint": "0.0.112",
    "@emotion/css": "11.11.0",
    "@emotion/css-prettifier": "1.1.3",
    "@emotion/server": "11.11.0",
    "@emotion/styled": "11.11.0",
    "html-tag-names": "^1.1.2",
    react: "16.14.0",
    "svg-tag-names": "^1.1.1",
    typescript: "^4.5.5"
  },
  repository: "https://github.com/emotion-js/emotion/tree/main/packages/react",
  publishConfig: {
    access: "public"
  },
  "umd:main": "dist/emotion-react.umd.min.js",
  preconstruct: {
    entrypoints: [
      "./index.js",
      "./jsx-runtime.js",
      "./jsx-dev-runtime.js",
      "./_isolated-hnrs.js"
    ],
    umdName: "emotionReact",
    exports: {
      envConditions: [
        "browser",
        "worker"
      ],
      extra: {
        "./types/css-prop": "./types/css-prop.d.ts",
        "./macro": {
          types: {
            import: "./macro.d.mts",
            default: "./macro.d.ts"
          },
          default: "./macro.js"
        }
      }
    }
  }
}, SW = !1, bfe = /* @__PURE__ */ dv(function(e, t) {
  process.env.NODE_ENV !== "production" && !SW && // check for className as well since the user is
  // probably using the custom createElement which
  // means it will be turned into a className prop
  // $FlowFixMe I don't really want to add it to the type since it shouldn't be used
  (e.className || e.css) && (console.error("It looks like you're using the css prop on Global, did you mean to use the styles prop instead?"), SW = !0);
  var r = e.styles, n = yu([r], void 0, et.useContext(Lu)), i = et.useRef();
  return wW(function() {
    var a = t.key + "-global", s = new t.sheet.constructor({
      key: a,
      nonce: t.sheet.nonce,
      container: t.sheet.container,
      speedy: t.sheet.isSpeedy
    }), o = !1, u = document.querySelector('style[data-emotion="' + a + " " + n.name + '"]');
    return t.sheet.tags.length && (s.before = t.sheet.tags[0]), u !== null && (o = !0, u.setAttribute("data-emotion", a), s.hydrate([u])), i.current = [s, o], function() {
      s.flush();
    };
  }, [t]), wW(function() {
    var a = i.current, s = a[0], o = a[1];
    if (o) {
      a[1] = !1;
      return;
    }
    if (n.next !== void 0 && lv(t, n.next, !0), s.tags.length) {
      var u = s.tags[s.tags.length - 1].nextElementSibling;
      s.before = u, s.flush();
    }
    t.insert("", n, s, !1);
  }, [t, n.name]), null;
});
process.env.NODE_ENV !== "production" && (bfe.displayName = "EmotionGlobal");
function Afe() {
  for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++)
    t[r] = arguments[r];
  return yu(t);
}
var kq = function() {
  var t = Afe.apply(void 0, arguments), r = "animation-" + t.name;
  return {
    name: r,
    styles: "@keyframes " + r + "{" + t.styles + "}",
    anim: 1,
    toString: function() {
      return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
    }
  };
}, wfe = function e(t) {
  for (var r = t.length, n = 0, i = ""; n < r; n++) {
    var a = t[n];
    if (a != null) {
      var s = void 0;
      switch (typeof a) {
        case "boolean":
          break;
        case "object": {
          if (Array.isArray(a))
            s = e(a);
          else {
            process.env.NODE_ENV !== "production" && a.styles !== void 0 && a.name !== void 0 && console.error("You have passed styles created with `css` from `@emotion/react` package to the `cx`.\n`cx` is meant to compose class names (strings) so you should convert those styles to a class name by passing them to the `css` received from <ClassNames/> component."), s = "";
            for (var o in a)
              a[o] && o && (s && (s += " "), s += o);
          }
          break;
        }
        default:
          s = a;
      }
      s && (i && (i += " "), i += s);
    }
  }
  return i;
};
function kfe(e, t, r) {
  var n = [], i = qq(e, n, r);
  return n.length < 2 ? r : i + t(n);
}
var Wfe = function(t) {
  var r = t.cache, n = t.serializedArr;
  return Aq(function() {
    for (var i = 0; i < n.length; i++)
      lv(r, n[i], !1);
  }), null;
}, Sfe = /* @__PURE__ */ dv(function(e, t) {
  var r = !1, n = [], i = function() {
    if (r && process.env.NODE_ENV !== "production")
      throw new Error("css can only be used during render");
    for (var f = arguments.length, l = new Array(f), d = 0; d < f; d++)
      l[d] = arguments[d];
    var c = yu(l, t.registered);
    return n.push(c), fv(t, c, !1), t.key + "-" + c.name;
  }, a = function() {
    if (r && process.env.NODE_ENV !== "production")
      throw new Error("cx can only be used during render");
    for (var f = arguments.length, l = new Array(f), d = 0; d < f; d++)
      l[d] = arguments[d];
    return kfe(t.registered, i, wfe(l));
  }, s = {
    css: i,
    cx: a,
    theme: et.useContext(Lu)
  }, o = e.children(s);
  return r = !0, /* @__PURE__ */ et.createElement(et.Fragment, null, /* @__PURE__ */ et.createElement(Wfe, {
    cache: t,
    serializedArr: n
  }), o);
});
process.env.NODE_ENV !== "production" && (Sfe.displayName = "EmotionClassNames");
if (process.env.NODE_ENV !== "production") {
  var CW = !0, Cfe = typeof jest < "u" || typeof vi < "u";
  if (CW && !Cfe) {
    var FW = (
      // $FlowIgnore
      typeof globalThis < "u" ? globalThis : CW ? window : global
    ), KW = "__EMOTION_REACT_" + qfe.version.split(".")[0] + "__";
    FW[KW] && console.warn("You are loading @emotion/react when it is already loaded. Running multiple instances may cause problems. This can happen if multiple versions are used, or if multiple builds of the same version are used."), FW[KW] = !0;
  }
}
var Ffe = kue, Kfe = function(t) {
  return t !== "theme";
}, RW = function(t) {
  return typeof t == "string" && // 96 is one less than the char code
  // for "a" so this is checking that
  // it's a lowercase character
  t.charCodeAt(0) > 96 ? Ffe : Kfe;
}, TW = function(t, r, n) {
  var i;
  if (r) {
    var a = r.shouldForwardProp;
    i = t.__emotion_forwardProp && a ? function(s) {
      return t.__emotion_forwardProp(s) && a(s);
    } : a;
  }
  return typeof i != "function" && n && (i = t.__emotion_forwardProp), i;
}, UW = `You have illegal escape sequence in your template literal, most likely inside content's property value.
Because you write your CSS inside a JavaScript string you actually have to do double escaping, so for example "content: '\\00d7';" should become "content: '\\\\00d7';".
You can read more about this here:
https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences`, Rfe = function(t) {
  var r = t.cache, n = t.serialized, i = t.isStringTag;
  return fv(r, n, i), Aq(function() {
    return lv(r, n, i);
  }), null;
}, Tfe = function e(t, r) {
  if (process.env.NODE_ENV !== "production" && t === void 0)
    throw new Error(`You are trying to create a styled element with an undefined component.
You may have forgotten to import it.`);
  var n = t.__emotion_real === t, i = n && t.__emotion_base || t, a, s;
  r !== void 0 && (a = r.label, s = r.target);
  var o = TW(t, r, n), u = o || RW(i), f = !u("as");
  return function() {
    var l = arguments, d = n && t.__emotion_styles !== void 0 ? t.__emotion_styles.slice(0) : [];
    if (a !== void 0 && d.push("label:" + a + ";"), l[0] == null || l[0].raw === void 0)
      d.push.apply(d, l);
    else {
      process.env.NODE_ENV !== "production" && l[0][0] === void 0 && console.error(UW), d.push(l[0][0]);
      for (var c = l.length, p = 1; p < c; p++)
        process.env.NODE_ENV !== "production" && l[0][p] === void 0 && console.error(UW), d.push(l[p], l[0][p]);
    }
    var v = dv(function(h, m, q) {
      var w = f && h.as || i, O = "", C = [], R = h;
      if (h.theme == null) {
        R = {};
        for (var I in h)
          R[I] = h[I];
        R.theme = et.useContext(Lu);
      }
      typeof h.className == "string" ? O = qq(m.registered, C, h.className) : h.className != null && (O = h.className + " ");
      var P = yu(d.concat(C), m.registered, R);
      O += m.key + "-" + P.name, s !== void 0 && (O += " " + s);
      var K = f && o === void 0 ? RW(w) : u, B = {};
      for (var L in h)
        f && L === "as" || // $FlowFixMe
        K(L) && (B[L] = h[L]);
      return B.className = O, B.ref = q, /* @__PURE__ */ et.createElement(et.Fragment, null, /* @__PURE__ */ et.createElement(Rfe, {
        cache: m,
        serialized: P,
        isStringTag: typeof w == "string"
      }), /* @__PURE__ */ et.createElement(w, B));
    });
    return v.displayName = a !== void 0 ? a : "Styled(" + (typeof i == "string" ? i : i.displayName || i.name || "Component") + ")", v.defaultProps = t.defaultProps, v.__emotion_real = v, v.__emotion_base = i, v.__emotion_styles = d, v.__emotion_forwardProp = o, Object.defineProperty(v, "toString", {
      value: function() {
        return s === void 0 && process.env.NODE_ENV !== "production" ? "NO_COMPONENT_SELECTOR" : "." + s;
      }
    }), v.withComponent = function(h, m) {
      return e(h, yt({}, r, m, {
        shouldForwardProp: TW(v, m, !0)
      })).apply(void 0, d);
    }, v;
  };
}, Ufe = [
  "a",
  "abbr",
  "address",
  "area",
  "article",
  "aside",
  "audio",
  "b",
  "base",
  "bdi",
  "bdo",
  "big",
  "blockquote",
  "body",
  "br",
  "button",
  "canvas",
  "caption",
  "cite",
  "code",
  "col",
  "colgroup",
  "data",
  "datalist",
  "dd",
  "del",
  "details",
  "dfn",
  "dialog",
  "div",
  "dl",
  "dt",
  "em",
  "embed",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "head",
  "header",
  "hgroup",
  "hr",
  "html",
  "i",
  "iframe",
  "img",
  "input",
  "ins",
  "kbd",
  "keygen",
  "label",
  "legend",
  "li",
  "link",
  "main",
  "map",
  "mark",
  "marquee",
  "menu",
  "menuitem",
  "meta",
  "meter",
  "nav",
  "noscript",
  "object",
  "ol",
  "optgroup",
  "option",
  "output",
  "p",
  "param",
  "picture",
  "pre",
  "progress",
  "q",
  "rp",
  "rt",
  "ruby",
  "s",
  "samp",
  "script",
  "section",
  "select",
  "small",
  "source",
  "span",
  "strong",
  "style",
  "sub",
  "summary",
  "sup",
  "table",
  "tbody",
  "td",
  "textarea",
  "tfoot",
  "th",
  "thead",
  "time",
  "title",
  "tr",
  "track",
  "u",
  "ul",
  "var",
  "video",
  "wbr",
  // SVG
  "circle",
  "clipPath",
  "defs",
  "ellipse",
  "foreignObject",
  "g",
  "image",
  "line",
  "linearGradient",
  "mask",
  "path",
  "pattern",
  "polygon",
  "polyline",
  "radialGradient",
  "rect",
  "stop",
  "svg",
  "text",
  "tspan"
], Xg = Tfe.bind();
Ufe.forEach(function(e) {
  Xg[e] = Xg(e);
});
/**
 * @mui/styled-engine v5.14.11
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
function xfe(e, t) {
  const r = Xg(e, t);
  return process.env.NODE_ENV !== "production" ? (...n) => {
    const i = typeof e == "string" ? `"${e}"` : "component";
    return n.length === 0 ? console.error([`MUI: Seems like you called \`styled(${i})()\` without a \`style\` argument.`, 'You must provide a `styles` argument: `styled("div")(styleYouForgotToPass)`.'].join(`
`)) : n.some((a) => a === void 0) && console.error(`MUI: the styled(${i})(...args) API requires all its args to be defined.`), r(...n);
  } : r;
}
const Efe = (e, t) => {
  Array.isArray(e.__emotion_styles) && (e.__emotion_styles = t(e.__emotion_styles));
}, Ofe = ["values", "unit", "step"], Nfe = (e) => {
  const t = Object.keys(e).map((r) => ({
    key: r,
    val: e[r]
  })) || [];
  return t.sort((r, n) => r.val - n.val), t.reduce((r, n) => yt({}, r, {
    [n.key]: n.val
  }), {});
};
function Ife(e) {
  const {
    // The breakpoint **start** at this value.
    // For instance with the first breakpoint xs: [xs, sm).
    values: t = {
      xs: 0,
      // phone
      sm: 600,
      // tablet
      md: 900,
      // small laptop
      lg: 1200,
      // desktop
      xl: 1536
      // large screen
    },
    unit: r = "px",
    step: n = 5
  } = e, i = vn(e, Ofe), a = Nfe(t), s = Object.keys(a);
  function o(c) {
    return `@media (min-width:${typeof t[c] == "number" ? t[c] : c}${r})`;
  }
  function u(c) {
    return `@media (max-width:${(typeof t[c] == "number" ? t[c] : c) - n / 100}${r})`;
  }
  function f(c, p) {
    const v = s.indexOf(p);
    return `@media (min-width:${typeof t[c] == "number" ? t[c] : c}${r}) and (max-width:${(v !== -1 && typeof t[s[v]] == "number" ? t[s[v]] : p) - n / 100}${r})`;
  }
  function l(c) {
    return s.indexOf(c) + 1 < s.length ? f(c, s[s.indexOf(c) + 1]) : o(c);
  }
  function d(c) {
    const p = s.indexOf(c);
    return p === 0 ? o(s[1]) : p === s.length - 1 ? u(s[p]) : f(c, s[s.indexOf(c) + 1]).replace("@media", "@media not all and");
  }
  return yt({
    keys: s,
    values: a,
    up: o,
    down: u,
    between: f,
    only: l,
    not: d,
    unit: r
  }, i);
}
const Xfe = {
  borderRadius: 4
}, Pfe = Xfe, Bfe = process.env.NODE_ENV !== "production" ? be.oneOfType([be.number, be.string, be.object, be.array]) : {}, bs = Bfe;
function Df(e, t) {
  return t ? ha(e, t, {
    clone: !1
    // No need to clone deep, it's way faster.
  }) : e;
}
const Wq = {
  xs: 0,
  // phone
  sm: 600,
  // tablet
  md: 900,
  // small laptop
  lg: 1200,
  // desktop
  xl: 1536
  // large screen
}, xW = {
  // Sorted ASC by size. That's important.
  // It can't be configured as it's used statically for propTypes.
  keys: ["xs", "sm", "md", "lg", "xl"],
  up: (e) => `@media (min-width:${Wq[e]}px)`
};
function Aa(e, t, r) {
  const n = e.theme || {};
  if (Array.isArray(t)) {
    const a = n.breakpoints || xW;
    return t.reduce((s, o, u) => (s[a.up(a.keys[u])] = r(t[u]), s), {});
  }
  if (typeof t == "object") {
    const a = n.breakpoints || xW;
    return Object.keys(t).reduce((s, o) => {
      if (Object.keys(a.values || Wq).indexOf(o) !== -1) {
        const u = a.up(o);
        s[u] = r(t[o], o);
      } else {
        const u = o;
        s[u] = t[u];
      }
      return s;
    }, {});
  }
  return r(t);
}
function Dfe(e = {}) {
  var t;
  return ((t = e.keys) == null ? void 0 : t.reduce((n, i) => {
    const a = e.up(i);
    return n[a] = {}, n;
  }, {})) || {};
}
function Lfe(e, t) {
  return e.reduce((r, n) => {
    const i = r[n];
    return (!i || Object.keys(i).length === 0) && delete r[n], r;
  }, t);
}
function cv(e, t, r = !0) {
  if (!t || typeof t != "string")
    return null;
  if (e && e.vars && r) {
    const n = `vars.${t}`.split(".").reduce((i, a) => i && i[a] ? i[a] : null, e);
    if (n != null)
      return n;
  }
  return t.split(".").reduce((n, i) => n && n[i] != null ? n[i] : null, e);
}
function Qc(e, t, r, n = r) {
  let i;
  return typeof e == "function" ? i = e(r) : Array.isArray(e) ? i = e[r] || n : i = cv(e, r) || n, t && (i = t(i, n, e)), i;
}
function ur(e) {
  const {
    prop: t,
    cssProperty: r = e.prop,
    themeKey: n,
    transform: i
  } = e, a = (s) => {
    if (s[t] == null)
      return null;
    const o = s[t], u = s.theme, f = cv(u, n) || {};
    return Aa(s, o, (d) => {
      let c = Qc(f, i, d);
      return d === c && typeof d == "string" && (c = Qc(f, i, `${t}${d === "default" ? "" : rs(d)}`, d)), r === !1 ? c : {
        [r]: c
      };
    });
  };
  return a.propTypes = process.env.NODE_ENV !== "production" ? {
    [t]: bs
  } : {}, a.filterProps = [t], a;
}
function Zfe(e) {
  const t = {};
  return (r) => (t[r] === void 0 && (t[r] = e(r)), t[r]);
}
const Mfe = {
  m: "margin",
  p: "padding"
}, jfe = {
  t: "Top",
  r: "Right",
  b: "Bottom",
  l: "Left",
  x: ["Left", "Right"],
  y: ["Top", "Bottom"]
}, EW = {
  marginX: "mx",
  marginY: "my",
  paddingX: "px",
  paddingY: "py"
}, Yfe = Zfe((e) => {
  if (e.length > 2)
    if (EW[e])
      e = EW[e];
    else
      return [e];
  const [t, r] = e.split(""), n = Mfe[t], i = jfe[r] || "";
  return Array.isArray(i) ? i.map((a) => n + a) : [n + i];
}), pv = ["m", "mt", "mr", "mb", "ml", "mx", "my", "margin", "marginTop", "marginRight", "marginBottom", "marginLeft", "marginX", "marginY", "marginInline", "marginInlineStart", "marginInlineEnd", "marginBlock", "marginBlockStart", "marginBlockEnd"], vv = ["p", "pt", "pr", "pb", "pl", "px", "py", "padding", "paddingTop", "paddingRight", "paddingBottom", "paddingLeft", "paddingX", "paddingY", "paddingInline", "paddingInlineStart", "paddingInlineEnd", "paddingBlock", "paddingBlockStart", "paddingBlockEnd"], zfe = [...pv, ...vv];
function Gl(e, t, r, n) {
  var i;
  const a = (i = cv(e, t, !1)) != null ? i : r;
  return typeof a == "number" ? (s) => typeof s == "string" ? s : (process.env.NODE_ENV !== "production" && typeof s != "number" && console.error(`MUI: Expected ${n} argument to be a number or a string, got ${s}.`), a * s) : Array.isArray(a) ? (s) => typeof s == "string" ? s : (process.env.NODE_ENV !== "production" && (Number.isInteger(s) ? s > a.length - 1 && console.error([`MUI: The value provided (${s}) overflows.`, `The supported values are: ${JSON.stringify(a)}.`, `${s} > ${a.length - 1}, you need to add the missing values.`].join(`
`)) : console.error([`MUI: The \`theme.${t}\` array type cannot be combined with non integer values.You should either use an integer value that can be used as index, or define the \`theme.${t}\` as a number.`].join(`
`))), a[s]) : typeof a == "function" ? a : (process.env.NODE_ENV !== "production" && console.error([`MUI: The \`theme.${t}\` value (${a}) is invalid.`, "It should be a number, an array or a function."].join(`
`)), () => {
  });
}
function WR(e) {
  return Gl(e, "spacing", 8, "spacing");
}
function Ql(e, t) {
  if (typeof t == "string" || t == null)
    return t;
  const r = Math.abs(t), n = e(r);
  return t >= 0 ? n : typeof n == "number" ? -n : `-${n}`;
}
function Gfe(e, t) {
  return (r) => e.reduce((n, i) => (n[i] = Ql(t, r), n), {});
}
function Qfe(e, t, r, n) {
  if (t.indexOf(r) === -1)
    return null;
  const i = Yfe(r), a = Gfe(i, n), s = e[r];
  return Aa(e, s, a);
}
function SR(e, t) {
  const r = WR(e.theme);
  return Object.keys(e).map((n) => Qfe(e, t, n, r)).reduce(Df, {});
}
function Xr(e) {
  return SR(e, pv);
}
Xr.propTypes = process.env.NODE_ENV !== "production" ? pv.reduce((e, t) => (e[t] = bs, e), {}) : {};
Xr.filterProps = pv;
function Pr(e) {
  return SR(e, vv);
}
Pr.propTypes = process.env.NODE_ENV !== "production" ? vv.reduce((e, t) => (e[t] = bs, e), {}) : {};
Pr.filterProps = vv;
process.env.NODE_ENV !== "production" && zfe.reduce((e, t) => (e[t] = bs, e), {});
function Jfe(e = 8) {
  if (e.mui)
    return e;
  const t = WR({
    spacing: e
  }), r = (...n) => (process.env.NODE_ENV !== "production" && (n.length <= 4 || console.error(`MUI: Too many arguments provided, expected between 0 and 4, got ${n.length}`)), (n.length === 0 ? [1] : n).map((a) => {
    const s = t(a);
    return typeof s == "number" ? `${s}px` : s;
  }).join(" "));
  return r.mui = !0, r;
}
function hv(...e) {
  const t = e.reduce((n, i) => (i.filterProps.forEach((a) => {
    n[a] = i;
  }), n), {}), r = (n) => Object.keys(n).reduce((i, a) => t[a] ? Df(i, t[a](n)) : i, {});
  return r.propTypes = process.env.NODE_ENV !== "production" ? e.reduce((n, i) => Object.assign(n, i.propTypes), {}) : {}, r.filterProps = e.reduce((n, i) => n.concat(i.filterProps), []), r;
}
function Pi(e) {
  return typeof e != "number" ? e : `${e}px solid`;
}
const Hfe = ur({
  prop: "border",
  themeKey: "borders",
  transform: Pi
}), _fe = ur({
  prop: "borderTop",
  themeKey: "borders",
  transform: Pi
}), $fe = ur({
  prop: "borderRight",
  themeKey: "borders",
  transform: Pi
}), ele = ur({
  prop: "borderBottom",
  themeKey: "borders",
  transform: Pi
}), tle = ur({
  prop: "borderLeft",
  themeKey: "borders",
  transform: Pi
}), rle = ur({
  prop: "borderColor",
  themeKey: "palette"
}), nle = ur({
  prop: "borderTopColor",
  themeKey: "palette"
}), ile = ur({
  prop: "borderRightColor",
  themeKey: "palette"
}), ale = ur({
  prop: "borderBottomColor",
  themeKey: "palette"
}), sle = ur({
  prop: "borderLeftColor",
  themeKey: "palette"
}), mv = (e) => {
  if (e.borderRadius !== void 0 && e.borderRadius !== null) {
    const t = Gl(e.theme, "shape.borderRadius", 4, "borderRadius"), r = (n) => ({
      borderRadius: Ql(t, n)
    });
    return Aa(e, e.borderRadius, r);
  }
  return null;
};
mv.propTypes = process.env.NODE_ENV !== "production" ? {
  borderRadius: bs
} : {};
mv.filterProps = ["borderRadius"];
hv(Hfe, _fe, $fe, ele, tle, rle, nle, ile, ale, sle, mv);
const gv = (e) => {
  if (e.gap !== void 0 && e.gap !== null) {
    const t = Gl(e.theme, "spacing", 8, "gap"), r = (n) => ({
      gap: Ql(t, n)
    });
    return Aa(e, e.gap, r);
  }
  return null;
};
gv.propTypes = process.env.NODE_ENV !== "production" ? {
  gap: bs
} : {};
gv.filterProps = ["gap"];
const yv = (e) => {
  if (e.columnGap !== void 0 && e.columnGap !== null) {
    const t = Gl(e.theme, "spacing", 8, "columnGap"), r = (n) => ({
      columnGap: Ql(t, n)
    });
    return Aa(e, e.columnGap, r);
  }
  return null;
};
yv.propTypes = process.env.NODE_ENV !== "production" ? {
  columnGap: bs
} : {};
yv.filterProps = ["columnGap"];
const Vv = (e) => {
  if (e.rowGap !== void 0 && e.rowGap !== null) {
    const t = Gl(e.theme, "spacing", 8, "rowGap"), r = (n) => ({
      rowGap: Ql(t, n)
    });
    return Aa(e, e.rowGap, r);
  }
  return null;
};
Vv.propTypes = process.env.NODE_ENV !== "production" ? {
  rowGap: bs
} : {};
Vv.filterProps = ["rowGap"];
const ole = ur({
  prop: "gridColumn"
}), ule = ur({
  prop: "gridRow"
}), fle = ur({
  prop: "gridAutoFlow"
}), lle = ur({
  prop: "gridAutoColumns"
}), dle = ur({
  prop: "gridAutoRows"
}), cle = ur({
  prop: "gridTemplateColumns"
}), ple = ur({
  prop: "gridTemplateRows"
}), vle = ur({
  prop: "gridTemplateAreas"
}), hle = ur({
  prop: "gridArea"
});
hv(gv, yv, Vv, ole, ule, fle, lle, dle, cle, ple, vle, hle);
function tu(e, t) {
  return t === "grey" ? t : e;
}
const mle = ur({
  prop: "color",
  themeKey: "palette",
  transform: tu
}), gle = ur({
  prop: "bgcolor",
  cssProperty: "backgroundColor",
  themeKey: "palette",
  transform: tu
}), yle = ur({
  prop: "backgroundColor",
  themeKey: "palette",
  transform: tu
});
hv(mle, gle, yle);
function Nn(e) {
  return e <= 1 && e !== 0 ? `${e * 100}%` : e;
}
const Vle = ur({
  prop: "width",
  transform: Nn
}), Sq = (e) => {
  if (e.maxWidth !== void 0 && e.maxWidth !== null) {
    const t = (r) => {
      var n, i;
      const a = ((n = e.theme) == null || (n = n.breakpoints) == null || (n = n.values) == null ? void 0 : n[r]) || Wq[r];
      return a ? ((i = e.theme) == null || (i = i.breakpoints) == null ? void 0 : i.unit) !== "px" ? {
        maxWidth: `${a}${e.theme.breakpoints.unit}`
      } : {
        maxWidth: a
      } : {
        maxWidth: Nn(r)
      };
    };
    return Aa(e, e.maxWidth, t);
  }
  return null;
};
Sq.filterProps = ["maxWidth"];
const qle = ur({
  prop: "minWidth",
  transform: Nn
}), ble = ur({
  prop: "height",
  transform: Nn
}), Ale = ur({
  prop: "maxHeight",
  transform: Nn
}), wle = ur({
  prop: "minHeight",
  transform: Nn
});
ur({
  prop: "size",
  cssProperty: "width",
  transform: Nn
});
ur({
  prop: "size",
  cssProperty: "height",
  transform: Nn
});
const kle = ur({
  prop: "boxSizing"
});
hv(Vle, Sq, qle, ble, Ale, wle, kle);
const Wle = {
  // borders
  border: {
    themeKey: "borders",
    transform: Pi
  },
  borderTop: {
    themeKey: "borders",
    transform: Pi
  },
  borderRight: {
    themeKey: "borders",
    transform: Pi
  },
  borderBottom: {
    themeKey: "borders",
    transform: Pi
  },
  borderLeft: {
    themeKey: "borders",
    transform: Pi
  },
  borderColor: {
    themeKey: "palette"
  },
  borderTopColor: {
    themeKey: "palette"
  },
  borderRightColor: {
    themeKey: "palette"
  },
  borderBottomColor: {
    themeKey: "palette"
  },
  borderLeftColor: {
    themeKey: "palette"
  },
  borderRadius: {
    themeKey: "shape.borderRadius",
    style: mv
  },
  // palette
  color: {
    themeKey: "palette",
    transform: tu
  },
  bgcolor: {
    themeKey: "palette",
    cssProperty: "backgroundColor",
    transform: tu
  },
  backgroundColor: {
    themeKey: "palette",
    transform: tu
  },
  // spacing
  p: {
    style: Pr
  },
  pt: {
    style: Pr
  },
  pr: {
    style: Pr
  },
  pb: {
    style: Pr
  },
  pl: {
    style: Pr
  },
  px: {
    style: Pr
  },
  py: {
    style: Pr
  },
  padding: {
    style: Pr
  },
  paddingTop: {
    style: Pr
  },
  paddingRight: {
    style: Pr
  },
  paddingBottom: {
    style: Pr
  },
  paddingLeft: {
    style: Pr
  },
  paddingX: {
    style: Pr
  },
  paddingY: {
    style: Pr
  },
  paddingInline: {
    style: Pr
  },
  paddingInlineStart: {
    style: Pr
  },
  paddingInlineEnd: {
    style: Pr
  },
  paddingBlock: {
    style: Pr
  },
  paddingBlockStart: {
    style: Pr
  },
  paddingBlockEnd: {
    style: Pr
  },
  m: {
    style: Xr
  },
  mt: {
    style: Xr
  },
  mr: {
    style: Xr
  },
  mb: {
    style: Xr
  },
  ml: {
    style: Xr
  },
  mx: {
    style: Xr
  },
  my: {
    style: Xr
  },
  margin: {
    style: Xr
  },
  marginTop: {
    style: Xr
  },
  marginRight: {
    style: Xr
  },
  marginBottom: {
    style: Xr
  },
  marginLeft: {
    style: Xr
  },
  marginX: {
    style: Xr
  },
  marginY: {
    style: Xr
  },
  marginInline: {
    style: Xr
  },
  marginInlineStart: {
    style: Xr
  },
  marginInlineEnd: {
    style: Xr
  },
  marginBlock: {
    style: Xr
  },
  marginBlockStart: {
    style: Xr
  },
  marginBlockEnd: {
    style: Xr
  },
  // display
  displayPrint: {
    cssProperty: !1,
    transform: (e) => ({
      "@media print": {
        display: e
      }
    })
  },
  display: {},
  overflow: {},
  textOverflow: {},
  visibility: {},
  whiteSpace: {},
  // flexbox
  flexBasis: {},
  flexDirection: {},
  flexWrap: {},
  justifyContent: {},
  alignItems: {},
  alignContent: {},
  order: {},
  flex: {},
  flexGrow: {},
  flexShrink: {},
  alignSelf: {},
  justifyItems: {},
  justifySelf: {},
  // grid
  gap: {
    style: gv
  },
  rowGap: {
    style: Vv
  },
  columnGap: {
    style: yv
  },
  gridColumn: {},
  gridRow: {},
  gridAutoFlow: {},
  gridAutoColumns: {},
  gridAutoRows: {},
  gridTemplateColumns: {},
  gridTemplateRows: {},
  gridTemplateAreas: {},
  gridArea: {},
  // positions
  position: {},
  zIndex: {
    themeKey: "zIndex"
  },
  top: {},
  right: {},
  bottom: {},
  left: {},
  // shadows
  boxShadow: {
    themeKey: "shadows"
  },
  // sizing
  width: {
    transform: Nn
  },
  maxWidth: {
    style: Sq
  },
  minWidth: {
    transform: Nn
  },
  height: {
    transform: Nn
  },
  maxHeight: {
    transform: Nn
  },
  minHeight: {
    transform: Nn
  },
  boxSizing: {},
  // typography
  fontFamily: {
    themeKey: "typography"
  },
  fontSize: {
    themeKey: "typography"
  },
  fontStyle: {
    themeKey: "typography"
  },
  fontWeight: {
    themeKey: "typography"
  },
  letterSpacing: {},
  textTransform: {},
  lineHeight: {},
  textAlign: {},
  typography: {
    cssProperty: !1,
    themeKey: "typography"
  }
}, qv = Wle;
function Sle(...e) {
  const t = e.reduce((n, i) => n.concat(Object.keys(i)), []), r = new Set(t);
  return e.every((n) => r.size === Object.keys(n).length);
}
function Cle(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function Fle() {
  function e(r, n, i, a) {
    const s = {
      [r]: n,
      theme: i
    }, o = a[r];
    if (!o)
      return {
        [r]: n
      };
    const {
      cssProperty: u = r,
      themeKey: f,
      transform: l,
      style: d
    } = o;
    if (n == null)
      return null;
    if (f === "typography" && n === "inherit")
      return {
        [r]: n
      };
    const c = cv(i, f) || {};
    return d ? d(s) : Aa(s, n, (v) => {
      let h = Qc(c, l, v);
      return v === h && typeof v == "string" && (h = Qc(c, l, `${r}${v === "default" ? "" : rs(v)}`, v)), u === !1 ? h : {
        [u]: h
      };
    });
  }
  function t(r) {
    var n;
    const {
      sx: i,
      theme: a = {}
    } = r || {};
    if (!i)
      return null;
    const s = (n = a.unstable_sxConfig) != null ? n : qv;
    function o(u) {
      let f = u;
      if (typeof u == "function")
        f = u(a);
      else if (typeof u != "object")
        return u;
      if (!f)
        return null;
      const l = Dfe(a.breakpoints), d = Object.keys(l);
      let c = l;
      return Object.keys(f).forEach((p) => {
        const v = Cle(f[p], a);
        if (v != null)
          if (typeof v == "object")
            if (s[p])
              c = Df(c, e(p, v, a, s));
            else {
              const h = Aa({
                theme: a
              }, v, (m) => ({
                [p]: m
              }));
              Sle(h, v) ? c[p] = t({
                sx: v,
                theme: a
              }) : c = Df(c, h);
            }
          else
            c = Df(c, e(p, v, a, s));
      }), Lfe(d, c);
    }
    return Array.isArray(i) ? i.map(o) : o(i);
  }
  return t;
}
const CR = Fle();
CR.filterProps = ["sx"];
const Cq = CR, Kle = ["breakpoints", "palette", "spacing", "shape"];
function Fq(e = {}, ...t) {
  const {
    breakpoints: r = {},
    palette: n = {},
    spacing: i,
    shape: a = {}
  } = e, s = vn(e, Kle), o = Ife(r), u = Jfe(i);
  let f = ha({
    breakpoints: o,
    direction: "ltr",
    components: {},
    // Inject component definitions.
    palette: yt({
      mode: "light"
    }, n),
    spacing: u,
    shape: yt({}, Pfe, a)
  }, s);
  return f = t.reduce((l, d) => ha(l, d), f), f.unstable_sxConfig = yt({}, qv, s == null ? void 0 : s.unstable_sxConfig), f.unstable_sx = function(d) {
    return Cq({
      sx: d,
      theme: this
    });
  }, f;
}
function Rle(e) {
  return Object.keys(e).length === 0;
}
function FR(e = null) {
  const t = et.useContext(Lu);
  return !t || Rle(t) ? e : t;
}
const Tle = Fq();
function KR(e = Tle) {
  return FR(e);
}
const Ule = ["sx"], xle = (e) => {
  var t, r;
  const n = {
    systemProps: {},
    otherProps: {}
  }, i = (t = e == null || (r = e.theme) == null ? void 0 : r.unstable_sxConfig) != null ? t : qv;
  return Object.keys(e).forEach((a) => {
    i[a] ? n.systemProps[a] = e[a] : n.otherProps[a] = e[a];
  }), n;
};
function Ele(e) {
  const {
    sx: t
  } = e, r = vn(e, Ule), {
    systemProps: n,
    otherProps: i
  } = xle(r);
  let a;
  return Array.isArray(t) ? a = [n, ...t] : typeof t == "function" ? a = (...s) => {
    const o = t(...s);
    return Os(o) ? yt({}, n, o) : n;
  } : a = yt({}, n, t), yt({}, i, {
    sx: a
  });
}
function RR(e) {
  var t, r, n = "";
  if (typeof e == "string" || typeof e == "number")
    n += e;
  else if (typeof e == "object")
    if (Array.isArray(e))
      for (t = 0; t < e.length; t++)
        e[t] && (r = RR(e[t])) && (n && (n += " "), n += r);
    else
      for (t in e)
        e[t] && (n && (n += " "), n += t);
  return n;
}
function qn() {
  for (var e, t, r = 0, n = ""; r < arguments.length; )
    (e = arguments[r++]) && (t = RR(e)) && (n && (n += " "), n += t);
  return n;
}
const Ole = ["variant"];
function OW(e) {
  return e.length === 0;
}
function TR(e) {
  const {
    variant: t
  } = e, r = vn(e, Ole);
  let n = t || "";
  return Object.keys(r).sort().forEach((i) => {
    i === "color" ? n += OW(n) ? e[i] : rs(e[i]) : n += `${OW(n) ? i : rs(i)}${rs(e[i].toString())}`;
  }), n;
}
const Nle = ["name", "slot", "skipVariantsResolver", "skipSx", "overridesResolver"];
function Ile(e) {
  return Object.keys(e).length === 0;
}
function Xle(e) {
  return typeof e == "string" && // 96 is one less than the char code
  // for "a" so this is checking that
  // it's a lowercase character
  e.charCodeAt(0) > 96;
}
const Ple = (e, t) => t.components && t.components[e] && t.components[e].styleOverrides ? t.components[e].styleOverrides : null, Ble = (e, t) => {
  let r = [];
  t && t.components && t.components[e] && t.components[e].variants && (r = t.components[e].variants);
  const n = {};
  return r.forEach((i) => {
    const a = TR(i.props);
    n[a] = i.style;
  }), n;
}, Dle = (e, t, r, n) => {
  var i;
  const {
    ownerState: a = {}
  } = e, s = [], o = r == null || (i = r.components) == null || (i = i[n]) == null ? void 0 : i.variants;
  return o && o.forEach((u) => {
    let f = !0;
    Object.keys(u.props).forEach((l) => {
      a[l] !== u.props[l] && e[l] !== u.props[l] && (f = !1);
    }), f && s.push(t[TR(u.props)]);
  }), s;
};
function cc(e) {
  return e !== "ownerState" && e !== "theme" && e !== "sx" && e !== "as";
}
const Lle = Fq(), NW = (e) => e && e.charAt(0).toLowerCase() + e.slice(1);
function wf({
  defaultTheme: e,
  theme: t,
  themeId: r
}) {
  return Ile(t) ? e : t[r] || t;
}
function Zle(e) {
  return e ? (t, r) => r[e] : null;
}
function Mle(e = {}) {
  const {
    themeId: t,
    defaultTheme: r = Lle,
    rootShouldForwardProp: n = cc,
    slotShouldForwardProp: i = cc
  } = e, a = (s) => Cq(yt({}, s, {
    theme: wf(yt({}, s, {
      defaultTheme: r,
      themeId: t
    }))
  }));
  return a.__mui_systemSx = !0, (s, o = {}) => {
    Efe(s, (C) => C.filter((R) => !(R != null && R.__mui_systemSx)));
    const {
      name: u,
      slot: f,
      skipVariantsResolver: l,
      skipSx: d,
      // TODO v6: remove `lowercaseFirstLetter()` in the next major release
      // For more details: https://github.com/mui/material-ui/pull/37908
      overridesResolver: c = Zle(NW(f))
    } = o, p = vn(o, Nle), v = l !== void 0 ? l : (
      // TODO v6: remove `Root` in the next major release
      // For more details: https://github.com/mui/material-ui/pull/37908
      f && f !== "Root" && f !== "root" || !1
    ), h = d || !1;
    let m;
    process.env.NODE_ENV !== "production" && u && (m = `${u}-${NW(f || "Root")}`);
    let q = cc;
    f === "Root" || f === "root" ? q = n : f ? q = i : Xle(s) && (q = void 0);
    const w = xfe(s, yt({
      shouldForwardProp: q,
      label: m
    }, p)), O = (C, ...R) => {
      const I = R ? R.map((L) => typeof L == "function" && L.__emotion_real !== L ? (_) => L(yt({}, _, {
        theme: wf(yt({}, _, {
          defaultTheme: r,
          themeId: t
        }))
      })) : L) : [];
      let P = C;
      u && c && I.push((L) => {
        const _ = wf(yt({}, L, {
          defaultTheme: r,
          themeId: t
        })), ne = Ple(u, _);
        if (ne) {
          const Z = {};
          return Object.entries(ne).forEach(([le, he]) => {
            Z[le] = typeof he == "function" ? he(yt({}, L, {
              theme: _
            })) : he;
          }), c(L, Z);
        }
        return null;
      }), u && !v && I.push((L) => {
        const _ = wf(yt({}, L, {
          defaultTheme: r,
          themeId: t
        }));
        return Dle(L, Ble(u, _), _, u);
      }), h || I.push(a);
      const K = I.length - R.length;
      if (Array.isArray(C) && K > 0) {
        const L = new Array(K).fill("");
        P = [...C, ...L], P.raw = [...C.raw, ...L];
      } else
        typeof C == "function" && // On the server Emotion doesn't use React.forwardRef for creating components, so the created
        // component stays as a function. This condition makes sure that we do not interpolate functions
        // which are basically components used as a selectors.
        C.__emotion_real !== C && (P = (L) => C(yt({}, L, {
          theme: wf(yt({}, L, {
            defaultTheme: r,
            themeId: t
          }))
        })));
      const B = w(P, ...I);
      if (process.env.NODE_ENV !== "production") {
        let L;
        u && (L = `${u}${rs(f || "")}`), L === void 0 && (L = `Styled(${oue(s)})`), B.displayName = L;
      }
      return s.muiName && (B.muiName = s.muiName), B;
    };
    return w.withConfig && (O.withConfig = w.withConfig), O;
  };
}
function UR(e) {
  const {
    theme: t,
    name: r,
    props: n
  } = e;
  return !t || !t.components || !t.components[r] || !t.components[r].defaultProps ? n : cR(t.components[r].defaultProps, n);
}
function jle({
  props: e,
  name: t,
  defaultTheme: r,
  themeId: n
}) {
  let i = KR(r);
  return n && (i = i[n] || i), UR({
    theme: i,
    name: t,
    props: e
  });
}
function Kq(e, t = 0, r = 1) {
  return process.env.NODE_ENV !== "production" && (e < t || e > r) && console.error(`MUI: The value provided ${e} is out of range [${t}, ${r}].`), Math.min(Math.max(t, e), r);
}
function Yle(e) {
  e = e.slice(1);
  const t = new RegExp(`.{1,${e.length >= 6 ? 2 : 1}}`, "g");
  let r = e.match(t);
  return r && r[0].length === 1 && (r = r.map((n) => n + n)), r ? `rgb${r.length === 4 ? "a" : ""}(${r.map((n, i) => i < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1e3) / 1e3).join(", ")})` : "";
}
function zs(e) {
  if (e.type)
    return e;
  if (e.charAt(0) === "#")
    return zs(Yle(e));
  const t = e.indexOf("("), r = e.substring(0, t);
  if (["rgb", "rgba", "hsl", "hsla", "color"].indexOf(r) === -1)
    throw new Error(process.env.NODE_ENV !== "production" ? `MUI: Unsupported \`${e}\` color.
The following formats are supported: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color().` : mu(9, e));
  let n = e.substring(t + 1, e.length - 1), i;
  if (r === "color") {
    if (n = n.split(" "), i = n.shift(), n.length === 4 && n[3].charAt(0) === "/" && (n[3] = n[3].slice(1)), ["srgb", "display-p3", "a98-rgb", "prophoto-rgb", "rec-2020"].indexOf(i) === -1)
      throw new Error(process.env.NODE_ENV !== "production" ? `MUI: unsupported \`${i}\` color space.
The following color spaces are supported: srgb, display-p3, a98-rgb, prophoto-rgb, rec-2020.` : mu(10, i));
  } else
    n = n.split(",");
  return n = n.map((a) => parseFloat(a)), {
    type: r,
    values: n,
    colorSpace: i
  };
}
function bv(e) {
  const {
    type: t,
    colorSpace: r
  } = e;
  let {
    values: n
  } = e;
  return t.indexOf("rgb") !== -1 ? n = n.map((i, a) => a < 3 ? parseInt(i, 10) : i) : t.indexOf("hsl") !== -1 && (n[1] = `${n[1]}%`, n[2] = `${n[2]}%`), t.indexOf("color") !== -1 ? n = `${r} ${n.join(" ")}` : n = `${n.join(", ")}`, `${t}(${n})`;
}
function zle(e) {
  e = zs(e);
  const {
    values: t
  } = e, r = t[0], n = t[1] / 100, i = t[2] / 100, a = n * Math.min(i, 1 - i), s = (f, l = (f + r / 30) % 12) => i - a * Math.max(Math.min(l - 3, 9 - l, 1), -1);
  let o = "rgb";
  const u = [Math.round(s(0) * 255), Math.round(s(8) * 255), Math.round(s(4) * 255)];
  return e.type === "hsla" && (o += "a", u.push(t[3])), bv({
    type: o,
    values: u
  });
}
function IW(e) {
  e = zs(e);
  let t = e.type === "hsl" || e.type === "hsla" ? zs(zle(e)).values : e.values;
  return t = t.map((r) => (e.type !== "color" && (r /= 255), r <= 0.03928 ? r / 12.92 : ((r + 0.055) / 1.055) ** 2.4)), Number((0.2126 * t[0] + 0.7152 * t[1] + 0.0722 * t[2]).toFixed(3));
}
function XW(e, t) {
  const r = IW(e), n = IW(t);
  return (Math.max(r, n) + 0.05) / (Math.min(r, n) + 0.05);
}
function jd(e, t) {
  return e = zs(e), t = Kq(t), (e.type === "rgb" || e.type === "hsl") && (e.type += "a"), e.type === "color" ? e.values[3] = `/${t}` : e.values[3] = t, bv(e);
}
function Gle(e, t) {
  if (e = zs(e), t = Kq(t), e.type.indexOf("hsl") !== -1)
    e.values[2] *= 1 - t;
  else if (e.type.indexOf("rgb") !== -1 || e.type.indexOf("color") !== -1)
    for (let r = 0; r < 3; r += 1)
      e.values[r] *= 1 - t;
  return bv(e);
}
function Qle(e, t) {
  if (e = zs(e), t = Kq(t), e.type.indexOf("hsl") !== -1)
    e.values[2] += (100 - e.values[2]) * t;
  else if (e.type.indexOf("rgb") !== -1)
    for (let r = 0; r < 3; r += 1)
      e.values[r] += (255 - e.values[r]) * t;
  else if (e.type.indexOf("color") !== -1)
    for (let r = 0; r < 3; r += 1)
      e.values[r] += (1 - e.values[r]) * t;
  return bv(e);
}
function Jle(e, t) {
  return yt({
    toolbar: {
      minHeight: 56,
      [e.up("xs")]: {
        "@media (orientation: landscape)": {
          minHeight: 48
        }
      },
      [e.up("sm")]: {
        minHeight: 64
      }
    }
  }, t);
}
const Hle = ["mode", "contrastThreshold", "tonalOffset"], PW = {
  // The colors used to style the text.
  text: {
    // The most important text.
    primary: "rgba(0, 0, 0, 0.87)",
    // Secondary text.
    secondary: "rgba(0, 0, 0, 0.6)",
    // Disabled text have even lower visual prominence.
    disabled: "rgba(0, 0, 0, 0.38)"
  },
  // The color used to divide different elements.
  divider: "rgba(0, 0, 0, 0.12)",
  // The background colors used to style the surfaces.
  // Consistency between these values is important.
  background: {
    paper: al.white,
    default: al.white
  },
  // The colors used to style the action elements.
  action: {
    // The color of an active action like an icon button.
    active: "rgba(0, 0, 0, 0.54)",
    // The color of an hovered action.
    hover: "rgba(0, 0, 0, 0.04)",
    hoverOpacity: 0.04,
    // The color of a selected action.
    selected: "rgba(0, 0, 0, 0.08)",
    selectedOpacity: 0.08,
    // The color of a disabled action.
    disabled: "rgba(0, 0, 0, 0.26)",
    // The background color of a disabled action.
    disabledBackground: "rgba(0, 0, 0, 0.12)",
    disabledOpacity: 0.38,
    focus: "rgba(0, 0, 0, 0.12)",
    focusOpacity: 0.12,
    activatedOpacity: 0.12
  }
}, Q1 = {
  text: {
    primary: al.white,
    secondary: "rgba(255, 255, 255, 0.7)",
    disabled: "rgba(255, 255, 255, 0.5)",
    icon: "rgba(255, 255, 255, 0.5)"
  },
  divider: "rgba(255, 255, 255, 0.12)",
  background: {
    paper: "#121212",
    default: "#121212"
  },
  action: {
    active: al.white,
    hover: "rgba(255, 255, 255, 0.08)",
    hoverOpacity: 0.08,
    selected: "rgba(255, 255, 255, 0.16)",
    selectedOpacity: 0.16,
    disabled: "rgba(255, 255, 255, 0.3)",
    disabledBackground: "rgba(255, 255, 255, 0.12)",
    disabledOpacity: 0.38,
    focus: "rgba(255, 255, 255, 0.12)",
    focusOpacity: 0.12,
    activatedOpacity: 0.24
  }
};
function BW(e, t, r, n) {
  const i = n.light || n, a = n.dark || n * 1.5;
  e[t] || (e.hasOwnProperty(r) ? e[t] = e[r] : t === "light" ? e.light = Qle(e.main, i) : t === "dark" && (e.dark = Gle(e.main, a)));
}
function _le(e = "light") {
  return e === "dark" ? {
    main: To[200],
    light: To[50],
    dark: To[400]
  } : {
    main: To[700],
    light: To[400],
    dark: To[800]
  };
}
function $le(e = "light") {
  return e === "dark" ? {
    main: Ro[200],
    light: Ro[50],
    dark: Ro[400]
  } : {
    main: Ro[500],
    light: Ro[300],
    dark: Ro[700]
  };
}
function ede(e = "light") {
  return e === "dark" ? {
    main: Ko[500],
    light: Ko[300],
    dark: Ko[700]
  } : {
    main: Ko[700],
    light: Ko[400],
    dark: Ko[800]
  };
}
function tde(e = "light") {
  return e === "dark" ? {
    main: Uo[400],
    light: Uo[300],
    dark: Uo[700]
  } : {
    main: Uo[700],
    light: Uo[500],
    dark: Uo[900]
  };
}
function rde(e = "light") {
  return e === "dark" ? {
    main: Us[400],
    light: Us[300],
    dark: Us[700]
  } : {
    main: Us[800],
    light: Us[500],
    dark: Us[900]
  };
}
function nde(e = "light") {
  return e === "dark" ? {
    main: bf[400],
    light: bf[300],
    dark: bf[700]
  } : {
    main: "#ed6c02",
    // closest to orange[800] that pass 3:1.
    light: bf[500],
    dark: bf[900]
  };
}
function ide(e) {
  const {
    mode: t = "light",
    contrastThreshold: r = 3,
    tonalOffset: n = 0.2
  } = e, i = vn(e, Hle), a = e.primary || _le(t), s = e.secondary || $le(t), o = e.error || ede(t), u = e.info || tde(t), f = e.success || rde(t), l = e.warning || nde(t);
  function d(h) {
    const m = XW(h, Q1.text.primary) >= r ? Q1.text.primary : PW.text.primary;
    if (process.env.NODE_ENV !== "production") {
      const q = XW(h, m);
      q < 3 && console.error([`MUI: The contrast ratio of ${q}:1 for ${m} on ${h}`, "falls below the WCAG recommended absolute minimum contrast ratio of 3:1.", "https://www.w3.org/TR/2008/REC-WCAG20-20081211/#visual-audio-contrast-contrast"].join(`
`));
    }
    return m;
  }
  const c = ({
    color: h,
    name: m,
    mainShade: q = 500,
    lightShade: w = 300,
    darkShade: O = 700
  }) => {
    if (h = yt({}, h), !h.main && h[q] && (h.main = h[q]), !h.hasOwnProperty("main"))
      throw new Error(process.env.NODE_ENV !== "production" ? `MUI: The color${m ? ` (${m})` : ""} provided to augmentColor(color) is invalid.
The color object needs to have a \`main\` property or a \`${q}\` property.` : mu(11, m ? ` (${m})` : "", q));
    if (typeof h.main != "string")
      throw new Error(process.env.NODE_ENV !== "production" ? `MUI: The color${m ? ` (${m})` : ""} provided to augmentColor(color) is invalid.
\`color.main\` should be a string, but \`${JSON.stringify(h.main)}\` was provided instead.

Did you intend to use one of the following approaches?

import { green } from "@mui/material/colors";

const theme1 = createTheme({ palette: {
  primary: green,
} });

const theme2 = createTheme({ palette: {
  primary: { main: green[500] },
} });` : mu(12, m ? ` (${m})` : "", JSON.stringify(h.main)));
    return BW(h, "light", w, n), BW(h, "dark", O, n), h.contrastText || (h.contrastText = d(h.main)), h;
  }, p = {
    dark: Q1,
    light: PW
  };
  return process.env.NODE_ENV !== "production" && (p[t] || console.error(`MUI: The palette mode \`${t}\` is not supported.`)), ha(yt({
    // A collection of common colors.
    common: yt({}, al),
    // prevent mutable object.
    // The palette mode, can be light or dark.
    mode: t,
    // The colors used to represent primary interface elements for a user.
    primary: c({
      color: a,
      name: "primary"
    }),
    // The colors used to represent secondary interface elements for a user.
    secondary: c({
      color: s,
      name: "secondary",
      mainShade: "A400",
      lightShade: "A200",
      darkShade: "A700"
    }),
    // The colors used to represent interface elements that the user should be made aware of.
    error: c({
      color: o,
      name: "error"
    }),
    // The colors used to represent potentially dangerous actions or important messages.
    warning: c({
      color: l,
      name: "warning"
    }),
    // The colors used to present information to the user that is neutral and not necessarily important.
    info: c({
      color: u,
      name: "info"
    }),
    // The colors used to indicate the successful completion of an action that user triggered.
    success: c({
      color: f,
      name: "success"
    }),
    // The grey colors.
    grey: joe,
    // Used by `getContrastText()` to maximize the contrast between
    // the background and the text.
    contrastThreshold: r,
    // Takes a background color and returns the text color that maximizes the contrast.
    getContrastText: d,
    // Generate a rich color object.
    augmentColor: c,
    // Used by the functions below to shift a color's luminance by approximately
    // two indexes within its tonal palette.
    // E.g., shift from Red 500 to Red 300 or Red 700.
    tonalOffset: n
  }, p[t]), i);
}
const ade = ["fontFamily", "fontSize", "fontWeightLight", "fontWeightRegular", "fontWeightMedium", "fontWeightBold", "htmlFontSize", "allVariants", "pxToRem"];
function sde(e) {
  return Math.round(e * 1e5) / 1e5;
}
const DW = {
  textTransform: "uppercase"
}, LW = '"Roboto", "Helvetica", "Arial", sans-serif';
function ode(e, t) {
  const r = typeof t == "function" ? t(e) : t, {
    fontFamily: n = LW,
    // The default font size of the Material Specification.
    fontSize: i = 14,
    // px
    fontWeightLight: a = 300,
    fontWeightRegular: s = 400,
    fontWeightMedium: o = 500,
    fontWeightBold: u = 700,
    // Tell MUI what's the font-size on the html element.
    // 16px is the default font-size used by browsers.
    htmlFontSize: f = 16,
    // Apply the CSS properties to all the variants.
    allVariants: l,
    pxToRem: d
  } = r, c = vn(r, ade);
  process.env.NODE_ENV !== "production" && (typeof i != "number" && console.error("MUI: `fontSize` is required to be a number."), typeof f != "number" && console.error("MUI: `htmlFontSize` is required to be a number."));
  const p = i / 14, v = d || ((q) => `${q / f * p}rem`), h = (q, w, O, C, R) => yt({
    fontFamily: n,
    fontWeight: q,
    fontSize: v(w),
    // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
    lineHeight: O
  }, n === LW ? {
    letterSpacing: `${sde(C / w)}em`
  } : {}, R, l), m = {
    h1: h(a, 96, 1.167, -1.5),
    h2: h(a, 60, 1.2, -0.5),
    h3: h(s, 48, 1.167, 0),
    h4: h(s, 34, 1.235, 0.25),
    h5: h(s, 24, 1.334, 0),
    h6: h(o, 20, 1.6, 0.15),
    subtitle1: h(s, 16, 1.75, 0.15),
    subtitle2: h(o, 14, 1.57, 0.1),
    body1: h(s, 16, 1.5, 0.15),
    body2: h(s, 14, 1.43, 0.15),
    button: h(o, 14, 1.75, 0.4, DW),
    caption: h(s, 12, 1.66, 0.4),
    overline: h(s, 12, 2.66, 1, DW),
    // TODO v6: Remove handling of 'inherit' variant from the theme as it is already handled in Material UI's Typography component. Also, remember to remove the associated types.
    inherit: {
      fontFamily: "inherit",
      fontWeight: "inherit",
      fontSize: "inherit",
      lineHeight: "inherit",
      letterSpacing: "inherit"
    }
  };
  return ha(yt({
    htmlFontSize: f,
    pxToRem: v,
    fontFamily: n,
    fontSize: i,
    fontWeightLight: a,
    fontWeightRegular: s,
    fontWeightMedium: o,
    fontWeightBold: u
  }, m), c, {
    clone: !1
    // No need to clone deep
  });
}
const ude = 0.2, fde = 0.14, lde = 0.12;
function Wr(...e) {
  return [`${e[0]}px ${e[1]}px ${e[2]}px ${e[3]}px rgba(0,0,0,${ude})`, `${e[4]}px ${e[5]}px ${e[6]}px ${e[7]}px rgba(0,0,0,${fde})`, `${e[8]}px ${e[9]}px ${e[10]}px ${e[11]}px rgba(0,0,0,${lde})`].join(",");
}
const dde = ["none", Wr(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0), Wr(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0), Wr(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0), Wr(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0), Wr(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0), Wr(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0), Wr(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1), Wr(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2), Wr(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2), Wr(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3), Wr(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3), Wr(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4), Wr(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4), Wr(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4), Wr(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5), Wr(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5), Wr(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5), Wr(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6), Wr(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6), Wr(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7), Wr(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7), Wr(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7), Wr(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8), Wr(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)], cde = dde, pde = ["duration", "easing", "delay"], vde = {
  // This is the most common easing curve.
  easeInOut: "cubic-bezier(0.4, 0, 0.2, 1)",
  // Objects enter the screen at full velocity from off-screen and
  // slowly decelerate to a resting point.
  easeOut: "cubic-bezier(0.0, 0, 0.2, 1)",
  // Objects leave the screen at full velocity. They do not decelerate when off-screen.
  easeIn: "cubic-bezier(0.4, 0, 1, 1)",
  // The sharp curve is used by objects that may return to the screen at any time.
  sharp: "cubic-bezier(0.4, 0, 0.6, 1)"
}, hde = {
  shortest: 150,
  shorter: 200,
  short: 250,
  // most basic recommended timing
  standard: 300,
  // this is to be used in complex animations
  complex: 375,
  // recommended when something is entering screen
  enteringScreen: 225,
  // recommended when something is leaving screen
  leavingScreen: 195
};
function ZW(e) {
  return `${Math.round(e)}ms`;
}
function mde(e) {
  if (!e)
    return 0;
  const t = e / 36;
  return Math.round((4 + 15 * t ** 0.25 + t / 5) * 10);
}
function gde(e) {
  const t = yt({}, vde, e.easing), r = yt({}, hde, e.duration);
  return yt({
    getAutoHeightDuration: mde,
    create: (i = ["all"], a = {}) => {
      const {
        duration: s = r.standard,
        easing: o = t.easeInOut,
        delay: u = 0
      } = a, f = vn(a, pde);
      if (process.env.NODE_ENV !== "production") {
        const l = (c) => typeof c == "string", d = (c) => !isNaN(parseFloat(c));
        !l(i) && !Array.isArray(i) && console.error('MUI: Argument "props" must be a string or Array.'), !d(s) && !l(s) && console.error(`MUI: Argument "duration" must be a number or a string but found ${s}.`), l(o) || console.error('MUI: Argument "easing" must be a string.'), !d(u) && !l(u) && console.error('MUI: Argument "delay" must be a number or a string.'), typeof a != "object" && console.error(["MUI: Secong argument of transition.create must be an object.", "Arguments should be either `create('prop1', options)` or `create(['prop1', 'prop2'], options)`"].join(`
`)), Object.keys(f).length !== 0 && console.error(`MUI: Unrecognized argument(s) [${Object.keys(f).join(",")}].`);
      }
      return (Array.isArray(i) ? i : [i]).map((l) => `${l} ${typeof s == "string" ? s : ZW(s)} ${o} ${typeof u == "string" ? u : ZW(u)}`).join(",");
    }
  }, e, {
    easing: t,
    duration: r
  });
}
const yde = {
  mobileStepper: 1e3,
  fab: 1050,
  speedDial: 1050,
  appBar: 1100,
  drawer: 1200,
  modal: 1300,
  snackbar: 1400,
  tooltip: 1500
}, Vde = yde, qde = ["breakpoints", "mixins", "spacing", "palette", "transitions", "typography", "shape"];
function bde(e = {}, ...t) {
  const {
    mixins: r = {},
    palette: n = {},
    transitions: i = {},
    typography: a = {}
  } = e, s = vn(e, qde);
  if (e.vars)
    throw new Error(process.env.NODE_ENV !== "production" ? "MUI: `vars` is a private field used for CSS variables support.\nPlease use another name." : mu(18));
  const o = ide(n), u = Fq(e);
  let f = ha(u, {
    mixins: Jle(u.breakpoints, r),
    palette: o,
    // Don't use [...shadows] until you've verified its transpiled code is not invoking the iterator protocol.
    shadows: cde.slice(),
    typography: ode(o, a),
    transitions: gde(i),
    zIndex: yt({}, Vde)
  });
  if (f = ha(f, s), f = t.reduce((l, d) => ha(l, d), f), process.env.NODE_ENV !== "production") {
    const l = ["active", "checked", "completed", "disabled", "error", "expanded", "focused", "focusVisible", "required", "selected"], d = (c, p) => {
      let v;
      for (v in c) {
        const h = c[v];
        if (l.indexOf(v) !== -1 && Object.keys(h).length > 0) {
          if (process.env.NODE_ENV !== "production") {
            const m = oo("", v);
            console.error([`MUI: The \`${p}\` component increases the CSS specificity of the \`${v}\` internal state.`, "You can not override it like this: ", JSON.stringify(c, null, 2), "", `Instead, you need to use the '&.${m}' syntax:`, JSON.stringify({
              root: {
                [`&.${m}`]: h
              }
            }, null, 2), "", "https://mui.com/r/state-classes-guide"].join(`
`));
          }
          c[v] = {};
        }
      }
    };
    Object.keys(f.components).forEach((c) => {
      const p = f.components[c].styleOverrides;
      p && c.indexOf("Mui") === 0 && d(p, c);
    });
  }
  return f.unstable_sxConfig = yt({}, qv, s == null ? void 0 : s.unstable_sxConfig), f.unstable_sx = function(d) {
    return Cq({
      sx: d,
      theme: this
    });
  }, f;
}
const Ade = bde(), Rq = Ade;
function wde() {
  const e = KR(Rq);
  return process.env.NODE_ENV !== "production" && et.useDebugValue(e), e[hq] || e;
}
function Zu({
  props: e,
  name: t
}) {
  return jle({
    props: e,
    name: t,
    defaultTheme: Rq,
    themeId: hq
  });
}
const xR = (e) => cc(e) && e !== "classes", kde = Mle({
  themeId: hq,
  defaultTheme: Rq,
  rootShouldForwardProp: xR
}), xa = kde, MW = In.createContext(null);
function Tq(e, t) {
  var r = function(a) {
    return t && Uf(a) ? t(a) : a;
  }, n = /* @__PURE__ */ Object.create(null);
  return e && BT.map(e, function(i) {
    return i;
  }).forEach(function(i) {
    n[i.key] = r(i);
  }), n;
}
function Wde(e, t) {
  e = e || {}, t = t || {};
  function r(l) {
    return l in t ? t[l] : e[l];
  }
  var n = /* @__PURE__ */ Object.create(null), i = [];
  for (var a in e)
    a in t ? i.length && (n[a] = i, i = []) : i.push(a);
  var s, o = {};
  for (var u in t) {
    if (n[u])
      for (s = 0; s < n[u].length; s++) {
        var f = n[u][s];
        o[n[u][s]] = r(f);
      }
    o[u] = r(u);
  }
  for (s = 0; s < i.length; s++)
    o[i[s]] = r(i[s]);
  return o;
}
function Ps(e, t, r) {
  return r[t] != null ? r[t] : e.props[t];
}
function Sde(e, t) {
  return Tq(e.children, function(r) {
    return Jd(r, {
      onExited: t.bind(null, r),
      in: !0,
      appear: Ps(r, "appear", e),
      enter: Ps(r, "enter", e),
      exit: Ps(r, "exit", e)
    });
  });
}
function Cde(e, t, r) {
  var n = Tq(e.children), i = Wde(t, n);
  return Object.keys(i).forEach(function(a) {
    var s = i[a];
    if (Uf(s)) {
      var o = a in t, u = a in n, f = t[a], l = Uf(f) && !f.props.in;
      u && (!o || l) ? i[a] = Jd(s, {
        onExited: r.bind(null, s),
        in: !0,
        exit: Ps(s, "exit", e),
        enter: Ps(s, "enter", e)
      }) : !u && o && !l ? i[a] = Jd(s, {
        in: !1
      }) : u && o && Uf(f) && (i[a] = Jd(s, {
        onExited: r.bind(null, s),
        in: f.props.in,
        exit: Ps(s, "exit", e),
        enter: Ps(s, "enter", e)
      }));
    }
  }), i;
}
var Fde = Object.values || function(e) {
  return Object.keys(e).map(function(t) {
    return e[t];
  });
}, Kde = {
  component: "div",
  childFactory: function(t) {
    return t;
  }
}, Uq = /* @__PURE__ */ function(e) {
  aR(t, e);
  function t(n, i) {
    var a;
    a = e.call(this, n, i) || this;
    var s = a.handleExited.bind(Fg(a));
    return a.state = {
      contextValue: {
        isMounting: !0
      },
      handleExited: s,
      firstRender: !0
    }, a;
  }
  var r = t.prototype;
  return r.componentDidMount = function() {
    this.mounted = !0, this.setState({
      contextValue: {
        isMounting: !1
      }
    });
  }, r.componentWillUnmount = function() {
    this.mounted = !1;
  }, t.getDerivedStateFromProps = function(i, a) {
    var s = a.children, o = a.handleExited, u = a.firstRender;
    return {
      children: u ? Sde(i, o) : Cde(i, s, o),
      firstRender: !1
    };
  }, r.handleExited = function(i, a) {
    var s = Tq(this.props.children);
    i.key in s || (i.props.onExited && i.props.onExited(a), this.mounted && this.setState(function(o) {
      var u = yt({}, o.children);
      return delete u[i.key], {
        children: u
      };
    }));
  }, r.render = function() {
    var i = this.props, a = i.component, s = i.childFactory, o = vn(i, ["component", "childFactory"]), u = this.state.contextValue, f = Fde(this.state.children).map(s);
    return delete o.appear, delete o.enter, delete o.exit, a === null ? /* @__PURE__ */ In.createElement(MW.Provider, {
      value: u
    }, f) : /* @__PURE__ */ In.createElement(MW.Provider, {
      value: u
    }, /* @__PURE__ */ In.createElement(a, o, f));
  }, t;
}(In.Component);
Uq.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * `<TransitionGroup>` renders a `<div>` by default. You can change this
   * behavior by providing a `component` prop.
   * If you use React v16+ and would like to avoid a wrapping `<div>` element
   * you can pass in `component={null}`. This is useful if the wrapping div
   * borks your css styles.
   */
  component: be.any,
  /**
   * A set of `<Transition>` components, that are toggled `in` and out as they
   * leave. the `<TransitionGroup>` will inject specific transition props, so
   * remember to spread them through if you are wrapping the `<Transition>` as
   * with our `<Fade>` example.
   *
   * While this component is meant for multiple `Transition` or `CSSTransition`
   * children, sometimes you may want to have a single transition child with
   * content that you want to be transitioned out and in when you change it
   * (e.g. routes, images etc.) In that case you can change the `key` prop of
   * the transition child as you change its content, this will cause
   * `TransitionGroup` to transition the child out and back in.
   */
  children: be.node,
  /**
   * A convenience prop that enables or disables appear animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  appear: be.bool,
  /**
   * A convenience prop that enables or disables enter animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  enter: be.bool,
  /**
   * A convenience prop that enables or disables exit animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  exit: be.bool,
  /**
   * You may need to apply reactive updates to a child as it is exiting.
   * This is generally done by using `cloneElement` however in the case of an exiting
   * child the element has already been removed and not accessible to the consumer.
   *
   * If you do need to update a child as it leaves you can provide a `childFactory`
   * to wrap every child, even the ones that are leaving.
   *
   * @type Function(child: ReactElement) -> ReactElement
   */
  childFactory: be.func
} : {};
Uq.defaultProps = Kde;
const Rde = Uq;
function ER(e) {
  const {
    className: t,
    classes: r,
    pulsate: n = !1,
    rippleX: i,
    rippleY: a,
    rippleSize: s,
    in: o,
    onExited: u,
    timeout: f
  } = e, [l, d] = et.useState(!1), c = qn(t, r.ripple, r.rippleVisible, n && r.ripplePulsate), p = {
    width: s,
    height: s,
    top: -(s / 2) + a,
    left: -(s / 2) + i
  }, v = qn(r.child, l && r.childLeaving, n && r.childPulsate);
  return !o && !l && d(!0), et.useEffect(() => {
    if (!o && u != null) {
      const h = setTimeout(u, f);
      return () => {
        clearTimeout(h);
      };
    }
  }, [u, o, f]), /* @__PURE__ */ j("span", {
    className: c,
    style: p,
    children: /* @__PURE__ */ j("span", {
      className: v
    })
  });
}
process.env.NODE_ENV !== "production" && (ER.propTypes = {
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: be.object.isRequired,
  className: be.string,
  /**
   * @ignore - injected from TransitionGroup
   */
  in: be.bool,
  /**
   * @ignore - injected from TransitionGroup
   */
  onExited: be.func,
  /**
   * If `true`, the ripple pulsates, typically indicating the keyboard focus state of an element.
   */
  pulsate: be.bool,
  /**
   * Diameter of the ripple.
   */
  rippleSize: be.number,
  /**
   * Horizontal position of the ripple center.
   */
  rippleX: be.number,
  /**
   * Vertical position of the ripple center.
   */
  rippleY: be.number,
  /**
   * exit delay
   */
  timeout: be.number.isRequired
});
const Tde = Bu("MuiTouchRipple", ["root", "ripple", "rippleVisible", "ripplePulsate", "child", "childLeaving", "childPulsate"]), ai = Tde, Ude = ["center", "classes", "className"];
let Av = (e) => e, jW, YW, zW, GW;
const Pg = 550, xde = 80, Ede = kq(jW || (jW = Av`
  0% {
    transform: scale(0);
    opacity: 0.1;
  }

  100% {
    transform: scale(1);
    opacity: 0.3;
  }
`)), Ode = kq(YW || (YW = Av`
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
`)), Nde = kq(zW || (zW = Av`
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(0.92);
  }

  100% {
    transform: scale(1);
  }
`)), Ide = xa("span", {
  name: "MuiTouchRipple",
  slot: "Root"
})({
  overflow: "hidden",
  pointerEvents: "none",
  position: "absolute",
  zIndex: 0,
  top: 0,
  right: 0,
  bottom: 0,
  left: 0,
  borderRadius: "inherit"
}), Xde = xa(ER, {
  name: "MuiTouchRipple",
  slot: "Ripple"
})(GW || (GW = Av`
  opacity: 0;
  position: absolute;

  &.${0} {
    opacity: 0.3;
    transform: scale(1);
    animation-name: ${0};
    animation-duration: ${0}ms;
    animation-timing-function: ${0};
  }

  &.${0} {
    animation-duration: ${0}ms;
  }

  & .${0} {
    opacity: 1;
    display: block;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: currentColor;
  }

  & .${0} {
    opacity: 0;
    animation-name: ${0};
    animation-duration: ${0}ms;
    animation-timing-function: ${0};
  }

  & .${0} {
    position: absolute;
    /* @noflip */
    left: 0px;
    top: 0;
    animation-name: ${0};
    animation-duration: 2500ms;
    animation-timing-function: ${0};
    animation-iteration-count: infinite;
    animation-delay: 200ms;
  }
`), ai.rippleVisible, Ede, Pg, ({
  theme: e
}) => e.transitions.easing.easeInOut, ai.ripplePulsate, ({
  theme: e
}) => e.transitions.duration.shorter, ai.child, ai.childLeaving, Ode, Pg, ({
  theme: e
}) => e.transitions.easing.easeInOut, ai.childPulsate, Nde, ({
  theme: e
}) => e.transitions.easing.easeInOut), OR = /* @__PURE__ */ et.forwardRef(function(t, r) {
  const n = Zu({
    props: t,
    name: "MuiTouchRipple"
  }), {
    center: i = !1,
    classes: a = {},
    className: s
  } = n, o = vn(n, Ude), [u, f] = et.useState([]), l = et.useRef(0), d = et.useRef(null);
  et.useEffect(() => {
    d.current && (d.current(), d.current = null);
  }, [u]);
  const c = et.useRef(!1), p = et.useRef(0), v = et.useRef(null), h = et.useRef(null);
  et.useEffect(() => () => {
    p.current && clearTimeout(p.current);
  }, []);
  const m = et.useCallback((C) => {
    const {
      pulsate: R,
      rippleX: I,
      rippleY: P,
      rippleSize: K,
      cb: B
    } = C;
    f((L) => [...L, /* @__PURE__ */ j(Xde, {
      classes: {
        ripple: qn(a.ripple, ai.ripple),
        rippleVisible: qn(a.rippleVisible, ai.rippleVisible),
        ripplePulsate: qn(a.ripplePulsate, ai.ripplePulsate),
        child: qn(a.child, ai.child),
        childLeaving: qn(a.childLeaving, ai.childLeaving),
        childPulsate: qn(a.childPulsate, ai.childPulsate)
      },
      timeout: Pg,
      pulsate: R,
      rippleX: I,
      rippleY: P,
      rippleSize: K
    }, l.current)]), l.current += 1, d.current = B;
  }, [a]), q = et.useCallback((C = {}, R = {}, I = () => {
  }) => {
    const {
      pulsate: P = !1,
      center: K = i || R.pulsate,
      fakeElement: B = !1
      // For test purposes
    } = R;
    if ((C == null ? void 0 : C.type) === "mousedown" && c.current) {
      c.current = !1;
      return;
    }
    (C == null ? void 0 : C.type) === "touchstart" && (c.current = !0);
    const L = B ? null : h.current, _ = L ? L.getBoundingClientRect() : {
      width: 0,
      height: 0,
      left: 0,
      top: 0
    };
    let ne, Z, le;
    if (K || C === void 0 || C.clientX === 0 && C.clientY === 0 || !C.clientX && !C.touches)
      ne = Math.round(_.width / 2), Z = Math.round(_.height / 2);
    else {
      const {
        clientX: he,
        clientY: Ie
      } = C.touches && C.touches.length > 0 ? C.touches[0] : C;
      ne = Math.round(he - _.left), Z = Math.round(Ie - _.top);
    }
    if (K)
      le = Math.sqrt((2 * _.width ** 2 + _.height ** 2) / 3), le % 2 === 0 && (le += 1);
    else {
      const he = Math.max(Math.abs((L ? L.clientWidth : 0) - ne), ne) * 2 + 2, Ie = Math.max(Math.abs((L ? L.clientHeight : 0) - Z), Z) * 2 + 2;
      le = Math.sqrt(he ** 2 + Ie ** 2);
    }
    C != null && C.touches ? v.current === null && (v.current = () => {
      m({
        pulsate: P,
        rippleX: ne,
        rippleY: Z,
        rippleSize: le,
        cb: I
      });
    }, p.current = setTimeout(() => {
      v.current && (v.current(), v.current = null);
    }, xde)) : m({
      pulsate: P,
      rippleX: ne,
      rippleY: Z,
      rippleSize: le,
      cb: I
    });
  }, [i, m]), w = et.useCallback(() => {
    q({}, {
      pulsate: !0
    });
  }, [q]), O = et.useCallback((C, R) => {
    if (clearTimeout(p.current), (C == null ? void 0 : C.type) === "touchend" && v.current) {
      v.current(), v.current = null, p.current = setTimeout(() => {
        O(C, R);
      });
      return;
    }
    v.current = null, f((I) => I.length > 0 ? I.slice(1) : I), d.current = R;
  }, []);
  return et.useImperativeHandle(r, () => ({
    pulsate: w,
    start: q,
    stop: O
  }), [w, q, O]), /* @__PURE__ */ j(Ide, yt({
    className: qn(ai.root, a.root, s),
    ref: h
  }, o, {
    children: /* @__PURE__ */ j(Rde, {
      component: null,
      exit: !0,
      children: u
    })
  }));
});
process.env.NODE_ENV !== "production" && (OR.propTypes = {
  /**
   * If `true`, the ripple starts at the center of the component
   * rather than at the point of interaction.
   */
  center: be.bool,
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: be.object,
  /**
   * @ignore
   */
  className: be.string
});
const Pde = OR;
function Bde(e) {
  return oo("MuiButtonBase", e);
}
const Dde = Bu("MuiButtonBase", ["root", "disabled", "focusVisible"]), Lde = Dde, Zde = ["action", "centerRipple", "children", "className", "component", "disabled", "disableRipple", "disableTouchRipple", "focusRipple", "focusVisibleClassName", "LinkComponent", "onBlur", "onClick", "onContextMenu", "onDragLeave", "onFocus", "onFocusVisible", "onKeyDown", "onKeyUp", "onMouseDown", "onMouseLeave", "onMouseUp", "onTouchEnd", "onTouchMove", "onTouchStart", "tabIndex", "TouchRippleProps", "touchRippleRef", "type"], Mde = (e) => {
  const {
    disabled: t,
    focusVisible: r,
    focusVisibleClassName: n,
    classes: i
  } = e, s = Yl({
    root: ["root", t && "disabled", r && "focusVisible"]
  }, Bde, i);
  return r && n && (s.root += ` ${n}`), s;
}, jde = xa("button", {
  name: "MuiButtonBase",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  position: "relative",
  boxSizing: "border-box",
  WebkitTapHighlightColor: "transparent",
  backgroundColor: "transparent",
  // Reset default value
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0,
  border: 0,
  margin: 0,
  // Remove the margin in Safari
  borderRadius: 0,
  padding: 0,
  // Remove the padding in Firefox
  cursor: "pointer",
  userSelect: "none",
  verticalAlign: "middle",
  MozAppearance: "none",
  // Reset
  WebkitAppearance: "none",
  // Reset
  textDecoration: "none",
  // So we take precedent over the style of a native <a /> element.
  color: "inherit",
  "&::-moz-focus-inner": {
    borderStyle: "none"
    // Remove Firefox dotted outline.
  },
  [`&.${Lde.disabled}`]: {
    pointerEvents: "none",
    // Disable link interactions
    cursor: "default"
  },
  "@media print": {
    colorAdjust: "exact"
  }
}), NR = /* @__PURE__ */ et.forwardRef(function(t, r) {
  const n = Zu({
    props: t,
    name: "MuiButtonBase"
  }), {
    action: i,
    centerRipple: a = !1,
    children: s,
    className: o,
    component: u = "button",
    disabled: f = !1,
    disableRipple: l = !1,
    disableTouchRipple: d = !1,
    focusRipple: c = !1,
    LinkComponent: p = "a",
    onBlur: v,
    onClick: h,
    onContextMenu: m,
    onDragLeave: q,
    onFocus: w,
    onFocusVisible: O,
    onKeyDown: C,
    onKeyUp: R,
    onMouseDown: I,
    onMouseLeave: P,
    onMouseUp: K,
    onTouchEnd: B,
    onTouchMove: L,
    onTouchStart: _,
    tabIndex: ne = 0,
    TouchRippleProps: Z,
    touchRippleRef: le,
    type: he
  } = n, Ie = vn(n, Zde), xe = et.useRef(null), ye = et.useRef(null), ue = Eg(ye, le), {
    isFocusVisibleRef: M,
    onFocus: F,
    onBlur: pe,
    ref: We
  } = yue(), [ce, oe] = et.useState(!1);
  f && ce && oe(!1), et.useImperativeHandle(i, () => ({
    focusVisible: () => {
      oe(!0), xe.current.focus();
    }
  }), []);
  const [z, Ze] = et.useState(!1);
  et.useEffect(() => {
    Ze(!0);
  }, []);
  const Ae = z && !l && !f;
  et.useEffect(() => {
    ce && c && !l && z && ye.current.pulsate();
  }, [l, c, ce, z]);
  function re(rt, Dt, vr = d) {
    return Zd((Qr) => (Dt && Dt(Qr), !vr && ye.current && ye.current[rt](Qr), !0));
  }
  const Qe = re("start", I), Ee = re("stop", m), Ue = re("stop", q), He = re("stop", K), te = re("stop", (rt) => {
    ce && rt.preventDefault(), P && P(rt);
  }), it = re("start", _), Vt = re("stop", B), Oe = re("stop", L), Bt = re("stop", (rt) => {
    pe(rt), M.current === !1 && oe(!1), v && v(rt);
  }, !1), mt = Zd((rt) => {
    xe.current || (xe.current = rt.currentTarget), F(rt), M.current === !0 && (oe(!0), O && O(rt)), w && w(rt);
  }), Ot = () => {
    const rt = xe.current;
    return u && u !== "button" && !(rt.tagName === "A" && rt.href);
  }, It = et.useRef(!1), Me = Zd((rt) => {
    c && !It.current && ce && ye.current && rt.key === " " && (It.current = !0, ye.current.stop(rt, () => {
      ye.current.start(rt);
    })), rt.target === rt.currentTarget && Ot() && rt.key === " " && rt.preventDefault(), C && C(rt), rt.target === rt.currentTarget && Ot() && rt.key === "Enter" && !f && (rt.preventDefault(), h && h(rt));
  }), Gr = Zd((rt) => {
    c && rt.key === " " && ye.current && ce && !rt.defaultPrevented && (It.current = !1, ye.current.stop(rt, () => {
      ye.current.pulsate(rt);
    })), R && R(rt), h && rt.target === rt.currentTarget && Ot() && rt.key === " " && !rt.defaultPrevented && h(rt);
  });
  let $e = u;
  $e === "button" && (Ie.href || Ie.to) && ($e = p);
  const Je = {};
  $e === "button" ? (Je.type = he === void 0 ? "button" : he, Je.disabled = f) : (!Ie.href && !Ie.to && (Je.role = "button"), f && (Je["aria-disabled"] = f));
  const qt = Eg(r, We, xe);
  process.env.NODE_ENV !== "production" && et.useEffect(() => {
    Ae && !ye.current && console.error(["MUI: The `component` prop provided to ButtonBase is invalid.", "Please make sure the children prop is rendered in this custom component."].join(`
`));
  }, [Ae]);
  const ft = yt({}, n, {
    centerRipple: a,
    component: u,
    disabled: f,
    disableRipple: l,
    disableTouchRipple: d,
    focusRipple: c,
    tabIndex: ne,
    focusVisible: ce
  }), at = Mde(ft);
  return /* @__PURE__ */ ut(jde, yt({
    as: $e,
    className: qn(at.root, o),
    ownerState: ft,
    onBlur: Bt,
    onClick: h,
    onContextMenu: Ee,
    onFocus: mt,
    onKeyDown: Me,
    onKeyUp: Gr,
    onMouseDown: Qe,
    onMouseLeave: te,
    onMouseUp: He,
    onDragLeave: Ue,
    onTouchEnd: Vt,
    onTouchMove: Oe,
    onTouchStart: it,
    ref: qt,
    tabIndex: f ? -1 : ne,
    type: he
  }, Je, Ie, {
    children: [s, Ae ? (
      /* TouchRipple is only needed client-side, x2 boost on the server. */
      /* @__PURE__ */ j(Pde, yt({
        ref: ue,
        center: a
      }, Z))
    ) : null]
  }));
});
process.env.NODE_ENV !== "production" && (NR.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * A ref for imperative actions.
   * It currently only supports `focusVisible()` action.
   */
  action: fue,
  /**
   * If `true`, the ripples are centered.
   * They won't start at the cursor interaction position.
   * @default false
   */
  centerRipple: be.bool,
  /**
   * The content of the component.
   */
  children: be.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: be.object,
  /**
   * @ignore
   */
  className: be.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: rue,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: be.bool,
  /**
   * If `true`, the ripple effect is disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `.Mui-focusVisible` class.
   * @default false
   */
  disableRipple: be.bool,
  /**
   * If `true`, the touch ripple effect is disabled.
   * @default false
   */
  disableTouchRipple: be.bool,
  /**
   * If `true`, the base button will have a keyboard focus ripple.
   * @default false
   */
  focusRipple: be.bool,
  /**
   * This prop can help identify which element has keyboard focus.
   * The class name will be applied when the element gains the focus through keyboard interaction.
   * It's a polyfill for the [CSS :focus-visible selector](https://drafts.csswg.org/selectors-4/#the-focus-visible-pseudo).
   * The rationale for using this feature [is explained here](https://github.com/WICG/focus-visible/blob/HEAD/explainer.md).
   * A [polyfill can be used](https://github.com/WICG/focus-visible) to apply a `focus-visible` class to other components
   * if needed.
   */
  focusVisibleClassName: be.string,
  /**
   * @ignore
   */
  href: be.any,
  /**
   * The component used to render a link when the `href` prop is provided.
   * @default 'a'
   */
  LinkComponent: be.elementType,
  /**
   * @ignore
   */
  onBlur: be.func,
  /**
   * @ignore
   */
  onClick: be.func,
  /**
   * @ignore
   */
  onContextMenu: be.func,
  /**
   * @ignore
   */
  onDragLeave: be.func,
  /**
   * @ignore
   */
  onFocus: be.func,
  /**
   * Callback fired when the component is focused with a keyboard.
   * We trigger a `onFocus` callback too.
   */
  onFocusVisible: be.func,
  /**
   * @ignore
   */
  onKeyDown: be.func,
  /**
   * @ignore
   */
  onKeyUp: be.func,
  /**
   * @ignore
   */
  onMouseDown: be.func,
  /**
   * @ignore
   */
  onMouseLeave: be.func,
  /**
   * @ignore
   */
  onMouseUp: be.func,
  /**
   * @ignore
   */
  onTouchEnd: be.func,
  /**
   * @ignore
   */
  onTouchMove: be.func,
  /**
   * @ignore
   */
  onTouchStart: be.func,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: be.oneOfType([be.arrayOf(be.oneOfType([be.func, be.object, be.bool])), be.func, be.object]),
  /**
   * @default 0
   */
  tabIndex: be.number,
  /**
   * Props applied to the `TouchRipple` element.
   */
  TouchRippleProps: be.object,
  /**
   * A ref that points to the `TouchRipple` element.
   */
  touchRippleRef: be.oneOfType([be.func, be.shape({
    current: be.shape({
      pulsate: be.func.isRequired,
      start: be.func.isRequired,
      stop: be.func.isRequired
    })
  })]),
  /**
   * @ignore
   */
  type: be.oneOfType([be.oneOf(["button", "reset", "submit"]), be.string])
});
const Yde = NR;
function zde(e) {
  return oo("MuiTypography", e);
}
Bu("MuiTypography", ["root", "h1", "h2", "h3", "h4", "h5", "h6", "subtitle1", "subtitle2", "body1", "body2", "inherit", "button", "caption", "overline", "alignLeft", "alignRight", "alignCenter", "alignJustify", "noWrap", "gutterBottom", "paragraph"]);
const Gde = ["align", "className", "component", "gutterBottom", "noWrap", "paragraph", "variant", "variantMapping"], Qde = (e) => {
  const {
    align: t,
    gutterBottom: r,
    noWrap: n,
    paragraph: i,
    variant: a,
    classes: s
  } = e, o = {
    root: ["root", a, e.align !== "inherit" && `align${rs(t)}`, r && "gutterBottom", n && "noWrap", i && "paragraph"]
  };
  return Yl(o, zde, s);
}, Jde = xa("span", {
  name: "MuiTypography",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: r
    } = e;
    return [t.root, r.variant && t[r.variant], r.align !== "inherit" && t[`align${rs(r.align)}`], r.noWrap && t.noWrap, r.gutterBottom && t.gutterBottom, r.paragraph && t.paragraph];
  }
})(({
  theme: e,
  ownerState: t
}) => yt({
  margin: 0
}, t.variant === "inherit" && {
  // Some elements, like <button> on Chrome have default font that doesn't inherit, reset this.
  font: "inherit"
}, t.variant !== "inherit" && e.typography[t.variant], t.align !== "inherit" && {
  textAlign: t.align
}, t.noWrap && {
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap"
}, t.gutterBottom && {
  marginBottom: "0.35em"
}, t.paragraph && {
  marginBottom: 16
})), QW = {
  h1: "h1",
  h2: "h2",
  h3: "h3",
  h4: "h4",
  h5: "h5",
  h6: "h6",
  subtitle1: "h6",
  subtitle2: "h6",
  body1: "p",
  body2: "p",
  inherit: "p"
}, Hde = {
  primary: "primary.main",
  textPrimary: "text.primary",
  secondary: "secondary.main",
  textSecondary: "text.secondary",
  error: "error.main"
}, _de = (e) => Hde[e] || e, IR = /* @__PURE__ */ et.forwardRef(function(t, r) {
  const n = Zu({
    props: t,
    name: "MuiTypography"
  }), i = _de(n.color), a = Ele(yt({}, n, {
    color: i
  })), {
    align: s = "inherit",
    className: o,
    component: u,
    gutterBottom: f = !1,
    noWrap: l = !1,
    paragraph: d = !1,
    variant: c = "body1",
    variantMapping: p = QW
  } = a, v = vn(a, Gde), h = yt({}, a, {
    align: s,
    color: i,
    className: o,
    component: u,
    gutterBottom: f,
    noWrap: l,
    paragraph: d,
    variant: c,
    variantMapping: p
  }), m = u || (d ? "p" : p[c] || QW[c]) || "span", q = Qde(h);
  return /* @__PURE__ */ j(Jde, yt({
    as: m,
    ref: r,
    ownerState: h,
    className: qn(q.root, o)
  }, v));
});
process.env.NODE_ENV !== "production" && (IR.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * Set the text-align on the component.
   * @default 'inherit'
   */
  align: be.oneOf(["center", "inherit", "justify", "left", "right"]),
  /**
   * The content of the component.
   */
  children: be.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: be.object,
  /**
   * @ignore
   */
  className: be.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: be.elementType,
  /**
   * If `true`, the text will have a bottom margin.
   * @default false
   */
  gutterBottom: be.bool,
  /**
   * If `true`, the text will not wrap, but instead will truncate with a text overflow ellipsis.
   *
   * Note that text overflow can only happen with block or inline-block level elements
   * (the element needs to have a width in order to overflow).
   * @default false
   */
  noWrap: be.bool,
  /**
   * If `true`, the element will be a paragraph element.
   * @default false
   */
  paragraph: be.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: be.oneOfType([be.arrayOf(be.oneOfType([be.func, be.object, be.bool])), be.func, be.object]),
  /**
   * Applies the theme typography styles.
   * @default 'body1'
   */
  variant: be.oneOfType([be.oneOf(["body1", "body2", "button", "caption", "h1", "h2", "h3", "h4", "h5", "h6", "inherit", "overline", "subtitle1", "subtitle2"]), be.string]),
  /**
   * The component maps the variant prop to a range of different HTML element types.
   * For instance, subtitle1 to `<h6>`.
   * If you wish to change that mapping, you can provide your own.
   * Alternatively, you can use the `component` prop.
   * @default {
   *   h1: 'h1',
   *   h2: 'h2',
   *   h3: 'h3',
   *   h4: 'h4',
   *   h5: 'h5',
   *   h6: 'h6',
   *   subtitle1: 'h6',
   *   subtitle2: 'h6',
   *   body1: 'p',
   *   body2: 'p',
   *   inherit: 'p',
   * }
   */
  variantMapping: be.object
});
const Yd = IR;
function $de(e, t, r, n, i) {
  const [a, s] = et.useState(() => i && r ? r(e).matches : n ? n(e).matches : t);
  return vq(() => {
    let o = !0;
    if (!r)
      return;
    const u = r(e), f = () => {
      o && s(u.matches);
    };
    return f(), u.addListener(f), () => {
      o = !1, u.removeListener(f);
    };
  }, [e, r]), a;
}
const XR = et["useSyncExternalStore"];
function ece(e, t, r, n, i) {
  const a = et.useCallback(() => t, [t]), s = et.useMemo(() => {
    if (i && r)
      return () => r(e).matches;
    if (n !== null) {
      const {
        matches: l
      } = n(e);
      return () => l;
    }
    return a;
  }, [a, e, n, i, r]), [o, u] = et.useMemo(() => {
    if (r === null)
      return [a, () => () => {
      }];
    const l = r(e);
    return [() => l.matches, (d) => (l.addListener(d), () => {
      l.removeListener(d);
    })];
  }, [a, r, e]);
  return XR(u, o, s);
}
function tce(e, t = {}) {
  const r = FR(), n = typeof window < "u" && typeof window.matchMedia < "u", {
    defaultMatches: i = !1,
    matchMedia: a = n ? window.matchMedia : null,
    ssrMatchMedia: s = null,
    noSsr: o = !1
  } = UR({
    name: "MuiUseMediaQuery",
    props: t,
    theme: r
  });
  process.env.NODE_ENV !== "production" && typeof e == "function" && r === null && console.error(["MUI: The `query` argument provided is invalid.", "You are providing a function without a theme in the context.", "One of the parent elements needs to use a ThemeProvider."].join(`
`));
  let u = typeof e == "function" ? e(r) : e;
  u = u.replace(/^@media( ?)/m, "");
  const l = (XR !== void 0 ? ece : $de)(u, i, a, s, o);
  return process.env.NODE_ENV !== "production" && et.useDebugValue({
    query: u,
    match: l
  }), l;
}
const PR = /* @__PURE__ */ et.createContext({});
process.env.NODE_ENV !== "production" && (PR.displayName = "ListContext");
const Jc = PR;
function rce(e) {
  return oo("MuiListItemButton", e);
}
const nce = Bu("MuiListItemButton", ["root", "focusVisible", "dense", "alignItemsFlexStart", "disabled", "divider", "gutters", "selected"]), kf = nce, ice = ["alignItems", "autoFocus", "component", "children", "dense", "disableGutters", "divider", "focusVisibleClassName", "selected", "className"], ace = (e, t) => {
  const {
    ownerState: r
  } = e;
  return [t.root, r.dense && t.dense, r.alignItems === "flex-start" && t.alignItemsFlexStart, r.divider && t.divider, !r.disableGutters && t.gutters];
}, sce = (e) => {
  const {
    alignItems: t,
    classes: r,
    dense: n,
    disabled: i,
    disableGutters: a,
    divider: s,
    selected: o
  } = e, f = Yl({
    root: ["root", n && "dense", !a && "gutters", s && "divider", i && "disabled", t === "flex-start" && "alignItemsFlexStart", o && "selected"]
  }, rce, r);
  return yt({}, r, f);
}, oce = xa(Yde, {
  shouldForwardProp: (e) => xR(e) || e === "classes",
  name: "MuiListItemButton",
  slot: "Root",
  overridesResolver: ace
})(({
  theme: e,
  ownerState: t
}) => yt({
  display: "flex",
  flexGrow: 1,
  justifyContent: "flex-start",
  alignItems: "center",
  position: "relative",
  textDecoration: "none",
  minWidth: 0,
  boxSizing: "border-box",
  textAlign: "left",
  paddingTop: 8,
  paddingBottom: 8,
  transition: e.transitions.create("background-color", {
    duration: e.transitions.duration.shortest
  }),
  "&:hover": {
    textDecoration: "none",
    backgroundColor: (e.vars || e).palette.action.hover,
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: "transparent"
    }
  },
  [`&.${kf.selected}`]: {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.selectedOpacity})` : jd(e.palette.primary.main, e.palette.action.selectedOpacity),
    [`&.${kf.focusVisible}`]: {
      backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.focusOpacity}))` : jd(e.palette.primary.main, e.palette.action.selectedOpacity + e.palette.action.focusOpacity)
    }
  },
  [`&.${kf.selected}:hover`]: {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.hoverOpacity}))` : jd(e.palette.primary.main, e.palette.action.selectedOpacity + e.palette.action.hoverOpacity),
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.selectedOpacity})` : jd(e.palette.primary.main, e.palette.action.selectedOpacity)
    }
  },
  [`&.${kf.focusVisible}`]: {
    backgroundColor: (e.vars || e).palette.action.focus
  },
  [`&.${kf.disabled}`]: {
    opacity: (e.vars || e).palette.action.disabledOpacity
  }
}, t.divider && {
  borderBottom: `1px solid ${(e.vars || e).palette.divider}`,
  backgroundClip: "padding-box"
}, t.alignItems === "flex-start" && {
  alignItems: "flex-start"
}, !t.disableGutters && {
  paddingLeft: 16,
  paddingRight: 16
}, t.dense && {
  paddingTop: 4,
  paddingBottom: 4
})), BR = /* @__PURE__ */ et.forwardRef(function(t, r) {
  const n = Zu({
    props: t,
    name: "MuiListItemButton"
  }), {
    alignItems: i = "center",
    autoFocus: a = !1,
    component: s = "div",
    children: o,
    dense: u = !1,
    disableGutters: f = !1,
    divider: l = !1,
    focusVisibleClassName: d,
    selected: c = !1,
    className: p
  } = n, v = vn(n, ice), h = et.useContext(Jc), m = et.useMemo(() => ({
    dense: u || h.dense || !1,
    alignItems: i,
    disableGutters: f
  }), [i, h.dense, u, f]), q = et.useRef(null);
  vq(() => {
    a && (q.current ? q.current.focus() : process.env.NODE_ENV !== "production" && console.error("MUI: Unable to set focus to a ListItemButton whose component has not been rendered."));
  }, [a]);
  const w = yt({}, n, {
    alignItems: i,
    dense: m.dense,
    disableGutters: f,
    divider: l,
    selected: c
  }), O = sce(w), C = Eg(q, r);
  return /* @__PURE__ */ j(Jc.Provider, {
    value: m,
    children: /* @__PURE__ */ j(oce, yt({
      ref: C,
      href: v.href || v.to,
      component: (v.href || v.to) && s === "div" ? "button" : s,
      focusVisibleClassName: qn(O.focusVisible, d),
      ownerState: w,
      className: qn(O.root, p)
    }, v, {
      classes: O,
      children: o
    }))
  });
});
process.env.NODE_ENV !== "production" && (BR.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * Defines the `align-items` style property.
   * @default 'center'
   */
  alignItems: be.oneOf(["center", "flex-start"]),
  /**
   * If `true`, the list item is focused during the first mount.
   * Focus will also be triggered if the value changes from false to true.
   * @default false
   */
  autoFocus: be.bool,
  /**
   * The content of the component if a `ListItemSecondaryAction` is used it must
   * be the last child.
   */
  children: be.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: be.object,
  /**
   * @ignore
   */
  className: be.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: be.elementType,
  /**
   * If `true`, compact vertical padding designed for keyboard and mouse input is used.
   * The prop defaults to the value inherited from the parent List component.
   * @default false
   */
  dense: be.bool,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: be.bool,
  /**
   * If `true`, the left and right padding is removed.
   * @default false
   */
  disableGutters: be.bool,
  /**
   * If `true`, a 1px light border is added to the bottom of the list item.
   * @default false
   */
  divider: be.bool,
  /**
   * This prop can help identify which element has keyboard focus.
   * The class name will be applied when the element gains the focus through keyboard interaction.
   * It's a polyfill for the [CSS :focus-visible selector](https://drafts.csswg.org/selectors-4/#the-focus-visible-pseudo).
   * The rationale for using this feature [is explained here](https://github.com/WICG/focus-visible/blob/HEAD/explainer.md).
   * A [polyfill can be used](https://github.com/WICG/focus-visible) to apply a `focus-visible` class to other components
   * if needed.
   */
  focusVisibleClassName: be.string,
  /**
   * @ignore
   */
  href: be.string,
  /**
   * Use to apply selected styling.
   * @default false
   */
  selected: be.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: be.oneOfType([be.arrayOf(be.oneOfType([be.func, be.object, be.bool])), be.func, be.object])
});
const uce = BR;
function fce(e) {
  return oo("MuiListItemAvatar", e);
}
Bu("MuiListItemAvatar", ["root", "alignItemsFlexStart"]);
const lce = ["className"], dce = (e) => {
  const {
    alignItems: t,
    classes: r
  } = e;
  return Yl({
    root: ["root", t === "flex-start" && "alignItemsFlexStart"]
  }, fce, r);
}, cce = xa("div", {
  name: "MuiListItemAvatar",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: r
    } = e;
    return [t.root, r.alignItems === "flex-start" && t.alignItemsFlexStart];
  }
})(({
  ownerState: e
}) => yt({
  minWidth: 56,
  flexShrink: 0
}, e.alignItems === "flex-start" && {
  marginTop: 8
})), DR = /* @__PURE__ */ et.forwardRef(function(t, r) {
  const n = Zu({
    props: t,
    name: "MuiListItemAvatar"
  }), {
    className: i
  } = n, a = vn(n, lce), s = et.useContext(Jc), o = yt({}, n, {
    alignItems: s.alignItems
  }), u = dce(o);
  return /* @__PURE__ */ j(cce, yt({
    className: qn(u.root, i),
    ownerState: o,
    ref: r
  }, a));
});
process.env.NODE_ENV !== "production" && (DR.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * The content of the component, normally an `Avatar`.
   */
  children: be.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: be.object,
  /**
   * @ignore
   */
  className: be.string,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: be.oneOfType([be.arrayOf(be.oneOfType([be.func, be.object, be.bool])), be.func, be.object])
});
const pce = DR;
function vce(e) {
  return oo("MuiListItemText", e);
}
const hce = Bu("MuiListItemText", ["root", "multiline", "dense", "inset", "primary", "secondary"]), JW = hce, mce = ["children", "className", "disableTypography", "inset", "primary", "primaryTypographyProps", "secondary", "secondaryTypographyProps"], gce = (e) => {
  const {
    classes: t,
    inset: r,
    primary: n,
    secondary: i,
    dense: a
  } = e;
  return Yl({
    root: ["root", r && "inset", a && "dense", n && i && "multiline"],
    primary: ["primary"],
    secondary: ["secondary"]
  }, vce, t);
}, yce = xa("div", {
  name: "MuiListItemText",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: r
    } = e;
    return [{
      [`& .${JW.primary}`]: t.primary
    }, {
      [`& .${JW.secondary}`]: t.secondary
    }, t.root, r.inset && t.inset, r.primary && r.secondary && t.multiline, r.dense && t.dense];
  }
})(({
  ownerState: e
}) => yt({
  flex: "1 1 auto",
  minWidth: 0,
  marginTop: 4,
  marginBottom: 4
}, e.primary && e.secondary && {
  marginTop: 6,
  marginBottom: 6
}, e.inset && {
  paddingLeft: 56
})), LR = /* @__PURE__ */ et.forwardRef(function(t, r) {
  const n = Zu({
    props: t,
    name: "MuiListItemText"
  }), {
    children: i,
    className: a,
    disableTypography: s = !1,
    inset: o = !1,
    primary: u,
    primaryTypographyProps: f,
    secondary: l,
    secondaryTypographyProps: d
  } = n, c = vn(n, mce), {
    dense: p
  } = et.useContext(Jc);
  let v = u ?? i, h = l;
  const m = yt({}, n, {
    disableTypography: s,
    inset: o,
    primary: !!v,
    secondary: !!h,
    dense: p
  }), q = gce(m);
  return v != null && v.type !== Yd && !s && (v = /* @__PURE__ */ j(Yd, yt({
    variant: p ? "body2" : "body1",
    className: q.primary,
    component: f != null && f.variant ? void 0 : "span",
    display: "block"
  }, f, {
    children: v
  }))), h != null && h.type !== Yd && !s && (h = /* @__PURE__ */ j(Yd, yt({
    variant: "body2",
    className: q.secondary,
    color: "text.secondary",
    display: "block"
  }, d, {
    children: h
  }))), /* @__PURE__ */ ut(yce, yt({
    className: qn(q.root, a),
    ownerState: m,
    ref: r
  }, c, {
    children: [v, h]
  }));
});
process.env.NODE_ENV !== "production" && (LR.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * Alias for the `primary` prop.
   */
  children: be.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: be.object,
  /**
   * @ignore
   */
  className: be.string,
  /**
   * If `true`, the children won't be wrapped by a Typography component.
   * This can be useful to render an alternative Typography variant by wrapping
   * the `children` (or `primary`) text, and optional `secondary` text
   * with the Typography component.
   * @default false
   */
  disableTypography: be.bool,
  /**
   * If `true`, the children are indented.
   * This should be used if there is no left avatar or left icon.
   * @default false
   */
  inset: be.bool,
  /**
   * The main content element.
   */
  primary: be.node,
  /**
   * These props will be forwarded to the primary typography component
   * (as long as disableTypography is not `true`).
   */
  primaryTypographyProps: be.object,
  /**
   * The secondary content element.
   */
  secondary: be.node,
  /**
   * These props will be forwarded to the secondary typography component
   * (as long as disableTypography is not `true`).
   */
  secondaryTypographyProps: be.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: be.oneOfType([be.arrayOf(be.oneOfType([be.func, be.object, be.bool])), be.func, be.object])
});
const Vce = LR, xq = ({ isOnline: e, children: t }) => /* @__PURE__ */ j(e ? qce : bce, { overlap: "circular", anchorOrigin: { vertical: "bottom", horizontal: "right" }, variant: "dot", children: t }), qce = xa(Au)(({ theme: e }) => ({
  "& .MuiBadge-badge": {
    backgroundColor: `${Us.A700}`,
    boxShadow: `0 0 0 1px ${e.palette.background.paper}`
  }
})), bce = xa(Au)(({ theme: e }) => ({
  "& .MuiBadge-badge": {
    backgroundColor: `${e.palette.grey[500]}`,
    boxShadow: `0 0 0 1px ${e.palette.background.paper}`
  }
})), ZR = (e) => {
  var u;
  const { data: t, index: r, style: n } = e, { users: i, selected: a, handleSelect: s } = t, o = i[r];
  return o ? /* @__PURE__ */ j(
    Z6,
    {
      style: n,
      onClick: s(o._id),
      secondaryAction: /* @__PURE__ */ j(HT, { edge: "end", checked: a.indexOf(o._id) !== -1, iconSize: "lg" }),
      disablePadding: !0,
      children: /* @__PURE__ */ ut(uce, { disableRipple: !0, sx: { height: "64px" }, children: [
        /* @__PURE__ */ j(pce, { children: /* @__PURE__ */ j(dq, { firstName: o.firstName, lastName: o.lastName, fullName: o == null ? void 0 : o.fullName, pictureUrl: (u = o.picture) == null ? void 0 : u.url }) }),
        /* @__PURE__ */ j(
          Vce,
          {
            primaryTypographyProps: { fontSize: "1rem", sx: { wordBreak: "break-word", fontWeight: "600" } },
            primary: o == null ? void 0 : o.fullName,
            secondary: o.employeeNumber
          }
        )
      ] })
    },
    r
  ) : null;
}, MR = ({ search: e, setSearch: t, selected: r, usersById: n, handleDelete: i }) => {
  const { t: a } = Ur();
  return /* @__PURE__ */ ut(
    gr,
    {
      sx: {
        display: "flex",
        flexWrap: "wrap",
        alignItems: "center",
        paddingLeft: 1,
        bgcolor: (s) => s.palette.grey[200],
        borderRadius: 1,
        marginX: 2
      },
      children: [
        /* @__PURE__ */ j(M6, {}),
        r.map((s) => {
          var o;
          return /* @__PURE__ */ j(Uoe, { label: (o = n[s]) == null ? void 0 : o.fullName, onDelete: () => i(s) }, s);
        }),
        /* @__PURE__ */ j(
          ll,
          {
            multiline: !0,
            sx: {
              fieldset: { border: "none" }
            },
            value: e,
            onChange: (s) => t(s.target.value),
            placeholder: a("ADD_USER"),
            InputProps: {
              style: {
                boxSizing: "border-box"
              }
            },
            autoFocus: !0
          }
        )
      ]
    }
  );
}, Ace = "data:image/png;base64,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", wce = "data:image/png;base64,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", kce = ({ error: e, resetErrorBoundary: t }) => {
  const { currentLanguage: r, t: n } = Ur(), i = r === "en" ? Ace : wce, a = e && typeof e == "object" && "message" in e && typeof e.message == "string" ? e.message : null;
  return /* @__PURE__ */ ut(pt, { sx: { height: 1 }, role: "alert", direction: "column", alignItems: "center", justifyContent: "center", children: [
    /* @__PURE__ */ j("img", { style: { width: "100%" }, src: i }),
    a ? /* @__PURE__ */ j(br, { variant: "caption", children: a }) : null,
    /* @__PURE__ */ j(nu, { onClick: t, children: n("RELOAD") })
  ] });
}, Wce = ({ isMobile: e, users: t, usersById: r }) => {
  var P;
  const { t: n } = Ur(), [i, a] = ir([]), [s, o] = ir(""), u = zr(null), f = Vs(), { param: l, goBack: d } = Gn(), c = Lt((K) => Zse(K, l)), p = t.filter((K) => !c.includes(K._id)), v = Br(() => t.length + 1, [t.length]);
  s !== "" && ((P = u.current) == null || P.scrollToItem(0));
  const h = async (K) => {
    const B = await Si(f, l ?? "");
    B && await G4(B, K), d();
  }, m = (K) => () => {
    a((B) => B.includes(K) ? B.filter((L) => L !== K) : (o(""), [...B, K]));
  }, q = (K) => {
    a((B) => B.filter((L) => L !== K));
  }, w = il(p, s, { keys: ["firstName", "lastName", "fullName", "employeeNumber"] }), O = Br(
    () => ({
      users: w,
      selected: i,
      handleSelect: m
    }),
    [w, i]
  ), C = () => {
    h(i);
  };
  return /* @__PURE__ */ ut(tn, { children: [
    /* @__PURE__ */ j(MR, { search: s, setSearch: o, selected: i, usersById: r, handleDelete: q }),
    /* @__PURE__ */ ut(pt, { width: "100%", height: "100%", sx: { marginTop: 2, overflow: "hidden", position: "relative" }, children: [
      /* @__PURE__ */ j(oR, { children: ({ height: K, width: B }) => /* @__PURE__ */ j(sR, { ref: u, itemData: O, height: K, width: B, itemSize: 64, itemCount: v, overscanCount: 5, children: ZR }) }),
      /* @__PURE__ */ j(
        gr,
        {
          width: 1,
          sx: {
            position: "absolute",
            bottom: 0,
            height: "5rem",
            backgroundImage: "linear-gradient(to bottom, rgba(255,255,255,0), rgba(255,255,255, 1) 90%)"
          }
        }
      ),
      e ? /* @__PURE__ */ j(() => /* @__PURE__ */ j(pt, { sx: { position: "absolute", bottom: 10, right: "2.5%", backgroundColor: "white", width: "95%" }, children: /* @__PURE__ */ j(nu, { disabled: !i.length, onClick: C, fullWidth: !0, children: n("ADD_PARTICIPANTS") }) }), {}) : /* @__PURE__ */ j(() => /* @__PURE__ */ j(gr, { sx: { position: "absolute", bottom: 10, right: 15, backgroundColor: "white", width: "50%" }, children: /* @__PURE__ */ j(nu, { disabled: !i.length, onClick: C, fullWidth: !0, children: n("ADD_PARTICIPANTS") }) }), {})
    ] })
  ] });
}, Sce = ({ unreadMessagesTotal: e, children: t }) => /* @__PURE__ */ j(Au, { badgeContent: e, max: 99, sx: { ...Cce }, overlap: "circular", children: t }), Cce = {
  "& .MuiBadge-badge": {
    backgroundColor: "error.main",
    color: "common.white",
    userSelect: "none",
    borderRadius: "100%",
    fontSize: "14px",
    height: "30px",
    justifyContent: "center",
    alignItems: "center",
    padding: "10px",
    width: "30px",
    zIndex: 101
  }
}, Fce = Zn(gr)`
  background-color: ${({ theme: e }) => e.palette.primary.main};
  color: ${({ theme: e }) => e.palette.common.white};
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  display: flex;
  cursor: pointer;
  padding: 20px;
  width: 60px;
  height: 60px;
  box-shadow: 0 1px 6px 0 rgb(0 0 0 / 6%), 0 2px 32px 0 rgb(0 0 0 / 16%);
  z-index: 100;
`, Kce = Zn(aU)`
  transition: transform 0.16s linear 0s, opacity 0.08s linear 0s;
  opacity: ${({ chatOpen: e }) => e ? 0 : 1};
  transform: ${({ chatOpen: e }) => e ? "rotate(60deg) scale(0)" : "rotate(0deg) scale(1)"};

  display: flex;
  position: absolute;
  -webkit-box-align: center;
  align-items: center;
  -webkit-box-pack: center;
  justify-content: center;
  font-size: xx-large;
  cursor: pointer;
`, Rce = Zn(wu)`
  transition: transform 0.16s linear 0s, opacity 0.08s linear 0s;
  opacity: ${({ chatOpen: e }) => e ? 1 : 0};
  transform: ${({ chatOpen: e }) => e ? "rotate(0deg) scale(1)" : "rotate(-60deg) scale(0)"};

  display: flex;
  position: absolute;
  -webkit-box-align: center;
  align-items: center;
  -webkit-box-pack: center;
  justify-content: center;
  font-size: xx-large;
  cursor: pointer;
`, Tce = ({ unreadMessagesTotal: e, setChatOpen: t, chatOpen: r, hideTriggerButton: n }) => /* @__PURE__ */ j(gr, { sx: { position: "absolute", bottom: "20px", right: "20px", display: n ? "none" : "flex" }, children: /* @__PURE__ */ j(Sce, { unreadMessagesTotal: e, children: /* @__PURE__ */ ut(Fce, { onClick: () => t(!r), children: [
  /* @__PURE__ */ j(Kce, { chatOpen: r }),
  /* @__PURE__ */ j(Rce, { chatOpen: r })
] }) }) }), Uce = Zn(gr)`
  background-color: ${({ theme: e }) => e.palette.common.white};
  position: absolute;
  bottom: 100px;
  right: 20px;
  height: 568px;
  overflow-y: hidden;
  width: 410px;
  box-shadow: rgba(0, 0, 0, 0.16) 0px 5px 40px;
  border-radius: 16px;
  z-index: 100;
`, xce = ({ chatOpen: e, children: t }) => e ? /* @__PURE__ */ j(Uce, { children: t }) : null;
/*! Capacitor: https://capacitorjs.com/ - MIT License */
const Ece = (e) => {
  const t = /* @__PURE__ */ new Map();
  t.set("web", { name: "web" });
  const r = e.CapacitorPlatforms || {
    currentPlatform: { name: "web" },
    platforms: t
  }, n = (a, s) => {
    r.platforms.set(a, s);
  }, i = (a) => {
    r.platforms.has(a) && (r.currentPlatform = r.platforms.get(a));
  };
  return r.addPlatform = n, r.setPlatform = i, r;
}, Oce = (e) => e.CapacitorPlatforms = Ece(e), jR = /* @__PURE__ */ Oce(typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : typeof global < "u" ? global : {});
jR.addPlatform;
jR.setPlatform;
var Vu;
(function(e) {
  e.Unimplemented = "UNIMPLEMENTED", e.Unavailable = "UNAVAILABLE";
})(Vu || (Vu = {}));
class J1 extends Error {
  constructor(t, r, n) {
    super(t), this.message = t, this.code = r, this.data = n;
  }
}
const Nce = (e) => {
  var t, r;
  return e != null && e.androidBridge ? "android" : !((r = (t = e == null ? void 0 : e.webkit) === null || t === void 0 ? void 0 : t.messageHandlers) === null || r === void 0) && r.bridge ? "ios" : "web";
}, Ice = (e) => {
  var t, r, n, i, a;
  const s = e.CapacitorCustomPlatform || null, o = e.Capacitor || {}, u = o.Plugins = o.Plugins || {}, f = e.CapacitorPlatforms, l = () => s !== null ? s.name : Nce(e), d = ((t = f == null ? void 0 : f.currentPlatform) === null || t === void 0 ? void 0 : t.getPlatform) || l, c = () => d() !== "web", p = ((r = f == null ? void 0 : f.currentPlatform) === null || r === void 0 ? void 0 : r.isNativePlatform) || c, v = (P) => {
    const K = C.get(P);
    return !!(K != null && K.platforms.has(d()) || q(P));
  }, h = ((n = f == null ? void 0 : f.currentPlatform) === null || n === void 0 ? void 0 : n.isPluginAvailable) || v, m = (P) => {
    var K;
    return (K = o.PluginHeaders) === null || K === void 0 ? void 0 : K.find((B) => B.name === P);
  }, q = ((i = f == null ? void 0 : f.currentPlatform) === null || i === void 0 ? void 0 : i.getPluginHeader) || m, w = (P) => e.console.error(P), O = (P, K, B) => Promise.reject(`${B} does not have an implementation of "${K}".`), C = /* @__PURE__ */ new Map(), R = (P, K = {}) => {
    const B = C.get(P);
    if (B)
      return console.warn(`Capacitor plugin "${P}" already registered. Cannot register plugins twice.`), B.proxy;
    const L = d(), _ = q(P);
    let ne;
    const Z = async () => (!ne && L in K ? ne = typeof K[L] == "function" ? ne = await K[L]() : ne = K[L] : s !== null && !ne && "web" in K && (ne = typeof K.web == "function" ? ne = await K.web() : ne = K.web), ne), le = (M, F) => {
      var pe, We;
      if (_) {
        const ce = _ == null ? void 0 : _.methods.find((oe) => F === oe.name);
        if (ce)
          return ce.rtype === "promise" ? (oe) => o.nativePromise(P, F.toString(), oe) : (oe, z) => o.nativeCallback(P, F.toString(), oe, z);
        if (M)
          return (pe = M[F]) === null || pe === void 0 ? void 0 : pe.bind(M);
      } else {
        if (M)
          return (We = M[F]) === null || We === void 0 ? void 0 : We.bind(M);
        throw new J1(`"${P}" plugin is not implemented on ${L}`, Vu.Unimplemented);
      }
    }, he = (M) => {
      let F;
      const pe = (...We) => {
        const ce = Z().then((oe) => {
          const z = le(oe, M);
          if (z) {
            const Ze = z(...We);
            return F = Ze == null ? void 0 : Ze.remove, Ze;
          } else
            throw new J1(`"${P}.${M}()" is not implemented on ${L}`, Vu.Unimplemented);
        });
        return M === "addListener" && (ce.remove = async () => F()), ce;
      };
      return pe.toString = () => `${M.toString()}() { [capacitor code] }`, Object.defineProperty(pe, "name", {
        value: M,
        writable: !1,
        configurable: !1
      }), pe;
    }, Ie = he("addListener"), xe = he("removeListener"), ye = (M, F) => {
      const pe = Ie({ eventName: M }, F), We = async () => {
        const oe = await pe;
        xe({
          eventName: M,
          callbackId: oe
        }, F);
      }, ce = new Promise((oe) => pe.then(() => oe({ remove: We })));
      return ce.remove = async () => {
        console.warn("Using addListener() without 'await' is deprecated."), await We();
      }, ce;
    }, ue = new Proxy({}, {
      get(M, F) {
        switch (F) {
          case "$$typeof":
            return;
          case "toJSON":
            return () => ({});
          case "addListener":
            return _ ? ye : Ie;
          case "removeListener":
            return xe;
          default:
            return he(F);
        }
      }
    });
    return u[P] = ue, C.set(P, {
      name: P,
      proxy: ue,
      platforms: /* @__PURE__ */ new Set([
        ...Object.keys(K),
        ..._ ? [L] : []
      ])
    }), ue;
  }, I = ((a = f == null ? void 0 : f.currentPlatform) === null || a === void 0 ? void 0 : a.registerPlugin) || R;
  return o.convertFileSrc || (o.convertFileSrc = (P) => P), o.getPlatform = d, o.handleError = w, o.isNativePlatform = p, o.isPluginAvailable = h, o.pluginMethodNoop = O, o.registerPlugin = I, o.Exception = J1, o.DEBUG = !!o.DEBUG, o.isLoggingEnabled = !!o.isLoggingEnabled, o.platform = o.getPlatform(), o.isNative = o.isNativePlatform(), o;
}, Xce = (e) => e.Capacitor = Ice(e), wa = /* @__PURE__ */ Xce(typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : typeof global < "u" ? global : {}), YR = wa.registerPlugin;
wa.Plugins;
class zR {
  constructor(t) {
    this.listeners = {}, this.windowListeners = {}, t && (console.warn(`Capacitor WebPlugin "${t.name}" config object was deprecated in v3 and will be removed in v4.`), this.config = t);
  }
  addListener(t, r) {
    this.listeners[t] || (this.listeners[t] = []), this.listeners[t].push(r);
    const i = this.windowListeners[t];
    i && !i.registered && this.addWindowListener(i);
    const a = async () => this.removeListener(t, r), s = Promise.resolve({ remove: a });
    return Object.defineProperty(s, "remove", {
      value: async () => {
        console.warn("Using addListener() without 'await' is deprecated."), await a();
      }
    }), s;
  }
  async removeAllListeners() {
    this.listeners = {};
    for (const t in this.windowListeners)
      this.removeWindowListener(this.windowListeners[t]);
    this.windowListeners = {};
  }
  notifyListeners(t, r) {
    const n = this.listeners[t];
    n && n.forEach((i) => i(r));
  }
  hasListeners(t) {
    return !!this.listeners[t].length;
  }
  registerWindowListener(t, r) {
    this.windowListeners[r] = {
      registered: !1,
      windowEventName: t,
      pluginEventName: r,
      handler: (n) => {
        this.notifyListeners(r, n);
      }
    };
  }
  unimplemented(t = "not implemented") {
    return new wa.Exception(t, Vu.Unimplemented);
  }
  unavailable(t = "not available") {
    return new wa.Exception(t, Vu.Unavailable);
  }
  async removeListener(t, r) {
    const n = this.listeners[t];
    if (!n)
      return;
    const i = n.indexOf(r);
    this.listeners[t].splice(i, 1), this.listeners[t].length || this.removeWindowListener(this.windowListeners[t]);
  }
  addWindowListener(t) {
    window.addEventListener(t.windowEventName, t.handler), t.registered = !0;
  }
  removeWindowListener(t) {
    t && (window.removeEventListener(t.windowEventName, t.handler), t.registered = !1);
  }
}
const HW = (e) => encodeURIComponent(e).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape), _W = (e) => e.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
class Pce extends zR {
  async getCookies() {
    const t = document.cookie, r = {};
    return t.split(";").forEach((n) => {
      if (n.length <= 0)
        return;
      let [i, a] = n.replace(/=/, "CAP_COOKIE").split("CAP_COOKIE");
      i = _W(i).trim(), a = _W(a).trim(), r[i] = a;
    }), r;
  }
  async setCookie(t) {
    try {
      const r = HW(t.key), n = HW(t.value), i = `; expires=${(t.expires || "").replace("expires=", "")}`, a = (t.path || "/").replace("path=", ""), s = t.url != null && t.url.length > 0 ? `domain=${t.url}` : "";
      document.cookie = `${r}=${n || ""}${i}; path=${a}; ${s};`;
    } catch (r) {
      return Promise.reject(r);
    }
  }
  async deleteCookie(t) {
    try {
      document.cookie = `${t.key}=; Max-Age=0`;
    } catch (r) {
      return Promise.reject(r);
    }
  }
  async clearCookies() {
    try {
      const t = document.cookie.split(";") || [];
      for (const r of t)
        document.cookie = r.replace(/^ +/, "").replace(/=.*/, `=;expires=${(/* @__PURE__ */ new Date()).toUTCString()};path=/`);
    } catch (t) {
      return Promise.reject(t);
    }
  }
  async clearAllCookies() {
    try {
      await this.clearCookies();
    } catch (t) {
      return Promise.reject(t);
    }
  }
}
YR("CapacitorCookies", {
  web: () => new Pce()
});
const Bce = async (e) => new Promise((t, r) => {
  const n = new FileReader();
  n.onload = () => {
    const i = n.result;
    t(i.indexOf(",") >= 0 ? i.split(",")[1] : i);
  }, n.onerror = (i) => r(i), n.readAsDataURL(e);
}), Dce = (e = {}) => {
  const t = Object.keys(e);
  return Object.keys(e).map((i) => i.toLocaleLowerCase()).reduce((i, a, s) => (i[a] = e[t[s]], i), {});
}, Lce = (e, t = !0) => e ? Object.entries(e).reduce((n, i) => {
  const [a, s] = i;
  let o, u;
  return Array.isArray(s) ? (u = "", s.forEach((f) => {
    o = t ? encodeURIComponent(f) : f, u += `${a}=${o}&`;
  }), u.slice(0, -1)) : (o = t ? encodeURIComponent(s) : s, u = `${a}=${o}`), `${n}&${u}`;
}, "").substr(1) : null, Zce = (e, t = {}) => {
  const r = Object.assign({ method: e.method || "GET", headers: e.headers }, t), i = Dce(e.headers)["content-type"] || "";
  if (typeof e.data == "string")
    r.body = e.data;
  else if (i.includes("application/x-www-form-urlencoded")) {
    const a = new URLSearchParams();
    for (const [s, o] of Object.entries(e.data || {}))
      a.set(s, o);
    r.body = a.toString();
  } else if (i.includes("multipart/form-data")) {
    const a = new FormData();
    if (e.data instanceof FormData)
      e.data.forEach((o, u) => {
        a.append(u, o);
      });
    else
      for (const o of Object.keys(e.data))
        a.append(o, e.data[o]);
    r.body = a;
    const s = new Headers(r.headers);
    s.delete("content-type"), r.headers = s;
  } else
    (i.includes("application/json") || typeof e.data == "object") && (r.body = JSON.stringify(e.data));
  return r;
};
class Mce extends zR {
  /**
   * Perform an Http request given a set of options
   * @param options Options to build the HTTP request
   */
  async request(t) {
    const r = Zce(t, t.webFetchExtra), n = Lce(t.params, t.shouldEncodeUrlParams), i = n ? `${t.url}?${n}` : t.url, a = await fetch(i, r), s = a.headers.get("content-type") || "";
    let { responseType: o = "text" } = a.ok ? t : {};
    s.includes("application/json") && (o = "json");
    let u, f;
    switch (o) {
      case "arraybuffer":
      case "blob":
        f = await a.blob(), u = await Bce(f);
        break;
      case "json":
        u = await a.json();
        break;
      case "document":
      case "text":
      default:
        u = await a.text();
    }
    const l = {};
    return a.headers.forEach((d, c) => {
      l[c] = d;
    }), {
      data: u,
      headers: l,
      status: a.status,
      url: a.url
    };
  }
  /**
   * Perform an Http GET request given a set of options
   * @param options Options to build the HTTP request
   */
  async get(t) {
    return this.request(Object.assign(Object.assign({}, t), { method: "GET" }));
  }
  /**
   * Perform an Http POST request given a set of options
   * @param options Options to build the HTTP request
   */
  async post(t) {
    return this.request(Object.assign(Object.assign({}, t), { method: "POST" }));
  }
  /**
   * Perform an Http PUT request given a set of options
   * @param options Options to build the HTTP request
   */
  async put(t) {
    return this.request(Object.assign(Object.assign({}, t), { method: "PUT" }));
  }
  /**
   * Perform an Http PATCH request given a set of options
   * @param options Options to build the HTTP request
   */
  async patch(t) {
    return this.request(Object.assign(Object.assign({}, t), { method: "PATCH" }));
  }
  /**
   * Perform an Http DELETE request given a set of options
   * @param options Options to build the HTTP request
   */
  async delete(t) {
    return this.request(Object.assign(Object.assign({}, t), { method: "DELETE" }));
  }
}
YR("CapacitorHttp", {
  web: () => new Mce()
});
const jce = Zn(gr)`
  background-color: ${({ theme: e }) => e.palette.common.white};
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  z-index: 100;
  overflow: auto;
  ${({ isNativePlatform: e }) => e && `padding-top: constant(safe-area-inset-top) !important;
  padding-top: env(safe-area-inset-top) !important;
  padding-bottom: env(safe-area-inset-bottom) !important;
  padding-bottom: constant(safe-area-inset-bottom) !important;`};
`, Yce = ({ children: e, setChatOpen: t, chatOpen: r }) => r ? /* @__PURE__ */ j(jce, { isNativePlatform: wa.isNativePlatform(), children: /* @__PURE__ */ ut(pt, { direction: "column", height: "100%", sx: { overflow: "auto" }, children: [
  /* @__PURE__ */ j(pt, { direction: "row", justifyContent: "flex-end", marginRight: 1, marginTop: 1, children: /* @__PURE__ */ j(Ci, { "aria-label": "Close", onClick: () => t(!1), sx: { color: (n) => n.palette.grey[400] }, children: /* @__PURE__ */ j(wu, { size: "sm" }) }) }),
  /* @__PURE__ */ j(pt, { marginTop: 1, height: "100%", sx: { overflow: "auto" }, children: e })
] }) }) : null, zce = ({ unreadMessagesTotal: e, children: t }) => {
  const r = wde(), n = tce(r.breakpoints.down("sm")), [i, a] = ir(!1), s = n && i;
  return Kr(() => {
    const o = (u) => {
      u.key === "Escape" && a(!1);
    };
    return document.addEventListener("keydown", o), () => {
      document.removeEventListener("keydown", o);
    };
  }, [a]), /* @__PURE__ */ ut(tn, { children: [
    n ? /* @__PURE__ */ j(Yce, { chatOpen: i, setChatOpen: a, children: t }) : /* @__PURE__ */ j(xce, { chatOpen: i, children: t }),
    /* @__PURE__ */ j(Tce, { unreadMessagesTotal: e, setChatOpen: a, chatOpen: i, hideTriggerButton: s })
  ] });
};
if (!("onscrollend" in window)) {
  let n = function(s, o, u) {
    let f = s[o];
    s[o] = function() {
      let l = Array.prototype.slice.apply(arguments, [0]);
      f.apply(this, l), l.unshift(f), u.apply(this, l);
    };
  }, i = function(s, o, u, f) {
    if (o != "scroll" && o != "scrollend")
      return;
    let l = this, d = r.get(l);
    if (d === void 0) {
      let c = 0;
      d = { scrollListener: (p) => {
        clearTimeout(c), c = setTimeout(() => {
          t.size ? setTimeout(d.scrollListener, 100) : (l.dispatchEvent(e), c = 0);
        }, 100);
      }, listeners: 0 }, s.apply(l, ["scroll", d.scrollListener]), r.set(l, d);
    }
    d.listeners++;
  }, a = function(s, o, u) {
    if (o != "scroll" && o != "scrollend")
      return;
    let f = this, l = r.get(f);
    l !== void 0 && (l[o]--, --l.listeners > 0 || (s.apply(f, ["scroll", l.scrollListener]), r.delete(f)));
  };
  const e = new Event("scrollend"), t = /* @__PURE__ */ new Set();
  document.addEventListener("touchstart", (s) => {
    for (let o of s.changedTouches)
      t.add(o.identifier);
  }, { passive: !0 }), document.addEventListener("touchend", (s) => {
    for (let o of s.changedTouches)
      t.delete(o.identifier);
  }, { passive: !0 });
  let r = /* @__PURE__ */ new WeakMap();
  n(Element.prototype, "addEventListener", i), n(window, "addEventListener", i), n(document, "addEventListener", i), n(Element.prototype, "removeEventListener", a), n(window, "removeEventListener", a), n(document, "removeEventListener", a);
}
function Mu(e, t) {
  if (t.length < e)
    throw new TypeError(e + " argument" + (e > 1 ? "s" : "") + " required, but only " + t.length + " present");
}
function Bg(e) {
  Mu(1, arguments);
  var t = Object.prototype.toString.call(e);
  return e instanceof Date || au(e) === "object" && t === "[object Date]" ? new Date(e.getTime()) : typeof e == "number" || t === "[object Number]" ? new Date(e) : ((typeof e == "string" || t === "[object String]") && typeof console < "u" && (console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments"), console.warn(new Error().stack)), /* @__PURE__ */ new Date(NaN));
}
function $W(e) {
  Mu(1, arguments);
  var t = Bg(e);
  return t.setHours(0, 0, 0, 0), t;
}
function GR(e, t) {
  Mu(2, arguments);
  var r = $W(e), n = $W(t);
  return r.getTime() === n.getTime();
}
function Gce(e, t) {
  return Mu(2, arguments), Bg(e).getTime() - Bg(t).getTime();
}
var e6 = {
  ceil: Math.ceil,
  round: Math.round,
  floor: Math.floor,
  trunc: function(t) {
    return t < 0 ? Math.ceil(t) : Math.floor(t);
  }
  // Math.trunc is not supported by IE
}, Qce = "trunc";
function Jce(e) {
  return e ? e6[e] : e6[Qce];
}
function t6(e, t, r) {
  Mu(2, arguments);
  var n = Gce(e, t) / 1e3;
  return Jce(r == null ? void 0 : r.roundingMethod)(n);
}
function Hce(e) {
  return Mu(1, arguments), GR(e, Date.now());
}
const _ce = (e, t, r) => {
  if (!e)
    return !1;
  if (!r)
    return !0;
  const n = new Date(r), i = new Date(e);
  return !t && t6(n, i) > 60 || t6(n, i) > 60;
}, $ce = (e, t) => {
  if (!e)
    return !1;
  const r = new Date(e);
  return !t || !GR(r, new Date(t));
}, epe = _T`
from{
  opacity: 0;
}
to{
  opacity: 1
}
`, tpe = Zn(ry)(() => ({
  opacity: 0,
  animation: `${epe} 300ms 2s  forwards`,
  margin: "auto",
  position: "sticky",
  bottom: "10px"
})), rpe = ({
  messages: e,
  language: t,
  userId: r,
  lastReadMessageIndex: n,
  markAllMessagesRead: i,
  isGroup: a,
  handleDeleteMessage: s,
  hasNewMessagesToShow: o,
  handleGetMoreMessages: u,
  handleCanDelete: f
}) => {
  const [l, d] = ir(!1), { t: c } = Ur(), p = zr(null), v = (h, m) => a ? m === 0 ? !0 : h[m].author !== h[m - 1].author : !1;
  return X6(() => {
    const h = p.current, m = async () => {
      !h || (h == null ? void 0 : h.scrollTop) > 0 || (d(!0), await u(), d(!1));
    };
    return h == null || h.addEventListener("scrollend", m), () => h == null ? void 0 : h.removeEventListener("scrollend", m);
  }, [u]), /* @__PURE__ */ j(
    gr,
    {
      sx: {
        height: 1,
        paddingBottom: 2,
        overflowY: "scroll",
        overscrollBehavior: "contain",
        position: "relative"
      },
      ref: p,
      children: /* @__PURE__ */ ut(pt, { m: 1, children: [
        /* @__PURE__ */ j(ipe, { isLoading: l }),
        e.map((h, m) => {
          var w, O, C;
          const q = _ce(h == null ? void 0 : h.dateCreated, (w = e[m - 1]) == null ? void 0 : w.dateCreated, (O = e[m + 1]) == null ? void 0 : O.dateCreated);
          return /* @__PURE__ */ ut(pt, { my: q ? 0 : 1, children: [
            /* @__PURE__ */ j(
              npe,
              {
                date: new Date(h.dateCreated),
                language: t,
                showDate: $ce(h.dateCreated, (C = e[m - 1]) == null ? void 0 : C.dateCreated)
              }
            ),
            /* @__PURE__ */ j(
              mhe,
              {
                lastReadMessageIndex: n,
                canDelete: f(h),
                message: h,
                handleDeleteMessage: s,
                isAuthor: r === h.author,
                language: t,
                showTimestamp: q,
                showAuthor: v(e, m)
              }
            )
          ] }, m);
        }),
        o ? /* @__PURE__ */ j(tpe, { icon: /* @__PURE__ */ j(sU, {}), color: "secondary", onClick: i, label: c("NEW_MESSAGES") }) : null
      ] })
    }
  );
}, npe = ({ showDate: e, date: t, language: r }) => {
  if (!t || !e)
    return null;
  const n = r === "fr" ? "fr-CA" : "en-CA";
  return /* @__PURE__ */ j(pt, { direction: "row", justifyContent: "center", mb: 2, mt: 10, children: /* @__PURE__ */ j(br, { color: (i) => i.palette.grey[500], variant: "caption", fontWeight: "medium", children: t.toLocaleString(n, { month: "long", year: "numeric", day: "numeric", weekday: "short" }) }) });
}, ipe = ({ isLoading: e }) => e ? /* @__PURE__ */ j(gr, { width: 1, sx: { position: "absolute", top: "1rem" }, children: /* @__PURE__ */ j(pt, { direction: "row", justifyContent: "center", children: /* @__PURE__ */ j($T, {}) }) }) : null, QR = ({ isFavorite: e, removeFromFavorites: t, addToFavorites: r }) => {
  const { t: n } = Ur();
  return /* @__PURE__ */ j(is, { component: "button", color: "inherit", variant: "subtitle2", onClick: e ? t : r, children: /* @__PURE__ */ j(pt, { direction: "row", alignItems: "baseline", marginLeft: 2, spacing: 1, children: e ? /* @__PURE__ */ ut(tn, { children: [
    /* @__PURE__ */ j(nm, { size: "sm", color: uR[600] }),
    /* @__PURE__ */ j(gr, { children: n("UNFAVORITE") })
  ] }) : /* @__PURE__ */ ut(tn, { children: [
    /* @__PURE__ */ j(nm, { size: "sm", family: "regular" }),
    /* @__PURE__ */ j(gr, { children: n("FAVORITE") })
  ] }) }) });
}, ape = ({ filename: e }) => {
  var r;
  const t = ((r = e.split(".").pop()) == null ? void 0 : r.toLowerCase()) ?? "";
  return /* @__PURE__ */ j(ey, { sx: { bgcolor: "#DCDCDC", color: (n) => n.palette.grey[800], height: 40, width: 40, borderRadius: 2 }, variant: "square", children: /* @__PURE__ */ j(spe, { fileExtension: t }) });
}, spe = ({ fileExtension: e }) => {
  switch (e) {
    case "jpeg":
    case "jpg":
    case "png":
      return /* @__PURE__ */ j(pU, {});
    case "mp4":
    case "mov":
      return /* @__PURE__ */ j(cU, {});
    case "pdf":
      return /* @__PURE__ */ j(dU, {});
    case "xlsx":
      return /* @__PURE__ */ j(lU, {});
    case "csv":
      return /* @__PURE__ */ j(fU, {});
    case "docx":
    case "txt":
    case "doc":
      return /* @__PURE__ */ j(uU, {});
    default:
      return /* @__PURE__ */ j(oU, {});
  }
}, ope = ({ authorId: e, dateUploaded: t, media: r }) => {
  var f;
  const { t: n, currentLanguage: i } = Ur(), a = Lt(Xu), { filename: s } = r, o = ((f = a == null ? void 0 : a[e ?? ""]) == null ? void 0 : f.fullName) ?? "", u = t == null ? void 0 : t.toLocaleString(i, { month: "long", day: "numeric", year: "numeric" });
  return /* @__PURE__ */ ut(pt, { direction: "row", alignItems: "flex-start", justifyContent: "flex-start", spacing: 2, children: [
    /* @__PURE__ */ j(ape, { filename: s || "" }),
    /* @__PURE__ */ ut(pt, { direction: "column", alignItems: "flex-start", children: [
      /* @__PURE__ */ j(
        is,
        {
          component: "button",
          color: (l) => l.palette.text.primary,
          fontWeight: "600",
          variant: "body2",
          onClick: async () => {
            const l = await r.getContentTemporaryUrl();
            if (l)
              return window.open(l, "_blank");
          },
          children: s
        }
      ),
      /* @__PURE__ */ j(br, { sx: { wordBreak: "break-word" }, variant: "caption", children: `${n("SHARED_BY")} ${o} ${n("ON")} ${u}` })
    ] })
  ] });
}, upe = () => {
  const { t: e } = Ur();
  return /* @__PURE__ */ ut(pt, { direction: "column", flexGrow: 1, justifyContent: "center", spacing: 2, marginX: 4, children: [
    /* @__PURE__ */ j(pt, { sx: { color: (t) => t.palette.primary.light }, children: /* @__PURE__ */ j(vU, { size: "3x" }) }),
    /* @__PURE__ */ j(br, { variant: "body2", align: "center", children: e("NO_ATTACHMENTS") })
  ] });
}, JR = ({ files: e }) => {
  const { t } = Ur();
  if (!e)
    return null;
  const r = e.length !== 0 && e.some((n) => {
    var i;
    return ((i = n.medias) == null ? void 0 : i.length) !== 0;
  });
  return /* @__PURE__ */ ut(pt, { direction: "column", flex: "1", sx: { overflow: "auto" }, marginLeft: 2, marginBottom: 2, children: [
    /* @__PURE__ */ j(br, { variant: "caption", sx: { color: (n) => n.palette.grey[500], marginBottom: 1, fontWeight: 600 }, children: t("FILES") }),
    /* @__PURE__ */ j(pt, { direction: "column", spacing: 2, sx: { overflow: "auto", height: "100%" }, children: r ? /* @__PURE__ */ j(tn, { children: e.map((n) => {
      var i;
      return (i = n.medias) == null ? void 0 : i.map((a) => /* @__PURE__ */ j(ope, { authorId: n.authorId, dateUploaded: n.dateUploaded, media: a }, a.sid));
    }) }) : /* @__PURE__ */ j(upe, {}) })
  ] });
}, HR = ({ deleteConversation: e }) => {
  const { t } = Ur(), [r, n] = ir(!1), i = () => {
    n(!1);
  }, a = () => {
    n(!0);
  }, s = [
    {
      text: t("DELETE"),
      onClick: e,
      danger: !0
    }
  ];
  return /* @__PURE__ */ ut(tn, { children: [
    /* @__PURE__ */ j(is, { component: "button", color: "error", variant: "subtitle2", fontWeight: "600", onClick: a, children: t("DELETE_CONVERSATION") }),
    /* @__PURE__ */ j(
      iv,
      {
        actions: s,
        handleClose: i,
        open: r,
        title: t("DELETE_CONVERSATION"),
        content: t("DELETE_CONVERSATION_MODAL_CONTENT")
      }
    )
  ] });
}, fpe = ({ name: e, friendlyName: t, setName: r, isEditing: n }) => {
  const i = (s) => {
    const o = s.target.value.trim();
    r(o);
  }, a = e.length === 0 ? t.length * 10 : e.length * 10;
  return n ? /* @__PURE__ */ j(
    ll,
    {
      sx: {
        fieldset: { border: "none" },
        input: {
          fontSize: (s) => s.typography.subtitle2.fontSize,
          fontWeight: (s) => s.typography.subtitle2.fontWeight,
          padding: 0
        },
        width: a,
        maxWidth: 250
      },
      type: "text",
      name: "conversation-name",
      placeholder: t,
      onChange: i,
      autoFocus: !0
    }
  ) : /* @__PURE__ */ j(
    br,
    {
      variant: "subtitle2",
      sx: {
        wordBreak: "break-word",
        maxWidth: 250,
        textAlign: "center",
        whiteSpace: "initial",
        overflow: "hidden",
        textOverflow: "ellipsis",
        display: "-webkit-box",
        WebkitLineClamp: "2",
        WebkitBoxOrient: "vertical"
      },
      children: e || t
    }
  );
}, lpe = ({ participants: e, updateFriendlyName: t, friendlyName: r, canEdit: n }) => {
  const { t: i } = Ur(), [a, s] = ir(""), [o, u] = ir(!1);
  return /* @__PURE__ */ ut(pt, { direction: "column", alignItems: "center", marginTop: 1, marginX: 2, children: [
    n && /* @__PURE__ */ j(pt, { alignSelf: "end", children: o ? /* @__PURE__ */ j(is, { component: "button", color: "primary", fontSize: "1rem", fontWeight: "600", onClick: () => {
      u(!1);
      const d = a.trim();
      d && t(d);
    }, children: i("DONE") }) : /* @__PURE__ */ j(is, { component: "button", sx: { color: (d) => d.palette.grey[500] }, fontSize: "1rem", fontWeight: "600", onClick: () => {
      u(!0);
    }, children: i("EDIT") }) }),
    /* @__PURE__ */ ut(pt, { direction: "column", alignItems: "center", spacing: 1, children: [
      /* @__PURE__ */ j(cq, { participants: e, type: "group", large: !0 }),
      /* @__PURE__ */ j(pt, { minHeight: 25, children: /* @__PURE__ */ j(fpe, { name: a, friendlyName: r ?? "", setName: s, isEditing: o }) })
    ] })
  ] });
}, _R = ({ leaveConversation: e }) => {
  const { t } = Ur(), [r, n] = ir(!1), i = () => {
    n(!1);
  }, a = () => {
    n(!0);
  }, s = [
    {
      text: t("LEAVE"),
      onClick: e,
      danger: !0
    }
  ];
  return /* @__PURE__ */ ut(tn, { children: [
    /* @__PURE__ */ j(is, { component: "button", color: "error", variant: "subtitle2", fontWeight: "600", onClick: a, children: t("LEAVE_CONVERSATION") }),
    /* @__PURE__ */ j(
      iv,
      {
        actions: s,
        handleClose: i,
        open: r,
        title: t("LEAVE_CONVERSATION"),
        content: t("LEAVE_CONVERSATION_MODAL_CONTENT")
      }
    )
  ] });
}, dpe = ({ canEdit: e, children: t }) => {
  const { t: r } = Ur(), { goTo: n, param: i } = Gn();
  return /* @__PURE__ */ ut(pt, { direction: "column", flex: "1", sx: { overflow: "auto" }, marginBottom: 2, children: [
    /* @__PURE__ */ ut(pt, { direction: "row", justifyContent: "space-between", alignItems: "center", paddingBottom: 1, paddingX: 2, children: [
      /* @__PURE__ */ j(br, { variant: "caption", sx: { color: (a) => a.palette.grey[500], fontWeight: 600 }, children: r("PARTICIPANTS") }),
      e && /* @__PURE__ */ j(Ci, { onClick: () => n(`addParticipants/${i}`), color: "primary", children: /* @__PURE__ */ j(hU, { size: "2xs" }) })
    ] }),
    /* @__PURE__ */ j(pt, { paddingX: 1, sx: { overflow: "auto" }, children: t })
  ] });
};
function ju(e, t, r, n) {
  function i(a) {
    return a instanceof r ? a : new r(function(s) {
      s(a);
    });
  }
  return new (r || (r = Promise))(function(a, s) {
    function o(l) {
      try {
        f(n.next(l));
      } catch (d) {
        s(d);
      }
    }
    function u(l) {
      try {
        f(n.throw(l));
      } catch (d) {
        s(d);
      }
    }
    function f(l) {
      l.done ? a(l.value) : i(l.value).then(o, u);
    }
    f((n = n.apply(e, t || [])).next());
  });
}
function Yu(e, t) {
  var r = { label: 0, sent: function() {
    if (a[0] & 1)
      throw a[1];
    return a[1];
  }, trys: [], ops: [] }, n, i, a, s;
  return s = { next: o(0), throw: o(1), return: o(2) }, typeof Symbol == "function" && (s[Symbol.iterator] = function() {
    return this;
  }), s;
  function o(f) {
    return function(l) {
      return u([f, l]);
    };
  }
  function u(f) {
    if (n)
      throw new TypeError("Generator is already executing.");
    for (; s && (s = 0, f[0] && (r = 0)), r; )
      try {
        if (n = 1, i && (a = f[0] & 2 ? i.return : f[0] ? i.throw || ((a = i.return) && a.call(i), 0) : i.next) && !(a = a.call(i, f[1])).done)
          return a;
        switch (i = 0, a && (f = [f[0] & 2, a.value]), f[0]) {
          case 0:
          case 1:
            a = f;
            break;
          case 4:
            return r.label++, { value: f[1], done: !1 };
          case 5:
            r.label++, i = f[1], f = [0];
            continue;
          case 7:
            f = r.ops.pop(), r.trys.pop();
            continue;
          default:
            if (a = r.trys, !(a = a.length > 0 && a[a.length - 1]) && (f[0] === 6 || f[0] === 2)) {
              r = 0;
              continue;
            }
            if (f[0] === 3 && (!a || f[1] > a[0] && f[1] < a[3])) {
              r.label = f[1];
              break;
            }
            if (f[0] === 6 && r.label < a[1]) {
              r.label = a[1], a = f;
              break;
            }
            if (a && r.label < a[2]) {
              r.label = a[2], r.ops.push(f);
              break;
            }
            a[2] && r.ops.pop(), r.trys.pop();
            continue;
        }
        f = t.call(e, r);
      } catch (l) {
        f = [6, l], i = 0;
      } finally {
        n = a = 0;
      }
    if (f[0] & 5)
      throw f[1];
    return { value: f[0] ? f[1] : void 0, done: !0 };
  }
}
function r6(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r)
    return e;
  var n = r.call(e), i, a = [], s;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; )
      a.push(i.value);
  } catch (o) {
    s = { error: o };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (s)
        throw s.error;
    }
  }
  return a;
}
function n6(e, t, r) {
  if (r || arguments.length === 2)
    for (var n = 0, i = t.length, a; n < i; n++)
      (a || !(n in t)) && (a || (a = Array.prototype.slice.call(t, 0, n)), a[n] = t[n]);
  return e.concat(a || Array.prototype.slice.call(t));
}
var cpe = /* @__PURE__ */ new Map([
  // https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types/Common_types
  ["aac", "audio/aac"],
  ["abw", "application/x-abiword"],
  ["arc", "application/x-freearc"],
  ["avif", "image/avif"],
  ["avi", "video/x-msvideo"],
  ["azw", "application/vnd.amazon.ebook"],
  ["bin", "application/octet-stream"],
  ["bmp", "image/bmp"],
  ["bz", "application/x-bzip"],
  ["bz2", "application/x-bzip2"],
  ["cda", "application/x-cdf"],
  ["csh", "application/x-csh"],
  ["css", "text/css"],
  ["csv", "text/csv"],
  ["doc", "application/msword"],
  ["docx", "application/vnd.openxmlformats-officedocument.wordprocessingml.document"],
  ["eot", "application/vnd.ms-fontobject"],
  ["epub", "application/epub+zip"],
  ["gz", "application/gzip"],
  ["gif", "image/gif"],
  ["heic", "image/heic"],
  ["heif", "image/heif"],
  ["htm", "text/html"],
  ["html", "text/html"],
  ["ico", "image/vnd.microsoft.icon"],
  ["ics", "text/calendar"],
  ["jar", "application/java-archive"],
  ["jpeg", "image/jpeg"],
  ["jpg", "image/jpeg"],
  ["js", "text/javascript"],
  ["json", "application/json"],
  ["jsonld", "application/ld+json"],
  ["mid", "audio/midi"],
  ["midi", "audio/midi"],
  ["mjs", "text/javascript"],
  ["mp3", "audio/mpeg"],
  ["mp4", "video/mp4"],
  ["mpeg", "video/mpeg"],
  ["mpkg", "application/vnd.apple.installer+xml"],
  ["odp", "application/vnd.oasis.opendocument.presentation"],
  ["ods", "application/vnd.oasis.opendocument.spreadsheet"],
  ["odt", "application/vnd.oasis.opendocument.text"],
  ["oga", "audio/ogg"],
  ["ogv", "video/ogg"],
  ["ogx", "application/ogg"],
  ["opus", "audio/opus"],
  ["otf", "font/otf"],
  ["png", "image/png"],
  ["pdf", "application/pdf"],
  ["php", "application/x-httpd-php"],
  ["ppt", "application/vnd.ms-powerpoint"],
  ["pptx", "application/vnd.openxmlformats-officedocument.presentationml.presentation"],
  ["rar", "application/vnd.rar"],
  ["rtf", "application/rtf"],
  ["sh", "application/x-sh"],
  ["svg", "image/svg+xml"],
  ["swf", "application/x-shockwave-flash"],
  ["tar", "application/x-tar"],
  ["tif", "image/tiff"],
  ["tiff", "image/tiff"],
  ["ts", "video/mp2t"],
  ["ttf", "font/ttf"],
  ["txt", "text/plain"],
  ["vsd", "application/vnd.visio"],
  ["wav", "audio/wav"],
  ["weba", "audio/webm"],
  ["webm", "video/webm"],
  ["webp", "image/webp"],
  ["woff", "font/woff"],
  ["woff2", "font/woff2"],
  ["xhtml", "application/xhtml+xml"],
  ["xls", "application/vnd.ms-excel"],
  ["xlsx", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"],
  ["xml", "application/xml"],
  ["xul", "application/vnd.mozilla.xul+xml"],
  ["zip", "application/zip"],
  ["7z", "application/x-7z-compressed"],
  // Others
  ["mkv", "video/x-matroska"],
  ["mov", "video/quicktime"],
  ["msg", "application/vnd.ms-outlook"]
]);
function Jl(e, t) {
  var r = ppe(e);
  if (typeof r.path != "string") {
    var n = e.webkitRelativePath;
    Object.defineProperty(r, "path", {
      value: typeof t == "string" ? t : typeof n == "string" && n.length > 0 ? n : e.name,
      writable: !1,
      configurable: !1,
      enumerable: !0
    });
  }
  return r;
}
function ppe(e) {
  var t = e.name, r = t && t.lastIndexOf(".") !== -1;
  if (r && !e.type) {
    var n = t.split(".").pop().toLowerCase(), i = cpe.get(n);
    i && Object.defineProperty(e, "type", {
      value: i,
      writable: !1,
      configurable: !1,
      enumerable: !0
    });
  }
  return e;
}
var vpe = [
  // Thumbnail cache files for macOS and Windows
  ".DS_Store",
  "Thumbs.db"
  // Windows
];
function hpe(e) {
  return ju(this, void 0, void 0, function() {
    return Yu(this, function(t) {
      return Hc(e) && mpe(e.dataTransfer) ? [2, qpe(e.dataTransfer, e.type)] : gpe(e) ? [2, ype(e)] : Array.isArray(e) && e.every(function(r) {
        return "getFile" in r && typeof r.getFile == "function";
      }) ? [2, Vpe(e)] : [2, []];
    });
  });
}
function mpe(e) {
  return Hc(e);
}
function gpe(e) {
  return Hc(e) && Hc(e.target);
}
function Hc(e) {
  return typeof e == "object" && e !== null;
}
function ype(e) {
  return Dg(e.target.files).map(function(t) {
    return Jl(t);
  });
}
function Vpe(e) {
  return ju(this, void 0, void 0, function() {
    var t;
    return Yu(this, function(r) {
      switch (r.label) {
        case 0:
          return [4, Promise.all(e.map(function(n) {
            return n.getFile();
          }))];
        case 1:
          return t = r.sent(), [2, t.map(function(n) {
            return Jl(n);
          })];
      }
    });
  });
}
function qpe(e, t) {
  return ju(this, void 0, void 0, function() {
    var r, n;
    return Yu(this, function(i) {
      switch (i.label) {
        case 0:
          return e.items ? (r = Dg(e.items).filter(function(a) {
            return a.kind === "file";
          }), t !== "drop" ? [2, r] : [4, Promise.all(r.map(bpe))]) : [3, 2];
        case 1:
          return n = i.sent(), [2, i6($R(n))];
        case 2:
          return [2, i6(Dg(e.files).map(function(a) {
            return Jl(a);
          }))];
      }
    });
  });
}
function i6(e) {
  return e.filter(function(t) {
    return vpe.indexOf(t.name) === -1;
  });
}
function Dg(e) {
  if (e === null)
    return [];
  for (var t = [], r = 0; r < e.length; r++) {
    var n = e[r];
    t.push(n);
  }
  return t;
}
function bpe(e) {
  if (typeof e.webkitGetAsEntry != "function")
    return a6(e);
  var t = e.webkitGetAsEntry();
  return t && t.isDirectory ? eT(t) : a6(e);
}
function $R(e) {
  return e.reduce(function(t, r) {
    return n6(n6([], r6(t), !1), r6(Array.isArray(r) ? $R(r) : [r]), !1);
  }, []);
}
function a6(e) {
  var t = e.getAsFile();
  if (!t)
    return Promise.reject("".concat(e, " is not a File"));
  var r = Jl(t);
  return Promise.resolve(r);
}
function Ape(e) {
  return ju(this, void 0, void 0, function() {
    return Yu(this, function(t) {
      return [2, e.isDirectory ? eT(e) : wpe(e)];
    });
  });
}
function eT(e) {
  var t = e.createReader();
  return new Promise(function(r, n) {
    var i = [];
    function a() {
      var s = this;
      t.readEntries(function(o) {
        return ju(s, void 0, void 0, function() {
          var u, f, l;
          return Yu(this, function(d) {
            switch (d.label) {
              case 0:
                if (o.length)
                  return [3, 5];
                d.label = 1;
              case 1:
                return d.trys.push([1, 3, , 4]), [4, Promise.all(i)];
              case 2:
                return u = d.sent(), r(u), [3, 4];
              case 3:
                return f = d.sent(), n(f), [3, 4];
              case 4:
                return [3, 6];
              case 5:
                l = Promise.all(o.map(Ape)), i.push(l), a(), d.label = 6;
              case 6:
                return [
                  2
                  /*return*/
                ];
            }
          });
        });
      }, function(o) {
        n(o);
      });
    }
    a();
  });
}
function wpe(e) {
  return ju(this, void 0, void 0, function() {
    return Yu(this, function(t) {
      return [2, new Promise(function(r, n) {
        e.file(function(i) {
          var a = Jl(i, e.fullPath);
          r(a);
        }, function(i) {
          n(i);
        });
      })];
    });
  });
}
var kpe = function(e, t) {
  if (e && t) {
    var r = Array.isArray(t) ? t : t.split(","), n = e.name || "", i = (e.type || "").toLowerCase(), a = i.replace(/\/.*$/, "");
    return r.some(function(s) {
      var o = s.trim().toLowerCase();
      return o.charAt(0) === "." ? n.toLowerCase().endsWith(o) : o.endsWith("/*") ? a === o.replace(/\/.*$/, "") : i === o;
    });
  }
  return !0;
};
function s6(e) {
  return Cpe(e) || Spe(e) || rT(e) || Wpe();
}
function Wpe() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Spe(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null)
    return Array.from(e);
}
function Cpe(e) {
  if (Array.isArray(e))
    return Lg(e);
}
function o6(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function u6(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? o6(Object(r), !0).forEach(function(n) {
      tT(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : o6(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function tT(e, t, r) {
  return t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function fl(e, t) {
  return Rpe(e) || Kpe(e, t) || rT(e, t) || Fpe();
}
function Fpe() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function rT(e, t) {
  if (e) {
    if (typeof e == "string")
      return Lg(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set")
      return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return Lg(e, t);
  }
}
function Lg(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
function Kpe(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n = [], i = !0, a = !1, s, o;
    try {
      for (r = r.call(e); !(i = (s = r.next()).done) && (n.push(s.value), !(t && n.length === t)); i = !0)
        ;
    } catch (u) {
      a = !0, o = u;
    } finally {
      try {
        !i && r.return != null && r.return();
      } finally {
        if (a)
          throw o;
      }
    }
    return n;
  }
}
function Rpe(e) {
  if (Array.isArray(e))
    return e;
}
var Tpe = "file-invalid-type", Upe = "file-too-large", xpe = "file-too-small", Epe = "too-many-files", Ope = function(t) {
  t = Array.isArray(t) && t.length === 1 ? t[0] : t;
  var r = Array.isArray(t) ? "one of ".concat(t.join(", ")) : t;
  return {
    code: Tpe,
    message: "File type must be ".concat(r)
  };
}, f6 = function(t) {
  return {
    code: Upe,
    message: "File is larger than ".concat(t, " ").concat(t === 1 ? "byte" : "bytes")
  };
}, l6 = function(t) {
  return {
    code: xpe,
    message: "File is smaller than ".concat(t, " ").concat(t === 1 ? "byte" : "bytes")
  };
}, Npe = {
  code: Epe,
  message: "Too many files"
};
function nT(e, t) {
  var r = e.type === "application/x-moz-file" || kpe(e, t);
  return [r, r ? null : Ope(t)];
}
function iT(e, t, r) {
  if (Ns(e.size))
    if (Ns(t) && Ns(r)) {
      if (e.size > r)
        return [!1, f6(r)];
      if (e.size < t)
        return [!1, l6(t)];
    } else {
      if (Ns(t) && e.size < t)
        return [!1, l6(t)];
      if (Ns(r) && e.size > r)
        return [!1, f6(r)];
    }
  return [!0, null];
}
function Ns(e) {
  return e != null;
}
function Ipe(e) {
  var t = e.files, r = e.accept, n = e.minSize, i = e.maxSize, a = e.multiple, s = e.maxFiles, o = e.validator;
  return !a && t.length > 1 || a && s >= 1 && t.length > s ? !1 : t.every(function(u) {
    var f = nT(u, r), l = fl(f, 1), d = l[0], c = iT(u, n, i), p = fl(c, 1), v = p[0], h = o ? o(u) : null;
    return d && v && !h;
  });
}
function _c(e) {
  return typeof e.isPropagationStopped == "function" ? e.isPropagationStopped() : typeof e.cancelBubble < "u" ? e.cancelBubble : !1;
}
function zd(e) {
  return e.dataTransfer ? Array.prototype.some.call(e.dataTransfer.types, function(t) {
    return t === "Files" || t === "application/x-moz-file";
  }) : !!e.target && !!e.target.files;
}
function d6(e) {
  e.preventDefault();
}
function Xpe(e) {
  return e.indexOf("MSIE") !== -1 || e.indexOf("Trident/") !== -1;
}
function Ppe(e) {
  return e.indexOf("Edge/") !== -1;
}
function Bpe() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : window.navigator.userAgent;
  return Xpe(e) || Ppe(e);
}
function Oi() {
  for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++)
    t[r] = arguments[r];
  return function(n) {
    for (var i = arguments.length, a = new Array(i > 1 ? i - 1 : 0), s = 1; s < i; s++)
      a[s - 1] = arguments[s];
    return t.some(function(o) {
      return !_c(n) && o && o.apply(void 0, [n].concat(a)), _c(n);
    });
  };
}
function Dpe() {
  return "showOpenFilePicker" in window;
}
function Lpe(e) {
  if (Ns(e)) {
    var t = Object.entries(e).filter(function(r) {
      var n = fl(r, 2), i = n[0], a = n[1], s = !0;
      return aT(i) || (console.warn('Skipped "'.concat(i, '" because it is not a valid MIME type. Check https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types/Common_types for a list of valid MIME types.')), s = !1), (!Array.isArray(a) || !a.every(sT)) && (console.warn('Skipped "'.concat(i, '" because an invalid file extension was provided.')), s = !1), s;
    }).reduce(function(r, n) {
      var i = fl(n, 2), a = i[0], s = i[1];
      return u6(u6({}, r), {}, tT({}, a, s));
    }, {});
    return [{
      // description is required due to https://crbug.com/1264708
      description: "Files",
      accept: t
    }];
  }
  return e;
}
function Zpe(e) {
  if (Ns(e))
    return Object.entries(e).reduce(function(t, r) {
      var n = fl(r, 2), i = n[0], a = n[1];
      return [].concat(s6(t), [i], s6(a));
    }, []).filter(function(t) {
      return aT(t) || sT(t);
    }).join(",");
}
function Mpe(e) {
  return e instanceof DOMException && (e.name === "AbortError" || e.code === e.ABORT_ERR);
}
function jpe(e) {
  return e instanceof DOMException && (e.name === "SecurityError" || e.code === e.SECURITY_ERR);
}
function aT(e) {
  return e === "audio/*" || e === "video/*" || e === "image/*" || e === "text/*" || /\w+\/[-+.\w]+/g.test(e);
}
function sT(e) {
  return /^.*\.[\w]+$/.test(e);
}
var Ype = ["children"], zpe = ["open"], Gpe = ["refKey", "role", "onKeyDown", "onFocus", "onBlur", "onClick", "onDragEnter", "onDragOver", "onDragLeave", "onDrop"], Qpe = ["refKey", "onChange", "onClick"];
function Jpe(e) {
  return $pe(e) || _pe(e) || oT(e) || Hpe();
}
function Hpe() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _pe(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null)
    return Array.from(e);
}
function $pe(e) {
  if (Array.isArray(e))
    return Zg(e);
}
function H1(e, t) {
  return rve(e) || tve(e, t) || oT(e, t) || eve();
}
function eve() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function oT(e, t) {
  if (e) {
    if (typeof e == "string")
      return Zg(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set")
      return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return Zg(e, t);
  }
}
function Zg(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
function tve(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n = [], i = !0, a = !1, s, o;
    try {
      for (r = r.call(e); !(i = (s = r.next()).done) && (n.push(s.value), !(t && n.length === t)); i = !0)
        ;
    } catch (u) {
      a = !0, o = u;
    } finally {
      try {
        !i && r.return != null && r.return();
      } finally {
        if (a)
          throw o;
      }
    }
    return n;
  }
}
function rve(e) {
  if (Array.isArray(e))
    return e;
}
function c6(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Er(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? c6(Object(r), !0).forEach(function(n) {
      Mg(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : c6(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function Mg(e, t, r) {
  return t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function $c(e, t) {
  if (e == null)
    return {};
  var r = nve(e, t), n, i;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (i = 0; i < a.length; i++)
      n = a[i], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function nve(e, t) {
  if (e == null)
    return {};
  var r = {}, n = Object.keys(e), i, a;
  for (a = 0; a < n.length; a++)
    i = n[a], !(t.indexOf(i) >= 0) && (r[i] = e[i]);
  return r;
}
var Eq = /* @__PURE__ */ $g(function(e, t) {
  var r = e.children, n = $c(e, Ype), i = fT(n), a = i.open, s = $c(i, zpe);
  return LT(t, function() {
    return {
      open: a
    };
  }, [a]), /* @__PURE__ */ In.createElement(ZT, null, r(Er(Er({}, s), {}, {
    open: a
  })));
});
Eq.displayName = "Dropzone";
var uT = {
  disabled: !1,
  getFilesFromEvent: hpe,
  maxSize: 1 / 0,
  minSize: 0,
  multiple: !0,
  maxFiles: 0,
  preventDropOnDocument: !0,
  noClick: !1,
  noKeyboard: !1,
  noDrag: !1,
  noDragEventsBubbling: !1,
  validator: null,
  useFsAccessApi: !0,
  autoFocus: !1
};
Eq.defaultProps = uT;
Eq.propTypes = {
  /**
   * Render function that exposes the dropzone state and prop getter fns
   *
   * @param {object} params
   * @param {Function} params.getRootProps Returns the props you should apply to the root drop container you render
   * @param {Function} params.getInputProps Returns the props you should apply to hidden file input you render
   * @param {Function} params.open Open the native file selection dialog
   * @param {boolean} params.isFocused Dropzone area is in focus
   * @param {boolean} params.isFileDialogActive File dialog is opened
   * @param {boolean} params.isDragActive Active drag is in progress
   * @param {boolean} params.isDragAccept Dragged files are accepted
   * @param {boolean} params.isDragReject Some dragged files are rejected
   * @param {File[]} params.acceptedFiles Accepted files
   * @param {FileRejection[]} params.fileRejections Rejected files and why they were rejected
   */
  children: be.func,
  /**
   * Set accepted file types.
   * Checkout https://developer.mozilla.org/en-US/docs/Web/API/window/showOpenFilePicker types option for more information.
   * Keep in mind that mime type determination is not reliable across platforms. CSV files,
   * for example, are reported as text/plain under macOS but as application/vnd.ms-excel under
   * Windows. In some cases there might not be a mime type set at all (https://github.com/react-dropzone/react-dropzone/issues/276).
   */
  accept: be.objectOf(be.arrayOf(be.string)),
  /**
   * Allow drag 'n' drop (or selection from the file dialog) of multiple files
   */
  multiple: be.bool,
  /**
   * If false, allow dropped items to take over the current browser window
   */
  preventDropOnDocument: be.bool,
  /**
   * If true, disables click to open the native file selection dialog
   */
  noClick: be.bool,
  /**
   * If true, disables SPACE/ENTER to open the native file selection dialog.
   * Note that it also stops tracking the focus state.
   */
  noKeyboard: be.bool,
  /**
   * If true, disables drag 'n' drop
   */
  noDrag: be.bool,
  /**
   * If true, stops drag event propagation to parents
   */
  noDragEventsBubbling: be.bool,
  /**
   * Minimum file size (in bytes)
   */
  minSize: be.number,
  /**
   * Maximum file size (in bytes)
   */
  maxSize: be.number,
  /**
   * Maximum accepted number of files
   * The default value is 0 which means there is no limitation to how many files are accepted.
   */
  maxFiles: be.number,
  /**
   * Enable/disable the dropzone
   */
  disabled: be.bool,
  /**
   * Use this to provide a custom file aggregator
   *
   * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
   */
  getFilesFromEvent: be.func,
  /**
   * Cb for when closing the file dialog with no selection
   */
  onFileDialogCancel: be.func,
  /**
   * Cb for when opening the file dialog
   */
  onFileDialogOpen: be.func,
  /**
   * Set to true to use the https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API
   * to open the file picker instead of using an `<input type="file">` click event.
   */
  useFsAccessApi: be.bool,
  /**
   * Set to true to focus the root element on render
   */
  autoFocus: be.bool,
  /**
   * Cb for when the `dragenter` event occurs.
   *
   * @param {DragEvent} event
   */
  onDragEnter: be.func,
  /**
   * Cb for when the `dragleave` event occurs
   *
   * @param {DragEvent} event
   */
  onDragLeave: be.func,
  /**
   * Cb for when the `dragover` event occurs
   *
   * @param {DragEvent} event
   */
  onDragOver: be.func,
  /**
   * Cb for when the `drop` event occurs.
   * Note that this callback is invoked after the `getFilesFromEvent` callback is done.
   *
   * Files are accepted or rejected based on the `accept`, `multiple`, `minSize` and `maxSize` props.
   * `accept` must be a valid [MIME type](http://www.iana.org/assignments/media-types/media-types.xhtml) according to [input element specification](https://www.w3.org/wiki/HTML/Elements/input/file) or a valid file extension.
   * If `multiple` is set to false and additional files are dropped,
   * all files besides the first will be rejected.
   * Any file which does not have a size in the [`minSize`, `maxSize`] range, will be rejected as well.
   *
   * Note that the `onDrop` callback will always be invoked regardless if the dropped files were accepted or rejected.
   * If you'd like to react to a specific scenario, use the `onDropAccepted`/`onDropRejected` props.
   *
   * `onDrop` will provide you with an array of [File](https://developer.mozilla.org/en-US/docs/Web/API/File) objects which you can then process and send to a server.
   * For example, with [SuperAgent](https://github.com/visionmedia/superagent) as a http/ajax library:
   *
   * ```js
   * function onDrop(acceptedFiles) {
   *   const req = request.post('/upload')
   *   acceptedFiles.forEach(file => {
   *     req.attach(file.name, file)
   *   })
   *   req.end(callback)
   * }
   * ```
   *
   * @param {File[]} acceptedFiles
   * @param {FileRejection[]} fileRejections
   * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
   */
  onDrop: be.func,
  /**
   * Cb for when the `drop` event occurs.
   * Note that if no files are accepted, this callback is not invoked.
   *
   * @param {File[]} files
   * @param {(DragEvent|Event)} event
   */
  onDropAccepted: be.func,
  /**
   * Cb for when the `drop` event occurs.
   * Note that if no files are rejected, this callback is not invoked.
   *
   * @param {FileRejection[]} fileRejections
   * @param {(DragEvent|Event)} event
   */
  onDropRejected: be.func,
  /**
   * Cb for when there's some error from any of the promises.
   *
   * @param {Error} error
   */
  onError: be.func,
  /**
   * Custom validation function. It must return null if there's no errors.
   * @param {File} file
   * @returns {FileError|FileError[]|null}
   */
  validator: be.func
};
var jg = {
  isFocused: !1,
  isFileDialogActive: !1,
  isDragActive: !1,
  isDragAccept: !1,
  isDragReject: !1,
  acceptedFiles: [],
  fileRejections: []
};
function fT() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = Er(Er({}, uT), e), r = t.accept, n = t.disabled, i = t.getFilesFromEvent, a = t.maxSize, s = t.minSize, o = t.multiple, u = t.maxFiles, f = t.onDragEnter, l = t.onDragLeave, d = t.onDragOver, c = t.onDrop, p = t.onDropAccepted, v = t.onDropRejected, h = t.onFileDialogCancel, m = t.onFileDialogOpen, q = t.useFsAccessApi, w = t.autoFocus, O = t.preventDropOnDocument, C = t.noClick, R = t.noKeyboard, I = t.noDrag, P = t.noDragEventsBubbling, K = t.onError, B = t.validator, L = Br(function() {
    return Zpe(r);
  }, [r]), _ = Br(function() {
    return Lpe(r);
  }, [r]), ne = Br(function() {
    return typeof m == "function" ? m : p6;
  }, [m]), Z = Br(function() {
    return typeof h == "function" ? h : p6;
  }, [h]), le = zr(null), he = zr(null), Ie = DT(ive, jg), xe = H1(Ie, 2), ye = xe[0], ue = xe[1], M = ye.isFocused, F = ye.isFileDialogActive, pe = zr(typeof window < "u" && window.isSecureContext && q && Dpe()), We = function() {
    !pe.current && F && setTimeout(function() {
      if (he.current) {
        var Je = he.current.files;
        Je.length || (ue({
          type: "closeDialog"
        }), Z());
      }
    }, 300);
  };
  Kr(function() {
    return window.addEventListener("focus", We, !1), function() {
      window.removeEventListener("focus", We, !1);
    };
  }, [he, F, Z, pe]);
  var ce = zr([]), oe = function(Je) {
    le.current && le.current.contains(Je.target) || (Je.preventDefault(), ce.current = []);
  };
  Kr(function() {
    return O && (document.addEventListener("dragover", d6, !1), document.addEventListener("drop", oe, !1)), function() {
      O && (document.removeEventListener("dragover", d6), document.removeEventListener("drop", oe));
    };
  }, [le, O]), Kr(function() {
    return !n && w && le.current && le.current.focus(), function() {
    };
  }, [le, w, n]);
  var z = qr(function($e) {
    K ? K($e) : console.error($e);
  }, [K]), Ze = qr(function($e) {
    $e.preventDefault(), $e.persist(), Ot($e), ce.current = [].concat(Jpe(ce.current), [$e.target]), zd($e) && Promise.resolve(i($e)).then(function(Je) {
      if (!(_c($e) && !P)) {
        var qt = Je.length, ft = qt > 0 && Ipe({
          files: Je,
          accept: L,
          minSize: s,
          maxSize: a,
          multiple: o,
          maxFiles: u,
          validator: B
        }), at = qt > 0 && !ft;
        ue({
          isDragAccept: ft,
          isDragReject: at,
          isDragActive: !0,
          type: "setDraggedFiles"
        }), f && f($e);
      }
    }).catch(function(Je) {
      return z(Je);
    });
  }, [i, f, z, P, L, s, a, o, u, B]), Ae = qr(function($e) {
    $e.preventDefault(), $e.persist(), Ot($e);
    var Je = zd($e);
    if (Je && $e.dataTransfer)
      try {
        $e.dataTransfer.dropEffect = "copy";
      } catch {
      }
    return Je && d && d($e), !1;
  }, [d, P]), re = qr(function($e) {
    $e.preventDefault(), $e.persist(), Ot($e);
    var Je = ce.current.filter(function(ft) {
      return le.current && le.current.contains(ft);
    }), qt = Je.indexOf($e.target);
    qt !== -1 && Je.splice(qt, 1), ce.current = Je, !(Je.length > 0) && (ue({
      type: "setDraggedFiles",
      isDragActive: !1,
      isDragAccept: !1,
      isDragReject: !1
    }), zd($e) && l && l($e));
  }, [le, l, P]), Qe = qr(function($e, Je) {
    var qt = [], ft = [];
    $e.forEach(function(at) {
      var rt = nT(at, L), Dt = H1(rt, 2), vr = Dt[0], Qr = Dt[1], un = iT(at, s, a), Nr = H1(un, 2), kr = Nr[0], Jr = Nr[1], Ke = B ? B(at) : null;
      if (vr && kr && !Ke)
        qt.push(at);
      else {
        var Re = [Qr, Jr];
        Ke && (Re = Re.concat(Ke)), ft.push({
          file: at,
          errors: Re.filter(function(ge) {
            return ge;
          })
        });
      }
    }), (!o && qt.length > 1 || o && u >= 1 && qt.length > u) && (qt.forEach(function(at) {
      ft.push({
        file: at,
        errors: [Npe]
      });
    }), qt.splice(0)), ue({
      acceptedFiles: qt,
      fileRejections: ft,
      type: "setFiles"
    }), c && c(qt, ft, Je), ft.length > 0 && v && v(ft, Je), qt.length > 0 && p && p(qt, Je);
  }, [ue, o, L, s, a, u, c, p, v, B]), Ee = qr(function($e) {
    $e.preventDefault(), $e.persist(), Ot($e), ce.current = [], zd($e) && Promise.resolve(i($e)).then(function(Je) {
      _c($e) && !P || Qe(Je, $e);
    }).catch(function(Je) {
      return z(Je);
    }), ue({
      type: "reset"
    });
  }, [i, Qe, z, P]), Ue = qr(function() {
    if (pe.current) {
      ue({
        type: "openDialog"
      }), ne();
      var $e = {
        multiple: o,
        types: _
      };
      window.showOpenFilePicker($e).then(function(Je) {
        return i(Je);
      }).then(function(Je) {
        Qe(Je, null), ue({
          type: "closeDialog"
        });
      }).catch(function(Je) {
        Mpe(Je) ? (Z(Je), ue({
          type: "closeDialog"
        })) : jpe(Je) ? (pe.current = !1, he.current ? (he.current.value = null, he.current.click()) : z(new Error("Cannot open the file picker because the https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API is not supported and no <input> was provided."))) : z(Je);
      });
      return;
    }
    he.current && (ue({
      type: "openDialog"
    }), ne(), he.current.value = null, he.current.click());
  }, [ue, ne, Z, q, Qe, z, _, o]), He = qr(function($e) {
    !le.current || !le.current.isEqualNode($e.target) || ($e.key === " " || $e.key === "Enter" || $e.keyCode === 32 || $e.keyCode === 13) && ($e.preventDefault(), Ue());
  }, [le, Ue]), te = qr(function() {
    ue({
      type: "focus"
    });
  }, []), it = qr(function() {
    ue({
      type: "blur"
    });
  }, []), Vt = qr(function() {
    C || (Bpe() ? setTimeout(Ue, 0) : Ue());
  }, [C, Ue]), Oe = function(Je) {
    return n ? null : Je;
  }, Bt = function(Je) {
    return R ? null : Oe(Je);
  }, mt = function(Je) {
    return I ? null : Oe(Je);
  }, Ot = function(Je) {
    P && Je.stopPropagation();
  }, It = Br(function() {
    return function() {
      var $e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, Je = $e.refKey, qt = Je === void 0 ? "ref" : Je, ft = $e.role, at = $e.onKeyDown, rt = $e.onFocus, Dt = $e.onBlur, vr = $e.onClick, Qr = $e.onDragEnter, un = $e.onDragOver, Nr = $e.onDragLeave, kr = $e.onDrop, Jr = $c($e, Gpe);
      return Er(Er(Mg({
        onKeyDown: Bt(Oi(at, He)),
        onFocus: Bt(Oi(rt, te)),
        onBlur: Bt(Oi(Dt, it)),
        onClick: Oe(Oi(vr, Vt)),
        onDragEnter: mt(Oi(Qr, Ze)),
        onDragOver: mt(Oi(un, Ae)),
        onDragLeave: mt(Oi(Nr, re)),
        onDrop: mt(Oi(kr, Ee)),
        role: typeof ft == "string" && ft !== "" ? ft : "presentation"
      }, qt, le), !n && !R ? {
        tabIndex: 0
      } : {}), Jr);
    };
  }, [le, He, te, it, Vt, Ze, Ae, re, Ee, R, I, n]), Me = qr(function($e) {
    $e.stopPropagation();
  }, []), Gr = Br(function() {
    return function() {
      var $e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, Je = $e.refKey, qt = Je === void 0 ? "ref" : Je, ft = $e.onChange, at = $e.onClick, rt = $c($e, Qpe), Dt = Mg({
        accept: L,
        multiple: o,
        type: "file",
        style: {
          display: "none"
        },
        onChange: Oe(Oi(ft, Ee)),
        onClick: Oe(Oi(at, Me)),
        tabIndex: -1
      }, qt, he);
      return Er(Er({}, Dt), rt);
    };
  }, [he, r, o, Ee, n]);
  return Er(Er({}, ye), {}, {
    isFocused: M && !n,
    getRootProps: It,
    getInputProps: Gr,
    rootRef: le,
    inputRef: he,
    open: Oe(Ue)
  });
}
function ive(e, t) {
  switch (t.type) {
    case "focus":
      return Er(Er({}, e), {}, {
        isFocused: !0
      });
    case "blur":
      return Er(Er({}, e), {}, {
        isFocused: !1
      });
    case "openDialog":
      return Er(Er({}, jg), {}, {
        isFileDialogActive: !0
      });
    case "closeDialog":
      return Er(Er({}, e), {}, {
        isFileDialogActive: !1
      });
    case "setDraggedFiles":
      return Er(Er({}, e), {}, {
        isDragActive: t.isDragActive,
        isDragAccept: t.isDragAccept,
        isDragReject: t.isDragReject
      });
    case "setFiles":
      return Er(Er({}, e), {}, {
        acceptedFiles: t.acceptedFiles,
        fileRejections: t.fileRejections
      });
    case "reset":
      return Er({}, jg);
    default:
      return e;
  }
}
function p6() {
}
const ave = [
  {
    id: "people",
    emojis: [
      "grinning",
      "smiley",
      "smile",
      "grin",
      "laughing",
      "sweat_smile",
      "rolling_on_the_floor_laughing",
      "joy",
      "slightly_smiling_face",
      "upside_down_face",
      "melting_face",
      "wink",
      "blush",
      "innocent",
      "smiling_face_with_3_hearts",
      "heart_eyes",
      "star-struck",
      "kissing_heart",
      "kissing",
      "relaxed",
      "kissing_closed_eyes",
      "kissing_smiling_eyes",
      "smiling_face_with_tear",
      "yum",
      "stuck_out_tongue",
      "stuck_out_tongue_winking_eye",
      "zany_face",
      "stuck_out_tongue_closed_eyes",
      "money_mouth_face",
      "hugging_face",
      "face_with_hand_over_mouth",
      "face_with_open_eyes_and_hand_over_mouth",
      "face_with_peeking_eye",
      "shushing_face",
      "thinking_face",
      "saluting_face",
      "zipper_mouth_face",
      "face_with_raised_eyebrow",
      "neutral_face",
      "expressionless",
      "no_mouth",
      "dotted_line_face",
      "face_in_clouds",
      "smirk",
      "unamused",
      "face_with_rolling_eyes",
      "grimacing",
      "face_exhaling",
      "lying_face",
      "relieved",
      "pensive",
      "sleepy",
      "drooling_face",
      "sleeping",
      "mask",
      "face_with_thermometer",
      "face_with_head_bandage",
      "nauseated_face",
      "face_vomiting",
      "sneezing_face",
      "hot_face",
      "cold_face",
      "woozy_face",
      "dizzy_face",
      "face_with_spiral_eyes",
      "exploding_head",
      "face_with_cowboy_hat",
      "partying_face",
      "disguised_face",
      "sunglasses",
      "nerd_face",
      "face_with_monocle",
      "confused",
      "face_with_diagonal_mouth",
      "worried",
      "slightly_frowning_face",
      "white_frowning_face",
      "open_mouth",
      "hushed",
      "astonished",
      "flushed",
      "pleading_face",
      "face_holding_back_tears",
      "frowning",
      "anguished",
      "fearful",
      "cold_sweat",
      "disappointed_relieved",
      "cry",
      "sob",
      "scream",
      "confounded",
      "persevere",
      "disappointed",
      "sweat",
      "weary",
      "tired_face",
      "yawning_face",
      "triumph",
      "rage",
      "angry",
      "face_with_symbols_on_mouth",
      "smiling_imp",
      "imp",
      "skull",
      "skull_and_crossbones",
      "hankey",
      "clown_face",
      "japanese_ogre",
      "japanese_goblin",
      "ghost",
      "alien",
      "space_invader",
      "robot_face",
      "wave",
      "raised_back_of_hand",
      "raised_hand_with_fingers_splayed",
      "hand",
      "spock-hand",
      "rightwards_hand",
      "leftwards_hand",
      "palm_down_hand",
      "palm_up_hand",
      "ok_hand",
      "pinched_fingers",
      "pinching_hand",
      "v",
      "crossed_fingers",
      "hand_with_index_finger_and_thumb_crossed",
      "i_love_you_hand_sign",
      "the_horns",
      "call_me_hand",
      "point_left",
      "point_right",
      "point_up_2",
      "middle_finger",
      "point_down",
      "point_up",
      "index_pointing_at_the_viewer",
      "+1",
      "-1",
      "fist",
      "facepunch",
      "left-facing_fist",
      "right-facing_fist",
      "clap",
      "raised_hands",
      "heart_hands",
      "open_hands",
      "palms_up_together",
      "handshake",
      "pray",
      "writing_hand",
      "nail_care",
      "selfie",
      "muscle",
      "mechanical_arm",
      "mechanical_leg",
      "leg",
      "foot",
      "ear",
      "ear_with_hearing_aid",
      "nose",
      "brain",
      "anatomical_heart",
      "lungs",
      "tooth",
      "bone",
      "eyes",
      "eye",
      "tongue",
      "lips",
      "biting_lip",
      "baby",
      "child",
      "boy",
      "girl",
      "adult",
      "person_with_blond_hair",
      "man",
      "bearded_person",
      "man_with_beard",
      "woman_with_beard",
      "red_haired_man",
      "curly_haired_man",
      "white_haired_man",
      "bald_man",
      "woman",
      "red_haired_woman",
      "red_haired_person",
      "curly_haired_woman",
      "curly_haired_person",
      "white_haired_woman",
      "white_haired_person",
      "bald_woman",
      "bald_person",
      "blond-haired-woman",
      "blond-haired-man",
      "older_adult",
      "older_man",
      "older_woman",
      "person_frowning",
      "man-frowning",
      "woman-frowning",
      "person_with_pouting_face",
      "man-pouting",
      "woman-pouting",
      "no_good",
      "man-gesturing-no",
      "woman-gesturing-no",
      "ok_woman",
      "man-gesturing-ok",
      "woman-gesturing-ok",
      "information_desk_person",
      "man-tipping-hand",
      "woman-tipping-hand",
      "raising_hand",
      "man-raising-hand",
      "woman-raising-hand",
      "deaf_person",
      "deaf_man",
      "deaf_woman",
      "bow",
      "man-bowing",
      "woman-bowing",
      "face_palm",
      "man-facepalming",
      "woman-facepalming",
      "shrug",
      "man-shrugging",
      "woman-shrugging",
      "health_worker",
      "male-doctor",
      "female-doctor",
      "student",
      "male-student",
      "female-student",
      "teacher",
      "male-teacher",
      "female-teacher",
      "judge",
      "male-judge",
      "female-judge",
      "farmer",
      "male-farmer",
      "female-farmer",
      "cook",
      "male-cook",
      "female-cook",
      "mechanic",
      "male-mechanic",
      "female-mechanic",
      "factory_worker",
      "male-factory-worker",
      "female-factory-worker",
      "office_worker",
      "male-office-worker",
      "female-office-worker",
      "scientist",
      "male-scientist",
      "female-scientist",
      "technologist",
      "male-technologist",
      "female-technologist",
      "singer",
      "male-singer",
      "female-singer",
      "artist",
      "male-artist",
      "female-artist",
      "pilot",
      "male-pilot",
      "female-pilot",
      "astronaut",
      "male-astronaut",
      "female-astronaut",
      "firefighter",
      "male-firefighter",
      "female-firefighter",
      "cop",
      "male-police-officer",
      "female-police-officer",
      "sleuth_or_spy",
      "male-detective",
      "female-detective",
      "guardsman",
      "male-guard",
      "female-guard",
      "ninja",
      "construction_worker",
      "male-construction-worker",
      "female-construction-worker",
      "person_with_crown",
      "prince",
      "princess",
      "man_with_turban",
      "man-wearing-turban",
      "woman-wearing-turban",
      "man_with_gua_pi_mao",
      "person_with_headscarf",
      "person_in_tuxedo",
      "man_in_tuxedo",
      "woman_in_tuxedo",
      "bride_with_veil",
      "man_with_veil",
      "woman_with_veil",
      "pregnant_woman",
      "pregnant_man",
      "pregnant_person",
      "breast-feeding",
      "woman_feeding_baby",
      "man_feeding_baby",
      "person_feeding_baby",
      "angel",
      "santa",
      "mrs_claus",
      "mx_claus",
      "superhero",
      "male_superhero",
      "female_superhero",
      "supervillain",
      "male_supervillain",
      "female_supervillain",
      "mage",
      "male_mage",
      "female_mage",
      "fairy",
      "male_fairy",
      "female_fairy",
      "vampire",
      "male_vampire",
      "female_vampire",
      "merperson",
      "merman",
      "mermaid",
      "elf",
      "male_elf",
      "female_elf",
      "genie",
      "male_genie",
      "female_genie",
      "zombie",
      "male_zombie",
      "female_zombie",
      "troll",
      "massage",
      "man-getting-massage",
      "woman-getting-massage",
      "haircut",
      "man-getting-haircut",
      "woman-getting-haircut",
      "walking",
      "man-walking",
      "woman-walking",
      "standing_person",
      "man_standing",
      "woman_standing",
      "kneeling_person",
      "man_kneeling",
      "woman_kneeling",
      "person_with_probing_cane",
      "man_with_probing_cane",
      "woman_with_probing_cane",
      "person_in_motorized_wheelchair",
      "man_in_motorized_wheelchair",
      "woman_in_motorized_wheelchair",
      "person_in_manual_wheelchair",
      "man_in_manual_wheelchair",
      "woman_in_manual_wheelchair",
      "runner",
      "man-running",
      "woman-running",
      "dancer",
      "man_dancing",
      "man_in_business_suit_levitating",
      "dancers",
      "men-with-bunny-ears-partying",
      "women-with-bunny-ears-partying",
      "person_in_steamy_room",
      "man_in_steamy_room",
      "woman_in_steamy_room",
      "person_climbing",
      "man_climbing",
      "woman_climbing",
      "fencer",
      "horse_racing",
      "skier",
      "snowboarder",
      "golfer",
      "man-golfing",
      "woman-golfing",
      "surfer",
      "man-surfing",
      "woman-surfing",
      "rowboat",
      "man-rowing-boat",
      "woman-rowing-boat",
      "swimmer",
      "man-swimming",
      "woman-swimming",
      "person_with_ball",
      "man-bouncing-ball",
      "woman-bouncing-ball",
      "weight_lifter",
      "man-lifting-weights",
      "woman-lifting-weights",
      "bicyclist",
      "man-biking",
      "woman-biking",
      "mountain_bicyclist",
      "man-mountain-biking",
      "woman-mountain-biking",
      "person_doing_cartwheel",
      "man-cartwheeling",
      "woman-cartwheeling",
      "wrestlers",
      "man-wrestling",
      "woman-wrestling",
      "water_polo",
      "man-playing-water-polo",
      "woman-playing-water-polo",
      "handball",
      "man-playing-handball",
      "woman-playing-handball",
      "juggling",
      "man-juggling",
      "woman-juggling",
      "person_in_lotus_position",
      "man_in_lotus_position",
      "woman_in_lotus_position",
      "bath",
      "sleeping_accommodation",
      "people_holding_hands",
      "two_women_holding_hands",
      "man_and_woman_holding_hands",
      "two_men_holding_hands",
      "couplekiss",
      "woman-kiss-man",
      "man-kiss-man",
      "woman-kiss-woman",
      "couple_with_heart",
      "woman-heart-man",
      "man-heart-man",
      "woman-heart-woman",
      "family",
      "man-woman-boy",
      "man-woman-girl",
      "man-woman-girl-boy",
      "man-woman-boy-boy",
      "man-woman-girl-girl",
      "man-man-boy",
      "man-man-girl",
      "man-man-girl-boy",
      "man-man-boy-boy",
      "man-man-girl-girl",
      "woman-woman-boy",
      "woman-woman-girl",
      "woman-woman-girl-boy",
      "woman-woman-boy-boy",
      "woman-woman-girl-girl",
      "man-boy",
      "man-boy-boy",
      "man-girl",
      "man-girl-boy",
      "man-girl-girl",
      "woman-boy",
      "woman-boy-boy",
      "woman-girl",
      "woman-girl-boy",
      "woman-girl-girl",
      "speaking_head_in_silhouette",
      "bust_in_silhouette",
      "busts_in_silhouette",
      "people_hugging",
      "footprints",
      "smiley_cat",
      "smile_cat",
      "joy_cat",
      "heart_eyes_cat",
      "smirk_cat",
      "kissing_cat",
      "scream_cat",
      "crying_cat_face",
      "pouting_cat",
      "see_no_evil",
      "hear_no_evil",
      "speak_no_evil",
      "kiss",
      "love_letter",
      "cupid",
      "gift_heart",
      "sparkling_heart",
      "heartpulse",
      "heartbeat",
      "revolving_hearts",
      "two_hearts",
      "heart_decoration",
      "heavy_heart_exclamation_mark_ornament",
      "broken_heart",
      "heart_on_fire",
      "mending_heart",
      "heart",
      "orange_heart",
      "yellow_heart",
      "green_heart",
      "blue_heart",
      "purple_heart",
      "brown_heart",
      "black_heart",
      "white_heart",
      "100",
      "anger",
      "boom",
      "dizzy",
      "sweat_drops",
      "dash",
      "hole",
      "bomb",
      "speech_balloon",
      "eye-in-speech-bubble",
      "left_speech_bubble",
      "right_anger_bubble",
      "thought_balloon",
      "zzz"
    ]
  },
  {
    id: "nature",
    emojis: [
      "monkey_face",
      "monkey",
      "gorilla",
      "orangutan",
      "dog",
      "dog2",
      "guide_dog",
      "service_dog",
      "poodle",
      "wolf",
      "fox_face",
      "raccoon",
      "cat",
      "cat2",
      "black_cat",
      "lion_face",
      "tiger",
      "tiger2",
      "leopard",
      "horse",
      "racehorse",
      "unicorn_face",
      "zebra_face",
      "deer",
      "bison",
      "cow",
      "ox",
      "water_buffalo",
      "cow2",
      "pig",
      "pig2",
      "boar",
      "pig_nose",
      "ram",
      "sheep",
      "goat",
      "dromedary_camel",
      "camel",
      "llama",
      "giraffe_face",
      "elephant",
      "mammoth",
      "rhinoceros",
      "hippopotamus",
      "mouse",
      "mouse2",
      "rat",
      "hamster",
      "rabbit",
      "rabbit2",
      "chipmunk",
      "beaver",
      "hedgehog",
      "bat",
      "bear",
      "polar_bear",
      "koala",
      "panda_face",
      "sloth",
      "otter",
      "skunk",
      "kangaroo",
      "badger",
      "feet",
      "turkey",
      "chicken",
      "rooster",
      "hatching_chick",
      "baby_chick",
      "hatched_chick",
      "bird",
      "penguin",
      "dove_of_peace",
      "eagle",
      "duck",
      "swan",
      "owl",
      "dodo",
      "feather",
      "flamingo",
      "peacock",
      "parrot",
      "frog",
      "crocodile",
      "turtle",
      "lizard",
      "snake",
      "dragon_face",
      "dragon",
      "sauropod",
      "t-rex",
      "whale",
      "whale2",
      "dolphin",
      "seal",
      "fish",
      "tropical_fish",
      "blowfish",
      "shark",
      "octopus",
      "shell",
      "coral",
      "snail",
      "butterfly",
      "bug",
      "ant",
      "bee",
      "beetle",
      "ladybug",
      "cricket",
      "cockroach",
      "spider",
      "spider_web",
      "scorpion",
      "mosquito",
      "fly",
      "worm",
      "microbe",
      "bouquet",
      "cherry_blossom",
      "white_flower",
      "lotus",
      "rosette",
      "rose",
      "wilted_flower",
      "hibiscus",
      "sunflower",
      "blossom",
      "tulip",
      "seedling",
      "potted_plant",
      "evergreen_tree",
      "deciduous_tree",
      "palm_tree",
      "cactus",
      "ear_of_rice",
      "herb",
      "shamrock",
      "four_leaf_clover",
      "maple_leaf",
      "fallen_leaf",
      "leaves",
      "empty_nest",
      "nest_with_eggs"
    ]
  },
  {
    id: "foods",
    emojis: [
      "grapes",
      "melon",
      "watermelon",
      "tangerine",
      "lemon",
      "banana",
      "pineapple",
      "mango",
      "apple",
      "green_apple",
      "pear",
      "peach",
      "cherries",
      "strawberry",
      "blueberries",
      "kiwifruit",
      "tomato",
      "olive",
      "coconut",
      "avocado",
      "eggplant",
      "potato",
      "carrot",
      "corn",
      "hot_pepper",
      "bell_pepper",
      "cucumber",
      "leafy_green",
      "broccoli",
      "garlic",
      "onion",
      "mushroom",
      "peanuts",
      "beans",
      "chestnut",
      "bread",
      "croissant",
      "baguette_bread",
      "flatbread",
      "pretzel",
      "bagel",
      "pancakes",
      "waffle",
      "cheese_wedge",
      "meat_on_bone",
      "poultry_leg",
      "cut_of_meat",
      "bacon",
      "hamburger",
      "fries",
      "pizza",
      "hotdog",
      "sandwich",
      "taco",
      "burrito",
      "tamale",
      "stuffed_flatbread",
      "falafel",
      "egg",
      "fried_egg",
      "shallow_pan_of_food",
      "stew",
      "fondue",
      "bowl_with_spoon",
      "green_salad",
      "popcorn",
      "butter",
      "salt",
      "canned_food",
      "bento",
      "rice_cracker",
      "rice_ball",
      "rice",
      "curry",
      "ramen",
      "spaghetti",
      "sweet_potato",
      "oden",
      "sushi",
      "fried_shrimp",
      "fish_cake",
      "moon_cake",
      "dango",
      "dumpling",
      "fortune_cookie",
      "takeout_box",
      "crab",
      "lobster",
      "shrimp",
      "squid",
      "oyster",
      "icecream",
      "shaved_ice",
      "ice_cream",
      "doughnut",
      "cookie",
      "birthday",
      "cake",
      "cupcake",
      "pie",
      "chocolate_bar",
      "candy",
      "lollipop",
      "custard",
      "honey_pot",
      "baby_bottle",
      "glass_of_milk",
      "coffee",
      "teapot",
      "tea",
      "sake",
      "champagne",
      "wine_glass",
      "cocktail",
      "tropical_drink",
      "beer",
      "beers",
      "clinking_glasses",
      "tumbler_glass",
      "pouring_liquid",
      "cup_with_straw",
      "bubble_tea",
      "beverage_box",
      "mate_drink",
      "ice_cube",
      "chopsticks",
      "knife_fork_plate",
      "fork_and_knife",
      "spoon",
      "hocho",
      "jar",
      "amphora"
    ]
  },
  {
    id: "activity",
    emojis: [
      "jack_o_lantern",
      "christmas_tree",
      "fireworks",
      "sparkler",
      "firecracker",
      "sparkles",
      "balloon",
      "tada",
      "confetti_ball",
      "tanabata_tree",
      "bamboo",
      "dolls",
      "flags",
      "wind_chime",
      "rice_scene",
      "red_envelope",
      "ribbon",
      "gift",
      "reminder_ribbon",
      "admission_tickets",
      "ticket",
      "medal",
      "trophy",
      "sports_medal",
      "first_place_medal",
      "second_place_medal",
      "third_place_medal",
      "soccer",
      "baseball",
      "softball",
      "basketball",
      "volleyball",
      "football",
      "rugby_football",
      "tennis",
      "flying_disc",
      "bowling",
      "cricket_bat_and_ball",
      "field_hockey_stick_and_ball",
      "ice_hockey_stick_and_puck",
      "lacrosse",
      "table_tennis_paddle_and_ball",
      "badminton_racquet_and_shuttlecock",
      "boxing_glove",
      "martial_arts_uniform",
      "goal_net",
      "golf",
      "ice_skate",
      "fishing_pole_and_fish",
      "diving_mask",
      "running_shirt_with_sash",
      "ski",
      "sled",
      "curling_stone",
      "dart",
      "yo-yo",
      "kite",
      "8ball",
      "crystal_ball",
      "magic_wand",
      "nazar_amulet",
      "hamsa",
      "video_game",
      "joystick",
      "slot_machine",
      "game_die",
      "jigsaw",
      "teddy_bear",
      "pinata",
      "mirror_ball",
      "nesting_dolls",
      "spades",
      "hearts",
      "diamonds",
      "clubs",
      "chess_pawn",
      "black_joker",
      "mahjong",
      "flower_playing_cards",
      "performing_arts",
      "frame_with_picture",
      "art",
      "thread",
      "sewing_needle",
      "yarn",
      "knot"
    ]
  },
  {
    id: "places",
    emojis: [
      "earth_africa",
      "earth_americas",
      "earth_asia",
      "globe_with_meridians",
      "world_map",
      "japan",
      "compass",
      "snow_capped_mountain",
      "mountain",
      "volcano",
      "mount_fuji",
      "camping",
      "beach_with_umbrella",
      "desert",
      "desert_island",
      "national_park",
      "stadium",
      "classical_building",
      "building_construction",
      "bricks",
      "rock",
      "wood",
      "hut",
      "house_buildings",
      "derelict_house_building",
      "house",
      "house_with_garden",
      "office",
      "post_office",
      "european_post_office",
      "hospital",
      "bank",
      "hotel",
      "love_hotel",
      "convenience_store",
      "school",
      "department_store",
      "factory",
      "japanese_castle",
      "european_castle",
      "wedding",
      "tokyo_tower",
      "statue_of_liberty",
      "church",
      "mosque",
      "hindu_temple",
      "synagogue",
      "shinto_shrine",
      "kaaba",
      "fountain",
      "tent",
      "foggy",
      "night_with_stars",
      "cityscape",
      "sunrise_over_mountains",
      "sunrise",
      "city_sunset",
      "city_sunrise",
      "bridge_at_night",
      "hotsprings",
      "carousel_horse",
      "playground_slide",
      "ferris_wheel",
      "roller_coaster",
      "barber",
      "circus_tent",
      "steam_locomotive",
      "railway_car",
      "bullettrain_side",
      "bullettrain_front",
      "train2",
      "metro",
      "light_rail",
      "station",
      "tram",
      "monorail",
      "mountain_railway",
      "train",
      "bus",
      "oncoming_bus",
      "trolleybus",
      "minibus",
      "ambulance",
      "fire_engine",
      "police_car",
      "oncoming_police_car",
      "taxi",
      "oncoming_taxi",
      "car",
      "oncoming_automobile",
      "blue_car",
      "pickup_truck",
      "truck",
      "articulated_lorry",
      "tractor",
      "racing_car",
      "racing_motorcycle",
      "motor_scooter",
      "manual_wheelchair",
      "motorized_wheelchair",
      "auto_rickshaw",
      "bike",
      "scooter",
      "skateboard",
      "roller_skate",
      "busstop",
      "motorway",
      "railway_track",
      "oil_drum",
      "fuelpump",
      "wheel",
      "rotating_light",
      "traffic_light",
      "vertical_traffic_light",
      "octagonal_sign",
      "construction",
      "anchor",
      "ring_buoy",
      "boat",
      "canoe",
      "speedboat",
      "passenger_ship",
      "ferry",
      "motor_boat",
      "ship",
      "airplane",
      "small_airplane",
      "airplane_departure",
      "airplane_arriving",
      "parachute",
      "seat",
      "helicopter",
      "suspension_railway",
      "mountain_cableway",
      "aerial_tramway",
      "satellite",
      "rocket",
      "flying_saucer",
      "bellhop_bell",
      "luggage",
      "hourglass",
      "hourglass_flowing_sand",
      "watch",
      "alarm_clock",
      "stopwatch",
      "timer_clock",
      "mantelpiece_clock",
      "clock12",
      "clock1230",
      "clock1",
      "clock130",
      "clock2",
      "clock230",
      "clock3",
      "clock330",
      "clock4",
      "clock430",
      "clock5",
      "clock530",
      "clock6",
      "clock630",
      "clock7",
      "clock730",
      "clock8",
      "clock830",
      "clock9",
      "clock930",
      "clock10",
      "clock1030",
      "clock11",
      "clock1130",
      "new_moon",
      "waxing_crescent_moon",
      "first_quarter_moon",
      "moon",
      "full_moon",
      "waning_gibbous_moon",
      "last_quarter_moon",
      "waning_crescent_moon",
      "crescent_moon",
      "new_moon_with_face",
      "first_quarter_moon_with_face",
      "last_quarter_moon_with_face",
      "thermometer",
      "sunny",
      "full_moon_with_face",
      "sun_with_face",
      "ringed_planet",
      "star",
      "star2",
      "stars",
      "milky_way",
      "cloud",
      "partly_sunny",
      "thunder_cloud_and_rain",
      "mostly_sunny",
      "barely_sunny",
      "partly_sunny_rain",
      "rain_cloud",
      "snow_cloud",
      "lightning",
      "tornado",
      "fog",
      "wind_blowing_face",
      "cyclone",
      "rainbow",
      "closed_umbrella",
      "umbrella",
      "umbrella_with_rain_drops",
      "umbrella_on_ground",
      "zap",
      "snowflake",
      "snowman",
      "snowman_without_snow",
      "comet",
      "fire",
      "droplet",
      "ocean"
    ]
  },
  {
    id: "objects",
    emojis: [
      "eyeglasses",
      "dark_sunglasses",
      "goggles",
      "lab_coat",
      "safety_vest",
      "necktie",
      "shirt",
      "jeans",
      "scarf",
      "gloves",
      "coat",
      "socks",
      "dress",
      "kimono",
      "sari",
      "one-piece_swimsuit",
      "briefs",
      "shorts",
      "bikini",
      "womans_clothes",
      "purse",
      "handbag",
      "pouch",
      "shopping_bags",
      "school_satchel",
      "thong_sandal",
      "mans_shoe",
      "athletic_shoe",
      "hiking_boot",
      "womans_flat_shoe",
      "high_heel",
      "sandal",
      "ballet_shoes",
      "boot",
      "crown",
      "womans_hat",
      "tophat",
      "mortar_board",
      "billed_cap",
      "military_helmet",
      "helmet_with_white_cross",
      "prayer_beads",
      "lipstick",
      "ring",
      "gem",
      "mute",
      "speaker",
      "sound",
      "loud_sound",
      "loudspeaker",
      "mega",
      "postal_horn",
      "bell",
      "no_bell",
      "musical_score",
      "musical_note",
      "notes",
      "studio_microphone",
      "level_slider",
      "control_knobs",
      "microphone",
      "headphones",
      "radio",
      "saxophone",
      "accordion",
      "guitar",
      "musical_keyboard",
      "trumpet",
      "violin",
      "banjo",
      "drum_with_drumsticks",
      "long_drum",
      "iphone",
      "calling",
      "phone",
      "telephone_receiver",
      "pager",
      "fax",
      "battery",
      "low_battery",
      "electric_plug",
      "computer",
      "desktop_computer",
      "printer",
      "keyboard",
      "three_button_mouse",
      "trackball",
      "minidisc",
      "floppy_disk",
      "cd",
      "dvd",
      "abacus",
      "movie_camera",
      "film_frames",
      "film_projector",
      "clapper",
      "tv",
      "camera",
      "camera_with_flash",
      "video_camera",
      "vhs",
      "mag",
      "mag_right",
      "candle",
      "bulb",
      "flashlight",
      "izakaya_lantern",
      "diya_lamp",
      "notebook_with_decorative_cover",
      "closed_book",
      "book",
      "green_book",
      "blue_book",
      "orange_book",
      "books",
      "notebook",
      "ledger",
      "page_with_curl",
      "scroll",
      "page_facing_up",
      "newspaper",
      "rolled_up_newspaper",
      "bookmark_tabs",
      "bookmark",
      "label",
      "moneybag",
      "coin",
      "yen",
      "dollar",
      "euro",
      "pound",
      "money_with_wings",
      "credit_card",
      "receipt",
      "chart",
      "email",
      "e-mail",
      "incoming_envelope",
      "envelope_with_arrow",
      "outbox_tray",
      "inbox_tray",
      "package",
      "mailbox",
      "mailbox_closed",
      "mailbox_with_mail",
      "mailbox_with_no_mail",
      "postbox",
      "ballot_box_with_ballot",
      "pencil2",
      "black_nib",
      "lower_left_fountain_pen",
      "lower_left_ballpoint_pen",
      "lower_left_paintbrush",
      "lower_left_crayon",
      "memo",
      "briefcase",
      "file_folder",
      "open_file_folder",
      "card_index_dividers",
      "date",
      "calendar",
      "spiral_note_pad",
      "spiral_calendar_pad",
      "card_index",
      "chart_with_upwards_trend",
      "chart_with_downwards_trend",
      "bar_chart",
      "clipboard",
      "pushpin",
      "round_pushpin",
      "paperclip",
      "linked_paperclips",
      "straight_ruler",
      "triangular_ruler",
      "scissors",
      "card_file_box",
      "file_cabinet",
      "wastebasket",
      "lock",
      "unlock",
      "lock_with_ink_pen",
      "closed_lock_with_key",
      "key",
      "old_key",
      "hammer",
      "axe",
      "pick",
      "hammer_and_pick",
      "hammer_and_wrench",
      "dagger_knife",
      "crossed_swords",
      "gun",
      "boomerang",
      "bow_and_arrow",
      "shield",
      "carpentry_saw",
      "wrench",
      "screwdriver",
      "nut_and_bolt",
      "gear",
      "compression",
      "scales",
      "probing_cane",
      "link",
      "chains",
      "hook",
      "toolbox",
      "magnet",
      "ladder",
      "alembic",
      "test_tube",
      "petri_dish",
      "dna",
      "microscope",
      "telescope",
      "satellite_antenna",
      "syringe",
      "drop_of_blood",
      "pill",
      "adhesive_bandage",
      "crutch",
      "stethoscope",
      "x-ray",
      "door",
      "elevator",
      "mirror",
      "window",
      "bed",
      "couch_and_lamp",
      "chair",
      "toilet",
      "plunger",
      "shower",
      "bathtub",
      "mouse_trap",
      "razor",
      "lotion_bottle",
      "safety_pin",
      "broom",
      "basket",
      "roll_of_paper",
      "bucket",
      "soap",
      "bubbles",
      "toothbrush",
      "sponge",
      "fire_extinguisher",
      "shopping_trolley",
      "smoking",
      "coffin",
      "headstone",
      "funeral_urn",
      "moyai",
      "placard",
      "identification_card"
    ]
  },
  {
    id: "symbols",
    emojis: [
      "atm",
      "put_litter_in_its_place",
      "potable_water",
      "wheelchair",
      "mens",
      "womens",
      "restroom",
      "baby_symbol",
      "wc",
      "passport_control",
      "customs",
      "baggage_claim",
      "left_luggage",
      "warning",
      "children_crossing",
      "no_entry",
      "no_entry_sign",
      "no_bicycles",
      "no_smoking",
      "do_not_litter",
      "non-potable_water",
      "no_pedestrians",
      "no_mobile_phones",
      "underage",
      "radioactive_sign",
      "biohazard_sign",
      "arrow_up",
      "arrow_upper_right",
      "arrow_right",
      "arrow_lower_right",
      "arrow_down",
      "arrow_lower_left",
      "arrow_left",
      "arrow_upper_left",
      "arrow_up_down",
      "left_right_arrow",
      "leftwards_arrow_with_hook",
      "arrow_right_hook",
      "arrow_heading_up",
      "arrow_heading_down",
      "arrows_clockwise",
      "arrows_counterclockwise",
      "back",
      "end",
      "on",
      "soon",
      "top",
      "place_of_worship",
      "atom_symbol",
      "om_symbol",
      "star_of_david",
      "wheel_of_dharma",
      "yin_yang",
      "latin_cross",
      "orthodox_cross",
      "star_and_crescent",
      "peace_symbol",
      "menorah_with_nine_branches",
      "six_pointed_star",
      "aries",
      "taurus",
      "gemini",
      "cancer",
      "leo",
      "virgo",
      "libra",
      "scorpius",
      "sagittarius",
      "capricorn",
      "aquarius",
      "pisces",
      "ophiuchus",
      "twisted_rightwards_arrows",
      "repeat",
      "repeat_one",
      "arrow_forward",
      "fast_forward",
      "black_right_pointing_double_triangle_with_vertical_bar",
      "black_right_pointing_triangle_with_double_vertical_bar",
      "arrow_backward",
      "rewind",
      "black_left_pointing_double_triangle_with_vertical_bar",
      "arrow_up_small",
      "arrow_double_up",
      "arrow_down_small",
      "arrow_double_down",
      "double_vertical_bar",
      "black_square_for_stop",
      "black_circle_for_record",
      "eject",
      "cinema",
      "low_brightness",
      "high_brightness",
      "signal_strength",
      "vibration_mode",
      "mobile_phone_off",
      "female_sign",
      "male_sign",
      "transgender_symbol",
      "heavy_multiplication_x",
      "heavy_plus_sign",
      "heavy_minus_sign",
      "heavy_division_sign",
      "heavy_equals_sign",
      "infinity",
      "bangbang",
      "interrobang",
      "question",
      "grey_question",
      "grey_exclamation",
      "exclamation",
      "wavy_dash",
      "currency_exchange",
      "heavy_dollar_sign",
      "medical_symbol",
      "recycle",
      "fleur_de_lis",
      "trident",
      "name_badge",
      "beginner",
      "o",
      "white_check_mark",
      "ballot_box_with_check",
      "heavy_check_mark",
      "x",
      "negative_squared_cross_mark",
      "curly_loop",
      "loop",
      "part_alternation_mark",
      "eight_spoked_asterisk",
      "eight_pointed_black_star",
      "sparkle",
      "copyright",
      "registered",
      "tm",
      "hash",
      "keycap_star",
      "zero",
      "one",
      "two",
      "three",
      "four",
      "five",
      "six",
      "seven",
      "eight",
      "nine",
      "keycap_ten",
      "capital_abcd",
      "abcd",
      "1234",
      "symbols",
      "abc",
      "a",
      "ab",
      "b",
      "cl",
      "cool",
      "free",
      "information_source",
      "id",
      "m",
      "new",
      "ng",
      "o2",
      "ok",
      "parking",
      "sos",
      "up",
      "vs",
      "koko",
      "sa",
      "u6708",
      "u6709",
      "u6307",
      "ideograph_advantage",
      "u5272",
      "u7121",
      "u7981",
      "accept",
      "u7533",
      "u5408",
      "u7a7a",
      "congratulations",
      "secret",
      "u55b6",
      "u6e80",
      "red_circle",
      "large_orange_circle",
      "large_yellow_circle",
      "large_green_circle",
      "large_blue_circle",
      "large_purple_circle",
      "large_brown_circle",
      "black_circle",
      "white_circle",
      "large_red_square",
      "large_orange_square",
      "large_yellow_square",
      "large_green_square",
      "large_blue_square",
      "large_purple_square",
      "large_brown_square",
      "black_large_square",
      "white_large_square",
      "black_medium_square",
      "white_medium_square",
      "black_medium_small_square",
      "white_medium_small_square",
      "black_small_square",
      "white_small_square",
      "large_orange_diamond",
      "large_blue_diamond",
      "small_orange_diamond",
      "small_blue_diamond",
      "small_red_triangle",
      "small_red_triangle_down",
      "diamond_shape_with_a_dot_inside",
      "radio_button",
      "white_square_button",
      "black_square_button"
    ]
  },
  {
    id: "flags",
    emojis: [
      "checkered_flag",
      "cn",
      "crossed_flags",
      "de",
      "es",
      "flag-ac",
      "flag-ad",
      "flag-ae",
      "flag-af",
      "flag-ag",
      "flag-ai",
      "flag-al",
      "flag-am",
      "flag-ao",
      "flag-aq",
      "flag-ar",
      "flag-as",
      "flag-at",
      "flag-au",
      "flag-aw",
      "flag-ax",
      "flag-az",
      "flag-ba",
      "flag-bb",
      "flag-bd",
      "flag-be",
      "flag-bf",
      "flag-bg",
      "flag-bh",
      "flag-bi",
      "flag-bj",
      "flag-bl",
      "flag-bm",
      "flag-bn",
      "flag-bo",
      "flag-bq",
      "flag-br",
      "flag-bs",
      "flag-bt",
      "flag-bv",
      "flag-bw",
      "flag-by",
      "flag-bz",
      "flag-ca",
      "flag-cc",
      "flag-cd",
      "flag-cf",
      "flag-cg",
      "flag-ch",
      "flag-ci",
      "flag-ck",
      "flag-cl",
      "flag-cm",
      "flag-co",
      "flag-cp",
      "flag-cr",
      "flag-cu",
      "flag-cv",
      "flag-cw",
      "flag-cx",
      "flag-cy",
      "flag-cz",
      "flag-dg",
      "flag-dj",
      "flag-dk",
      "flag-dm",
      "flag-do",
      "flag-dz",
      "flag-ea",
      "flag-ec",
      "flag-ee",
      "flag-eg",
      "flag-eh",
      "flag-england",
      "flag-er",
      "flag-et",
      "flag-eu",
      "flag-fi",
      "flag-fj",
      "flag-fk",
      "flag-fm",
      "flag-fo",
      "flag-ga",
      "flag-gd",
      "flag-ge",
      "flag-gf",
      "flag-gg",
      "flag-gh",
      "flag-gi",
      "flag-gl",
      "flag-gm",
      "flag-gn",
      "flag-gp",
      "flag-gq",
      "flag-gr",
      "flag-gs",
      "flag-gt",
      "flag-gu",
      "flag-gw",
      "flag-gy",
      "flag-hk",
      "flag-hm",
      "flag-hn",
      "flag-hr",
      "flag-ht",
      "flag-hu",
      "flag-ic",
      "flag-id",
      "flag-ie",
      "flag-il",
      "flag-im",
      "flag-in",
      "flag-io",
      "flag-iq",
      "flag-ir",
      "flag-is",
      "flag-je",
      "flag-jm",
      "flag-jo",
      "flag-ke",
      "flag-kg",
      "flag-kh",
      "flag-ki",
      "flag-km",
      "flag-kn",
      "flag-kp",
      "flag-kw",
      "flag-ky",
      "flag-kz",
      "flag-la",
      "flag-lb",
      "flag-lc",
      "flag-li",
      "flag-lk",
      "flag-lr",
      "flag-ls",
      "flag-lt",
      "flag-lu",
      "flag-lv",
      "flag-ly",
      "flag-ma",
      "flag-mc",
      "flag-md",
      "flag-me",
      "flag-mf",
      "flag-mg",
      "flag-mh",
      "flag-mk",
      "flag-ml",
      "flag-mm",
      "flag-mn",
      "flag-mo",
      "flag-mp",
      "flag-mq",
      "flag-mr",
      "flag-ms",
      "flag-mt",
      "flag-mu",
      "flag-mv",
      "flag-mw",
      "flag-mx",
      "flag-my",
      "flag-mz",
      "flag-na",
      "flag-nc",
      "flag-ne",
      "flag-nf",
      "flag-ng",
      "flag-ni",
      "flag-nl",
      "flag-no",
      "flag-np",
      "flag-nr",
      "flag-nu",
      "flag-nz",
      "flag-om",
      "flag-pa",
      "flag-pe",
      "flag-pf",
      "flag-pg",
      "flag-ph",
      "flag-pk",
      "flag-pl",
      "flag-pm",
      "flag-pn",
      "flag-pr",
      "flag-ps",
      "flag-pt",
      "flag-pw",
      "flag-py",
      "flag-qa",
      "flag-re",
      "flag-ro",
      "flag-rs",
      "flag-rw",
      "flag-sa",
      "flag-sb",
      "flag-sc",
      "flag-scotland",
      "flag-sd",
      "flag-se",
      "flag-sg",
      "flag-sh",
      "flag-si",
      "flag-sj",
      "flag-sk",
      "flag-sl",
      "flag-sm",
      "flag-sn",
      "flag-so",
      "flag-sr",
      "flag-ss",
      "flag-st",
      "flag-sv",
      "flag-sx",
      "flag-sy",
      "flag-sz",
      "flag-ta",
      "flag-tc",
      "flag-td",
      "flag-tf",
      "flag-tg",
      "flag-th",
      "flag-tj",
      "flag-tk",
      "flag-tl",
      "flag-tm",
      "flag-tn",
      "flag-to",
      "flag-tr",
      "flag-tt",
      "flag-tv",
      "flag-tw",
      "flag-tz",
      "flag-ua",
      "flag-ug",
      "flag-um",
      "flag-un",
      "flag-uy",
      "flag-uz",
      "flag-va",
      "flag-vc",
      "flag-ve",
      "flag-vg",
      "flag-vi",
      "flag-vn",
      "flag-vu",
      "flag-wales",
      "flag-wf",
      "flag-ws",
      "flag-xk",
      "flag-ye",
      "flag-yt",
      "flag-za",
      "flag-zm",
      "flag-zw",
      "fr",
      "gb",
      "it",
      "jp",
      "kr",
      "pirate_flag",
      "rainbow-flag",
      "ru",
      "transgender_flag",
      "triangular_flag_on_post",
      "us",
      "waving_black_flag",
      "waving_white_flag"
    ]
  }
], sve = {
  100: {
    id: "100",
    name: "Hundred Points",
    keywords: [
      "100",
      "score",
      "perfect",
      "numbers",
      "century",
      "exam",
      "quiz",
      "test",
      "pass"
    ],
    skins: [
      {
        unified: "1f4af",
        native: "💯"
      }
    ],
    version: 1
  },
  1234: {
    id: "1234",
    name: "Input Numbers",
    keywords: [
      "1234",
      "blue",
      "square"
    ],
    skins: [
      {
        unified: "1f522",
        native: "🔢"
      }
    ],
    version: 1
  },
  grinning: {
    id: "grinning",
    name: "Grinning Face",
    emoticons: [
      ":D"
    ],
    keywords: [
      "smile",
      "happy",
      "joy",
      ":D",
      "grin"
    ],
    skins: [
      {
        unified: "1f600",
        native: "😀"
      }
    ],
    version: 1
  },
  smiley: {
    id: "smiley",
    name: "Grinning Face with Big Eyes",
    emoticons: [
      ":)",
      "=)",
      "=-)"
    ],
    keywords: [
      "smiley",
      "happy",
      "joy",
      "haha",
      ":D",
      ":)",
      "smile",
      "funny"
    ],
    skins: [
      {
        unified: "1f603",
        native: "😃"
      }
    ],
    version: 1
  },
  smile: {
    id: "smile",
    name: "Grinning Face with Smiling Eyes",
    emoticons: [
      ":)",
      "C:",
      "c:",
      ":D",
      ":-D"
    ],
    keywords: [
      "smile",
      "happy",
      "joy",
      "funny",
      "haha",
      "laugh",
      "like",
      ":D",
      ":)"
    ],
    skins: [
      {
        unified: "1f604",
        native: "😄"
      }
    ],
    version: 1
  },
  grin: {
    id: "grin",
    name: "Beaming Face with Smiling Eyes",
    keywords: [
      "grin",
      "happy",
      "smile",
      "joy",
      "kawaii"
    ],
    skins: [
      {
        unified: "1f601",
        native: "😁"
      }
    ],
    version: 1
  },
  laughing: {
    id: "laughing",
    name: "Grinning Squinting Face",
    emoticons: [
      ":>",
      ":->"
    ],
    keywords: [
      "laughing",
      "satisfied",
      "happy",
      "joy",
      "lol",
      "haha",
      "glad",
      "XD",
      "laugh"
    ],
    skins: [
      {
        unified: "1f606",
        native: "😆"
      }
    ],
    version: 1
  },
  sweat_smile: {
    id: "sweat_smile",
    name: "Grinning Face with Sweat",
    keywords: [
      "smile",
      "hot",
      "happy",
      "laugh",
      "relief"
    ],
    skins: [
      {
        unified: "1f605",
        native: "😅"
      }
    ],
    version: 1
  },
  rolling_on_the_floor_laughing: {
    id: "rolling_on_the_floor_laughing",
    name: "Rolling on the Floor Laughing",
    keywords: [
      "face",
      "lol",
      "haha",
      "rofl"
    ],
    skins: [
      {
        unified: "1f923",
        native: "🤣"
      }
    ],
    version: 3
  },
  joy: {
    id: "joy",
    name: "Face with Tears of Joy",
    keywords: [
      "cry",
      "weep",
      "happy",
      "happytears",
      "haha"
    ],
    skins: [
      {
        unified: "1f602",
        native: "😂"
      }
    ],
    version: 1
  },
  slightly_smiling_face: {
    id: "slightly_smiling_face",
    name: "Slightly Smiling Face",
    emoticons: [
      ":)",
      "(:",
      ":-)"
    ],
    keywords: [
      "smile"
    ],
    skins: [
      {
        unified: "1f642",
        native: "🙂"
      }
    ],
    version: 1
  },
  upside_down_face: {
    id: "upside_down_face",
    name: "Upside-Down Face",
    keywords: [
      "upside",
      "down",
      "flipped",
      "silly",
      "smile"
    ],
    skins: [
      {
        unified: "1f643",
        native: "🙃"
      }
    ],
    version: 1
  },
  melting_face: {
    id: "melting_face",
    name: "Melting Face",
    keywords: [
      "hot",
      "heat"
    ],
    skins: [
      {
        unified: "1fae0",
        native: "🫠"
      }
    ],
    version: 14
  },
  wink: {
    id: "wink",
    name: "Winking Face",
    emoticons: [
      ";)",
      ";-)"
    ],
    keywords: [
      "wink",
      "happy",
      "mischievous",
      "secret",
      ";)",
      "smile",
      "eye"
    ],
    skins: [
      {
        unified: "1f609",
        native: "😉"
      }
    ],
    version: 1
  },
  blush: {
    id: "blush",
    name: "Smiling Face with Smiling Eyes",
    emoticons: [
      ":)"
    ],
    keywords: [
      "blush",
      "smile",
      "happy",
      "flushed",
      "crush",
      "embarrassed",
      "shy",
      "joy"
    ],
    skins: [
      {
        unified: "1f60a",
        native: "😊"
      }
    ],
    version: 1
  },
  innocent: {
    id: "innocent",
    name: "Smiling Face with Halo",
    keywords: [
      "innocent",
      "angel",
      "heaven"
    ],
    skins: [
      {
        unified: "1f607",
        native: "😇"
      }
    ],
    version: 1
  },
  smiling_face_with_3_hearts: {
    id: "smiling_face_with_3_hearts",
    name: "Smiling Face with Hearts",
    keywords: [
      "3",
      "love",
      "like",
      "affection",
      "valentines",
      "infatuation",
      "crush",
      "adore"
    ],
    skins: [
      {
        unified: "1f970",
        native: "🥰"
      }
    ],
    version: 11
  },
  heart_eyes: {
    id: "heart_eyes",
    name: "Smiling Face with Heart-Eyes",
    keywords: [
      "heart",
      "eyes",
      "love",
      "like",
      "affection",
      "valentines",
      "infatuation",
      "crush"
    ],
    skins: [
      {
        unified: "1f60d",
        native: "😍"
      }
    ],
    version: 1
  },
  "star-struck": {
    id: "star-struck",
    name: "Star-Struck",
    keywords: [
      "star",
      "struck",
      "grinning",
      "face",
      "with",
      "eyes",
      "smile",
      "starry"
    ],
    skins: [
      {
        unified: "1f929",
        native: "🤩"
      }
    ],
    version: 5
  },
  kissing_heart: {
    id: "kissing_heart",
    name: "Face Blowing a Kiss",
    emoticons: [
      ":*",
      ":-*"
    ],
    keywords: [
      "kissing",
      "heart",
      "love",
      "like",
      "affection",
      "valentines",
      "infatuation"
    ],
    skins: [
      {
        unified: "1f618",
        native: "😘"
      }
    ],
    version: 1
  },
  kissing: {
    id: "kissing",
    name: "Kissing Face",
    keywords: [
      "love",
      "like",
      "3",
      "valentines",
      "infatuation",
      "kiss"
    ],
    skins: [
      {
        unified: "1f617",
        native: "😗"
      }
    ],
    version: 1
  },
  relaxed: {
    id: "relaxed",
    name: "Smiling Face",
    keywords: [
      "relaxed",
      "blush",
      "massage",
      "happiness"
    ],
    skins: [
      {
        unified: "263a-fe0f",
        native: "☺️"
      }
    ],
    version: 1
  },
  kissing_closed_eyes: {
    id: "kissing_closed_eyes",
    name: "Kissing Face with Closed Eyes",
    keywords: [
      "love",
      "like",
      "affection",
      "valentines",
      "infatuation",
      "kiss"
    ],
    skins: [
      {
        unified: "1f61a",
        native: "😚"
      }
    ],
    version: 1
  },
  kissing_smiling_eyes: {
    id: "kissing_smiling_eyes",
    name: "Kissing Face with Smiling Eyes",
    keywords: [
      "affection",
      "valentines",
      "infatuation",
      "kiss"
    ],
    skins: [
      {
        unified: "1f619",
        native: "😙"
      }
    ],
    version: 1
  },
  smiling_face_with_tear: {
    id: "smiling_face_with_tear",
    name: "Smiling Face with Tear",
    keywords: [
      "sad",
      "cry",
      "pretend"
    ],
    skins: [
      {
        unified: "1f972",
        native: "🥲"
      }
    ],
    version: 13
  },
  yum: {
    id: "yum",
    name: "Face Savoring Food",
    keywords: [
      "yum",
      "happy",
      "joy",
      "tongue",
      "smile",
      "silly",
      "yummy",
      "nom",
      "delicious",
      "savouring"
    ],
    skins: [
      {
        unified: "1f60b",
        native: "😋"
      }
    ],
    version: 1
  },
  stuck_out_tongue: {
    id: "stuck_out_tongue",
    name: "Face with Tongue",
    emoticons: [
      ":p",
      ":-p",
      ":P",
      ":-P",
      ":b",
      ":-b"
    ],
    keywords: [
      "stuck",
      "out",
      "prank",
      "childish",
      "playful",
      "mischievous",
      "smile"
    ],
    skins: [
      {
        unified: "1f61b",
        native: "😛"
      }
    ],
    version: 1
  },
  stuck_out_tongue_winking_eye: {
    id: "stuck_out_tongue_winking_eye",
    name: "Winking Face with Tongue",
    emoticons: [
      ";p",
      ";-p",
      ";b",
      ";-b",
      ";P",
      ";-P"
    ],
    keywords: [
      "stuck",
      "out",
      "eye",
      "prank",
      "childish",
      "playful",
      "mischievous",
      "smile",
      "wink"
    ],
    skins: [
      {
        unified: "1f61c",
        native: "😜"
      }
    ],
    version: 1
  },
  zany_face: {
    id: "zany_face",
    name: "Zany Face",
    keywords: [
      "grinning",
      "with",
      "one",
      "large",
      "and",
      "small",
      "eye",
      "goofy",
      "crazy"
    ],
    skins: [
      {
        unified: "1f92a",
        native: "🤪"
      }
    ],
    version: 5
  },
  stuck_out_tongue_closed_eyes: {
    id: "stuck_out_tongue_closed_eyes",
    name: "Squinting Face with Tongue",
    keywords: [
      "stuck",
      "out",
      "closed",
      "eyes",
      "prank",
      "playful",
      "mischievous",
      "smile"
    ],
    skins: [
      {
        unified: "1f61d",
        native: "😝"
      }
    ],
    version: 1
  },
  money_mouth_face: {
    id: "money_mouth_face",
    name: "Money-Mouth Face",
    keywords: [
      "money",
      "mouth",
      "rich",
      "dollar"
    ],
    skins: [
      {
        unified: "1f911",
        native: "🤑"
      }
    ],
    version: 1
  },
  hugging_face: {
    id: "hugging_face",
    name: "Hugging Face",
    keywords: [
      "smile",
      "hug"
    ],
    skins: [
      {
        unified: "1f917",
        native: "🤗"
      }
    ],
    version: 1
  },
  face_with_hand_over_mouth: {
    id: "face_with_hand_over_mouth",
    name: "Face with Hand over Mouth",
    keywords: [
      "smiling",
      "eyes",
      "and",
      "covering",
      "whoops",
      "shock",
      "surprise"
    ],
    skins: [
      {
        unified: "1f92d",
        native: "🤭"
      }
    ],
    version: 5
  },
  face_with_open_eyes_and_hand_over_mouth: {
    id: "face_with_open_eyes_and_hand_over_mouth",
    name: "Face with Open Eyes and Hand over Mouth",
    keywords: [
      "silence",
      "secret",
      "shock",
      "surprise"
    ],
    skins: [
      {
        unified: "1fae2",
        native: "🫢"
      }
    ],
    version: 14
  },
  face_with_peeking_eye: {
    id: "face_with_peeking_eye",
    name: "Face with Peeking Eye",
    keywords: [
      "scared",
      "frightening",
      "embarrassing"
    ],
    skins: [
      {
        unified: "1fae3",
        native: "🫣"
      }
    ],
    version: 14
  },
  shushing_face: {
    id: "shushing_face",
    name: "Shushing Face",
    keywords: [
      "with",
      "finger",
      "covering",
      "closed",
      "lips",
      "quiet",
      "shhh"
    ],
    skins: [
      {
        unified: "1f92b",
        native: "🤫"
      }
    ],
    version: 5
  },
  thinking_face: {
    id: "thinking_face",
    name: "Thinking Face",
    keywords: [
      "hmmm",
      "think",
      "consider"
    ],
    skins: [
      {
        unified: "1f914",
        native: "🤔"
      }
    ],
    version: 1
  },
  saluting_face: {
    id: "saluting_face",
    name: "Saluting Face",
    keywords: [
      "respect",
      "salute"
    ],
    skins: [
      {
        unified: "1fae1",
        native: "🫡"
      }
    ],
    version: 14
  },
  zipper_mouth_face: {
    id: "zipper_mouth_face",
    name: "Zipper-Mouth Face",
    keywords: [
      "zipper",
      "mouth",
      "sealed",
      "secret"
    ],
    skins: [
      {
        unified: "1f910",
        native: "🤐"
      }
    ],
    version: 1
  },
  face_with_raised_eyebrow: {
    id: "face_with_raised_eyebrow",
    name: "Face with Raised Eyebrow",
    keywords: [
      "one",
      "distrust",
      "scepticism",
      "disapproval",
      "disbelief",
      "surprise"
    ],
    skins: [
      {
        unified: "1f928",
        native: "🤨"
      }
    ],
    version: 5
  },
  neutral_face: {
    id: "neutral_face",
    name: "Neutral Face",
    emoticons: [
      ":|",
      ":-|"
    ],
    keywords: [
      "indifference",
      "meh",
      ":",
      ""
    ],
    skins: [
      {
        unified: "1f610",
        native: "😐"
      }
    ],
    version: 1
  },
  expressionless: {
    id: "expressionless",
    name: "Expressionless Face",
    emoticons: [
      "-_-"
    ],
    keywords: [
      "indifferent",
      "-",
      "",
      "meh",
      "deadpan"
    ],
    skins: [
      {
        unified: "1f611",
        native: "😑"
      }
    ],
    version: 1
  },
  no_mouth: {
    id: "no_mouth",
    name: "Face Without Mouth",
    keywords: [
      "no",
      "hellokitty"
    ],
    skins: [
      {
        unified: "1f636",
        native: "😶"
      }
    ],
    version: 1
  },
  dotted_line_face: {
    id: "dotted_line_face",
    name: "Dotted Line Face",
    keywords: [
      "invisible",
      "lonely",
      "isolation",
      "depression"
    ],
    skins: [
      {
        unified: "1fae5",
        native: "🫥"
      }
    ],
    version: 14
  },
  face_in_clouds: {
    id: "face_in_clouds",
    name: "Face in Clouds",
    keywords: [
      "shower",
      "steam",
      "dream"
    ],
    skins: [
      {
        unified: "1f636-200d-1f32b-fe0f",
        native: "😶‍🌫️"
      }
    ],
    version: 13.1
  },
  smirk: {
    id: "smirk",
    name: "Smirking Face",
    keywords: [
      "smirk",
      "smile",
      "mean",
      "prank",
      "smug",
      "sarcasm"
    ],
    skins: [
      {
        unified: "1f60f",
        native: "😏"
      }
    ],
    version: 1
  },
  unamused: {
    id: "unamused",
    name: "Unamused Face",
    emoticons: [
      ":("
    ],
    keywords: [
      "indifference",
      "bored",
      "straight",
      "serious",
      "sarcasm",
      "unimpressed",
      "skeptical",
      "dubious",
      "side",
      "eye"
    ],
    skins: [
      {
        unified: "1f612",
        native: "😒"
      }
    ],
    version: 1
  },
  face_with_rolling_eyes: {
    id: "face_with_rolling_eyes",
    name: "Face with Rolling Eyes",
    keywords: [
      "eyeroll",
      "frustrated"
    ],
    skins: [
      {
        unified: "1f644",
        native: "🙄"
      }
    ],
    version: 1
  },
  grimacing: {
    id: "grimacing",
    name: "Grimacing Face",
    keywords: [
      "grimace",
      "teeth"
    ],
    skins: [
      {
        unified: "1f62c",
        native: "😬"
      }
    ],
    version: 1
  },
  face_exhaling: {
    id: "face_exhaling",
    name: "Face Exhaling",
    keywords: [
      "relieve",
      "relief",
      "tired",
      "sigh"
    ],
    skins: [
      {
        unified: "1f62e-200d-1f4a8",
        native: "😮‍💨"
      }
    ],
    version: 13.1
  },
  lying_face: {
    id: "lying_face",
    name: "Lying Face",
    keywords: [
      "lie",
      "pinocchio"
    ],
    skins: [
      {
        unified: "1f925",
        native: "🤥"
      }
    ],
    version: 3
  },
  relieved: {
    id: "relieved",
    name: "Relieved Face",
    keywords: [
      "relaxed",
      "phew",
      "massage",
      "happiness"
    ],
    skins: [
      {
        unified: "1f60c",
        native: "😌"
      }
    ],
    version: 1
  },
  pensive: {
    id: "pensive",
    name: "Pensive Face",
    keywords: [
      "sad",
      "depressed",
      "upset"
    ],
    skins: [
      {
        unified: "1f614",
        native: "😔"
      }
    ],
    version: 1
  },
  sleepy: {
    id: "sleepy",
    name: "Sleepy Face",
    keywords: [
      "tired",
      "rest",
      "nap"
    ],
    skins: [
      {
        unified: "1f62a",
        native: "😪"
      }
    ],
    version: 1
  },
  drooling_face: {
    id: "drooling_face",
    name: "Drooling Face",
    keywords: [],
    skins: [
      {
        unified: "1f924",
        native: "🤤"
      }
    ],
    version: 3
  },
  sleeping: {
    id: "sleeping",
    name: "Sleeping Face",
    keywords: [
      "tired",
      "sleepy",
      "night",
      "zzz"
    ],
    skins: [
      {
        unified: "1f634",
        native: "😴"
      }
    ],
    version: 1
  },
  mask: {
    id: "mask",
    name: "Face with Medical Mask",
    keywords: [
      "sick",
      "ill",
      "disease"
    ],
    skins: [
      {
        unified: "1f637",
        native: "😷"
      }
    ],
    version: 1
  },
  face_with_thermometer: {
    id: "face_with_thermometer",
    name: "Face with Thermometer",
    keywords: [
      "sick",
      "temperature",
      "cold",
      "fever"
    ],
    skins: [
      {
        unified: "1f912",
        native: "🤒"
      }
    ],
    version: 1
  },
  face_with_head_bandage: {
    id: "face_with_head_bandage",
    name: "Face with Head-Bandage",
    keywords: [
      "head",
      "bandage",
      "injured",
      "clumsy",
      "hurt"
    ],
    skins: [
      {
        unified: "1f915",
        native: "🤕"
      }
    ],
    version: 1
  },
  nauseated_face: {
    id: "nauseated_face",
    name: "Nauseated Face",
    keywords: [
      "vomit",
      "gross",
      "green",
      "sick",
      "throw",
      "up",
      "ill"
    ],
    skins: [
      {
        unified: "1f922",
        native: "🤢"
      }
    ],
    version: 3
  },
  face_vomiting: {
    id: "face_vomiting",
    name: "Face Vomiting",
    keywords: [
      "with",
      "open",
      "mouth",
      "sick"
    ],
    skins: [
      {
        unified: "1f92e",
        native: "🤮"
      }
    ],
    version: 5
  },
  sneezing_face: {
    id: "sneezing_face",
    name: "Sneezing Face",
    keywords: [
      "gesundheit",
      "sneeze",
      "sick",
      "allergy"
    ],
    skins: [
      {
        unified: "1f927",
        native: "🤧"
      }
    ],
    version: 3
  },
  hot_face: {
    id: "hot_face",
    name: "Hot Face",
    keywords: [
      "feverish",
      "heat",
      "red",
      "sweating"
    ],
    skins: [
      {
        unified: "1f975",
        native: "🥵"
      }
    ],
    version: 11
  },
  cold_face: {
    id: "cold_face",
    name: "Cold Face",
    keywords: [
      "blue",
      "freezing",
      "frozen",
      "frostbite",
      "icicles"
    ],
    skins: [
      {
        unified: "1f976",
        native: "🥶"
      }
    ],
    version: 11
  },
  woozy_face: {
    id: "woozy_face",
    name: "Woozy Face",
    keywords: [
      "dizzy",
      "intoxicated",
      "tipsy",
      "wavy"
    ],
    skins: [
      {
        unified: "1f974",
        native: "🥴"
      }
    ],
    version: 11
  },
  dizzy_face: {
    id: "dizzy_face",
    name: "Dizzy Face",
    keywords: [
      "spent",
      "unconscious",
      "xox"
    ],
    skins: [
      {
        unified: "1f635",
        native: "😵"
      }
    ],
    version: 1
  },
  face_with_spiral_eyes: {
    id: "face_with_spiral_eyes",
    name: "Face with Spiral Eyes",
    keywords: [
      "sick",
      "ill",
      "confused",
      "nauseous",
      "nausea"
    ],
    skins: [
      {
        unified: "1f635-200d-1f4ab",
        native: "😵‍💫"
      }
    ],
    version: 13.1
  },
  exploding_head: {
    id: "exploding_head",
    name: "Exploding Head",
    keywords: [
      "shocked",
      "face",
      "with",
      "mind",
      "blown"
    ],
    skins: [
      {
        unified: "1f92f",
        native: "🤯"
      }
    ],
    version: 5
  },
  face_with_cowboy_hat: {
    id: "face_with_cowboy_hat",
    name: "Cowboy Hat Face",
    keywords: [
      "with",
      "cowgirl"
    ],
    skins: [
      {
        unified: "1f920",
        native: "🤠"
      }
    ],
    version: 3
  },
  partying_face: {
    id: "partying_face",
    name: "Partying Face",
    keywords: [
      "celebration",
      "woohoo"
    ],
    skins: [
      {
        unified: "1f973",
        native: "🥳"
      }
    ],
    version: 11
  },
  disguised_face: {
    id: "disguised_face",
    name: "Disguised Face",
    keywords: [
      "pretent",
      "brows",
      "glasses",
      "moustache"
    ],
    skins: [
      {
        unified: "1f978",
        native: "🥸"
      }
    ],
    version: 13
  },
  sunglasses: {
    id: "sunglasses",
    name: "Smiling Face with Sunglasses",
    emoticons: [
      "8)"
    ],
    keywords: [
      "cool",
      "smile",
      "summer",
      "beach",
      "sunglass"
    ],
    skins: [
      {
        unified: "1f60e",
        native: "😎"
      }
    ],
    version: 1
  },
  nerd_face: {
    id: "nerd_face",
    name: "Nerd Face",
    keywords: [
      "nerdy",
      "geek",
      "dork"
    ],
    skins: [
      {
        unified: "1f913",
        native: "🤓"
      }
    ],
    version: 1
  },
  face_with_monocle: {
    id: "face_with_monocle",
    name: "Face with Monocle",
    keywords: [
      "stuffy",
      "wealthy"
    ],
    skins: [
      {
        unified: "1f9d0",
        native: "🧐"
      }
    ],
    version: 5
  },
  confused: {
    id: "confused",
    name: "Confused Face",
    emoticons: [
      ":\\",
      ":-\\",
      ":/",
      ":-/"
    ],
    keywords: [
      "indifference",
      "huh",
      "weird",
      "hmmm",
      ":/"
    ],
    skins: [
      {
        unified: "1f615",
        native: "😕"
      }
    ],
    version: 1
  },
  face_with_diagonal_mouth: {
    id: "face_with_diagonal_mouth",
    name: "Face with Diagonal Mouth",
    keywords: [
      "skeptic",
      "confuse",
      "frustrated",
      "indifferent"
    ],
    skins: [
      {
        unified: "1fae4",
        native: "🫤"
      }
    ],
    version: 14
  },
  worried: {
    id: "worried",
    name: "Worried Face",
    keywords: [
      "concern",
      "nervous",
      ":("
    ],
    skins: [
      {
        unified: "1f61f",
        native: "😟"
      }
    ],
    version: 1
  },
  slightly_frowning_face: {
    id: "slightly_frowning_face",
    name: "Slightly Frowning Face",
    keywords: [
      "disappointed",
      "sad",
      "upset"
    ],
    skins: [
      {
        unified: "1f641",
        native: "🙁"
      }
    ],
    version: 1
  },
  white_frowning_face: {
    id: "white_frowning_face",
    name: "Frowning Face",
    keywords: [
      "white",
      "sad",
      "upset",
      "frown"
    ],
    skins: [
      {
        unified: "2639-fe0f",
        native: "☹️"
      }
    ],
    version: 1
  },
  open_mouth: {
    id: "open_mouth",
    name: "Face with Open Mouth",
    emoticons: [
      ":o",
      ":-o",
      ":O",
      ":-O"
    ],
    keywords: [
      "surprise",
      "impressed",
      "wow",
      "whoa",
      ":O"
    ],
    skins: [
      {
        unified: "1f62e",
        native: "😮"
      }
    ],
    version: 1
  },
  hushed: {
    id: "hushed",
    name: "Hushed Face",
    keywords: [
      "woo",
      "shh"
    ],
    skins: [
      {
        unified: "1f62f",
        native: "😯"
      }
    ],
    version: 1
  },
  astonished: {
    id: "astonished",
    name: "Astonished Face",
    keywords: [
      "xox",
      "surprised",
      "poisoned"
    ],
    skins: [
      {
        unified: "1f632",
        native: "😲"
      }
    ],
    version: 1
  },
  flushed: {
    id: "flushed",
    name: "Flushed Face",
    keywords: [
      "blush",
      "shy",
      "flattered"
    ],
    skins: [
      {
        unified: "1f633",
        native: "😳"
      }
    ],
    version: 1
  },
  pleading_face: {
    id: "pleading_face",
    name: "Pleading Face",
    keywords: [
      "begging",
      "mercy"
    ],
    skins: [
      {
        unified: "1f97a",
        native: "🥺"
      }
    ],
    version: 11
  },
  face_holding_back_tears: {
    id: "face_holding_back_tears",
    name: "Face Holding Back Tears",
    keywords: [
      "touched",
      "gratitude"
    ],
    skins: [
      {
        unified: "1f979",
        native: "🥹"
      }
    ],
    version: 14
  },
  frowning: {
    id: "frowning",
    name: "Frowning Face with Open Mouth",
    keywords: [
      "aw",
      "what"
    ],
    skins: [
      {
        unified: "1f626",
        native: "😦"
      }
    ],
    version: 1
  },
  anguished: {
    id: "anguished",
    name: "Anguished Face",
    emoticons: [
      "D:"
    ],
    keywords: [
      "stunned",
      "nervous"
    ],
    skins: [
      {
        unified: "1f627",
        native: "😧"
      }
    ],
    version: 1
  },
  fearful: {
    id: "fearful",
    name: "Fearful Face",
    keywords: [
      "scared",
      "terrified",
      "nervous",
      "oops",
      "huh"
    ],
    skins: [
      {
        unified: "1f628",
        native: "😨"
      }
    ],
    version: 1
  },
  cold_sweat: {
    id: "cold_sweat",
    name: "Anxious Face with Sweat",
    keywords: [
      "cold",
      "nervous"
    ],
    skins: [
      {
        unified: "1f630",
        native: "😰"
      }
    ],
    version: 1
  },
  disappointed_relieved: {
    id: "disappointed_relieved",
    name: "Sad but Relieved Face",
    keywords: [
      "disappointed",
      "phew",
      "sweat",
      "nervous"
    ],
    skins: [
      {
        unified: "1f625",
        native: "😥"
      }
    ],
    version: 1
  },
  cry: {
    id: "cry",
    name: "Crying Face",
    emoticons: [
      ":'("
    ],
    keywords: [
      "cry",
      "tears",
      "sad",
      "depressed",
      "upset",
      ":'("
    ],
    skins: [
      {
        unified: "1f622",
        native: "😢"
      }
    ],
    version: 1
  },
  sob: {
    id: "sob",
    name: "Loudly Crying Face",
    emoticons: [
      ":'("
    ],
    keywords: [
      "sob",
      "cry",
      "tears",
      "sad",
      "upset",
      "depressed"
    ],
    skins: [
      {
        unified: "1f62d",
        native: "😭"
      }
    ],
    version: 1
  },
  scream: {
    id: "scream",
    name: "Face Screaming in Fear",
    keywords: [
      "scream",
      "munch",
      "scared",
      "omg"
    ],
    skins: [
      {
        unified: "1f631",
        native: "😱"
      }
    ],
    version: 1
  },
  confounded: {
    id: "confounded",
    name: "Confounded Face",
    keywords: [
      "confused",
      "sick",
      "unwell",
      "oops",
      ":S"
    ],
    skins: [
      {
        unified: "1f616",
        native: "😖"
      }
    ],
    version: 1
  },
  persevere: {
    id: "persevere",
    name: "Persevering Face",
    keywords: [
      "persevere",
      "sick",
      "no",
      "upset",
      "oops"
    ],
    skins: [
      {
        unified: "1f623",
        native: "😣"
      }
    ],
    version: 1
  },
  disappointed: {
    id: "disappointed",
    name: "Disappointed Face",
    emoticons: [
      "):",
      ":(",
      ":-("
    ],
    keywords: [
      "sad",
      "upset",
      "depressed",
      ":("
    ],
    skins: [
      {
        unified: "1f61e",
        native: "😞"
      }
    ],
    version: 1
  },
  sweat: {
    id: "sweat",
    name: "Face with Cold Sweat",
    keywords: [
      "downcast",
      "hot",
      "sad",
      "tired",
      "exercise"
    ],
    skins: [
      {
        unified: "1f613",
        native: "😓"
      }
    ],
    version: 1
  },
  weary: {
    id: "weary",
    name: "Weary Face",
    keywords: [
      "tired",
      "sleepy",
      "sad",
      "frustrated",
      "upset"
    ],
    skins: [
      {
        unified: "1f629",
        native: "😩"
      }
    ],
    version: 1
  },
  tired_face: {
    id: "tired_face",
    name: "Tired Face",
    keywords: [
      "sick",
      "whine",
      "upset",
      "frustrated"
    ],
    skins: [
      {
        unified: "1f62b",
        native: "😫"
      }
    ],
    version: 1
  },
  yawning_face: {
    id: "yawning_face",
    name: "Yawning Face",
    keywords: [
      "tired",
      "sleepy"
    ],
    skins: [
      {
        unified: "1f971",
        native: "🥱"
      }
    ],
    version: 12
  },
  triumph: {
    id: "triumph",
    name: "Face with Look of Triumph",
    keywords: [
      "steam",
      "from",
      "nose",
      "gas",
      "phew",
      "proud",
      "pride"
    ],
    skins: [
      {
        unified: "1f624",
        native: "😤"
      }
    ],
    version: 1
  },
  rage: {
    id: "rage",
    name: "Pouting Face",
    keywords: [
      "rage",
      "angry",
      "mad",
      "hate",
      "despise"
    ],
    skins: [
      {
        unified: "1f621",
        native: "😡"
      }
    ],
    version: 1
  },
  angry: {
    id: "angry",
    name: "Angry Face",
    emoticons: [
      ">:(",
      ">:-("
    ],
    keywords: [
      "mad",
      "annoyed",
      "frustrated"
    ],
    skins: [
      {
        unified: "1f620",
        native: "😠"
      }
    ],
    version: 1
  },
  face_with_symbols_on_mouth: {
    id: "face_with_symbols_on_mouth",
    name: "Face with Symbols on Mouth",
    keywords: [
      "serious",
      "covering",
      "swearing",
      "cursing",
      "cussing",
      "profanity",
      "expletive"
    ],
    skins: [
      {
        unified: "1f92c",
        native: "🤬"
      }
    ],
    version: 5
  },
  smiling_imp: {
    id: "smiling_imp",
    name: "Smiling Face with Horns",
    keywords: [
      "imp",
      "devil"
    ],
    skins: [
      {
        unified: "1f608",
        native: "😈"
      }
    ],
    version: 1
  },
  imp: {
    id: "imp",
    name: "Imp",
    keywords: [
      "angry",
      "face",
      "with",
      "horns",
      "devil"
    ],
    skins: [
      {
        unified: "1f47f",
        native: "👿"
      }
    ],
    version: 1
  },
  skull: {
    id: "skull",
    name: "Skull",
    keywords: [
      "dead",
      "skeleton",
      "creepy",
      "death"
    ],
    skins: [
      {
        unified: "1f480",
        native: "💀"
      }
    ],
    version: 1
  },
  skull_and_crossbones: {
    id: "skull_and_crossbones",
    name: "Skull and Crossbones",
    keywords: [
      "poison",
      "danger",
      "deadly",
      "scary",
      "death",
      "pirate",
      "evil"
    ],
    skins: [
      {
        unified: "2620-fe0f",
        native: "☠️"
      }
    ],
    version: 1
  },
  hankey: {
    id: "hankey",
    name: "Pile of Poo",
    keywords: [
      "hankey",
      "poop",
      "shit",
      "shitface",
      "fail",
      "turd"
    ],
    skins: [
      {
        unified: "1f4a9",
        native: "💩"
      }
    ],
    version: 1
  },
  clown_face: {
    id: "clown_face",
    name: "Clown Face",
    keywords: [],
    skins: [
      {
        unified: "1f921",
        native: "🤡"
      }
    ],
    version: 3
  },
  japanese_ogre: {
    id: "japanese_ogre",
    name: "Ogre",
    keywords: [
      "japanese",
      "monster",
      "red",
      "mask",
      "halloween",
      "scary",
      "creepy",
      "devil",
      "demon"
    ],
    skins: [
      {
        unified: "1f479",
        native: "👹"
      }
    ],
    version: 1
  },
  japanese_goblin: {
    id: "japanese_goblin",
    name: "Goblin",
    keywords: [
      "japanese",
      "red",
      "evil",
      "mask",
      "monster",
      "scary",
      "creepy"
    ],
    skins: [
      {
        unified: "1f47a",
        native: "👺"
      }
    ],
    version: 1
  },
  ghost: {
    id: "ghost",
    name: "Ghost",
    keywords: [
      "halloween",
      "spooky",
      "scary"
    ],
    skins: [
      {
        unified: "1f47b",
        native: "👻"
      }
    ],
    version: 1
  },
  alien: {
    id: "alien",
    name: "Alien",
    keywords: [
      "UFO",
      "paul",
      "weird",
      "outer",
      "space"
    ],
    skins: [
      {
        unified: "1f47d",
        native: "👽"
      }
    ],
    version: 1
  },
  space_invader: {
    id: "space_invader",
    name: "Alien Monster",
    keywords: [
      "space",
      "invader",
      "game",
      "arcade",
      "play"
    ],
    skins: [
      {
        unified: "1f47e",
        native: "👾"
      }
    ],
    version: 1
  },
  robot_face: {
    id: "robot_face",
    name: "Robot",
    keywords: [
      "face",
      "computer",
      "machine",
      "bot"
    ],
    skins: [
      {
        unified: "1f916",
        native: "🤖"
      }
    ],
    version: 1
  },
  smiley_cat: {
    id: "smiley_cat",
    name: "Grinning Cat",
    keywords: [
      "smiley",
      "animal",
      "cats",
      "happy",
      "smile"
    ],
    skins: [
      {
        unified: "1f63a",
        native: "😺"
      }
    ],
    version: 1
  },
  smile_cat: {
    id: "smile_cat",
    name: "Grinning Cat with Smiling Eyes",
    keywords: [
      "smile",
      "animal",
      "cats"
    ],
    skins: [
      {
        unified: "1f638",
        native: "😸"
      }
    ],
    version: 1
  },
  joy_cat: {
    id: "joy_cat",
    name: "Cat with Tears of Joy",
    keywords: [
      "animal",
      "cats",
      "haha",
      "happy"
    ],
    skins: [
      {
        unified: "1f639",
        native: "😹"
      }
    ],
    version: 1
  },
  heart_eyes_cat: {
    id: "heart_eyes_cat",
    name: "Smiling Cat with Heart-Eyes",
    keywords: [
      "heart",
      "eyes",
      "animal",
      "love",
      "like",
      "affection",
      "cats",
      "valentines"
    ],
    skins: [
      {
        unified: "1f63b",
        native: "😻"
      }
    ],
    version: 1
  },
  smirk_cat: {
    id: "smirk_cat",
    name: "Cat with Wry Smile",
    keywords: [
      "smirk",
      "animal",
      "cats"
    ],
    skins: [
      {
        unified: "1f63c",
        native: "😼"
      }
    ],
    version: 1
  },
  kissing_cat: {
    id: "kissing_cat",
    name: "Kissing Cat",
    keywords: [
      "animal",
      "cats",
      "kiss"
    ],
    skins: [
      {
        unified: "1f63d",
        native: "😽"
      }
    ],
    version: 1
  },
  scream_cat: {
    id: "scream_cat",
    name: "Weary Cat",
    keywords: [
      "scream",
      "animal",
      "cats",
      "munch",
      "scared"
    ],
    skins: [
      {
        unified: "1f640",
        native: "🙀"
      }
    ],
    version: 1
  },
  crying_cat_face: {
    id: "crying_cat_face",
    name: "Crying Cat",
    keywords: [
      "face",
      "animal",
      "tears",
      "weep",
      "sad",
      "cats",
      "upset",
      "cry"
    ],
    skins: [
      {
        unified: "1f63f",
        native: "😿"
      }
    ],
    version: 1
  },
  pouting_cat: {
    id: "pouting_cat",
    name: "Pouting Cat",
    keywords: [
      "animal",
      "cats"
    ],
    skins: [
      {
        unified: "1f63e",
        native: "😾"
      }
    ],
    version: 1
  },
  see_no_evil: {
    id: "see_no_evil",
    name: "See-No-Evil Monkey",
    keywords: [
      "see",
      "no",
      "evil",
      "animal",
      "nature",
      "haha"
    ],
    skins: [
      {
        unified: "1f648",
        native: "🙈"
      }
    ],
    version: 1
  },
  hear_no_evil: {
    id: "hear_no_evil",
    name: "Hear-No-Evil Monkey",
    keywords: [
      "hear",
      "no",
      "evil",
      "animal",
      "nature"
    ],
    skins: [
      {
        unified: "1f649",
        native: "🙉"
      }
    ],
    version: 1
  },
  speak_no_evil: {
    id: "speak_no_evil",
    name: "Speak-No-Evil Monkey",
    keywords: [
      "speak",
      "no",
      "evil",
      "animal",
      "nature",
      "omg"
    ],
    skins: [
      {
        unified: "1f64a",
        native: "🙊"
      }
    ],
    version: 1
  },
  kiss: {
    id: "kiss",
    name: "Kiss Mark",
    keywords: [
      "face",
      "lips",
      "love",
      "like",
      "affection",
      "valentines"
    ],
    skins: [
      {
        unified: "1f48b",
        native: "💋"
      }
    ],
    version: 1
  },
  love_letter: {
    id: "love_letter",
    name: "Love Letter",
    keywords: [
      "email",
      "like",
      "affection",
      "envelope",
      "valentines"
    ],
    skins: [
      {
        unified: "1f48c",
        native: "💌"
      }
    ],
    version: 1
  },
  cupid: {
    id: "cupid",
    name: "Heart with Arrow",
    keywords: [
      "cupid",
      "love",
      "like",
      "affection",
      "valentines"
    ],
    skins: [
      {
        unified: "1f498",
        native: "💘"
      }
    ],
    version: 1
  },
  gift_heart: {
    id: "gift_heart",
    name: "Heart with Ribbon",
    keywords: [
      "gift",
      "love",
      "valentines"
    ],
    skins: [
      {
        unified: "1f49d",
        native: "💝"
      }
    ],
    version: 1
  },
  sparkling_heart: {
    id: "sparkling_heart",
    name: "Sparkling Heart",
    keywords: [
      "love",
      "like",
      "affection",
      "valentines"
    ],
    skins: [
      {
        unified: "1f496",
        native: "💖"
      }
    ],
    version: 1
  },
  heartpulse: {
    id: "heartpulse",
    name: "Growing Heart",
    keywords: [
      "heartpulse",
      "like",
      "love",
      "affection",
      "valentines",
      "pink"
    ],
    skins: [
      {
        unified: "1f497",
        native: "💗"
      }
    ],
    version: 1
  },
  heartbeat: {
    id: "heartbeat",
    name: "Beating Heart",
    keywords: [
      "heartbeat",
      "love",
      "like",
      "affection",
      "valentines",
      "pink"
    ],
    skins: [
      {
        unified: "1f493",
        native: "💓"
      }
    ],
    version: 1
  },
  revolving_hearts: {
    id: "revolving_hearts",
    name: "Revolving Hearts",
    keywords: [
      "love",
      "like",
      "affection",
      "valentines"
    ],
    skins: [
      {
        unified: "1f49e",
        native: "💞"
      }
    ],
    version: 1
  },
  two_hearts: {
    id: "two_hearts",
    name: "Two Hearts",
    keywords: [
      "love",
      "like",
      "affection",
      "valentines",
      "heart"
    ],
    skins: [
      {
        unified: "1f495",
        native: "💕"
      }
    ],
    version: 1
  },
  heart_decoration: {
    id: "heart_decoration",
    name: "Heart Decoration",
    keywords: [
      "purple",
      "square",
      "love",
      "like"
    ],
    skins: [
      {
        unified: "1f49f",
        native: "💟"
      }
    ],
    version: 1
  },
  heavy_heart_exclamation_mark_ornament: {
    id: "heavy_heart_exclamation_mark_ornament",
    name: "Heart Exclamation",
    keywords: [
      "heavy",
      "mark",
      "ornament",
      "decoration",
      "love"
    ],
    skins: [
      {
        unified: "2763-fe0f",
        native: "❣️"
      }
    ],
    version: 1
  },
  broken_heart: {
    id: "broken_heart",
    name: "Broken Heart",
    emoticons: [
      "</3"
    ],
    keywords: [
      "sad",
      "sorry",
      "break",
      "heartbreak"
    ],
    skins: [
      {
        unified: "1f494",
        native: "💔"
      }
    ],
    version: 1
  },
  heart_on_fire: {
    id: "heart_on_fire",
    name: "Heart on Fire",
    keywords: [
      "passionate",
      "enthusiastic"
    ],
    skins: [
      {
        unified: "2764-fe0f-200d-1f525",
        native: "❤️‍🔥"
      }
    ],
    version: 13.1
  },
  mending_heart: {
    id: "mending_heart",
    name: "Mending Heart",
    keywords: [
      "broken",
      "bandage",
      "wounded"
    ],
    skins: [
      {
        unified: "2764-fe0f-200d-1fa79",
        native: "❤️‍🩹"
      }
    ],
    version: 13.1
  },
  heart: {
    id: "heart",
    name: "Red Heart",
    emoticons: [
      "<3"
    ],
    keywords: [
      "love",
      "like",
      "valentines"
    ],
    skins: [
      {
        unified: "2764-fe0f",
        native: "❤️"
      }
    ],
    version: 1
  },
  orange_heart: {
    id: "orange_heart",
    name: "Orange Heart",
    keywords: [
      "love",
      "like",
      "affection",
      "valentines"
    ],
    skins: [
      {
        unified: "1f9e1",
        native: "🧡"
      }
    ],
    version: 5
  },
  yellow_heart: {
    id: "yellow_heart",
    name: "Yellow Heart",
    emoticons: [
      "<3"
    ],
    keywords: [
      "love",
      "like",
      "affection",
      "valentines"
    ],
    skins: [
      {
        unified: "1f49b",
        native: "💛"
      }
    ],
    version: 1
  },
  green_heart: {
    id: "green_heart",
    name: "Green Heart",
    emoticons: [
      "<3"
    ],
    keywords: [
      "love",
      "like",
      "affection",
      "valentines"
    ],
    skins: [
      {
        unified: "1f49a",
        native: "💚"
      }
    ],
    version: 1
  },
  blue_heart: {
    id: "blue_heart",
    name: "Blue Heart",
    emoticons: [
      "<3"
    ],
    keywords: [
      "love",
      "like",
      "affection",
      "valentines"
    ],
    skins: [
      {
        unified: "1f499",
        native: "💙"
      }
    ],
    version: 1
  },
  purple_heart: {
    id: "purple_heart",
    name: "Purple Heart",
    emoticons: [
      "<3"
    ],
    keywords: [
      "love",
      "like",
      "affection",
      "valentines"
    ],
    skins: [
      {
        unified: "1f49c",
        native: "💜"
      }
    ],
    version: 1
  },
  brown_heart: {
    id: "brown_heart",
    name: "Brown Heart",
    keywords: [
      "coffee"
    ],
    skins: [
      {
        unified: "1f90e",
        native: "🤎"
      }
    ],
    version: 12
  },
  black_heart: {
    id: "black_heart",
    name: "Black Heart",
    keywords: [
      "evil"
    ],
    skins: [
      {
        unified: "1f5a4",
        native: "🖤"
      }
    ],
    version: 3
  },
  white_heart: {
    id: "white_heart",
    name: "White Heart",
    keywords: [
      "pure"
    ],
    skins: [
      {
        unified: "1f90d",
        native: "🤍"
      }
    ],
    version: 12
  },
  anger: {
    id: "anger",
    name: "Anger Symbol",
    keywords: [
      "angry",
      "mad"
    ],
    skins: [
      {
        unified: "1f4a2",
        native: "💢"
      }
    ],
    version: 1
  },
  boom: {
    id: "boom",
    name: "Collision",
    keywords: [
      "boom",
      "bomb",
      "explode",
      "explosion",
      "blown"
    ],
    skins: [
      {
        unified: "1f4a5",
        native: "💥"
      }
    ],
    version: 1
  },
  dizzy: {
    id: "dizzy",
    name: "Dizzy",
    keywords: [
      "star",
      "sparkle",
      "shoot",
      "magic"
    ],
    skins: [
      {
        unified: "1f4ab",
        native: "💫"
      }
    ],
    version: 1
  },
  sweat_drops: {
    id: "sweat_drops",
    name: "Sweat Droplets",
    keywords: [
      "drops",
      "water",
      "drip",
      "oops"
    ],
    skins: [
      {
        unified: "1f4a6",
        native: "💦"
      }
    ],
    version: 1
  },
  dash: {
    id: "dash",
    name: "Dash Symbol",
    keywords: [
      "dashing",
      "away",
      "wind",
      "air",
      "fast",
      "shoo",
      "fart",
      "smoke",
      "puff"
    ],
    skins: [
      {
        unified: "1f4a8",
        native: "💨"
      }
    ],
    version: 1
  },
  hole: {
    id: "hole",
    name: "Hole",
    keywords: [
      "embarrassing"
    ],
    skins: [
      {
        unified: "1f573-fe0f",
        native: "🕳️"
      }
    ],
    version: 1
  },
  bomb: {
    id: "bomb",
    name: "Bomb",
    keywords: [
      "boom",
      "explode",
      "explosion",
      "terrorism"
    ],
    skins: [
      {
        unified: "1f4a3",
        native: "💣"
      }
    ],
    version: 1
  },
  speech_balloon: {
    id: "speech_balloon",
    name: "Speech Balloon",
    keywords: [
      "bubble",
      "words",
      "message",
      "talk",
      "chatting"
    ],
    skins: [
      {
        unified: "1f4ac",
        native: "💬"
      }
    ],
    version: 1
  },
  "eye-in-speech-bubble": {
    id: "eye-in-speech-bubble",
    name: "Eye in Speech Bubble",
    keywords: [
      "in-speech-bubble",
      "info"
    ],
    skins: [
      {
        unified: "1f441-fe0f-200d-1f5e8-fe0f",
        native: "👁️‍🗨️"
      }
    ],
    version: 2
  },
  left_speech_bubble: {
    id: "left_speech_bubble",
    name: "Left Speech Bubble",
    keywords: [
      "words",
      "message",
      "talk",
      "chatting"
    ],
    skins: [
      {
        unified: "1f5e8-fe0f",
        native: "🗨️"
      }
    ],
    version: 2
  },
  right_anger_bubble: {
    id: "right_anger_bubble",
    name: "Right Anger Bubble",
    keywords: [
      "caption",
      "speech",
      "thinking",
      "mad"
    ],
    skins: [
      {
        unified: "1f5ef-fe0f",
        native: "🗯️"
      }
    ],
    version: 1
  },
  thought_balloon: {
    id: "thought_balloon",
    name: "Thought Balloon",
    keywords: [
      "bubble",
      "cloud",
      "speech",
      "thinking",
      "dream"
    ],
    skins: [
      {
        unified: "1f4ad",
        native: "💭"
      }
    ],
    version: 1
  },
  zzz: {
    id: "zzz",
    name: "Zzz",
    keywords: [
      "sleepy",
      "tired",
      "dream"
    ],
    skins: [
      {
        unified: "1f4a4",
        native: "💤"
      }
    ],
    version: 1
  },
  wave: {
    id: "wave",
    name: "Waving Hand",
    keywords: [
      "wave",
      "hands",
      "gesture",
      "goodbye",
      "solong",
      "farewell",
      "hello",
      "hi",
      "palm"
    ],
    skins: [
      {
        unified: "1f44b",
        native: "👋"
      },
      {
        unified: "1f44b-1f3fb",
        native: "👋🏻"
      },
      {
        unified: "1f44b-1f3fc",
        native: "👋🏼"
      },
      {
        unified: "1f44b-1f3fd",
        native: "👋🏽"
      },
      {
        unified: "1f44b-1f3fe",
        native: "👋🏾"
      },
      {
        unified: "1f44b-1f3ff",
        native: "👋🏿"
      }
    ],
    version: 1
  },
  raised_back_of_hand: {
    id: "raised_back_of_hand",
    name: "Raised Back of Hand",
    keywords: [
      "fingers",
      "backhand"
    ],
    skins: [
      {
        unified: "1f91a",
        native: "🤚"
      },
      {
        unified: "1f91a-1f3fb",
        native: "🤚🏻"
      },
      {
        unified: "1f91a-1f3fc",
        native: "🤚🏼"
      },
      {
        unified: "1f91a-1f3fd",
        native: "🤚🏽"
      },
      {
        unified: "1f91a-1f3fe",
        native: "🤚🏾"
      },
      {
        unified: "1f91a-1f3ff",
        native: "🤚🏿"
      }
    ],
    version: 3
  },
  raised_hand_with_fingers_splayed: {
    id: "raised_hand_with_fingers_splayed",
    name: "Hand with Fingers Splayed",
    keywords: [
      "raised",
      "palm"
    ],
    skins: [
      {
        unified: "1f590-fe0f",
        native: "🖐️"
      },
      {
        unified: "1f590-1f3fb",
        native: "🖐🏻"
      },
      {
        unified: "1f590-1f3fc",
        native: "🖐🏼"
      },
      {
        unified: "1f590-1f3fd",
        native: "🖐🏽"
      },
      {
        unified: "1f590-1f3fe",
        native: "🖐🏾"
      },
      {
        unified: "1f590-1f3ff",
        native: "🖐🏿"
      }
    ],
    version: 1
  },
  hand: {
    id: "hand",
    name: "Raised Hand",
    keywords: [
      "fingers",
      "stop",
      "highfive",
      "high",
      "five",
      "palm",
      "ban"
    ],
    skins: [
      {
        unified: "270b",
        native: "✋"
      },
      {
        unified: "270b-1f3fb",
        native: "✋🏻"
      },
      {
        unified: "270b-1f3fc",
        native: "✋🏼"
      },
      {
        unified: "270b-1f3fd",
        native: "✋🏽"
      },
      {
        unified: "270b-1f3fe",
        native: "✋🏾"
      },
      {
        unified: "270b-1f3ff",
        native: "✋🏿"
      }
    ],
    version: 1
  },
  "spock-hand": {
    id: "spock-hand",
    name: "Vulcan Salute",
    keywords: [
      "spock",
      "hand",
      "fingers",
      "star",
      "trek"
    ],
    skins: [
      {
        unified: "1f596",
        native: "🖖"
      },
      {
        unified: "1f596-1f3fb",
        native: "🖖🏻"
      },
      {
        unified: "1f596-1f3fc",
        native: "🖖🏼"
      },
      {
        unified: "1f596-1f3fd",
        native: "🖖🏽"
      },
      {
        unified: "1f596-1f3fe",
        native: "🖖🏾"
      },
      {
        unified: "1f596-1f3ff",
        native: "🖖🏿"
      }
    ],
    version: 1
  },
  rightwards_hand: {
    id: "rightwards_hand",
    name: "Rightwards Hand",
    keywords: [
      "palm",
      "offer"
    ],
    skins: [
      {
        unified: "1faf1",
        native: "🫱"
      },
      {
        unified: "1faf1-1f3fb",
        native: "🫱🏻"
      },
      {
        unified: "1faf1-1f3fc",
        native: "🫱🏼"
      },
      {
        unified: "1faf1-1f3fd",
        native: "🫱🏽"
      },
      {
        unified: "1faf1-1f3fe",
        native: "🫱🏾"
      },
      {
        unified: "1faf1-1f3ff",
        native: "🫱🏿"
      }
    ],
    version: 14
  },
  leftwards_hand: {
    id: "leftwards_hand",
    name: "Leftwards Hand",
    keywords: [
      "palm",
      "offer"
    ],
    skins: [
      {
        unified: "1faf2",
        native: "🫲"
      },
      {
        unified: "1faf2-1f3fb",
        native: "🫲🏻"
      },
      {
        unified: "1faf2-1f3fc",
        native: "🫲🏼"
      },
      {
        unified: "1faf2-1f3fd",
        native: "🫲🏽"
      },
      {
        unified: "1faf2-1f3fe",
        native: "🫲🏾"
      },
      {
        unified: "1faf2-1f3ff",
        native: "🫲🏿"
      }
    ],
    version: 14
  },
  palm_down_hand: {
    id: "palm_down_hand",
    name: "Palm Down Hand",
    keywords: [
      "drop"
    ],
    skins: [
      {
        unified: "1faf3",
        native: "🫳"
      },
      {
        unified: "1faf3-1f3fb",
        native: "🫳🏻"
      },
      {
        unified: "1faf3-1f3fc",
        native: "🫳🏼"
      },
      {
        unified: "1faf3-1f3fd",
        native: "🫳🏽"
      },
      {
        unified: "1faf3-1f3fe",
        native: "🫳🏾"
      },
      {
        unified: "1faf3-1f3ff",
        native: "🫳🏿"
      }
    ],
    version: 14
  },
  palm_up_hand: {
    id: "palm_up_hand",
    name: "Palm Up Hand",
    keywords: [
      "lift",
      "offer",
      "demand"
    ],
    skins: [
      {
        unified: "1faf4",
        native: "🫴"
      },
      {
        unified: "1faf4-1f3fb",
        native: "🫴🏻"
      },
      {
        unified: "1faf4-1f3fc",
        native: "🫴🏼"
      },
      {
        unified: "1faf4-1f3fd",
        native: "🫴🏽"
      },
      {
        unified: "1faf4-1f3fe",
        native: "🫴🏾"
      },
      {
        unified: "1faf4-1f3ff",
        native: "🫴🏿"
      }
    ],
    version: 14
  },
  ok_hand: {
    id: "ok_hand",
    name: "Ok Hand",
    keywords: [
      "fingers",
      "limbs",
      "perfect",
      "okay"
    ],
    skins: [
      {
        unified: "1f44c",
        native: "👌"
      },
      {
        unified: "1f44c-1f3fb",
        native: "👌🏻"
      },
      {
        unified: "1f44c-1f3fc",
        native: "👌🏼"
      },
      {
        unified: "1f44c-1f3fd",
        native: "👌🏽"
      },
      {
        unified: "1f44c-1f3fe",
        native: "👌🏾"
      },
      {
        unified: "1f44c-1f3ff",
        native: "👌🏿"
      }
    ],
    version: 1
  },
  pinched_fingers: {
    id: "pinched_fingers",
    name: "Pinched Fingers",
    keywords: [
      "size",
      "tiny",
      "small"
    ],
    skins: [
      {
        unified: "1f90c",
        native: "🤌"
      },
      {
        unified: "1f90c-1f3fb",
        native: "🤌🏻"
      },
      {
        unified: "1f90c-1f3fc",
        native: "🤌🏼"
      },
      {
        unified: "1f90c-1f3fd",
        native: "🤌🏽"
      },
      {
        unified: "1f90c-1f3fe",
        native: "🤌🏾"
      },
      {
        unified: "1f90c-1f3ff",
        native: "🤌🏿"
      }
    ],
    version: 13
  },
  pinching_hand: {
    id: "pinching_hand",
    name: "Pinching Hand",
    keywords: [
      "tiny",
      "small",
      "size"
    ],
    skins: [
      {
        unified: "1f90f",
        native: "🤏"
      },
      {
        unified: "1f90f-1f3fb",
        native: "🤏🏻"
      },
      {
        unified: "1f90f-1f3fc",
        native: "🤏🏼"
      },
      {
        unified: "1f90f-1f3fd",
        native: "🤏🏽"
      },
      {
        unified: "1f90f-1f3fe",
        native: "🤏🏾"
      },
      {
        unified: "1f90f-1f3ff",
        native: "🤏🏿"
      }
    ],
    version: 12
  },
  v: {
    id: "v",
    name: "Victory Hand",
    keywords: [
      "v",
      "fingers",
      "ohyeah",
      "peace",
      "two"
    ],
    skins: [
      {
        unified: "270c-fe0f",
        native: "✌️"
      },
      {
        unified: "270c-1f3fb",
        native: "✌🏻"
      },
      {
        unified: "270c-1f3fc",
        native: "✌🏼"
      },
      {
        unified: "270c-1f3fd",
        native: "✌🏽"
      },
      {
        unified: "270c-1f3fe",
        native: "✌🏾"
      },
      {
        unified: "270c-1f3ff",
        native: "✌🏿"
      }
    ],
    version: 1
  },
  crossed_fingers: {
    id: "crossed_fingers",
    name: "Crossed Fingers",
    keywords: [
      "hand",
      "with",
      "index",
      "and",
      "middle",
      "good",
      "lucky"
    ],
    skins: [
      {
        unified: "1f91e",
        native: "🤞"
      },
      {
        unified: "1f91e-1f3fb",
        native: "🤞🏻"
      },
      {
        unified: "1f91e-1f3fc",
        native: "🤞🏼"
      },
      {
        unified: "1f91e-1f3fd",
        native: "🤞🏽"
      },
      {
        unified: "1f91e-1f3fe",
        native: "🤞🏾"
      },
      {
        unified: "1f91e-1f3ff",
        native: "🤞🏿"
      }
    ],
    version: 3
  },
  hand_with_index_finger_and_thumb_crossed: {
    id: "hand_with_index_finger_and_thumb_crossed",
    name: "Hand with Index Finger and Thumb Crossed",
    keywords: [
      "heart",
      "love",
      "money",
      "expensive"
    ],
    skins: [
      {
        unified: "1faf0",
        native: "🫰"
      },
      {
        unified: "1faf0-1f3fb",
        native: "🫰🏻"
      },
      {
        unified: "1faf0-1f3fc",
        native: "🫰🏼"
      },
      {
        unified: "1faf0-1f3fd",
        native: "🫰🏽"
      },
      {
        unified: "1faf0-1f3fe",
        native: "🫰🏾"
      },
      {
        unified: "1faf0-1f3ff",
        native: "🫰🏿"
      }
    ],
    version: 14
  },
  i_love_you_hand_sign: {
    id: "i_love_you_hand_sign",
    name: "Love-You Gesture",
    keywords: [
      "i",
      "love",
      "you",
      "hand",
      "sign",
      "fingers"
    ],
    skins: [
      {
        unified: "1f91f",
        native: "🤟"
      },
      {
        unified: "1f91f-1f3fb",
        native: "🤟🏻"
      },
      {
        unified: "1f91f-1f3fc",
        native: "🤟🏼"
      },
      {
        unified: "1f91f-1f3fd",
        native: "🤟🏽"
      },
      {
        unified: "1f91f-1f3fe",
        native: "🤟🏾"
      },
      {
        unified: "1f91f-1f3ff",
        native: "🤟🏿"
      }
    ],
    version: 5
  },
  the_horns: {
    id: "the_horns",
    name: "Sign of the Horns",
    keywords: [
      "hand",
      "fingers",
      "evil",
      "eye",
      "rock",
      "on"
    ],
    skins: [
      {
        unified: "1f918",
        native: "🤘"
      },
      {
        unified: "1f918-1f3fb",
        native: "🤘🏻"
      },
      {
        unified: "1f918-1f3fc",
        native: "🤘🏼"
      },
      {
        unified: "1f918-1f3fd",
        native: "🤘🏽"
      },
      {
        unified: "1f918-1f3fe",
        native: "🤘🏾"
      },
      {
        unified: "1f918-1f3ff",
        native: "🤘🏿"
      }
    ],
    version: 1
  },
  call_me_hand: {
    id: "call_me_hand",
    name: "Call Me Hand",
    keywords: [
      "hands",
      "gesture",
      "shaka"
    ],
    skins: [
      {
        unified: "1f919",
        native: "🤙"
      },
      {
        unified: "1f919-1f3fb",
        native: "🤙🏻"
      },
      {
        unified: "1f919-1f3fc",
        native: "🤙🏼"
      },
      {
        unified: "1f919-1f3fd",
        native: "🤙🏽"
      },
      {
        unified: "1f919-1f3fe",
        native: "🤙🏾"
      },
      {
        unified: "1f919-1f3ff",
        native: "🤙🏿"
      }
    ],
    version: 3
  },
  point_left: {
    id: "point_left",
    name: "Backhand Index Pointing Left",
    keywords: [
      "point",
      "direction",
      "fingers",
      "hand"
    ],
    skins: [
      {
        unified: "1f448",
        native: "👈"
      },
      {
        unified: "1f448-1f3fb",
        native: "👈🏻"
      },
      {
        unified: "1f448-1f3fc",
        native: "👈🏼"
      },
      {
        unified: "1f448-1f3fd",
        native: "👈🏽"
      },
      {
        unified: "1f448-1f3fe",
        native: "👈🏾"
      },
      {
        unified: "1f448-1f3ff",
        native: "👈🏿"
      }
    ],
    version: 1
  },
  point_right: {
    id: "point_right",
    name: "Backhand Index Pointing Right",
    keywords: [
      "point",
      "fingers",
      "hand",
      "direction"
    ],
    skins: [
      {
        unified: "1f449",
        native: "👉"
      },
      {
        unified: "1f449-1f3fb",
        native: "👉🏻"
      },
      {
        unified: "1f449-1f3fc",
        native: "👉🏼"
      },
      {
        unified: "1f449-1f3fd",
        native: "👉🏽"
      },
      {
        unified: "1f449-1f3fe",
        native: "👉🏾"
      },
      {
        unified: "1f449-1f3ff",
        native: "👉🏿"
      }
    ],
    version: 1
  },
  point_up_2: {
    id: "point_up_2",
    name: "Backhand Index Pointing Up",
    keywords: [
      "point",
      "2",
      "fingers",
      "hand",
      "direction"
    ],
    skins: [
      {
        unified: "1f446",
        native: "👆"
      },
      {
        unified: "1f446-1f3fb",
        native: "👆🏻"
      },
      {
        unified: "1f446-1f3fc",
        native: "👆🏼"
      },
      {
        unified: "1f446-1f3fd",
        native: "👆🏽"
      },
      {
        unified: "1f446-1f3fe",
        native: "👆🏾"
      },
      {
        unified: "1f446-1f3ff",
        native: "👆🏿"
      }
    ],
    version: 1
  },
  middle_finger: {
    id: "middle_finger",
    name: "Middle Finger",
    keywords: [
      "reversed",
      "hand",
      "with",
      "extended",
      "fingers",
      "rude",
      "flipping"
    ],
    skins: [
      {
        unified: "1f595",
        native: "🖕"
      },
      {
        unified: "1f595-1f3fb",
        native: "🖕🏻"
      },
      {
        unified: "1f595-1f3fc",
        native: "🖕🏼"
      },
      {
        unified: "1f595-1f3fd",
        native: "🖕🏽"
      },
      {
        unified: "1f595-1f3fe",
        native: "🖕🏾"
      },
      {
        unified: "1f595-1f3ff",
        native: "🖕🏿"
      }
    ],
    version: 1
  },
  point_down: {
    id: "point_down",
    name: "Backhand Index Pointing Down",
    keywords: [
      "point",
      "fingers",
      "hand",
      "direction"
    ],
    skins: [
      {
        unified: "1f447",
        native: "👇"
      },
      {
        unified: "1f447-1f3fb",
        native: "👇🏻"
      },
      {
        unified: "1f447-1f3fc",
        native: "👇🏼"
      },
      {
        unified: "1f447-1f3fd",
        native: "👇🏽"
      },
      {
        unified: "1f447-1f3fe",
        native: "👇🏾"
      },
      {
        unified: "1f447-1f3ff",
        native: "👇🏿"
      }
    ],
    version: 1
  },
  point_up: {
    id: "point_up",
    name: "Index Pointing Up",
    keywords: [
      "point",
      "hand",
      "fingers",
      "direction"
    ],
    skins: [
      {
        unified: "261d-fe0f",
        native: "☝️"
      },
      {
        unified: "261d-1f3fb",
        native: "☝🏻"
      },
      {
        unified: "261d-1f3fc",
        native: "☝🏼"
      },
      {
        unified: "261d-1f3fd",
        native: "☝🏽"
      },
      {
        unified: "261d-1f3fe",
        native: "☝🏾"
      },
      {
        unified: "261d-1f3ff",
        native: "☝🏿"
      }
    ],
    version: 1
  },
  index_pointing_at_the_viewer: {
    id: "index_pointing_at_the_viewer",
    name: "Index Pointing at the Viewer",
    keywords: [
      "you",
      "recruit"
    ],
    skins: [
      {
        unified: "1faf5",
        native: "🫵"
      },
      {
        unified: "1faf5-1f3fb",
        native: "🫵🏻"
      },
      {
        unified: "1faf5-1f3fc",
        native: "🫵🏼"
      },
      {
        unified: "1faf5-1f3fd",
        native: "🫵🏽"
      },
      {
        unified: "1faf5-1f3fe",
        native: "🫵🏾"
      },
      {
        unified: "1faf5-1f3ff",
        native: "🫵🏿"
      }
    ],
    version: 14
  },
  "+1": {
    id: "+1",
    name: "Thumbs Up",
    keywords: [
      "+1",
      "thumbsup",
      "yes",
      "awesome",
      "good",
      "agree",
      "accept",
      "cool",
      "hand",
      "like"
    ],
    skins: [
      {
        unified: "1f44d",
        native: "👍"
      },
      {
        unified: "1f44d-1f3fb",
        native: "👍🏻"
      },
      {
        unified: "1f44d-1f3fc",
        native: "👍🏼"
      },
      {
        unified: "1f44d-1f3fd",
        native: "👍🏽"
      },
      {
        unified: "1f44d-1f3fe",
        native: "👍🏾"
      },
      {
        unified: "1f44d-1f3ff",
        native: "👍🏿"
      }
    ],
    version: 1
  },
  "-1": {
    id: "-1",
    name: "Thumbs Down",
    keywords: [
      "-1",
      "thumbsdown",
      "no",
      "dislike",
      "hand"
    ],
    skins: [
      {
        unified: "1f44e",
        native: "👎"
      },
      {
        unified: "1f44e-1f3fb",
        native: "👎🏻"
      },
      {
        unified: "1f44e-1f3fc",
        native: "👎🏼"
      },
      {
        unified: "1f44e-1f3fd",
        native: "👎🏽"
      },
      {
        unified: "1f44e-1f3fe",
        native: "👎🏾"
      },
      {
        unified: "1f44e-1f3ff",
        native: "👎🏿"
      }
    ],
    version: 1
  },
  fist: {
    id: "fist",
    name: "Raised Fist",
    keywords: [
      "fingers",
      "hand",
      "grasp"
    ],
    skins: [
      {
        unified: "270a",
        native: "✊"
      },
      {
        unified: "270a-1f3fb",
        native: "✊🏻"
      },
      {
        unified: "270a-1f3fc",
        native: "✊🏼"
      },
      {
        unified: "270a-1f3fd",
        native: "✊🏽"
      },
      {
        unified: "270a-1f3fe",
        native: "✊🏾"
      },
      {
        unified: "270a-1f3ff",
        native: "✊🏿"
      }
    ],
    version: 1
  },
  facepunch: {
    id: "facepunch",
    name: "Oncoming Fist",
    keywords: [
      "facepunch",
      "punch",
      "angry",
      "violence",
      "hit",
      "attack",
      "hand"
    ],
    skins: [
      {
        unified: "1f44a",
        native: "👊"
      },
      {
        unified: "1f44a-1f3fb",
        native: "👊🏻"
      },
      {
        unified: "1f44a-1f3fc",
        native: "👊🏼"
      },
      {
        unified: "1f44a-1f3fd",
        native: "👊🏽"
      },
      {
        unified: "1f44a-1f3fe",
        native: "👊🏾"
      },
      {
        unified: "1f44a-1f3ff",
        native: "👊🏿"
      }
    ],
    version: 1
  },
  "left-facing_fist": {
    id: "left-facing_fist",
    name: "Left-Facing Fist",
    keywords: [
      "left",
      "facing",
      "hand",
      "fistbump"
    ],
    skins: [
      {
        unified: "1f91b",
        native: "🤛"
      },
      {
        unified: "1f91b-1f3fb",
        native: "🤛🏻"
      },
      {
        unified: "1f91b-1f3fc",
        native: "🤛🏼"
      },
      {
        unified: "1f91b-1f3fd",
        native: "🤛🏽"
      },
      {
        unified: "1f91b-1f3fe",
        native: "🤛🏾"
      },
      {
        unified: "1f91b-1f3ff",
        native: "🤛🏿"
      }
    ],
    version: 3
  },
  "right-facing_fist": {
    id: "right-facing_fist",
    name: "Right-Facing Fist",
    keywords: [
      "right",
      "facing",
      "hand",
      "fistbump"
    ],
    skins: [
      {
        unified: "1f91c",
        native: "🤜"
      },
      {
        unified: "1f91c-1f3fb",
        native: "🤜🏻"
      },
      {
        unified: "1f91c-1f3fc",
        native: "🤜🏼"
      },
      {
        unified: "1f91c-1f3fd",
        native: "🤜🏽"
      },
      {
        unified: "1f91c-1f3fe",
        native: "🤜🏾"
      },
      {
        unified: "1f91c-1f3ff",
        native: "🤜🏿"
      }
    ],
    version: 3
  },
  clap: {
    id: "clap",
    name: "Clapping Hands",
    keywords: [
      "clap",
      "praise",
      "applause",
      "congrats",
      "yay"
    ],
    skins: [
      {
        unified: "1f44f",
        native: "👏"
      },
      {
        unified: "1f44f-1f3fb",
        native: "👏🏻"
      },
      {
        unified: "1f44f-1f3fc",
        native: "👏🏼"
      },
      {
        unified: "1f44f-1f3fd",
        native: "👏🏽"
      },
      {
        unified: "1f44f-1f3fe",
        native: "👏🏾"
      },
      {
        unified: "1f44f-1f3ff",
        native: "👏🏿"
      }
    ],
    version: 1
  },
  raised_hands: {
    id: "raised_hands",
    name: "Raising Hands",
    keywords: [
      "raised",
      "gesture",
      "hooray",
      "yea",
      "celebration"
    ],
    skins: [
      {
        unified: "1f64c",
        native: "🙌"
      },
      {
        unified: "1f64c-1f3fb",
        native: "🙌🏻"
      },
      {
        unified: "1f64c-1f3fc",
        native: "🙌🏼"
      },
      {
        unified: "1f64c-1f3fd",
        native: "🙌🏽"
      },
      {
        unified: "1f64c-1f3fe",
        native: "🙌🏾"
      },
      {
        unified: "1f64c-1f3ff",
        native: "🙌🏿"
      }
    ],
    version: 1
  },
  heart_hands: {
    id: "heart_hands",
    name: "Heart Hands",
    keywords: [
      "love",
      "appreciation",
      "support"
    ],
    skins: [
      {
        unified: "1faf6",
        native: "🫶"
      },
      {
        unified: "1faf6-1f3fb",
        native: "🫶🏻"
      },
      {
        unified: "1faf6-1f3fc",
        native: "🫶🏼"
      },
      {
        unified: "1faf6-1f3fd",
        native: "🫶🏽"
      },
      {
        unified: "1faf6-1f3fe",
        native: "🫶🏾"
      },
      {
        unified: "1faf6-1f3ff",
        native: "🫶🏿"
      }
    ],
    version: 14
  },
  open_hands: {
    id: "open_hands",
    name: "Open Hands",
    keywords: [
      "fingers",
      "butterfly"
    ],
    skins: [
      {
        unified: "1f450",
        native: "👐"
      },
      {
        unified: "1f450-1f3fb",
        native: "👐🏻"
      },
      {
        unified: "1f450-1f3fc",
        native: "👐🏼"
      },
      {
        unified: "1f450-1f3fd",
        native: "👐🏽"
      },
      {
        unified: "1f450-1f3fe",
        native: "👐🏾"
      },
      {
        unified: "1f450-1f3ff",
        native: "👐🏿"
      }
    ],
    version: 1
  },
  palms_up_together: {
    id: "palms_up_together",
    name: "Palms Up Together",
    keywords: [
      "hands",
      "gesture",
      "cupped",
      "prayer"
    ],
    skins: [
      {
        unified: "1f932",
        native: "🤲"
      },
      {
        unified: "1f932-1f3fb",
        native: "🤲🏻"
      },
      {
        unified: "1f932-1f3fc",
        native: "🤲🏼"
      },
      {
        unified: "1f932-1f3fd",
        native: "🤲🏽"
      },
      {
        unified: "1f932-1f3fe",
        native: "🤲🏾"
      },
      {
        unified: "1f932-1f3ff",
        native: "🤲🏿"
      }
    ],
    version: 5
  },
  handshake: {
    id: "handshake",
    name: "Handshake",
    keywords: [
      "agreement",
      "shake"
    ],
    skins: [
      {
        unified: "1f91d",
        native: "🤝"
      },
      {
        unified: "1f91d-1f3fb",
        native: "🤝🏻"
      },
      {
        unified: "1f91d-1f3fc",
        native: "🤝🏼"
      },
      {
        unified: "1f91d-1f3fd",
        native: "🤝🏽"
      },
      {
        unified: "1f91d-1f3fe",
        native: "🤝🏾"
      },
      {
        unified: "1f91d-1f3ff",
        native: "🤝🏿"
      }
    ],
    version: 3
  },
  pray: {
    id: "pray",
    name: "Folded Hands",
    keywords: [
      "pray",
      "please",
      "hope",
      "wish",
      "namaste",
      "highfive",
      "high",
      "five"
    ],
    skins: [
      {
        unified: "1f64f",
        native: "🙏"
      },
      {
        unified: "1f64f-1f3fb",
        native: "🙏🏻"
      },
      {
        unified: "1f64f-1f3fc",
        native: "🙏🏼"
      },
      {
        unified: "1f64f-1f3fd",
        native: "🙏🏽"
      },
      {
        unified: "1f64f-1f3fe",
        native: "🙏🏾"
      },
      {
        unified: "1f64f-1f3ff",
        native: "🙏🏿"
      }
    ],
    version: 1
  },
  writing_hand: {
    id: "writing_hand",
    name: "Writing Hand",
    keywords: [
      "lower",
      "left",
      "ballpoint",
      "pen",
      "stationery",
      "write",
      "compose"
    ],
    skins: [
      {
        unified: "270d-fe0f",
        native: "✍️"
      },
      {
        unified: "270d-1f3fb",
        native: "✍🏻"
      },
      {
        unified: "270d-1f3fc",
        native: "✍🏼"
      },
      {
        unified: "270d-1f3fd",
        native: "✍🏽"
      },
      {
        unified: "270d-1f3fe",
        native: "✍🏾"
      },
      {
        unified: "270d-1f3ff",
        native: "✍🏿"
      }
    ],
    version: 1
  },
  nail_care: {
    id: "nail_care",
    name: "Nail Polish",
    keywords: [
      "care",
      "beauty",
      "manicure",
      "finger",
      "fashion"
    ],
    skins: [
      {
        unified: "1f485",
        native: "💅"
      },
      {
        unified: "1f485-1f3fb",
        native: "💅🏻"
      },
      {
        unified: "1f485-1f3fc",
        native: "💅🏼"
      },
      {
        unified: "1f485-1f3fd",
        native: "💅🏽"
      },
      {
        unified: "1f485-1f3fe",
        native: "💅🏾"
      },
      {
        unified: "1f485-1f3ff",
        native: "💅🏿"
      }
    ],
    version: 1
  },
  selfie: {
    id: "selfie",
    name: "Selfie",
    keywords: [
      "camera",
      "phone"
    ],
    skins: [
      {
        unified: "1f933",
        native: "🤳"
      },
      {
        unified: "1f933-1f3fb",
        native: "🤳🏻"
      },
      {
        unified: "1f933-1f3fc",
        native: "🤳🏼"
      },
      {
        unified: "1f933-1f3fd",
        native: "🤳🏽"
      },
      {
        unified: "1f933-1f3fe",
        native: "🤳🏾"
      },
      {
        unified: "1f933-1f3ff",
        native: "🤳🏿"
      }
    ],
    version: 3
  },
  muscle: {
    id: "muscle",
    name: "Flexed Biceps",
    keywords: [
      "muscle",
      "arm",
      "flex",
      "hand",
      "summer",
      "strong"
    ],
    skins: [
      {
        unified: "1f4aa",
        native: "💪"
      },
      {
        unified: "1f4aa-1f3fb",
        native: "💪🏻"
      },
      {
        unified: "1f4aa-1f3fc",
        native: "💪🏼"
      },
      {
        unified: "1f4aa-1f3fd",
        native: "💪🏽"
      },
      {
        unified: "1f4aa-1f3fe",
        native: "💪🏾"
      },
      {
        unified: "1f4aa-1f3ff",
        native: "💪🏿"
      }
    ],
    version: 1
  },
  mechanical_arm: {
    id: "mechanical_arm",
    name: "Mechanical Arm",
    keywords: [
      "accessibility"
    ],
    skins: [
      {
        unified: "1f9be",
        native: "🦾"
      }
    ],
    version: 12
  },
  mechanical_leg: {
    id: "mechanical_leg",
    name: "Mechanical Leg",
    keywords: [
      "accessibility"
    ],
    skins: [
      {
        unified: "1f9bf",
        native: "🦿"
      }
    ],
    version: 12
  },
  leg: {
    id: "leg",
    name: "Leg",
    keywords: [
      "kick",
      "limb"
    ],
    skins: [
      {
        unified: "1f9b5",
        native: "🦵"
      },
      {
        unified: "1f9b5-1f3fb",
        native: "🦵🏻"
      },
      {
        unified: "1f9b5-1f3fc",
        native: "🦵🏼"
      },
      {
        unified: "1f9b5-1f3fd",
        native: "🦵🏽"
      },
      {
        unified: "1f9b5-1f3fe",
        native: "🦵🏾"
      },
      {
        unified: "1f9b5-1f3ff",
        native: "🦵🏿"
      }
    ],
    version: 11
  },
  foot: {
    id: "foot",
    name: "Foot",
    keywords: [
      "kick",
      "stomp"
    ],
    skins: [
      {
        unified: "1f9b6",
        native: "🦶"
      },
      {
        unified: "1f9b6-1f3fb",
        native: "🦶🏻"
      },
      {
        unified: "1f9b6-1f3fc",
        native: "🦶🏼"
      },
      {
        unified: "1f9b6-1f3fd",
        native: "🦶🏽"
      },
      {
        unified: "1f9b6-1f3fe",
        native: "🦶🏾"
      },
      {
        unified: "1f9b6-1f3ff",
        native: "🦶🏿"
      }
    ],
    version: 11
  },
  ear: {
    id: "ear",
    name: "Ear",
    keywords: [
      "face",
      "hear",
      "sound",
      "listen"
    ],
    skins: [
      {
        unified: "1f442",
        native: "👂"
      },
      {
        unified: "1f442-1f3fb",
        native: "👂🏻"
      },
      {
        unified: "1f442-1f3fc",
        native: "👂🏼"
      },
      {
        unified: "1f442-1f3fd",
        native: "👂🏽"
      },
      {
        unified: "1f442-1f3fe",
        native: "👂🏾"
      },
      {
        unified: "1f442-1f3ff",
        native: "👂🏿"
      }
    ],
    version: 1
  },
  ear_with_hearing_aid: {
    id: "ear_with_hearing_aid",
    name: "Ear with Hearing Aid",
    keywords: [
      "accessibility"
    ],
    skins: [
      {
        unified: "1f9bb",
        native: "🦻"
      },
      {
        unified: "1f9bb-1f3fb",
        native: "🦻🏻"
      },
      {
        unified: "1f9bb-1f3fc",
        native: "🦻🏼"
      },
      {
        unified: "1f9bb-1f3fd",
        native: "🦻🏽"
      },
      {
        unified: "1f9bb-1f3fe",
        native: "🦻🏾"
      },
      {
        unified: "1f9bb-1f3ff",
        native: "🦻🏿"
      }
    ],
    version: 12
  },
  nose: {
    id: "nose",
    name: "Nose",
    keywords: [
      "smell",
      "sniff"
    ],
    skins: [
      {
        unified: "1f443",
        native: "👃"
      },
      {
        unified: "1f443-1f3fb",
        native: "👃🏻"
      },
      {
        unified: "1f443-1f3fc",
        native: "👃🏼"
      },
      {
        unified: "1f443-1f3fd",
        native: "👃🏽"
      },
      {
        unified: "1f443-1f3fe",
        native: "👃🏾"
      },
      {
        unified: "1f443-1f3ff",
        native: "👃🏿"
      }
    ],
    version: 1
  },
  brain: {
    id: "brain",
    name: "Brain",
    keywords: [
      "smart",
      "intelligent"
    ],
    skins: [
      {
        unified: "1f9e0",
        native: "🧠"
      }
    ],
    version: 5
  },
  anatomical_heart: {
    id: "anatomical_heart",
    name: "Anatomical Heart",
    keywords: [
      "health",
      "heartbeat"
    ],
    skins: [
      {
        unified: "1fac0",
        native: "🫀"
      }
    ],
    version: 13
  },
  lungs: {
    id: "lungs",
    name: "Lungs",
    keywords: [
      "breathe"
    ],
    skins: [
      {
        unified: "1fac1",
        native: "🫁"
      }
    ],
    version: 13
  },
  tooth: {
    id: "tooth",
    name: "Tooth",
    keywords: [
      "teeth",
      "dentist"
    ],
    skins: [
      {
        unified: "1f9b7",
        native: "🦷"
      }
    ],
    version: 11
  },
  bone: {
    id: "bone",
    name: "Bone",
    keywords: [
      "skeleton"
    ],
    skins: [
      {
        unified: "1f9b4",
        native: "🦴"
      }
    ],
    version: 11
  },
  eyes: {
    id: "eyes",
    name: "Eyes",
    keywords: [
      "look",
      "watch",
      "stalk",
      "peek",
      "see"
    ],
    skins: [
      {
        unified: "1f440",
        native: "👀"
      }
    ],
    version: 1
  },
  eye: {
    id: "eye",
    name: "Eye",
    keywords: [
      "face",
      "look",
      "see",
      "watch",
      "stare"
    ],
    skins: [
      {
        unified: "1f441-fe0f",
        native: "👁️"
      }
    ],
    version: 1
  },
  tongue: {
    id: "tongue",
    name: "Tongue",
    keywords: [
      "mouth",
      "playful"
    ],
    skins: [
      {
        unified: "1f445",
        native: "👅"
      }
    ],
    version: 1
  },
  lips: {
    id: "lips",
    name: "Mouth",
    keywords: [
      "lips",
      "kiss"
    ],
    skins: [
      {
        unified: "1f444",
        native: "👄"
      }
    ],
    version: 1
  },
  biting_lip: {
    id: "biting_lip",
    name: "Biting Lip",
    keywords: [
      "flirt",
      "sexy",
      "pain",
      "worry"
    ],
    skins: [
      {
        unified: "1fae6",
        native: "🫦"
      }
    ],
    version: 14
  },
  baby: {
    id: "baby",
    name: "Baby",
    keywords: [
      "child",
      "boy",
      "girl",
      "toddler"
    ],
    skins: [
      {
        unified: "1f476",
        native: "👶"
      },
      {
        unified: "1f476-1f3fb",
        native: "👶🏻"
      },
      {
        unified: "1f476-1f3fc",
        native: "👶🏼"
      },
      {
        unified: "1f476-1f3fd",
        native: "👶🏽"
      },
      {
        unified: "1f476-1f3fe",
        native: "👶🏾"
      },
      {
        unified: "1f476-1f3ff",
        native: "👶🏿"
      }
    ],
    version: 1
  },
  child: {
    id: "child",
    name: "Child",
    keywords: [
      "gender",
      "neutral",
      "young"
    ],
    skins: [
      {
        unified: "1f9d2",
        native: "🧒"
      },
      {
        unified: "1f9d2-1f3fb",
        native: "🧒🏻"
      },
      {
        unified: "1f9d2-1f3fc",
        native: "🧒🏼"
      },
      {
        unified: "1f9d2-1f3fd",
        native: "🧒🏽"
      },
      {
        unified: "1f9d2-1f3fe",
        native: "🧒🏾"
      },
      {
        unified: "1f9d2-1f3ff",
        native: "🧒🏿"
      }
    ],
    version: 5
  },
  boy: {
    id: "boy",
    name: "Boy",
    keywords: [
      "man",
      "male",
      "guy",
      "teenager"
    ],
    skins: [
      {
        unified: "1f466",
        native: "👦"
      },
      {
        unified: "1f466-1f3fb",
        native: "👦🏻"
      },
      {
        unified: "1f466-1f3fc",
        native: "👦🏼"
      },
      {
        unified: "1f466-1f3fd",
        native: "👦🏽"
      },
      {
        unified: "1f466-1f3fe",
        native: "👦🏾"
      },
      {
        unified: "1f466-1f3ff",
        native: "👦🏿"
      }
    ],
    version: 1
  },
  girl: {
    id: "girl",
    name: "Girl",
    keywords: [
      "female",
      "woman",
      "teenager"
    ],
    skins: [
      {
        unified: "1f467",
        native: "👧"
      },
      {
        unified: "1f467-1f3fb",
        native: "👧🏻"
      },
      {
        unified: "1f467-1f3fc",
        native: "👧🏼"
      },
      {
        unified: "1f467-1f3fd",
        native: "👧🏽"
      },
      {
        unified: "1f467-1f3fe",
        native: "👧🏾"
      },
      {
        unified: "1f467-1f3ff",
        native: "👧🏿"
      }
    ],
    version: 1
  },
  adult: {
    id: "adult",
    name: "Adult",
    keywords: [
      "person",
      "gender",
      "neutral"
    ],
    skins: [
      {
        unified: "1f9d1",
        native: "🧑"
      },
      {
        unified: "1f9d1-1f3fb",
        native: "🧑🏻"
      },
      {
        unified: "1f9d1-1f3fc",
        native: "🧑🏼"
      },
      {
        unified: "1f9d1-1f3fd",
        native: "🧑🏽"
      },
      {
        unified: "1f9d1-1f3fe",
        native: "🧑🏾"
      },
      {
        unified: "1f9d1-1f3ff",
        native: "🧑🏿"
      }
    ],
    version: 5
  },
  person_with_blond_hair: {
    id: "person_with_blond_hair",
    name: "Person Blond Hair",
    keywords: [
      "with",
      "hairstyle"
    ],
    skins: [
      {
        unified: "1f471",
        native: "👱"
      },
      {
        unified: "1f471-1f3fb",
        native: "👱🏻"
      },
      {
        unified: "1f471-1f3fc",
        native: "👱🏼"
      },
      {
        unified: "1f471-1f3fd",
        native: "👱🏽"
      },
      {
        unified: "1f471-1f3fe",
        native: "👱🏾"
      },
      {
        unified: "1f471-1f3ff",
        native: "👱🏿"
      }
    ],
    version: 1
  },
  man: {
    id: "man",
    name: "Man",
    keywords: [
      "mustache",
      "father",
      "dad",
      "guy",
      "classy",
      "sir",
      "moustache"
    ],
    skins: [
      {
        unified: "1f468",
        native: "👨"
      },
      {
        unified: "1f468-1f3fb",
        native: "👨🏻"
      },
      {
        unified: "1f468-1f3fc",
        native: "👨🏼"
      },
      {
        unified: "1f468-1f3fd",
        native: "👨🏽"
      },
      {
        unified: "1f468-1f3fe",
        native: "👨🏾"
      },
      {
        unified: "1f468-1f3ff",
        native: "👨🏿"
      }
    ],
    version: 1
  },
  bearded_person: {
    id: "bearded_person",
    name: "Person Beard",
    keywords: [
      "bearded",
      "man",
      "bewhiskered"
    ],
    skins: [
      {
        unified: "1f9d4",
        native: "🧔"
      },
      {
        unified: "1f9d4-1f3fb",
        native: "🧔🏻"
      },
      {
        unified: "1f9d4-1f3fc",
        native: "🧔🏼"
      },
      {
        unified: "1f9d4-1f3fd",
        native: "🧔🏽"
      },
      {
        unified: "1f9d4-1f3fe",
        native: "🧔🏾"
      },
      {
        unified: "1f9d4-1f3ff",
        native: "🧔🏿"
      }
    ],
    version: 5
  },
  man_with_beard: {
    id: "man_with_beard",
    name: "Man: Beard",
    keywords: [
      "man",
      "with",
      "facial",
      "hair"
    ],
    skins: [
      {
        unified: "1f9d4-200d-2642-fe0f",
        native: "🧔‍♂️"
      },
      {
        unified: "1f9d4-1f3fb-200d-2642-fe0f",
        native: "🧔🏻‍♂️"
      },
      {
        unified: "1f9d4-1f3fc-200d-2642-fe0f",
        native: "🧔🏼‍♂️"
      },
      {
        unified: "1f9d4-1f3fd-200d-2642-fe0f",
        native: "🧔🏽‍♂️"
      },
      {
        unified: "1f9d4-1f3fe-200d-2642-fe0f",
        native: "🧔🏾‍♂️"
      },
      {
        unified: "1f9d4-1f3ff-200d-2642-fe0f",
        native: "🧔🏿‍♂️"
      }
    ],
    version: 13.1
  },
  woman_with_beard: {
    id: "woman_with_beard",
    name: "Woman: Beard",
    keywords: [
      "woman",
      "with",
      "facial",
      "hair"
    ],
    skins: [
      {
        unified: "1f9d4-200d-2640-fe0f",
        native: "🧔‍♀️"
      },
      {
        unified: "1f9d4-1f3fb-200d-2640-fe0f",
        native: "🧔🏻‍♀️"
      },
      {
        unified: "1f9d4-1f3fc-200d-2640-fe0f",
        native: "🧔🏼‍♀️"
      },
      {
        unified: "1f9d4-1f3fd-200d-2640-fe0f",
        native: "🧔🏽‍♀️"
      },
      {
        unified: "1f9d4-1f3fe-200d-2640-fe0f",
        native: "🧔🏾‍♀️"
      },
      {
        unified: "1f9d4-1f3ff-200d-2640-fe0f",
        native: "🧔🏿‍♀️"
      }
    ],
    version: 13.1
  },
  red_haired_man: {
    id: "red_haired_man",
    name: "Man: Red Hair",
    keywords: [
      "haired",
      "man",
      "hairstyle"
    ],
    skins: [
      {
        unified: "1f468-200d-1f9b0",
        native: "👨‍🦰"
      },
      {
        unified: "1f468-1f3fb-200d-1f9b0",
        native: "👨🏻‍🦰"
      },
      {
        unified: "1f468-1f3fc-200d-1f9b0",
        native: "👨🏼‍🦰"
      },
      {
        unified: "1f468-1f3fd-200d-1f9b0",
        native: "👨🏽‍🦰"
      },
      {
        unified: "1f468-1f3fe-200d-1f9b0",
        native: "👨🏾‍🦰"
      },
      {
        unified: "1f468-1f3ff-200d-1f9b0",
        native: "👨🏿‍🦰"
      }
    ],
    version: 11
  },
  curly_haired_man: {
    id: "curly_haired_man",
    name: "Man: Curly Hair",
    keywords: [
      "haired",
      "man",
      "hairstyle"
    ],
    skins: [
      {
        unified: "1f468-200d-1f9b1",
        native: "👨‍🦱"
      },
      {
        unified: "1f468-1f3fb-200d-1f9b1",
        native: "👨🏻‍🦱"
      },
      {
        unified: "1f468-1f3fc-200d-1f9b1",
        native: "👨🏼‍🦱"
      },
      {
        unified: "1f468-1f3fd-200d-1f9b1",
        native: "👨🏽‍🦱"
      },
      {
        unified: "1f468-1f3fe-200d-1f9b1",
        native: "👨🏾‍🦱"
      },
      {
        unified: "1f468-1f3ff-200d-1f9b1",
        native: "👨🏿‍🦱"
      }
    ],
    version: 11
  },
  white_haired_man: {
    id: "white_haired_man",
    name: "Man: White Hair",
    keywords: [
      "haired",
      "man",
      "old",
      "elder"
    ],
    skins: [
      {
        unified: "1f468-200d-1f9b3",
        native: "👨‍🦳"
      },
      {
        unified: "1f468-1f3fb-200d-1f9b3",
        native: "👨🏻‍🦳"
      },
      {
        unified: "1f468-1f3fc-200d-1f9b3",
        native: "👨🏼‍🦳"
      },
      {
        unified: "1f468-1f3fd-200d-1f9b3",
        native: "👨🏽‍🦳"
      },
      {
        unified: "1f468-1f3fe-200d-1f9b3",
        native: "👨🏾‍🦳"
      },
      {
        unified: "1f468-1f3ff-200d-1f9b3",
        native: "👨🏿‍🦳"
      }
    ],
    version: 11
  },
  bald_man: {
    id: "bald_man",
    name: "Man: Bald",
    keywords: [
      "man",
      "hairless"
    ],
    skins: [
      {
        unified: "1f468-200d-1f9b2",
        native: "👨‍🦲"
      },
      {
        unified: "1f468-1f3fb-200d-1f9b2",
        native: "👨🏻‍🦲"
      },
      {
        unified: "1f468-1f3fc-200d-1f9b2",
        native: "👨🏼‍🦲"
      },
      {
        unified: "1f468-1f3fd-200d-1f9b2",
        native: "👨🏽‍🦲"
      },
      {
        unified: "1f468-1f3fe-200d-1f9b2",
        native: "👨🏾‍🦲"
      },
      {
        unified: "1f468-1f3ff-200d-1f9b2",
        native: "👨🏿‍🦲"
      }
    ],
    version: 11
  },
  woman: {
    id: "woman",
    name: "Woman",
    keywords: [
      "female",
      "girls",
      "lady"
    ],
    skins: [
      {
        unified: "1f469",
        native: "👩"
      },
      {
        unified: "1f469-1f3fb",
        native: "👩🏻"
      },
      {
        unified: "1f469-1f3fc",
        native: "👩🏼"
      },
      {
        unified: "1f469-1f3fd",
        native: "👩🏽"
      },
      {
        unified: "1f469-1f3fe",
        native: "👩🏾"
      },
      {
        unified: "1f469-1f3ff",
        native: "👩🏿"
      }
    ],
    version: 1
  },
  red_haired_woman: {
    id: "red_haired_woman",
    name: "Woman: Red Hair",
    keywords: [
      "haired",
      "woman",
      "hairstyle"
    ],
    skins: [
      {
        unified: "1f469-200d-1f9b0",
        native: "👩‍🦰"
      },
      {
        unified: "1f469-1f3fb-200d-1f9b0",
        native: "👩🏻‍🦰"
      },
      {
        unified: "1f469-1f3fc-200d-1f9b0",
        native: "👩🏼‍🦰"
      },
      {
        unified: "1f469-1f3fd-200d-1f9b0",
        native: "👩🏽‍🦰"
      },
      {
        unified: "1f469-1f3fe-200d-1f9b0",
        native: "👩🏾‍🦰"
      },
      {
        unified: "1f469-1f3ff-200d-1f9b0",
        native: "👩🏿‍🦰"
      }
    ],
    version: 11
  },
  red_haired_person: {
    id: "red_haired_person",
    name: "Person: Red Hair",
    keywords: [
      "haired",
      "person",
      "hairstyle"
    ],
    skins: [
      {
        unified: "1f9d1-200d-1f9b0",
        native: "🧑‍🦰"
      },
      {
        unified: "1f9d1-1f3fb-200d-1f9b0",
        native: "🧑🏻‍🦰"
      },
      {
        unified: "1f9d1-1f3fc-200d-1f9b0",
        native: "🧑🏼‍🦰"
      },
      {
        unified: "1f9d1-1f3fd-200d-1f9b0",
        native: "🧑🏽‍🦰"
      },
      {
        unified: "1f9d1-1f3fe-200d-1f9b0",
        native: "🧑🏾‍🦰"
      },
      {
        unified: "1f9d1-1f3ff-200d-1f9b0",
        native: "🧑🏿‍🦰"
      }
    ],
    version: 12.1
  },
  curly_haired_woman: {
    id: "curly_haired_woman",
    name: "Woman: Curly Hair",
    keywords: [
      "haired",
      "woman",
      "hairstyle"
    ],
    skins: [
      {
        unified: "1f469-200d-1f9b1",
        native: "👩‍🦱"
      },
      {
        unified: "1f469-1f3fb-200d-1f9b1",
        native: "👩🏻‍🦱"
      },
      {
        unified: "1f469-1f3fc-200d-1f9b1",
        native: "👩🏼‍🦱"
      },
      {
        unified: "1f469-1f3fd-200d-1f9b1",
        native: "👩🏽‍🦱"
      },
      {
        unified: "1f469-1f3fe-200d-1f9b1",
        native: "👩🏾‍🦱"
      },
      {
        unified: "1f469-1f3ff-200d-1f9b1",
        native: "👩🏿‍🦱"
      }
    ],
    version: 11
  },
  curly_haired_person: {
    id: "curly_haired_person",
    name: "Person: Curly Hair",
    keywords: [
      "haired",
      "person",
      "hairstyle"
    ],
    skins: [
      {
        unified: "1f9d1-200d-1f9b1",
        native: "🧑‍🦱"
      },
      {
        unified: "1f9d1-1f3fb-200d-1f9b1",
        native: "🧑🏻‍🦱"
      },
      {
        unified: "1f9d1-1f3fc-200d-1f9b1",
        native: "🧑🏼‍🦱"
      },
      {
        unified: "1f9d1-1f3fd-200d-1f9b1",
        native: "🧑🏽‍🦱"
      },
      {
        unified: "1f9d1-1f3fe-200d-1f9b1",
        native: "🧑🏾‍🦱"
      },
      {
        unified: "1f9d1-1f3ff-200d-1f9b1",
        native: "🧑🏿‍🦱"
      }
    ],
    version: 12.1
  },
  white_haired_woman: {
    id: "white_haired_woman",
    name: "Woman: White Hair",
    keywords: [
      "haired",
      "woman",
      "old",
      "elder"
    ],
    skins: [
      {
        unified: "1f469-200d-1f9b3",
        native: "👩‍🦳"
      },
      {
        unified: "1f469-1f3fb-200d-1f9b3",
        native: "👩🏻‍🦳"
      },
      {
        unified: "1f469-1f3fc-200d-1f9b3",
        native: "👩🏼‍🦳"
      },
      {
        unified: "1f469-1f3fd-200d-1f9b3",
        native: "👩🏽‍🦳"
      },
      {
        unified: "1f469-1f3fe-200d-1f9b3",
        native: "👩🏾‍🦳"
      },
      {
        unified: "1f469-1f3ff-200d-1f9b3",
        native: "👩🏿‍🦳"
      }
    ],
    version: 11
  },
  white_haired_person: {
    id: "white_haired_person",
    name: "Person: White Hair",
    keywords: [
      "haired",
      "person",
      "elder",
      "old"
    ],
    skins: [
      {
        unified: "1f9d1-200d-1f9b3",
        native: "🧑‍🦳"
      },
      {
        unified: "1f9d1-1f3fb-200d-1f9b3",
        native: "🧑🏻‍🦳"
      },
      {
        unified: "1f9d1-1f3fc-200d-1f9b3",
        native: "🧑🏼‍🦳"
      },
      {
        unified: "1f9d1-1f3fd-200d-1f9b3",
        native: "🧑🏽‍🦳"
      },
      {
        unified: "1f9d1-1f3fe-200d-1f9b3",
        native: "🧑🏾‍🦳"
      },
      {
        unified: "1f9d1-1f3ff-200d-1f9b3",
        native: "🧑🏿‍🦳"
      }
    ],
    version: 12.1
  },
  bald_woman: {
    id: "bald_woman",
    name: "Woman: Bald",
    keywords: [
      "woman",
      "hairless"
    ],
    skins: [
      {
        unified: "1f469-200d-1f9b2",
        native: "👩‍🦲"
      },
      {
        unified: "1f469-1f3fb-200d-1f9b2",
        native: "👩🏻‍🦲"
      },
      {
        unified: "1f469-1f3fc-200d-1f9b2",
        native: "👩🏼‍🦲"
      },
      {
        unified: "1f469-1f3fd-200d-1f9b2",
        native: "👩🏽‍🦲"
      },
      {
        unified: "1f469-1f3fe-200d-1f9b2",
        native: "👩🏾‍🦲"
      },
      {
        unified: "1f469-1f3ff-200d-1f9b2",
        native: "👩🏿‍🦲"
      }
    ],
    version: 11
  },
  bald_person: {
    id: "bald_person",
    name: "Person: Bald",
    keywords: [
      "person",
      "hairless"
    ],
    skins: [
      {
        unified: "1f9d1-200d-1f9b2",
        native: "🧑‍🦲"
      },
      {
        unified: "1f9d1-1f3fb-200d-1f9b2",
        native: "🧑🏻‍🦲"
      },
      {
        unified: "1f9d1-1f3fc-200d-1f9b2",
        native: "🧑🏼‍🦲"
      },
      {
        unified: "1f9d1-1f3fd-200d-1f9b2",
        native: "🧑🏽‍🦲"
      },
      {
        unified: "1f9d1-1f3fe-200d-1f9b2",
        native: "🧑🏾‍🦲"
      },
      {
        unified: "1f9d1-1f3ff-200d-1f9b2",
        native: "🧑🏿‍🦲"
      }
    ],
    version: 12.1
  },
  "blond-haired-woman": {
    id: "blond-haired-woman",
    name: "Woman: Blond Hair",
    keywords: [
      "haired-woman",
      "woman",
      "female",
      "girl",
      "blonde",
      "person"
    ],
    skins: [
      {
        unified: "1f471-200d-2640-fe0f",
        native: "👱‍♀️"
      },
      {
        unified: "1f471-1f3fb-200d-2640-fe0f",
        native: "👱🏻‍♀️"
      },
      {
        unified: "1f471-1f3fc-200d-2640-fe0f",
        native: "👱🏼‍♀️"
      },
      {
        unified: "1f471-1f3fd-200d-2640-fe0f",
        native: "👱🏽‍♀️"
      },
      {
        unified: "1f471-1f3fe-200d-2640-fe0f",
        native: "👱🏾‍♀️"
      },
      {
        unified: "1f471-1f3ff-200d-2640-fe0f",
        native: "👱🏿‍♀️"
      }
    ],
    version: 4
  },
  "blond-haired-man": {
    id: "blond-haired-man",
    name: "Man: Blond Hair",
    keywords: [
      "haired-man",
      "man",
      "male",
      "boy",
      "blonde",
      "guy",
      "person"
    ],
    skins: [
      {
        unified: "1f471-200d-2642-fe0f",
        native: "👱‍♂️"
      },
      {
        unified: "1f471-1f3fb-200d-2642-fe0f",
        native: "👱🏻‍♂️"
      },
      {
        unified: "1f471-1f3fc-200d-2642-fe0f",
        native: "👱🏼‍♂️"
      },
      {
        unified: "1f471-1f3fd-200d-2642-fe0f",
        native: "👱🏽‍♂️"
      },
      {
        unified: "1f471-1f3fe-200d-2642-fe0f",
        native: "👱🏾‍♂️"
      },
      {
        unified: "1f471-1f3ff-200d-2642-fe0f",
        native: "👱🏿‍♂️"
      }
    ],
    version: 4
  },
  older_adult: {
    id: "older_adult",
    name: "Older Adult",
    keywords: [
      "person",
      "human",
      "elder",
      "senior",
      "gender",
      "neutral"
    ],
    skins: [
      {
        unified: "1f9d3",
        native: "🧓"
      },
      {
        unified: "1f9d3-1f3fb",
        native: "🧓🏻"
      },
      {
        unified: "1f9d3-1f3fc",
        native: "🧓🏼"
      },
      {
        unified: "1f9d3-1f3fd",
        native: "🧓🏽"
      },
      {
        unified: "1f9d3-1f3fe",
        native: "🧓🏾"
      },
      {
        unified: "1f9d3-1f3ff",
        native: "🧓🏿"
      }
    ],
    version: 5
  },
  older_man: {
    id: "older_man",
    name: "Old Man",
    keywords: [
      "older",
      "human",
      "male",
      "men",
      "elder",
      "senior"
    ],
    skins: [
      {
        unified: "1f474",
        native: "👴"
      },
      {
        unified: "1f474-1f3fb",
        native: "👴🏻"
      },
      {
        unified: "1f474-1f3fc",
        native: "👴🏼"
      },
      {
        unified: "1f474-1f3fd",
        native: "👴🏽"
      },
      {
        unified: "1f474-1f3fe",
        native: "👴🏾"
      },
      {
        unified: "1f474-1f3ff",
        native: "👴🏿"
      }
    ],
    version: 1
  },
  older_woman: {
    id: "older_woman",
    name: "Old Woman",
    keywords: [
      "older",
      "human",
      "female",
      "women",
      "lady",
      "elder",
      "senior"
    ],
    skins: [
      {
        unified: "1f475",
        native: "👵"
      },
      {
        unified: "1f475-1f3fb",
        native: "👵🏻"
      },
      {
        unified: "1f475-1f3fc",
        native: "👵🏼"
      },
      {
        unified: "1f475-1f3fd",
        native: "👵🏽"
      },
      {
        unified: "1f475-1f3fe",
        native: "👵🏾"
      },
      {
        unified: "1f475-1f3ff",
        native: "👵🏿"
      }
    ],
    version: 1
  },
  person_frowning: {
    id: "person_frowning",
    name: "Person Frowning",
    keywords: [
      "worried"
    ],
    skins: [
      {
        unified: "1f64d",
        native: "🙍"
      },
      {
        unified: "1f64d-1f3fb",
        native: "🙍🏻"
      },
      {
        unified: "1f64d-1f3fc",
        native: "🙍🏼"
      },
      {
        unified: "1f64d-1f3fd",
        native: "🙍🏽"
      },
      {
        unified: "1f64d-1f3fe",
        native: "🙍🏾"
      },
      {
        unified: "1f64d-1f3ff",
        native: "🙍🏿"
      }
    ],
    version: 1
  },
  "man-frowning": {
    id: "man-frowning",
    name: "Man Frowning",
    keywords: [
      "male",
      "boy",
      "sad",
      "depressed",
      "discouraged",
      "unhappy"
    ],
    skins: [
      {
        unified: "1f64d-200d-2642-fe0f",
        native: "🙍‍♂️"
      },
      {
        unified: "1f64d-1f3fb-200d-2642-fe0f",
        native: "🙍🏻‍♂️"
      },
      {
        unified: "1f64d-1f3fc-200d-2642-fe0f",
        native: "🙍🏼‍♂️"
      },
      {
        unified: "1f64d-1f3fd-200d-2642-fe0f",
        native: "🙍🏽‍♂️"
      },
      {
        unified: "1f64d-1f3fe-200d-2642-fe0f",
        native: "🙍🏾‍♂️"
      },
      {
        unified: "1f64d-1f3ff-200d-2642-fe0f",
        native: "🙍🏿‍♂️"
      }
    ],
    version: 4
  },
  "woman-frowning": {
    id: "woman-frowning",
    name: "Woman Frowning",
    keywords: [
      "female",
      "girl",
      "sad",
      "depressed",
      "discouraged",
      "unhappy"
    ],
    skins: [
      {
        unified: "1f64d-200d-2640-fe0f",
        native: "🙍‍♀️"
      },
      {
        unified: "1f64d-1f3fb-200d-2640-fe0f",
        native: "🙍🏻‍♀️"
      },
      {
        unified: "1f64d-1f3fc-200d-2640-fe0f",
        native: "🙍🏼‍♀️"
      },
      {
        unified: "1f64d-1f3fd-200d-2640-fe0f",
        native: "🙍🏽‍♀️"
      },
      {
        unified: "1f64d-1f3fe-200d-2640-fe0f",
        native: "🙍🏾‍♀️"
      },
      {
        unified: "1f64d-1f3ff-200d-2640-fe0f",
        native: "🙍🏿‍♀️"
      }
    ],
    version: 4
  },
  person_with_pouting_face: {
    id: "person_with_pouting_face",
    name: "Person Pouting",
    keywords: [
      "with",
      "face",
      "upset"
    ],
    skins: [
      {
        unified: "1f64e",
        native: "🙎"
      },
      {
        unified: "1f64e-1f3fb",
        native: "🙎🏻"
      },
      {
        unified: "1f64e-1f3fc",
        native: "🙎🏼"
      },
      {
        unified: "1f64e-1f3fd",
        native: "🙎🏽"
      },
      {
        unified: "1f64e-1f3fe",
        native: "🙎🏾"
      },
      {
        unified: "1f64e-1f3ff",
        native: "🙎🏿"
      }
    ],
    version: 1
  },
  "man-pouting": {
    id: "man-pouting",
    name: "Man Pouting",
    keywords: [
      "male",
      "boy"
    ],
    skins: [
      {
        unified: "1f64e-200d-2642-fe0f",
        native: "🙎‍♂️"
      },
      {
        unified: "1f64e-1f3fb-200d-2642-fe0f",
        native: "🙎🏻‍♂️"
      },
      {
        unified: "1f64e-1f3fc-200d-2642-fe0f",
        native: "🙎🏼‍♂️"
      },
      {
        unified: "1f64e-1f3fd-200d-2642-fe0f",
        native: "🙎🏽‍♂️"
      },
      {
        unified: "1f64e-1f3fe-200d-2642-fe0f",
        native: "🙎🏾‍♂️"
      },
      {
        unified: "1f64e-1f3ff-200d-2642-fe0f",
        native: "🙎🏿‍♂️"
      }
    ],
    version: 4
  },
  "woman-pouting": {
    id: "woman-pouting",
    name: "Woman Pouting",
    keywords: [
      "female",
      "girl"
    ],
    skins: [
      {
        unified: "1f64e-200d-2640-fe0f",
        native: "🙎‍♀️"
      },
      {
        unified: "1f64e-1f3fb-200d-2640-fe0f",
        native: "🙎🏻‍♀️"
      },
      {
        unified: "1f64e-1f3fc-200d-2640-fe0f",
        native: "🙎🏼‍♀️"
      },
      {
        unified: "1f64e-1f3fd-200d-2640-fe0f",
        native: "🙎🏽‍♀️"
      },
      {
        unified: "1f64e-1f3fe-200d-2640-fe0f",
        native: "🙎🏾‍♀️"
      },
      {
        unified: "1f64e-1f3ff-200d-2640-fe0f",
        native: "🙎🏿‍♀️"
      }
    ],
    version: 4
  },
  no_good: {
    id: "no_good",
    name: "Person Gesturing No",
    keywords: [
      "good",
      "decline"
    ],
    skins: [
      {
        unified: "1f645",
        native: "🙅"
      },
      {
        unified: "1f645-1f3fb",
        native: "🙅🏻"
      },
      {
        unified: "1f645-1f3fc",
        native: "🙅🏼"
      },
      {
        unified: "1f645-1f3fd",
        native: "🙅🏽"
      },
      {
        unified: "1f645-1f3fe",
        native: "🙅🏾"
      },
      {
        unified: "1f645-1f3ff",
        native: "🙅🏿"
      }
    ],
    version: 1
  },
  "man-gesturing-no": {
    id: "man-gesturing-no",
    name: "Man Gesturing No",
    keywords: [
      "gesturing-no",
      "male",
      "boy",
      "nope"
    ],
    skins: [
      {
        unified: "1f645-200d-2642-fe0f",
        native: "🙅‍♂️"
      },
      {
        unified: "1f645-1f3fb-200d-2642-fe0f",
        native: "🙅🏻‍♂️"
      },
      {
        unified: "1f645-1f3fc-200d-2642-fe0f",
        native: "🙅🏼‍♂️"
      },
      {
        unified: "1f645-1f3fd-200d-2642-fe0f",
        native: "🙅🏽‍♂️"
      },
      {
        unified: "1f645-1f3fe-200d-2642-fe0f",
        native: "🙅🏾‍♂️"
      },
      {
        unified: "1f645-1f3ff-200d-2642-fe0f",
        native: "🙅🏿‍♂️"
      }
    ],
    version: 4
  },
  "woman-gesturing-no": {
    id: "woman-gesturing-no",
    name: "Woman Gesturing No",
    keywords: [
      "gesturing-no",
      "female",
      "girl",
      "nope"
    ],
    skins: [
      {
        unified: "1f645-200d-2640-fe0f",
        native: "🙅‍♀️"
      },
      {
        unified: "1f645-1f3fb-200d-2640-fe0f",
        native: "🙅🏻‍♀️"
      },
      {
        unified: "1f645-1f3fc-200d-2640-fe0f",
        native: "🙅🏼‍♀️"
      },
      {
        unified: "1f645-1f3fd-200d-2640-fe0f",
        native: "🙅🏽‍♀️"
      },
      {
        unified: "1f645-1f3fe-200d-2640-fe0f",
        native: "🙅🏾‍♀️"
      },
      {
        unified: "1f645-1f3ff-200d-2640-fe0f",
        native: "🙅🏿‍♀️"
      }
    ],
    version: 4
  },
  ok_woman: {
    id: "ok_woman",
    name: "Person Gesturing Ok",
    keywords: [
      "woman",
      "agree"
    ],
    skins: [
      {
        unified: "1f646",
        native: "🙆"
      },
      {
        unified: "1f646-1f3fb",
        native: "🙆🏻"
      },
      {
        unified: "1f646-1f3fc",
        native: "🙆🏼"
      },
      {
        unified: "1f646-1f3fd",
        native: "🙆🏽"
      },
      {
        unified: "1f646-1f3fe",
        native: "🙆🏾"
      },
      {
        unified: "1f646-1f3ff",
        native: "🙆🏿"
      }
    ],
    version: 1
  },
  "man-gesturing-ok": {
    id: "man-gesturing-ok",
    name: "Man Gesturing Ok",
    keywords: [
      "gesturing-ok",
      "men",
      "boy",
      "male",
      "blue",
      "human"
    ],
    skins: [
      {
        unified: "1f646-200d-2642-fe0f",
        native: "🙆‍♂️"
      },
      {
        unified: "1f646-1f3fb-200d-2642-fe0f",
        native: "🙆🏻‍♂️"
      },
      {
        unified: "1f646-1f3fc-200d-2642-fe0f",
        native: "🙆🏼‍♂️"
      },
      {
        unified: "1f646-1f3fd-200d-2642-fe0f",
        native: "🙆🏽‍♂️"
      },
      {
        unified: "1f646-1f3fe-200d-2642-fe0f",
        native: "🙆🏾‍♂️"
      },
      {
        unified: "1f646-1f3ff-200d-2642-fe0f",
        native: "🙆🏿‍♂️"
      }
    ],
    version: 4
  },
  "woman-gesturing-ok": {
    id: "woman-gesturing-ok",
    name: "Woman Gesturing Ok",
    keywords: [
      "gesturing-ok",
      "women",
      "girl",
      "female",
      "pink",
      "human"
    ],
    skins: [
      {
        unified: "1f646-200d-2640-fe0f",
        native: "🙆‍♀️"
      },
      {
        unified: "1f646-1f3fb-200d-2640-fe0f",
        native: "🙆🏻‍♀️"
      },
      {
        unified: "1f646-1f3fc-200d-2640-fe0f",
        native: "🙆🏼‍♀️"
      },
      {
        unified: "1f646-1f3fd-200d-2640-fe0f",
        native: "🙆🏽‍♀️"
      },
      {
        unified: "1f646-1f3fe-200d-2640-fe0f",
        native: "🙆🏾‍♀️"
      },
      {
        unified: "1f646-1f3ff-200d-2640-fe0f",
        native: "🙆🏿‍♀️"
      }
    ],
    version: 4
  },
  information_desk_person: {
    id: "information_desk_person",
    name: "Person Tipping Hand",
    keywords: [
      "information",
      "desk"
    ],
    skins: [
      {
        unified: "1f481",
        native: "💁"
      },
      {
        unified: "1f481-1f3fb",
        native: "💁🏻"
      },
      {
        unified: "1f481-1f3fc",
        native: "💁🏼"
      },
      {
        unified: "1f481-1f3fd",
        native: "💁🏽"
      },
      {
        unified: "1f481-1f3fe",
        native: "💁🏾"
      },
      {
        unified: "1f481-1f3ff",
        native: "💁🏿"
      }
    ],
    version: 1
  },
  "man-tipping-hand": {
    id: "man-tipping-hand",
    name: "Man Tipping Hand",
    keywords: [
      "tipping-hand",
      "male",
      "boy",
      "human",
      "information"
    ],
    skins: [
      {
        unified: "1f481-200d-2642-fe0f",
        native: "💁‍♂️"
      },
      {
        unified: "1f481-1f3fb-200d-2642-fe0f",
        native: "💁🏻‍♂️"
      },
      {
        unified: "1f481-1f3fc-200d-2642-fe0f",
        native: "💁🏼‍♂️"
      },
      {
        unified: "1f481-1f3fd-200d-2642-fe0f",
        native: "💁🏽‍♂️"
      },
      {
        unified: "1f481-1f3fe-200d-2642-fe0f",
        native: "💁🏾‍♂️"
      },
      {
        unified: "1f481-1f3ff-200d-2642-fe0f",
        native: "💁🏿‍♂️"
      }
    ],
    version: 4
  },
  "woman-tipping-hand": {
    id: "woman-tipping-hand",
    name: "Woman Tipping Hand",
    keywords: [
      "tipping-hand",
      "female",
      "girl",
      "human",
      "information"
    ],
    skins: [
      {
        unified: "1f481-200d-2640-fe0f",
        native: "💁‍♀️"
      },
      {
        unified: "1f481-1f3fb-200d-2640-fe0f",
        native: "💁🏻‍♀️"
      },
      {
        unified: "1f481-1f3fc-200d-2640-fe0f",
        native: "💁🏼‍♀️"
      },
      {
        unified: "1f481-1f3fd-200d-2640-fe0f",
        native: "💁🏽‍♀️"
      },
      {
        unified: "1f481-1f3fe-200d-2640-fe0f",
        native: "💁🏾‍♀️"
      },
      {
        unified: "1f481-1f3ff-200d-2640-fe0f",
        native: "💁🏿‍♀️"
      }
    ],
    version: 4
  },
  raising_hand: {
    id: "raising_hand",
    name: "Person Raising Hand",
    keywords: [
      "question"
    ],
    skins: [
      {
        unified: "1f64b",
        native: "🙋"
      },
      {
        unified: "1f64b-1f3fb",
        native: "🙋🏻"
      },
      {
        unified: "1f64b-1f3fc",
        native: "🙋🏼"
      },
      {
        unified: "1f64b-1f3fd",
        native: "🙋🏽"
      },
      {
        unified: "1f64b-1f3fe",
        native: "🙋🏾"
      },
      {
        unified: "1f64b-1f3ff",
        native: "🙋🏿"
      }
    ],
    version: 1
  },
  "man-raising-hand": {
    id: "man-raising-hand",
    name: "Man Raising Hand",
    keywords: [
      "raising-hand",
      "male",
      "boy"
    ],
    skins: [
      {
        unified: "1f64b-200d-2642-fe0f",
        native: "🙋‍♂️"
      },
      {
        unified: "1f64b-1f3fb-200d-2642-fe0f",
        native: "🙋🏻‍♂️"
      },
      {
        unified: "1f64b-1f3fc-200d-2642-fe0f",
        native: "🙋🏼‍♂️"
      },
      {
        unified: "1f64b-1f3fd-200d-2642-fe0f",
        native: "🙋🏽‍♂️"
      },
      {
        unified: "1f64b-1f3fe-200d-2642-fe0f",
        native: "🙋🏾‍♂️"
      },
      {
        unified: "1f64b-1f3ff-200d-2642-fe0f",
        native: "🙋🏿‍♂️"
      }
    ],
    version: 4
  },
  "woman-raising-hand": {
    id: "woman-raising-hand",
    name: "Woman Raising Hand",
    keywords: [
      "raising-hand",
      "female",
      "girl"
    ],
    skins: [
      {
        unified: "1f64b-200d-2640-fe0f",
        native: "🙋‍♀️"
      },
      {
        unified: "1f64b-1f3fb-200d-2640-fe0f",
        native: "🙋🏻‍♀️"
      },
      {
        unified: "1f64b-1f3fc-200d-2640-fe0f",
        native: "🙋🏼‍♀️"
      },
      {
        unified: "1f64b-1f3fd-200d-2640-fe0f",
        native: "🙋🏽‍♀️"
      },
      {
        unified: "1f64b-1f3fe-200d-2640-fe0f",
        native: "🙋🏾‍♀️"
      },
      {
        unified: "1f64b-1f3ff-200d-2640-fe0f",
        native: "🙋🏿‍♀️"
      }
    ],
    version: 4
  },
  deaf_person: {
    id: "deaf_person",
    name: "Deaf Person",
    keywords: [
      "accessibility"
    ],
    skins: [
      {
        unified: "1f9cf",
        native: "🧏"
      },
      {
        unified: "1f9cf-1f3fb",
        native: "🧏🏻"
      },
      {
        unified: "1f9cf-1f3fc",
        native: "🧏🏼"
      },
      {
        unified: "1f9cf-1f3fd",
        native: "🧏🏽"
      },
      {
        unified: "1f9cf-1f3fe",
        native: "🧏🏾"
      },
      {
        unified: "1f9cf-1f3ff",
        native: "🧏🏿"
      }
    ],
    version: 12
  },
  deaf_man: {
    id: "deaf_man",
    name: "Deaf Man",
    keywords: [
      "accessibility"
    ],
    skins: [
      {
        unified: "1f9cf-200d-2642-fe0f",
        native: "🧏‍♂️"
      },
      {
        unified: "1f9cf-1f3fb-200d-2642-fe0f",
        native: "🧏🏻‍♂️"
      },
      {
        unified: "1f9cf-1f3fc-200d-2642-fe0f",
        native: "🧏🏼‍♂️"
      },
      {
        unified: "1f9cf-1f3fd-200d-2642-fe0f",
        native: "🧏🏽‍♂️"
      },
      {
        unified: "1f9cf-1f3fe-200d-2642-fe0f",
        native: "🧏🏾‍♂️"
      },
      {
        unified: "1f9cf-1f3ff-200d-2642-fe0f",
        native: "🧏🏿‍♂️"
      }
    ],
    version: 12
  },
  deaf_woman: {
    id: "deaf_woman",
    name: "Deaf Woman",
    keywords: [
      "accessibility"
    ],
    skins: [
      {
        unified: "1f9cf-200d-2640-fe0f",
        native: "🧏‍♀️"
      },
      {
        unified: "1f9cf-1f3fb-200d-2640-fe0f",
        native: "🧏🏻‍♀️"
      },
      {
        unified: "1f9cf-1f3fc-200d-2640-fe0f",
        native: "🧏🏼‍♀️"
      },
      {
        unified: "1f9cf-1f3fd-200d-2640-fe0f",
        native: "🧏🏽‍♀️"
      },
      {
        unified: "1f9cf-1f3fe-200d-2640-fe0f",
        native: "🧏🏾‍♀️"
      },
      {
        unified: "1f9cf-1f3ff-200d-2640-fe0f",
        native: "🧏🏿‍♀️"
      }
    ],
    version: 12
  },
  bow: {
    id: "bow",
    name: "Person Bowing",
    keywords: [
      "bow",
      "respectiful"
    ],
    skins: [
      {
        unified: "1f647",
        native: "🙇"
      },
      {
        unified: "1f647-1f3fb",
        native: "🙇🏻"
      },
      {
        unified: "1f647-1f3fc",
        native: "🙇🏼"
      },
      {
        unified: "1f647-1f3fd",
        native: "🙇🏽"
      },
      {
        unified: "1f647-1f3fe",
        native: "🙇🏾"
      },
      {
        unified: "1f647-1f3ff",
        native: "🙇🏿"
      }
    ],
    version: 1
  },
  "man-bowing": {
    id: "man-bowing",
    name: "Man Bowing",
    keywords: [
      "male",
      "boy"
    ],
    skins: [
      {
        unified: "1f647-200d-2642-fe0f",
        native: "🙇‍♂️"
      },
      {
        unified: "1f647-1f3fb-200d-2642-fe0f",
        native: "🙇🏻‍♂️"
      },
      {
        unified: "1f647-1f3fc-200d-2642-fe0f",
        native: "🙇🏼‍♂️"
      },
      {
        unified: "1f647-1f3fd-200d-2642-fe0f",
        native: "🙇🏽‍♂️"
      },
      {
        unified: "1f647-1f3fe-200d-2642-fe0f",
        native: "🙇🏾‍♂️"
      },
      {
        unified: "1f647-1f3ff-200d-2642-fe0f",
        native: "🙇🏿‍♂️"
      }
    ],
    version: 4
  },
  "woman-bowing": {
    id: "woman-bowing",
    name: "Woman Bowing",
    keywords: [
      "female",
      "girl"
    ],
    skins: [
      {
        unified: "1f647-200d-2640-fe0f",
        native: "🙇‍♀️"
      },
      {
        unified: "1f647-1f3fb-200d-2640-fe0f",
        native: "🙇🏻‍♀️"
      },
      {
        unified: "1f647-1f3fc-200d-2640-fe0f",
        native: "🙇🏼‍♀️"
      },
      {
        unified: "1f647-1f3fd-200d-2640-fe0f",
        native: "🙇🏽‍♀️"
      },
      {
        unified: "1f647-1f3fe-200d-2640-fe0f",
        native: "🙇🏾‍♀️"
      },
      {
        unified: "1f647-1f3ff-200d-2640-fe0f",
        native: "🙇🏿‍♀️"
      }
    ],
    version: 4
  },
  face_palm: {
    id: "face_palm",
    name: "Face Palm",
    keywords: [
      "person",
      "facepalming",
      "disappointed"
    ],
    skins: [
      {
        unified: "1f926",
        native: "🤦"
      },
      {
        unified: "1f926-1f3fb",
        native: "🤦🏻"
      },
      {
        unified: "1f926-1f3fc",
        native: "🤦🏼"
      },
      {
        unified: "1f926-1f3fd",
        native: "🤦🏽"
      },
      {
        unified: "1f926-1f3fe",
        native: "🤦🏾"
      },
      {
        unified: "1f926-1f3ff",
        native: "🤦🏿"
      }
    ],
    version: 3
  },
  "man-facepalming": {
    id: "man-facepalming",
    name: "Man Facepalming",
    keywords: [
      "male",
      "boy",
      "disbelief"
    ],
    skins: [
      {
        unified: "1f926-200d-2642-fe0f",
        native: "🤦‍♂️"
      },
      {
        unified: "1f926-1f3fb-200d-2642-fe0f",
        native: "🤦🏻‍♂️"
      },
      {
        unified: "1f926-1f3fc-200d-2642-fe0f",
        native: "🤦🏼‍♂️"
      },
      {
        unified: "1f926-1f3fd-200d-2642-fe0f",
        native: "🤦🏽‍♂️"
      },
      {
        unified: "1f926-1f3fe-200d-2642-fe0f",
        native: "🤦🏾‍♂️"
      },
      {
        unified: "1f926-1f3ff-200d-2642-fe0f",
        native: "🤦🏿‍♂️"
      }
    ],
    version: 4
  },
  "woman-facepalming": {
    id: "woman-facepalming",
    name: "Woman Facepalming",
    keywords: [
      "female",
      "girl",
      "disbelief"
    ],
    skins: [
      {
        unified: "1f926-200d-2640-fe0f",
        native: "🤦‍♀️"
      },
      {
        unified: "1f926-1f3fb-200d-2640-fe0f",
        native: "🤦🏻‍♀️"
      },
      {
        unified: "1f926-1f3fc-200d-2640-fe0f",
        native: "🤦🏼‍♀️"
      },
      {
        unified: "1f926-1f3fd-200d-2640-fe0f",
        native: "🤦🏽‍♀️"
      },
      {
        unified: "1f926-1f3fe-200d-2640-fe0f",
        native: "🤦🏾‍♀️"
      },
      {
        unified: "1f926-1f3ff-200d-2640-fe0f",
        native: "🤦🏿‍♀️"
      }
    ],
    version: 4
  },
  shrug: {
    id: "shrug",
    name: "Shrug",
    keywords: [
      "person",
      "shrugging",
      "regardless"
    ],
    skins: [
      {
        unified: "1f937",
        native: "🤷"
      },
      {
        unified: "1f937-1f3fb",
        native: "🤷🏻"
      },
      {
        unified: "1f937-1f3fc",
        native: "🤷🏼"
      },
      {
        unified: "1f937-1f3fd",
        native: "🤷🏽"
      },
      {
        unified: "1f937-1f3fe",
        native: "🤷🏾"
      },
      {
        unified: "1f937-1f3ff",
        native: "🤷🏿"
      }
    ],
    version: 3
  },
  "man-shrugging": {
    id: "man-shrugging",
    name: "Man Shrugging",
    keywords: [
      "male",
      "boy",
      "confused",
      "indifferent",
      "doubt"
    ],
    skins: [
      {
        unified: "1f937-200d-2642-fe0f",
        native: "🤷‍♂️"
      },
      {
        unified: "1f937-1f3fb-200d-2642-fe0f",
        native: "🤷🏻‍♂️"
      },
      {
        unified: "1f937-1f3fc-200d-2642-fe0f",
        native: "🤷🏼‍♂️"
      },
      {
        unified: "1f937-1f3fd-200d-2642-fe0f",
        native: "🤷🏽‍♂️"
      },
      {
        unified: "1f937-1f3fe-200d-2642-fe0f",
        native: "🤷🏾‍♂️"
      },
      {
        unified: "1f937-1f3ff-200d-2642-fe0f",
        native: "🤷🏿‍♂️"
      }
    ],
    version: 4
  },
  "woman-shrugging": {
    id: "woman-shrugging",
    name: "Woman Shrugging",
    keywords: [
      "female",
      "girl",
      "confused",
      "indifferent",
      "doubt"
    ],
    skins: [
      {
        unified: "1f937-200d-2640-fe0f",
        native: "🤷‍♀️"
      },
      {
        unified: "1f937-1f3fb-200d-2640-fe0f",
        native: "🤷🏻‍♀️"
      },
      {
        unified: "1f937-1f3fc-200d-2640-fe0f",
        native: "🤷🏼‍♀️"
      },
      {
        unified: "1f937-1f3fd-200d-2640-fe0f",
        native: "🤷🏽‍♀️"
      },
      {
        unified: "1f937-1f3fe-200d-2640-fe0f",
        native: "🤷🏾‍♀️"
      },
      {
        unified: "1f937-1f3ff-200d-2640-fe0f",
        native: "🤷🏿‍♀️"
      }
    ],
    version: 4
  },
  health_worker: {
    id: "health_worker",
    name: "Health Worker",
    keywords: [
      "hospital"
    ],
    skins: [
      {
        unified: "1f9d1-200d-2695-fe0f",
        native: "🧑‍⚕️"
      },
      {
        unified: "1f9d1-1f3fb-200d-2695-fe0f",
        native: "🧑🏻‍⚕️"
      },
      {
        unified: "1f9d1-1f3fc-200d-2695-fe0f",
        native: "🧑🏼‍⚕️"
      },
      {
        unified: "1f9d1-1f3fd-200d-2695-fe0f",
        native: "🧑🏽‍⚕️"
      },
      {
        unified: "1f9d1-1f3fe-200d-2695-fe0f",
        native: "🧑🏾‍⚕️"
      },
      {
        unified: "1f9d1-1f3ff-200d-2695-fe0f",
        native: "🧑🏿‍⚕️"
      }
    ],
    version: 12.1
  },
  "male-doctor": {
    id: "male-doctor",
    name: "Man Health Worker",
    keywords: [
      "male",
      "doctor",
      "nurse",
      "therapist",
      "healthcare",
      "human"
    ],
    skins: [
      {
        unified: "1f468-200d-2695-fe0f",
        native: "👨‍⚕️"
      },
      {
        unified: "1f468-1f3fb-200d-2695-fe0f",
        native: "👨🏻‍⚕️"
      },
      {
        unified: "1f468-1f3fc-200d-2695-fe0f",
        native: "👨🏼‍⚕️"
      },
      {
        unified: "1f468-1f3fd-200d-2695-fe0f",
        native: "👨🏽‍⚕️"
      },
      {
        unified: "1f468-1f3fe-200d-2695-fe0f",
        native: "👨🏾‍⚕️"
      },
      {
        unified: "1f468-1f3ff-200d-2695-fe0f",
        native: "👨🏿‍⚕️"
      }
    ],
    version: 4
  },
  "female-doctor": {
    id: "female-doctor",
    name: "Woman Health Worker",
    keywords: [
      "female",
      "doctor",
      "nurse",
      "therapist",
      "healthcare",
      "human"
    ],
    skins: [
      {
        unified: "1f469-200d-2695-fe0f",
        native: "👩‍⚕️"
      },
      {
        unified: "1f469-1f3fb-200d-2695-fe0f",
        native: "👩🏻‍⚕️"
      },
      {
        unified: "1f469-1f3fc-200d-2695-fe0f",
        native: "👩🏼‍⚕️"
      },
      {
        unified: "1f469-1f3fd-200d-2695-fe0f",
        native: "👩🏽‍⚕️"
      },
      {
        unified: "1f469-1f3fe-200d-2695-fe0f",
        native: "👩🏾‍⚕️"
      },
      {
        unified: "1f469-1f3ff-200d-2695-fe0f",
        native: "👩🏿‍⚕️"
      }
    ],
    version: 4
  },
  student: {
    id: "student",
    name: "Student",
    keywords: [
      "learn"
    ],
    skins: [
      {
        unified: "1f9d1-200d-1f393",
        native: "🧑‍🎓"
      },
      {
        unified: "1f9d1-1f3fb-200d-1f393",
        native: "🧑🏻‍🎓"
      },
      {
        unified: "1f9d1-1f3fc-200d-1f393",
        native: "🧑🏼‍🎓"
      },
      {
        unified: "1f9d1-1f3fd-200d-1f393",
        native: "🧑🏽‍🎓"
      },
      {
        unified: "1f9d1-1f3fe-200d-1f393",
        native: "🧑🏾‍🎓"
      },
      {
        unified: "1f9d1-1f3ff-200d-1f393",
        native: "🧑🏿‍🎓"
      }
    ],
    version: 12.1
  },
  "male-student": {
    id: "male-student",
    name: "Man Student",
    keywords: [
      "male",
      "graduate",
      "human"
    ],
    skins: [
      {
        unified: "1f468-200d-1f393",
        native: "👨‍🎓"
      },
      {
        unified: "1f468-1f3fb-200d-1f393",
        native: "👨🏻‍🎓"
      },
      {
        unified: "1f468-1f3fc-200d-1f393",
        native: "👨🏼‍🎓"
      },
      {
        unified: "1f468-1f3fd-200d-1f393",
        native: "👨🏽‍🎓"
      },
      {
        unified: "1f468-1f3fe-200d-1f393",
        native: "👨🏾‍🎓"
      },
      {
        unified: "1f468-1f3ff-200d-1f393",
        native: "👨🏿‍🎓"
      }
    ],
    version: 4
  },
  "female-student": {
    id: "female-student",
    name: "Woman Student",
    keywords: [
      "female",
      "graduate",
      "human"
    ],
    skins: [
      {
        unified: "1f469-200d-1f393",
        native: "👩‍🎓"
      },
      {
        unified: "1f469-1f3fb-200d-1f393",
        native: "👩🏻‍🎓"
      },
      {
        unified: "1f469-1f3fc-200d-1f393",
        native: "👩🏼‍🎓"
      },
      {
        unified: "1f469-1f3fd-200d-1f393",
        native: "👩🏽‍🎓"
      },
      {
        unified: "1f469-1f3fe-200d-1f393",
        native: "👩🏾‍🎓"
      },
      {
        unified: "1f469-1f3ff-200d-1f393",
        native: "👩🏿‍🎓"
      }
    ],
    version: 4
  },
  teacher: {
    id: "teacher",
    name: "Teacher",
    keywords: [
      "professor"
    ],
    skins: [
      {
        unified: "1f9d1-200d-1f3eb",
        native: "🧑‍🏫"
      },
      {
        unified: "1f9d1-1f3fb-200d-1f3eb",
        native: "🧑🏻‍🏫"
      },
      {
        unified: "1f9d1-1f3fc-200d-1f3eb",
        native: "🧑🏼‍🏫"
      },
      {
        unified: "1f9d1-1f3fd-200d-1f3eb",
        native: "🧑🏽‍🏫"
      },
      {
        unified: "1f9d1-1f3fe-200d-1f3eb",
        native: "🧑🏾‍🏫"
      },
      {
        unified: "1f9d1-1f3ff-200d-1f3eb",
        native: "🧑🏿‍🏫"
      }
    ],
    version: 12.1
  },
  "male-teacher": {
    id: "male-teacher",
    name: "Man Teacher",
    keywords: [
      "male",
      "instructor",
      "professor",
      "human"
    ],
    skins: [
      {
        unified: "1f468-200d-1f3eb",
        native: "👨‍🏫"
      },
      {
        unified: "1f468-1f3fb-200d-1f3eb",
        native: "👨🏻‍🏫"
      },
      {
        unified: "1f468-1f3fc-200d-1f3eb",
        native: "👨🏼‍🏫"
      },
      {
        unified: "1f468-1f3fd-200d-1f3eb",
        native: "👨🏽‍🏫"
      },
      {
        unified: "1f468-1f3fe-200d-1f3eb",
        native: "👨🏾‍🏫"
      },
      {
        unified: "1f468-1f3ff-200d-1f3eb",
        native: "👨🏿‍🏫"
      }
    ],
    version: 4
  },
  "female-teacher": {
    id: "female-teacher",
    name: "Woman Teacher",
    keywords: [
      "female",
      "instructor",
      "professor",
      "human"
    ],
    skins: [
      {
        unified: "1f469-200d-1f3eb",
        native: "👩‍🏫"
      },
      {
        unified: "1f469-1f3fb-200d-1f3eb",
        native: "👩🏻‍🏫"
      },
      {
        unified: "1f469-1f3fc-200d-1f3eb",
        native: "👩🏼‍🏫"
      },
      {
        unified: "1f469-1f3fd-200d-1f3eb",
        native: "👩🏽‍🏫"
      },
      {
        unified: "1f469-1f3fe-200d-1f3eb",
        native: "👩🏾‍🏫"
      },
      {
        unified: "1f469-1f3ff-200d-1f3eb",
        native: "👩🏿‍🏫"
      }
    ],
    version: 4
  },
  judge: {
    id: "judge",
    name: "Judge",
    keywords: [
      "law"
    ],
    skins: [
      {
        unified: "1f9d1-200d-2696-fe0f",
        native: "🧑‍⚖️"
      },
      {
        unified: "1f9d1-1f3fb-200d-2696-fe0f",
        native: "🧑🏻‍⚖️"
      },
      {
        unified: "1f9d1-1f3fc-200d-2696-fe0f",
        native: "🧑🏼‍⚖️"
      },
      {
        unified: "1f9d1-1f3fd-200d-2696-fe0f",
        native: "🧑🏽‍⚖️"
      },
      {
        unified: "1f9d1-1f3fe-200d-2696-fe0f",
        native: "🧑🏾‍⚖️"
      },
      {
        unified: "1f9d1-1f3ff-200d-2696-fe0f",
        native: "🧑🏿‍⚖️"
      }
    ],
    version: 12.1
  },
  "male-judge": {
    id: "male-judge",
    name: "Man Judge",
    keywords: [
      "male",
      "justice",
      "court",
      "human"
    ],
    skins: [
      {
        unified: "1f468-200d-2696-fe0f",
        native: "👨‍⚖️"
      },
      {
        unified: "1f468-1f3fb-200d-2696-fe0f",
        native: "👨🏻‍⚖️"
      },
      {
        unified: "1f468-1f3fc-200d-2696-fe0f",
        native: "👨🏼‍⚖️"
      },
      {
        unified: "1f468-1f3fd-200d-2696-fe0f",
        native: "👨🏽‍⚖️"
      },
      {
        unified: "1f468-1f3fe-200d-2696-fe0f",
        native: "👨🏾‍⚖️"
      },
      {
        unified: "1f468-1f3ff-200d-2696-fe0f",
        native: "👨🏿‍⚖️"
      }
    ],
    version: 4
  },
  "female-judge": {
    id: "female-judge",
    name: "Woman Judge",
    keywords: [
      "female",
      "justice",
      "court",
      "human"
    ],
    skins: [
      {
        unified: "1f469-200d-2696-fe0f",
        native: "👩‍⚖️"
      },
      {
        unified: "1f469-1f3fb-200d-2696-fe0f",
        native: "👩🏻‍⚖️"
      },
      {
        unified: "1f469-1f3fc-200d-2696-fe0f",
        native: "👩🏼‍⚖️"
      },
      {
        unified: "1f469-1f3fd-200d-2696-fe0f",
        native: "👩🏽‍⚖️"
      },
      {
        unified: "1f469-1f3fe-200d-2696-fe0f",
        native: "👩🏾‍⚖️"
      },
      {
        unified: "1f469-1f3ff-200d-2696-fe0f",
        native: "👩🏿‍⚖️"
      }
    ],
    version: 4
  },
  farmer: {
    id: "farmer",
    name: "Farmer",
    keywords: [
      "crops"
    ],
    skins: [
      {
        unified: "1f9d1-200d-1f33e",
        native: "🧑‍🌾"
      },
      {
        unified: "1f9d1-1f3fb-200d-1f33e",
        native: "🧑🏻‍🌾"
      },
      {
        unified: "1f9d1-1f3fc-200d-1f33e",
        native: "🧑🏼‍🌾"
      },
      {
        unified: "1f9d1-1f3fd-200d-1f33e",
        native: "🧑🏽‍🌾"
      },
      {
        unified: "1f9d1-1f3fe-200d-1f33e",
        native: "🧑🏾‍🌾"
      },
      {
        unified: "1f9d1-1f3ff-200d-1f33e",
        native: "🧑🏿‍🌾"
      }
    ],
    version: 12.1
  },
  "male-farmer": {
    id: "male-farmer",
    name: "Man Farmer",
    keywords: [
      "male",
      "rancher",
      "gardener",
      "human"
    ],
    skins: [
      {
        unified: "1f468-200d-1f33e",
        native: "👨‍🌾"
      },
      {
        unified: "1f468-1f3fb-200d-1f33e",
        native: "👨🏻‍🌾"
      },
      {
        unified: "1f468-1f3fc-200d-1f33e",
        native: "👨🏼‍🌾"
      },
      {
        unified: "1f468-1f3fd-200d-1f33e",
        native: "👨🏽‍🌾"
      },
      {
        unified: "1f468-1f3fe-200d-1f33e",
        native: "👨🏾‍🌾"
      },
      {
        unified: "1f468-1f3ff-200d-1f33e",
        native: "👨🏿‍🌾"
      }
    ],
    version: 4
  },
  "female-farmer": {
    id: "female-farmer",
    name: "Woman Farmer",
    keywords: [
      "female",
      "rancher",
      "gardener",
      "human"
    ],
    skins: [
      {
        unified: "1f469-200d-1f33e",
        native: "👩‍🌾"
      },
      {
        unified: "1f469-1f3fb-200d-1f33e",
        native: "👩🏻‍🌾"
      },
      {
        unified: "1f469-1f3fc-200d-1f33e",
        native: "👩🏼‍🌾"
      },
      {
        unified: "1f469-1f3fd-200d-1f33e",
        native: "👩🏽‍🌾"
      },
      {
        unified: "1f469-1f3fe-200d-1f33e",
        native: "👩🏾‍🌾"
      },
      {
        unified: "1f469-1f3ff-200d-1f33e",
        native: "👩🏿‍🌾"
      }
    ],
    version: 4
  },
  cook: {
    id: "cook",
    name: "Cook",
    keywords: [
      "food",
      "kitchen",
      "culinary"
    ],
    skins: [
      {
        unified: "1f9d1-200d-1f373",
        native: "🧑‍🍳"
      },
      {
        unified: "1f9d1-1f3fb-200d-1f373",
        native: "🧑🏻‍🍳"
      },
      {
        unified: "1f9d1-1f3fc-200d-1f373",
        native: "🧑🏼‍🍳"
      },
      {
        unified: "1f9d1-1f3fd-200d-1f373",
        native: "🧑🏽‍🍳"
      },
      {
        unified: "1f9d1-1f3fe-200d-1f373",
        native: "🧑🏾‍🍳"
      },
      {
        unified: "1f9d1-1f3ff-200d-1f373",
        native: "🧑🏿‍🍳"
      }
    ],
    version: 12.1
  },
  "male-cook": {
    id: "male-cook",
    name: "Man Cook",
    keywords: [
      "male",
      "chef",
      "human"
    ],
    skins: [
      {
        unified: "1f468-200d-1f373",
        native: "👨‍🍳"
      },
      {
        unified: "1f468-1f3fb-200d-1f373",
        native: "👨🏻‍🍳"
      },
      {
        unified: "1f468-1f3fc-200d-1f373",
        native: "👨🏼‍🍳"
      },
      {
        unified: "1f468-1f3fd-200d-1f373",
        native: "👨🏽‍🍳"
      },
      {
        unified: "1f468-1f3fe-200d-1f373",
        native: "👨🏾‍🍳"
      },
      {
        unified: "1f468-1f3ff-200d-1f373",
        native: "👨🏿‍🍳"
      }
    ],
    version: 4
  },
  "female-cook": {
    id: "female-cook",
    name: "Woman Cook",
    keywords: [
      "female",
      "chef",
      "human"
    ],
    skins: [
      {
        unified: "1f469-200d-1f373",
        native: "👩‍🍳"
      },
      {
        unified: "1f469-1f3fb-200d-1f373",
        native: "👩🏻‍🍳"
      },
      {
        unified: "1f469-1f3fc-200d-1f373",
        native: "👩🏼‍🍳"
      },
      {
        unified: "1f469-1f3fd-200d-1f373",
        native: "👩🏽‍🍳"
      },
      {
        unified: "1f469-1f3fe-200d-1f373",
        native: "👩🏾‍🍳"
      },
      {
        unified: "1f469-1f3ff-200d-1f373",
        native: "👩🏿‍🍳"
      }
    ],
    version: 4
  },
  mechanic: {
    id: "mechanic",
    name: "Mechanic",
    keywords: [
      "worker",
      "technician"
    ],
    skins: [
      {
        unified: "1f9d1-200d-1f527",
        native: "🧑‍🔧"
      },
      {
        unified: "1f9d1-1f3fb-200d-1f527",
        native: "🧑🏻‍🔧"
      },
      {
        unified: "1f9d1-1f3fc-200d-1f527",
        native: "🧑🏼‍🔧"
      },
      {
        unified: "1f9d1-1f3fd-200d-1f527",
        native: "🧑🏽‍🔧"
      },
      {
        unified: "1f9d1-1f3fe-200d-1f527",
        native: "🧑🏾‍🔧"
      },
      {
        unified: "1f9d1-1f3ff-200d-1f527",
        native: "🧑🏿‍🔧"
      }
    ],
    version: 12.1
  },
  "male-mechanic": {
    id: "male-mechanic",
    name: "Man Mechanic",
    keywords: [
      "male",
      "plumber",
      "human",
      "wrench"
    ],
    skins: [
      {
        unified: "1f468-200d-1f527",
        native: "👨‍🔧"
      },
      {
        unified: "1f468-1f3fb-200d-1f527",
        native: "👨🏻‍🔧"
      },
      {
        unified: "1f468-1f3fc-200d-1f527",
        native: "👨🏼‍🔧"
      },
      {
        unified: "1f468-1f3fd-200d-1f527",
        native: "👨🏽‍🔧"
      },
      {
        unified: "1f468-1f3fe-200d-1f527",
        native: "👨🏾‍🔧"
      },
      {
        unified: "1f468-1f3ff-200d-1f527",
        native: "👨🏿‍🔧"
      }
    ],
    version: 4
  },
  "female-mechanic": {
    id: "female-mechanic",
    name: "Woman Mechanic",
    keywords: [
      "female",
      "plumber",
      "human",
      "wrench"
    ],
    skins: [
      {
        unified: "1f469-200d-1f527",
        native: "👩‍🔧"
      },
      {
        unified: "1f469-1f3fb-200d-1f527",
        native: "👩🏻‍🔧"
      },
      {
        unified: "1f469-1f3fc-200d-1f527",
        native: "👩🏼‍🔧"
      },
      {
        unified: "1f469-1f3fd-200d-1f527",
        native: "👩🏽‍🔧"
      },
      {
        unified: "1f469-1f3fe-200d-1f527",
        native: "👩🏾‍🔧"
      },
      {
        unified: "1f469-1f3ff-200d-1f527",
        native: "👩🏿‍🔧"
      }
    ],
    version: 4
  },
  factory_worker: {
    id: "factory_worker",
    name: "Factory Worker",
    keywords: [
      "labor"
    ],
    skins: [
      {
        unified: "1f9d1-200d-1f3ed",
        native: "🧑‍🏭"
      },
      {
        unified: "1f9d1-1f3fb-200d-1f3ed",
        native: "🧑🏻‍🏭"
      },
      {
        unified: "1f9d1-1f3fc-200d-1f3ed",
        native: "🧑🏼‍🏭"
      },
      {
        unified: "1f9d1-1f3fd-200d-1f3ed",
        native: "🧑🏽‍🏭"
      },
      {
        unified: "1f9d1-1f3fe-200d-1f3ed",
        native: "🧑🏾‍🏭"
      },
      {
        unified: "1f9d1-1f3ff-200d-1f3ed",
        native: "🧑🏿‍🏭"
      }
    ],
    version: 12.1
  },
  "male-factory-worker": {
    id: "male-factory-worker",
    name: "Man Factory Worker",
    keywords: [
      "male",
      "factory-worker",
      "assembly",
      "industrial",
      "human"
    ],
    skins: [
      {
        unified: "1f468-200d-1f3ed",
        native: "👨‍🏭"
      },
      {
        unified: "1f468-1f3fb-200d-1f3ed",
        native: "👨🏻‍🏭"
      },
      {
        unified: "1f468-1f3fc-200d-1f3ed",
        native: "👨🏼‍🏭"
      },
      {
        unified: "1f468-1f3fd-200d-1f3ed",
        native: "👨🏽‍🏭"
      },
      {
        unified: "1f468-1f3fe-200d-1f3ed",
        native: "👨🏾‍🏭"
      },
      {
        unified: "1f468-1f3ff-200d-1f3ed",
        native: "👨🏿‍🏭"
      }
    ],
    version: 4
  },
  "female-factory-worker": {
    id: "female-factory-worker",
    name: "Woman Factory Worker",
    keywords: [
      "female",
      "factory-worker",
      "assembly",
      "industrial",
      "human"
    ],
    skins: [
      {
        unified: "1f469-200d-1f3ed",
        native: "👩‍🏭"
      },
      {
        unified: "1f469-1f3fb-200d-1f3ed",
        native: "👩🏻‍🏭"
      },
      {
        unified: "1f469-1f3fc-200d-1f3ed",
        native: "👩🏼‍🏭"
      },
      {
        unified: "1f469-1f3fd-200d-1f3ed",
        native: "👩🏽‍🏭"
      },
      {
        unified: "1f469-1f3fe-200d-1f3ed",
        native: "👩🏾‍🏭"
      },
      {
        unified: "1f469-1f3ff-200d-1f3ed",
        native: "👩🏿‍🏭"
      }
    ],
    version: 4
  },
  office_worker: {
    id: "office_worker",
    name: "Office Worker",
    keywords: [
      "business"
    ],
    skins: [
      {
        unified: "1f9d1-200d-1f4bc",
        native: "🧑‍💼"
      },
      {
        unified: "1f9d1-1f3fb-200d-1f4bc",
        native: "🧑🏻‍💼"
      },
      {
        unified: "1f9d1-1f3fc-200d-1f4bc",
        native: "🧑🏼‍💼"
      },
      {
        unified: "1f9d1-1f3fd-200d-1f4bc",
        native: "🧑🏽‍💼"
      },
      {
        unified: "1f9d1-1f3fe-200d-1f4bc",
        native: "🧑🏾‍💼"
      },
      {
        unified: "1f9d1-1f3ff-200d-1f4bc",
        native: "🧑🏿‍💼"
      }
    ],
    version: 12.1
  },
  "male-office-worker": {
    id: "male-office-worker",
    name: "Man Office Worker",
    keywords: [
      "male",
      "office-worker",
      "business",
      "manager",
      "human"
    ],
    skins: [
      {
        unified: "1f468-200d-1f4bc",
        native: "👨‍💼"
      },
      {
        unified: "1f468-1f3fb-200d-1f4bc",
        native: "👨🏻‍💼"
      },
      {
        unified: "1f468-1f3fc-200d-1f4bc",
        native: "👨🏼‍💼"
      },
      {
        unified: "1f468-1f3fd-200d-1f4bc",
        native: "👨🏽‍💼"
      },
      {
        unified: "1f468-1f3fe-200d-1f4bc",
        native: "👨🏾‍💼"
      },
      {
        unified: "1f468-1f3ff-200d-1f4bc",
        native: "👨🏿‍💼"
      }
    ],
    version: 4
  },
  "female-office-worker": {
    id: "female-office-worker",
    name: "Woman Office Worker",
    keywords: [
      "female",
      "office-worker",
      "business",
      "manager",
      "human"
    ],
    skins: [
      {
        unified: "1f469-200d-1f4bc",
        native: "👩‍💼"
      },
      {
        unified: "1f469-1f3fb-200d-1f4bc",
        native: "👩🏻‍💼"
      },
      {
        unified: "1f469-1f3fc-200d-1f4bc",
        native: "👩🏼‍💼"
      },
      {
        unified: "1f469-1f3fd-200d-1f4bc",
        native: "👩🏽‍💼"
      },
      {
        unified: "1f469-1f3fe-200d-1f4bc",
        native: "👩🏾‍💼"
      },
      {
        unified: "1f469-1f3ff-200d-1f4bc",
        native: "👩🏿‍💼"
      }
    ],
    version: 4
  },
  scientist: {
    id: "scientist",
    name: "Scientist",
    keywords: [
      "chemistry"
    ],
    skins: [
      {
        unified: "1f9d1-200d-1f52c",
        native: "🧑‍🔬"
      },
      {
        unified: "1f9d1-1f3fb-200d-1f52c",
        native: "🧑🏻‍🔬"
      },
      {
        unified: "1f9d1-1f3fc-200d-1f52c",
        native: "🧑🏼‍🔬"
      },
      {
        unified: "1f9d1-1f3fd-200d-1f52c",
        native: "🧑🏽‍🔬"
      },
      {
        unified: "1f9d1-1f3fe-200d-1f52c",
        native: "🧑🏾‍🔬"
      },
      {
        unified: "1f9d1-1f3ff-200d-1f52c",
        native: "🧑🏿‍🔬"
      }
    ],
    version: 12.1
  },
  "male-scientist": {
    id: "male-scientist",
    name: "Man Scientist",
    keywords: [
      "male",
      "biologist",
      "chemist",
      "engineer",
      "physicist",
      "human"
    ],
    skins: [
      {
        unified: "1f468-200d-1f52c",
        native: "👨‍🔬"
      },
      {
        unified: "1f468-1f3fb-200d-1f52c",
        native: "👨🏻‍🔬"
      },
      {
        unified: "1f468-1f3fc-200d-1f52c",
        native: "👨🏼‍🔬"
      },
      {
        unified: "1f468-1f3fd-200d-1f52c",
        native: "👨🏽‍🔬"
      },
      {
        unified: "1f468-1f3fe-200d-1f52c",
        native: "👨🏾‍🔬"
      },
      {
        unified: "1f468-1f3ff-200d-1f52c",
        native: "👨🏿‍🔬"
      }
    ],
    version: 4
  },
  "female-scientist": {
    id: "female-scientist",
    name: "Woman Scientist",
    keywords: [
      "female",
      "biologist",
      "chemist",
      "engineer",
      "physicist",
      "human"
    ],
    skins: [
      {
        unified: "1f469-200d-1f52c",
        native: "👩‍🔬"
      },
      {
        unified: "1f469-1f3fb-200d-1f52c",
        native: "👩🏻‍🔬"
      },
      {
        unified: "1f469-1f3fc-200d-1f52c",
        native: "👩🏼‍🔬"
      },
      {
        unified: "1f469-1f3fd-200d-1f52c",
        native: "👩🏽‍🔬"
      },
      {
        unified: "1f469-1f3fe-200d-1f52c",
        native: "👩🏾‍🔬"
      },
      {
        unified: "1f469-1f3ff-200d-1f52c",
        native: "👩🏿‍🔬"
      }
    ],
    version: 4
  },
  technologist: {
    id: "technologist",
    name: "Technologist",
    keywords: [
      "computer"
    ],
    skins: [
      {
        unified: "1f9d1-200d-1f4bb",
        native: "🧑‍💻"
      },
      {
        unified: "1f9d1-1f3fb-200d-1f4bb",
        native: "🧑🏻‍💻"
      },
      {
        unified: "1f9d1-1f3fc-200d-1f4bb",
        native: "🧑🏼‍💻"
      },
      {
        unified: "1f9d1-1f3fd-200d-1f4bb",
        native: "🧑🏽‍💻"
      },
      {
        unified: "1f9d1-1f3fe-200d-1f4bb",
        native: "🧑🏾‍💻"
      },
      {
        unified: "1f9d1-1f3ff-200d-1f4bb",
        native: "🧑🏿‍💻"
      }
    ],
    version: 12.1
  },
  "male-technologist": {
    id: "male-technologist",
    name: "Man Technologist",
    keywords: [
      "male",
      "coder",
      "developer",
      "engineer",
      "programmer",
      "software",
      "human",
      "laptop",
      "computer"
    ],
    skins: [
      {
        unified: "1f468-200d-1f4bb",
        native: "👨‍💻"
      },
      {
        unified: "1f468-1f3fb-200d-1f4bb",
        native: "👨🏻‍💻"
      },
      {
        unified: "1f468-1f3fc-200d-1f4bb",
        native: "👨🏼‍💻"
      },
      {
        unified: "1f468-1f3fd-200d-1f4bb",
        native: "👨🏽‍💻"
      },
      {
        unified: "1f468-1f3fe-200d-1f4bb",
        native: "👨🏾‍💻"
      },
      {
        unified: "1f468-1f3ff-200d-1f4bb",
        native: "👨🏿‍💻"
      }
    ],
    version: 4
  },
  "female-technologist": {
    id: "female-technologist",
    name: "Woman Technologist",
    keywords: [
      "female",
      "coder",
      "developer",
      "engineer",
      "programmer",
      "software",
      "human",
      "laptop",
      "computer"
    ],
    skins: [
      {
        unified: "1f469-200d-1f4bb",
        native: "👩‍💻"
      },
      {
        unified: "1f469-1f3fb-200d-1f4bb",
        native: "👩🏻‍💻"
      },
      {
        unified: "1f469-1f3fc-200d-1f4bb",
        native: "👩🏼‍💻"
      },
      {
        unified: "1f469-1f3fd-200d-1f4bb",
        native: "👩🏽‍💻"
      },
      {
        unified: "1f469-1f3fe-200d-1f4bb",
        native: "👩🏾‍💻"
      },
      {
        unified: "1f469-1f3ff-200d-1f4bb",
        native: "👩🏿‍💻"
      }
    ],
    version: 4
  },
  singer: {
    id: "singer",
    name: "Singer",
    keywords: [
      "song",
      "artist",
      "performer"
    ],
    skins: [
      {
        unified: "1f9d1-200d-1f3a4",
        native: "🧑‍🎤"
      },
      {
        unified: "1f9d1-1f3fb-200d-1f3a4",
        native: "🧑🏻‍🎤"
      },
      {
        unified: "1f9d1-1f3fc-200d-1f3a4",
        native: "🧑🏼‍🎤"
      },
      {
        unified: "1f9d1-1f3fd-200d-1f3a4",
        native: "🧑🏽‍🎤"
      },
      {
        unified: "1f9d1-1f3fe-200d-1f3a4",
        native: "🧑🏾‍🎤"
      },
      {
        unified: "1f9d1-1f3ff-200d-1f3a4",
        native: "🧑🏿‍🎤"
      }
    ],
    version: 12.1
  },
  "male-singer": {
    id: "male-singer",
    name: "Man Singer",
    keywords: [
      "male",
      "rockstar",
      "entertainer",
      "human"
    ],
    skins: [
      {
        unified: "1f468-200d-1f3a4",
        native: "👨‍🎤"
      },
      {
        unified: "1f468-1f3fb-200d-1f3a4",
        native: "👨🏻‍🎤"
      },
      {
        unified: "1f468-1f3fc-200d-1f3a4",
        native: "👨🏼‍🎤"
      },
      {
        unified: "1f468-1f3fd-200d-1f3a4",
        native: "👨🏽‍🎤"
      },
      {
        unified: "1f468-1f3fe-200d-1f3a4",
        native: "👨🏾‍🎤"
      },
      {
        unified: "1f468-1f3ff-200d-1f3a4",
        native: "👨🏿‍🎤"
      }
    ],
    version: 4
  },
  "female-singer": {
    id: "female-singer",
    name: "Woman Singer",
    keywords: [
      "female",
      "rockstar",
      "entertainer",
      "human"
    ],
    skins: [
      {
        unified: "1f469-200d-1f3a4",
        native: "👩‍🎤"
      },
      {
        unified: "1f469-1f3fb-200d-1f3a4",
        native: "👩🏻‍🎤"
      },
      {
        unified: "1f469-1f3fc-200d-1f3a4",
        native: "👩🏼‍🎤"
      },
      {
        unified: "1f469-1f3fd-200d-1f3a4",
        native: "👩🏽‍🎤"
      },
      {
        unified: "1f469-1f3fe-200d-1f3a4",
        native: "👩🏾‍🎤"
      },
      {
        unified: "1f469-1f3ff-200d-1f3a4",
        native: "👩🏿‍🎤"
      }
    ],
    version: 4
  },
  artist: {
    id: "artist",
    name: "Artist",
    keywords: [
      "painting",
      "draw",
      "creativity"
    ],
    skins: [
      {
        unified: "1f9d1-200d-1f3a8",
        native: "🧑‍🎨"
      },
      {
        unified: "1f9d1-1f3fb-200d-1f3a8",
        native: "🧑🏻‍🎨"
      },
      {
        unified: "1f9d1-1f3fc-200d-1f3a8",
        native: "🧑🏼‍🎨"
      },
      {
        unified: "1f9d1-1f3fd-200d-1f3a8",
        native: "🧑🏽‍🎨"
      },
      {
        unified: "1f9d1-1f3fe-200d-1f3a8",
        native: "🧑🏾‍🎨"
      },
      {
        unified: "1f9d1-1f3ff-200d-1f3a8",
        native: "🧑🏿‍🎨"
      }
    ],
    version: 12.1
  },
  "male-artist": {
    id: "male-artist",
    name: "Man Artist",
    keywords: [
      "male",
      "painter",
      "human"
    ],
    skins: [
      {
        unified: "1f468-200d-1f3a8",
        native: "👨‍🎨"
      },
      {
        unified: "1f468-1f3fb-200d-1f3a8",
        native: "👨🏻‍🎨"
      },
      {
        unified: "1f468-1f3fc-200d-1f3a8",
        native: "👨🏼‍🎨"
      },
      {
        unified: "1f468-1f3fd-200d-1f3a8",
        native: "👨🏽‍🎨"
      },
      {
        unified: "1f468-1f3fe-200d-1f3a8",
        native: "👨🏾‍🎨"
      },
      {
        unified: "1f468-1f3ff-200d-1f3a8",
        native: "👨🏿‍🎨"
      }
    ],
    version: 4
  },
  "female-artist": {
    id: "female-artist",
    name: "Woman Artist",
    keywords: [
      "female",
      "painter",
      "human"
    ],
    skins: [
      {
        unified: "1f469-200d-1f3a8",
        native: "👩‍🎨"
      },
      {
        unified: "1f469-1f3fb-200d-1f3a8",
        native: "👩🏻‍🎨"
      },
      {
        unified: "1f469-1f3fc-200d-1f3a8",
        native: "👩🏼‍🎨"
      },
      {
        unified: "1f469-1f3fd-200d-1f3a8",
        native: "👩🏽‍🎨"
      },
      {
        unified: "1f469-1f3fe-200d-1f3a8",
        native: "👩🏾‍🎨"
      },
      {
        unified: "1f469-1f3ff-200d-1f3a8",
        native: "👩🏿‍🎨"
      }
    ],
    version: 4
  },
  pilot: {
    id: "pilot",
    name: "Pilot",
    keywords: [
      "fly",
      "plane",
      "airplane"
    ],
    skins: [
      {
        unified: "1f9d1-200d-2708-fe0f",
        native: "🧑‍✈️"
      },
      {
        unified: "1f9d1-1f3fb-200d-2708-fe0f",
        native: "🧑🏻‍✈️"
      },
      {
        unified: "1f9d1-1f3fc-200d-2708-fe0f",
        native: "🧑🏼‍✈️"
      },
      {
        unified: "1f9d1-1f3fd-200d-2708-fe0f",
        native: "🧑🏽‍✈️"
      },
      {
        unified: "1f9d1-1f3fe-200d-2708-fe0f",
        native: "🧑🏾‍✈️"
      },
      {
        unified: "1f9d1-1f3ff-200d-2708-fe0f",
        native: "🧑🏿‍✈️"
      }
    ],
    version: 12.1
  },
  "male-pilot": {
    id: "male-pilot",
    name: "Man Pilot",
    keywords: [
      "male",
      "aviator",
      "plane",
      "human"
    ],
    skins: [
      {
        unified: "1f468-200d-2708-fe0f",
        native: "👨‍✈️"
      },
      {
        unified: "1f468-1f3fb-200d-2708-fe0f",
        native: "👨🏻‍✈️"
      },
      {
        unified: "1f468-1f3fc-200d-2708-fe0f",
        native: "👨🏼‍✈️"
      },
      {
        unified: "1f468-1f3fd-200d-2708-fe0f",
        native: "👨🏽‍✈️"
      },
      {
        unified: "1f468-1f3fe-200d-2708-fe0f",
        native: "👨🏾‍✈️"
      },
      {
        unified: "1f468-1f3ff-200d-2708-fe0f",
        native: "👨🏿‍✈️"
      }
    ],
    version: 4
  },
  "female-pilot": {
    id: "female-pilot",
    name: "Woman Pilot",
    keywords: [
      "female",
      "aviator",
      "plane",
      "human"
    ],
    skins: [
      {
        unified: "1f469-200d-2708-fe0f",
        native: "👩‍✈️"
      },
      {
        unified: "1f469-1f3fb-200d-2708-fe0f",
        native: "👩🏻‍✈️"
      },
      {
        unified: "1f469-1f3fc-200d-2708-fe0f",
        native: "👩🏼‍✈️"
      },
      {
        unified: "1f469-1f3fd-200d-2708-fe0f",
        native: "👩🏽‍✈️"
      },
      {
        unified: "1f469-1f3fe-200d-2708-fe0f",
        native: "👩🏾‍✈️"
      },
      {
        unified: "1f469-1f3ff-200d-2708-fe0f",
        native: "👩🏿‍✈️"
      }
    ],
    version: 4
  },
  astronaut: {
    id: "astronaut",
    name: "Astronaut",
    keywords: [
      "outerspace"
    ],
    skins: [
      {
        unified: "1f9d1-200d-1f680",
        native: "🧑‍🚀"
      },
      {
        unified: "1f9d1-1f3fb-200d-1f680",
        native: "🧑🏻‍🚀"
      },
      {
        unified: "1f9d1-1f3fc-200d-1f680",
        native: "🧑🏼‍🚀"
      },
      {
        unified: "1f9d1-1f3fd-200d-1f680",
        native: "🧑🏽‍🚀"
      },
      {
        unified: "1f9d1-1f3fe-200d-1f680",
        native: "🧑🏾‍🚀"
      },
      {
        unified: "1f9d1-1f3ff-200d-1f680",
        native: "🧑🏿‍🚀"
      }
    ],
    version: 12.1
  },
  "male-astronaut": {
    id: "male-astronaut",
    name: "Man Astronaut",
    keywords: [
      "male",
      "space",
      "rocket",
      "human"
    ],
    skins: [
      {
        unified: "1f468-200d-1f680",
        native: "👨‍🚀"
      },
      {
        unified: "1f468-1f3fb-200d-1f680",
        native: "👨🏻‍🚀"
      },
      {
        unified: "1f468-1f3fc-200d-1f680",
        native: "👨🏼‍🚀"
      },
      {
        unified: "1f468-1f3fd-200d-1f680",
        native: "👨🏽‍🚀"
      },
      {
        unified: "1f468-1f3fe-200d-1f680",
        native: "👨🏾‍🚀"
      },
      {
        unified: "1f468-1f3ff-200d-1f680",
        native: "👨🏿‍🚀"
      }
    ],
    version: 4
  },
  "female-astronaut": {
    id: "female-astronaut",
    name: "Woman Astronaut",
    keywords: [
      "female",
      "space",
      "rocket",
      "human"
    ],
    skins: [
      {
        unified: "1f469-200d-1f680",
        native: "👩‍🚀"
      },
      {
        unified: "1f469-1f3fb-200d-1f680",
        native: "👩🏻‍🚀"
      },
      {
        unified: "1f469-1f3fc-200d-1f680",
        native: "👩🏼‍🚀"
      },
      {
        unified: "1f469-1f3fd-200d-1f680",
        native: "👩🏽‍🚀"
      },
      {
        unified: "1f469-1f3fe-200d-1f680",
        native: "👩🏾‍🚀"
      },
      {
        unified: "1f469-1f3ff-200d-1f680",
        native: "👩🏿‍🚀"
      }
    ],
    version: 4
  },
  firefighter: {
    id: "firefighter",
    name: "Firefighter",
    keywords: [
      "fire"
    ],
    skins: [
      {
        unified: "1f9d1-200d-1f692",
        native: "🧑‍🚒"
      },
      {
        unified: "1f9d1-1f3fb-200d-1f692",
        native: "🧑🏻‍🚒"
      },
      {
        unified: "1f9d1-1f3fc-200d-1f692",
        native: "🧑🏼‍🚒"
      },
      {
        unified: "1f9d1-1f3fd-200d-1f692",
        native: "🧑🏽‍🚒"
      },
      {
        unified: "1f9d1-1f3fe-200d-1f692",
        native: "🧑🏾‍🚒"
      },
      {
        unified: "1f9d1-1f3ff-200d-1f692",
        native: "🧑🏿‍🚒"
      }
    ],
    version: 12.1
  },
  "male-firefighter": {
    id: "male-firefighter",
    name: "Man Firefighter",
    keywords: [
      "male",
      "fireman",
      "human"
    ],
    skins: [
      {
        unified: "1f468-200d-1f692",
        native: "👨‍🚒"
      },
      {
        unified: "1f468-1f3fb-200d-1f692",
        native: "👨🏻‍🚒"
      },
      {
        unified: "1f468-1f3fc-200d-1f692",
        native: "👨🏼‍🚒"
      },
      {
        unified: "1f468-1f3fd-200d-1f692",
        native: "👨🏽‍🚒"
      },
      {
        unified: "1f468-1f3fe-200d-1f692",
        native: "👨🏾‍🚒"
      },
      {
        unified: "1f468-1f3ff-200d-1f692",
        native: "👨🏿‍🚒"
      }
    ],
    version: 4
  },
  "female-firefighter": {
    id: "female-firefighter",
    name: "Woman Firefighter",
    keywords: [
      "female",
      "fireman",
      "human"
    ],
    skins: [
      {
        unified: "1f469-200d-1f692",
        native: "👩‍🚒"
      },
      {
        unified: "1f469-1f3fb-200d-1f692",
        native: "👩🏻‍🚒"
      },
      {
        unified: "1f469-1f3fc-200d-1f692",
        native: "👩🏼‍🚒"
      },
      {
        unified: "1f469-1f3fd-200d-1f692",
        native: "👩🏽‍🚒"
      },
      {
        unified: "1f469-1f3fe-200d-1f692",
        native: "👩🏾‍🚒"
      },
      {
        unified: "1f469-1f3ff-200d-1f692",
        native: "👩🏿‍🚒"
      }
    ],
    version: 4
  },
  cop: {
    id: "cop",
    name: "Police Officer",
    keywords: [
      "cop"
    ],
    skins: [
      {
        unified: "1f46e",
        native: "👮"
      },
      {
        unified: "1f46e-1f3fb",
        native: "👮🏻"
      },
      {
        unified: "1f46e-1f3fc",
        native: "👮🏼"
      },
      {
        unified: "1f46e-1f3fd",
        native: "👮🏽"
      },
      {
        unified: "1f46e-1f3fe",
        native: "👮🏾"
      },
      {
        unified: "1f46e-1f3ff",
        native: "👮🏿"
      }
    ],
    version: 1
  },
  "male-police-officer": {
    id: "male-police-officer",
    name: "Man Police Officer",
    keywords: [
      "male",
      "police-officer",
      "law",
      "legal",
      "enforcement",
      "arrest",
      "911"
    ],
    skins: [
      {
        unified: "1f46e-200d-2642-fe0f",
        native: "👮‍♂️"
      },
      {
        unified: "1f46e-1f3fb-200d-2642-fe0f",
        native: "👮🏻‍♂️"
      },
      {
        unified: "1f46e-1f3fc-200d-2642-fe0f",
        native: "👮🏼‍♂️"
      },
      {
        unified: "1f46e-1f3fd-200d-2642-fe0f",
        native: "👮🏽‍♂️"
      },
      {
        unified: "1f46e-1f3fe-200d-2642-fe0f",
        native: "👮🏾‍♂️"
      },
      {
        unified: "1f46e-1f3ff-200d-2642-fe0f",
        native: "👮🏿‍♂️"
      }
    ],
    version: 4
  },
  "female-police-officer": {
    id: "female-police-officer",
    name: "Woman Police Officer",
    keywords: [
      "female",
      "police-officer",
      "law",
      "legal",
      "enforcement",
      "arrest",
      "911"
    ],
    skins: [
      {
        unified: "1f46e-200d-2640-fe0f",
        native: "👮‍♀️"
      },
      {
        unified: "1f46e-1f3fb-200d-2640-fe0f",
        native: "👮🏻‍♀️"
      },
      {
        unified: "1f46e-1f3fc-200d-2640-fe0f",
        native: "👮🏼‍♀️"
      },
      {
        unified: "1f46e-1f3fd-200d-2640-fe0f",
        native: "👮🏽‍♀️"
      },
      {
        unified: "1f46e-1f3fe-200d-2640-fe0f",
        native: "👮🏾‍♀️"
      },
      {
        unified: "1f46e-1f3ff-200d-2640-fe0f",
        native: "👮🏿‍♀️"
      }
    ],
    version: 4
  },
  sleuth_or_spy: {
    id: "sleuth_or_spy",
    name: "Detective",
    keywords: [
      "sleuth",
      "or",
      "spy",
      "human"
    ],
    skins: [
      {
        unified: "1f575-fe0f",
        native: "🕵️"
      },
      {
        unified: "1f575-1f3fb",
        native: "🕵🏻"
      },
      {
        unified: "1f575-1f3fc",
        native: "🕵🏼"
      },
      {
        unified: "1f575-1f3fd",
        native: "🕵🏽"
      },
      {
        unified: "1f575-1f3fe",
        native: "🕵🏾"
      },
      {
        unified: "1f575-1f3ff",
        native: "🕵🏿"
      }
    ],
    version: 1
  },
  "male-detective": {
    id: "male-detective",
    name: "Man Detective",
    keywords: [
      "male",
      "crime"
    ],
    skins: [
      {
        unified: "1f575-fe0f-200d-2642-fe0f",
        native: "🕵️‍♂️"
      },
      {
        unified: "1f575-1f3fb-200d-2642-fe0f",
        native: "🕵🏻‍♂️"
      },
      {
        unified: "1f575-1f3fc-200d-2642-fe0f",
        native: "🕵🏼‍♂️"
      },
      {
        unified: "1f575-1f3fd-200d-2642-fe0f",
        native: "🕵🏽‍♂️"
      },
      {
        unified: "1f575-1f3fe-200d-2642-fe0f",
        native: "🕵🏾‍♂️"
      },
      {
        unified: "1f575-1f3ff-200d-2642-fe0f",
        native: "🕵🏿‍♂️"
      }
    ],
    version: 4
  },
  "female-detective": {
    id: "female-detective",
    name: "Woman Detective",
    keywords: [
      "female",
      "human",
      "spy"
    ],
    skins: [
      {
        unified: "1f575-fe0f-200d-2640-fe0f",
        native: "🕵️‍♀️"
      },
      {
        unified: "1f575-1f3fb-200d-2640-fe0f",
        native: "🕵🏻‍♀️"
      },
      {
        unified: "1f575-1f3fc-200d-2640-fe0f",
        native: "🕵🏼‍♀️"
      },
      {
        unified: "1f575-1f3fd-200d-2640-fe0f",
        native: "🕵🏽‍♀️"
      },
      {
        unified: "1f575-1f3fe-200d-2640-fe0f",
        native: "🕵🏾‍♀️"
      },
      {
        unified: "1f575-1f3ff-200d-2640-fe0f",
        native: "🕵🏿‍♀️"
      }
    ],
    version: 4
  },
  guardsman: {
    id: "guardsman",
    name: "Guard",
    keywords: [
      "guardsman",
      "protect"
    ],
    skins: [
      {
        unified: "1f482",
        native: "💂"
      },
      {
        unified: "1f482-1f3fb",
        native: "💂🏻"
      },
      {
        unified: "1f482-1f3fc",
        native: "💂🏼"
      },
      {
        unified: "1f482-1f3fd",
        native: "💂🏽"
      },
      {
        unified: "1f482-1f3fe",
        native: "💂🏾"
      },
      {
        unified: "1f482-1f3ff",
        native: "💂🏿"
      }
    ],
    version: 1
  },
  "male-guard": {
    id: "male-guard",
    name: "Man Guard",
    keywords: [
      "male",
      "uk",
      "gb",
      "british",
      "guy",
      "royal"
    ],
    skins: [
      {
        unified: "1f482-200d-2642-fe0f",
        native: "💂‍♂️"
      },
      {
        unified: "1f482-1f3fb-200d-2642-fe0f",
        native: "💂🏻‍♂️"
      },
      {
        unified: "1f482-1f3fc-200d-2642-fe0f",
        native: "💂🏼‍♂️"
      },
      {
        unified: "1f482-1f3fd-200d-2642-fe0f",
        native: "💂🏽‍♂️"
      },
      {
        unified: "1f482-1f3fe-200d-2642-fe0f",
        native: "💂🏾‍♂️"
      },
      {
        unified: "1f482-1f3ff-200d-2642-fe0f",
        native: "💂🏿‍♂️"
      }
    ],
    version: 4
  },
  "female-guard": {
    id: "female-guard",
    name: "Woman Guard",
    keywords: [
      "female",
      "uk",
      "gb",
      "british",
      "royal"
    ],
    skins: [
      {
        unified: "1f482-200d-2640-fe0f",
        native: "💂‍♀️"
      },
      {
        unified: "1f482-1f3fb-200d-2640-fe0f",
        native: "💂🏻‍♀️"
      },
      {
        unified: "1f482-1f3fc-200d-2640-fe0f",
        native: "💂🏼‍♀️"
      },
      {
        unified: "1f482-1f3fd-200d-2640-fe0f",
        native: "💂🏽‍♀️"
      },
      {
        unified: "1f482-1f3fe-200d-2640-fe0f",
        native: "💂🏾‍♀️"
      },
      {
        unified: "1f482-1f3ff-200d-2640-fe0f",
        native: "💂🏿‍♀️"
      }
    ],
    version: 4
  },
  ninja: {
    id: "ninja",
    name: "Ninja",
    keywords: [
      "ninjutsu",
      "skills",
      "japanese"
    ],
    skins: [
      {
        unified: "1f977",
        native: "🥷"
      },
      {
        unified: "1f977-1f3fb",
        native: "🥷🏻"
      },
      {
        unified: "1f977-1f3fc",
        native: "🥷🏼"
      },
      {
        unified: "1f977-1f3fd",
        native: "🥷🏽"
      },
      {
        unified: "1f977-1f3fe",
        native: "🥷🏾"
      },
      {
        unified: "1f977-1f3ff",
        native: "🥷🏿"
      }
    ],
    version: 13
  },
  construction_worker: {
    id: "construction_worker",
    name: "Construction Worker",
    keywords: [
      "labor",
      "build"
    ],
    skins: [
      {
        unified: "1f477",
        native: "👷"
      },
      {
        unified: "1f477-1f3fb",
        native: "👷🏻"
      },
      {
        unified: "1f477-1f3fc",
        native: "👷🏼"
      },
      {
        unified: "1f477-1f3fd",
        native: "👷🏽"
      },
      {
        unified: "1f477-1f3fe",
        native: "👷🏾"
      },
      {
        unified: "1f477-1f3ff",
        native: "👷🏿"
      }
    ],
    version: 1
  },
  "male-construction-worker": {
    id: "male-construction-worker",
    name: "Man Construction Worker",
    keywords: [
      "male",
      "construction-worker",
      "human",
      "wip",
      "guy",
      "build",
      "labor"
    ],
    skins: [
      {
        unified: "1f477-200d-2642-fe0f",
        native: "👷‍♂️"
      },
      {
        unified: "1f477-1f3fb-200d-2642-fe0f",
        native: "👷🏻‍♂️"
      },
      {
        unified: "1f477-1f3fc-200d-2642-fe0f",
        native: "👷🏼‍♂️"
      },
      {
        unified: "1f477-1f3fd-200d-2642-fe0f",
        native: "👷🏽‍♂️"
      },
      {
        unified: "1f477-1f3fe-200d-2642-fe0f",
        native: "👷🏾‍♂️"
      },
      {
        unified: "1f477-1f3ff-200d-2642-fe0f",
        native: "👷🏿‍♂️"
      }
    ],
    version: 4
  },
  "female-construction-worker": {
    id: "female-construction-worker",
    name: "Woman Construction Worker",
    keywords: [
      "female",
      "construction-worker",
      "human",
      "wip",
      "build",
      "labor"
    ],
    skins: [
      {
        unified: "1f477-200d-2640-fe0f",
        native: "👷‍♀️"
      },
      {
        unified: "1f477-1f3fb-200d-2640-fe0f",
        native: "👷🏻‍♀️"
      },
      {
        unified: "1f477-1f3fc-200d-2640-fe0f",
        native: "👷🏼‍♀️"
      },
      {
        unified: "1f477-1f3fd-200d-2640-fe0f",
        native: "👷🏽‍♀️"
      },
      {
        unified: "1f477-1f3fe-200d-2640-fe0f",
        native: "👷🏾‍♀️"
      },
      {
        unified: "1f477-1f3ff-200d-2640-fe0f",
        native: "👷🏿‍♀️"
      }
    ],
    version: 4
  },
  person_with_crown: {
    id: "person_with_crown",
    name: "Person with Crown",
    keywords: [
      "royalty",
      "power"
    ],
    skins: [
      {
        unified: "1fac5",
        native: "🫅"
      },
      {
        unified: "1fac5-1f3fb",
        native: "🫅🏻"
      },
      {
        unified: "1fac5-1f3fc",
        native: "🫅🏼"
      },
      {
        unified: "1fac5-1f3fd",
        native: "🫅🏽"
      },
      {
        unified: "1fac5-1f3fe",
        native: "🫅🏾"
      },
      {
        unified: "1fac5-1f3ff",
        native: "🫅🏿"
      }
    ],
    version: 14
  },
  prince: {
    id: "prince",
    name: "Prince",
    keywords: [
      "boy",
      "man",
      "male",
      "crown",
      "royal",
      "king"
    ],
    skins: [
      {
        unified: "1f934",
        native: "🤴"
      },
      {
        unified: "1f934-1f3fb",
        native: "🤴🏻"
      },
      {
        unified: "1f934-1f3fc",
        native: "🤴🏼"
      },
      {
        unified: "1f934-1f3fd",
        native: "🤴🏽"
      },
      {
        unified: "1f934-1f3fe",
        native: "🤴🏾"
      },
      {
        unified: "1f934-1f3ff",
        native: "🤴🏿"
      }
    ],
    version: 3
  },
  princess: {
    id: "princess",
    name: "Princess",
    keywords: [
      "girl",
      "woman",
      "female",
      "blond",
      "crown",
      "royal",
      "queen"
    ],
    skins: [
      {
        unified: "1f478",
        native: "👸"
      },
      {
        unified: "1f478-1f3fb",
        native: "👸🏻"
      },
      {
        unified: "1f478-1f3fc",
        native: "👸🏼"
      },
      {
        unified: "1f478-1f3fd",
        native: "👸🏽"
      },
      {
        unified: "1f478-1f3fe",
        native: "👸🏾"
      },
      {
        unified: "1f478-1f3ff",
        native: "👸🏿"
      }
    ],
    version: 1
  },
  man_with_turban: {
    id: "man_with_turban",
    name: "Man with Turban",
    keywords: [
      "person",
      "wearing",
      "headdress"
    ],
    skins: [
      {
        unified: "1f473",
        native: "👳"
      },
      {
        unified: "1f473-1f3fb",
        native: "👳🏻"
      },
      {
        unified: "1f473-1f3fc",
        native: "👳🏼"
      },
      {
        unified: "1f473-1f3fd",
        native: "👳🏽"
      },
      {
        unified: "1f473-1f3fe",
        native: "👳🏾"
      },
      {
        unified: "1f473-1f3ff",
        native: "👳🏿"
      }
    ],
    version: 1
  },
  "man-wearing-turban": {
    id: "man-wearing-turban",
    name: "Man Wearing Turban",
    keywords: [
      "wearing-turban",
      "male",
      "indian",
      "hinduism",
      "arabs"
    ],
    skins: [
      {
        unified: "1f473-200d-2642-fe0f",
        native: "👳‍♂️"
      },
      {
        unified: "1f473-1f3fb-200d-2642-fe0f",
        native: "👳🏻‍♂️"
      },
      {
        unified: "1f473-1f3fc-200d-2642-fe0f",
        native: "👳🏼‍♂️"
      },
      {
        unified: "1f473-1f3fd-200d-2642-fe0f",
        native: "👳🏽‍♂️"
      },
      {
        unified: "1f473-1f3fe-200d-2642-fe0f",
        native: "👳🏾‍♂️"
      },
      {
        unified: "1f473-1f3ff-200d-2642-fe0f",
        native: "👳🏿‍♂️"
      }
    ],
    version: 4
  },
  "woman-wearing-turban": {
    id: "woman-wearing-turban",
    name: "Woman Wearing Turban",
    keywords: [
      "wearing-turban",
      "female",
      "indian",
      "hinduism",
      "arabs"
    ],
    skins: [
      {
        unified: "1f473-200d-2640-fe0f",
        native: "👳‍♀️"
      },
      {
        unified: "1f473-1f3fb-200d-2640-fe0f",
        native: "👳🏻‍♀️"
      },
      {
        unified: "1f473-1f3fc-200d-2640-fe0f",
        native: "👳🏼‍♀️"
      },
      {
        unified: "1f473-1f3fd-200d-2640-fe0f",
        native: "👳🏽‍♀️"
      },
      {
        unified: "1f473-1f3fe-200d-2640-fe0f",
        native: "👳🏾‍♀️"
      },
      {
        unified: "1f473-1f3ff-200d-2640-fe0f",
        native: "👳🏿‍♀️"
      }
    ],
    version: 4
  },
  man_with_gua_pi_mao: {
    id: "man_with_gua_pi_mao",
    name: "Man with Gua Pi Mao",
    keywords: [
      "skullcap",
      "male",
      "boy",
      "chinese"
    ],
    skins: [
      {
        unified: "1f472",
        native: "👲"
      },
      {
        unified: "1f472-1f3fb",
        native: "👲🏻"
      },
      {
        unified: "1f472-1f3fc",
        native: "👲🏼"
      },
      {
        unified: "1f472-1f3fd",
        native: "👲🏽"
      },
      {
        unified: "1f472-1f3fe",
        native: "👲🏾"
      },
      {
        unified: "1f472-1f3ff",
        native: "👲🏿"
      }
    ],
    version: 1
  },
  person_with_headscarf: {
    id: "person_with_headscarf",
    name: "Woman with Headscarf",
    keywords: [
      "person",
      "female",
      "hijab",
      "mantilla",
      "tichel"
    ],
    skins: [
      {
        unified: "1f9d5",
        native: "🧕"
      },
      {
        unified: "1f9d5-1f3fb",
        native: "🧕🏻"
      },
      {
        unified: "1f9d5-1f3fc",
        native: "🧕🏼"
      },
      {
        unified: "1f9d5-1f3fd",
        native: "🧕🏽"
      },
      {
        unified: "1f9d5-1f3fe",
        native: "🧕🏾"
      },
      {
        unified: "1f9d5-1f3ff",
        native: "🧕🏿"
      }
    ],
    version: 5
  },
  person_in_tuxedo: {
    id: "person_in_tuxedo",
    name: "Man in Tuxedo",
    keywords: [
      "person",
      "couple",
      "marriage",
      "wedding",
      "groom"
    ],
    skins: [
      {
        unified: "1f935",
        native: "🤵"
      },
      {
        unified: "1f935-1f3fb",
        native: "🤵🏻"
      },
      {
        unified: "1f935-1f3fc",
        native: "🤵🏼"
      },
      {
        unified: "1f935-1f3fd",
        native: "🤵🏽"
      },
      {
        unified: "1f935-1f3fe",
        native: "🤵🏾"
      },
      {
        unified: "1f935-1f3ff",
        native: "🤵🏿"
      }
    ],
    version: 3
  },
  man_in_tuxedo: {
    id: "man_in_tuxedo",
    name: "Man in Tuxedo",
    keywords: [
      "formal",
      "fashion"
    ],
    skins: [
      {
        unified: "1f935-200d-2642-fe0f",
        native: "🤵‍♂️"
      },
      {
        unified: "1f935-1f3fb-200d-2642-fe0f",
        native: "🤵🏻‍♂️"
      },
      {
        unified: "1f935-1f3fc-200d-2642-fe0f",
        native: "🤵🏼‍♂️"
      },
      {
        unified: "1f935-1f3fd-200d-2642-fe0f",
        native: "🤵🏽‍♂️"
      },
      {
        unified: "1f935-1f3fe-200d-2642-fe0f",
        native: "🤵🏾‍♂️"
      },
      {
        unified: "1f935-1f3ff-200d-2642-fe0f",
        native: "🤵🏿‍♂️"
      }
    ],
    version: 13
  },
  woman_in_tuxedo: {
    id: "woman_in_tuxedo",
    name: "Woman in Tuxedo",
    keywords: [
      "formal",
      "fashion"
    ],
    skins: [
      {
        unified: "1f935-200d-2640-fe0f",
        native: "🤵‍♀️"
      },
      {
        unified: "1f935-1f3fb-200d-2640-fe0f",
        native: "🤵🏻‍♀️"
      },
      {
        unified: "1f935-1f3fc-200d-2640-fe0f",
        native: "🤵🏼‍♀️"
      },
      {
        unified: "1f935-1f3fd-200d-2640-fe0f",
        native: "🤵🏽‍♀️"
      },
      {
        unified: "1f935-1f3fe-200d-2640-fe0f",
        native: "🤵🏾‍♀️"
      },
      {
        unified: "1f935-1f3ff-200d-2640-fe0f",
        native: "🤵🏿‍♀️"
      }
    ],
    version: 13
  },
  bride_with_veil: {
    id: "bride_with_veil",
    name: "Bride with Veil",
    keywords: [
      "couple",
      "marriage",
      "wedding",
      "woman"
    ],
    skins: [
      {
        unified: "1f470",
        native: "👰"
      },
      {
        unified: "1f470-1f3fb",
        native: "👰🏻"
      },
      {
        unified: "1f470-1f3fc",
        native: "👰🏼"
      },
      {
        unified: "1f470-1f3fd",
        native: "👰🏽"
      },
      {
        unified: "1f470-1f3fe",
        native: "👰🏾"
      },
      {
        unified: "1f470-1f3ff",
        native: "👰🏿"
      }
    ],
    version: 1
  },
  man_with_veil: {
    id: "man_with_veil",
    name: "Man with Veil",
    keywords: [
      "wedding",
      "marriage"
    ],
    skins: [
      {
        unified: "1f470-200d-2642-fe0f",
        native: "👰‍♂️"
      },
      {
        unified: "1f470-1f3fb-200d-2642-fe0f",
        native: "👰🏻‍♂️"
      },
      {
        unified: "1f470-1f3fc-200d-2642-fe0f",
        native: "👰🏼‍♂️"
      },
      {
        unified: "1f470-1f3fd-200d-2642-fe0f",
        native: "👰🏽‍♂️"
      },
      {
        unified: "1f470-1f3fe-200d-2642-fe0f",
        native: "👰🏾‍♂️"
      },
      {
        unified: "1f470-1f3ff-200d-2642-fe0f",
        native: "👰🏿‍♂️"
      }
    ],
    version: 13
  },
  woman_with_veil: {
    id: "woman_with_veil",
    name: "Woman with Veil",
    keywords: [
      "wedding",
      "marriage"
    ],
    skins: [
      {
        unified: "1f470-200d-2640-fe0f",
        native: "👰‍♀️"
      },
      {
        unified: "1f470-1f3fb-200d-2640-fe0f",
        native: "👰🏻‍♀️"
      },
      {
        unified: "1f470-1f3fc-200d-2640-fe0f",
        native: "👰🏼‍♀️"
      },
      {
        unified: "1f470-1f3fd-200d-2640-fe0f",
        native: "👰🏽‍♀️"
      },
      {
        unified: "1f470-1f3fe-200d-2640-fe0f",
        native: "👰🏾‍♀️"
      },
      {
        unified: "1f470-1f3ff-200d-2640-fe0f",
        native: "👰🏿‍♀️"
      }
    ],
    version: 13
  },
  pregnant_woman: {
    id: "pregnant_woman",
    name: "Pregnant Woman",
    keywords: [
      "baby"
    ],
    skins: [
      {
        unified: "1f930",
        native: "🤰"
      },
      {
        unified: "1f930-1f3fb",
        native: "🤰🏻"
      },
      {
        unified: "1f930-1f3fc",
        native: "🤰🏼"
      },
      {
        unified: "1f930-1f3fd",
        native: "🤰🏽"
      },
      {
        unified: "1f930-1f3fe",
        native: "🤰🏾"
      },
      {
        unified: "1f930-1f3ff",
        native: "🤰🏿"
      }
    ],
    version: 3
  },
  pregnant_man: {
    id: "pregnant_man",
    name: "Pregnant Man",
    keywords: [
      "baby",
      "belly"
    ],
    skins: [
      {
        unified: "1fac3",
        native: "🫃"
      },
      {
        unified: "1fac3-1f3fb",
        native: "🫃🏻"
      },
      {
        unified: "1fac3-1f3fc",
        native: "🫃🏼"
      },
      {
        unified: "1fac3-1f3fd",
        native: "🫃🏽"
      },
      {
        unified: "1fac3-1f3fe",
        native: "🫃🏾"
      },
      {
        unified: "1fac3-1f3ff",
        native: "🫃🏿"
      }
    ],
    version: 14
  },
  pregnant_person: {
    id: "pregnant_person",
    name: "Pregnant Person",
    keywords: [
      "baby",
      "belly"
    ],
    skins: [
      {
        unified: "1fac4",
        native: "🫄"
      },
      {
        unified: "1fac4-1f3fb",
        native: "🫄🏻"
      },
      {
        unified: "1fac4-1f3fc",
        native: "🫄🏼"
      },
      {
        unified: "1fac4-1f3fd",
        native: "🫄🏽"
      },
      {
        unified: "1fac4-1f3fe",
        native: "🫄🏾"
      },
      {
        unified: "1fac4-1f3ff",
        native: "🫄🏿"
      }
    ],
    version: 14
  },
  "breast-feeding": {
    id: "breast-feeding",
    name: "Breast-Feeding",
    keywords: [
      "breast",
      "feeding",
      "nursing",
      "baby"
    ],
    skins: [
      {
        unified: "1f931",
        native: "🤱"
      },
      {
        unified: "1f931-1f3fb",
        native: "🤱🏻"
      },
      {
        unified: "1f931-1f3fc",
        native: "🤱🏼"
      },
      {
        unified: "1f931-1f3fd",
        native: "🤱🏽"
      },
      {
        unified: "1f931-1f3fe",
        native: "🤱🏾"
      },
      {
        unified: "1f931-1f3ff",
        native: "🤱🏿"
      }
    ],
    version: 5
  },
  woman_feeding_baby: {
    id: "woman_feeding_baby",
    name: "Woman Feeding Baby",
    keywords: [
      "birth",
      "food"
    ],
    skins: [
      {
        unified: "1f469-200d-1f37c",
        native: "👩‍🍼"
      },
      {
        unified: "1f469-1f3fb-200d-1f37c",
        native: "👩🏻‍🍼"
      },
      {
        unified: "1f469-1f3fc-200d-1f37c",
        native: "👩🏼‍🍼"
      },
      {
        unified: "1f469-1f3fd-200d-1f37c",
        native: "👩🏽‍🍼"
      },
      {
        unified: "1f469-1f3fe-200d-1f37c",
        native: "👩🏾‍🍼"
      },
      {
        unified: "1f469-1f3ff-200d-1f37c",
        native: "👩🏿‍🍼"
      }
    ],
    version: 13
  },
  man_feeding_baby: {
    id: "man_feeding_baby",
    name: "Man Feeding Baby",
    keywords: [
      "birth",
      "food"
    ],
    skins: [
      {
        unified: "1f468-200d-1f37c",
        native: "👨‍🍼"
      },
      {
        unified: "1f468-1f3fb-200d-1f37c",
        native: "👨🏻‍🍼"
      },
      {
        unified: "1f468-1f3fc-200d-1f37c",
        native: "👨🏼‍🍼"
      },
      {
        unified: "1f468-1f3fd-200d-1f37c",
        native: "👨🏽‍🍼"
      },
      {
        unified: "1f468-1f3fe-200d-1f37c",
        native: "👨🏾‍🍼"
      },
      {
        unified: "1f468-1f3ff-200d-1f37c",
        native: "👨🏿‍🍼"
      }
    ],
    version: 13
  },
  person_feeding_baby: {
    id: "person_feeding_baby",
    name: "Person Feeding Baby",
    keywords: [
      "birth",
      "food"
    ],
    skins: [
      {
        unified: "1f9d1-200d-1f37c",
        native: "🧑‍🍼"
      },
      {
        unified: "1f9d1-1f3fb-200d-1f37c",
        native: "🧑🏻‍🍼"
      },
      {
        unified: "1f9d1-1f3fc-200d-1f37c",
        native: "🧑🏼‍🍼"
      },
      {
        unified: "1f9d1-1f3fd-200d-1f37c",
        native: "🧑🏽‍🍼"
      },
      {
        unified: "1f9d1-1f3fe-200d-1f37c",
        native: "🧑🏾‍🍼"
      },
      {
        unified: "1f9d1-1f3ff-200d-1f37c",
        native: "🧑🏿‍🍼"
      }
    ],
    version: 13
  },
  angel: {
    id: "angel",
    name: "Baby Angel",
    keywords: [
      "heaven",
      "wings",
      "halo"
    ],
    skins: [
      {
        unified: "1f47c",
        native: "👼"
      },
      {
        unified: "1f47c-1f3fb",
        native: "👼🏻"
      },
      {
        unified: "1f47c-1f3fc",
        native: "👼🏼"
      },
      {
        unified: "1f47c-1f3fd",
        native: "👼🏽"
      },
      {
        unified: "1f47c-1f3fe",
        native: "👼🏾"
      },
      {
        unified: "1f47c-1f3ff",
        native: "👼🏿"
      }
    ],
    version: 1
  },
  santa: {
    id: "santa",
    name: "Santa Claus",
    keywords: [
      "festival",
      "man",
      "male",
      "xmas",
      "father",
      "christmas"
    ],
    skins: [
      {
        unified: "1f385",
        native: "🎅"
      },
      {
        unified: "1f385-1f3fb",
        native: "🎅🏻"
      },
      {
        unified: "1f385-1f3fc",
        native: "🎅🏼"
      },
      {
        unified: "1f385-1f3fd",
        native: "🎅🏽"
      },
      {
        unified: "1f385-1f3fe",
        native: "🎅🏾"
      },
      {
        unified: "1f385-1f3ff",
        native: "🎅🏿"
      }
    ],
    version: 1
  },
  mrs_claus: {
    id: "mrs_claus",
    name: "Mrs. Claus",
    keywords: [
      "mrs",
      "mother",
      "christmas",
      "woman",
      "female",
      "xmas"
    ],
    skins: [
      {
        unified: "1f936",
        native: "🤶"
      },
      {
        unified: "1f936-1f3fb",
        native: "🤶🏻"
      },
      {
        unified: "1f936-1f3fc",
        native: "🤶🏼"
      },
      {
        unified: "1f936-1f3fd",
        native: "🤶🏽"
      },
      {
        unified: "1f936-1f3fe",
        native: "🤶🏾"
      },
      {
        unified: "1f936-1f3ff",
        native: "🤶🏿"
      }
    ],
    version: 3
  },
  mx_claus: {
    id: "mx_claus",
    name: "Mx Claus",
    keywords: [
      "christmas"
    ],
    skins: [
      {
        unified: "1f9d1-200d-1f384",
        native: "🧑‍🎄"
      },
      {
        unified: "1f9d1-1f3fb-200d-1f384",
        native: "🧑🏻‍🎄"
      },
      {
        unified: "1f9d1-1f3fc-200d-1f384",
        native: "🧑🏼‍🎄"
      },
      {
        unified: "1f9d1-1f3fd-200d-1f384",
        native: "🧑🏽‍🎄"
      },
      {
        unified: "1f9d1-1f3fe-200d-1f384",
        native: "🧑🏾‍🎄"
      },
      {
        unified: "1f9d1-1f3ff-200d-1f384",
        native: "🧑🏿‍🎄"
      }
    ],
    version: 13
  },
  superhero: {
    id: "superhero",
    name: "Superhero",
    keywords: [
      "marvel"
    ],
    skins: [
      {
        unified: "1f9b8",
        native: "🦸"
      },
      {
        unified: "1f9b8-1f3fb",
        native: "🦸🏻"
      },
      {
        unified: "1f9b8-1f3fc",
        native: "🦸🏼"
      },
      {
        unified: "1f9b8-1f3fd",
        native: "🦸🏽"
      },
      {
        unified: "1f9b8-1f3fe",
        native: "🦸🏾"
      },
      {
        unified: "1f9b8-1f3ff",
        native: "🦸🏿"
      }
    ],
    version: 11
  },
  male_superhero: {
    id: "male_superhero",
    name: "Man Superhero",
    keywords: [
      "male",
      "good",
      "hero",
      "superpowers"
    ],
    skins: [
      {
        unified: "1f9b8-200d-2642-fe0f",
        native: "🦸‍♂️"
      },
      {
        unified: "1f9b8-1f3fb-200d-2642-fe0f",
        native: "🦸🏻‍♂️"
      },
      {
        unified: "1f9b8-1f3fc-200d-2642-fe0f",
        native: "🦸🏼‍♂️"
      },
      {
        unified: "1f9b8-1f3fd-200d-2642-fe0f",
        native: "🦸🏽‍♂️"
      },
      {
        unified: "1f9b8-1f3fe-200d-2642-fe0f",
        native: "🦸🏾‍♂️"
      },
      {
        unified: "1f9b8-1f3ff-200d-2642-fe0f",
        native: "🦸🏿‍♂️"
      }
    ],
    version: 11
  },
  female_superhero: {
    id: "female_superhero",
    name: "Woman Superhero",
    keywords: [
      "female",
      "good",
      "heroine",
      "superpowers"
    ],
    skins: [
      {
        unified: "1f9b8-200d-2640-fe0f",
        native: "🦸‍♀️"
      },
      {
        unified: "1f9b8-1f3fb-200d-2640-fe0f",
        native: "🦸🏻‍♀️"
      },
      {
        unified: "1f9b8-1f3fc-200d-2640-fe0f",
        native: "🦸🏼‍♀️"
      },
      {
        unified: "1f9b8-1f3fd-200d-2640-fe0f",
        native: "🦸🏽‍♀️"
      },
      {
        unified: "1f9b8-1f3fe-200d-2640-fe0f",
        native: "🦸🏾‍♀️"
      },
      {
        unified: "1f9b8-1f3ff-200d-2640-fe0f",
        native: "🦸🏿‍♀️"
      }
    ],
    version: 11
  },
  supervillain: {
    id: "supervillain",
    name: "Supervillain",
    keywords: [
      "marvel"
    ],
    skins: [
      {
        unified: "1f9b9",
        native: "🦹"
      },
      {
        unified: "1f9b9-1f3fb",
        native: "🦹🏻"
      },
      {
        unified: "1f9b9-1f3fc",
        native: "🦹🏼"
      },
      {
        unified: "1f9b9-1f3fd",
        native: "🦹🏽"
      },
      {
        unified: "1f9b9-1f3fe",
        native: "🦹🏾"
      },
      {
        unified: "1f9b9-1f3ff",
        native: "🦹🏿"
      }
    ],
    version: 11
  },
  male_supervillain: {
    id: "male_supervillain",
    name: "Man Supervillain",
    keywords: [
      "male",
      "evil",
      "bad",
      "criminal",
      "hero",
      "superpowers"
    ],
    skins: [
      {
        unified: "1f9b9-200d-2642-fe0f",
        native: "🦹‍♂️"
      },
      {
        unified: "1f9b9-1f3fb-200d-2642-fe0f",
        native: "🦹🏻‍♂️"
      },
      {
        unified: "1f9b9-1f3fc-200d-2642-fe0f",
        native: "🦹🏼‍♂️"
      },
      {
        unified: "1f9b9-1f3fd-200d-2642-fe0f",
        native: "🦹🏽‍♂️"
      },
      {
        unified: "1f9b9-1f3fe-200d-2642-fe0f",
        native: "🦹🏾‍♂️"
      },
      {
        unified: "1f9b9-1f3ff-200d-2642-fe0f",
        native: "🦹🏿‍♂️"
      }
    ],
    version: 11
  },
  female_supervillain: {
    id: "female_supervillain",
    name: "Woman Supervillain",
    keywords: [
      "female",
      "evil",
      "bad",
      "criminal",
      "heroine",
      "superpowers"
    ],
    skins: [
      {
        unified: "1f9b9-200d-2640-fe0f",
        native: "🦹‍♀️"
      },
      {
        unified: "1f9b9-1f3fb-200d-2640-fe0f",
        native: "🦹🏻‍♀️"
      },
      {
        unified: "1f9b9-1f3fc-200d-2640-fe0f",
        native: "🦹🏼‍♀️"
      },
      {
        unified: "1f9b9-1f3fd-200d-2640-fe0f",
        native: "🦹🏽‍♀️"
      },
      {
        unified: "1f9b9-1f3fe-200d-2640-fe0f",
        native: "🦹🏾‍♀️"
      },
      {
        unified: "1f9b9-1f3ff-200d-2640-fe0f",
        native: "🦹🏿‍♀️"
      }
    ],
    version: 11
  },
  mage: {
    id: "mage",
    name: "Mage",
    keywords: [
      "magic"
    ],
    skins: [
      {
        unified: "1f9d9",
        native: "🧙"
      },
      {
        unified: "1f9d9-1f3fb",
        native: "🧙🏻"
      },
      {
        unified: "1f9d9-1f3fc",
        native: "🧙🏼"
      },
      {
        unified: "1f9d9-1f3fd",
        native: "🧙🏽"
      },
      {
        unified: "1f9d9-1f3fe",
        native: "🧙🏾"
      },
      {
        unified: "1f9d9-1f3ff",
        native: "🧙🏿"
      }
    ],
    version: 5
  },
  male_mage: {
    id: "male_mage",
    name: "Man Mage",
    keywords: [
      "male",
      "sorcerer"
    ],
    skins: [
      {
        unified: "1f9d9-200d-2642-fe0f",
        native: "🧙‍♂️"
      },
      {
        unified: "1f9d9-1f3fb-200d-2642-fe0f",
        native: "🧙🏻‍♂️"
      },
      {
        unified: "1f9d9-1f3fc-200d-2642-fe0f",
        native: "🧙🏼‍♂️"
      },
      {
        unified: "1f9d9-1f3fd-200d-2642-fe0f",
        native: "🧙🏽‍♂️"
      },
      {
        unified: "1f9d9-1f3fe-200d-2642-fe0f",
        native: "🧙🏾‍♂️"
      },
      {
        unified: "1f9d9-1f3ff-200d-2642-fe0f",
        native: "🧙🏿‍♂️"
      }
    ],
    version: 5
  },
  female_mage: {
    id: "female_mage",
    name: "Woman Mage",
    keywords: [
      "female",
      "witch"
    ],
    skins: [
      {
        unified: "1f9d9-200d-2640-fe0f",
        native: "🧙‍♀️"
      },
      {
        unified: "1f9d9-1f3fb-200d-2640-fe0f",
        native: "🧙🏻‍♀️"
      },
      {
        unified: "1f9d9-1f3fc-200d-2640-fe0f",
        native: "🧙🏼‍♀️"
      },
      {
        unified: "1f9d9-1f3fd-200d-2640-fe0f",
        native: "🧙🏽‍♀️"
      },
      {
        unified: "1f9d9-1f3fe-200d-2640-fe0f",
        native: "🧙🏾‍♀️"
      },
      {
        unified: "1f9d9-1f3ff-200d-2640-fe0f",
        native: "🧙🏿‍♀️"
      }
    ],
    version: 5
  },
  fairy: {
    id: "fairy",
    name: "Fairy",
    keywords: [
      "wings",
      "magical"
    ],
    skins: [
      {
        unified: "1f9da",
        native: "🧚"
      },
      {
        unified: "1f9da-1f3fb",
        native: "🧚🏻"
      },
      {
        unified: "1f9da-1f3fc",
        native: "🧚🏼"
      },
      {
        unified: "1f9da-1f3fd",
        native: "🧚🏽"
      },
      {
        unified: "1f9da-1f3fe",
        native: "🧚🏾"
      },
      {
        unified: "1f9da-1f3ff",
        native: "🧚🏿"
      }
    ],
    version: 5
  },
  male_fairy: {
    id: "male_fairy",
    name: "Man Fairy",
    keywords: [
      "male"
    ],
    skins: [
      {
        unified: "1f9da-200d-2642-fe0f",
        native: "🧚‍♂️"
      },
      {
        unified: "1f9da-1f3fb-200d-2642-fe0f",
        native: "🧚🏻‍♂️"
      },
      {
        unified: "1f9da-1f3fc-200d-2642-fe0f",
        native: "🧚🏼‍♂️"
      },
      {
        unified: "1f9da-1f3fd-200d-2642-fe0f",
        native: "🧚🏽‍♂️"
      },
      {
        unified: "1f9da-1f3fe-200d-2642-fe0f",
        native: "🧚🏾‍♂️"
      },
      {
        unified: "1f9da-1f3ff-200d-2642-fe0f",
        native: "🧚🏿‍♂️"
      }
    ],
    version: 5
  },
  female_fairy: {
    id: "female_fairy",
    name: "Woman Fairy",
    keywords: [
      "female"
    ],
    skins: [
      {
        unified: "1f9da-200d-2640-fe0f",
        native: "🧚‍♀️"
      },
      {
        unified: "1f9da-1f3fb-200d-2640-fe0f",
        native: "🧚🏻‍♀️"
      },
      {
        unified: "1f9da-1f3fc-200d-2640-fe0f",
        native: "🧚🏼‍♀️"
      },
      {
        unified: "1f9da-1f3fd-200d-2640-fe0f",
        native: "🧚🏽‍♀️"
      },
      {
        unified: "1f9da-1f3fe-200d-2640-fe0f",
        native: "🧚🏾‍♀️"
      },
      {
        unified: "1f9da-1f3ff-200d-2640-fe0f",
        native: "🧚🏿‍♀️"
      }
    ],
    version: 5
  },
  vampire: {
    id: "vampire",
    name: "Vampire",
    keywords: [
      "blood",
      "twilight"
    ],
    skins: [
      {
        unified: "1f9db",
        native: "🧛"
      },
      {
        unified: "1f9db-1f3fb",
        native: "🧛🏻"
      },
      {
        unified: "1f9db-1f3fc",
        native: "🧛🏼"
      },
      {
        unified: "1f9db-1f3fd",
        native: "🧛🏽"
      },
      {
        unified: "1f9db-1f3fe",
        native: "🧛🏾"
      },
      {
        unified: "1f9db-1f3ff",
        native: "🧛🏿"
      }
    ],
    version: 5
  },
  male_vampire: {
    id: "male_vampire",
    name: "Man Vampire",
    keywords: [
      "male",
      "dracula"
    ],
    skins: [
      {
        unified: "1f9db-200d-2642-fe0f",
        native: "🧛‍♂️"
      },
      {
        unified: "1f9db-1f3fb-200d-2642-fe0f",
        native: "🧛🏻‍♂️"
      },
      {
        unified: "1f9db-1f3fc-200d-2642-fe0f",
        native: "🧛🏼‍♂️"
      },
      {
        unified: "1f9db-1f3fd-200d-2642-fe0f",
        native: "🧛🏽‍♂️"
      },
      {
        unified: "1f9db-1f3fe-200d-2642-fe0f",
        native: "🧛🏾‍♂️"
      },
      {
        unified: "1f9db-1f3ff-200d-2642-fe0f",
        native: "🧛🏿‍♂️"
      }
    ],
    version: 5
  },
  female_vampire: {
    id: "female_vampire",
    name: "Woman Vampire",
    keywords: [
      "female"
    ],
    skins: [
      {
        unified: "1f9db-200d-2640-fe0f",
        native: "🧛‍♀️"
      },
      {
        unified: "1f9db-1f3fb-200d-2640-fe0f",
        native: "🧛🏻‍♀️"
      },
      {
        unified: "1f9db-1f3fc-200d-2640-fe0f",
        native: "🧛🏼‍♀️"
      },
      {
        unified: "1f9db-1f3fd-200d-2640-fe0f",
        native: "🧛🏽‍♀️"
      },
      {
        unified: "1f9db-1f3fe-200d-2640-fe0f",
        native: "🧛🏾‍♀️"
      },
      {
        unified: "1f9db-1f3ff-200d-2640-fe0f",
        native: "🧛🏿‍♀️"
      }
    ],
    version: 5
  },
  merperson: {
    id: "merperson",
    name: "Merperson",
    keywords: [
      "sea"
    ],
    skins: [
      {
        unified: "1f9dc",
        native: "🧜"
      },
      {
        unified: "1f9dc-1f3fb",
        native: "🧜🏻"
      },
      {
        unified: "1f9dc-1f3fc",
        native: "🧜🏼"
      },
      {
        unified: "1f9dc-1f3fd",
        native: "🧜🏽"
      },
      {
        unified: "1f9dc-1f3fe",
        native: "🧜🏾"
      },
      {
        unified: "1f9dc-1f3ff",
        native: "🧜🏿"
      }
    ],
    version: 5
  },
  merman: {
    id: "merman",
    name: "Merman",
    keywords: [
      "man",
      "male",
      "triton"
    ],
    skins: [
      {
        unified: "1f9dc-200d-2642-fe0f",
        native: "🧜‍♂️"
      },
      {
        unified: "1f9dc-1f3fb-200d-2642-fe0f",
        native: "🧜🏻‍♂️"
      },
      {
        unified: "1f9dc-1f3fc-200d-2642-fe0f",
        native: "🧜🏼‍♂️"
      },
      {
        unified: "1f9dc-1f3fd-200d-2642-fe0f",
        native: "🧜🏽‍♂️"
      },
      {
        unified: "1f9dc-1f3fe-200d-2642-fe0f",
        native: "🧜🏾‍♂️"
      },
      {
        unified: "1f9dc-1f3ff-200d-2642-fe0f",
        native: "🧜🏿‍♂️"
      }
    ],
    version: 5
  },
  mermaid: {
    id: "mermaid",
    name: "Mermaid",
    keywords: [
      "woman",
      "female",
      "merwoman",
      "ariel"
    ],
    skins: [
      {
        unified: "1f9dc-200d-2640-fe0f",
        native: "🧜‍♀️"
      },
      {
        unified: "1f9dc-1f3fb-200d-2640-fe0f",
        native: "🧜🏻‍♀️"
      },
      {
        unified: "1f9dc-1f3fc-200d-2640-fe0f",
        native: "🧜🏼‍♀️"
      },
      {
        unified: "1f9dc-1f3fd-200d-2640-fe0f",
        native: "🧜🏽‍♀️"
      },
      {
        unified: "1f9dc-1f3fe-200d-2640-fe0f",
        native: "🧜🏾‍♀️"
      },
      {
        unified: "1f9dc-1f3ff-200d-2640-fe0f",
        native: "🧜🏿‍♀️"
      }
    ],
    version: 5
  },
  elf: {
    id: "elf",
    name: "Elf",
    keywords: [
      "magical"
    ],
    skins: [
      {
        unified: "1f9dd",
        native: "🧝"
      },
      {
        unified: "1f9dd-1f3fb",
        native: "🧝🏻"
      },
      {
        unified: "1f9dd-1f3fc",
        native: "🧝🏼"
      },
      {
        unified: "1f9dd-1f3fd",
        native: "🧝🏽"
      },
      {
        unified: "1f9dd-1f3fe",
        native: "🧝🏾"
      },
      {
        unified: "1f9dd-1f3ff",
        native: "🧝🏿"
      }
    ],
    version: 5
  },
  male_elf: {
    id: "male_elf",
    name: "Man Elf",
    keywords: [
      "male"
    ],
    skins: [
      {
        unified: "1f9dd-200d-2642-fe0f",
        native: "🧝‍♂️"
      },
      {
        unified: "1f9dd-1f3fb-200d-2642-fe0f",
        native: "🧝🏻‍♂️"
      },
      {
        unified: "1f9dd-1f3fc-200d-2642-fe0f",
        native: "🧝🏼‍♂️"
      },
      {
        unified: "1f9dd-1f3fd-200d-2642-fe0f",
        native: "🧝🏽‍♂️"
      },
      {
        unified: "1f9dd-1f3fe-200d-2642-fe0f",
        native: "🧝🏾‍♂️"
      },
      {
        unified: "1f9dd-1f3ff-200d-2642-fe0f",
        native: "🧝🏿‍♂️"
      }
    ],
    version: 5
  },
  female_elf: {
    id: "female_elf",
    name: "Woman Elf",
    keywords: [
      "female"
    ],
    skins: [
      {
        unified: "1f9dd-200d-2640-fe0f",
        native: "🧝‍♀️"
      },
      {
        unified: "1f9dd-1f3fb-200d-2640-fe0f",
        native: "🧝🏻‍♀️"
      },
      {
        unified: "1f9dd-1f3fc-200d-2640-fe0f",
        native: "🧝🏼‍♀️"
      },
      {
        unified: "1f9dd-1f3fd-200d-2640-fe0f",
        native: "🧝🏽‍♀️"
      },
      {
        unified: "1f9dd-1f3fe-200d-2640-fe0f",
        native: "🧝🏾‍♀️"
      },
      {
        unified: "1f9dd-1f3ff-200d-2640-fe0f",
        native: "🧝🏿‍♀️"
      }
    ],
    version: 5
  },
  genie: {
    id: "genie",
    name: "Genie",
    keywords: [
      "magical",
      "wishes"
    ],
    skins: [
      {
        unified: "1f9de",
        native: "🧞"
      }
    ],
    version: 5
  },
  male_genie: {
    id: "male_genie",
    name: "Man Genie",
    keywords: [
      "male"
    ],
    skins: [
      {
        unified: "1f9de-200d-2642-fe0f",
        native: "🧞‍♂️"
      }
    ],
    version: 5
  },
  female_genie: {
    id: "female_genie",
    name: "Woman Genie",
    keywords: [
      "female"
    ],
    skins: [
      {
        unified: "1f9de-200d-2640-fe0f",
        native: "🧞‍♀️"
      }
    ],
    version: 5
  },
  zombie: {
    id: "zombie",
    name: "Zombie",
    keywords: [
      "dead"
    ],
    skins: [
      {
        unified: "1f9df",
        native: "🧟"
      }
    ],
    version: 5
  },
  male_zombie: {
    id: "male_zombie",
    name: "Man Zombie",
    keywords: [
      "male",
      "dracula",
      "undead",
      "walking",
      "dead"
    ],
    skins: [
      {
        unified: "1f9df-200d-2642-fe0f",
        native: "🧟‍♂️"
      }
    ],
    version: 5
  },
  female_zombie: {
    id: "female_zombie",
    name: "Woman Zombie",
    keywords: [
      "female",
      "undead",
      "walking",
      "dead"
    ],
    skins: [
      {
        unified: "1f9df-200d-2640-fe0f",
        native: "🧟‍♀️"
      }
    ],
    version: 5
  },
  troll: {
    id: "troll",
    name: "Troll",
    keywords: [
      "mystical",
      "monster"
    ],
    skins: [
      {
        unified: "1f9cc",
        native: "🧌"
      }
    ],
    version: 14
  },
  massage: {
    id: "massage",
    name: "Face Massage",
    keywords: [
      "person",
      "getting",
      "relax"
    ],
    skins: [
      {
        unified: "1f486",
        native: "💆"
      },
      {
        unified: "1f486-1f3fb",
        native: "💆🏻"
      },
      {
        unified: "1f486-1f3fc",
        native: "💆🏼"
      },
      {
        unified: "1f486-1f3fd",
        native: "💆🏽"
      },
      {
        unified: "1f486-1f3fe",
        native: "💆🏾"
      },
      {
        unified: "1f486-1f3ff",
        native: "💆🏿"
      }
    ],
    version: 1
  },
  "man-getting-massage": {
    id: "man-getting-massage",
    name: "Man Getting Massage",
    keywords: [
      "getting-massage",
      "male",
      "boy",
      "head"
    ],
    skins: [
      {
        unified: "1f486-200d-2642-fe0f",
        native: "💆‍♂️"
      },
      {
        unified: "1f486-1f3fb-200d-2642-fe0f",
        native: "💆🏻‍♂️"
      },
      {
        unified: "1f486-1f3fc-200d-2642-fe0f",
        native: "💆🏼‍♂️"
      },
      {
        unified: "1f486-1f3fd-200d-2642-fe0f",
        native: "💆🏽‍♂️"
      },
      {
        unified: "1f486-1f3fe-200d-2642-fe0f",
        native: "💆🏾‍♂️"
      },
      {
        unified: "1f486-1f3ff-200d-2642-fe0f",
        native: "💆🏿‍♂️"
      }
    ],
    version: 4
  },
  "woman-getting-massage": {
    id: "woman-getting-massage",
    name: "Woman Getting Massage",
    keywords: [
      "getting-massage",
      "female",
      "girl",
      "head"
    ],
    skins: [
      {
        unified: "1f486-200d-2640-fe0f",
        native: "💆‍♀️"
      },
      {
        unified: "1f486-1f3fb-200d-2640-fe0f",
        native: "💆🏻‍♀️"
      },
      {
        unified: "1f486-1f3fc-200d-2640-fe0f",
        native: "💆🏼‍♀️"
      },
      {
        unified: "1f486-1f3fd-200d-2640-fe0f",
        native: "💆🏽‍♀️"
      },
      {
        unified: "1f486-1f3fe-200d-2640-fe0f",
        native: "💆🏾‍♀️"
      },
      {
        unified: "1f486-1f3ff-200d-2640-fe0f",
        native: "💆🏿‍♀️"
      }
    ],
    version: 4
  },
  haircut: {
    id: "haircut",
    name: "Haircut",
    keywords: [
      "person",
      "getting",
      "hairstyle"
    ],
    skins: [
      {
        unified: "1f487",
        native: "💇"
      },
      {
        unified: "1f487-1f3fb",
        native: "💇🏻"
      },
      {
        unified: "1f487-1f3fc",
        native: "💇🏼"
      },
      {
        unified: "1f487-1f3fd",
        native: "💇🏽"
      },
      {
        unified: "1f487-1f3fe",
        native: "💇🏾"
      },
      {
        unified: "1f487-1f3ff",
        native: "💇🏿"
      }
    ],
    version: 1
  },
  "man-getting-haircut": {
    id: "man-getting-haircut",
    name: "Man Getting Haircut",
    keywords: [
      "getting-haircut",
      "male",
      "boy"
    ],
    skins: [
      {
        unified: "1f487-200d-2642-fe0f",
        native: "💇‍♂️"
      },
      {
        unified: "1f487-1f3fb-200d-2642-fe0f",
        native: "💇🏻‍♂️"
      },
      {
        unified: "1f487-1f3fc-200d-2642-fe0f",
        native: "💇🏼‍♂️"
      },
      {
        unified: "1f487-1f3fd-200d-2642-fe0f",
        native: "💇🏽‍♂️"
      },
      {
        unified: "1f487-1f3fe-200d-2642-fe0f",
        native: "💇🏾‍♂️"
      },
      {
        unified: "1f487-1f3ff-200d-2642-fe0f",
        native: "💇🏿‍♂️"
      }
    ],
    version: 4
  },
  "woman-getting-haircut": {
    id: "woman-getting-haircut",
    name: "Woman Getting Haircut",
    keywords: [
      "getting-haircut",
      "female",
      "girl"
    ],
    skins: [
      {
        unified: "1f487-200d-2640-fe0f",
        native: "💇‍♀️"
      },
      {
        unified: "1f487-1f3fb-200d-2640-fe0f",
        native: "💇🏻‍♀️"
      },
      {
        unified: "1f487-1f3fc-200d-2640-fe0f",
        native: "💇🏼‍♀️"
      },
      {
        unified: "1f487-1f3fd-200d-2640-fe0f",
        native: "💇🏽‍♀️"
      },
      {
        unified: "1f487-1f3fe-200d-2640-fe0f",
        native: "💇🏾‍♀️"
      },
      {
        unified: "1f487-1f3ff-200d-2640-fe0f",
        native: "💇🏿‍♀️"
      }
    ],
    version: 4
  },
  walking: {
    id: "walking",
    name: "Pedestrian",
    keywords: [
      "walking",
      "person",
      "move"
    ],
    skins: [
      {
        unified: "1f6b6",
        native: "🚶"
      },
      {
        unified: "1f6b6-1f3fb",
        native: "🚶🏻"
      },
      {
        unified: "1f6b6-1f3fc",
        native: "🚶🏼"
      },
      {
        unified: "1f6b6-1f3fd",
        native: "🚶🏽"
      },
      {
        unified: "1f6b6-1f3fe",
        native: "🚶🏾"
      },
      {
        unified: "1f6b6-1f3ff",
        native: "🚶🏿"
      }
    ],
    version: 1
  },
  "man-walking": {
    id: "man-walking",
    name: "Man Walking",
    keywords: [
      "human",
      "feet",
      "steps"
    ],
    skins: [
      {
        unified: "1f6b6-200d-2642-fe0f",
        native: "🚶‍♂️"
      },
      {
        unified: "1f6b6-1f3fb-200d-2642-fe0f",
        native: "🚶🏻‍♂️"
      },
      {
        unified: "1f6b6-1f3fc-200d-2642-fe0f",
        native: "🚶🏼‍♂️"
      },
      {
        unified: "1f6b6-1f3fd-200d-2642-fe0f",
        native: "🚶🏽‍♂️"
      },
      {
        unified: "1f6b6-1f3fe-200d-2642-fe0f",
        native: "🚶🏾‍♂️"
      },
      {
        unified: "1f6b6-1f3ff-200d-2642-fe0f",
        native: "🚶🏿‍♂️"
      }
    ],
    version: 4
  },
  "woman-walking": {
    id: "woman-walking",
    name: "Woman Walking",
    keywords: [
      "human",
      "feet",
      "steps",
      "female"
    ],
    skins: [
      {
        unified: "1f6b6-200d-2640-fe0f",
        native: "🚶‍♀️"
      },
      {
        unified: "1f6b6-1f3fb-200d-2640-fe0f",
        native: "🚶🏻‍♀️"
      },
      {
        unified: "1f6b6-1f3fc-200d-2640-fe0f",
        native: "🚶🏼‍♀️"
      },
      {
        unified: "1f6b6-1f3fd-200d-2640-fe0f",
        native: "🚶🏽‍♀️"
      },
      {
        unified: "1f6b6-1f3fe-200d-2640-fe0f",
        native: "🚶🏾‍♀️"
      },
      {
        unified: "1f6b6-1f3ff-200d-2640-fe0f",
        native: "🚶🏿‍♀️"
      }
    ],
    version: 4
  },
  standing_person: {
    id: "standing_person",
    name: "Standing Person",
    keywords: [
      "still"
    ],
    skins: [
      {
        unified: "1f9cd",
        native: "🧍"
      },
      {
        unified: "1f9cd-1f3fb",
        native: "🧍🏻"
      },
      {
        unified: "1f9cd-1f3fc",
        native: "🧍🏼"
      },
      {
        unified: "1f9cd-1f3fd",
        native: "🧍🏽"
      },
      {
        unified: "1f9cd-1f3fe",
        native: "🧍🏾"
      },
      {
        unified: "1f9cd-1f3ff",
        native: "🧍🏿"
      }
    ],
    version: 12
  },
  man_standing: {
    id: "man_standing",
    name: "Man Standing",
    keywords: [
      "still"
    ],
    skins: [
      {
        unified: "1f9cd-200d-2642-fe0f",
        native: "🧍‍♂️"
      },
      {
        unified: "1f9cd-1f3fb-200d-2642-fe0f",
        native: "🧍🏻‍♂️"
      },
      {
        unified: "1f9cd-1f3fc-200d-2642-fe0f",
        native: "🧍🏼‍♂️"
      },
      {
        unified: "1f9cd-1f3fd-200d-2642-fe0f",
        native: "🧍🏽‍♂️"
      },
      {
        unified: "1f9cd-1f3fe-200d-2642-fe0f",
        native: "🧍🏾‍♂️"
      },
      {
        unified: "1f9cd-1f3ff-200d-2642-fe0f",
        native: "🧍🏿‍♂️"
      }
    ],
    version: 12
  },
  woman_standing: {
    id: "woman_standing",
    name: "Woman Standing",
    keywords: [
      "still"
    ],
    skins: [
      {
        unified: "1f9cd-200d-2640-fe0f",
        native: "🧍‍♀️"
      },
      {
        unified: "1f9cd-1f3fb-200d-2640-fe0f",
        native: "🧍🏻‍♀️"
      },
      {
        unified: "1f9cd-1f3fc-200d-2640-fe0f",
        native: "🧍🏼‍♀️"
      },
      {
        unified: "1f9cd-1f3fd-200d-2640-fe0f",
        native: "🧍🏽‍♀️"
      },
      {
        unified: "1f9cd-1f3fe-200d-2640-fe0f",
        native: "🧍🏾‍♀️"
      },
      {
        unified: "1f9cd-1f3ff-200d-2640-fe0f",
        native: "🧍🏿‍♀️"
      }
    ],
    version: 12
  },
  kneeling_person: {
    id: "kneeling_person",
    name: "Kneeling Person",
    keywords: [
      "pray",
      "respectful"
    ],
    skins: [
      {
        unified: "1f9ce",
        native: "🧎"
      },
      {
        unified: "1f9ce-1f3fb",
        native: "🧎🏻"
      },
      {
        unified: "1f9ce-1f3fc",
        native: "🧎🏼"
      },
      {
        unified: "1f9ce-1f3fd",
        native: "🧎🏽"
      },
      {
        unified: "1f9ce-1f3fe",
        native: "🧎🏾"
      },
      {
        unified: "1f9ce-1f3ff",
        native: "🧎🏿"
      }
    ],
    version: 12
  },
  man_kneeling: {
    id: "man_kneeling",
    name: "Man Kneeling",
    keywords: [
      "pray",
      "respectful"
    ],
    skins: [
      {
        unified: "1f9ce-200d-2642-fe0f",
        native: "🧎‍♂️"
      },
      {
        unified: "1f9ce-1f3fb-200d-2642-fe0f",
        native: "🧎🏻‍♂️"
      },
      {
        unified: "1f9ce-1f3fc-200d-2642-fe0f",
        native: "🧎🏼‍♂️"
      },
      {
        unified: "1f9ce-1f3fd-200d-2642-fe0f",
        native: "🧎🏽‍♂️"
      },
      {
        unified: "1f9ce-1f3fe-200d-2642-fe0f",
        native: "🧎🏾‍♂️"
      },
      {
        unified: "1f9ce-1f3ff-200d-2642-fe0f",
        native: "🧎🏿‍♂️"
      }
    ],
    version: 12
  },
  woman_kneeling: {
    id: "woman_kneeling",
    name: "Woman Kneeling",
    keywords: [
      "respectful",
      "pray"
    ],
    skins: [
      {
        unified: "1f9ce-200d-2640-fe0f",
        native: "🧎‍♀️"
      },
      {
        unified: "1f9ce-1f3fb-200d-2640-fe0f",
        native: "🧎🏻‍♀️"
      },
      {
        unified: "1f9ce-1f3fc-200d-2640-fe0f",
        native: "🧎🏼‍♀️"
      },
      {
        unified: "1f9ce-1f3fd-200d-2640-fe0f",
        native: "🧎🏽‍♀️"
      },
      {
        unified: "1f9ce-1f3fe-200d-2640-fe0f",
        native: "🧎🏾‍♀️"
      },
      {
        unified: "1f9ce-1f3ff-200d-2640-fe0f",
        native: "🧎🏿‍♀️"
      }
    ],
    version: 12
  },
  person_with_probing_cane: {
    id: "person_with_probing_cane",
    name: "Person with White Cane",
    keywords: [
      "probing",
      "blind"
    ],
    skins: [
      {
        unified: "1f9d1-200d-1f9af",
        native: "🧑‍🦯"
      },
      {
        unified: "1f9d1-1f3fb-200d-1f9af",
        native: "🧑🏻‍🦯"
      },
      {
        unified: "1f9d1-1f3fc-200d-1f9af",
        native: "🧑🏼‍🦯"
      },
      {
        unified: "1f9d1-1f3fd-200d-1f9af",
        native: "🧑🏽‍🦯"
      },
      {
        unified: "1f9d1-1f3fe-200d-1f9af",
        native: "🧑🏾‍🦯"
      },
      {
        unified: "1f9d1-1f3ff-200d-1f9af",
        native: "🧑🏿‍🦯"
      }
    ],
    version: 12.1
  },
  man_with_probing_cane: {
    id: "man_with_probing_cane",
    name: "Man with White Cane",
    keywords: [
      "probing",
      "blind"
    ],
    skins: [
      {
        unified: "1f468-200d-1f9af",
        native: "👨‍🦯"
      },
      {
        unified: "1f468-1f3fb-200d-1f9af",
        native: "👨🏻‍🦯"
      },
      {
        unified: "1f468-1f3fc-200d-1f9af",
        native: "👨🏼‍🦯"
      },
      {
        unified: "1f468-1f3fd-200d-1f9af",
        native: "👨🏽‍🦯"
      },
      {
        unified: "1f468-1f3fe-200d-1f9af",
        native: "👨🏾‍🦯"
      },
      {
        unified: "1f468-1f3ff-200d-1f9af",
        native: "👨🏿‍🦯"
      }
    ],
    version: 12
  },
  woman_with_probing_cane: {
    id: "woman_with_probing_cane",
    name: "Woman with White Cane",
    keywords: [
      "probing",
      "blind"
    ],
    skins: [
      {
        unified: "1f469-200d-1f9af",
        native: "👩‍🦯"
      },
      {
        unified: "1f469-1f3fb-200d-1f9af",
        native: "👩🏻‍🦯"
      },
      {
        unified: "1f469-1f3fc-200d-1f9af",
        native: "👩🏼‍🦯"
      },
      {
        unified: "1f469-1f3fd-200d-1f9af",
        native: "👩🏽‍🦯"
      },
      {
        unified: "1f469-1f3fe-200d-1f9af",
        native: "👩🏾‍🦯"
      },
      {
        unified: "1f469-1f3ff-200d-1f9af",
        native: "👩🏿‍🦯"
      }
    ],
    version: 12
  },
  person_in_motorized_wheelchair: {
    id: "person_in_motorized_wheelchair",
    name: "Person in Motorized Wheelchair",
    keywords: [
      "disability",
      "accessibility"
    ],
    skins: [
      {
        unified: "1f9d1-200d-1f9bc",
        native: "🧑‍🦼"
      },
      {
        unified: "1f9d1-1f3fb-200d-1f9bc",
        native: "🧑🏻‍🦼"
      },
      {
        unified: "1f9d1-1f3fc-200d-1f9bc",
        native: "🧑🏼‍🦼"
      },
      {
        unified: "1f9d1-1f3fd-200d-1f9bc",
        native: "🧑🏽‍🦼"
      },
      {
        unified: "1f9d1-1f3fe-200d-1f9bc",
        native: "🧑🏾‍🦼"
      },
      {
        unified: "1f9d1-1f3ff-200d-1f9bc",
        native: "🧑🏿‍🦼"
      }
    ],
    version: 12.1
  },
  man_in_motorized_wheelchair: {
    id: "man_in_motorized_wheelchair",
    name: "Man in Motorized Wheelchair",
    keywords: [
      "disability",
      "accessibility"
    ],
    skins: [
      {
        unified: "1f468-200d-1f9bc",
        native: "👨‍🦼"
      },
      {
        unified: "1f468-1f3fb-200d-1f9bc",
        native: "👨🏻‍🦼"
      },
      {
        unified: "1f468-1f3fc-200d-1f9bc",
        native: "👨🏼‍🦼"
      },
      {
        unified: "1f468-1f3fd-200d-1f9bc",
        native: "👨🏽‍🦼"
      },
      {
        unified: "1f468-1f3fe-200d-1f9bc",
        native: "👨🏾‍🦼"
      },
      {
        unified: "1f468-1f3ff-200d-1f9bc",
        native: "👨🏿‍🦼"
      }
    ],
    version: 12
  },
  woman_in_motorized_wheelchair: {
    id: "woman_in_motorized_wheelchair",
    name: "Woman in Motorized Wheelchair",
    keywords: [
      "disability",
      "accessibility"
    ],
    skins: [
      {
        unified: "1f469-200d-1f9bc",
        native: "👩‍🦼"
      },
      {
        unified: "1f469-1f3fb-200d-1f9bc",
        native: "👩🏻‍🦼"
      },
      {
        unified: "1f469-1f3fc-200d-1f9bc",
        native: "👩🏼‍🦼"
      },
      {
        unified: "1f469-1f3fd-200d-1f9bc",
        native: "👩🏽‍🦼"
      },
      {
        unified: "1f469-1f3fe-200d-1f9bc",
        native: "👩🏾‍🦼"
      },
      {
        unified: "1f469-1f3ff-200d-1f9bc",
        native: "👩🏿‍🦼"
      }
    ],
    version: 12
  },
  person_in_manual_wheelchair: {
    id: "person_in_manual_wheelchair",
    name: "Person in Manual Wheelchair",
    keywords: [
      "disability",
      "accessibility"
    ],
    skins: [
      {
        unified: "1f9d1-200d-1f9bd",
        native: "🧑‍🦽"
      },
      {
        unified: "1f9d1-1f3fb-200d-1f9bd",
        native: "🧑🏻‍🦽"
      },
      {
        unified: "1f9d1-1f3fc-200d-1f9bd",
        native: "🧑🏼‍🦽"
      },
      {
        unified: "1f9d1-1f3fd-200d-1f9bd",
        native: "🧑🏽‍🦽"
      },
      {
        unified: "1f9d1-1f3fe-200d-1f9bd",
        native: "🧑🏾‍🦽"
      },
      {
        unified: "1f9d1-1f3ff-200d-1f9bd",
        native: "🧑🏿‍🦽"
      }
    ],
    version: 12.1
  },
  man_in_manual_wheelchair: {
    id: "man_in_manual_wheelchair",
    name: "Man in Manual Wheelchair",
    keywords: [
      "disability",
      "accessibility"
    ],
    skins: [
      {
        unified: "1f468-200d-1f9bd",
        native: "👨‍🦽"
      },
      {
        unified: "1f468-1f3fb-200d-1f9bd",
        native: "👨🏻‍🦽"
      },
      {
        unified: "1f468-1f3fc-200d-1f9bd",
        native: "👨🏼‍🦽"
      },
      {
        unified: "1f468-1f3fd-200d-1f9bd",
        native: "👨🏽‍🦽"
      },
      {
        unified: "1f468-1f3fe-200d-1f9bd",
        native: "👨🏾‍🦽"
      },
      {
        unified: "1f468-1f3ff-200d-1f9bd",
        native: "👨🏿‍🦽"
      }
    ],
    version: 12
  },
  woman_in_manual_wheelchair: {
    id: "woman_in_manual_wheelchair",
    name: "Woman in Manual Wheelchair",
    keywords: [
      "disability",
      "accessibility"
    ],
    skins: [
      {
        unified: "1f469-200d-1f9bd",
        native: "👩‍🦽"
      },
      {
        unified: "1f469-1f3fb-200d-1f9bd",
        native: "👩🏻‍🦽"
      },
      {
        unified: "1f469-1f3fc-200d-1f9bd",
        native: "👩🏼‍🦽"
      },
      {
        unified: "1f469-1f3fd-200d-1f9bd",
        native: "👩🏽‍🦽"
      },
      {
        unified: "1f469-1f3fe-200d-1f9bd",
        native: "👩🏾‍🦽"
      },
      {
        unified: "1f469-1f3ff-200d-1f9bd",
        native: "👩🏿‍🦽"
      }
    ],
    version: 12
  },
  runner: {
    id: "runner",
    name: "Runner",
    keywords: [
      "running",
      "person",
      "move"
    ],
    skins: [
      {
        unified: "1f3c3",
        native: "🏃"
      },
      {
        unified: "1f3c3-1f3fb",
        native: "🏃🏻"
      },
      {
        unified: "1f3c3-1f3fc",
        native: "🏃🏼"
      },
      {
        unified: "1f3c3-1f3fd",
        native: "🏃🏽"
      },
      {
        unified: "1f3c3-1f3fe",
        native: "🏃🏾"
      },
      {
        unified: "1f3c3-1f3ff",
        native: "🏃🏿"
      }
    ],
    version: 1
  },
  "man-running": {
    id: "man-running",
    name: "Man Running",
    keywords: [
      "walking",
      "exercise",
      "race"
    ],
    skins: [
      {
        unified: "1f3c3-200d-2642-fe0f",
        native: "🏃‍♂️"
      },
      {
        unified: "1f3c3-1f3fb-200d-2642-fe0f",
        native: "🏃🏻‍♂️"
      },
      {
        unified: "1f3c3-1f3fc-200d-2642-fe0f",
        native: "🏃🏼‍♂️"
      },
      {
        unified: "1f3c3-1f3fd-200d-2642-fe0f",
        native: "🏃🏽‍♂️"
      },
      {
        unified: "1f3c3-1f3fe-200d-2642-fe0f",
        native: "🏃🏾‍♂️"
      },
      {
        unified: "1f3c3-1f3ff-200d-2642-fe0f",
        native: "🏃🏿‍♂️"
      }
    ],
    version: 4
  },
  "woman-running": {
    id: "woman-running",
    name: "Woman Running",
    keywords: [
      "walking",
      "exercise",
      "race",
      "female"
    ],
    skins: [
      {
        unified: "1f3c3-200d-2640-fe0f",
        native: "🏃‍♀️"
      },
      {
        unified: "1f3c3-1f3fb-200d-2640-fe0f",
        native: "🏃🏻‍♀️"
      },
      {
        unified: "1f3c3-1f3fc-200d-2640-fe0f",
        native: "🏃🏼‍♀️"
      },
      {
        unified: "1f3c3-1f3fd-200d-2640-fe0f",
        native: "🏃🏽‍♀️"
      },
      {
        unified: "1f3c3-1f3fe-200d-2640-fe0f",
        native: "🏃🏾‍♀️"
      },
      {
        unified: "1f3c3-1f3ff-200d-2640-fe0f",
        native: "🏃🏿‍♀️"
      }
    ],
    version: 4
  },
  dancer: {
    id: "dancer",
    name: "Dancer",
    keywords: [
      "woman",
      "dancing",
      "female",
      "girl",
      "fun"
    ],
    skins: [
      {
        unified: "1f483",
        native: "💃"
      },
      {
        unified: "1f483-1f3fb",
        native: "💃🏻"
      },
      {
        unified: "1f483-1f3fc",
        native: "💃🏼"
      },
      {
        unified: "1f483-1f3fd",
        native: "💃🏽"
      },
      {
        unified: "1f483-1f3fe",
        native: "💃🏾"
      },
      {
        unified: "1f483-1f3ff",
        native: "💃🏿"
      }
    ],
    version: 1
  },
  man_dancing: {
    id: "man_dancing",
    name: "Man Dancing",
    keywords: [
      "male",
      "boy",
      "fun",
      "dancer"
    ],
    skins: [
      {
        unified: "1f57a",
        native: "🕺"
      },
      {
        unified: "1f57a-1f3fb",
        native: "🕺🏻"
      },
      {
        unified: "1f57a-1f3fc",
        native: "🕺🏼"
      },
      {
        unified: "1f57a-1f3fd",
        native: "🕺🏽"
      },
      {
        unified: "1f57a-1f3fe",
        native: "🕺🏾"
      },
      {
        unified: "1f57a-1f3ff",
        native: "🕺🏿"
      }
    ],
    version: 3
  },
  man_in_business_suit_levitating: {
    id: "man_in_business_suit_levitating",
    name: "Person in Suit Levitating",
    keywords: [
      "man",
      "business",
      "levitate",
      "hover",
      "jump"
    ],
    skins: [
      {
        unified: "1f574-fe0f",
        native: "🕴️"
      },
      {
        unified: "1f574-1f3fb",
        native: "🕴🏻"
      },
      {
        unified: "1f574-1f3fc",
        native: "🕴🏼"
      },
      {
        unified: "1f574-1f3fd",
        native: "🕴🏽"
      },
      {
        unified: "1f574-1f3fe",
        native: "🕴🏾"
      },
      {
        unified: "1f574-1f3ff",
        native: "🕴🏿"
      }
    ],
    version: 1
  },
  dancers: {
    id: "dancers",
    name: "Woman with Bunny Ears",
    keywords: [
      "dancers",
      "people",
      "perform",
      "costume"
    ],
    skins: [
      {
        unified: "1f46f",
        native: "👯"
      }
    ],
    version: 1
  },
  "men-with-bunny-ears-partying": {
    id: "men-with-bunny-ears-partying",
    name: "Men with Bunny Ears",
    keywords: [
      "with-bunny-ears-partying",
      "man",
      "male",
      "boys"
    ],
    skins: [
      {
        unified: "1f46f-200d-2642-fe0f",
        native: "👯‍♂️"
      }
    ],
    version: 4
  },
  "women-with-bunny-ears-partying": {
    id: "women-with-bunny-ears-partying",
    name: "Women with Bunny Ears",
    keywords: [
      "with-bunny-ears-partying",
      "woman",
      "female",
      "girls"
    ],
    skins: [
      {
        unified: "1f46f-200d-2640-fe0f",
        native: "👯‍♀️"
      }
    ],
    version: 4
  },
  person_in_steamy_room: {
    id: "person_in_steamy_room",
    name: "Person in Steamy Room",
    keywords: [
      "relax",
      "spa"
    ],
    skins: [
      {
        unified: "1f9d6",
        native: "🧖"
      },
      {
        unified: "1f9d6-1f3fb",
        native: "🧖🏻"
      },
      {
        unified: "1f9d6-1f3fc",
        native: "🧖🏼"
      },
      {
        unified: "1f9d6-1f3fd",
        native: "🧖🏽"
      },
      {
        unified: "1f9d6-1f3fe",
        native: "🧖🏾"
      },
      {
        unified: "1f9d6-1f3ff",
        native: "🧖🏿"
      }
    ],
    version: 5
  },
  man_in_steamy_room: {
    id: "man_in_steamy_room",
    name: "Man in Steamy Room",
    keywords: [
      "male",
      "spa",
      "steamroom",
      "sauna"
    ],
    skins: [
      {
        unified: "1f9d6-200d-2642-fe0f",
        native: "🧖‍♂️"
      },
      {
        unified: "1f9d6-1f3fb-200d-2642-fe0f",
        native: "🧖🏻‍♂️"
      },
      {
        unified: "1f9d6-1f3fc-200d-2642-fe0f",
        native: "🧖🏼‍♂️"
      },
      {
        unified: "1f9d6-1f3fd-200d-2642-fe0f",
        native: "🧖🏽‍♂️"
      },
      {
        unified: "1f9d6-1f3fe-200d-2642-fe0f",
        native: "🧖🏾‍♂️"
      },
      {
        unified: "1f9d6-1f3ff-200d-2642-fe0f",
        native: "🧖🏿‍♂️"
      }
    ],
    version: 5
  },
  woman_in_steamy_room: {
    id: "woman_in_steamy_room",
    name: "Woman in Steamy Room",
    keywords: [
      "female",
      "spa",
      "steamroom",
      "sauna"
    ],
    skins: [
      {
        unified: "1f9d6-200d-2640-fe0f",
        native: "🧖‍♀️"
      },
      {
        unified: "1f9d6-1f3fb-200d-2640-fe0f",
        native: "🧖🏻‍♀️"
      },
      {
        unified: "1f9d6-1f3fc-200d-2640-fe0f",
        native: "🧖🏼‍♀️"
      },
      {
        unified: "1f9d6-1f3fd-200d-2640-fe0f",
        native: "🧖🏽‍♀️"
      },
      {
        unified: "1f9d6-1f3fe-200d-2640-fe0f",
        native: "🧖🏾‍♀️"
      },
      {
        unified: "1f9d6-1f3ff-200d-2640-fe0f",
        native: "🧖🏿‍♀️"
      }
    ],
    version: 5
  },
  person_climbing: {
    id: "person_climbing",
    name: "Person Climbing",
    keywords: [
      "sport"
    ],
    skins: [
      {
        unified: "1f9d7",
        native: "🧗"
      },
      {
        unified: "1f9d7-1f3fb",
        native: "🧗🏻"
      },
      {
        unified: "1f9d7-1f3fc",
        native: "🧗🏼"
      },
      {
        unified: "1f9d7-1f3fd",
        native: "🧗🏽"
      },
      {
        unified: "1f9d7-1f3fe",
        native: "🧗🏾"
      },
      {
        unified: "1f9d7-1f3ff",
        native: "🧗🏿"
      }
    ],
    version: 5
  },
  man_climbing: {
    id: "man_climbing",
    name: "Man Climbing",
    keywords: [
      "sports",
      "hobby",
      "male",
      "rock"
    ],
    skins: [
      {
        unified: "1f9d7-200d-2642-fe0f",
        native: "🧗‍♂️"
      },
      {
        unified: "1f9d7-1f3fb-200d-2642-fe0f",
        native: "🧗🏻‍♂️"
      },
      {
        unified: "1f9d7-1f3fc-200d-2642-fe0f",
        native: "🧗🏼‍♂️"
      },
      {
        unified: "1f9d7-1f3fd-200d-2642-fe0f",
        native: "🧗🏽‍♂️"
      },
      {
        unified: "1f9d7-1f3fe-200d-2642-fe0f",
        native: "🧗🏾‍♂️"
      },
      {
        unified: "1f9d7-1f3ff-200d-2642-fe0f",
        native: "🧗🏿‍♂️"
      }
    ],
    version: 5
  },
  woman_climbing: {
    id: "woman_climbing",
    name: "Woman Climbing",
    keywords: [
      "sports",
      "hobby",
      "female",
      "rock"
    ],
    skins: [
      {
        unified: "1f9d7-200d-2640-fe0f",
        native: "🧗‍♀️"
      },
      {
        unified: "1f9d7-1f3fb-200d-2640-fe0f",
        native: "🧗🏻‍♀️"
      },
      {
        unified: "1f9d7-1f3fc-200d-2640-fe0f",
        native: "🧗🏼‍♀️"
      },
      {
        unified: "1f9d7-1f3fd-200d-2640-fe0f",
        native: "🧗🏽‍♀️"
      },
      {
        unified: "1f9d7-1f3fe-200d-2640-fe0f",
        native: "🧗🏾‍♀️"
      },
      {
        unified: "1f9d7-1f3ff-200d-2640-fe0f",
        native: "🧗🏿‍♀️"
      }
    ],
    version: 5
  },
  fencer: {
    id: "fencer",
    name: "Fencer",
    keywords: [
      "person",
      "fencing",
      "sports",
      "sword"
    ],
    skins: [
      {
        unified: "1f93a",
        native: "🤺"
      }
    ],
    version: 3
  },
  horse_racing: {
    id: "horse_racing",
    name: "Horse Racing",
    keywords: [
      "animal",
      "betting",
      "competition",
      "gambling",
      "luck"
    ],
    skins: [
      {
        unified: "1f3c7",
        native: "🏇"
      },
      {
        unified: "1f3c7-1f3fb",
        native: "🏇🏻"
      },
      {
        unified: "1f3c7-1f3fc",
        native: "🏇🏼"
      },
      {
        unified: "1f3c7-1f3fd",
        native: "🏇🏽"
      },
      {
        unified: "1f3c7-1f3fe",
        native: "🏇🏾"
      },
      {
        unified: "1f3c7-1f3ff",
        native: "🏇🏿"
      }
    ],
    version: 1
  },
  skier: {
    id: "skier",
    name: "Skier",
    keywords: [
      "sports",
      "winter",
      "snow"
    ],
    skins: [
      {
        unified: "26f7-fe0f",
        native: "⛷️"
      }
    ],
    version: 1
  },
  snowboarder: {
    id: "snowboarder",
    name: "Snowboarder",
    keywords: [
      "sports",
      "winter"
    ],
    skins: [
      {
        unified: "1f3c2",
        native: "🏂"
      },
      {
        unified: "1f3c2-1f3fb",
        native: "🏂🏻"
      },
      {
        unified: "1f3c2-1f3fc",
        native: "🏂🏼"
      },
      {
        unified: "1f3c2-1f3fd",
        native: "🏂🏽"
      },
      {
        unified: "1f3c2-1f3fe",
        native: "🏂🏾"
      },
      {
        unified: "1f3c2-1f3ff",
        native: "🏂🏿"
      }
    ],
    version: 1
  },
  golfer: {
    id: "golfer",
    name: "Person Golfing",
    keywords: [
      "golfer",
      "sports",
      "business"
    ],
    skins: [
      {
        unified: "1f3cc-fe0f",
        native: "🏌️"
      },
      {
        unified: "1f3cc-1f3fb",
        native: "🏌🏻"
      },
      {
        unified: "1f3cc-1f3fc",
        native: "🏌🏼"
      },
      {
        unified: "1f3cc-1f3fd",
        native: "🏌🏽"
      },
      {
        unified: "1f3cc-1f3fe",
        native: "🏌🏾"
      },
      {
        unified: "1f3cc-1f3ff",
        native: "🏌🏿"
      }
    ],
    version: 1
  },
  "man-golfing": {
    id: "man-golfing",
    name: "Man Golfing",
    keywords: [
      "sport"
    ],
    skins: [
      {
        unified: "1f3cc-fe0f-200d-2642-fe0f",
        native: "🏌️‍♂️"
      },
      {
        unified: "1f3cc-1f3fb-200d-2642-fe0f",
        native: "🏌🏻‍♂️"
      },
      {
        unified: "1f3cc-1f3fc-200d-2642-fe0f",
        native: "🏌🏼‍♂️"
      },
      {
        unified: "1f3cc-1f3fd-200d-2642-fe0f",
        native: "🏌🏽‍♂️"
      },
      {
        unified: "1f3cc-1f3fe-200d-2642-fe0f",
        native: "🏌🏾‍♂️"
      },
      {
        unified: "1f3cc-1f3ff-200d-2642-fe0f",
        native: "🏌🏿‍♂️"
      }
    ],
    version: 4
  },
  "woman-golfing": {
    id: "woman-golfing",
    name: "Woman Golfing",
    keywords: [
      "sports",
      "business",
      "female"
    ],
    skins: [
      {
        unified: "1f3cc-fe0f-200d-2640-fe0f",
        native: "🏌️‍♀️"
      },
      {
        unified: "1f3cc-1f3fb-200d-2640-fe0f",
        native: "🏌🏻‍♀️"
      },
      {
        unified: "1f3cc-1f3fc-200d-2640-fe0f",
        native: "🏌🏼‍♀️"
      },
      {
        unified: "1f3cc-1f3fd-200d-2640-fe0f",
        native: "🏌🏽‍♀️"
      },
      {
        unified: "1f3cc-1f3fe-200d-2640-fe0f",
        native: "🏌🏾‍♀️"
      },
      {
        unified: "1f3cc-1f3ff-200d-2640-fe0f",
        native: "🏌🏿‍♀️"
      }
    ],
    version: 4
  },
  surfer: {
    id: "surfer",
    name: "Surfer",
    keywords: [
      "person",
      "surfing",
      "sport",
      "sea"
    ],
    skins: [
      {
        unified: "1f3c4",
        native: "🏄"
      },
      {
        unified: "1f3c4-1f3fb",
        native: "🏄🏻"
      },
      {
        unified: "1f3c4-1f3fc",
        native: "🏄🏼"
      },
      {
        unified: "1f3c4-1f3fd",
        native: "🏄🏽"
      },
      {
        unified: "1f3c4-1f3fe",
        native: "🏄🏾"
      },
      {
        unified: "1f3c4-1f3ff",
        native: "🏄🏿"
      }
    ],
    version: 1
  },
  "man-surfing": {
    id: "man-surfing",
    name: "Man Surfing",
    keywords: [
      "sports",
      "ocean",
      "sea",
      "summer",
      "beach"
    ],
    skins: [
      {
        unified: "1f3c4-200d-2642-fe0f",
        native: "🏄‍♂️"
      },
      {
        unified: "1f3c4-1f3fb-200d-2642-fe0f",
        native: "🏄🏻‍♂️"
      },
      {
        unified: "1f3c4-1f3fc-200d-2642-fe0f",
        native: "🏄🏼‍♂️"
      },
      {
        unified: "1f3c4-1f3fd-200d-2642-fe0f",
        native: "🏄🏽‍♂️"
      },
      {
        unified: "1f3c4-1f3fe-200d-2642-fe0f",
        native: "🏄🏾‍♂️"
      },
      {
        unified: "1f3c4-1f3ff-200d-2642-fe0f",
        native: "🏄🏿‍♂️"
      }
    ],
    version: 4
  },
  "woman-surfing": {
    id: "woman-surfing",
    name: "Woman Surfing",
    keywords: [
      "sports",
      "ocean",
      "sea",
      "summer",
      "beach",
      "female"
    ],
    skins: [
      {
        unified: "1f3c4-200d-2640-fe0f",
        native: "🏄‍♀️"
      },
      {
        unified: "1f3c4-1f3fb-200d-2640-fe0f",
        native: "🏄🏻‍♀️"
      },
      {
        unified: "1f3c4-1f3fc-200d-2640-fe0f",
        native: "🏄🏼‍♀️"
      },
      {
        unified: "1f3c4-1f3fd-200d-2640-fe0f",
        native: "🏄🏽‍♀️"
      },
      {
        unified: "1f3c4-1f3fe-200d-2640-fe0f",
        native: "🏄🏾‍♀️"
      },
      {
        unified: "1f3c4-1f3ff-200d-2640-fe0f",
        native: "🏄🏿‍♀️"
      }
    ],
    version: 4
  },
  rowboat: {
    id: "rowboat",
    name: "Rowboat",
    keywords: [
      "person",
      "rowing",
      "boat",
      "sport",
      "move"
    ],
    skins: [
      {
        unified: "1f6a3",
        native: "🚣"
      },
      {
        unified: "1f6a3-1f3fb",
        native: "🚣🏻"
      },
      {
        unified: "1f6a3-1f3fc",
        native: "🚣🏼"
      },
      {
        unified: "1f6a3-1f3fd",
        native: "🚣🏽"
      },
      {
        unified: "1f6a3-1f3fe",
        native: "🚣🏾"
      },
      {
        unified: "1f6a3-1f3ff",
        native: "🚣🏿"
      }
    ],
    version: 1
  },
  "man-rowing-boat": {
    id: "man-rowing-boat",
    name: "Man Rowing Boat",
    keywords: [
      "rowing-boat",
      "sports",
      "hobby",
      "water",
      "ship"
    ],
    skins: [
      {
        unified: "1f6a3-200d-2642-fe0f",
        native: "🚣‍♂️"
      },
      {
        unified: "1f6a3-1f3fb-200d-2642-fe0f",
        native: "🚣🏻‍♂️"
      },
      {
        unified: "1f6a3-1f3fc-200d-2642-fe0f",
        native: "🚣🏼‍♂️"
      },
      {
        unified: "1f6a3-1f3fd-200d-2642-fe0f",
        native: "🚣🏽‍♂️"
      },
      {
        unified: "1f6a3-1f3fe-200d-2642-fe0f",
        native: "🚣🏾‍♂️"
      },
      {
        unified: "1f6a3-1f3ff-200d-2642-fe0f",
        native: "🚣🏿‍♂️"
      }
    ],
    version: 4
  },
  "woman-rowing-boat": {
    id: "woman-rowing-boat",
    name: "Woman Rowing Boat",
    keywords: [
      "rowing-boat",
      "sports",
      "hobby",
      "water",
      "ship",
      "female"
    ],
    skins: [
      {
        unified: "1f6a3-200d-2640-fe0f",
        native: "🚣‍♀️"
      },
      {
        unified: "1f6a3-1f3fb-200d-2640-fe0f",
        native: "🚣🏻‍♀️"
      },
      {
        unified: "1f6a3-1f3fc-200d-2640-fe0f",
        native: "🚣🏼‍♀️"
      },
      {
        unified: "1f6a3-1f3fd-200d-2640-fe0f",
        native: "🚣🏽‍♀️"
      },
      {
        unified: "1f6a3-1f3fe-200d-2640-fe0f",
        native: "🚣🏾‍♀️"
      },
      {
        unified: "1f6a3-1f3ff-200d-2640-fe0f",
        native: "🚣🏿‍♀️"
      }
    ],
    version: 4
  },
  swimmer: {
    id: "swimmer",
    name: "Swimmer",
    keywords: [
      "person",
      "swimming",
      "sport",
      "pool"
    ],
    skins: [
      {
        unified: "1f3ca",
        native: "🏊"
      },
      {
        unified: "1f3ca-1f3fb",
        native: "🏊🏻"
      },
      {
        unified: "1f3ca-1f3fc",
        native: "🏊🏼"
      },
      {
        unified: "1f3ca-1f3fd",
        native: "🏊🏽"
      },
      {
        unified: "1f3ca-1f3fe",
        native: "🏊🏾"
      },
      {
        unified: "1f3ca-1f3ff",
        native: "🏊🏿"
      }
    ],
    version: 1
  },
  "man-swimming": {
    id: "man-swimming",
    name: "Man Swimming",
    keywords: [
      "sports",
      "exercise",
      "human",
      "athlete",
      "water",
      "summer"
    ],
    skins: [
      {
        unified: "1f3ca-200d-2642-fe0f",
        native: "🏊‍♂️"
      },
      {
        unified: "1f3ca-1f3fb-200d-2642-fe0f",
        native: "🏊🏻‍♂️"
      },
      {
        unified: "1f3ca-1f3fc-200d-2642-fe0f",
        native: "🏊🏼‍♂️"
      },
      {
        unified: "1f3ca-1f3fd-200d-2642-fe0f",
        native: "🏊🏽‍♂️"
      },
      {
        unified: "1f3ca-1f3fe-200d-2642-fe0f",
        native: "🏊🏾‍♂️"
      },
      {
        unified: "1f3ca-1f3ff-200d-2642-fe0f",
        native: "🏊🏿‍♂️"
      }
    ],
    version: 4
  },
  "woman-swimming": {
    id: "woman-swimming",
    name: "Woman Swimming",
    keywords: [
      "sports",
      "exercise",
      "human",
      "athlete",
      "water",
      "summer",
      "female"
    ],
    skins: [
      {
        unified: "1f3ca-200d-2640-fe0f",
        native: "🏊‍♀️"
      },
      {
        unified: "1f3ca-1f3fb-200d-2640-fe0f",
        native: "🏊🏻‍♀️"
      },
      {
        unified: "1f3ca-1f3fc-200d-2640-fe0f",
        native: "🏊🏼‍♀️"
      },
      {
        unified: "1f3ca-1f3fd-200d-2640-fe0f",
        native: "🏊🏽‍♀️"
      },
      {
        unified: "1f3ca-1f3fe-200d-2640-fe0f",
        native: "🏊🏾‍♀️"
      },
      {
        unified: "1f3ca-1f3ff-200d-2640-fe0f",
        native: "🏊🏿‍♀️"
      }
    ],
    version: 4
  },
  person_with_ball: {
    id: "person_with_ball",
    name: "Person Bouncing Ball",
    keywords: [
      "with",
      "sports",
      "human"
    ],
    skins: [
      {
        unified: "26f9-fe0f",
        native: "⛹️"
      },
      {
        unified: "26f9-1f3fb",
        native: "⛹🏻"
      },
      {
        unified: "26f9-1f3fc",
        native: "⛹🏼"
      },
      {
        unified: "26f9-1f3fd",
        native: "⛹🏽"
      },
      {
        unified: "26f9-1f3fe",
        native: "⛹🏾"
      },
      {
        unified: "26f9-1f3ff",
        native: "⛹🏿"
      }
    ],
    version: 1
  },
  "man-bouncing-ball": {
    id: "man-bouncing-ball",
    name: "Man Bouncing Ball",
    keywords: [
      "bouncing-ball",
      "sport"
    ],
    skins: [
      {
        unified: "26f9-fe0f-200d-2642-fe0f",
        native: "⛹️‍♂️"
      },
      {
        unified: "26f9-1f3fb-200d-2642-fe0f",
        native: "⛹🏻‍♂️"
      },
      {
        unified: "26f9-1f3fc-200d-2642-fe0f",
        native: "⛹🏼‍♂️"
      },
      {
        unified: "26f9-1f3fd-200d-2642-fe0f",
        native: "⛹🏽‍♂️"
      },
      {
        unified: "26f9-1f3fe-200d-2642-fe0f",
        native: "⛹🏾‍♂️"
      },
      {
        unified: "26f9-1f3ff-200d-2642-fe0f",
        native: "⛹🏿‍♂️"
      }
    ],
    version: 4
  },
  "woman-bouncing-ball": {
    id: "woman-bouncing-ball",
    name: "Woman Bouncing Ball",
    keywords: [
      "bouncing-ball",
      "sports",
      "human",
      "female"
    ],
    skins: [
      {
        unified: "26f9-fe0f-200d-2640-fe0f",
        native: "⛹️‍♀️"
      },
      {
        unified: "26f9-1f3fb-200d-2640-fe0f",
        native: "⛹🏻‍♀️"
      },
      {
        unified: "26f9-1f3fc-200d-2640-fe0f",
        native: "⛹🏼‍♀️"
      },
      {
        unified: "26f9-1f3fd-200d-2640-fe0f",
        native: "⛹🏽‍♀️"
      },
      {
        unified: "26f9-1f3fe-200d-2640-fe0f",
        native: "⛹🏾‍♀️"
      },
      {
        unified: "26f9-1f3ff-200d-2640-fe0f",
        native: "⛹🏿‍♀️"
      }
    ],
    version: 4
  },
  weight_lifter: {
    id: "weight_lifter",
    name: "Person Lifting Weights",
    keywords: [
      "weight",
      "lifter",
      "sports",
      "training",
      "exercise"
    ],
    skins: [
      {
        unified: "1f3cb-fe0f",
        native: "🏋️"
      },
      {
        unified: "1f3cb-1f3fb",
        native: "🏋🏻"
      },
      {
        unified: "1f3cb-1f3fc",
        native: "🏋🏼"
      },
      {
        unified: "1f3cb-1f3fd",
        native: "🏋🏽"
      },
      {
        unified: "1f3cb-1f3fe",
        native: "🏋🏾"
      },
      {
        unified: "1f3cb-1f3ff",
        native: "🏋🏿"
      }
    ],
    version: 1
  },
  "man-lifting-weights": {
    id: "man-lifting-weights",
    name: "Man Lifting Weights",
    keywords: [
      "lifting-weights",
      "sport"
    ],
    skins: [
      {
        unified: "1f3cb-fe0f-200d-2642-fe0f",
        native: "🏋️‍♂️"
      },
      {
        unified: "1f3cb-1f3fb-200d-2642-fe0f",
        native: "🏋🏻‍♂️"
      },
      {
        unified: "1f3cb-1f3fc-200d-2642-fe0f",
        native: "🏋🏼‍♂️"
      },
      {
        unified: "1f3cb-1f3fd-200d-2642-fe0f",
        native: "🏋🏽‍♂️"
      },
      {
        unified: "1f3cb-1f3fe-200d-2642-fe0f",
        native: "🏋🏾‍♂️"
      },
      {
        unified: "1f3cb-1f3ff-200d-2642-fe0f",
        native: "🏋🏿‍♂️"
      }
    ],
    version: 4
  },
  "woman-lifting-weights": {
    id: "woman-lifting-weights",
    name: "Woman Lifting Weights",
    keywords: [
      "lifting-weights",
      "sports",
      "training",
      "exercise",
      "female"
    ],
    skins: [
      {
        unified: "1f3cb-fe0f-200d-2640-fe0f",
        native: "🏋️‍♀️"
      },
      {
        unified: "1f3cb-1f3fb-200d-2640-fe0f",
        native: "🏋🏻‍♀️"
      },
      {
        unified: "1f3cb-1f3fc-200d-2640-fe0f",
        native: "🏋🏼‍♀️"
      },
      {
        unified: "1f3cb-1f3fd-200d-2640-fe0f",
        native: "🏋🏽‍♀️"
      },
      {
        unified: "1f3cb-1f3fe-200d-2640-fe0f",
        native: "🏋🏾‍♀️"
      },
      {
        unified: "1f3cb-1f3ff-200d-2640-fe0f",
        native: "🏋🏿‍♀️"
      }
    ],
    version: 4
  },
  bicyclist: {
    id: "bicyclist",
    name: "Bicyclist",
    keywords: [
      "person",
      "biking",
      "sport",
      "move"
    ],
    skins: [
      {
        unified: "1f6b4",
        native: "🚴"
      },
      {
        unified: "1f6b4-1f3fb",
        native: "🚴🏻"
      },
      {
        unified: "1f6b4-1f3fc",
        native: "🚴🏼"
      },
      {
        unified: "1f6b4-1f3fd",
        native: "🚴🏽"
      },
      {
        unified: "1f6b4-1f3fe",
        native: "🚴🏾"
      },
      {
        unified: "1f6b4-1f3ff",
        native: "🚴🏿"
      }
    ],
    version: 1
  },
  "man-biking": {
    id: "man-biking",
    name: "Man Biking",
    keywords: [
      "sports",
      "bike",
      "exercise",
      "hipster"
    ],
    skins: [
      {
        unified: "1f6b4-200d-2642-fe0f",
        native: "🚴‍♂️"
      },
      {
        unified: "1f6b4-1f3fb-200d-2642-fe0f",
        native: "🚴🏻‍♂️"
      },
      {
        unified: "1f6b4-1f3fc-200d-2642-fe0f",
        native: "🚴🏼‍♂️"
      },
      {
        unified: "1f6b4-1f3fd-200d-2642-fe0f",
        native: "🚴🏽‍♂️"
      },
      {
        unified: "1f6b4-1f3fe-200d-2642-fe0f",
        native: "🚴🏾‍♂️"
      },
      {
        unified: "1f6b4-1f3ff-200d-2642-fe0f",
        native: "🚴🏿‍♂️"
      }
    ],
    version: 4
  },
  "woman-biking": {
    id: "woman-biking",
    name: "Woman Biking",
    keywords: [
      "sports",
      "bike",
      "exercise",
      "hipster",
      "female"
    ],
    skins: [
      {
        unified: "1f6b4-200d-2640-fe0f",
        native: "🚴‍♀️"
      },
      {
        unified: "1f6b4-1f3fb-200d-2640-fe0f",
        native: "🚴🏻‍♀️"
      },
      {
        unified: "1f6b4-1f3fc-200d-2640-fe0f",
        native: "🚴🏼‍♀️"
      },
      {
        unified: "1f6b4-1f3fd-200d-2640-fe0f",
        native: "🚴🏽‍♀️"
      },
      {
        unified: "1f6b4-1f3fe-200d-2640-fe0f",
        native: "🚴🏾‍♀️"
      },
      {
        unified: "1f6b4-1f3ff-200d-2640-fe0f",
        native: "🚴🏿‍♀️"
      }
    ],
    version: 4
  },
  mountain_bicyclist: {
    id: "mountain_bicyclist",
    name: "Mountain Bicyclist",
    keywords: [
      "person",
      "biking",
      "sport",
      "move"
    ],
    skins: [
      {
        unified: "1f6b5",
        native: "🚵"
      },
      {
        unified: "1f6b5-1f3fb",
        native: "🚵🏻"
      },
      {
        unified: "1f6b5-1f3fc",
        native: "🚵🏼"
      },
      {
        unified: "1f6b5-1f3fd",
        native: "🚵🏽"
      },
      {
        unified: "1f6b5-1f3fe",
        native: "🚵🏾"
      },
      {
        unified: "1f6b5-1f3ff",
        native: "🚵🏿"
      }
    ],
    version: 1
  },
  "man-mountain-biking": {
    id: "man-mountain-biking",
    name: "Man Mountain Biking",
    keywords: [
      "mountain-biking",
      "transportation",
      "sports",
      "human",
      "race",
      "bike"
    ],
    skins: [
      {
        unified: "1f6b5-200d-2642-fe0f",
        native: "🚵‍♂️"
      },
      {
        unified: "1f6b5-1f3fb-200d-2642-fe0f",
        native: "🚵🏻‍♂️"
      },
      {
        unified: "1f6b5-1f3fc-200d-2642-fe0f",
        native: "🚵🏼‍♂️"
      },
      {
        unified: "1f6b5-1f3fd-200d-2642-fe0f",
        native: "🚵🏽‍♂️"
      },
      {
        unified: "1f6b5-1f3fe-200d-2642-fe0f",
        native: "🚵🏾‍♂️"
      },
      {
        unified: "1f6b5-1f3ff-200d-2642-fe0f",
        native: "🚵🏿‍♂️"
      }
    ],
    version: 4
  },
  "woman-mountain-biking": {
    id: "woman-mountain-biking",
    name: "Woman Mountain Biking",
    keywords: [
      "mountain-biking",
      "transportation",
      "sports",
      "human",
      "race",
      "bike",
      "female"
    ],
    skins: [
      {
        unified: "1f6b5-200d-2640-fe0f",
        native: "🚵‍♀️"
      },
      {
        unified: "1f6b5-1f3fb-200d-2640-fe0f",
        native: "🚵🏻‍♀️"
      },
      {
        unified: "1f6b5-1f3fc-200d-2640-fe0f",
        native: "🚵🏼‍♀️"
      },
      {
        unified: "1f6b5-1f3fd-200d-2640-fe0f",
        native: "🚵🏽‍♀️"
      },
      {
        unified: "1f6b5-1f3fe-200d-2640-fe0f",
        native: "🚵🏾‍♀️"
      },
      {
        unified: "1f6b5-1f3ff-200d-2640-fe0f",
        native: "🚵🏿‍♀️"
      }
    ],
    version: 4
  },
  person_doing_cartwheel: {
    id: "person_doing_cartwheel",
    name: "Person Cartwheeling",
    keywords: [
      "doing",
      "cartwheel",
      "sport",
      "gymnastic"
    ],
    skins: [
      {
        unified: "1f938",
        native: "🤸"
      },
      {
        unified: "1f938-1f3fb",
        native: "🤸🏻"
      },
      {
        unified: "1f938-1f3fc",
        native: "🤸🏼"
      },
      {
        unified: "1f938-1f3fd",
        native: "🤸🏽"
      },
      {
        unified: "1f938-1f3fe",
        native: "🤸🏾"
      },
      {
        unified: "1f938-1f3ff",
        native: "🤸🏿"
      }
    ],
    version: 3
  },
  "man-cartwheeling": {
    id: "man-cartwheeling",
    name: "Man Cartwheeling",
    keywords: [
      "gymnastics"
    ],
    skins: [
      {
        unified: "1f938-200d-2642-fe0f",
        native: "🤸‍♂️"
      },
      {
        unified: "1f938-1f3fb-200d-2642-fe0f",
        native: "🤸🏻‍♂️"
      },
      {
        unified: "1f938-1f3fc-200d-2642-fe0f",
        native: "🤸🏼‍♂️"
      },
      {
        unified: "1f938-1f3fd-200d-2642-fe0f",
        native: "🤸🏽‍♂️"
      },
      {
        unified: "1f938-1f3fe-200d-2642-fe0f",
        native: "🤸🏾‍♂️"
      },
      {
        unified: "1f938-1f3ff-200d-2642-fe0f",
        native: "🤸🏿‍♂️"
      }
    ],
    version: 4
  },
  "woman-cartwheeling": {
    id: "woman-cartwheeling",
    name: "Woman Cartwheeling",
    keywords: [
      "gymnastics"
    ],
    skins: [
      {
        unified: "1f938-200d-2640-fe0f",
        native: "🤸‍♀️"
      },
      {
        unified: "1f938-1f3fb-200d-2640-fe0f",
        native: "🤸🏻‍♀️"
      },
      {
        unified: "1f938-1f3fc-200d-2640-fe0f",
        native: "🤸🏼‍♀️"
      },
      {
        unified: "1f938-1f3fd-200d-2640-fe0f",
        native: "🤸🏽‍♀️"
      },
      {
        unified: "1f938-1f3fe-200d-2640-fe0f",
        native: "🤸🏾‍♀️"
      },
      {
        unified: "1f938-1f3ff-200d-2640-fe0f",
        native: "🤸🏿‍♀️"
      }
    ],
    version: 4
  },
  wrestlers: {
    id: "wrestlers",
    name: "Wrestlers",
    keywords: [
      "people",
      "wrestling",
      "sport"
    ],
    skins: [
      {
        unified: "1f93c",
        native: "🤼"
      }
    ],
    version: 3
  },
  "man-wrestling": {
    id: "man-wrestling",
    name: "Men Wrestling",
    keywords: [
      "man",
      "sports",
      "wrestlers"
    ],
    skins: [
      {
        unified: "1f93c-200d-2642-fe0f",
        native: "🤼‍♂️"
      }
    ],
    version: 4
  },
  "woman-wrestling": {
    id: "woman-wrestling",
    name: "Women Wrestling",
    keywords: [
      "woman",
      "sports",
      "wrestlers"
    ],
    skins: [
      {
        unified: "1f93c-200d-2640-fe0f",
        native: "🤼‍♀️"
      }
    ],
    version: 4
  },
  water_polo: {
    id: "water_polo",
    name: "Water Polo",
    keywords: [
      "person",
      "playing",
      "sport"
    ],
    skins: [
      {
        unified: "1f93d",
        native: "🤽"
      },
      {
        unified: "1f93d-1f3fb",
        native: "🤽🏻"
      },
      {
        unified: "1f93d-1f3fc",
        native: "🤽🏼"
      },
      {
        unified: "1f93d-1f3fd",
        native: "🤽🏽"
      },
      {
        unified: "1f93d-1f3fe",
        native: "🤽🏾"
      },
      {
        unified: "1f93d-1f3ff",
        native: "🤽🏿"
      }
    ],
    version: 3
  },
  "man-playing-water-polo": {
    id: "man-playing-water-polo",
    name: "Man Playing Water Polo",
    keywords: [
      "playing-water-polo",
      "sports",
      "pool"
    ],
    skins: [
      {
        unified: "1f93d-200d-2642-fe0f",
        native: "🤽‍♂️"
      },
      {
        unified: "1f93d-1f3fb-200d-2642-fe0f",
        native: "🤽🏻‍♂️"
      },
      {
        unified: "1f93d-1f3fc-200d-2642-fe0f",
        native: "🤽🏼‍♂️"
      },
      {
        unified: "1f93d-1f3fd-200d-2642-fe0f",
        native: "🤽🏽‍♂️"
      },
      {
        unified: "1f93d-1f3fe-200d-2642-fe0f",
        native: "🤽🏾‍♂️"
      },
      {
        unified: "1f93d-1f3ff-200d-2642-fe0f",
        native: "🤽🏿‍♂️"
      }
    ],
    version: 4
  },
  "woman-playing-water-polo": {
    id: "woman-playing-water-polo",
    name: "Woman Playing Water Polo",
    keywords: [
      "playing-water-polo",
      "sports",
      "pool"
    ],
    skins: [
      {
        unified: "1f93d-200d-2640-fe0f",
        native: "🤽‍♀️"
      },
      {
        unified: "1f93d-1f3fb-200d-2640-fe0f",
        native: "🤽🏻‍♀️"
      },
      {
        unified: "1f93d-1f3fc-200d-2640-fe0f",
        native: "🤽🏼‍♀️"
      },
      {
        unified: "1f93d-1f3fd-200d-2640-fe0f",
        native: "🤽🏽‍♀️"
      },
      {
        unified: "1f93d-1f3fe-200d-2640-fe0f",
        native: "🤽🏾‍♀️"
      },
      {
        unified: "1f93d-1f3ff-200d-2640-fe0f",
        native: "🤽🏿‍♀️"
      }
    ],
    version: 4
  },
  handball: {
    id: "handball",
    name: "Handball",
    keywords: [
      "person",
      "playing",
      "sport"
    ],
    skins: [
      {
        unified: "1f93e",
        native: "🤾"
      },
      {
        unified: "1f93e-1f3fb",
        native: "🤾🏻"
      },
      {
        unified: "1f93e-1f3fc",
        native: "🤾🏼"
      },
      {
        unified: "1f93e-1f3fd",
        native: "🤾🏽"
      },
      {
        unified: "1f93e-1f3fe",
        native: "🤾🏾"
      },
      {
        unified: "1f93e-1f3ff",
        native: "🤾🏿"
      }
    ],
    version: 3
  },
  "man-playing-handball": {
    id: "man-playing-handball",
    name: "Man Playing Handball",
    keywords: [
      "playing-handball",
      "sports"
    ],
    skins: [
      {
        unified: "1f93e-200d-2642-fe0f",
        native: "🤾‍♂️"
      },
      {
        unified: "1f93e-1f3fb-200d-2642-fe0f",
        native: "🤾🏻‍♂️"
      },
      {
        unified: "1f93e-1f3fc-200d-2642-fe0f",
        native: "🤾🏼‍♂️"
      },
      {
        unified: "1f93e-1f3fd-200d-2642-fe0f",
        native: "🤾🏽‍♂️"
      },
      {
        unified: "1f93e-1f3fe-200d-2642-fe0f",
        native: "🤾🏾‍♂️"
      },
      {
        unified: "1f93e-1f3ff-200d-2642-fe0f",
        native: "🤾🏿‍♂️"
      }
    ],
    version: 4
  },
  "woman-playing-handball": {
    id: "woman-playing-handball",
    name: "Woman Playing Handball",
    keywords: [
      "playing-handball",
      "sports"
    ],
    skins: [
      {
        unified: "1f93e-200d-2640-fe0f",
        native: "🤾‍♀️"
      },
      {
        unified: "1f93e-1f3fb-200d-2640-fe0f",
        native: "🤾🏻‍♀️"
      },
      {
        unified: "1f93e-1f3fc-200d-2640-fe0f",
        native: "🤾🏼‍♀️"
      },
      {
        unified: "1f93e-1f3fd-200d-2640-fe0f",
        native: "🤾🏽‍♀️"
      },
      {
        unified: "1f93e-1f3fe-200d-2640-fe0f",
        native: "🤾🏾‍♀️"
      },
      {
        unified: "1f93e-1f3ff-200d-2640-fe0f",
        native: "🤾🏿‍♀️"
      }
    ],
    version: 4
  },
  juggling: {
    id: "juggling",
    name: "Juggling",
    keywords: [
      "person",
      "performance",
      "balance"
    ],
    skins: [
      {
        unified: "1f939",
        native: "🤹"
      },
      {
        unified: "1f939-1f3fb",
        native: "🤹🏻"
      },
      {
        unified: "1f939-1f3fc",
        native: "🤹🏼"
      },
      {
        unified: "1f939-1f3fd",
        native: "🤹🏽"
      },
      {
        unified: "1f939-1f3fe",
        native: "🤹🏾"
      },
      {
        unified: "1f939-1f3ff",
        native: "🤹🏿"
      }
    ],
    version: 3
  },
  "man-juggling": {
    id: "man-juggling",
    name: "Man Juggling",
    keywords: [
      "juggle",
      "balance",
      "skill",
      "multitask"
    ],
    skins: [
      {
        unified: "1f939-200d-2642-fe0f",
        native: "🤹‍♂️"
      },
      {
        unified: "1f939-1f3fb-200d-2642-fe0f",
        native: "🤹🏻‍♂️"
      },
      {
        unified: "1f939-1f3fc-200d-2642-fe0f",
        native: "🤹🏼‍♂️"
      },
      {
        unified: "1f939-1f3fd-200d-2642-fe0f",
        native: "🤹🏽‍♂️"
      },
      {
        unified: "1f939-1f3fe-200d-2642-fe0f",
        native: "🤹🏾‍♂️"
      },
      {
        unified: "1f939-1f3ff-200d-2642-fe0f",
        native: "🤹🏿‍♂️"
      }
    ],
    version: 4
  },
  "woman-juggling": {
    id: "woman-juggling",
    name: "Woman Juggling",
    keywords: [
      "juggle",
      "balance",
      "skill",
      "multitask"
    ],
    skins: [
      {
        unified: "1f939-200d-2640-fe0f",
        native: "🤹‍♀️"
      },
      {
        unified: "1f939-1f3fb-200d-2640-fe0f",
        native: "🤹🏻‍♀️"
      },
      {
        unified: "1f939-1f3fc-200d-2640-fe0f",
        native: "🤹🏼‍♀️"
      },
      {
        unified: "1f939-1f3fd-200d-2640-fe0f",
        native: "🤹🏽‍♀️"
      },
      {
        unified: "1f939-1f3fe-200d-2640-fe0f",
        native: "🤹🏾‍♀️"
      },
      {
        unified: "1f939-1f3ff-200d-2640-fe0f",
        native: "🤹🏿‍♀️"
      }
    ],
    version: 4
  },
  person_in_lotus_position: {
    id: "person_in_lotus_position",
    name: "Person in Lotus Position",
    keywords: [
      "meditate"
    ],
    skins: [
      {
        unified: "1f9d8",
        native: "🧘"
      },
      {
        unified: "1f9d8-1f3fb",
        native: "🧘🏻"
      },
      {
        unified: "1f9d8-1f3fc",
        native: "🧘🏼"
      },
      {
        unified: "1f9d8-1f3fd",
        native: "🧘🏽"
      },
      {
        unified: "1f9d8-1f3fe",
        native: "🧘🏾"
      },
      {
        unified: "1f9d8-1f3ff",
        native: "🧘🏿"
      }
    ],
    version: 5
  },
  man_in_lotus_position: {
    id: "man_in_lotus_position",
    name: "Man in Lotus Position",
    keywords: [
      "male",
      "meditation",
      "yoga",
      "serenity",
      "zen",
      "mindfulness"
    ],
    skins: [
      {
        unified: "1f9d8-200d-2642-fe0f",
        native: "🧘‍♂️"
      },
      {
        unified: "1f9d8-1f3fb-200d-2642-fe0f",
        native: "🧘🏻‍♂️"
      },
      {
        unified: "1f9d8-1f3fc-200d-2642-fe0f",
        native: "🧘🏼‍♂️"
      },
      {
        unified: "1f9d8-1f3fd-200d-2642-fe0f",
        native: "🧘🏽‍♂️"
      },
      {
        unified: "1f9d8-1f3fe-200d-2642-fe0f",
        native: "🧘🏾‍♂️"
      },
      {
        unified: "1f9d8-1f3ff-200d-2642-fe0f",
        native: "🧘🏿‍♂️"
      }
    ],
    version: 5
  },
  woman_in_lotus_position: {
    id: "woman_in_lotus_position",
    name: "Woman in Lotus Position",
    keywords: [
      "female",
      "meditation",
      "yoga",
      "serenity",
      "zen",
      "mindfulness"
    ],
    skins: [
      {
        unified: "1f9d8-200d-2640-fe0f",
        native: "🧘‍♀️"
      },
      {
        unified: "1f9d8-1f3fb-200d-2640-fe0f",
        native: "🧘🏻‍♀️"
      },
      {
        unified: "1f9d8-1f3fc-200d-2640-fe0f",
        native: "🧘🏼‍♀️"
      },
      {
        unified: "1f9d8-1f3fd-200d-2640-fe0f",
        native: "🧘🏽‍♀️"
      },
      {
        unified: "1f9d8-1f3fe-200d-2640-fe0f",
        native: "🧘🏾‍♀️"
      },
      {
        unified: "1f9d8-1f3ff-200d-2640-fe0f",
        native: "🧘🏿‍♀️"
      }
    ],
    version: 5
  },
  bath: {
    id: "bath",
    name: "Bath",
    keywords: [
      "person",
      "taking",
      "clean",
      "shower",
      "bathroom"
    ],
    skins: [
      {
        unified: "1f6c0",
        native: "🛀"
      },
      {
        unified: "1f6c0-1f3fb",
        native: "🛀🏻"
      },
      {
        unified: "1f6c0-1f3fc",
        native: "🛀🏼"
      },
      {
        unified: "1f6c0-1f3fd",
        native: "🛀🏽"
      },
      {
        unified: "1f6c0-1f3fe",
        native: "🛀🏾"
      },
      {
        unified: "1f6c0-1f3ff",
        native: "🛀🏿"
      }
    ],
    version: 1
  },
  sleeping_accommodation: {
    id: "sleeping_accommodation",
    name: "Person in Bed",
    keywords: [
      "sleeping",
      "accommodation",
      "rest"
    ],
    skins: [
      {
        unified: "1f6cc",
        native: "🛌"
      },
      {
        unified: "1f6cc-1f3fb",
        native: "🛌🏻"
      },
      {
        unified: "1f6cc-1f3fc",
        native: "🛌🏼"
      },
      {
        unified: "1f6cc-1f3fd",
        native: "🛌🏽"
      },
      {
        unified: "1f6cc-1f3fe",
        native: "🛌🏾"
      },
      {
        unified: "1f6cc-1f3ff",
        native: "🛌🏿"
      }
    ],
    version: 1
  },
  people_holding_hands: {
    id: "people_holding_hands",
    name: "People Holding Hands",
    keywords: [
      "friendship"
    ],
    skins: [
      {
        unified: "1f9d1-200d-1f91d-200d-1f9d1",
        native: "🧑‍🤝‍🧑"
      },
      {
        unified: "1f9d1-1f3fb-200d-1f91d-200d-1f9d1-1f3fb",
        native: "🧑🏻‍🤝‍🧑🏻"
      },
      {
        unified: "1f9d1-1f3fc-200d-1f91d-200d-1f9d1-1f3fc",
        native: "🧑🏼‍🤝‍🧑🏼"
      },
      {
        unified: "1f9d1-1f3fd-200d-1f91d-200d-1f9d1-1f3fd",
        native: "🧑🏽‍🤝‍🧑🏽"
      },
      {
        unified: "1f9d1-1f3fe-200d-1f91d-200d-1f9d1-1f3fe",
        native: "🧑🏾‍🤝‍🧑🏾"
      },
      {
        unified: "1f9d1-1f3ff-200d-1f91d-200d-1f9d1-1f3ff",
        native: "🧑🏿‍🤝‍🧑🏿"
      }
    ],
    version: 12
  },
  two_women_holding_hands: {
    id: "two_women_holding_hands",
    name: "Women Holding Hands",
    keywords: [
      "two",
      "pair",
      "friendship",
      "couple",
      "love",
      "like",
      "female",
      "people",
      "human"
    ],
    skins: [
      {
        unified: "1f46d",
        native: "👭"
      },
      {
        unified: "1f46d-1f3fb",
        native: "👭🏻"
      },
      {
        unified: "1f46d-1f3fc",
        native: "👭🏼"
      },
      {
        unified: "1f46d-1f3fd",
        native: "👭🏽"
      },
      {
        unified: "1f46d-1f3fe",
        native: "👭🏾"
      },
      {
        unified: "1f46d-1f3ff",
        native: "👭🏿"
      }
    ],
    version: 1
  },
  man_and_woman_holding_hands: {
    id: "man_and_woman_holding_hands",
    name: "Man and Woman Holding Hands",
    keywords: [
      "couple",
      "pair",
      "people",
      "human",
      "love",
      "date",
      "dating",
      "like",
      "affection",
      "valentines",
      "marriage"
    ],
    skins: [
      {
        unified: "1f46b",
        native: "👫"
      },
      {
        unified: "1f46b-1f3fb",
        native: "👫🏻"
      },
      {
        unified: "1f46b-1f3fc",
        native: "👫🏼"
      },
      {
        unified: "1f46b-1f3fd",
        native: "👫🏽"
      },
      {
        unified: "1f46b-1f3fe",
        native: "👫🏾"
      },
      {
        unified: "1f46b-1f3ff",
        native: "👫🏿"
      }
    ],
    version: 1
  },
  two_men_holding_hands: {
    id: "two_men_holding_hands",
    name: "Men Holding Hands",
    keywords: [
      "two",
      "pair",
      "couple",
      "love",
      "like",
      "bromance",
      "friendship",
      "people",
      "human"
    ],
    skins: [
      {
        unified: "1f46c",
        native: "👬"
      },
      {
        unified: "1f46c-1f3fb",
        native: "👬🏻"
      },
      {
        unified: "1f46c-1f3fc",
        native: "👬🏼"
      },
      {
        unified: "1f46c-1f3fd",
        native: "👬🏽"
      },
      {
        unified: "1f46c-1f3fe",
        native: "👬🏾"
      },
      {
        unified: "1f46c-1f3ff",
        native: "👬🏿"
      }
    ],
    version: 1
  },
  couplekiss: {
    id: "couplekiss",
    name: "Kiss",
    keywords: [
      "couplekiss",
      "pair",
      "valentines",
      "love",
      "like",
      "dating",
      "marriage"
    ],
    skins: [
      {
        unified: "1f48f",
        native: "💏"
      },
      {
        unified: "1f48f-1f3fb",
        native: "💏🏻"
      },
      {
        unified: "1f48f-1f3fc",
        native: "💏🏼"
      },
      {
        unified: "1f48f-1f3fd",
        native: "💏🏽"
      },
      {
        unified: "1f48f-1f3fe",
        native: "💏🏾"
      },
      {
        unified: "1f48f-1f3ff",
        native: "💏🏿"
      }
    ],
    version: 1
  },
  "woman-kiss-man": {
    id: "woman-kiss-man",
    name: "Kiss: Woman, Man",
    keywords: [
      "woman",
      "kiss-man",
      "kiss",
      "love"
    ],
    skins: [
      {
        unified: "1f469-200d-2764-fe0f-200d-1f48b-200d-1f468",
        native: "👩‍❤️‍💋‍👨"
      },
      {
        unified: "1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb",
        native: "👩🏻‍❤️‍💋‍👨🏻"
      },
      {
        unified: "1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc",
        native: "👩🏼‍❤️‍💋‍👨🏼"
      },
      {
        unified: "1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd",
        native: "👩🏽‍❤️‍💋‍👨🏽"
      },
      {
        unified: "1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe",
        native: "👩🏾‍❤️‍💋‍👨🏾"
      },
      {
        unified: "1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff",
        native: "👩🏿‍❤️‍💋‍👨🏿"
      }
    ],
    version: 2
  },
  "man-kiss-man": {
    id: "man-kiss-man",
    name: "Kiss: Man, Man",
    keywords: [
      "kiss-man",
      "kiss",
      "pair",
      "valentines",
      "love",
      "like",
      "dating",
      "marriage"
    ],
    skins: [
      {
        unified: "1f468-200d-2764-fe0f-200d-1f48b-200d-1f468",
        native: "👨‍❤️‍💋‍👨"
      },
      {
        unified: "1f468-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb",
        native: "👨🏻‍❤️‍💋‍👨🏻"
      },
      {
        unified: "1f468-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc",
        native: "👨🏼‍❤️‍💋‍👨🏼"
      },
      {
        unified: "1f468-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd",
        native: "👨🏽‍❤️‍💋‍👨🏽"
      },
      {
        unified: "1f468-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe",
        native: "👨🏾‍❤️‍💋‍👨🏾"
      },
      {
        unified: "1f468-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff",
        native: "👨🏿‍❤️‍💋‍👨🏿"
      }
    ],
    version: 2
  },
  "woman-kiss-woman": {
    id: "woman-kiss-woman",
    name: "Kiss: Woman, Woman",
    keywords: [
      "kiss-woman",
      "kiss",
      "pair",
      "valentines",
      "love",
      "like",
      "dating",
      "marriage"
    ],
    skins: [
      {
        unified: "1f469-200d-2764-fe0f-200d-1f48b-200d-1f469",
        native: "👩‍❤️‍💋‍👩"
      },
      {
        unified: "1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fb",
        native: "👩🏻‍❤️‍💋‍👩🏻"
      },
      {
        unified: "1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fc",
        native: "👩🏼‍❤️‍💋‍👩🏼"
      },
      {
        unified: "1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fd",
        native: "👩🏽‍❤️‍💋‍👩🏽"
      },
      {
        unified: "1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fe",
        native: "👩🏾‍❤️‍💋‍👩🏾"
      },
      {
        unified: "1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3ff",
        native: "👩🏿‍❤️‍💋‍👩🏿"
      }
    ],
    version: 2
  },
  couple_with_heart: {
    id: "couple_with_heart",
    name: "Couple with Heart",
    keywords: [
      "pair",
      "love",
      "like",
      "affection",
      "human",
      "dating",
      "valentines",
      "marriage"
    ],
    skins: [
      {
        unified: "1f491",
        native: "💑"
      },
      {
        unified: "1f491-1f3fb",
        native: "💑🏻"
      },
      {
        unified: "1f491-1f3fc",
        native: "💑🏼"
      },
      {
        unified: "1f491-1f3fd",
        native: "💑🏽"
      },
      {
        unified: "1f491-1f3fe",
        native: "💑🏾"
      },
      {
        unified: "1f491-1f3ff",
        native: "💑🏿"
      }
    ],
    version: 1
  },
  "woman-heart-man": {
    id: "woman-heart-man",
    name: "Couple with Heart: Woman, Man",
    keywords: [
      "woman",
      "heart-man",
      "heart",
      "love"
    ],
    skins: [
      {
        unified: "1f469-200d-2764-fe0f-200d-1f468",
        native: "👩‍❤️‍👨"
      },
      {
        unified: "1f469-1f3fb-200d-2764-fe0f-200d-1f468-1f3fb",
        native: "👩🏻‍❤️‍👨🏻"
      },
      {
        unified: "1f469-1f3fc-200d-2764-fe0f-200d-1f468-1f3fc",
        native: "👩🏼‍❤️‍👨🏼"
      },
      {
        unified: "1f469-1f3fd-200d-2764-fe0f-200d-1f468-1f3fd",
        native: "👩🏽‍❤️‍👨🏽"
      },
      {
        unified: "1f469-1f3fe-200d-2764-fe0f-200d-1f468-1f3fe",
        native: "👩🏾‍❤️‍👨🏾"
      },
      {
        unified: "1f469-1f3ff-200d-2764-fe0f-200d-1f468-1f3ff",
        native: "👩🏿‍❤️‍👨🏿"
      }
    ],
    version: 2
  },
  "man-heart-man": {
    id: "man-heart-man",
    name: "Couple with Heart: Man, Man",
    keywords: [
      "heart-man",
      "heart",
      "pair",
      "love",
      "like",
      "affection",
      "human",
      "dating",
      "valentines",
      "marriage"
    ],
    skins: [
      {
        unified: "1f468-200d-2764-fe0f-200d-1f468",
        native: "👨‍❤️‍👨"
      },
      {
        unified: "1f468-1f3fb-200d-2764-fe0f-200d-1f468-1f3fb",
        native: "👨🏻‍❤️‍👨🏻"
      },
      {
        unified: "1f468-1f3fc-200d-2764-fe0f-200d-1f468-1f3fc",
        native: "👨🏼‍❤️‍👨🏼"
      },
      {
        unified: "1f468-1f3fd-200d-2764-fe0f-200d-1f468-1f3fd",
        native: "👨🏽‍❤️‍👨🏽"
      },
      {
        unified: "1f468-1f3fe-200d-2764-fe0f-200d-1f468-1f3fe",
        native: "👨🏾‍❤️‍👨🏾"
      },
      {
        unified: "1f468-1f3ff-200d-2764-fe0f-200d-1f468-1f3ff",
        native: "👨🏿‍❤️‍👨🏿"
      }
    ],
    version: 2
  },
  "woman-heart-woman": {
    id: "woman-heart-woman",
    name: "Couple with Heart: Woman, Woman",
    keywords: [
      "heart-woman",
      "heart",
      "pair",
      "love",
      "like",
      "affection",
      "human",
      "dating",
      "valentines",
      "marriage"
    ],
    skins: [
      {
        unified: "1f469-200d-2764-fe0f-200d-1f469",
        native: "👩‍❤️‍👩"
      },
      {
        unified: "1f469-1f3fb-200d-2764-fe0f-200d-1f469-1f3fb",
        native: "👩🏻‍❤️‍👩🏻"
      },
      {
        unified: "1f469-1f3fc-200d-2764-fe0f-200d-1f469-1f3fc",
        native: "👩🏼‍❤️‍👩🏼"
      },
      {
        unified: "1f469-1f3fd-200d-2764-fe0f-200d-1f469-1f3fd",
        native: "👩🏽‍❤️‍👩🏽"
      },
      {
        unified: "1f469-1f3fe-200d-2764-fe0f-200d-1f469-1f3fe",
        native: "👩🏾‍❤️‍👩🏾"
      },
      {
        unified: "1f469-1f3ff-200d-2764-fe0f-200d-1f469-1f3ff",
        native: "👩🏿‍❤️‍👩🏿"
      }
    ],
    version: 2
  },
  family: {
    id: "family",
    name: "Family",
    keywords: [
      "home",
      "parents",
      "child",
      "mom",
      "dad",
      "father",
      "mother",
      "people",
      "human"
    ],
    skins: [
      {
        unified: "1f46a",
        native: "👪"
      }
    ],
    version: 1
  },
  "man-woman-boy": {
    id: "man-woman-boy",
    name: "Family: Man, Woman, Boy",
    keywords: [
      "man",
      "woman-boy",
      "family",
      "woman",
      "love"
    ],
    skins: [
      {
        unified: "1f468-200d-1f469-200d-1f466",
        native: "👨‍👩‍👦"
      }
    ],
    version: 2
  },
  "man-woman-girl": {
    id: "man-woman-girl",
    name: "Family: Man, Woman, Girl",
    keywords: [
      "man",
      "woman-girl",
      "family",
      "woman",
      "home",
      "parents",
      "people",
      "human",
      "child"
    ],
    skins: [
      {
        unified: "1f468-200d-1f469-200d-1f467",
        native: "👨‍👩‍👧"
      }
    ],
    version: 2
  },
  "man-woman-girl-boy": {
    id: "man-woman-girl-boy",
    name: "Family: Man, Woman, Girl, Boy",
    keywords: [
      "man",
      "woman-girl-boy",
      "family",
      "woman",
      "girl",
      "home",
      "parents",
      "people",
      "human",
      "children"
    ],
    skins: [
      {
        unified: "1f468-200d-1f469-200d-1f467-200d-1f466",
        native: "👨‍👩‍👧‍👦"
      }
    ],
    version: 2
  },
  "man-woman-boy-boy": {
    id: "man-woman-boy-boy",
    name: "Family: Man, Woman, Boy, Boy",
    keywords: [
      "man",
      "woman-boy-boy",
      "family",
      "woman",
      "home",
      "parents",
      "people",
      "human",
      "children"
    ],
    skins: [
      {
        unified: "1f468-200d-1f469-200d-1f466-200d-1f466",
        native: "👨‍👩‍👦‍👦"
      }
    ],
    version: 2
  },
  "man-woman-girl-girl": {
    id: "man-woman-girl-girl",
    name: "Family: Man, Woman, Girl, Girl",
    keywords: [
      "man",
      "woman-girl-girl",
      "family",
      "woman",
      "home",
      "parents",
      "people",
      "human",
      "children"
    ],
    skins: [
      {
        unified: "1f468-200d-1f469-200d-1f467-200d-1f467",
        native: "👨‍👩‍👧‍👧"
      }
    ],
    version: 2
  },
  "man-man-boy": {
    id: "man-man-boy",
    name: "Family: Man, Man, Boy",
    keywords: [
      "man",
      "man-boy",
      "family",
      "home",
      "parents",
      "people",
      "human",
      "children"
    ],
    skins: [
      {
        unified: "1f468-200d-1f468-200d-1f466",
        native: "👨‍👨‍👦"
      }
    ],
    version: 2
  },
  "man-man-girl": {
    id: "man-man-girl",
    name: "Family: Man, Man, Girl",
    keywords: [
      "man",
      "man-girl",
      "family",
      "home",
      "parents",
      "people",
      "human",
      "children"
    ],
    skins: [
      {
        unified: "1f468-200d-1f468-200d-1f467",
        native: "👨‍👨‍👧"
      }
    ],
    version: 2
  },
  "man-man-girl-boy": {
    id: "man-man-girl-boy",
    name: "Family: Man, Man, Girl, Boy",
    keywords: [
      "man",
      "man-girl-boy",
      "family",
      "girl",
      "home",
      "parents",
      "people",
      "human",
      "children"
    ],
    skins: [
      {
        unified: "1f468-200d-1f468-200d-1f467-200d-1f466",
        native: "👨‍👨‍👧‍👦"
      }
    ],
    version: 2
  },
  "man-man-boy-boy": {
    id: "man-man-boy-boy",
    name: "Family: Man, Man, Boy, Boy",
    keywords: [
      "man",
      "man-boy-boy",
      "family",
      "home",
      "parents",
      "people",
      "human",
      "children"
    ],
    skins: [
      {
        unified: "1f468-200d-1f468-200d-1f466-200d-1f466",
        native: "👨‍👨‍👦‍👦"
      }
    ],
    version: 2
  },
  "man-man-girl-girl": {
    id: "man-man-girl-girl",
    name: "Family: Man, Man, Girl, Girl",
    keywords: [
      "man",
      "man-girl-girl",
      "family",
      "home",
      "parents",
      "people",
      "human",
      "children"
    ],
    skins: [
      {
        unified: "1f468-200d-1f468-200d-1f467-200d-1f467",
        native: "👨‍👨‍👧‍👧"
      }
    ],
    version: 2
  },
  "woman-woman-boy": {
    id: "woman-woman-boy",
    name: "Family: Woman, Woman, Boy",
    keywords: [
      "woman",
      "woman-boy",
      "family",
      "home",
      "parents",
      "people",
      "human",
      "children"
    ],
    skins: [
      {
        unified: "1f469-200d-1f469-200d-1f466",
        native: "👩‍👩‍👦"
      }
    ],
    version: 2
  },
  "woman-woman-girl": {
    id: "woman-woman-girl",
    name: "Family: Woman, Woman, Girl",
    keywords: [
      "woman",
      "woman-girl",
      "family",
      "home",
      "parents",
      "people",
      "human",
      "children"
    ],
    skins: [
      {
        unified: "1f469-200d-1f469-200d-1f467",
        native: "👩‍👩‍👧"
      }
    ],
    version: 2
  },
  "woman-woman-girl-boy": {
    id: "woman-woman-girl-boy",
    name: "Family: Woman, Woman, Girl, Boy",
    keywords: [
      "woman",
      "woman-girl-boy",
      "family",
      "girl",
      "home",
      "parents",
      "people",
      "human",
      "children"
    ],
    skins: [
      {
        unified: "1f469-200d-1f469-200d-1f467-200d-1f466",
        native: "👩‍👩‍👧‍👦"
      }
    ],
    version: 2
  },
  "woman-woman-boy-boy": {
    id: "woman-woman-boy-boy",
    name: "Family: Woman, Woman, Boy, Boy",
    keywords: [
      "woman",
      "woman-boy-boy",
      "family",
      "home",
      "parents",
      "people",
      "human",
      "children"
    ],
    skins: [
      {
        unified: "1f469-200d-1f469-200d-1f466-200d-1f466",
        native: "👩‍👩‍👦‍👦"
      }
    ],
    version: 2
  },
  "woman-woman-girl-girl": {
    id: "woman-woman-girl-girl",
    name: "Family: Woman, Woman, Girl, Girl",
    keywords: [
      "woman",
      "woman-girl-girl",
      "family",
      "home",
      "parents",
      "people",
      "human",
      "children"
    ],
    skins: [
      {
        unified: "1f469-200d-1f469-200d-1f467-200d-1f467",
        native: "👩‍👩‍👧‍👧"
      }
    ],
    version: 2
  },
  "man-boy": {
    id: "man-boy",
    name: "Family: Man, Boy",
    keywords: [
      "man",
      "family",
      "home",
      "parent",
      "people",
      "human",
      "child"
    ],
    skins: [
      {
        unified: "1f468-200d-1f466",
        native: "👨‍👦"
      }
    ],
    version: 4
  },
  "man-boy-boy": {
    id: "man-boy-boy",
    name: "Family: Man, Boy, Boy",
    keywords: [
      "man",
      "boy-boy",
      "family",
      "home",
      "parent",
      "people",
      "human",
      "children"
    ],
    skins: [
      {
        unified: "1f468-200d-1f466-200d-1f466",
        native: "👨‍👦‍👦"
      }
    ],
    version: 4
  },
  "man-girl": {
    id: "man-girl",
    name: "Family: Man, Girl",
    keywords: [
      "man",
      "family",
      "home",
      "parent",
      "people",
      "human",
      "child"
    ],
    skins: [
      {
        unified: "1f468-200d-1f467",
        native: "👨‍👧"
      }
    ],
    version: 4
  },
  "man-girl-boy": {
    id: "man-girl-boy",
    name: "Family: Man, Girl, Boy",
    keywords: [
      "man",
      "girl-boy",
      "family",
      "girl",
      "home",
      "parent",
      "people",
      "human",
      "children"
    ],
    skins: [
      {
        unified: "1f468-200d-1f467-200d-1f466",
        native: "👨‍👧‍👦"
      }
    ],
    version: 4
  },
  "man-girl-girl": {
    id: "man-girl-girl",
    name: "Family: Man, Girl, Girl",
    keywords: [
      "man",
      "girl-girl",
      "family",
      "home",
      "parent",
      "people",
      "human",
      "children"
    ],
    skins: [
      {
        unified: "1f468-200d-1f467-200d-1f467",
        native: "👨‍👧‍👧"
      }
    ],
    version: 4
  },
  "woman-boy": {
    id: "woman-boy",
    name: "Family: Woman, Boy",
    keywords: [
      "woman",
      "family",
      "home",
      "parent",
      "people",
      "human",
      "child"
    ],
    skins: [
      {
        unified: "1f469-200d-1f466",
        native: "👩‍👦"
      }
    ],
    version: 4
  },
  "woman-boy-boy": {
    id: "woman-boy-boy",
    name: "Family: Woman, Boy, Boy",
    keywords: [
      "woman",
      "boy-boy",
      "family",
      "home",
      "parent",
      "people",
      "human",
      "children"
    ],
    skins: [
      {
        unified: "1f469-200d-1f466-200d-1f466",
        native: "👩‍👦‍👦"
      }
    ],
    version: 4
  },
  "woman-girl": {
    id: "woman-girl",
    name: "Family: Woman, Girl",
    keywords: [
      "woman",
      "family",
      "home",
      "parent",
      "people",
      "human",
      "child"
    ],
    skins: [
      {
        unified: "1f469-200d-1f467",
        native: "👩‍👧"
      }
    ],
    version: 4
  },
  "woman-girl-boy": {
    id: "woman-girl-boy",
    name: "Family: Woman, Girl, Boy",
    keywords: [
      "woman",
      "girl-boy",
      "family",
      "girl",
      "home",
      "parent",
      "people",
      "human",
      "children"
    ],
    skins: [
      {
        unified: "1f469-200d-1f467-200d-1f466",
        native: "👩‍👧‍👦"
      }
    ],
    version: 4
  },
  "woman-girl-girl": {
    id: "woman-girl-girl",
    name: "Family: Woman, Girl, Girl",
    keywords: [
      "woman",
      "girl-girl",
      "family",
      "home",
      "parent",
      "people",
      "human",
      "children"
    ],
    skins: [
      {
        unified: "1f469-200d-1f467-200d-1f467",
        native: "👩‍👧‍👧"
      }
    ],
    version: 4
  },
  speaking_head_in_silhouette: {
    id: "speaking_head_in_silhouette",
    name: "Speaking Head",
    keywords: [
      "in",
      "silhouette",
      "user",
      "person",
      "human",
      "sing",
      "say",
      "talk"
    ],
    skins: [
      {
        unified: "1f5e3-fe0f",
        native: "🗣️"
      }
    ],
    version: 1
  },
  bust_in_silhouette: {
    id: "bust_in_silhouette",
    name: "Bust in Silhouette",
    keywords: [
      "user",
      "person",
      "human"
    ],
    skins: [
      {
        unified: "1f464",
        native: "👤"
      }
    ],
    version: 1
  },
  busts_in_silhouette: {
    id: "busts_in_silhouette",
    name: "Busts in Silhouette",
    keywords: [
      "user",
      "person",
      "human",
      "group",
      "team"
    ],
    skins: [
      {
        unified: "1f465",
        native: "👥"
      }
    ],
    version: 1
  },
  people_hugging: {
    id: "people_hugging",
    name: "People Hugging",
    keywords: [
      "care"
    ],
    skins: [
      {
        unified: "1fac2",
        native: "🫂"
      }
    ],
    version: 13
  },
  footprints: {
    id: "footprints",
    name: "Footprints",
    keywords: [
      "feet",
      "tracking",
      "walking",
      "beach"
    ],
    skins: [
      {
        unified: "1f463",
        native: "👣"
      }
    ],
    version: 1
  },
  monkey_face: {
    id: "monkey_face",
    name: "Monkey Face",
    emoticons: [
      ":o)"
    ],
    keywords: [
      "animal",
      "nature",
      "circus"
    ],
    skins: [
      {
        unified: "1f435",
        native: "🐵"
      }
    ],
    version: 1
  },
  monkey: {
    id: "monkey",
    name: "Monkey",
    keywords: [
      "animal",
      "nature",
      "banana",
      "circus"
    ],
    skins: [
      {
        unified: "1f412",
        native: "🐒"
      }
    ],
    version: 1
  },
  gorilla: {
    id: "gorilla",
    name: "Gorilla",
    keywords: [
      "animal",
      "nature",
      "circus"
    ],
    skins: [
      {
        unified: "1f98d",
        native: "🦍"
      }
    ],
    version: 3
  },
  orangutan: {
    id: "orangutan",
    name: "Orangutan",
    keywords: [
      "animal"
    ],
    skins: [
      {
        unified: "1f9a7",
        native: "🦧"
      }
    ],
    version: 12
  },
  dog: {
    id: "dog",
    name: "Dog Face",
    keywords: [
      "animal",
      "friend",
      "nature",
      "woof",
      "puppy",
      "pet",
      "faithful"
    ],
    skins: [
      {
        unified: "1f436",
        native: "🐶"
      }
    ],
    version: 1
  },
  dog2: {
    id: "dog2",
    name: "Dog",
    keywords: [
      "dog2",
      "animal",
      "nature",
      "friend",
      "doge",
      "pet",
      "faithful"
    ],
    skins: [
      {
        unified: "1f415",
        native: "🐕"
      }
    ],
    version: 1
  },
  guide_dog: {
    id: "guide_dog",
    name: "Guide Dog",
    keywords: [
      "animal",
      "blind"
    ],
    skins: [
      {
        unified: "1f9ae",
        native: "🦮"
      }
    ],
    version: 12
  },
  service_dog: {
    id: "service_dog",
    name: "Service Dog",
    keywords: [
      "blind",
      "animal"
    ],
    skins: [
      {
        unified: "1f415-200d-1f9ba",
        native: "🐕‍🦺"
      }
    ],
    version: 12
  },
  poodle: {
    id: "poodle",
    name: "Poodle",
    keywords: [
      "dog",
      "animal",
      "101",
      "nature",
      "pet"
    ],
    skins: [
      {
        unified: "1f429",
        native: "🐩"
      }
    ],
    version: 1
  },
  wolf: {
    id: "wolf",
    name: "Wolf",
    keywords: [
      "animal",
      "nature",
      "wild"
    ],
    skins: [
      {
        unified: "1f43a",
        native: "🐺"
      }
    ],
    version: 1
  },
  fox_face: {
    id: "fox_face",
    name: "Fox",
    keywords: [
      "face",
      "animal",
      "nature"
    ],
    skins: [
      {
        unified: "1f98a",
        native: "🦊"
      }
    ],
    version: 3
  },
  raccoon: {
    id: "raccoon",
    name: "Raccoon",
    keywords: [
      "animal",
      "nature"
    ],
    skins: [
      {
        unified: "1f99d",
        native: "🦝"
      }
    ],
    version: 11
  },
  cat: {
    id: "cat",
    name: "Cat Face",
    keywords: [
      "animal",
      "meow",
      "nature",
      "pet",
      "kitten"
    ],
    skins: [
      {
        unified: "1f431",
        native: "🐱"
      }
    ],
    version: 1
  },
  cat2: {
    id: "cat2",
    name: "Cat",
    keywords: [
      "cat2",
      "animal",
      "meow",
      "pet",
      "cats"
    ],
    skins: [
      {
        unified: "1f408",
        native: "🐈"
      }
    ],
    version: 1
  },
  black_cat: {
    id: "black_cat",
    name: "Black Cat",
    keywords: [
      "superstition",
      "luck"
    ],
    skins: [
      {
        unified: "1f408-200d-2b1b",
        native: "🐈‍⬛"
      }
    ],
    version: 13
  },
  lion_face: {
    id: "lion_face",
    name: "Lion",
    keywords: [
      "face",
      "animal",
      "nature"
    ],
    skins: [
      {
        unified: "1f981",
        native: "🦁"
      }
    ],
    version: 1
  },
  tiger: {
    id: "tiger",
    name: "Tiger Face",
    keywords: [
      "animal",
      "cat",
      "danger",
      "wild",
      "nature",
      "roar"
    ],
    skins: [
      {
        unified: "1f42f",
        native: "🐯"
      }
    ],
    version: 1
  },
  tiger2: {
    id: "tiger2",
    name: "Tiger",
    keywords: [
      "tiger2",
      "animal",
      "nature",
      "roar"
    ],
    skins: [
      {
        unified: "1f405",
        native: "🐅"
      }
    ],
    version: 1
  },
  leopard: {
    id: "leopard",
    name: "Leopard",
    keywords: [
      "animal",
      "nature"
    ],
    skins: [
      {
        unified: "1f406",
        native: "🐆"
      }
    ],
    version: 1
  },
  horse: {
    id: "horse",
    name: "Horse Face",
    keywords: [
      "animal",
      "brown",
      "nature"
    ],
    skins: [
      {
        unified: "1f434",
        native: "🐴"
      }
    ],
    version: 1
  },
  racehorse: {
    id: "racehorse",
    name: "Horse",
    keywords: [
      "racehorse",
      "animal",
      "gamble",
      "luck"
    ],
    skins: [
      {
        unified: "1f40e",
        native: "🐎"
      }
    ],
    version: 1
  },
  unicorn_face: {
    id: "unicorn_face",
    name: "Unicorn",
    keywords: [
      "face",
      "animal",
      "nature",
      "mystical"
    ],
    skins: [
      {
        unified: "1f984",
        native: "🦄"
      }
    ],
    version: 1
  },
  zebra_face: {
    id: "zebra_face",
    name: "Zebra",
    keywords: [
      "face",
      "animal",
      "nature",
      "stripes",
      "safari"
    ],
    skins: [
      {
        unified: "1f993",
        native: "🦓"
      }
    ],
    version: 5
  },
  deer: {
    id: "deer",
    name: "Deer",
    keywords: [
      "animal",
      "nature",
      "horns",
      "venison"
    ],
    skins: [
      {
        unified: "1f98c",
        native: "🦌"
      }
    ],
    version: 3
  },
  bison: {
    id: "bison",
    name: "Bison",
    keywords: [
      "ox"
    ],
    skins: [
      {
        unified: "1f9ac",
        native: "🦬"
      }
    ],
    version: 13
  },
  cow: {
    id: "cow",
    name: "Cow Face",
    keywords: [
      "beef",
      "ox",
      "animal",
      "nature",
      "moo",
      "milk"
    ],
    skins: [
      {
        unified: "1f42e",
        native: "🐮"
      }
    ],
    version: 1
  },
  ox: {
    id: "ox",
    name: "Ox",
    keywords: [
      "animal",
      "cow",
      "beef"
    ],
    skins: [
      {
        unified: "1f402",
        native: "🐂"
      }
    ],
    version: 1
  },
  water_buffalo: {
    id: "water_buffalo",
    name: "Water Buffalo",
    keywords: [
      "animal",
      "nature",
      "ox",
      "cow"
    ],
    skins: [
      {
        unified: "1f403",
        native: "🐃"
      }
    ],
    version: 1
  },
  cow2: {
    id: "cow2",
    name: "Cow",
    keywords: [
      "cow2",
      "beef",
      "ox",
      "animal",
      "nature",
      "moo",
      "milk"
    ],
    skins: [
      {
        unified: "1f404",
        native: "🐄"
      }
    ],
    version: 1
  },
  pig: {
    id: "pig",
    name: "Pig Face",
    keywords: [
      "animal",
      "oink",
      "nature"
    ],
    skins: [
      {
        unified: "1f437",
        native: "🐷"
      }
    ],
    version: 1
  },
  pig2: {
    id: "pig2",
    name: "Pig",
    keywords: [
      "pig2",
      "animal",
      "nature"
    ],
    skins: [
      {
        unified: "1f416",
        native: "🐖"
      }
    ],
    version: 1
  },
  boar: {
    id: "boar",
    name: "Boar",
    keywords: [
      "animal",
      "nature"
    ],
    skins: [
      {
        unified: "1f417",
        native: "🐗"
      }
    ],
    version: 1
  },
  pig_nose: {
    id: "pig_nose",
    name: "Pig Nose",
    keywords: [
      "animal",
      "oink"
    ],
    skins: [
      {
        unified: "1f43d",
        native: "🐽"
      }
    ],
    version: 1
  },
  ram: {
    id: "ram",
    name: "Ram",
    keywords: [
      "animal",
      "sheep",
      "nature"
    ],
    skins: [
      {
        unified: "1f40f",
        native: "🐏"
      }
    ],
    version: 1
  },
  sheep: {
    id: "sheep",
    name: "Ewe",
    keywords: [
      "sheep",
      "animal",
      "nature",
      "wool",
      "shipit"
    ],
    skins: [
      {
        unified: "1f411",
        native: "🐑"
      }
    ],
    version: 1
  },
  goat: {
    id: "goat",
    name: "Goat",
    keywords: [
      "animal",
      "nature"
    ],
    skins: [
      {
        unified: "1f410",
        native: "🐐"
      }
    ],
    version: 1
  },
  dromedary_camel: {
    id: "dromedary_camel",
    name: "Camel",
    keywords: [
      "dromedary",
      "animal",
      "hot",
      "desert",
      "hump"
    ],
    skins: [
      {
        unified: "1f42a",
        native: "🐪"
      }
    ],
    version: 1
  },
  camel: {
    id: "camel",
    name: "Bactrian Camel",
    keywords: [
      "two",
      "hump",
      "animal",
      "nature",
      "hot",
      "desert"
    ],
    skins: [
      {
        unified: "1f42b",
        native: "🐫"
      }
    ],
    version: 1
  },
  llama: {
    id: "llama",
    name: "Llama",
    keywords: [
      "animal",
      "nature",
      "alpaca"
    ],
    skins: [
      {
        unified: "1f999",
        native: "🦙"
      }
    ],
    version: 11
  },
  giraffe_face: {
    id: "giraffe_face",
    name: "Giraffe",
    keywords: [
      "face",
      "animal",
      "nature",
      "spots",
      "safari"
    ],
    skins: [
      {
        unified: "1f992",
        native: "🦒"
      }
    ],
    version: 5
  },
  elephant: {
    id: "elephant",
    name: "Elephant",
    keywords: [
      "animal",
      "nature",
      "nose",
      "th",
      "circus"
    ],
    skins: [
      {
        unified: "1f418",
        native: "🐘"
      }
    ],
    version: 1
  },
  mammoth: {
    id: "mammoth",
    name: "Mammoth",
    keywords: [
      "elephant",
      "tusks"
    ],
    skins: [
      {
        unified: "1f9a3",
        native: "🦣"
      }
    ],
    version: 13
  },
  rhinoceros: {
    id: "rhinoceros",
    name: "Rhinoceros",
    keywords: [
      "animal",
      "nature",
      "horn"
    ],
    skins: [
      {
        unified: "1f98f",
        native: "🦏"
      }
    ],
    version: 3
  },
  hippopotamus: {
    id: "hippopotamus",
    name: "Hippopotamus",
    keywords: [
      "animal",
      "nature"
    ],
    skins: [
      {
        unified: "1f99b",
        native: "🦛"
      }
    ],
    version: 11
  },
  mouse: {
    id: "mouse",
    name: "Mouse Face",
    keywords: [
      "animal",
      "nature",
      "cheese",
      "wedge",
      "rodent"
    ],
    skins: [
      {
        unified: "1f42d",
        native: "🐭"
      }
    ],
    version: 1
  },
  mouse2: {
    id: "mouse2",
    name: "Mouse",
    keywords: [
      "mouse2",
      "animal",
      "nature",
      "rodent"
    ],
    skins: [
      {
        unified: "1f401",
        native: "🐁"
      }
    ],
    version: 1
  },
  rat: {
    id: "rat",
    name: "Rat",
    keywords: [
      "animal",
      "mouse",
      "rodent"
    ],
    skins: [
      {
        unified: "1f400",
        native: "🐀"
      }
    ],
    version: 1
  },
  hamster: {
    id: "hamster",
    name: "Hamster",
    keywords: [
      "animal",
      "nature"
    ],
    skins: [
      {
        unified: "1f439",
        native: "🐹"
      }
    ],
    version: 1
  },
  rabbit: {
    id: "rabbit",
    name: "Rabbit Face",
    keywords: [
      "animal",
      "nature",
      "pet",
      "spring",
      "magic",
      "bunny"
    ],
    skins: [
      {
        unified: "1f430",
        native: "🐰"
      }
    ],
    version: 1
  },
  rabbit2: {
    id: "rabbit2",
    name: "Rabbit",
    keywords: [
      "rabbit2",
      "animal",
      "nature",
      "pet",
      "magic",
      "spring"
    ],
    skins: [
      {
        unified: "1f407",
        native: "🐇"
      }
    ],
    version: 1
  },
  chipmunk: {
    id: "chipmunk",
    name: "Chipmunk",
    keywords: [
      "animal",
      "nature",
      "rodent",
      "squirrel"
    ],
    skins: [
      {
        unified: "1f43f-fe0f",
        native: "🐿️"
      }
    ],
    version: 1
  },
  beaver: {
    id: "beaver",
    name: "Beaver",
    keywords: [
      "animal",
      "rodent"
    ],
    skins: [
      {
        unified: "1f9ab",
        native: "🦫"
      }
    ],
    version: 13
  },
  hedgehog: {
    id: "hedgehog",
    name: "Hedgehog",
    keywords: [
      "animal",
      "nature",
      "spiny"
    ],
    skins: [
      {
        unified: "1f994",
        native: "🦔"
      }
    ],
    version: 5
  },
  bat: {
    id: "bat",
    name: "Bat",
    keywords: [
      "animal",
      "nature",
      "blind",
      "vampire"
    ],
    skins: [
      {
        unified: "1f987",
        native: "🦇"
      }
    ],
    version: 3
  },
  bear: {
    id: "bear",
    name: "Bear",
    keywords: [
      "animal",
      "nature",
      "wild"
    ],
    skins: [
      {
        unified: "1f43b",
        native: "🐻"
      }
    ],
    version: 1
  },
  polar_bear: {
    id: "polar_bear",
    name: "Polar Bear",
    keywords: [
      "animal",
      "arctic"
    ],
    skins: [
      {
        unified: "1f43b-200d-2744-fe0f",
        native: "🐻‍❄️"
      }
    ],
    version: 13
  },
  koala: {
    id: "koala",
    name: "Koala",
    keywords: [
      "animal",
      "nature"
    ],
    skins: [
      {
        unified: "1f428",
        native: "🐨"
      }
    ],
    version: 1
  },
  panda_face: {
    id: "panda_face",
    name: "Panda",
    keywords: [
      "face",
      "animal",
      "nature"
    ],
    skins: [
      {
        unified: "1f43c",
        native: "🐼"
      }
    ],
    version: 1
  },
  sloth: {
    id: "sloth",
    name: "Sloth",
    keywords: [
      "animal"
    ],
    skins: [
      {
        unified: "1f9a5",
        native: "🦥"
      }
    ],
    version: 12
  },
  otter: {
    id: "otter",
    name: "Otter",
    keywords: [
      "animal"
    ],
    skins: [
      {
        unified: "1f9a6",
        native: "🦦"
      }
    ],
    version: 12
  },
  skunk: {
    id: "skunk",
    name: "Skunk",
    keywords: [
      "animal"
    ],
    skins: [
      {
        unified: "1f9a8",
        native: "🦨"
      }
    ],
    version: 12
  },
  kangaroo: {
    id: "kangaroo",
    name: "Kangaroo",
    keywords: [
      "animal",
      "nature",
      "australia",
      "joey",
      "hop",
      "marsupial"
    ],
    skins: [
      {
        unified: "1f998",
        native: "🦘"
      }
    ],
    version: 11
  },
  badger: {
    id: "badger",
    name: "Badger",
    keywords: [
      "animal",
      "nature",
      "honey"
    ],
    skins: [
      {
        unified: "1f9a1",
        native: "🦡"
      }
    ],
    version: 11
  },
  feet: {
    id: "feet",
    name: "Paw Prints",
    keywords: [
      "feet",
      "animal",
      "tracking",
      "footprints",
      "dog",
      "cat",
      "pet"
    ],
    skins: [
      {
        unified: "1f43e",
        native: "🐾"
      }
    ],
    version: 1
  },
  turkey: {
    id: "turkey",
    name: "Turkey",
    keywords: [
      "animal",
      "bird"
    ],
    skins: [
      {
        unified: "1f983",
        native: "🦃"
      }
    ],
    version: 1
  },
  chicken: {
    id: "chicken",
    name: "Chicken",
    keywords: [
      "animal",
      "cluck",
      "nature",
      "bird"
    ],
    skins: [
      {
        unified: "1f414",
        native: "🐔"
      }
    ],
    version: 1
  },
  rooster: {
    id: "rooster",
    name: "Rooster",
    keywords: [
      "animal",
      "nature",
      "chicken"
    ],
    skins: [
      {
        unified: "1f413",
        native: "🐓"
      }
    ],
    version: 1
  },
  hatching_chick: {
    id: "hatching_chick",
    name: "Hatching Chick",
    keywords: [
      "animal",
      "chicken",
      "egg",
      "born",
      "baby",
      "bird"
    ],
    skins: [
      {
        unified: "1f423",
        native: "🐣"
      }
    ],
    version: 1
  },
  baby_chick: {
    id: "baby_chick",
    name: "Baby Chick",
    keywords: [
      "animal",
      "chicken",
      "bird"
    ],
    skins: [
      {
        unified: "1f424",
        native: "🐤"
      }
    ],
    version: 1
  },
  hatched_chick: {
    id: "hatched_chick",
    name: "Front-Facing Baby Chick",
    keywords: [
      "hatched",
      "front",
      "facing",
      "animal",
      "chicken",
      "bird"
    ],
    skins: [
      {
        unified: "1f425",
        native: "🐥"
      }
    ],
    version: 1
  },
  bird: {
    id: "bird",
    name: "Bird",
    keywords: [
      "animal",
      "nature",
      "fly",
      "tweet",
      "spring"
    ],
    skins: [
      {
        unified: "1f426",
        native: "🐦"
      }
    ],
    version: 1
  },
  penguin: {
    id: "penguin",
    name: "Penguin",
    keywords: [
      "animal",
      "nature"
    ],
    skins: [
      {
        unified: "1f427",
        native: "🐧"
      }
    ],
    version: 1
  },
  dove_of_peace: {
    id: "dove_of_peace",
    name: "Dove",
    keywords: [
      "of",
      "peace",
      "animal",
      "bird"
    ],
    skins: [
      {
        unified: "1f54a-fe0f",
        native: "🕊️"
      }
    ],
    version: 1
  },
  eagle: {
    id: "eagle",
    name: "Eagle",
    keywords: [
      "animal",
      "nature",
      "bird"
    ],
    skins: [
      {
        unified: "1f985",
        native: "🦅"
      }
    ],
    version: 3
  },
  duck: {
    id: "duck",
    name: "Duck",
    keywords: [
      "animal",
      "nature",
      "bird",
      "mallard"
    ],
    skins: [
      {
        unified: "1f986",
        native: "🦆"
      }
    ],
    version: 3
  },
  swan: {
    id: "swan",
    name: "Swan",
    keywords: [
      "animal",
      "nature",
      "bird"
    ],
    skins: [
      {
        unified: "1f9a2",
        native: "🦢"
      }
    ],
    version: 11
  },
  owl: {
    id: "owl",
    name: "Owl",
    keywords: [
      "animal",
      "nature",
      "bird",
      "hoot"
    ],
    skins: [
      {
        unified: "1f989",
        native: "🦉"
      }
    ],
    version: 3
  },
  dodo: {
    id: "dodo",
    name: "Dodo",
    keywords: [
      "animal",
      "bird"
    ],
    skins: [
      {
        unified: "1f9a4",
        native: "🦤"
      }
    ],
    version: 13
  },
  feather: {
    id: "feather",
    name: "Feather",
    keywords: [
      "bird",
      "fly"
    ],
    skins: [
      {
        unified: "1fab6",
        native: "🪶"
      }
    ],
    version: 13
  },
  flamingo: {
    id: "flamingo",
    name: "Flamingo",
    keywords: [
      "animal"
    ],
    skins: [
      {
        unified: "1f9a9",
        native: "🦩"
      }
    ],
    version: 12
  },
  peacock: {
    id: "peacock",
    name: "Peacock",
    keywords: [
      "animal",
      "nature",
      "peahen",
      "bird"
    ],
    skins: [
      {
        unified: "1f99a",
        native: "🦚"
      }
    ],
    version: 11
  },
  parrot: {
    id: "parrot",
    name: "Parrot",
    keywords: [
      "animal",
      "nature",
      "bird",
      "pirate",
      "talk"
    ],
    skins: [
      {
        unified: "1f99c",
        native: "🦜"
      }
    ],
    version: 11
  },
  frog: {
    id: "frog",
    name: "Frog",
    keywords: [
      "animal",
      "nature",
      "croak",
      "toad"
    ],
    skins: [
      {
        unified: "1f438",
        native: "🐸"
      }
    ],
    version: 1
  },
  crocodile: {
    id: "crocodile",
    name: "Crocodile",
    keywords: [
      "animal",
      "nature",
      "reptile",
      "lizard",
      "alligator"
    ],
    skins: [
      {
        unified: "1f40a",
        native: "🐊"
      }
    ],
    version: 1
  },
  turtle: {
    id: "turtle",
    name: "Turtle",
    keywords: [
      "animal",
      "slow",
      "nature",
      "tortoise"
    ],
    skins: [
      {
        unified: "1f422",
        native: "🐢"
      }
    ],
    version: 1
  },
  lizard: {
    id: "lizard",
    name: "Lizard",
    keywords: [
      "animal",
      "nature",
      "reptile"
    ],
    skins: [
      {
        unified: "1f98e",
        native: "🦎"
      }
    ],
    version: 3
  },
  snake: {
    id: "snake",
    name: "Snake",
    keywords: [
      "animal",
      "evil",
      "nature",
      "hiss",
      "python"
    ],
    skins: [
      {
        unified: "1f40d",
        native: "🐍"
      }
    ],
    version: 1
  },
  dragon_face: {
    id: "dragon_face",
    name: "Dragon Face",
    keywords: [
      "animal",
      "myth",
      "nature",
      "chinese",
      "green"
    ],
    skins: [
      {
        unified: "1f432",
        native: "🐲"
      }
    ],
    version: 1
  },
  dragon: {
    id: "dragon",
    name: "Dragon",
    keywords: [
      "animal",
      "myth",
      "nature",
      "chinese",
      "green"
    ],
    skins: [
      {
        unified: "1f409",
        native: "🐉"
      }
    ],
    version: 1
  },
  sauropod: {
    id: "sauropod",
    name: "Sauropod",
    keywords: [
      "animal",
      "nature",
      "dinosaur",
      "brachiosaurus",
      "brontosaurus",
      "diplodocus",
      "extinct"
    ],
    skins: [
      {
        unified: "1f995",
        native: "🦕"
      }
    ],
    version: 5
  },
  "t-rex": {
    id: "t-rex",
    name: "T-Rex",
    keywords: [
      "t",
      "rex",
      "animal",
      "nature",
      "dinosaur",
      "tyrannosaurus",
      "extinct"
    ],
    skins: [
      {
        unified: "1f996",
        native: "🦖"
      }
    ],
    version: 5
  },
  whale: {
    id: "whale",
    name: "Spouting Whale",
    keywords: [
      "animal",
      "nature",
      "sea",
      "ocean"
    ],
    skins: [
      {
        unified: "1f433",
        native: "🐳"
      }
    ],
    version: 1
  },
  whale2: {
    id: "whale2",
    name: "Whale",
    keywords: [
      "whale2",
      "animal",
      "nature",
      "sea",
      "ocean"
    ],
    skins: [
      {
        unified: "1f40b",
        native: "🐋"
      }
    ],
    version: 1
  },
  dolphin: {
    id: "dolphin",
    name: "Dolphin",
    keywords: [
      "flipper",
      "animal",
      "nature",
      "fish",
      "sea",
      "ocean",
      "fins",
      "beach"
    ],
    skins: [
      {
        unified: "1f42c",
        native: "🐬"
      }
    ],
    version: 1
  },
  seal: {
    id: "seal",
    name: "Seal",
    keywords: [
      "animal",
      "creature",
      "sea"
    ],
    skins: [
      {
        unified: "1f9ad",
        native: "🦭"
      }
    ],
    version: 13
  },
  fish: {
    id: "fish",
    name: "Fish",
    keywords: [
      "animal",
      "food",
      "nature"
    ],
    skins: [
      {
        unified: "1f41f",
        native: "🐟"
      }
    ],
    version: 1
  },
  tropical_fish: {
    id: "tropical_fish",
    name: "Tropical Fish",
    keywords: [
      "animal",
      "swim",
      "ocean",
      "beach",
      "nemo"
    ],
    skins: [
      {
        unified: "1f420",
        native: "🐠"
      }
    ],
    version: 1
  },
  blowfish: {
    id: "blowfish",
    name: "Blowfish",
    keywords: [
      "animal",
      "nature",
      "food",
      "sea",
      "ocean"
    ],
    skins: [
      {
        unified: "1f421",
        native: "🐡"
      }
    ],
    version: 1
  },
  shark: {
    id: "shark",
    name: "Shark",
    keywords: [
      "animal",
      "nature",
      "fish",
      "sea",
      "ocean",
      "jaws",
      "fins",
      "beach"
    ],
    skins: [
      {
        unified: "1f988",
        native: "🦈"
      }
    ],
    version: 3
  },
  octopus: {
    id: "octopus",
    name: "Octopus",
    keywords: [
      "animal",
      "creature",
      "ocean",
      "sea",
      "nature",
      "beach"
    ],
    skins: [
      {
        unified: "1f419",
        native: "🐙"
      }
    ],
    version: 1
  },
  shell: {
    id: "shell",
    name: "Spiral Shell",
    keywords: [
      "nature",
      "sea",
      "beach"
    ],
    skins: [
      {
        unified: "1f41a",
        native: "🐚"
      }
    ],
    version: 1
  },
  coral: {
    id: "coral",
    name: "Coral",
    keywords: [
      "ocean",
      "sea",
      "reef"
    ],
    skins: [
      {
        unified: "1fab8",
        native: "🪸"
      }
    ],
    version: 14
  },
  snail: {
    id: "snail",
    name: "Snail",
    keywords: [
      "slow",
      "animal",
      "shell"
    ],
    skins: [
      {
        unified: "1f40c",
        native: "🐌"
      }
    ],
    version: 1
  },
  butterfly: {
    id: "butterfly",
    name: "Butterfly",
    keywords: [
      "animal",
      "insect",
      "nature",
      "caterpillar"
    ],
    skins: [
      {
        unified: "1f98b",
        native: "🦋"
      }
    ],
    version: 3
  },
  bug: {
    id: "bug",
    name: "Bug",
    keywords: [
      "animal",
      "insect",
      "nature",
      "worm"
    ],
    skins: [
      {
        unified: "1f41b",
        native: "🐛"
      }
    ],
    version: 1
  },
  ant: {
    id: "ant",
    name: "Ant",
    keywords: [
      "animal",
      "insect",
      "nature",
      "bug"
    ],
    skins: [
      {
        unified: "1f41c",
        native: "🐜"
      }
    ],
    version: 1
  },
  bee: {
    id: "bee",
    name: "Honeybee",
    keywords: [
      "bee",
      "animal",
      "insect",
      "nature",
      "bug",
      "spring",
      "honey"
    ],
    skins: [
      {
        unified: "1f41d",
        native: "🐝"
      }
    ],
    version: 1
  },
  beetle: {
    id: "beetle",
    name: "Beetle",
    keywords: [
      "insect"
    ],
    skins: [
      {
        unified: "1fab2",
        native: "🪲"
      }
    ],
    version: 13
  },
  ladybug: {
    id: "ladybug",
    name: "Lady Beetle",
    keywords: [
      "ladybug",
      "animal",
      "insect",
      "nature"
    ],
    skins: [
      {
        unified: "1f41e",
        native: "🐞"
      }
    ],
    version: 1
  },
  cricket: {
    id: "cricket",
    name: "Cricket",
    keywords: [
      "animal",
      "chirp"
    ],
    skins: [
      {
        unified: "1f997",
        native: "🦗"
      }
    ],
    version: 5
  },
  cockroach: {
    id: "cockroach",
    name: "Cockroach",
    keywords: [
      "insect",
      "pests"
    ],
    skins: [
      {
        unified: "1fab3",
        native: "🪳"
      }
    ],
    version: 13
  },
  spider: {
    id: "spider",
    name: "Spider",
    keywords: [
      "animal",
      "arachnid"
    ],
    skins: [
      {
        unified: "1f577-fe0f",
        native: "🕷️"
      }
    ],
    version: 1
  },
  spider_web: {
    id: "spider_web",
    name: "Spider Web",
    keywords: [
      "animal",
      "insect",
      "arachnid",
      "silk"
    ],
    skins: [
      {
        unified: "1f578-fe0f",
        native: "🕸️"
      }
    ],
    version: 1
  },
  scorpion: {
    id: "scorpion",
    name: "Scorpion",
    keywords: [
      "animal",
      "arachnid"
    ],
    skins: [
      {
        unified: "1f982",
        native: "🦂"
      }
    ],
    version: 1
  },
  mosquito: {
    id: "mosquito",
    name: "Mosquito",
    keywords: [
      "animal",
      "nature",
      "insect",
      "malaria"
    ],
    skins: [
      {
        unified: "1f99f",
        native: "🦟"
      }
    ],
    version: 11
  },
  fly: {
    id: "fly",
    name: "Fly",
    keywords: [
      "insect"
    ],
    skins: [
      {
        unified: "1fab0",
        native: "🪰"
      }
    ],
    version: 13
  },
  worm: {
    id: "worm",
    name: "Worm",
    keywords: [
      "animal"
    ],
    skins: [
      {
        unified: "1fab1",
        native: "🪱"
      }
    ],
    version: 13
  },
  microbe: {
    id: "microbe",
    name: "Microbe",
    keywords: [
      "amoeba",
      "bacteria",
      "germs",
      "virus"
    ],
    skins: [
      {
        unified: "1f9a0",
        native: "🦠"
      }
    ],
    version: 11
  },
  bouquet: {
    id: "bouquet",
    name: "Bouquet",
    keywords: [
      "flowers",
      "nature",
      "spring"
    ],
    skins: [
      {
        unified: "1f490",
        native: "💐"
      }
    ],
    version: 1
  },
  cherry_blossom: {
    id: "cherry_blossom",
    name: "Cherry Blossom",
    keywords: [
      "nature",
      "plant",
      "spring",
      "flower"
    ],
    skins: [
      {
        unified: "1f338",
        native: "🌸"
      }
    ],
    version: 1
  },
  white_flower: {
    id: "white_flower",
    name: "White Flower",
    keywords: [
      "japanese",
      "spring"
    ],
    skins: [
      {
        unified: "1f4ae",
        native: "💮"
      }
    ],
    version: 1
  },
  lotus: {
    id: "lotus",
    name: "Lotus",
    keywords: [
      "flower",
      "calm",
      "meditation"
    ],
    skins: [
      {
        unified: "1fab7",
        native: "🪷"
      }
    ],
    version: 14
  },
  rosette: {
    id: "rosette",
    name: "Rosette",
    keywords: [
      "flower",
      "decoration",
      "military"
    ],
    skins: [
      {
        unified: "1f3f5-fe0f",
        native: "🏵️"
      }
    ],
    version: 1
  },
  rose: {
    id: "rose",
    name: "Rose",
    keywords: [
      "flowers",
      "valentines",
      "love",
      "spring"
    ],
    skins: [
      {
        unified: "1f339",
        native: "🌹"
      }
    ],
    version: 1
  },
  wilted_flower: {
    id: "wilted_flower",
    name: "Wilted Flower",
    keywords: [
      "plant",
      "nature"
    ],
    skins: [
      {
        unified: "1f940",
        native: "🥀"
      }
    ],
    version: 3
  },
  hibiscus: {
    id: "hibiscus",
    name: "Hibiscus",
    keywords: [
      "plant",
      "vegetable",
      "flowers",
      "beach"
    ],
    skins: [
      {
        unified: "1f33a",
        native: "🌺"
      }
    ],
    version: 1
  },
  sunflower: {
    id: "sunflower",
    name: "Sunflower",
    keywords: [
      "nature",
      "plant",
      "fall"
    ],
    skins: [
      {
        unified: "1f33b",
        native: "🌻"
      }
    ],
    version: 1
  },
  blossom: {
    id: "blossom",
    name: "Blossom",
    keywords: [
      "nature",
      "flowers",
      "yellow"
    ],
    skins: [
      {
        unified: "1f33c",
        native: "🌼"
      }
    ],
    version: 1
  },
  tulip: {
    id: "tulip",
    name: "Tulip",
    keywords: [
      "flowers",
      "plant",
      "nature",
      "summer",
      "spring"
    ],
    skins: [
      {
        unified: "1f337",
        native: "🌷"
      }
    ],
    version: 1
  },
  seedling: {
    id: "seedling",
    name: "Seedling",
    keywords: [
      "plant",
      "nature",
      "grass",
      "lawn",
      "spring"
    ],
    skins: [
      {
        unified: "1f331",
        native: "🌱"
      }
    ],
    version: 1
  },
  potted_plant: {
    id: "potted_plant",
    name: "Potted Plant",
    keywords: [
      "greenery",
      "house"
    ],
    skins: [
      {
        unified: "1fab4",
        native: "🪴"
      }
    ],
    version: 13
  },
  evergreen_tree: {
    id: "evergreen_tree",
    name: "Evergreen Tree",
    keywords: [
      "plant",
      "nature"
    ],
    skins: [
      {
        unified: "1f332",
        native: "🌲"
      }
    ],
    version: 1
  },
  deciduous_tree: {
    id: "deciduous_tree",
    name: "Deciduous Tree",
    keywords: [
      "plant",
      "nature"
    ],
    skins: [
      {
        unified: "1f333",
        native: "🌳"
      }
    ],
    version: 1
  },
  palm_tree: {
    id: "palm_tree",
    name: "Palm Tree",
    keywords: [
      "plant",
      "vegetable",
      "nature",
      "summer",
      "beach",
      "mojito",
      "tropical"
    ],
    skins: [
      {
        unified: "1f334",
        native: "🌴"
      }
    ],
    version: 1
  },
  cactus: {
    id: "cactus",
    name: "Cactus",
    keywords: [
      "vegetable",
      "plant",
      "nature"
    ],
    skins: [
      {
        unified: "1f335",
        native: "🌵"
      }
    ],
    version: 1
  },
  ear_of_rice: {
    id: "ear_of_rice",
    name: "Ear of Rice",
    keywords: [
      "sheaf",
      "nature",
      "plant"
    ],
    skins: [
      {
        unified: "1f33e",
        native: "🌾"
      }
    ],
    version: 1
  },
  herb: {
    id: "herb",
    name: "Herb",
    keywords: [
      "vegetable",
      "plant",
      "medicine",
      "weed",
      "grass",
      "lawn"
    ],
    skins: [
      {
        unified: "1f33f",
        native: "🌿"
      }
    ],
    version: 1
  },
  shamrock: {
    id: "shamrock",
    name: "Shamrock",
    keywords: [
      "vegetable",
      "plant",
      "nature",
      "irish",
      "clover"
    ],
    skins: [
      {
        unified: "2618-fe0f",
        native: "☘️"
      }
    ],
    version: 1
  },
  four_leaf_clover: {
    id: "four_leaf_clover",
    name: "Four Leaf Clover",
    keywords: [
      "vegetable",
      "plant",
      "nature",
      "lucky",
      "irish"
    ],
    skins: [
      {
        unified: "1f340",
        native: "🍀"
      }
    ],
    version: 1
  },
  maple_leaf: {
    id: "maple_leaf",
    name: "Maple Leaf",
    keywords: [
      "nature",
      "plant",
      "vegetable",
      "ca",
      "fall"
    ],
    skins: [
      {
        unified: "1f341",
        native: "🍁"
      }
    ],
    version: 1
  },
  fallen_leaf: {
    id: "fallen_leaf",
    name: "Fallen Leaf",
    keywords: [
      "nature",
      "plant",
      "vegetable",
      "leaves"
    ],
    skins: [
      {
        unified: "1f342",
        native: "🍂"
      }
    ],
    version: 1
  },
  leaves: {
    id: "leaves",
    name: "Leaf Fluttering in Wind",
    keywords: [
      "leaves",
      "nature",
      "plant",
      "tree",
      "vegetable",
      "grass",
      "lawn",
      "spring"
    ],
    skins: [
      {
        unified: "1f343",
        native: "🍃"
      }
    ],
    version: 1
  },
  empty_nest: {
    id: "empty_nest",
    name: "Empty Nest",
    keywords: [
      "bird"
    ],
    skins: [
      {
        unified: "1fab9",
        native: "🪹"
      }
    ],
    version: 14
  },
  nest_with_eggs: {
    id: "nest_with_eggs",
    name: "Nest with Eggs",
    keywords: [
      "bird"
    ],
    skins: [
      {
        unified: "1faba",
        native: "🪺"
      }
    ],
    version: 14
  },
  grapes: {
    id: "grapes",
    name: "Grapes",
    keywords: [
      "fruit",
      "food",
      "wine"
    ],
    skins: [
      {
        unified: "1f347",
        native: "🍇"
      }
    ],
    version: 1
  },
  melon: {
    id: "melon",
    name: "Melon",
    keywords: [
      "fruit",
      "nature",
      "food"
    ],
    skins: [
      {
        unified: "1f348",
        native: "🍈"
      }
    ],
    version: 1
  },
  watermelon: {
    id: "watermelon",
    name: "Watermelon",
    keywords: [
      "fruit",
      "food",
      "picnic",
      "summer"
    ],
    skins: [
      {
        unified: "1f349",
        native: "🍉"
      }
    ],
    version: 1
  },
  tangerine: {
    id: "tangerine",
    name: "Tangerine",
    keywords: [
      "food",
      "fruit",
      "nature",
      "orange"
    ],
    skins: [
      {
        unified: "1f34a",
        native: "🍊"
      }
    ],
    version: 1
  },
  lemon: {
    id: "lemon",
    name: "Lemon",
    keywords: [
      "fruit",
      "nature"
    ],
    skins: [
      {
        unified: "1f34b",
        native: "🍋"
      }
    ],
    version: 1
  },
  banana: {
    id: "banana",
    name: "Banana",
    keywords: [
      "fruit",
      "food",
      "monkey"
    ],
    skins: [
      {
        unified: "1f34c",
        native: "🍌"
      }
    ],
    version: 1
  },
  pineapple: {
    id: "pineapple",
    name: "Pineapple",
    keywords: [
      "fruit",
      "nature",
      "food"
    ],
    skins: [
      {
        unified: "1f34d",
        native: "🍍"
      }
    ],
    version: 1
  },
  mango: {
    id: "mango",
    name: "Mango",
    keywords: [
      "fruit",
      "food",
      "tropical"
    ],
    skins: [
      {
        unified: "1f96d",
        native: "🥭"
      }
    ],
    version: 11
  },
  apple: {
    id: "apple",
    name: "Red Apple",
    keywords: [
      "fruit",
      "mac",
      "school"
    ],
    skins: [
      {
        unified: "1f34e",
        native: "🍎"
      }
    ],
    version: 1
  },
  green_apple: {
    id: "green_apple",
    name: "Green Apple",
    keywords: [
      "fruit",
      "nature"
    ],
    skins: [
      {
        unified: "1f34f",
        native: "🍏"
      }
    ],
    version: 1
  },
  pear: {
    id: "pear",
    name: "Pear",
    keywords: [
      "fruit",
      "nature",
      "food"
    ],
    skins: [
      {
        unified: "1f350",
        native: "🍐"
      }
    ],
    version: 1
  },
  peach: {
    id: "peach",
    name: "Peach",
    keywords: [
      "fruit",
      "nature",
      "food"
    ],
    skins: [
      {
        unified: "1f351",
        native: "🍑"
      }
    ],
    version: 1
  },
  cherries: {
    id: "cherries",
    name: "Cherries",
    keywords: [
      "food",
      "fruit"
    ],
    skins: [
      {
        unified: "1f352",
        native: "🍒"
      }
    ],
    version: 1
  },
  strawberry: {
    id: "strawberry",
    name: "Strawberry",
    keywords: [
      "fruit",
      "food",
      "nature"
    ],
    skins: [
      {
        unified: "1f353",
        native: "🍓"
      }
    ],
    version: 1
  },
  blueberries: {
    id: "blueberries",
    name: "Blueberries",
    keywords: [
      "fruit"
    ],
    skins: [
      {
        unified: "1fad0",
        native: "🫐"
      }
    ],
    version: 13
  },
  kiwifruit: {
    id: "kiwifruit",
    name: "Kiwifruit",
    keywords: [
      "kiwi",
      "fruit",
      "food"
    ],
    skins: [
      {
        unified: "1f95d",
        native: "🥝"
      }
    ],
    version: 3
  },
  tomato: {
    id: "tomato",
    name: "Tomato",
    keywords: [
      "fruit",
      "vegetable",
      "nature",
      "food"
    ],
    skins: [
      {
        unified: "1f345",
        native: "🍅"
      }
    ],
    version: 1
  },
  olive: {
    id: "olive",
    name: "Olive",
    keywords: [
      "fruit"
    ],
    skins: [
      {
        unified: "1fad2",
        native: "🫒"
      }
    ],
    version: 13
  },
  coconut: {
    id: "coconut",
    name: "Coconut",
    keywords: [
      "fruit",
      "nature",
      "food",
      "palm"
    ],
    skins: [
      {
        unified: "1f965",
        native: "🥥"
      }
    ],
    version: 5
  },
  avocado: {
    id: "avocado",
    name: "Avocado",
    keywords: [
      "fruit",
      "food"
    ],
    skins: [
      {
        unified: "1f951",
        native: "🥑"
      }
    ],
    version: 3
  },
  eggplant: {
    id: "eggplant",
    name: "Eggplant",
    keywords: [
      "vegetable",
      "nature",
      "food",
      "aubergine"
    ],
    skins: [
      {
        unified: "1f346",
        native: "🍆"
      }
    ],
    version: 1
  },
  potato: {
    id: "potato",
    name: "Potato",
    keywords: [
      "food",
      "tuber",
      "vegatable",
      "starch"
    ],
    skins: [
      {
        unified: "1f954",
        native: "🥔"
      }
    ],
    version: 3
  },
  carrot: {
    id: "carrot",
    name: "Carrot",
    keywords: [
      "vegetable",
      "food",
      "orange"
    ],
    skins: [
      {
        unified: "1f955",
        native: "🥕"
      }
    ],
    version: 3
  },
  corn: {
    id: "corn",
    name: "Ear of Corn",
    keywords: [
      "food",
      "vegetable",
      "plant"
    ],
    skins: [
      {
        unified: "1f33d",
        native: "🌽"
      }
    ],
    version: 1
  },
  hot_pepper: {
    id: "hot_pepper",
    name: "Hot Pepper",
    keywords: [
      "food",
      "spicy",
      "chilli",
      "chili"
    ],
    skins: [
      {
        unified: "1f336-fe0f",
        native: "🌶️"
      }
    ],
    version: 1
  },
  bell_pepper: {
    id: "bell_pepper",
    name: "Bell Pepper",
    keywords: [
      "fruit",
      "plant"
    ],
    skins: [
      {
        unified: "1fad1",
        native: "🫑"
      }
    ],
    version: 13
  },
  cucumber: {
    id: "cucumber",
    name: "Cucumber",
    keywords: [
      "fruit",
      "food",
      "pickle"
    ],
    skins: [
      {
        unified: "1f952",
        native: "🥒"
      }
    ],
    version: 3
  },
  leafy_green: {
    id: "leafy_green",
    name: "Leafy Green",
    keywords: [
      "food",
      "vegetable",
      "plant",
      "bok",
      "choy",
      "cabbage",
      "kale",
      "lettuce"
    ],
    skins: [
      {
        unified: "1f96c",
        native: "🥬"
      }
    ],
    version: 11
  },
  broccoli: {
    id: "broccoli",
    name: "Broccoli",
    keywords: [
      "fruit",
      "food",
      "vegetable"
    ],
    skins: [
      {
        unified: "1f966",
        native: "🥦"
      }
    ],
    version: 5
  },
  garlic: {
    id: "garlic",
    name: "Garlic",
    keywords: [
      "food",
      "spice",
      "cook"
    ],
    skins: [
      {
        unified: "1f9c4",
        native: "🧄"
      }
    ],
    version: 12
  },
  onion: {
    id: "onion",
    name: "Onion",
    keywords: [
      "cook",
      "food",
      "spice"
    ],
    skins: [
      {
        unified: "1f9c5",
        native: "🧅"
      }
    ],
    version: 12
  },
  mushroom: {
    id: "mushroom",
    name: "Mushroom",
    keywords: [
      "plant",
      "vegetable"
    ],
    skins: [
      {
        unified: "1f344",
        native: "🍄"
      }
    ],
    version: 1
  },
  peanuts: {
    id: "peanuts",
    name: "Peanuts",
    keywords: [
      "food",
      "nut"
    ],
    skins: [
      {
        unified: "1f95c",
        native: "🥜"
      }
    ],
    version: 3
  },
  beans: {
    id: "beans",
    name: "Beans",
    keywords: [
      "food"
    ],
    skins: [
      {
        unified: "1fad8",
        native: "🫘"
      }
    ],
    version: 14
  },
  chestnut: {
    id: "chestnut",
    name: "Chestnut",
    keywords: [
      "food",
      "squirrel"
    ],
    skins: [
      {
        unified: "1f330",
        native: "🌰"
      }
    ],
    version: 1
  },
  bread: {
    id: "bread",
    name: "Bread",
    keywords: [
      "food",
      "wheat",
      "breakfast",
      "toast"
    ],
    skins: [
      {
        unified: "1f35e",
        native: "🍞"
      }
    ],
    version: 1
  },
  croissant: {
    id: "croissant",
    name: "Croissant",
    keywords: [
      "food",
      "bread",
      "french"
    ],
    skins: [
      {
        unified: "1f950",
        native: "🥐"
      }
    ],
    version: 3
  },
  baguette_bread: {
    id: "baguette_bread",
    name: "Baguette Bread",
    keywords: [
      "food",
      "french"
    ],
    skins: [
      {
        unified: "1f956",
        native: "🥖"
      }
    ],
    version: 3
  },
  flatbread: {
    id: "flatbread",
    name: "Flatbread",
    keywords: [
      "flour",
      "food"
    ],
    skins: [
      {
        unified: "1fad3",
        native: "🫓"
      }
    ],
    version: 13
  },
  pretzel: {
    id: "pretzel",
    name: "Pretzel",
    keywords: [
      "food",
      "bread",
      "twisted"
    ],
    skins: [
      {
        unified: "1f968",
        native: "🥨"
      }
    ],
    version: 5
  },
  bagel: {
    id: "bagel",
    name: "Bagel",
    keywords: [
      "food",
      "bread",
      "bakery",
      "schmear"
    ],
    skins: [
      {
        unified: "1f96f",
        native: "🥯"
      }
    ],
    version: 11
  },
  pancakes: {
    id: "pancakes",
    name: "Pancakes",
    keywords: [
      "food",
      "breakfast",
      "flapjacks",
      "hotcakes"
    ],
    skins: [
      {
        unified: "1f95e",
        native: "🥞"
      }
    ],
    version: 3
  },
  waffle: {
    id: "waffle",
    name: "Waffle",
    keywords: [
      "food",
      "breakfast"
    ],
    skins: [
      {
        unified: "1f9c7",
        native: "🧇"
      }
    ],
    version: 12
  },
  cheese_wedge: {
    id: "cheese_wedge",
    name: "Cheese Wedge",
    keywords: [
      "food",
      "chadder"
    ],
    skins: [
      {
        unified: "1f9c0",
        native: "🧀"
      }
    ],
    version: 1
  },
  meat_on_bone: {
    id: "meat_on_bone",
    name: "Meat on Bone",
    keywords: [
      "good",
      "food",
      "drumstick"
    ],
    skins: [
      {
        unified: "1f356",
        native: "🍖"
      }
    ],
    version: 1
  },
  poultry_leg: {
    id: "poultry_leg",
    name: "Poultry Leg",
    keywords: [
      "food",
      "meat",
      "drumstick",
      "bird",
      "chicken",
      "turkey"
    ],
    skins: [
      {
        unified: "1f357",
        native: "🍗"
      }
    ],
    version: 1
  },
  cut_of_meat: {
    id: "cut_of_meat",
    name: "Cut of Meat",
    keywords: [
      "food",
      "cow",
      "chop",
      "lambchop",
      "porkchop"
    ],
    skins: [
      {
        unified: "1f969",
        native: "🥩"
      }
    ],
    version: 5
  },
  bacon: {
    id: "bacon",
    name: "Bacon",
    keywords: [
      "food",
      "breakfast",
      "pork",
      "pig",
      "meat"
    ],
    skins: [
      {
        unified: "1f953",
        native: "🥓"
      }
    ],
    version: 3
  },
  hamburger: {
    id: "hamburger",
    name: "Hamburger",
    keywords: [
      "meat",
      "fast",
      "food",
      "beef",
      "cheeseburger",
      "mcdonalds",
      "burger",
      "king"
    ],
    skins: [
      {
        unified: "1f354",
        native: "🍔"
      }
    ],
    version: 1
  },
  fries: {
    id: "fries",
    name: "French Fries",
    keywords: [
      "chips",
      "snack",
      "fast",
      "food"
    ],
    skins: [
      {
        unified: "1f35f",
        native: "🍟"
      }
    ],
    version: 1
  },
  pizza: {
    id: "pizza",
    name: "Pizza",
    keywords: [
      "food",
      "party"
    ],
    skins: [
      {
        unified: "1f355",
        native: "🍕"
      }
    ],
    version: 1
  },
  hotdog: {
    id: "hotdog",
    name: "Hot Dog",
    keywords: [
      "hotdog",
      "food",
      "frankfurter"
    ],
    skins: [
      {
        unified: "1f32d",
        native: "🌭"
      }
    ],
    version: 1
  },
  sandwich: {
    id: "sandwich",
    name: "Sandwich",
    keywords: [
      "food",
      "lunch",
      "bread"
    ],
    skins: [
      {
        unified: "1f96a",
        native: "🥪"
      }
    ],
    version: 5
  },
  taco: {
    id: "taco",
    name: "Taco",
    keywords: [
      "food",
      "mexican"
    ],
    skins: [
      {
        unified: "1f32e",
        native: "🌮"
      }
    ],
    version: 1
  },
  burrito: {
    id: "burrito",
    name: "Burrito",
    keywords: [
      "food",
      "mexican"
    ],
    skins: [
      {
        unified: "1f32f",
        native: "🌯"
      }
    ],
    version: 1
  },
  tamale: {
    id: "tamale",
    name: "Tamale",
    keywords: [
      "food",
      "masa"
    ],
    skins: [
      {
        unified: "1fad4",
        native: "🫔"
      }
    ],
    version: 13
  },
  stuffed_flatbread: {
    id: "stuffed_flatbread",
    name: "Stuffed Flatbread",
    keywords: [
      "food",
      "gyro"
    ],
    skins: [
      {
        unified: "1f959",
        native: "🥙"
      }
    ],
    version: 3
  },
  falafel: {
    id: "falafel",
    name: "Falafel",
    keywords: [
      "food"
    ],
    skins: [
      {
        unified: "1f9c6",
        native: "🧆"
      }
    ],
    version: 12
  },
  egg: {
    id: "egg",
    name: "Egg",
    keywords: [
      "food",
      "chicken",
      "breakfast"
    ],
    skins: [
      {
        unified: "1f95a",
        native: "🥚"
      }
    ],
    version: 3
  },
  fried_egg: {
    id: "fried_egg",
    name: "Cooking",
    keywords: [
      "fried",
      "egg",
      "food",
      "breakfast",
      "kitchen"
    ],
    skins: [
      {
        unified: "1f373",
        native: "🍳"
      }
    ],
    version: 1
  },
  shallow_pan_of_food: {
    id: "shallow_pan_of_food",
    name: "Shallow Pan of Food",
    keywords: [
      "cooking",
      "casserole",
      "paella"
    ],
    skins: [
      {
        unified: "1f958",
        native: "🥘"
      }
    ],
    version: 3
  },
  stew: {
    id: "stew",
    name: "Pot of Food",
    keywords: [
      "stew",
      "meat",
      "soup"
    ],
    skins: [
      {
        unified: "1f372",
        native: "🍲"
      }
    ],
    version: 1
  },
  fondue: {
    id: "fondue",
    name: "Fondue",
    keywords: [
      "cheese",
      "pot",
      "food"
    ],
    skins: [
      {
        unified: "1fad5",
        native: "🫕"
      }
    ],
    version: 13
  },
  bowl_with_spoon: {
    id: "bowl_with_spoon",
    name: "Bowl with Spoon",
    keywords: [
      "food",
      "breakfast",
      "cereal",
      "oatmeal",
      "porridge"
    ],
    skins: [
      {
        unified: "1f963",
        native: "🥣"
      }
    ],
    version: 5
  },
  green_salad: {
    id: "green_salad",
    name: "Green Salad",
    keywords: [
      "food",
      "healthy",
      "lettuce"
    ],
    skins: [
      {
        unified: "1f957",
        native: "🥗"
      }
    ],
    version: 3
  },
  popcorn: {
    id: "popcorn",
    name: "Popcorn",
    keywords: [
      "food",
      "movie",
      "theater",
      "films",
      "snack"
    ],
    skins: [
      {
        unified: "1f37f",
        native: "🍿"
      }
    ],
    version: 1
  },
  butter: {
    id: "butter",
    name: "Butter",
    keywords: [
      "food",
      "cook"
    ],
    skins: [
      {
        unified: "1f9c8",
        native: "🧈"
      }
    ],
    version: 12
  },
  salt: {
    id: "salt",
    name: "Salt",
    keywords: [
      "condiment",
      "shaker"
    ],
    skins: [
      {
        unified: "1f9c2",
        native: "🧂"
      }
    ],
    version: 11
  },
  canned_food: {
    id: "canned_food",
    name: "Canned Food",
    keywords: [
      "soup"
    ],
    skins: [
      {
        unified: "1f96b",
        native: "🥫"
      }
    ],
    version: 5
  },
  bento: {
    id: "bento",
    name: "Bento Box",
    keywords: [
      "food",
      "japanese"
    ],
    skins: [
      {
        unified: "1f371",
        native: "🍱"
      }
    ],
    version: 1
  },
  rice_cracker: {
    id: "rice_cracker",
    name: "Rice Cracker",
    keywords: [
      "food",
      "japanese"
    ],
    skins: [
      {
        unified: "1f358",
        native: "🍘"
      }
    ],
    version: 1
  },
  rice_ball: {
    id: "rice_ball",
    name: "Rice Ball",
    keywords: [
      "food",
      "japanese"
    ],
    skins: [
      {
        unified: "1f359",
        native: "🍙"
      }
    ],
    version: 1
  },
  rice: {
    id: "rice",
    name: "Cooked Rice",
    keywords: [
      "food",
      "china",
      "asian"
    ],
    skins: [
      {
        unified: "1f35a",
        native: "🍚"
      }
    ],
    version: 1
  },
  curry: {
    id: "curry",
    name: "Curry Rice",
    keywords: [
      "food",
      "spicy",
      "hot",
      "indian"
    ],
    skins: [
      {
        unified: "1f35b",
        native: "🍛"
      }
    ],
    version: 1
  },
  ramen: {
    id: "ramen",
    name: "Steaming Bowl",
    keywords: [
      "ramen",
      "food",
      "japanese",
      "noodle",
      "chopsticks"
    ],
    skins: [
      {
        unified: "1f35c",
        native: "🍜"
      }
    ],
    version: 1
  },
  spaghetti: {
    id: "spaghetti",
    name: "Spaghetti",
    keywords: [
      "food",
      "italian",
      "noodle"
    ],
    skins: [
      {
        unified: "1f35d",
        native: "🍝"
      }
    ],
    version: 1
  },
  sweet_potato: {
    id: "sweet_potato",
    name: "Roasted Sweet Potato",
    keywords: [
      "food",
      "nature"
    ],
    skins: [
      {
        unified: "1f360",
        native: "🍠"
      }
    ],
    version: 1
  },
  oden: {
    id: "oden",
    name: "Oden",
    keywords: [
      "food",
      "japanese"
    ],
    skins: [
      {
        unified: "1f362",
        native: "🍢"
      }
    ],
    version: 1
  },
  sushi: {
    id: "sushi",
    name: "Sushi",
    keywords: [
      "food",
      "fish",
      "japanese",
      "rice"
    ],
    skins: [
      {
        unified: "1f363",
        native: "🍣"
      }
    ],
    version: 1
  },
  fried_shrimp: {
    id: "fried_shrimp",
    name: "Fried Shrimp",
    keywords: [
      "food",
      "animal",
      "appetizer",
      "summer"
    ],
    skins: [
      {
        unified: "1f364",
        native: "🍤"
      }
    ],
    version: 1
  },
  fish_cake: {
    id: "fish_cake",
    name: "Fish Cake with Swirl",
    keywords: [
      "food",
      "japan",
      "sea",
      "beach",
      "narutomaki",
      "pink",
      "kamaboko",
      "surimi",
      "ramen"
    ],
    skins: [
      {
        unified: "1f365",
        native: "🍥"
      }
    ],
    version: 1
  },
  moon_cake: {
    id: "moon_cake",
    name: "Moon Cake",
    keywords: [
      "food",
      "autumn"
    ],
    skins: [
      {
        unified: "1f96e",
        native: "🥮"
      }
    ],
    version: 11
  },
  dango: {
    id: "dango",
    name: "Dango",
    keywords: [
      "food",
      "dessert",
      "sweet",
      "japanese",
      "barbecue",
      "meat"
    ],
    skins: [
      {
        unified: "1f361",
        native: "🍡"
      }
    ],
    version: 1
  },
  dumpling: {
    id: "dumpling",
    name: "Dumpling",
    keywords: [
      "food",
      "empanada",
      "pierogi",
      "potsticker"
    ],
    skins: [
      {
        unified: "1f95f",
        native: "🥟"
      }
    ],
    version: 5
  },
  fortune_cookie: {
    id: "fortune_cookie",
    name: "Fortune Cookie",
    keywords: [
      "food",
      "prophecy"
    ],
    skins: [
      {
        unified: "1f960",
        native: "🥠"
      }
    ],
    version: 5
  },
  takeout_box: {
    id: "takeout_box",
    name: "Takeout Box",
    keywords: [
      "food",
      "leftovers"
    ],
    skins: [
      {
        unified: "1f961",
        native: "🥡"
      }
    ],
    version: 5
  },
  crab: {
    id: "crab",
    name: "Crab",
    keywords: [
      "animal",
      "crustacean"
    ],
    skins: [
      {
        unified: "1f980",
        native: "🦀"
      }
    ],
    version: 1
  },
  lobster: {
    id: "lobster",
    name: "Lobster",
    keywords: [
      "animal",
      "nature",
      "bisque",
      "claws",
      "seafood"
    ],
    skins: [
      {
        unified: "1f99e",
        native: "🦞"
      }
    ],
    version: 11
  },
  shrimp: {
    id: "shrimp",
    name: "Shrimp",
    keywords: [
      "animal",
      "ocean",
      "nature",
      "seafood"
    ],
    skins: [
      {
        unified: "1f990",
        native: "🦐"
      }
    ],
    version: 3
  },
  squid: {
    id: "squid",
    name: "Squid",
    keywords: [
      "animal",
      "nature",
      "ocean",
      "sea"
    ],
    skins: [
      {
        unified: "1f991",
        native: "🦑"
      }
    ],
    version: 3
  },
  oyster: {
    id: "oyster",
    name: "Oyster",
    keywords: [
      "food"
    ],
    skins: [
      {
        unified: "1f9aa",
        native: "🦪"
      }
    ],
    version: 12
  },
  icecream: {
    id: "icecream",
    name: "Soft Ice Cream",
    keywords: [
      "icecream",
      "food",
      "hot",
      "dessert",
      "summer"
    ],
    skins: [
      {
        unified: "1f366",
        native: "🍦"
      }
    ],
    version: 1
  },
  shaved_ice: {
    id: "shaved_ice",
    name: "Shaved Ice",
    keywords: [
      "hot",
      "dessert",
      "summer"
    ],
    skins: [
      {
        unified: "1f367",
        native: "🍧"
      }
    ],
    version: 1
  },
  ice_cream: {
    id: "ice_cream",
    name: "Ice Cream",
    keywords: [
      "food",
      "hot",
      "dessert"
    ],
    skins: [
      {
        unified: "1f368",
        native: "🍨"
      }
    ],
    version: 1
  },
  doughnut: {
    id: "doughnut",
    name: "Doughnut",
    keywords: [
      "food",
      "dessert",
      "snack",
      "sweet",
      "donut"
    ],
    skins: [
      {
        unified: "1f369",
        native: "🍩"
      }
    ],
    version: 1
  },
  cookie: {
    id: "cookie",
    name: "Cookie",
    keywords: [
      "food",
      "snack",
      "oreo",
      "chocolate",
      "sweet",
      "dessert"
    ],
    skins: [
      {
        unified: "1f36a",
        native: "🍪"
      }
    ],
    version: 1
  },
  birthday: {
    id: "birthday",
    name: "Birthday Cake",
    keywords: [
      "food",
      "dessert"
    ],
    skins: [
      {
        unified: "1f382",
        native: "🎂"
      }
    ],
    version: 1
  },
  cake: {
    id: "cake",
    name: "Shortcake",
    keywords: [
      "cake",
      "food",
      "dessert"
    ],
    skins: [
      {
        unified: "1f370",
        native: "🍰"
      }
    ],
    version: 1
  },
  cupcake: {
    id: "cupcake",
    name: "Cupcake",
    keywords: [
      "food",
      "dessert",
      "bakery",
      "sweet"
    ],
    skins: [
      {
        unified: "1f9c1",
        native: "🧁"
      }
    ],
    version: 11
  },
  pie: {
    id: "pie",
    name: "Pie",
    keywords: [
      "food",
      "dessert",
      "pastry"
    ],
    skins: [
      {
        unified: "1f967",
        native: "🥧"
      }
    ],
    version: 5
  },
  chocolate_bar: {
    id: "chocolate_bar",
    name: "Chocolate Bar",
    keywords: [
      "food",
      "snack",
      "dessert",
      "sweet"
    ],
    skins: [
      {
        unified: "1f36b",
        native: "🍫"
      }
    ],
    version: 1
  },
  candy: {
    id: "candy",
    name: "Candy",
    keywords: [
      "snack",
      "dessert",
      "sweet",
      "lolly"
    ],
    skins: [
      {
        unified: "1f36c",
        native: "🍬"
      }
    ],
    version: 1
  },
  lollipop: {
    id: "lollipop",
    name: "Lollipop",
    keywords: [
      "food",
      "snack",
      "candy",
      "sweet"
    ],
    skins: [
      {
        unified: "1f36d",
        native: "🍭"
      }
    ],
    version: 1
  },
  custard: {
    id: "custard",
    name: "Custard",
    keywords: [
      "dessert",
      "food"
    ],
    skins: [
      {
        unified: "1f36e",
        native: "🍮"
      }
    ],
    version: 1
  },
  honey_pot: {
    id: "honey_pot",
    name: "Honey Pot",
    keywords: [
      "bees",
      "sweet",
      "kitchen"
    ],
    skins: [
      {
        unified: "1f36f",
        native: "🍯"
      }
    ],
    version: 1
  },
  baby_bottle: {
    id: "baby_bottle",
    name: "Baby Bottle",
    keywords: [
      "food",
      "container",
      "milk"
    ],
    skins: [
      {
        unified: "1f37c",
        native: "🍼"
      }
    ],
    version: 1
  },
  glass_of_milk: {
    id: "glass_of_milk",
    name: "Glass of Milk",
    keywords: [
      "beverage",
      "drink",
      "cow"
    ],
    skins: [
      {
        unified: "1f95b",
        native: "🥛"
      }
    ],
    version: 3
  },
  coffee: {
    id: "coffee",
    name: "Hot Beverage",
    keywords: [
      "coffee",
      "caffeine",
      "latte",
      "espresso"
    ],
    skins: [
      {
        unified: "2615",
        native: "☕"
      }
    ],
    version: 1
  },
  teapot: {
    id: "teapot",
    name: "Teapot",
    keywords: [
      "drink",
      "hot"
    ],
    skins: [
      {
        unified: "1fad6",
        native: "🫖"
      }
    ],
    version: 13
  },
  tea: {
    id: "tea",
    name: "Teacup Without Handle",
    keywords: [
      "tea",
      "drink",
      "bowl",
      "breakfast",
      "green",
      "british"
    ],
    skins: [
      {
        unified: "1f375",
        native: "🍵"
      }
    ],
    version: 1
  },
  sake: {
    id: "sake",
    name: "Sake",
    keywords: [
      "wine",
      "drink",
      "drunk",
      "beverage",
      "japanese",
      "alcohol",
      "booze"
    ],
    skins: [
      {
        unified: "1f376",
        native: "🍶"
      }
    ],
    version: 1
  },
  champagne: {
    id: "champagne",
    name: "Bottle with Popping Cork",
    keywords: [
      "champagne",
      "drink",
      "wine",
      "celebration"
    ],
    skins: [
      {
        unified: "1f37e",
        native: "🍾"
      }
    ],
    version: 1
  },
  wine_glass: {
    id: "wine_glass",
    name: "Wine Glass",
    keywords: [
      "drink",
      "beverage",
      "drunk",
      "alcohol",
      "booze"
    ],
    skins: [
      {
        unified: "1f377",
        native: "🍷"
      }
    ],
    version: 1
  },
  cocktail: {
    id: "cocktail",
    name: "Cocktail Glass",
    keywords: [
      "drink",
      "drunk",
      "alcohol",
      "beverage",
      "booze",
      "mojito"
    ],
    skins: [
      {
        unified: "1f378",
        native: "🍸"
      }
    ],
    version: 1
  },
  tropical_drink: {
    id: "tropical_drink",
    name: "Tropical Drink",
    keywords: [
      "beverage",
      "cocktail",
      "summer",
      "beach",
      "alcohol",
      "booze",
      "mojito"
    ],
    skins: [
      {
        unified: "1f379",
        native: "🍹"
      }
    ],
    version: 1
  },
  beer: {
    id: "beer",
    name: "Beer Mug",
    keywords: [
      "relax",
      "beverage",
      "drink",
      "drunk",
      "party",
      "pub",
      "summer",
      "alcohol",
      "booze"
    ],
    skins: [
      {
        unified: "1f37a",
        native: "🍺"
      }
    ],
    version: 1
  },
  beers: {
    id: "beers",
    name: "Clinking Beer Mugs",
    keywords: [
      "beers",
      "relax",
      "beverage",
      "drink",
      "drunk",
      "party",
      "pub",
      "summer",
      "alcohol",
      "booze"
    ],
    skins: [
      {
        unified: "1f37b",
        native: "🍻"
      }
    ],
    version: 1
  },
  clinking_glasses: {
    id: "clinking_glasses",
    name: "Clinking Glasses",
    keywords: [
      "beverage",
      "drink",
      "party",
      "alcohol",
      "celebrate",
      "cheers",
      "wine",
      "champagne",
      "toast"
    ],
    skins: [
      {
        unified: "1f942",
        native: "🥂"
      }
    ],
    version: 3
  },
  tumbler_glass: {
    id: "tumbler_glass",
    name: "Tumbler Glass",
    keywords: [
      "drink",
      "beverage",
      "drunk",
      "alcohol",
      "liquor",
      "booze",
      "bourbon",
      "scotch",
      "whisky",
      "shot"
    ],
    skins: [
      {
        unified: "1f943",
        native: "🥃"
      }
    ],
    version: 3
  },
  pouring_liquid: {
    id: "pouring_liquid",
    name: "Pouring Liquid",
    keywords: [
      "cup",
      "water"
    ],
    skins: [
      {
        unified: "1fad7",
        native: "🫗"
      }
    ],
    version: 14
  },
  cup_with_straw: {
    id: "cup_with_straw",
    name: "Cup with Straw",
    keywords: [
      "drink",
      "soda"
    ],
    skins: [
      {
        unified: "1f964",
        native: "🥤"
      }
    ],
    version: 5
  },
  bubble_tea: {
    id: "bubble_tea",
    name: "Bubble Tea",
    keywords: [
      "taiwan",
      "boba",
      "milk",
      "straw"
    ],
    skins: [
      {
        unified: "1f9cb",
        native: "🧋"
      }
    ],
    version: 13
  },
  beverage_box: {
    id: "beverage_box",
    name: "Beverage Box",
    keywords: [
      "drink"
    ],
    skins: [
      {
        unified: "1f9c3",
        native: "🧃"
      }
    ],
    version: 12
  },
  mate_drink: {
    id: "mate_drink",
    name: "Mate",
    keywords: [
      "drink",
      "tea",
      "beverage"
    ],
    skins: [
      {
        unified: "1f9c9",
        native: "🧉"
      }
    ],
    version: 12
  },
  ice_cube: {
    id: "ice_cube",
    name: "Ice",
    keywords: [
      "cube",
      "water",
      "cold"
    ],
    skins: [
      {
        unified: "1f9ca",
        native: "🧊"
      }
    ],
    version: 12
  },
  chopsticks: {
    id: "chopsticks",
    name: "Chopsticks",
    keywords: [
      "food"
    ],
    skins: [
      {
        unified: "1f962",
        native: "🥢"
      }
    ],
    version: 5
  },
  knife_fork_plate: {
    id: "knife_fork_plate",
    name: "Fork and Knife with Plate",
    keywords: [
      "food",
      "eat",
      "meal",
      "lunch",
      "dinner",
      "restaurant"
    ],
    skins: [
      {
        unified: "1f37d-fe0f",
        native: "🍽️"
      }
    ],
    version: 1
  },
  fork_and_knife: {
    id: "fork_and_knife",
    name: "Fork and Knife",
    keywords: [
      "cutlery",
      "kitchen"
    ],
    skins: [
      {
        unified: "1f374",
        native: "🍴"
      }
    ],
    version: 1
  },
  spoon: {
    id: "spoon",
    name: "Spoon",
    keywords: [
      "cutlery",
      "kitchen",
      "tableware"
    ],
    skins: [
      {
        unified: "1f944",
        native: "🥄"
      }
    ],
    version: 3
  },
  hocho: {
    id: "hocho",
    name: "Hocho",
    keywords: [
      "knife",
      "kitchen",
      "blade",
      "cutlery",
      "weapon"
    ],
    skins: [
      {
        unified: "1f52a",
        native: "🔪"
      }
    ],
    version: 1
  },
  jar: {
    id: "jar",
    name: "Jar",
    keywords: [
      "container",
      "sauce"
    ],
    skins: [
      {
        unified: "1fad9",
        native: "🫙"
      }
    ],
    version: 14
  },
  amphora: {
    id: "amphora",
    name: "Amphora",
    keywords: [
      "vase",
      "jar"
    ],
    skins: [
      {
        unified: "1f3fa",
        native: "🏺"
      }
    ],
    version: 1
  },
  earth_africa: {
    id: "earth_africa",
    name: "Earth Globe Europe-Africa",
    keywords: [
      "africa",
      "showing",
      "europe",
      "world",
      "international"
    ],
    skins: [
      {
        unified: "1f30d",
        native: "🌍"
      }
    ],
    version: 1
  },
  earth_americas: {
    id: "earth_americas",
    name: "Earth Globe Americas",
    keywords: [
      "showing",
      "world",
      "USA",
      "international"
    ],
    skins: [
      {
        unified: "1f30e",
        native: "🌎"
      }
    ],
    version: 1
  },
  earth_asia: {
    id: "earth_asia",
    name: "Earth Globe Asia-Australia",
    keywords: [
      "asia",
      "showing",
      "australia",
      "world",
      "east",
      "international"
    ],
    skins: [
      {
        unified: "1f30f",
        native: "🌏"
      }
    ],
    version: 1
  },
  globe_with_meridians: {
    id: "globe_with_meridians",
    name: "Globe with Meridians",
    keywords: [
      "earth",
      "international",
      "world",
      "internet",
      "interweb",
      "i18n"
    ],
    skins: [
      {
        unified: "1f310",
        native: "🌐"
      }
    ],
    version: 1
  },
  world_map: {
    id: "world_map",
    name: "World Map",
    keywords: [
      "location",
      "direction"
    ],
    skins: [
      {
        unified: "1f5fa-fe0f",
        native: "🗺️"
      }
    ],
    version: 1
  },
  japan: {
    id: "japan",
    name: "Map of Japan",
    keywords: [
      "nation",
      "country",
      "japanese",
      "asia"
    ],
    skins: [
      {
        unified: "1f5fe",
        native: "🗾"
      }
    ],
    version: 1
  },
  compass: {
    id: "compass",
    name: "Compass",
    keywords: [
      "magnetic",
      "navigation",
      "orienteering"
    ],
    skins: [
      {
        unified: "1f9ed",
        native: "🧭"
      }
    ],
    version: 11
  },
  snow_capped_mountain: {
    id: "snow_capped_mountain",
    name: "Snow-Capped Mountain",
    keywords: [
      "snow",
      "capped",
      "photo",
      "nature",
      "environment",
      "winter",
      "cold"
    ],
    skins: [
      {
        unified: "1f3d4-fe0f",
        native: "🏔️"
      }
    ],
    version: 1
  },
  mountain: {
    id: "mountain",
    name: "Mountain",
    keywords: [
      "photo",
      "nature",
      "environment"
    ],
    skins: [
      {
        unified: "26f0-fe0f",
        native: "⛰️"
      }
    ],
    version: 1
  },
  volcano: {
    id: "volcano",
    name: "Volcano",
    keywords: [
      "photo",
      "nature",
      "disaster"
    ],
    skins: [
      {
        unified: "1f30b",
        native: "🌋"
      }
    ],
    version: 1
  },
  mount_fuji: {
    id: "mount_fuji",
    name: "Mount Fuji",
    keywords: [
      "photo",
      "mountain",
      "nature",
      "japanese"
    ],
    skins: [
      {
        unified: "1f5fb",
        native: "🗻"
      }
    ],
    version: 1
  },
  camping: {
    id: "camping",
    name: "Camping",
    keywords: [
      "photo",
      "outdoors",
      "tent"
    ],
    skins: [
      {
        unified: "1f3d5-fe0f",
        native: "🏕️"
      }
    ],
    version: 1
  },
  beach_with_umbrella: {
    id: "beach_with_umbrella",
    name: "Beach with Umbrella",
    keywords: [
      "weather",
      "summer",
      "sunny",
      "sand",
      "mojito"
    ],
    skins: [
      {
        unified: "1f3d6-fe0f",
        native: "🏖️"
      }
    ],
    version: 1
  },
  desert: {
    id: "desert",
    name: "Desert",
    keywords: [
      "photo",
      "warm",
      "saharah"
    ],
    skins: [
      {
        unified: "1f3dc-fe0f",
        native: "🏜️"
      }
    ],
    version: 1
  },
  desert_island: {
    id: "desert_island",
    name: "Desert Island",
    keywords: [
      "photo",
      "tropical",
      "mojito"
    ],
    skins: [
      {
        unified: "1f3dd-fe0f",
        native: "🏝️"
      }
    ],
    version: 1
  },
  national_park: {
    id: "national_park",
    name: "National Park",
    keywords: [
      "photo",
      "environment",
      "nature"
    ],
    skins: [
      {
        unified: "1f3de-fe0f",
        native: "🏞️"
      }
    ],
    version: 1
  },
  stadium: {
    id: "stadium",
    name: "Stadium",
    keywords: [
      "photo",
      "place",
      "sports",
      "concert",
      "venue"
    ],
    skins: [
      {
        unified: "1f3df-fe0f",
        native: "🏟️"
      }
    ],
    version: 1
  },
  classical_building: {
    id: "classical_building",
    name: "Classical Building",
    keywords: [
      "art",
      "culture",
      "history"
    ],
    skins: [
      {
        unified: "1f3db-fe0f",
        native: "🏛️"
      }
    ],
    version: 1
  },
  building_construction: {
    id: "building_construction",
    name: "Building Construction",
    keywords: [
      "wip",
      "working",
      "progress"
    ],
    skins: [
      {
        unified: "1f3d7-fe0f",
        native: "🏗️"
      }
    ],
    version: 1
  },
  bricks: {
    id: "bricks",
    name: "Brick",
    keywords: [
      "bricks"
    ],
    skins: [
      {
        unified: "1f9f1",
        native: "🧱"
      }
    ],
    version: 11
  },
  rock: {
    id: "rock",
    name: "Rock",
    keywords: [
      "stone"
    ],
    skins: [
      {
        unified: "1faa8",
        native: "🪨"
      }
    ],
    version: 13
  },
  wood: {
    id: "wood",
    name: "Wood",
    keywords: [
      "nature",
      "timber",
      "trunk"
    ],
    skins: [
      {
        unified: "1fab5",
        native: "🪵"
      }
    ],
    version: 13
  },
  hut: {
    id: "hut",
    name: "Hut",
    keywords: [
      "house",
      "structure"
    ],
    skins: [
      {
        unified: "1f6d6",
        native: "🛖"
      }
    ],
    version: 13
  },
  house_buildings: {
    id: "house_buildings",
    name: "Houses",
    keywords: [
      "house",
      "buildings",
      "photo"
    ],
    skins: [
      {
        unified: "1f3d8-fe0f",
        native: "🏘️"
      }
    ],
    version: 1
  },
  derelict_house_building: {
    id: "derelict_house_building",
    name: "Derelict House",
    keywords: [
      "building",
      "abandon",
      "evict",
      "broken"
    ],
    skins: [
      {
        unified: "1f3da-fe0f",
        native: "🏚️"
      }
    ],
    version: 1
  },
  house: {
    id: "house",
    name: "House",
    keywords: [
      "building",
      "home"
    ],
    skins: [
      {
        unified: "1f3e0",
        native: "🏠"
      }
    ],
    version: 1
  },
  house_with_garden: {
    id: "house_with_garden",
    name: "House with Garden",
    keywords: [
      "home",
      "plant",
      "nature"
    ],
    skins: [
      {
        unified: "1f3e1",
        native: "🏡"
      }
    ],
    version: 1
  },
  office: {
    id: "office",
    name: "Office Building",
    keywords: [
      "bureau",
      "work"
    ],
    skins: [
      {
        unified: "1f3e2",
        native: "🏢"
      }
    ],
    version: 1
  },
  post_office: {
    id: "post_office",
    name: "Japanese Post Office",
    keywords: [
      "building",
      "envelope",
      "communication"
    ],
    skins: [
      {
        unified: "1f3e3",
        native: "🏣"
      }
    ],
    version: 1
  },
  european_post_office: {
    id: "european_post_office",
    name: "Post Office",
    keywords: [
      "european",
      "building",
      "email"
    ],
    skins: [
      {
        unified: "1f3e4",
        native: "🏤"
      }
    ],
    version: 1
  },
  hospital: {
    id: "hospital",
    name: "Hospital",
    keywords: [
      "building",
      "health",
      "surgery",
      "doctor"
    ],
    skins: [
      {
        unified: "1f3e5",
        native: "🏥"
      }
    ],
    version: 1
  },
  bank: {
    id: "bank",
    name: "Bank",
    keywords: [
      "building",
      "money",
      "sales",
      "cash",
      "business",
      "enterprise"
    ],
    skins: [
      {
        unified: "1f3e6",
        native: "🏦"
      }
    ],
    version: 1
  },
  hotel: {
    id: "hotel",
    name: "Hotel",
    keywords: [
      "building",
      "accomodation",
      "checkin"
    ],
    skins: [
      {
        unified: "1f3e8",
        native: "🏨"
      }
    ],
    version: 1
  },
  love_hotel: {
    id: "love_hotel",
    name: "Love Hotel",
    keywords: [
      "like",
      "affection",
      "dating"
    ],
    skins: [
      {
        unified: "1f3e9",
        native: "🏩"
      }
    ],
    version: 1
  },
  convenience_store: {
    id: "convenience_store",
    name: "Convenience Store",
    keywords: [
      "building",
      "shopping",
      "groceries"
    ],
    skins: [
      {
        unified: "1f3ea",
        native: "🏪"
      }
    ],
    version: 1
  },
  school: {
    id: "school",
    name: "School",
    keywords: [
      "building",
      "student",
      "education",
      "learn",
      "teach"
    ],
    skins: [
      {
        unified: "1f3eb",
        native: "🏫"
      }
    ],
    version: 1
  },
  department_store: {
    id: "department_store",
    name: "Department Store",
    keywords: [
      "building",
      "shopping",
      "mall"
    ],
    skins: [
      {
        unified: "1f3ec",
        native: "🏬"
      }
    ],
    version: 1
  },
  factory: {
    id: "factory",
    name: "Factory",
    keywords: [
      "building",
      "industry",
      "pollution",
      "smoke"
    ],
    skins: [
      {
        unified: "1f3ed",
        native: "🏭"
      }
    ],
    version: 1
  },
  japanese_castle: {
    id: "japanese_castle",
    name: "Japanese Castle",
    keywords: [
      "photo",
      "building"
    ],
    skins: [
      {
        unified: "1f3ef",
        native: "🏯"
      }
    ],
    version: 1
  },
  european_castle: {
    id: "european_castle",
    name: "Castle",
    keywords: [
      "european",
      "building",
      "royalty",
      "history"
    ],
    skins: [
      {
        unified: "1f3f0",
        native: "🏰"
      }
    ],
    version: 1
  },
  wedding: {
    id: "wedding",
    name: "Wedding",
    keywords: [
      "love",
      "like",
      "affection",
      "couple",
      "marriage",
      "bride",
      "groom"
    ],
    skins: [
      {
        unified: "1f492",
        native: "💒"
      }
    ],
    version: 1
  },
  tokyo_tower: {
    id: "tokyo_tower",
    name: "Tokyo Tower",
    keywords: [
      "photo",
      "japanese"
    ],
    skins: [
      {
        unified: "1f5fc",
        native: "🗼"
      }
    ],
    version: 1
  },
  statue_of_liberty: {
    id: "statue_of_liberty",
    name: "Statue of Liberty",
    keywords: [
      "american",
      "newyork"
    ],
    skins: [
      {
        unified: "1f5fd",
        native: "🗽"
      }
    ],
    version: 1
  },
  church: {
    id: "church",
    name: "Church",
    keywords: [
      "building",
      "religion",
      "christ"
    ],
    skins: [
      {
        unified: "26ea",
        native: "⛪"
      }
    ],
    version: 1
  },
  mosque: {
    id: "mosque",
    name: "Mosque",
    keywords: [
      "islam",
      "worship",
      "minaret"
    ],
    skins: [
      {
        unified: "1f54c",
        native: "🕌"
      }
    ],
    version: 1
  },
  hindu_temple: {
    id: "hindu_temple",
    name: "Hindu Temple",
    keywords: [
      "religion"
    ],
    skins: [
      {
        unified: "1f6d5",
        native: "🛕"
      }
    ],
    version: 12
  },
  synagogue: {
    id: "synagogue",
    name: "Synagogue",
    keywords: [
      "judaism",
      "worship",
      "temple",
      "jewish"
    ],
    skins: [
      {
        unified: "1f54d",
        native: "🕍"
      }
    ],
    version: 1
  },
  shinto_shrine: {
    id: "shinto_shrine",
    name: "Shinto Shrine",
    keywords: [
      "temple",
      "japan",
      "kyoto"
    ],
    skins: [
      {
        unified: "26e9-fe0f",
        native: "⛩️"
      }
    ],
    version: 1
  },
  kaaba: {
    id: "kaaba",
    name: "Kaaba",
    keywords: [
      "mecca",
      "mosque",
      "islam"
    ],
    skins: [
      {
        unified: "1f54b",
        native: "🕋"
      }
    ],
    version: 1
  },
  fountain: {
    id: "fountain",
    name: "Fountain",
    keywords: [
      "photo",
      "summer",
      "water",
      "fresh"
    ],
    skins: [
      {
        unified: "26f2",
        native: "⛲"
      }
    ],
    version: 1
  },
  tent: {
    id: "tent",
    name: "Tent",
    keywords: [
      "photo",
      "camping",
      "outdoors"
    ],
    skins: [
      {
        unified: "26fa",
        native: "⛺"
      }
    ],
    version: 1
  },
  foggy: {
    id: "foggy",
    name: "Foggy",
    keywords: [
      "photo",
      "mountain"
    ],
    skins: [
      {
        unified: "1f301",
        native: "🌁"
      }
    ],
    version: 1
  },
  night_with_stars: {
    id: "night_with_stars",
    name: "Night with Stars",
    keywords: [
      "evening",
      "city",
      "downtown"
    ],
    skins: [
      {
        unified: "1f303",
        native: "🌃"
      }
    ],
    version: 1
  },
  cityscape: {
    id: "cityscape",
    name: "Cityscape",
    keywords: [
      "photo",
      "night",
      "life",
      "urban"
    ],
    skins: [
      {
        unified: "1f3d9-fe0f",
        native: "🏙️"
      }
    ],
    version: 1
  },
  sunrise_over_mountains: {
    id: "sunrise_over_mountains",
    name: "Sunrise over Mountains",
    keywords: [
      "view",
      "vacation",
      "photo"
    ],
    skins: [
      {
        unified: "1f304",
        native: "🌄"
      }
    ],
    version: 1
  },
  sunrise: {
    id: "sunrise",
    name: "Sunrise",
    keywords: [
      "morning",
      "view",
      "vacation",
      "photo"
    ],
    skins: [
      {
        unified: "1f305",
        native: "🌅"
      }
    ],
    version: 1
  },
  city_sunset: {
    id: "city_sunset",
    name: "Cityscape at Dusk",
    keywords: [
      "city",
      "sunset",
      "photo",
      "evening",
      "sky",
      "buildings"
    ],
    skins: [
      {
        unified: "1f306",
        native: "🌆"
      }
    ],
    version: 1
  },
  city_sunrise: {
    id: "city_sunrise",
    name: "Sunset",
    keywords: [
      "city",
      "sunrise",
      "photo",
      "good",
      "morning",
      "dawn"
    ],
    skins: [
      {
        unified: "1f307",
        native: "🌇"
      }
    ],
    version: 1
  },
  bridge_at_night: {
    id: "bridge_at_night",
    name: "Bridge at Night",
    keywords: [
      "photo",
      "sanfrancisco"
    ],
    skins: [
      {
        unified: "1f309",
        native: "🌉"
      }
    ],
    version: 1
  },
  hotsprings: {
    id: "hotsprings",
    name: "Hot Springs",
    keywords: [
      "hotsprings",
      "bath",
      "warm",
      "relax"
    ],
    skins: [
      {
        unified: "2668-fe0f",
        native: "♨️"
      }
    ],
    version: 1
  },
  carousel_horse: {
    id: "carousel_horse",
    name: "Carousel Horse",
    keywords: [
      "photo",
      "carnival"
    ],
    skins: [
      {
        unified: "1f3a0",
        native: "🎠"
      }
    ],
    version: 1
  },
  playground_slide: {
    id: "playground_slide",
    name: "Playground Slide",
    keywords: [
      "fun",
      "park"
    ],
    skins: [
      {
        unified: "1f6dd",
        native: "🛝"
      }
    ],
    version: 14
  },
  ferris_wheel: {
    id: "ferris_wheel",
    name: "Ferris Wheel",
    keywords: [
      "photo",
      "carnival",
      "londoneye"
    ],
    skins: [
      {
        unified: "1f3a1",
        native: "🎡"
      }
    ],
    version: 1
  },
  roller_coaster: {
    id: "roller_coaster",
    name: "Roller Coaster",
    keywords: [
      "carnival",
      "playground",
      "photo",
      "fun"
    ],
    skins: [
      {
        unified: "1f3a2",
        native: "🎢"
      }
    ],
    version: 1
  },
  barber: {
    id: "barber",
    name: "Barber Pole",
    keywords: [
      "hair",
      "salon",
      "style"
    ],
    skins: [
      {
        unified: "1f488",
        native: "💈"
      }
    ],
    version: 1
  },
  circus_tent: {
    id: "circus_tent",
    name: "Circus Tent",
    keywords: [
      "festival",
      "carnival",
      "party"
    ],
    skins: [
      {
        unified: "1f3aa",
        native: "🎪"
      }
    ],
    version: 1
  },
  steam_locomotive: {
    id: "steam_locomotive",
    name: "Locomotive",
    keywords: [
      "steam",
      "transportation",
      "vehicle",
      "train"
    ],
    skins: [
      {
        unified: "1f682",
        native: "🚂"
      }
    ],
    version: 1
  },
  railway_car: {
    id: "railway_car",
    name: "Railway Car",
    keywords: [
      "transportation",
      "vehicle"
    ],
    skins: [
      {
        unified: "1f683",
        native: "🚃"
      }
    ],
    version: 1
  },
  bullettrain_side: {
    id: "bullettrain_side",
    name: "High-Speed Train",
    keywords: [
      "bullettrain",
      "side",
      "high",
      "speed",
      "transportation",
      "vehicle"
    ],
    skins: [
      {
        unified: "1f684",
        native: "🚄"
      }
    ],
    version: 1
  },
  bullettrain_front: {
    id: "bullettrain_front",
    name: "Bullet Train",
    keywords: [
      "bullettrain",
      "front",
      "transportation",
      "vehicle",
      "speed",
      "fast",
      "public",
      "travel"
    ],
    skins: [
      {
        unified: "1f685",
        native: "🚅"
      }
    ],
    version: 1
  },
  train2: {
    id: "train2",
    name: "Train",
    keywords: [
      "train2",
      "transportation",
      "vehicle"
    ],
    skins: [
      {
        unified: "1f686",
        native: "🚆"
      }
    ],
    version: 1
  },
  metro: {
    id: "metro",
    name: "Metro",
    keywords: [
      "transportation",
      "blue",
      "square",
      "mrt",
      "underground",
      "tube"
    ],
    skins: [
      {
        unified: "1f687",
        native: "🚇"
      }
    ],
    version: 1
  },
  light_rail: {
    id: "light_rail",
    name: "Light Rail",
    keywords: [
      "transportation",
      "vehicle"
    ],
    skins: [
      {
        unified: "1f688",
        native: "🚈"
      }
    ],
    version: 1
  },
  station: {
    id: "station",
    name: "Station",
    keywords: [
      "transportation",
      "vehicle",
      "public"
    ],
    skins: [
      {
        unified: "1f689",
        native: "🚉"
      }
    ],
    version: 1
  },
  tram: {
    id: "tram",
    name: "Tram",
    keywords: [
      "transportation",
      "vehicle"
    ],
    skins: [
      {
        unified: "1f68a",
        native: "🚊"
      }
    ],
    version: 1
  },
  monorail: {
    id: "monorail",
    name: "Monorail",
    keywords: [
      "transportation",
      "vehicle"
    ],
    skins: [
      {
        unified: "1f69d",
        native: "🚝"
      }
    ],
    version: 1
  },
  mountain_railway: {
    id: "mountain_railway",
    name: "Mountain Railway",
    keywords: [
      "transportation",
      "vehicle"
    ],
    skins: [
      {
        unified: "1f69e",
        native: "🚞"
      }
    ],
    version: 1
  },
  train: {
    id: "train",
    name: "Tram Car",
    keywords: [
      "train",
      "transportation",
      "vehicle",
      "carriage",
      "public",
      "travel"
    ],
    skins: [
      {
        unified: "1f68b",
        native: "🚋"
      }
    ],
    version: 1
  },
  bus: {
    id: "bus",
    name: "Bus",
    keywords: [
      "car",
      "vehicle",
      "transportation"
    ],
    skins: [
      {
        unified: "1f68c",
        native: "🚌"
      }
    ],
    version: 1
  },
  oncoming_bus: {
    id: "oncoming_bus",
    name: "Oncoming Bus",
    keywords: [
      "vehicle",
      "transportation"
    ],
    skins: [
      {
        unified: "1f68d",
        native: "🚍"
      }
    ],
    version: 1
  },
  trolleybus: {
    id: "trolleybus",
    name: "Trolleybus",
    keywords: [
      "bart",
      "transportation",
      "vehicle"
    ],
    skins: [
      {
        unified: "1f68e",
        native: "🚎"
      }
    ],
    version: 1
  },
  minibus: {
    id: "minibus",
    name: "Minibus",
    keywords: [
      "vehicle",
      "car",
      "transportation"
    ],
    skins: [
      {
        unified: "1f690",
        native: "🚐"
      }
    ],
    version: 1
  },
  ambulance: {
    id: "ambulance",
    name: "Ambulance",
    keywords: [
      "health",
      "911",
      "hospital"
    ],
    skins: [
      {
        unified: "1f691",
        native: "🚑"
      }
    ],
    version: 1
  },
  fire_engine: {
    id: "fire_engine",
    name: "Fire Engine",
    keywords: [
      "transportation",
      "cars",
      "vehicle"
    ],
    skins: [
      {
        unified: "1f692",
        native: "🚒"
      }
    ],
    version: 1
  },
  police_car: {
    id: "police_car",
    name: "Police Car",
    keywords: [
      "vehicle",
      "cars",
      "transportation",
      "law",
      "legal",
      "enforcement"
    ],
    skins: [
      {
        unified: "1f693",
        native: "🚓"
      }
    ],
    version: 1
  },
  oncoming_police_car: {
    id: "oncoming_police_car",
    name: "Oncoming Police Car",
    keywords: [
      "vehicle",
      "law",
      "legal",
      "enforcement",
      "911"
    ],
    skins: [
      {
        unified: "1f694",
        native: "🚔"
      }
    ],
    version: 1
  },
  taxi: {
    id: "taxi",
    name: "Taxi",
    keywords: [
      "uber",
      "vehicle",
      "cars",
      "transportation"
    ],
    skins: [
      {
        unified: "1f695",
        native: "🚕"
      }
    ],
    version: 1
  },
  oncoming_taxi: {
    id: "oncoming_taxi",
    name: "Oncoming Taxi",
    keywords: [
      "vehicle",
      "cars",
      "uber"
    ],
    skins: [
      {
        unified: "1f696",
        native: "🚖"
      }
    ],
    version: 1
  },
  car: {
    id: "car",
    name: "Automobile",
    keywords: [
      "car",
      "red",
      "transportation",
      "vehicle"
    ],
    skins: [
      {
        unified: "1f697",
        native: "🚗"
      }
    ],
    version: 1
  },
  oncoming_automobile: {
    id: "oncoming_automobile",
    name: "Oncoming Automobile",
    keywords: [
      "car",
      "vehicle",
      "transportation"
    ],
    skins: [
      {
        unified: "1f698",
        native: "🚘"
      }
    ],
    version: 1
  },
  blue_car: {
    id: "blue_car",
    name: "Recreational Vehicle",
    keywords: [
      "blue",
      "car",
      "sport",
      "utility",
      "transportation"
    ],
    skins: [
      {
        unified: "1f699",
        native: "🚙"
      }
    ],
    version: 1
  },
  pickup_truck: {
    id: "pickup_truck",
    name: "Pickup Truck",
    keywords: [
      "car",
      "transportation"
    ],
    skins: [
      {
        unified: "1f6fb",
        native: "🛻"
      }
    ],
    version: 13
  },
  truck: {
    id: "truck",
    name: "Delivery Truck",
    keywords: [
      "cars",
      "transportation"
    ],
    skins: [
      {
        unified: "1f69a",
        native: "🚚"
      }
    ],
    version: 1
  },
  articulated_lorry: {
    id: "articulated_lorry",
    name: "Articulated Lorry",
    keywords: [
      "vehicle",
      "cars",
      "transportation",
      "express"
    ],
    skins: [
      {
        unified: "1f69b",
        native: "🚛"
      }
    ],
    version: 1
  },
  tractor: {
    id: "tractor",
    name: "Tractor",
    keywords: [
      "vehicle",
      "car",
      "farming",
      "agriculture"
    ],
    skins: [
      {
        unified: "1f69c",
        native: "🚜"
      }
    ],
    version: 1
  },
  racing_car: {
    id: "racing_car",
    name: "Racing Car",
    keywords: [
      "sports",
      "race",
      "fast",
      "formula",
      "f1"
    ],
    skins: [
      {
        unified: "1f3ce-fe0f",
        native: "🏎️"
      }
    ],
    version: 1
  },
  racing_motorcycle: {
    id: "racing_motorcycle",
    name: "Motorcycle",
    keywords: [
      "racing",
      "race",
      "sports",
      "fast"
    ],
    skins: [
      {
        unified: "1f3cd-fe0f",
        native: "🏍️"
      }
    ],
    version: 1
  },
  motor_scooter: {
    id: "motor_scooter",
    name: "Motor Scooter",
    keywords: [
      "vehicle",
      "vespa",
      "sasha"
    ],
    skins: [
      {
        unified: "1f6f5",
        native: "🛵"
      }
    ],
    version: 3
  },
  manual_wheelchair: {
    id: "manual_wheelchair",
    name: "Manual Wheelchair",
    keywords: [
      "accessibility"
    ],
    skins: [
      {
        unified: "1f9bd",
        native: "🦽"
      }
    ],
    version: 12
  },
  motorized_wheelchair: {
    id: "motorized_wheelchair",
    name: "Motorized Wheelchair",
    keywords: [
      "accessibility"
    ],
    skins: [
      {
        unified: "1f9bc",
        native: "🦼"
      }
    ],
    version: 12
  },
  auto_rickshaw: {
    id: "auto_rickshaw",
    name: "Auto Rickshaw",
    keywords: [
      "move",
      "transportation"
    ],
    skins: [
      {
        unified: "1f6fa",
        native: "🛺"
      }
    ],
    version: 12
  },
  bike: {
    id: "bike",
    name: "Bicycle",
    keywords: [
      "bike",
      "sports",
      "exercise",
      "hipster"
    ],
    skins: [
      {
        unified: "1f6b2",
        native: "🚲"
      }
    ],
    version: 1
  },
  scooter: {
    id: "scooter",
    name: "Scooter",
    keywords: [
      "kick",
      "vehicle",
      "razor"
    ],
    skins: [
      {
        unified: "1f6f4",
        native: "🛴"
      }
    ],
    version: 3
  },
  skateboard: {
    id: "skateboard",
    name: "Skateboard",
    keywords: [
      "board"
    ],
    skins: [
      {
        unified: "1f6f9",
        native: "🛹"
      }
    ],
    version: 11
  },
  roller_skate: {
    id: "roller_skate",
    name: "Roller Skate",
    keywords: [
      "footwear",
      "sports"
    ],
    skins: [
      {
        unified: "1f6fc",
        native: "🛼"
      }
    ],
    version: 13
  },
  busstop: {
    id: "busstop",
    name: "Bus Stop",
    keywords: [
      "busstop",
      "transportation",
      "wait"
    ],
    skins: [
      {
        unified: "1f68f",
        native: "🚏"
      }
    ],
    version: 1
  },
  motorway: {
    id: "motorway",
    name: "Motorway",
    keywords: [
      "road",
      "cupertino",
      "interstate",
      "highway"
    ],
    skins: [
      {
        unified: "1f6e3-fe0f",
        native: "🛣️"
      }
    ],
    version: 1
  },
  railway_track: {
    id: "railway_track",
    name: "Railway Track",
    keywords: [
      "train",
      "transportation"
    ],
    skins: [
      {
        unified: "1f6e4-fe0f",
        native: "🛤️"
      }
    ],
    version: 1
  },
  oil_drum: {
    id: "oil_drum",
    name: "Oil Drum",
    keywords: [
      "barrell"
    ],
    skins: [
      {
        unified: "1f6e2-fe0f",
        native: "🛢️"
      }
    ],
    version: 1
  },
  fuelpump: {
    id: "fuelpump",
    name: "Fuel Pump",
    keywords: [
      "fuelpump",
      "gas",
      "station",
      "petroleum"
    ],
    skins: [
      {
        unified: "26fd",
        native: "⛽"
      }
    ],
    version: 1
  },
  wheel: {
    id: "wheel",
    name: "Wheel",
    keywords: [
      "car",
      "transport"
    ],
    skins: [
      {
        unified: "1f6de",
        native: "🛞"
      }
    ],
    version: 14
  },
  rotating_light: {
    id: "rotating_light",
    name: "Police Car Light",
    keywords: [
      "rotating",
      "ambulance",
      "911",
      "emergency",
      "alert",
      "error",
      "pinged",
      "law",
      "legal"
    ],
    skins: [
      {
        unified: "1f6a8",
        native: "🚨"
      }
    ],
    version: 1
  },
  traffic_light: {
    id: "traffic_light",
    name: "Horizontal Traffic Light",
    keywords: [
      "transportation",
      "signal"
    ],
    skins: [
      {
        unified: "1f6a5",
        native: "🚥"
      }
    ],
    version: 1
  },
  vertical_traffic_light: {
    id: "vertical_traffic_light",
    name: "Vertical Traffic Light",
    keywords: [
      "transportation",
      "driving"
    ],
    skins: [
      {
        unified: "1f6a6",
        native: "🚦"
      }
    ],
    version: 1
  },
  octagonal_sign: {
    id: "octagonal_sign",
    name: "Stop Sign",
    keywords: [
      "octagonal"
    ],
    skins: [
      {
        unified: "1f6d1",
        native: "🛑"
      }
    ],
    version: 3
  },
  construction: {
    id: "construction",
    name: "Construction",
    keywords: [
      "wip",
      "progress",
      "caution",
      "warning"
    ],
    skins: [
      {
        unified: "1f6a7",
        native: "🚧"
      }
    ],
    version: 1
  },
  anchor: {
    id: "anchor",
    name: "Anchor",
    keywords: [
      "ship",
      "ferry",
      "sea",
      "boat"
    ],
    skins: [
      {
        unified: "2693",
        native: "⚓"
      }
    ],
    version: 1
  },
  ring_buoy: {
    id: "ring_buoy",
    name: "Ring Buoy",
    keywords: [
      "life",
      "saver",
      "preserver"
    ],
    skins: [
      {
        unified: "1f6df",
        native: "🛟"
      }
    ],
    version: 14
  },
  boat: {
    id: "boat",
    name: "Sailboat",
    keywords: [
      "boat",
      "ship",
      "summer",
      "transportation",
      "water",
      "sailing"
    ],
    skins: [
      {
        unified: "26f5",
        native: "⛵"
      }
    ],
    version: 1
  },
  canoe: {
    id: "canoe",
    name: "Canoe",
    keywords: [
      "boat",
      "paddle",
      "water",
      "ship"
    ],
    skins: [
      {
        unified: "1f6f6",
        native: "🛶"
      }
    ],
    version: 3
  },
  speedboat: {
    id: "speedboat",
    name: "Speedboat",
    keywords: [
      "ship",
      "transportation",
      "vehicle",
      "summer"
    ],
    skins: [
      {
        unified: "1f6a4",
        native: "🚤"
      }
    ],
    version: 1
  },
  passenger_ship: {
    id: "passenger_ship",
    name: "Passenger Ship",
    keywords: [
      "yacht",
      "cruise",
      "ferry"
    ],
    skins: [
      {
        unified: "1f6f3-fe0f",
        native: "🛳️"
      }
    ],
    version: 1
  },
  ferry: {
    id: "ferry",
    name: "Ferry",
    keywords: [
      "boat",
      "ship",
      "yacht"
    ],
    skins: [
      {
        unified: "26f4-fe0f",
        native: "⛴️"
      }
    ],
    version: 1
  },
  motor_boat: {
    id: "motor_boat",
    name: "Motor Boat",
    keywords: [
      "ship"
    ],
    skins: [
      {
        unified: "1f6e5-fe0f",
        native: "🛥️"
      }
    ],
    version: 1
  },
  ship: {
    id: "ship",
    name: "Ship",
    keywords: [
      "transportation",
      "titanic",
      "deploy"
    ],
    skins: [
      {
        unified: "1f6a2",
        native: "🚢"
      }
    ],
    version: 1
  },
  airplane: {
    id: "airplane",
    name: "Airplane",
    keywords: [
      "vehicle",
      "transportation",
      "flight",
      "fly"
    ],
    skins: [
      {
        unified: "2708-fe0f",
        native: "✈️"
      }
    ],
    version: 1
  },
  small_airplane: {
    id: "small_airplane",
    name: "Small Airplane",
    keywords: [
      "flight",
      "transportation",
      "fly",
      "vehicle"
    ],
    skins: [
      {
        unified: "1f6e9-fe0f",
        native: "🛩️"
      }
    ],
    version: 1
  },
  airplane_departure: {
    id: "airplane_departure",
    name: "Airplane Departure",
    keywords: [
      "airport",
      "flight",
      "landing"
    ],
    skins: [
      {
        unified: "1f6eb",
        native: "🛫"
      }
    ],
    version: 1
  },
  airplane_arriving: {
    id: "airplane_arriving",
    name: "Airplane Arrival",
    keywords: [
      "arriving",
      "airport",
      "flight",
      "boarding"
    ],
    skins: [
      {
        unified: "1f6ec",
        native: "🛬"
      }
    ],
    version: 1
  },
  parachute: {
    id: "parachute",
    name: "Parachute",
    keywords: [
      "fly",
      "glide"
    ],
    skins: [
      {
        unified: "1fa82",
        native: "🪂"
      }
    ],
    version: 12
  },
  seat: {
    id: "seat",
    name: "Seat",
    keywords: [
      "sit",
      "airplane",
      "transport",
      "bus",
      "flight",
      "fly"
    ],
    skins: [
      {
        unified: "1f4ba",
        native: "💺"
      }
    ],
    version: 1
  },
  helicopter: {
    id: "helicopter",
    name: "Helicopter",
    keywords: [
      "transportation",
      "vehicle",
      "fly"
    ],
    skins: [
      {
        unified: "1f681",
        native: "🚁"
      }
    ],
    version: 1
  },
  suspension_railway: {
    id: "suspension_railway",
    name: "Suspension Railway",
    keywords: [
      "vehicle",
      "transportation"
    ],
    skins: [
      {
        unified: "1f69f",
        native: "🚟"
      }
    ],
    version: 1
  },
  mountain_cableway: {
    id: "mountain_cableway",
    name: "Mountain Cableway",
    keywords: [
      "transportation",
      "vehicle",
      "ski"
    ],
    skins: [
      {
        unified: "1f6a0",
        native: "🚠"
      }
    ],
    version: 1
  },
  aerial_tramway: {
    id: "aerial_tramway",
    name: "Aerial Tramway",
    keywords: [
      "transportation",
      "vehicle",
      "ski"
    ],
    skins: [
      {
        unified: "1f6a1",
        native: "🚡"
      }
    ],
    version: 1
  },
  satellite: {
    id: "satellite",
    name: "Satellite",
    keywords: [
      "communication",
      "gps",
      "orbit",
      "spaceflight",
      "NASA",
      "ISS"
    ],
    skins: [
      {
        unified: "1f6f0-fe0f",
        native: "🛰️"
      }
    ],
    version: 1
  },
  rocket: {
    id: "rocket",
    name: "Rocket",
    keywords: [
      "launch",
      "ship",
      "staffmode",
      "NASA",
      "outer",
      "space",
      "fly"
    ],
    skins: [
      {
        unified: "1f680",
        native: "🚀"
      }
    ],
    version: 1
  },
  flying_saucer: {
    id: "flying_saucer",
    name: "Flying Saucer",
    keywords: [
      "transportation",
      "vehicle",
      "ufo"
    ],
    skins: [
      {
        unified: "1f6f8",
        native: "🛸"
      }
    ],
    version: 5
  },
  bellhop_bell: {
    id: "bellhop_bell",
    name: "Bellhop Bell",
    keywords: [
      "service"
    ],
    skins: [
      {
        unified: "1f6ce-fe0f",
        native: "🛎️"
      }
    ],
    version: 1
  },
  luggage: {
    id: "luggage",
    name: "Luggage",
    keywords: [
      "packing",
      "travel"
    ],
    skins: [
      {
        unified: "1f9f3",
        native: "🧳"
      }
    ],
    version: 11
  },
  hourglass: {
    id: "hourglass",
    name: "Hourglass",
    keywords: [
      "done",
      "time",
      "clock",
      "oldschool",
      "limit",
      "exam",
      "quiz",
      "test"
    ],
    skins: [
      {
        unified: "231b",
        native: "⌛"
      }
    ],
    version: 1
  },
  hourglass_flowing_sand: {
    id: "hourglass_flowing_sand",
    name: "Hourglass Not Done",
    keywords: [
      "flowing",
      "sand",
      "oldschool",
      "time",
      "countdown"
    ],
    skins: [
      {
        unified: "23f3",
        native: "⏳"
      }
    ],
    version: 1
  },
  watch: {
    id: "watch",
    name: "Watch",
    keywords: [
      "time",
      "accessories"
    ],
    skins: [
      {
        unified: "231a",
        native: "⌚"
      }
    ],
    version: 1
  },
  alarm_clock: {
    id: "alarm_clock",
    name: "Alarm Clock",
    keywords: [
      "time",
      "wake"
    ],
    skins: [
      {
        unified: "23f0",
        native: "⏰"
      }
    ],
    version: 1
  },
  stopwatch: {
    id: "stopwatch",
    name: "Stopwatch",
    keywords: [
      "time",
      "deadline"
    ],
    skins: [
      {
        unified: "23f1-fe0f",
        native: "⏱️"
      }
    ],
    version: 1
  },
  timer_clock: {
    id: "timer_clock",
    name: "Timer Clock",
    keywords: [
      "alarm"
    ],
    skins: [
      {
        unified: "23f2-fe0f",
        native: "⏲️"
      }
    ],
    version: 1
  },
  mantelpiece_clock: {
    id: "mantelpiece_clock",
    name: "Mantelpiece Clock",
    keywords: [
      "time"
    ],
    skins: [
      {
        unified: "1f570-fe0f",
        native: "🕰️"
      }
    ],
    version: 1
  },
  clock12: {
    id: "clock12",
    name: "Twelve O’clock",
    keywords: [
      "clock12",
      "o",
      "clock",
      "time",
      "noon",
      "midnight",
      "midday",
      "late",
      "early",
      "schedule"
    ],
    skins: [
      {
        unified: "1f55b",
        native: "🕛"
      }
    ],
    version: 1
  },
  clock1230: {
    id: "clock1230",
    name: "Twelve-Thirty",
    keywords: [
      "clock1230",
      "twelve",
      "thirty",
      "time",
      "late",
      "early",
      "schedule"
    ],
    skins: [
      {
        unified: "1f567",
        native: "🕧"
      }
    ],
    version: 1
  },
  clock1: {
    id: "clock1",
    name: "One O’clock",
    keywords: [
      "clock1",
      "o",
      "clock",
      "time",
      "late",
      "early",
      "schedule"
    ],
    skins: [
      {
        unified: "1f550",
        native: "🕐"
      }
    ],
    version: 1
  },
  clock130: {
    id: "clock130",
    name: "One-Thirty",
    keywords: [
      "clock130",
      "one",
      "thirty",
      "time",
      "late",
      "early",
      "schedule"
    ],
    skins: [
      {
        unified: "1f55c",
        native: "🕜"
      }
    ],
    version: 1
  },
  clock2: {
    id: "clock2",
    name: "Two O’clock",
    keywords: [
      "clock2",
      "o",
      "clock",
      "time",
      "late",
      "early",
      "schedule"
    ],
    skins: [
      {
        unified: "1f551",
        native: "🕑"
      }
    ],
    version: 1
  },
  clock230: {
    id: "clock230",
    name: "Two-Thirty",
    keywords: [
      "clock230",
      "two",
      "thirty",
      "time",
      "late",
      "early",
      "schedule"
    ],
    skins: [
      {
        unified: "1f55d",
        native: "🕝"
      }
    ],
    version: 1
  },
  clock3: {
    id: "clock3",
    name: "Three O’clock",
    keywords: [
      "clock3",
      "o",
      "clock",
      "time",
      "late",
      "early",
      "schedule"
    ],
    skins: [
      {
        unified: "1f552",
        native: "🕒"
      }
    ],
    version: 1
  },
  clock330: {
    id: "clock330",
    name: "Three-Thirty",
    keywords: [
      "clock330",
      "three",
      "thirty",
      "time",
      "late",
      "early",
      "schedule"
    ],
    skins: [
      {
        unified: "1f55e",
        native: "🕞"
      }
    ],
    version: 1
  },
  clock4: {
    id: "clock4",
    name: "Four O’clock",
    keywords: [
      "clock4",
      "o",
      "clock",
      "time",
      "late",
      "early",
      "schedule"
    ],
    skins: [
      {
        unified: "1f553",
        native: "🕓"
      }
    ],
    version: 1
  },
  clock430: {
    id: "clock430",
    name: "Four-Thirty",
    keywords: [
      "clock430",
      "four",
      "thirty",
      "time",
      "late",
      "early",
      "schedule"
    ],
    skins: [
      {
        unified: "1f55f",
        native: "🕟"
      }
    ],
    version: 1
  },
  clock5: {
    id: "clock5",
    name: "Five O’clock",
    keywords: [
      "clock5",
      "o",
      "clock",
      "time",
      "late",
      "early",
      "schedule"
    ],
    skins: [
      {
        unified: "1f554",
        native: "🕔"
      }
    ],
    version: 1
  },
  clock530: {
    id: "clock530",
    name: "Five-Thirty",
    keywords: [
      "clock530",
      "five",
      "thirty",
      "time",
      "late",
      "early",
      "schedule"
    ],
    skins: [
      {
        unified: "1f560",
        native: "🕠"
      }
    ],
    version: 1
  },
  clock6: {
    id: "clock6",
    name: "Six O’clock",
    keywords: [
      "clock6",
      "o",
      "clock",
      "time",
      "late",
      "early",
      "schedule",
      "dawn",
      "dusk"
    ],
    skins: [
      {
        unified: "1f555",
        native: "🕕"
      }
    ],
    version: 1
  },
  clock630: {
    id: "clock630",
    name: "Six-Thirty",
    keywords: [
      "clock630",
      "six",
      "thirty",
      "time",
      "late",
      "early",
      "schedule"
    ],
    skins: [
      {
        unified: "1f561",
        native: "🕡"
      }
    ],
    version: 1
  },
  clock7: {
    id: "clock7",
    name: "Seven O’clock",
    keywords: [
      "clock7",
      "o",
      "clock",
      "time",
      "late",
      "early",
      "schedule"
    ],
    skins: [
      {
        unified: "1f556",
        native: "🕖"
      }
    ],
    version: 1
  },
  clock730: {
    id: "clock730",
    name: "Seven-Thirty",
    keywords: [
      "clock730",
      "seven",
      "thirty",
      "time",
      "late",
      "early",
      "schedule"
    ],
    skins: [
      {
        unified: "1f562",
        native: "🕢"
      }
    ],
    version: 1
  },
  clock8: {
    id: "clock8",
    name: "Eight O’clock",
    keywords: [
      "clock8",
      "o",
      "clock",
      "time",
      "late",
      "early",
      "schedule"
    ],
    skins: [
      {
        unified: "1f557",
        native: "🕗"
      }
    ],
    version: 1
  },
  clock830: {
    id: "clock830",
    name: "Eight-Thirty",
    keywords: [
      "clock830",
      "eight",
      "thirty",
      "time",
      "late",
      "early",
      "schedule"
    ],
    skins: [
      {
        unified: "1f563",
        native: "🕣"
      }
    ],
    version: 1
  },
  clock9: {
    id: "clock9",
    name: "Nine O’clock",
    keywords: [
      "clock9",
      "o",
      "clock",
      "time",
      "late",
      "early",
      "schedule"
    ],
    skins: [
      {
        unified: "1f558",
        native: "🕘"
      }
    ],
    version: 1
  },
  clock930: {
    id: "clock930",
    name: "Nine-Thirty",
    keywords: [
      "clock930",
      "nine",
      "thirty",
      "time",
      "late",
      "early",
      "schedule"
    ],
    skins: [
      {
        unified: "1f564",
        native: "🕤"
      }
    ],
    version: 1
  },
  clock10: {
    id: "clock10",
    name: "Ten O’clock",
    keywords: [
      "clock10",
      "o",
      "clock",
      "time",
      "late",
      "early",
      "schedule"
    ],
    skins: [
      {
        unified: "1f559",
        native: "🕙"
      }
    ],
    version: 1
  },
  clock1030: {
    id: "clock1030",
    name: "Ten-Thirty",
    keywords: [
      "clock1030",
      "ten",
      "thirty",
      "time",
      "late",
      "early",
      "schedule"
    ],
    skins: [
      {
        unified: "1f565",
        native: "🕥"
      }
    ],
    version: 1
  },
  clock11: {
    id: "clock11",
    name: "Eleven O’clock",
    keywords: [
      "clock11",
      "o",
      "clock",
      "time",
      "late",
      "early",
      "schedule"
    ],
    skins: [
      {
        unified: "1f55a",
        native: "🕚"
      }
    ],
    version: 1
  },
  clock1130: {
    id: "clock1130",
    name: "Eleven-Thirty",
    keywords: [
      "clock1130",
      "eleven",
      "thirty",
      "time",
      "late",
      "early",
      "schedule"
    ],
    skins: [
      {
        unified: "1f566",
        native: "🕦"
      }
    ],
    version: 1
  },
  new_moon: {
    id: "new_moon",
    name: "New Moon",
    keywords: [
      "nature",
      "twilight",
      "planet",
      "space",
      "night",
      "evening",
      "sleep"
    ],
    skins: [
      {
        unified: "1f311",
        native: "🌑"
      }
    ],
    version: 1
  },
  waxing_crescent_moon: {
    id: "waxing_crescent_moon",
    name: "Waxing Crescent Moon",
    keywords: [
      "nature",
      "twilight",
      "planet",
      "space",
      "night",
      "evening",
      "sleep"
    ],
    skins: [
      {
        unified: "1f312",
        native: "🌒"
      }
    ],
    version: 1
  },
  first_quarter_moon: {
    id: "first_quarter_moon",
    name: "First Quarter Moon",
    keywords: [
      "nature",
      "twilight",
      "planet",
      "space",
      "night",
      "evening",
      "sleep"
    ],
    skins: [
      {
        unified: "1f313",
        native: "🌓"
      }
    ],
    version: 1
  },
  moon: {
    id: "moon",
    name: "Waxing Gibbous Moon",
    keywords: [
      "nature",
      "night",
      "sky",
      "gray",
      "twilight",
      "planet",
      "space",
      "evening",
      "sleep"
    ],
    skins: [
      {
        unified: "1f314",
        native: "🌔"
      }
    ],
    version: 1
  },
  full_moon: {
    id: "full_moon",
    name: "Full Moon",
    keywords: [
      "nature",
      "yellow",
      "twilight",
      "planet",
      "space",
      "night",
      "evening",
      "sleep"
    ],
    skins: [
      {
        unified: "1f315",
        native: "🌕"
      }
    ],
    version: 1
  },
  waning_gibbous_moon: {
    id: "waning_gibbous_moon",
    name: "Waning Gibbous Moon",
    keywords: [
      "nature",
      "twilight",
      "planet",
      "space",
      "night",
      "evening",
      "sleep",
      "waxing"
    ],
    skins: [
      {
        unified: "1f316",
        native: "🌖"
      }
    ],
    version: 1
  },
  last_quarter_moon: {
    id: "last_quarter_moon",
    name: "Last Quarter Moon",
    keywords: [
      "nature",
      "twilight",
      "planet",
      "space",
      "night",
      "evening",
      "sleep"
    ],
    skins: [
      {
        unified: "1f317",
        native: "🌗"
      }
    ],
    version: 1
  },
  waning_crescent_moon: {
    id: "waning_crescent_moon",
    name: "Waning Crescent Moon",
    keywords: [
      "nature",
      "twilight",
      "planet",
      "space",
      "night",
      "evening",
      "sleep"
    ],
    skins: [
      {
        unified: "1f318",
        native: "🌘"
      }
    ],
    version: 1
  },
  crescent_moon: {
    id: "crescent_moon",
    name: "Crescent Moon",
    keywords: [
      "night",
      "sleep",
      "sky",
      "evening",
      "magic"
    ],
    skins: [
      {
        unified: "1f319",
        native: "🌙"
      }
    ],
    version: 1
  },
  new_moon_with_face: {
    id: "new_moon_with_face",
    name: "New Moon Face",
    keywords: [
      "with",
      "nature",
      "twilight",
      "planet",
      "space",
      "night",
      "evening",
      "sleep"
    ],
    skins: [
      {
        unified: "1f31a",
        native: "🌚"
      }
    ],
    version: 1
  },
  first_quarter_moon_with_face: {
    id: "first_quarter_moon_with_face",
    name: "First Quarter Moon Face",
    keywords: [
      "with",
      "nature",
      "twilight",
      "planet",
      "space",
      "night",
      "evening",
      "sleep"
    ],
    skins: [
      {
        unified: "1f31b",
        native: "🌛"
      }
    ],
    version: 1
  },
  last_quarter_moon_with_face: {
    id: "last_quarter_moon_with_face",
    name: "Last Quarter Moon Face",
    keywords: [
      "with",
      "nature",
      "twilight",
      "planet",
      "space",
      "night",
      "evening",
      "sleep"
    ],
    skins: [
      {
        unified: "1f31c",
        native: "🌜"
      }
    ],
    version: 1
  },
  thermometer: {
    id: "thermometer",
    name: "Thermometer",
    keywords: [
      "weather",
      "temperature",
      "hot",
      "cold"
    ],
    skins: [
      {
        unified: "1f321-fe0f",
        native: "🌡️"
      }
    ],
    version: 1
  },
  sunny: {
    id: "sunny",
    name: "Sun",
    keywords: [
      "sunny",
      "weather",
      "nature",
      "brightness",
      "summer",
      "beach",
      "spring"
    ],
    skins: [
      {
        unified: "2600-fe0f",
        native: "☀️"
      }
    ],
    version: 1
  },
  full_moon_with_face: {
    id: "full_moon_with_face",
    name: "Full Moon Face",
    keywords: [
      "with",
      "nature",
      "twilight",
      "planet",
      "space",
      "night",
      "evening",
      "sleep"
    ],
    skins: [
      {
        unified: "1f31d",
        native: "🌝"
      }
    ],
    version: 1
  },
  sun_with_face: {
    id: "sun_with_face",
    name: "Sun with Face",
    keywords: [
      "nature",
      "morning",
      "sky"
    ],
    skins: [
      {
        unified: "1f31e",
        native: "🌞"
      }
    ],
    version: 1
  },
  ringed_planet: {
    id: "ringed_planet",
    name: "Ringed Planet",
    keywords: [
      "outerspace"
    ],
    skins: [
      {
        unified: "1fa90",
        native: "🪐"
      }
    ],
    version: 12
  },
  star: {
    id: "star",
    name: "Star",
    keywords: [
      "night",
      "yellow"
    ],
    skins: [
      {
        unified: "2b50",
        native: "⭐"
      }
    ],
    version: 1
  },
  star2: {
    id: "star2",
    name: "Glowing Star",
    keywords: [
      "star2",
      "night",
      "sparkle",
      "awesome",
      "good",
      "magic"
    ],
    skins: [
      {
        unified: "1f31f",
        native: "🌟"
      }
    ],
    version: 1
  },
  stars: {
    id: "stars",
    name: "Shooting Star",
    keywords: [
      "stars",
      "night",
      "photo"
    ],
    skins: [
      {
        unified: "1f320",
        native: "🌠"
      }
    ],
    version: 1
  },
  milky_way: {
    id: "milky_way",
    name: "Milky Way",
    keywords: [
      "photo",
      "space",
      "stars"
    ],
    skins: [
      {
        unified: "1f30c",
        native: "🌌"
      }
    ],
    version: 1
  },
  cloud: {
    id: "cloud",
    name: "Cloud",
    keywords: [
      "weather",
      "sky"
    ],
    skins: [
      {
        unified: "2601-fe0f",
        native: "☁️"
      }
    ],
    version: 1
  },
  partly_sunny: {
    id: "partly_sunny",
    name: "Sun Behind Cloud",
    keywords: [
      "partly",
      "sunny",
      "weather",
      "nature",
      "cloudy",
      "morning",
      "fall",
      "spring"
    ],
    skins: [
      {
        unified: "26c5",
        native: "⛅"
      }
    ],
    version: 1
  },
  thunder_cloud_and_rain: {
    id: "thunder_cloud_and_rain",
    name: "Cloud with Lightning and Rain",
    keywords: [
      "thunder",
      "weather"
    ],
    skins: [
      {
        unified: "26c8-fe0f",
        native: "⛈️"
      }
    ],
    version: 1
  },
  mostly_sunny: {
    id: "mostly_sunny",
    name: "Sun Behind Small Cloud",
    keywords: [
      "mostly",
      "sunny",
      "weather"
    ],
    skins: [
      {
        unified: "1f324-fe0f",
        native: "🌤️"
      }
    ],
    version: 1
  },
  barely_sunny: {
    id: "barely_sunny",
    name: "Sun Behind Large Cloud",
    keywords: [
      "barely",
      "sunny",
      "weather"
    ],
    skins: [
      {
        unified: "1f325-fe0f",
        native: "🌥️"
      }
    ],
    version: 1
  },
  partly_sunny_rain: {
    id: "partly_sunny_rain",
    name: "Sun Behind Rain Cloud",
    keywords: [
      "partly",
      "sunny",
      "weather"
    ],
    skins: [
      {
        unified: "1f326-fe0f",
        native: "🌦️"
      }
    ],
    version: 1
  },
  rain_cloud: {
    id: "rain_cloud",
    name: "Cloud with Rain",
    keywords: [
      "weather"
    ],
    skins: [
      {
        unified: "1f327-fe0f",
        native: "🌧️"
      }
    ],
    version: 1
  },
  snow_cloud: {
    id: "snow_cloud",
    name: "Cloud with Snow",
    keywords: [
      "weather"
    ],
    skins: [
      {
        unified: "1f328-fe0f",
        native: "🌨️"
      }
    ],
    version: 1
  },
  lightning: {
    id: "lightning",
    name: "Cloud with Lightning",
    keywords: [
      "weather",
      "thunder"
    ],
    skins: [
      {
        unified: "1f329-fe0f",
        native: "🌩️"
      }
    ],
    version: 1
  },
  tornado: {
    id: "tornado",
    name: "Tornado",
    keywords: [
      "cloud",
      "weather",
      "cyclone",
      "twister"
    ],
    skins: [
      {
        unified: "1f32a-fe0f",
        native: "🌪️"
      }
    ],
    version: 1
  },
  fog: {
    id: "fog",
    name: "Fog",
    keywords: [
      "weather"
    ],
    skins: [
      {
        unified: "1f32b-fe0f",
        native: "🌫️"
      }
    ],
    version: 1
  },
  wind_blowing_face: {
    id: "wind_blowing_face",
    name: "Wind Face",
    keywords: [
      "blowing",
      "gust",
      "air"
    ],
    skins: [
      {
        unified: "1f32c-fe0f",
        native: "🌬️"
      }
    ],
    version: 1
  },
  cyclone: {
    id: "cyclone",
    name: "Cyclone",
    keywords: [
      "weather",
      "swirl",
      "blue",
      "cloud",
      "vortex",
      "spiral",
      "whirlpool",
      "spin",
      "tornado",
      "hurricane",
      "typhoon"
    ],
    skins: [
      {
        unified: "1f300",
        native: "🌀"
      }
    ],
    version: 1
  },
  rainbow: {
    id: "rainbow",
    name: "Rainbow",
    keywords: [
      "nature",
      "happy",
      "unicorn",
      "face",
      "photo",
      "sky",
      "spring"
    ],
    skins: [
      {
        unified: "1f308",
        native: "🌈"
      }
    ],
    version: 1
  },
  closed_umbrella: {
    id: "closed_umbrella",
    name: "Closed Umbrella",
    keywords: [
      "weather",
      "rain",
      "drizzle"
    ],
    skins: [
      {
        unified: "1f302",
        native: "🌂"
      }
    ],
    version: 1
  },
  umbrella: {
    id: "umbrella",
    name: "Umbrella",
    keywords: [
      "weather",
      "spring"
    ],
    skins: [
      {
        unified: "2602-fe0f",
        native: "☂️"
      }
    ],
    version: 1
  },
  umbrella_with_rain_drops: {
    id: "umbrella_with_rain_drops",
    name: "Umbrella with Rain Drops",
    keywords: [
      "rainy",
      "weather",
      "spring"
    ],
    skins: [
      {
        unified: "2614",
        native: "☔"
      }
    ],
    version: 1
  },
  umbrella_on_ground: {
    id: "umbrella_on_ground",
    name: "Umbrella on Ground",
    keywords: [
      "weather",
      "summer"
    ],
    skins: [
      {
        unified: "26f1-fe0f",
        native: "⛱️"
      }
    ],
    version: 1
  },
  zap: {
    id: "zap",
    name: "High Voltage",
    keywords: [
      "zap",
      "thunder",
      "weather",
      "lightning",
      "bolt",
      "fast"
    ],
    skins: [
      {
        unified: "26a1",
        native: "⚡"
      }
    ],
    version: 1
  },
  snowflake: {
    id: "snowflake",
    name: "Snowflake",
    keywords: [
      "winter",
      "season",
      "cold",
      "weather",
      "christmas",
      "xmas"
    ],
    skins: [
      {
        unified: "2744-fe0f",
        native: "❄️"
      }
    ],
    version: 1
  },
  snowman: {
    id: "snowman",
    name: "Snowman",
    keywords: [
      "winter",
      "season",
      "cold",
      "weather",
      "christmas",
      "xmas",
      "frozen"
    ],
    skins: [
      {
        unified: "2603-fe0f",
        native: "☃️"
      }
    ],
    version: 1
  },
  snowman_without_snow: {
    id: "snowman_without_snow",
    name: "Snowman Without Snow",
    keywords: [
      "winter",
      "season",
      "cold",
      "weather",
      "christmas",
      "xmas",
      "frozen"
    ],
    skins: [
      {
        unified: "26c4",
        native: "⛄"
      }
    ],
    version: 1
  },
  comet: {
    id: "comet",
    name: "Comet",
    keywords: [
      "space"
    ],
    skins: [
      {
        unified: "2604-fe0f",
        native: "☄️"
      }
    ],
    version: 1
  },
  fire: {
    id: "fire",
    name: "Fire",
    keywords: [
      "hot",
      "cook",
      "flame"
    ],
    skins: [
      {
        unified: "1f525",
        native: "🔥"
      }
    ],
    version: 1
  },
  droplet: {
    id: "droplet",
    name: "Droplet",
    keywords: [
      "water",
      "drip",
      "faucet",
      "spring"
    ],
    skins: [
      {
        unified: "1f4a7",
        native: "💧"
      }
    ],
    version: 1
  },
  ocean: {
    id: "ocean",
    name: "Water Wave",
    keywords: [
      "ocean",
      "sea",
      "nature",
      "tsunami",
      "disaster"
    ],
    skins: [
      {
        unified: "1f30a",
        native: "🌊"
      }
    ],
    version: 1
  },
  jack_o_lantern: {
    id: "jack_o_lantern",
    name: "Jack-O-Lantern",
    keywords: [
      "jack",
      "o",
      "lantern",
      "halloween",
      "light",
      "pumpkin",
      "creepy",
      "fall"
    ],
    skins: [
      {
        unified: "1f383",
        native: "🎃"
      }
    ],
    version: 1
  },
  christmas_tree: {
    id: "christmas_tree",
    name: "Christmas Tree",
    keywords: [
      "festival",
      "vacation",
      "december",
      "xmas",
      "celebration"
    ],
    skins: [
      {
        unified: "1f384",
        native: "🎄"
      }
    ],
    version: 1
  },
  fireworks: {
    id: "fireworks",
    name: "Fireworks",
    keywords: [
      "photo",
      "festival",
      "carnival",
      "congratulations"
    ],
    skins: [
      {
        unified: "1f386",
        native: "🎆"
      }
    ],
    version: 1
  },
  sparkler: {
    id: "sparkler",
    name: "Sparkler",
    keywords: [
      "stars",
      "night",
      "shine"
    ],
    skins: [
      {
        unified: "1f387",
        native: "🎇"
      }
    ],
    version: 1
  },
  firecracker: {
    id: "firecracker",
    name: "Firecracker",
    keywords: [
      "dynamite",
      "boom",
      "explode",
      "explosion",
      "explosive"
    ],
    skins: [
      {
        unified: "1f9e8",
        native: "🧨"
      }
    ],
    version: 11
  },
  sparkles: {
    id: "sparkles",
    name: "Sparkles",
    keywords: [
      "stars",
      "shine",
      "shiny",
      "cool",
      "awesome",
      "good",
      "magic"
    ],
    skins: [
      {
        unified: "2728",
        native: "✨"
      }
    ],
    version: 1
  },
  balloon: {
    id: "balloon",
    name: "Balloon",
    keywords: [
      "party",
      "celebration",
      "birthday",
      "circus"
    ],
    skins: [
      {
        unified: "1f388",
        native: "🎈"
      }
    ],
    version: 1
  },
  tada: {
    id: "tada",
    name: "Party Popper",
    keywords: [
      "tada",
      "congratulations",
      "birthday",
      "magic",
      "circus",
      "celebration"
    ],
    skins: [
      {
        unified: "1f389",
        native: "🎉"
      }
    ],
    version: 1
  },
  confetti_ball: {
    id: "confetti_ball",
    name: "Confetti Ball",
    keywords: [
      "festival",
      "party",
      "birthday",
      "circus"
    ],
    skins: [
      {
        unified: "1f38a",
        native: "🎊"
      }
    ],
    version: 1
  },
  tanabata_tree: {
    id: "tanabata_tree",
    name: "Tanabata Tree",
    keywords: [
      "plant",
      "nature",
      "branch",
      "summer"
    ],
    skins: [
      {
        unified: "1f38b",
        native: "🎋"
      }
    ],
    version: 1
  },
  bamboo: {
    id: "bamboo",
    name: "Pine Decoration",
    keywords: [
      "bamboo",
      "plant",
      "nature",
      "vegetable",
      "panda"
    ],
    skins: [
      {
        unified: "1f38d",
        native: "🎍"
      }
    ],
    version: 1
  },
  dolls: {
    id: "dolls",
    name: "Japanese Dolls",
    keywords: [
      "toy",
      "kimono"
    ],
    skins: [
      {
        unified: "1f38e",
        native: "🎎"
      }
    ],
    version: 1
  },
  flags: {
    id: "flags",
    name: "Carp Streamer",
    keywords: [
      "flags",
      "fish",
      "japanese",
      "koinobori",
      "banner"
    ],
    skins: [
      {
        unified: "1f38f",
        native: "🎏"
      }
    ],
    version: 1
  },
  wind_chime: {
    id: "wind_chime",
    name: "Wind Chime",
    keywords: [
      "nature",
      "ding",
      "spring",
      "bell"
    ],
    skins: [
      {
        unified: "1f390",
        native: "🎐"
      }
    ],
    version: 1
  },
  rice_scene: {
    id: "rice_scene",
    name: "Moon Viewing Ceremony",
    keywords: [
      "rice",
      "scene",
      "photo",
      "japan",
      "asia",
      "tsukimi"
    ],
    skins: [
      {
        unified: "1f391",
        native: "🎑"
      }
    ],
    version: 1
  },
  red_envelope: {
    id: "red_envelope",
    name: "Red Envelope",
    keywords: [
      "gift"
    ],
    skins: [
      {
        unified: "1f9e7",
        native: "🧧"
      }
    ],
    version: 11
  },
  ribbon: {
    id: "ribbon",
    name: "Ribbon",
    keywords: [
      "decoration",
      "pink",
      "girl",
      "bowtie"
    ],
    skins: [
      {
        unified: "1f380",
        native: "🎀"
      }
    ],
    version: 1
  },
  gift: {
    id: "gift",
    name: "Wrapped Gift",
    keywords: [
      "present",
      "birthday",
      "christmas",
      "xmas"
    ],
    skins: [
      {
        unified: "1f381",
        native: "🎁"
      }
    ],
    version: 1
  },
  reminder_ribbon: {
    id: "reminder_ribbon",
    name: "Reminder Ribbon",
    keywords: [
      "sports",
      "cause",
      "support",
      "awareness"
    ],
    skins: [
      {
        unified: "1f397-fe0f",
        native: "🎗️"
      }
    ],
    version: 1
  },
  admission_tickets: {
    id: "admission_tickets",
    name: "Admission Tickets",
    keywords: [
      "sports",
      "concert",
      "entrance"
    ],
    skins: [
      {
        unified: "1f39f-fe0f",
        native: "🎟️"
      }
    ],
    version: 1
  },
  ticket: {
    id: "ticket",
    name: "Ticket",
    keywords: [
      "event",
      "concert",
      "pass"
    ],
    skins: [
      {
        unified: "1f3ab",
        native: "🎫"
      }
    ],
    version: 1
  },
  medal: {
    id: "medal",
    name: "Military Medal",
    keywords: [
      "award",
      "winning",
      "army"
    ],
    skins: [
      {
        unified: "1f396-fe0f",
        native: "🎖️"
      }
    ],
    version: 1
  },
  trophy: {
    id: "trophy",
    name: "Trophy",
    keywords: [
      "win",
      "award",
      "contest",
      "place",
      "ftw",
      "ceremony"
    ],
    skins: [
      {
        unified: "1f3c6",
        native: "🏆"
      }
    ],
    version: 1
  },
  sports_medal: {
    id: "sports_medal",
    name: "Sports Medal",
    keywords: [
      "award",
      "winning"
    ],
    skins: [
      {
        unified: "1f3c5",
        native: "🏅"
      }
    ],
    version: 1
  },
  first_place_medal: {
    id: "first_place_medal",
    name: "1st Place Medal",
    keywords: [
      "first",
      "award",
      "winning"
    ],
    skins: [
      {
        unified: "1f947",
        native: "🥇"
      }
    ],
    version: 3
  },
  second_place_medal: {
    id: "second_place_medal",
    name: "2nd Place Medal",
    keywords: [
      "second",
      "award"
    ],
    skins: [
      {
        unified: "1f948",
        native: "🥈"
      }
    ],
    version: 3
  },
  third_place_medal: {
    id: "third_place_medal",
    name: "3rd Place Medal",
    keywords: [
      "third",
      "award"
    ],
    skins: [
      {
        unified: "1f949",
        native: "🥉"
      }
    ],
    version: 3
  },
  soccer: {
    id: "soccer",
    name: "Soccer Ball",
    keywords: [
      "sports",
      "football"
    ],
    skins: [
      {
        unified: "26bd",
        native: "⚽"
      }
    ],
    version: 1
  },
  baseball: {
    id: "baseball",
    name: "Baseball",
    keywords: [
      "sports",
      "balls"
    ],
    skins: [
      {
        unified: "26be",
        native: "⚾"
      }
    ],
    version: 1
  },
  softball: {
    id: "softball",
    name: "Softball",
    keywords: [
      "sports",
      "balls"
    ],
    skins: [
      {
        unified: "1f94e",
        native: "🥎"
      }
    ],
    version: 11
  },
  basketball: {
    id: "basketball",
    name: "Basketball",
    keywords: [
      "sports",
      "balls",
      "NBA"
    ],
    skins: [
      {
        unified: "1f3c0",
        native: "🏀"
      }
    ],
    version: 1
  },
  volleyball: {
    id: "volleyball",
    name: "Volleyball",
    keywords: [
      "sports",
      "balls"
    ],
    skins: [
      {
        unified: "1f3d0",
        native: "🏐"
      }
    ],
    version: 1
  },
  football: {
    id: "football",
    name: "American Football",
    keywords: [
      "sports",
      "balls",
      "NFL"
    ],
    skins: [
      {
        unified: "1f3c8",
        native: "🏈"
      }
    ],
    version: 1
  },
  rugby_football: {
    id: "rugby_football",
    name: "Rugby Football",
    keywords: [
      "sports",
      "team"
    ],
    skins: [
      {
        unified: "1f3c9",
        native: "🏉"
      }
    ],
    version: 1
  },
  tennis: {
    id: "tennis",
    name: "Tennis",
    keywords: [
      "sports",
      "balls",
      "green"
    ],
    skins: [
      {
        unified: "1f3be",
        native: "🎾"
      }
    ],
    version: 1
  },
  flying_disc: {
    id: "flying_disc",
    name: "Flying Disc",
    keywords: [
      "sports",
      "frisbee",
      "ultimate"
    ],
    skins: [
      {
        unified: "1f94f",
        native: "🥏"
      }
    ],
    version: 11
  },
  bowling: {
    id: "bowling",
    name: "Bowling",
    keywords: [
      "sports",
      "fun",
      "play"
    ],
    skins: [
      {
        unified: "1f3b3",
        native: "🎳"
      }
    ],
    version: 1
  },
  cricket_bat_and_ball: {
    id: "cricket_bat_and_ball",
    name: "Cricket Game",
    keywords: [
      "bat",
      "and",
      "ball",
      "sports"
    ],
    skins: [
      {
        unified: "1f3cf",
        native: "🏏"
      }
    ],
    version: 1
  },
  field_hockey_stick_and_ball: {
    id: "field_hockey_stick_and_ball",
    name: "Field Hockey",
    keywords: [
      "stick",
      "and",
      "ball",
      "sports"
    ],
    skins: [
      {
        unified: "1f3d1",
        native: "🏑"
      }
    ],
    version: 1
  },
  ice_hockey_stick_and_puck: {
    id: "ice_hockey_stick_and_puck",
    name: "Ice Hockey",
    keywords: [
      "stick",
      "and",
      "puck",
      "sports"
    ],
    skins: [
      {
        unified: "1f3d2",
        native: "🏒"
      }
    ],
    version: 1
  },
  lacrosse: {
    id: "lacrosse",
    name: "Lacrosse",
    keywords: [
      "sports",
      "ball",
      "stick"
    ],
    skins: [
      {
        unified: "1f94d",
        native: "🥍"
      }
    ],
    version: 11
  },
  table_tennis_paddle_and_ball: {
    id: "table_tennis_paddle_and_ball",
    name: "Ping Pong",
    keywords: [
      "table",
      "tennis",
      "paddle",
      "and",
      "ball",
      "sports",
      "pingpong"
    ],
    skins: [
      {
        unified: "1f3d3",
        native: "🏓"
      }
    ],
    version: 1
  },
  badminton_racquet_and_shuttlecock: {
    id: "badminton_racquet_and_shuttlecock",
    name: "Badminton",
    keywords: [
      "racquet",
      "and",
      "shuttlecock",
      "sports"
    ],
    skins: [
      {
        unified: "1f3f8",
        native: "🏸"
      }
    ],
    version: 1
  },
  boxing_glove: {
    id: "boxing_glove",
    name: "Boxing Glove",
    keywords: [
      "sports",
      "fighting"
    ],
    skins: [
      {
        unified: "1f94a",
        native: "🥊"
      }
    ],
    version: 3
  },
  martial_arts_uniform: {
    id: "martial_arts_uniform",
    name: "Martial Arts Uniform",
    keywords: [
      "judo",
      "karate",
      "taekwondo"
    ],
    skins: [
      {
        unified: "1f94b",
        native: "🥋"
      }
    ],
    version: 3
  },
  goal_net: {
    id: "goal_net",
    name: "Goal Net",
    keywords: [
      "sports"
    ],
    skins: [
      {
        unified: "1f945",
        native: "🥅"
      }
    ],
    version: 3
  },
  golf: {
    id: "golf",
    name: "Flag in Hole",
    keywords: [
      "golf",
      "sports",
      "business",
      "summer"
    ],
    skins: [
      {
        unified: "26f3",
        native: "⛳"
      }
    ],
    version: 1
  },
  ice_skate: {
    id: "ice_skate",
    name: "Ice Skate",
    keywords: [
      "sports"
    ],
    skins: [
      {
        unified: "26f8-fe0f",
        native: "⛸️"
      }
    ],
    version: 1
  },
  fishing_pole_and_fish: {
    id: "fishing_pole_and_fish",
    name: "Fishing Pole",
    keywords: [
      "and",
      "fish",
      "food",
      "hobby",
      "summer"
    ],
    skins: [
      {
        unified: "1f3a3",
        native: "🎣"
      }
    ],
    version: 1
  },
  diving_mask: {
    id: "diving_mask",
    name: "Diving Mask",
    keywords: [
      "sport",
      "ocean"
    ],
    skins: [
      {
        unified: "1f93f",
        native: "🤿"
      }
    ],
    version: 12
  },
  running_shirt_with_sash: {
    id: "running_shirt_with_sash",
    name: "Running Shirt",
    keywords: [
      "with",
      "sash",
      "play",
      "pageant"
    ],
    skins: [
      {
        unified: "1f3bd",
        native: "🎽"
      }
    ],
    version: 1
  },
  ski: {
    id: "ski",
    name: "Skis",
    keywords: [
      "ski",
      "sports",
      "winter",
      "cold",
      "snow"
    ],
    skins: [
      {
        unified: "1f3bf",
        native: "🎿"
      }
    ],
    version: 1
  },
  sled: {
    id: "sled",
    name: "Sled",
    keywords: [
      "sleigh",
      "luge",
      "toboggan"
    ],
    skins: [
      {
        unified: "1f6f7",
        native: "🛷"
      }
    ],
    version: 5
  },
  curling_stone: {
    id: "curling_stone",
    name: "Curling Stone",
    keywords: [
      "sports"
    ],
    skins: [
      {
        unified: "1f94c",
        native: "🥌"
      }
    ],
    version: 5
  },
  dart: {
    id: "dart",
    name: "Bullseye",
    keywords: [
      "dart",
      "direct",
      "hit",
      "game",
      "play",
      "bar",
      "target"
    ],
    skins: [
      {
        unified: "1f3af",
        native: "🎯"
      }
    ],
    version: 1
  },
  "yo-yo": {
    id: "yo-yo",
    name: "Yo-Yo",
    keywords: [
      "yo",
      "toy"
    ],
    skins: [
      {
        unified: "1fa80",
        native: "🪀"
      }
    ],
    version: 12
  },
  kite: {
    id: "kite",
    name: "Kite",
    keywords: [
      "wind",
      "fly"
    ],
    skins: [
      {
        unified: "1fa81",
        native: "🪁"
      }
    ],
    version: 12
  },
  "8ball": {
    id: "8ball",
    name: "Billiards",
    keywords: [
      "8ball",
      "pool",
      "8",
      "ball",
      "hobby",
      "game",
      "luck",
      "magic"
    ],
    skins: [
      {
        unified: "1f3b1",
        native: "🎱"
      }
    ],
    version: 1
  },
  crystal_ball: {
    id: "crystal_ball",
    name: "Crystal Ball",
    keywords: [
      "disco",
      "party",
      "magic",
      "circus",
      "fortune",
      "teller"
    ],
    skins: [
      {
        unified: "1f52e",
        native: "🔮"
      }
    ],
    version: 1
  },
  magic_wand: {
    id: "magic_wand",
    name: "Magic Wand",
    keywords: [
      "supernature",
      "power"
    ],
    skins: [
      {
        unified: "1fa84",
        native: "🪄"
      }
    ],
    version: 13
  },
  nazar_amulet: {
    id: "nazar_amulet",
    name: "Nazar Amulet",
    keywords: [
      "bead",
      "charm"
    ],
    skins: [
      {
        unified: "1f9ff",
        native: "🧿"
      }
    ],
    version: 11
  },
  hamsa: {
    id: "hamsa",
    name: "Hamsa",
    keywords: [
      "religion",
      "protection"
    ],
    skins: [
      {
        unified: "1faac",
        native: "🪬"
      }
    ],
    version: 14
  },
  video_game: {
    id: "video_game",
    name: "Video Game",
    keywords: [
      "play",
      "console",
      "PS4",
      "controller"
    ],
    skins: [
      {
        unified: "1f3ae",
        native: "🎮"
      }
    ],
    version: 1
  },
  joystick: {
    id: "joystick",
    name: "Joystick",
    keywords: [
      "game",
      "play"
    ],
    skins: [
      {
        unified: "1f579-fe0f",
        native: "🕹️"
      }
    ],
    version: 1
  },
  slot_machine: {
    id: "slot_machine",
    name: "Slot Machine",
    keywords: [
      "bet",
      "gamble",
      "vegas",
      "fruit",
      "luck",
      "casino"
    ],
    skins: [
      {
        unified: "1f3b0",
        native: "🎰"
      }
    ],
    version: 1
  },
  game_die: {
    id: "game_die",
    name: "Game Die",
    keywords: [
      "dice",
      "random",
      "tabletop",
      "play",
      "luck"
    ],
    skins: [
      {
        unified: "1f3b2",
        native: "🎲"
      }
    ],
    version: 1
  },
  jigsaw: {
    id: "jigsaw",
    name: "Puzzle Piece",
    keywords: [
      "jigsaw",
      "interlocking"
    ],
    skins: [
      {
        unified: "1f9e9",
        native: "🧩"
      }
    ],
    version: 11
  },
  teddy_bear: {
    id: "teddy_bear",
    name: "Teddy Bear",
    keywords: [
      "plush",
      "stuffed"
    ],
    skins: [
      {
        unified: "1f9f8",
        native: "🧸"
      }
    ],
    version: 11
  },
  pinata: {
    id: "pinata",
    name: "Pinata",
    keywords: [
      "mexico",
      "candy",
      "celebration"
    ],
    skins: [
      {
        unified: "1fa85",
        native: "🪅"
      }
    ],
    version: 13
  },
  mirror_ball: {
    id: "mirror_ball",
    name: "Mirror Ball",
    keywords: [
      "disco",
      "dance",
      "party"
    ],
    skins: [
      {
        unified: "1faa9",
        native: "🪩"
      }
    ],
    version: 14
  },
  nesting_dolls: {
    id: "nesting_dolls",
    name: "Nesting Dolls",
    keywords: [
      "matryoshka",
      "toy"
    ],
    skins: [
      {
        unified: "1fa86",
        native: "🪆"
      }
    ],
    version: 13
  },
  spades: {
    id: "spades",
    name: "Spade Suit",
    keywords: [
      "spades",
      "poker",
      "cards",
      "suits",
      "magic"
    ],
    skins: [
      {
        unified: "2660-fe0f",
        native: "♠️"
      }
    ],
    version: 1
  },
  hearts: {
    id: "hearts",
    name: "Heart Suit",
    keywords: [
      "hearts",
      "poker",
      "cards",
      "magic",
      "suits"
    ],
    skins: [
      {
        unified: "2665-fe0f",
        native: "♥️"
      }
    ],
    version: 1
  },
  diamonds: {
    id: "diamonds",
    name: "Diamond Suit",
    keywords: [
      "diamonds",
      "poker",
      "cards",
      "magic",
      "suits"
    ],
    skins: [
      {
        unified: "2666-fe0f",
        native: "♦️"
      }
    ],
    version: 1
  },
  clubs: {
    id: "clubs",
    name: "Club Suit",
    keywords: [
      "clubs",
      "poker",
      "cards",
      "magic",
      "suits"
    ],
    skins: [
      {
        unified: "2663-fe0f",
        native: "♣️"
      }
    ],
    version: 1
  },
  chess_pawn: {
    id: "chess_pawn",
    name: "Chess Pawn",
    keywords: [
      "expendable"
    ],
    skins: [
      {
        unified: "265f-fe0f",
        native: "♟️"
      }
    ],
    version: 11
  },
  black_joker: {
    id: "black_joker",
    name: "Joker",
    keywords: [
      "black",
      "poker",
      "cards",
      "game",
      "play",
      "magic"
    ],
    skins: [
      {
        unified: "1f0cf",
        native: "🃏"
      }
    ],
    version: 1
  },
  mahjong: {
    id: "mahjong",
    name: "Mahjong Red Dragon",
    keywords: [
      "game",
      "play",
      "chinese",
      "kanji"
    ],
    skins: [
      {
        unified: "1f004",
        native: "🀄"
      }
    ],
    version: 1
  },
  flower_playing_cards: {
    id: "flower_playing_cards",
    name: "Flower Playing Cards",
    keywords: [
      "game",
      "sunset",
      "red"
    ],
    skins: [
      {
        unified: "1f3b4",
        native: "🎴"
      }
    ],
    version: 1
  },
  performing_arts: {
    id: "performing_arts",
    name: "Performing Arts",
    keywords: [
      "acting",
      "theater",
      "drama"
    ],
    skins: [
      {
        unified: "1f3ad",
        native: "🎭"
      }
    ],
    version: 1
  },
  frame_with_picture: {
    id: "frame_with_picture",
    name: "Framed Picture",
    keywords: [
      "frame",
      "with",
      "photography"
    ],
    skins: [
      {
        unified: "1f5bc-fe0f",
        native: "🖼️"
      }
    ],
    version: 1
  },
  art: {
    id: "art",
    name: "Artist Palette",
    keywords: [
      "art",
      "design",
      "paint",
      "draw",
      "colors"
    ],
    skins: [
      {
        unified: "1f3a8",
        native: "🎨"
      }
    ],
    version: 1
  },
  thread: {
    id: "thread",
    name: "Thread",
    keywords: [
      "needle",
      "sewing",
      "spool",
      "string"
    ],
    skins: [
      {
        unified: "1f9f5",
        native: "🧵"
      }
    ],
    version: 11
  },
  sewing_needle: {
    id: "sewing_needle",
    name: "Sewing Needle",
    keywords: [
      "stitches"
    ],
    skins: [
      {
        unified: "1faa1",
        native: "🪡"
      }
    ],
    version: 13
  },
  yarn: {
    id: "yarn",
    name: "Yarn",
    keywords: [
      "ball",
      "crochet",
      "knit"
    ],
    skins: [
      {
        unified: "1f9f6",
        native: "🧶"
      }
    ],
    version: 11
  },
  knot: {
    id: "knot",
    name: "Knot",
    keywords: [
      "rope",
      "scout"
    ],
    skins: [
      {
        unified: "1faa2",
        native: "🪢"
      }
    ],
    version: 13
  },
  eyeglasses: {
    id: "eyeglasses",
    name: "Glasses",
    keywords: [
      "eyeglasses",
      "fashion",
      "accessories",
      "eyesight",
      "nerdy",
      "dork",
      "geek"
    ],
    skins: [
      {
        unified: "1f453",
        native: "👓"
      }
    ],
    version: 1
  },
  dark_sunglasses: {
    id: "dark_sunglasses",
    name: "Sunglasses",
    keywords: [
      "dark",
      "face",
      "cool",
      "accessories"
    ],
    skins: [
      {
        unified: "1f576-fe0f",
        native: "🕶️"
      }
    ],
    version: 1
  },
  goggles: {
    id: "goggles",
    name: "Goggles",
    keywords: [
      "eyes",
      "protection",
      "safety"
    ],
    skins: [
      {
        unified: "1f97d",
        native: "🥽"
      }
    ],
    version: 11
  },
  lab_coat: {
    id: "lab_coat",
    name: "Lab Coat",
    keywords: [
      "doctor",
      "experiment",
      "scientist",
      "chemist"
    ],
    skins: [
      {
        unified: "1f97c",
        native: "🥼"
      }
    ],
    version: 11
  },
  safety_vest: {
    id: "safety_vest",
    name: "Safety Vest",
    keywords: [
      "protection"
    ],
    skins: [
      {
        unified: "1f9ba",
        native: "🦺"
      }
    ],
    version: 12
  },
  necktie: {
    id: "necktie",
    name: "Necktie",
    keywords: [
      "shirt",
      "suitup",
      "formal",
      "fashion",
      "cloth",
      "business"
    ],
    skins: [
      {
        unified: "1f454",
        native: "👔"
      }
    ],
    version: 1
  },
  shirt: {
    id: "shirt",
    name: "T-Shirt",
    keywords: [
      "shirt",
      "tshirt",
      "t",
      "fashion",
      "cloth",
      "casual",
      "tee"
    ],
    skins: [
      {
        unified: "1f455",
        native: "👕"
      }
    ],
    version: 1
  },
  jeans: {
    id: "jeans",
    name: "Jeans",
    keywords: [
      "fashion",
      "shopping"
    ],
    skins: [
      {
        unified: "1f456",
        native: "👖"
      }
    ],
    version: 1
  },
  scarf: {
    id: "scarf",
    name: "Scarf",
    keywords: [
      "neck",
      "winter",
      "clothes"
    ],
    skins: [
      {
        unified: "1f9e3",
        native: "🧣"
      }
    ],
    version: 5
  },
  gloves: {
    id: "gloves",
    name: "Gloves",
    keywords: [
      "hands",
      "winter",
      "clothes"
    ],
    skins: [
      {
        unified: "1f9e4",
        native: "🧤"
      }
    ],
    version: 5
  },
  coat: {
    id: "coat",
    name: "Coat",
    keywords: [
      "jacket"
    ],
    skins: [
      {
        unified: "1f9e5",
        native: "🧥"
      }
    ],
    version: 5
  },
  socks: {
    id: "socks",
    name: "Socks",
    keywords: [
      "stockings",
      "clothes"
    ],
    skins: [
      {
        unified: "1f9e6",
        native: "🧦"
      }
    ],
    version: 5
  },
  dress: {
    id: "dress",
    name: "Dress",
    keywords: [
      "clothes",
      "fashion",
      "shopping"
    ],
    skins: [
      {
        unified: "1f457",
        native: "👗"
      }
    ],
    version: 1
  },
  kimono: {
    id: "kimono",
    name: "Kimono",
    keywords: [
      "dress",
      "fashion",
      "women",
      "female",
      "japanese"
    ],
    skins: [
      {
        unified: "1f458",
        native: "👘"
      }
    ],
    version: 1
  },
  sari: {
    id: "sari",
    name: "Sari",
    keywords: [
      "dress"
    ],
    skins: [
      {
        unified: "1f97b",
        native: "🥻"
      }
    ],
    version: 12
  },
  "one-piece_swimsuit": {
    id: "one-piece_swimsuit",
    name: "One-Piece Swimsuit",
    keywords: [
      "one",
      "piece",
      "fashion"
    ],
    skins: [
      {
        unified: "1fa71",
        native: "🩱"
      }
    ],
    version: 12
  },
  briefs: {
    id: "briefs",
    name: "Briefs",
    keywords: [
      "clothing"
    ],
    skins: [
      {
        unified: "1fa72",
        native: "🩲"
      }
    ],
    version: 12
  },
  shorts: {
    id: "shorts",
    name: "Shorts",
    keywords: [
      "clothing"
    ],
    skins: [
      {
        unified: "1fa73",
        native: "🩳"
      }
    ],
    version: 12
  },
  bikini: {
    id: "bikini",
    name: "Bikini",
    keywords: [
      "swimming",
      "female",
      "woman",
      "girl",
      "fashion",
      "beach",
      "summer"
    ],
    skins: [
      {
        unified: "1f459",
        native: "👙"
      }
    ],
    version: 1
  },
  womans_clothes: {
    id: "womans_clothes",
    name: "Womans Clothes",
    keywords: [
      "woman",
      "s",
      "fashion",
      "shopping",
      "bags",
      "female"
    ],
    skins: [
      {
        unified: "1f45a",
        native: "👚"
      }
    ],
    version: 1
  },
  purse: {
    id: "purse",
    name: "Purse",
    keywords: [
      "fashion",
      "accessories",
      "money",
      "sales",
      "shopping"
    ],
    skins: [
      {
        unified: "1f45b",
        native: "👛"
      }
    ],
    version: 1
  },
  handbag: {
    id: "handbag",
    name: "Handbag",
    keywords: [
      "fashion",
      "accessory",
      "accessories",
      "shopping"
    ],
    skins: [
      {
        unified: "1f45c",
        native: "👜"
      }
    ],
    version: 1
  },
  pouch: {
    id: "pouch",
    name: "Pouch",
    keywords: [
      "clutch",
      "bag",
      "accessories",
      "shopping"
    ],
    skins: [
      {
        unified: "1f45d",
        native: "👝"
      }
    ],
    version: 1
  },
  shopping_bags: {
    id: "shopping_bags",
    name: "Shopping Bags",
    keywords: [
      "mall",
      "buy",
      "purchase"
    ],
    skins: [
      {
        unified: "1f6cd-fe0f",
        native: "🛍️"
      }
    ],
    version: 1
  },
  school_satchel: {
    id: "school_satchel",
    name: "Backpack",
    keywords: [
      "school",
      "satchel",
      "student",
      "education",
      "bag"
    ],
    skins: [
      {
        unified: "1f392",
        native: "🎒"
      }
    ],
    version: 1
  },
  thong_sandal: {
    id: "thong_sandal",
    name: "Thong Sandal",
    keywords: [
      "footwear",
      "summer"
    ],
    skins: [
      {
        unified: "1fa74",
        native: "🩴"
      }
    ],
    version: 13
  },
  mans_shoe: {
    id: "mans_shoe",
    name: "Mans Shoe",
    keywords: [
      "man",
      "s",
      "fashion",
      "male"
    ],
    skins: [
      {
        unified: "1f45e",
        native: "👞"
      }
    ],
    version: 1
  },
  athletic_shoe: {
    id: "athletic_shoe",
    name: "Running Shoe",
    keywords: [
      "athletic",
      "shoes",
      "sports",
      "sneakers"
    ],
    skins: [
      {
        unified: "1f45f",
        native: "👟"
      }
    ],
    version: 1
  },
  hiking_boot: {
    id: "hiking_boot",
    name: "Hiking Boot",
    keywords: [
      "backpacking",
      "camping"
    ],
    skins: [
      {
        unified: "1f97e",
        native: "🥾"
      }
    ],
    version: 11
  },
  womans_flat_shoe: {
    id: "womans_flat_shoe",
    name: "Flat Shoe",
    keywords: [
      "womans",
      "ballet",
      "slip",
      "on",
      "slipper"
    ],
    skins: [
      {
        unified: "1f97f",
        native: "🥿"
      }
    ],
    version: 11
  },
  high_heel: {
    id: "high_heel",
    name: "High-Heeled Shoe",
    keywords: [
      "high",
      "heel",
      "heeled",
      "fashion",
      "shoes",
      "female",
      "pumps",
      "stiletto"
    ],
    skins: [
      {
        unified: "1f460",
        native: "👠"
      }
    ],
    version: 1
  },
  sandal: {
    id: "sandal",
    name: "Womans Sandal",
    keywords: [
      "woman",
      "s",
      "shoes",
      "fashion",
      "flip",
      "flops"
    ],
    skins: [
      {
        unified: "1f461",
        native: "👡"
      }
    ],
    version: 1
  },
  ballet_shoes: {
    id: "ballet_shoes",
    name: "Ballet Shoes",
    keywords: [
      "dance"
    ],
    skins: [
      {
        unified: "1fa70",
        native: "🩰"
      }
    ],
    version: 12
  },
  boot: {
    id: "boot",
    name: "Womans Boots",
    keywords: [
      "boot",
      "woman",
      "s",
      "shoes",
      "fashion"
    ],
    skins: [
      {
        unified: "1f462",
        native: "👢"
      }
    ],
    version: 1
  },
  crown: {
    id: "crown",
    name: "Crown",
    keywords: [
      "king",
      "kod",
      "leader",
      "royalty",
      "lord"
    ],
    skins: [
      {
        unified: "1f451",
        native: "👑"
      }
    ],
    version: 1
  },
  womans_hat: {
    id: "womans_hat",
    name: "Womans Hat",
    keywords: [
      "woman",
      "s",
      "fashion",
      "accessories",
      "female",
      "lady",
      "spring"
    ],
    skins: [
      {
        unified: "1f452",
        native: "👒"
      }
    ],
    version: 1
  },
  tophat: {
    id: "tophat",
    name: "Top Hat",
    keywords: [
      "tophat",
      "magic",
      "gentleman",
      "classy",
      "circus"
    ],
    skins: [
      {
        unified: "1f3a9",
        native: "🎩"
      }
    ],
    version: 1
  },
  mortar_board: {
    id: "mortar_board",
    name: "Graduation Cap",
    keywords: [
      "mortar",
      "board",
      "school",
      "college",
      "degree",
      "university",
      "hat",
      "legal",
      "learn",
      "education"
    ],
    skins: [
      {
        unified: "1f393",
        native: "🎓"
      }
    ],
    version: 1
  },
  billed_cap: {
    id: "billed_cap",
    name: "Billed Cap",
    keywords: [
      "baseball"
    ],
    skins: [
      {
        unified: "1f9e2",
        native: "🧢"
      }
    ],
    version: 5
  },
  military_helmet: {
    id: "military_helmet",
    name: "Military Helmet",
    keywords: [
      "army",
      "protection"
    ],
    skins: [
      {
        unified: "1fa96",
        native: "🪖"
      }
    ],
    version: 13
  },
  helmet_with_white_cross: {
    id: "helmet_with_white_cross",
    name: "Rescue Worker’s Helmet",
    keywords: [
      "with",
      "white",
      "cross",
      "worker",
      "s",
      "construction",
      "build"
    ],
    skins: [
      {
        unified: "26d1-fe0f",
        native: "⛑️"
      }
    ],
    version: 1
  },
  prayer_beads: {
    id: "prayer_beads",
    name: "Prayer Beads",
    keywords: [
      "dhikr",
      "religious"
    ],
    skins: [
      {
        unified: "1f4ff",
        native: "📿"
      }
    ],
    version: 1
  },
  lipstick: {
    id: "lipstick",
    name: "Lipstick",
    keywords: [
      "female",
      "girl",
      "fashion",
      "woman"
    ],
    skins: [
      {
        unified: "1f484",
        native: "💄"
      }
    ],
    version: 1
  },
  ring: {
    id: "ring",
    name: "Ring",
    keywords: [
      "wedding",
      "propose",
      "marriage",
      "valentines",
      "diamond",
      "fashion",
      "jewelry",
      "gem",
      "engagement"
    ],
    skins: [
      {
        unified: "1f48d",
        native: "💍"
      }
    ],
    version: 1
  },
  gem: {
    id: "gem",
    name: "Gem Stone",
    keywords: [
      "blue",
      "ruby",
      "diamond",
      "jewelry"
    ],
    skins: [
      {
        unified: "1f48e",
        native: "💎"
      }
    ],
    version: 1
  },
  mute: {
    id: "mute",
    name: "Muted Speaker",
    keywords: [
      "mute",
      "sound",
      "volume",
      "silence",
      "quiet"
    ],
    skins: [
      {
        unified: "1f507",
        native: "🔇"
      }
    ],
    version: 1
  },
  speaker: {
    id: "speaker",
    name: "Speaker",
    keywords: [
      "low",
      "volume",
      "sound",
      "silence",
      "broadcast"
    ],
    skins: [
      {
        unified: "1f508",
        native: "🔈"
      }
    ],
    version: 1
  },
  sound: {
    id: "sound",
    name: "Speaker Medium Volume",
    keywords: [
      "sound",
      "broadcast"
    ],
    skins: [
      {
        unified: "1f509",
        native: "🔉"
      }
    ],
    version: 1
  },
  loud_sound: {
    id: "loud_sound",
    name: "Speaker High Volume",
    keywords: [
      "loud",
      "sound",
      "noise",
      "noisy",
      "broadcast"
    ],
    skins: [
      {
        unified: "1f50a",
        native: "🔊"
      }
    ],
    version: 1
  },
  loudspeaker: {
    id: "loudspeaker",
    name: "Loudspeaker",
    keywords: [
      "volume",
      "sound"
    ],
    skins: [
      {
        unified: "1f4e2",
        native: "📢"
      }
    ],
    version: 1
  },
  mega: {
    id: "mega",
    name: "Megaphone",
    keywords: [
      "mega",
      "sound",
      "speaker",
      "volume"
    ],
    skins: [
      {
        unified: "1f4e3",
        native: "📣"
      }
    ],
    version: 1
  },
  postal_horn: {
    id: "postal_horn",
    name: "Postal Horn",
    keywords: [
      "instrument",
      "music"
    ],
    skins: [
      {
        unified: "1f4ef",
        native: "📯"
      }
    ],
    version: 1
  },
  bell: {
    id: "bell",
    name: "Bell",
    keywords: [
      "sound",
      "notification",
      "christmas",
      "xmas",
      "chime"
    ],
    skins: [
      {
        unified: "1f514",
        native: "🔔"
      }
    ],
    version: 1
  },
  no_bell: {
    id: "no_bell",
    name: "Bell with Slash",
    keywords: [
      "no",
      "sound",
      "volume",
      "mute",
      "quiet",
      "silent"
    ],
    skins: [
      {
        unified: "1f515",
        native: "🔕"
      }
    ],
    version: 1
  },
  musical_score: {
    id: "musical_score",
    name: "Musical Score",
    keywords: [
      "treble",
      "clef",
      "compose"
    ],
    skins: [
      {
        unified: "1f3bc",
        native: "🎼"
      }
    ],
    version: 1
  },
  musical_note: {
    id: "musical_note",
    name: "Musical Note",
    keywords: [
      "score",
      "tone",
      "sound"
    ],
    skins: [
      {
        unified: "1f3b5",
        native: "🎵"
      }
    ],
    version: 1
  },
  notes: {
    id: "notes",
    name: "Musical Notes",
    keywords: [
      "music",
      "score"
    ],
    skins: [
      {
        unified: "1f3b6",
        native: "🎶"
      }
    ],
    version: 1
  },
  studio_microphone: {
    id: "studio_microphone",
    name: "Studio Microphone",
    keywords: [
      "sing",
      "recording",
      "artist",
      "talkshow"
    ],
    skins: [
      {
        unified: "1f399-fe0f",
        native: "🎙️"
      }
    ],
    version: 1
  },
  level_slider: {
    id: "level_slider",
    name: "Level Slider",
    keywords: [
      "scale"
    ],
    skins: [
      {
        unified: "1f39a-fe0f",
        native: "🎚️"
      }
    ],
    version: 1
  },
  control_knobs: {
    id: "control_knobs",
    name: "Control Knobs",
    keywords: [
      "dial"
    ],
    skins: [
      {
        unified: "1f39b-fe0f",
        native: "🎛️"
      }
    ],
    version: 1
  },
  microphone: {
    id: "microphone",
    name: "Microphone",
    keywords: [
      "sound",
      "music",
      "PA",
      "sing",
      "talkshow"
    ],
    skins: [
      {
        unified: "1f3a4",
        native: "🎤"
      }
    ],
    version: 1
  },
  headphones: {
    id: "headphones",
    name: "Headphone",
    keywords: [
      "headphones",
      "music",
      "score",
      "gadgets"
    ],
    skins: [
      {
        unified: "1f3a7",
        native: "🎧"
      }
    ],
    version: 1
  },
  radio: {
    id: "radio",
    name: "Radio",
    keywords: [
      "communication",
      "music",
      "podcast",
      "program"
    ],
    skins: [
      {
        unified: "1f4fb",
        native: "📻"
      }
    ],
    version: 1
  },
  saxophone: {
    id: "saxophone",
    name: "Saxophone",
    keywords: [
      "music",
      "instrument",
      "jazz",
      "blues"
    ],
    skins: [
      {
        unified: "1f3b7",
        native: "🎷"
      }
    ],
    version: 1
  },
  accordion: {
    id: "accordion",
    name: "Accordion",
    keywords: [
      "music"
    ],
    skins: [
      {
        unified: "1fa97",
        native: "🪗"
      }
    ],
    version: 13
  },
  guitar: {
    id: "guitar",
    name: "Guitar",
    keywords: [
      "music",
      "instrument"
    ],
    skins: [
      {
        unified: "1f3b8",
        native: "🎸"
      }
    ],
    version: 1
  },
  musical_keyboard: {
    id: "musical_keyboard",
    name: "Musical Keyboard",
    keywords: [
      "piano",
      "instrument",
      "compose"
    ],
    skins: [
      {
        unified: "1f3b9",
        native: "🎹"
      }
    ],
    version: 1
  },
  trumpet: {
    id: "trumpet",
    name: "Trumpet",
    keywords: [
      "music",
      "brass"
    ],
    skins: [
      {
        unified: "1f3ba",
        native: "🎺"
      }
    ],
    version: 1
  },
  violin: {
    id: "violin",
    name: "Violin",
    keywords: [
      "music",
      "instrument",
      "orchestra",
      "symphony"
    ],
    skins: [
      {
        unified: "1f3bb",
        native: "🎻"
      }
    ],
    version: 1
  },
  banjo: {
    id: "banjo",
    name: "Banjo",
    keywords: [
      "music",
      "instructment"
    ],
    skins: [
      {
        unified: "1fa95",
        native: "🪕"
      }
    ],
    version: 12
  },
  drum_with_drumsticks: {
    id: "drum_with_drumsticks",
    name: "Drum",
    keywords: [
      "with",
      "drumsticks",
      "music",
      "instrument",
      "snare"
    ],
    skins: [
      {
        unified: "1f941",
        native: "🥁"
      }
    ],
    version: 3
  },
  long_drum: {
    id: "long_drum",
    name: "Long Drum",
    keywords: [
      "music"
    ],
    skins: [
      {
        unified: "1fa98",
        native: "🪘"
      }
    ],
    version: 13
  },
  iphone: {
    id: "iphone",
    name: "Mobile Phone",
    keywords: [
      "iphone",
      "technology",
      "apple",
      "gadgets",
      "dial"
    ],
    skins: [
      {
        unified: "1f4f1",
        native: "📱"
      }
    ],
    version: 1
  },
  calling: {
    id: "calling",
    name: "Mobile Phone with Arrow",
    keywords: [
      "calling",
      "iphone",
      "incoming"
    ],
    skins: [
      {
        unified: "1f4f2",
        native: "📲"
      }
    ],
    version: 1
  },
  phone: {
    id: "phone",
    name: "Telephone",
    keywords: [
      "phone",
      "technology",
      "communication",
      "dial"
    ],
    skins: [
      {
        unified: "260e-fe0f",
        native: "☎️"
      }
    ],
    version: 1
  },
  telephone_receiver: {
    id: "telephone_receiver",
    name: "Telephone Receiver",
    keywords: [
      "technology",
      "communication",
      "dial"
    ],
    skins: [
      {
        unified: "1f4de",
        native: "📞"
      }
    ],
    version: 1
  },
  pager: {
    id: "pager",
    name: "Pager",
    keywords: [
      "bbcall",
      "oldschool",
      "90s"
    ],
    skins: [
      {
        unified: "1f4df",
        native: "📟"
      }
    ],
    version: 1
  },
  fax: {
    id: "fax",
    name: "Fax Machine",
    keywords: [
      "communication",
      "technology"
    ],
    skins: [
      {
        unified: "1f4e0",
        native: "📠"
      }
    ],
    version: 1
  },
  battery: {
    id: "battery",
    name: "Battery",
    keywords: [
      "power",
      "energy",
      "sustain"
    ],
    skins: [
      {
        unified: "1f50b",
        native: "🔋"
      }
    ],
    version: 1
  },
  low_battery: {
    id: "low_battery",
    name: "Low Battery",
    keywords: [
      "drained",
      "dead"
    ],
    skins: [
      {
        unified: "1faab",
        native: "🪫"
      }
    ],
    version: 14
  },
  electric_plug: {
    id: "electric_plug",
    name: "Electric Plug",
    keywords: [
      "charger",
      "power"
    ],
    skins: [
      {
        unified: "1f50c",
        native: "🔌"
      }
    ],
    version: 1
  },
  computer: {
    id: "computer",
    name: "Laptop",
    keywords: [
      "computer",
      "technology",
      "screen",
      "display",
      "monitor"
    ],
    skins: [
      {
        unified: "1f4bb",
        native: "💻"
      }
    ],
    version: 1
  },
  desktop_computer: {
    id: "desktop_computer",
    name: "Desktop Computer",
    keywords: [
      "technology",
      "computing",
      "screen"
    ],
    skins: [
      {
        unified: "1f5a5-fe0f",
        native: "🖥️"
      }
    ],
    version: 1
  },
  printer: {
    id: "printer",
    name: "Printer",
    keywords: [
      "paper",
      "ink"
    ],
    skins: [
      {
        unified: "1f5a8-fe0f",
        native: "🖨️"
      }
    ],
    version: 1
  },
  keyboard: {
    id: "keyboard",
    name: "Keyboard",
    keywords: [
      "technology",
      "computer",
      "type",
      "input",
      "text"
    ],
    skins: [
      {
        unified: "2328-fe0f",
        native: "⌨️"
      }
    ],
    version: 1
  },
  three_button_mouse: {
    id: "three_button_mouse",
    name: "Computer Mouse",
    keywords: [
      "three",
      "button",
      "click"
    ],
    skins: [
      {
        unified: "1f5b1-fe0f",
        native: "🖱️"
      }
    ],
    version: 1
  },
  trackball: {
    id: "trackball",
    name: "Trackball",
    keywords: [
      "technology",
      "trackpad"
    ],
    skins: [
      {
        unified: "1f5b2-fe0f",
        native: "🖲️"
      }
    ],
    version: 1
  },
  minidisc: {
    id: "minidisc",
    name: "Minidisc",
    keywords: [
      "computer",
      "disk",
      "technology",
      "record",
      "data",
      "90s"
    ],
    skins: [
      {
        unified: "1f4bd",
        native: "💽"
      }
    ],
    version: 1
  },
  floppy_disk: {
    id: "floppy_disk",
    name: "Floppy Disk",
    keywords: [
      "oldschool",
      "technology",
      "save",
      "90s",
      "80s"
    ],
    skins: [
      {
        unified: "1f4be",
        native: "💾"
      }
    ],
    version: 1
  },
  cd: {
    id: "cd",
    name: "Optical Disc",
    keywords: [
      "cd",
      "disk",
      "technology",
      "dvd",
      "90s"
    ],
    skins: [
      {
        unified: "1f4bf",
        native: "💿"
      }
    ],
    version: 1
  },
  dvd: {
    id: "dvd",
    name: "Dvd",
    keywords: [
      "cd",
      "disk",
      "disc"
    ],
    skins: [
      {
        unified: "1f4c0",
        native: "📀"
      }
    ],
    version: 1
  },
  abacus: {
    id: "abacus",
    name: "Abacus",
    keywords: [
      "calculation"
    ],
    skins: [
      {
        unified: "1f9ee",
        native: "🧮"
      }
    ],
    version: 11
  },
  movie_camera: {
    id: "movie_camera",
    name: "Movie Camera",
    keywords: [
      "film",
      "record"
    ],
    skins: [
      {
        unified: "1f3a5",
        native: "🎥"
      }
    ],
    version: 1
  },
  film_frames: {
    id: "film_frames",
    name: "Film Frames",
    keywords: [
      "movie"
    ],
    skins: [
      {
        unified: "1f39e-fe0f",
        native: "🎞️"
      }
    ],
    version: 1
  },
  film_projector: {
    id: "film_projector",
    name: "Film Projector",
    keywords: [
      "video",
      "tape",
      "record",
      "movie"
    ],
    skins: [
      {
        unified: "1f4fd-fe0f",
        native: "📽️"
      }
    ],
    version: 1
  },
  clapper: {
    id: "clapper",
    name: "Clapper Board",
    keywords: [
      "movie",
      "film",
      "record"
    ],
    skins: [
      {
        unified: "1f3ac",
        native: "🎬"
      }
    ],
    version: 1
  },
  tv: {
    id: "tv",
    name: "Television",
    keywords: [
      "tv",
      "technology",
      "program",
      "oldschool",
      "show"
    ],
    skins: [
      {
        unified: "1f4fa",
        native: "📺"
      }
    ],
    version: 1
  },
  camera: {
    id: "camera",
    name: "Camera",
    keywords: [
      "gadgets",
      "photography"
    ],
    skins: [
      {
        unified: "1f4f7",
        native: "📷"
      }
    ],
    version: 1
  },
  camera_with_flash: {
    id: "camera_with_flash",
    name: "Camera with Flash",
    keywords: [
      "photography",
      "gadgets"
    ],
    skins: [
      {
        unified: "1f4f8",
        native: "📸"
      }
    ],
    version: 1
  },
  video_camera: {
    id: "video_camera",
    name: "Video Camera",
    keywords: [
      "film",
      "record"
    ],
    skins: [
      {
        unified: "1f4f9",
        native: "📹"
      }
    ],
    version: 1
  },
  vhs: {
    id: "vhs",
    name: "Videocassette",
    keywords: [
      "vhs",
      "record",
      "video",
      "oldschool",
      "90s",
      "80s"
    ],
    skins: [
      {
        unified: "1f4fc",
        native: "📼"
      }
    ],
    version: 1
  },
  mag: {
    id: "mag",
    name: "Magnifying Glass Tilted Left",
    keywords: [
      "mag",
      "search",
      "zoom",
      "find",
      "detective"
    ],
    skins: [
      {
        unified: "1f50d",
        native: "🔍"
      }
    ],
    version: 1
  },
  mag_right: {
    id: "mag_right",
    name: "Magnifying Glass Tilted Right",
    keywords: [
      "mag",
      "search",
      "zoom",
      "find",
      "detective"
    ],
    skins: [
      {
        unified: "1f50e",
        native: "🔎"
      }
    ],
    version: 1
  },
  candle: {
    id: "candle",
    name: "Candle",
    keywords: [
      "fire",
      "wax"
    ],
    skins: [
      {
        unified: "1f56f-fe0f",
        native: "🕯️"
      }
    ],
    version: 1
  },
  bulb: {
    id: "bulb",
    name: "Light Bulb",
    keywords: [
      "electricity",
      "idea"
    ],
    skins: [
      {
        unified: "1f4a1",
        native: "💡"
      }
    ],
    version: 1
  },
  flashlight: {
    id: "flashlight",
    name: "Flashlight",
    keywords: [
      "dark",
      "camping",
      "sight",
      "night"
    ],
    skins: [
      {
        unified: "1f526",
        native: "🔦"
      }
    ],
    version: 1
  },
  izakaya_lantern: {
    id: "izakaya_lantern",
    name: "Izakaya Lantern",
    keywords: [
      "red",
      "paper",
      "light",
      "halloween",
      "spooky"
    ],
    skins: [
      {
        unified: "1f3ee",
        native: "🏮"
      }
    ],
    version: 1
  },
  diya_lamp: {
    id: "diya_lamp",
    name: "Diya Lamp",
    keywords: [
      "lighting"
    ],
    skins: [
      {
        unified: "1fa94",
        native: "🪔"
      }
    ],
    version: 12
  },
  notebook_with_decorative_cover: {
    id: "notebook_with_decorative_cover",
    name: "Notebook with Decorative Cover",
    keywords: [
      "classroom",
      "notes",
      "record",
      "paper",
      "study"
    ],
    skins: [
      {
        unified: "1f4d4",
        native: "📔"
      }
    ],
    version: 1
  },
  closed_book: {
    id: "closed_book",
    name: "Closed Book",
    keywords: [
      "read",
      "library",
      "knowledge",
      "textbook",
      "learn"
    ],
    skins: [
      {
        unified: "1f4d5",
        native: "📕"
      }
    ],
    version: 1
  },
  book: {
    id: "book",
    name: "Open Book",
    keywords: [
      "read",
      "library",
      "knowledge",
      "literature",
      "learn",
      "study"
    ],
    skins: [
      {
        unified: "1f4d6",
        native: "📖"
      }
    ],
    version: 1
  },
  green_book: {
    id: "green_book",
    name: "Green Book",
    keywords: [
      "read",
      "library",
      "knowledge",
      "study"
    ],
    skins: [
      {
        unified: "1f4d7",
        native: "📗"
      }
    ],
    version: 1
  },
  blue_book: {
    id: "blue_book",
    name: "Blue Book",
    keywords: [
      "read",
      "library",
      "knowledge",
      "learn",
      "study"
    ],
    skins: [
      {
        unified: "1f4d8",
        native: "📘"
      }
    ],
    version: 1
  },
  orange_book: {
    id: "orange_book",
    name: "Orange Book",
    keywords: [
      "read",
      "library",
      "knowledge",
      "textbook",
      "study"
    ],
    skins: [
      {
        unified: "1f4d9",
        native: "📙"
      }
    ],
    version: 1
  },
  books: {
    id: "books",
    name: "Books",
    keywords: [
      "literature",
      "library",
      "study"
    ],
    skins: [
      {
        unified: "1f4da",
        native: "📚"
      }
    ],
    version: 1
  },
  notebook: {
    id: "notebook",
    name: "Notebook",
    keywords: [
      "stationery",
      "record",
      "notes",
      "paper",
      "study"
    ],
    skins: [
      {
        unified: "1f4d3",
        native: "📓"
      }
    ],
    version: 1
  },
  ledger: {
    id: "ledger",
    name: "Ledger",
    keywords: [
      "notes",
      "paper"
    ],
    skins: [
      {
        unified: "1f4d2",
        native: "📒"
      }
    ],
    version: 1
  },
  page_with_curl: {
    id: "page_with_curl",
    name: "Page with Curl",
    keywords: [
      "documents",
      "office",
      "paper"
    ],
    skins: [
      {
        unified: "1f4c3",
        native: "📃"
      }
    ],
    version: 1
  },
  scroll: {
    id: "scroll",
    name: "Scroll",
    keywords: [
      "documents",
      "ancient",
      "history",
      "paper"
    ],
    skins: [
      {
        unified: "1f4dc",
        native: "📜"
      }
    ],
    version: 1
  },
  page_facing_up: {
    id: "page_facing_up",
    name: "Page Facing Up",
    keywords: [
      "documents",
      "office",
      "paper",
      "information"
    ],
    skins: [
      {
        unified: "1f4c4",
        native: "📄"
      }
    ],
    version: 1
  },
  newspaper: {
    id: "newspaper",
    name: "Newspaper",
    keywords: [
      "press",
      "headline"
    ],
    skins: [
      {
        unified: "1f4f0",
        native: "📰"
      }
    ],
    version: 1
  },
  rolled_up_newspaper: {
    id: "rolled_up_newspaper",
    name: "Rolled-Up Newspaper",
    keywords: [
      "rolled",
      "up",
      "press",
      "headline"
    ],
    skins: [
      {
        unified: "1f5de-fe0f",
        native: "🗞️"
      }
    ],
    version: 1
  },
  bookmark_tabs: {
    id: "bookmark_tabs",
    name: "Bookmark Tabs",
    keywords: [
      "favorite",
      "save",
      "order",
      "tidy"
    ],
    skins: [
      {
        unified: "1f4d1",
        native: "📑"
      }
    ],
    version: 1
  },
  bookmark: {
    id: "bookmark",
    name: "Bookmark",
    keywords: [
      "favorite",
      "label",
      "save"
    ],
    skins: [
      {
        unified: "1f516",
        native: "🔖"
      }
    ],
    version: 1
  },
  label: {
    id: "label",
    name: "Label",
    keywords: [
      "sale",
      "tag"
    ],
    skins: [
      {
        unified: "1f3f7-fe0f",
        native: "🏷️"
      }
    ],
    version: 1
  },
  moneybag: {
    id: "moneybag",
    name: "Money Bag",
    keywords: [
      "moneybag",
      "dollar",
      "payment",
      "coins",
      "sale"
    ],
    skins: [
      {
        unified: "1f4b0",
        native: "💰"
      }
    ],
    version: 1
  },
  coin: {
    id: "coin",
    name: "Coin",
    keywords: [
      "money",
      "currency"
    ],
    skins: [
      {
        unified: "1fa99",
        native: "🪙"
      }
    ],
    version: 13
  },
  yen: {
    id: "yen",
    name: "Yen Banknote",
    keywords: [
      "money",
      "sales",
      "japanese",
      "dollar",
      "currency"
    ],
    skins: [
      {
        unified: "1f4b4",
        native: "💴"
      }
    ],
    version: 1
  },
  dollar: {
    id: "dollar",
    name: "Dollar Banknote",
    keywords: [
      "money",
      "sales",
      "bill",
      "currency"
    ],
    skins: [
      {
        unified: "1f4b5",
        native: "💵"
      }
    ],
    version: 1
  },
  euro: {
    id: "euro",
    name: "Euro Banknote",
    keywords: [
      "money",
      "sales",
      "dollar",
      "currency"
    ],
    skins: [
      {
        unified: "1f4b6",
        native: "💶"
      }
    ],
    version: 1
  },
  pound: {
    id: "pound",
    name: "Pound Banknote",
    keywords: [
      "british",
      "sterling",
      "money",
      "sales",
      "bills",
      "uk",
      "england",
      "currency"
    ],
    skins: [
      {
        unified: "1f4b7",
        native: "💷"
      }
    ],
    version: 1
  },
  money_with_wings: {
    id: "money_with_wings",
    name: "Money with Wings",
    keywords: [
      "dollar",
      "bills",
      "payment",
      "sale"
    ],
    skins: [
      {
        unified: "1f4b8",
        native: "💸"
      }
    ],
    version: 1
  },
  credit_card: {
    id: "credit_card",
    name: "Credit Card",
    keywords: [
      "money",
      "sales",
      "dollar",
      "bill",
      "payment",
      "shopping"
    ],
    skins: [
      {
        unified: "1f4b3",
        native: "💳"
      }
    ],
    version: 1
  },
  receipt: {
    id: "receipt",
    name: "Receipt",
    keywords: [
      "accounting",
      "expenses"
    ],
    skins: [
      {
        unified: "1f9fe",
        native: "🧾"
      }
    ],
    version: 11
  },
  chart: {
    id: "chart",
    name: "Chart Increasing with Yen",
    keywords: [
      "green",
      "square",
      "graph",
      "presentation",
      "stats"
    ],
    skins: [
      {
        unified: "1f4b9",
        native: "💹"
      }
    ],
    version: 1
  },
  email: {
    id: "email",
    name: "Envelope",
    keywords: [
      "email",
      "letter",
      "postal",
      "inbox",
      "communication"
    ],
    skins: [
      {
        unified: "2709-fe0f",
        native: "✉️"
      }
    ],
    version: 1
  },
  "e-mail": {
    id: "e-mail",
    name: "E-Mail",
    keywords: [
      "e",
      "mail",
      "communication",
      "inbox"
    ],
    skins: [
      {
        unified: "1f4e7",
        native: "📧"
      }
    ],
    version: 1
  },
  incoming_envelope: {
    id: "incoming_envelope",
    name: "Incoming Envelope",
    keywords: [
      "email",
      "inbox"
    ],
    skins: [
      {
        unified: "1f4e8",
        native: "📨"
      }
    ],
    version: 1
  },
  envelope_with_arrow: {
    id: "envelope_with_arrow",
    name: "Envelope with Arrow",
    keywords: [
      "email",
      "communication"
    ],
    skins: [
      {
        unified: "1f4e9",
        native: "📩"
      }
    ],
    version: 1
  },
  outbox_tray: {
    id: "outbox_tray",
    name: "Outbox Tray",
    keywords: [
      "inbox",
      "email"
    ],
    skins: [
      {
        unified: "1f4e4",
        native: "📤"
      }
    ],
    version: 1
  },
  inbox_tray: {
    id: "inbox_tray",
    name: "Inbox Tray",
    keywords: [
      "email",
      "documents"
    ],
    skins: [
      {
        unified: "1f4e5",
        native: "📥"
      }
    ],
    version: 1
  },
  package: {
    id: "package",
    name: "Package",
    keywords: [
      "mail",
      "gift",
      "cardboard",
      "box",
      "moving"
    ],
    skins: [
      {
        unified: "1f4e6",
        native: "📦"
      }
    ],
    version: 1
  },
  mailbox: {
    id: "mailbox",
    name: "Closed Mailbox with Raised Flag",
    keywords: [
      "email",
      "inbox",
      "communication"
    ],
    skins: [
      {
        unified: "1f4eb",
        native: "📫"
      }
    ],
    version: 1
  },
  mailbox_closed: {
    id: "mailbox_closed",
    name: "Closed Mailbox with Lowered Flag",
    keywords: [
      "email",
      "communication",
      "inbox"
    ],
    skins: [
      {
        unified: "1f4ea",
        native: "📪"
      }
    ],
    version: 1
  },
  mailbox_with_mail: {
    id: "mailbox_with_mail",
    name: "Open Mailbox with Raised Flag",
    keywords: [
      "mail",
      "email",
      "inbox",
      "communication"
    ],
    skins: [
      {
        unified: "1f4ec",
        native: "📬"
      }
    ],
    version: 1
  },
  mailbox_with_no_mail: {
    id: "mailbox_with_no_mail",
    name: "Open Mailbox with Lowered Flag",
    keywords: [
      "no",
      "mail",
      "email",
      "inbox"
    ],
    skins: [
      {
        unified: "1f4ed",
        native: "📭"
      }
    ],
    version: 1
  },
  postbox: {
    id: "postbox",
    name: "Postbox",
    keywords: [
      "email",
      "letter",
      "envelope"
    ],
    skins: [
      {
        unified: "1f4ee",
        native: "📮"
      }
    ],
    version: 1
  },
  ballot_box_with_ballot: {
    id: "ballot_box_with_ballot",
    name: "Ballot Box with Ballot",
    keywords: [
      "election",
      "vote"
    ],
    skins: [
      {
        unified: "1f5f3-fe0f",
        native: "🗳️"
      }
    ],
    version: 1
  },
  pencil2: {
    id: "pencil2",
    name: "Pencil",
    keywords: [
      "pencil2",
      "stationery",
      "write",
      "paper",
      "writing",
      "school",
      "study"
    ],
    skins: [
      {
        unified: "270f-fe0f",
        native: "✏️"
      }
    ],
    version: 1
  },
  black_nib: {
    id: "black_nib",
    name: "Black Nib",
    keywords: [
      "pen",
      "stationery",
      "writing",
      "write"
    ],
    skins: [
      {
        unified: "2712-fe0f",
        native: "✒️"
      }
    ],
    version: 1
  },
  lower_left_fountain_pen: {
    id: "lower_left_fountain_pen",
    name: "Fountain Pen",
    keywords: [
      "lower",
      "left",
      "stationery",
      "writing",
      "write"
    ],
    skins: [
      {
        unified: "1f58b-fe0f",
        native: "🖋️"
      }
    ],
    version: 1
  },
  lower_left_ballpoint_pen: {
    id: "lower_left_ballpoint_pen",
    name: "Pen",
    keywords: [
      "lower",
      "left",
      "ballpoint",
      "stationery",
      "writing",
      "write"
    ],
    skins: [
      {
        unified: "1f58a-fe0f",
        native: "🖊️"
      }
    ],
    version: 1
  },
  lower_left_paintbrush: {
    id: "lower_left_paintbrush",
    name: "Paintbrush",
    keywords: [
      "lower",
      "left",
      "drawing",
      "creativity",
      "art"
    ],
    skins: [
      {
        unified: "1f58c-fe0f",
        native: "🖌️"
      }
    ],
    version: 1
  },
  lower_left_crayon: {
    id: "lower_left_crayon",
    name: "Crayon",
    keywords: [
      "lower",
      "left",
      "drawing",
      "creativity"
    ],
    skins: [
      {
        unified: "1f58d-fe0f",
        native: "🖍️"
      }
    ],
    version: 1
  },
  memo: {
    id: "memo",
    name: "Memo",
    keywords: [
      "pencil",
      "write",
      "documents",
      "stationery",
      "paper",
      "writing",
      "legal",
      "exam",
      "quiz",
      "test",
      "study",
      "compose"
    ],
    skins: [
      {
        unified: "1f4dd",
        native: "📝"
      }
    ],
    version: 1
  },
  briefcase: {
    id: "briefcase",
    name: "Briefcase",
    keywords: [
      "business",
      "documents",
      "work",
      "law",
      "legal",
      "job",
      "career"
    ],
    skins: [
      {
        unified: "1f4bc",
        native: "💼"
      }
    ],
    version: 1
  },
  file_folder: {
    id: "file_folder",
    name: "File Folder",
    keywords: [
      "documents",
      "business",
      "office"
    ],
    skins: [
      {
        unified: "1f4c1",
        native: "📁"
      }
    ],
    version: 1
  },
  open_file_folder: {
    id: "open_file_folder",
    name: "Open File Folder",
    keywords: [
      "documents",
      "load"
    ],
    skins: [
      {
        unified: "1f4c2",
        native: "📂"
      }
    ],
    version: 1
  },
  card_index_dividers: {
    id: "card_index_dividers",
    name: "Card Index Dividers",
    keywords: [
      "organizing",
      "business",
      "stationery"
    ],
    skins: [
      {
        unified: "1f5c2-fe0f",
        native: "🗂️"
      }
    ],
    version: 1
  },
  date: {
    id: "date",
    name: "Calendar",
    keywords: [
      "date",
      "schedule"
    ],
    skins: [
      {
        unified: "1f4c5",
        native: "📅"
      }
    ],
    version: 1
  },
  calendar: {
    id: "calendar",
    name: "Tear-off Calendar",
    keywords: [
      "tear",
      "off",
      "schedule",
      "date",
      "planning"
    ],
    skins: [
      {
        unified: "1f4c6",
        native: "📆"
      }
    ],
    version: 1
  },
  spiral_note_pad: {
    id: "spiral_note_pad",
    name: "Spiral Notepad",
    keywords: [
      "note",
      "pad",
      "memo",
      "stationery"
    ],
    skins: [
      {
        unified: "1f5d2-fe0f",
        native: "🗒️"
      }
    ],
    version: 1
  },
  spiral_calendar_pad: {
    id: "spiral_calendar_pad",
    name: "Spiral Calendar",
    keywords: [
      "pad",
      "date",
      "schedule",
      "planning"
    ],
    skins: [
      {
        unified: "1f5d3-fe0f",
        native: "🗓️"
      }
    ],
    version: 1
  },
  card_index: {
    id: "card_index",
    name: "Card Index",
    keywords: [
      "business",
      "stationery"
    ],
    skins: [
      {
        unified: "1f4c7",
        native: "📇"
      }
    ],
    version: 1
  },
  chart_with_upwards_trend: {
    id: "chart_with_upwards_trend",
    name: "Chart Increasing",
    keywords: [
      "with",
      "upwards",
      "trend",
      "graph",
      "presentation",
      "stats",
      "recovery",
      "business",
      "economics",
      "money",
      "sales",
      "good",
      "success"
    ],
    skins: [
      {
        unified: "1f4c8",
        native: "📈"
      }
    ],
    version: 1
  },
  chart_with_downwards_trend: {
    id: "chart_with_downwards_trend",
    name: "Chart Decreasing",
    keywords: [
      "with",
      "downwards",
      "trend",
      "graph",
      "presentation",
      "stats",
      "recession",
      "business",
      "economics",
      "money",
      "sales",
      "bad",
      "failure"
    ],
    skins: [
      {
        unified: "1f4c9",
        native: "📉"
      }
    ],
    version: 1
  },
  bar_chart: {
    id: "bar_chart",
    name: "Bar Chart",
    keywords: [
      "graph",
      "presentation",
      "stats"
    ],
    skins: [
      {
        unified: "1f4ca",
        native: "📊"
      }
    ],
    version: 1
  },
  clipboard: {
    id: "clipboard",
    name: "Clipboard",
    keywords: [
      "stationery",
      "documents"
    ],
    skins: [
      {
        unified: "1f4cb",
        native: "📋"
      }
    ],
    version: 1
  },
  pushpin: {
    id: "pushpin",
    name: "Pushpin",
    keywords: [
      "stationery",
      "mark",
      "here"
    ],
    skins: [
      {
        unified: "1f4cc",
        native: "📌"
      }
    ],
    version: 1
  },
  round_pushpin: {
    id: "round_pushpin",
    name: "Round Pushpin",
    keywords: [
      "stationery",
      "location",
      "map",
      "here"
    ],
    skins: [
      {
        unified: "1f4cd",
        native: "📍"
      }
    ],
    version: 1
  },
  paperclip: {
    id: "paperclip",
    name: "Paperclip",
    keywords: [
      "documents",
      "stationery"
    ],
    skins: [
      {
        unified: "1f4ce",
        native: "📎"
      }
    ],
    version: 1
  },
  linked_paperclips: {
    id: "linked_paperclips",
    name: "Linked Paperclips",
    keywords: [
      "documents",
      "stationery"
    ],
    skins: [
      {
        unified: "1f587-fe0f",
        native: "🖇️"
      }
    ],
    version: 1
  },
  straight_ruler: {
    id: "straight_ruler",
    name: "Straight Ruler",
    keywords: [
      "stationery",
      "calculate",
      "length",
      "math",
      "school",
      "drawing",
      "architect",
      "sketch"
    ],
    skins: [
      {
        unified: "1f4cf",
        native: "📏"
      }
    ],
    version: 1
  },
  triangular_ruler: {
    id: "triangular_ruler",
    name: "Triangular Ruler",
    keywords: [
      "stationery",
      "math",
      "architect",
      "sketch"
    ],
    skins: [
      {
        unified: "1f4d0",
        native: "📐"
      }
    ],
    version: 1
  },
  scissors: {
    id: "scissors",
    name: "Scissors",
    keywords: [
      "stationery",
      "cut"
    ],
    skins: [
      {
        unified: "2702-fe0f",
        native: "✂️"
      }
    ],
    version: 1
  },
  card_file_box: {
    id: "card_file_box",
    name: "Card File Box",
    keywords: [
      "business",
      "stationery"
    ],
    skins: [
      {
        unified: "1f5c3-fe0f",
        native: "🗃️"
      }
    ],
    version: 1
  },
  file_cabinet: {
    id: "file_cabinet",
    name: "File Cabinet",
    keywords: [
      "filing",
      "organizing"
    ],
    skins: [
      {
        unified: "1f5c4-fe0f",
        native: "🗄️"
      }
    ],
    version: 1
  },
  wastebasket: {
    id: "wastebasket",
    name: "Wastebasket",
    keywords: [
      "bin",
      "trash",
      "rubbish",
      "garbage",
      "toss"
    ],
    skins: [
      {
        unified: "1f5d1-fe0f",
        native: "🗑️"
      }
    ],
    version: 1
  },
  lock: {
    id: "lock",
    name: "Lock",
    keywords: [
      "locked",
      "security",
      "password",
      "padlock"
    ],
    skins: [
      {
        unified: "1f512",
        native: "🔒"
      }
    ],
    version: 1
  },
  unlock: {
    id: "unlock",
    name: "Unlocked",
    keywords: [
      "unlock",
      "privacy",
      "security"
    ],
    skins: [
      {
        unified: "1f513",
        native: "🔓"
      }
    ],
    version: 1
  },
  lock_with_ink_pen: {
    id: "lock_with_ink_pen",
    name: "Locked with Pen",
    keywords: [
      "lock",
      "ink",
      "security",
      "secret"
    ],
    skins: [
      {
        unified: "1f50f",
        native: "🔏"
      }
    ],
    version: 1
  },
  closed_lock_with_key: {
    id: "closed_lock_with_key",
    name: "Locked with Key",
    keywords: [
      "closed",
      "lock",
      "security",
      "privacy"
    ],
    skins: [
      {
        unified: "1f510",
        native: "🔐"
      }
    ],
    version: 1
  },
  key: {
    id: "key",
    name: "Key",
    keywords: [
      "lock",
      "door",
      "password"
    ],
    skins: [
      {
        unified: "1f511",
        native: "🔑"
      }
    ],
    version: 1
  },
  old_key: {
    id: "old_key",
    name: "Old Key",
    keywords: [
      "lock",
      "door",
      "password"
    ],
    skins: [
      {
        unified: "1f5dd-fe0f",
        native: "🗝️"
      }
    ],
    version: 1
  },
  hammer: {
    id: "hammer",
    name: "Hammer",
    keywords: [
      "tools",
      "build",
      "create"
    ],
    skins: [
      {
        unified: "1f528",
        native: "🔨"
      }
    ],
    version: 1
  },
  axe: {
    id: "axe",
    name: "Axe",
    keywords: [
      "tool",
      "chop",
      "cut"
    ],
    skins: [
      {
        unified: "1fa93",
        native: "🪓"
      }
    ],
    version: 12
  },
  pick: {
    id: "pick",
    name: "Pick",
    keywords: [
      "tools",
      "dig"
    ],
    skins: [
      {
        unified: "26cf-fe0f",
        native: "⛏️"
      }
    ],
    version: 1
  },
  hammer_and_pick: {
    id: "hammer_and_pick",
    name: "Hammer and Pick",
    keywords: [
      "tools",
      "build",
      "create"
    ],
    skins: [
      {
        unified: "2692-fe0f",
        native: "⚒️"
      }
    ],
    version: 1
  },
  hammer_and_wrench: {
    id: "hammer_and_wrench",
    name: "Hammer and Wrench",
    keywords: [
      "tools",
      "build",
      "create"
    ],
    skins: [
      {
        unified: "1f6e0-fe0f",
        native: "🛠️"
      }
    ],
    version: 1
  },
  dagger_knife: {
    id: "dagger_knife",
    name: "Dagger",
    keywords: [
      "knife",
      "weapon"
    ],
    skins: [
      {
        unified: "1f5e1-fe0f",
        native: "🗡️"
      }
    ],
    version: 1
  },
  crossed_swords: {
    id: "crossed_swords",
    name: "Crossed Swords",
    keywords: [
      "weapon"
    ],
    skins: [
      {
        unified: "2694-fe0f",
        native: "⚔️"
      }
    ],
    version: 1
  },
  gun: {
    id: "gun",
    name: "Pistol",
    keywords: [
      "gun",
      "violence",
      "weapon",
      "revolver"
    ],
    skins: [
      {
        unified: "1f52b",
        native: "🔫"
      }
    ],
    version: 1
  },
  boomerang: {
    id: "boomerang",
    name: "Boomerang",
    keywords: [
      "weapon"
    ],
    skins: [
      {
        unified: "1fa83",
        native: "🪃"
      }
    ],
    version: 13
  },
  bow_and_arrow: {
    id: "bow_and_arrow",
    name: "Bow and Arrow",
    keywords: [
      "sports"
    ],
    skins: [
      {
        unified: "1f3f9",
        native: "🏹"
      }
    ],
    version: 1
  },
  shield: {
    id: "shield",
    name: "Shield",
    keywords: [
      "protection",
      "security"
    ],
    skins: [
      {
        unified: "1f6e1-fe0f",
        native: "🛡️"
      }
    ],
    version: 1
  },
  carpentry_saw: {
    id: "carpentry_saw",
    name: "Carpentry Saw",
    keywords: [
      "cut",
      "chop"
    ],
    skins: [
      {
        unified: "1fa9a",
        native: "🪚"
      }
    ],
    version: 13
  },
  wrench: {
    id: "wrench",
    name: "Wrench",
    keywords: [
      "tools",
      "diy",
      "ikea",
      "fix",
      "maintainer"
    ],
    skins: [
      {
        unified: "1f527",
        native: "🔧"
      }
    ],
    version: 1
  },
  screwdriver: {
    id: "screwdriver",
    name: "Screwdriver",
    keywords: [
      "tools"
    ],
    skins: [
      {
        unified: "1fa9b",
        native: "🪛"
      }
    ],
    version: 13
  },
  nut_and_bolt: {
    id: "nut_and_bolt",
    name: "Nut and Bolt",
    keywords: [
      "handy",
      "tools",
      "fix"
    ],
    skins: [
      {
        unified: "1f529",
        native: "🔩"
      }
    ],
    version: 1
  },
  gear: {
    id: "gear",
    name: "Gear",
    keywords: [
      "cog"
    ],
    skins: [
      {
        unified: "2699-fe0f",
        native: "⚙️"
      }
    ],
    version: 1
  },
  compression: {
    id: "compression",
    name: "Clamp",
    keywords: [
      "compression",
      "tool"
    ],
    skins: [
      {
        unified: "1f5dc-fe0f",
        native: "🗜️"
      }
    ],
    version: 1
  },
  scales: {
    id: "scales",
    name: "Balance Scale",
    keywords: [
      "scales",
      "law",
      "fairness",
      "weight"
    ],
    skins: [
      {
        unified: "2696-fe0f",
        native: "⚖️"
      }
    ],
    version: 1
  },
  probing_cane: {
    id: "probing_cane",
    name: "White Cane",
    keywords: [
      "probing",
      "accessibility"
    ],
    skins: [
      {
        unified: "1f9af",
        native: "🦯"
      }
    ],
    version: 12
  },
  link: {
    id: "link",
    name: "Link",
    keywords: [
      "rings",
      "url"
    ],
    skins: [
      {
        unified: "1f517",
        native: "🔗"
      }
    ],
    version: 1
  },
  chains: {
    id: "chains",
    name: "Chains",
    keywords: [
      "lock",
      "arrest"
    ],
    skins: [
      {
        unified: "26d3-fe0f",
        native: "⛓️"
      }
    ],
    version: 1
  },
  hook: {
    id: "hook",
    name: "Hook",
    keywords: [
      "tools"
    ],
    skins: [
      {
        unified: "1fa9d",
        native: "🪝"
      }
    ],
    version: 13
  },
  toolbox: {
    id: "toolbox",
    name: "Toolbox",
    keywords: [
      "tools",
      "diy",
      "fix",
      "maintainer",
      "mechanic"
    ],
    skins: [
      {
        unified: "1f9f0",
        native: "🧰"
      }
    ],
    version: 11
  },
  magnet: {
    id: "magnet",
    name: "Magnet",
    keywords: [
      "attraction",
      "magnetic"
    ],
    skins: [
      {
        unified: "1f9f2",
        native: "🧲"
      }
    ],
    version: 11
  },
  ladder: {
    id: "ladder",
    name: "Ladder",
    keywords: [
      "tools"
    ],
    skins: [
      {
        unified: "1fa9c",
        native: "🪜"
      }
    ],
    version: 13
  },
  alembic: {
    id: "alembic",
    name: "Alembic",
    keywords: [
      "distilling",
      "science",
      "experiment",
      "chemistry"
    ],
    skins: [
      {
        unified: "2697-fe0f",
        native: "⚗️"
      }
    ],
    version: 1
  },
  test_tube: {
    id: "test_tube",
    name: "Test Tube",
    keywords: [
      "chemistry",
      "experiment",
      "lab",
      "science"
    ],
    skins: [
      {
        unified: "1f9ea",
        native: "🧪"
      }
    ],
    version: 11
  },
  petri_dish: {
    id: "petri_dish",
    name: "Petri Dish",
    keywords: [
      "bacteria",
      "biology",
      "culture",
      "lab"
    ],
    skins: [
      {
        unified: "1f9eb",
        native: "🧫"
      }
    ],
    version: 11
  },
  dna: {
    id: "dna",
    name: "Dna",
    keywords: [
      "biologist",
      "genetics",
      "life"
    ],
    skins: [
      {
        unified: "1f9ec",
        native: "🧬"
      }
    ],
    version: 11
  },
  microscope: {
    id: "microscope",
    name: "Microscope",
    keywords: [
      "laboratory",
      "experiment",
      "zoomin",
      "science",
      "study"
    ],
    skins: [
      {
        unified: "1f52c",
        native: "🔬"
      }
    ],
    version: 1
  },
  telescope: {
    id: "telescope",
    name: "Telescope",
    keywords: [
      "stars",
      "space",
      "zoom",
      "science",
      "astronomy"
    ],
    skins: [
      {
        unified: "1f52d",
        native: "🔭"
      }
    ],
    version: 1
  },
  satellite_antenna: {
    id: "satellite_antenna",
    name: "Satellite Antenna",
    keywords: [
      "communication",
      "future",
      "radio",
      "space"
    ],
    skins: [
      {
        unified: "1f4e1",
        native: "📡"
      }
    ],
    version: 1
  },
  syringe: {
    id: "syringe",
    name: "Syringe",
    keywords: [
      "health",
      "hospital",
      "drugs",
      "blood",
      "medicine",
      "needle",
      "doctor",
      "nurse"
    ],
    skins: [
      {
        unified: "1f489",
        native: "💉"
      }
    ],
    version: 1
  },
  drop_of_blood: {
    id: "drop_of_blood",
    name: "Drop of Blood",
    keywords: [
      "period",
      "hurt",
      "harm",
      "wound"
    ],
    skins: [
      {
        unified: "1fa78",
        native: "🩸"
      }
    ],
    version: 12
  },
  pill: {
    id: "pill",
    name: "Pill",
    keywords: [
      "health",
      "medicine",
      "doctor",
      "pharmacy",
      "drug"
    ],
    skins: [
      {
        unified: "1f48a",
        native: "💊"
      }
    ],
    version: 1
  },
  adhesive_bandage: {
    id: "adhesive_bandage",
    name: "Adhesive Bandage",
    keywords: [
      "heal"
    ],
    skins: [
      {
        unified: "1fa79",
        native: "🩹"
      }
    ],
    version: 12
  },
  crutch: {
    id: "crutch",
    name: "Crutch",
    keywords: [
      "accessibility",
      "assist"
    ],
    skins: [
      {
        unified: "1fa7c",
        native: "🩼"
      }
    ],
    version: 14
  },
  stethoscope: {
    id: "stethoscope",
    name: "Stethoscope",
    keywords: [
      "health"
    ],
    skins: [
      {
        unified: "1fa7a",
        native: "🩺"
      }
    ],
    version: 12
  },
  "x-ray": {
    id: "x-ray",
    name: "X-Ray",
    keywords: [
      "x",
      "ray",
      "skeleton",
      "medicine"
    ],
    skins: [
      {
        unified: "1fa7b",
        native: "🩻"
      }
    ],
    version: 14
  },
  door: {
    id: "door",
    name: "Door",
    keywords: [
      "house",
      "entry",
      "exit"
    ],
    skins: [
      {
        unified: "1f6aa",
        native: "🚪"
      }
    ],
    version: 1
  },
  elevator: {
    id: "elevator",
    name: "Elevator",
    keywords: [
      "lift"
    ],
    skins: [
      {
        unified: "1f6d7",
        native: "🛗"
      }
    ],
    version: 13
  },
  mirror: {
    id: "mirror",
    name: "Mirror",
    keywords: [
      "reflection"
    ],
    skins: [
      {
        unified: "1fa9e",
        native: "🪞"
      }
    ],
    version: 13
  },
  window: {
    id: "window",
    name: "Window",
    keywords: [
      "scenery"
    ],
    skins: [
      {
        unified: "1fa9f",
        native: "🪟"
      }
    ],
    version: 13
  },
  bed: {
    id: "bed",
    name: "Bed",
    keywords: [
      "sleep",
      "rest"
    ],
    skins: [
      {
        unified: "1f6cf-fe0f",
        native: "🛏️"
      }
    ],
    version: 1
  },
  couch_and_lamp: {
    id: "couch_and_lamp",
    name: "Couch and Lamp",
    keywords: [
      "read",
      "chill"
    ],
    skins: [
      {
        unified: "1f6cb-fe0f",
        native: "🛋️"
      }
    ],
    version: 1
  },
  chair: {
    id: "chair",
    name: "Chair",
    keywords: [
      "sit",
      "furniture"
    ],
    skins: [
      {
        unified: "1fa91",
        native: "🪑"
      }
    ],
    version: 12
  },
  toilet: {
    id: "toilet",
    name: "Toilet",
    keywords: [
      "restroom",
      "wc",
      "washroom",
      "bathroom",
      "potty"
    ],
    skins: [
      {
        unified: "1f6bd",
        native: "🚽"
      }
    ],
    version: 1
  },
  plunger: {
    id: "plunger",
    name: "Plunger",
    keywords: [
      "toilet"
    ],
    skins: [
      {
        unified: "1faa0",
        native: "🪠"
      }
    ],
    version: 13
  },
  shower: {
    id: "shower",
    name: "Shower",
    keywords: [
      "clean",
      "water",
      "bathroom"
    ],
    skins: [
      {
        unified: "1f6bf",
        native: "🚿"
      }
    ],
    version: 1
  },
  bathtub: {
    id: "bathtub",
    name: "Bathtub",
    keywords: [
      "clean",
      "shower",
      "bathroom"
    ],
    skins: [
      {
        unified: "1f6c1",
        native: "🛁"
      }
    ],
    version: 1
  },
  mouse_trap: {
    id: "mouse_trap",
    name: "Mouse Trap",
    keywords: [
      "cheese"
    ],
    skins: [
      {
        unified: "1faa4",
        native: "🪤"
      }
    ],
    version: 13
  },
  razor: {
    id: "razor",
    name: "Razor",
    keywords: [
      "cut"
    ],
    skins: [
      {
        unified: "1fa92",
        native: "🪒"
      }
    ],
    version: 12
  },
  lotion_bottle: {
    id: "lotion_bottle",
    name: "Lotion Bottle",
    keywords: [
      "moisturizer",
      "sunscreen"
    ],
    skins: [
      {
        unified: "1f9f4",
        native: "🧴"
      }
    ],
    version: 11
  },
  safety_pin: {
    id: "safety_pin",
    name: "Safety Pin",
    keywords: [
      "diaper"
    ],
    skins: [
      {
        unified: "1f9f7",
        native: "🧷"
      }
    ],
    version: 11
  },
  broom: {
    id: "broom",
    name: "Broom",
    keywords: [
      "cleaning",
      "sweeping",
      "witch"
    ],
    skins: [
      {
        unified: "1f9f9",
        native: "🧹"
      }
    ],
    version: 11
  },
  basket: {
    id: "basket",
    name: "Basket",
    keywords: [
      "laundry"
    ],
    skins: [
      {
        unified: "1f9fa",
        native: "🧺"
      }
    ],
    version: 11
  },
  roll_of_paper: {
    id: "roll_of_paper",
    name: "Roll of Paper",
    keywords: [],
    skins: [
      {
        unified: "1f9fb",
        native: "🧻"
      }
    ],
    version: 11
  },
  bucket: {
    id: "bucket",
    name: "Bucket",
    keywords: [
      "water",
      "container"
    ],
    skins: [
      {
        unified: "1faa3",
        native: "🪣"
      }
    ],
    version: 13
  },
  soap: {
    id: "soap",
    name: "Soap",
    keywords: [
      "bar",
      "bathing",
      "cleaning",
      "lather"
    ],
    skins: [
      {
        unified: "1f9fc",
        native: "🧼"
      }
    ],
    version: 11
  },
  bubbles: {
    id: "bubbles",
    name: "Bubbles",
    keywords: [
      "soap",
      "fun",
      "carbonation",
      "sparkling"
    ],
    skins: [
      {
        unified: "1fae7",
        native: "🫧"
      }
    ],
    version: 14
  },
  toothbrush: {
    id: "toothbrush",
    name: "Toothbrush",
    keywords: [
      "hygiene",
      "dental"
    ],
    skins: [
      {
        unified: "1faa5",
        native: "🪥"
      }
    ],
    version: 13
  },
  sponge: {
    id: "sponge",
    name: "Sponge",
    keywords: [
      "absorbing",
      "cleaning",
      "porous"
    ],
    skins: [
      {
        unified: "1f9fd",
        native: "🧽"
      }
    ],
    version: 11
  },
  fire_extinguisher: {
    id: "fire_extinguisher",
    name: "Fire Extinguisher",
    keywords: [
      "quench"
    ],
    skins: [
      {
        unified: "1f9ef",
        native: "🧯"
      }
    ],
    version: 11
  },
  shopping_trolley: {
    id: "shopping_trolley",
    name: "Shopping Cart",
    keywords: [
      "trolley"
    ],
    skins: [
      {
        unified: "1f6d2",
        native: "🛒"
      }
    ],
    version: 3
  },
  smoking: {
    id: "smoking",
    name: "Cigarette",
    keywords: [
      "smoking",
      "kills",
      "tobacco",
      "joint",
      "smoke"
    ],
    skins: [
      {
        unified: "1f6ac",
        native: "🚬"
      }
    ],
    version: 1
  },
  coffin: {
    id: "coffin",
    name: "Coffin",
    keywords: [
      "vampire",
      "dead",
      "die",
      "death",
      "rip",
      "graveyard",
      "cemetery",
      "casket",
      "funeral",
      "box"
    ],
    skins: [
      {
        unified: "26b0-fe0f",
        native: "⚰️"
      }
    ],
    version: 1
  },
  headstone: {
    id: "headstone",
    name: "Headstone",
    keywords: [
      "death",
      "rip",
      "grave"
    ],
    skins: [
      {
        unified: "1faa6",
        native: "🪦"
      }
    ],
    version: 13
  },
  funeral_urn: {
    id: "funeral_urn",
    name: "Funeral Urn",
    keywords: [
      "dead",
      "die",
      "death",
      "rip",
      "ashes"
    ],
    skins: [
      {
        unified: "26b1-fe0f",
        native: "⚱️"
      }
    ],
    version: 1
  },
  moyai: {
    id: "moyai",
    name: "Moai",
    keywords: [
      "moyai",
      "rock",
      "easter",
      "island"
    ],
    skins: [
      {
        unified: "1f5ff",
        native: "🗿"
      }
    ],
    version: 1
  },
  placard: {
    id: "placard",
    name: "Placard",
    keywords: [
      "announcement"
    ],
    skins: [
      {
        unified: "1faa7",
        native: "🪧"
      }
    ],
    version: 13
  },
  identification_card: {
    id: "identification_card",
    name: "Identification Card",
    keywords: [
      "document"
    ],
    skins: [
      {
        unified: "1faaa",
        native: "🪪"
      }
    ],
    version: 14
  },
  atm: {
    id: "atm",
    name: "Atm Sign",
    keywords: [
      "money",
      "sales",
      "cash",
      "blue",
      "square",
      "payment",
      "bank"
    ],
    skins: [
      {
        unified: "1f3e7",
        native: "🏧"
      }
    ],
    version: 1
  },
  put_litter_in_its_place: {
    id: "put_litter_in_its_place",
    name: "Litter in Bin Sign",
    keywords: [
      "put",
      "its",
      "place",
      "blue",
      "square",
      "human",
      "info"
    ],
    skins: [
      {
        unified: "1f6ae",
        native: "🚮"
      }
    ],
    version: 1
  },
  potable_water: {
    id: "potable_water",
    name: "Potable Water",
    keywords: [
      "blue",
      "square",
      "liquid",
      "restroom",
      "cleaning",
      "faucet"
    ],
    skins: [
      {
        unified: "1f6b0",
        native: "🚰"
      }
    ],
    version: 1
  },
  wheelchair: {
    id: "wheelchair",
    name: "Wheelchair Symbol",
    keywords: [
      "blue",
      "square",
      "disabled",
      "accessibility"
    ],
    skins: [
      {
        unified: "267f",
        native: "♿"
      }
    ],
    version: 1
  },
  mens: {
    id: "mens",
    name: "Men’s Room",
    keywords: [
      "mens",
      "men",
      "s",
      "toilet",
      "restroom",
      "wc",
      "blue",
      "square",
      "gender",
      "male"
    ],
    skins: [
      {
        unified: "1f6b9",
        native: "🚹"
      }
    ],
    version: 1
  },
  womens: {
    id: "womens",
    name: "Women’s Room",
    keywords: [
      "womens",
      "women",
      "s",
      "purple",
      "square",
      "woman",
      "female",
      "toilet",
      "loo",
      "restroom",
      "gender"
    ],
    skins: [
      {
        unified: "1f6ba",
        native: "🚺"
      }
    ],
    version: 1
  },
  restroom: {
    id: "restroom",
    name: "Restroom",
    keywords: [
      "blue",
      "square",
      "toilet",
      "refresh",
      "wc",
      "gender"
    ],
    skins: [
      {
        unified: "1f6bb",
        native: "🚻"
      }
    ],
    version: 1
  },
  baby_symbol: {
    id: "baby_symbol",
    name: "Baby Symbol",
    keywords: [
      "orange",
      "square",
      "child"
    ],
    skins: [
      {
        unified: "1f6bc",
        native: "🚼"
      }
    ],
    version: 1
  },
  wc: {
    id: "wc",
    name: "Water Closet",
    keywords: [
      "wc",
      "toilet",
      "restroom",
      "blue",
      "square"
    ],
    skins: [
      {
        unified: "1f6be",
        native: "🚾"
      }
    ],
    version: 1
  },
  passport_control: {
    id: "passport_control",
    name: "Passport Control",
    keywords: [
      "custom",
      "blue",
      "square"
    ],
    skins: [
      {
        unified: "1f6c2",
        native: "🛂"
      }
    ],
    version: 1
  },
  customs: {
    id: "customs",
    name: "Customs",
    keywords: [
      "passport",
      "border",
      "blue",
      "square"
    ],
    skins: [
      {
        unified: "1f6c3",
        native: "🛃"
      }
    ],
    version: 1
  },
  baggage_claim: {
    id: "baggage_claim",
    name: "Baggage Claim",
    keywords: [
      "blue",
      "square",
      "airport",
      "transport"
    ],
    skins: [
      {
        unified: "1f6c4",
        native: "🛄"
      }
    ],
    version: 1
  },
  left_luggage: {
    id: "left_luggage",
    name: "Left Luggage",
    keywords: [
      "blue",
      "square",
      "travel"
    ],
    skins: [
      {
        unified: "1f6c5",
        native: "🛅"
      }
    ],
    version: 1
  },
  warning: {
    id: "warning",
    name: "Warning",
    keywords: [
      "exclamation",
      "wip",
      "alert",
      "error",
      "problem",
      "issue"
    ],
    skins: [
      {
        unified: "26a0-fe0f",
        native: "⚠️"
      }
    ],
    version: 1
  },
  children_crossing: {
    id: "children_crossing",
    name: "Children Crossing",
    keywords: [
      "school",
      "warning",
      "danger",
      "sign",
      "driving",
      "yellow",
      "diamond"
    ],
    skins: [
      {
        unified: "1f6b8",
        native: "🚸"
      }
    ],
    version: 1
  },
  no_entry: {
    id: "no_entry",
    name: "No Entry",
    keywords: [
      "limit",
      "security",
      "privacy",
      "bad",
      "denied",
      "stop",
      "circle"
    ],
    skins: [
      {
        unified: "26d4",
        native: "⛔"
      }
    ],
    version: 1
  },
  no_entry_sign: {
    id: "no_entry_sign",
    name: "Prohibited",
    keywords: [
      "no",
      "entry",
      "sign",
      "forbid",
      "stop",
      "limit",
      "denied",
      "disallow",
      "circle"
    ],
    skins: [
      {
        unified: "1f6ab",
        native: "🚫"
      }
    ],
    version: 1
  },
  no_bicycles: {
    id: "no_bicycles",
    name: "No Bicycles",
    keywords: [
      "cyclist",
      "prohibited",
      "circle"
    ],
    skins: [
      {
        unified: "1f6b3",
        native: "🚳"
      }
    ],
    version: 1
  },
  no_smoking: {
    id: "no_smoking",
    name: "No Smoking",
    keywords: [
      "cigarette",
      "blue",
      "square",
      "smell",
      "smoke"
    ],
    skins: [
      {
        unified: "1f6ad",
        native: "🚭"
      }
    ],
    version: 1
  },
  do_not_litter: {
    id: "do_not_litter",
    name: "No Littering",
    keywords: [
      "do",
      "not",
      "litter",
      "trash",
      "bin",
      "garbage",
      "circle"
    ],
    skins: [
      {
        unified: "1f6af",
        native: "🚯"
      }
    ],
    version: 1
  },
  "non-potable_water": {
    id: "non-potable_water",
    name: "Non-Potable Water",
    keywords: [
      "non",
      "potable",
      "drink",
      "faucet",
      "tap",
      "circle"
    ],
    skins: [
      {
        unified: "1f6b1",
        native: "🚱"
      }
    ],
    version: 1
  },
  no_pedestrians: {
    id: "no_pedestrians",
    name: "No Pedestrians",
    keywords: [
      "rules",
      "crossing",
      "walking",
      "circle"
    ],
    skins: [
      {
        unified: "1f6b7",
        native: "🚷"
      }
    ],
    version: 1
  },
  no_mobile_phones: {
    id: "no_mobile_phones",
    name: "No Mobile Phones",
    keywords: [
      "iphone",
      "mute",
      "circle"
    ],
    skins: [
      {
        unified: "1f4f5",
        native: "📵"
      }
    ],
    version: 1
  },
  underage: {
    id: "underage",
    name: "No One Under Eighteen",
    keywords: [
      "underage",
      "18",
      "drink",
      "pub",
      "night",
      "minor",
      "circle"
    ],
    skins: [
      {
        unified: "1f51e",
        native: "🔞"
      }
    ],
    version: 1
  },
  radioactive_sign: {
    id: "radioactive_sign",
    name: "Radioactive",
    keywords: [
      "sign",
      "nuclear",
      "danger"
    ],
    skins: [
      {
        unified: "2622-fe0f",
        native: "☢️"
      }
    ],
    version: 1
  },
  biohazard_sign: {
    id: "biohazard_sign",
    name: "Biohazard",
    keywords: [
      "sign",
      "danger"
    ],
    skins: [
      {
        unified: "2623-fe0f",
        native: "☣️"
      }
    ],
    version: 1
  },
  arrow_up: {
    id: "arrow_up",
    name: "Up Arrow",
    keywords: [
      "blue",
      "square",
      "continue",
      "top",
      "direction"
    ],
    skins: [
      {
        unified: "2b06-fe0f",
        native: "⬆️"
      }
    ],
    version: 1
  },
  arrow_upper_right: {
    id: "arrow_upper_right",
    name: "Up-Right Arrow",
    keywords: [
      "upper",
      "right",
      "up",
      "blue",
      "square",
      "point",
      "direction",
      "diagonal",
      "northeast"
    ],
    skins: [
      {
        unified: "2197-fe0f",
        native: "↗️"
      }
    ],
    version: 1
  },
  arrow_right: {
    id: "arrow_right",
    name: "Right Arrow",
    keywords: [
      "blue",
      "square",
      "next"
    ],
    skins: [
      {
        unified: "27a1-fe0f",
        native: "➡️"
      }
    ],
    version: 1
  },
  arrow_lower_right: {
    id: "arrow_lower_right",
    name: "South East Arrow",
    keywords: [
      "lower",
      "right",
      "down",
      "blue",
      "square",
      "direction",
      "diagonal",
      "southeast"
    ],
    skins: [
      {
        unified: "2198-fe0f",
        native: "↘️"
      }
    ],
    version: 1
  },
  arrow_down: {
    id: "arrow_down",
    name: "Down Arrow",
    keywords: [
      "blue",
      "square",
      "direction",
      "bottom"
    ],
    skins: [
      {
        unified: "2b07-fe0f",
        native: "⬇️"
      }
    ],
    version: 1
  },
  arrow_lower_left: {
    id: "arrow_lower_left",
    name: "Down-Left Arrow",
    keywords: [
      "lower",
      "left",
      "down",
      "blue",
      "square",
      "direction",
      "diagonal",
      "southwest"
    ],
    skins: [
      {
        unified: "2199-fe0f",
        native: "↙️"
      }
    ],
    version: 1
  },
  arrow_left: {
    id: "arrow_left",
    name: "Left Arrow",
    keywords: [
      "blue",
      "square",
      "previous",
      "back"
    ],
    skins: [
      {
        unified: "2b05-fe0f",
        native: "⬅️"
      }
    ],
    version: 1
  },
  arrow_upper_left: {
    id: "arrow_upper_left",
    name: "Up-Left Arrow",
    keywords: [
      "upper",
      "left",
      "up",
      "blue",
      "square",
      "point",
      "direction",
      "diagonal",
      "northwest"
    ],
    skins: [
      {
        unified: "2196-fe0f",
        native: "↖️"
      }
    ],
    version: 1
  },
  arrow_up_down: {
    id: "arrow_up_down",
    name: "Up Down Arrow",
    keywords: [
      "blue",
      "square",
      "direction",
      "way",
      "vertical"
    ],
    skins: [
      {
        unified: "2195-fe0f",
        native: "↕️"
      }
    ],
    version: 1
  },
  left_right_arrow: {
    id: "left_right_arrow",
    name: "Left Right Arrow",
    keywords: [
      "shape",
      "direction",
      "horizontal",
      "sideways"
    ],
    skins: [
      {
        unified: "2194-fe0f",
        native: "↔️"
      }
    ],
    version: 1
  },
  leftwards_arrow_with_hook: {
    id: "leftwards_arrow_with_hook",
    name: "Right Arrow Curving Left",
    keywords: [
      "leftwards",
      "with",
      "hook",
      "back",
      "return",
      "blue",
      "square",
      "undo",
      "enter"
    ],
    skins: [
      {
        unified: "21a9-fe0f",
        native: "↩️"
      }
    ],
    version: 1
  },
  arrow_right_hook: {
    id: "arrow_right_hook",
    name: "Left Arrow Curving Right",
    keywords: [
      "hook",
      "blue",
      "square",
      "return",
      "rotate",
      "direction"
    ],
    skins: [
      {
        unified: "21aa-fe0f",
        native: "↪️"
      }
    ],
    version: 1
  },
  arrow_heading_up: {
    id: "arrow_heading_up",
    name: "Right Arrow Curving Up",
    keywords: [
      "heading",
      "blue",
      "square",
      "direction",
      "top"
    ],
    skins: [
      {
        unified: "2934-fe0f",
        native: "⤴️"
      }
    ],
    version: 1
  },
  arrow_heading_down: {
    id: "arrow_heading_down",
    name: "Right Arrow Curving Down",
    keywords: [
      "heading",
      "blue",
      "square",
      "direction",
      "bottom"
    ],
    skins: [
      {
        unified: "2935-fe0f",
        native: "⤵️"
      }
    ],
    version: 1
  },
  arrows_clockwise: {
    id: "arrows_clockwise",
    name: "Clockwise Vertical Arrows",
    keywords: [
      "sync",
      "cycle",
      "round",
      "repeat"
    ],
    skins: [
      {
        unified: "1f503",
        native: "🔃"
      }
    ],
    version: 1
  },
  arrows_counterclockwise: {
    id: "arrows_counterclockwise",
    name: "Counterclockwise Arrows Button",
    keywords: [
      "blue",
      "square",
      "sync",
      "cycle"
    ],
    skins: [
      {
        unified: "1f504",
        native: "🔄"
      }
    ],
    version: 1
  },
  back: {
    id: "back",
    name: "Back Arrow",
    keywords: [
      "words",
      "return"
    ],
    skins: [
      {
        unified: "1f519",
        native: "🔙"
      }
    ],
    version: 1
  },
  end: {
    id: "end",
    name: "End Arrow",
    keywords: [
      "words"
    ],
    skins: [
      {
        unified: "1f51a",
        native: "🔚"
      }
    ],
    version: 1
  },
  on: {
    id: "on",
    name: "On! Arrow",
    keywords: [
      "on",
      "words"
    ],
    skins: [
      {
        unified: "1f51b",
        native: "🔛"
      }
    ],
    version: 1
  },
  soon: {
    id: "soon",
    name: "Soon Arrow",
    keywords: [
      "words"
    ],
    skins: [
      {
        unified: "1f51c",
        native: "🔜"
      }
    ],
    version: 1
  },
  top: {
    id: "top",
    name: "Top Arrow",
    keywords: [
      "words",
      "blue",
      "square"
    ],
    skins: [
      {
        unified: "1f51d",
        native: "🔝"
      }
    ],
    version: 1
  },
  place_of_worship: {
    id: "place_of_worship",
    name: "Place of Worship",
    keywords: [
      "religion",
      "church",
      "temple",
      "prayer"
    ],
    skins: [
      {
        unified: "1f6d0",
        native: "🛐"
      }
    ],
    version: 1
  },
  atom_symbol: {
    id: "atom_symbol",
    name: "Atom Symbol",
    keywords: [
      "science",
      "physics",
      "chemistry"
    ],
    skins: [
      {
        unified: "269b-fe0f",
        native: "⚛️"
      }
    ],
    version: 1
  },
  om_symbol: {
    id: "om_symbol",
    name: "Om",
    keywords: [
      "symbol",
      "hinduism",
      "buddhism",
      "sikhism",
      "jainism"
    ],
    skins: [
      {
        unified: "1f549-fe0f",
        native: "🕉️"
      }
    ],
    version: 1
  },
  star_of_david: {
    id: "star_of_david",
    name: "Star of David",
    keywords: [
      "judaism"
    ],
    skins: [
      {
        unified: "2721-fe0f",
        native: "✡️"
      }
    ],
    version: 1
  },
  wheel_of_dharma: {
    id: "wheel_of_dharma",
    name: "Wheel of Dharma",
    keywords: [
      "hinduism",
      "buddhism",
      "sikhism",
      "jainism"
    ],
    skins: [
      {
        unified: "2638-fe0f",
        native: "☸️"
      }
    ],
    version: 1
  },
  yin_yang: {
    id: "yin_yang",
    name: "Yin Yang",
    keywords: [
      "balance"
    ],
    skins: [
      {
        unified: "262f-fe0f",
        native: "☯️"
      }
    ],
    version: 1
  },
  latin_cross: {
    id: "latin_cross",
    name: "Latin Cross",
    keywords: [
      "christianity"
    ],
    skins: [
      {
        unified: "271d-fe0f",
        native: "✝️"
      }
    ],
    version: 1
  },
  orthodox_cross: {
    id: "orthodox_cross",
    name: "Orthodox Cross",
    keywords: [
      "suppedaneum",
      "religion"
    ],
    skins: [
      {
        unified: "2626-fe0f",
        native: "☦️"
      }
    ],
    version: 1
  },
  star_and_crescent: {
    id: "star_and_crescent",
    name: "Star and Crescent",
    keywords: [
      "islam"
    ],
    skins: [
      {
        unified: "262a-fe0f",
        native: "☪️"
      }
    ],
    version: 1
  },
  peace_symbol: {
    id: "peace_symbol",
    name: "Peace Symbol",
    keywords: [
      "hippie"
    ],
    skins: [
      {
        unified: "262e-fe0f",
        native: "☮️"
      }
    ],
    version: 1
  },
  menorah_with_nine_branches: {
    id: "menorah_with_nine_branches",
    name: "Menorah",
    keywords: [
      "with",
      "nine",
      "branches",
      "hanukkah",
      "candles",
      "jewish"
    ],
    skins: [
      {
        unified: "1f54e",
        native: "🕎"
      }
    ],
    version: 1
  },
  six_pointed_star: {
    id: "six_pointed_star",
    name: "Dotted Six-Pointed Star",
    keywords: [
      "six",
      "pointed",
      "purple",
      "square",
      "religion",
      "jewish",
      "hexagram"
    ],
    skins: [
      {
        unified: "1f52f",
        native: "🔯"
      }
    ],
    version: 1
  },
  aries: {
    id: "aries",
    name: "Aries",
    keywords: [
      "sign",
      "purple",
      "square",
      "zodiac",
      "astrology"
    ],
    skins: [
      {
        unified: "2648",
        native: "♈"
      }
    ],
    version: 1
  },
  taurus: {
    id: "taurus",
    name: "Taurus",
    keywords: [
      "purple",
      "square",
      "sign",
      "zodiac",
      "astrology"
    ],
    skins: [
      {
        unified: "2649",
        native: "♉"
      }
    ],
    version: 1
  },
  gemini: {
    id: "gemini",
    name: "Gemini",
    keywords: [
      "sign",
      "zodiac",
      "purple",
      "square",
      "astrology"
    ],
    skins: [
      {
        unified: "264a",
        native: "♊"
      }
    ],
    version: 1
  },
  cancer: {
    id: "cancer",
    name: "Cancer",
    keywords: [
      "sign",
      "zodiac",
      "purple",
      "square",
      "astrology"
    ],
    skins: [
      {
        unified: "264b",
        native: "♋"
      }
    ],
    version: 1
  },
  leo: {
    id: "leo",
    name: "Leo",
    keywords: [
      "sign",
      "purple",
      "square",
      "zodiac",
      "astrology"
    ],
    skins: [
      {
        unified: "264c",
        native: "♌"
      }
    ],
    version: 1
  },
  virgo: {
    id: "virgo",
    name: "Virgo",
    keywords: [
      "sign",
      "zodiac",
      "purple",
      "square",
      "astrology"
    ],
    skins: [
      {
        unified: "264d",
        native: "♍"
      }
    ],
    version: 1
  },
  libra: {
    id: "libra",
    name: "Libra",
    keywords: [
      "sign",
      "purple",
      "square",
      "zodiac",
      "astrology"
    ],
    skins: [
      {
        unified: "264e",
        native: "♎"
      }
    ],
    version: 1
  },
  scorpius: {
    id: "scorpius",
    name: "Scorpio",
    keywords: [
      "scorpius",
      "sign",
      "zodiac",
      "purple",
      "square",
      "astrology"
    ],
    skins: [
      {
        unified: "264f",
        native: "♏"
      }
    ],
    version: 1
  },
  sagittarius: {
    id: "sagittarius",
    name: "Sagittarius",
    keywords: [
      "sign",
      "zodiac",
      "purple",
      "square",
      "astrology"
    ],
    skins: [
      {
        unified: "2650",
        native: "♐"
      }
    ],
    version: 1
  },
  capricorn: {
    id: "capricorn",
    name: "Capricorn",
    keywords: [
      "sign",
      "zodiac",
      "purple",
      "square",
      "astrology"
    ],
    skins: [
      {
        unified: "2651",
        native: "♑"
      }
    ],
    version: 1
  },
  aquarius: {
    id: "aquarius",
    name: "Aquarius",
    keywords: [
      "sign",
      "purple",
      "square",
      "zodiac",
      "astrology"
    ],
    skins: [
      {
        unified: "2652",
        native: "♒"
      }
    ],
    version: 1
  },
  pisces: {
    id: "pisces",
    name: "Pisces",
    keywords: [
      "purple",
      "square",
      "sign",
      "zodiac",
      "astrology"
    ],
    skins: [
      {
        unified: "2653",
        native: "♓"
      }
    ],
    version: 1
  },
  ophiuchus: {
    id: "ophiuchus",
    name: "Ophiuchus",
    keywords: [
      "sign",
      "purple",
      "square",
      "constellation",
      "astrology"
    ],
    skins: [
      {
        unified: "26ce",
        native: "⛎"
      }
    ],
    version: 1
  },
  twisted_rightwards_arrows: {
    id: "twisted_rightwards_arrows",
    name: "Shuffle Tracks Button",
    keywords: [
      "twisted",
      "rightwards",
      "arrows",
      "blue",
      "square",
      "music",
      "random"
    ],
    skins: [
      {
        unified: "1f500",
        native: "🔀"
      }
    ],
    version: 1
  },
  repeat: {
    id: "repeat",
    name: "Repeat Button",
    keywords: [
      "loop",
      "record"
    ],
    skins: [
      {
        unified: "1f501",
        native: "🔁"
      }
    ],
    version: 1
  },
  repeat_one: {
    id: "repeat_one",
    name: "Repeat Single Button",
    keywords: [
      "one",
      "blue",
      "square",
      "loop"
    ],
    skins: [
      {
        unified: "1f502",
        native: "🔂"
      }
    ],
    version: 1
  },
  arrow_forward: {
    id: "arrow_forward",
    name: "Play Button",
    keywords: [
      "arrow",
      "forward",
      "blue",
      "square",
      "right",
      "direction"
    ],
    skins: [
      {
        unified: "25b6-fe0f",
        native: "▶️"
      }
    ],
    version: 1
  },
  fast_forward: {
    id: "fast_forward",
    name: "Fast-Forward Button",
    keywords: [
      "fast",
      "forward",
      "blue",
      "square",
      "play",
      "speed",
      "continue"
    ],
    skins: [
      {
        unified: "23e9",
        native: "⏩"
      }
    ],
    version: 1
  },
  black_right_pointing_double_triangle_with_vertical_bar: {
    id: "black_right_pointing_double_triangle_with_vertical_bar",
    name: "Next Track Button",
    keywords: [
      "black",
      "right",
      "pointing",
      "double",
      "triangle",
      "with",
      "vertical",
      "bar",
      "forward",
      "blue",
      "square"
    ],
    skins: [
      {
        unified: "23ed-fe0f",
        native: "⏭️"
      }
    ],
    version: 1
  },
  black_right_pointing_triangle_with_double_vertical_bar: {
    id: "black_right_pointing_triangle_with_double_vertical_bar",
    name: "Play or Pause Button",
    keywords: [
      "black",
      "right",
      "pointing",
      "triangle",
      "with",
      "double",
      "vertical",
      "bar",
      "blue",
      "square"
    ],
    skins: [
      {
        unified: "23ef-fe0f",
        native: "⏯️"
      }
    ],
    version: 1
  },
  arrow_backward: {
    id: "arrow_backward",
    name: "Reverse Button",
    keywords: [
      "arrow",
      "backward",
      "blue",
      "square",
      "left",
      "direction"
    ],
    skins: [
      {
        unified: "25c0-fe0f",
        native: "◀️"
      }
    ],
    version: 1
  },
  rewind: {
    id: "rewind",
    name: "Fast Reverse Button",
    keywords: [
      "rewind",
      "play",
      "blue",
      "square"
    ],
    skins: [
      {
        unified: "23ea",
        native: "⏪"
      }
    ],
    version: 1
  },
  black_left_pointing_double_triangle_with_vertical_bar: {
    id: "black_left_pointing_double_triangle_with_vertical_bar",
    name: "Last Track Button",
    keywords: [
      "black",
      "left",
      "pointing",
      "double",
      "triangle",
      "with",
      "vertical",
      "bar",
      "backward"
    ],
    skins: [
      {
        unified: "23ee-fe0f",
        native: "⏮️"
      }
    ],
    version: 1
  },
  arrow_up_small: {
    id: "arrow_up_small",
    name: "Upwards Button",
    keywords: [
      "arrow",
      "up",
      "small",
      "blue",
      "square",
      "triangle",
      "direction",
      "point",
      "forward",
      "top"
    ],
    skins: [
      {
        unified: "1f53c",
        native: "🔼"
      }
    ],
    version: 1
  },
  arrow_double_up: {
    id: "arrow_double_up",
    name: "Fast Up Button",
    keywords: [
      "arrow",
      "double",
      "blue",
      "square",
      "direction",
      "top"
    ],
    skins: [
      {
        unified: "23eb",
        native: "⏫"
      }
    ],
    version: 1
  },
  arrow_down_small: {
    id: "arrow_down_small",
    name: "Downwards Button",
    keywords: [
      "arrow",
      "down",
      "small",
      "blue",
      "square",
      "direction",
      "bottom"
    ],
    skins: [
      {
        unified: "1f53d",
        native: "🔽"
      }
    ],
    version: 1
  },
  arrow_double_down: {
    id: "arrow_double_down",
    name: "Fast Down Button",
    keywords: [
      "arrow",
      "double",
      "blue",
      "square",
      "direction",
      "bottom"
    ],
    skins: [
      {
        unified: "23ec",
        native: "⏬"
      }
    ],
    version: 1
  },
  double_vertical_bar: {
    id: "double_vertical_bar",
    name: "Pause Button",
    keywords: [
      "double",
      "vertical",
      "bar",
      "blue",
      "square"
    ],
    skins: [
      {
        unified: "23f8-fe0f",
        native: "⏸️"
      }
    ],
    version: 1
  },
  black_square_for_stop: {
    id: "black_square_for_stop",
    name: "Stop Button",
    keywords: [
      "black",
      "square",
      "for",
      "blue"
    ],
    skins: [
      {
        unified: "23f9-fe0f",
        native: "⏹️"
      }
    ],
    version: 1
  },
  black_circle_for_record: {
    id: "black_circle_for_record",
    name: "Record Button",
    keywords: [
      "black",
      "circle",
      "for",
      "blue",
      "square"
    ],
    skins: [
      {
        unified: "23fa-fe0f",
        native: "⏺️"
      }
    ],
    version: 1
  },
  eject: {
    id: "eject",
    name: "Eject Button",
    keywords: [
      "blue",
      "square"
    ],
    skins: [
      {
        unified: "23cf-fe0f",
        native: "⏏️"
      }
    ],
    version: 1
  },
  cinema: {
    id: "cinema",
    name: "Cinema",
    keywords: [
      "blue",
      "square",
      "record",
      "film",
      "movie",
      "curtain",
      "stage",
      "theater"
    ],
    skins: [
      {
        unified: "1f3a6",
        native: "🎦"
      }
    ],
    version: 1
  },
  low_brightness: {
    id: "low_brightness",
    name: "Dim Button",
    keywords: [
      "low",
      "brightness",
      "sun",
      "afternoon",
      "warm",
      "summer"
    ],
    skins: [
      {
        unified: "1f505",
        native: "🔅"
      }
    ],
    version: 1
  },
  high_brightness: {
    id: "high_brightness",
    name: "Bright Button",
    keywords: [
      "high",
      "brightness",
      "sun",
      "light"
    ],
    skins: [
      {
        unified: "1f506",
        native: "🔆"
      }
    ],
    version: 1
  },
  signal_strength: {
    id: "signal_strength",
    name: "Antenna Bars",
    keywords: [
      "signal",
      "strength",
      "blue",
      "square",
      "reception",
      "phone",
      "internet",
      "connection",
      "wifi",
      "bluetooth"
    ],
    skins: [
      {
        unified: "1f4f6",
        native: "📶"
      }
    ],
    version: 1
  },
  vibration_mode: {
    id: "vibration_mode",
    name: "Vibration Mode",
    keywords: [
      "orange",
      "square",
      "phone"
    ],
    skins: [
      {
        unified: "1f4f3",
        native: "📳"
      }
    ],
    version: 1
  },
  mobile_phone_off: {
    id: "mobile_phone_off",
    name: "Mobile Phone off",
    keywords: [
      "mute",
      "orange",
      "square",
      "silence",
      "quiet"
    ],
    skins: [
      {
        unified: "1f4f4",
        native: "📴"
      }
    ],
    version: 1
  },
  female_sign: {
    id: "female_sign",
    name: "Female Sign",
    keywords: [
      "woman",
      "women",
      "lady",
      "girl"
    ],
    skins: [
      {
        unified: "2640-fe0f",
        native: "♀️"
      }
    ],
    version: 4
  },
  male_sign: {
    id: "male_sign",
    name: "Male Sign",
    keywords: [
      "man",
      "boy",
      "men"
    ],
    skins: [
      {
        unified: "2642-fe0f",
        native: "♂️"
      }
    ],
    version: 4
  },
  transgender_symbol: {
    id: "transgender_symbol",
    name: "Transgender Symbol",
    keywords: [
      "lgbtq"
    ],
    skins: [
      {
        unified: "26a7-fe0f",
        native: "⚧️"
      }
    ],
    version: 13
  },
  heavy_multiplication_x: {
    id: "heavy_multiplication_x",
    name: "Multiply",
    keywords: [
      "heavy",
      "multiplication",
      "x",
      "sign",
      "math",
      "calculation"
    ],
    skins: [
      {
        unified: "2716-fe0f",
        native: "✖️"
      }
    ],
    version: 1
  },
  heavy_plus_sign: {
    id: "heavy_plus_sign",
    name: "Plus",
    keywords: [
      "heavy",
      "sign",
      "math",
      "calculation",
      "addition",
      "more",
      "increase"
    ],
    skins: [
      {
        unified: "2795",
        native: "➕"
      }
    ],
    version: 1
  },
  heavy_minus_sign: {
    id: "heavy_minus_sign",
    name: "Minus",
    keywords: [
      "heavy",
      "sign",
      "math",
      "calculation",
      "subtract",
      "less"
    ],
    skins: [
      {
        unified: "2796",
        native: "➖"
      }
    ],
    version: 1
  },
  heavy_division_sign: {
    id: "heavy_division_sign",
    name: "Divide",
    keywords: [
      "heavy",
      "division",
      "sign",
      "math",
      "calculation"
    ],
    skins: [
      {
        unified: "2797",
        native: "➗"
      }
    ],
    version: 1
  },
  heavy_equals_sign: {
    id: "heavy_equals_sign",
    name: "Heavy Equals Sign",
    keywords: [
      "math"
    ],
    skins: [
      {
        unified: "1f7f0",
        native: "🟰"
      }
    ],
    version: 14
  },
  infinity: {
    id: "infinity",
    name: "Infinity",
    keywords: [
      "forever"
    ],
    skins: [
      {
        unified: "267e-fe0f",
        native: "♾️"
      }
    ],
    version: 11
  },
  bangbang: {
    id: "bangbang",
    name: "Double Exclamation Mark",
    keywords: [
      "bangbang",
      "surprise"
    ],
    skins: [
      {
        unified: "203c-fe0f",
        native: "‼️"
      }
    ],
    version: 1
  },
  interrobang: {
    id: "interrobang",
    name: "Exclamation Question Mark",
    keywords: [
      "interrobang",
      "wat",
      "punctuation",
      "surprise"
    ],
    skins: [
      {
        unified: "2049-fe0f",
        native: "⁉️"
      }
    ],
    version: 1
  },
  question: {
    id: "question",
    name: "Red Question Mark",
    keywords: [
      "doubt",
      "confused"
    ],
    skins: [
      {
        unified: "2753",
        native: "❓"
      }
    ],
    version: 1
  },
  grey_question: {
    id: "grey_question",
    name: "White Question Mark",
    keywords: [
      "grey",
      "doubts",
      "gray",
      "huh",
      "confused"
    ],
    skins: [
      {
        unified: "2754",
        native: "❔"
      }
    ],
    version: 1
  },
  grey_exclamation: {
    id: "grey_exclamation",
    name: "White Exclamation Mark",
    keywords: [
      "grey",
      "surprise",
      "punctuation",
      "gray",
      "wow",
      "warning"
    ],
    skins: [
      {
        unified: "2755",
        native: "❕"
      }
    ],
    version: 1
  },
  exclamation: {
    id: "exclamation",
    name: "Red Exclamation Mark",
    keywords: [
      "heavy",
      "danger",
      "surprise",
      "punctuation",
      "wow",
      "warning"
    ],
    skins: [
      {
        unified: "2757",
        native: "❗"
      }
    ],
    version: 1
  },
  wavy_dash: {
    id: "wavy_dash",
    name: "Wavy Dash",
    keywords: [
      "draw",
      "line",
      "moustache",
      "mustache",
      "squiggle",
      "scribble"
    ],
    skins: [
      {
        unified: "3030-fe0f",
        native: "〰️"
      }
    ],
    version: 1
  },
  currency_exchange: {
    id: "currency_exchange",
    name: "Currency Exchange",
    keywords: [
      "money",
      "sales",
      "dollar",
      "travel"
    ],
    skins: [
      {
        unified: "1f4b1",
        native: "💱"
      }
    ],
    version: 1
  },
  heavy_dollar_sign: {
    id: "heavy_dollar_sign",
    name: "Heavy Dollar Sign",
    keywords: [
      "money",
      "sales",
      "payment",
      "currency",
      "buck"
    ],
    skins: [
      {
        unified: "1f4b2",
        native: "💲"
      }
    ],
    version: 1
  },
  medical_symbol: {
    id: "medical_symbol",
    name: "Medical Symbol",
    keywords: [
      "staff",
      "of",
      "aesculapius",
      "health",
      "hospital"
    ],
    skins: [
      {
        unified: "2695-fe0f",
        native: "⚕️"
      }
    ],
    version: 4
  },
  recycle: {
    id: "recycle",
    name: "Recycling Symbol",
    keywords: [
      "recycle",
      "arrow",
      "environment",
      "garbage",
      "trash"
    ],
    skins: [
      {
        unified: "267b-fe0f",
        native: "♻️"
      }
    ],
    version: 1
  },
  fleur_de_lis: {
    id: "fleur_de_lis",
    name: "Fleur-De-Lis",
    keywords: [
      "fleur",
      "de",
      "lis",
      "decorative",
      "scout"
    ],
    skins: [
      {
        unified: "269c-fe0f",
        native: "⚜️"
      }
    ],
    version: 1
  },
  trident: {
    id: "trident",
    name: "Trident Emblem",
    keywords: [
      "weapon",
      "spear"
    ],
    skins: [
      {
        unified: "1f531",
        native: "🔱"
      }
    ],
    version: 1
  },
  name_badge: {
    id: "name_badge",
    name: "Name Badge",
    keywords: [
      "fire",
      "forbid"
    ],
    skins: [
      {
        unified: "1f4db",
        native: "📛"
      }
    ],
    version: 1
  },
  beginner: {
    id: "beginner",
    name: "Japanese Symbol for Beginner",
    keywords: [
      "badge",
      "shield"
    ],
    skins: [
      {
        unified: "1f530",
        native: "🔰"
      }
    ],
    version: 1
  },
  o: {
    id: "o",
    name: "Hollow Red Circle",
    keywords: [
      "o",
      "round"
    ],
    skins: [
      {
        unified: "2b55",
        native: "⭕"
      }
    ],
    version: 1
  },
  white_check_mark: {
    id: "white_check_mark",
    name: "Check Mark Button",
    keywords: [
      "white",
      "green",
      "square",
      "ok",
      "agree",
      "vote",
      "election",
      "answer",
      "tick"
    ],
    skins: [
      {
        unified: "2705",
        native: "✅"
      }
    ],
    version: 1
  },
  ballot_box_with_check: {
    id: "ballot_box_with_check",
    name: "Check Box with Check",
    keywords: [
      "ballot",
      "ok",
      "agree",
      "confirm",
      "black",
      "square",
      "vote",
      "election",
      "yes",
      "tick"
    ],
    skins: [
      {
        unified: "2611-fe0f",
        native: "☑️"
      }
    ],
    version: 1
  },
  heavy_check_mark: {
    id: "heavy_check_mark",
    name: "Check Mark",
    keywords: [
      "heavy",
      "ok",
      "nike",
      "answer",
      "yes",
      "tick"
    ],
    skins: [
      {
        unified: "2714-fe0f",
        native: "✔️"
      }
    ],
    version: 1
  },
  x: {
    id: "x",
    name: "Cross Mark",
    keywords: [
      "x",
      "no",
      "delete",
      "remove",
      "cancel",
      "red"
    ],
    skins: [
      {
        unified: "274c",
        native: "❌"
      }
    ],
    version: 1
  },
  negative_squared_cross_mark: {
    id: "negative_squared_cross_mark",
    name: "Cross Mark Button",
    keywords: [
      "negative",
      "squared",
      "x",
      "green",
      "square",
      "no",
      "deny"
    ],
    skins: [
      {
        unified: "274e",
        native: "❎"
      }
    ],
    version: 1
  },
  curly_loop: {
    id: "curly_loop",
    name: "Curly Loop",
    keywords: [
      "scribble",
      "draw",
      "shape",
      "squiggle"
    ],
    skins: [
      {
        unified: "27b0",
        native: "➰"
      }
    ],
    version: 1
  },
  loop: {
    id: "loop",
    name: "Double Curly Loop",
    keywords: [
      "tape",
      "cassette"
    ],
    skins: [
      {
        unified: "27bf",
        native: "➿"
      }
    ],
    version: 1
  },
  part_alternation_mark: {
    id: "part_alternation_mark",
    name: "Part Alternation Mark",
    keywords: [
      "graph",
      "presentation",
      "stats",
      "business",
      "economics",
      "bad"
    ],
    skins: [
      {
        unified: "303d-fe0f",
        native: "〽️"
      }
    ],
    version: 1
  },
  eight_spoked_asterisk: {
    id: "eight_spoked_asterisk",
    name: "Eight Spoked Asterisk",
    keywords: [
      "star",
      "sparkle",
      "green",
      "square"
    ],
    skins: [
      {
        unified: "2733-fe0f",
        native: "✳️"
      }
    ],
    version: 1
  },
  eight_pointed_black_star: {
    id: "eight_pointed_black_star",
    name: "Eight-Pointed Star",
    keywords: [
      "eight",
      "pointed",
      "black",
      "orange",
      "square",
      "shape",
      "polygon"
    ],
    skins: [
      {
        unified: "2734-fe0f",
        native: "✴️"
      }
    ],
    version: 1
  },
  sparkle: {
    id: "sparkle",
    name: "Sparkle",
    keywords: [
      "stars",
      "green",
      "square",
      "awesome",
      "good",
      "fireworks"
    ],
    skins: [
      {
        unified: "2747-fe0f",
        native: "❇️"
      }
    ],
    version: 1
  },
  copyright: {
    id: "copyright",
    name: "Copyright",
    keywords: [
      "ip",
      "license",
      "circle",
      "law",
      "legal"
    ],
    skins: [
      {
        unified: "00a9-fe0f",
        native: "©️"
      }
    ],
    version: 1
  },
  registered: {
    id: "registered",
    name: "Registered",
    keywords: [
      "alphabet",
      "circle"
    ],
    skins: [
      {
        unified: "00ae-fe0f",
        native: "®️"
      }
    ],
    version: 1
  },
  tm: {
    id: "tm",
    name: "Trade Mark",
    keywords: [
      "tm",
      "trademark",
      "brand",
      "law",
      "legal"
    ],
    skins: [
      {
        unified: "2122-fe0f",
        native: "™️"
      }
    ],
    version: 1
  },
  hash: {
    id: "hash",
    name: "Hash Key",
    keywords: [
      "keycap",
      "",
      "symbol",
      "blue",
      "square",
      "twitter"
    ],
    skins: [
      {
        unified: "0023-fe0f-20e3",
        native: "#️⃣"
      }
    ],
    version: 1
  },
  keycap_star: {
    id: "keycap_star",
    name: "Keycap: *",
    keywords: [
      "keycap",
      "star",
      ""
    ],
    skins: [
      {
        unified: "002a-fe0f-20e3",
        native: "*️⃣"
      }
    ],
    version: 2
  },
  zero: {
    id: "zero",
    name: "Keycap 0",
    keywords: [
      "zero",
      "numbers",
      "blue",
      "square",
      "null"
    ],
    skins: [
      {
        unified: "0030-fe0f-20e3",
        native: "0️⃣"
      }
    ],
    version: 1
  },
  one: {
    id: "one",
    name: "Keycap 1",
    keywords: [
      "one",
      "blue",
      "square",
      "numbers"
    ],
    skins: [
      {
        unified: "0031-fe0f-20e3",
        native: "1️⃣"
      }
    ],
    version: 1
  },
  two: {
    id: "two",
    name: "Keycap 2",
    keywords: [
      "two",
      "numbers",
      "prime",
      "blue",
      "square"
    ],
    skins: [
      {
        unified: "0032-fe0f-20e3",
        native: "2️⃣"
      }
    ],
    version: 1
  },
  three: {
    id: "three",
    name: "Keycap 3",
    keywords: [
      "three",
      "numbers",
      "prime",
      "blue",
      "square"
    ],
    skins: [
      {
        unified: "0033-fe0f-20e3",
        native: "3️⃣"
      }
    ],
    version: 1
  },
  four: {
    id: "four",
    name: "Keycap 4",
    keywords: [
      "four",
      "numbers",
      "blue",
      "square"
    ],
    skins: [
      {
        unified: "0034-fe0f-20e3",
        native: "4️⃣"
      }
    ],
    version: 1
  },
  five: {
    id: "five",
    name: "Keycap 5",
    keywords: [
      "five",
      "numbers",
      "blue",
      "square",
      "prime"
    ],
    skins: [
      {
        unified: "0035-fe0f-20e3",
        native: "5️⃣"
      }
    ],
    version: 1
  },
  six: {
    id: "six",
    name: "Keycap 6",
    keywords: [
      "six",
      "numbers",
      "blue",
      "square"
    ],
    skins: [
      {
        unified: "0036-fe0f-20e3",
        native: "6️⃣"
      }
    ],
    version: 1
  },
  seven: {
    id: "seven",
    name: "Keycap 7",
    keywords: [
      "seven",
      "numbers",
      "blue",
      "square",
      "prime"
    ],
    skins: [
      {
        unified: "0037-fe0f-20e3",
        native: "7️⃣"
      }
    ],
    version: 1
  },
  eight: {
    id: "eight",
    name: "Keycap 8",
    keywords: [
      "eight",
      "blue",
      "square",
      "numbers"
    ],
    skins: [
      {
        unified: "0038-fe0f-20e3",
        native: "8️⃣"
      }
    ],
    version: 1
  },
  nine: {
    id: "nine",
    name: "Keycap 9",
    keywords: [
      "nine",
      "blue",
      "square",
      "numbers"
    ],
    skins: [
      {
        unified: "0039-fe0f-20e3",
        native: "9️⃣"
      }
    ],
    version: 1
  },
  keycap_ten: {
    id: "keycap_ten",
    name: "Keycap 10",
    keywords: [
      "ten",
      "numbers",
      "blue",
      "square"
    ],
    skins: [
      {
        unified: "1f51f",
        native: "🔟"
      }
    ],
    version: 1
  },
  capital_abcd: {
    id: "capital_abcd",
    name: "Input Latin Uppercase",
    keywords: [
      "capital",
      "abcd",
      "alphabet",
      "words",
      "blue",
      "square"
    ],
    skins: [
      {
        unified: "1f520",
        native: "🔠"
      }
    ],
    version: 1
  },
  abcd: {
    id: "abcd",
    name: "Input Latin Lowercase",
    keywords: [
      "abcd",
      "blue",
      "square",
      "alphabet"
    ],
    skins: [
      {
        unified: "1f521",
        native: "🔡"
      }
    ],
    version: 1
  },
  symbols: {
    id: "symbols",
    name: "Input Symbols",
    keywords: [
      "blue",
      "square",
      "music",
      "note",
      "ampersand",
      "percent",
      "glyphs",
      "characters"
    ],
    skins: [
      {
        unified: "1f523",
        native: "🔣"
      }
    ],
    version: 1
  },
  abc: {
    id: "abc",
    name: "Input Latin Letters",
    keywords: [
      "abc",
      "blue",
      "square",
      "alphabet"
    ],
    skins: [
      {
        unified: "1f524",
        native: "🔤"
      }
    ],
    version: 1
  },
  a: {
    id: "a",
    name: "A Button (blood Type)",
    keywords: [
      "red",
      "square",
      "alphabet",
      "letter"
    ],
    skins: [
      {
        unified: "1f170-fe0f",
        native: "🅰️"
      }
    ],
    version: 1
  },
  ab: {
    id: "ab",
    name: "Negative Squared Ab",
    keywords: [
      "button",
      "red",
      "square",
      "alphabet"
    ],
    skins: [
      {
        unified: "1f18e",
        native: "🆎"
      }
    ],
    version: 1
  },
  b: {
    id: "b",
    name: "B Button (blood Type)",
    keywords: [
      "red",
      "square",
      "alphabet",
      "letter"
    ],
    skins: [
      {
        unified: "1f171-fe0f",
        native: "🅱️"
      }
    ],
    version: 1
  },
  cl: {
    id: "cl",
    name: "Cl Button",
    keywords: [
      "alphabet",
      "words",
      "red",
      "square"
    ],
    skins: [
      {
        unified: "1f191",
        native: "🆑"
      }
    ],
    version: 1
  },
  cool: {
    id: "cool",
    name: "Cool Button",
    keywords: [
      "words",
      "blue",
      "square"
    ],
    skins: [
      {
        unified: "1f192",
        native: "🆒"
      }
    ],
    version: 1
  },
  free: {
    id: "free",
    name: "Free Button",
    keywords: [
      "blue",
      "square",
      "words"
    ],
    skins: [
      {
        unified: "1f193",
        native: "🆓"
      }
    ],
    version: 1
  },
  information_source: {
    id: "information_source",
    name: "Information",
    keywords: [
      "source",
      "blue",
      "square",
      "alphabet",
      "letter"
    ],
    skins: [
      {
        unified: "2139-fe0f",
        native: "ℹ️"
      }
    ],
    version: 1
  },
  id: {
    id: "id",
    name: "Id Button",
    keywords: [
      "purple",
      "square",
      "words"
    ],
    skins: [
      {
        unified: "1f194",
        native: "🆔"
      }
    ],
    version: 1
  },
  m: {
    id: "m",
    name: "Circled M",
    keywords: [
      "alphabet",
      "blue",
      "circle",
      "letter"
    ],
    skins: [
      {
        unified: "24c2-fe0f",
        native: "Ⓜ️"
      }
    ],
    version: 1
  },
  new: {
    id: "new",
    name: "New Button",
    keywords: [
      "blue",
      "square",
      "words",
      "start"
    ],
    skins: [
      {
        unified: "1f195",
        native: "🆕"
      }
    ],
    version: 1
  },
  ng: {
    id: "ng",
    name: "Ng Button",
    keywords: [
      "blue",
      "square",
      "words",
      "shape",
      "icon"
    ],
    skins: [
      {
        unified: "1f196",
        native: "🆖"
      }
    ],
    version: 1
  },
  o2: {
    id: "o2",
    name: "O Button (blood Type)",
    keywords: [
      "o2",
      "alphabet",
      "red",
      "square",
      "letter"
    ],
    skins: [
      {
        unified: "1f17e-fe0f",
        native: "🅾️"
      }
    ],
    version: 1
  },
  ok: {
    id: "ok",
    name: "Ok Button",
    keywords: [
      "good",
      "agree",
      "yes",
      "blue",
      "square"
    ],
    skins: [
      {
        unified: "1f197",
        native: "🆗"
      }
    ],
    version: 1
  },
  parking: {
    id: "parking",
    name: "P Button",
    keywords: [
      "parking",
      "cars",
      "blue",
      "square",
      "alphabet",
      "letter"
    ],
    skins: [
      {
        unified: "1f17f-fe0f",
        native: "🅿️"
      }
    ],
    version: 1
  },
  sos: {
    id: "sos",
    name: "Sos Button",
    keywords: [
      "help",
      "red",
      "square",
      "words",
      "emergency",
      "911"
    ],
    skins: [
      {
        unified: "1f198",
        native: "🆘"
      }
    ],
    version: 1
  },
  up: {
    id: "up",
    name: "Up! Button",
    keywords: [
      "up",
      "blue",
      "square",
      "above",
      "high"
    ],
    skins: [
      {
        unified: "1f199",
        native: "🆙"
      }
    ],
    version: 1
  },
  vs: {
    id: "vs",
    name: "Vs Button",
    keywords: [
      "words",
      "orange",
      "square"
    ],
    skins: [
      {
        unified: "1f19a",
        native: "🆚"
      }
    ],
    version: 1
  },
  koko: {
    id: "koko",
    name: "Squared Katakana Koko",
    keywords: [
      "japanese",
      "here",
      "button",
      "blue",
      "square",
      "destination"
    ],
    skins: [
      {
        unified: "1f201",
        native: "🈁"
      }
    ],
    version: 1
  },
  sa: {
    id: "sa",
    name: "Squared Katakana Sa",
    keywords: [
      "japanese",
      "service",
      "charge",
      "button",
      "blue",
      "square"
    ],
    skins: [
      {
        unified: "1f202-fe0f",
        native: "🈂️"
      }
    ],
    version: 1
  },
  u6708: {
    id: "u6708",
    name: "Japanese “monthly Amount” Button",
    keywords: [
      "u6708",
      "monthly",
      "amount",
      "chinese",
      "month",
      "moon",
      "orange",
      "square",
      "kanji"
    ],
    skins: [
      {
        unified: "1f237-fe0f",
        native: "🈷️"
      }
    ],
    version: 1
  },
  u6709: {
    id: "u6709",
    name: "Squared Cjk Unified Ideograph-6709",
    keywords: [
      "u6709",
      "japanese",
      "not",
      "free",
      "of",
      "charge",
      "button",
      "orange",
      "square",
      "chinese",
      "have",
      "kanji"
    ],
    skins: [
      {
        unified: "1f236",
        native: "🈶"
      }
    ],
    version: 1
  },
  u6307: {
    id: "u6307",
    name: "Japanese “reserved” Button",
    keywords: [
      "u6307",
      "reserved",
      "chinese",
      "point",
      "green",
      "square",
      "kanji"
    ],
    skins: [
      {
        unified: "1f22f",
        native: "🈯"
      }
    ],
    version: 1
  },
  ideograph_advantage: {
    id: "ideograph_advantage",
    name: "Japanese “bargain” Button",
    keywords: [
      "ideograph",
      "advantage",
      "bargain",
      "chinese",
      "kanji",
      "obtain",
      "get",
      "circle"
    ],
    skins: [
      {
        unified: "1f250",
        native: "🉐"
      }
    ],
    version: 1
  },
  u5272: {
    id: "u5272",
    name: "Japanese “discount” Button",
    keywords: [
      "u5272",
      "discount",
      "cut",
      "divide",
      "chinese",
      "kanji",
      "pink",
      "square"
    ],
    skins: [
      {
        unified: "1f239",
        native: "🈹"
      }
    ],
    version: 1
  },
  u7121: {
    id: "u7121",
    name: "Japanese “free of Charge” Button",
    keywords: [
      "u7121",
      "free",
      "charge",
      "nothing",
      "chinese",
      "kanji",
      "orange",
      "square"
    ],
    skins: [
      {
        unified: "1f21a",
        native: "🈚"
      }
    ],
    version: 1
  },
  u7981: {
    id: "u7981",
    name: "Japanese “prohibited” Button",
    keywords: [
      "u7981",
      "prohibited",
      "kanji",
      "chinese",
      "forbidden",
      "limit",
      "restricted",
      "red",
      "square"
    ],
    skins: [
      {
        unified: "1f232",
        native: "🈲"
      }
    ],
    version: 1
  },
  accept: {
    id: "accept",
    name: "Circled Ideograph Accept",
    keywords: [
      "japanese",
      "acceptable",
      "button",
      "ok",
      "good",
      "chinese",
      "kanji",
      "agree",
      "yes",
      "orange",
      "circle"
    ],
    skins: [
      {
        unified: "1f251",
        native: "🉑"
      }
    ],
    version: 1
  },
  u7533: {
    id: "u7533",
    name: "Japanese “application” Button",
    keywords: [
      "u7533",
      "application",
      "chinese",
      "kanji",
      "orange",
      "square"
    ],
    skins: [
      {
        unified: "1f238",
        native: "🈸"
      }
    ],
    version: 1
  },
  u5408: {
    id: "u5408",
    name: "Japanese “passing Grade” Button",
    keywords: [
      "u5408",
      "passing",
      "grade",
      "chinese",
      "join",
      "kanji",
      "red",
      "square"
    ],
    skins: [
      {
        unified: "1f234",
        native: "🈴"
      }
    ],
    version: 1
  },
  u7a7a: {
    id: "u7a7a",
    name: "Japanese “vacancy” Button",
    keywords: [
      "u7a7a",
      "vacancy",
      "kanji",
      "chinese",
      "empty",
      "sky",
      "blue",
      "square"
    ],
    skins: [
      {
        unified: "1f233",
        native: "🈳"
      }
    ],
    version: 1
  },
  congratulations: {
    id: "congratulations",
    name: "Circled Ideograph Congratulation",
    keywords: [
      "congratulations",
      "japanese",
      "button",
      "chinese",
      "kanji",
      "red",
      "circle"
    ],
    skins: [
      {
        unified: "3297-fe0f",
        native: "㊗️"
      }
    ],
    version: 1
  },
  secret: {
    id: "secret",
    name: "Circled Ideograph Secret",
    keywords: [
      "japanese",
      "button",
      "privacy",
      "chinese",
      "sshh",
      "kanji",
      "red",
      "circle"
    ],
    skins: [
      {
        unified: "3299-fe0f",
        native: "㊙️"
      }
    ],
    version: 1
  },
  u55b6: {
    id: "u55b6",
    name: "Squared Cjk Unified Ideograph-55b6",
    keywords: [
      "u55b6",
      "japanese",
      "open",
      "for",
      "business",
      "button",
      "opening",
      "hours",
      "orange",
      "square"
    ],
    skins: [
      {
        unified: "1f23a",
        native: "🈺"
      }
    ],
    version: 1
  },
  u6e80: {
    id: "u6e80",
    name: "Japanese “no Vacancy” Button",
    keywords: [
      "u6e80",
      "no",
      "vacancy",
      "full",
      "chinese",
      "red",
      "square",
      "kanji"
    ],
    skins: [
      {
        unified: "1f235",
        native: "🈵"
      }
    ],
    version: 1
  },
  red_circle: {
    id: "red_circle",
    name: "Red Circle",
    keywords: [
      "shape",
      "error",
      "danger"
    ],
    skins: [
      {
        unified: "1f534",
        native: "🔴"
      }
    ],
    version: 1
  },
  large_orange_circle: {
    id: "large_orange_circle",
    name: "Orange Circle",
    keywords: [
      "large",
      "round"
    ],
    skins: [
      {
        unified: "1f7e0",
        native: "🟠"
      }
    ],
    version: 12
  },
  large_yellow_circle: {
    id: "large_yellow_circle",
    name: "Yellow Circle",
    keywords: [
      "large",
      "round"
    ],
    skins: [
      {
        unified: "1f7e1",
        native: "🟡"
      }
    ],
    version: 12
  },
  large_green_circle: {
    id: "large_green_circle",
    name: "Green Circle",
    keywords: [
      "large",
      "round"
    ],
    skins: [
      {
        unified: "1f7e2",
        native: "🟢"
      }
    ],
    version: 12
  },
  large_blue_circle: {
    id: "large_blue_circle",
    name: "Blue Circle",
    keywords: [
      "large",
      "shape",
      "icon",
      "button"
    ],
    skins: [
      {
        unified: "1f535",
        native: "🔵"
      }
    ],
    version: 1
  },
  large_purple_circle: {
    id: "large_purple_circle",
    name: "Purple Circle",
    keywords: [
      "large",
      "round"
    ],
    skins: [
      {
        unified: "1f7e3",
        native: "🟣"
      }
    ],
    version: 12
  },
  large_brown_circle: {
    id: "large_brown_circle",
    name: "Brown Circle",
    keywords: [
      "large",
      "round"
    ],
    skins: [
      {
        unified: "1f7e4",
        native: "🟤"
      }
    ],
    version: 12
  },
  black_circle: {
    id: "black_circle",
    name: "Black Circle",
    keywords: [
      "shape",
      "button",
      "round"
    ],
    skins: [
      {
        unified: "26ab",
        native: "⚫"
      }
    ],
    version: 1
  },
  white_circle: {
    id: "white_circle",
    name: "White Circle",
    keywords: [
      "shape",
      "round"
    ],
    skins: [
      {
        unified: "26aa",
        native: "⚪"
      }
    ],
    version: 1
  },
  large_red_square: {
    id: "large_red_square",
    name: "Red Square",
    keywords: [
      "large"
    ],
    skins: [
      {
        unified: "1f7e5",
        native: "🟥"
      }
    ],
    version: 12
  },
  large_orange_square: {
    id: "large_orange_square",
    name: "Orange Square",
    keywords: [
      "large"
    ],
    skins: [
      {
        unified: "1f7e7",
        native: "🟧"
      }
    ],
    version: 12
  },
  large_yellow_square: {
    id: "large_yellow_square",
    name: "Yellow Square",
    keywords: [
      "large"
    ],
    skins: [
      {
        unified: "1f7e8",
        native: "🟨"
      }
    ],
    version: 12
  },
  large_green_square: {
    id: "large_green_square",
    name: "Green Square",
    keywords: [
      "large"
    ],
    skins: [
      {
        unified: "1f7e9",
        native: "🟩"
      }
    ],
    version: 12
  },
  large_blue_square: {
    id: "large_blue_square",
    name: "Blue Square",
    keywords: [
      "large"
    ],
    skins: [
      {
        unified: "1f7e6",
        native: "🟦"
      }
    ],
    version: 12
  },
  large_purple_square: {
    id: "large_purple_square",
    name: "Purple Square",
    keywords: [
      "large"
    ],
    skins: [
      {
        unified: "1f7ea",
        native: "🟪"
      }
    ],
    version: 12
  },
  large_brown_square: {
    id: "large_brown_square",
    name: "Brown Square",
    keywords: [
      "large"
    ],
    skins: [
      {
        unified: "1f7eb",
        native: "🟫"
      }
    ],
    version: 12
  },
  black_large_square: {
    id: "black_large_square",
    name: "Black Large Square",
    keywords: [
      "shape",
      "icon",
      "button"
    ],
    skins: [
      {
        unified: "2b1b",
        native: "⬛"
      }
    ],
    version: 1
  },
  white_large_square: {
    id: "white_large_square",
    name: "White Large Square",
    keywords: [
      "shape",
      "icon",
      "stone",
      "button"
    ],
    skins: [
      {
        unified: "2b1c",
        native: "⬜"
      }
    ],
    version: 1
  },
  black_medium_square: {
    id: "black_medium_square",
    name: "Black Medium Square",
    keywords: [
      "shape",
      "button",
      "icon"
    ],
    skins: [
      {
        unified: "25fc-fe0f",
        native: "◼️"
      }
    ],
    version: 1
  },
  white_medium_square: {
    id: "white_medium_square",
    name: "White Medium Square",
    keywords: [
      "shape",
      "stone",
      "icon"
    ],
    skins: [
      {
        unified: "25fb-fe0f",
        native: "◻️"
      }
    ],
    version: 1
  },
  black_medium_small_square: {
    id: "black_medium_small_square",
    name: "Black Medium Small Square",
    keywords: [
      "icon",
      "shape",
      "button"
    ],
    skins: [
      {
        unified: "25fe",
        native: "◾"
      }
    ],
    version: 1
  },
  white_medium_small_square: {
    id: "white_medium_small_square",
    name: "White Medium Small Square",
    keywords: [
      "shape",
      "stone",
      "icon",
      "button"
    ],
    skins: [
      {
        unified: "25fd",
        native: "◽"
      }
    ],
    version: 1
  },
  black_small_square: {
    id: "black_small_square",
    name: "Black Small Square",
    keywords: [
      "shape",
      "icon"
    ],
    skins: [
      {
        unified: "25aa-fe0f",
        native: "▪️"
      }
    ],
    version: 1
  },
  white_small_square: {
    id: "white_small_square",
    name: "White Small Square",
    keywords: [
      "shape",
      "icon"
    ],
    skins: [
      {
        unified: "25ab-fe0f",
        native: "▫️"
      }
    ],
    version: 1
  },
  large_orange_diamond: {
    id: "large_orange_diamond",
    name: "Large Orange Diamond",
    keywords: [
      "shape",
      "jewel",
      "gem"
    ],
    skins: [
      {
        unified: "1f536",
        native: "🔶"
      }
    ],
    version: 1
  },
  large_blue_diamond: {
    id: "large_blue_diamond",
    name: "Large Blue Diamond",
    keywords: [
      "shape",
      "jewel",
      "gem"
    ],
    skins: [
      {
        unified: "1f537",
        native: "🔷"
      }
    ],
    version: 1
  },
  small_orange_diamond: {
    id: "small_orange_diamond",
    name: "Small Orange Diamond",
    keywords: [
      "shape",
      "jewel",
      "gem"
    ],
    skins: [
      {
        unified: "1f538",
        native: "🔸"
      }
    ],
    version: 1
  },
  small_blue_diamond: {
    id: "small_blue_diamond",
    name: "Small Blue Diamond",
    keywords: [
      "shape",
      "jewel",
      "gem"
    ],
    skins: [
      {
        unified: "1f539",
        native: "🔹"
      }
    ],
    version: 1
  },
  small_red_triangle: {
    id: "small_red_triangle",
    name: "Red Triangle Pointed Up",
    keywords: [
      "small",
      "shape",
      "direction",
      "top"
    ],
    skins: [
      {
        unified: "1f53a",
        native: "🔺"
      }
    ],
    version: 1
  },
  small_red_triangle_down: {
    id: "small_red_triangle_down",
    name: "Red Triangle Pointed Down",
    keywords: [
      "small",
      "shape",
      "direction",
      "bottom"
    ],
    skins: [
      {
        unified: "1f53b",
        native: "🔻"
      }
    ],
    version: 1
  },
  diamond_shape_with_a_dot_inside: {
    id: "diamond_shape_with_a_dot_inside",
    name: "Diamond with a Dot",
    keywords: [
      "shape",
      "inside",
      "jewel",
      "blue",
      "gem",
      "crystal",
      "fancy"
    ],
    skins: [
      {
        unified: "1f4a0",
        native: "💠"
      }
    ],
    version: 1
  },
  radio_button: {
    id: "radio_button",
    name: "Radio Button",
    keywords: [
      "input",
      "old",
      "music",
      "circle"
    ],
    skins: [
      {
        unified: "1f518",
        native: "🔘"
      }
    ],
    version: 1
  },
  white_square_button: {
    id: "white_square_button",
    name: "White Square Button",
    keywords: [
      "shape",
      "input"
    ],
    skins: [
      {
        unified: "1f533",
        native: "🔳"
      }
    ],
    version: 1
  },
  black_square_button: {
    id: "black_square_button",
    name: "Black Square Button",
    keywords: [
      "shape",
      "input",
      "frame"
    ],
    skins: [
      {
        unified: "1f532",
        native: "🔲"
      }
    ],
    version: 1
  },
  checkered_flag: {
    id: "checkered_flag",
    name: "Chequered Flag",
    keywords: [
      "checkered",
      "contest",
      "finishline",
      "race",
      "gokart"
    ],
    skins: [
      {
        unified: "1f3c1",
        native: "🏁"
      }
    ],
    version: 1
  },
  triangular_flag_on_post: {
    id: "triangular_flag_on_post",
    name: "Triangular Flag",
    keywords: [
      "on",
      "post",
      "mark",
      "milestone",
      "place"
    ],
    skins: [
      {
        unified: "1f6a9",
        native: "🚩"
      }
    ],
    version: 1
  },
  crossed_flags: {
    id: "crossed_flags",
    name: "Crossed Flags",
    keywords: [
      "japanese",
      "nation",
      "country",
      "border"
    ],
    skins: [
      {
        unified: "1f38c",
        native: "🎌"
      }
    ],
    version: 1
  },
  waving_black_flag: {
    id: "waving_black_flag",
    name: "Black Flag",
    keywords: [
      "waving",
      "pirate"
    ],
    skins: [
      {
        unified: "1f3f4",
        native: "🏴"
      }
    ],
    version: 1
  },
  waving_white_flag: {
    id: "waving_white_flag",
    name: "White Flag",
    keywords: [
      "waving",
      "losing",
      "loser",
      "lost",
      "surrender",
      "give",
      "up",
      "fail"
    ],
    skins: [
      {
        unified: "1f3f3-fe0f",
        native: "🏳️"
      }
    ],
    version: 1
  },
  "rainbow-flag": {
    id: "rainbow-flag",
    name: "Rainbow Flag",
    keywords: [
      "pride",
      "gay",
      "lgbt",
      "glbt",
      "queer",
      "homosexual",
      "lesbian",
      "bisexual",
      "transgender"
    ],
    skins: [
      {
        unified: "1f3f3-fe0f-200d-1f308",
        native: "🏳️‍🌈"
      }
    ],
    version: 4
  },
  transgender_flag: {
    id: "transgender_flag",
    name: "Transgender Flag",
    keywords: [
      "lgbtq"
    ],
    skins: [
      {
        unified: "1f3f3-fe0f-200d-26a7-fe0f",
        native: "🏳️‍⚧️"
      }
    ],
    version: 13
  },
  pirate_flag: {
    id: "pirate_flag",
    name: "Pirate Flag",
    keywords: [
      "skull",
      "crossbones",
      "banner"
    ],
    skins: [
      {
        unified: "1f3f4-200d-2620-fe0f",
        native: "🏴‍☠️"
      }
    ],
    version: 11
  },
  "flag-ac": {
    id: "flag-ac",
    name: "Ascension Island Flag",
    keywords: [
      "ac"
    ],
    skins: [
      {
        unified: "1f1e6-1f1e8",
        native: "🇦🇨"
      }
    ],
    version: 2
  },
  "flag-ad": {
    id: "flag-ad",
    name: "Andorra Flag",
    keywords: [
      "ad",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e6-1f1e9",
        native: "🇦🇩"
      }
    ],
    version: 2
  },
  "flag-ae": {
    id: "flag-ae",
    name: "United Arab Emirates Flag",
    keywords: [
      "ae",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e6-1f1ea",
        native: "🇦🇪"
      }
    ],
    version: 2
  },
  "flag-af": {
    id: "flag-af",
    name: "Afghanistan Flag",
    keywords: [
      "af",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e6-1f1eb",
        native: "🇦🇫"
      }
    ],
    version: 2
  },
  "flag-ag": {
    id: "flag-ag",
    name: "Antigua & Barbuda Flag",
    keywords: [
      "ag",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e6-1f1ec",
        native: "🇦🇬"
      }
    ],
    version: 2
  },
  "flag-ai": {
    id: "flag-ai",
    name: "Anguilla Flag",
    keywords: [
      "ai",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e6-1f1ee",
        native: "🇦🇮"
      }
    ],
    version: 2
  },
  "flag-al": {
    id: "flag-al",
    name: "Albania Flag",
    keywords: [
      "al",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e6-1f1f1",
        native: "🇦🇱"
      }
    ],
    version: 2
  },
  "flag-am": {
    id: "flag-am",
    name: "Armenia Flag",
    keywords: [
      "am",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e6-1f1f2",
        native: "🇦🇲"
      }
    ],
    version: 2
  },
  "flag-ao": {
    id: "flag-ao",
    name: "Angola Flag",
    keywords: [
      "ao",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e6-1f1f4",
        native: "🇦🇴"
      }
    ],
    version: 2
  },
  "flag-aq": {
    id: "flag-aq",
    name: "Antarctica Flag",
    keywords: [
      "aq",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e6-1f1f6",
        native: "🇦🇶"
      }
    ],
    version: 2
  },
  "flag-ar": {
    id: "flag-ar",
    name: "Argentina Flag",
    keywords: [
      "ar",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e6-1f1f7",
        native: "🇦🇷"
      }
    ],
    version: 2
  },
  "flag-as": {
    id: "flag-as",
    name: "American Samoa Flag",
    keywords: [
      "as",
      "ws",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e6-1f1f8",
        native: "🇦🇸"
      }
    ],
    version: 2
  },
  "flag-at": {
    id: "flag-at",
    name: "Austria Flag",
    keywords: [
      "at",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e6-1f1f9",
        native: "🇦🇹"
      }
    ],
    version: 2
  },
  "flag-au": {
    id: "flag-au",
    name: "Australia Flag",
    keywords: [
      "au",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e6-1f1fa",
        native: "🇦🇺"
      }
    ],
    version: 2
  },
  "flag-aw": {
    id: "flag-aw",
    name: "Aruba Flag",
    keywords: [
      "aw",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e6-1f1fc",
        native: "🇦🇼"
      }
    ],
    version: 2
  },
  "flag-ax": {
    id: "flag-ax",
    name: "Åland Islands Flag",
    keywords: [
      "ax",
      "aland",
      "Aland",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e6-1f1fd",
        native: "🇦🇽"
      }
    ],
    version: 2
  },
  "flag-az": {
    id: "flag-az",
    name: "Azerbaijan Flag",
    keywords: [
      "az",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e6-1f1ff",
        native: "🇦🇿"
      }
    ],
    version: 2
  },
  "flag-ba": {
    id: "flag-ba",
    name: "Bosnia & Herzegovina Flag",
    keywords: [
      "ba",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e7-1f1e6",
        native: "🇧🇦"
      }
    ],
    version: 2
  },
  "flag-bb": {
    id: "flag-bb",
    name: "Barbados Flag",
    keywords: [
      "bb",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e7-1f1e7",
        native: "🇧🇧"
      }
    ],
    version: 2
  },
  "flag-bd": {
    id: "flag-bd",
    name: "Bangladesh Flag",
    keywords: [
      "bd",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e7-1f1e9",
        native: "🇧🇩"
      }
    ],
    version: 2
  },
  "flag-be": {
    id: "flag-be",
    name: "Belgium Flag",
    keywords: [
      "be",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e7-1f1ea",
        native: "🇧🇪"
      }
    ],
    version: 2
  },
  "flag-bf": {
    id: "flag-bf",
    name: "Burkina Faso Flag",
    keywords: [
      "bf",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e7-1f1eb",
        native: "🇧🇫"
      }
    ],
    version: 2
  },
  "flag-bg": {
    id: "flag-bg",
    name: "Bulgaria Flag",
    keywords: [
      "bg",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e7-1f1ec",
        native: "🇧🇬"
      }
    ],
    version: 2
  },
  "flag-bh": {
    id: "flag-bh",
    name: "Bahrain Flag",
    keywords: [
      "bh",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e7-1f1ed",
        native: "🇧🇭"
      }
    ],
    version: 2
  },
  "flag-bi": {
    id: "flag-bi",
    name: "Burundi Flag",
    keywords: [
      "bi",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e7-1f1ee",
        native: "🇧🇮"
      }
    ],
    version: 2
  },
  "flag-bj": {
    id: "flag-bj",
    name: "Benin Flag",
    keywords: [
      "bj",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e7-1f1ef",
        native: "🇧🇯"
      }
    ],
    version: 2
  },
  "flag-bl": {
    id: "flag-bl",
    name: "St. Barthélemy Flag",
    keywords: [
      "bl",
      "st",
      "barthelemy",
      "saint",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e7-1f1f1",
        native: "🇧🇱"
      }
    ],
    version: 2
  },
  "flag-bm": {
    id: "flag-bm",
    name: "Bermuda Flag",
    keywords: [
      "bm",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e7-1f1f2",
        native: "🇧🇲"
      }
    ],
    version: 2
  },
  "flag-bn": {
    id: "flag-bn",
    name: "Brunei Flag",
    keywords: [
      "bn",
      "darussalam",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e7-1f1f3",
        native: "🇧🇳"
      }
    ],
    version: 2
  },
  "flag-bo": {
    id: "flag-bo",
    name: "Bolivia Flag",
    keywords: [
      "bo",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e7-1f1f4",
        native: "🇧🇴"
      }
    ],
    version: 2
  },
  "flag-bq": {
    id: "flag-bq",
    name: "Caribbean Netherlands Flag",
    keywords: [
      "bq",
      "bonaire",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e7-1f1f6",
        native: "🇧🇶"
      }
    ],
    version: 2
  },
  "flag-br": {
    id: "flag-br",
    name: "Brazil Flag",
    keywords: [
      "br",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e7-1f1f7",
        native: "🇧🇷"
      }
    ],
    version: 2
  },
  "flag-bs": {
    id: "flag-bs",
    name: "Bahamas Flag",
    keywords: [
      "bs",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e7-1f1f8",
        native: "🇧🇸"
      }
    ],
    version: 2
  },
  "flag-bt": {
    id: "flag-bt",
    name: "Bhutan Flag",
    keywords: [
      "bt",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e7-1f1f9",
        native: "🇧🇹"
      }
    ],
    version: 2
  },
  "flag-bv": {
    id: "flag-bv",
    name: "Bouvet Island Flag",
    keywords: [
      "bv",
      "norway"
    ],
    skins: [
      {
        unified: "1f1e7-1f1fb",
        native: "🇧🇻"
      }
    ],
    version: 2
  },
  "flag-bw": {
    id: "flag-bw",
    name: "Botswana Flag",
    keywords: [
      "bw",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e7-1f1fc",
        native: "🇧🇼"
      }
    ],
    version: 2
  },
  "flag-by": {
    id: "flag-by",
    name: "Belarus Flag",
    keywords: [
      "by",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e7-1f1fe",
        native: "🇧🇾"
      }
    ],
    version: 2
  },
  "flag-bz": {
    id: "flag-bz",
    name: "Belize Flag",
    keywords: [
      "bz",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e7-1f1ff",
        native: "🇧🇿"
      }
    ],
    version: 2
  },
  "flag-ca": {
    id: "flag-ca",
    name: "Canada Flag",
    keywords: [
      "ca",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e8-1f1e6",
        native: "🇨🇦"
      }
    ],
    version: 2
  },
  "flag-cc": {
    id: "flag-cc",
    name: "Cocos (keeling) Islands Flag",
    keywords: [
      "cc",
      "keeling",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e8-1f1e8",
        native: "🇨🇨"
      }
    ],
    version: 2
  },
  "flag-cd": {
    id: "flag-cd",
    name: "Congo - Kinshasa Flag",
    keywords: [
      "cd",
      "democratic",
      "republic",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e8-1f1e9",
        native: "🇨🇩"
      }
    ],
    version: 2
  },
  "flag-cf": {
    id: "flag-cf",
    name: "Central African Republic Flag",
    keywords: [
      "cf",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e8-1f1eb",
        native: "🇨🇫"
      }
    ],
    version: 2
  },
  "flag-cg": {
    id: "flag-cg",
    name: "Congo - Brazzaville Flag",
    keywords: [
      "cg",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e8-1f1ec",
        native: "🇨🇬"
      }
    ],
    version: 2
  },
  "flag-ch": {
    id: "flag-ch",
    name: "Switzerland Flag",
    keywords: [
      "ch",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e8-1f1ed",
        native: "🇨🇭"
      }
    ],
    version: 2
  },
  "flag-ci": {
    id: "flag-ci",
    name: "Côte D’ivoire Flag",
    keywords: [
      "ci",
      "cote",
      "d",
      "ivoire",
      "ivory",
      "coast",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e8-1f1ee",
        native: "🇨🇮"
      }
    ],
    version: 2
  },
  "flag-ck": {
    id: "flag-ck",
    name: "Cook Islands Flag",
    keywords: [
      "ck",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e8-1f1f0",
        native: "🇨🇰"
      }
    ],
    version: 2
  },
  "flag-cl": {
    id: "flag-cl",
    name: "Chile Flag",
    keywords: [
      "cl",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e8-1f1f1",
        native: "🇨🇱"
      }
    ],
    version: 2
  },
  "flag-cm": {
    id: "flag-cm",
    name: "Cameroon Flag",
    keywords: [
      "cm",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e8-1f1f2",
        native: "🇨🇲"
      }
    ],
    version: 2
  },
  cn: {
    id: "cn",
    name: "China Flag",
    keywords: [
      "cn",
      "chinese",
      "prc",
      "country",
      "nation",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e8-1f1f3",
        native: "🇨🇳"
      }
    ],
    version: 1
  },
  "flag-co": {
    id: "flag-co",
    name: "Colombia Flag",
    keywords: [
      "co",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e8-1f1f4",
        native: "🇨🇴"
      }
    ],
    version: 2
  },
  "flag-cp": {
    id: "flag-cp",
    name: "Clipperton Island Flag",
    keywords: [
      "cp"
    ],
    skins: [
      {
        unified: "1f1e8-1f1f5",
        native: "🇨🇵"
      }
    ],
    version: 2
  },
  "flag-cr": {
    id: "flag-cr",
    name: "Costa Rica Flag",
    keywords: [
      "cr",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e8-1f1f7",
        native: "🇨🇷"
      }
    ],
    version: 2
  },
  "flag-cu": {
    id: "flag-cu",
    name: "Cuba Flag",
    keywords: [
      "cu",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e8-1f1fa",
        native: "🇨🇺"
      }
    ],
    version: 2
  },
  "flag-cv": {
    id: "flag-cv",
    name: "Cape Verde Flag",
    keywords: [
      "cv",
      "cabo",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e8-1f1fb",
        native: "🇨🇻"
      }
    ],
    version: 2
  },
  "flag-cw": {
    id: "flag-cw",
    name: "Curaçao Flag",
    keywords: [
      "cw",
      "curacao",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e8-1f1fc",
        native: "🇨🇼"
      }
    ],
    version: 2
  },
  "flag-cx": {
    id: "flag-cx",
    name: "Christmas Island Flag",
    keywords: [
      "cx",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e8-1f1fd",
        native: "🇨🇽"
      }
    ],
    version: 2
  },
  "flag-cy": {
    id: "flag-cy",
    name: "Cyprus Flag",
    keywords: [
      "cy",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e8-1f1fe",
        native: "🇨🇾"
      }
    ],
    version: 2
  },
  "flag-cz": {
    id: "flag-cz",
    name: "Czechia Flag",
    keywords: [
      "cz",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e8-1f1ff",
        native: "🇨🇿"
      }
    ],
    version: 2
  },
  de: {
    id: "de",
    name: "Germany Flag",
    keywords: [
      "de",
      "german",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e9-1f1ea",
        native: "🇩🇪"
      }
    ],
    version: 1
  },
  "flag-dg": {
    id: "flag-dg",
    name: "Diego Garcia Flag",
    keywords: [
      "dg"
    ],
    skins: [
      {
        unified: "1f1e9-1f1ec",
        native: "🇩🇬"
      }
    ],
    version: 2
  },
  "flag-dj": {
    id: "flag-dj",
    name: "Djibouti Flag",
    keywords: [
      "dj",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e9-1f1ef",
        native: "🇩🇯"
      }
    ],
    version: 2
  },
  "flag-dk": {
    id: "flag-dk",
    name: "Denmark Flag",
    keywords: [
      "dk",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e9-1f1f0",
        native: "🇩🇰"
      }
    ],
    version: 2
  },
  "flag-dm": {
    id: "flag-dm",
    name: "Dominica Flag",
    keywords: [
      "dm",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e9-1f1f2",
        native: "🇩🇲"
      }
    ],
    version: 2
  },
  "flag-do": {
    id: "flag-do",
    name: "Dominican Republic Flag",
    keywords: [
      "do",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e9-1f1f4",
        native: "🇩🇴"
      }
    ],
    version: 2
  },
  "flag-dz": {
    id: "flag-dz",
    name: "Algeria Flag",
    keywords: [
      "dz",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1e9-1f1ff",
        native: "🇩🇿"
      }
    ],
    version: 2
  },
  "flag-ea": {
    id: "flag-ea",
    name: "Ceuta & Melilla Flag",
    keywords: [
      "ea"
    ],
    skins: [
      {
        unified: "1f1ea-1f1e6",
        native: "🇪🇦"
      }
    ],
    version: 2
  },
  "flag-ec": {
    id: "flag-ec",
    name: "Ecuador Flag",
    keywords: [
      "ec",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1ea-1f1e8",
        native: "🇪🇨"
      }
    ],
    version: 2
  },
  "flag-ee": {
    id: "flag-ee",
    name: "Estonia Flag",
    keywords: [
      "ee",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1ea-1f1ea",
        native: "🇪🇪"
      }
    ],
    version: 2
  },
  "flag-eg": {
    id: "flag-eg",
    name: "Egypt Flag",
    keywords: [
      "eg",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1ea-1f1ec",
        native: "🇪🇬"
      }
    ],
    version: 2
  },
  "flag-eh": {
    id: "flag-eh",
    name: "Western Sahara Flag",
    keywords: [
      "eh",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1ea-1f1ed",
        native: "🇪🇭"
      }
    ],
    version: 2
  },
  "flag-er": {
    id: "flag-er",
    name: "Eritrea Flag",
    keywords: [
      "er",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1ea-1f1f7",
        native: "🇪🇷"
      }
    ],
    version: 2
  },
  es: {
    id: "es",
    name: "Spain Flag",
    keywords: [
      "es",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1ea-1f1f8",
        native: "🇪🇸"
      }
    ],
    version: 1
  },
  "flag-et": {
    id: "flag-et",
    name: "Ethiopia Flag",
    keywords: [
      "et",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1ea-1f1f9",
        native: "🇪🇹"
      }
    ],
    version: 2
  },
  "flag-eu": {
    id: "flag-eu",
    name: "European Union Flag",
    keywords: [
      "eu",
      "banner"
    ],
    skins: [
      {
        unified: "1f1ea-1f1fa",
        native: "🇪🇺"
      }
    ],
    version: 2
  },
  "flag-fi": {
    id: "flag-fi",
    name: "Finland Flag",
    keywords: [
      "fi",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1eb-1f1ee",
        native: "🇫🇮"
      }
    ],
    version: 2
  },
  "flag-fj": {
    id: "flag-fj",
    name: "Fiji Flag",
    keywords: [
      "fj",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1eb-1f1ef",
        native: "🇫🇯"
      }
    ],
    version: 2
  },
  "flag-fk": {
    id: "flag-fk",
    name: "Falkland Islands Flag",
    keywords: [
      "fk",
      "malvinas",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1eb-1f1f0",
        native: "🇫🇰"
      }
    ],
    version: 2
  },
  "flag-fm": {
    id: "flag-fm",
    name: "Micronesia Flag",
    keywords: [
      "fm",
      "federated",
      "states",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1eb-1f1f2",
        native: "🇫🇲"
      }
    ],
    version: 2
  },
  "flag-fo": {
    id: "flag-fo",
    name: "Faroe Islands Flag",
    keywords: [
      "fo",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1eb-1f1f4",
        native: "🇫🇴"
      }
    ],
    version: 2
  },
  fr: {
    id: "fr",
    name: "France Flag",
    keywords: [
      "fr",
      "banner",
      "nation",
      "french",
      "country"
    ],
    skins: [
      {
        unified: "1f1eb-1f1f7",
        native: "🇫🇷"
      }
    ],
    version: 1
  },
  "flag-ga": {
    id: "flag-ga",
    name: "Gabon Flag",
    keywords: [
      "ga",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1ec-1f1e6",
        native: "🇬🇦"
      }
    ],
    version: 2
  },
  gb: {
    id: "gb",
    name: "United Kingdom Flag",
    keywords: [
      "gb",
      "uk",
      "great",
      "britain",
      "northern",
      "ireland",
      "nation",
      "country",
      "banner",
      "british",
      "UK",
      "english",
      "england",
      "union",
      "jack"
    ],
    skins: [
      {
        unified: "1f1ec-1f1e7",
        native: "🇬🇧"
      }
    ],
    version: 1
  },
  "flag-gd": {
    id: "flag-gd",
    name: "Grenada Flag",
    keywords: [
      "gd",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1ec-1f1e9",
        native: "🇬🇩"
      }
    ],
    version: 2
  },
  "flag-ge": {
    id: "flag-ge",
    name: "Georgia Flag",
    keywords: [
      "ge",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1ec-1f1ea",
        native: "🇬🇪"
      }
    ],
    version: 2
  },
  "flag-gf": {
    id: "flag-gf",
    name: "French Guiana Flag",
    keywords: [
      "gf",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1ec-1f1eb",
        native: "🇬🇫"
      }
    ],
    version: 2
  },
  "flag-gg": {
    id: "flag-gg",
    name: "Guernsey Flag",
    keywords: [
      "gg",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1ec-1f1ec",
        native: "🇬🇬"
      }
    ],
    version: 2
  },
  "flag-gh": {
    id: "flag-gh",
    name: "Ghana Flag",
    keywords: [
      "gh",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1ec-1f1ed",
        native: "🇬🇭"
      }
    ],
    version: 2
  },
  "flag-gi": {
    id: "flag-gi",
    name: "Gibraltar Flag",
    keywords: [
      "gi",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1ec-1f1ee",
        native: "🇬🇮"
      }
    ],
    version: 2
  },
  "flag-gl": {
    id: "flag-gl",
    name: "Greenland Flag",
    keywords: [
      "gl",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1ec-1f1f1",
        native: "🇬🇱"
      }
    ],
    version: 2
  },
  "flag-gm": {
    id: "flag-gm",
    name: "Gambia Flag",
    keywords: [
      "gm",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1ec-1f1f2",
        native: "🇬🇲"
      }
    ],
    version: 2
  },
  "flag-gn": {
    id: "flag-gn",
    name: "Guinea Flag",
    keywords: [
      "gn",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1ec-1f1f3",
        native: "🇬🇳"
      }
    ],
    version: 2
  },
  "flag-gp": {
    id: "flag-gp",
    name: "Guadeloupe Flag",
    keywords: [
      "gp",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1ec-1f1f5",
        native: "🇬🇵"
      }
    ],
    version: 2
  },
  "flag-gq": {
    id: "flag-gq",
    name: "Equatorial Guinea Flag",
    keywords: [
      "gq",
      "gn",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1ec-1f1f6",
        native: "🇬🇶"
      }
    ],
    version: 2
  },
  "flag-gr": {
    id: "flag-gr",
    name: "Greece Flag",
    keywords: [
      "gr",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1ec-1f1f7",
        native: "🇬🇷"
      }
    ],
    version: 2
  },
  "flag-gs": {
    id: "flag-gs",
    name: "South Georgia & South Sandwich Islands Flag",
    keywords: [
      "gs",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1ec-1f1f8",
        native: "🇬🇸"
      }
    ],
    version: 2
  },
  "flag-gt": {
    id: "flag-gt",
    name: "Guatemala Flag",
    keywords: [
      "gt",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1ec-1f1f9",
        native: "🇬🇹"
      }
    ],
    version: 2
  },
  "flag-gu": {
    id: "flag-gu",
    name: "Guam Flag",
    keywords: [
      "gu",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1ec-1f1fa",
        native: "🇬🇺"
      }
    ],
    version: 2
  },
  "flag-gw": {
    id: "flag-gw",
    name: "Guinea-Bissau Flag",
    keywords: [
      "gw",
      "guinea",
      "bissau",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1ec-1f1fc",
        native: "🇬🇼"
      }
    ],
    version: 2
  },
  "flag-gy": {
    id: "flag-gy",
    name: "Guyana Flag",
    keywords: [
      "gy",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1ec-1f1fe",
        native: "🇬🇾"
      }
    ],
    version: 2
  },
  "flag-hk": {
    id: "flag-hk",
    name: "Hong Kong Sar China Flag",
    keywords: [
      "hk",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1ed-1f1f0",
        native: "🇭🇰"
      }
    ],
    version: 2
  },
  "flag-hm": {
    id: "flag-hm",
    name: "Heard & Mcdonald Islands Flag",
    keywords: [
      "hm"
    ],
    skins: [
      {
        unified: "1f1ed-1f1f2",
        native: "🇭🇲"
      }
    ],
    version: 2
  },
  "flag-hn": {
    id: "flag-hn",
    name: "Honduras Flag",
    keywords: [
      "hn",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1ed-1f1f3",
        native: "🇭🇳"
      }
    ],
    version: 2
  },
  "flag-hr": {
    id: "flag-hr",
    name: "Croatia Flag",
    keywords: [
      "hr",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1ed-1f1f7",
        native: "🇭🇷"
      }
    ],
    version: 2
  },
  "flag-ht": {
    id: "flag-ht",
    name: "Haiti Flag",
    keywords: [
      "ht",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1ed-1f1f9",
        native: "🇭🇹"
      }
    ],
    version: 2
  },
  "flag-hu": {
    id: "flag-hu",
    name: "Hungary Flag",
    keywords: [
      "hu",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1ed-1f1fa",
        native: "🇭🇺"
      }
    ],
    version: 2
  },
  "flag-ic": {
    id: "flag-ic",
    name: "Canary Islands Flag",
    keywords: [
      "ic",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1ee-1f1e8",
        native: "🇮🇨"
      }
    ],
    version: 2
  },
  "flag-id": {
    id: "flag-id",
    name: "Indonesia Flag",
    keywords: [
      "id",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1ee-1f1e9",
        native: "🇮🇩"
      }
    ],
    version: 2
  },
  "flag-ie": {
    id: "flag-ie",
    name: "Ireland Flag",
    keywords: [
      "ie",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1ee-1f1ea",
        native: "🇮🇪"
      }
    ],
    version: 2
  },
  "flag-il": {
    id: "flag-il",
    name: "Israel Flag",
    keywords: [
      "il",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1ee-1f1f1",
        native: "🇮🇱"
      }
    ],
    version: 2
  },
  "flag-im": {
    id: "flag-im",
    name: "Isle of Man Flag",
    keywords: [
      "im",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1ee-1f1f2",
        native: "🇮🇲"
      }
    ],
    version: 2
  },
  "flag-in": {
    id: "flag-in",
    name: "India Flag",
    keywords: [
      "in",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1ee-1f1f3",
        native: "🇮🇳"
      }
    ],
    version: 2
  },
  "flag-io": {
    id: "flag-io",
    name: "British Indian Ocean Territory Flag",
    keywords: [
      "io",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1ee-1f1f4",
        native: "🇮🇴"
      }
    ],
    version: 2
  },
  "flag-iq": {
    id: "flag-iq",
    name: "Iraq Flag",
    keywords: [
      "iq",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1ee-1f1f6",
        native: "🇮🇶"
      }
    ],
    version: 2
  },
  "flag-ir": {
    id: "flag-ir",
    name: "Iran Flag",
    keywords: [
      "ir",
      "islamic",
      "republic",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1ee-1f1f7",
        native: "🇮🇷"
      }
    ],
    version: 2
  },
  "flag-is": {
    id: "flag-is",
    name: "Iceland Flag",
    keywords: [
      "is",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1ee-1f1f8",
        native: "🇮🇸"
      }
    ],
    version: 2
  },
  it: {
    id: "it",
    name: "Italy Flag",
    keywords: [
      "it",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1ee-1f1f9",
        native: "🇮🇹"
      }
    ],
    version: 1
  },
  "flag-je": {
    id: "flag-je",
    name: "Jersey Flag",
    keywords: [
      "je",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1ef-1f1ea",
        native: "🇯🇪"
      }
    ],
    version: 2
  },
  "flag-jm": {
    id: "flag-jm",
    name: "Jamaica Flag",
    keywords: [
      "jm",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1ef-1f1f2",
        native: "🇯🇲"
      }
    ],
    version: 2
  },
  "flag-jo": {
    id: "flag-jo",
    name: "Jordan Flag",
    keywords: [
      "jo",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1ef-1f1f4",
        native: "🇯🇴"
      }
    ],
    version: 2
  },
  jp: {
    id: "jp",
    name: "Japan Flag",
    keywords: [
      "jp",
      "japanese",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1ef-1f1f5",
        native: "🇯🇵"
      }
    ],
    version: 1
  },
  "flag-ke": {
    id: "flag-ke",
    name: "Kenya Flag",
    keywords: [
      "ke",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f0-1f1ea",
        native: "🇰🇪"
      }
    ],
    version: 2
  },
  "flag-kg": {
    id: "flag-kg",
    name: "Kyrgyzstan Flag",
    keywords: [
      "kg",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f0-1f1ec",
        native: "🇰🇬"
      }
    ],
    version: 2
  },
  "flag-kh": {
    id: "flag-kh",
    name: "Cambodia Flag",
    keywords: [
      "kh",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f0-1f1ed",
        native: "🇰🇭"
      }
    ],
    version: 2
  },
  "flag-ki": {
    id: "flag-ki",
    name: "Kiribati Flag",
    keywords: [
      "ki",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f0-1f1ee",
        native: "🇰🇮"
      }
    ],
    version: 2
  },
  "flag-km": {
    id: "flag-km",
    name: "Comoros Flag",
    keywords: [
      "km",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f0-1f1f2",
        native: "🇰🇲"
      }
    ],
    version: 2
  },
  "flag-kn": {
    id: "flag-kn",
    name: "St. Kitts & Nevis Flag",
    keywords: [
      "kn",
      "st",
      "saint",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f0-1f1f3",
        native: "🇰🇳"
      }
    ],
    version: 2
  },
  "flag-kp": {
    id: "flag-kp",
    name: "North Korea Flag",
    keywords: [
      "kp",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f0-1f1f5",
        native: "🇰🇵"
      }
    ],
    version: 2
  },
  kr: {
    id: "kr",
    name: "South Korea Flag",
    keywords: [
      "kr",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f0-1f1f7",
        native: "🇰🇷"
      }
    ],
    version: 1
  },
  "flag-kw": {
    id: "flag-kw",
    name: "Kuwait Flag",
    keywords: [
      "kw",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f0-1f1fc",
        native: "🇰🇼"
      }
    ],
    version: 2
  },
  "flag-ky": {
    id: "flag-ky",
    name: "Cayman Islands Flag",
    keywords: [
      "ky",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f0-1f1fe",
        native: "🇰🇾"
      }
    ],
    version: 2
  },
  "flag-kz": {
    id: "flag-kz",
    name: "Kazakhstan Flag",
    keywords: [
      "kz",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f0-1f1ff",
        native: "🇰🇿"
      }
    ],
    version: 2
  },
  "flag-la": {
    id: "flag-la",
    name: "Laos Flag",
    keywords: [
      "la",
      "lao",
      "democratic",
      "republic",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f1-1f1e6",
        native: "🇱🇦"
      }
    ],
    version: 2
  },
  "flag-lb": {
    id: "flag-lb",
    name: "Lebanon Flag",
    keywords: [
      "lb",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f1-1f1e7",
        native: "🇱🇧"
      }
    ],
    version: 2
  },
  "flag-lc": {
    id: "flag-lc",
    name: "St. Lucia Flag",
    keywords: [
      "lc",
      "st",
      "saint",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f1-1f1e8",
        native: "🇱🇨"
      }
    ],
    version: 2
  },
  "flag-li": {
    id: "flag-li",
    name: "Liechtenstein Flag",
    keywords: [
      "li",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f1-1f1ee",
        native: "🇱🇮"
      }
    ],
    version: 2
  },
  "flag-lk": {
    id: "flag-lk",
    name: "Sri Lanka Flag",
    keywords: [
      "lk",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f1-1f1f0",
        native: "🇱🇰"
      }
    ],
    version: 2
  },
  "flag-lr": {
    id: "flag-lr",
    name: "Liberia Flag",
    keywords: [
      "lr",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f1-1f1f7",
        native: "🇱🇷"
      }
    ],
    version: 2
  },
  "flag-ls": {
    id: "flag-ls",
    name: "Lesotho Flag",
    keywords: [
      "ls",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f1-1f1f8",
        native: "🇱🇸"
      }
    ],
    version: 2
  },
  "flag-lt": {
    id: "flag-lt",
    name: "Lithuania Flag",
    keywords: [
      "lt",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f1-1f1f9",
        native: "🇱🇹"
      }
    ],
    version: 2
  },
  "flag-lu": {
    id: "flag-lu",
    name: "Luxembourg Flag",
    keywords: [
      "lu",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f1-1f1fa",
        native: "🇱🇺"
      }
    ],
    version: 2
  },
  "flag-lv": {
    id: "flag-lv",
    name: "Latvia Flag",
    keywords: [
      "lv",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f1-1f1fb",
        native: "🇱🇻"
      }
    ],
    version: 2
  },
  "flag-ly": {
    id: "flag-ly",
    name: "Libya Flag",
    keywords: [
      "ly",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f1-1f1fe",
        native: "🇱🇾"
      }
    ],
    version: 2
  },
  "flag-ma": {
    id: "flag-ma",
    name: "Morocco Flag",
    keywords: [
      "ma",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f2-1f1e6",
        native: "🇲🇦"
      }
    ],
    version: 2
  },
  "flag-mc": {
    id: "flag-mc",
    name: "Monaco Flag",
    keywords: [
      "mc",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f2-1f1e8",
        native: "🇲🇨"
      }
    ],
    version: 2
  },
  "flag-md": {
    id: "flag-md",
    name: "Moldova Flag",
    keywords: [
      "md",
      "republic",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f2-1f1e9",
        native: "🇲🇩"
      }
    ],
    version: 2
  },
  "flag-me": {
    id: "flag-me",
    name: "Montenegro Flag",
    keywords: [
      "me",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f2-1f1ea",
        native: "🇲🇪"
      }
    ],
    version: 2
  },
  "flag-mf": {
    id: "flag-mf",
    name: "St. Martin Flag",
    keywords: [
      "mf",
      "st"
    ],
    skins: [
      {
        unified: "1f1f2-1f1eb",
        native: "🇲🇫"
      }
    ],
    version: 2
  },
  "flag-mg": {
    id: "flag-mg",
    name: "Madagascar Flag",
    keywords: [
      "mg",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f2-1f1ec",
        native: "🇲🇬"
      }
    ],
    version: 2
  },
  "flag-mh": {
    id: "flag-mh",
    name: "Marshall Islands Flag",
    keywords: [
      "mh",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f2-1f1ed",
        native: "🇲🇭"
      }
    ],
    version: 2
  },
  "flag-mk": {
    id: "flag-mk",
    name: "North Macedonia Flag",
    keywords: [
      "mk",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f2-1f1f0",
        native: "🇲🇰"
      }
    ],
    version: 2
  },
  "flag-ml": {
    id: "flag-ml",
    name: "Mali Flag",
    keywords: [
      "ml",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f2-1f1f1",
        native: "🇲🇱"
      }
    ],
    version: 2
  },
  "flag-mm": {
    id: "flag-mm",
    name: "Myanmar (burma) Flag",
    keywords: [
      "mm",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f2-1f1f2",
        native: "🇲🇲"
      }
    ],
    version: 2
  },
  "flag-mn": {
    id: "flag-mn",
    name: "Mongolia Flag",
    keywords: [
      "mn",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f2-1f1f3",
        native: "🇲🇳"
      }
    ],
    version: 2
  },
  "flag-mo": {
    id: "flag-mo",
    name: "Macao Sar China Flag",
    keywords: [
      "mo",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f2-1f1f4",
        native: "🇲🇴"
      }
    ],
    version: 2
  },
  "flag-mp": {
    id: "flag-mp",
    name: "Northern Mariana Islands Flag",
    keywords: [
      "mp",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f2-1f1f5",
        native: "🇲🇵"
      }
    ],
    version: 2
  },
  "flag-mq": {
    id: "flag-mq",
    name: "Martinique Flag",
    keywords: [
      "mq",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f2-1f1f6",
        native: "🇲🇶"
      }
    ],
    version: 2
  },
  "flag-mr": {
    id: "flag-mr",
    name: "Mauritania Flag",
    keywords: [
      "mr",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f2-1f1f7",
        native: "🇲🇷"
      }
    ],
    version: 2
  },
  "flag-ms": {
    id: "flag-ms",
    name: "Montserrat Flag",
    keywords: [
      "ms",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f2-1f1f8",
        native: "🇲🇸"
      }
    ],
    version: 2
  },
  "flag-mt": {
    id: "flag-mt",
    name: "Malta Flag",
    keywords: [
      "mt",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f2-1f1f9",
        native: "🇲🇹"
      }
    ],
    version: 2
  },
  "flag-mu": {
    id: "flag-mu",
    name: "Mauritius Flag",
    keywords: [
      "mu",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f2-1f1fa",
        native: "🇲🇺"
      }
    ],
    version: 2
  },
  "flag-mv": {
    id: "flag-mv",
    name: "Maldives Flag",
    keywords: [
      "mv",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f2-1f1fb",
        native: "🇲🇻"
      }
    ],
    version: 2
  },
  "flag-mw": {
    id: "flag-mw",
    name: "Malawi Flag",
    keywords: [
      "mw",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f2-1f1fc",
        native: "🇲🇼"
      }
    ],
    version: 2
  },
  "flag-mx": {
    id: "flag-mx",
    name: "Mexico Flag",
    keywords: [
      "mx",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f2-1f1fd",
        native: "🇲🇽"
      }
    ],
    version: 2
  },
  "flag-my": {
    id: "flag-my",
    name: "Malaysia Flag",
    keywords: [
      "my",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f2-1f1fe",
        native: "🇲🇾"
      }
    ],
    version: 2
  },
  "flag-mz": {
    id: "flag-mz",
    name: "Mozambique Flag",
    keywords: [
      "mz",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f2-1f1ff",
        native: "🇲🇿"
      }
    ],
    version: 2
  },
  "flag-na": {
    id: "flag-na",
    name: "Namibia Flag",
    keywords: [
      "na",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f3-1f1e6",
        native: "🇳🇦"
      }
    ],
    version: 2
  },
  "flag-nc": {
    id: "flag-nc",
    name: "New Caledonia Flag",
    keywords: [
      "nc",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f3-1f1e8",
        native: "🇳🇨"
      }
    ],
    version: 2
  },
  "flag-ne": {
    id: "flag-ne",
    name: "Niger Flag",
    keywords: [
      "ne",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f3-1f1ea",
        native: "🇳🇪"
      }
    ],
    version: 2
  },
  "flag-nf": {
    id: "flag-nf",
    name: "Norfolk Island Flag",
    keywords: [
      "nf",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f3-1f1eb",
        native: "🇳🇫"
      }
    ],
    version: 2
  },
  "flag-ng": {
    id: "flag-ng",
    name: "Nigeria Flag",
    keywords: [
      "ng",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f3-1f1ec",
        native: "🇳🇬"
      }
    ],
    version: 2
  },
  "flag-ni": {
    id: "flag-ni",
    name: "Nicaragua Flag",
    keywords: [
      "ni",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f3-1f1ee",
        native: "🇳🇮"
      }
    ],
    version: 2
  },
  "flag-nl": {
    id: "flag-nl",
    name: "Netherlands Flag",
    keywords: [
      "nl",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f3-1f1f1",
        native: "🇳🇱"
      }
    ],
    version: 2
  },
  "flag-no": {
    id: "flag-no",
    name: "Norway Flag",
    keywords: [
      "no",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f3-1f1f4",
        native: "🇳🇴"
      }
    ],
    version: 2
  },
  "flag-np": {
    id: "flag-np",
    name: "Nepal Flag",
    keywords: [
      "np",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f3-1f1f5",
        native: "🇳🇵"
      }
    ],
    version: 2
  },
  "flag-nr": {
    id: "flag-nr",
    name: "Nauru Flag",
    keywords: [
      "nr",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f3-1f1f7",
        native: "🇳🇷"
      }
    ],
    version: 2
  },
  "flag-nu": {
    id: "flag-nu",
    name: "Niue Flag",
    keywords: [
      "nu",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f3-1f1fa",
        native: "🇳🇺"
      }
    ],
    version: 2
  },
  "flag-nz": {
    id: "flag-nz",
    name: "New Zealand Flag",
    keywords: [
      "nz",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f3-1f1ff",
        native: "🇳🇿"
      }
    ],
    version: 2
  },
  "flag-om": {
    id: "flag-om",
    name: "Oman Flag",
    keywords: [
      "om",
      "symbol",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f4-1f1f2",
        native: "🇴🇲"
      }
    ],
    version: 2
  },
  "flag-pa": {
    id: "flag-pa",
    name: "Panama Flag",
    keywords: [
      "pa",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f5-1f1e6",
        native: "🇵🇦"
      }
    ],
    version: 2
  },
  "flag-pe": {
    id: "flag-pe",
    name: "Peru Flag",
    keywords: [
      "pe",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f5-1f1ea",
        native: "🇵🇪"
      }
    ],
    version: 2
  },
  "flag-pf": {
    id: "flag-pf",
    name: "French Polynesia Flag",
    keywords: [
      "pf",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f5-1f1eb",
        native: "🇵🇫"
      }
    ],
    version: 2
  },
  "flag-pg": {
    id: "flag-pg",
    name: "Papua New Guinea Flag",
    keywords: [
      "pg",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f5-1f1ec",
        native: "🇵🇬"
      }
    ],
    version: 2
  },
  "flag-ph": {
    id: "flag-ph",
    name: "Philippines Flag",
    keywords: [
      "ph",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f5-1f1ed",
        native: "🇵🇭"
      }
    ],
    version: 2
  },
  "flag-pk": {
    id: "flag-pk",
    name: "Pakistan Flag",
    keywords: [
      "pk",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f5-1f1f0",
        native: "🇵🇰"
      }
    ],
    version: 2
  },
  "flag-pl": {
    id: "flag-pl",
    name: "Poland Flag",
    keywords: [
      "pl",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f5-1f1f1",
        native: "🇵🇱"
      }
    ],
    version: 2
  },
  "flag-pm": {
    id: "flag-pm",
    name: "St. Pierre & Miquelon Flag",
    keywords: [
      "pm",
      "st",
      "saint",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f5-1f1f2",
        native: "🇵🇲"
      }
    ],
    version: 2
  },
  "flag-pn": {
    id: "flag-pn",
    name: "Pitcairn Islands Flag",
    keywords: [
      "pn",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f5-1f1f3",
        native: "🇵🇳"
      }
    ],
    version: 2
  },
  "flag-pr": {
    id: "flag-pr",
    name: "Puerto Rico Flag",
    keywords: [
      "pr",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f5-1f1f7",
        native: "🇵🇷"
      }
    ],
    version: 2
  },
  "flag-ps": {
    id: "flag-ps",
    name: "Palestinian Territories Flag",
    keywords: [
      "ps",
      "palestine",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f5-1f1f8",
        native: "🇵🇸"
      }
    ],
    version: 2
  },
  "flag-pt": {
    id: "flag-pt",
    name: "Portugal Flag",
    keywords: [
      "pt",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f5-1f1f9",
        native: "🇵🇹"
      }
    ],
    version: 2
  },
  "flag-pw": {
    id: "flag-pw",
    name: "Palau Flag",
    keywords: [
      "pw",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f5-1f1fc",
        native: "🇵🇼"
      }
    ],
    version: 2
  },
  "flag-py": {
    id: "flag-py",
    name: "Paraguay Flag",
    keywords: [
      "py",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f5-1f1fe",
        native: "🇵🇾"
      }
    ],
    version: 2
  },
  "flag-qa": {
    id: "flag-qa",
    name: "Qatar Flag",
    keywords: [
      "qa",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f6-1f1e6",
        native: "🇶🇦"
      }
    ],
    version: 2
  },
  "flag-re": {
    id: "flag-re",
    name: "Réunion Flag",
    keywords: [
      "re",
      "reunion",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f7-1f1ea",
        native: "🇷🇪"
      }
    ],
    version: 2
  },
  "flag-ro": {
    id: "flag-ro",
    name: "Romania Flag",
    keywords: [
      "ro",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f7-1f1f4",
        native: "🇷🇴"
      }
    ],
    version: 2
  },
  "flag-rs": {
    id: "flag-rs",
    name: "Serbia Flag",
    keywords: [
      "rs",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f7-1f1f8",
        native: "🇷🇸"
      }
    ],
    version: 2
  },
  ru: {
    id: "ru",
    name: "Russia Flag",
    keywords: [
      "ru",
      "russian",
      "federation",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f7-1f1fa",
        native: "🇷🇺"
      }
    ],
    version: 1
  },
  "flag-rw": {
    id: "flag-rw",
    name: "Rwanda Flag",
    keywords: [
      "rw",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f7-1f1fc",
        native: "🇷🇼"
      }
    ],
    version: 2
  },
  "flag-sa": {
    id: "flag-sa",
    name: "Saudi Arabia Flag",
    keywords: [
      "sa",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f8-1f1e6",
        native: "🇸🇦"
      }
    ],
    version: 2
  },
  "flag-sb": {
    id: "flag-sb",
    name: "Solomon Islands Flag",
    keywords: [
      "sb",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f8-1f1e7",
        native: "🇸🇧"
      }
    ],
    version: 2
  },
  "flag-sc": {
    id: "flag-sc",
    name: "Seychelles Flag",
    keywords: [
      "sc",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f8-1f1e8",
        native: "🇸🇨"
      }
    ],
    version: 2
  },
  "flag-sd": {
    id: "flag-sd",
    name: "Sudan Flag",
    keywords: [
      "sd",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f8-1f1e9",
        native: "🇸🇩"
      }
    ],
    version: 2
  },
  "flag-se": {
    id: "flag-se",
    name: "Sweden Flag",
    keywords: [
      "se",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f8-1f1ea",
        native: "🇸🇪"
      }
    ],
    version: 2
  },
  "flag-sg": {
    id: "flag-sg",
    name: "Singapore Flag",
    keywords: [
      "sg",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f8-1f1ec",
        native: "🇸🇬"
      }
    ],
    version: 2
  },
  "flag-sh": {
    id: "flag-sh",
    name: "St. Helena Flag",
    keywords: [
      "sh",
      "st",
      "saint",
      "ascension",
      "tristan",
      "cunha",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f8-1f1ed",
        native: "🇸🇭"
      }
    ],
    version: 2
  },
  "flag-si": {
    id: "flag-si",
    name: "Slovenia Flag",
    keywords: [
      "si",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f8-1f1ee",
        native: "🇸🇮"
      }
    ],
    version: 2
  },
  "flag-sj": {
    id: "flag-sj",
    name: "Svalbard & Jan Mayen Flag",
    keywords: [
      "sj"
    ],
    skins: [
      {
        unified: "1f1f8-1f1ef",
        native: "🇸🇯"
      }
    ],
    version: 2
  },
  "flag-sk": {
    id: "flag-sk",
    name: "Slovakia Flag",
    keywords: [
      "sk",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f8-1f1f0",
        native: "🇸🇰"
      }
    ],
    version: 2
  },
  "flag-sl": {
    id: "flag-sl",
    name: "Sierra Leone Flag",
    keywords: [
      "sl",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f8-1f1f1",
        native: "🇸🇱"
      }
    ],
    version: 2
  },
  "flag-sm": {
    id: "flag-sm",
    name: "San Marino Flag",
    keywords: [
      "sm",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f8-1f1f2",
        native: "🇸🇲"
      }
    ],
    version: 2
  },
  "flag-sn": {
    id: "flag-sn",
    name: "Senegal Flag",
    keywords: [
      "sn",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f8-1f1f3",
        native: "🇸🇳"
      }
    ],
    version: 2
  },
  "flag-so": {
    id: "flag-so",
    name: "Somalia Flag",
    keywords: [
      "so",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f8-1f1f4",
        native: "🇸🇴"
      }
    ],
    version: 2
  },
  "flag-sr": {
    id: "flag-sr",
    name: "Suriname Flag",
    keywords: [
      "sr",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f8-1f1f7",
        native: "🇸🇷"
      }
    ],
    version: 2
  },
  "flag-ss": {
    id: "flag-ss",
    name: "South Sudan Flag",
    keywords: [
      "ss",
      "sd",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f8-1f1f8",
        native: "🇸🇸"
      }
    ],
    version: 2
  },
  "flag-st": {
    id: "flag-st",
    name: "São Tomé & Príncipe Flag",
    keywords: [
      "st",
      "sao",
      "tome",
      "principe",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f8-1f1f9",
        native: "🇸🇹"
      }
    ],
    version: 2
  },
  "flag-sv": {
    id: "flag-sv",
    name: "El Salvador Flag",
    keywords: [
      "sv",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f8-1f1fb",
        native: "🇸🇻"
      }
    ],
    version: 2
  },
  "flag-sx": {
    id: "flag-sx",
    name: "Sint Maarten Flag",
    keywords: [
      "sx",
      "dutch",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f8-1f1fd",
        native: "🇸🇽"
      }
    ],
    version: 2
  },
  "flag-sy": {
    id: "flag-sy",
    name: "Syria Flag",
    keywords: [
      "sy",
      "syrian",
      "arab",
      "republic",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f8-1f1fe",
        native: "🇸🇾"
      }
    ],
    version: 2
  },
  "flag-sz": {
    id: "flag-sz",
    name: "Eswatini Flag",
    keywords: [
      "sz",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f8-1f1ff",
        native: "🇸🇿"
      }
    ],
    version: 2
  },
  "flag-ta": {
    id: "flag-ta",
    name: "Tristan Da Cunha Flag",
    keywords: [
      "ta"
    ],
    skins: [
      {
        unified: "1f1f9-1f1e6",
        native: "🇹🇦"
      }
    ],
    version: 2
  },
  "flag-tc": {
    id: "flag-tc",
    name: "Turks & Caicos Islands Flag",
    keywords: [
      "tc",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f9-1f1e8",
        native: "🇹🇨"
      }
    ],
    version: 2
  },
  "flag-td": {
    id: "flag-td",
    name: "Chad Flag",
    keywords: [
      "td",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f9-1f1e9",
        native: "🇹🇩"
      }
    ],
    version: 2
  },
  "flag-tf": {
    id: "flag-tf",
    name: "French Southern Territories Flag",
    keywords: [
      "tf",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f9-1f1eb",
        native: "🇹🇫"
      }
    ],
    version: 2
  },
  "flag-tg": {
    id: "flag-tg",
    name: "Togo Flag",
    keywords: [
      "tg",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f9-1f1ec",
        native: "🇹🇬"
      }
    ],
    version: 2
  },
  "flag-th": {
    id: "flag-th",
    name: "Thailand Flag",
    keywords: [
      "th",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f9-1f1ed",
        native: "🇹🇭"
      }
    ],
    version: 2
  },
  "flag-tj": {
    id: "flag-tj",
    name: "Tajikistan Flag",
    keywords: [
      "tj",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f9-1f1ef",
        native: "🇹🇯"
      }
    ],
    version: 2
  },
  "flag-tk": {
    id: "flag-tk",
    name: "Tokelau Flag",
    keywords: [
      "tk",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f9-1f1f0",
        native: "🇹🇰"
      }
    ],
    version: 2
  },
  "flag-tl": {
    id: "flag-tl",
    name: "Timor-Leste Flag",
    keywords: [
      "tl",
      "timor",
      "leste",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f9-1f1f1",
        native: "🇹🇱"
      }
    ],
    version: 2
  },
  "flag-tm": {
    id: "flag-tm",
    name: "Turkmenistan Flag",
    keywords: [
      "tm",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f9-1f1f2",
        native: "🇹🇲"
      }
    ],
    version: 2
  },
  "flag-tn": {
    id: "flag-tn",
    name: "Tunisia Flag",
    keywords: [
      "tn",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f9-1f1f3",
        native: "🇹🇳"
      }
    ],
    version: 2
  },
  "flag-to": {
    id: "flag-to",
    name: "Tonga Flag",
    keywords: [
      "to",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f9-1f1f4",
        native: "🇹🇴"
      }
    ],
    version: 2
  },
  "flag-tr": {
    id: "flag-tr",
    name: "Turkey Flag",
    keywords: [
      "tr",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f9-1f1f7",
        native: "🇹🇷"
      }
    ],
    version: 2
  },
  "flag-tt": {
    id: "flag-tt",
    name: "Trinidad & Tobago Flag",
    keywords: [
      "tt",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f9-1f1f9",
        native: "🇹🇹"
      }
    ],
    version: 2
  },
  "flag-tv": {
    id: "flag-tv",
    name: "Tuvalu Flag",
    keywords: [
      "tv",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f9-1f1fb",
        native: "🇹🇻"
      }
    ],
    version: 2
  },
  "flag-tw": {
    id: "flag-tw",
    name: "Taiwan Flag",
    keywords: [
      "tw",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f9-1f1fc",
        native: "🇹🇼"
      }
    ],
    version: 2
  },
  "flag-tz": {
    id: "flag-tz",
    name: "Tanzania Flag",
    keywords: [
      "tz",
      "united",
      "republic",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1f9-1f1ff",
        native: "🇹🇿"
      }
    ],
    version: 2
  },
  "flag-ua": {
    id: "flag-ua",
    name: "Ukraine Flag",
    keywords: [
      "ua",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1fa-1f1e6",
        native: "🇺🇦"
      }
    ],
    version: 2
  },
  "flag-ug": {
    id: "flag-ug",
    name: "Uganda Flag",
    keywords: [
      "ug",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1fa-1f1ec",
        native: "🇺🇬"
      }
    ],
    version: 2
  },
  "flag-um": {
    id: "flag-um",
    name: "U.s. Outlying Islands Flag",
    keywords: [
      "um",
      "u",
      "s"
    ],
    skins: [
      {
        unified: "1f1fa-1f1f2",
        native: "🇺🇲"
      }
    ],
    version: 2
  },
  "flag-un": {
    id: "flag-un",
    name: "United Nations Flag",
    keywords: [
      "un",
      "banner"
    ],
    skins: [
      {
        unified: "1f1fa-1f1f3",
        native: "🇺🇳"
      }
    ],
    version: 4
  },
  us: {
    id: "us",
    name: "United States Flag",
    keywords: [
      "us",
      "america",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1fa-1f1f8",
        native: "🇺🇸"
      }
    ],
    version: 1
  },
  "flag-uy": {
    id: "flag-uy",
    name: "Uruguay Flag",
    keywords: [
      "uy",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1fa-1f1fe",
        native: "🇺🇾"
      }
    ],
    version: 2
  },
  "flag-uz": {
    id: "flag-uz",
    name: "Uzbekistan Flag",
    keywords: [
      "uz",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1fa-1f1ff",
        native: "🇺🇿"
      }
    ],
    version: 2
  },
  "flag-va": {
    id: "flag-va",
    name: "Vatican City Flag",
    keywords: [
      "va",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1fb-1f1e6",
        native: "🇻🇦"
      }
    ],
    version: 2
  },
  "flag-vc": {
    id: "flag-vc",
    name: "St. Vincent & Grenadines Flag",
    keywords: [
      "vc",
      "st",
      "saint",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1fb-1f1e8",
        native: "🇻🇨"
      }
    ],
    version: 2
  },
  "flag-ve": {
    id: "flag-ve",
    name: "Venezuela Flag",
    keywords: [
      "ve",
      "bolivarian",
      "republic",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1fb-1f1ea",
        native: "🇻🇪"
      }
    ],
    version: 2
  },
  "flag-vg": {
    id: "flag-vg",
    name: "British Virgin Islands Flag",
    keywords: [
      "vg",
      "bvi",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1fb-1f1ec",
        native: "🇻🇬"
      }
    ],
    version: 2
  },
  "flag-vi": {
    id: "flag-vi",
    name: "U.s. Virgin Islands Flag",
    keywords: [
      "vi",
      "u",
      "s",
      "us",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1fb-1f1ee",
        native: "🇻🇮"
      }
    ],
    version: 2
  },
  "flag-vn": {
    id: "flag-vn",
    name: "Vietnam Flag",
    keywords: [
      "vn",
      "viet",
      "nam",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1fb-1f1f3",
        native: "🇻🇳"
      }
    ],
    version: 2
  },
  "flag-vu": {
    id: "flag-vu",
    name: "Vanuatu Flag",
    keywords: [
      "vu",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1fb-1f1fa",
        native: "🇻🇺"
      }
    ],
    version: 2
  },
  "flag-wf": {
    id: "flag-wf",
    name: "Wallis & Futuna Flag",
    keywords: [
      "wf",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1fc-1f1eb",
        native: "🇼🇫"
      }
    ],
    version: 2
  },
  "flag-ws": {
    id: "flag-ws",
    name: "Samoa Flag",
    keywords: [
      "ws",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1fc-1f1f8",
        native: "🇼🇸"
      }
    ],
    version: 2
  },
  "flag-xk": {
    id: "flag-xk",
    name: "Kosovo Flag",
    keywords: [
      "xk",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1fd-1f1f0",
        native: "🇽🇰"
      }
    ],
    version: 2
  },
  "flag-ye": {
    id: "flag-ye",
    name: "Yemen Flag",
    keywords: [
      "ye",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1fe-1f1ea",
        native: "🇾🇪"
      }
    ],
    version: 2
  },
  "flag-yt": {
    id: "flag-yt",
    name: "Mayotte Flag",
    keywords: [
      "yt",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1fe-1f1f9",
        native: "🇾🇹"
      }
    ],
    version: 2
  },
  "flag-za": {
    id: "flag-za",
    name: "South Africa Flag",
    keywords: [
      "za",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1ff-1f1e6",
        native: "🇿🇦"
      }
    ],
    version: 2
  },
  "flag-zm": {
    id: "flag-zm",
    name: "Zambia Flag",
    keywords: [
      "zm",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1ff-1f1f2",
        native: "🇿🇲"
      }
    ],
    version: 2
  },
  "flag-zw": {
    id: "flag-zw",
    name: "Zimbabwe Flag",
    keywords: [
      "zw",
      "nation",
      "country",
      "banner"
    ],
    skins: [
      {
        unified: "1f1ff-1f1fc",
        native: "🇿🇼"
      }
    ],
    version: 2
  },
  "flag-england": {
    id: "flag-england",
    name: "England Flag",
    keywords: [
      "english"
    ],
    skins: [
      {
        unified: "1f3f4-e0067-e0062-e0065-e006e-e0067-e007f",
        native: "🏴󠁧󠁢󠁥󠁮󠁧󠁿"
      }
    ],
    version: 5
  },
  "flag-scotland": {
    id: "flag-scotland",
    name: "Scotland Flag",
    keywords: [
      "scottish"
    ],
    skins: [
      {
        unified: "1f3f4-e0067-e0062-e0073-e0063-e0074-e007f",
        native: "🏴󠁧󠁢󠁳󠁣󠁴󠁿"
      }
    ],
    version: 5
  },
  "flag-wales": {
    id: "flag-wales",
    name: "Wales Flag",
    keywords: [
      "welsh"
    ],
    skins: [
      {
        unified: "1f3f4-e0067-e0062-e0077-e006c-e0073-e007f",
        native: "🏴󠁧󠁢󠁷󠁬󠁳󠁿"
      }
    ],
    version: 5
  }
}, ove = {
  satisfied: "laughing",
  grinning_face_with_star_eyes: "star-struck",
  grinning_face_with_one_large_and_one_small_eye: "zany_face",
  smiling_face_with_smiling_eyes_and_hand_covering_mouth: "face_with_hand_over_mouth",
  face_with_finger_covering_closed_lips: "shushing_face",
  face_with_one_eyebrow_raised: "face_with_raised_eyebrow",
  face_with_open_mouth_vomiting: "face_vomiting",
  shocked_face_with_exploding_head: "exploding_head",
  serious_face_with_symbols_covering_mouth: "face_with_symbols_on_mouth",
  poop: "hankey",
  shit: "hankey",
  collision: "boom",
  raised_hand: "hand",
  hand_with_index_and_middle_fingers_crossed: "crossed_fingers",
  sign_of_the_horns: "the_horns",
  reversed_hand_with_middle_finger_extended: "middle_finger",
  thumbsup: "+1",
  thumbsdown: "-1",
  punch: "facepunch",
  mother_christmas: "mrs_claus",
  running: "runner",
  "man-with-bunny-ears-partying": "men-with-bunny-ears-partying",
  "woman-with-bunny-ears-partying": "women-with-bunny-ears-partying",
  women_holding_hands: "two_women_holding_hands",
  woman_and_man_holding_hands: "man_and_woman_holding_hands",
  couple: "man_and_woman_holding_hands",
  men_holding_hands: "two_men_holding_hands",
  paw_prints: "feet",
  flipper: "dolphin",
  honeybee: "bee",
  lady_beetle: "ladybug",
  cooking: "fried_egg",
  knife: "hocho",
  red_car: "car",
  sailboat: "boat",
  waxing_gibbous_moon: "moon",
  sun_small_cloud: "mostly_sunny",
  sun_behind_cloud: "barely_sunny",
  sun_behind_rain_cloud: "partly_sunny_rain",
  lightning_cloud: "lightning",
  tornado_cloud: "tornado",
  tshirt: "shirt",
  shoe: "mans_shoe",
  telephone: "phone",
  lantern: "izakaya_lantern",
  open_book: "book",
  envelope: "email",
  pencil: "memo",
  heavy_exclamation_mark: "exclamation",
  staff_of_aesculapius: "medical_symbol",
  "flag-cn": "cn",
  "flag-de": "de",
  "flag-es": "es",
  "flag-fr": "fr",
  uk: "gb",
  "flag-gb": "gb",
  "flag-it": "it",
  "flag-jp": "jp",
  "flag-kr": "kr",
  "flag-ru": "ru",
  "flag-us": "us"
}, uve = {
  cols: 61,
  rows: 61
}, fve = {
  categories: ave,
  emojis: sve,
  aliases: ove,
  sheet: uve
};
function lT(e) {
  return e && e.__esModule ? e.default : e;
}
function qi(e, t, r) {
  return t in e ? Object.defineProperty(e, t, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = r, e;
}
var wv, kt, dT, Lf, cT, v6, ep = {}, pT = [], lve = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i;
function Qa(e, t) {
  for (var r in t)
    e[r] = t[r];
  return e;
}
function vT(e) {
  var t = e.parentNode;
  t && t.removeChild(e);
}
function Yg(e, t, r) {
  var n, i, a, s = {};
  for (a in t)
    a == "key" ? n = t[a] : a == "ref" ? i = t[a] : s[a] = t[a];
  if (arguments.length > 2 && (s.children = arguments.length > 3 ? wv.call(arguments, 2) : r), typeof e == "function" && e.defaultProps != null)
    for (a in e.defaultProps)
      s[a] === void 0 && (s[a] = e.defaultProps[a]);
  return pc(e, s, n, i, null);
}
function pc(e, t, r, n, i) {
  var a = {
    type: e,
    props: t,
    key: r,
    ref: n,
    __k: null,
    __: null,
    __b: 0,
    __e: null,
    __d: void 0,
    __c: null,
    __h: null,
    constructor: void 0,
    __v: i ?? ++dT
  };
  return i == null && kt.vnode != null && kt.vnode(a), a;
}
function aa() {
  return {
    current: null
  };
}
function qu(e) {
  return e.children;
}
function ji(e, t) {
  this.props = e, this.context = t;
}
function bu(e, t) {
  if (t == null)
    return e.__ ? bu(e.__, e.__.__k.indexOf(e) + 1) : null;
  for (var r; t < e.__k.length; t++)
    if ((r = e.__k[t]) != null && r.__e != null)
      return r.__e;
  return typeof e.type == "function" ? bu(e) : null;
}
function hT(e) {
  var t, r;
  if ((e = e.__) != null && e.__c != null) {
    for (e.__e = e.__c.base = null, t = 0; t < e.__k.length; t++)
      if ((r = e.__k[t]) != null && r.__e != null) {
        e.__e = e.__c.base = r.__e;
        break;
      }
    return hT(e);
  }
}
function h6(e) {
  (!e.__d && (e.__d = !0) && Lf.push(e) && !tp.__r++ || v6 !== kt.debounceRendering) && ((v6 = kt.debounceRendering) || cT)(tp);
}
function tp() {
  for (var e; tp.__r = Lf.length; )
    e = Lf.sort(function(t, r) {
      return t.__v.__b - r.__v.__b;
    }), Lf = [], e.some(function(t) {
      var r, n, i, a, s, o;
      t.__d && (s = (a = (r = t).__v).__e, (o = r.__P) && (n = [], (i = Qa({}, a)).__v = a.__v + 1, Oq(o, a, i, r.__n, o.ownerSVGElement !== void 0, a.__h != null ? [
        s
      ] : null, n, s ?? bu(a), a.__h), VT(n, a), a.__e != s && hT(a)));
    });
}
function mT(e, t, r, n, i, a, s, o, u, f) {
  var l, d, c, p, v, h, m, q = n && n.__k || pT, w = q.length;
  for (r.__k = [], l = 0; l < t.length; l++)
    if ((p = r.__k[l] = (p = t[l]) == null || typeof p == "boolean" ? null : typeof p == "string" || typeof p == "number" || typeof p == "bigint" ? pc(null, p, null, null, p) : Array.isArray(p) ? pc(qu, {
      children: p
    }, null, null, null) : p.__b > 0 ? pc(p.type, p.props, p.key, null, p.__v) : p) != null) {
      if (p.__ = r, p.__b = r.__b + 1, (c = q[l]) === null || c && p.key == c.key && p.type === c.type)
        q[l] = void 0;
      else
        for (d = 0; d < w; d++) {
          if ((c = q[d]) && p.key == c.key && p.type === c.type) {
            q[d] = void 0;
            break;
          }
          c = null;
        }
      Oq(e, p, c = c || ep, i, a, s, o, u, f), v = p.__e, (d = p.ref) && c.ref != d && (m || (m = []), c.ref && m.push(c.ref, null, p), m.push(d, p.__c || v, p)), v != null ? (h == null && (h = v), typeof p.type == "function" && p.__k === c.__k ? p.__d = u = gT(p, u, e) : u = yT(e, p, c, q, v, u), typeof r.type == "function" && (r.__d = u)) : u && c.__e == u && u.parentNode != e && (u = bu(c));
    }
  for (r.__e = h, l = w; l--; )
    q[l] != null && (typeof r.type == "function" && q[l].__e != null && q[l].__e == r.__d && (r.__d = bu(n, l + 1)), bT(q[l], q[l]));
  if (m)
    for (l = 0; l < m.length; l++)
      qT(m[l], m[++l], m[++l]);
}
function gT(e, t, r) {
  for (var n, i = e.__k, a = 0; i && a < i.length; a++)
    (n = i[a]) && (n.__ = e, t = typeof n.type == "function" ? gT(n, t, r) : yT(r, n, n, i, n.__e, t));
  return t;
}
function rp(e, t) {
  return t = t || [], e == null || typeof e == "boolean" || (Array.isArray(e) ? e.some(function(r) {
    rp(r, t);
  }) : t.push(e)), t;
}
function yT(e, t, r, n, i, a) {
  var s, o, u;
  if (t.__d !== void 0)
    s = t.__d, t.__d = void 0;
  else if (r == null || i != a || i.parentNode == null)
    e:
      if (a == null || a.parentNode !== e)
        e.appendChild(i), s = null;
      else {
        for (o = a, u = 0; (o = o.nextSibling) && u < n.length; u += 2)
          if (o == i)
            break e;
        e.insertBefore(i, a), s = a;
      }
  return s !== void 0 ? s : i.nextSibling;
}
function dve(e, t, r, n, i) {
  var a;
  for (a in r)
    a === "children" || a === "key" || a in t || np(e, a, null, r[a], n);
  for (a in t)
    i && typeof t[a] != "function" || a === "children" || a === "key" || a === "value" || a === "checked" || r[a] === t[a] || np(e, a, t[a], r[a], n);
}
function m6(e, t, r) {
  t[0] === "-" ? e.setProperty(t, r) : e[t] = r == null ? "" : typeof r != "number" || lve.test(t) ? r : r + "px";
}
function np(e, t, r, n, i) {
  var a;
  e:
    if (t === "style")
      if (typeof r == "string")
        e.style.cssText = r;
      else {
        if (typeof n == "string" && (e.style.cssText = n = ""), n)
          for (t in n)
            r && t in r || m6(e.style, t, "");
        if (r)
          for (t in r)
            n && r[t] === n[t] || m6(e.style, t, r[t]);
      }
    else if (t[0] === "o" && t[1] === "n")
      a = t !== (t = t.replace(/Capture$/, "")), t = t.toLowerCase() in e ? t.toLowerCase().slice(2) : t.slice(2), e.l || (e.l = {}), e.l[t + a] = r, r ? n || e.addEventListener(t, a ? y6 : g6, a) : e.removeEventListener(t, a ? y6 : g6, a);
    else if (t !== "dangerouslySetInnerHTML") {
      if (i)
        t = t.replace(/xlink[H:h]/, "h").replace(/sName$/, "s");
      else if (t !== "href" && t !== "list" && t !== "form" && t !== "tabIndex" && t !== "download" && t in e)
        try {
          e[t] = r ?? "";
          break e;
        } catch {
        }
      typeof r == "function" || (r != null && (r !== !1 || t[0] === "a" && t[1] === "r") ? e.setAttribute(t, r) : e.removeAttribute(t));
    }
}
function g6(e) {
  this.l[e.type + !1](kt.event ? kt.event(e) : e);
}
function y6(e) {
  this.l[e.type + !0](kt.event ? kt.event(e) : e);
}
function Oq(e, t, r, n, i, a, s, o, u) {
  var f, l, d, c, p, v, h, m, q, w, O, C = t.type;
  if (t.constructor !== void 0)
    return null;
  r.__h != null && (u = r.__h, o = t.__e = r.__e, t.__h = null, a = [
    o
  ]), (f = kt.__b) && f(t);
  try {
    e:
      if (typeof C == "function") {
        if (m = t.props, q = (f = C.contextType) && n[f.__c], w = f ? q ? q.props.value : f.__ : n, r.__c ? h = (l = t.__c = r.__c).__ = l.__E : ("prototype" in C && C.prototype.render ? t.__c = l = new C(m, w) : (t.__c = l = new ji(m, w), l.constructor = C, l.render = pve), q && q.sub(l), l.props = m, l.state || (l.state = {}), l.context = w, l.__n = n, d = l.__d = !0, l.__h = []), l.__s == null && (l.__s = l.state), C.getDerivedStateFromProps != null && (l.__s == l.state && (l.__s = Qa({}, l.__s)), Qa(l.__s, C.getDerivedStateFromProps(m, l.__s))), c = l.props, p = l.state, d)
          C.getDerivedStateFromProps == null && l.componentWillMount != null && l.componentWillMount(), l.componentDidMount != null && l.__h.push(l.componentDidMount);
        else {
          if (C.getDerivedStateFromProps == null && m !== c && l.componentWillReceiveProps != null && l.componentWillReceiveProps(m, w), !l.__e && l.shouldComponentUpdate != null && l.shouldComponentUpdate(m, l.__s, w) === !1 || t.__v === r.__v) {
            l.props = m, l.state = l.__s, t.__v !== r.__v && (l.__d = !1), l.__v = t, t.__e = r.__e, t.__k = r.__k, t.__k.forEach(function(R) {
              R && (R.__ = t);
            }), l.__h.length && s.push(l);
            break e;
          }
          l.componentWillUpdate != null && l.componentWillUpdate(m, l.__s, w), l.componentDidUpdate != null && l.__h.push(function() {
            l.componentDidUpdate(c, p, v);
          });
        }
        l.context = w, l.props = m, l.state = l.__s, (f = kt.__r) && f(t), l.__d = !1, l.__v = t, l.__P = e, f = l.render(l.props, l.state, l.context), l.state = l.__s, l.getChildContext != null && (n = Qa(Qa({}, n), l.getChildContext())), d || l.getSnapshotBeforeUpdate == null || (v = l.getSnapshotBeforeUpdate(c, p)), O = f != null && f.type === qu && f.key == null ? f.props.children : f, mT(e, Array.isArray(O) ? O : [
          O
        ], t, r, n, i, a, s, o, u), l.base = t.__e, t.__h = null, l.__h.length && s.push(l), h && (l.__E = l.__ = null), l.__e = !1;
      } else
        a == null && t.__v === r.__v ? (t.__k = r.__k, t.__e = r.__e) : t.__e = cve(r.__e, t, r, n, i, a, s, u);
    (f = kt.diffed) && f(t);
  } catch (R) {
    t.__v = null, (u || a != null) && (t.__e = o, t.__h = !!u, a[a.indexOf(o)] = null), kt.__e(R, t, r);
  }
}
function VT(e, t) {
  kt.__c && kt.__c(t, e), e.some(function(r) {
    try {
      e = r.__h, r.__h = [], e.some(function(n) {
        n.call(r);
      });
    } catch (n) {
      kt.__e(n, r.__v);
    }
  });
}
function cve(e, t, r, n, i, a, s, o) {
  var u, f, l, d = r.props, c = t.props, p = t.type, v = 0;
  if (p === "svg" && (i = !0), a != null) {
    for (; v < a.length; v++)
      if ((u = a[v]) && "setAttribute" in u == !!p && (p ? u.localName === p : u.nodeType === 3)) {
        e = u, a[v] = null;
        break;
      }
  }
  if (e == null) {
    if (p === null)
      return document.createTextNode(c);
    e = i ? document.createElementNS("http://www.w3.org/2000/svg", p) : document.createElement(p, c.is && c), a = null, o = !1;
  }
  if (p === null)
    d === c || o && e.data === c || (e.data = c);
  else {
    if (a = a && wv.call(e.childNodes), f = (d = r.props || ep).dangerouslySetInnerHTML, l = c.dangerouslySetInnerHTML, !o) {
      if (a != null)
        for (d = {}, v = 0; v < e.attributes.length; v++)
          d[e.attributes[v].name] = e.attributes[v].value;
      (l || f) && (l && (f && l.__html == f.__html || l.__html === e.innerHTML) || (e.innerHTML = l && l.__html || ""));
    }
    if (dve(e, c, d, i, o), l)
      t.__k = [];
    else if (v = t.props.children, mT(e, Array.isArray(v) ? v : [
      v
    ], t, r, n, i && p !== "foreignObject", a, s, a ? a[0] : r.__k && bu(r, 0), o), a != null)
      for (v = a.length; v--; )
        a[v] != null && vT(a[v]);
    o || ("value" in c && (v = c.value) !== void 0 && (v !== d.value || v !== e.value || p === "progress" && !v) && np(e, "value", v, d.value, !1), "checked" in c && (v = c.checked) !== void 0 && v !== e.checked && np(e, "checked", v, d.checked, !1));
  }
  return e;
}
function qT(e, t, r) {
  try {
    typeof e == "function" ? e(t) : e.current = t;
  } catch (n) {
    kt.__e(n, r);
  }
}
function bT(e, t, r) {
  var n, i;
  if (kt.unmount && kt.unmount(e), (n = e.ref) && (n.current && n.current !== e.__e || qT(n, null, t)), (n = e.__c) != null) {
    if (n.componentWillUnmount)
      try {
        n.componentWillUnmount();
      } catch (a) {
        kt.__e(a, t);
      }
    n.base = n.__P = null;
  }
  if (n = e.__k)
    for (i = 0; i < n.length; i++)
      n[i] && bT(n[i], t, typeof e.type != "function");
  r || e.__e == null || vT(e.__e), e.__e = e.__d = void 0;
}
function pve(e, t, r) {
  return this.constructor(e, r);
}
function AT(e, t, r) {
  var n, i, a;
  kt.__ && kt.__(e, t), i = (n = typeof r == "function") ? null : r && r.__k || t.__k, a = [], Oq(t, e = (!n && r || t).__k = Yg(qu, null, [
    e
  ]), i || ep, ep, t.ownerSVGElement !== void 0, !n && r ? [
    r
  ] : i ? null : t.firstChild ? wv.call(t.childNodes) : null, a, !n && r ? r : i ? i.__e : t.firstChild, n), VT(a, e);
}
wv = pT.slice, kt = {
  __e: function(e, t) {
    for (var r, n, i; t = t.__; )
      if ((r = t.__c) && !r.__)
        try {
          if ((n = r.constructor) && n.getDerivedStateFromError != null && (r.setState(n.getDerivedStateFromError(e)), i = r.__d), r.componentDidCatch != null && (r.componentDidCatch(e), i = r.__d), i)
            return r.__E = r;
        } catch (a) {
          e = a;
        }
    throw e;
  }
}, dT = 0, ji.prototype.setState = function(e, t) {
  var r;
  r = this.__s != null && this.__s !== this.state ? this.__s : this.__s = Qa({}, this.state), typeof e == "function" && (e = e(Qa({}, r), this.props)), e && Qa(r, e), e != null && this.__v && (t && this.__h.push(t), h6(this));
}, ji.prototype.forceUpdate = function(e) {
  this.__v && (this.__e = !0, e && this.__h.push(e), h6(this));
}, ji.prototype.render = qu, Lf = [], cT = typeof Promise == "function" ? Promise.prototype.then.bind(Promise.resolve()) : setTimeout, tp.__r = 0;
var vve = 0;
function De(e, t, r, n, i) {
  var a, s, o = {};
  for (s in t)
    s == "ref" ? a = t[s] : o[s] = t[s];
  var u = {
    type: e,
    props: o,
    key: r,
    ref: a,
    __k: null,
    __: null,
    __b: 0,
    __e: null,
    __d: void 0,
    __c: null,
    __h: null,
    constructor: void 0,
    __v: --vve,
    __source: n,
    __self: i
  };
  if (typeof e == "function" && (a = e.defaultProps))
    for (s in a)
      o[s] === void 0 && (o[s] = a[s]);
  return kt.vnode && kt.vnode(u), u;
}
function hve(e, t) {
  try {
    window.localStorage[`emoji-mart.${e}`] = JSON.stringify(t);
  } catch {
  }
}
function mve(e) {
  try {
    const t = window.localStorage[`emoji-mart.${e}`];
    if (t)
      return JSON.parse(t);
  } catch {
  }
}
var ns = {
  set: hve,
  get: mve
};
const _1 = /* @__PURE__ */ new Map(), gve = [
  {
    v: 14,
    emoji: "🫠"
  },
  {
    v: 13.1,
    emoji: "😶‍🌫️"
  },
  {
    v: 13,
    emoji: "🥸"
  },
  {
    v: 12.1,
    emoji: "🧑‍🦰"
  },
  {
    v: 12,
    emoji: "🥱"
  },
  {
    v: 11,
    emoji: "🥰"
  },
  {
    v: 5,
    emoji: "🤩"
  },
  {
    v: 4,
    emoji: "👱‍♀️"
  },
  {
    v: 3,
    emoji: "🤣"
  },
  {
    v: 2,
    emoji: "👋🏻"
  },
  {
    v: 1,
    emoji: "🙃"
  }
];
function yve() {
  for (const { v: e, emoji: t } of gve)
    if (wT(t))
      return e;
}
function Vve() {
  return !wT("🇨🇦");
}
function wT(e) {
  if (_1.has(e))
    return _1.get(e);
  const t = qve(e);
  return _1.set(e, t), t;
}
const qve = (() => {
  let e = null;
  try {
    navigator.userAgent.includes("jsdom") || (e = document.createElement("canvas").getContext("2d", {
      willReadFrequently: !0
    }));
  } catch {
  }
  if (!e)
    return () => !1;
  const t = 25, r = 20, n = Math.floor(t / 2);
  return e.font = n + "px Arial, Sans-Serif", e.textBaseline = "top", e.canvas.width = r * 2, e.canvas.height = t, (i) => {
    e.clearRect(0, 0, r * 2, t), e.fillStyle = "#FF0000", e.fillText(i, 0, 22), e.fillStyle = "#0000FF", e.fillText(i, r, 22);
    const a = e.getImageData(0, 0, r, t).data, s = a.length;
    let o = 0;
    for (; o < s && !a[o + 3]; o += 4)
      ;
    if (o >= s)
      return !1;
    const u = r + o / 4 % r, f = Math.floor(o / 4 / r), l = e.getImageData(u, f, 1, 1).data;
    return !(a[o] !== l[0] || a[o + 2] !== l[2] || e.measureText(i).width >= r);
  };
})();
var V6 = {
  latestVersion: yve,
  noCountryFlags: Vve
};
const zg = [
  "+1",
  "grinning",
  "kissing_heart",
  "heart_eyes",
  "laughing",
  "stuck_out_tongue_winking_eye",
  "sweat_smile",
  "joy",
  "scream",
  "disappointed",
  "unamused",
  "weary",
  "sob",
  "sunglasses",
  "heart"
];
let an = null;
function bve(e) {
  an || (an = ns.get("frequently") || {});
  const t = e.id || e;
  t && (an[t] || (an[t] = 0), an[t] += 1, ns.set("last", t), ns.set("frequently", an));
}
function Ave({ maxFrequentRows: e, perLine: t }) {
  if (!e)
    return [];
  an || (an = ns.get("frequently"));
  let r = [];
  if (!an) {
    an = {};
    for (let a in zg.slice(0, t)) {
      const s = zg[a];
      an[s] = t - a, r.push(s);
    }
    return r;
  }
  const n = e * t, i = ns.get("last");
  for (let a in an)
    r.push(a);
  if (r.sort((a, s) => {
    const o = an[s], u = an[a];
    return o == u ? a.localeCompare(s) : o - u;
  }), r.length > n) {
    const a = r.slice(n);
    r = r.slice(0, n);
    for (let s of a)
      s != i && delete an[s];
    i && r.indexOf(i) == -1 && (delete an[r[r.length - 1]], r.splice(-1, 1, i)), ns.set("frequently", an);
  }
  return r;
}
var kT = {
  add: bve,
  get: Ave,
  DEFAULTS: zg
}, WT = {};
WT = JSON.parse('{"search":"Search","search_no_results_1":"Oh no!","search_no_results_2":"That emoji couldn’t be found","pick":"Pick an emoji…","add_custom":"Add custom emoji","categories":{"activity":"Activity","custom":"Custom","flags":"Flags","foods":"Food & Drink","frequent":"Frequently used","nature":"Animals & Nature","objects":"Objects","people":"Smileys & People","places":"Travel & Places","search":"Search Results","symbols":"Symbols"},"skins":{"1":"Default","2":"Light","3":"Medium-Light","4":"Medium","5":"Medium-Dark","6":"Dark","choose":"Choose default skin tone"}}');
var va = {
  autoFocus: {
    value: !1
  },
  dynamicWidth: {
    value: !1
  },
  emojiButtonColors: {
    value: null
  },
  emojiButtonRadius: {
    value: "100%"
  },
  emojiButtonSize: {
    value: 36
  },
  emojiSize: {
    value: 24
  },
  emojiVersion: {
    value: 14,
    choices: [
      1,
      2,
      3,
      4,
      5,
      11,
      12,
      12.1,
      13,
      13.1,
      14
    ]
  },
  exceptEmojis: {
    value: []
  },
  icons: {
    value: "auto",
    choices: [
      "auto",
      "outline",
      "solid"
    ]
  },
  locale: {
    value: "en",
    choices: [
      "en",
      "ar",
      "be",
      "cs",
      "de",
      "es",
      "fa",
      "fi",
      "fr",
      "hi",
      "it",
      "ja",
      "kr",
      "nl",
      "pl",
      "pt",
      "ru",
      "sa",
      "tr",
      "uk",
      "vi",
      "zh"
    ]
  },
  maxFrequentRows: {
    value: 4
  },
  navPosition: {
    value: "top",
    choices: [
      "top",
      "bottom",
      "none"
    ]
  },
  noCountryFlags: {
    value: !1
  },
  noResultsEmoji: {
    value: null
  },
  perLine: {
    value: 9
  },
  previewEmoji: {
    value: null
  },
  previewPosition: {
    value: "bottom",
    choices: [
      "top",
      "bottom",
      "none"
    ]
  },
  searchPosition: {
    value: "sticky",
    choices: [
      "sticky",
      "static",
      "none"
    ]
  },
  set: {
    value: "native",
    choices: [
      "native",
      "apple",
      "facebook",
      "google",
      "twitter"
    ]
  },
  skin: {
    value: 1,
    choices: [
      1,
      2,
      3,
      4,
      5,
      6
    ]
  },
  skinTonePosition: {
    value: "preview",
    choices: [
      "preview",
      "search",
      "none"
    ]
  },
  theme: {
    value: "auto",
    choices: [
      "auto",
      "light",
      "dark"
    ]
  },
  // Data
  categories: null,
  categoryIcons: null,
  custom: null,
  data: null,
  i18n: null,
  // Callbacks
  getImageURL: null,
  getSpritesheetURL: null,
  onAddCustomEmoji: null,
  onClickOutside: null,
  onEmojiSelect: null,
  // Deprecated
  stickySearch: {
    deprecated: !0,
    value: !0
  }
};
let cn = null, Pt = null;
const $1 = {};
async function q6(e) {
  if ($1[e])
    return $1[e];
  const r = await (await fetch(e)).json();
  return $1[e] = r, r;
}
let em = null, ST = null, CT = !1;
function kv(e, { caller: t } = {}) {
  return em || (em = new Promise((r) => {
    ST = r;
  })), e ? wve(e) : t && !CT && console.warn(`\`${t}\` requires data to be initialized first. Promise will be pending until \`init\` is called.`), em;
}
async function wve(e) {
  CT = !0;
  let { emojiVersion: t, set: r, locale: n } = e;
  if (t || (t = va.emojiVersion.value), r || (r = va.set.value), n || (n = va.locale.value), Pt)
    Pt.categories = Pt.categories.filter((u) => !u.name);
  else {
    Pt = (typeof e.data == "function" ? await e.data() : e.data) || await q6(`https://cdn.jsdelivr.net/npm/@emoji-mart/data@latest/sets/${t}/${r}.json`), Pt.emoticons = {}, Pt.natives = {}, Pt.categories.unshift({
      id: "frequent",
      emojis: []
    });
    for (const u in Pt.aliases) {
      const f = Pt.aliases[u], l = Pt.emojis[f];
      l && (l.aliases || (l.aliases = []), l.aliases.push(u));
    }
    Pt.originalCategories = Pt.categories;
  }
  if (cn = (typeof e.i18n == "function" ? await e.i18n() : e.i18n) || (n == "en" ? /* @__PURE__ */ lT(WT) : await q6(`https://cdn.jsdelivr.net/npm/@emoji-mart/data@latest/i18n/${n}.json`)), e.custom)
    for (let u in e.custom) {
      u = parseInt(u);
      const f = e.custom[u], l = e.custom[u - 1];
      if (!(!f.emojis || !f.emojis.length)) {
        f.id || (f.id = `custom_${u + 1}`), f.name || (f.name = cn.categories.custom), l && !f.icon && (f.target = l.target || l), Pt.categories.push(f);
        for (const d of f.emojis)
          Pt.emojis[d.id] = d;
      }
    }
  e.categories && (Pt.categories = Pt.originalCategories.filter((u) => e.categories.indexOf(u.id) != -1).sort((u, f) => {
    const l = e.categories.indexOf(u.id), d = e.categories.indexOf(f.id);
    return l - d;
  }));
  let i = null, a = null;
  r == "native" && (i = V6.latestVersion(), a = e.noCountryFlags || V6.noCountryFlags());
  let s = Pt.categories.length, o = !1;
  for (; s--; ) {
    const u = Pt.categories[s];
    if (u.id == "frequent") {
      let { maxFrequentRows: d, perLine: c } = e;
      d = d >= 0 ? d : va.maxFrequentRows.value, c || (c = va.perLine.value), u.emojis = kT.get({
        maxFrequentRows: d,
        perLine: c
      });
    }
    if (!u.emojis || !u.emojis.length) {
      Pt.categories.splice(s, 1);
      continue;
    }
    const { categoryIcons: f } = e;
    if (f) {
      const d = f[u.id];
      d && !u.icon && (u.icon = d);
    }
    let l = u.emojis.length;
    for (; l--; ) {
      const d = u.emojis[l], c = d.id ? d : Pt.emojis[d], p = () => {
        u.emojis.splice(l, 1);
      };
      if (!c || e.exceptEmojis && e.exceptEmojis.includes(c.id)) {
        p();
        continue;
      }
      if (i && c.version > i) {
        p();
        continue;
      }
      if (a && u.id == "flags" && !Fve.includes(c.id)) {
        p();
        continue;
      }
      if (!c.search) {
        if (o = !0, c.search = "," + [
          [
            c.id,
            !1
          ],
          [
            c.name,
            !0
          ],
          [
            c.keywords,
            !1
          ],
          [
            c.emoticons,
            !1
          ]
        ].map(([h, m]) => {
          if (h)
            return (Array.isArray(h) ? h : [
              h
            ]).map((q) => (m ? q.split(/[-|_|\s]+/) : [
              q
            ]).map((w) => w.toLowerCase())).flat();
        }).flat().filter((h) => h && h.trim()).join(","), c.emoticons)
          for (const h of c.emoticons)
            Pt.emoticons[h] || (Pt.emoticons[h] = c.id);
        let v = 0;
        for (const h of c.skins) {
          if (!h)
            continue;
          v++;
          const { native: m } = h;
          m && (Pt.natives[m] = c.id, c.search += `,${m}`);
          const q = v == 1 ? "" : `:skin-tone-${v}:`;
          h.shortcodes = `:${c.id}:${q}`;
        }
      }
    }
  }
  o && ru.reset(), ST();
}
function FT(e, t, r) {
  e || (e = {});
  const n = {};
  for (let i in t)
    n[i] = KT(i, e, t, r);
  return n;
}
function KT(e, t, r, n) {
  const i = r[e];
  let a = n && n.getAttribute(e) || (t[e] != null && t[e] != null ? t[e] : null);
  return i && (a != null && i.value && typeof i.value != typeof a && (typeof i.value == "boolean" ? a = a != "false" : a = i.value.constructor(a)), i.transform && a && (a = i.transform(a)), (a == null || i.choices && i.choices.indexOf(a) == -1) && (a = i.value)), a;
}
const kve = /^(?:\:([^\:]+)\:)(?:\:skin-tone-(\d)\:)?$/;
let Gg = null;
function Wve(e) {
  return e.id ? e : Pt.emojis[e] || Pt.emojis[Pt.aliases[e]] || Pt.emojis[Pt.natives[e]];
}
function Sve() {
  Gg = null;
}
async function Cve(e, { maxResults: t, caller: r } = {}) {
  if (!e || !e.trim().length)
    return null;
  t || (t = 90), await kv(null, {
    caller: r || "SearchIndex.search"
  });
  const n = e.toLowerCase().replace(/(\w)-/, "$1 ").split(/[\s|,]+/).filter((o, u, f) => o.trim() && f.indexOf(o) == u);
  if (!n.length)
    return;
  let i = Gg || (Gg = Object.values(Pt.emojis)), a, s;
  for (const o of n) {
    if (!i.length)
      break;
    a = [], s = {};
    for (const u of i) {
      if (!u.search)
        continue;
      const f = u.search.indexOf(`,${o}`);
      f != -1 && (a.push(u), s[u.id] || (s[u.id] = 0), s[u.id] += u.id == o ? 0 : f + 1);
    }
    i = a;
  }
  return a.length < 2 || (a.sort((o, u) => {
    const f = s[o.id], l = s[u.id];
    return f == l ? o.id.localeCompare(u.id) : f - l;
  }), a.length > t && (a = a.slice(0, t))), a;
}
var ru = {
  search: Cve,
  get: Wve,
  reset: Sve,
  SHORTCODES_REGEX: kve
};
const Fve = [
  "checkered_flag",
  "crossed_flags",
  "pirate_flag",
  "rainbow-flag",
  "transgender_flag",
  "triangular_flag_on_post",
  "waving_black_flag",
  "waving_white_flag"
];
function Kve(e, t) {
  return Array.isArray(e) && Array.isArray(t) && e.length === t.length && e.every((r, n) => r == t[n]);
}
async function Rve(e = 1) {
  for (let t in [
    ...Array(e).keys()
  ])
    await new Promise(requestAnimationFrame);
}
function Tve(e, { skinIndex: t = 0 } = {}) {
  const r = e.skins[t] || (() => (t = 0, e.skins[t]))(), n = {
    id: e.id,
    name: e.name,
    native: r.native,
    unified: r.unified,
    keywords: e.keywords,
    shortcodes: r.shortcodes || e.shortcodes
  };
  return e.skins.length > 1 && (n.skin = t + 1), r.src && (n.src = r.src), e.aliases && e.aliases.length && (n.aliases = e.aliases), e.emoticons && e.emoticons.length && (n.emoticons = e.emoticons), n;
}
const Uve = {
  activity: {
    outline: /* @__PURE__ */ De("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      children: /* @__PURE__ */ De("path", {
        d: "M12 0C5.373 0 0 5.372 0 12c0 6.627 5.373 12 12 12 6.628 0 12-5.373 12-12 0-6.628-5.372-12-12-12m9.949 11H17.05c.224-2.527 1.232-4.773 1.968-6.113A9.966 9.966 0 0 1 21.949 11M13 11V2.051a9.945 9.945 0 0 1 4.432 1.564c-.858 1.491-2.156 4.22-2.392 7.385H13zm-2 0H8.961c-.238-3.165-1.536-5.894-2.393-7.385A9.95 9.95 0 0 1 11 2.051V11zm0 2v8.949a9.937 9.937 0 0 1-4.432-1.564c.857-1.492 2.155-4.221 2.393-7.385H11zm4.04 0c.236 3.164 1.534 5.893 2.392 7.385A9.92 9.92 0 0 1 13 21.949V13h2.04zM4.982 4.887C5.718 6.227 6.726 8.473 6.951 11h-4.9a9.977 9.977 0 0 1 2.931-6.113M2.051 13h4.9c-.226 2.527-1.233 4.771-1.969 6.113A9.972 9.972 0 0 1 2.051 13m16.967 6.113c-.735-1.342-1.744-3.586-1.968-6.113h4.899a9.961 9.961 0 0 1-2.931 6.113"
      })
    }),
    solid: /* @__PURE__ */ De("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 512 512",
      children: /* @__PURE__ */ De("path", {
        d: "M16.17 337.5c0 44.98 7.565 83.54 13.98 107.9C35.22 464.3 50.46 496 174.9 496c9.566 0 19.59-.4707 29.84-1.271L17.33 307.3C16.53 317.6 16.17 327.7 16.17 337.5zM495.8 174.5c0-44.98-7.565-83.53-13.98-107.9c-4.688-17.54-18.34-31.23-36.04-35.95C435.5 27.91 392.9 16 337 16c-9.564 0-19.59 .4707-29.84 1.271l187.5 187.5C495.5 194.4 495.8 184.3 495.8 174.5zM26.77 248.8l236.3 236.3c142-36.1 203.9-150.4 222.2-221.1L248.9 26.87C106.9 62.96 45.07 177.2 26.77 248.8zM256 335.1c0 9.141-7.474 16-16 16c-4.094 0-8.188-1.564-11.31-4.689L164.7 283.3C161.6 280.2 160 276.1 160 271.1c0-8.529 6.865-16 16-16c4.095 0 8.189 1.562 11.31 4.688l64.01 64C254.4 327.8 256 331.9 256 335.1zM304 287.1c0 9.141-7.474 16-16 16c-4.094 0-8.188-1.564-11.31-4.689L212.7 235.3C209.6 232.2 208 228.1 208 223.1c0-9.141 7.473-16 16-16c4.094 0 8.188 1.562 11.31 4.688l64.01 64.01C302.5 279.8 304 283.9 304 287.1zM256 175.1c0-9.141 7.473-16 16-16c4.094 0 8.188 1.562 11.31 4.688l64.01 64.01c3.125 3.125 4.688 7.219 4.688 11.31c0 9.133-7.468 16-16 16c-4.094 0-8.189-1.562-11.31-4.688l-64.01-64.01C257.6 184.2 256 180.1 256 175.1z"
      })
    })
  },
  custom: /* @__PURE__ */ De("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    children: /* @__PURE__ */ De("path", {
      d: "M417.1 368c-5.937 10.27-16.69 16-27.75 16c-5.422 0-10.92-1.375-15.97-4.281L256 311.4V448c0 17.67-14.33 32-31.1 32S192 465.7 192 448V311.4l-118.3 68.29C68.67 382.6 63.17 384 57.75 384c-11.06 0-21.81-5.734-27.75-16c-8.828-15.31-3.594-34.88 11.72-43.72L159.1 256L41.72 187.7C26.41 178.9 21.17 159.3 29.1 144C36.63 132.5 49.26 126.7 61.65 128.2C65.78 128.7 69.88 130.1 73.72 132.3L192 200.6V64c0-17.67 14.33-32 32-32S256 46.33 256 64v136.6l118.3-68.29c3.838-2.213 7.939-3.539 12.07-4.051C398.7 126.7 411.4 132.5 417.1 144c8.828 15.31 3.594 34.88-11.72 43.72L288 256l118.3 68.28C421.6 333.1 426.8 352.7 417.1 368z"
    })
  }),
  flags: {
    outline: /* @__PURE__ */ De("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      children: /* @__PURE__ */ De("path", {
        d: "M0 0l6.084 24H8L1.916 0zM21 5h-4l-1-4H4l3 12h3l1 4h13L21 5zM6.563 3h7.875l2 8H8.563l-2-8zm8.832 10l-2.856 1.904L12.063 13h3.332zM19 13l-1.5-6h1.938l2 8H16l3-2z"
      })
    }),
    solid: /* @__PURE__ */ De("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 512 512",
      children: /* @__PURE__ */ De("path", {
        d: "M64 496C64 504.8 56.75 512 48 512h-32C7.25 512 0 504.8 0 496V32c0-17.75 14.25-32 32-32s32 14.25 32 32V496zM476.3 0c-6.365 0-13.01 1.35-19.34 4.233c-45.69 20.86-79.56 27.94-107.8 27.94c-59.96 0-94.81-31.86-163.9-31.87C160.9 .3055 131.6 4.867 96 15.75v350.5c32-9.984 59.87-14.1 84.85-14.1c73.63 0 124.9 31.78 198.6 31.78c31.91 0 68.02-5.971 111.1-23.09C504.1 355.9 512 344.4 512 332.1V30.73C512 11.1 495.3 0 476.3 0z"
      })
    })
  },
  foods: {
    outline: /* @__PURE__ */ De("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      children: /* @__PURE__ */ De("path", {
        d: "M17 4.978c-1.838 0-2.876.396-3.68.934.513-1.172 1.768-2.934 4.68-2.934a1 1 0 0 0 0-2c-2.921 0-4.629 1.365-5.547 2.512-.064.078-.119.162-.18.244C11.73 1.838 10.798.023 9.207.023 8.579.022 7.85.306 7 .978 5.027 2.54 5.329 3.902 6.492 4.999 3.609 5.222 0 7.352 0 12.969c0 4.582 4.961 11.009 9 11.009 1.975 0 2.371-.486 3-1 .629.514 1.025 1 3 1 4.039 0 9-6.418 9-11 0-5.953-4.055-8-7-8M8.242 2.546c.641-.508.943-.523.965-.523.426.169.975 1.405 1.357 3.055-1.527-.629-2.741-1.352-2.98-1.846.059-.112.241-.356.658-.686M15 21.978c-1.08 0-1.21-.109-1.559-.402l-.176-.146c-.367-.302-.816-.452-1.266-.452s-.898.15-1.266.452l-.176.146c-.347.292-.477.402-1.557.402-2.813 0-7-5.389-7-9.009 0-5.823 4.488-5.991 5-5.991 1.939 0 2.484.471 3.387 1.251l.323.276a1.995 1.995 0 0 0 2.58 0l.323-.276c.902-.78 1.447-1.251 3.387-1.251.512 0 5 .168 5 6 0 3.617-4.187 9-7 9"
      })
    }),
    solid: /* @__PURE__ */ De("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 512 512",
      children: /* @__PURE__ */ De("path", {
        d: "M481.9 270.1C490.9 279.1 496 291.3 496 304C496 316.7 490.9 328.9 481.9 337.9C472.9 346.9 460.7 352 448 352H64C51.27 352 39.06 346.9 30.06 337.9C21.06 328.9 16 316.7 16 304C16 291.3 21.06 279.1 30.06 270.1C39.06 261.1 51.27 256 64 256H448C460.7 256 472.9 261.1 481.9 270.1zM475.3 388.7C478.3 391.7 480 395.8 480 400V416C480 432.1 473.3 449.3 461.3 461.3C449.3 473.3 432.1 480 416 480H96C79.03 480 62.75 473.3 50.75 461.3C38.74 449.3 32 432.1 32 416V400C32 395.8 33.69 391.7 36.69 388.7C39.69 385.7 43.76 384 48 384H464C468.2 384 472.3 385.7 475.3 388.7zM50.39 220.8C45.93 218.6 42.03 215.5 38.97 211.6C35.91 207.7 33.79 203.2 32.75 198.4C31.71 193.5 31.8 188.5 32.99 183.7C54.98 97.02 146.5 32 256 32C365.5 32 457 97.02 479 183.7C480.2 188.5 480.3 193.5 479.2 198.4C478.2 203.2 476.1 207.7 473 211.6C469.1 215.5 466.1 218.6 461.6 220.8C457.2 222.9 452.3 224 447.3 224H64.67C59.73 224 54.84 222.9 50.39 220.8zM372.7 116.7C369.7 119.7 368 123.8 368 128C368 131.2 368.9 134.3 370.7 136.9C372.5 139.5 374.1 141.6 377.9 142.8C380.8 143.1 384 144.3 387.1 143.7C390.2 143.1 393.1 141.6 395.3 139.3C397.6 137.1 399.1 134.2 399.7 131.1C400.3 128 399.1 124.8 398.8 121.9C397.6 118.1 395.5 116.5 392.9 114.7C390.3 112.9 387.2 111.1 384 111.1C379.8 111.1 375.7 113.7 372.7 116.7V116.7zM244.7 84.69C241.7 87.69 240 91.76 240 96C240 99.16 240.9 102.3 242.7 104.9C244.5 107.5 246.1 109.6 249.9 110.8C252.8 111.1 256 112.3 259.1 111.7C262.2 111.1 265.1 109.6 267.3 107.3C269.6 105.1 271.1 102.2 271.7 99.12C272.3 96.02 271.1 92.8 270.8 89.88C269.6 86.95 267.5 84.45 264.9 82.7C262.3 80.94 259.2 79.1 256 79.1C251.8 79.1 247.7 81.69 244.7 84.69V84.69zM116.7 116.7C113.7 119.7 112 123.8 112 128C112 131.2 112.9 134.3 114.7 136.9C116.5 139.5 118.1 141.6 121.9 142.8C124.8 143.1 128 144.3 131.1 143.7C134.2 143.1 137.1 141.6 139.3 139.3C141.6 137.1 143.1 134.2 143.7 131.1C144.3 128 143.1 124.8 142.8 121.9C141.6 118.1 139.5 116.5 136.9 114.7C134.3 112.9 131.2 111.1 128 111.1C123.8 111.1 119.7 113.7 116.7 116.7L116.7 116.7z"
      })
    })
  },
  frequent: {
    outline: /* @__PURE__ */ De("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      children: [
        /* @__PURE__ */ De("path", {
          d: "M13 4h-2l-.001 7H9v2h2v2h2v-2h4v-2h-4z"
        }),
        /* @__PURE__ */ De("path", {
          d: "M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0m0 22C6.486 22 2 17.514 2 12S6.486 2 12 2s10 4.486 10 10-4.486 10-10 10"
        })
      ]
    }),
    solid: /* @__PURE__ */ De("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 512 512",
      children: /* @__PURE__ */ De("path", {
        d: "M256 512C114.6 512 0 397.4 0 256C0 114.6 114.6 0 256 0C397.4 0 512 114.6 512 256C512 397.4 397.4 512 256 512zM232 256C232 264 236 271.5 242.7 275.1L338.7 339.1C349.7 347.3 364.6 344.3 371.1 333.3C379.3 322.3 376.3 307.4 365.3 300L280 243.2V120C280 106.7 269.3 96 255.1 96C242.7 96 231.1 106.7 231.1 120L232 256z"
      })
    })
  },
  nature: {
    outline: /* @__PURE__ */ De("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      children: [
        /* @__PURE__ */ De("path", {
          d: "M15.5 8a1.5 1.5 0 1 0 .001 3.001A1.5 1.5 0 0 0 15.5 8M8.5 8a1.5 1.5 0 1 0 .001 3.001A1.5 1.5 0 0 0 8.5 8"
        }),
        /* @__PURE__ */ De("path", {
          d: "M18.933 0h-.027c-.97 0-2.138.787-3.018 1.497-1.274-.374-2.612-.51-3.887-.51-1.285 0-2.616.133-3.874.517C7.245.79 6.069 0 5.093 0h-.027C3.352 0 .07 2.67.002 7.026c-.039 2.479.276 4.238 1.04 5.013.254.258.882.677 1.295.882.191 3.177.922 5.238 2.536 6.38.897.637 2.187.949 3.2 1.102C8.04 20.6 8 20.795 8 21c0 1.773 2.35 3 4 3 1.648 0 4-1.227 4-3 0-.201-.038-.393-.072-.586 2.573-.385 5.435-1.877 5.925-7.587.396-.22.887-.568 1.104-.788.763-.774 1.079-2.534 1.04-5.013C23.929 2.67 20.646 0 18.933 0M3.223 9.135c-.237.281-.837 1.155-.884 1.238-.15-.41-.368-1.349-.337-3.291.051-3.281 2.478-4.972 3.091-5.031.256.015.731.27 1.265.646-1.11 1.171-2.275 2.915-2.352 5.125-.133.546-.398.858-.783 1.313M12 22c-.901 0-1.954-.693-2-1 0-.654.475-1.236 1-1.602V20a1 1 0 1 0 2 0v-.602c.524.365 1 .947 1 1.602-.046.307-1.099 1-2 1m3-3.48v.02a4.752 4.752 0 0 0-1.262-1.02c1.092-.516 2.239-1.334 2.239-2.217 0-1.842-1.781-2.195-3.977-2.195-2.196 0-3.978.354-3.978 2.195 0 .883 1.148 1.701 2.238 2.217A4.8 4.8 0 0 0 9 18.539v-.025c-1-.076-2.182-.281-2.973-.842-1.301-.92-1.838-3.045-1.853-6.478l.023-.041c.496-.826 1.49-1.45 1.804-3.102 0-2.047 1.357-3.631 2.362-4.522C9.37 3.178 10.555 3 11.948 3c1.447 0 2.685.192 3.733.57 1 .9 2.316 2.465 2.316 4.48.313 1.651 1.307 2.275 1.803 3.102.035.058.068.117.102.178-.059 5.967-1.949 7.01-4.902 7.19m6.628-8.202c-.037-.065-.074-.13-.113-.195a7.587 7.587 0 0 0-.739-.987c-.385-.455-.648-.768-.782-1.313-.076-2.209-1.241-3.954-2.353-5.124.531-.376 1.004-.63 1.261-.647.636.071 3.044 1.764 3.096 5.031.027 1.81-.347 3.218-.37 3.235"
        })
      ]
    }),
    solid: /* @__PURE__ */ De("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 576 512",
      children: /* @__PURE__ */ De("path", {
        d: "M332.7 19.85C334.6 8.395 344.5 0 356.1 0C363.6 0 370.6 3.52 375.1 9.502L392 32H444.1C456.8 32 469.1 37.06 478.1 46.06L496 64H552C565.3 64 576 74.75 576 88V112C576 156.2 540.2 192 496 192H426.7L421.6 222.5L309.6 158.5L332.7 19.85zM448 64C439.2 64 432 71.16 432 80C432 88.84 439.2 96 448 96C456.8 96 464 88.84 464 80C464 71.16 456.8 64 448 64zM416 256.1V480C416 497.7 401.7 512 384 512H352C334.3 512 320 497.7 320 480V364.8C295.1 377.1 268.8 384 240 384C211.2 384 184 377.1 160 364.8V480C160 497.7 145.7 512 128 512H96C78.33 512 64 497.7 64 480V249.8C35.23 238.9 12.64 214.5 4.836 183.3L.9558 167.8C-3.331 150.6 7.094 133.2 24.24 128.1C41.38 124.7 58.76 135.1 63.05 152.2L66.93 167.8C70.49 182 83.29 191.1 97.97 191.1H303.8L416 256.1z"
      })
    })
  },
  objects: {
    outline: /* @__PURE__ */ De("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      children: [
        /* @__PURE__ */ De("path", {
          d: "M12 0a9 9 0 0 0-5 16.482V21s2.035 3 5 3 5-3 5-3v-4.518A9 9 0 0 0 12 0zm0 2c3.86 0 7 3.141 7 7s-3.14 7-7 7-7-3.141-7-7 3.14-7 7-7zM9 17.477c.94.332 1.946.523 3 .523s2.06-.19 3-.523v.834c-.91.436-1.925.689-3 .689a6.924 6.924 0 0 1-3-.69v-.833zm.236 3.07A8.854 8.854 0 0 0 12 21c.965 0 1.888-.167 2.758-.451C14.155 21.173 13.153 22 12 22c-1.102 0-2.117-.789-2.764-1.453z"
        }),
        /* @__PURE__ */ De("path", {
          d: "M14.745 12.449h-.004c-.852-.024-1.188-.858-1.577-1.824-.421-1.061-.703-1.561-1.182-1.566h-.009c-.481 0-.783.497-1.235 1.537-.436.982-.801 1.811-1.636 1.791l-.276-.043c-.565-.171-.853-.691-1.284-1.794-.125-.313-.202-.632-.27-.913-.051-.213-.127-.53-.195-.634C7.067 9.004 7.039 9 6.99 9A1 1 0 0 1 7 7h.01c1.662.017 2.015 1.373 2.198 2.134.486-.981 1.304-2.058 2.797-2.075 1.531.018 2.28 1.153 2.731 2.141l.002-.008C14.944 8.424 15.327 7 16.979 7h.032A1 1 0 1 1 17 9h-.011c-.149.076-.256.474-.319.709a6.484 6.484 0 0 1-.311.951c-.429.973-.79 1.789-1.614 1.789"
        })
      ]
    }),
    solid: /* @__PURE__ */ De("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 384 512",
      children: /* @__PURE__ */ De("path", {
        d: "M112.1 454.3c0 6.297 1.816 12.44 5.284 17.69l17.14 25.69c5.25 7.875 17.17 14.28 26.64 14.28h61.67c9.438 0 21.36-6.401 26.61-14.28l17.08-25.68c2.938-4.438 5.348-12.37 5.348-17.7L272 415.1h-160L112.1 454.3zM191.4 .0132C89.44 .3257 16 82.97 16 175.1c0 44.38 16.44 84.84 43.56 115.8c16.53 18.84 42.34 58.23 52.22 91.45c.0313 .25 .0938 .5166 .125 .7823h160.2c.0313-.2656 .0938-.5166 .125-.7823c9.875-33.22 35.69-72.61 52.22-91.45C351.6 260.8 368 220.4 368 175.1C368 78.61 288.9-.2837 191.4 .0132zM192 96.01c-44.13 0-80 35.89-80 79.1C112 184.8 104.8 192 96 192S80 184.8 80 176c0-61.76 50.25-111.1 112-111.1c8.844 0 16 7.159 16 16S200.8 96.01 192 96.01z"
      })
    })
  },
  people: {
    outline: /* @__PURE__ */ De("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      children: [
        /* @__PURE__ */ De("path", {
          d: "M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0m0 22C6.486 22 2 17.514 2 12S6.486 2 12 2s10 4.486 10 10-4.486 10-10 10"
        }),
        /* @__PURE__ */ De("path", {
          d: "M8 7a2 2 0 1 0-.001 3.999A2 2 0 0 0 8 7M16 7a2 2 0 1 0-.001 3.999A2 2 0 0 0 16 7M15.232 15c-.693 1.195-1.87 2-3.349 2-1.477 0-2.655-.805-3.347-2H15m3-2H6a6 6 0 1 0 12 0"
        })
      ]
    }),
    solid: /* @__PURE__ */ De("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 512 512",
      children: /* @__PURE__ */ De("path", {
        d: "M0 256C0 114.6 114.6 0 256 0C397.4 0 512 114.6 512 256C512 397.4 397.4 512 256 512C114.6 512 0 397.4 0 256zM256 432C332.1 432 396.2 382 415.2 314.1C419.1 300.4 407.8 288 393.6 288H118.4C104.2 288 92.92 300.4 96.76 314.1C115.8 382 179.9 432 256 432V432zM176.4 160C158.7 160 144.4 174.3 144.4 192C144.4 209.7 158.7 224 176.4 224C194 224 208.4 209.7 208.4 192C208.4 174.3 194 160 176.4 160zM336.4 224C354 224 368.4 209.7 368.4 192C368.4 174.3 354 160 336.4 160C318.7 160 304.4 174.3 304.4 192C304.4 209.7 318.7 224 336.4 224z"
      })
    })
  },
  places: {
    outline: /* @__PURE__ */ De("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      children: [
        /* @__PURE__ */ De("path", {
          d: "M6.5 12C5.122 12 4 13.121 4 14.5S5.122 17 6.5 17 9 15.879 9 14.5 7.878 12 6.5 12m0 3c-.275 0-.5-.225-.5-.5s.225-.5.5-.5.5.225.5.5-.225.5-.5.5M17.5 12c-1.378 0-2.5 1.121-2.5 2.5s1.122 2.5 2.5 2.5 2.5-1.121 2.5-2.5-1.122-2.5-2.5-2.5m0 3c-.275 0-.5-.225-.5-.5s.225-.5.5-.5.5.225.5.5-.225.5-.5.5"
        }),
        /* @__PURE__ */ De("path", {
          d: "M22.482 9.494l-1.039-.346L21.4 9h.6c.552 0 1-.439 1-.992 0-.006-.003-.008-.003-.008H23c0-1-.889-2-1.984-2h-.642l-.731-1.717C19.262 3.012 18.091 2 16.764 2H7.236C5.909 2 4.738 3.012 4.357 4.283L3.626 6h-.642C1.889 6 1 7 1 8h.003S1 8.002 1 8.008C1 8.561 1.448 9 2 9h.6l-.043.148-1.039.346a2.001 2.001 0 0 0-1.359 2.097l.751 7.508a1 1 0 0 0 .994.901H3v1c0 1.103.896 2 2 2h2c1.104 0 2-.897 2-2v-1h6v1c0 1.103.896 2 2 2h2c1.104 0 2-.897 2-2v-1h1.096a.999.999 0 0 0 .994-.901l.751-7.508a2.001 2.001 0 0 0-1.359-2.097M6.273 4.857C6.402 4.43 6.788 4 7.236 4h9.527c.448 0 .834.43.963.857L19.313 9H4.688l1.585-4.143zM7 21H5v-1h2v1zm12 0h-2v-1h2v1zm2.189-3H2.811l-.662-6.607L3 11h18l.852.393L21.189 18z"
        })
      ]
    }),
    solid: /* @__PURE__ */ De("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 512 512",
      children: /* @__PURE__ */ De("path", {
        d: "M39.61 196.8L74.8 96.29C88.27 57.78 124.6 32 165.4 32H346.6C387.4 32 423.7 57.78 437.2 96.29L472.4 196.8C495.6 206.4 512 229.3 512 256V448C512 465.7 497.7 480 480 480H448C430.3 480 416 465.7 416 448V400H96V448C96 465.7 81.67 480 64 480H32C14.33 480 0 465.7 0 448V256C0 229.3 16.36 206.4 39.61 196.8V196.8zM109.1 192H402.9L376.8 117.4C372.3 104.6 360.2 96 346.6 96H165.4C151.8 96 139.7 104.6 135.2 117.4L109.1 192zM96 256C78.33 256 64 270.3 64 288C64 305.7 78.33 320 96 320C113.7 320 128 305.7 128 288C128 270.3 113.7 256 96 256zM416 320C433.7 320 448 305.7 448 288C448 270.3 433.7 256 416 256C398.3 256 384 270.3 384 288C384 305.7 398.3 320 416 320z"
      })
    })
  },
  symbols: {
    outline: /* @__PURE__ */ De("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      children: /* @__PURE__ */ De("path", {
        d: "M0 0h11v2H0zM4 11h3V6h4V4H0v2h4zM15.5 17c1.381 0 2.5-1.116 2.5-2.493s-1.119-2.493-2.5-2.493S13 13.13 13 14.507 14.119 17 15.5 17m0-2.986c.276 0 .5.222.5.493 0 .272-.224.493-.5.493s-.5-.221-.5-.493.224-.493.5-.493M21.5 19.014c-1.381 0-2.5 1.116-2.5 2.493S20.119 24 21.5 24s2.5-1.116 2.5-2.493-1.119-2.493-2.5-2.493m0 2.986a.497.497 0 0 1-.5-.493c0-.271.224-.493.5-.493s.5.222.5.493a.497.497 0 0 1-.5.493M22 13l-9 9 1.513 1.5 8.99-9.009zM17 11c2.209 0 4-1.119 4-2.5V2s.985-.161 1.498.949C23.01 4.055 23 6 23 6s1-1.119 1-3.135C24-.02 21 0 21 0h-2v6.347A5.853 5.853 0 0 0 17 6c-2.209 0-4 1.119-4 2.5s1.791 2.5 4 2.5M10.297 20.482l-1.475-1.585a47.54 47.54 0 0 1-1.442 1.129c-.307-.288-.989-1.016-2.045-2.183.902-.836 1.479-1.466 1.729-1.892s.376-.871.376-1.336c0-.592-.273-1.178-.818-1.759-.546-.581-1.329-.871-2.349-.871-1.008 0-1.79.293-2.344.879-.556.587-.832 1.181-.832 1.784 0 .813.419 1.748 1.256 2.805-.847.614-1.444 1.208-1.794 1.784a3.465 3.465 0 0 0-.523 1.833c0 .857.308 1.56.924 2.107.616.549 1.423.823 2.42.823 1.173 0 2.444-.379 3.813-1.137L8.235 24h2.819l-2.09-2.383 1.333-1.135zm-6.736-6.389a1.02 1.02 0 0 1 .73-.286c.31 0 .559.085.747.254a.849.849 0 0 1 .283.659c0 .518-.419 1.112-1.257 1.784-.536-.651-.805-1.231-.805-1.742a.901.901 0 0 1 .302-.669M3.74 22c-.427 0-.778-.116-1.057-.349-.279-.232-.418-.487-.418-.766 0-.594.509-1.288 1.527-2.083.968 1.134 1.717 1.946 2.248 2.438-.921.507-1.686.76-2.3.76"
      })
    }),
    solid: /* @__PURE__ */ De("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 512 512",
      children: /* @__PURE__ */ De("path", {
        d: "M500.3 7.251C507.7 13.33 512 22.41 512 31.1V175.1C512 202.5 483.3 223.1 447.1 223.1C412.7 223.1 383.1 202.5 383.1 175.1C383.1 149.5 412.7 127.1 447.1 127.1V71.03L351.1 90.23V207.1C351.1 234.5 323.3 255.1 287.1 255.1C252.7 255.1 223.1 234.5 223.1 207.1C223.1 181.5 252.7 159.1 287.1 159.1V63.1C287.1 48.74 298.8 35.61 313.7 32.62L473.7 .6198C483.1-1.261 492.9 1.173 500.3 7.251H500.3zM74.66 303.1L86.5 286.2C92.43 277.3 102.4 271.1 113.1 271.1H174.9C185.6 271.1 195.6 277.3 201.5 286.2L213.3 303.1H239.1C266.5 303.1 287.1 325.5 287.1 351.1V463.1C287.1 490.5 266.5 511.1 239.1 511.1H47.1C21.49 511.1-.0019 490.5-.0019 463.1V351.1C-.0019 325.5 21.49 303.1 47.1 303.1H74.66zM143.1 359.1C117.5 359.1 95.1 381.5 95.1 407.1C95.1 434.5 117.5 455.1 143.1 455.1C170.5 455.1 191.1 434.5 191.1 407.1C191.1 381.5 170.5 359.1 143.1 359.1zM440.3 367.1H496C502.7 367.1 508.6 372.1 510.1 378.4C513.3 384.6 511.6 391.7 506.5 396L378.5 508C372.9 512.1 364.6 513.3 358.6 508.9C352.6 504.6 350.3 496.6 353.3 489.7L391.7 399.1H336C329.3 399.1 323.4 395.9 321 389.6C318.7 383.4 320.4 376.3 325.5 371.1L453.5 259.1C459.1 255 467.4 254.7 473.4 259.1C479.4 263.4 481.6 271.4 478.7 278.3L440.3 367.1zM116.7 219.1L19.85 119.2C-8.112 90.26-6.614 42.31 24.85 15.34C51.82-8.137 93.26-3.642 118.2 21.83L128.2 32.32L137.7 21.83C162.7-3.642 203.6-8.137 231.6 15.34C262.6 42.31 264.1 90.26 236.1 119.2L139.7 219.1C133.2 225.6 122.7 225.6 116.7 219.1H116.7z"
      })
    })
  }
}, xve = {
  loupe: /* @__PURE__ */ De("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    children: /* @__PURE__ */ De("path", {
      d: "M12.9 14.32a8 8 0 1 1 1.41-1.41l5.35 5.33-1.42 1.42-5.33-5.34zM8 14A6 6 0 1 0 8 2a6 6 0 0 0 0 12z"
    })
  }),
  delete: /* @__PURE__ */ De("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    children: /* @__PURE__ */ De("path", {
      d: "M10 8.586L2.929 1.515 1.515 2.929 8.586 10l-7.071 7.071 1.414 1.414L10 11.414l7.071 7.071 1.414-1.414L11.414 10l7.071-7.071-1.414-1.414L10 8.586z"
    })
  })
};
var ip = {
  categories: Uve,
  search: xve
};
function Qg(e) {
  let { id: t, skin: r, emoji: n } = e;
  if (e.shortcodes) {
    const o = e.shortcodes.match(ru.SHORTCODES_REGEX);
    o && (t = o[1], o[2] && (r = o[2]));
  }
  if (n || (n = ru.get(t || e.native)), !n)
    return e.fallback;
  const i = n.skins[r - 1] || n.skins[0], a = i.src || (e.set != "native" && !e.spritesheet ? typeof e.getImageURL == "function" ? e.getImageURL(e.set, i.unified) : `https://cdn.jsdelivr.net/npm/emoji-datasource-${e.set}@14.0.0/img/${e.set}/64/${i.unified}.png` : void 0), s = typeof e.getSpritesheetURL == "function" ? e.getSpritesheetURL(e.set) : `https://cdn.jsdelivr.net/npm/emoji-datasource-${e.set}@14.0.0/img/${e.set}/sheets-256/64.png`;
  return /* @__PURE__ */ De("span", {
    class: "emoji-mart-emoji",
    "data-emoji-set": e.set,
    children: a ? /* @__PURE__ */ De("img", {
      style: {
        maxWidth: e.size || "1em",
        maxHeight: e.size || "1em",
        display: "inline-block"
      },
      alt: i.native || i.shortcodes,
      src: a
    }) : e.set == "native" ? /* @__PURE__ */ De("span", {
      style: {
        fontSize: e.size,
        fontFamily: '"EmojiMart", "Segoe UI Emoji", "Segoe UI Symbol", "Segoe UI", "Apple Color Emoji", "Twemoji Mozilla", "Noto Color Emoji", "Android Emoji"'
      },
      children: i.native
    }) : /* @__PURE__ */ De("span", {
      style: {
        display: "block",
        width: e.size,
        height: e.size,
        backgroundImage: `url(${s})`,
        backgroundSize: `${100 * Pt.sheet.cols}% ${100 * Pt.sheet.rows}%`,
        backgroundPosition: `${100 / (Pt.sheet.cols - 1) * i.x}% ${100 / (Pt.sheet.rows - 1) * i.y}%`
      }
    })
  });
}
const Eve = typeof window < "u" && window.HTMLElement ? window.HTMLElement : Object;
class RT extends Eve {
  static get observedAttributes() {
    return Object.keys(this.Props);
  }
  update(t = {}) {
    for (let r in t)
      this.attributeChangedCallback(r, null, t[r]);
  }
  attributeChangedCallback(t, r, n) {
    if (!this.component)
      return;
    const i = KT(t, {
      [t]: n
    }, this.constructor.Props, this);
    this.component.componentWillReceiveProps ? this.component.componentWillReceiveProps({
      [t]: i
    }) : (this.component.props[t] = i, this.component.forceUpdate());
  }
  disconnectedCallback() {
    this.disconnected = !0, this.component && this.component.unregister && this.component.unregister();
  }
  constructor(t = {}) {
    if (super(), this.props = t, t.parent || t.ref) {
      let r = null;
      const n = t.parent || (r = t.ref && t.ref.current);
      r && (r.innerHTML = ""), n && n.appendChild(this);
    }
  }
}
class Ove extends RT {
  setShadow() {
    this.attachShadow({
      mode: "open"
    });
  }
  injectStyles(t) {
    if (!t)
      return;
    const r = document.createElement("style");
    r.textContent = t, this.shadowRoot.insertBefore(r, this.shadowRoot.firstChild);
  }
  constructor(t, { styles: r } = {}) {
    super(t), this.setShadow(), this.injectStyles(r);
  }
}
var TT = {
  fallback: "",
  id: "",
  native: "",
  shortcodes: "",
  size: {
    value: "",
    transform: (e) => /\D/.test(e) ? e : `${e}px`
  },
  // Shared
  set: va.set,
  skin: va.skin
};
class UT extends RT {
  async connectedCallback() {
    const t = FT(this.props, TT, this);
    t.element = this, t.ref = (r) => {
      this.component = r;
    }, await kv(), !this.disconnected && AT(/* @__PURE__ */ De(Qg, {
      ...t
    }), this);
  }
  constructor(t) {
    super(t);
  }
}
qi(UT, "Props", TT);
typeof customElements < "u" && !customElements.get("em-emoji") && customElements.define("em-emoji", UT);
var b6, Jg = [], A6 = kt.__b, w6 = kt.__r, k6 = kt.diffed, W6 = kt.__c, S6 = kt.unmount;
function Nve() {
  var e;
  for (Jg.sort(function(t, r) {
    return t.__v.__b - r.__v.__b;
  }); e = Jg.pop(); )
    if (e.__P)
      try {
        e.__H.__h.forEach(vc), e.__H.__h.forEach(Hg), e.__H.__h = [];
      } catch (t) {
        e.__H.__h = [], kt.__e(t, e.__v);
      }
}
kt.__b = function(e) {
  A6 && A6(e);
}, kt.__r = function(e) {
  w6 && w6(e);
  var t = e.__c.__H;
  t && (t.__h.forEach(vc), t.__h.forEach(Hg), t.__h = []);
}, kt.diffed = function(e) {
  k6 && k6(e);
  var t = e.__c;
  t && t.__H && t.__H.__h.length && (Jg.push(t) !== 1 && b6 === kt.requestAnimationFrame || ((b6 = kt.requestAnimationFrame) || function(r) {
    var n, i = function() {
      clearTimeout(a), C6 && cancelAnimationFrame(n), setTimeout(r);
    }, a = setTimeout(i, 100);
    C6 && (n = requestAnimationFrame(i));
  })(Nve));
}, kt.__c = function(e, t) {
  t.some(function(r) {
    try {
      r.__h.forEach(vc), r.__h = r.__h.filter(function(n) {
        return !n.__ || Hg(n);
      });
    } catch (n) {
      t.some(function(i) {
        i.__h && (i.__h = []);
      }), t = [], kt.__e(n, r.__v);
    }
  }), W6 && W6(e, t);
}, kt.unmount = function(e) {
  S6 && S6(e);
  var t, r = e.__c;
  r && r.__H && (r.__H.__.forEach(function(n) {
    try {
      vc(n);
    } catch (i) {
      t = i;
    }
  }), t && kt.__e(t, r.__v));
};
var C6 = typeof requestAnimationFrame == "function";
function vc(e) {
  var t = e.__c;
  typeof t == "function" && (e.__c = void 0, t());
}
function Hg(e) {
  e.__c = e.__();
}
function Ive(e, t) {
  for (var r in t)
    e[r] = t[r];
  return e;
}
function F6(e, t) {
  for (var r in e)
    if (r !== "__source" && !(r in t))
      return !0;
  for (var n in t)
    if (n !== "__source" && e[n] !== t[n])
      return !0;
  return !1;
}
function ap(e) {
  this.props = e;
}
(ap.prototype = new ji()).isPureReactComponent = !0, ap.prototype.shouldComponentUpdate = function(e, t) {
  return F6(this.props, e) || F6(this.state, t);
};
var K6 = kt.__b;
kt.__b = function(e) {
  e.type && e.type.__f && e.ref && (e.props.ref = e.ref, e.ref = null), K6 && K6(e);
};
var Xve = kt.__e;
kt.__e = function(e, t, r) {
  if (e.then) {
    for (var n, i = t; i = i.__; )
      if ((n = i.__c) && n.__c)
        return t.__e == null && (t.__e = r.__e, t.__k = r.__k), n.__c(e, t);
  }
  Xve(e, t, r);
};
var R6 = kt.unmount;
function tm() {
  this.__u = 0, this.t = null, this.__b = null;
}
function xT(e) {
  var t = e.__.__c;
  return t && t.__e && t.__e(e);
}
function Gd() {
  this.u = null, this.o = null;
}
kt.unmount = function(e) {
  var t = e.__c;
  t && t.__R && t.__R(), t && e.__h === !0 && (e.type = null), R6 && R6(e);
}, (tm.prototype = new ji()).__c = function(e, t) {
  var r = t.__c, n = this;
  n.t == null && (n.t = []), n.t.push(r);
  var i = xT(n.__v), a = !1, s = function() {
    a || (a = !0, r.__R = null, i ? i(o) : o());
  };
  r.__R = s;
  var o = function() {
    if (!--n.__u) {
      if (n.state.__e) {
        var f = n.state.__e;
        n.__v.__k[0] = function d(c, p, v) {
          return c && (c.__v = null, c.__k = c.__k && c.__k.map(function(h) {
            return d(h, p, v);
          }), c.__c && c.__c.__P === p && (c.__e && v.insertBefore(c.__e, c.__d), c.__c.__e = !0, c.__c.__P = v)), c;
        }(f, f.__c.__P, f.__c.__O);
      }
      var l;
      for (n.setState({
        __e: n.__b = null
      }); l = n.t.pop(); )
        l.forceUpdate();
    }
  }, u = t.__h === !0;
  n.__u++ || u || n.setState({
    __e: n.__b = n.__v.__k[0]
  }), e.then(s, s);
}, tm.prototype.componentWillUnmount = function() {
  this.t = [];
}, tm.prototype.render = function(e, t) {
  if (this.__b) {
    if (this.__v.__k) {
      var r = document.createElement("div"), n = this.__v.__k[0].__c;
      this.__v.__k[0] = function a(s, o, u) {
        return s && (s.__c && s.__c.__H && (s.__c.__H.__.forEach(function(f) {
          typeof f.__c == "function" && f.__c();
        }), s.__c.__H = null), (s = Ive({}, s)).__c != null && (s.__c.__P === u && (s.__c.__P = o), s.__c = null), s.__k = s.__k && s.__k.map(function(f) {
          return a(f, o, u);
        })), s;
      }(this.__b, r, n.__O = n.__P);
    }
    this.__b = null;
  }
  var i = t.__e && Yg(qu, null, e.fallback);
  return i && (i.__h = null), [
    Yg(qu, null, t.__e ? null : e.children),
    i
  ];
};
var T6 = function(e, t, r) {
  if (++r[1] === r[0] && e.o.delete(t), e.props.revealOrder && (e.props.revealOrder[0] !== "t" || !e.o.size))
    for (r = e.u; r; ) {
      for (; r.length > 3; )
        r.pop()();
      if (r[1] < r[0])
        break;
      e.u = r = r[2];
    }
};
(Gd.prototype = new ji()).__e = function(e) {
  var t = this, r = xT(t.__v), n = t.o.get(e);
  return n[0]++, function(i) {
    var a = function() {
      t.props.revealOrder ? (n.push(i), T6(t, e, n)) : i();
    };
    r ? r(a) : a();
  };
}, Gd.prototype.render = function(e) {
  this.u = null, this.o = /* @__PURE__ */ new Map();
  var t = rp(e.children);
  e.revealOrder && e.revealOrder[0] === "b" && t.reverse();
  for (var r = t.length; r--; )
    this.o.set(t[r], this.u = [
      1,
      0,
      this.u
    ]);
  return e.children;
}, Gd.prototype.componentDidUpdate = Gd.prototype.componentDidMount = function() {
  var e = this;
  this.o.forEach(function(t, r) {
    T6(e, r, t);
  });
};
var Pve = typeof Symbol < "u" && Symbol.for && Symbol.for("react.element") || 60103, Bve = /^(?:accent|alignment|arabic|baseline|cap|clip(?!PathU)|color|dominant|fill|flood|font|glyph(?!R)|horiz|marker(?!H|W|U)|overline|paint|stop|strikethrough|stroke|text(?!L)|underline|unicode|units|v|vector|vert|word|writing|x(?!C))[A-Z]/, Dve = typeof document < "u", Lve = function(e) {
  return (typeof Symbol < "u" && typeof Symbol() == "symbol" ? /fil|che|rad/i : /fil|che|ra/i).test(e);
};
ji.prototype.isReactComponent = {}, [
  "componentWillMount",
  "componentWillReceiveProps",
  "componentWillUpdate"
].forEach(function(e) {
  Object.defineProperty(ji.prototype, e, {
    configurable: !0,
    get: function() {
      return this["UNSAFE_" + e];
    },
    set: function(t) {
      Object.defineProperty(this, e, {
        configurable: !0,
        writable: !0,
        value: t
      });
    }
  });
});
var U6 = kt.event;
function Zve() {
}
function Mve() {
  return this.cancelBubble;
}
function jve() {
  return this.defaultPrevented;
}
kt.event = function(e) {
  return U6 && (e = U6(e)), e.persist = Zve, e.isPropagationStopped = Mve, e.isDefaultPrevented = jve, e.nativeEvent = e;
};
var x6 = {
  configurable: !0,
  get: function() {
    return this.class;
  }
}, E6 = kt.vnode;
kt.vnode = function(e) {
  var t = e.type, r = e.props, n = r;
  if (typeof t == "string") {
    var i = t.indexOf("-") === -1;
    for (var a in n = {}, r) {
      var s = r[a];
      Dve && a === "children" && t === "noscript" || a === "value" && "defaultValue" in r && s == null || (a === "defaultValue" && "value" in r && r.value == null ? a = "value" : a === "download" && s === !0 ? s = "" : /ondoubleclick/i.test(a) ? a = "ondblclick" : /^onchange(textarea|input)/i.test(a + t) && !Lve(r.type) ? a = "oninput" : /^onfocus$/i.test(a) ? a = "onfocusin" : /^onblur$/i.test(a) ? a = "onfocusout" : /^on(Ani|Tra|Tou|BeforeInp)/.test(a) ? a = a.toLowerCase() : i && Bve.test(a) ? a = a.replace(/[A-Z0-9]/, "-$&").toLowerCase() : s === null && (s = void 0), n[a] = s);
    }
    t == "select" && n.multiple && Array.isArray(n.value) && (n.value = rp(r.children).forEach(function(o) {
      o.props.selected = n.value.indexOf(o.props.value) != -1;
    })), t == "select" && n.defaultValue != null && (n.value = rp(r.children).forEach(function(o) {
      o.props.selected = n.multiple ? n.defaultValue.indexOf(o.props.value) != -1 : n.defaultValue == o.props.value;
    })), e.props = n, r.class != r.className && (x6.enumerable = "className" in r, r.className != null && (n.class = r.className), Object.defineProperty(n, "className", x6));
  }
  e.$$typeof = Pve, E6 && E6(e);
};
var O6 = kt.__r;
kt.__r = function(e) {
  O6 && O6(e), e.__c;
};
const Yve = {
  light: "outline",
  dark: "solid"
};
class zve extends ap {
  renderIcon(t) {
    const { icon: r } = t;
    if (r) {
      if (r.svg)
        return /* @__PURE__ */ De("span", {
          class: "flex",
          dangerouslySetInnerHTML: {
            __html: r.svg
          }
        });
      if (r.src)
        return /* @__PURE__ */ De("img", {
          src: r.src
        });
    }
    const n = ip.categories[t.id] || ip.categories.custom, i = this.props.icons == "auto" ? Yve[this.props.theme] : this.props.icons;
    return n[i] || n;
  }
  render() {
    let t = null;
    return /* @__PURE__ */ De("nav", {
      id: "nav",
      class: "padding",
      "data-position": this.props.position,
      dir: this.props.dir,
      children: /* @__PURE__ */ De("div", {
        class: "flex relative",
        children: [
          this.categories.map((r, n) => {
            const i = r.name || cn.categories[r.id], a = !this.props.unfocused && r.id == this.state.categoryId;
            return a && (t = n), /* @__PURE__ */ De("button", {
              "aria-label": i,
              "aria-selected": a || void 0,
              title: i,
              type: "button",
              class: "flex flex-grow flex-center",
              onMouseDown: (s) => s.preventDefault(),
              onClick: () => {
                this.props.onClick({
                  category: r,
                  i: n
                });
              },
              children: this.renderIcon(r)
            });
          }),
          /* @__PURE__ */ De("div", {
            class: "bar",
            style: {
              width: `${100 / this.categories.length}%`,
              opacity: t == null ? 0 : 1,
              transform: this.props.dir === "rtl" ? `scaleX(-1) translateX(${t * 100}%)` : `translateX(${t * 100}%)`
            }
          })
        ]
      })
    });
  }
  constructor() {
    super(), this.categories = Pt.categories.filter((t) => !t.target), this.state = {
      categoryId: this.categories[0].id
    };
  }
}
class Gve extends ap {
  shouldComponentUpdate(t) {
    for (let r in t)
      if (r != "children" && t[r] != this.props[r])
        return !0;
    return !1;
  }
  render() {
    return this.props.children;
  }
}
const Qd = {
  rowsPerRender: 10
};
class Qve extends ji {
  getInitialState(t = this.props) {
    return {
      skin: ns.get("skin") || t.skin,
      theme: this.initTheme(t.theme)
    };
  }
  componentWillMount() {
    this.dir = cn.rtl ? "rtl" : "ltr", this.refs = {
      menu: aa(),
      navigation: aa(),
      scroll: aa(),
      search: aa(),
      searchInput: aa(),
      skinToneButton: aa(),
      skinToneRadio: aa()
    }, this.initGrid(), this.props.stickySearch == !1 && this.props.searchPosition == "sticky" && (console.warn("[EmojiMart] Deprecation warning: `stickySearch` has been renamed `searchPosition`."), this.props.searchPosition = "static");
  }
  componentDidMount() {
    if (this.register(), this.shadowRoot = this.base.parentNode, this.props.autoFocus) {
      const { searchInput: t } = this.refs;
      t.current && t.current.focus();
    }
  }
  componentWillReceiveProps(t) {
    this.nextState || (this.nextState = {});
    for (const r in t)
      this.nextState[r] = t[r];
    clearTimeout(this.nextStateTimer), this.nextStateTimer = setTimeout(() => {
      let r = !1;
      for (const i in this.nextState)
        this.props[i] = this.nextState[i], (i === "custom" || i === "categories") && (r = !0);
      delete this.nextState;
      const n = this.getInitialState();
      if (r)
        return this.reset(n);
      this.setState(n);
    });
  }
  componentWillUnmount() {
    this.unregister();
  }
  async reset(t = {}) {
    await kv(this.props), this.initGrid(), this.unobserve(), this.setState(t, () => {
      this.observeCategories(), this.observeRows();
    });
  }
  register() {
    document.addEventListener("click", this.handleClickOutside), this.observe();
  }
  unregister() {
    document.removeEventListener("click", this.handleClickOutside), this.unobserve();
  }
  observe() {
    this.observeCategories(), this.observeRows();
  }
  unobserve({ except: t = [] } = {}) {
    Array.isArray(t) || (t = [
      t
    ]);
    for (const r of this.observers)
      t.includes(r) || r.disconnect();
    this.observers = [].concat(t);
  }
  initGrid() {
    const { categories: t } = Pt;
    this.refs.categories = /* @__PURE__ */ new Map();
    const r = Pt.categories.map((i) => i.id).join(",");
    this.navKey && this.navKey != r && this.refs.scroll.current && (this.refs.scroll.current.scrollTop = 0), this.navKey = r, this.grid = [], this.grid.setsize = 0;
    const n = (i, a) => {
      const s = [];
      s.__categoryId = a.id, s.__index = i.length, this.grid.push(s);
      const o = this.grid.length - 1, u = o % Qd.rowsPerRender ? {} : aa();
      return u.index = o, u.posinset = this.grid.setsize + 1, i.push(u), s;
    };
    for (let i of t) {
      const a = [];
      let s = n(a, i);
      for (let o of i.emojis)
        s.length == this.getPerLine() && (s = n(a, i)), this.grid.setsize += 1, s.push(o);
      this.refs.categories.set(i.id, {
        root: aa(),
        rows: a
      });
    }
  }
  initTheme(t) {
    if (t != "auto")
      return t;
    if (!this.darkMedia) {
      if (this.darkMedia = matchMedia("(prefers-color-scheme: dark)"), this.darkMedia.media.match(/^not/))
        return "light";
      this.darkMedia.addListener(() => {
        this.props.theme == "auto" && this.setState({
          theme: this.darkMedia.matches ? "dark" : "light"
        });
      });
    }
    return this.darkMedia.matches ? "dark" : "light";
  }
  initDynamicPerLine(t = this.props) {
    if (!t.dynamicWidth)
      return;
    const { element: r, emojiButtonSize: n } = t, i = () => {
      const { width: s } = r.getBoundingClientRect();
      return Math.floor(s / n);
    }, a = new ResizeObserver(() => {
      this.unobserve({
        except: a
      }), this.setState({
        perLine: i()
      }, () => {
        this.initGrid(), this.forceUpdate(() => {
          this.observeCategories(), this.observeRows();
        });
      });
    });
    return a.observe(r), this.observers.push(a), i();
  }
  getPerLine() {
    return this.state.perLine || this.props.perLine;
  }
  getEmojiByPos([t, r]) {
    const n = this.state.searchResults || this.grid, i = n[t] && n[t][r];
    if (i)
      return ru.get(i);
  }
  observeCategories() {
    const t = this.refs.navigation.current;
    if (!t)
      return;
    const r = /* @__PURE__ */ new Map(), n = (s) => {
      s != t.state.categoryId && t.setState({
        categoryId: s
      });
    }, i = {
      root: this.refs.scroll.current,
      threshold: [
        0,
        1
      ]
    }, a = new IntersectionObserver((s) => {
      for (const u of s) {
        const f = u.target.dataset.id;
        r.set(f, u.intersectionRatio);
      }
      const o = [
        ...r
      ];
      for (const [u, f] of o)
        if (f) {
          n(u);
          break;
        }
    }, i);
    for (const { root: s } of this.refs.categories.values())
      a.observe(s.current);
    this.observers.push(a);
  }
  observeRows() {
    const t = {
      ...this.state.visibleRows
    }, r = new IntersectionObserver((n) => {
      for (const i of n) {
        const a = parseInt(i.target.dataset.index);
        i.isIntersecting ? t[a] = !0 : delete t[a];
      }
      this.setState({
        visibleRows: t
      });
    }, {
      root: this.refs.scroll.current,
      rootMargin: `${this.props.emojiButtonSize * (Qd.rowsPerRender + 5)}px 0px ${this.props.emojiButtonSize * Qd.rowsPerRender}px`
    });
    for (const { rows: n } of this.refs.categories.values())
      for (const i of n)
        i.current && r.observe(i.current);
    this.observers.push(r);
  }
  preventDefault(t) {
    t.preventDefault();
  }
  unfocusSearch() {
    const t = this.refs.searchInput.current;
    t && t.blur();
  }
  navigate({ e: t, input: r, left: n, right: i, up: a, down: s }) {
    const o = this.state.searchResults || this.grid;
    if (!o.length)
      return;
    let [u, f] = this.state.pos;
    const l = (() => {
      if (u == 0 && f == 0 && !t.repeat && (n || a))
        return null;
      if (u == -1)
        return !t.repeat && (i || s) && r.selectionStart == r.value.length ? [
          0,
          0
        ] : null;
      if (n || i) {
        let d = o[u];
        const c = n ? -1 : 1;
        if (f += c, !d[f]) {
          if (u += c, d = o[u], !d)
            return u = n ? 0 : o.length - 1, f = n ? 0 : o[u].length - 1, [
              u,
              f
            ];
          f = n ? d.length - 1 : 0;
        }
        return [
          u,
          f
        ];
      }
      if (a || s) {
        u += a ? -1 : 1;
        const d = o[u];
        return d ? (d[f] || (f = d.length - 1), [
          u,
          f
        ]) : (u = a ? 0 : o.length - 1, f = a ? 0 : o[u].length - 1, [
          u,
          f
        ]);
      }
    })();
    if (l)
      t.preventDefault();
    else {
      this.state.pos[0] > -1 && this.setState({
        pos: [
          -1,
          -1
        ]
      });
      return;
    }
    this.setState({
      pos: l,
      keyboard: !0
    }, () => {
      this.scrollTo({
        row: l[0]
      });
    });
  }
  scrollTo({ categoryId: t, row: r }) {
    const n = this.state.searchResults || this.grid;
    if (!n.length)
      return;
    const i = this.refs.scroll.current, a = i.getBoundingClientRect();
    let s = 0;
    if (r >= 0 && (t = n[r].__categoryId), t && (s = (this.refs[t] || this.refs.categories.get(t).root).current.getBoundingClientRect().top - (a.top - i.scrollTop) + 1), r >= 0)
      if (!r)
        s = 0;
      else {
        const o = n[r].__index, u = s + o * this.props.emojiButtonSize, f = u + this.props.emojiButtonSize + this.props.emojiButtonSize * 0.88;
        if (u < i.scrollTop)
          s = u;
        else if (f > i.scrollTop + a.height)
          s = f - a.height;
        else
          return;
      }
    this.ignoreMouse(), i.scrollTop = s;
  }
  ignoreMouse() {
    this.mouseIsIgnored = !0, clearTimeout(this.ignoreMouseTimer), this.ignoreMouseTimer = setTimeout(() => {
      delete this.mouseIsIgnored;
    }, 100);
  }
  handleEmojiOver(t) {
    this.mouseIsIgnored || this.state.showSkins || this.setState({
      pos: t || [
        -1,
        -1
      ],
      keyboard: !1
    });
  }
  handleEmojiClick({ e: t, emoji: r, pos: n }) {
    if (this.props.onEmojiSelect && (!r && n && (r = this.getEmojiByPos(n)), r)) {
      const i = Tve(r, {
        skinIndex: this.state.skin - 1
      });
      this.props.maxFrequentRows && kT.add(i, this.props), this.props.onEmojiSelect(i, t);
    }
  }
  closeSkins() {
    this.state.showSkins && (this.setState({
      showSkins: null,
      tempSkin: null
    }), this.base.removeEventListener("click", this.handleBaseClick), this.base.removeEventListener("keydown", this.handleBaseKeydown));
  }
  handleSkinMouseOver(t) {
    this.setState({
      tempSkin: t
    });
  }
  handleSkinClick(t) {
    this.ignoreMouse(), this.closeSkins(), this.setState({
      skin: t,
      tempSkin: null
    }), ns.set("skin", t);
  }
  renderNav() {
    return /* @__PURE__ */ De(zve, {
      ref: this.refs.navigation,
      icons: this.props.icons,
      theme: this.state.theme,
      dir: this.dir,
      unfocused: !!this.state.searchResults,
      position: this.props.navPosition,
      onClick: this.handleCategoryClick
    }, this.navKey);
  }
  renderPreview() {
    const t = this.getEmojiByPos(this.state.pos), r = this.state.searchResults && !this.state.searchResults.length;
    return /* @__PURE__ */ De("div", {
      id: "preview",
      class: "flex flex-middle",
      dir: this.dir,
      "data-position": this.props.previewPosition,
      children: [
        /* @__PURE__ */ De("div", {
          class: "flex flex-middle flex-grow",
          children: [
            /* @__PURE__ */ De("div", {
              class: "flex flex-auto flex-middle flex-center",
              style: {
                height: this.props.emojiButtonSize,
                fontSize: this.props.emojiButtonSize
              },
              children: /* @__PURE__ */ De(Qg, {
                emoji: t,
                id: r ? this.props.noResultsEmoji || "cry" : this.props.previewEmoji || (this.props.previewPosition == "top" ? "point_down" : "point_up"),
                set: this.props.set,
                size: this.props.emojiButtonSize,
                skin: this.state.tempSkin || this.state.skin,
                spritesheet: !0,
                getSpritesheetURL: this.props.getSpritesheetURL
              })
            }),
            /* @__PURE__ */ De("div", {
              class: `margin-${this.dir[0]}`,
              children: t || r ? /* @__PURE__ */ De("div", {
                class: `padding-${this.dir[2]} align-${this.dir[0]}`,
                children: [
                  /* @__PURE__ */ De("div", {
                    class: "preview-title ellipsis",
                    children: t ? t.name : cn.search_no_results_1
                  }),
                  /* @__PURE__ */ De("div", {
                    class: "preview-subtitle ellipsis color-c",
                    children: t ? t.skins[0].shortcodes : cn.search_no_results_2
                  })
                ]
              }) : /* @__PURE__ */ De("div", {
                class: "preview-placeholder color-c",
                children: cn.pick
              })
            })
          ]
        }),
        !t && this.props.skinTonePosition == "preview" && this.renderSkinToneButton()
      ]
    });
  }
  renderEmojiButton(t, { pos: r, posinset: n, grid: i }) {
    const a = this.props.emojiButtonSize, s = this.state.tempSkin || this.state.skin, u = (t.skins[s - 1] || t.skins[0]).native, f = Kve(this.state.pos, r), l = r.concat(t.id).join("");
    return /* @__PURE__ */ De(Gve, {
      selected: f,
      skin: s,
      size: a,
      children: /* @__PURE__ */ De("button", {
        "aria-label": u,
        "aria-selected": f || void 0,
        "aria-posinset": n,
        "aria-setsize": i.setsize,
        "data-keyboard": this.state.keyboard,
        title: this.props.previewPosition == "none" ? t.name : void 0,
        type: "button",
        class: "flex flex-center flex-middle",
        tabindex: "-1",
        onClick: (d) => this.handleEmojiClick({
          e: d,
          emoji: t
        }),
        onMouseEnter: () => this.handleEmojiOver(r),
        onMouseLeave: () => this.handleEmojiOver(),
        style: {
          width: this.props.emojiButtonSize,
          height: this.props.emojiButtonSize,
          fontSize: this.props.emojiSize,
          lineHeight: 0
        },
        children: [
          /* @__PURE__ */ De("div", {
            "aria-hidden": "true",
            class: "background",
            style: {
              borderRadius: this.props.emojiButtonRadius,
              backgroundColor: this.props.emojiButtonColors ? this.props.emojiButtonColors[(n - 1) % this.props.emojiButtonColors.length] : void 0
            }
          }),
          /* @__PURE__ */ De(Qg, {
            emoji: t,
            set: this.props.set,
            size: this.props.emojiSize,
            skin: s,
            spritesheet: !0,
            getSpritesheetURL: this.props.getSpritesheetURL
          })
        ]
      })
    }, l);
  }
  renderSearch() {
    const t = this.props.previewPosition == "none" || this.props.skinTonePosition == "search";
    return /* @__PURE__ */ De("div", {
      children: [
        /* @__PURE__ */ De("div", {
          class: "spacer"
        }),
        /* @__PURE__ */ De("div", {
          class: "flex flex-middle",
          children: [
            /* @__PURE__ */ De("div", {
              class: "search relative flex-grow",
              children: [
                /* @__PURE__ */ De("input", {
                  type: "search",
                  ref: this.refs.searchInput,
                  placeholder: cn.search,
                  onClick: this.handleSearchClick,
                  onInput: this.handleSearchInput,
                  onKeyDown: this.handleSearchKeyDown,
                  autoComplete: "off"
                }),
                /* @__PURE__ */ De("span", {
                  class: "icon loupe flex",
                  children: ip.search.loupe
                }),
                this.state.searchResults && /* @__PURE__ */ De("button", {
                  title: "Clear",
                  "aria-label": "Clear",
                  type: "button",
                  class: "icon delete flex",
                  onClick: this.clearSearch,
                  onMouseDown: this.preventDefault,
                  children: ip.search.delete
                })
              ]
            }),
            t && this.renderSkinToneButton()
          ]
        })
      ]
    });
  }
  renderSearchResults() {
    const { searchResults: t } = this.state;
    return t ? /* @__PURE__ */ De("div", {
      class: "category",
      ref: this.refs.search,
      children: [
        /* @__PURE__ */ De("div", {
          class: `sticky padding-small align-${this.dir[0]}`,
          children: cn.categories.search
        }),
        /* @__PURE__ */ De("div", {
          children: t.length ? t.map((r, n) => /* @__PURE__ */ De("div", {
            class: "flex",
            children: r.map((i, a) => this.renderEmojiButton(i, {
              pos: [
                n,
                a
              ],
              posinset: n * this.props.perLine + a + 1,
              grid: t
            }))
          })) : /* @__PURE__ */ De("div", {
            class: `padding-small align-${this.dir[0]}`,
            children: this.props.onAddCustomEmoji && /* @__PURE__ */ De("a", {
              onClick: this.props.onAddCustomEmoji,
              children: cn.add_custom
            })
          })
        })
      ]
    }) : null;
  }
  renderCategories() {
    const { categories: t } = Pt, r = !!this.state.searchResults, n = this.getPerLine();
    return /* @__PURE__ */ De("div", {
      style: {
        visibility: r ? "hidden" : void 0,
        display: r ? "none" : void 0,
        height: "100%"
      },
      children: t.map((i) => {
        const { root: a, rows: s } = this.refs.categories.get(i.id);
        return /* @__PURE__ */ De("div", {
          "data-id": i.target ? i.target.id : i.id,
          class: "category",
          ref: a,
          children: [
            /* @__PURE__ */ De("div", {
              class: `sticky padding-small align-${this.dir[0]}`,
              children: i.name || cn.categories[i.id]
            }),
            /* @__PURE__ */ De("div", {
              class: "relative",
              style: {
                height: s.length * this.props.emojiButtonSize
              },
              children: s.map((o, u) => {
                const f = o.index - o.index % Qd.rowsPerRender, l = this.state.visibleRows[f], d = "current" in o ? o : void 0;
                if (!l && !d)
                  return null;
                const c = u * n, p = c + n, v = i.emojis.slice(c, p);
                return v.length < n && v.push(...new Array(n - v.length)), /* @__PURE__ */ De("div", {
                  "data-index": o.index,
                  ref: d,
                  class: "flex row",
                  style: {
                    top: u * this.props.emojiButtonSize
                  },
                  children: l && v.map((h, m) => {
                    if (!h)
                      return /* @__PURE__ */ De("div", {
                        style: {
                          width: this.props.emojiButtonSize,
                          height: this.props.emojiButtonSize
                        }
                      });
                    const q = ru.get(h);
                    return this.renderEmojiButton(q, {
                      pos: [
                        o.index,
                        m
                      ],
                      posinset: o.posinset + m,
                      grid: this.grid
                    });
                  })
                }, o.index);
              })
            })
          ]
        });
      })
    });
  }
  renderSkinToneButton() {
    return this.props.skinTonePosition == "none" ? null : /* @__PURE__ */ De("div", {
      class: "flex flex-auto flex-center flex-middle",
      style: {
        position: "relative",
        width: this.props.emojiButtonSize,
        height: this.props.emojiButtonSize
      },
      children: /* @__PURE__ */ De("button", {
        type: "button",
        ref: this.refs.skinToneButton,
        class: "skin-tone-button flex flex-auto flex-center flex-middle",
        "aria-selected": this.state.showSkins ? "" : void 0,
        "aria-label": cn.skins.choose,
        title: cn.skins.choose,
        onClick: this.openSkins,
        style: {
          width: this.props.emojiSize,
          height: this.props.emojiSize
        },
        children: /* @__PURE__ */ De("span", {
          class: `skin-tone skin-tone-${this.state.skin}`
        })
      })
    });
  }
  renderLiveRegion() {
    const t = this.getEmojiByPos(this.state.pos), r = t ? t.name : "";
    return /* @__PURE__ */ De("div", {
      "aria-live": "polite",
      class: "sr-only",
      children: r
    });
  }
  renderSkins() {
    const r = this.refs.skinToneButton.current.getBoundingClientRect(), n = this.base.getBoundingClientRect(), i = {};
    return this.dir == "ltr" ? i.right = n.right - r.right - 3 : i.left = r.left - n.left - 3, this.props.previewPosition == "bottom" && this.props.skinTonePosition == "preview" ? i.bottom = n.bottom - r.top + 6 : (i.top = r.bottom - n.top + 3, i.bottom = "auto"), /* @__PURE__ */ De("div", {
      ref: this.refs.menu,
      role: "radiogroup",
      dir: this.dir,
      "aria-label": cn.skins.choose,
      class: "menu hidden",
      "data-position": i.top ? "top" : "bottom",
      style: i,
      children: [
        ...Array(6).keys()
      ].map((a) => {
        const s = a + 1, o = this.state.skin == s;
        return /* @__PURE__ */ De("div", {
          children: [
            /* @__PURE__ */ De("input", {
              type: "radio",
              name: "skin-tone",
              value: s,
              "aria-label": cn.skins[s],
              ref: o ? this.refs.skinToneRadio : null,
              defaultChecked: o,
              onChange: () => this.handleSkinMouseOver(s),
              onKeyDown: (u) => {
                (u.code == "Enter" || u.code == "Space" || u.code == "Tab") && (u.preventDefault(), this.handleSkinClick(s));
              }
            }),
            /* @__PURE__ */ De("button", {
              "aria-hidden": "true",
              tabindex: "-1",
              onClick: () => this.handleSkinClick(s),
              onMouseEnter: () => this.handleSkinMouseOver(s),
              onMouseLeave: () => this.handleSkinMouseOver(),
              class: "option flex flex-grow flex-middle",
              children: [
                /* @__PURE__ */ De("span", {
                  class: `skin-tone skin-tone-${s}`
                }),
                /* @__PURE__ */ De("span", {
                  class: "margin-small-lr",
                  children: cn.skins[s]
                })
              ]
            })
          ]
        });
      })
    });
  }
  render() {
    const t = this.props.perLine * this.props.emojiButtonSize;
    return /* @__PURE__ */ De("section", {
      id: "root",
      class: "flex flex-column",
      dir: this.dir,
      style: {
        width: this.props.dynamicWidth ? "100%" : `calc(${t}px + (var(--padding) + var(--sidebar-width)))`
      },
      "data-emoji-set": this.props.set,
      "data-theme": this.state.theme,
      "data-menu": this.state.showSkins ? "" : void 0,
      children: [
        this.props.previewPosition == "top" && this.renderPreview(),
        this.props.navPosition == "top" && this.renderNav(),
        this.props.searchPosition == "sticky" && /* @__PURE__ */ De("div", {
          class: "padding-lr",
          children: this.renderSearch()
        }),
        /* @__PURE__ */ De("div", {
          ref: this.refs.scroll,
          class: "scroll flex-grow padding-lr",
          children: /* @__PURE__ */ De("div", {
            style: {
              width: this.props.dynamicWidth ? "100%" : t,
              height: "100%"
            },
            children: [
              this.props.searchPosition == "static" && this.renderSearch(),
              this.renderSearchResults(),
              this.renderCategories()
            ]
          })
        }),
        this.props.navPosition == "bottom" && this.renderNav(),
        this.props.previewPosition == "bottom" && this.renderPreview(),
        this.state.showSkins && this.renderSkins(),
        this.renderLiveRegion()
      ]
    });
  }
  constructor(t) {
    super(), qi(this, "handleClickOutside", (r) => {
      const { element: n } = this.props;
      r.target != n && (this.state.showSkins && this.closeSkins(), this.props.onClickOutside && this.props.onClickOutside(r));
    }), qi(this, "handleBaseClick", (r) => {
      this.state.showSkins && (r.target.closest(".menu") || (r.preventDefault(), r.stopImmediatePropagation(), this.closeSkins()));
    }), qi(this, "handleBaseKeydown", (r) => {
      this.state.showSkins && r.key == "Escape" && (r.preventDefault(), r.stopImmediatePropagation(), this.closeSkins());
    }), qi(this, "handleSearchClick", () => {
      this.getEmojiByPos(this.state.pos) && this.setState({
        pos: [
          -1,
          -1
        ]
      });
    }), qi(this, "handleSearchInput", async () => {
      const r = this.refs.searchInput.current;
      if (!r)
        return;
      const { value: n } = r, i = await ru.search(n), a = () => {
        this.refs.scroll.current && (this.refs.scroll.current.scrollTop = 0);
      };
      if (!i)
        return this.setState({
          searchResults: i,
          pos: [
            -1,
            -1
          ]
        }, a);
      const s = r.selectionStart == r.value.length ? [
        0,
        0
      ] : [
        -1,
        -1
      ], o = [];
      o.setsize = i.length;
      let u = null;
      for (let f of i)
        (!o.length || u.length == this.getPerLine()) && (u = [], u.__categoryId = "search", u.__index = o.length, o.push(u)), u.push(f);
      this.ignoreMouse(), this.setState({
        searchResults: o,
        pos: s
      }, a);
    }), qi(this, "handleSearchKeyDown", (r) => {
      const n = r.currentTarget;
      switch (r.stopImmediatePropagation(), r.key) {
        case "ArrowLeft":
          this.navigate({
            e: r,
            input: n,
            left: !0
          });
          break;
        case "ArrowRight":
          this.navigate({
            e: r,
            input: n,
            right: !0
          });
          break;
        case "ArrowUp":
          this.navigate({
            e: r,
            input: n,
            up: !0
          });
          break;
        case "ArrowDown":
          this.navigate({
            e: r,
            input: n,
            down: !0
          });
          break;
        case "Enter":
          r.preventDefault(), this.handleEmojiClick({
            e: r,
            pos: this.state.pos
          });
          break;
        case "Escape":
          r.preventDefault(), this.state.searchResults ? this.clearSearch() : this.unfocusSearch();
          break;
      }
    }), qi(this, "clearSearch", () => {
      const r = this.refs.searchInput.current;
      r && (r.value = "", r.focus(), this.handleSearchInput());
    }), qi(this, "handleCategoryClick", ({ category: r, i: n }) => {
      this.scrollTo(n == 0 ? {
        row: -1
      } : {
        categoryId: r.id
      });
    }), qi(this, "openSkins", (r) => {
      const { currentTarget: n } = r, i = n.getBoundingClientRect();
      this.setState({
        showSkins: i
      }, async () => {
        await Rve(2);
        const a = this.refs.menu.current;
        a && (a.classList.remove("hidden"), this.refs.skinToneRadio.current.focus(), this.base.addEventListener("click", this.handleBaseClick, !0), this.base.addEventListener("keydown", this.handleBaseKeydown, !0));
      });
    }), this.observers = [], this.state = {
      pos: [
        -1,
        -1
      ],
      perLine: this.initDynamicPerLine(t),
      visibleRows: {
        0: !0
      },
      ...this.getInitialState(t)
    };
  }
}
class Nq extends Ove {
  async connectedCallback() {
    const t = FT(this.props, va, this);
    t.element = this, t.ref = (r) => {
      this.component = r;
    }, await kv(t), !this.disconnected && AT(/* @__PURE__ */ De(Qve, {
      ...t
    }), this.shadowRoot);
  }
  constructor(t) {
    super(t, {
      styles: /* @__PURE__ */ lT(ET)
    });
  }
}
qi(Nq, "Props", va);
typeof customElements < "u" && !customElements.get("em-emoji-picker") && customElements.define("em-emoji-picker", Nq);
var ET = {};
ET = `:host {
  width: min-content;
  height: 435px;
  min-height: 230px;
  border-radius: var(--border-radius);
  box-shadow: var(--shadow);
  --border-radius: 10px;
  --category-icon-size: 18px;
  --font-family: -apple-system, BlinkMacSystemFont, "Helvetica Neue", sans-serif;
  --font-size: 15px;
  --preview-placeholder-size: 21px;
  --preview-title-size: 1.1em;
  --preview-subtitle-size: .9em;
  --shadow-color: 0deg 0% 0%;
  --shadow: .3px .5px 2.7px hsl(var(--shadow-color) / .14), .4px .8px 1px -3.2px hsl(var(--shadow-color) / .14), 1px 2px 2.5px -4.5px hsl(var(--shadow-color) / .14);
  display: flex;
}

[data-theme="light"] {
  --em-rgb-color: var(--rgb-color, 34, 36, 39);
  --em-rgb-accent: var(--rgb-accent, 34, 102, 237);
  --em-rgb-background: var(--rgb-background, 255, 255, 255);
  --em-rgb-input: var(--rgb-input, 255, 255, 255);
  --em-color-border: var(--color-border, rgba(0, 0, 0, .05));
  --em-color-border-over: var(--color-border-over, rgba(0, 0, 0, .1));
}

[data-theme="dark"] {
  --em-rgb-color: var(--rgb-color, 222, 222, 221);
  --em-rgb-accent: var(--rgb-accent, 58, 130, 247);
  --em-rgb-background: var(--rgb-background, 21, 22, 23);
  --em-rgb-input: var(--rgb-input, 0, 0, 0);
  --em-color-border: var(--color-border, rgba(255, 255, 255, .1));
  --em-color-border-over: var(--color-border-over, rgba(255, 255, 255, .2));
}

#root {
  --color-a: rgb(var(--em-rgb-color));
  --color-b: rgba(var(--em-rgb-color), .65);
  --color-c: rgba(var(--em-rgb-color), .45);
  --padding: 12px;
  --padding-small: calc(var(--padding) / 2);
  --sidebar-width: 16px;
  --duration: 225ms;
  --duration-fast: 125ms;
  --duration-instant: 50ms;
  --easing: cubic-bezier(.4, 0, .2, 1);
  width: 100%;
  text-align: left;
  border-radius: var(--border-radius);
  background-color: rgb(var(--em-rgb-background));
  position: relative;
}

@media (prefers-reduced-motion) {
  #root {
    --duration: 0;
    --duration-fast: 0;
    --duration-instant: 0;
  }
}

#root[data-menu] button {
  cursor: auto;
}

#root[data-menu] .menu button {
  cursor: pointer;
}

:host, #root, input, button {
  color: rgb(var(--em-rgb-color));
  font-family: var(--font-family);
  font-size: var(--font-size);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  line-height: normal;
}

*, :before, :after {
  box-sizing: border-box;
  min-width: 0;
  margin: 0;
  padding: 0;
}

.relative {
  position: relative;
}

.flex {
  display: flex;
}

.flex-auto {
  flex: none;
}

.flex-center {
  justify-content: center;
}

.flex-column {
  flex-direction: column;
}

.flex-grow {
  flex: auto;
}

.flex-middle {
  align-items: center;
}

.flex-wrap {
  flex-wrap: wrap;
}

.padding {
  padding: var(--padding);
}

.padding-t {
  padding-top: var(--padding);
}

.padding-lr {
  padding-left: var(--padding);
  padding-right: var(--padding);
}

.padding-r {
  padding-right: var(--padding);
}

.padding-small {
  padding: var(--padding-small);
}

.padding-small-b {
  padding-bottom: var(--padding-small);
}

.padding-small-lr {
  padding-left: var(--padding-small);
  padding-right: var(--padding-small);
}

.margin {
  margin: var(--padding);
}

.margin-r {
  margin-right: var(--padding);
}

.margin-l {
  margin-left: var(--padding);
}

.margin-small-l {
  margin-left: var(--padding-small);
}

.margin-small-lr {
  margin-left: var(--padding-small);
  margin-right: var(--padding-small);
}

.align-l {
  text-align: left;
}

.align-r {
  text-align: right;
}

.color-a {
  color: var(--color-a);
}

.color-b {
  color: var(--color-b);
}

.color-c {
  color: var(--color-c);
}

.ellipsis {
  white-space: nowrap;
  max-width: 100%;
  width: auto;
  text-overflow: ellipsis;
  overflow: hidden;
}

.sr-only {
  width: 1px;
  height: 1px;
  position: absolute;
  top: auto;
  left: -10000px;
  overflow: hidden;
}

a {
  cursor: pointer;
  color: rgb(var(--em-rgb-accent));
}

a:hover {
  text-decoration: underline;
}

.spacer {
  height: 10px;
}

[dir="rtl"] .scroll {
  padding-left: 0;
  padding-right: var(--padding);
}

.scroll {
  padding-right: 0;
  overflow-x: hidden;
  overflow-y: auto;
}

.scroll::-webkit-scrollbar {
  width: var(--sidebar-width);
  height: var(--sidebar-width);
}

.scroll::-webkit-scrollbar-track {
  border: 0;
}

.scroll::-webkit-scrollbar-button {
  width: 0;
  height: 0;
  display: none;
}

.scroll::-webkit-scrollbar-corner {
  background-color: rgba(0, 0, 0, 0);
}

.scroll::-webkit-scrollbar-thumb {
  min-height: 20%;
  min-height: 65px;
  border: 4px solid rgb(var(--em-rgb-background));
  border-radius: 8px;
}

.scroll::-webkit-scrollbar-thumb:hover {
  background-color: var(--em-color-border-over) !important;
}

.scroll:hover::-webkit-scrollbar-thumb {
  background-color: var(--em-color-border);
}

.sticky {
  z-index: 1;
  background-color: rgba(var(--em-rgb-background), .9);
  -webkit-backdrop-filter: blur(4px);
  backdrop-filter: blur(4px);
  font-weight: 500;
  position: sticky;
  top: -1px;
}

[dir="rtl"] .search input[type="search"] {
  padding: 10px 2.2em 10px 2em;
}

[dir="rtl"] .search .loupe {
  left: auto;
  right: .7em;
}

[dir="rtl"] .search .delete {
  left: .7em;
  right: auto;
}

.search {
  z-index: 2;
  position: relative;
}

.search input, .search button {
  font-size: calc(var(--font-size)  - 1px);
}

.search input[type="search"] {
  width: 100%;
  background-color: var(--em-color-border);
  transition-duration: var(--duration);
  transition-property: background-color, box-shadow;
  transition-timing-function: var(--easing);
  border: 0;
  border-radius: 10px;
  outline: 0;
  padding: 10px 2em 10px 2.2em;
  display: block;
}

.search input[type="search"]::-ms-input-placeholder {
  color: inherit;
  opacity: .6;
}

.search input[type="search"]::placeholder {
  color: inherit;
  opacity: .6;
}

.search input[type="search"], .search input[type="search"]::-webkit-search-decoration, .search input[type="search"]::-webkit-search-cancel-button, .search input[type="search"]::-webkit-search-results-button, .search input[type="search"]::-webkit-search-results-decoration {
  -webkit-appearance: none;
  -ms-appearance: none;
  appearance: none;
}

.search input[type="search"]:focus {
  background-color: rgb(var(--em-rgb-input));
  box-shadow: inset 0 0 0 1px rgb(var(--em-rgb-accent)), 0 1px 3px rgba(65, 69, 73, .2);
}

.search .icon {
  z-index: 1;
  color: rgba(var(--em-rgb-color), .7);
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}

.search .loupe {
  pointer-events: none;
  left: .7em;
}

.search .delete {
  right: .7em;
}

svg {
  fill: currentColor;
  width: 1em;
  height: 1em;
}

button {
  -webkit-appearance: none;
  -ms-appearance: none;
  appearance: none;
  cursor: pointer;
  color: currentColor;
  background-color: rgba(0, 0, 0, 0);
  border: 0;
}

#nav {
  z-index: 2;
  padding-top: 12px;
  padding-bottom: 12px;
  padding-right: var(--sidebar-width);
  position: relative;
}

#nav button {
  color: var(--color-b);
  transition: color var(--duration) var(--easing);
}

#nav button:hover {
  color: var(--color-a);
}

#nav svg, #nav img {
  width: var(--category-icon-size);
  height: var(--category-icon-size);
}

#nav[dir="rtl"] .bar {
  left: auto;
  right: 0;
}

#nav .bar {
  width: 100%;
  height: 3px;
  background-color: rgb(var(--em-rgb-accent));
  transition: transform var(--duration) var(--easing);
  border-radius: 3px 3px 0 0;
  position: absolute;
  bottom: -12px;
  left: 0;
}

#nav button[aria-selected] {
  color: rgb(var(--em-rgb-accent));
}

#preview {
  z-index: 2;
  padding: calc(var(--padding)  + 4px) var(--padding);
  padding-right: var(--sidebar-width);
  position: relative;
}

#preview .preview-placeholder {
  font-size: var(--preview-placeholder-size);
}

#preview .preview-title {
  font-size: var(--preview-title-size);
}

#preview .preview-subtitle {
  font-size: var(--preview-subtitle-size);
}

#nav:before, #preview:before {
  content: "";
  height: 2px;
  position: absolute;
  left: 0;
  right: 0;
}

#nav[data-position="top"]:before, #preview[data-position="top"]:before {
  background: linear-gradient(to bottom, var(--em-color-border), transparent);
  top: 100%;
}

#nav[data-position="bottom"]:before, #preview[data-position="bottom"]:before {
  background: linear-gradient(to top, var(--em-color-border), transparent);
  bottom: 100%;
}

.category:last-child {
  min-height: calc(100% + 1px);
}

.category button {
  font-family: -apple-system, BlinkMacSystemFont, Helvetica Neue, sans-serif;
  position: relative;
}

.category button > * {
  position: relative;
}

.category button .background {
  opacity: 0;
  background-color: var(--em-color-border);
  transition: opacity var(--duration-fast) var(--easing) var(--duration-instant);
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}

.category button:hover .background {
  transition-duration: var(--duration-instant);
  transition-delay: 0s;
}

.category button[aria-selected] .background {
  opacity: 1;
}

.category button[data-keyboard] .background {
  transition: none;
}

.row {
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
}

.skin-tone-button {
  border: 1px solid rgba(0, 0, 0, 0);
  border-radius: 100%;
}

.skin-tone-button:hover {
  border-color: var(--em-color-border);
}

.skin-tone-button:active .skin-tone {
  transform: scale(.85) !important;
}

.skin-tone-button .skin-tone {
  transition: transform var(--duration) var(--easing);
}

.skin-tone-button[aria-selected] {
  background-color: var(--em-color-border);
  border-top-color: rgba(0, 0, 0, .05);
  border-bottom-color: rgba(0, 0, 0, 0);
  border-left-width: 0;
  border-right-width: 0;
}

.skin-tone-button[aria-selected] .skin-tone {
  transform: scale(.9);
}

.menu {
  z-index: 2;
  white-space: nowrap;
  border: 1px solid var(--em-color-border);
  background-color: rgba(var(--em-rgb-background), .9);
  -webkit-backdrop-filter: blur(4px);
  backdrop-filter: blur(4px);
  transition-property: opacity, transform;
  transition-duration: var(--duration);
  transition-timing-function: var(--easing);
  border-radius: 10px;
  padding: 4px;
  position: absolute;
  box-shadow: 1px 1px 5px rgba(0, 0, 0, .05);
}

.menu.hidden {
  opacity: 0;
}

.menu[data-position="bottom"] {
  transform-origin: 100% 100%;
}

.menu[data-position="bottom"].hidden {
  transform: scale(.9)rotate(-3deg)translateY(5%);
}

.menu[data-position="top"] {
  transform-origin: 100% 0;
}

.menu[data-position="top"].hidden {
  transform: scale(.9)rotate(3deg)translateY(-5%);
}

.menu input[type="radio"] {
  clip: rect(0 0 0 0);
  width: 1px;
  height: 1px;
  border: 0;
  margin: 0;
  padding: 0;
  position: absolute;
  overflow: hidden;
}

.menu input[type="radio"]:checked + .option {
  box-shadow: 0 0 0 2px rgb(var(--em-rgb-accent));
}

.option {
  width: 100%;
  border-radius: 6px;
  padding: 4px 6px;
}

.option:hover {
  color: #fff;
  background-color: rgb(var(--em-rgb-accent));
}

.skin-tone {
  width: 16px;
  height: 16px;
  border-radius: 100%;
  display: inline-block;
  position: relative;
  overflow: hidden;
}

.skin-tone:after {
  content: "";
  mix-blend-mode: overlay;
  background: linear-gradient(rgba(255, 255, 255, .2), rgba(0, 0, 0, 0));
  border: 1px solid rgba(0, 0, 0, .8);
  border-radius: 100%;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  box-shadow: inset 0 -2px 3px #000, inset 0 1px 2px #fff;
}

.skin-tone-1 {
  background-color: #ffc93a;
}

.skin-tone-2 {
  background-color: #ffdab7;
}

.skin-tone-3 {
  background-color: #e7b98f;
}

.skin-tone-4 {
  background-color: #c88c61;
}

.skin-tone-5 {
  background-color: #a46134;
}

.skin-tone-6 {
  background-color: #5d4437;
}

[data-index] {
  justify-content: space-between;
}

[data-emoji-set="twitter"] .skin-tone:after {
  box-shadow: none;
  border-color: rgba(0, 0, 0, .5);
}

[data-emoji-set="twitter"] .skin-tone-1 {
  background-color: #fade72;
}

[data-emoji-set="twitter"] .skin-tone-2 {
  background-color: #f3dfd0;
}

[data-emoji-set="twitter"] .skin-tone-3 {
  background-color: #eed3a8;
}

[data-emoji-set="twitter"] .skin-tone-4 {
  background-color: #cfad8d;
}

[data-emoji-set="twitter"] .skin-tone-5 {
  background-color: #a8805d;
}

[data-emoji-set="twitter"] .skin-tone-6 {
  background-color: #765542;
}

[data-emoji-set="google"] .skin-tone:after {
  box-shadow: inset 0 0 2px 2px rgba(0, 0, 0, .4);
}

[data-emoji-set="google"] .skin-tone-1 {
  background-color: #f5c748;
}

[data-emoji-set="google"] .skin-tone-2 {
  background-color: #f1d5aa;
}

[data-emoji-set="google"] .skin-tone-3 {
  background-color: #d4b48d;
}

[data-emoji-set="google"] .skin-tone-4 {
  background-color: #aa876b;
}

[data-emoji-set="google"] .skin-tone-5 {
  background-color: #916544;
}

[data-emoji-set="google"] .skin-tone-6 {
  background-color: #61493f;
}

[data-emoji-set="facebook"] .skin-tone:after {
  border-color: rgba(0, 0, 0, .4);
  box-shadow: inset 0 -2px 3px #000, inset 0 1px 4px #fff;
}

[data-emoji-set="facebook"] .skin-tone-1 {
  background-color: #f5c748;
}

[data-emoji-set="facebook"] .skin-tone-2 {
  background-color: #f1d5aa;
}

[data-emoji-set="facebook"] .skin-tone-3 {
  background-color: #d4b48d;
}

[data-emoji-set="facebook"] .skin-tone-4 {
  background-color: #aa876b;
}

[data-emoji-set="facebook"] .skin-tone-5 {
  background-color: #916544;
}

[data-emoji-set="facebook"] .skin-tone-6 {
  background-color: #61493f;
}

`;
function Jve(e) {
  const t = zr(null), r = zr(null);
  return r.current && r.current.update(e), Kr(() => (r.current = new Nq({
    ...e,
    ref: t
  }), () => {
    r.current = null;
  }), []), /* @__PURE__ */ In.createElement("div", {
    ref: t
  });
}
const Hve = ({ usersTyping: e }) => {
  const { t } = Ur();
  return /* @__PURE__ */ j(gr, { sx: { width: 0.9, margin: "auto", height: "22px", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }, children: e.length > 0 ? /* @__PURE__ */ ut(gr, { sx: { position: "sticky", bottom: 0, display: "flex", alignItems: "center" }, children: [
    /* @__PURE__ */ ut(br, { mr: 1, variant: "caption", children: [
      e.join(","),
      " ",
      t("typing", { count: e.length })
    ] }),
    /* @__PURE__ */ j(ku, { fade: !0 })
  ] }) : null });
}, _ve = ({ handleSendMessage: e, handleParticipantTyping: t, usersTyping: r }) => {
  const { t: n } = Ur(), [i, a] = ir([]), [s, o] = ir(!1), [u, f] = ir(""), l = u.trim() || (i == null ? void 0 : i.length), d = (C) => {
    const R = C.map((I) => ({
      contentType: I.type,
      media: I,
      filename: I.name
    }));
    a((I) => I != null && I.length ? [...I, ...R] : [...R]);
  }, { getRootProps: c, getInputProps: p, open: v } = fT({
    onDrop: d,
    noClick: !0,
    noKeyboard: !0
  }), h = (C) => {
    a((R) => R == null ? void 0 : R.filter((I, P) => P !== C));
  }, m = () => o((C) => !C), q = (C) => {
    const R = C.native;
    f((I) => I ? I + R : R), o(!1);
  }, w = () => {
    e({ message: u, attachments: i }), a([]), f(""), o(!1);
  }, O = (C) => {
    C.repeat || !l || (C.key === "Enter" && !C.shiftKey ? (C.preventDefault(), w()) : t());
  };
  return /* @__PURE__ */ ut(gr, { ...c(), children: [
    /* @__PURE__ */ j(Hve, { usersTyping: r }),
    /* @__PURE__ */ ut(gr, { sx: { border: 1, borderColor: (C) => C.palette.grey[400], borderRadius: "5px", width: 0.9, marginX: "auto", marginBottom: 2 }, children: [
      /* @__PURE__ */ j("input", { ...p() }),
      /* @__PURE__ */ j($ve, { files: i, handleRemoveAttachment: h }),
      /* @__PURE__ */ j(
        ll,
        {
          sx: { width: 1, "& fieldset": { border: "none" } },
          multiline: !0,
          placeholder: n("WRITE_MESSAGE"),
          value: u,
          onKeyDown: O,
          onChange: (C) => {
            f(C.target.value);
          },
          autoFocus: !0
        }
      ),
      /* @__PURE__ */ ut(pt, { direction: "row", justifyContent: "space-between", paddingX: 1, paddingBottom: 1, children: [
        /* @__PURE__ */ ut(pt, { direction: "row", spacing: 1.5, justifyContent: "flex-start", children: [
          /* @__PURE__ */ j(Ci, { onClick: v, children: /* @__PURE__ */ j(ny, { size: "2xs", duotone: !0 }) }),
          /* @__PURE__ */ j(Ci, { onClick: m, sx: { color: (C) => C.palette.grey[400] }, children: /* @__PURE__ */ j(mU, { size: "2xs" }) })
        ] }),
        /* @__PURE__ */ ut(nu, { color: "success", size: "small", onClick: w, disabled: !l, children: [
          /* @__PURE__ */ j(br, { color: (C) => C.palette.common.white, children: n("SEND") }),
          /* @__PURE__ */ j(gr, { color: (C) => C.palette.common.white, ml: 1, children: /* @__PURE__ */ j(gU, { size: "1x", color: "white" }) })
        ] })
      ] }),
      s ? /* @__PURE__ */ j(eU, { onClickAway: () => o(!1), children: /* @__PURE__ */ j(gr, { sx: { position: "absolute", bottom: 100 }, children: /* @__PURE__ */ j(Jve, { data: fve, onEmojiSelect: q }) }) }) : null
    ] })
  ] });
}, $ve = ({ files: e, handleRemoveAttachment: t }) => /* @__PURE__ */ j(pt, { direction: "row", useFlexGap: !0, flexWrap: "wrap", spacing: 1, margin: e.length ? 1 : 0, children: e == null ? void 0 : e.map((r, n) => /* @__PURE__ */ j(
  ry,
  {
    icon: /* @__PURE__ */ j(ny, {}),
    label: r.filename,
    onDelete: () => t(n),
    deleteIcon: /* @__PURE__ */ j(wu, { style: { color: "black" } }),
    sx: { borderRadius: "4px" }
  },
  n
)) }), ehe = ({ search: e, setSearch: t }) => {
  const { t: r } = Ur();
  return /* @__PURE__ */ ut(gr, { sx: { display: "flex", alignItems: "center", paddingLeft: 1, bgcolor: (n) => n.palette.grey[200], borderRadius: 1, marginX: 2 }, children: [
    /* @__PURE__ */ j(M6, {}),
    /* @__PURE__ */ j(
      ll,
      {
        sx: {
          fieldset: { border: "none" }
        },
        value: e,
        onChange: (n) => t(n.target.value),
        placeholder: r("SEARCH"),
        autoFocus: !0
      }
    )
  ] });
}, the = (e) => /* @__PURE__ */ j(hc, { disablePadding: !0, sx: { marginTop: 2, overflow: "auto" }, children: e.children }), OT = ({ isFavorite: e, children: t }) => e ? /* @__PURE__ */ j(Au, { overlap: "circular", anchorOrigin: { vertical: "top", horizontal: "right" }, badgeContent: /* @__PURE__ */ j(nm, { size: "sm", color: uR[600] }), children: t }) : t, rhe = ({
  _id: e,
  isFavorite: t,
  addToFavorites: r,
  removeFromFavorites: n,
  deleteConversation: i,
  leaveConversation: a,
  setOnHover: s
}) => {
  const { t: o } = Ur(), [u, f] = ir(null), [l, d] = ir(!1), c = !!u, p = (w) => {
    f(w.currentTarget);
  }, v = () => {
    f(null), s(!1);
  }, h = () => {
    d(!1);
  }, m = () => {
    d(!0);
  }, q = [
    {
      text: o(i ? "DELETE" : "LEAVE"),
      onClick: i || a,
      danger: !0
    }
  ];
  return /* @__PURE__ */ ut("div", { children: [
    /* @__PURE__ */ j(
      Ci,
      {
        id: `conversationItem-button-${e}`,
        "aria-controls": c ? `conversationItem-menu-${e}` : void 0,
        "aria-haspopup": "true",
        "aria-expanded": c ? "true" : void 0,
        onClick: p,
        children: /* @__PURE__ */ j(ku, {})
      }
    ),
    /* @__PURE__ */ ut(
      nhe,
      {
        id: `conversationItem-menu-${e}`,
        MenuListProps: {
          "aria-labelledby": `conversationItem-button-${e}`
        },
        anchorEl: u,
        open: c,
        onClose: v,
        disablePortal: !0,
        children: [
          /* @__PURE__ */ j(
            Iq,
            {
              onClick: () => {
                t ? n(e) : r(e), v();
              },
              children: /* @__PURE__ */ j(br, { noWrap: !0, variant: "subtitle2", children: o(t ? "UNFAVORITE" : "FAVORITE") })
            }
          ),
          /* @__PURE__ */ j(ty, { sx: { "&.MuiDivider-root": { marginTop: "0px", marginBottom: "0px" } } }),
          i || a ? /* @__PURE__ */ j(Iq, { onClick: m, children: /* @__PURE__ */ j(br, { noWrap: !0, variant: "subtitle2", color: "error", children: o(i ? "DELETE" : "LEAVE") }) }) : null,
          /* @__PURE__ */ j(
            iv,
            {
              actions: q,
              handleClose: () => {
                h(), v();
              },
              open: l,
              title: o(i ? "DELETE_CONVERSATION" : "LEAVE_CONVERSATION"),
              content: o(i ? "DELETE_CONVERSATION_MODAL_CONTENT" : "LEAVE_CONVERSATION_MODAL_CONTENT")
            }
          )
        ]
      }
    )
  ] });
}, nhe = Zn((e) => /* @__PURE__ */ j(
  tU,
  {
    anchorOrigin: {
      vertical: "bottom",
      horizontal: "right"
    },
    transformOrigin: {
      vertical: "top",
      horizontal: "right"
    },
    ...e,
    children: e.children
  }
))(() => ({
  "& .MuiPaper-root": {
    minWidth: "120px",
    boxShadow: "rgb(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 5px 10px -3px",
    "& .MuiMenu-list": {
      padding: "0px"
    }
  }
})), ihe = ({
  unreadMessages: e,
  conversation: t,
  participants: r,
  isFavorite: n,
  isOnline: i,
  showTyping: a,
  addToFavorites: s,
  removeFromFavorites: o,
  deleteConversation: u,
  leaveConversation: f
}) => {
  const [l, d] = ir(!1), { goTo: c } = Gn();
  return /* @__PURE__ */ j(Z6, { disablePadding: !0, dense: !0, children: /* @__PURE__ */ j(Zf, { sx: { width: "inherit" }, disableRipple: !0, onMouseEnter: () => d(!0), onMouseLeave: () => d(!1), children: /* @__PURE__ */ ut(pt, { direction: "row", justifyContent: "space-between", alignItems: "center", paddingTop: 1, paddingBottom: 1, spacing: 3, width: "inherit", children: [
    /* @__PURE__ */ ut(
      pt,
      {
        onClick: () => c(`conversation/${t.sid}`),
        direction: "row",
        justifyContent: "flex-start",
        alignItems: "center",
        spacing: 2,
        sx: { minWidth: 0, width: "100%" },
        children: [
          /* @__PURE__ */ j(OT, { isFavorite: n, children: /* @__PURE__ */ j(xq, { isOnline: i, children: /* @__PURE__ */ j(cq, { participants: r, type: t.type }) }) }),
          /* @__PURE__ */ j(br, { fontSize: "1rem", noWrap: !0, sx: { wordBreak: "break-word", fontWeight: "600" }, children: t.displayName }),
          a ? /* @__PURE__ */ j(ku, { fade: !0 }) : null
        ]
      }
    ),
    l ? /* @__PURE__ */ j(
      rhe,
      {
        _id: t.sid,
        isFavorite: n,
        addToFavorites: s,
        removeFromFavorites: o,
        deleteConversation: u,
        leaveConversation: f,
        setOnHover: d
      }
    ) : /* @__PURE__ */ j(pt, { paddingRight: 2, paddingLeft: 2, children: /* @__PURE__ */ j(Au, { badgeContent: e, max: 99, color: "primary" }) })
  ] }) }) });
}, ahe = ({
  addToFavorites: e,
  removeFromFavorites: t,
  deleteConversation: r,
  leaveConversation: n,
  isFavorite: i
}) => {
  const { t: a } = Ur(), s = MT(), [o, u] = ir(!1), [f, l] = ir(!1), d = () => {
    u(!1);
  }, c = () => {
    u(!0);
  }, p = () => {
    l(!1);
  }, v = () => {
    l(!0);
  }, h = [
    { text: a(i ? "UNFAVORITE" : "FAVORITE"), onClick: i ? t : e },
    {
      text: a(r ? "DELETE" : "LEAVE"),
      onClick: v,
      danger: !0
    }
  ], m = [
    {
      text: a(r ? "DELETE" : "LEAVE"),
      onClick: r || n,
      danger: !0
    }
  ];
  return /* @__PURE__ */ ut(tn, { children: [
    /* @__PURE__ */ j(
      Ci,
      {
        id: `conversationItem-button-${s}`,
        "aria-controls": o ? `conversationItem-menu-${s}` : void 0,
        "aria-haspopup": "true",
        "aria-expanded": o ? "true" : void 0,
        onClick: c,
        children: /* @__PURE__ */ j(ku, {})
      }
    ),
    /* @__PURE__ */ j(xoe, { actions: h, handleClose: d, open: o }),
    /* @__PURE__ */ j(
      iv,
      {
        actions: m,
        handleClose: p,
        open: f,
        title: a(r ? "DELETE_CONVERSATION" : "LEAVE_CONVERSATION"),
        content: a(r ? "DELETE_CONVERSATION_MODAL_CONTENT" : "LEAVE_CONVERSATION_MODAL_CONTENT")
      }
    )
  ] });
}, she = Zn(gr)`
  width: 100%;
  display: flex;
  overflow-x: auto;
  scroll-snap-type: x mandatory;
  scrollbar-width: none;
  ::-webkit-scrollbar {
    display: none;
  }
`, ohe = Zn(pt)`
  width: inherit;
  scroll-snap-align: start;
  flex: 2 0 100%;
  user-select: none;
`, uhe = Zn(pt)`
  scroll-snap-align: start;
  flex: 1 0 17%;
  color: white;
  background-color: ${({ theme: e }) => e.palette.grey[200]};
`, fhe = ({
  conversation: e,
  participants: t,
  unreadMessages: r,
  showTyping: n,
  isFavorite: i,
  isOnline: a,
  addToFavorites: s,
  removeFromFavorites: o,
  deleteConversation: u,
  leaveConversation: f
}) => {
  const { goTo: l } = Gn();
  return /* @__PURE__ */ ut(she, { children: [
    /* @__PURE__ */ ut(
      ohe,
      {
        direction: "row",
        justifyContent: "space-between",
        alignItems: "center",
        paddingBottom: 1.5,
        paddingTop: 1.5,
        paddingLeft: 2,
        paddingRight: 4.2,
        spacing: 3,
        children: [
          /* @__PURE__ */ ut(
            pt,
            {
              onClick: () => l(`conversation/${e.sid}`),
              direction: "row",
              justifyContent: "flex-start",
              alignItems: "center",
              spacing: 2,
              sx: { minWidth: 0, width: "100%" },
              children: [
                /* @__PURE__ */ j(OT, { isFavorite: i, children: /* @__PURE__ */ j(xq, { isOnline: a, children: /* @__PURE__ */ j(cq, { participants: t, type: e.type }) }) }),
                /* @__PURE__ */ j(br, { fontSize: "1rem", noWrap: !0, sx: { wordBreak: "break-word", fontWeight: "600" }, children: e.displayName }),
                n ? /* @__PURE__ */ j(ku, { fade: !0 }) : null
              ]
            }
          ),
          /* @__PURE__ */ j(pt, { paddingLeft: 2.5, children: /* @__PURE__ */ j(Au, { badgeContent: r, max: 99, color: "primary" }) })
        ]
      }
    ),
    /* @__PURE__ */ j(uhe, { justifyContent: "center", alignItems: "center", children: /* @__PURE__ */ j(
      ahe,
      {
        addToFavorites: s,
        removeFromFavorites: o,
        deleteConversation: u,
        leaveConversation: f,
        isFavorite: i
      }
    ) })
  ] });
}, N6 = ({ conversation: e }) => {
  const t = Vs(), r = Lt(_4), n = Lt((v) => H4(v, e.sid)) ?? [], i = Lt((v) => Qse(v, e.sid)) ?? [], a = Lt(tv), s = Lt(qs), o = Lt((v) => tR(v, e.sid)), u = wa.isNativePlatform(), f = i.some((v) => v.isOnline), l = s === e.createdBy, d = !l, c = async () => {
    const v = await Si(t, e.sid);
    v && await fq(v);
  }, p = async () => {
    if (!e)
      return;
    const v = await Si(t, e.sid);
    v && await Yc(v, s);
  };
  return u ? /* @__PURE__ */ j(
    fhe,
    {
      showTyping: o.length > 0,
      participants: n,
      conversation: e,
      deleteConversation: l ? c : null,
      leaveConversation: d ? p : null,
      addToFavorites: () => {
        Ga(t, [...a, e.sid]);
      },
      removeFromFavorites: () => {
        Ga(
          t,
          a.filter((v) => v !== e.sid)
        );
      },
      unreadMessages: r[e.sid],
      isFavorite: e.isFavorite,
      isOnline: f
    }
  ) : /* @__PURE__ */ j(
    ihe,
    {
      showTyping: o.length > 0,
      participants: n,
      conversation: e,
      deleteConversation: l ? c : null,
      leaveConversation: d ? p : null,
      addToFavorites: () => {
        Ga(t, [...a, e.sid]);
      },
      removeFromFavorites: () => Ga(
        t,
        a.filter((v) => v !== e.sid)
      ),
      unreadMessages: r[e.sid],
      isFavorite: e.isFavorite,
      isOnline: f
    }
  );
}, lhe = ({ isMobile: e, users: t, selected: r, search: n, handleCreateNewConversation: i, listItemData: a, children: s }) => {
  var q;
  const { t: o } = Ur(), u = zr(null), { replace: f } = Gn(), l = r.length === 1, d = Br(() => t.length + 1, [t.length]);
  n !== "" && ((q = u.current) == null || q.scrollToItem(0));
  const c = Lt(Lse), p = l ? lO({ directConversationsParticipant: c, selectedUserId: r[0] }) : null, v = async () => {
    if (p)
      return f(`conversation/${p}`);
    const w = await i(r);
    return f(`conversation/${w.sid}`);
  };
  return /* @__PURE__ */ ut(tn, { children: [
    s,
    /* @__PURE__ */ ut(pt, { width: "100%", height: "100%", sx: { marginTop: 2, overflow: "hidden", position: "relative" }, children: [
      /* @__PURE__ */ j(oR, { children: ({ height: w, width: O }) => /* @__PURE__ */ j(sR, { ref: u, itemData: a, height: w, width: O, itemSize: 64, itemCount: d, overscanCount: 5, children: ZR }) }),
      /* @__PURE__ */ j(
        gr,
        {
          width: 1,
          sx: {
            position: "absolute",
            bottom: 0,
            height: "5rem",
            backgroundImage: "linear-gradient(to bottom, rgba(255,255,255,0), rgba(255,255,255, 1) 90%)"
          }
        }
      ),
      e ? /* @__PURE__ */ j(() => /* @__PURE__ */ j(pt, { sx: { position: "absolute", bottom: 10, right: "2.5%", backgroundColor: "white", width: "95%" }, children: /* @__PURE__ */ j(nu, { disabled: !r.length, onClick: v, fullWidth: !0, children: o(p ? "SEE_CONVERSATION" : "CREATE_CONVERSATION") }) }), {}) : /* @__PURE__ */ j(() => /* @__PURE__ */ j(gr, { sx: { position: "absolute", bottom: 10, right: 15, backgroundColor: "white", width: "50%" }, children: /* @__PURE__ */ j(nu, { disabled: !r.length, onClick: v, fullWidth: !0, children: o(p ? "SEE_CONVERSATION" : "CREATE_CONVERSATION") }) }), {})
    ] })
  ] });
}, NT = ({ media: e, isAuthor: t }) => {
  const [r, n] = ir(), i = Vs();
  return Kr(() => {
    (async () => {
      const s = await i.getTemporaryContentUrlsForMediaSids([e.sid]);
      s && n(s.get(e.sid));
    })();
  }, [i, e]), /* @__PURE__ */ ut(
    gr,
    {
      sx: {
        color: t ? "white" : (a) => a.palette.text.primary
      },
      children: [
        /* @__PURE__ */ j(ny, {}),
        /* @__PURE__ */ j(
          is,
          {
            rel: "noopener noreferrer",
            target: "_blank",
            href: r,
            sx: {
              color: t ? "white" : (a) => a.palette.text.primary,
              textDecorationColor: t ? "white" : (a) => a.palette.text.primary,
              paddingLeft: 1
            },
            children: e.filename
          }
        )
      ]
    }
  );
}, IT = ({ show: e, handleOnDeleteMessage: t }) => e ? /* @__PURE__ */ j(pt, { direction: "row", justifyContent: "center", width: 0.1, children: /* @__PURE__ */ j(Ci, { onClick: t, sx: { color: (r) => r.palette.grey[400] }, children: /* @__PURE__ */ j(wu, { size: "2xs" }) }) }) : null, dhe = ({ message: e, isAuthor: t, handleDeleteMessage: r, canDelete: n }) => {
  var f;
  const [i, a] = ir(!1), s = (l) => {
    !n || !e.sid || (l.stopPropagation(), r(e));
  };
  return /* @__PURE__ */ ut(pt, { direction: "row", onMouseLeave: () => {
    n && a(!1);
  }, justifyContent: t ? "flex-end" : "flex-start", width: i ? "90%" : "80%", children: [
    /* @__PURE__ */ j(
      pt,
      {
        direction: "row",
        onMouseEnter: () => {
          n && a(!0);
        },
        sx: {
          borderRadius: "8px",
          backgroundColor: t ? (l) => l.palette.primary.main : (l) => l.palette.grey[200],
          wordBreak: "break-word",
          paddingX: 1,
          paddingY: 0.5
        },
        maxWidth: i ? "89%" : "100%",
        children: /* @__PURE__ */ ut(pt, { direction: "column", children: [
          (f = e.attachments) != null && f.length ? /* @__PURE__ */ j(tn, { children: e.attachments.map((l) => /* @__PURE__ */ j(NT, { media: l, isAuthor: t }, l.sid)) }) : null,
          e.body ? /* @__PURE__ */ j(br, { color: t ? "white" : (l) => l.palette.text.primary, children: e.body }) : null
        ] })
      }
    ),
    n ? /* @__PURE__ */ j(IT, { show: i, handleOnDeleteMessage: s }) : null
  ] });
}, che = Zn(gr)`
  max-width: 80%;
  display: flex;
  overflow-x: visible;
  scroll-snap-type: x mandatory;
  scrollbar-width: none;
  ::-webkit-scrollbar {
    display: none;
    background: transparent;
  }
`, phe = Zn(pt)`
  align-items: flex-end;
  scroll-snap-align: start;
  flex: 2 0 100%;
  user-select: none;
`, vhe = Zn(pt)`
  scroll-snap-align: start;
  color: white;
`, hhe = ({ message: e, isAuthor: t, handleDeleteMessage: r, canDelete: n }) => {
  var a;
  const i = (s) => {
    !n || !e.sid || (s.stopPropagation(), r(e));
  };
  return /* @__PURE__ */ ut(che, { children: [
    /* @__PURE__ */ j(phe, { children: /* @__PURE__ */ ut(
      pt,
      {
        direction: "column",
        sx: {
          borderRadius: "8px",
          backgroundColor: t ? (s) => s.palette.primary.main : (s) => s.palette.grey[200],
          wordBreak: "break-word",
          paddingX: 1,
          paddingY: 0.5
        },
        children: [
          (a = e.attachments) != null && a.length ? /* @__PURE__ */ j(tn, { children: e.attachments.map((s) => /* @__PURE__ */ j(NT, { media: s, isAuthor: t }, s.sid)) }) : null,
          e.body ? /* @__PURE__ */ j(br, { color: t ? "white" : (s) => s.palette.text.primary, children: e.body }) : null
        ]
      }
    ) }),
    n ? /* @__PURE__ */ j(vhe, { justifyContent: "center", alignItems: "center", paddingX: 1.5, children: /* @__PURE__ */ j(IT, { show: !0, handleOnDeleteMessage: i }) }) : null
  ] });
}, mhe = ({
  message: e,
  lastReadMessageIndex: t,
  handleDeleteMessage: r,
  isAuthor: n,
  showAuthor: i,
  language: a,
  showTimestamp: s,
  canDelete: o
}) => {
  var v, h;
  const u = zr(null), f = Lt(Xu), l = wa.isNativePlatform();
  if (Kr(() => {
    var m;
    e.index === t && ((m = u.current) == null || m.scrollIntoView());
  }, [t, e.index, u]), !e.dateCreated || !e.author)
    return null;
  const d = a === "fr" ? "fr-CA" : "en-CA", c = s ? (h = (v = new Date(e.dateCreated)).toLocaleTimeString) == null ? void 0 : h.call(v, d, { hour: "2-digit", minute: "2-digit" }) : null, p = (f == null ? void 0 : f[e.author].fullName) ?? "";
  return /* @__PURE__ */ j(gr, { ref: u, children: /* @__PURE__ */ ut(pt, { alignItems: n ? "flex-end" : "flex-start", children: [
    /* @__PURE__ */ ut(
      pt,
      {
        direction: "column",
        width: "100%",
        alignItems: n ? "flex-end" : "flex-start",
        sx: { overflow: "auto", scrollbarWidth: "none", "::-webkit-scrollbar": { display: "none", background: "transparent" } },
        children: [
          /* @__PURE__ */ j(ghe, { isAuthor: n, author: p, showAuthor: i }),
          l ? /* @__PURE__ */ j(hhe, { canDelete: o, message: e, isAuthor: n, handleDeleteMessage: r }) : /* @__PURE__ */ j(dhe, { canDelete: o, message: e, isAuthor: n, handleDeleteMessage: r })
        ]
      }
    ),
    /* @__PURE__ */ j(pt, { mt: 0.5, direction: "row", justifyContent: n ? "flex-end" : "flex-start", children: /* @__PURE__ */ j(br, { fontSize: "0.65rem", color: (m) => m.palette.grey[500], children: c }) })
  ] }) });
}, ghe = ({ author: e, isAuthor: t, showAuthor: r }) => t || !r ? null : /* @__PURE__ */ j(br, { fontSize: "0.75rem", color: "black", children: e }), yhe = () => {
  const { t: e } = Ur(), { goTo: t } = Gn();
  return /* @__PURE__ */ ut(pt, { direction: "column", flexGrow: 1, justifyContent: "center", spacing: 2, marginX: 4, children: [
    /* @__PURE__ */ j(pt, { sx: { color: (r) => r.palette.primary.main }, children: /* @__PURE__ */ j(yU, { size: "4x" }) }),
    /* @__PURE__ */ ut(pt, { direction: "column", spacing: 5, children: [
      /* @__PURE__ */ j(br, { variant: "body2", align: "center", children: e("NO_CONVERSATIONS") }),
      /* @__PURE__ */ j(is, { component: "button", color: "primary", underline: "hover", variant: "subtitle2", fontWeight: "600", onClick: () => t("newConversation"), children: e("CREATE_CONVERSATION") })
    ] })
  ] });
}, Vhe = () => {
  const e = Lt(jl), [t, r] = ir(""), n = jT(t), i = il(e, n, {
    keys: ["displayName", "participantsNames"],
    threshold: il.rankings.CONTAINS,
    baseSort: (o, u) => {
      const f = new Date(o.item.lastMessageDate ?? 0), l = new Date(u.item.lastMessageDate ?? 0);
      return f > l ? -1 : 1;
    }
  });
  if (i.length === 0 && t.length === 0)
    return /* @__PURE__ */ j(yhe, {});
  const a = i.filter((o) => o.isFavorite), s = i.filter((o) => !o.isFavorite);
  return /* @__PURE__ */ ut(tn, { children: [
    /* @__PURE__ */ j(
      ehe,
      {
        search: t,
        setSearch: (o) => {
          r(o);
        }
      }
    ),
    /* @__PURE__ */ ut(the, { children: [
      a.map((o) => /* @__PURE__ */ j(N6, { conversation: o }, o.sid)),
      s.map((o) => /* @__PURE__ */ j(N6, { conversation: o }, o.sid))
    ] })
  ] });
}, qhe = (e) => {
  const { goTo: t } = Gn();
  return /* @__PURE__ */ j(
    Pu,
    {
      topBarProps: {
        color: "transparent",
        title: "Conversations",
        action: /* @__PURE__ */ j(Ci, { color: "primary", onClick: () => t("newConversation"), children: /* @__PURE__ */ j(VU, { size: "sm" }) })
      },
      children: /* @__PURE__ */ j(pt, { sx: { height: "100%", overflow: "auto" }, children: e.children })
    }
  );
}, bhe = {
  routePath: "conversations",
  element: /* @__PURE__ */ j(qhe, { children: /* @__PURE__ */ j(Vhe, {}) })
}, Ahe = (e) => {
  const t = Gs(), r = Lt(zse), n = Vs(), i = zr(null), [a, s] = ir(null), o = Lt(qs), u = async (h) => {
    const m = await (a == null ? void 0 : a.getMessages(1, h));
    return m == null ? void 0 : m.items[0];
  }, f = async (h, m) => {
    const q = a == null ? void 0 : a.prepareMessage();
    q == null || q.setBody(h), m == null || m.forEach((w) => {
      q == null || q.addMedia(w);
    }), await (q == null ? void 0 : q.build().send()), await l();
  }, l = qr(async () => {
    a && (await Bse(a), a != null && a.sid && t(pl({ conversationId: a == null ? void 0 : a.sid, unreadCount: 0 })));
  }, [a, t]), d = (h) => h.map(j2), c = qr(async () => {
    var h, m;
    if ((h = i.current) != null && h.hasPrevPage) {
      const q = await i.current.prevPage(), w = d(q.items);
      t(Q3(w));
      const O = (m = w.at(-1)) == null ? void 0 : m.index;
      a == null || a.updateLastReadMessageIndex(O ?? null), i.current = q;
    }
  }, [a, t]), p = qr(
    async (h) => {
      if (!h)
        return;
      const m = await Bn(h).getMessagesCursor();
      i.current = m ?? null;
      const q = (m == null ? void 0 : m.items) ?? [], w = d(q);
      t(G3(w));
    },
    [t]
  ), v = async () => {
    a && await Ise(a);
  };
  return Kr(() => {
    e && (async () => {
      const h = await Si(n, e);
      h && (s(h), p(h));
    })();
  }, [n, e, p, l, t]), Kr(() => {
    if (e)
      return l(), () => {
        l();
      };
  }, [l, t, e]), Kr(() => {
    if (!a)
      return;
    const h = (q) => {
      const w = j2(q);
      t(J3(w)), j4(t)(Bn)(q, o);
    }, m = (q) => {
      t(H3(q.sid)), Y4(t)(Bn)(q);
    };
    return a.on("messageAdded", h), a.on("messageRemoved", m), () => {
      a.off("messageAdded", h), a.off("messageRemoved", m);
    };
  }, [a, o, t]), {
    messages: r,
    markAllMessagesRead: l,
    getMessageByIndex: u,
    sendMessage: f,
    handleParticipantTyping: v,
    loadConversationPreviousMessages: c
  };
}, XT = (e) => {
  const t = Vs(), [r, n] = ir(void 0), i = qr(async () => {
    if (!e)
      return;
    const a = await Si(t, e);
    if (!a)
      return;
    const o = (await a.getMessages(100)).items.map((u) => ({
      authorId: u.author,
      dateUploaded: u.dateCreated,
      medias: u.attachedMedia
    })).filter(Boolean);
    n(o);
  }, [t, e]);
  return Kr(() => {
    i();
  }, [i]), {
    conversationFiles: r
  };
}, whe = () => {
  const [e, t] = ir([]), [r, n] = ir(""), [i, a] = ir(""), s = Vs(), o = Lt(lq), u = il(o ?? [], r, { keys: ["firstName", "lastName", "fullName", "employeeNumber"] }), f = (v) => () => {
    t((h) => h.includes(v) ? h.filter((m) => m !== v) : (n(""), [...h, v]));
  }, l = Br(
    () => ({
      users: u,
      selected: e,
      handleSelect: f
    }),
    [u, e]
  ), d = e.length === 1;
  return {
    selected: e,
    handleSelect: f,
    handleDelete: (v) => {
      t((h) => h.filter((m) => m !== v));
    },
    handleCreateNewConversation: async (v) => {
      const h = d ? await Xse(s) : await Pse(s, i);
      return await G4(h, v), await (h == null ? void 0 : h.join()), h;
    },
    search: r,
    setSearch: n,
    listItemData: l,
    customFriendlyName: i,
    setCustomFriendlyName: a
  };
}, khe = () => {
  const { param: e, goTo: t } = Gn(), { currentLanguage: r } = Ur(), n = Lt(jl), i = Lt(qs), [a, s] = ir(!1), o = n.find((w) => w.sid === e), u = Lt((w) => tR(w, o == null ? void 0 : o.sid)), { messages: f, loadConversationPreviousMessages: l, getMessageByIndex: d, sendMessage: c, markAllMessagesRead: p, handleParticipantTyping: v } = Ahe(
    o == null ? void 0 : o.sid
  ), h = (o == null ? void 0 : o.type) === "group", m = (w) => {
    const O = new Date(w.dateCreated);
    return Hce(O) && w.author === i;
  }, q = (w, O) => !w || !O ? !1 : w > O;
  return i ? /* @__PURE__ */ ut(
    Pu,
    {
      topBarProps: {
        color: "primary",
        title: o == null ? void 0 : o.displayName,
        action: /* @__PURE__ */ j(
          Ci,
          {
            sx: { color: (w) => w.palette.common.white },
            onClick: () => {
              t(h ? `groupConversationDetails/${o == null ? void 0 : o.sid}` : `directConversationDetails/${o == null ? void 0 : o.sid}`);
            },
            children: /* @__PURE__ */ j(ku, {})
          }
        )
      },
      stackProps: { direction: "column", justifyContent: "space-between", sx: { height: "100%" } },
      children: [
        /* @__PURE__ */ j(
          rpe,
          {
            lastReadMessageIndex: (o == null ? void 0 : o.lastReadMessageIndex) ?? null,
            hasNewMessagesToShow: !a && q(o == null ? void 0 : o.lastMessageIndex, (o == null ? void 0 : o.lastReadMessageIndex) ?? void 0),
            messages: f,
            markAllMessagesRead: p,
            handleDeleteMessage: async (w) => {
              const O = await d(w.index);
              O == null || O.remove();
            },
            handleGetMoreMessages: l,
            handleCanDelete: m,
            language: r,
            userId: i,
            isGroup: (o == null ? void 0 : o.type) === "group"
          }
        ),
        /* @__PURE__ */ j(
          _ve,
          {
            usersTyping: u,
            handleSendMessage: async ({ message: w, attachments: O }) => {
              s(!0), await c(w, O), await p(), s(!1);
            },
            handleParticipantTyping: v
          }
        )
      ]
    }
  ) : null;
}, Whe = {
  routePath: "conversation/:id",
  element: /* @__PURE__ */ j(khe, {})
}, She = () => {
  const { t: e } = Ur(), { selected: t, handleDelete: r, search: n, setSearch: i, handleCreateNewConversation: a, listItemData: s, customFriendlyName: o, setCustomFriendlyName: u } = whe(), f = Lt(lq), l = Lt(Xu), d = wa.isNativePlatform(), c = t.length > 1;
  return /* @__PURE__ */ j(
    Pu,
    {
      topBarProps: {
        color: "transparent",
        title: c ? /* @__PURE__ */ j(Ooe, { name: o, setName: u }) : e("NEW_CONVERSATION")
      },
      children: /* @__PURE__ */ j(pt, { sx: { height: "100%", overflow: "auto" }, children: /* @__PURE__ */ j(
        lhe,
        {
          isMobile: d,
          users: f ?? [],
          selected: t,
          search: n,
          handleCreateNewConversation: a,
          listItemData: s,
          children: /* @__PURE__ */ j(MR, { search: n, setSearch: i, selected: t, usersById: l ?? {}, handleDelete: r })
        }
      ) })
    }
  );
}, Che = {
  routePath: "newConversation",
  element: /* @__PURE__ */ j(She, {})
}, Fhe = () => {
  const e = wa.isNativePlatform(), t = Lt(lq), r = Lt(Xu);
  return /* @__PURE__ */ j(Wce, { isMobile: e, users: t ?? [], usersById: r ?? {} });
}, Khe = (e) => {
  const { param: t } = Gn(), n = Lt(jl).find((i) => i.sid === t);
  return /* @__PURE__ */ j(
    Pu,
    {
      topBarProps: {
        color: "transparent",
        title: `${n == null ? void 0 : n.displayName}`
      },
      children: /* @__PURE__ */ j(pt, { sx: { height: "100%", overflow: "auto" }, children: e.children })
    }
  );
}, Rhe = {
  routePath: "addParticipants/:id",
  element: /* @__PURE__ */ j(Khe, { children: /* @__PURE__ */ j(Fhe, {}) })
}, The = ({ participant: e, canEdit: t, removeParticipant: r }) => {
  var l;
  const { firstName: n, lastName: i, fullName: a, picture: s, _id: o } = e, f = ((l = Lt(eR)[o]) == null ? void 0 : l.isOnline) ?? !1;
  return /* @__PURE__ */ ut(pt, { direction: "row", justifyContent: "space-between", alignItems: "center", padding: 1, spacing: 1, children: [
    /* @__PURE__ */ ut(pt, { direction: "row", justifyContent: "flex-start", alignItems: "center", spacing: 2, children: [
      /* @__PURE__ */ j(xq, { isOnline: f, children: /* @__PURE__ */ j(dq, { firstName: n, lastName: i, fullName: a, pictureUrl: s == null ? void 0 : s.url }) }),
      /* @__PURE__ */ j(br, { fontSize: "1rem", noWrap: !0, sx: { wordBreak: "break-word", fontWeight: "600" }, children: a })
    ] }),
    t && /* @__PURE__ */ j(
      Ci,
      {
        onClick: () => {
          r(e._id);
        },
        sx: { color: (d) => d.palette.grey[400] },
        children: /* @__PURE__ */ j(wu, { size: "2xs" })
      }
    )
  ] });
}, Uhe = () => {
  const e = Vs(), t = Lt(qs), { param: r, goHome: n } = Gn(), a = Lt(jl).find((v) => v.sid === r), s = Lt((v) => H4(v, r ?? "")) ?? [], o = (a == null ? void 0 : a.createdBy) === t, { conversationFiles: u } = XT(a == null ? void 0 : a.sid), f = Lt(tv), l = async () => {
    if (!a)
      return;
    const v = await Si(e, a.sid);
    v && (await fq(v), n());
  }, d = async (v) => {
    if (!a)
      return;
    const h = await Si(e, a.sid);
    h && await Dse(h, v);
  }, c = async (v) => {
    if (!a)
      return;
    const h = await Si(e, a.sid);
    h && await Yc(h, v);
  }, p = async () => {
    if (!a)
      return;
    const v = await Si(e, a.sid);
    v && (await Yc(v, t), n());
  };
  return (a == null ? void 0 : a.type) !== "group" ? null : /* @__PURE__ */ ut(tn, { children: [
    /* @__PURE__ */ ut(pt, { direction: "column", sx: { height: "100%", overflow: "auto" }, children: [
      /* @__PURE__ */ j(
        lpe,
        {
          participants: s,
          updateFriendlyName: d,
          friendlyName: a.displayName,
          canEdit: o
        }
      ),
      /* @__PURE__ */ j(pt, { sx: { marginY: 2 }, children: /* @__PURE__ */ j(
        QR,
        {
          isFavorite: a.isFavorite,
          addToFavorites: () => {
            Ga(e, [...f, a.sid]);
          },
          removeFromFavorites: () => {
            Ga(
              e,
              f.filter((v) => v !== a.sid)
            );
          }
        }
      ) }),
      /* @__PURE__ */ ut(pt, { sx: { height: "100%", overflow: "auto" }, children: [
        /* @__PURE__ */ j(dpe, { canEdit: o, children: s.map((v) => /* @__PURE__ */ j(The, { participant: v, canEdit: o, removeParticipant: c }, v._id)) }),
        u != null && u.length ? /* @__PURE__ */ j(JR, { files: u }) : null
      ] })
    ] }),
    o ? /* @__PURE__ */ j(HR, { deleteConversation: l }) : /* @__PURE__ */ j(_R, { leaveConversation: p })
  ] });
}, xhe = (e) => /* @__PURE__ */ j(
  Pu,
  {
    topBarProps: {
      color: "primary"
    },
    children: /* @__PURE__ */ ut(pt, { sx: { height: "100%", overflow: "auto", marginBottom: 3 }, children: [
      " ",
      e.children
    ] })
  }
), Ehe = {
  routePath: "groupConversationDetails/:id",
  element: /* @__PURE__ */ j(xhe, { children: /* @__PURE__ */ j(Uhe, {}) })
}, Ohe = () => {
  const e = Vs(), t = Lt(qs), { param: r, goHome: n } = Gn(), a = Lt(jl).find((d) => d.sid === r), s = Lt(tv), o = (a == null ? void 0 : a.createdBy) === t, { conversationFiles: u } = XT(a == null ? void 0 : a.sid), f = async () => {
    if (!a)
      return;
    const d = await Si(e, a.sid);
    d && (await fq(d), n());
  }, l = async () => {
    if (!a)
      return;
    const d = await Si(e, a.sid);
    d && (await Yc(d, t), n());
  };
  return (a == null ? void 0 : a.type) !== "direct" ? null : /* @__PURE__ */ ut(tn, { children: [
    /* @__PURE__ */ ut(pt, { direction: "column", sx: { height: "100%", overflow: "auto" }, children: [
      /* @__PURE__ */ j(pt, { sx: { marginTop: 2 }, children: /* @__PURE__ */ j(
        QR,
        {
          isFavorite: a.isFavorite,
          addToFavorites: () => {
            Ga(e, [...s, a.sid]);
          },
          removeFromFavorites: () => {
            Ga(
              e,
              s.filter((d) => d !== a.sid)
            );
          }
        }
      ) }),
      /* @__PURE__ */ j(pt, { sx: { height: "100%", overflow: "auto", marginTop: 2 }, children: /* @__PURE__ */ j(JR, { files: u }) })
    ] }),
    o ? /* @__PURE__ */ j(HR, { deleteConversation: f }) : /* @__PURE__ */ j(_R, { leaveConversation: l })
  ] });
}, Nhe = (e) => /* @__PURE__ */ j(
  Pu,
  {
    topBarProps: {
      color: "primary"
    },
    children: /* @__PURE__ */ ut(pt, { sx: { height: "100%", overflow: "auto", marginBottom: 3 }, children: [
      " ",
      e.children
    ] })
  }
), Ihe = {
  routePath: "directConversationDetails/:id",
  element: /* @__PURE__ */ j(Nhe, { children: /* @__PURE__ */ j(Ohe, {}) })
}, I6 = [
  Ehe,
  Ihe,
  bhe,
  Whe,
  Che,
  Rhe
], Gn = () => {
  const e = Gs(), { routes: t } = Lt((s) => s.router), r = t.at(-1) ?? I6[0].routePath, n = t.at(-2) ?? null, [i] = r != null && r.includes("/") ? r.split("/").reverse() : [null], a = I6.find((s) => s.routePath === r || s.routePath.split("/")[0] === r.split("/")[0]);
  return {
    goBack: () => e(M3()),
    goTo: (s) => e(j3(s)),
    replace: (s) => e(Y3(s)),
    goHome: () => e(z3()),
    currentRoute: r,
    previousRoute: n,
    param: i,
    screen: a
  };
}, Xhe = ({ client: e }) => {
  roe(e);
  const { isError: t, isLoading: r } = pO(), { currentRoute: n, screen: i } = Gn(), a = Lt(Yse);
  return r ? /* @__PURE__ */ j(tn, { children: "isLoading" }) : t ? /* @__PURE__ */ j(tn, { children: " something went wrong fetching users" }) : i ? /* @__PURE__ */ j(tn, { children: /* @__PURE__ */ j(zce, { unreadMessagesTotal: a, children: /* @__PURE__ */ j(ioe, { FallbackComponent: kce, children: i.element }) }) }) : /* @__PURE__ */ ut(tn, { children: [
    "404 , no screen matchs ",
    n,
    " "
  ] });
}, jhe = () => {
  const e = Sse();
  return e.ready ? /* @__PURE__ */ j(Cse, { client: e.client, children: /* @__PURE__ */ j(GU, { store: VO, children: /* @__PURE__ */ j(rU, { children: /* @__PURE__ */ j(Xhe, { client: e.client }) }) }) }) : null;
};
export {
  jhe as ChatWidget
};
